export default [
  {
    "cast": "Abertamy",
    "psc": "36235",
    "okres": "Karlovy Vary",
    "obec": "Abertamy",
    "val": "36235 Abertamy Abertamy"
  },
  {
    "cast": "Adamov",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54232 Trutnov Adamov"
  },
  {
    "cast": "Adamov",
    "psc": "67904",
    "okres": "Blansko",
    "obec": "Adamov",
    "val": "67904 Adamov Adamov"
  },
  {
    "cast": "Adamov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Adamov",
    "val": "28601 Adamov Adamov"
  },
  {
    "cast": "Adamov",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Adamov",
    "val": "37371 Adamov Adamov"
  },
  {
    "cast": "Adolfovice",
    "psc": "79001",
    "okres": "Jeseník",
    "obec": "Bělá pod Pradědem",
    "val": "79001 Bela pod Pradedem Adolfovice"
  },
  {
    "cast": "Alberovice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Loket",
    "val": "25765 Loket Alberovice"
  },
  {
    "cast": "Albeř",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Alber"
  },
  {
    "cast": "Albeřice",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Alberice"
  },
  {
    "cast": "Albrechtice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Albrechtice"
  },
  {
    "cast": "Albrechtice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Drahonice",
    "val": "38901 Drahonice Albrechtice"
  },
  {
    "cast": "Albrechtice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Malešov",
    "val": "28401 Malesov Albrechtice"
  },
  {
    "cast": "Albrechtice",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Pěnčín",
    "val": "46345 Pencin Albrechtice"
  },
  {
    "cast": "Albrechtice",
    "psc": "59257",
    "okres": "Žďár nad Sázavou",
    "obec": "Rozsochy",
    "val": "59257 Rozsochy Albrechtice"
  },
  {
    "cast": "Albrechtice",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Albrechtice",
    "val": "56301 Albrechtice Albrechtice"
  },
  {
    "cast": "Albrechtice",
    "psc": "73543",
    "okres": "Karviná",
    "obec": "Albrechtice",
    "val": "73543 Albrechtice Albrechtice"
  },
  {
    "cast": "Albrechtice nad Orlicí",
    "psc": "51722",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Albrechtice nad Orlicí",
    "val": "51722 Albrechtice nad Orlici Albrechtice nad Orlici"
  },
  {
    "cast": "Albrechtice nad Vltavou",
    "psc": "39816",
    "okres": "Písek",
    "obec": "Albrechtice nad Vltavou",
    "val": "39816 Albrechtice nad Vltavou Albrechtice nad Vltavou"
  },
  {
    "cast": "Albrechtice u Frýdlantu",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Frýdlant",
    "val": "46331 Frydlant Albrechtice u Frydlantu"
  },
  {
    "cast": "Albrechtice u Rýmařova",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Břidličná",
    "val": "79351 Bridlicna Albrechtice u Rymarova"
  },
  {
    "cast": "Albrechtice v Jizerských horách",
    "psc": "46843",
    "okres": "Jablonec nad Nisou",
    "obec": "Albrechtice v Jizerských horách",
    "val": "46843 Albrechtice v Jizerskych horach Albrechtice v Jizerskych horach"
  },
  {
    "cast": "Albrechtičky",
    "psc": "74255",
    "okres": "Nový Jičín",
    "obec": "Albrechtičky",
    "val": "74255 Albrechticky Albrechticky"
  },
  {
    "cast": "Albrechtovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Záblatí",
    "val": "38301 Zablati Albrechtovice"
  },
  {
    "cast": "Aleje-Zátiší",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Františkovy Lázně",
    "val": "35002 Frantiskovy Lazne Aleje-Zatisi"
  },
  {
    "cast": "Alenina Lhota",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Alenina Lhota"
  },
  {
    "cast": "Alexovice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Ivančice",
    "val": "66491 Ivancice Alexovice"
  },
  {
    "cast": "Alojzov",
    "psc": "79804",
    "okres": "Prostějov",
    "obec": "Alojzov",
    "val": "79804 Alojzov Alojzov"
  },
  {
    "cast": "Alšovice",
    "psc": "46821",
    "okres": "Jablonec nad Nisou",
    "obec": "Pěnčín",
    "val": "46821 Pencin Alsovice"
  },
  {
    "cast": "Alžbětín",
    "psc": "34004",
    "okres": "Klatovy",
    "obec": "Železná Ruda",
    "val": "34004 Zelezna Ruda Alzbetin"
  },
  {
    "cast": "Amalín",
    "psc": "79397",
    "okres": "Bruntál",
    "obec": "Slezské Rudoltice",
    "val": "79397 Slezske Rudoltice Amalin"
  },
  {
    "cast": "Amerika",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Amerika"
  },
  {
    "cast": "Anděl Strážce",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Andel Strazce"
  },
  {
    "cast": "Andělice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Andelice"
  },
  {
    "cast": "Andělka",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46373 Visnova Andelka"
  },
  {
    "cast": "Andělská Hora",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Chrastava",
    "val": "46331 Chrastava Andelska Hora"
  },
  {
    "cast": "Andělská Hora",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Andělská Hora",
    "val": "36471 Andelska Hora Andelska Hora"
  },
  {
    "cast": "Andělská Hora",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Andělská Hora",
    "val": "79331 Andelska Hora Andelska Hora"
  },
  {
    "cast": "Anenská Studánka",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Anenská Studánka",
    "val": "56301 Anenska Studanka Anenska Studanka"
  },
  {
    "cast": "Anenská Ves",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Krajková",
    "val": "35709 Krajkova Anenska Ves"
  },
  {
    "cast": "Annín",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dlouhá Ves",
    "val": "34201 Dlouha Ves Annin"
  },
  {
    "cast": "Annín-Tovačov II x)",
    "psc": "75101",
    "okres": "Přerov",
    "obec": "Tovačov",
    "val": "75101 Tovacov Annin-Tovacov II x)"
  },
  {
    "cast": "Annovice",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Drunče",
    "val": "37821 Drunce Annovice"
  },
  {
    "cast": "Antonínov",
    "psc": "46844",
    "okres": "Jablonec nad Nisou",
    "obec": "Josefův Důl",
    "val": "46844 Josefuv Dul Antoninov"
  },
  {
    "cast": "Antonínova Výšina",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Vojtanov",
    "val": "35002 Vojtanov Antoninova Vysina"
  },
  {
    "cast": "Antonínův Důl",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Antoninuv Dul"
  },
  {
    "cast": "Antonka",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Kamenice nad Lipou",
    "val": "39470 Kamenice nad Lipou Antonka"
  },
  {
    "cast": "Antošovice",
    "psc": "71100",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71100 Ostrava Antosovice"
  },
  {
    "cast": "Archlebov",
    "psc": "69633",
    "okres": "Hodonín",
    "obec": "Archlebov",
    "val": "69633 Archlebov Archlebov"
  },
  {
    "cast": "Arneštovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Arneštovice",
    "val": "39501 Arnestovice Arnestovice"
  },
  {
    "cast": "Arnoldov",
    "psc": "36251",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36251 Ostrov Arnoldov"
  },
  {
    "cast": "Arnolec",
    "psc": "58827",
    "okres": "Jihlava",
    "obec": "Arnolec",
    "val": "58827 Arnolec Arnolec"
  },
  {
    "cast": "Arnoltice",
    "psc": "79351",
    "okres": "Olomouc",
    "obec": "Huzová",
    "val": "79351 Huzova Arnoltice"
  },
  {
    "cast": "Arnoltice",
    "psc": "40714",
    "okres": "Děčín",
    "obec": "Arnoltice",
    "val": "40714 Arnoltice Arnoltice"
  },
  {
    "cast": "Arnoltice",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Bulovka",
    "val": "46401 Bulovka Arnoltice"
  },
  {
    "cast": "Arnoltov",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Březová",
    "val": "35601 Brezova Arnoltov"
  },
  {
    "cast": "Arnoštka",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Arnostka"
  },
  {
    "cast": "Arnoštov",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Pecka",
    "val": "50782 Pecka Arnostov"
  },
  {
    "cast": "Arnoštov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Křišťanov",
    "val": "38301 Kristanov Arnostov"
  },
  {
    "cast": "Arnoštovice",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Arnostovice"
  },
  {
    "cast": "Arnultovice",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Nový Bor",
    "val": "47301 Novy Bor Arnultovice"
  },
  {
    "cast": "Arnultovice",
    "psc": "54372",
    "okres": "Trutnov",
    "obec": "Rudník",
    "val": "54372 Rudnik Arnultovice"
  },
  {
    "cast": "Arnultovice",
    "psc": "79383",
    "okres": "Bruntál",
    "obec": "Jindřichov",
    "val": "79383 Jindrichov Arnultovice"
  },
  {
    "cast": "Arnultovice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Velké Chvojno",
    "val": "40002 Velke Chvojno Arnultovice"
  },
  {
    "cast": "Artolec",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Artolec"
  },
  {
    "cast": "Aš",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As As"
  },
  {
    "cast": "Baba",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Baba"
  },
  {
    "cast": "Babčice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Vodice",
    "val": "39155 Vodice Babcice"
  },
  {
    "cast": "Babčice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Babcice"
  },
  {
    "cast": "Babí",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Babi"
  },
  {
    "cast": "Babí",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Babi"
  },
  {
    "cast": "Babice",
    "psc": "75643",
    "okres": "Vsetín",
    "obec": "Kelč",
    "val": "75643 Kelc Babice"
  },
  {
    "cast": "Babice",
    "psc": "34012",
    "okres": "Plzeň-jih",
    "obec": "Kbel",
    "val": "34012 Kbel Babice"
  },
  {
    "cast": "Babice",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Babice",
    "val": "67544 Babice Babice"
  },
  {
    "cast": "Babice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Buřenice",
    "val": "39501 Burenice Babice"
  },
  {
    "cast": "Babice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Babice",
    "val": "38411 Babice Babice"
  },
  {
    "cast": "Babice",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Babice",
    "val": "78501 Babice Babice"
  },
  {
    "cast": "Babice",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "35301 Tepla Babice"
  },
  {
    "cast": "Babice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Babice",
    "val": "25101 Babice Babice"
  },
  {
    "cast": "Babice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25753 Olbramovice Babice"
  },
  {
    "cast": "Babice",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Babice",
    "val": "50351 Babice Babice"
  },
  {
    "cast": "Babice",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Okrouhlice",
    "val": "58001 Okrouhlice Babice"
  },
  {
    "cast": "Babice",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Babice"
  },
  {
    "cast": "Babice",
    "psc": "68703",
    "okres": "Uherské Hradiště",
    "obec": "Babice",
    "val": "68703 Babice Babice"
  },
  {
    "cast": "Babice nad Svitavou",
    "psc": "66401",
    "okres": "Brno-venkov",
    "obec": "Babice nad Svitavou",
    "val": "66401 Babice nad Svitavou Babice nad Svitavou"
  },
  {
    "cast": "Babice u Rosic",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Babice u Rosic",
    "val": "66484 Babice u Rosic Babice u Rosic"
  },
  {
    "cast": "Babice (část)",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Řehenice",
    "val": "25167 Rehenice Babice (cast)"
  },
  {
    "cast": "Babice (část)",
    "psc": "25168",
    "okres": "Benešov",
    "obec": "Řehenice",
    "val": "25168 Rehenice Babice (cast)"
  },
  {
    "cast": "Babín",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Horažďovice",
    "val": "34101 Horazdovice Babin"
  },
  {
    "cast": "Babín",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Těmice",
    "val": "39470 Temice Babin"
  },
  {
    "cast": "Babina",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Plasy",
    "val": "33101 Plasy Babina"
  },
  {
    "cast": "Babiny I",
    "psc": "40327",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40327 Malecov Babiny I"
  },
  {
    "cast": "Babiny II",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Babiny II"
  },
  {
    "cast": "Babolky",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Babolky"
  },
  {
    "cast": "Babylon",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Babylon",
    "val": "34401 Babylon Babylon"
  },
  {
    "cast": "Bacov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50601 Mladejov Bacov"
  },
  {
    "cast": "Bácovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Bácovice",
    "val": "39301 Bacovice Bacovice"
  },
  {
    "cast": "Bačalky",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Bačalky",
    "val": "50723 Bacalky Bacalky"
  },
  {
    "cast": "Bačetín",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bačetín",
    "val": "51801 Bacetin Bacetin"
  },
  {
    "cast": "Bačice",
    "psc": "67555",
    "okres": "Třebíč",
    "obec": "Bačice",
    "val": "67555 Bacice Bacice"
  },
  {
    "cast": "Bačkov",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Bačkov",
    "val": "58291 Backov Backov"
  },
  {
    "cast": "Bačkovice",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Bačkovice",
    "val": "67532 Backovice Backovice"
  },
  {
    "cast": "Bačov",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Boskovice",
    "val": "68001 Boskovice Bacov"
  },
  {
    "cast": "Bahno",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Černíny",
    "val": "28401 Cerniny Bahno"
  },
  {
    "cast": "Bakov",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Beřovice",
    "val": "27371 Berovice Bakov"
  },
  {
    "cast": "Bakov",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Studnice",
    "val": "54701 Studnice Bakov"
  },
  {
    "cast": "Bakov nad Jizerou",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Bakov nad Jizerou"
  },
  {
    "cast": "Baldovec",
    "psc": "79861",
    "okres": "Prostějov",
    "obec": "Rozstání",
    "val": "79861 Rozstani Baldovec"
  },
  {
    "cast": "Baliny",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Baliny",
    "val": "59401 Baliny Baliny"
  },
  {
    "cast": "Balková",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Tis u Blatna",
    "val": "33165 Tis u Blatna Balkova"
  },
  {
    "cast": "Balkova Lhota",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Balkova Lhota",
    "val": "39131 Balkova Lhota Balkova Lhota"
  },
  {
    "cast": "Balkovy",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Balkovy"
  },
  {
    "cast": "Banín",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Banín",
    "val": "56802 Banin Banin"
  },
  {
    "cast": "Bánov",
    "psc": "68754",
    "okres": "Uherské Hradiště",
    "obec": "Bánov",
    "val": "68754 Banov Banov"
  },
  {
    "cast": "Báňov",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Ješetice",
    "val": "25789 Jesetice Banov"
  },
  {
    "cast": "Báňovice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Báňovice",
    "val": "38001 Banovice Banovice"
  },
  {
    "cast": "Bantice",
    "psc": "67161",
    "okres": "Znojmo",
    "obec": "Bantice",
    "val": "67161 Bantice Bantice"
  },
  {
    "cast": "Barčov",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Barcov"
  },
  {
    "cast": "Barchov",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Barchov",
    "val": "53002 Barchov Barchov"
  },
  {
    "cast": "Barchov",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Barchov",
    "val": "50401 Barchov Barchov"
  },
  {
    "cast": "Barchovice",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Barchovice",
    "val": "28163 Barchovice Barchovice"
  },
  {
    "cast": "Barchůvek",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Měník",
    "val": "50401 Menik Barchuvek"
  },
  {
    "cast": "Barochov",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Řehenice",
    "val": "25167 Rehenice Barochov"
  },
  {
    "cast": "Barovice",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Barovice"
  },
  {
    "cast": "Bartoňov",
    "psc": "78963",
    "okres": "Šumperk",
    "obec": "Ruda nad Moravou",
    "val": "78963 Ruda nad Moravou Bartonov"
  },
  {
    "cast": "Bartošovice",
    "psc": "74254",
    "okres": "Nový Jičín",
    "obec": "Bartošovice",
    "val": "74254 Bartosovice Bartosovice"
  },
  {
    "cast": "Bartošovice v Orlických horách",
    "psc": "51761",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bartošovice v Orlických horách",
    "val": "51761 Bartosovice v Orlickych horach Bartosovice v Orlickych horach"
  },
  {
    "cast": "Bartoušov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičíněves",
    "val": "50601 Jicineves Bartousov"
  },
  {
    "cast": "Bartoušov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Bartoušov",
    "val": "58001 Bartousov Bartousov"
  },
  {
    "cast": "Bartovice (část)",
    "psc": "71700",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71700 Ostrava Bartovice (cast)"
  },
  {
    "cast": "Bartovice (část)",
    "psc": "73934",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "73934 Ostrava Bartovice (cast)"
  },
  {
    "cast": "Bartultovice",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Vysoká",
    "val": "79399 Vysoka Bartultovice"
  },
  {
    "cast": "Bařice",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Bařice-Velké Těšany",
    "val": "76701 Barice-Velke Tesany Barice"
  },
  {
    "cast": "Baška",
    "psc": "73901",
    "okres": "Frýdek-Místek",
    "obec": "Baška",
    "val": "73901 Baska Baska"
  },
  {
    "cast": "Bašnice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Bašnice",
    "val": "50801 Basnice Basnice"
  },
  {
    "cast": "Bašť",
    "psc": "25065",
    "okres": "Praha-východ",
    "obec": "Bašť",
    "val": "25065 Bast Bast"
  },
  {
    "cast": "Bašta",
    "psc": "28123",
    "okres": "Kolín",
    "obec": "Starý Kolín",
    "val": "28123 Stary Kolin Basta"
  },
  {
    "cast": "Batelov",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Batelov",
    "val": "58851 Batelov Batelov"
  },
  {
    "cast": "Batín",
    "psc": "50722",
    "okres": "Jičín",
    "obec": "Střevač",
    "val": "50722 Strevac Batin"
  },
  {
    "cast": "Batňovice (část)",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Batňovice",
    "val": "54232 Batnovice Batnovice (cast)"
  },
  {
    "cast": "Batňovice (část)",
    "psc": "54237",
    "okres": "Trutnov",
    "obec": "Batňovice",
    "val": "54237 Batnovice Batnovice (cast)"
  },
  {
    "cast": "Batňovice (část)",
    "psc": "54234",
    "okres": "Trutnov",
    "obec": "Batňovice",
    "val": "54234 Batnovice Batnovice (cast)"
  },
  {
    "cast": "Batouchovice",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Bochovice",
    "val": "67505 Bochovice Batouchovice"
  },
  {
    "cast": "Bavorov",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Bavorov",
    "val": "38773 Bavorov Bavorov"
  },
  {
    "cast": "Bavorovice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Bavorovice"
  },
  {
    "cast": "Bavory",
    "psc": "69201",
    "okres": "Břeclav",
    "obec": "Bavory",
    "val": "69201 Bavory Bavory"
  },
  {
    "cast": "Bavoryně",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Bavoryně",
    "val": "26751 Bavoryne Bavoryne"
  },
  {
    "cast": "Bdeněves",
    "psc": "33032",
    "okres": "Plzeň-sever",
    "obec": "Bdeněves",
    "val": "33032 Bdeneves Bdeneves"
  },
  {
    "cast": "Bdín",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Bdín",
    "val": "27054 Bdin Bdin"
  },
  {
    "cast": "Bečice",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Bečice",
    "val": "39175 Becice Becice"
  },
  {
    "cast": "Bečice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Bečice",
    "val": "37501 Becice Becice"
  },
  {
    "cast": "Bečov",
    "psc": "43526",
    "okres": "Most",
    "obec": "Bečov",
    "val": "43526 Becov Becov"
  },
  {
    "cast": "Bečov",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Blatno",
    "val": "43001 Blatno Becov"
  },
  {
    "cast": "Bečov nad Teplou",
    "psc": "36464",
    "okres": "Karlovy Vary",
    "obec": "Bečov nad Teplou",
    "val": "36464 Becov nad Teplou Becov nad Teplou"
  },
  {
    "cast": "Bečváry",
    "psc": "28143",
    "okres": "Kolín",
    "obec": "Bečváry",
    "val": "28143 Becvary Becvary"
  },
  {
    "cast": "Bedihošť",
    "psc": "79821",
    "okres": "Prostějov",
    "obec": "Bedihošť",
    "val": "79821 Bedihost Bedihost"
  },
  {
    "cast": "Bedlno",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Jesenice",
    "val": "27033 Jesenice Bedlno"
  },
  {
    "cast": "Bednárec",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Bednárec",
    "val": "37842 Bednarec Bednarec"
  },
  {
    "cast": "Bednáreček",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Bednáreček",
    "val": "37842 Bednarecek Bednarecek"
  },
  {
    "cast": "Bedrč",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Bedrc"
  },
  {
    "cast": "Bedřichov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pacov",
    "val": "39501 Pacov Bedrichov"
  },
  {
    "cast": "Bedřichov",
    "psc": "78801",
    "okres": "Šumperk",
    "obec": "Oskava",
    "val": "78801 Oskava Bedrichov"
  },
  {
    "cast": "Bedřichov",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Bedřichov",
    "val": "67971 Bedrichov Bedrichov"
  },
  {
    "cast": "Bedřichov",
    "psc": "46812",
    "okres": "Jablonec nad Nisou",
    "obec": "Bedřichov",
    "val": "46812 Bedrichov Bedrichov"
  },
  {
    "cast": "Bedřichov",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Nepoměřice",
    "val": "28504 Nepomerice Bedrichov"
  },
  {
    "cast": "Bedřichov",
    "psc": "54351",
    "okres": "Trutnov",
    "obec": "Špindlerův Mlýn",
    "val": "54351 Spindleruv Mlyn Bedrichov"
  },
  {
    "cast": "Bedřichov (část)",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Bedrichov (cast)"
  },
  {
    "cast": "Bedřichov (část)",
    "psc": "37335",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37335 Horni Stropnice Bedrichov (cast)"
  },
  {
    "cast": "Bedřichovice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Bedrichovice"
  },
  {
    "cast": "Bedřichovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Hříškov",
    "val": "44001 Hriskov Bedrichovice"
  },
  {
    "cast": "Bedřichovice",
    "psc": "66451",
    "okres": "Brno-venkov",
    "obec": "Šlapanice",
    "val": "66451 Slapanice Bedrichovice"
  },
  {
    "cast": "Bedřichovka-Liberec XXXIV x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Bedrichovka-Liberec XXXIV x)"
  },
  {
    "cast": "Bedřichův Světec",
    "psc": "43401",
    "okres": "Most",
    "obec": "Bělušice",
    "val": "43401 Belusice Bedrichuv Svetec"
  },
  {
    "cast": "Běhánky (část)",
    "psc": "41702",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41702 Dubi Behanky (cast)"
  },
  {
    "cast": "Běhánky (část)",
    "psc": "41701",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41701 Dubi Behanky (cast)"
  },
  {
    "cast": "Běhařov",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Běhařov",
    "val": "34021 Beharov Beharov"
  },
  {
    "cast": "Běhařovice",
    "psc": "67139",
    "okres": "Znojmo",
    "obec": "Běhařovice",
    "val": "67139 Beharovice Beharovice"
  },
  {
    "cast": "Běchárky",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Běchary",
    "val": "50732 Bechary Becharky"
  },
  {
    "cast": "Běchary",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Běchary",
    "val": "50732 Bechary Bechary"
  },
  {
    "cast": "Bechlejovice-Děčín XXVI x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Bechlejovice-Decin XXVI x)"
  },
  {
    "cast": "Bechlín",
    "psc": "41186",
    "okres": "Litoměřice",
    "obec": "Bechlín",
    "val": "41186 Bechlin Bechlin"
  },
  {
    "cast": "Bechov",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Bousov",
    "val": "29404 Dolni Bousov Bechov"
  },
  {
    "cast": "Běchovice",
    "psc": "19011",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19011 Praha Bechovice"
  },
  {
    "cast": "Bechyně",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Bechyně",
    "val": "39165 Bechyne Bechyne"
  },
  {
    "cast": "Bechyňská Smoleč",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Sudoměřice u Bechyně",
    "val": "39165 Sudomerice u Bechyne Bechynska Smolec"
  },
  {
    "cast": "Bělá",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Bela"
  },
  {
    "cast": "Bělá",
    "psc": "74723",
    "okres": "Opava",
    "obec": "Bělá",
    "val": "74723 Bela Bela"
  },
  {
    "cast": "Bělá",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Bělá",
    "val": "51401 Bela Bela"
  },
  {
    "cast": "Bělá",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Bělá",
    "val": "39301 Bela Bela"
  },
  {
    "cast": "Bělá",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Nová Pec",
    "val": "38451 Nova Pec Bela"
  },
  {
    "cast": "Bělá",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Malonty",
    "val": "38241 Malonty Bela"
  },
  {
    "cast": "Bělá",
    "psc": "79001",
    "okres": "Jeseník",
    "obec": "Bělá pod Pradědem",
    "val": "79001 Bela pod Pradedem Bela"
  },
  {
    "cast": "Bělá",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Bela"
  },
  {
    "cast": "Bělá",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Bělá",
    "val": "58401 Bela Bela"
  },
  {
    "cast": "Bělá",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51601 Liberk Bela"
  },
  {
    "cast": "Bělá nad Radbuzou",
    "psc": "34526",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34526 Bela nad Radbuzou Bela nad Radbuzou"
  },
  {
    "cast": "Bělá nad Svitavou",
    "psc": "56905",
    "okres": "Svitavy",
    "obec": "Bělá nad Svitavou",
    "val": "56905 Bela nad Svitavou Bela nad Svitavou"
  },
  {
    "cast": "Bělá pod Bezdězem",
    "psc": "29421",
    "okres": "Mladá Boleslav",
    "obec": "Bělá pod Bezdězem",
    "val": "29421 Bela pod Bezdezem Bela pod Bezdezem"
  },
  {
    "cast": "Bělá u Jevíčka",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Bělá u Jevíčka",
    "val": "56943 Bela u Jevicka Bela u Jevicka"
  },
  {
    "cast": "Bělá u Pecky",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Pecka",
    "val": "50782 Pecka Bela u Pecky"
  },
  {
    "cast": "Bělá-Děčín X x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Bela-Decin X x)"
  },
  {
    "cast": "Bělbožice",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Šípy",
    "val": "27034 Sipy Belbozice"
  },
  {
    "cast": "Bělčice",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Ostředek",
    "val": "25724 Ostredek Belcice"
  },
  {
    "cast": "Bělčice",
    "psc": "38743",
    "okres": "Strakonice",
    "obec": "Bělčice",
    "val": "38743 Belcice Belcice"
  },
  {
    "cast": "Bělčovice",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Dešná",
    "val": "37881 Desna Belcovice"
  },
  {
    "cast": "Běleč",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Liteň",
    "val": "26727 Liten Belec"
  },
  {
    "cast": "Běleč",
    "psc": "27363",
    "okres": "Kladno",
    "obec": "Běleč",
    "val": "27363 Belec Belec"
  },
  {
    "cast": "Běleč",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Běleč",
    "val": "39143 Belec Belec"
  },
  {
    "cast": "Běleč",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Těšovice",
    "val": "38301 Tesovice Belec"
  },
  {
    "cast": "Běleč",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Běleč",
    "val": "67923 Belec Belec"
  },
  {
    "cast": "Běleč nad Orlicí",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Běleč nad Orlicí",
    "val": "50346 Belec nad Orlici Belec nad Orlici"
  },
  {
    "cast": "Bělečko",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Býšť",
    "val": "53401 Byst Belecko"
  },
  {
    "cast": "Bělečská Lhota",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Těšovice",
    "val": "38301 Tesovice Belecska Lhota"
  },
  {
    "cast": "Bělešovice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Slepotice",
    "val": "53002 Slepotice Belesovice"
  },
  {
    "cast": "Bělice (část)",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Belice (cast)"
  },
  {
    "cast": "Bělice (část)",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25744 Neveklov Belice (cast)"
  },
  {
    "cast": "Bělidla",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Belidla"
  },
  {
    "cast": "Bělkovice-Lašťany",
    "psc": "78316",
    "okres": "Olomouc",
    "obec": "Bělkovice-Lašťany",
    "val": "78316 Belkovice-Lastany Belkovice-Lastany"
  },
  {
    "cast": "Bělohrad",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Nečín",
    "val": "26301 Necin Belohrad"
  },
  {
    "cast": "Bělokozly",
    "psc": "28506",
    "okres": "Benešov",
    "obec": "Sázava",
    "val": "28506 Sazava Belokozly"
  },
  {
    "cast": "Běloky",
    "psc": "27353",
    "okres": "Kladno",
    "obec": "Běloky",
    "val": "27353 Beloky Beloky"
  },
  {
    "cast": "Bělotín",
    "psc": "75364",
    "okres": "Přerov",
    "obec": "Bělotín",
    "val": "75364 Belotin Belotin"
  },
  {
    "cast": "Bělov",
    "psc": "76821",
    "okres": "Zlín",
    "obec": "Bělov",
    "val": "76821 Belov Belov"
  },
  {
    "cast": "Běloves",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Beloves"
  },
  {
    "cast": "Bělský Les",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Belsky Les"
  },
  {
    "cast": "Běluň",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Brzice",
    "val": "55205 Brzice Belun"
  },
  {
    "cast": "Běluň",
    "psc": "55212",
    "okres": "Náchod",
    "obec": "Heřmanice",
    "val": "55212 Hermanice Belun"
  },
  {
    "cast": "Bělušice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Bělušice",
    "val": "43401 Belusice Belusice"
  },
  {
    "cast": "Bělušice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Bělušice",
    "val": "28002 Belusice Belusice"
  },
  {
    "cast": "Bělý",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Machov",
    "val": "54931 Machov Bely"
  },
  {
    "cast": "Benátecká Vrutice",
    "psc": "28923",
    "okres": "Nymburk",
    "obec": "Milovice",
    "val": "28923 Milovice Benatecka Vrutice"
  },
  {
    "cast": "Benátky",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28506 Uzice Benatky"
  },
  {
    "cast": "Benátky",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Benátky",
    "val": "57001 Benatky Benatky"
  },
  {
    "cast": "Benátky",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Benatky"
  },
  {
    "cast": "Benátky",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Benátky",
    "val": "50303 Benatky Benatky"
  },
  {
    "cast": "Benátky",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Jimramov",
    "val": "59242 Jimramov Benatky"
  },
  {
    "cast": "Benátky",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec nad Doubravou",
    "val": "58263 Zdirec nad Doubravou Benatky"
  },
  {
    "cast": "Benátky nad Jizerou I",
    "psc": "29471",
    "okres": "Mladá Boleslav",
    "obec": "Benátky nad Jizerou",
    "val": "29471 Benatky nad Jizerou Benatky nad Jizerou I"
  },
  {
    "cast": "Benátky nad Jizerou II",
    "psc": "29471",
    "okres": "Mladá Boleslav",
    "obec": "Benátky nad Jizerou",
    "val": "29471 Benatky nad Jizerou Benatky nad Jizerou II"
  },
  {
    "cast": "Benátky nad Jizerou III",
    "psc": "29471",
    "okres": "Mladá Boleslav",
    "obec": "Benátky nad Jizerou",
    "val": "29471 Benatky nad Jizerou Benatky nad Jizerou III"
  },
  {
    "cast": "Bendovo Záhoří",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Bendovo Zahori"
  },
  {
    "cast": "Benecko",
    "psc": "51237",
    "okres": "Semily",
    "obec": "Benecko",
    "val": "51237 Benecko Benecko"
  },
  {
    "cast": "Beneda",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Bušanovice",
    "val": "38422 Busanovice Beneda"
  },
  {
    "cast": "Benešov",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Broumov",
    "val": "55001 Broumov Benesov"
  },
  {
    "cast": "Benešov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Benesov"
  },
  {
    "cast": "Benešov",
    "psc": "67953",
    "okres": "Blansko",
    "obec": "Benešov",
    "val": "67953 Benesov Benesov"
  },
  {
    "cast": "Benešov",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39470 Cernovice Benesov"
  },
  {
    "cast": "Benešov nad Černou",
    "psc": "38282",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38282 Benesov nad Cernou Benesov nad Cernou"
  },
  {
    "cast": "Benešov nad Ploučnicí",
    "psc": "40722",
    "okres": "Děčín",
    "obec": "Benešov nad Ploučnicí",
    "val": "40722 Benesov nad Ploucnici Benesov nad Ploucnici"
  },
  {
    "cast": "Benešov u Semil",
    "psc": "51206",
    "okres": "Semily",
    "obec": "Benešov u Semil",
    "val": "51206 Benesov u Semil Benesov u Semil"
  },
  {
    "cast": "Benešova Hora",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Benesova Hora"
  },
  {
    "cast": "Benešovice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Brloh",
    "val": "53501 Brloh Benesovice"
  },
  {
    "cast": "Benešovice",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Benešovice",
    "val": "34901 Benesovice Benesovice"
  },
  {
    "cast": "Benešovice",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Benesovice"
  },
  {
    "cast": "Benetice",
    "psc": "67506",
    "okres": "Třebíč",
    "obec": "Benetice",
    "val": "67506 Benetice Benetice"
  },
  {
    "cast": "Benetice",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Benetice"
  },
  {
    "cast": "Benice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Chrášťany",
    "val": "25744 Chrastany Benice"
  },
  {
    "cast": "Benice",
    "psc": "10300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10300 Praha Benice"
  },
  {
    "cast": "Benkov",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Benkov"
  },
  {
    "cast": "Benkov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Dlouhomilov",
    "val": "78901 Dlouhomilov Benkov"
  },
  {
    "cast": "Benkovice",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Hradec nad Moravicí",
    "val": "74741 Hradec nad Moravici Benkovice"
  },
  {
    "cast": "Beňov",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Beňov",
    "val": "75002 Benov Benov"
  },
  {
    "cast": "Beňovy",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Benovy"
  },
  {
    "cast": "Beranov",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Beranov"
  },
  {
    "cast": "Beranova Lhota",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Beranova Lhota"
  },
  {
    "cast": "Beranovec",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Suchá",
    "val": "58833 Sucha Beranovec"
  },
  {
    "cast": "Beranovka",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Beranovka"
  },
  {
    "cast": "Bergov",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Vlčice",
    "val": "79065 Vlcice Bergov"
  },
  {
    "cast": "Bernardov",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Bernardov",
    "val": "28401 Bernardov Bernardov"
  },
  {
    "cast": "Bernartice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Bernartice"
  },
  {
    "cast": "Bernartice",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Bernartice"
  },
  {
    "cast": "Bernartice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Bernartice",
    "val": "25765 Bernartice Bernartice"
  },
  {
    "cast": "Bernartice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Bernartice"
  },
  {
    "cast": "Bernartice",
    "psc": "54204",
    "okres": "Trutnov",
    "obec": "Bernartice",
    "val": "54204 Bernartice Bernartice"
  },
  {
    "cast": "Bernartice",
    "psc": "79057",
    "okres": "Jeseník",
    "obec": "Bernartice",
    "val": "79057 Bernartice Bernartice"
  },
  {
    "cast": "Bernartice nad Odrou",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Bernartice nad Odrou",
    "val": "74101 Bernartice nad Odrou Bernartice nad Odrou"
  },
  {
    "cast": "Bernov",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Krajková",
    "val": "35709 Krajkova Bernov"
  },
  {
    "cast": "Bernov",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36221 Nejdek Bernov"
  },
  {
    "cast": "Beroun",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Beroun"
  },
  {
    "cast": "Beroun-Centrum",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Beroun-Centrum"
  },
  {
    "cast": "Beroun-Hostim",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Beroun-Hostim"
  },
  {
    "cast": "Beroun-Jarov",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Beroun-Jarov"
  },
  {
    "cast": "Beroun-Město",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Beroun-Mesto"
  },
  {
    "cast": "Beroun-Zavadilka",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Beroun-Zavadilka"
  },
  {
    "cast": "Beroun-Závodí",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Beroun-Zavodi"
  },
  {
    "cast": "Beroun-Zdejcina",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Beroun-Zdejcina"
  },
  {
    "cast": "Bertoldka",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Šárovcova Lhota",
    "val": "50801 Sarovcova Lhota Bertoldka"
  },
  {
    "cast": "Běrunice",
    "psc": "28908",
    "okres": "Nymburk",
    "obec": "Běrunice",
    "val": "28908 Berunice Berunice"
  },
  {
    "cast": "Běruničky",
    "psc": "28908",
    "okres": "Nymburk",
    "obec": "Běrunice",
    "val": "28908 Berunice Berunicky"
  },
  {
    "cast": "Běřín",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Jince",
    "val": "26223 Jince Berin"
  },
  {
    "cast": "Beřovice",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Beřovice",
    "val": "27371 Berovice Berovice"
  },
  {
    "cast": "Besedice",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Koberovy",
    "val": "46822 Koberovy Besedice"
  },
  {
    "cast": "Besednice (část)",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Besednice",
    "val": "38241 Besednice Besednice (cast)"
  },
  {
    "cast": "Besednice (část)",
    "psc": "38281",
    "okres": "Český Krumlov",
    "obec": "Besednice",
    "val": "38281 Besednice Besednice (cast)"
  },
  {
    "cast": "Běsno",
    "psc": "43986",
    "okres": "Louny",
    "obec": "Kryry",
    "val": "43986 Kryry Besno"
  },
  {
    "cast": "Běstovice",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Běstovice",
    "val": "56501 Bestovice Bestovice"
  },
  {
    "cast": "Běstvina",
    "psc": "53845",
    "okres": "Chrudim",
    "obec": "Běstvina",
    "val": "53845 Bestvina Bestvina"
  },
  {
    "cast": "Běstviny",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobruška",
    "val": "51801 Dobruska Bestviny"
  },
  {
    "cast": "Bešetín",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Žihobce",
    "val": "34201 Zihobce Besetin"
  },
  {
    "cast": "Běšiny",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Běšiny",
    "val": "33901 Besiny Besiny"
  },
  {
    "cast": "Beškov",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Blatce",
    "val": "47201 Blatce Beskov"
  },
  {
    "cast": "Běštín",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Běštín",
    "val": "26724 Bestin Bestin"
  },
  {
    "cast": "Betlem",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Samšina",
    "val": "50601 Samsina Betlem"
  },
  {
    "cast": "Bezděčí",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Velké Opatovice",
    "val": "67961 Velke Opatovice Bezdeci"
  },
  {
    "cast": "Bezděčí u Trnávky",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Bezděčí u Trnávky",
    "val": "56943 Bezdeci u Trnavky Bezdeci u Trnavky"
  },
  {
    "cast": "Bezděčín",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Obrataň",
    "val": "39501 Obratan Bezdecin"
  },
  {
    "cast": "Bezděčín",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Batelov",
    "val": "58851 Batelov Bezdecin"
  },
  {
    "cast": "Bezděčín",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Stružinec",
    "val": "51251 Struzinec Bezdecin"
  },
  {
    "cast": "Bezděčín",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Bezdecin"
  },
  {
    "cast": "Bezděčín",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Bezdecin"
  },
  {
    "cast": "Bezděčín (část)",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Želeč",
    "val": "39175 Zelec Bezdecin (cast)"
  },
  {
    "cast": "Bezděčín (část)",
    "psc": "39174",
    "okres": "Tábor",
    "obec": "Želeč",
    "val": "39174 Zelec Bezdecin (cast)"
  },
  {
    "cast": "Bezdědice",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Hostomice",
    "val": "26724 Hostomice Bezdedice"
  },
  {
    "cast": "Bezdědice",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Bělá pod Bezdězem",
    "val": "29425 Bela pod Bezdezem Bezdedice"
  },
  {
    "cast": "Bezdědovice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Bezdědovice",
    "val": "38801 Bezdedovice Bezdedovice"
  },
  {
    "cast": "Bezděkov",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žatec",
    "val": "43801 Zatec Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Pavlov",
    "val": "58901 Pavlov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25722 Vranov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Třemešné",
    "val": "34806 Tremesne Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Lukavec",
    "val": "39501 Lukavec Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Bezděkov",
    "val": "33824 Bezdekov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bezděkov",
    "val": "33901 Bezdekov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Bezděkov",
    "val": "53501 Bezdekov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Loket",
    "val": "25768 Loket Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Hradiště",
    "val": "33544 Hradiste Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Bezděkov",
    "val": "58301 Bezdekov Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34815 Bor Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Bezdekov"
  },
  {
    "cast": "Bezděkov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58001 Krasna Hora Bezdekov"
  },
  {
    "cast": "Bezděkov nad Metují (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Bezděkov nad Metují",
    "val": "54931 Bezdekov nad Metuji Bezdekov nad Metuji (cast)"
  },
  {
    "cast": "Bezděkov nad Metují (část)",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Bezděkov nad Metují",
    "val": "54954 Bezdekov nad Metuji Bezdekov nad Metuji (cast)"
  },
  {
    "cast": "Bezděkov nad Metují (část)",
    "psc": "54964",
    "okres": "Náchod",
    "obec": "Bezděkov nad Metují",
    "val": "54964 Bezdekov nad Metuji Bezdekov nad Metuji (cast)"
  },
  {
    "cast": "Bezděkov pod Třemšínem",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Bezděkov pod Třemšínem",
    "val": "26242 Bezdekov pod Tremsinem Bezdekov pod Tremsinem"
  },
  {
    "cast": "Bezděkov u Úsova",
    "psc": "78973",
    "okres": "Šumperk",
    "obec": "Úsov",
    "val": "78973 Usov Bezdekov u Usova"
  },
  {
    "cast": "Bezděkovec",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mileč",
    "val": "33501 Milec Bezdekovec"
  },
  {
    "cast": "Bezděkovské Předměstí",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Domažlice",
    "val": "34401 Domazlice Bezdekovske Predmesti"
  },
  {
    "cast": "Bezděz",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Bezděz",
    "val": "47201 Bezdez Bezdez"
  },
  {
    "cast": "Bezdružice",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Bezdruzice"
  },
  {
    "cast": "Bezejovice (část)",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Bezejovice (cast)"
  },
  {
    "cast": "Bezejovice (část)",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25751 Marsovice Bezejovice (cast)"
  },
  {
    "cast": "Bezemín",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Cebiv",
    "val": "34952 Cebiv Bezemin"
  },
  {
    "cast": "Bezkov",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Bezkov",
    "val": "66902 Bezkov Bezkov"
  },
  {
    "cast": "Bezměrov",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Bezměrov",
    "val": "76701 Bezmerov Bezmerov"
  },
  {
    "cast": "Bezmíř",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25753 Vojkov Bezmir"
  },
  {
    "cast": "Bezník",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Borek",
    "val": "50771 Borek Beznik"
  },
  {
    "cast": "Bezno",
    "psc": "29429",
    "okres": "Mladá Boleslav",
    "obec": "Bezno",
    "val": "29429 Bezno Bezno"
  },
  {
    "cast": "Bezpravovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Chudenice",
    "val": "33901 Chudenice Bezpravovice"
  },
  {
    "cast": "Beztahov",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Beztahov"
  },
  {
    "cast": "Bezuchov",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Bezuchov",
    "val": "75354 Bezuchov Bezuchov"
  },
  {
    "cast": "Bezvěrov",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Bezverov"
  },
  {
    "cast": "Bezvěrov",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Bezverov"
  },
  {
    "cast": "Bežerovice",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Sudoměřice u Bechyně",
    "val": "39165 Sudomerice u Bechyne Bezerovice"
  },
  {
    "cast": "Bílá",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Bila"
  },
  {
    "cast": "Bílá",
    "psc": "73915",
    "okres": "Frýdek-Místek",
    "obec": "Bílá",
    "val": "73915 Bila Bila"
  },
  {
    "cast": "Bílá",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Číměř",
    "val": "37833 Cimer Bila"
  },
  {
    "cast": "Bílá Bříza",
    "psc": "74728",
    "okres": "Opava",
    "obec": "Štěpánkovice",
    "val": "74728 Stepankovice Bila Briza"
  },
  {
    "cast": "Bílá Hlína",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Bílá Hlína",
    "val": "29501 Bila Hlina Bila Hlina"
  },
  {
    "cast": "Bílá Lhota",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Bílá Lhota",
    "val": "78321 Bila Lhota Bila Lhota"
  },
  {
    "cast": "Bílá Skála",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Terešov",
    "val": "33808 Teresov Bila Skala"
  },
  {
    "cast": "Bílá Studně",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Staré Město",
    "val": "57101 Stare Mesto Bila Studne"
  },
  {
    "cast": "Bílá Třemešná (část)",
    "psc": "54472",
    "okres": "Trutnov",
    "obec": "Bílá Třemešná",
    "val": "54472 Bila Tremesna Bila Tremesna (cast)"
  },
  {
    "cast": "Bílá Třemešná (část)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Bílá Třemešná",
    "val": "54401 Bila Tremesna Bila Tremesna (cast)"
  },
  {
    "cast": "Bílá Voda (část)",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56169 Cervena Voda Bila Voda (cast)"
  },
  {
    "cast": "Bílá Voda (část)",
    "psc": "56162",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56162 Cervena Voda Bila Voda (cast)"
  },
  {
    "cast": "Bilantova Lhota",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Trpišovice",
    "val": "58401 Trpisovice Bilantova Lhota"
  },
  {
    "cast": "Bílany",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Bilany"
  },
  {
    "cast": "Bílavsko (část)",
    "psc": "76841",
    "okres": "Kroměříž",
    "obec": "Bystřice pod Hostýnem",
    "val": "76841 Bystrice pod Hostynem Bilavsko (cast)"
  },
  {
    "cast": "Bílavsko (část)",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Bystřice pod Hostýnem",
    "val": "76861 Bystrice pod Hostynem Bilavsko (cast)"
  },
  {
    "cast": "Bílčice",
    "psc": "79368",
    "okres": "Bruntál",
    "obec": "Bílčice",
    "val": "79368 Bilcice Bilcice"
  },
  {
    "cast": "Bílé Podolí",
    "psc": "28572",
    "okres": "Kutná Hora",
    "obec": "Bílé Podolí",
    "val": "28572 Bile Podoli Bile Podoli"
  },
  {
    "cast": "Bílé Poličany",
    "psc": "54452",
    "okres": "Trutnov",
    "obec": "Bílé Poličany",
    "val": "54452 Bile Policany Bile Policany"
  },
  {
    "cast": "Bílé Předměstí (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Bile Predmesti (cast)"
  },
  {
    "cast": "Bílé Předměstí (část)",
    "psc": "53003",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53003 Pardubice Bile Predmesti (cast)"
  },
  {
    "cast": "Bílé Předměstí (část)",
    "psc": "53012",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53012 Pardubice Bile Predmesti (cast)"
  },
  {
    "cast": "Bílé Vchynice",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Kladruby nad Labem",
    "val": "53316 Kladruby nad Labem Bile Vchynice"
  },
  {
    "cast": "Bílek",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Bilek"
  },
  {
    "cast": "Bílence",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Bílence",
    "val": "43001 Bilence Bilence"
  },
  {
    "cast": "Bílenec",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Petrohrad",
    "val": "44101 Petrohrad Bilenec"
  },
  {
    "cast": "Bílenice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Žihobce",
    "val": "34201 Zihobce Bilenice"
  },
  {
    "cast": "Bíletín",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Biletin"
  },
  {
    "cast": "Bílichov",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Bílichov",
    "val": "27374 Bilichov Bilichov"
  },
  {
    "cast": "Bilina",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Veselíčko",
    "val": "39843 Veselicko Bilina"
  },
  {
    "cast": "Bílina",
    "psc": "41801",
    "okres": "Teplice",
    "obec": "Bílina",
    "val": "41801 Bilina Bilina"
  },
  {
    "cast": "Bilinka",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Bilinka"
  },
  {
    "cast": "Bílinka",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41002 Velemin Bilinka"
  },
  {
    "cast": "Bílka",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bořislav",
    "val": "41501 Borislav Bilka"
  },
  {
    "cast": "Bílkov",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Bilkov"
  },
  {
    "cast": "Bílkovice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Bílkovice",
    "val": "25726 Bilkovice Bilkovice"
  },
  {
    "cast": "Bílov",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Bílov",
    "val": "74301 Bilov Bilov"
  },
  {
    "cast": "Bílov",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Bílov",
    "val": "33141 Bilov Bilov"
  },
  {
    "cast": "Bílovec",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Bílovec",
    "val": "74301 Bilovec Bilovec"
  },
  {
    "cast": "Bílovice",
    "psc": "79841",
    "okres": "Prostějov",
    "obec": "Bílovice-Lutotín",
    "val": "79841 Bilovice-Lutotin Bilovice"
  },
  {
    "cast": "Bílovice",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Bílovice",
    "val": "68712 Bilovice Bilovice"
  },
  {
    "cast": "Bílovice nad Svitavou",
    "psc": "66401",
    "okres": "Brno-venkov",
    "obec": "Bílovice nad Svitavou",
    "val": "66401 Bilovice nad Svitavou Bilovice nad Svitavou"
  },
  {
    "cast": "Bílsko",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Údrnice",
    "val": "50732 Udrnice Bilsko"
  },
  {
    "cast": "Bílsko",
    "psc": "78322",
    "okres": "Olomouc",
    "obec": "Bílsko",
    "val": "78322 Bilsko Bilsko"
  },
  {
    "cast": "Bílsko",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Bílsko",
    "val": "38773 Bilsko Bilsko"
  },
  {
    "cast": "Bílsko u Hořic",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Bílsko u Hořic",
    "val": "50801 Bilsko u Horic Bilsko u Horic"
  },
  {
    "cast": "Bíluky",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "34012 Mecin Biluky"
  },
  {
    "cast": "Bílý Kámen",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Bílý Kámen",
    "val": "58841 Bily Kamen Bily Kamen"
  },
  {
    "cast": "Bílý Kámen",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Podhořany u Ronova",
    "val": "53803 Podhorany u Ronova Bily Kamen"
  },
  {
    "cast": "Bílý Kostel nad Nisou",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Bílý Kostel nad Nisou",
    "val": "46331 Bily Kostel nad Nisou Bily Kostel nad Nisou"
  },
  {
    "cast": "Bílý Kostelec",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Bily Kostelec"
  },
  {
    "cast": "Bílý Kůň",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Střemošice",
    "val": "53854 Stremosice Bily Kun"
  },
  {
    "cast": "Bílý Potok",
    "psc": "46362",
    "okres": "Liberec",
    "obec": "Bílý Potok",
    "val": "46362 Bily Potok Bily Potok"
  },
  {
    "cast": "Bílý Potok",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Javorník",
    "val": "79070 Javornik Bily Potok"
  },
  {
    "cast": "Bílý Potok",
    "psc": "79326",
    "okres": "Bruntál",
    "obec": "Vrbno pod Pradědem",
    "val": "79326 Vrbno pod Pradedem Bily Potok"
  },
  {
    "cast": "Bílý Újezd",
    "psc": "41131",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41131 Velemin Bily Ujezd"
  },
  {
    "cast": "Bílý Újezd",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bílý Újezd",
    "val": "51801 Bily Ujezd Bily Ujezd"
  },
  {
    "cast": "Biřkov",
    "psc": "33401",
    "okres": "Klatovy",
    "obec": "Biřkov",
    "val": "33401 Birkov Birkov"
  },
  {
    "cast": "Biskoupky",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Sebečice",
    "val": "33808 Sebecice Biskoupky"
  },
  {
    "cast": "Biskoupky",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Biskoupky",
    "val": "66491 Biskoupky Biskoupky"
  },
  {
    "cast": "Biskupice",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Biskupice",
    "val": "56943 Biskupice Biskupice"
  },
  {
    "cast": "Biskupice",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Biskupice",
    "val": "53843 Biskupice Biskupice"
  },
  {
    "cast": "Biskupice",
    "psc": "67557",
    "okres": "Třebíč",
    "obec": "Biskupice-Pulkov",
    "val": "67557 Biskupice-Pulkov Biskupice"
  },
  {
    "cast": "Biskupice",
    "psc": "79812",
    "okres": "Prostějov",
    "obec": "Biskupice",
    "val": "79812 Biskupice Biskupice"
  },
  {
    "cast": "Biskupice",
    "psc": "76341",
    "okres": "Zlín",
    "obec": "Biskupice",
    "val": "76341 Biskupice Biskupice"
  },
  {
    "cast": "Bitětice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Bitetice"
  },
  {
    "cast": "Bítouchov",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Semily",
    "val": "51301 Semily Bitouchov"
  },
  {
    "cast": "Bítouchov",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Veselá",
    "val": "51263 Vesela Bitouchov"
  },
  {
    "cast": "Bítouchov",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bítouchov",
    "val": "29401 Bitouchov Bitouchov"
  },
  {
    "cast": "Bítov",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Radenín",
    "val": "39155 Radenin Bitov"
  },
  {
    "cast": "Bítov",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Koněprusy",
    "val": "26601 Koneprusy Bitov"
  },
  {
    "cast": "Bítov",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Bítov",
    "val": "74301 Bitov Bitov"
  },
  {
    "cast": "Bítov",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Přehýšov",
    "val": "33023 Prehysov Bitov"
  },
  {
    "cast": "Bítov (část)",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Bítov",
    "val": "67107 Bitov Bitov (cast)"
  },
  {
    "cast": "Bítov (část)",
    "psc": "67110",
    "okres": "Znojmo",
    "obec": "Bítov",
    "val": "67110 Bitov Bitov (cast)"
  },
  {
    "cast": "Bítovánky",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Želetava",
    "val": "67526 Zeletava Bitovanky"
  },
  {
    "cast": "Bítovánky",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Bítovany",
    "val": "53851 Bitovany Bitovanky"
  },
  {
    "cast": "Bítovany",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Bítovany",
    "val": "53851 Bitovany Bitovany"
  },
  {
    "cast": "Bítovčice",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Bítovčice",
    "val": "58822 Bitovcice Bitovcice"
  },
  {
    "cast": "Bitozeves",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Bitozeves",
    "val": "44001 Bitozeves Bitozeves"
  },
  {
    "cast": "Blahoňov",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Kuřimské Jestřabí",
    "val": "59455 Kurimske Jestrabi Blahonov"
  },
  {
    "cast": "Blahotice",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Blahotice"
  },
  {
    "cast": "Blahousty",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Erpužice",
    "val": "34901 Erpuzice Blahousty"
  },
  {
    "cast": "Bláhov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Blahov"
  },
  {
    "cast": "Bláhova Lhota",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Vysoký Chlumec",
    "val": "26401 Vysoky Chlumec Blahova Lhota"
  },
  {
    "cast": "Blahuňov",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Místo",
    "val": "43001 Misto Blahunov"
  },
  {
    "cast": "Blahutovice",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Jeseník nad Odrou",
    "val": "74101 Jesenik nad Odrou Blahutovice"
  },
  {
    "cast": "Blanice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Bavorov",
    "val": "38901 Bavorov Blanice"
  },
  {
    "cast": "Blanice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Blanice"
  },
  {
    "cast": "Blanička",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Rodná",
    "val": "39143 Rodna Blanicka"
  },
  {
    "cast": "Blanička",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Strunkovice nad Blanicí",
    "val": "38301 Strunkovice nad Blanici Blanicka"
  },
  {
    "cast": "Blankartice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Heřmanov",
    "val": "40502 Hermanov Blankartice"
  },
  {
    "cast": "Blanné",
    "psc": "67154",
    "okres": "Znojmo",
    "obec": "Blanné",
    "val": "67154 Blanne Blanne"
  },
  {
    "cast": "Blansko",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Blansko"
  },
  {
    "cast": "Blansko",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Blansko"
  },
  {
    "cast": "Blansko",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Hrochův Týnec",
    "val": "53862 Hrochuv Tynec Blansko"
  },
  {
    "cast": "Blansko",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Blansko"
  },
  {
    "cast": "Blata",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Nýrsko",
    "val": "34022 Nyrsko Blata"
  },
  {
    "cast": "Blata",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Zámostí-Blata",
    "val": "50601 Zamosti-Blata Blata"
  },
  {
    "cast": "Blatce",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Blatce",
    "val": "47201 Blatce Blatce"
  },
  {
    "cast": "Blatec",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Hodětín",
    "val": "39165 Hodetin Blatec"
  },
  {
    "cast": "Blatec",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Blatec",
    "val": "78375 Blatec Blatec"
  },
  {
    "cast": "Blatec",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Rovensko pod Troskami",
    "val": "51263 Rovensko pod Troskami Blatec"
  },
  {
    "cast": "Blatečky",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Blatce",
    "val": "47201 Blatce Blatecky"
  },
  {
    "cast": "Blatenka",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Blatenka"
  },
  {
    "cast": "Blatiny",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Sněžné",
    "val": "59202 Snezne Blatiny"
  },
  {
    "cast": "Blatná",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Blatna"
  },
  {
    "cast": "Blatná",
    "psc": "38279",
    "okres": "Český Krumlov",
    "obec": "Frymburk",
    "val": "38279 Frymburk Blatna"
  },
  {
    "cast": "Blatnice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Pojbuky",
    "val": "39143 Pojbuky Blatnice"
  },
  {
    "cast": "Blatnice",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Maleč",
    "val": "58301 Malec Blatnice"
  },
  {
    "cast": "Blatnice",
    "psc": "33025",
    "okres": "Plzeň-sever",
    "obec": "Blatnice",
    "val": "33025 Blatnice Blatnice"
  },
  {
    "cast": "Blatnice",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Blatnice",
    "val": "67551 Blatnice Blatnice"
  },
  {
    "cast": "Blatnice pod Svatým Antonínkem",
    "psc": "69671",
    "okres": "Hodonín",
    "obec": "Blatnice pod Svatým Antonínkem",
    "val": "69671 Blatnice pod Svatym Antoninkem Blatnice pod Svatym Antoninkem"
  },
  {
    "cast": "Blatnička",
    "psc": "69671",
    "okres": "Hodonín",
    "obec": "Blatnička",
    "val": "69671 Blatnicka Blatnicka"
  },
  {
    "cast": "Blatno",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Blatno",
    "val": "43001 Blatno Blatno"
  },
  {
    "cast": "Blatno",
    "psc": "43984",
    "okres": "Louny",
    "obec": "Blatno",
    "val": "43984 Blatno Blatno"
  },
  {
    "cast": "Blatno",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Hlinsko",
    "val": "53901 Hlinsko Blatno"
  },
  {
    "cast": "Blato",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Mikulovice",
    "val": "53002 Mikulovice Blato"
  },
  {
    "cast": "Blato",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Blato"
  },
  {
    "cast": "Bláto",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Uhlířské Janovice",
    "val": "28504 Uhlirske Janovice Blato"
  },
  {
    "cast": "Blazice",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Blazice",
    "val": "76861 Blazice Blazice"
  },
  {
    "cast": "Blažejov",
    "psc": "37852",
    "okres": "Jindřichův Hradec",
    "obec": "Blažejov",
    "val": "37852 Blazejov Blazejov"
  },
  {
    "cast": "Blažejovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Zbytiny",
    "val": "38301 Zbytiny Blazejovice"
  },
  {
    "cast": "Blažejovice",
    "psc": "59257",
    "okres": "Žďár nad Sázavou",
    "obec": "Rozsochy",
    "val": "59257 Rozsochy Blazejovice"
  },
  {
    "cast": "Blažejovice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Blažejovice",
    "val": "25768 Blazejovice Blazejovice"
  },
  {
    "cast": "Blaženice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Rabyně",
    "val": "25744 Rabyne Blazenice"
  },
  {
    "cast": "Blažim",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Blažim",
    "val": "44001 Blazim Blazim"
  },
  {
    "cast": "Blažim",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Blažim",
    "val": "33038 Blazim Blazim"
  },
  {
    "cast": "Blažim",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25744 Neveklov Blazim"
  },
  {
    "cast": "Blažkov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Omlenice",
    "val": "38241 Omlenice Blazkov"
  },
  {
    "cast": "Blažkov",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Blažkov",
    "val": "59251 Blazkov Blazkov"
  },
  {
    "cast": "Blažkov",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Slavoňov",
    "val": "54901 Slavonov Blazkov"
  },
  {
    "cast": "Blažnov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Křešín",
    "val": "39501 Kresin Blaznov"
  },
  {
    "cast": "Blažov",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Blazov"
  },
  {
    "cast": "Blažovice",
    "psc": "66408",
    "okres": "Brno-venkov",
    "obec": "Blažovice",
    "val": "66408 Blazovice Blazovice"
  },
  {
    "cast": "Blehov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Zhoř",
    "val": "39901 Zhor Blehov"
  },
  {
    "cast": "Blešno",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebívlice",
    "val": "41115 Trebivlice Blesno"
  },
  {
    "cast": "Blešno",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Blešno",
    "val": "50346 Blesno Blesno"
  },
  {
    "cast": "Blevice",
    "psc": "27328",
    "okres": "Kladno",
    "obec": "Blevice",
    "val": "27328 Blevice Blevice"
  },
  {
    "cast": "Blinka",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Plaňany",
    "val": "28002 Planany Blinka"
  },
  {
    "cast": "Blišice",
    "psc": "76805",
    "okres": "Kroměříž",
    "obec": "Koryčany",
    "val": "76805 Korycany Blisice"
  },
  {
    "cast": "Blízkov",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Blízkov",
    "val": "59442 Blizkov Blizkov"
  },
  {
    "cast": "Bližanovy",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34034 Planice Blizanovy"
  },
  {
    "cast": "Blížejov",
    "psc": "34545",
    "okres": "Domažlice",
    "obec": "Blížejov",
    "val": "34545 Blizejov Blizejov"
  },
  {
    "cast": "Blíževedly",
    "psc": "47104",
    "okres": "Česká Lípa",
    "obec": "Blíževedly",
    "val": "47104 Blizevedly Blizevedly"
  },
  {
    "cast": "Blížkovice",
    "psc": "67155",
    "okres": "Znojmo",
    "obec": "Blížkovice",
    "val": "67155 Blizkovice Blizkovice"
  },
  {
    "cast": "Bližná",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Černá v Pošumaví",
    "val": "38226 Cerna v Posumavi Blizna"
  },
  {
    "cast": "Blížňovice",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Hrochův Týnec",
    "val": "53862 Hrochuv Tynec Bliznovice"
  },
  {
    "cast": "Bližší Lhota",
    "psc": "38451",
    "okres": "Český Krumlov",
    "obec": "Horní Planá",
    "val": "38451 Horni Plana Blizsi Lhota"
  },
  {
    "cast": "Blov",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Vilémov",
    "val": "43201 Vilemov Blov"
  },
  {
    "cast": "Blovice",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Blovice"
  },
  {
    "cast": "Blšany",
    "psc": "43988",
    "okres": "Louny",
    "obec": "Blšany",
    "val": "43988 Blsany Blsany"
  },
  {
    "cast": "Blšany u Loun",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Blšany u Loun",
    "val": "44001 Blsany u Loun Blsany u Loun"
  },
  {
    "cast": "Blučina",
    "psc": "66456",
    "okres": "Brno-venkov",
    "obec": "Blučina",
    "val": "66456 Blucina Blucina"
  },
  {
    "cast": "Bludná",
    "psc": "36236",
    "okres": "Karlovy Vary",
    "obec": "Pernink",
    "val": "36236 Pernink Bludna"
  },
  {
    "cast": "Bludov",
    "psc": "78961",
    "okres": "Šumperk",
    "obec": "Bludov",
    "val": "78961 Bludov Bludov"
  },
  {
    "cast": "Bludov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Bludov",
    "val": "28601 Bludov Bludov"
  },
  {
    "cast": "Bludovice",
    "psc": "73601",
    "okres": "Karviná",
    "obec": "Havířov",
    "val": "73601 Havirov Bludovice"
  },
  {
    "cast": "Bludovice",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Nový Jičín",
    "val": "74101 Novy Jicin Bludovice"
  },
  {
    "cast": "Bobnice",
    "psc": "28931",
    "okres": "Nymburk",
    "obec": "Bobnice",
    "val": "28931 Bobnice Bobnice"
  },
  {
    "cast": "Bobov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Bobov"
  },
  {
    "cast": "Bobr",
    "psc": "54201",
    "okres": "Trutnov",
    "obec": "Žacléř",
    "val": "54201 Zacler Bobr"
  },
  {
    "cast": "Bobrová",
    "psc": "59255",
    "okres": "Žďár nad Sázavou",
    "obec": "Bobrová",
    "val": "59255 Bobrova Bobrova"
  },
  {
    "cast": "Bobrovník",
    "psc": "79061",
    "okres": "Jeseník",
    "obec": "Lipová-lázně",
    "val": "79061 Lipova-lazne Bobrovnik"
  },
  {
    "cast": "Bobrovníky",
    "psc": "74801",
    "okres": "Opava",
    "obec": "Hlučín",
    "val": "74801 Hlucin Bobrovniky"
  },
  {
    "cast": "Bobrůvka",
    "psc": "59255",
    "okres": "Žďár nad Sázavou",
    "obec": "Bobrůvka",
    "val": "59255 Bobruvka Bobruvka"
  },
  {
    "cast": "Bocanovice",
    "psc": "73991",
    "okres": "Frýdek-Místek",
    "obec": "Bocanovice",
    "val": "73991 Bocanovice Bocanovice"
  },
  {
    "cast": "Boč",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Boc"
  },
  {
    "cast": "Boháňka",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Boháňka",
    "val": "50801 Bohanka Bohanka"
  },
  {
    "cast": "Boharyně",
    "psc": "50323",
    "okres": "Hradec Králové",
    "obec": "Boharyně",
    "val": "50323 Boharyne Boharyne"
  },
  {
    "cast": "Bohaté Málkovice",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Bohaté Málkovice",
    "val": "68501 Bohate Malkovice Bohate Malkovice"
  },
  {
    "cast": "Bohatice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Bohatice",
    "val": "47002 Bohatice Bohatice"
  },
  {
    "cast": "Bohatice",
    "psc": "36004",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36004 Karlovy Vary Bohatice"
  },
  {
    "cast": "Bohdalec",
    "psc": "59255",
    "okres": "Žďár nad Sázavou",
    "obec": "Bohdalec",
    "val": "59255 Bohdalec Bohdalec"
  },
  {
    "cast": "Bohdalice",
    "psc": "68341",
    "okres": "Vyškov",
    "obec": "Bohdalice-Pavlovice",
    "val": "68341 Bohdalice-Pavlovice Bohdalice"
  },
  {
    "cast": "Bohdalín",
    "psc": "39491",
    "okres": "Pelhřimov",
    "obec": "Bohdalín",
    "val": "39491 Bohdalin Bohdalin"
  },
  {
    "cast": "Bohdalov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Bohdalov"
  },
  {
    "cast": "Bohdalov (část)",
    "psc": "59213",
    "okres": "Žďár nad Sázavou",
    "obec": "Bohdalov",
    "val": "59213 Bohdalov Bohdalov (cast)"
  },
  {
    "cast": "Bohdalov (část)",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Bohdalov",
    "val": "59214 Bohdalov Bohdalov (cast)"
  },
  {
    "cast": "Bohdalovice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Bohdalovice",
    "val": "38101 Bohdalovice Bohdalovice"
  },
  {
    "cast": "Bohdalovice",
    "psc": "46845",
    "okres": "Jablonec nad Nisou",
    "obec": "Velké Hamry",
    "val": "46845 Velke Hamry Bohdalovice"
  },
  {
    "cast": "Bohdaneč (část)",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Bohdaneč",
    "val": "28522 Bohdanec Bohdanec (cast)"
  },
  {
    "cast": "Bohdaneč (část)",
    "psc": "28525",
    "okres": "Kutná Hora",
    "obec": "Bohdaneč",
    "val": "28525 Bohdanec Bohdanec (cast)"
  },
  {
    "cast": "Bohdánkov",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46342 Bila Bohdankov"
  },
  {
    "cast": "Bohdanovice",
    "psc": "74755",
    "okres": "Opava",
    "obec": "Jakartovice",
    "val": "74755 Jakartovice Bohdanovice"
  },
  {
    "cast": "Bohdašice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dlouhá Ves",
    "val": "34201 Dlouha Ves Bohdasice"
  },
  {
    "cast": "Bohdašín",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Červený Kostelec",
    "val": "54941 Cerveny Kostelec Bohdasin"
  },
  {
    "cast": "Bohdašín",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Bohdasin"
  },
  {
    "cast": "Bohdašín (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bohdašín",
    "val": "51801 Bohdasin Bohdasin (cast)"
  },
  {
    "cast": "Bohdašín (část)",
    "psc": "54922",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bohdašín",
    "val": "54922 Bohdasin Bohdasin (cast)"
  },
  {
    "cast": "Bohdašín (část)",
    "psc": "54901",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bohdašín",
    "val": "54901 Bohdasin Bohdasin (cast)"
  },
  {
    "cast": "Bohdíkov",
    "psc": "78964",
    "okres": "Šumperk",
    "obec": "Bohdíkov",
    "val": "78964 Bohdikov Bohdikov"
  },
  {
    "cast": "Bohnice (část)",
    "psc": "18100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18100 Praha Bohnice (cast)"
  },
  {
    "cast": "Bohnice (část)",
    "psc": "18200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18200 Praha Bohnice (cast)"
  },
  {
    "cast": "Bohostice (část)",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Bohostice",
    "val": "26231 Bohostice Bohostice (cast)"
  },
  {
    "cast": "Bohostice (část)",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Bohostice",
    "val": "26263 Bohostice Bohostice (cast)"
  },
  {
    "cast": "Bohosudov (část)",
    "psc": "41741",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41741 Krupka Bohosudov (cast)"
  },
  {
    "cast": "Bohosudov (část)",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Bohosudov (cast)"
  },
  {
    "cast": "Bohouňovice I",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Červené Pečky",
    "val": "28002 Cervene Pecky Bohounovice I"
  },
  {
    "cast": "Bohouňovice II",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Horní Kruty",
    "val": "28163 Horni Kruty Bohounovice II"
  },
  {
    "cast": "Bohousová",
    "psc": "56186",
    "okres": "Ústí nad Orlicí",
    "obec": "Záchlumí",
    "val": "56186 Zachlumi Bohousova"
  },
  {
    "cast": "Bohouškovice",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Bohouskovice"
  },
  {
    "cast": "Bohučovice",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Hradec nad Moravicí",
    "val": "74741 Hradec nad Moravici Bohucovice"
  },
  {
    "cast": "Bohuliby",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Petrov",
    "val": "25401 Petrov Bohuliby"
  },
  {
    "cast": "Bohumileč",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Rokytno",
    "val": "53304 Rokytno Bohumilec"
  },
  {
    "cast": "Bohumileč",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Bohumilec"
  },
  {
    "cast": "Bohumilice",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Bohumilice",
    "val": "38481 Bohumilice Bohumilice"
  },
  {
    "cast": "Bohumilice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kožlí",
    "val": "58401 Kozli Bohumilice"
  },
  {
    "cast": "Bohumilice",
    "psc": "69172",
    "okres": "Břeclav",
    "obec": "Klobouky u Brna",
    "val": "69172 Klobouky u Brna Bohumilice"
  },
  {
    "cast": "Bohumín-Nový Bohumín x)",
    "psc": "73581",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73581 Bohumin Bohumin-Novy Bohumin x)"
  },
  {
    "cast": "Bohumín-Pudlov x)",
    "psc": "73551",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73551 Bohumin Bohumin-Pudlov x)"
  },
  {
    "cast": "Bohumín-Skřečoň x)",
    "psc": "73531",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73531 Bohumin Bohumin-Skrecon x)"
  },
  {
    "cast": "Bohumín-Starý Bohumín x)",
    "psc": "73581",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73581 Bohumin Bohumin-Stary Bohumin x)"
  },
  {
    "cast": "Bohumín-Šunychl x)",
    "psc": "73581",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73581 Bohumin Bohumin-Sunychl x)"
  },
  {
    "cast": "Bohumín-Vrbice x)",
    "psc": "73551",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73551 Bohumin Bohumin-Vrbice x)"
  },
  {
    "cast": "Bohumín-Záblatí x)",
    "psc": "73552",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73552 Bohumin Bohumin-Zablati x)"
  },
  {
    "cast": "Bohunice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Bohunice",
    "val": "38422 Bohunice Bohunice"
  },
  {
    "cast": "Bohunice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Všemyslice",
    "val": "37501 Vsemyslice Bohunice"
  },
  {
    "cast": "Bohunice (část)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Bohunice (cast)"
  },
  {
    "cast": "Bohunice (část)",
    "psc": "62500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62500 Brno Bohunice (cast)"
  },
  {
    "cast": "Bohunice (část)",
    "psc": "63900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63900 Brno Bohunice (cast)"
  },
  {
    "cast": "Bohuňov",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Bohuňov",
    "val": "56904 Bohunov Bohunov"
  },
  {
    "cast": "Bohuňov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bohuňov",
    "val": "59301 Bohunov Bohunov"
  },
  {
    "cast": "Bohuňovice",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Bohuňovice",
    "val": "57001 Bohunovice Bohunovice"
  },
  {
    "cast": "Bohuňovice",
    "psc": "78314",
    "okres": "Olomouc",
    "obec": "Bohuňovice",
    "val": "78314 Bohunovice Bohunovice"
  },
  {
    "cast": "Bohuňovsko",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Jesenný",
    "val": "51301 Jesenny Bohunovsko"
  },
  {
    "cast": "Bohuslav",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51101 Hruba Skala Bohuslav"
  },
  {
    "cast": "Bohuslav",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "35301 Tepla Bohuslav"
  },
  {
    "cast": "Bohuslavice",
    "psc": "69655",
    "okres": "Hodonín",
    "obec": "Kyjov",
    "val": "69655 Kyjov Bohuslavice"
  },
  {
    "cast": "Bohuslavice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Bohuslavice",
    "val": "58856 Bohuslavice Bohuslavice"
  },
  {
    "cast": "Bohuslavice",
    "psc": "78972",
    "okres": "Šumperk",
    "obec": "Bohuslavice",
    "val": "78972 Bohuslavice Bohuslavice"
  },
  {
    "cast": "Bohuslavice",
    "psc": "74719",
    "okres": "Opava",
    "obec": "Bohuslavice",
    "val": "74719 Bohuslavice Bohuslavice"
  },
  {
    "cast": "Bohuslavice",
    "psc": "79856",
    "okres": "Prostějov",
    "obec": "Bohuslavice",
    "val": "79856 Bohuslavice Bohuslavice"
  },
  {
    "cast": "Bohuslavice nad Vláří",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Bohuslavice nad Vláří",
    "val": "76321 Bohuslavice nad Vlari Bohuslavice nad Vlari"
  },
  {
    "cast": "Bohuslavice u Zlína",
    "psc": "76351",
    "okres": "Zlín",
    "obec": "Bohuslavice u Zlína",
    "val": "76351 Bohuslavice u Zlina Bohuslavice u Zlina"
  },
  {
    "cast": "Bohuslavice (část)",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54232 Trutnov Bohuslavice (cast)"
  },
  {
    "cast": "Bohuslavice (část)",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Bohuslavice (cast)"
  },
  {
    "cast": "Bohuslavice (část)",
    "psc": "54906",
    "okres": "Náchod",
    "obec": "Bohuslavice",
    "val": "54906 Bohuslavice Bohuslavice (cast)"
  },
  {
    "cast": "Bohuslavice (část)",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Bohuslavice",
    "val": "54901 Bohuslavice Bohuslavice (cast)"
  },
  {
    "cast": "Bohuslávky",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Bohuslávky",
    "val": "75131 Bohuslavky Bohuslavky"
  },
  {
    "cast": "Bohusoudov",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Knínice",
    "val": "58856 Kninice Bohusoudov"
  },
  {
    "cast": "Bohušice",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Bohušice",
    "val": "67551 Bohusice Bohusice"
  },
  {
    "cast": "Bohušov",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Bohušov",
    "val": "79399 Bohusov Bohusov"
  },
  {
    "cast": "Bohušov",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Bohusov"
  },
  {
    "cast": "Bohušovice nad Ohří",
    "psc": "41156",
    "okres": "Litoměřice",
    "obec": "Bohušovice nad Ohří",
    "val": "41156 Bohusovice nad Ohri Bohusovice nad Ohri"
  },
  {
    "cast": "Bohutice",
    "psc": "67176",
    "okres": "Znojmo",
    "obec": "Bohutice",
    "val": "67176 Bohutice Bohutice"
  },
  {
    "cast": "Bohutín",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Lidmaň",
    "val": "39501 Lidman Bohutin"
  },
  {
    "cast": "Bohutín",
    "psc": "26241",
    "okres": "Příbram",
    "obec": "Bohutín",
    "val": "26241 Bohutin Bohutin"
  },
  {
    "cast": "Bohutín",
    "psc": "78962",
    "okres": "Šumperk",
    "obec": "Bohutín",
    "val": "78962 Bohutin Bohutin"
  },
  {
    "cast": "Bohy",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Bohy",
    "val": "33141 Bohy Bohy"
  },
  {
    "cast": "Bochoř",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Bochoř",
    "val": "75002 Bochor Bochor"
  },
  {
    "cast": "Bochov",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Bochov"
  },
  {
    "cast": "Bochovice",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Bochovice",
    "val": "67505 Bochovice Bochovice"
  },
  {
    "cast": "Bojanov",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Křižanov",
    "val": "59451 Krizanov Bojanov"
  },
  {
    "cast": "Bojanov (část)",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Bojanov (cast)"
  },
  {
    "cast": "Bojanov (část)",
    "psc": "53826",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53826 Bojanov Bojanov (cast)"
  },
  {
    "cast": "Bojanovice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Rabí",
    "val": "34201 Rabi Bojanovice"
  },
  {
    "cast": "Bojanovice",
    "psc": "76831",
    "okres": "Kroměříž",
    "obec": "Zlobice",
    "val": "76831 Zlobice Bojanovice"
  },
  {
    "cast": "Bojanovice",
    "psc": "25206",
    "okres": "Praha-západ",
    "obec": "Bojanovice",
    "val": "25206 Bojanovice Bojanovice"
  },
  {
    "cast": "Bojanovice",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Bojanovice",
    "val": "67153 Bojanovice Bojanovice"
  },
  {
    "cast": "Boječnice",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Bojecnice"
  },
  {
    "cast": "Bojenice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Bojenice"
  },
  {
    "cast": "Boješice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Bojesice"
  },
  {
    "cast": "Bojetice",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Dobrovice",
    "val": "29441 Dobrovice Bojetice"
  },
  {
    "cast": "Bojiště",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Bojiste"
  },
  {
    "cast": "Bojiště",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Červené Pečky",
    "val": "28002 Cervene Pecky Bojiste"
  },
  {
    "cast": "Bojiště",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Bojiště",
    "val": "58401 Bojiste Bojiste"
  },
  {
    "cast": "Bojkovice",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Bojkovice",
    "val": "68771 Bojkovice Bojkovice"
  },
  {
    "cast": "Bojmany",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Žehušice",
    "val": "28601 Zehusice Bojmany"
  },
  {
    "cast": "Bojov",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Čisovice",
    "val": "25210 Cisovice Bojov"
  },
  {
    "cast": "Bolatice",
    "psc": "74723",
    "okres": "Opava",
    "obec": "Bolatice",
    "val": "74723 Bolatice Bolatice"
  },
  {
    "cast": "Boleboř",
    "psc": "43121",
    "okres": "Chomutov",
    "obec": "Boleboř",
    "val": "43121 Bolebor Bolebor"
  },
  {
    "cast": "Bolehošť",
    "psc": "51731",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bolehošť",
    "val": "51731 Bolehost Bolehost"
  },
  {
    "cast": "Bolehošťská Lhota",
    "psc": "51731",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bolehošť",
    "val": "51731 Bolehost Bolehostska Lhota"
  },
  {
    "cast": "Bolechov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Želiv",
    "val": "39601 Zeliv Bolechov"
  },
  {
    "cast": "Bolechovice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "26401 Sedlec-Prcice Bolechovice"
  },
  {
    "cast": "Bolelouc",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Dub nad Moravou",
    "val": "78375 Dub nad Moravou Bolelouc"
  },
  {
    "cast": "Boleradice",
    "psc": "69112",
    "okres": "Břeclav",
    "obec": "Boleradice",
    "val": "69112 Boleradice Boleradice"
  },
  {
    "cast": "Boleslav",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Černousy",
    "val": "46373 Cernousy Boleslav"
  },
  {
    "cast": "Bolešín",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Bolesin"
  },
  {
    "cast": "Bolešín",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Věstín",
    "val": "59301 Vestin Bolesin"
  },
  {
    "cast": "Bolešiny",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bolešiny",
    "val": "33901 Bolesiny Bolesiny"
  },
  {
    "cast": "Boletice",
    "psc": "38221",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38221 Kajov Boletice"
  },
  {
    "cast": "Boletice nad Labem-Děčín XXXII x)",
    "psc": "40711",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40711 Decin Boletice nad Labem-Decin XXXII x)"
  },
  {
    "cast": "Boletice (část)",
    "psc": "38208",
    "okres": "Český Krumlov",
    "obec": "Boletice",
    "val": "38208 Boletice Boletice (cast)"
  },
  {
    "cast": "Boletice (část)",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Boletice",
    "val": "38101 Boletice Boletice (cast)"
  },
  {
    "cast": "Bolevec (část)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Bolevec (cast)"
  },
  {
    "cast": "Bolevec (část)",
    "psc": "31600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31600 Plzen Bolevec (cast)"
  },
  {
    "cast": "Bolevec (část)",
    "psc": "32300",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32300 Plzen Bolevec (cast)"
  },
  {
    "cast": "Bolíkovice",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Babice",
    "val": "67544 Babice Bolikovice"
  },
  {
    "cast": "Bolíkovice",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Zálezly",
    "val": "38481 Zalezly Bolikovice"
  },
  {
    "cast": "Bolina",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vlašim",
    "val": "25801 Vlasim Bolina"
  },
  {
    "cast": "Bolkov",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Bolkov",
    "val": "33401 Bolkov Bolkov"
  },
  {
    "cast": "Boněnov",
    "psc": "34813",
    "okres": "Tachov",
    "obec": "Chodová Planá",
    "val": "34813 Chodova Plana Bonenov"
  },
  {
    "cast": "Bonětice",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Bonetice"
  },
  {
    "cast": "Bonětičky",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Boneticky"
  },
  {
    "cast": "Boňkov",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Olšovec",
    "val": "75301 Olsovec Bonkov"
  },
  {
    "cast": "Boňkov",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Boňkov",
    "val": "58255 Bonkov Bonkov"
  },
  {
    "cast": "Bonkovice",
    "psc": "25791",
    "okres": "Benešov",
    "obec": "Střezimíř",
    "val": "25791 Strezimir Bonkovice"
  },
  {
    "cast": "Boňov",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Jaroměřice nad Rokytnou",
    "val": "67551 Jaromerice nad Rokytnou Bonov"
  },
  {
    "cast": "Bor",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Bor"
  },
  {
    "cast": "Bor",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Březnice",
    "val": "26272 Breznice Bor"
  },
  {
    "cast": "Bor",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Střítež",
    "val": "39301 Stritez Bor"
  },
  {
    "cast": "Bor",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nedrahovice",
    "val": "26401 Nedrahovice Bor"
  },
  {
    "cast": "Bor",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Velešín",
    "val": "38232 Velesin Bor"
  },
  {
    "cast": "Bor",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Sadov",
    "val": "36001 Sadov Bor"
  },
  {
    "cast": "Bor",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Sejřek",
    "val": "59262 Sejrek Bor"
  },
  {
    "cast": "Bor",
    "psc": "29443",
    "okres": "Mladá Boleslav",
    "obec": "Vlkava",
    "val": "29443 Vlkava Bor"
  },
  {
    "cast": "Bor",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Suchdol nad Lužnicí",
    "val": "37806 Suchdol nad Luznici Bor"
  },
  {
    "cast": "Bor u Chroustovic",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Rosice",
    "val": "53863 Rosice Bor u Chroustovic"
  },
  {
    "cast": "Bor u Skutče",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Bor u Skutče",
    "val": "53944 Bor u Skutce Bor u Skutce"
  },
  {
    "cast": "Borač",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Borač",
    "val": "59261 Borac Borac"
  },
  {
    "cast": "Boratkov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Boratkov"
  },
  {
    "cast": "Borčice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Dub",
    "val": "38422 Dub Borcice"
  },
  {
    "cast": "Bordovice",
    "psc": "74401",
    "okres": "Nový Jičín",
    "obec": "Bordovice",
    "val": "74401 Bordovice Bordovice"
  },
  {
    "cast": "Boreč",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Boreč",
    "val": "29426 Borec Borec"
  },
  {
    "cast": "Boreč",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41002 Velemin Borec"
  },
  {
    "cast": "Boreček",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "47124 Ralsko Borecek"
  },
  {
    "cast": "Borečnice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Čížová",
    "val": "39701 Cizova Borecnice"
  },
  {
    "cast": "Borek",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Borek",
    "val": "50771 Borek Borek"
  },
  {
    "cast": "Borek",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Košice",
    "val": "39201 Kosice Borek"
  },
  {
    "cast": "Borek",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Borek"
  },
  {
    "cast": "Borek",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40502 Malsovice Borek"
  },
  {
    "cast": "Borek",
    "psc": "27714",
    "okres": "Praha-východ",
    "obec": "Borek",
    "val": "27714 Borek Borek"
  },
  {
    "cast": "Borek",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Horka I",
    "val": "28601 Horka I Borek"
  },
  {
    "cast": "Borek",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Pšov",
    "val": "36452 Psov Borek"
  },
  {
    "cast": "Borek",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Borek"
  },
  {
    "cast": "Borek",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Rokycany",
    "val": "33701 Rokycany Borek"
  },
  {
    "cast": "Borek",
    "psc": "37367",
    "okres": "České Budějovice",
    "obec": "Borek",
    "val": "37367 Borek Borek"
  },
  {
    "cast": "Borek",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kozojedy",
    "val": "33141 Kozojedy Borek"
  },
  {
    "cast": "Borek",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Borek"
  },
  {
    "cast": "Borek",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Zahrádky",
    "val": "47002 Zahradky Borek"
  },
  {
    "cast": "Borek",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Borek",
    "val": "53401 Borek Borek"
  },
  {
    "cast": "Borek",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Borek",
    "val": "58282 Borek Borek"
  },
  {
    "cast": "Borek",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Suchomasty",
    "val": "26701 Suchomasty Borek"
  },
  {
    "cast": "Borek",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Třebovle",
    "val": "28163 Trebovle Borek"
  },
  {
    "cast": "Borek",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51263 Hruba Skala Borek"
  },
  {
    "cast": "Borek",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Jílové u Prahy",
    "val": "25401 Jilove u Prahy Borek"
  },
  {
    "cast": "Borek",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46822 Frydstejn Borek"
  },
  {
    "cast": "Borkovany",
    "psc": "69175",
    "okres": "Břeclav",
    "obec": "Borkovany",
    "val": "69175 Borkovany Borkovany"
  },
  {
    "cast": "Borkovice",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Borkovice",
    "val": "39181 Borkovice Borkovice"
  },
  {
    "cast": "Borohrádek (část)",
    "psc": "51724",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Borohrádek",
    "val": "51724 Borohradek Borohradek (cast)"
  },
  {
    "cast": "Borohrádek (část)",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Borohrádek",
    "val": "51721 Borohradek Borohradek (cast)"
  },
  {
    "cast": "Borotice",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Borotice",
    "val": "67178 Borotice Borotice"
  },
  {
    "cast": "Borotice (část)",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26301 Borotice Borotice (cast)"
  },
  {
    "cast": "Borotice (část)",
    "psc": "26215",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26215 Borotice Borotice (cast)"
  },
  {
    "cast": "Borotín",
    "psc": "39135",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39135 Borotin Borotin"
  },
  {
    "cast": "Borotín",
    "psc": "67937",
    "okres": "Blansko",
    "obec": "Borotín",
    "val": "67937 Borotin Borotin"
  },
  {
    "cast": "Borová",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Borová",
    "val": "54701 Borova Borova"
  },
  {
    "cast": "Borová",
    "psc": "74723",
    "okres": "Opava",
    "obec": "Bolatice",
    "val": "74723 Bolatice Borova"
  },
  {
    "cast": "Borová",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Budeč",
    "val": "38001 Budec Borova"
  },
  {
    "cast": "Borová",
    "psc": "56982",
    "okres": "Svitavy",
    "obec": "Borová",
    "val": "56982 Borova Borova"
  },
  {
    "cast": "Borová",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Borova"
  },
  {
    "cast": "Borová",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "České Heřmanice",
    "val": "56601 Ceske Hermanice Borova"
  },
  {
    "cast": "Borová Lada",
    "psc": "38492",
    "okres": "Prachatice",
    "obec": "Borová Lada",
    "val": "38492 Borova Lada Borova Lada"
  },
  {
    "cast": "Borová Lhota",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Pyšely",
    "val": "25722 Pysely Borova Lhota"
  },
  {
    "cast": "Borová (část)",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Chvalšiny",
    "val": "38203 Chvalsiny Borova (cast)"
  },
  {
    "cast": "Borová (část)",
    "psc": "38208",
    "okres": "Český Krumlov",
    "obec": "Chvalšiny",
    "val": "38208 Chvalsiny Borova (cast)"
  },
  {
    "cast": "Borová (část)",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Chvalšiny",
    "val": "38101 Chvalsiny Borova (cast)"
  },
  {
    "cast": "Borovany",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Borovany"
  },
  {
    "cast": "Borovany",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Borovany",
    "val": "37312 Borovany Borovany"
  },
  {
    "cast": "Borovany",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Borovany",
    "val": "39843 Borovany Borovany"
  },
  {
    "cast": "Borovice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Borovice"
  },
  {
    "cast": "Borovice",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mukařov",
    "val": "29501 Mukarov Borovice"
  },
  {
    "cast": "Borovice",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Libníkovice",
    "val": "50346 Libnikovice Borovice"
  },
  {
    "cast": "Borovina",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Borovina"
  },
  {
    "cast": "Borovka",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Borovka"
  },
  {
    "cast": "Borovná",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Borovná",
    "val": "58856 Borovna Borovna"
  },
  {
    "cast": "Borovnice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Borovnice",
    "val": "25765 Borovnice Borovnice"
  },
  {
    "cast": "Borovnice",
    "psc": "54477",
    "okres": "Trutnov",
    "obec": "Borovnice",
    "val": "54477 Borovnice Borovnice"
  },
  {
    "cast": "Borovnice",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Borovnice",
    "val": "59242 Borovnice Borovnice"
  },
  {
    "cast": "Borovnice",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Borovnice",
    "val": "51741 Borovnice Borovnice"
  },
  {
    "cast": "Borovnice (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Borovnice",
    "val": "37006 Borovnice Borovnice (cast)"
  },
  {
    "cast": "Borovnice (část)",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Borovnice",
    "val": "37007 Borovnice Borovnice (cast)"
  },
  {
    "cast": "Borovnička",
    "psc": "54475",
    "okres": "Trutnov",
    "obec": "Borovnička",
    "val": "54475 Borovnicka Borovnicka"
  },
  {
    "cast": "Borovník",
    "psc": "59451",
    "okres": "Brno-venkov",
    "obec": "Borovník",
    "val": "59451 Borovnik Borovnik"
  },
  {
    "cast": "Borovno",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Borovno",
    "val": "33561 Borovno Borovno"
  },
  {
    "cast": "Borovsko",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Bernartice",
    "val": "25765 Bernartice Borovsko"
  },
  {
    "cast": "Borovy",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Borovy",
    "val": "33401 Borovy Borovy"
  },
  {
    "cast": "Boršice",
    "psc": "68709",
    "okres": "Uherské Hradiště",
    "obec": "Boršice",
    "val": "68709 Borsice Borsice"
  },
  {
    "cast": "Boršice u Blatnice",
    "psc": "68763",
    "okres": "Uherské Hradiště",
    "obec": "Boršice u Blatnice",
    "val": "68763 Borsice u Blatnice Borsice u Blatnice"
  },
  {
    "cast": "Boršíkov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Čížkrajice",
    "val": "37401 Cizkrajice Borsikov"
  },
  {
    "cast": "Boršov",
    "psc": "69701",
    "okres": "Hodonín",
    "obec": "Kyjov",
    "val": "69701 Kyjov Borsov"
  },
  {
    "cast": "Boršov",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Boršov",
    "val": "58805 Borsov Borsov"
  },
  {
    "cast": "Boršov nad Vltavou",
    "psc": "37382",
    "okres": "České Budějovice",
    "obec": "Boršov nad Vltavou",
    "val": "37382 Borsov nad Vltavou Borsov nad Vltavou"
  },
  {
    "cast": "Boršov (část)",
    "psc": "56921",
    "okres": "Svitavy",
    "obec": "Moravská Třebová",
    "val": "56921 Moravska Trebova Borsov (cast)"
  },
  {
    "cast": "Boršov (část)",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Moravská Třebová",
    "val": "57101 Moravska Trebova Borsov (cast)"
  },
  {
    "cast": "Borušov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Borušov",
    "val": "57101 Borusov Borusov"
  },
  {
    "cast": "Bořanovice",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Boranovice"
  },
  {
    "cast": "Bořanovice",
    "psc": "25065",
    "okres": "Praha-východ",
    "obec": "Bořanovice",
    "val": "25065 Boranovice Boranovice"
  },
  {
    "cast": "Bořejov",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Ždírec",
    "val": "47201 Zdirec Borejov"
  },
  {
    "cast": "Bořená Hora",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Štětkovice",
    "val": "26401 Stetkovice Borena Hora"
  },
  {
    "cast": "Bořenovice",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Bořenovice",
    "val": "76901 Borenovice Borenovice"
  },
  {
    "cast": "Bořeňovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Borenovice"
  },
  {
    "cast": "Bořetice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Bořetice",
    "val": "39501 Boretice Boretice"
  },
  {
    "cast": "Bořetice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Červené Pečky",
    "val": "28002 Cervene Pecky Boretice"
  },
  {
    "cast": "Bořetice",
    "psc": "69108",
    "okres": "Břeclav",
    "obec": "Bořetice",
    "val": "69108 Boretice Boretice"
  },
  {
    "cast": "Bořetice (část)",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25703 Neustupov Boretice (cast)"
  },
  {
    "cast": "Bořetice (část)",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Boretice (cast)"
  },
  {
    "cast": "Bořetín",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Stružnice",
    "val": "47001 Struznice Boretin"
  },
  {
    "cast": "Bořetín",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Bořetín",
    "val": "37853 Boretin Boretin"
  },
  {
    "cast": "Bořetín",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Bořetín",
    "val": "39470 Boretin Boretin"
  },
  {
    "cast": "Bořice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39804 Mirotice Borice"
  },
  {
    "cast": "Bořice",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Bořice",
    "val": "53862 Borice Borice"
  },
  {
    "cast": "Bořice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Zahořany",
    "val": "34401 Zahorany Borice"
  },
  {
    "cast": "Boříkovy",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Borikovy"
  },
  {
    "cast": "Bořislav",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bořislav",
    "val": "41501 Borislav Borislav"
  },
  {
    "cast": "Bořitov",
    "psc": "67921",
    "okres": "Blansko",
    "obec": "Bořitov",
    "val": "67921 Boritov Boritov"
  },
  {
    "cast": "Bořitov",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Studené",
    "val": "56164 Studene Boritov"
  },
  {
    "cast": "Bořkov (část)",
    "psc": "51201",
    "okres": "Semily",
    "obec": "Slaná",
    "val": "51201 Slana Borkov (cast)"
  },
  {
    "cast": "Bořkov (část)",
    "psc": "51206",
    "okres": "Semily",
    "obec": "Slaná",
    "val": "51206 Slana Borkov (cast)"
  },
  {
    "cast": "Bořkovice (část)",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25801 Zvestov Borkovice (cast)"
  },
  {
    "cast": "Bořkovice (část)",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Borkovice (cast)"
  },
  {
    "cast": "Boseň",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Boseň",
    "val": "29501 Bosen Bosen"
  },
  {
    "cast": "Boskovice",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Boskovice",
    "val": "68001 Boskovice Boskovice"
  },
  {
    "cast": "Boskovštejn",
    "psc": "67154",
    "okres": "Znojmo",
    "obec": "Boskovštejn",
    "val": "67154 Boskovstejn Boskovstejn"
  },
  {
    "cast": "Bosonohy",
    "psc": "64200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64200 Brno Bosonohy"
  },
  {
    "cast": "Bosyně",
    "psc": "27724",
    "okres": "Mělník",
    "obec": "Vysoká",
    "val": "27724 Vysoka Bosyne"
  },
  {
    "cast": "Bošice",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Bošice",
    "val": "38481 Bosice Bosice"
  },
  {
    "cast": "Bošice",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Svojšice",
    "val": "28163 Svojsice Bosice"
  },
  {
    "cast": "Bošilec (část)",
    "psc": "37364",
    "okres": "České Budějovice",
    "obec": "Bošilec",
    "val": "37364 Bosilec Bosilec (cast)"
  },
  {
    "cast": "Bošilec (část)",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Bošilec",
    "val": "37365 Bosilec Bosilec (cast)"
  },
  {
    "cast": "Bošín",
    "psc": "28933",
    "okres": "Nymburk",
    "obec": "Křinec",
    "val": "28933 Krinec Bosin"
  },
  {
    "cast": "Bošín",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Bošín",
    "val": "56501 Bosin Bosin"
  },
  {
    "cast": "Boškov",
    "psc": "75362",
    "okres": "Přerov",
    "obec": "Potštát",
    "val": "75362 Potstat Boskov"
  },
  {
    "cast": "Boškůvky",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Prusy-Boškůvky",
    "val": "68201 Prusy-Boskuvky Boskuvky"
  },
  {
    "cast": "Bošov",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Vrbice",
    "val": "36453 Vrbice Bosov"
  },
  {
    "cast": "Bošov",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53825 Miretice Bosov"
  },
  {
    "cast": "Bošovice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Čížová",
    "val": "39701 Cizova Bosovice"
  },
  {
    "cast": "Bošovice",
    "psc": "68354",
    "okres": "Vyškov",
    "obec": "Bošovice",
    "val": "68354 Bosovice Bosovice"
  },
  {
    "cast": "Boštice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Petrovice II",
    "val": "28504 Petrovice II Bostice"
  },
  {
    "cast": "Boubín",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Horažďovice",
    "val": "34101 Horazdovice Boubin"
  },
  {
    "cast": "Boubská",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Boubska"
  },
  {
    "cast": "Boučí",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Dolní Nivy",
    "val": "35601 Dolni Nivy Bouci"
  },
  {
    "cast": "Boudy",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Boudy",
    "val": "39804 Boudy Boudy"
  },
  {
    "cast": "Boudy",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Boudy"
  },
  {
    "cast": "Boudy",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Skryje",
    "val": "59455 Skryje Boudy"
  },
  {
    "cast": "Bousín",
    "psc": "79861",
    "okres": "Prostějov",
    "obec": "Bousín",
    "val": "79861 Bousin Bousin"
  },
  {
    "cast": "Bousov",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Bousov",
    "val": "53843 Bousov Bousov"
  },
  {
    "cast": "Boušice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Bousice"
  },
  {
    "cast": "Bouzov",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Bouzov"
  },
  {
    "cast": "Bozdíš",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34601 Meclov Bozdis"
  },
  {
    "cast": "Bozkov",
    "psc": "51213",
    "okres": "Semily",
    "obec": "Bozkov",
    "val": "51213 Bozkov Bozkov"
  },
  {
    "cast": "Božanov",
    "psc": "54974",
    "okres": "Náchod",
    "obec": "Božanov",
    "val": "54974 Bozanov Bozanov"
  },
  {
    "cast": "Božec",
    "psc": "28127",
    "okres": "Kolín",
    "obec": "Krakovany",
    "val": "28127 Krakovany Bozec"
  },
  {
    "cast": "Božejov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Žár",
    "val": "37401 Zar Bozejov"
  },
  {
    "cast": "Božejov (část)",
    "psc": "39461",
    "okres": "Pelhřimov",
    "obec": "Božejov",
    "val": "39461 Bozejov Bozejov (cast)"
  },
  {
    "cast": "Božejov (část)",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Božejov",
    "val": "39301 Bozejov Bozejov (cast)"
  },
  {
    "cast": "Božejovice",
    "psc": "39132",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39132 Jistebnice Bozejovice"
  },
  {
    "cast": "Božetice (část)",
    "psc": "39851",
    "okres": "Písek",
    "obec": "Božetice",
    "val": "39851 Bozetice Bozetice (cast)"
  },
  {
    "cast": "Božetice (část)",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Božetice",
    "val": "39901 Bozetice Bozetice (cast)"
  },
  {
    "cast": "Božetín",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Nový Kostel",
    "val": "35134 Novy Kostel Bozetin"
  },
  {
    "cast": "Božetín",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Bozetin"
  },
  {
    "cast": "Boží Dar",
    "psc": "36262",
    "okres": "Karlovy Vary",
    "obec": "Boží Dar",
    "val": "36262 Bozi Dar Bozi Dar"
  },
  {
    "cast": "Boží Dar",
    "psc": "28924",
    "okres": "Nymburk",
    "obec": "Milovice",
    "val": "28924 Milovice Bozi Dar"
  },
  {
    "cast": "Božice",
    "psc": "67164",
    "okres": "Znojmo",
    "obec": "Božice",
    "val": "67164 Bozice Bozice"
  },
  {
    "cast": "Božičany",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Božičany",
    "val": "36225 Bozicany Bozicany"
  },
  {
    "cast": "Božíkov (část)",
    "psc": "47123",
    "okres": "Česká Lípa",
    "obec": "Zákupy",
    "val": "47123 Zakupy Bozikov (cast)"
  },
  {
    "cast": "Božíkov (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Zákupy",
    "val": "47002 Zakupy Bozikov (cast)"
  },
  {
    "cast": "Božkov",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Bozkov"
  },
  {
    "cast": "Božkov",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Mnichovice",
    "val": "25164 Mnichovice Bozkov"
  },
  {
    "cast": "Božkovice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25753 Bystrice Bozkovice"
  },
  {
    "cast": "Božkovy",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Milavče",
    "val": "34401 Milavce Bozkovy"
  },
  {
    "cast": "Božtěšice",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Boztesice"
  },
  {
    "cast": "Božtěšice",
    "psc": "40340",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40340 Usti nad Labem Boztesice"
  },
  {
    "cast": "Brada",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Brada-Rybníček",
    "val": "50601 Brada-Rybnicek Brada"
  },
  {
    "cast": "Bradáčov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Bradáčov",
    "val": "39143 Bradacov Bradacov"
  },
  {
    "cast": "Bradlec",
    "psc": "29306",
    "okres": "Mladá Boleslav",
    "obec": "Bradlec",
    "val": "29306 Bradlec Bradlec"
  },
  {
    "cast": "Bradlecká Lhota",
    "psc": "50713",
    "okres": "Semily",
    "obec": "Bradlecká Lhota",
    "val": "50713 Bradlecka Lhota Bradlecka Lhota"
  },
  {
    "cast": "Bradlo",
    "psc": "58821",
    "okres": "Jihlava",
    "obec": "Velký Beranov",
    "val": "58821 Velky Beranov Bradlo"
  },
  {
    "cast": "Bradné",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Bradne"
  },
  {
    "cast": "Brambory",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Brambory",
    "val": "28601 Brambory Brambory"
  },
  {
    "cast": "Braňany",
    "psc": "43522",
    "okres": "Most",
    "obec": "Braňany",
    "val": "43522 Branany Branany"
  },
  {
    "cast": "Brandlín",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Tučapy",
    "val": "39201 Tucapy Brandlin"
  },
  {
    "cast": "Brandlín",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Volfířov",
    "val": "38001 Volfirov Brandlin"
  },
  {
    "cast": "Brandov",
    "psc": "43547",
    "okres": "Most",
    "obec": "Brandov",
    "val": "43547 Brandov Brandov"
  },
  {
    "cast": "Brandýs",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Chabeřice",
    "val": "28522 Chaberice Brandys"
  },
  {
    "cast": "Brandýs nad Labem",
    "psc": "25001",
    "okres": "Praha-východ",
    "obec": "Brandýs nad Labem-Stará Boleslav",
    "val": "25001 Brandys nad Labem-Stara Boleslav Brandys nad Labem"
  },
  {
    "cast": "Brandýs nad Orlicí",
    "psc": "56112",
    "okres": "Ústí nad Orlicí",
    "obec": "Brandýs nad Orlicí",
    "val": "56112 Brandys nad Orlici Brandys nad Orlici"
  },
  {
    "cast": "Brandýsek",
    "psc": "27341",
    "okres": "Kladno",
    "obec": "Brandýsek",
    "val": "27341 Brandysek Brandysek"
  },
  {
    "cast": "Branice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Branice",
    "val": "39843 Branice Branice"
  },
  {
    "cast": "Braníčkov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Branickov"
  },
  {
    "cast": "Braník (část)",
    "psc": "14000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14000 Praha Branik (cast)"
  },
  {
    "cast": "Braník (část)",
    "psc": "14700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14700 Praha Branik (cast)"
  },
  {
    "cast": "Braník (část)",
    "psc": "14200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14200 Praha Branik (cast)"
  },
  {
    "cast": "Braníškov",
    "psc": "66471",
    "okres": "Brno-venkov",
    "obec": "Braníškov",
    "val": "66471 Braniskov Braniskov"
  },
  {
    "cast": "Branišov",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Branisov"
  },
  {
    "cast": "Branišov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Branisov"
  },
  {
    "cast": "Branišov",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Branisov"
  },
  {
    "cast": "Branišov",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Branisov"
  },
  {
    "cast": "Branišov",
    "psc": "58842",
    "okres": "Jihlava",
    "obec": "Ústí",
    "val": "58842 Usti Branisov"
  },
  {
    "cast": "Branišov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Vyskytná",
    "val": "39301 Vyskytna Branisov"
  },
  {
    "cast": "Branišov",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Branišov",
    "val": "37384 Branisov Branisov"
  },
  {
    "cast": "Branišov",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Zvole",
    "val": "59251 Zvole Branisov"
  },
  {
    "cast": "Branišov",
    "psc": "58264",
    "okres": "Havlíčkův Brod",
    "obec": "Podmoklany",
    "val": "58264 Podmoklany Branisov"
  },
  {
    "cast": "Branišovice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Branisovice"
  },
  {
    "cast": "Branišovice",
    "psc": "67177",
    "okres": "Brno-venkov",
    "obec": "Branišovice",
    "val": "67177 Branisovice Branisovice"
  },
  {
    "cast": "Branišovice (část)",
    "psc": "37324",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37324 Rimov Branisovice (cast)"
  },
  {
    "cast": "Branišovice (část)",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37401 Rimov Branisovice (cast)"
  },
  {
    "cast": "Branka",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Halže",
    "val": "34701 Halze Branka"
  },
  {
    "cast": "Branka u Opavy",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Branka u Opavy",
    "val": "74741 Branka u Opavy Branka u Opavy"
  },
  {
    "cast": "Brankovice",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Brankovice",
    "val": "68333 Brankovice Brankovice"
  },
  {
    "cast": "Branky",
    "psc": "75645",
    "okres": "Vsetín",
    "obec": "Branky",
    "val": "75645 Branky Branky"
  },
  {
    "cast": "Branná",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Třeboň",
    "val": "37901 Trebon Branna"
  },
  {
    "cast": "Branná",
    "psc": "78825",
    "okres": "Šumperk",
    "obec": "Branná",
    "val": "78825 Branna Branna"
  },
  {
    "cast": "Branov",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Branov",
    "val": "27023 Branov Branov"
  },
  {
    "cast": "Bransouze",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Bransouze",
    "val": "67521 Bransouze Bransouze"
  },
  {
    "cast": "Brantice",
    "psc": "79393",
    "okres": "Bruntál",
    "obec": "Brantice",
    "val": "79393 Brantice Brantice"
  },
  {
    "cast": "Branžež",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Branžež",
    "val": "29402 Branzez Branzez"
  },
  {
    "cast": "Braškov",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Braškov",
    "val": "27351 Braskov Braskov"
  },
  {
    "cast": "Braštice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Brastice"
  },
  {
    "cast": "Bratčice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Bratčice",
    "val": "28601 Bratcice Bratcice"
  },
  {
    "cast": "Bratčice",
    "psc": "66467",
    "okres": "Brno-venkov",
    "obec": "Bratčice",
    "val": "66467 Bratcice Bratcice"
  },
  {
    "cast": "Bratkovice",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Černuc",
    "val": "27324 Cernuc Bratkovice"
  },
  {
    "cast": "Bratkovice",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Bratkovice",
    "val": "26223 Bratkovice Bratkovice"
  },
  {
    "cast": "Bratronice",
    "psc": "27363",
    "okres": "Kladno",
    "obec": "Bratronice",
    "val": "27363 Bratronice Bratronice"
  },
  {
    "cast": "Bratronice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Bratronice",
    "val": "38801 Bratronice Bratronice"
  },
  {
    "cast": "Bratronice",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Smilovice",
    "val": "29442 Smilovice Bratronice"
  },
  {
    "cast": "Bratroňov",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Ctětín",
    "val": "53825 Ctetin Bratronov"
  },
  {
    "cast": "Bratroňov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58001 Krasna Hora Bratronov"
  },
  {
    "cast": "Bratrouchov",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Bratrouchov"
  },
  {
    "cast": "Bratrušín",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Bratrusin"
  },
  {
    "cast": "Bratrušov",
    "psc": "78701",
    "okres": "Šumperk",
    "obec": "Bratrušov",
    "val": "78701 Bratrusov Bratrusov"
  },
  {
    "cast": "Bratřejov",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Bratřejov",
    "val": "76312 Bratrejov Bratrejov"
  },
  {
    "cast": "Bratřejov",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Bratrejov"
  },
  {
    "cast": "Bratřice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Bratřice",
    "val": "39501 Bratrice Bratrice"
  },
  {
    "cast": "Bratříkov (část)",
    "psc": "46826",
    "okres": "Jablonec nad Nisou",
    "obec": "Pěnčín",
    "val": "46826 Pencin Bratrikov (cast)"
  },
  {
    "cast": "Bratříkov (část)",
    "psc": "46821",
    "okres": "Jablonec nad Nisou",
    "obec": "Pěnčín",
    "val": "46821 Pencin Bratrikov (cast)"
  },
  {
    "cast": "Bratříkovice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Bratrikovice"
  },
  {
    "cast": "Bratříkovice",
    "psc": "74752",
    "okres": "Opava",
    "obec": "Bratříkovice",
    "val": "74752 Bratrikovice Bratrikovice"
  },
  {
    "cast": "Bratřínov (část)",
    "psc": "25206",
    "okres": "Praha-západ",
    "obec": "Bratřínov",
    "val": "25206 Bratrinov Bratrinov (cast)"
  },
  {
    "cast": "Bratřínov (část)",
    "psc": "25205",
    "okres": "Praha-západ",
    "obec": "Bratřínov",
    "val": "25205 Bratrinov Bratrinov (cast)"
  },
  {
    "cast": "Bravantice",
    "psc": "74281",
    "okres": "Nový Jičín",
    "obec": "Bravantice",
    "val": "74281 Bravantice Bravantice"
  },
  {
    "cast": "Bravinné",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Bílovec",
    "val": "74301 Bilovec Bravinne"
  },
  {
    "cast": "Bražec",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Brazec"
  },
  {
    "cast": "Bražec",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bražec",
    "val": "36471 Brazec Brazec"
  },
  {
    "cast": "Bražná",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26256 Svaty Jan Brazna"
  },
  {
    "cast": "Brčekoly",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Rosice",
    "val": "53862 Rosice Brcekoly"
  },
  {
    "cast": "Brdečný",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Brdecny"
  },
  {
    "cast": "Brdo",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Brdo"
  },
  {
    "cast": "Brdo",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Stará Paka",
    "val": "50901 Stara Paka Brdo"
  },
  {
    "cast": "Brdo",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Brdo"
  },
  {
    "cast": "Brdo",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Svatá Maří",
    "val": "38501 Svata Mari Brdo"
  },
  {
    "cast": "Bredůvka",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Nekoř",
    "val": "56164 Nekor Breduvka"
  },
  {
    "cast": "Brejlov",
    "psc": "29306",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29306 Bakov nad Jizerou Brejlov"
  },
  {
    "cast": "Brenná",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Zákupy",
    "val": "47002 Zakupy Brenna"
  },
  {
    "cast": "Brloh",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Louny",
    "val": "44001 Louny Brloh"
  },
  {
    "cast": "Brloh",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Drhovle",
    "val": "39701 Drhovle Brloh"
  },
  {
    "cast": "Brloh",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Brloh",
    "val": "53501 Brloh Brloh"
  },
  {
    "cast": "Brloh (část)",
    "psc": "38206",
    "okres": "Český Krumlov",
    "obec": "Brloh",
    "val": "38206 Brloh Brloh (cast)"
  },
  {
    "cast": "Brloh (část)",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Brloh",
    "val": "38203 Brloh Brloh (cast)"
  },
  {
    "cast": "Brložec",
    "psc": "40741",
    "okres": "Děčín",
    "obec": "Dobrná",
    "val": "40741 Dobrna Brlozec"
  },
  {
    "cast": "Brložec",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Štědrá",
    "val": "36452 Stedra Brlozec"
  },
  {
    "cast": "Brná",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Věžná",
    "val": "39501 Vezna Brna"
  },
  {
    "cast": "Brná",
    "psc": "51743",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Potštejn",
    "val": "51743 Potstejn Brna"
  },
  {
    "cast": "Brná (část)",
    "psc": "40003",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40003 Usti nad Labem Brna (cast)"
  },
  {
    "cast": "Brná (část)",
    "psc": "40321",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40321 Usti nad Labem Brna (cast)"
  },
  {
    "cast": "Brňany",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Brnany"
  },
  {
    "cast": "Brňany",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Brňany",
    "val": "41201 Brnany Brnany"
  },
  {
    "cast": "Brněnec",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Brněnec",
    "val": "56904 Brnenec Brnenec"
  },
  {
    "cast": "Brněnské Ivanovice",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Brnenske Ivanovice"
  },
  {
    "cast": "Brníčko",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Brnicko"
  },
  {
    "cast": "Brníčko",
    "psc": "78975",
    "okres": "Šumperk",
    "obec": "Brníčko",
    "val": "78975 Brnicko Brnicko"
  },
  {
    "cast": "Brník",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Oleška",
    "val": "28163 Oleska Brnik"
  },
  {
    "cast": "Brníkov",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Mšené-lázně",
    "val": "41119 Msene-lazne Brnikov"
  },
  {
    "cast": "Brnířov",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Brnířov",
    "val": "34506 Brnirov Brnirov"
  },
  {
    "cast": "Brniště",
    "psc": "47129",
    "okres": "Česká Lípa",
    "obec": "Brniště",
    "val": "47129 Brniste Brniste"
  },
  {
    "cast": "Brnky",
    "psc": "25066",
    "okres": "Praha-východ",
    "obec": "Zdiby",
    "val": "25066 Zdiby Brnky"
  },
  {
    "cast": "Brno-Bohunice (část) x)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Brno-Bohunice (cast) x)"
  },
  {
    "cast": "Brno-Bohunice (část) x)",
    "psc": "62500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62500 Brno Brno-Bohunice (cast) x)"
  },
  {
    "cast": "Brno-Bohunice (část) x)",
    "psc": "63900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63900 Brno Brno-Bohunice (cast) x)"
  },
  {
    "cast": "Brno-Bosonohy x)",
    "psc": "64200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64200 Brno Brno-Bosonohy x)"
  },
  {
    "cast": "Brno-Brněnské Ivanovice x)",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Brno-Brnenske Ivanovice x)"
  },
  {
    "cast": "Brno-Bystrc (část) x)",
    "psc": "63500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63500 Brno Brno-Bystrc (cast) x)"
  },
  {
    "cast": "Brno-Bystrc (část) x)",
    "psc": "66481",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "66481 Brno Brno-Bystrc (cast) x)"
  },
  {
    "cast": "Brno-Bystrc (část) x)",
    "psc": "66471",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "66471 Brno Brno-Bystrc (cast) x)"
  },
  {
    "cast": "Brno-Černovice (část) x)",
    "psc": "61800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61800 Brno Brno-Cernovice (cast) x)"
  },
  {
    "cast": "Brno-Černovice (část) x)",
    "psc": "62700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62700 Brno Brno-Cernovice (cast) x)"
  },
  {
    "cast": "Brno-Dolní Heršpice (část) x)",
    "psc": "61700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61700 Brno Brno-Dolni Herspice (cast) x)"
  },
  {
    "cast": "Brno-Dolní Heršpice (část) x)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Brno-Dolni Herspice (cast) x)"
  },
  {
    "cast": "Brno-Dvorska x)",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Brno-Dvorska x)"
  },
  {
    "cast": "Brno-Holásky x)",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Brno-Holasky x)"
  },
  {
    "cast": "Brno-Horní Heršpice (část) x)",
    "psc": "61700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61700 Brno Brno-Horni Herspice (cast) x)"
  },
  {
    "cast": "Brno-Horní Heršpice (část) x)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Brno-Horni Herspice (cast) x)"
  },
  {
    "cast": "Brno-Husovice (část) x)",
    "psc": "61300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61300 Brno Brno-Husovice (cast) x)"
  },
  {
    "cast": "Brno-Husovice (část) x)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Brno-Husovice (cast) x)"
  },
  {
    "cast": "Brno-Husovice (část) x)",
    "psc": "63800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63800 Brno Brno-Husovice (cast) x)"
  },
  {
    "cast": "Brno-Chrlice (část) x)",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Brno-Chrlice (cast) x)"
  },
  {
    "cast": "Brno-Chrlice (část) x)",
    "psc": "64300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64300 Brno Brno-Chrlice (cast) x)"
  },
  {
    "cast": "Brno-Chrlice (část) x)",
    "psc": "66442",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "66442 Brno Brno-Chrlice (cast) x)"
  },
  {
    "cast": "Brno-Ivanovice x)",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Brno-Ivanovice x)"
  },
  {
    "cast": "Brno-Jehnice x)",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Brno-Jehnice x)"
  },
  {
    "cast": "Brno-Kníničky (část) x)",
    "psc": "66434",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "66434 Brno Brno-Kninicky (cast) x)"
  },
  {
    "cast": "Brno-Kníničky (část) x)",
    "psc": "63500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63500 Brno Brno-Kninicky (cast) x)"
  },
  {
    "cast": "Brno-Kohoutovice x)",
    "psc": "62300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62300 Brno Brno-Kohoutovice x)"
  },
  {
    "cast": "Brno-Komárov (část) x)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Brno-Komarov (cast) x)"
  },
  {
    "cast": "Brno-Komárov (část) x)",
    "psc": "61700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61700 Brno Brno-Komarov (cast) x)"
  },
  {
    "cast": "Brno-Komárov (část) x)",
    "psc": "61800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61800 Brno Brno-Komarov (cast) x)"
  },
  {
    "cast": "Brno-Komín (část) x)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Brno-Komin (cast) x)"
  },
  {
    "cast": "Brno-Komín (část) x)",
    "psc": "62400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62400 Brno Brno-Komin (cast) x)"
  },
  {
    "cast": "Brno-Komín (část) x)",
    "psc": "63500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63500 Brno Brno-Komin (cast) x)"
  },
  {
    "cast": "Brno-Královo Pole (část) x)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Brno-Kralovo Pole (cast) x)"
  },
  {
    "cast": "Brno-Královo Pole (část) x)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Brno-Kralovo Pole (cast) x)"
  },
  {
    "cast": "Brno-Lesná (část) x)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Brno-Lesna (cast) x)"
  },
  {
    "cast": "Brno-Lesná (část) x)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Brno-Lesna (cast) x)"
  },
  {
    "cast": "Brno-Lesná (část) x)",
    "psc": "63800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63800 Brno Brno-Lesna (cast) x)"
  },
  {
    "cast": "Brno-Líšeň (část) x)",
    "psc": "62800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62800 Brno Brno-Lisen (cast) x)"
  },
  {
    "cast": "Brno-Líšeň (část) x)",
    "psc": "63600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63600 Brno Brno-Lisen (cast) x)"
  },
  {
    "cast": "Brno-Medlánky (část) x)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Brno-Medlanky (cast) x)"
  },
  {
    "cast": "Brno-Medlánky (část) x)",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Brno-Medlanky (cast) x)"
  },
  {
    "cast": "Brno-město (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Brno-mesto (cast)"
  },
  {
    "cast": "Brno-město (část)",
    "psc": "63900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63900 Brno Brno-mesto (cast)"
  },
  {
    "cast": "Brno-Mokrá Hora x)",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Brno-Mokra Hora x)"
  },
  {
    "cast": "Brno-Obřany (část) x)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Brno-Obrany (cast) x)"
  },
  {
    "cast": "Brno-Obřany (část) x)",
    "psc": "64400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64400 Brno Brno-Obrany (cast) x)"
  },
  {
    "cast": "Brno-Ořešín x)",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Brno-Oresin x)"
  },
  {
    "cast": "Brno-Ponava (část) x)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Brno-Ponava (cast) x)"
  },
  {
    "cast": "Brno-Ponava (část) x)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Brno-Ponava (cast) x)"
  },
  {
    "cast": "Brno-Přízřenice x)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Brno-Prizrenice x)"
  },
  {
    "cast": "Brno-Řečkovice (část) x)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Brno-Reckovice (cast) x)"
  },
  {
    "cast": "Brno-Řečkovice (část) x)",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Brno-Reckovice (cast) x)"
  },
  {
    "cast": "Brno-Sadová x)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Brno-Sadova x)"
  },
  {
    "cast": "Brno-Slatina x)",
    "psc": "62700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62700 Brno Brno-Slatina x)"
  },
  {
    "cast": "Brno-Soběšice x)",
    "psc": "64400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64400 Brno Brno-Sobesice x)"
  },
  {
    "cast": "Brno-Staré Brno (část) x)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Brno-Stare Brno (cast) x)"
  },
  {
    "cast": "Brno-Staré Brno (část) x)",
    "psc": "60300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60300 Brno Brno-Stare Brno (cast) x)"
  },
  {
    "cast": "Brno-Staré Brno (část) x)",
    "psc": "63900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63900 Brno Brno-Stare Brno (cast) x)"
  },
  {
    "cast": "Brno-Starý Lískovec x)",
    "psc": "62500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62500 Brno Brno-Stary Liskovec x)"
  },
  {
    "cast": "Brno-Stránice (část) x)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Brno-Stranice (cast) x)"
  },
  {
    "cast": "Brno-Stránice (část) x)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Brno-Stranice (cast) x)"
  },
  {
    "cast": "Brno-Štýřice (část) x)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Brno-Styrice (cast) x)"
  },
  {
    "cast": "Brno-Štýřice (část) x)",
    "psc": "63900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63900 Brno Brno-Styrice (cast) x)"
  },
  {
    "cast": "Brno-Tuřany (část) x)",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Brno-Turany (cast) x)"
  },
  {
    "cast": "Brno-Tuřany (část) x)",
    "psc": "62700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62700 Brno Brno-Turany (cast) x)"
  },
  {
    "cast": "Brno-Útěchov x)",
    "psc": "64400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64400 Brno Brno-Utechov x)"
  },
  {
    "cast": "Brno-Veveří (část) x)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Brno-Veveri (cast) x)"
  },
  {
    "cast": "Brno-Veveří (část) x)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Brno-Veveri (cast) x)"
  },
  {
    "cast": "Brno-Žabovřesky (část) x)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Brno-Zabovresky (cast) x)"
  },
  {
    "cast": "Brno-Žabovřesky (část) x)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Brno-Zabovresky (cast) x)"
  },
  {
    "cast": "Brno-Žabovřesky (část) x)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Brno-Zabovresky (cast) x)"
  },
  {
    "cast": "Brno-Žabovřesky (část) x)",
    "psc": "63700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63700 Brno Brno-Zabovresky (cast) x)"
  },
  {
    "cast": "Brno-Žebětín x)",
    "psc": "64100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64100 Brno Brno-Zebetin x)"
  },
  {
    "cast": "Brocná (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51801 Skuhrov nad Belou Brocna (cast)"
  },
  {
    "cast": "Brocná (část)",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51703 Skuhrov nad Belou Brocna (cast)"
  },
  {
    "cast": "Brocno",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Brocno"
  },
  {
    "cast": "Brod",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Brod"
  },
  {
    "cast": "Brod",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Brod"
  },
  {
    "cast": "Brod",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26401 Petrovice Brod"
  },
  {
    "cast": "Brod",
    "psc": "55212",
    "okres": "Náchod",
    "obec": "Heřmanice",
    "val": "55212 Hermanice Brod"
  },
  {
    "cast": "Brod nad Dyjí",
    "psc": "69181",
    "okres": "Břeclav",
    "obec": "Brod nad Dyjí",
    "val": "69181 Brod nad Dyji Brod nad Dyji"
  },
  {
    "cast": "Brod nad Tichou",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Brod nad Tichou",
    "val": "34815 Brod nad Tichou Brod nad Tichou"
  },
  {
    "cast": "Brod u Stříbra",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kladruby",
    "val": "34901 Kladruby Brod u Stribra"
  },
  {
    "cast": "Brodce",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Brodce"
  },
  {
    "cast": "Brodce",
    "psc": "67529",
    "okres": "Jihlava",
    "obec": "Kněžice",
    "val": "67529 Knezice Brodce"
  },
  {
    "cast": "Brodce",
    "psc": "29473",
    "okres": "Mladá Boleslav",
    "obec": "Brodce",
    "val": "29473 Brodce Brodce"
  },
  {
    "cast": "Brodce",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25741 Tynec nad Sazavou Brodce"
  },
  {
    "cast": "Brodec",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Brodec",
    "val": "44001 Brodec Brodec"
  },
  {
    "cast": "Brodek",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Dětenice",
    "val": "50723 Detenice Brodek"
  },
  {
    "cast": "Brodek u Konice",
    "psc": "79846",
    "okres": "Prostějov",
    "obec": "Brodek u Konice",
    "val": "79846 Brodek u Konice Brodek u Konice"
  },
  {
    "cast": "Brodek u Prostějova",
    "psc": "79807",
    "okres": "Prostějov",
    "obec": "Brodek u Prostějova",
    "val": "79807 Brodek u Prostejova Brodek u Prostejova"
  },
  {
    "cast": "Brodek u Přerova",
    "psc": "75103",
    "okres": "Přerov",
    "obec": "Brodek u Přerova",
    "val": "75103 Brodek u Prerova Brodek u Prerova"
  },
  {
    "cast": "Brodeslavy",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Brodeslavy",
    "val": "33141 Brodeslavy Brodeslavy"
  },
  {
    "cast": "Brody",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Krásný Dvůr",
    "val": "44101 Krasny Dvur Brody"
  },
  {
    "cast": "Broučkova Lhota",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Brouckova Lhota"
  },
  {
    "cast": "Broumov",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Broumov",
    "val": "55001 Broumov Broumov"
  },
  {
    "cast": "Broumov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Broumov",
    "val": "34815 Broumov Broumov"
  },
  {
    "cast": "Broumova Lhota",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58291 Krasna Hora Broumova Lhota"
  },
  {
    "cast": "Broumovice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25703 Neustupov Broumovice"
  },
  {
    "cast": "Broumy",
    "psc": "26742",
    "okres": "Beroun",
    "obec": "Broumy",
    "val": "26742 Broumy Broumy"
  },
  {
    "cast": "Brozánky",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Hořín",
    "val": "27601 Horin Brozanky"
  },
  {
    "cast": "Brozánky",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Řehlovice",
    "val": "40002 Rehlovice Brozanky"
  },
  {
    "cast": "Brozany",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Staré Hradiště",
    "val": "53352 Stare Hradiste Brozany"
  },
  {
    "cast": "Brozany nad Ohří",
    "psc": "41181",
    "okres": "Litoměřice",
    "obec": "Brozany nad Ohří",
    "val": "41181 Brozany nad Ohri Brozany nad Ohri"
  },
  {
    "cast": "Brť",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Otročín",
    "val": "36401 Otrocin Brt"
  },
  {
    "cast": "Brtec",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Brtec"
  },
  {
    "cast": "Brteč",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Brtec"
  },
  {
    "cast": "Brtev",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Brtev"
  },
  {
    "cast": "Brtí",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Brti"
  },
  {
    "cast": "Brtná",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Želiv",
    "val": "39601 Zeliv Brtna"
  },
  {
    "cast": "Brtnice",
    "psc": "58832",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58832 Brtnice Brtnice"
  },
  {
    "cast": "Brtnice",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Brtnice"
  },
  {
    "cast": "Brtnička",
    "psc": "67527",
    "okres": "Jihlava",
    "obec": "Brtnička",
    "val": "67527 Brtnicka Brtnicka"
  },
  {
    "cast": "Brtníky",
    "psc": "40760",
    "okres": "Děčín",
    "obec": "Staré Křečany",
    "val": "40760 Stare Krecany Brtniky"
  },
  {
    "cast": "Brťov u Černé Hory",
    "psc": "67921",
    "okres": "Blansko",
    "obec": "Brťov-Jeneč",
    "val": "67921 Brtov-Jenec Brtov u Cerne Hory"
  },
  {
    "cast": "Brťov u Velkých Opatovic",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Velké Opatovice",
    "val": "67963 Velke Opatovice Brtov u Velkych Opatovic"
  },
  {
    "cast": "Brťoví",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Prosetín",
    "val": "59301 Prosetin Brtovi"
  },
  {
    "cast": "Brůdek",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34506 Vseruby Brudek"
  },
  {
    "cast": "Brumov",
    "psc": "76331",
    "okres": "Zlín",
    "obec": "Brumov-Bylnice",
    "val": "76331 Brumov-Bylnice Brumov"
  },
  {
    "cast": "Brumov",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Brumov",
    "val": "67923 Brumov Brumov"
  },
  {
    "cast": "Brumovice",
    "psc": "74771",
    "okres": "Opava",
    "obec": "Brumovice",
    "val": "74771 Brumovice Brumovice"
  },
  {
    "cast": "Brumovice",
    "psc": "69111",
    "okres": "Břeclav",
    "obec": "Brumovice",
    "val": "69111 Brumovice Brumovice"
  },
  {
    "cast": "Brunka",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Brunka"
  },
  {
    "cast": "Brunšov",
    "psc": "25209",
    "okres": "Praha-západ",
    "obec": "Hradištko",
    "val": "25209 Hradistko Brunsov"
  },
  {
    "cast": "Bruntál",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Bruntál",
    "val": "79201 Bruntal Bruntal"
  },
  {
    "cast": "Brusná",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Lomnice",
    "val": "67923 Lomnice Brusna"
  },
  {
    "cast": "Brusné",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Brusné",
    "val": "76861 Brusne Brusne"
  },
  {
    "cast": "Brusné 1.díl",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Nosálov",
    "val": "27735 Nosalov Brusne 1.dil"
  },
  {
    "cast": "Brusné 2.díl",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Brusne 2.dil"
  },
  {
    "cast": "Brusov",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Brusov"
  },
  {
    "cast": "Brusy",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Přešťovice",
    "val": "38601 Prestovice Brusy"
  },
  {
    "cast": "Brušovec",
    "psc": "59201",
    "okres": "Žďár nad Sázavou",
    "obec": "Herálec",
    "val": "59201 Heralec Brusovec"
  },
  {
    "cast": "Brušperk",
    "psc": "73944",
    "okres": "Frýdek-Místek",
    "obec": "Brušperk",
    "val": "73944 Brusperk Brusperk"
  },
  {
    "cast": "Bruzovice",
    "psc": "73936",
    "okres": "Frýdek-Místek",
    "obec": "Bruzovice",
    "val": "73936 Bruzovice Bruzovice"
  },
  {
    "cast": "Brzánky",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Brzánky",
    "val": "41301 Brzanky Brzanky"
  },
  {
    "cast": "Brzice",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Brzice",
    "val": "55205 Brzice Brzice"
  },
  {
    "cast": "Brzina",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26256 Svaty Jan Brzina"
  },
  {
    "cast": "Brzkov",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Brzkov",
    "val": "58813 Brzkov Brzkov"
  },
  {
    "cast": "Brzotice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Loket",
    "val": "25768 Loket Brzotice"
  },
  {
    "cast": "Břasy",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Břasy",
    "val": "33824 Brasy Brasy"
  },
  {
    "cast": "Břeclav (část)",
    "psc": "69146",
    "okres": "Břeclav",
    "obec": "Břeclav",
    "val": "69146 Breclav Breclav (cast)"
  },
  {
    "cast": "Břeclav (část)",
    "psc": "69002",
    "okres": "Břeclav",
    "obec": "Břeclav",
    "val": "69002 Breclav Breclav (cast)"
  },
  {
    "cast": "Břeclav (část)",
    "psc": "69003",
    "okres": "Břeclav",
    "obec": "Břeclav",
    "val": "69003 Breclav Breclav (cast)"
  },
  {
    "cast": "Břeclav (část)",
    "psc": "69006",
    "okres": "Břeclav",
    "obec": "Břeclav",
    "val": "69006 Breclav Breclav (cast)"
  },
  {
    "cast": "Břehoryje",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Drahobuz",
    "val": "41145 Drahobuz Brehoryje"
  },
  {
    "cast": "Břehov",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Břehov",
    "val": "37341 Brehov Brehov"
  },
  {
    "cast": "Břehy",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Břehy",
    "val": "53501 Brehy Brehy"
  },
  {
    "cast": "Břehy",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Žďár",
    "val": "29411 Zdar Brehy"
  },
  {
    "cast": "Břehyně",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Doksy",
    "val": "47201 Doksy Brehyne"
  },
  {
    "cast": "Břekova Lhota",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Dublovice",
    "val": "26401 Dublovice Brekova Lhota"
  },
  {
    "cast": "Břest",
    "psc": "76823",
    "okres": "Kroměříž",
    "obec": "Břest",
    "val": "76823 Brest Brest"
  },
  {
    "cast": "Břestek (část)",
    "psc": "68708",
    "okres": "Uherské Hradiště",
    "obec": "Břestek",
    "val": "68708 Brestek Brestek (cast)"
  },
  {
    "cast": "Břestek (část)",
    "psc": "68709",
    "okres": "Uherské Hradiště",
    "obec": "Břestek",
    "val": "68709 Brestek Brestek (cast)"
  },
  {
    "cast": "Břešťany",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Zlonice",
    "val": "27371 Zlonice Brestany"
  },
  {
    "cast": "Břetětice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Bretetice"
  },
  {
    "cast": "Břetislav",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Konstantinovy Lázně",
    "val": "34952 Konstantinovy Lazne Bretislav"
  },
  {
    "cast": "Břevenec",
    "psc": "78385",
    "okres": "Olomouc",
    "obec": "Šumvald",
    "val": "78385 Sumvald Brevenec"
  },
  {
    "cast": "Břevnice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Stranný",
    "val": "25756 Stranny Brevnice"
  },
  {
    "cast": "Břevnice",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Břevnice",
    "val": "58001 Brevnice Brevnice"
  },
  {
    "cast": "Břevniště",
    "psc": "47128",
    "okres": "Česká Lípa",
    "obec": "Hamr na Jezeře",
    "val": "47128 Hamr na Jezere Brevniste"
  },
  {
    "cast": "Břevnov (část)",
    "psc": "16900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16900 Praha Brevnov (cast)"
  },
  {
    "cast": "Břevnov (část)",
    "psc": "16200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16200 Praha Brevnov (cast)"
  },
  {
    "cast": "Březce",
    "psc": "78313",
    "okres": "Olomouc",
    "obec": "Štěpánov",
    "val": "78313 Stepanov Brezce"
  },
  {
    "cast": "Březejc",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Březejc",
    "val": "59401 Brezejc Brezejc"
  },
  {
    "cast": "Březenec",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Jirkov",
    "val": "43111 Jirkov Brezenec"
  },
  {
    "cast": "Březenice",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Choceň",
    "val": "56501 Chocen Brezenice"
  },
  {
    "cast": "Březhrad",
    "psc": "50332",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50332 Hradec Kralove Brezhrad"
  },
  {
    "cast": "Březí",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Zhoř",
    "val": "39901 Zhor Brezi"
  },
  {
    "cast": "Březí",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Zbýšov",
    "val": "28601 Zbysov Brezi"
  },
  {
    "cast": "Březí",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Brezi"
  },
  {
    "cast": "Březí",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Brezi"
  },
  {
    "cast": "Březí",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Pernarec",
    "val": "33036 Pernarec Brezi"
  },
  {
    "cast": "Březí",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34601 Meclov Brezi"
  },
  {
    "cast": "Březí",
    "psc": "69181",
    "okres": "Břeclav",
    "obec": "Březí",
    "val": "69181 Brezi Brezi"
  },
  {
    "cast": "Březí",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Březí",
    "val": "25101 Brezi Brezi"
  },
  {
    "cast": "Březí",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Slabčice",
    "val": "39843 Slabcice Brezi"
  },
  {
    "cast": "Březí",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Březí",
    "val": "59453 Brezi Brezi"
  },
  {
    "cast": "Březí",
    "psc": "26242",
    "okres": "Strakonice",
    "obec": "Březí",
    "val": "26242 Brezi Brezi"
  },
  {
    "cast": "Březí",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Ctiboř",
    "val": "34815 Ctibor Brezi"
  },
  {
    "cast": "Březí",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40002 Malecov Brezi"
  },
  {
    "cast": "Březí",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Dražíč",
    "val": "37501 Drazic Brezi"
  },
  {
    "cast": "Březí",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Brezi"
  },
  {
    "cast": "Březí",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Kamenice nad Lipou",
    "val": "39470 Kamenice nad Lipou Brezi"
  },
  {
    "cast": "Březí nad Oslavou",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Březí nad Oslavou",
    "val": "59214 Brezi nad Oslavou Brezi nad Oslavou"
  },
  {
    "cast": "Březí u Týna nad Vltavou",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Brezi u Tyna nad Vltavou"
  },
  {
    "cast": "Březí (část)",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Kluky",
    "val": "39701 Kluky Brezi (cast)"
  },
  {
    "cast": "Březí (část)",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Žinkovy",
    "val": "33601 Zinkovy Brezi (cast)"
  },
  {
    "cast": "Březí (část)",
    "psc": "39819",
    "okres": "Písek",
    "obec": "Kluky",
    "val": "39819 Kluky Brezi (cast)"
  },
  {
    "cast": "Březí (část)",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Brezi (cast)"
  },
  {
    "cast": "Březí (část)",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Žinkovy",
    "val": "33501 Zinkovy Brezi (cast)"
  },
  {
    "cast": "Březí (část)",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "25791 Nechvalice Brezi (cast)"
  },
  {
    "cast": "Březí (část)",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Brezi (cast)"
  },
  {
    "cast": "Březí (část)",
    "psc": "37382",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37382 Kamenny Ujezd Brezi (cast)"
  },
  {
    "cast": "Březín",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Brezin"
  },
  {
    "cast": "Březina",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Březina",
    "val": "50601 Brezina Brezina"
  },
  {
    "cast": "Březina",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Luká",
    "val": "78324 Luka Brezina"
  },
  {
    "cast": "Březina",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Březina",
    "val": "68201 Brezina Brezina"
  },
  {
    "cast": "Březina",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Březina",
    "val": "33824 Brezina Brezina"
  },
  {
    "cast": "Březina",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Hořepník",
    "val": "39501 Horepnik Brezina"
  },
  {
    "cast": "Březina",
    "psc": "67905",
    "okres": "Brno-venkov",
    "obec": "Březina",
    "val": "67905 Brezina Brezina"
  },
  {
    "cast": "Březina",
    "psc": "68308",
    "okres": "Vyškov",
    "obec": "Nové Sady",
    "val": "68308 Nove Sady Brezina"
  },
  {
    "cast": "Březina",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "28522 Vlastejovice Brezina"
  },
  {
    "cast": "Březina",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Březina",
    "val": "37821 Brezina Brezina"
  },
  {
    "cast": "Březina",
    "psc": "56923",
    "okres": "Svitavy",
    "obec": "Březina",
    "val": "56923 Brezina Brezina"
  },
  {
    "cast": "Březina",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Březina",
    "val": "29411 Brezina Brezina"
  },
  {
    "cast": "Březina (část)",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Březina",
    "val": "66601 Brezina Brezina (cast)"
  },
  {
    "cast": "Březina (část)",
    "psc": "66603",
    "okres": "Brno-venkov",
    "obec": "Březina",
    "val": "66603 Brezina Brezina (cast)"
  },
  {
    "cast": "Březiněves",
    "psc": "18200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18200 Praha Brezineves"
  },
  {
    "cast": "Březinka",
    "psc": "27723",
    "okres": "Mělník",
    "obec": "Kokořín",
    "val": "27723 Kokorin Brezinka"
  },
  {
    "cast": "Březinka",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Slatina",
    "val": "56943 Slatina Brezinka"
  },
  {
    "cast": "Březinka",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Hošťalovice",
    "val": "53803 Hostalovice Brezinka"
  },
  {
    "cast": "Březinka",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Bělá pod Bezdězem",
    "val": "29425 Bela pod Bezdezem Brezinka"
  },
  {
    "cast": "Březinka",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Brezinka"
  },
  {
    "cast": "Březinky",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Březinky",
    "val": "56943 Brezinky Brezinky"
  },
  {
    "cast": "Březiny",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Březiny",
    "val": "57201 Breziny Breziny"
  },
  {
    "cast": "Březiny-Děčín XXVII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Breziny-Decin XXVII x)"
  },
  {
    "cast": "Březka",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libuň",
    "val": "50601 Libun Brezka"
  },
  {
    "cast": "Březka",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Železnice",
    "val": "50713 Zeleznice Brezka"
  },
  {
    "cast": "Březka",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Brezka"
  },
  {
    "cast": "Březná",
    "psc": "78991",
    "okres": "Šumperk",
    "obec": "Štíty",
    "val": "78991 Stity Brezna"
  },
  {
    "cast": "Březnice",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Březnice",
    "val": "76001 Breznice Breznice"
  },
  {
    "cast": "Březnice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Březnice",
    "val": "26272 Breznice Breznice"
  },
  {
    "cast": "Březnice",
    "psc": "39171",
    "okres": "Tábor",
    "obec": "Březnice",
    "val": "39171 Breznice Breznice"
  },
  {
    "cast": "Březník",
    "psc": "67574",
    "okres": "Třebíč",
    "obec": "Březník",
    "val": "67574 Breznik Breznik"
  },
  {
    "cast": "Březno",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Brezno"
  },
  {
    "cast": "Březno",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41002 Velemin Brezno"
  },
  {
    "cast": "Březno",
    "psc": "43145",
    "okres": "Chomutov",
    "obec": "Březno",
    "val": "43145 Brezno Brezno"
  },
  {
    "cast": "Březno",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Březno",
    "val": "29406 Brezno Brezno"
  },
  {
    "cast": "Březolupy",
    "psc": "68713",
    "okres": "Uherské Hradiště",
    "obec": "Březolupy",
    "val": "68713 Brezolupy Brezolupy"
  },
  {
    "cast": "Březová",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Březová",
    "val": "26751 Brezova Brezova"
  },
  {
    "cast": "Březová",
    "psc": "76315",
    "okres": "Zlín",
    "obec": "Březová",
    "val": "76315 Brezova Brezova"
  },
  {
    "cast": "Březová",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Úmonín",
    "val": "28601 Umonin Brezova"
  },
  {
    "cast": "Březová",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Březová",
    "val": "35601 Brezova Brezova"
  },
  {
    "cast": "Březová",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Brezova"
  },
  {
    "cast": "Březová",
    "psc": "74744",
    "okres": "Opava",
    "obec": "Březová",
    "val": "74744 Brezova Brezova"
  },
  {
    "cast": "Březová",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Březová",
    "val": "36001 Brezova Brezova"
  },
  {
    "cast": "Březová",
    "psc": "54983",
    "okres": "Náchod",
    "obec": "Meziměstí",
    "val": "54983 Mezimesti Brezova"
  },
  {
    "cast": "Březová",
    "psc": "25245",
    "okres": "Praha-západ",
    "obec": "Březová-Oleško",
    "val": "25245 Brezova-Olesko Brezova"
  },
  {
    "cast": "Březová",
    "psc": "68767",
    "okres": "Uherské Hradiště",
    "obec": "Březová",
    "val": "68767 Brezova Brezova"
  },
  {
    "cast": "Březová Lada",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Horní Vltavice",
    "val": "38501 Horni Vltavice Brezova Lada"
  },
  {
    "cast": "Březová nad Svitavou (část)",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Březová nad Svitavou",
    "val": "56802 Brezova nad Svitavou Brezova nad Svitavou (cast)"
  },
  {
    "cast": "Březová nad Svitavou (část)",
    "psc": "56902",
    "okres": "Svitavy",
    "obec": "Březová nad Svitavou",
    "val": "56902 Brezova nad Svitavou Brezova nad Svitavou (cast)"
  },
  {
    "cast": "Březové",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78401 Litovel Brezove"
  },
  {
    "cast": "Březové Hory-Příbram VI x)",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Brezove Hory-Pribram VI x)"
  },
  {
    "cast": "Březovec",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Nasavrky",
    "val": "53825 Nasavrky Brezovec"
  },
  {
    "cast": "Březovice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Hořice",
    "val": "50801 Horice Brezovice"
  },
  {
    "cast": "Březovice",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Chroustovice",
    "val": "53863 Chroustovice Brezovice"
  },
  {
    "cast": "Březovice (část)",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Březovice",
    "val": "29425 Brezovice Brezovice (cast)"
  },
  {
    "cast": "Březovice (část)",
    "psc": "29421",
    "okres": "Mladá Boleslav",
    "obec": "Březovice",
    "val": "29421 Brezovice Brezovice (cast)"
  },
  {
    "cast": "Březovice (část)",
    "psc": "29424",
    "okres": "Mladá Boleslav",
    "obec": "Březovice",
    "val": "29424 Brezovice Brezovice (cast)"
  },
  {
    "cast": "Březovík",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38301 Ktis Brezovik"
  },
  {
    "cast": "Březské (část)",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Březské",
    "val": "59501 Brezske Brezske (cast)"
  },
  {
    "cast": "Březské (část)",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Březské",
    "val": "59453 Brezske Brezske (cast)"
  },
  {
    "cast": "Březsko",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Březsko",
    "val": "79852 Brezsko Brezsko"
  },
  {
    "cast": "Březůvky (část)",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Březůvky",
    "val": "76001 Brezuvky Brezuvky (cast)"
  },
  {
    "cast": "Březůvky (část)",
    "psc": "76345",
    "okres": "Zlín",
    "obec": "Březůvky",
    "val": "76345 Brezuvky Brezuvky (cast)"
  },
  {
    "cast": "Břežany",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Nové Sedlo",
    "val": "43801 Nove Sedlo Brezany"
  },
  {
    "cast": "Břežany",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Břežany",
    "val": "34101 Brezany Brezany"
  },
  {
    "cast": "Břežany",
    "psc": "67165",
    "okres": "Znojmo",
    "obec": "Břežany",
    "val": "67165 Brezany Brezany"
  },
  {
    "cast": "Břežany",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Břežany",
    "val": "27034 Brezany Brezany"
  },
  {
    "cast": "Břežany I",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Břežany I",
    "val": "28002 Brezany I Brezany I"
  },
  {
    "cast": "Břežany II",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Břežany II",
    "val": "28201 Brezany II Brezany II"
  },
  {
    "cast": "Břežany nad Ohří",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Budyně nad Ohří",
    "val": "41301 Budyne nad Ohri Brezany nad Ohri"
  },
  {
    "cast": "Břežany (část)",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Lešany",
    "val": "25744 Lesany Brezany (cast)"
  },
  {
    "cast": "Břežany (část)",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Lešany",
    "val": "25741 Lesany Brezany (cast)"
  },
  {
    "cast": "Břidličná",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Břidličná",
    "val": "79351 Bridlicna Bridlicna"
  },
  {
    "cast": "Břilice",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Třeboň",
    "val": "37901 Trebon Brilice"
  },
  {
    "cast": "Břínkov",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Ročov",
    "val": "44001 Rocov Brinkov"
  },
  {
    "cast": "Břístev",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Chotěšice",
    "val": "28934 Chotesice Bristev"
  },
  {
    "cast": "Bříství",
    "psc": "28915",
    "okres": "Nymburk",
    "obec": "Bříství",
    "val": "28915 Bristvi Bristvi"
  },
  {
    "cast": "Břišejov",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Prosenická Lhota",
    "val": "26401 Prosenicka Lhota Brisejov"
  },
  {
    "cast": "Bříšťany",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Bříšťany",
    "val": "50801 Bristany Bristany"
  },
  {
    "cast": "Bříza",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Briza"
  },
  {
    "cast": "Bříza",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Všestary",
    "val": "50312 Vsestary Briza"
  },
  {
    "cast": "Bříza",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Bříza",
    "val": "41301 Briza Briza"
  },
  {
    "cast": "Břízsko",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kozojedy",
    "val": "33141 Kozojedy Brizsko"
  },
  {
    "cast": "Břuchotín",
    "psc": "78336",
    "okres": "Olomouc",
    "obec": "Křelov-Břuchotín",
    "val": "78336 Krelov-Bruchotin Bruchotin"
  },
  {
    "cast": "Břvany",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Břvany",
    "val": "44001 Brvany Brvany"
  },
  {
    "cast": "Břve",
    "psc": "25301",
    "okres": "Praha-západ",
    "obec": "Hostivice",
    "val": "25301 Hostivice Brve"
  },
  {
    "cast": "Bubeneč (část)",
    "psc": "16000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16000 Praha Bubenec (cast)"
  },
  {
    "cast": "Bubeneč (část)",
    "psc": "17000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "17000 Praha Bubenec (cast)"
  },
  {
    "cast": "Bublava",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Bublava",
    "val": "35801 Bublava Bublava"
  },
  {
    "cast": "Bubnov",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Kunvald",
    "val": "56401 Kunvald Bubnov"
  },
  {
    "cast": "Bubovice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Volenice",
    "val": "26272 Volenice Bubovice"
  },
  {
    "cast": "Bubovice",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Bubovice",
    "val": "26718 Bubovice Bubovice"
  },
  {
    "cast": "Buč",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Buc"
  },
  {
    "cast": "Bučávka",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Liptaň",
    "val": "79399 Liptan Bucavka"
  },
  {
    "cast": "Buček",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kožlany",
    "val": "33141 Kozlany Bucek"
  },
  {
    "cast": "Bučí",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Bučí",
    "val": "33152 Buci Buci"
  },
  {
    "cast": "Bučina",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25722 Vranov Bucina"
  },
  {
    "cast": "Bučina",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Kvilda",
    "val": "38501 Kvilda Bucina"
  },
  {
    "cast": "Bučina",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Bučina",
    "val": "56601 Bucina Bucina"
  },
  {
    "cast": "Bučovice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Bucovice"
  },
  {
    "cast": "Bučovice",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Bučovice",
    "val": "68501 Bucovice Bucovice"
  },
  {
    "cast": "Bučovice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Heřmanice",
    "val": "58282 Hermanice Bucovice"
  },
  {
    "cast": "Buda",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Horka II",
    "val": "28522 Horka II Buda"
  },
  {
    "cast": "Buda",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Chocnějovice",
    "val": "29413 Chocnejovice Buda"
  },
  {
    "cast": "Buda",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Buda"
  },
  {
    "cast": "Budákov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38241 Dolni Dvoriste Budakov"
  },
  {
    "cast": "Budčeves",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Budčeves",
    "val": "50732 Budceves Budceves"
  },
  {
    "cast": "Budčice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "28522 Vlastejovice Budcice"
  },
  {
    "cast": "Budeč",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33038 Unesov Budec"
  },
  {
    "cast": "Budeč",
    "psc": "37892",
    "okres": "Jindřichův Hradec",
    "obec": "Budeč",
    "val": "37892 Budec Budec"
  },
  {
    "cast": "Budeč",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Budeč",
    "val": "59214 Budec Budec"
  },
  {
    "cast": "Budeč",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58401 Hnevkovice Budec"
  },
  {
    "cast": "Budějovické Předměstí",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Budejovicke Predmesti"
  },
  {
    "cast": "Budenice",
    "psc": "27372",
    "okres": "Kladno",
    "obec": "Jarpice",
    "val": "27372 Jarpice Budenice"
  },
  {
    "cast": "Budeničky",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Šlapanice",
    "val": "27371 Slapanice Budenicky"
  },
  {
    "cast": "Budenín",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Budenin"
  },
  {
    "cast": "Budětice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Budětice",
    "val": "34201 Budetice Budetice"
  },
  {
    "cast": "Budětsko",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Budětsko",
    "val": "79852 Budetsko Budetsko"
  },
  {
    "cast": "Budičovice",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Skály",
    "val": "39811 Skaly Budicovice"
  },
  {
    "cast": "Budihostice",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Chržín",
    "val": "27324 Chrzin Budihostice"
  },
  {
    "cast": "Budíkov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Budíkov",
    "val": "39601 Budikov Budikov"
  },
  {
    "cast": "Budíkov",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Budikov"
  },
  {
    "cast": "Budíkovice",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Budikovice"
  },
  {
    "cast": "Budilov",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Bošice",
    "val": "38481 Bosice Budilov"
  },
  {
    "cast": "Budiměřice",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Budiměřice",
    "val": "28802 Budimerice Budimerice"
  },
  {
    "cast": "Budín",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Rybníky",
    "val": "26301 Rybniky Budin"
  },
  {
    "cast": "Budín",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Samopše",
    "val": "28506 Samopse Budin"
  },
  {
    "cast": "Budín",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Boharyně",
    "val": "50315 Boharyne Budin"
  },
  {
    "cast": "Budínek",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Svaté Pole",
    "val": "26301 Svate Pole Budinek"
  },
  {
    "cast": "Budislav",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Budislav",
    "val": "39201 Budislav Budislav"
  },
  {
    "cast": "Budislav",
    "psc": "56965",
    "okres": "Svitavy",
    "obec": "Budislav",
    "val": "56965 Budislav Budislav"
  },
  {
    "cast": "Budislavice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mladý Smolivec",
    "val": "33501 Mlady Smolivec Budislavice"
  },
  {
    "cast": "Budíškovice (část)",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Budíškovice",
    "val": "38001 Budiskovice Budiskovice (cast)"
  },
  {
    "cast": "Budíškovice (část)",
    "psc": "37891",
    "okres": "Jindřichův Hradec",
    "obec": "Budíškovice",
    "val": "37891 Budiskovice Budiskovice (cast)"
  },
  {
    "cast": "Budišov",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Budišov",
    "val": "67503 Budisov Budisov"
  },
  {
    "cast": "Budišov nad Budišovkou",
    "psc": "74787",
    "okres": "Opava",
    "obec": "Budišov nad Budišovkou",
    "val": "74787 Budisov nad Budisovkou Budisov nad Budisovkou"
  },
  {
    "cast": "Budišovice",
    "psc": "74764",
    "okres": "Opava",
    "obec": "Budišovice",
    "val": "74764 Budisovice Budisovice"
  },
  {
    "cast": "Budkov",
    "psc": "67542",
    "okres": "Třebíč",
    "obec": "Budkov",
    "val": "67542 Budkov Budkov"
  },
  {
    "cast": "Budkov",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Budkov",
    "val": "38422 Budkov Budkov"
  },
  {
    "cast": "Budkov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Budkov"
  },
  {
    "cast": "Budkov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Střížovice",
    "val": "37853 Strizovice Budkov"
  },
  {
    "cast": "Budkovice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Ivančice",
    "val": "66491 Ivancice Budkovice"
  },
  {
    "cast": "Budkovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Pertoltice",
    "val": "28522 Pertoltice Budkovice"
  },
  {
    "cast": "Budov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Budov"
  },
  {
    "cast": "Budy",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Onomyšl",
    "val": "28504 Onomysl Budy"
  },
  {
    "cast": "Budyně",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Budyně",
    "val": "38773 Budyne Budyne"
  },
  {
    "cast": "Budyně nad Ohří (část)",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Budyně nad Ohří",
    "val": "41108 Budyne nad Ohri Budyne nad Ohri (cast)"
  },
  {
    "cast": "Budyně nad Ohří (část)",
    "psc": "41118",
    "okres": "Litoměřice",
    "obec": "Budyně nad Ohří",
    "val": "41118 Budyne nad Ohri Budyne nad Ohri (cast)"
  },
  {
    "cast": "Bůhzdař",
    "psc": "27343",
    "okres": "Kladno",
    "obec": "Zájezd",
    "val": "27343 Zajezd Buhzdar"
  },
  {
    "cast": "Buchlovice (část)",
    "psc": "68708",
    "okres": "Uherské Hradiště",
    "obec": "Buchlovice",
    "val": "68708 Buchlovice Buchlovice (cast)"
  },
  {
    "cast": "Buchlovice (část)",
    "psc": "68709",
    "okres": "Uherské Hradiště",
    "obec": "Buchlovice",
    "val": "68709 Buchlovice Buchlovice (cast)"
  },
  {
    "cast": "Buchov",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Buchov"
  },
  {
    "cast": "Bujanov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Bujanov",
    "val": "38241 Bujanov Bujanov"
  },
  {
    "cast": "Bujesily",
    "psc": "33141",
    "okres": "Rokycany",
    "obec": "Bujesily",
    "val": "33141 Bujesily Bujesily"
  },
  {
    "cast": "Buk",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Milín",
    "val": "26231 Milin Buk"
  },
  {
    "cast": "Buk",
    "psc": "75121",
    "okres": "Přerov",
    "obec": "Buk",
    "val": "75121 Buk Buk"
  },
  {
    "cast": "Buk",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Buk"
  },
  {
    "cast": "Buk (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Buk",
    "val": "38301 Buk Buk (cast)"
  },
  {
    "cast": "Buk (část)",
    "psc": "38471",
    "okres": "Prachatice",
    "obec": "Buk",
    "val": "38471 Buk Buk (cast)"
  },
  {
    "cast": "Bukol (část)",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Vojkovice",
    "val": "27745 Vojkovice Bukol (cast)"
  },
  {
    "cast": "Bukol (část)",
    "psc": "27744",
    "okres": "Mělník",
    "obec": "Vojkovice",
    "val": "27744 Vojkovice Bukol (cast)"
  },
  {
    "cast": "Bukov",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Hořovičky",
    "val": "27004 Horovicky Bukov"
  },
  {
    "cast": "Bukov",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Bukov",
    "val": "59251 Bukov Bukov"
  },
  {
    "cast": "Bukov (část)",
    "psc": "40001",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40001 Usti nad Labem Bukov (cast)"
  },
  {
    "cast": "Bukov (část)",
    "psc": "40010",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40010 Usti nad Labem Bukov (cast)"
  },
  {
    "cast": "Buková",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Třešť",
    "val": "58901 Trest Bukova"
  },
  {
    "cast": "Buková",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dlažov",
    "val": "33901 Dlazov Bukova"
  },
  {
    "cast": "Buková",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Pravonín",
    "val": "25708 Pravonin Bukova"
  },
  {
    "cast": "Buková",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Řemíčov",
    "val": "39143 Remicov Bukova"
  },
  {
    "cast": "Buková",
    "psc": "79848",
    "okres": "Prostějov",
    "obec": "Buková",
    "val": "79848 Bukova Bukova"
  },
  {
    "cast": "Buková",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Nížkov",
    "val": "59212 Nizkov Bukova"
  },
  {
    "cast": "Buková",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Mezholezy",
    "val": "34601 Mezholezy Bukova"
  },
  {
    "cast": "Buková",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Buková",
    "val": "33452 Bukova Bukova"
  },
  {
    "cast": "Buková",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Věšín",
    "val": "26242 Vesin Bukova"
  },
  {
    "cast": "Buková",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Olešnice",
    "val": "37401 Olesnice Bukova"
  },
  {
    "cast": "Buková",
    "psc": "79057",
    "okres": "Jeseník",
    "obec": "Bernartice",
    "val": "79057 Bernartice Bukova"
  },
  {
    "cast": "Buková Lhota",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Bukova Lhota"
  },
  {
    "cast": "Buková u Příbramě",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Buková u Příbramě",
    "val": "26223 Bukova u Pribrame Bukova u Pribrame"
  },
  {
    "cast": "Bukovany",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Bukovany",
    "val": "26272 Bukovany Bukovany"
  },
  {
    "cast": "Bukovany",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Bukovany",
    "val": "77900 Bukovany Bukovany"
  },
  {
    "cast": "Bukovany",
    "psc": "35755",
    "okres": "Sokolov",
    "obec": "Bukovany",
    "val": "35755 Bukovany Bukovany"
  },
  {
    "cast": "Bukovany",
    "psc": "69631",
    "okres": "Hodonín",
    "obec": "Bukovany",
    "val": "69631 Bukovany Bukovany"
  },
  {
    "cast": "Bukovany (část)",
    "psc": "47118",
    "okres": "Česká Lípa",
    "obec": "Nový Bor",
    "val": "47118 Novy Bor Bukovany (cast)"
  },
  {
    "cast": "Bukovany (část)",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Nový Bor",
    "val": "47301 Novy Bor Bukovany (cast)"
  },
  {
    "cast": "Bukovany (část)",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Bukovany",
    "val": "25741 Bukovany Bukovany (cast)"
  },
  {
    "cast": "Bukovany (část)",
    "psc": "25721",
    "okres": "Benešov",
    "obec": "Bukovany",
    "val": "25721 Bukovany Bukovany (cast)"
  },
  {
    "cast": "Bukovec",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Bukovec"
  },
  {
    "cast": "Bukovec",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Bukovec",
    "val": "34562 Bukovec Bukovec"
  },
  {
    "cast": "Bukovec",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Bukovec"
  },
  {
    "cast": "Bukovec",
    "psc": "73985",
    "okres": "Frýdek-Místek",
    "obec": "Bukovec",
    "val": "73985 Bukovec Bukovec"
  },
  {
    "cast": "Bukovec",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Bukovec"
  },
  {
    "cast": "Bukovice",
    "psc": "78991",
    "okres": "Šumperk",
    "obec": "Písařov",
    "val": "78991 Pisarov Bukovice"
  },
  {
    "cast": "Bukovice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bžany",
    "val": "41501 Bzany Bukovice"
  },
  {
    "cast": "Bukovice",
    "psc": "79001",
    "okres": "Jeseník",
    "obec": "Jeseník",
    "val": "79001 Jesenik Bukovice"
  },
  {
    "cast": "Bukovice",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Bukovice",
    "val": "54954 Bukovice Bukovice"
  },
  {
    "cast": "Bukovice",
    "psc": "78815",
    "okres": "Šumperk",
    "obec": "Velké Losiny",
    "val": "78815 Velke Losiny Bukovice"
  },
  {
    "cast": "Bukovice (část)",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Bukovice",
    "val": "67923 Bukovice Bukovice (cast)"
  },
  {
    "cast": "Bukovice (část)",
    "psc": "67924",
    "okres": "Brno-venkov",
    "obec": "Bukovice",
    "val": "67924 Bukovice Bukovice (cast)"
  },
  {
    "cast": "Bukovina",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Bukovina"
  },
  {
    "cast": "Bukovina",
    "psc": "67905",
    "okres": "Blansko",
    "obec": "Bukovina",
    "val": "67905 Bukovina Bukovina"
  },
  {
    "cast": "Bukovina",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kralovice",
    "val": "33141 Kralovice Bukovina"
  },
  {
    "cast": "Bukovina",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořanský Rohozec",
    "val": "44101 Podboransky Rohozec Bukovina"
  },
  {
    "cast": "Bukovina",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Bukovina"
  },
  {
    "cast": "Bukovina",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Bukovina"
  },
  {
    "cast": "Bukovina",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Černilov",
    "val": "50003 Cernilov Bukovina"
  },
  {
    "cast": "Bukovina nad Labem",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Bukovina nad Labem",
    "val": "53352 Bukovina nad Labem Bukovina nad Labem"
  },
  {
    "cast": "Bukovina u Čisté",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Bukovina u Čisté",
    "val": "51401 Bukovina u Ciste Bukovina u Ciste"
  },
  {
    "cast": "Bukovina u Pecky",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Pecka",
    "val": "50782 Pecka Bukovina u Pecky"
  },
  {
    "cast": "Bukovina u Přelouče",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Bukovina u Přelouče",
    "val": "53501 Bukovina u Prelouce Bukovina u Prelouce"
  },
  {
    "cast": "Bukovinka",
    "psc": "67905",
    "okres": "Blansko",
    "obec": "Bukovinka",
    "val": "67905 Bukovinka Bukovinka"
  },
  {
    "cast": "Bukovka",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Bukovka",
    "val": "53341 Bukovka Bukovka"
  },
  {
    "cast": "Bukovka",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Radouň",
    "val": "37842 Horni Radoun Bukovka"
  },
  {
    "cast": "Bukovník",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Bukovník",
    "val": "34201 Bukovnik Bukovnik"
  },
  {
    "cast": "Bukovno",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Bukovno",
    "val": "29301 Bukovno Bukovno"
  },
  {
    "cast": "Bukovsko",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Malonty",
    "val": "38241 Malonty Bukovsko"
  },
  {
    "cast": "Bukvice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Bukvice",
    "val": "50601 Bukvice Bukvice"
  },
  {
    "cast": "Bukvice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Bukvice"
  },
  {
    "cast": "Bulánka",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Oleška",
    "val": "28163 Oleska Bulanka"
  },
  {
    "cast": "Bulhary",
    "psc": "69189",
    "okres": "Břeclav",
    "obec": "Bulhary",
    "val": "69189 Bulhary Bulhary"
  },
  {
    "cast": "Bulovka",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Bulovka",
    "val": "46401 Bulovka Bulovka"
  },
  {
    "cast": "Bumbalka",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Turkovice",
    "val": "53501 Turkovice Bumbalka"
  },
  {
    "cast": "Burkvíz",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Burkviz"
  },
  {
    "cast": "Buršice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Bursice"
  },
  {
    "cast": "Buřany",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Burany"
  },
  {
    "cast": "Buřenice (část)",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Buřenice",
    "val": "39501 Burenice Burenice (cast)"
  },
  {
    "cast": "Buřenice (část)",
    "psc": "39422",
    "okres": "Pelhřimov",
    "obec": "Buřenice",
    "val": "39422 Burenice Burenice (cast)"
  },
  {
    "cast": "Buřínsko 1.díl",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Chocnějovice",
    "val": "29413 Chocnejovice Burinsko 1.dil"
  },
  {
    "cast": "Buřínsko 2.díl",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Chocnějovice",
    "val": "29413 Chocnejovice Burinsko 2.dil"
  },
  {
    "cast": "Buš",
    "psc": "25208",
    "okres": "Praha-západ",
    "obec": "Buš",
    "val": "25208 Bus Bus"
  },
  {
    "cast": "Bušanovice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Bušanovice",
    "val": "38422 Busanovice Busanovice"
  },
  {
    "cast": "Bušín",
    "psc": "78962",
    "okres": "Šumperk",
    "obec": "Bušín",
    "val": "78962 Busin Busin"
  },
  {
    "cast": "Buškovice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Buskovice"
  },
  {
    "cast": "Bušovice",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Bušovice",
    "val": "33824 Busovice Busovice"
  },
  {
    "cast": "Buštěhrad",
    "psc": "27343",
    "okres": "Kladno",
    "obec": "Buštěhrad",
    "val": "27343 Bustehrad Bustehrad"
  },
  {
    "cast": "Butov",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Stříbro",
    "val": "34901 Stribro Butov"
  },
  {
    "cast": "Butoves",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Butoves",
    "val": "50601 Butoves Butoves"
  },
  {
    "cast": "Butovice",
    "psc": "74213",
    "okres": "Nový Jičín",
    "obec": "Studénka",
    "val": "74213 Studenka Butovice"
  },
  {
    "cast": "Buzice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Buzice",
    "val": "38801 Buzice Buzice"
  },
  {
    "cast": "Buzkov",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Buzkov"
  },
  {
    "cast": "Býčina",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Bycina"
  },
  {
    "cast": "Býčkovice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Býčkovice",
    "val": "41201 Byckovice Byckovice"
  },
  {
    "cast": "Bydžovská Lhotka",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Měník",
    "val": "50401 Menik Bydzovska Lhotka"
  },
  {
    "cast": "Býchory",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Býchory",
    "val": "28002 Bychory Bychory"
  },
  {
    "cast": "Bykáň",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Křesetice",
    "val": "28401 Kresetice Bykan"
  },
  {
    "cast": "Býkev",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Býkev",
    "val": "27601 Bykev Bykev"
  },
  {
    "cast": "Bykoš",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Bykoš",
    "val": "26701 Bykos Bykos"
  },
  {
    "cast": "Býkov",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Býkov-Láryšov",
    "val": "79401 Bykov-Larysov Bykov"
  },
  {
    "cast": "Býkovec",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Kaliště",
    "val": "58851 Kaliste Bykovec"
  },
  {
    "cast": "Býkovice",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Býkovice",
    "val": "67971 Bykovice Bykovice"
  },
  {
    "cast": "Býkovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Bykovice"
  },
  {
    "cast": "Býkovice",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Louňovice pod Blaníkem",
    "val": "25706 Lounovice pod Blanikem Bykovice"
  },
  {
    "cast": "Bylany",
    "psc": "53801",
    "okres": "Chrudim",
    "obec": "Bylany",
    "val": "53801 Bylany Bylany"
  },
  {
    "cast": "Bylany",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Chrášťany",
    "val": "28201 Chrastany Bylany"
  },
  {
    "cast": "Bylany",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Miskovice",
    "val": "28401 Miskovice Bylany"
  },
  {
    "cast": "Bylnice",
    "psc": "76331",
    "okres": "Zlín",
    "obec": "Brumov-Bylnice",
    "val": "76331 Brumov-Bylnice Bylnice"
  },
  {
    "cast": "Bylochov",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Snědovice",
    "val": "41108 Snedovice Bylochov"
  },
  {
    "cast": "Bynina",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Valašské Meziříčí",
    "val": "75701 Valasske Mezirici Bynina"
  },
  {
    "cast": "Byňov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37401 Nove Hrady Bynov"
  },
  {
    "cast": "Byňov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Bynov"
  },
  {
    "cast": "Bynovec",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Bynovec",
    "val": "40502 Bynovec Bynovec"
  },
  {
    "cast": "Bynov-Děčín IX (část) x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Bynov-Decin IX (cast) x)"
  },
  {
    "cast": "Bynov-Děčín IX (část) x)",
    "psc": "40505",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40505 Decin Bynov-Decin IX (cast) x)"
  },
  {
    "cast": "Byseň",
    "psc": "27379",
    "okres": "Kladno",
    "obec": "Tuřany",
    "val": "27379 Turany Bysen"
  },
  {
    "cast": "Bystrá",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Bystrá",
    "val": "39601 Bystra Bystra"
  },
  {
    "cast": "Bystrá",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Řečice",
    "val": "39601 Recice Bystra"
  },
  {
    "cast": "Bystrá nad Jizerou",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Bystrá nad Jizerou",
    "val": "51301 Bystra nad Jizerou Bystra nad Jizerou"
  },
  {
    "cast": "Bystrc (část)",
    "psc": "63500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63500 Brno Bystrc (cast)"
  },
  {
    "cast": "Bystrc (část)",
    "psc": "66481",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "66481 Brno Bystrc (cast)"
  },
  {
    "cast": "Bystrc (část)",
    "psc": "66471",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "66471 Brno Bystrc (cast)"
  },
  {
    "cast": "Bystré",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Stárkov",
    "val": "54931 Starkov Bystre"
  },
  {
    "cast": "Bystré",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Bystre"
  },
  {
    "cast": "Bystré",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Bystré",
    "val": "56992 Bystre Bystre"
  },
  {
    "cast": "Bystré",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bystré",
    "val": "51801 Bystre Bystre"
  },
  {
    "cast": "Bystročice",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Bystročice",
    "val": "77900 Bystrocice Bystrocice"
  },
  {
    "cast": "Bystrovany",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Bystrovany",
    "val": "77900 Bystrovany Bystrovany"
  },
  {
    "cast": "Bystřany",
    "psc": "41761",
    "okres": "Teplice",
    "obec": "Bystřany",
    "val": "41761 Bystrany Bystrany"
  },
  {
    "cast": "Bystřec (část)",
    "psc": "56154",
    "okres": "Ústí nad Orlicí",
    "obec": "Bystřec",
    "val": "56154 Bystrec Bystrec (cast)"
  },
  {
    "cast": "Bystřec (část)",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Bystřec",
    "val": "56164 Bystrec Bystrec (cast)"
  },
  {
    "cast": "Bystřice",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Bystřice",
    "val": "50723 Bystrice Bystrice"
  },
  {
    "cast": "Bystřice",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Bystrice"
  },
  {
    "cast": "Bystřice",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Včelákov",
    "val": "53901 Vcelakov Bystrice"
  },
  {
    "cast": "Bystřice",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Hroznětín",
    "val": "36301 Hroznetin Bystrice"
  },
  {
    "cast": "Bystřice",
    "psc": "73995",
    "okres": "Frýdek-Místek",
    "obec": "Bystřice",
    "val": "73995 Bystrice Bystrice"
  },
  {
    "cast": "Bystřice",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Bystrice"
  },
  {
    "cast": "Bystřice nad Pernštejnem",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Bystrice nad Pernstejnem"
  },
  {
    "cast": "Bystřice nad Úhlavou",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Nýrsko",
    "val": "34022 Nyrsko Bystrice nad Uhlavou"
  },
  {
    "cast": "Bystřice pod Hostýnem",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Bystřice pod Hostýnem",
    "val": "76861 Bystrice pod Hostynem Bystrice pod Hostynem"
  },
  {
    "cast": "Bystřice pod Lopeníkem (část)",
    "psc": "68755",
    "okres": "Uherské Hradiště",
    "obec": "Bystřice pod Lopeníkem",
    "val": "68755 Bystrice pod Lopenikem Bystrice pod Lopenikem (cast)"
  },
  {
    "cast": "Bystřice pod Lopeníkem (část)",
    "psc": "68767",
    "okres": "Uherské Hradiště",
    "obec": "Bystřice pod Lopeníkem",
    "val": "68767 Bystrice pod Lopenikem Bystrice pod Lopenikem (cast)"
  },
  {
    "cast": "Bystřice (část)",
    "psc": "41702",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41702 Dubi Bystrice (cast)"
  },
  {
    "cast": "Bystřice (část)",
    "psc": "41703",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41703 Dubi Bystrice (cast)"
  },
  {
    "cast": "Bystřice (část)",
    "psc": "41701",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41701 Dubi Bystrice (cast)"
  },
  {
    "cast": "Bystřička",
    "psc": "75624",
    "okres": "Vsetín",
    "obec": "Bystřička",
    "val": "75624 Bystricka Bystricka"
  },
  {
    "cast": "Byšice",
    "psc": "27732",
    "okres": "Mělník",
    "obec": "Byšice",
    "val": "27732 Bysice Bysice"
  },
  {
    "cast": "Byšičky",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Lysá nad Labem",
    "val": "28922 Lysa nad Labem Bysicky"
  },
  {
    "cast": "Byškovice",
    "psc": "27711",
    "okres": "Mělník",
    "obec": "Neratovice",
    "val": "27711 Neratovice Byskovice"
  },
  {
    "cast": "Býškovice",
    "psc": "75353",
    "okres": "Přerov",
    "obec": "Býškovice",
    "val": "75353 Byskovice Byskovice"
  },
  {
    "cast": "Býšov",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Chudenice",
    "val": "34012 Chudenice Bysov"
  },
  {
    "cast": "Býšovec",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Býšovec",
    "val": "59301 Bysovec Bysovec"
  },
  {
    "cast": "Býšť",
    "psc": "53322",
    "okres": "Pardubice",
    "obec": "Býšť",
    "val": "53322 Byst Byst"
  },
  {
    "cast": "Bytíz",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Bytiz"
  },
  {
    "cast": "Byzhradec",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Byzhradec",
    "val": "51801 Byzhradec Byzhradec"
  },
  {
    "cast": "Bzenec (část)",
    "psc": "69681",
    "okres": "Hodonín",
    "obec": "Bzenec",
    "val": "69681 Bzenec Bzenec (cast)"
  },
  {
    "cast": "Bzenec (část)",
    "psc": "69685",
    "okres": "Hodonín",
    "obec": "Bzenec",
    "val": "69685 Bzenec Bzenec (cast)"
  },
  {
    "cast": "Bzí",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Letiny",
    "val": "33601 Letiny Bzi"
  },
  {
    "cast": "Bzí",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Bzi"
  },
  {
    "cast": "Bzí",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Dolní Bukovsko",
    "val": "37365 Dolni Bukovsko Bzi"
  },
  {
    "cast": "Bzová",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Běleč",
    "val": "39143 Belec Bzova"
  },
  {
    "cast": "Bzová",
    "psc": "26743",
    "okres": "Beroun",
    "obec": "Bzová",
    "val": "26743 Bzova Bzova"
  },
  {
    "cast": "Bzová",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Bojkovice",
    "val": "68771 Bojkovice Bzova"
  },
  {
    "cast": "Bžany",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bžany",
    "val": "41501 Bzany Bzany"
  },
  {
    "cast": "Cakov",
    "psc": "78322",
    "okres": "Olomouc",
    "obec": "Senice na Hané",
    "val": "78322 Senice na Hane Cakov"
  },
  {
    "cast": "Capartice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Klenčí pod Čerchovem",
    "val": "34401 Klenci pod Cerchovem Capartice"
  },
  {
    "cast": "Cebiv",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Cebiv",
    "val": "34952 Cebiv Cebiv"
  },
  {
    "cast": "Cehnice",
    "psc": "38752",
    "okres": "Strakonice",
    "obec": "Cehnice",
    "val": "38752 Cehnice Cehnice"
  },
  {
    "cast": "Cejle (část)",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Cejle",
    "val": "58851 Cejle Cejle (cast)"
  },
  {
    "cast": "Cejle (část)",
    "psc": "58861",
    "okres": "Jihlava",
    "obec": "Cejle",
    "val": "58861 Cejle Cejle (cast)"
  },
  {
    "cast": "Cejřov",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Vrbatův Kostelec",
    "val": "53973 Vrbatuv Kostelec Cejrov"
  },
  {
    "cast": "Cejsice",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Cejsice"
  },
  {
    "cast": "Cekov",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Cekov",
    "val": "33808 Cekov Cekov"
  },
  {
    "cast": "Celná",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Celna"
  },
  {
    "cast": "Celné",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Těchonín",
    "val": "56164 Techonin Celne"
  },
  {
    "cast": "Cep",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Cep",
    "val": "37901 Cep Cep"
  },
  {
    "cast": "Cerekvice nad Bystřicí",
    "psc": "50777",
    "okres": "Jičín",
    "obec": "Cerekvice nad Bystřicí",
    "val": "50777 Cerekvice nad Bystrici Cerekvice nad Bystrici"
  },
  {
    "cast": "Cerekvice nad Loučnou",
    "psc": "56953",
    "okres": "Svitavy",
    "obec": "Cerekvice nad Loučnou",
    "val": "56953 Cerekvice nad Loucnou Cerekvice nad Loucnou"
  },
  {
    "cast": "Cerekvička (část)",
    "psc": "58835",
    "okres": "Jihlava",
    "obec": "Cerekvička-Rosice",
    "val": "58835 Cerekvicka-Rosice Cerekvicka (cast)"
  },
  {
    "cast": "Cerekvička (část)",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Cerekvička-Rosice",
    "val": "58833 Cerekvicka-Rosice Cerekvicka (cast)"
  },
  {
    "cast": "Cerhenice (část)",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Cerhenice",
    "val": "28002 Cerhenice Cerhenice (cast)"
  },
  {
    "cast": "Cerhenice (část)",
    "psc": "28102",
    "okres": "Kolín",
    "obec": "Cerhenice",
    "val": "28102 Cerhenice Cerhenice (cast)"
  },
  {
    "cast": "Cerhonice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Cerhonice",
    "val": "39804 Cerhonice Cerhonice"
  },
  {
    "cast": "Cerhovice",
    "psc": "26761",
    "okres": "Beroun",
    "obec": "Cerhovice",
    "val": "26761 Cerhovice Cerhovice"
  },
  {
    "cast": "Cerhýnky",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Cerhenice",
    "val": "28002 Cerhenice Cerhynky"
  },
  {
    "cast": "Cetechovice",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Cetechovice",
    "val": "76802 Cetechovice Cetechovice"
  },
  {
    "cast": "Cetenov",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Cetenov",
    "val": "46348 Cetenov Cetenov"
  },
  {
    "cast": "Cetkovice",
    "psc": "67938",
    "okres": "Blansko",
    "obec": "Cetkovice",
    "val": "67938 Cetkovice Cetkovice"
  },
  {
    "cast": "Cetnov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Cetnov"
  },
  {
    "cast": "Cetoraz",
    "psc": "39411",
    "okres": "Pelhřimov",
    "obec": "Cetoraz",
    "val": "39411 Cetoraz Cetoraz"
  },
  {
    "cast": "Cetule",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Bratřice",
    "val": "39501 Bratrice Cetule"
  },
  {
    "cast": "Cetyně",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Cetyně",
    "val": "26231 Cetyne Cetyne"
  },
  {
    "cast": "Cibotín",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Česká Bělá",
    "val": "58301 Ceska Bela Cibotin"
  },
  {
    "cast": "Ciboušov",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Cibousov"
  },
  {
    "cast": "Cidlina",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Železnice",
    "val": "50713 Zeleznice Cidlina"
  },
  {
    "cast": "Cidlina (část)",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Cidlina",
    "val": "67526 Cidlina Cidlina (cast)"
  },
  {
    "cast": "Cidlina (část)",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Cidlina",
    "val": "67544 Cidlina Cidlina (cast)"
  },
  {
    "cast": "Cihelna",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Cihelna"
  },
  {
    "cast": "Cihelna",
    "psc": "53009",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53009 Pardubice Cihelna"
  },
  {
    "cast": "Cihelny",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Cihelny"
  },
  {
    "cast": "Cihelny",
    "psc": "36464",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36464 Karlovy Vary Cihelny"
  },
  {
    "cast": "Cikháj",
    "psc": "59102",
    "okres": "Žďár nad Sázavou",
    "obec": "Cikháj",
    "val": "59102 Cikhaj Cikhaj"
  },
  {
    "cast": "Cínovec",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41501 Dubi Cinovec"
  },
  {
    "cast": "Církvice",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Církvice",
    "val": "28144 Cirkvice Cirkvice"
  },
  {
    "cast": "Církvice",
    "psc": "28533",
    "okres": "Kutná Hora",
    "obec": "Církvice",
    "val": "28533 Cirkvice Cirkvice"
  },
  {
    "cast": "Církvice",
    "psc": "40302",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40302 Usti nad Labem Cirkvice"
  },
  {
    "cast": "Císařov",
    "psc": "75103",
    "okres": "Přerov",
    "obec": "Císařov",
    "val": "75103 Cisarov Cisarov"
  },
  {
    "cast": "Císařská Kuchyně",
    "psc": "25088",
    "okres": "Praha-východ",
    "obec": "Čelákovice",
    "val": "25088 Celakovice Cisarska Kuchyne"
  },
  {
    "cast": "Císařský",
    "psc": "40777",
    "okres": "Děčín",
    "obec": "Šluknov",
    "val": "40777 Sluknov Cisarsky"
  },
  {
    "cast": "Citice",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Citice",
    "val": "35601 Citice Citice"
  },
  {
    "cast": "Cítkov",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Vápenný Podol",
    "val": "53803 Vapenny Podol Citkov"
  },
  {
    "cast": "Cítoliby",
    "psc": "43902",
    "okres": "Louny",
    "obec": "Cítoliby",
    "val": "43902 Citoliby Citoliby"
  },
  {
    "cast": "Citonice",
    "psc": "67101",
    "okres": "Znojmo",
    "obec": "Citonice",
    "val": "67101 Citonice Citonice"
  },
  {
    "cast": "Citov",
    "psc": "75103",
    "okres": "Přerov",
    "obec": "Citov",
    "val": "75103 Citov Citov"
  },
  {
    "cast": "Cítov",
    "psc": "27704",
    "okres": "Mělník",
    "obec": "Cítov",
    "val": "27704 Citov Citov"
  },
  {
    "cast": "Cizkrajov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Cizkrajov",
    "val": "37881 Cizkrajov Cizkrajov"
  },
  {
    "cast": "Cotkytle (část)",
    "psc": "56132",
    "okres": "Ústí nad Orlicí",
    "obec": "Cotkytle",
    "val": "56132 Cotkytle Cotkytle (cast)"
  },
  {
    "cast": "Cotkytle (část)",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Cotkytle",
    "val": "56301 Cotkytle Cotkytle (cast)"
  },
  {
    "cast": "Crhov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Štíty",
    "val": "78901 Stity Crhov"
  },
  {
    "cast": "Crhov",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Crhov",
    "val": "67974 Crhov Crhov"
  },
  {
    "cast": "Ctětín",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Ctětín",
    "val": "53825 Ctetin Ctetin"
  },
  {
    "cast": "Ctiboř",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Ctiboř",
    "val": "25801 Ctibor Ctibor"
  },
  {
    "cast": "Ctiboř",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Ctiboř",
    "val": "34701 Ctibor Ctibor"
  },
  {
    "cast": "Ctiboř",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Častrov",
    "val": "39468 Castrov Ctibor"
  },
  {
    "cast": "Ctidružice",
    "psc": "67154",
    "okres": "Znojmo",
    "obec": "Ctidružice",
    "val": "67154 Ctidruzice Ctidruzice"
  },
  {
    "cast": "Ctiměřice",
    "psc": "29446",
    "okres": "Mladá Boleslav",
    "obec": "Ctiměřice",
    "val": "29446 Ctimerice Ctimerice"
  },
  {
    "cast": "Ctiněves",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Ctiněves",
    "val": "41301 Ctineves Ctineves"
  },
  {
    "cast": "Cunkov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Cunkov"
  },
  {
    "cast": "Cvikov I",
    "psc": "47154",
    "okres": "Česká Lípa",
    "obec": "Cvikov",
    "val": "47154 Cvikov Cvikov I"
  },
  {
    "cast": "Cvikov II",
    "psc": "47154",
    "okres": "Česká Lípa",
    "obec": "Cvikov",
    "val": "47154 Cvikov Cvikov II"
  },
  {
    "cast": "Cvrčov",
    "psc": "75101",
    "okres": "Přerov",
    "obec": "Lobodice",
    "val": "75101 Lobodice Cvrcov"
  },
  {
    "cast": "Cvrčovice",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Zdounky",
    "val": "76802 Zdounky Cvrcovice"
  },
  {
    "cast": "Cvrčovice",
    "psc": "27341",
    "okres": "Kladno",
    "obec": "Cvrčovice",
    "val": "27341 Cvrcovice Cvrcovice"
  },
  {
    "cast": "Cvrčovice",
    "psc": "69123",
    "okres": "Brno-venkov",
    "obec": "Cvrčovice",
    "val": "69123 Cvrcovice Cvrcovice"
  },
  {
    "cast": "Cyrilov",
    "psc": "59461",
    "okres": "Žďár nad Sázavou",
    "obec": "Bory",
    "val": "59461 Bory Cyrilov"
  },
  {
    "cast": "Čabová",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Moravský Beroun",
    "val": "79305 Moravsky Beroun Cabova"
  },
  {
    "cast": "Čábuze",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Cabuze"
  },
  {
    "cast": "Čachnov",
    "psc": "56982",
    "okres": "Chrudim",
    "obec": "Krouna",
    "val": "56982 Krouna Cachnov"
  },
  {
    "cast": "Čachotín (část)",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Čachotín",
    "val": "58301 Cachotin Cachotin (cast)"
  },
  {
    "cast": "Čachotín (část)",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Čachotín",
    "val": "58001 Cachotin Cachotin (cast)"
  },
  {
    "cast": "Čachovice",
    "psc": "29443",
    "okres": "Mladá Boleslav",
    "obec": "Čachovice",
    "val": "29443 Cachovice Cachovice"
  },
  {
    "cast": "Čachrov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Cachrov"
  },
  {
    "cast": "Čakov",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Čakov",
    "val": "25724 Cakov Cakov"
  },
  {
    "cast": "Čakov",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Čakov",
    "val": "37384 Cakov Cakov"
  },
  {
    "cast": "Čaková",
    "psc": "79316",
    "okres": "Bruntál",
    "obec": "Čaková",
    "val": "79316 Cakova Cakova"
  },
  {
    "cast": "Čakovec",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Čakov",
    "val": "37384 Cakov Cakovec"
  },
  {
    "cast": "Čakovice",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Cakovice"
  },
  {
    "cast": "Čakovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Cakovice"
  },
  {
    "cast": "Čakovice",
    "psc": "19600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19600 Praha Cakovice"
  },
  {
    "cast": "Čakovice",
    "psc": "25168",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25168 Tynec nad Sazavou Cakovice"
  },
  {
    "cast": "Čakovičky (část)",
    "psc": "25063",
    "okres": "Mělník",
    "obec": "Čakovičky",
    "val": "25063 Cakovicky Cakovicky (cast)"
  },
  {
    "cast": "Čakovičky (část)",
    "psc": "25001",
    "okres": "Mělník",
    "obec": "Čakovičky",
    "val": "25001 Cakovicky Cakovicky (cast)"
  },
  {
    "cast": "Čálovice",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Calovice"
  },
  {
    "cast": "Čánka",
    "psc": "51773",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Opočno",
    "val": "51773 Opocno Canka"
  },
  {
    "cast": "Čankov",
    "psc": "36017",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36017 Karlovy Vary Cankov"
  },
  {
    "cast": "Čankovice",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Čankovice",
    "val": "53862 Cankovice Cankovice"
  },
  {
    "cast": "Čanovice",
    "psc": "27377",
    "okres": "Kladno",
    "obec": "Malíkovice",
    "val": "27377 Malikovice Canovice"
  },
  {
    "cast": "Čáslav",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Verneřice",
    "val": "40502 Vernerice Caslav"
  },
  {
    "cast": "Čáslavice",
    "psc": "67524",
    "okres": "Třebíč",
    "obec": "Čáslavice",
    "val": "67524 Caslavice Caslavice"
  },
  {
    "cast": "Čáslavky",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Dolany",
    "val": "55203 Dolany Caslavky"
  },
  {
    "cast": "Čáslavsko",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Čáslavsko",
    "val": "39501 Caslavsko Caslavsko"
  },
  {
    "cast": "Čáslav-Nové Město",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Čáslav",
    "val": "28601 Caslav Caslav-Nove Mesto"
  },
  {
    "cast": "Čáslav-Staré Město",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Čáslav",
    "val": "28601 Caslav Caslav-Stare Mesto"
  },
  {
    "cast": "Částkov",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Žumberk",
    "val": "53821 Zumberk Castkov"
  },
  {
    "cast": "Částkov",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Částkov",
    "val": "34801 Castkov Castkov"
  },
  {
    "cast": "Částkov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Castkov"
  },
  {
    "cast": "Částkov",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Částkov",
    "val": "68712 Castkov Castkov"
  },
  {
    "cast": "Částkovice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Hostětice",
    "val": "58856 Hostetice Castkovice"
  },
  {
    "cast": "Částkovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nová Cerekev",
    "val": "39301 Nova Cerekev Castkovice"
  },
  {
    "cast": "Častohostice",
    "psc": "67602",
    "okres": "Třebíč",
    "obec": "Častohostice",
    "val": "67602 Castohostice Castohostice"
  },
  {
    "cast": "Častolovice",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Castolovice"
  },
  {
    "cast": "Častolovice (část)",
    "psc": "51750",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Častolovice",
    "val": "51750 Castolovice Castolovice (cast)"
  },
  {
    "cast": "Častolovice (část)",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Častolovice",
    "val": "51741 Castolovice Castolovice (cast)"
  },
  {
    "cast": "Častolovické Horky",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Čestice",
    "val": "51741 Cestice Castolovicke Horky"
  },
  {
    "cast": "Častonice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Castonice"
  },
  {
    "cast": "Častonice",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Křivoklát",
    "val": "27023 Krivoklat Castonice"
  },
  {
    "cast": "Častonín",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Zachotín",
    "val": "39301 Zachotin Castonin"
  },
  {
    "cast": "Častotice",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Zahrádka",
    "val": "67571 Zahradka Castotice"
  },
  {
    "cast": "Častrov (část)",
    "psc": "39463",
    "okres": "Pelhřimov",
    "obec": "Častrov",
    "val": "39463 Castrov Castrov (cast)"
  },
  {
    "cast": "Častrov (část)",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Častrov",
    "val": "39470 Castrov Castrov (cast)"
  },
  {
    "cast": "Časy",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Časy",
    "val": "53401 Casy Casy"
  },
  {
    "cast": "Čavisov",
    "psc": "74764",
    "okres": "Ostrava-město",
    "obec": "Čavisov",
    "val": "74764 Cavisov Cavisov"
  },
  {
    "cast": "Čavyně",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Cavyne"
  },
  {
    "cast": "Čbán",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33038 Unesov Cban"
  },
  {
    "cast": "Čebín",
    "psc": "66423",
    "okres": "Brno-venkov",
    "obec": "Čebín",
    "val": "66423 Cebin Cebin"
  },
  {
    "cast": "Čečelice",
    "psc": "27732",
    "okres": "Mělník",
    "obec": "Čečelice",
    "val": "27732 Cecelice Cecelice"
  },
  {
    "cast": "Čečelovice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Čečelovice",
    "val": "38801 Cecelovice Cecelovice"
  },
  {
    "cast": "Čečín",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Cecin"
  },
  {
    "cast": "Čečkov",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Ceckov"
  },
  {
    "cast": "Čečkovice",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Ceckovice"
  },
  {
    "cast": "Čečkovice",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Čečkovice",
    "val": "58301 Ceckovice Ceckovice"
  },
  {
    "cast": "Čečovice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Čížkov",
    "val": "33501 Cizkov Cecovice"
  },
  {
    "cast": "Čečovice",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Čečovice",
    "val": "34562 Cecovice Cecovice"
  },
  {
    "cast": "Čehovice",
    "psc": "79821",
    "okres": "Prostějov",
    "obec": "Čehovice",
    "val": "79821 Cehovice Cehovice"
  },
  {
    "cast": "Čechočovice",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Čechočovice",
    "val": "67522 Cechocovice Cechocovice"
  },
  {
    "cast": "Čechovice",
    "psc": "79604",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79604 Prostejov Cechovice"
  },
  {
    "cast": "Čechovice",
    "psc": "78372",
    "okres": "Olomouc",
    "obec": "Velký Týnec",
    "val": "78372 Velky Tynec Cechovice"
  },
  {
    "cast": "Čechtice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Cechtice"
  },
  {
    "cast": "Čechtín",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Čechtín",
    "val": "67507 Cechtin Cechtin"
  },
  {
    "cast": "Čechůvky",
    "psc": "79811",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79811 Prostejov Cechuvky"
  },
  {
    "cast": "Čechy",
    "psc": "75115",
    "okres": "Přerov",
    "obec": "Čechy",
    "val": "75115 Cechy Cechy"
  },
  {
    "cast": "Čechy pod Kosířem",
    "psc": "79858",
    "okres": "Prostějov",
    "obec": "Čechy pod Kosířem",
    "val": "79858 Cechy pod Kosirem Cechy pod Kosirem"
  },
  {
    "cast": "Čechyně",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Rousínov",
    "val": "68301 Rousinov Cechyne"
  },
  {
    "cast": "Čechy-Děčín XIX x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Cechy-Decin XIX x)"
  },
  {
    "cast": "Čejč",
    "psc": "69614",
    "okres": "Hodonín",
    "obec": "Čejč",
    "val": "69614 Cejc Cejc"
  },
  {
    "cast": "Čejetice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Čejetice",
    "val": "38601 Cejetice Cejetice"
  },
  {
    "cast": "Čejetice",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Cejetice"
  },
  {
    "cast": "Čejetičky",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Cejeticky"
  },
  {
    "cast": "Čejkov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nový Rychnov",
    "val": "39301 Novy Rychnov Cejkov"
  },
  {
    "cast": "Čejkovice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Podhradí",
    "val": "50601 Podhradi Cejkovice"
  },
  {
    "cast": "Čejkovice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Libědice",
    "val": "43801 Libedice Cejkovice"
  },
  {
    "cast": "Čejkovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Čejkovice",
    "val": "28601 Cejkovice Cejkovice"
  },
  {
    "cast": "Čejkovice",
    "psc": "69615",
    "okres": "Hodonín",
    "obec": "Čejkovice",
    "val": "69615 Cejkovice Cejkovice"
  },
  {
    "cast": "Čejkovice",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Mladoňovice",
    "val": "53821 Mladonovice Cejkovice"
  },
  {
    "cast": "Čejkovice",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Čejkovice",
    "val": "67178 Cejkovice Cejkovice"
  },
  {
    "cast": "Čejkovice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Čejkovice",
    "val": "37341 Cejkovice Cejkovice"
  },
  {
    "cast": "Čejkovy",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hrádek",
    "val": "34201 Hradek Cejkovy"
  },
  {
    "cast": "Čejov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Čejov",
    "val": "39601 Cejov Cejov"
  },
  {
    "cast": "Čejtice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Horka II",
    "val": "28522 Horka II Cejtice"
  },
  {
    "cast": "Čekanice",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39002 Tabor Cekanice"
  },
  {
    "cast": "Čekanice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Cekanice"
  },
  {
    "cast": "Čekanov",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28506 Uzice Cekanov"
  },
  {
    "cast": "Čekánov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58001 Krasna Hora Cekanov"
  },
  {
    "cast": "Čekov (část)",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53825 Miretice Cekov (cast)"
  },
  {
    "cast": "Čekov (část)",
    "psc": "53955",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53955 Miretice Cekov (cast)"
  },
  {
    "cast": "Čekyně-Přerov VII x)",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Cekyne-Prerov VII x)"
  },
  {
    "cast": "Čeladná",
    "psc": "73912",
    "okres": "Frýdek-Místek",
    "obec": "Čeladná",
    "val": "73912 Celadna Celadna"
  },
  {
    "cast": "Čelákovice",
    "psc": "25088",
    "okres": "Praha-východ",
    "obec": "Čelákovice",
    "val": "25088 Celakovice Celakovice"
  },
  {
    "cast": "Čelákovy",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Zemětice",
    "val": "33452 Zemetice Celakovy"
  },
  {
    "cast": "Čelčice",
    "psc": "79823",
    "okres": "Prostějov",
    "obec": "Čelčice",
    "val": "79823 Celcice Celcice"
  },
  {
    "cast": "Čelechovice",
    "psc": "27304",
    "okres": "Kladno",
    "obec": "Stochov",
    "val": "27304 Stochov Celechovice"
  },
  {
    "cast": "Čelechovice",
    "psc": "75103",
    "okres": "Přerov",
    "obec": "Čelechovice",
    "val": "75103 Celechovice Celechovice"
  },
  {
    "cast": "Čelechovice na Hané",
    "psc": "79816",
    "okres": "Prostějov",
    "obec": "Čelechovice na Hané",
    "val": "79816 Celechovice na Hane Celechovice na Hane"
  },
  {
    "cast": "Čeletice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Celetice"
  },
  {
    "cast": "Čelina (část)",
    "psc": "26215",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26215 Borotice Celina (cast)"
  },
  {
    "cast": "Čelina (část)",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26203 Borotice Celina (cast)"
  },
  {
    "cast": "Čelistná",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Čelistná",
    "val": "39301 Celistna Celistna"
  },
  {
    "cast": "Čeliv",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Kokašice",
    "val": "34953 Kokasice Celiv"
  },
  {
    "cast": "Čelivo",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Celivo"
  },
  {
    "cast": "Čelkovice (část)",
    "psc": "39001",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39001 Tabor Celkovice (cast)"
  },
  {
    "cast": "Čelkovice (část)",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39002 Tabor Celkovice (cast)"
  },
  {
    "cast": "Čeložnice",
    "psc": "69651",
    "okres": "Hodonín",
    "obec": "Čeložnice",
    "val": "69651 Celoznice Celoznice"
  },
  {
    "cast": "Čeminy",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Čeminy",
    "val": "33033 Ceminy Ceminy"
  },
  {
    "cast": "Čeněnice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Křešín",
    "val": "39501 Kresin Cenenice"
  },
  {
    "cast": "Čenětice",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Křížkový Újezdec",
    "val": "25168 Krizkovy Ujezdec Cenetice"
  },
  {
    "cast": "Čenice 2.díl",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Cerekvice nad Bystřicí",
    "val": "50801 Cerekvice nad Bystrici Cenice 2.dil"
  },
  {
    "cast": "Čenkov",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Třešť",
    "val": "58901 Trest Cenkov"
  },
  {
    "cast": "Čenkov",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Čenkov",
    "val": "26223 Cenkov Cenkov"
  },
  {
    "cast": "Čenkov",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Cenkov"
  },
  {
    "cast": "Čenkov u Bechyně",
    "psc": "39165",
    "okres": "České Budějovice",
    "obec": "Čenkov u Bechyně",
    "val": "39165 Cenkov u Bechyne Cenkov u Bechyne"
  },
  {
    "cast": "Čenkovice",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Čenkovice",
    "val": "56164 Cenkovice Cenkovice"
  },
  {
    "cast": "Čenovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28522 Cestin Cenovice"
  },
  {
    "cast": "Čeňovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Teplýšovice",
    "val": "25601 Teplysovice Cenovice"
  },
  {
    "cast": "Čentice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28522 Cestin Centice"
  },
  {
    "cast": "Čeperka (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Čeperka",
    "val": "53002 Ceperka Ceperka (cast)"
  },
  {
    "cast": "Čeperka (část)",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Čeperka",
    "val": "53345 Ceperka Ceperka (cast)"
  },
  {
    "cast": "Čeperka (část)",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Čeperka",
    "val": "53352 Ceperka Ceperka (cast)"
  },
  {
    "cast": "Čepí",
    "psc": "53332",
    "okres": "Pardubice",
    "obec": "Čepí",
    "val": "53332 Cepi Cepi"
  },
  {
    "cast": "Čepice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Rabí",
    "val": "34201 Rabi Cepice"
  },
  {
    "cast": "Čepinec",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Žinkovy",
    "val": "33501 Zinkovy Cepinec"
  },
  {
    "cast": "Čepirohy",
    "psc": "43401",
    "okres": "Most",
    "obec": "Most",
    "val": "43401 Most Cepirohy"
  },
  {
    "cast": "Čepřovice",
    "psc": "38756",
    "okres": "Strakonice",
    "obec": "Čepřovice",
    "val": "38756 Ceprovice Ceprovice"
  },
  {
    "cast": "Čeradice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Čeradice",
    "val": "43801 Ceradice Ceradice"
  },
  {
    "cast": "Čeradice",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Klobuky",
    "val": "27374 Klobuky Ceradice"
  },
  {
    "cast": "Čeradice",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Moravany",
    "val": "53401 Moravany Ceradice"
  },
  {
    "cast": "Čeraz",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Vesce",
    "val": "39201 Vesce Ceraz"
  },
  {
    "cast": "Čerčany",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Čerčany",
    "val": "25722 Cercany Cercany"
  },
  {
    "cast": "Čermákovice",
    "psc": "67173",
    "okres": "Znojmo",
    "obec": "Čermákovice",
    "val": "67173 Cermakovice Cermakovice"
  },
  {
    "cast": "Čermná",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Čermná",
    "val": "34561 Cermna Cermna"
  },
  {
    "cast": "Čermná",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Libouchec",
    "val": "40002 Libouchec Cermna"
  },
  {
    "cast": "Čermná ve Slezsku",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Čermná ve Slezsku",
    "val": "74901 Cermna ve Slezsku Cermna ve Slezsku"
  },
  {
    "cast": "Čermná (část)",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hrádek",
    "val": "34142 Hradek Cermna (cast)"
  },
  {
    "cast": "Čermná (část)",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hrádek",
    "val": "34201 Hradek Cermna (cast)"
  },
  {
    "cast": "Čermná (část)",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Čermná",
    "val": "54371 Cermna Cermna (cast)"
  },
  {
    "cast": "Čermná (část)",
    "psc": "54377",
    "okres": "Trutnov",
    "obec": "Čermná",
    "val": "54377 Cermna Cermna (cast)"
  },
  {
    "cast": "Černá",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Cerna"
  },
  {
    "cast": "Černá",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Černá",
    "val": "59442 Cerna Cerna"
  },
  {
    "cast": "Černá",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Cerna"
  },
  {
    "cast": "Černá Hať",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Mladotice",
    "val": "33141 Mladotice Cerna Hat"
  },
  {
    "cast": "Černá Hora",
    "psc": "28901",
    "okres": "Nymburk",
    "obec": "Dymokury",
    "val": "28901 Dymokury Cerna Hora"
  },
  {
    "cast": "Černá Hora",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Cerna Hora"
  },
  {
    "cast": "Černá Hora (část)",
    "psc": "67922",
    "okres": "Blansko",
    "obec": "Černá Hora",
    "val": "67922 Cerna Hora Cerna Hora (cast)"
  },
  {
    "cast": "Černá Hora (část)",
    "psc": "67921",
    "okres": "Blansko",
    "obec": "Černá Hora",
    "val": "67921 Cerna Hora Cerna Hora (cast)"
  },
  {
    "cast": "Černá Lada",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Borová Lada",
    "val": "38501 Borova Lada Cerna Lada"
  },
  {
    "cast": "Černá Louže",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Rynoltice",
    "val": "46353 Rynoltice Cerna Louze"
  },
  {
    "cast": "Černá Pole (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Cerna Pole (cast)"
  },
  {
    "cast": "Černá Pole (část)",
    "psc": "61300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61300 Brno Cerna Pole (cast)"
  },
  {
    "cast": "Černá Pole (část)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Cerna Pole (cast)"
  },
  {
    "cast": "Černá Řeka",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Klenčí pod Čerchovem",
    "val": "34401 Klenci pod Cerchovem Cerna Reka"
  },
  {
    "cast": "Černá u Bohdanče",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Černá u Bohdanče",
    "val": "53341 Cerna u Bohdance Cerna u Bohdance"
  },
  {
    "cast": "Černá v Pošumaví (část)",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Černá v Pošumaví",
    "val": "38226 Cerna v Posumavi Cerna v Posumavi (cast)"
  },
  {
    "cast": "Černá v Pošumaví (část)",
    "psc": "38223",
    "okres": "Český Krumlov",
    "obec": "Černá v Pošumaví",
    "val": "38223 Cerna v Posumavi Cerna v Posumavi (cast)"
  },
  {
    "cast": "Černá Voda",
    "psc": "79054",
    "okres": "Jeseník",
    "obec": "Černá Voda",
    "val": "79054 Cerna Voda Cerna Voda"
  },
  {
    "cast": "Černá za Bory (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Cerna za Bory (cast)"
  },
  {
    "cast": "Černá za Bory (část)",
    "psc": "53301",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53301 Pardubice Cerna za Bory (cast)"
  },
  {
    "cast": "Černava",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Černava",
    "val": "36221 Cernava Cernava"
  },
  {
    "cast": "Černčice",
    "psc": "43901",
    "okres": "Louny",
    "obec": "Černčice",
    "val": "43901 Cerncice Cerncice"
  },
  {
    "cast": "Černčice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Žalany",
    "val": "41501 Zalany Cerncice"
  },
  {
    "cast": "Černčice",
    "psc": "43985",
    "okres": "Louny",
    "obec": "Petrohrad",
    "val": "43985 Petrohrad Cerncice"
  },
  {
    "cast": "Černčice (část)",
    "psc": "54906",
    "okres": "Náchod",
    "obec": "Černčice",
    "val": "54906 Cerncice Cerncice (cast)"
  },
  {
    "cast": "Černčice (část)",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Černčice",
    "val": "54901 Cerncice Cerncice (cast)"
  },
  {
    "cast": "Černčín",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Bučovice",
    "val": "68501 Bucovice Cerncin"
  },
  {
    "cast": "Černé Budy",
    "psc": "28506",
    "okres": "Benešov",
    "obec": "Sázava",
    "val": "28506 Sazava Cerne Budy"
  },
  {
    "cast": "Černé Údolí",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Cerne Udoli"
  },
  {
    "cast": "Černé Voděrady",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Černé Voděrady",
    "val": "28163 Cerne Voderady Cerne Voderady"
  },
  {
    "cast": "Černětice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Volyně",
    "val": "38701 Volyne Cernetice"
  },
  {
    "cast": "Černěves",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Černěves",
    "val": "41301 Cerneves Cerneves"
  },
  {
    "cast": "Černěves (část)",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Libějovice",
    "val": "38901 Libejovice Cerneves (cast)"
  },
  {
    "cast": "Černěves (část)",
    "psc": "38411",
    "okres": "Strakonice",
    "obec": "Libějovice",
    "val": "38411 Libejovice Cerneves (cast)"
  },
  {
    "cast": "Černice",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Cernice"
  },
  {
    "cast": "Černice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mojné",
    "val": "38232 Mojne Cernice"
  },
  {
    "cast": "Černice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Chanovice",
    "val": "34101 Chanovice Cernice"
  },
  {
    "cast": "Černice",
    "psc": "43543",
    "okres": "Most",
    "obec": "Horní Jiřetín",
    "val": "43543 Horni Jiretin Cernice"
  },
  {
    "cast": "Černíč",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Černíč",
    "val": "58856 Cernic Cernic"
  },
  {
    "cast": "Černíč",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Hradešice",
    "val": "34101 Hradesice Cernic"
  },
  {
    "cast": "Černičí",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Cernici"
  },
  {
    "cast": "Černíkov",
    "psc": "34506",
    "okres": "Klatovy",
    "obec": "Černíkov",
    "val": "34506 Cernikov Cernikov"
  },
  {
    "cast": "Černíkov",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Droužetice",
    "val": "38601 Drouzetice Cernikov"
  },
  {
    "cast": "Černíkovice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Chrášťany",
    "val": "25756 Chrastany Cernikovice"
  },
  {
    "cast": "Černíkovice",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Černíkovice",
    "val": "33141 Cernikovice Cernikovice"
  },
  {
    "cast": "Černíkovice",
    "psc": "51704",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Černíkovice",
    "val": "51704 Cernikovice Cernikovice"
  },
  {
    "cast": "Černíky",
    "psc": "28915",
    "okres": "Nymburk",
    "obec": "Černíky",
    "val": "28915 Cerniky Cerniky"
  },
  {
    "cast": "Černíky",
    "psc": "25245",
    "okres": "Praha-západ",
    "obec": "Zvole",
    "val": "25245 Zvole Cerniky"
  },
  {
    "cast": "Černilov (část)",
    "psc": "50343",
    "okres": "Hradec Králové",
    "obec": "Černilov",
    "val": "50343 Cernilov Cernilov (cast)"
  },
  {
    "cast": "Černilov (část)",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Černilov",
    "val": "50003 Cernilov Cernilov (cast)"
  },
  {
    "cast": "Černilov (část)",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Černilov",
    "val": "50346 Cernilov Cernilov (cast)"
  },
  {
    "cast": "Černín",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Zdice",
    "val": "26751 Zdice Cernin"
  },
  {
    "cast": "Černín",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Černín",
    "val": "67153 Cernin Cernin"
  },
  {
    "cast": "Černín",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Lukavec u Hořic",
    "val": "50801 Lukavec u Horic Cernin"
  },
  {
    "cast": "Černíny",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Černíny",
    "val": "28401 Cerniny Cerniny"
  },
  {
    "cast": "Černiv",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Černiv",
    "val": "41002 Cerniv Cerniv"
  },
  {
    "cast": "Černívsko",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Uzeničky",
    "val": "38801 Uzenicky Cernivsko"
  },
  {
    "cast": "Černochov",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Peruc",
    "val": "44001 Peruc Cernochov"
  },
  {
    "cast": "Černolice",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Černolice",
    "val": "25210 Cernolice Cernolice"
  },
  {
    "cast": "Černošice (část)",
    "psc": "25226",
    "okres": "Praha-západ",
    "obec": "Černošice",
    "val": "25226 Cernosice Cernosice (cast)"
  },
  {
    "cast": "Černošice (část)",
    "psc": "25228",
    "okres": "Praha-západ",
    "obec": "Černošice",
    "val": "25228 Cernosice Cernosice (cast)"
  },
  {
    "cast": "Černošín",
    "psc": "34958",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34958 Cernosin Cernosin"
  },
  {
    "cast": "Černotice",
    "psc": "25791",
    "okres": "Benešov",
    "obec": "Střezimíř",
    "val": "25791 Strezimir Cernotice"
  },
  {
    "cast": "Černotín",
    "psc": "75368",
    "okres": "Přerov",
    "obec": "Černotín",
    "val": "75368 Cernotin Cernotin"
  },
  {
    "cast": "Černotín",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Dnešice",
    "val": "33401 Dnesice Cernotin"
  },
  {
    "cast": "Černouček",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Černouček",
    "val": "41301 Cernoucek Cernoucek"
  },
  {
    "cast": "Černousy",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Černousy",
    "val": "46373 Cernousy Cernousy"
  },
  {
    "cast": "Černov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Černov",
    "val": "39301 Cernov Cernov"
  },
  {
    "cast": "Černovice",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Černovice",
    "val": "34562 Cernovice Cernovice"
  },
  {
    "cast": "Černovice",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Černovice",
    "val": "43001 Cernovice Cernovice"
  },
  {
    "cast": "Černovice",
    "psc": "39494",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39494 Cernovice Cernovice"
  },
  {
    "cast": "Černovice",
    "psc": "67975",
    "okres": "Blansko",
    "obec": "Černovice",
    "val": "67975 Cernovice Cernovice"
  },
  {
    "cast": "Čerňovice",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Čerňovice",
    "val": "33036 Cernovice Cernovice"
  },
  {
    "cast": "Černovice (část)",
    "psc": "61800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61800 Brno Cernovice (cast)"
  },
  {
    "cast": "Černovice (část)",
    "psc": "62700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62700 Brno Cernovice (cast)"
  },
  {
    "cast": "Černovír",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Cernovir"
  },
  {
    "cast": "Černovír",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56201 Usti nad Orlici Cernovir"
  },
  {
    "cast": "Černožice",
    "psc": "50304",
    "okres": "Hradec Králové",
    "obec": "Černožice",
    "val": "50304 Cernozice Cernozice"
  },
  {
    "cast": "Černuc",
    "psc": "27323",
    "okres": "Kladno",
    "obec": "Černuc",
    "val": "27323 Cernuc Cernuc"
  },
  {
    "cast": "Černvír",
    "psc": "59262",
    "okres": "Brno-venkov",
    "obec": "Černvír",
    "val": "59262 Cernvir Cernvir"
  },
  {
    "cast": "Černý Dub",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Homole",
    "val": "37001 Homole Cerny Dub"
  },
  {
    "cast": "Černý Důl",
    "psc": "54344",
    "okres": "Trutnov",
    "obec": "Černý Důl",
    "val": "54344 Cerny Dul Cerny Dul"
  },
  {
    "cast": "Černý Most",
    "psc": "19800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19800 Praha Cerny Most"
  },
  {
    "cast": "Černý Potok",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Kryštofovy Hamry",
    "val": "43191 Krystofovy Hamry Cerny Potok"
  },
  {
    "cast": "Černý Vůl",
    "psc": "25262",
    "okres": "Praha-západ",
    "obec": "Statenice",
    "val": "25262 Statenice Cerny Vul"
  },
  {
    "cast": "Černýš",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Soutice",
    "val": "25763 Soutice Cernys"
  },
  {
    "cast": "Černýš",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Perštejn",
    "val": "43151 Perstejn Cernys"
  },
  {
    "cast": "Černýšovice",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Černýšovice",
    "val": "39165 Cernysovice Cernysovice"
  },
  {
    "cast": "Čertoryje",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Charváty",
    "val": "78375 Charvaty Certoryje"
  },
  {
    "cast": "Čertovina",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Hlinsko",
    "val": "53901 Hlinsko Certovina"
  },
  {
    "cast": "Čertyně",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Dolní Třebonín",
    "val": "38232 Dolni Trebonin Certyne"
  },
  {
    "cast": "Červená",
    "psc": "56151",
    "okres": "Ústí nad Orlicí",
    "obec": "Letohrad",
    "val": "56151 Letohrad Cervena"
  },
  {
    "cast": "Červená",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Cervena"
  },
  {
    "cast": "Červená Hora",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Červená Hora",
    "val": "54941 Cervena Hora Cervena Hora"
  },
  {
    "cast": "Červená Lhota",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Bílá Lhota",
    "val": "78321 Bila Lhota Cervena Lhota"
  },
  {
    "cast": "Červená Lhota",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Červená Lhota",
    "val": "67507 Cervena Lhota Cervena Lhota"
  },
  {
    "cast": "Červená Lhota",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Úžice",
    "val": "27745 Uzice Cervena Lhota"
  },
  {
    "cast": "Červená Lhota",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Pluhův Žďár",
    "val": "37821 Pluhuv Zdar Cervena Lhota"
  },
  {
    "cast": "Červená Řečice (část)",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Červená Řečice",
    "val": "39301 Cervena Recice Cervena Recice (cast)"
  },
  {
    "cast": "Červená Řečice (část)",
    "psc": "39446",
    "okres": "Pelhřimov",
    "obec": "Červená Řečice",
    "val": "39446 Cervena Recice Cervena Recice (cast)"
  },
  {
    "cast": "Červená Třemešná",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Červená Třemešná",
    "val": "50801 Cervena Tremesna Cervena Tremesna"
  },
  {
    "cast": "Červená Voda (část)",
    "psc": "56161",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56161 Cervena Voda Cervena Voda (cast)"
  },
  {
    "cast": "Červená Voda (část)",
    "psc": "56162",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56162 Cervena Voda Cervena Voda (cast)"
  },
  {
    "cast": "Červená (část)",
    "psc": "39848",
    "okres": "Písek",
    "obec": "Jetětice",
    "val": "39848 Jetetice Cervena (cast)"
  },
  {
    "cast": "Červená (část)",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Jetětice",
    "val": "39843 Jetetice Cervena (cast)"
  },
  {
    "cast": "Červené Dvorce",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Cervene Dvorce"
  },
  {
    "cast": "Červené Janovice (část)",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Červené Janovice",
    "val": "28601 Cervene Janovice Cervene Janovice (cast)"
  },
  {
    "cast": "Červené Janovice (část)",
    "psc": "28542",
    "okres": "Kutná Hora",
    "obec": "Červené Janovice",
    "val": "28542 Cervene Janovice Cervene Janovice (cast)"
  },
  {
    "cast": "Červené Pečky (část)",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Červené Pečky",
    "val": "28002 Cervene Pecky Cervene Pecky (cast)"
  },
  {
    "cast": "Červené Pečky (část)",
    "psc": "28121",
    "okres": "Kolín",
    "obec": "Červené Pečky",
    "val": "28121 Cervene Pecky Cervene Pecky (cast)"
  },
  {
    "cast": "Červené Poříčí",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Červené Poříčí",
    "val": "34012 Cervene Porici Cervene Porici"
  },
  {
    "cast": "Červené Záhoří",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Cervene Zahori"
  },
  {
    "cast": "Červeněves",
    "psc": "50353",
    "okres": "Hradec Králové",
    "obec": "Smidary",
    "val": "50353 Smidary Cerveneves"
  },
  {
    "cast": "Červenice",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Pěnčín",
    "val": "46344 Pencin Cervenice"
  },
  {
    "cast": "Červenka",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Červenka",
    "val": "78401 Cervenka Cervenka"
  },
  {
    "cast": "Červený Důl",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Uhelná",
    "val": "79070 Uhelna Cerveny Dul"
  },
  {
    "cast": "Červený Dvůr",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Cerveny Dvur"
  },
  {
    "cast": "Červený Dvůr",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Chvalšiny",
    "val": "38101 Chvalsiny Cerveny Dvur"
  },
  {
    "cast": "Červený Hrádek",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Jirkov",
    "val": "43111 Jirkov Cerveny Hradek"
  },
  {
    "cast": "Červený Hrádek",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Cerveny Hradek"
  },
  {
    "cast": "Červený Hrádek",
    "psc": "28504",
    "okres": "Kolín",
    "obec": "Bečváry",
    "val": "28504 Becvary Cerveny Hradek"
  },
  {
    "cast": "Červený Hrádek",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Červený Hrádek",
    "val": "38001 Cerveny Hradek Cerveny Hradek"
  },
  {
    "cast": "Červený Kostelec",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Červený Kostelec",
    "val": "54941 Cerveny Kostelec Cerveny Kostelec"
  },
  {
    "cast": "Červený Kříž",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Cerveny Kriz"
  },
  {
    "cast": "Červený Potok",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Cerveny Potok"
  },
  {
    "cast": "Červený Újezd",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Zbůch",
    "val": "33023 Zbuch Cerveny Ujezd"
  },
  {
    "cast": "Červený Újezd",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41804 Hrobcice Cerveny Ujezd"
  },
  {
    "cast": "Červený Újezd",
    "psc": "27351",
    "okres": "Praha-západ",
    "obec": "Červený Újezd",
    "val": "27351 Cerveny Ujezd Cerveny Ujezd"
  },
  {
    "cast": "Červený Újezd",
    "psc": "25788",
    "okres": "Benešov",
    "obec": "Červený Újezd",
    "val": "25788 Cerveny Ujezd Cerveny Ujezd"
  },
  {
    "cast": "Červený Újezdec",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Vlastec",
    "val": "39701 Vlastec Cerveny Ujezdec"
  },
  {
    "cast": "Červený Újezdec",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Cerveny Ujezdec"
  },
  {
    "cast": "Čeřejov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Cerejov"
  },
  {
    "cast": "Čeřenice",
    "psc": "28506",
    "okres": "Benešov",
    "obec": "Sázava",
    "val": "28506 Sazava Cerenice"
  },
  {
    "cast": "Čeřeniště",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40002 Malecov Cereniste"
  },
  {
    "cast": "Čeřín",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Rožmitál na Šumavě",
    "val": "38101 Rozmital na Sumave Cerin"
  },
  {
    "cast": "Česká",
    "psc": "66431",
    "okres": "Brno-venkov",
    "obec": "Česká",
    "val": "66431 Ceska Ceska"
  },
  {
    "cast": "Česká Bělá",
    "psc": "58261",
    "okres": "Havlíčkův Brod",
    "obec": "Česká Bělá",
    "val": "58261 Ceska Bela Ceska Bela"
  },
  {
    "cast": "Česká Bříza",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Česká Bříza",
    "val": "33011 Ceska Briza Ceska Briza"
  },
  {
    "cast": "Česká Cikánka",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Svratka",
    "val": "59202 Svratka Ceska Cikanka"
  },
  {
    "cast": "Česká Čermná",
    "psc": "54921",
    "okres": "Náchod",
    "obec": "Česká Čermná",
    "val": "54921 Ceska Cermna Ceska Cermna"
  },
  {
    "cast": "Česká Doubravice",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Ceska Doubravice"
  },
  {
    "cast": "Česká Jablonná",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Přibyslav",
    "val": "58222 Pribyslav Ceska Jablonna"
  },
  {
    "cast": "Česká Kamenice",
    "psc": "40721",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40721 Ceska Kamenice Ceska Kamenice"
  },
  {
    "cast": "Česká Kubice",
    "psc": "34532",
    "okres": "Domažlice",
    "obec": "Česká Kubice",
    "val": "34532 Ceska Kubice Ceska Kubice"
  },
  {
    "cast": "Česká Lhota",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dívčice",
    "val": "37348 Divcice Ceska Lhota"
  },
  {
    "cast": "Česká Lípa (část)",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Ceska Lipa (cast)"
  },
  {
    "cast": "Česká Lípa (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47002 Ceska Lipa Ceska Lipa (cast)"
  },
  {
    "cast": "Česká Lípa (část)",
    "psc": "47006",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47006 Ceska Lipa Ceska Lipa (cast)"
  },
  {
    "cast": "Česká Metuje",
    "psc": "54956",
    "okres": "Náchod",
    "obec": "Česká Metuje",
    "val": "54956 Ceska Metuje Ceska Metuje"
  },
  {
    "cast": "Česká Mez",
    "psc": "59211",
    "okres": "Žďár nad Sázavou",
    "obec": "Sázava",
    "val": "59211 Sazava Ceska Mez"
  },
  {
    "cast": "Česká Olešná",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Strmilov",
    "val": "37853 Strmilov Ceska Olesna"
  },
  {
    "cast": "Česká Proseč",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Úbislavice",
    "val": "50901 Ubislavice Ceska Prosec"
  },
  {
    "cast": "Česká Rybná",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Proseč",
    "val": "53944 Prosec Ceska Rybna"
  },
  {
    "cast": "Česká Rybná",
    "psc": "56185",
    "okres": "Ústí nad Orlicí",
    "obec": "Česká Rybná",
    "val": "56185 Ceska Rybna Ceska Rybna"
  },
  {
    "cast": "Česká Skalice",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Česká Skalice",
    "val": "55203 Ceska Skalice Ceska Skalice"
  },
  {
    "cast": "Česká Třebová",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Česká Třebová",
    "val": "56002 Ceska Trebova Ceska Trebova"
  },
  {
    "cast": "Česká Ves",
    "psc": "79081",
    "okres": "Jeseník",
    "obec": "Česká Ves",
    "val": "79081 Ceska Ves Ceska Ves"
  },
  {
    "cast": "Česká Ves",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Ceska Ves"
  },
  {
    "cast": "Česká Ves",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Ceska Ves"
  },
  {
    "cast": "České Budějovice 1 (část)",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37001 Ceske Budejovice Ceske Budejovice 1 (cast)"
  },
  {
    "cast": "České Budějovice 1 (část)",
    "psc": "37004",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37004 Ceske Budejovice Ceske Budejovice 1 (cast)"
  },
  {
    "cast": "České Budějovice 2 (část)",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37001 Ceske Budejovice Ceske Budejovice 2 (cast)"
  },
  {
    "cast": "České Budějovice 2 (část)",
    "psc": "37005",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37005 Ceske Budejovice Ceske Budejovice 2 (cast)"
  },
  {
    "cast": "České Budějovice 2 (část)",
    "psc": "37011",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37011 Ceske Budejovice Ceske Budejovice 2 (cast)"
  },
  {
    "cast": "České Budějovice 3 (část)",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37001 Ceske Budejovice Ceske Budejovice 3 (cast)"
  },
  {
    "cast": "České Budějovice 3 (část)",
    "psc": "37004",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37004 Ceske Budejovice Ceske Budejovice 3 (cast)"
  },
  {
    "cast": "České Budějovice 3 (část)",
    "psc": "37010",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37010 Ceske Budejovice Ceske Budejovice 3 (cast)"
  },
  {
    "cast": "České Budějovice 4 (část)",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37001 Ceske Budejovice Ceske Budejovice 4 (cast)"
  },
  {
    "cast": "České Budějovice 4 (část)",
    "psc": "37004",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37004 Ceske Budejovice Ceske Budejovice 4 (cast)"
  },
  {
    "cast": "České Budějovice 4 (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37006 Ceske Budejovice Ceske Budejovice 4 (cast)"
  },
  {
    "cast": "České Budějovice 4 (část)",
    "psc": "37010",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37010 Ceske Budejovice Ceske Budejovice 4 (cast)"
  },
  {
    "cast": "České Budějovice 5 (část)",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37001 Ceske Budejovice Ceske Budejovice 5 (cast)"
  },
  {
    "cast": "České Budějovice 5 (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37006 Ceske Budejovice Ceske Budejovice 5 (cast)"
  },
  {
    "cast": "České Budějovice 5 (část)",
    "psc": "37008",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37008 Ceske Budejovice Ceske Budejovice 5 (cast)"
  },
  {
    "cast": "České Budějovice 6 (část)",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37001 Ceske Budejovice Ceske Budejovice 6 (cast)"
  },
  {
    "cast": "České Budějovice 6 (část)",
    "psc": "37004",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37004 Ceske Budejovice Ceske Budejovice 6 (cast)"
  },
  {
    "cast": "České Budějovice 6 (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37006 Ceske Budejovice Ceske Budejovice 6 (cast)"
  },
  {
    "cast": "České Budějovice 6 (část)",
    "psc": "37008",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37008 Ceske Budejovice Ceske Budejovice 6 (cast)"
  },
  {
    "cast": "České Budějovice 7 (část)",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37001 Ceske Budejovice Ceske Budejovice 7 (cast)"
  },
  {
    "cast": "České Budějovice 7 (část)",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "České Budějovice",
    "val": "37007 Ceske Budejovice Ceske Budejovice 7 (cast)"
  },
  {
    "cast": "České Hamry",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Vejprty",
    "val": "43191 Vejprty Ceske Hamry"
  },
  {
    "cast": "České Hamry",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Ceske Hamry"
  },
  {
    "cast": "České Heřmanice",
    "psc": "56552",
    "okres": "Ústí nad Orlicí",
    "obec": "České Heřmanice",
    "val": "56552 Ceske Hermanice Ceske Hermanice"
  },
  {
    "cast": "České Chalupy",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Nová Ves",
    "val": "38203 Nova Ves Ceske Chalupy"
  },
  {
    "cast": "České Kopisty",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Terezín",
    "val": "41201 Terezin Ceske Kopisty"
  },
  {
    "cast": "České Křižánky",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Křižánky",
    "val": "59202 Krizanky Ceske Krizanky"
  },
  {
    "cast": "České Lhotice",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "České Lhotice",
    "val": "53825 Ceske Lhotice Ceske Lhotice"
  },
  {
    "cast": "České Libchavy",
    "psc": "56114",
    "okres": "Ústí nad Orlicí",
    "obec": "České Libchavy",
    "val": "56114 Ceske Libchavy Ceske Libchavy"
  },
  {
    "cast": "České Meziříčí",
    "psc": "51771",
    "okres": "Rychnov nad Kněžnou",
    "obec": "České Meziříčí",
    "val": "51771 Ceske Mezirici Ceske Mezirici"
  },
  {
    "cast": "České Milovy",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Křižánky",
    "val": "59202 Krizanky Ceske Milovy"
  },
  {
    "cast": "České Petrovice",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "České Petrovice",
    "val": "56401 Ceske Petrovice Ceske Petrovice"
  },
  {
    "cast": "České Velenice",
    "psc": "37810",
    "okres": "Jindřichův Hradec",
    "obec": "České Velenice",
    "val": "37810 Ceske Velenice Ceske Velenice"
  },
  {
    "cast": "České Zlatníky",
    "psc": "43401",
    "okres": "Most",
    "obec": "Obrnice",
    "val": "43401 Obrnice Ceske Zlatniky"
  },
  {
    "cast": "České Žleby",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Stožec",
    "val": "38451 Stozec Ceske Zleby"
  },
  {
    "cast": "Český Brod",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Český Brod",
    "val": "28201 Cesky Brod Cesky Brod"
  },
  {
    "cast": "Český Dub I",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Cesky Dub I"
  },
  {
    "cast": "Český Dub II",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Cesky Dub II"
  },
  {
    "cast": "Český Dub III",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Cesky Dub III"
  },
  {
    "cast": "Český Dub IV",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Cesky Dub IV"
  },
  {
    "cast": "Český Herálec",
    "psc": "59201",
    "okres": "Žďár nad Sázavou",
    "obec": "Herálec",
    "val": "59201 Heralec Cesky Heralec"
  },
  {
    "cast": "Český Heršlák",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Horní Dvořiště",
    "val": "38241 Horni Dvoriste Cesky Herslak"
  },
  {
    "cast": "Český Chloumek",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Útvina",
    "val": "36401 Utvina Cesky Chloumek"
  },
  {
    "cast": "Český Jiřetín",
    "psc": "43601",
    "okres": "Most",
    "obec": "Český Jiřetín",
    "val": "43601 Cesky Jiretin Cesky Jiretin"
  },
  {
    "cast": "Český Rudolec",
    "psc": "37883",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "37883 Cesky Rudolec Cesky Rudolec"
  },
  {
    "cast": "Český Šternberk",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Český Šternberk",
    "val": "25726 Cesky Sternberk Cesky Sternberk"
  },
  {
    "cast": "Český Těšín",
    "psc": "73701",
    "okres": "Karviná",
    "obec": "Český Těšín",
    "val": "73701 Cesky Tesin Cesky Tesin"
  },
  {
    "cast": "Český Újezd",
    "psc": "40010",
    "okres": "Ústí nad Labem",
    "obec": "Chlumec",
    "val": "40010 Chlumec Cesky Ujezd"
  },
  {
    "cast": "Čestětín",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Cestetin"
  },
  {
    "cast": "Čestice",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Čestice",
    "val": "51741 Cestice Cestice"
  },
  {
    "cast": "Čestice (část)",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38701 Cestice Cestice (cast)"
  },
  {
    "cast": "Čestice (část)",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38719 Cestice Cestice (cast)"
  },
  {
    "cast": "Čestín",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Cestin"
  },
  {
    "cast": "Čestín",
    "psc": "28510",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28510 Cestin Cestin"
  },
  {
    "cast": "Čestlice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Čestlice",
    "val": "25101 Cestlice Cestlice"
  },
  {
    "cast": "Češkovice",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Ceskovice"
  },
  {
    "cast": "Češnovice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Pištín",
    "val": "37341 Pistin Cesnovice"
  },
  {
    "cast": "Češov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Češov",
    "val": "50601 Cesov Cesov"
  },
  {
    "cast": "Číbuz",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Skalice",
    "val": "50303 Skalice Cibuz"
  },
  {
    "cast": "Číčenice (část)",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Číčenice",
    "val": "38901 Cicenice Cicenice (cast)"
  },
  {
    "cast": "Číčenice (část)",
    "psc": "38771",
    "okres": "Strakonice",
    "obec": "Číčenice",
    "val": "38771 Cicenice Cicenice (cast)"
  },
  {
    "cast": "Číčov",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33563 Spalene Porici Cicov"
  },
  {
    "cast": "Číčová",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Čermná nad Orlicí",
    "val": "51741 Cermna nad Orlici Cicova"
  },
  {
    "cast": "Číčovice",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Cicovice"
  },
  {
    "cast": "Číčovice",
    "psc": "25268",
    "okres": "Praha-západ",
    "obec": "Číčovice",
    "val": "25268 Cicovice Cicovice"
  },
  {
    "cast": "Čihadla (část)",
    "psc": "28926",
    "okres": "Nymburk",
    "obec": "Stará Lysá",
    "val": "28926 Stara Lysa Cihadla (cast)"
  },
  {
    "cast": "Čihadla (část)",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Stará Lysá",
    "val": "28922 Stara Lysa Cihadla (cast)"
  },
  {
    "cast": "Čihák",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Klášterec nad Orlicí",
    "val": "56401 Klasterec nad Orlici Cihak"
  },
  {
    "cast": "Číhalín",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Číhalín",
    "val": "67507 Cihalin Cihalin"
  },
  {
    "cast": "Číhaň",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Číhaň",
    "val": "34142 Cihan Cihan"
  },
  {
    "cast": "Číhaná",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33038 Unesov Cihana"
  },
  {
    "cast": "Číhaná",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Cihana"
  },
  {
    "cast": "Číhaná",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "35301 Tepla Cihana"
  },
  {
    "cast": "Číhání",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Cihani"
  },
  {
    "cast": "Čihátka",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Ptýrov",
    "val": "29401 Ptyrov Cihatka"
  },
  {
    "cast": "Číhošť",
    "psc": "58287",
    "okres": "Havlíčkův Brod",
    "obec": "Číhošť",
    "val": "58287 Cihost Cihost"
  },
  {
    "cast": "Číhovice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Křelovice",
    "val": "39601 Krelovice Cihovice"
  },
  {
    "cast": "Čichalov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Čichalov",
    "val": "36452 Cichalov Cichalov"
  },
  {
    "cast": "Čichořice",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Cichorice"
  },
  {
    "cast": "Číchov",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Číchov",
    "val": "67521 Cichov Cichov"
  },
  {
    "cast": "Čichtice",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Bavorov",
    "val": "38773 Bavorov Cichtice"
  },
  {
    "cast": "Čikov",
    "psc": "67578",
    "okres": "Třebíč",
    "obec": "Čikov",
    "val": "67578 Cikov Cikov"
  },
  {
    "cast": "Čikvásky",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Košťálov",
    "val": "51251 Kostalov Cikvasky"
  },
  {
    "cast": "Čilá",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Čilá",
    "val": "33808 Cila Cila"
  },
  {
    "cast": "Čilec",
    "psc": "28925",
    "okres": "Nymburk",
    "obec": "Čilec",
    "val": "28925 Cilec Cilec"
  },
  {
    "cast": "Čím",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Čím",
    "val": "26203 Cim Cim"
  },
  {
    "cast": "Čimelice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Čimelice",
    "val": "39804 Cimelice Cimelice"
  },
  {
    "cast": "Číměř",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Číměř",
    "val": "67501 Cimer Cimer"
  },
  {
    "cast": "Číměř",
    "psc": "37832",
    "okres": "Jindřichův Hradec",
    "obec": "Číměř",
    "val": "37832 Cimer Cimer"
  },
  {
    "cast": "Čímice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Čímice",
    "val": "34201 Cimice Cimice"
  },
  {
    "cast": "Čimice (část)",
    "psc": "18100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18100 Praha Cimice (cast)"
  },
  {
    "cast": "Čimice (část)",
    "psc": "18400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18400 Praha Cimice (cast)"
  },
  {
    "cast": "Čímyšl",
    "psc": "51263",
    "okres": "Jičín",
    "obec": "Újezd pod Troskami",
    "val": "51263 Ujezd pod Troskami Cimysl"
  },
  {
    "cast": "Činěves",
    "psc": "28901",
    "okres": "Nymburk",
    "obec": "Činěves",
    "val": "28901 Cineves Cineves"
  },
  {
    "cast": "Činov",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Doupovské Hradiště",
    "val": "36471 Doupovske Hradiste Cinov"
  },
  {
    "cast": "Čínov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Cinov"
  },
  {
    "cast": "Číňov",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Nové Sedlo",
    "val": "43801 Nove Sedlo Cinov"
  },
  {
    "cast": "Čirá",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Cira"
  },
  {
    "cast": "Čisovice (část)",
    "psc": "25204",
    "okres": "Praha-západ",
    "obec": "Čisovice",
    "val": "25204 Cisovice Cisovice (cast)"
  },
  {
    "cast": "Čisovice (část)",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Čisovice",
    "val": "25210 Cisovice Cisovice (cast)"
  },
  {
    "cast": "Čistá",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Čistá",
    "val": "27034 Cista Cista"
  },
  {
    "cast": "Čistá",
    "psc": "29423",
    "okres": "Mladá Boleslav",
    "obec": "Čistá",
    "val": "29423 Cista Cista"
  },
  {
    "cast": "Čistá u Horek",
    "psc": "51235",
    "okres": "Semily",
    "obec": "Čistá u Horek",
    "val": "51235 Cista u Horek Cista u Horek"
  },
  {
    "cast": "Čistá v Krkonoších",
    "psc": "54344",
    "okres": "Trutnov",
    "obec": "Černý Důl",
    "val": "54344 Cerny Dul Cista v Krkonosich"
  },
  {
    "cast": "Čistá (část)",
    "psc": "56956",
    "okres": "Svitavy",
    "obec": "Čistá",
    "val": "56956 Cista Cista (cast)"
  },
  {
    "cast": "Čistá (část)",
    "psc": "56957",
    "okres": "Svitavy",
    "obec": "Čistá",
    "val": "56957 Cista Cista (cast)"
  },
  {
    "cast": "Čistec (část)",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Přestavlky u Čerčan",
    "val": "25722 Prestavlky u Cercan Cistec (cast)"
  },
  {
    "cast": "Čistec (část)",
    "psc": "25723",
    "okres": "Benešov",
    "obec": "Přestavlky u Čerčan",
    "val": "25723 Prestavlky u Cercan Cistec (cast)"
  },
  {
    "cast": "Čistěves",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Čistěves",
    "val": "50315 Cisteves Cisteves"
  },
  {
    "cast": "Číšťovice",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Cistovice"
  },
  {
    "cast": "Čivice",
    "psc": "33151",
    "okres": "Plzeň-sever",
    "obec": "Dobříč",
    "val": "33151 Dobric Civice"
  },
  {
    "cast": "Čižebná",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Nový Kostel",
    "val": "35134 Novy Kostel Cizebna"
  },
  {
    "cast": "Čižice",
    "psc": "33209",
    "okres": "Plzeň-jih",
    "obec": "Čižice",
    "val": "33209 Cizice Cizice"
  },
  {
    "cast": "Čížkov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Čížkov",
    "val": "39301 Cizkov Cizkov"
  },
  {
    "cast": "Čížkov",
    "psc": "33564",
    "okres": "Plzeň-jih",
    "obec": "Čížkov",
    "val": "33564 Cizkov Cizkov"
  },
  {
    "cast": "Čížkovice",
    "psc": "41112",
    "okres": "Litoměřice",
    "obec": "Čížkovice",
    "val": "41112 Cizkovice Cizkovice"
  },
  {
    "cast": "Čížkovice 1.díl",
    "psc": "46821",
    "okres": "Jablonec nad Nisou",
    "obec": "Maršovice",
    "val": "46821 Marsovice Cizkovice 1.dil"
  },
  {
    "cast": "Čížkrajice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Čížkrajice",
    "val": "37401 Cizkrajice Cizkrajice"
  },
  {
    "cast": "Čížky",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Úsuší",
    "val": "66601 Ususi Cizky"
  },
  {
    "cast": "Čížov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Čížov",
    "val": "58601 Cizov Cizov"
  },
  {
    "cast": "Čížov",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Horní Břečkov",
    "val": "67102 Horni Breckov Cizov"
  },
  {
    "cast": "Čížov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Chabeřice",
    "val": "28522 Chaberice Cizov"
  },
  {
    "cast": "Čížová",
    "psc": "39831",
    "okres": "Písek",
    "obec": "Čížová",
    "val": "39831 Cizova Cizova"
  },
  {
    "cast": "Čížovka",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Cizovka"
  },
  {
    "cast": "Čížovky",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Petkovy",
    "val": "29406 Petkovy Cizovky"
  },
  {
    "cast": "Čkyně",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Čkyně",
    "val": "38481 Ckyne Ckyne"
  },
  {
    "cast": "Člunek",
    "psc": "37861",
    "okres": "Jindřichův Hradec",
    "obec": "Člunek",
    "val": "37861 Clunek Clunek"
  },
  {
    "cast": "Člupek",
    "psc": "56118",
    "okres": "Svitavy",
    "obec": "Němčice",
    "val": "56118 Nemcice Clupek"
  },
  {
    "cast": "Čmelíny",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Čmelíny",
    "val": "33501 Cmeliny Cmeliny"
  },
  {
    "cast": "Čtveřín",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Čtveřín",
    "val": "46345 Ctverin Ctverin"
  },
  {
    "cast": "Čtyři Dvory",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Prosetín",
    "val": "59301 Prosetin Ctyri Dvory"
  },
  {
    "cast": "Čtyřkoly",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Čtyřkoly",
    "val": "25722 Ctyrkoly Ctyrkoly"
  },
  {
    "cast": "Čučice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Čučice",
    "val": "66491 Cucice Cucice"
  },
  {
    "cast": "Čunín",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Konice",
    "val": "79852 Konice Cunin"
  },
  {
    "cast": "Ďáblice (část)",
    "psc": "18200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18200 Praha Dablice (cast)"
  },
  {
    "cast": "Ďáblice (část)",
    "psc": "19600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19600 Praha Dablice (cast)"
  },
  {
    "cast": "Dačice I",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Dacice I"
  },
  {
    "cast": "Dačice II",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Dacice II"
  },
  {
    "cast": "Dačice III",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Dacice III"
  },
  {
    "cast": "Dačice IV",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Dacice IV"
  },
  {
    "cast": "Dačice V",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Dacice V"
  },
  {
    "cast": "Dachov",
    "psc": "53955",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53955 Miretice Dachov"
  },
  {
    "cast": "Dachov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Vlachovo Březí",
    "val": "38301 Vlachovo Brezi Dachov"
  },
  {
    "cast": "Dálčice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Dalcice"
  },
  {
    "cast": "Dalečín",
    "psc": "59241",
    "okres": "Žďár nad Sázavou",
    "obec": "Dalečín",
    "val": "59241 Dalecin Dalecin"
  },
  {
    "cast": "Daleké Dušníky",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Daleké Dušníky",
    "val": "26301 Daleke Dusniky Daleke Dusniky"
  },
  {
    "cast": "Daleké Popelice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Daleke Popelice"
  },
  {
    "cast": "Dalešice",
    "psc": "67554",
    "okres": "Třebíč",
    "obec": "Dalešice",
    "val": "67554 Dalesice Dalesice"
  },
  {
    "cast": "Dalešice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25744 Neveklov Dalesice"
  },
  {
    "cast": "Dalešice",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bítouchov",
    "val": "29401 Bitouchov Dalesice"
  },
  {
    "cast": "Dalešice",
    "psc": "46802",
    "okres": "Jablonec nad Nisou",
    "obec": "Dalešice",
    "val": "46802 Dalesice Dalesice"
  },
  {
    "cast": "Daliměřice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Dalimerice"
  },
  {
    "cast": "Dalkovice",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Trhový Štěpánov",
    "val": "25763 Trhovy Stepanov Dalkovice"
  },
  {
    "cast": "Dalov",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Šternberk",
    "val": "78501 Sternberk Dalov"
  },
  {
    "cast": "Dalovice",
    "psc": "36263",
    "okres": "Karlovy Vary",
    "obec": "Dalovice",
    "val": "36263 Dalovice Dalovice"
  },
  {
    "cast": "Dalovice",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Dalovice",
    "val": "29301 Dalovice Dalovice"
  },
  {
    "cast": "Dalovy",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Divišov",
    "val": "25726 Divisov Dalovy"
  },
  {
    "cast": "Damašek",
    "psc": "79382",
    "okres": "Bruntál",
    "obec": "Třemešná",
    "val": "79382 Tremesna Damasek"
  },
  {
    "cast": "Dambořice (část)",
    "psc": "69173",
    "okres": "Hodonín",
    "obec": "Dambořice",
    "val": "69173 Damborice Damborice (cast)"
  },
  {
    "cast": "Dambořice (část)",
    "psc": "69635",
    "okres": "Hodonín",
    "obec": "Dambořice",
    "val": "69635 Damborice Damborice (cast)"
  },
  {
    "cast": "Daměnice",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Damenice"
  },
  {
    "cast": "Damětice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Frymburk",
    "val": "34201 Frymburk Dametice"
  },
  {
    "cast": "Damice",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Krásný Les",
    "val": "36301 Krasny Les Damice"
  },
  {
    "cast": "Damíč",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Soběšice",
    "val": "34201 Sobesice Damic"
  },
  {
    "cast": "Daminěves",
    "psc": "27704",
    "okres": "Mělník",
    "obec": "Cítov",
    "val": "27704 Citov Damineves"
  },
  {
    "cast": "Damírov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Zbýšov",
    "val": "28601 Zbysov Damirov"
  },
  {
    "cast": "Damnice",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Damnice",
    "val": "67178 Damnice Damnice"
  },
  {
    "cast": "Damníkov",
    "psc": "56123",
    "okres": "Ústí nad Orlicí",
    "obec": "Damníkov",
    "val": "56123 Damnikov Damnikov"
  },
  {
    "cast": "Damnov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34815 Bor Damnov"
  },
  {
    "cast": "Dančovice",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Dešná",
    "val": "37881 Desna Dancovice"
  },
  {
    "cast": "Daňkovice",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Daňkovice",
    "val": "59203 Dankovice Dankovice"
  },
  {
    "cast": "Darkovice",
    "psc": "74717",
    "okres": "Opava",
    "obec": "Darkovice",
    "val": "74717 Darkovice Darkovice"
  },
  {
    "cast": "Darkovičky",
    "psc": "74801",
    "okres": "Opava",
    "obec": "Hlučín",
    "val": "74801 Hlucin Darkovicky"
  },
  {
    "cast": "Darmyšl",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Staré Sedlo",
    "val": "34802 Stare Sedlo Darmysl"
  },
  {
    "cast": "Darová",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Břasy",
    "val": "33824 Brasy Darova"
  },
  {
    "cast": "Daskabát",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Daskabát",
    "val": "77900 Daskabat Daskabat"
  },
  {
    "cast": "Dasnice",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Dasnice",
    "val": "35709 Dasnice Dasnice"
  },
  {
    "cast": "Dasný",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Dasný",
    "val": "37341 Dasny Dasny"
  },
  {
    "cast": "Dašice (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Dašice",
    "val": "53002 Dasice Dasice (cast)"
  },
  {
    "cast": "Dašice (část)",
    "psc": "53303",
    "okres": "Pardubice",
    "obec": "Dašice",
    "val": "53303 Dasice Dasice (cast)"
  },
  {
    "cast": "Datelov",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34022 Desenice Datelov"
  },
  {
    "cast": "Davle",
    "psc": "25206",
    "okres": "Praha-západ",
    "obec": "Davle",
    "val": "25206 Davle Davle"
  },
  {
    "cast": "Deblín (část)",
    "psc": "66475",
    "okres": "Brno-venkov",
    "obec": "Deblín",
    "val": "66475 Deblin Deblin (cast)"
  },
  {
    "cast": "Deblín (část)",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Deblín",
    "val": "66601 Deblin Deblin (cast)"
  },
  {
    "cast": "Deblov",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Mladoňovice",
    "val": "53821 Mladonovice Deblov"
  },
  {
    "cast": "Děbolín",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Debolin"
  },
  {
    "cast": "Debrné",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Mostek",
    "val": "54371 Mostek Debrne"
  },
  {
    "cast": "Debrník",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Hlavatce",
    "val": "39201 Hlavatce Debrnik"
  },
  {
    "cast": "Debrník",
    "psc": "34004",
    "okres": "Klatovy",
    "obec": "Železná Ruda",
    "val": "34004 Zelezna Ruda Debrnik"
  },
  {
    "cast": "Debrno",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Dolany",
    "val": "27801 Dolany Debrno"
  },
  {
    "cast": "Debř",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Debr"
  },
  {
    "cast": "Debřece",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51703 Skuhrov nad Belou Debrece"
  },
  {
    "cast": "Děčany",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Děčany",
    "val": "41115 Decany Decany"
  },
  {
    "cast": "Děčín III-Staré Město",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin III-Stare Mesto"
  },
  {
    "cast": "Děčín II-Nové Město",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin II-Nove Mesto"
  },
  {
    "cast": "Děčín IV-Podmokly",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin IV-Podmokly"
  },
  {
    "cast": "Děčín IX-Bynov (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin IX-Bynov (cast)"
  },
  {
    "cast": "Děčín IX-Bynov (část)",
    "psc": "40505",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40505 Decin Decin IX-Bynov (cast)"
  },
  {
    "cast": "Děčín I-Děčín",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin I-Decin"
  },
  {
    "cast": "Děčín VIII-Dolní Oldřichov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin VIII-Dolni Oldrichov"
  },
  {
    "cast": "Děčín VII-Chrochvice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin VII-Chrochvice"
  },
  {
    "cast": "Děčín VI-Letná",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin VI-Letna"
  },
  {
    "cast": "Děčín V-Rozbělesy",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin V-Rozbelesy"
  },
  {
    "cast": "Děčín XIII-Loubí",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XIII-Loubi"
  },
  {
    "cast": "Děčín XII-Vilsnice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XII-Vilsnice"
  },
  {
    "cast": "Děčín XIV-Dolní Žleb",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XIV-Dolni Zleb"
  },
  {
    "cast": "Děčín XIX-Čechy",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XIX-Cechy"
  },
  {
    "cast": "Děčín XI-Horní Žleb",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XI-Horni Zleb"
  },
  {
    "cast": "Děčín XVIII-Maxičky",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XVIII-Maxicky"
  },
  {
    "cast": "Děčín XVII-Jalůvčí",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XVII-Jaluvci"
  },
  {
    "cast": "Děčín XVI-Přípeř",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XVI-Priper"
  },
  {
    "cast": "Děčín XV-Prostřední Žleb",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XV-Prostredni Zleb"
  },
  {
    "cast": "Děčín XXIII-Popovice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXIII-Popovice"
  },
  {
    "cast": "Děčín XXII-Václavov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXII-Vaclavov"
  },
  {
    "cast": "Děčín XXIV-Krásný Studenec",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXIV-Krasny Studenec"
  },
  {
    "cast": "Děčín XXIX-Hoštice nad Labem",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXIX-Hostice nad Labem"
  },
  {
    "cast": "Děčín XXI-Horní Oldřichov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXI-Horni Oldrichov"
  },
  {
    "cast": "Děčín XXVIII-Folknáře",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXVIII-Folknare"
  },
  {
    "cast": "Děčín XXVII-Březiny",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXVII-Breziny"
  },
  {
    "cast": "Děčín XXVI-Bechlejovice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXVI-Bechlejovice"
  },
  {
    "cast": "Děčín XXV-Chmelnice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXV-Chmelnice"
  },
  {
    "cast": "Děčín XXXIII-Nebočady (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXXIII-Nebocady (cast)"
  },
  {
    "cast": "Děčín XXXIII-Nebočady (část)",
    "psc": "40711",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40711 Decin Decin XXXIII-Nebocady (cast)"
  },
  {
    "cast": "Děčín XXXII-Boletice nad Labem",
    "psc": "40711",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40711 Decin Decin XXXII-Boletice nad Labem"
  },
  {
    "cast": "Děčín XXXIV-Chlum",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXXIV-Chlum"
  },
  {
    "cast": "Děčín XXXI-Křešice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXXI-Kresice"
  },
  {
    "cast": "Děčín XXXV-Lesná",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXXV-Lesna"
  },
  {
    "cast": "Děčín XXX-Velká Veleň",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XXX-Velka Velen"
  },
  {
    "cast": "Děčín XX-Nová Ves (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin XX-Nova Ves (cast)"
  },
  {
    "cast": "Děčín XX-Nová Ves (část)",
    "psc": "40505",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40505 Decin Decin XX-Nova Ves (cast)"
  },
  {
    "cast": "Děčín X-Bělá",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Decin X-Bela"
  },
  {
    "cast": "Dědek",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Živanice",
    "val": "53341 Zivanice Dedek"
  },
  {
    "cast": "Dědibaby",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Vojkovice",
    "val": "27745 Vojkovice Dedibaby"
  },
  {
    "cast": "Dědice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Dedice"
  },
  {
    "cast": "Dědice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nemyšl",
    "val": "39143 Nemysl Dedice"
  },
  {
    "cast": "Dědice",
    "psc": "67541",
    "okres": "Třebíč",
    "obec": "Dědice",
    "val": "67541 Dedice Dedice"
  },
  {
    "cast": "Dědice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Dobrovítov",
    "val": "28601 Dobrovitov Dedice"
  },
  {
    "cast": "Dědičky",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nemyšl",
    "val": "39143 Nemysl Dedicky"
  },
  {
    "cast": "Dědinka",
    "psc": "78383",
    "okres": "Olomouc",
    "obec": "Troubelice",
    "val": "78383 Troubelice Dedinka"
  },
  {
    "cast": "Dědkov",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Dedkov"
  },
  {
    "cast": "Dědkov",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Blízkov",
    "val": "59442 Blizkov Dedkov"
  },
  {
    "cast": "Dědov",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Dedov"
  },
  {
    "cast": "Dědová",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Dědová",
    "val": "53901 Dedova Dedova"
  },
  {
    "cast": "Dědovice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Ostrovec",
    "val": "39701 Ostrovec Dedovice"
  },
  {
    "cast": "Defurovy Lažany",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Chanovice",
    "val": "34101 Chanovice Defurovy Lazany"
  },
  {
    "cast": "Dehetná",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Dehetna"
  },
  {
    "cast": "Dehtáry",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Dehtary"
  },
  {
    "cast": "Dehtáry",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Cetenov",
    "val": "46348 Cetenov Dehtary"
  },
  {
    "cast": "Dehtáry",
    "psc": "25091",
    "okres": "Praha-východ",
    "obec": "Jenštejn",
    "val": "25091 Jenstejn Dehtary"
  },
  {
    "cast": "Dehtáře",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Dehtáře",
    "val": "39301 Dehtare Dehtare"
  },
  {
    "cast": "Dehtáře",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Žabovřesky",
    "val": "37341 Zabovresky Dehtare"
  },
  {
    "cast": "Dehtín",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Dehtin"
  },
  {
    "cast": "Děhylov",
    "psc": "74794",
    "okres": "Opava",
    "obec": "Děhylov",
    "val": "74794 Dehylov Dehylov"
  },
  {
    "cast": "Dejvice (část)",
    "psc": "16000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16000 Praha Dejvice (cast)"
  },
  {
    "cast": "Dejvice (část)",
    "psc": "16200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16200 Praha Dejvice (cast)"
  },
  {
    "cast": "Dejvice (část)",
    "psc": "16400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16400 Praha Dejvice (cast)"
  },
  {
    "cast": "Děkančice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Hořice",
    "val": "39601 Horice Dekancice"
  },
  {
    "cast": "Děkanovice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Děkanovice",
    "val": "25768 Dekanovice Dekanovice"
  },
  {
    "cast": "Děkanské Skaliny",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Dekanske Skaliny"
  },
  {
    "cast": "Děkov",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Děkov",
    "val": "27004 Dekov Dekov"
  },
  {
    "cast": "Děkovka",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Podsedice",
    "val": "41115 Podsedice Dekovka"
  },
  {
    "cast": "Denětice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Březno",
    "val": "43801 Brezno Denetice"
  },
  {
    "cast": "Děpoltice",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34022 Desenice Depoltice"
  },
  {
    "cast": "Děpoltovice",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Děpoltovice",
    "val": "36225 Depoltovice Depoltovice"
  },
  {
    "cast": "Derflice",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "67128 Znojmo Derflice"
  },
  {
    "cast": "Děrné",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Derne"
  },
  {
    "cast": "Desky",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Malonty",
    "val": "38241 Malonty Desky"
  },
  {
    "cast": "Desná",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Desná",
    "val": "57001 Desna Desna"
  },
  {
    "cast": "Desná I",
    "psc": "46861",
    "okres": "Jablonec nad Nisou",
    "obec": "Desná",
    "val": "46861 Desna Desna I"
  },
  {
    "cast": "Desná II (část)",
    "psc": "46841",
    "okres": "Jablonec nad Nisou",
    "obec": "Desná",
    "val": "46841 Desna Desna II (cast)"
  },
  {
    "cast": "Desná II (část)",
    "psc": "46861",
    "okres": "Jablonec nad Nisou",
    "obec": "Desná",
    "val": "46861 Desna Desna II (cast)"
  },
  {
    "cast": "Desná III",
    "psc": "46861",
    "okres": "Jablonec nad Nisou",
    "obec": "Desná",
    "val": "46861 Desna Desna III"
  },
  {
    "cast": "Dešenice",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34022 Desenice Desenice"
  },
  {
    "cast": "Dešná",
    "psc": "76315",
    "okres": "Zlín",
    "obec": "Dešná",
    "val": "76315 Desna Desna"
  },
  {
    "cast": "Dešná",
    "psc": "37873",
    "okres": "Jindřichův Hradec",
    "obec": "Dešná",
    "val": "37873 Desna Desna"
  },
  {
    "cast": "Dešov",
    "psc": "67533",
    "okres": "Třebíč",
    "obec": "Dešov",
    "val": "67533 Desov Desov"
  },
  {
    "cast": "Deštná",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Destna"
  },
  {
    "cast": "Deštná",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Deštná",
    "val": "67961 Destna Destna"
  },
  {
    "cast": "Deštná",
    "psc": "37825",
    "okres": "Jindřichův Hradec",
    "obec": "Deštná",
    "val": "37825 Destna Destna"
  },
  {
    "cast": "Deštné",
    "psc": "74755",
    "okres": "Opava",
    "obec": "Jakartovice",
    "val": "74755 Jakartovice Destne"
  },
  {
    "cast": "Deštné v Orlických horách",
    "psc": "51791",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Deštné v Orlických horách",
    "val": "51791 Destne v Orlickych horach Destne v Orlickych horach"
  },
  {
    "cast": "Deštnice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Deštnice",
    "val": "43801 Destnice Destnice"
  },
  {
    "cast": "Dětaň",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Nepomyšl",
    "val": "44101 Nepomysl Detan"
  },
  {
    "cast": "Dětenice",
    "psc": "50724",
    "okres": "Jičín",
    "obec": "Dětenice",
    "val": "50724 Detenice Detenice"
  },
  {
    "cast": "Dětkovice",
    "psc": "79804",
    "okres": "Prostějov",
    "obec": "Dětkovice",
    "val": "79804 Detkovice Detkovice"
  },
  {
    "cast": "Dětkovice",
    "psc": "68323",
    "okres": "Vyškov",
    "obec": "Dětkovice",
    "val": "68323 Detkovice Detkovice"
  },
  {
    "cast": "Dětkovice",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Ludmírov",
    "val": "79855 Ludmirov Detkovice"
  },
  {
    "cast": "Dětmarovice",
    "psc": "73571",
    "okres": "Karviná",
    "obec": "Dětmarovice",
    "val": "73571 Detmarovice Detmarovice"
  },
  {
    "cast": "Dětřichov",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Detrichov"
  },
  {
    "cast": "Dětřichov",
    "psc": "79001",
    "okres": "Jeseník",
    "obec": "Jeseník",
    "val": "79001 Jesenik Detrichov"
  },
  {
    "cast": "Dětřichov",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Dětřichov",
    "val": "56802 Detrichov Detrichov"
  },
  {
    "cast": "Dětřichov",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Dětřichov",
    "val": "46401 Detrichov Detrichov"
  },
  {
    "cast": "Dětřichov nad Bystřicí",
    "psc": "79303",
    "okres": "Bruntál",
    "obec": "Dětřichov nad Bystřicí",
    "val": "79303 Detrichov nad Bystrici Detrichov nad Bystrici"
  },
  {
    "cast": "Dětřichov u Moravské Třebové",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Dětřichov u Moravské Třebové",
    "val": "57101 Detrichov u Moravske Trebove Detrichov u Moravske Trebove"
  },
  {
    "cast": "Dětřichovec",
    "psc": "46365",
    "okres": "Liberec",
    "obec": "Jindřichovice pod Smrkem",
    "val": "46365 Jindrichovice pod Smrkem Detrichovec"
  },
  {
    "cast": "Dětřichovice",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Světlá Hora",
    "val": "79331 Svetla Hora Detrichovice"
  },
  {
    "cast": "Diana",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Rozvadov",
    "val": "34806 Rozvadov Diana"
  },
  {
    "cast": "Dílce",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Dílce",
    "val": "50601 Dilce Dilce"
  },
  {
    "cast": "Díly",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Díly",
    "val": "34401 Dily Dily"
  },
  {
    "cast": "Dírná",
    "psc": "39127",
    "okres": "Tábor",
    "obec": "Dírná",
    "val": "39127 Dirna Dirna"
  },
  {
    "cast": "Diváky",
    "psc": "69171",
    "okres": "Břeclav",
    "obec": "Diváky",
    "val": "69171 Divaky Divaky"
  },
  {
    "cast": "Dívčí Hrad",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Dívčí Hrad",
    "val": "79399 Divci Hrad Divci Hrad"
  },
  {
    "cast": "Dívčí Kopy",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Dívčí Kopy",
    "val": "37842 Divci Kopy Divci Kopy"
  },
  {
    "cast": "Dívčice",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dívčice",
    "val": "37348 Divcice Divcice"
  },
  {
    "cast": "Divec",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Divec",
    "val": "50003 Divec Divec"
  },
  {
    "cast": "Divice",
    "psc": "43915",
    "okres": "Louny",
    "obec": "Vinařice",
    "val": "43915 Vinarice Divice"
  },
  {
    "cast": "Divišov",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Divišov",
    "val": "25726 Divisov Divisov"
  },
  {
    "cast": "Divišov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Divisov"
  },
  {
    "cast": "Divišov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Divisov"
  },
  {
    "cast": "Divišovice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Divisovice"
  },
  {
    "cast": "Divišovice",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34021 Desenice Divisovice"
  },
  {
    "cast": "Divnice",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Slavičín",
    "val": "76321 Slavicin Divnice"
  },
  {
    "cast": "Divoky",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Zdounky",
    "val": "76802 Zdounky Divoky"
  },
  {
    "cast": "Dlažkovice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Dlažkovice",
    "val": "41115 Dlazkovice Dlazkovice"
  },
  {
    "cast": "Dlažov",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Dlažov",
    "val": "34021 Dlazov Dlazov"
  },
  {
    "cast": "Dlouhá",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Netřebice",
    "val": "38232 Netrebice Dlouha"
  },
  {
    "cast": "Dlouhá Brtnice",
    "psc": "58834",
    "okres": "Jihlava",
    "obec": "Dlouhá Brtnice",
    "val": "58834 Dlouha Brtnice Dlouha Brtnice"
  },
  {
    "cast": "Dlouhá Lhota",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dlouhá Lhota",
    "val": "39155 Dlouha Lhota Dlouha Lhota"
  },
  {
    "cast": "Dlouhá Lhota",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Dlouha Lhota"
  },
  {
    "cast": "Dlouhá Lhota",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Dlouhá Lhota",
    "val": "26301 Dlouha Lhota Dlouha Lhota"
  },
  {
    "cast": "Dlouhá Lhota",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Dlouhá Lhota",
    "val": "67971 Dlouha Lhota Dlouha Lhota"
  },
  {
    "cast": "Dlouhá Lhota",
    "psc": "29405",
    "okres": "Mladá Boleslav",
    "obec": "Dlouhá Lhota",
    "val": "29405 Dlouha Lhota Dlouha Lhota"
  },
  {
    "cast": "Dlouhá Lomnice",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Dlouha Lomnice"
  },
  {
    "cast": "Dlouhá Loučka",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Dlouhá Loučka",
    "val": "56943 Dlouha Loucka Dlouha Loucka"
  },
  {
    "cast": "Dlouhá Loučka",
    "psc": "78386",
    "okres": "Olomouc",
    "obec": "Dlouhá Loučka",
    "val": "78386 Dlouha Loucka Dlouha Loucka"
  },
  {
    "cast": "Dlouhá Louka",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Lužany",
    "val": "33401 Luzany Dlouha Louka"
  },
  {
    "cast": "Dlouhá Louka",
    "psc": "41705",
    "okres": "Teplice",
    "obec": "Osek",
    "val": "41705 Osek Dlouha Louka"
  },
  {
    "cast": "Dlouhá Louka",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lípa nad Orlicí",
    "val": "51721 Lipa nad Orlici Dlouha Louka"
  },
  {
    "cast": "Dlouhá Stráň",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Dlouhá Stráň",
    "val": "79201 Dlouha Stran Dlouha Stran"
  },
  {
    "cast": "Dlouhá Stropnice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Dlouha Stropnice"
  },
  {
    "cast": "Dlouhá Třebová",
    "psc": "56117",
    "okres": "Ústí nad Orlicí",
    "obec": "Dlouhá Třebová",
    "val": "56117 Dlouha Trebova Dlouha Trebova"
  },
  {
    "cast": "Dlouhá Ves",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Hynčina",
    "val": "78901 Hyncina Dlouha Ves"
  },
  {
    "cast": "Dlouhá Ves",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dlouhá Ves",
    "val": "34201 Dlouha Ves Dlouha Ves"
  },
  {
    "cast": "Dlouhá Ves",
    "psc": "79371",
    "okres": "Bruntál",
    "obec": "Holčovice",
    "val": "79371 Holcovice Dlouha Ves"
  },
  {
    "cast": "Dlouhá Ves",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Truskovice",
    "val": "38901 Truskovice Dlouha Ves"
  },
  {
    "cast": "Dlouhá Ves",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Dlouhá Ves",
    "val": "58222 Dlouha Ves Dlouha Ves"
  },
  {
    "cast": "Dlouhá Ves",
    "psc": "79827",
    "okres": "Prostějov",
    "obec": "Vrchoslavice",
    "val": "79827 Vrchoslavice Dlouha Ves"
  },
  {
    "cast": "Dlouhá Ves",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51601 Rychnov nad Kneznou Dlouha Ves"
  },
  {
    "cast": "Dlouhá Voda",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Dlouha Voda"
  },
  {
    "cast": "Dlouhé",
    "psc": "59255",
    "okres": "Žďár nad Sázavou",
    "obec": "Dlouhé",
    "val": "59255 Dlouhe Dlouhe"
  },
  {
    "cast": "Dlouhé",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nový Hrádek",
    "val": "54901 Novy Hradek Dlouhe"
  },
  {
    "cast": "Dlouhé Dvory",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Střezetice",
    "val": "50312 Strezetice Dlouhe Dvory"
  },
  {
    "cast": "Dlouhé Hradiště",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Konstantinovy Lázně",
    "val": "34952 Konstantinovy Lazne Dlouhe Hradiste"
  },
  {
    "cast": "Dlouhé Mosty",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Františkovy Lázně",
    "val": "35002 Frantiskovy Lazne Dlouhe Mosty"
  },
  {
    "cast": "Dlouhé Pole",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Dlouhe Pole"
  },
  {
    "cast": "Dlouhomilov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Dlouhomilov",
    "val": "78901 Dlouhomilov Dlouhomilov"
  },
  {
    "cast": "Dlouhoňovice",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Dlouhoňovice",
    "val": "56401 Dlouhonovice Dlouhonovice"
  },
  {
    "cast": "Dlouhopolsko",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Dlouhopolsko",
    "val": "28903 Dlouhopolsko Dlouhopolsko"
  },
  {
    "cast": "Dlouhý",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Záhoří",
    "val": "51301 Zahori Dlouhy"
  },
  {
    "cast": "Dlouhý",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58263 Slavikov Dlouhy"
  },
  {
    "cast": "Dlouhý Bor (část)",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Nová Pec",
    "val": "38451 Nova Pec Dlouhy Bor (cast)"
  },
  {
    "cast": "Dlouhý Bor (část)",
    "psc": "38462",
    "okres": "Prachatice",
    "obec": "Nová Pec",
    "val": "38462 Nova Pec Dlouhy Bor (cast)"
  },
  {
    "cast": "Dlouhý Důl",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40747 Krasna Lipa Dlouhy Dul"
  },
  {
    "cast": "Dlouhý Most",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Dlouhý Most",
    "val": "46312 Dlouhy Most Dlouhy Most"
  },
  {
    "cast": "Dlouhý Újezd",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Dlouhý Újezd",
    "val": "34701 Dlouhy Ujezd Dlouhy Ujezd"
  },
  {
    "cast": "Dluhonice-Přerov V x)",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Dluhonice-Prerov V x)"
  },
  {
    "cast": "Dluhoště",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Dluhoste"
  },
  {
    "cast": "Dmýštice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Milevsko",
    "val": "39901 Milevsko Dmystice"
  },
  {
    "cast": "Dneboh",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Dneboh"
  },
  {
    "cast": "Dnešice",
    "psc": "33443",
    "okres": "Plzeň-jih",
    "obec": "Dnešice",
    "val": "33443 Dnesice Dnesice"
  },
  {
    "cast": "Dobčice",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Záboří",
    "val": "37384 Zabori Dobcice"
  },
  {
    "cast": "Dobechov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Dobechov"
  },
  {
    "cast": "Dobelice",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Dobelice",
    "val": "67201 Dobelice Dobelice"
  },
  {
    "cast": "Dobeš",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Lukavec u Hořic",
    "val": "50801 Lukavec u Horic Dobes"
  },
  {
    "cast": "Dobešice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Kluky",
    "val": "39701 Kluky Dobesice"
  },
  {
    "cast": "Dobešov",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74235 Odry Dobesov"
  },
  {
    "cast": "Dobešov",
    "psc": "39494",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39494 Cernovice Dobesov"
  },
  {
    "cast": "Dobkov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Dobkov"
  },
  {
    "cast": "Dobkovice",
    "psc": "40703",
    "okres": "Děčín",
    "obec": "Dobkovice",
    "val": "40703 Dobkovice Dobkovice"
  },
  {
    "cast": "Dobkovičky",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41002 Velemin Dobkovicky"
  },
  {
    "cast": "Dobrá",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Stožec",
    "val": "38451 Stozec Dobra"
  },
  {
    "cast": "Dobrá",
    "psc": "73951",
    "okres": "Frýdek-Místek",
    "obec": "Dobrá",
    "val": "73951 Dobra Dobra"
  },
  {
    "cast": "Dobrá",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Přibyslav",
    "val": "58222 Pribyslav Dobra"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Mrákotín",
    "val": "58856 Mrakotin Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Březnice",
    "val": "26272 Breznice Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Dobrá Voda",
    "val": "39301 Dobra Voda Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Dobrá Voda",
    "val": "59451 Dobra Voda Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Číměř",
    "val": "37833 Cimer Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Jedlá",
    "val": "58401 Jedla Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Malčín",
    "val": "58291 Malcin Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Dobra Voda"
  },
  {
    "cast": "Dobrá Voda",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Dobra Voda"
  },
  {
    "cast": "Dobrá Voda Lipnická",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Město",
    "val": "58401 Dolni Mesto Dobra Voda Lipnicka"
  },
  {
    "cast": "Dobrá Voda u Českých Budějovic (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Dobrá Voda u Českých Budějovic",
    "val": "37006 Dobra Voda u Ceskych Budejovic Dobra Voda u Ceskych Budejovic (cast)"
  },
  {
    "cast": "Dobrá Voda u Českých Budějovic (část)",
    "psc": "37316",
    "okres": "České Budějovice",
    "obec": "Dobrá Voda u Českých Budějovic",
    "val": "37316 Dobra Voda u Ceskych Budejovic Dobra Voda u Ceskych Budejovic (cast)"
  },
  {
    "cast": "Dobrá Voda u Hořic",
    "psc": "50773",
    "okres": "Jičín",
    "obec": "Dobrá Voda u Hořic",
    "val": "50773 Dobra Voda u Horic Dobra Voda u Horic"
  },
  {
    "cast": "Dobrá Voda u Pacova",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Dobrá Voda u Pacova",
    "val": "39501 Dobra Voda u Pacova Dobra Voda u Pacova"
  },
  {
    "cast": "Dobranov",
    "psc": "47121",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47121 Ceska Lipa Dobranov"
  },
  {
    "cast": "Dobratice (část)",
    "psc": "73951",
    "okres": "Frýdek-Místek",
    "obec": "Dobratice",
    "val": "73951 Dobratice Dobratice (cast)"
  },
  {
    "cast": "Dobratice (část)",
    "psc": "73953",
    "okres": "Frýdek-Místek",
    "obec": "Dobratice",
    "val": "73953 Dobratice Dobratice (cast)"
  },
  {
    "cast": "Dobrčice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Skršín",
    "val": "43401 Skrsin Dobrcice"
  },
  {
    "cast": "Dobrčice",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Dobrčice",
    "val": "75002 Dobrcice Dobrcice"
  },
  {
    "cast": "Dobré Pole",
    "psc": "69181",
    "okres": "Břeclav",
    "obec": "Dobré Pole",
    "val": "69181 Dobre Pole Dobre Pole"
  },
  {
    "cast": "Dobré Pole",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Vitice",
    "val": "28163 Vitice Dobre Pole"
  },
  {
    "cast": "Dobré (část)",
    "psc": "51793",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobré",
    "val": "51793 Dobre Dobre (cast)"
  },
  {
    "cast": "Dobré (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobré",
    "val": "51801 Dobre Dobre (cast)"
  },
  {
    "cast": "Dobrkov",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Dobrkov"
  },
  {
    "cast": "Dobrkovice",
    "psc": "76307",
    "okres": "Zlín",
    "obec": "Dobrkovice",
    "val": "76307 Dobrkovice Dobrkovice"
  },
  {
    "cast": "Dobrkovská Lhotka",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Slavče",
    "val": "37401 Slavce Dobrkovska Lhotka"
  },
  {
    "cast": "Dobrná",
    "psc": "40741",
    "okres": "Děčín",
    "obec": "Dobrná",
    "val": "40741 Dobrna Dobrna"
  },
  {
    "cast": "Dobrné",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38101 Vetrni Dobrne"
  },
  {
    "cast": "Dobrnice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Leština u Světlé",
    "val": "58401 Lestina u Svetle Dobrnice"
  },
  {
    "cast": "Dobročkov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38301 Ktis Dobrockov"
  },
  {
    "cast": "Dobročkovice",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Dobročkovice",
    "val": "68333 Dobrockovice Dobrockovice"
  },
  {
    "cast": "Dobročovice",
    "psc": "25082",
    "okres": "Praha-východ",
    "obec": "Dobročovice",
    "val": "25082 Dobrocovice Dobrocovice"
  },
  {
    "cast": "Dobrohostov",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Lípa",
    "val": "58253 Lipa Dobrohostov"
  },
  {
    "cast": "Dobrohošť",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26401 Kosova Hora Dobrohost"
  },
  {
    "cast": "Dobrohošť",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dobrohošť",
    "val": "38001 Dobrohost Dobrohost"
  },
  {
    "cast": "Dobrochov",
    "psc": "79807",
    "okres": "Prostějov",
    "obec": "Dobrochov",
    "val": "79807 Dobrochov Dobrochov"
  },
  {
    "cast": "Dobroměřice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Dobroměřice",
    "val": "44001 Dobromerice Dobromerice"
  },
  {
    "cast": "Dobromilice",
    "psc": "79825",
    "okres": "Prostějov",
    "obec": "Dobromilice",
    "val": "79825 Dobromilice Dobromilice"
  },
  {
    "cast": "Dobronice",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Tavíkovice",
    "val": "67140 Tavikovice Dobronice"
  },
  {
    "cast": "Dobronice u Bechyně",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Dobronice u Bechyně",
    "val": "39165 Dobronice u Bechyne Dobronice u Bechyne"
  },
  {
    "cast": "Dobronice u Chýnova",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Chýnov",
    "val": "39155 Chynov Dobronice u Chynova"
  },
  {
    "cast": "Dobronín (část)",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Dobronín",
    "val": "58813 Dobronin Dobronin (cast)"
  },
  {
    "cast": "Dobronín (část)",
    "psc": "58812",
    "okres": "Jihlava",
    "obec": "Dobronín",
    "val": "58812 Dobronin Dobronin (cast)"
  },
  {
    "cast": "Dobroslavice",
    "psc": "74794",
    "okres": "Opava",
    "obec": "Dobroslavice",
    "val": "74794 Dobroslavice Dobroslavice"
  },
  {
    "cast": "Dobroše",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Odrava",
    "val": "35002 Odrava Dobrose"
  },
  {
    "cast": "Dobrošov",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Dobrosov"
  },
  {
    "cast": "Dobrošov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Hrazany",
    "val": "39901 Hrazany Dobrosov"
  },
  {
    "cast": "Dobrošovice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Dobrosovice"
  },
  {
    "cast": "Dobrotice",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Holešov",
    "val": "76901 Holesov Dobrotice"
  },
  {
    "cast": "Dobrotice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Chanovice",
    "val": "34101 Chanovice Dobrotice"
  },
  {
    "cast": "Dobrotín",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Město pod Landštejnem",
    "val": "37881 Stare Mesto pod Landstejnem Dobrotin"
  },
  {
    "cast": "Dobroutov",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Dobroutov",
    "val": "58813 Dobroutov Dobroutov"
  },
  {
    "cast": "Dobrovice",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Dobrovice",
    "val": "29441 Dobrovice Dobrovice"
  },
  {
    "cast": "Dobrovítov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Dobrovítov",
    "val": "28601 Dobrovitov Dobrovitov"
  },
  {
    "cast": "Dobrovítova Lhota",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Trpišovice",
    "val": "58401 Trpisovice Dobrovitova Lhota"
  },
  {
    "cast": "Dobrovíz",
    "psc": "25261",
    "okres": "Praha-západ",
    "obec": "Dobrovíz",
    "val": "25261 Dobroviz Dobroviz"
  },
  {
    "cast": "Dobrš",
    "psc": "38473",
    "okres": "Strakonice",
    "obec": "Drážov",
    "val": "38473 Drazov Dobrs"
  },
  {
    "cast": "Dobršín",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dobršín",
    "val": "34201 Dobrsin Dobrsin"
  },
  {
    "cast": "Dobruška",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobruška",
    "val": "51801 Dobruska Dobruska"
  },
  {
    "cast": "Dobřany",
    "psc": "33441",
    "okres": "Plzeň-jih",
    "obec": "Dobřany",
    "val": "33441 Dobrany Dobrany"
  },
  {
    "cast": "Dobřany",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobřany",
    "val": "51801 Dobrany Dobrany"
  },
  {
    "cast": "Dobřečov",
    "psc": "79344",
    "okres": "Bruntál",
    "obec": "Horní Město",
    "val": "79344 Horni Mesto Dobrecov"
  },
  {
    "cast": "Dobřejice",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Dobrejice"
  },
  {
    "cast": "Dobřejovice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Dobřejovice",
    "val": "25101 Dobrejovice Dobrejovice"
  },
  {
    "cast": "Dobřejovice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hosín",
    "val": "37341 Hosin Dobrejovice"
  },
  {
    "cast": "Dobřemilice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "34142 Cachrov Dobremilice"
  },
  {
    "cast": "Dobřemilice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Vlksice",
    "val": "39901 Vlksice Dobremilice"
  },
  {
    "cast": "Dobřeň",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Dobřeň",
    "val": "27721 Dobren Dobren"
  },
  {
    "cast": "Dobřeň",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Suchdol",
    "val": "28401 Suchdol Dobren"
  },
  {
    "cast": "Dobřenec",
    "psc": "44101",
    "okres": "Chomutov",
    "obec": "Mašťov",
    "val": "44101 Mastov Dobrenec"
  },
  {
    "cast": "Dobřenice",
    "psc": "50325",
    "okres": "Hradec Králové",
    "obec": "Dobřenice",
    "val": "50325 Dobrenice Dobrenice"
  },
  {
    "cast": "Dobříč",
    "psc": "33005",
    "okres": "Plzeň-sever",
    "obec": "Dobříč",
    "val": "33005 Dobric Dobric"
  },
  {
    "cast": "Dobříč",
    "psc": "25225",
    "okres": "Praha-západ",
    "obec": "Dobříč",
    "val": "25225 Dobric Dobric"
  },
  {
    "cast": "Dobříčany",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Liběšice",
    "val": "43801 Libesice Dobricany"
  },
  {
    "cast": "Dobříčkov",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Dobrickov"
  },
  {
    "cast": "Dobřichov",
    "psc": "28911",
    "okres": "Kolín",
    "obec": "Dobřichov",
    "val": "28911 Dobrichov Dobrichov"
  },
  {
    "cast": "Dobřichovice",
    "psc": "25229",
    "okres": "Praha-západ",
    "obec": "Dobřichovice",
    "val": "25229 Dobrichovice Dobrichovice"
  },
  {
    "cast": "Dobříkov",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Dobrikov"
  },
  {
    "cast": "Dobříkov",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Dobříkov",
    "val": "56601 Dobrikov Dobrikov"
  },
  {
    "cast": "Dobříkovec",
    "psc": "51773",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Opočno",
    "val": "51773 Opocno Dobrikovec"
  },
  {
    "cast": "Dobříkovice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Dobrikovice"
  },
  {
    "cast": "Dobříň",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Dobříň",
    "val": "41301 Dobrin Dobrin"
  },
  {
    "cast": "Dobřínsko",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Dobřínsko",
    "val": "67201 Dobrinsko Dobrinsko"
  },
  {
    "cast": "Dobříš (část)",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Dobříš",
    "val": "26301 Dobris Dobris (cast)"
  },
  {
    "cast": "Dobříš (část)",
    "psc": "26202",
    "okres": "Příbram",
    "obec": "Dobříš",
    "val": "26202 Dobris Dobris (cast)"
  },
  {
    "cast": "Dobřív",
    "psc": "33844",
    "okres": "Rokycany",
    "obec": "Dobřív",
    "val": "33844 Dobriv Dobriv"
  },
  {
    "cast": "Dobšice",
    "psc": "28905",
    "okres": "Nymburk",
    "obec": "Dobšice",
    "val": "28905 Dobsice Dobsice"
  },
  {
    "cast": "Dobšice",
    "psc": "67182",
    "okres": "Znojmo",
    "obec": "Dobšice",
    "val": "67182 Dobsice Dobsice"
  },
  {
    "cast": "Dobšice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50601 Libosovice Dobsice"
  },
  {
    "cast": "Dobšice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Bezdědovice",
    "val": "38801 Bezdedovice Dobsice"
  },
  {
    "cast": "Dobšice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Dobšice",
    "val": "37501 Dobsice Dobsice"
  },
  {
    "cast": "Dobšín",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dobšín",
    "val": "29404 Dobsin Dobsin"
  },
  {
    "cast": "Dohalice",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Osvračín",
    "val": "34561 Osvracin Dohalice"
  },
  {
    "cast": "Dohalice",
    "psc": "50313",
    "okres": "Hradec Králové",
    "obec": "Dohalice",
    "val": "50313 Dohalice Dohalice"
  },
  {
    "cast": "Dohnalova Lhota",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26401 Kosova Hora Dohnalova Lhota"
  },
  {
    "cast": "Dojetřice",
    "psc": "28506",
    "okres": "Benešov",
    "obec": "Sázava",
    "val": "28506 Sazava Dojetrice"
  },
  {
    "cast": "Doksany",
    "psc": "41182",
    "okres": "Litoměřice",
    "obec": "Doksany",
    "val": "41182 Doksany Doksany"
  },
  {
    "cast": "Doksy",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Doksy",
    "val": "47201 Doksy Doksy"
  },
  {
    "cast": "Doksy (část)",
    "psc": "27362",
    "okres": "Kladno",
    "obec": "Doksy",
    "val": "27362 Doksy Doksy (cast)"
  },
  {
    "cast": "Doksy (část)",
    "psc": "27364",
    "okres": "Kladno",
    "obec": "Doksy",
    "val": "27364 Doksy Doksy (cast)"
  },
  {
    "cast": "Dolánky",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Cetenov",
    "val": "46352 Cetenov Dolanky"
  },
  {
    "cast": "Dolánky",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Ohníč",
    "val": "41501 Ohnic Dolanky"
  },
  {
    "cast": "Dolánky",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Dolanky"
  },
  {
    "cast": "Dolánky",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Dřevěnice",
    "val": "50713 Drevenice Dolanky"
  },
  {
    "cast": "Dolánky",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Zlončice",
    "val": "27801 Zloncice Dolanky"
  },
  {
    "cast": "Dolánky",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bítouchov",
    "val": "29401 Bitouchov Dolanky"
  },
  {
    "cast": "Dolánky",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Březno",
    "val": "29406 Brezno Dolanky"
  },
  {
    "cast": "Dolánky nad Ohří",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Dolánky nad Ohří",
    "val": "41301 Dolanky nad Ohri Dolanky nad Ohri"
  },
  {
    "cast": "Dolánky u Turnova",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Dolanky u Turnova"
  },
  {
    "cast": "Dolany",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Dolany",
    "val": "27351 Dolany Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Čkyně",
    "val": "38481 Ckyne Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičíněves",
    "val": "50601 Jicineves Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Červené Pečky",
    "val": "28002 Cervene Pecky Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Dolany",
    "val": "33011 Dolany Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Dolany",
    "val": "55203 Dolany Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Hluboká",
    "val": "53944 Hluboka Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "78316",
    "okres": "Olomouc",
    "obec": "Dolany",
    "val": "78316 Dolany Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Dolany",
    "val": "27801 Dolany Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Dolany",
    "val": "53345 Dolany Dolany"
  },
  {
    "cast": "Dolany",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Mladkov",
    "val": "56164 Mladkov Dolany"
  },
  {
    "cast": "Dolce",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Dolce",
    "val": "33401 Dolce Dolce"
  },
  {
    "cast": "Dolce",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Dolce"
  },
  {
    "cast": "Doleček",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Hlavice",
    "val": "46348 Hlavice Dolecek"
  },
  {
    "cast": "Dolejší Hůrky",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Dolejsi Hurky"
  },
  {
    "cast": "Dolejší Krušec",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Dolejsi Krusec"
  },
  {
    "cast": "Dolejší Kunčice",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Dolejsi Kuncice"
  },
  {
    "cast": "Dolejší Předměstí",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Domažlice",
    "val": "34401 Domazlice Dolejsi Predmesti"
  },
  {
    "cast": "Dolejší Těšov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Dolejsi Tesov"
  },
  {
    "cast": "Dolení Paseky",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Světlá pod Ještědem",
    "val": "46343 Svetla pod Jestedem Doleni Paseky"
  },
  {
    "cast": "Dolenice",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Dolenice",
    "val": "67178 Dolenice Dolenice"
  },
  {
    "cast": "Dolín",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Dolin"
  },
  {
    "cast": "Dolina",
    "psc": "35708",
    "okres": "Sokolov",
    "obec": "Krajková",
    "val": "35708 Krajkova Dolina"
  },
  {
    "cast": "Dolina",
    "psc": "40780",
    "okres": "Děčín",
    "obec": "Vilémov",
    "val": "40780 Vilemov Dolina"
  },
  {
    "cast": "Dolínek",
    "psc": "25070",
    "okres": "Praha-východ",
    "obec": "Odolena Voda",
    "val": "25070 Odolena Voda Dolinek"
  },
  {
    "cast": "Dolívka",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Předhradí",
    "val": "53973 Predhradi Dolivka"
  },
  {
    "cast": "Dolní Adršpach",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Adršpach",
    "val": "54957 Adrspach Dolni Adrspach"
  },
  {
    "cast": "Dolní Albeřice",
    "psc": "54226",
    "okres": "Trutnov",
    "obec": "Horní Maršov",
    "val": "54226 Horni Marsov Dolni Alberice"
  },
  {
    "cast": "Dolní Babákov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Včelákov",
    "val": "53901 Vcelakov Dolni Babakov"
  },
  {
    "cast": "Dolní Bečva (část)",
    "psc": "75655",
    "okres": "Vsetín",
    "obec": "Dolní Bečva",
    "val": "75655 Dolni Becva Dolni Becva (cast)"
  },
  {
    "cast": "Dolní Bečva (část)",
    "psc": "75661",
    "okres": "Vsetín",
    "obec": "Dolní Bečva",
    "val": "75661 Dolni Becva Dolni Becva (cast)"
  },
  {
    "cast": "Dolní Bělá",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Dolní Bělá",
    "val": "33152 Dolni Bela Dolni Bela"
  },
  {
    "cast": "Dolní Benešov",
    "psc": "74722",
    "okres": "Opava",
    "obec": "Dolní Benešov",
    "val": "74722 Dolni Benesov Dolni Benesov"
  },
  {
    "cast": "Dolní Beřkovice",
    "psc": "27701",
    "okres": "Mělník",
    "obec": "Dolní Beřkovice",
    "val": "27701 Dolni Berkovice Dolni Berkovice"
  },
  {
    "cast": "Dolní Bezděkov",
    "psc": "27362",
    "okres": "Kladno",
    "obec": "Bratronice",
    "val": "27362 Bratronice Dolni Bezdekov"
  },
  {
    "cast": "Dolní Bezděkov",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Dolní Bezděkov",
    "val": "53862 Dolni Bezdekov Dolni Bezdekov"
  },
  {
    "cast": "Dolní Bojanovice (část)",
    "psc": "69616",
    "okres": "Hodonín",
    "obec": "Dolní Bojanovice",
    "val": "69616 Dolni Bojanovice Dolni Bojanovice (cast)"
  },
  {
    "cast": "Dolní Bojanovice (část)",
    "psc": "69617",
    "okres": "Hodonín",
    "obec": "Dolní Bojanovice",
    "val": "69617 Dolni Bojanovice Dolni Bojanovice (cast)"
  },
  {
    "cast": "Dolní Bolíkov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Cizkrajov",
    "val": "37881 Cizkrajov Dolni Bolikov"
  },
  {
    "cast": "Dolní Borek",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Dolni Borek"
  },
  {
    "cast": "Dolní Bory",
    "psc": "59461",
    "okres": "Žďár nad Sázavou",
    "obec": "Bory",
    "val": "59461 Bory Dolni Bory"
  },
  {
    "cast": "Dolní Boříkovice",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Dolni Borikovice"
  },
  {
    "cast": "Dolní Bousov",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Bousov",
    "val": "29404 Dolni Bousov Dolni Bousov"
  },
  {
    "cast": "Dolní Bradlo",
    "psc": "53953",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53953 Horni Bradlo Dolni Bradlo"
  },
  {
    "cast": "Dolní Branná",
    "psc": "54362",
    "okres": "Trutnov",
    "obec": "Dolní Branná",
    "val": "54362 Dolni Branna Dolni Branna"
  },
  {
    "cast": "Dolní Brusnice",
    "psc": "54472",
    "okres": "Trutnov",
    "obec": "Dolní Brusnice",
    "val": "54472 Dolni Brusnice Dolni Brusnice"
  },
  {
    "cast": "Dolní Březinka",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Dolni Brezinka"
  },
  {
    "cast": "Dolní Břežany (část)",
    "psc": "25241",
    "okres": "Praha-západ",
    "obec": "Dolní Břežany",
    "val": "25241 Dolni Brezany Dolni Brezany (cast)"
  },
  {
    "cast": "Dolní Břežany (část)",
    "psc": "25245",
    "okres": "Praha-západ",
    "obec": "Dolní Břežany",
    "val": "25245 Dolni Brezany Dolni Brezany (cast)"
  },
  {
    "cast": "Dolní Bučice",
    "psc": "28571",
    "okres": "Kutná Hora",
    "obec": "Vrdy",
    "val": "28571 Vrdy Dolni Bucice"
  },
  {
    "cast": "Dolní Bukovina",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Horní Bukovina",
    "val": "29501 Horni Bukovina Dolni Bukovina"
  },
  {
    "cast": "Dolní Bukovsko",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Dolní Bukovsko",
    "val": "37365 Dolni Bukovsko Dolni Bukovsko"
  },
  {
    "cast": "Dolní Bušínov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Zábřeh",
    "val": "78901 Zabreh Dolni Businov"
  },
  {
    "cast": "Dolní Cerekev (část)",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Dolní Cerekev",
    "val": "58851 Dolni Cerekev Dolni Cerekev (cast)"
  },
  {
    "cast": "Dolní Cerekev (část)",
    "psc": "58845",
    "okres": "Jihlava",
    "obec": "Dolní Cerekev",
    "val": "58845 Dolni Cerekev Dolni Cerekev (cast)"
  },
  {
    "cast": "Dolní Cetno",
    "psc": "29430",
    "okres": "Mladá Boleslav",
    "obec": "Niměřice",
    "val": "29430 Nimerice Dolni Cetno"
  },
  {
    "cast": "Dolní Čepí",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Ujčov",
    "val": "59262 Ujcov Dolni Cepi"
  },
  {
    "cast": "Dolní Čermná (část)",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Čermná",
    "val": "56301 Dolni Cermna Dolni Cermna (cast)"
  },
  {
    "cast": "Dolní Čermná (část)",
    "psc": "56153",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Čermná",
    "val": "56153 Dolni Cermna Dolni Cermna (cast)"
  },
  {
    "cast": "Dolní Černá Studnice",
    "psc": "46821",
    "okres": "Jablonec nad Nisou",
    "obec": "Pěnčín",
    "val": "46821 Pencin Dolni Cerna Studnice"
  },
  {
    "cast": "Dolní Černilov",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Výrava",
    "val": "50303 Vyrava Dolni Cernilov"
  },
  {
    "cast": "Dolní Černůtky",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Jeřice",
    "val": "50801 Jerice Dolni Cernutky"
  },
  {
    "cast": "Dolní Datyně",
    "psc": "73601",
    "okres": "Karviná",
    "obec": "Havířov",
    "val": "73601 Havirov Dolni Datyne"
  },
  {
    "cast": "Dolní Dehtov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Třebihošť",
    "val": "54401 Trebihost Dolni Dehtov"
  },
  {
    "cast": "Dolní Dlužiny",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Dolni Dluziny"
  },
  {
    "cast": "Dolní Dobrouč",
    "psc": "56102",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Dobrouč",
    "val": "56102 Dolni Dobrouc Dolni Dobrouc"
  },
  {
    "cast": "Dolní Dobřejov",
    "psc": "25791",
    "okres": "Benešov",
    "obec": "Střezimíř",
    "val": "25791 Strezimir Dolni Dobrejov"
  },
  {
    "cast": "Dolní Dolce",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Dolni Dolce"
  },
  {
    "cast": "Dolní Domaslavice",
    "psc": "73938",
    "okres": "Frýdek-Místek",
    "obec": "Dolní Domaslavice",
    "val": "73938 Dolni Domaslavice Dolni Domaslavice"
  },
  {
    "cast": "Dolní Drkolná",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Vyšší Brod",
    "val": "38273 Vyssi Brod Dolni Drkolna"
  },
  {
    "cast": "Dolní Dubňany",
    "psc": "67173",
    "okres": "Znojmo",
    "obec": "Dolní Dubňany",
    "val": "67173 Dolni Dubnany Dolni Dubnany"
  },
  {
    "cast": "Dolní Dubová Hora",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Tuhaň",
    "val": "47201 Tuhan Dolni Dubova Hora"
  },
  {
    "cast": "Dolní Dunajovice",
    "psc": "69185",
    "okres": "Břeclav",
    "obec": "Dolní Dunajovice",
    "val": "69185 Dolni Dunajovice Dolni Dunajovice"
  },
  {
    "cast": "Dolní Dušnice",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Dolni Dusnice"
  },
  {
    "cast": "Dolní Dvorce",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Dyjice",
    "val": "58862 Dyjice Dolni Dvorce"
  },
  {
    "cast": "Dolní Dvorce",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Dolni Dvorce"
  },
  {
    "cast": "Dolní Dvory",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Dolni Dvory"
  },
  {
    "cast": "Dolní Dvořiště",
    "psc": "38272",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38272 Dolni Dvoriste Dolni Dvoriste"
  },
  {
    "cast": "Dolní Dvůr (část)",
    "psc": "54344",
    "okres": "Trutnov",
    "obec": "Dolní Dvůr",
    "val": "54344 Dolni Dvur Dolni Dvur (cast)"
  },
  {
    "cast": "Dolní Dvůr (část)",
    "psc": "54342",
    "okres": "Trutnov",
    "obec": "Dolní Dvůr",
    "val": "54342 Dolni Dvur Dolni Dvur (cast)"
  },
  {
    "cast": "Dolní Falknov",
    "psc": "40745",
    "okres": "Děčín",
    "obec": "Kytlice",
    "val": "40745 Kytlice Dolni Falknov"
  },
  {
    "cast": "Dolní Folmava",
    "psc": "34532",
    "okres": "Domažlice",
    "obec": "Česká Kubice",
    "val": "34532 Ceska Kubice Dolni Folmava"
  },
  {
    "cast": "Dolní Fořt",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Uhelná",
    "val": "79070 Uhelna Dolni Fort"
  },
  {
    "cast": "Dolní Habartice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Dolní Habartice",
    "val": "40502 Dolni Habartice Dolni Habartice"
  },
  {
    "cast": "Dolní Hanychov-Liberec VIII x)",
    "psc": "46008",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46008 Liberec Dolni Hanychov-Liberec VIII x)"
  },
  {
    "cast": "Dolní Hbity",
    "psc": "26262",
    "okres": "Příbram",
    "obec": "Dolní Hbity",
    "val": "26262 Dolni Hbity Dolni Hbity"
  },
  {
    "cast": "Dolní Hedeč",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Dolni Hedec"
  },
  {
    "cast": "Dolní Heršpice (část)",
    "psc": "61700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61700 Brno Dolni Herspice (cast)"
  },
  {
    "cast": "Dolní Heršpice (část)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Dolni Herspice (cast)"
  },
  {
    "cast": "Dolní Heřmanice",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Horní Heřmanice",
    "val": "56301 Horni Hermanice Dolni Hermanice"
  },
  {
    "cast": "Dolní Heřmanice",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Dolní Heřmanice",
    "val": "59401 Dolni Hermanice Dolni Hermanice"
  },
  {
    "cast": "Dolní Hlíny",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Horní Libochová",
    "val": "59451 Horni Libochova Dolni Hliny"
  },
  {
    "cast": "Dolní Holetín",
    "psc": "53971",
    "okres": "Chrudim",
    "obec": "Holetín",
    "val": "53971 Holetin Dolni Holetin"
  },
  {
    "cast": "Dolní Hořice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Dolni Horice"
  },
  {
    "cast": "Dolní Houžovec",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56201 Usti nad Orlici Dolni Houzovec"
  },
  {
    "cast": "Dolní Hradiště",
    "psc": "33151",
    "okres": "Plzeň-sever",
    "obec": "Dolní Hradiště",
    "val": "33151 Dolni Hradiste Dolni Hradiste"
  },
  {
    "cast": "Dolní Hrachovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Dolní Hrachovice",
    "val": "39143 Dolni Hrachovice Dolni Hrachovice"
  },
  {
    "cast": "Dolní Chabry",
    "psc": "18400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18400 Praha Dolni Chabry"
  },
  {
    "cast": "Dolní Chobolice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41145 Libesice Dolni Chobolice"
  },
  {
    "cast": "Dolní Chrastava",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Chrastava",
    "val": "46331 Chrastava Dolni Chrastava"
  },
  {
    "cast": "Dolní Chrášťany",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38411 Lhenice Dolni Chrastany"
  },
  {
    "cast": "Dolní Chřibská",
    "psc": "40744",
    "okres": "Děčín",
    "obec": "Chřibská",
    "val": "40744 Chribska Dolni Chribska"
  },
  {
    "cast": "Dolní Chvatliny",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Dolní Chvatliny",
    "val": "28144 Dolni Chvatliny Dolni Chvatliny"
  },
  {
    "cast": "Dolní Jablonná",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Přibyslav",
    "val": "58222 Pribyslav Dolni Jablonna"
  },
  {
    "cast": "Dolní Jadruž",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Chodský Újezd",
    "val": "34815 Chodsky Ujezd Dolni Jadruz"
  },
  {
    "cast": "Dolní Jamné",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Dolni Jamne"
  },
  {
    "cast": "Dolní Javoří",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Dolni Javori"
  },
  {
    "cast": "Dolní Jelení (část)",
    "psc": "53374",
    "okres": "Pardubice",
    "obec": "Horní Jelení",
    "val": "53374 Horni Jeleni Dolni Jeleni (cast)"
  },
  {
    "cast": "Dolní Jelení (část)",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Horní Jelení",
    "val": "53401 Horni Jeleni Dolni Jeleni (cast)"
  },
  {
    "cast": "Dolní Jílovice",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Vyšší Brod",
    "val": "38273 Vyssi Brod Dolni Jilovice"
  },
  {
    "cast": "Dolní Jirčany",
    "psc": "25244",
    "okres": "Praha-západ",
    "obec": "Psáry",
    "val": "25244 Psary Dolni Jircany"
  },
  {
    "cast": "Dolní Jiřetín",
    "psc": "43401",
    "okres": "Most",
    "obec": "Horní Jiřetín",
    "val": "43401 Horni Jiretin Dolni Jiretin"
  },
  {
    "cast": "Dolní Kalná (část)",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Dolní Kalná",
    "val": "54371 Dolni Kalna Dolni Kalna (cast)"
  },
  {
    "cast": "Dolní Kalná (část)",
    "psc": "54374",
    "okres": "Trutnov",
    "obec": "Dolní Kalná",
    "val": "54374 Dolni Kalna Dolni Kalna (cast)"
  },
  {
    "cast": "Dolní Kamenice",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Chržín",
    "val": "27324 Chrzin Dolni Kamenice"
  },
  {
    "cast": "Dolní Kamenice",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Holýšov",
    "val": "34562 Holysov Dolni Kamenice"
  },
  {
    "cast": "Dolní Kamenice",
    "psc": "40721",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40721 Ceska Kamenice Dolni Kamenice"
  },
  {
    "cast": "Dolní Kněžeklady",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Horní Kněžeklady",
    "val": "37501 Horni Knezeklady Dolni Knezeklady"
  },
  {
    "cast": "Dolní Kochánov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Dolni Kochanov"
  },
  {
    "cast": "Dolní Kounice",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Dolní Kounice",
    "val": "66464 Dolni Kounice Dolni Kounice"
  },
  {
    "cast": "Dolní Kouty",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Dolni Kouty"
  },
  {
    "cast": "Dolní Kožlí",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Vlachovo Březí",
    "val": "38301 Vlachovo Brezi Dolni Kozli"
  },
  {
    "cast": "Dolní Kralovice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Dolní Kralovice",
    "val": "25768 Dolni Kralovice Dolni Kralovice"
  },
  {
    "cast": "Dolní Kramolín",
    "psc": "34813",
    "okres": "Tachov",
    "obec": "Chodová Planá",
    "val": "34813 Chodova Plana Dolni Kramolin"
  },
  {
    "cast": "Dolní Krupá",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Krupá",
    "val": "29501 Dolni Krupa Dolni Krupa"
  },
  {
    "cast": "Dolní Krupá (část)",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Krupá",
    "val": "58001 Dolni Krupa Dolni Krupa (cast)"
  },
  {
    "cast": "Dolní Krupá (část)",
    "psc": "58271",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Krupá",
    "val": "58271 Dolni Krupa Dolni Krupa (cast)"
  },
  {
    "cast": "Dolní Kruty",
    "psc": "28146",
    "okres": "Kolín",
    "obec": "Horní Kruty",
    "val": "28146 Horni Kruty Dolni Kruty"
  },
  {
    "cast": "Dolní Lánov",
    "psc": "54341",
    "okres": "Trutnov",
    "obec": "Dolní Lánov",
    "val": "54341 Dolni Lanov Dolni Lanov"
  },
  {
    "cast": "Dolní Lažany",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Dolni Lazany"
  },
  {
    "cast": "Dolní Lažany",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Dolní Lažany",
    "val": "67551 Dolni Lazany Dolni Lazany"
  },
  {
    "cast": "Dolní Les",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Vlčice",
    "val": "79065 Vlcice Dolni Les"
  },
  {
    "cast": "Dolní Lhota",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Dolni Lhota"
  },
  {
    "cast": "Dolní Lhota",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Svojanov",
    "val": "56992 Svojanov Dolni Lhota"
  },
  {
    "cast": "Dolní Lhota",
    "psc": "74766",
    "okres": "Ostrava-město",
    "obec": "Dolní Lhota",
    "val": "74766 Dolni Lhota Dolni Lhota"
  },
  {
    "cast": "Dolní Lhota",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Dolni Lhota"
  },
  {
    "cast": "Dolní Lhota",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Stráž nad Nežárkou",
    "val": "37802 Straz nad Nezarkou Dolni Lhota"
  },
  {
    "cast": "Dolní Lhota (část)",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Dolni Lhota (cast)"
  },
  {
    "cast": "Dolní Lhota (část)",
    "psc": "76326",
    "okres": "Zlín",
    "obec": "Dolní Lhota",
    "val": "76326 Dolni Lhota Dolni Lhota (cast)"
  },
  {
    "cast": "Dolní Lhota (část)",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67902 Blansko Dolni Lhota (cast)"
  },
  {
    "cast": "Dolní Lhota (část)",
    "psc": "76323",
    "okres": "Zlín",
    "obec": "Dolní Lhota",
    "val": "76323 Dolni Lhota Dolni Lhota (cast)"
  },
  {
    "cast": "Dolní Lhotka",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Maleč",
    "val": "58301 Malec Dolni Lhotka"
  },
  {
    "cast": "Dolní Libchava",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Dolni Libchava"
  },
  {
    "cast": "Dolní Libchavy",
    "psc": "56116",
    "okres": "Ústí nad Orlicí",
    "obec": "Libchavy",
    "val": "56116 Libchavy Dolni Libchavy"
  },
  {
    "cast": "Dolní Libina",
    "psc": "78805",
    "okres": "Šumperk",
    "obec": "Libina",
    "val": "78805 Libina Dolni Libina"
  },
  {
    "cast": "Dolní Libochová",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Dolní Libochová",
    "val": "59253 Dolni Libochova Dolni Libochova"
  },
  {
    "cast": "Dolní Lipina",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Dolni Lipina"
  },
  {
    "cast": "Dolní Lipka",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Dolni Lipka"
  },
  {
    "cast": "Dolní Líšnice",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Solenice",
    "val": "26263 Solenice Dolni Lisnice"
  },
  {
    "cast": "Dolní Líštná",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Dolni Listna"
  },
  {
    "cast": "Dolní Litvínov",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Dolni Litvinov"
  },
  {
    "cast": "Dolní Lochov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Dolní Lochov",
    "val": "50601 Dolni Lochov Dolni Lochov"
  },
  {
    "cast": "Dolní Lomany",
    "psc": "35101",
    "okres": "Cheb",
    "obec": "Františkovy Lázně",
    "val": "35101 Frantiskovy Lazne Dolni Lomany"
  },
  {
    "cast": "Dolní Lomná",
    "psc": "73991",
    "okres": "Frýdek-Místek",
    "obec": "Dolní Lomná",
    "val": "73991 Dolni Lomna Dolni Lomna"
  },
  {
    "cast": "Dolní Lomnice",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Kunice",
    "val": "25169 Kunice Dolni Lomnice"
  },
  {
    "cast": "Dolní Lomnice",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Doupovské Hradiště",
    "val": "36272 Doupovske Hradiste Dolni Lomnice"
  },
  {
    "cast": "Dolní Loučky",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Dolní Loučky",
    "val": "59455 Dolni Loucky Dolni Loucky"
  },
  {
    "cast": "Dolní Luby",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Luby",
    "val": "35134 Luby Dolni Luby"
  },
  {
    "cast": "Dolní Lukavice",
    "psc": "33444",
    "okres": "Plzeň-jih",
    "obec": "Dolní Lukavice",
    "val": "33444 Dolni Lukavice Dolni Lukavice"
  },
  {
    "cast": "Dolní Lutyně (část)",
    "psc": "73531",
    "okres": "Karviná",
    "obec": "Dolní Lutyně",
    "val": "73531 Dolni Lutyne Dolni Lutyne (cast)"
  },
  {
    "cast": "Dolní Lutyně (část)",
    "psc": "73553",
    "okres": "Karviná",
    "obec": "Dolní Lutyně",
    "val": "73553 Dolni Lutyne Dolni Lutyne (cast)"
  },
  {
    "cast": "Dolní Lysečiny",
    "psc": "54226",
    "okres": "Trutnov",
    "obec": "Horní Maršov",
    "val": "54226 Horni Marsov Dolni Lyseciny"
  },
  {
    "cast": "Dolní Malá Úpa (část)",
    "psc": "54221",
    "okres": "Trutnov",
    "obec": "Malá Úpa",
    "val": "54221 Mala Upa Dolni Mala Upa (cast)"
  },
  {
    "cast": "Dolní Malá Úpa (část)",
    "psc": "54227",
    "okres": "Trutnov",
    "obec": "Malá Úpa",
    "val": "54227 Mala Upa Dolni Mala Upa (cast)"
  },
  {
    "cast": "Dolní Marklovice",
    "psc": "73572",
    "okres": "Karviná",
    "obec": "Petrovice u Karviné",
    "val": "73572 Petrovice u Karvine Dolni Marklovice"
  },
  {
    "cast": "Dolní Maxov",
    "psc": "46844",
    "okres": "Jablonec nad Nisou",
    "obec": "Josefův Důl",
    "val": "46844 Josefuv Dul Dolni Maxov"
  },
  {
    "cast": "Dolní Měcholupy (část)",
    "psc": "10200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10200 Praha Dolni Mecholupy (cast)"
  },
  {
    "cast": "Dolní Měcholupy (část)",
    "psc": "10700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10700 Praha Dolni Mecholupy (cast)"
  },
  {
    "cast": "Dolní Měcholupy (část)",
    "psc": "10900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10900 Praha Dolni Mecholupy (cast)"
  },
  {
    "cast": "Dolní Město",
    "psc": "58233",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Město",
    "val": "58233 Dolni Mesto Dolni Mesto"
  },
  {
    "cast": "Dolní Metelsko",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Dolni Metelsko"
  },
  {
    "cast": "Dolní Mezihoří",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Holovousy",
    "val": "50781 Holovousy Dolni Mezihori"
  },
  {
    "cast": "Dolní Miletín",
    "psc": "37373",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37373 Lisov Dolni Miletin"
  },
  {
    "cast": "Dolní Morava",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Morava",
    "val": "56169 Dolni Morava Dolni Morava"
  },
  {
    "cast": "Dolní Moravice",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Dolní Moravice",
    "val": "79501 Dolni Moravice Dolni Moravice"
  },
  {
    "cast": "Dolní Nakvasovice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Bušanovice",
    "val": "38422 Busanovice Dolni Nakvasovice"
  },
  {
    "cast": "Dolní Němčí",
    "psc": "68762",
    "okres": "Uherské Hradiště",
    "obec": "Dolní Němčí",
    "val": "68762 Dolni Nemci Dolni Nemci"
  },
  {
    "cast": "Dolní Němčice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Dolni Nemcice"
  },
  {
    "cast": "Dolní Nemojov",
    "psc": "54461",
    "okres": "Trutnov",
    "obec": "Nemojov",
    "val": "54461 Nemojov Dolni Nemojov"
  },
  {
    "cast": "Dolní Nerestce",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Nerestce",
    "val": "39804 Nerestce Dolni Nerestce"
  },
  {
    "cast": "Dolní Nětčice",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Dolní Nětčice",
    "val": "75354 Dolni Netcice Dolni Netcice"
  },
  {
    "cast": "Dolní Nezly",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41201 Libesice Dolni Nezly"
  },
  {
    "cast": "Dolní Nivy",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Dolní Nivy",
    "val": "35601 Dolni Nivy Dolni Nivy"
  },
  {
    "cast": "Dolní Nová Ves",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Dolni Nova Ves"
  },
  {
    "cast": "Dolní Novosedly",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dolní Novosedly",
    "val": "39701 Dolni Novosedly Dolni Novosedly"
  },
  {
    "cast": "Dolní Oldřichov-Děčín VIII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Dolni Oldrichov-Decin VIII x)"
  },
  {
    "cast": "Dolní Oldřiš",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Bulovka",
    "val": "46401 Bulovka Dolni Oldris"
  },
  {
    "cast": "Dolní Olešnice (část)",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Dolní Olešnice",
    "val": "54371 Dolni Olesnice Dolni Olesnice (cast)"
  },
  {
    "cast": "Dolní Olešnice (část)",
    "psc": "54375",
    "okres": "Trutnov",
    "obec": "Dolní Olešnice",
    "val": "54375 Dolni Olesnice Dolni Olesnice (cast)"
  },
  {
    "cast": "Dolní Orlice",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56169 Cervena Voda Dolni Orlice"
  },
  {
    "cast": "Dolní Ostrovec",
    "psc": "39833",
    "okres": "Písek",
    "obec": "Ostrovec",
    "val": "39833 Ostrovec Dolni Ostrovec"
  },
  {
    "cast": "Dolní Paseka",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kamenná Lhota",
    "val": "58401 Kamenna Lhota Dolni Paseka"
  },
  {
    "cast": "Dolní Paseky",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As Dolni Paseky"
  },
  {
    "cast": "Dolní Pěna",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Dolní Pěna",
    "val": "37701 Dolni Pena Dolni Pena"
  },
  {
    "cast": "Dolní Pertoltice",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Pertoltice",
    "val": "46373 Pertoltice Dolni Pertoltice"
  },
  {
    "cast": "Dolní Pláně",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Věžovatá Pláně",
    "val": "38232 Vezovata Plane Dolni Plane"
  },
  {
    "cast": "Dolní Ples t. Vodní Ples",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Rasošky",
    "val": "55101 Rasosky Dolni Ples t. Vodni Ples"
  },
  {
    "cast": "Dolní Plezom",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Ošelín",
    "val": "34802 Oselin Dolni Plezom"
  },
  {
    "cast": "Dolní Počernice",
    "psc": "19012",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19012 Praha Dolni Pocernice"
  },
  {
    "cast": "Dolní Podhájí",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Dolni Podhaji"
  },
  {
    "cast": "Dolní Podluží",
    "psc": "40755",
    "okres": "Děčín",
    "obec": "Dolní Podluží",
    "val": "40755 Dolni Podluzi Dolni Podluzi"
  },
  {
    "cast": "Dolní Pohleď",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Dolní Pohleď",
    "val": "28522 Dolni Pohled Dolni Pohled"
  },
  {
    "cast": "Dolní Pochlovice",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kynšperk nad Ohří",
    "val": "35751 Kynsperk nad Ohri Dolni Pochlovice"
  },
  {
    "cast": "Dolní Police (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Žandov",
    "val": "47002 Zandov Dolni Police (cast)"
  },
  {
    "cast": "Dolní Police (část)",
    "psc": "47107",
    "okres": "Česká Lípa",
    "obec": "Žandov",
    "val": "47107 Zandov Dolni Police (cast)"
  },
  {
    "cast": "Dolní Polžice",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Dolni Polzice"
  },
  {
    "cast": "Dolní Poříčí",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Křetín",
    "val": "67962 Kretin Dolni Porici"
  },
  {
    "cast": "Dolní Poříčí",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Horní Poříčí",
    "val": "38601 Horni Porici Dolni Porici"
  },
  {
    "cast": "Dolní Poustevna",
    "psc": "40782",
    "okres": "Děčín",
    "obec": "Dolní Poustevna",
    "val": "40782 Dolni Poustevna Dolni Poustevna"
  },
  {
    "cast": "Dolní Povelice",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Bohušov",
    "val": "79399 Bohusov Dolni Povelice"
  },
  {
    "cast": "Dolní Požáry",
    "psc": "25742",
    "okres": "Benešov",
    "obec": "Krhanice",
    "val": "25742 Krhanice Dolni Pozary"
  },
  {
    "cast": "Dolní Prosíčka",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Prosíčka",
    "val": "58401 Prosicka Dolni Prosicka"
  },
  {
    "cast": "Dolní Prysk",
    "psc": "47115",
    "okres": "Česká Lípa",
    "obec": "Prysk",
    "val": "47115 Prysk Dolni Prysk"
  },
  {
    "cast": "Dolní Předměstí",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Polička",
    "val": "57201 Policka Dolni Predmesti"
  },
  {
    "cast": "Dolní Předměstí (část)",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Dolni Predmesti (cast)"
  },
  {
    "cast": "Dolní Předměstí (část)",
    "psc": "54103",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54103 Trutnov Dolni Predmesti (cast)"
  },
  {
    "cast": "Dolní Přím",
    "psc": "50316",
    "okres": "Hradec Králové",
    "obec": "Dolní Přím",
    "val": "50316 Dolni Prim Dolni Prim"
  },
  {
    "cast": "Dolní Radechová",
    "psc": "54911",
    "okres": "Náchod",
    "obec": "Dolní Radechová",
    "val": "54911 Dolni Radechova Dolni Radechova"
  },
  {
    "cast": "Dolní Radouň",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Dolni Radoun"
  },
  {
    "cast": "Dolní Radslavice",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Meziříčí",
    "val": "59401 Velke Mezirici Dolni Radslavice"
  },
  {
    "cast": "Dolní Rápotice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Šetějovice",
    "val": "25768 Setejovice Dolni Rapotice"
  },
  {
    "cast": "Dolní Raškovice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Svinčany",
    "val": "53501 Svincany Dolni Raskovice"
  },
  {
    "cast": "Dolní Roblín",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Mořina",
    "val": "26718 Morina Dolni Roblin"
  },
  {
    "cast": "Dolní Rokytá",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Rokytá",
    "val": "29501 Rokyta Dolni Rokyta"
  },
  {
    "cast": "Dolní Rokytňany",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Rokytňany",
    "val": "50723 Rokytnany Dolni Rokytnany"
  },
  {
    "cast": "Dolní Rokytnice",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Dolni Rokytnice"
  },
  {
    "cast": "Dolní Roveň",
    "psc": "53371",
    "okres": "Pardubice",
    "obec": "Dolní Roveň",
    "val": "53371 Dolni Roven Dolni Roven"
  },
  {
    "cast": "Dolní Rozsíčka",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Blažkov",
    "val": "59251 Blazkov Dolni Rozsicka"
  },
  {
    "cast": "Dolní Rožínka",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Dolní Rožínka",
    "val": "59251 Dolni Rozinka Dolni Rozinka"
  },
  {
    "cast": "Dolní Rychnov",
    "psc": "35604",
    "okres": "Sokolov",
    "obec": "Dolní Rychnov",
    "val": "35604 Dolni Rychnov Dolni Rychnov"
  },
  {
    "cast": "Dolní Řasnice",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Dolní Řasnice",
    "val": "46401 Dolni Rasnice Dolni Rasnice"
  },
  {
    "cast": "Dolní Ředice",
    "psc": "53375",
    "okres": "Pardubice",
    "obec": "Dolní Ředice",
    "val": "53375 Dolni Redice Dolni Redice"
  },
  {
    "cast": "Dolní Řepčice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41145 Libesice Dolni Repcice"
  },
  {
    "cast": "Dolní Sedlo",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Dolni Sedlo"
  },
  {
    "cast": "Dolní Sekyřany",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Heřmanova Huť",
    "val": "33023 Hermanova Hut Dolni Sekyrany"
  },
  {
    "cast": "Dolní Sklenov",
    "psc": "73946",
    "okres": "Frýdek-Místek",
    "obec": "Hukvaldy",
    "val": "73946 Hukvaldy Dolni Sklenov"
  },
  {
    "cast": "Dolní Skrýchov",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Dolni Skrychov"
  },
  {
    "cast": "Dolní Slivno",
    "psc": "29478",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Slivno",
    "val": "29478 Dolni Slivno Dolni Slivno"
  },
  {
    "cast": "Dolní Sloupnice",
    "psc": "56553",
    "okres": "Svitavy",
    "obec": "Sloupnice",
    "val": "56553 Sloupnice Dolni Sloupnice"
  },
  {
    "cast": "Dolní Slověnice",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Dolni Slovenice"
  },
  {
    "cast": "Dolní Smrčné",
    "psc": "58832",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58832 Brtnice Dolni Smrcne"
  },
  {
    "cast": "Dolní Smržov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Dolni Smrzov"
  },
  {
    "cast": "Dolní Sokolovec",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Sokolovec",
    "val": "58301 Dolni Sokolovec Dolni Sokolovec"
  },
  {
    "cast": "Dolní Stakory",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Stakory",
    "val": "29301 Dolni Stakory Dolni Stakory"
  },
  {
    "cast": "Dolní Staňkov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Dolni Stankov"
  },
  {
    "cast": "Dolní Staré Buky",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Staré Buky",
    "val": "54101 Stare Buky Dolni Stare Buky"
  },
  {
    "cast": "Dolní Staré Město (část)",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Dolni Stare Mesto (cast)"
  },
  {
    "cast": "Dolní Staré Město (část)",
    "psc": "54102",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54102 Trutnov Dolni Stare Mesto (cast)"
  },
  {
    "cast": "Dolní Stropnice (část)",
    "psc": "37324",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37324 Rimov Dolni Stropnice (cast)"
  },
  {
    "cast": "Dolní Stropnice (část)",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37401 Rimov Dolni Stropnice (cast)"
  },
  {
    "cast": "Dolní Studénky",
    "psc": "78820",
    "okres": "Šumperk",
    "obec": "Dolní Studénky",
    "val": "78820 Dolni Studenky Dolni Studenky"
  },
  {
    "cast": "Dolní Suchá",
    "psc": "73564",
    "okres": "Karviná",
    "obec": "Havířov",
    "val": "73564 Havirov Dolni Sucha"
  },
  {
    "cast": "Dolní Suchá",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Dolni Sucha"
  },
  {
    "cast": "Dolní Sukolom",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Dolni Sukolom"
  },
  {
    "cast": "Dolní Světlá",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Pojbuky",
    "val": "39143 Pojbuky Dolni Svetla"
  },
  {
    "cast": "Dolní Světlá",
    "psc": "47157",
    "okres": "Česká Lípa",
    "obec": "Mařenice",
    "val": "47157 Marenice Dolni Svetla"
  },
  {
    "cast": "Dolní Svince",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Dolní Třebonín",
    "val": "38232 Dolni Trebonin Dolni Svince"
  },
  {
    "cast": "Dolní Sytová",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Háje nad Jizerou",
    "val": "51301 Haje nad Jizerou Dolni Sytova"
  },
  {
    "cast": "Dolní Šebířov",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Lovečkovice",
    "val": "41145 Loveckovice Dolni Sebirov"
  },
  {
    "cast": "Dolní Štěpanice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Benecko",
    "val": "51401 Benecko Dolni Stepanice"
  },
  {
    "cast": "Dolní Teplice",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Dolni Teplice"
  },
  {
    "cast": "Dolní Těrlicko",
    "psc": "73542",
    "okres": "Karviná",
    "obec": "Těrlicko",
    "val": "73542 Terlicko Dolni Terlicko"
  },
  {
    "cast": "Dolní Těšice",
    "psc": "75353",
    "okres": "Přerov",
    "obec": "Dolní Těšice",
    "val": "75353 Dolni Tesice Dolni Tesice"
  },
  {
    "cast": "Dolní Tošanovice",
    "psc": "73953",
    "okres": "Frýdek-Místek",
    "obec": "Dolní Tošanovice",
    "val": "73953 Dolni Tosanovice Dolni Tosanovice"
  },
  {
    "cast": "Dolní Třebonín",
    "psc": "38201",
    "okres": "Český Krumlov",
    "obec": "Dolní Třebonín",
    "val": "38201 Dolni Trebonin Dolni Trebonin"
  },
  {
    "cast": "Dolní Třešňovec",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Lanškroun",
    "val": "56301 Lanskroun Dolni Tresnovec"
  },
  {
    "cast": "Dolní Tříč (část)",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51301 Jablonec nad Jizerou Dolni Tric (cast)"
  },
  {
    "cast": "Dolní Tříč (část)",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Dolni Tric (cast)"
  },
  {
    "cast": "Dolní Týnec",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Třebušín",
    "val": "41201 Trebusin Dolni Tynec"
  },
  {
    "cast": "Dolní Údolí",
    "psc": "79376",
    "okres": "Jeseník",
    "obec": "Zlaté Hory",
    "val": "79376 Zlate Hory Dolni Udoli"
  },
  {
    "cast": "Dolní Újezd",
    "psc": "75123",
    "okres": "Přerov",
    "obec": "Dolní Újezd",
    "val": "75123 Dolni Ujezd Dolni Ujezd"
  },
  {
    "cast": "Dolní Újezd",
    "psc": "56961",
    "okres": "Svitavy",
    "obec": "Dolní Újezd",
    "val": "56961 Dolni Ujezd Dolni Ujezd"
  },
  {
    "cast": "Dolní Václavov",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Václavov u Bruntálu",
    "val": "79201 Vaclavov u Bruntalu Dolni Vaclavov"
  },
  {
    "cast": "Dolní Valov",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bražec",
    "val": "36471 Brazec Dolni Valov"
  },
  {
    "cast": "Dolní Ves",
    "psc": "76316",
    "okres": "Zlín",
    "obec": "Fryšták",
    "val": "76316 Frystak Dolni Ves"
  },
  {
    "cast": "Dolní Vesce",
    "psc": "37324",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37324 Rimov Dolni Vesce"
  },
  {
    "cast": "Dolní Vestec",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58301 Slavikov Dolni Vestec"
  },
  {
    "cast": "Dolní Věstonice",
    "psc": "69129",
    "okres": "Břeclav",
    "obec": "Dolní Věstonice",
    "val": "69129 Dolni Vestonice Dolni Vestonice"
  },
  {
    "cast": "Dolní Vilémovice",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Dolní Vilémovice",
    "val": "67552 Dolni Vilemovice Dolni Vilemovice"
  },
  {
    "cast": "Dolní Vilímeč",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Dolní Vilímeč",
    "val": "58856 Dolni Vilimec Dolni Vilimec"
  },
  {
    "cast": "Dolní Vinice",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Kly",
    "val": "27741 Kly Dolni Vinice"
  },
  {
    "cast": "Dolní Vítkov",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Chrastava",
    "val": "46331 Chrastava Dolni Vitkov"
  },
  {
    "cast": "Dolní Vlčkovice",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vlčkovice v Podkrkonoší",
    "val": "54401 Vlckovice v Podkrkonosi Dolni Vlckovice"
  },
  {
    "cast": "Dolní Vlence",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Liteň",
    "val": "26727 Liten Dolni Vlence"
  },
  {
    "cast": "Dolní Vlkýš",
    "psc": "31800",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31800 Plzen Dolni Vlkys"
  },
  {
    "cast": "Dolní Vltavice",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Černá v Pošumaví",
    "val": "38226 Cerna v Posumavi Dolni Vltavice"
  },
  {
    "cast": "Dolní Vysoké",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Dolni Vysoke"
  },
  {
    "cast": "Dolní Výšina",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Obora",
    "val": "34701 Obora Dolni Vysina"
  },
  {
    "cast": "Dolní Záhoří",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Dolni Zahori"
  },
  {
    "cast": "Dolní Záhoří",
    "psc": "39818",
    "okres": "Písek",
    "obec": "Záhoří",
    "val": "39818 Zahori Dolni Zahori"
  },
  {
    "cast": "Dolní Zálezly",
    "psc": "40301",
    "okres": "Ústí nad Labem",
    "obec": "Dolní Zálezly",
    "val": "40301 Dolni Zalezly Dolni Zalezly"
  },
  {
    "cast": "Dolní Zimoř",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Dolní Zimoř",
    "val": "27721 Dolni Zimor Dolni Zimor"
  },
  {
    "cast": "Dolní Žandov",
    "psc": "35493",
    "okres": "Cheb",
    "obec": "Dolní Žandov",
    "val": "35493 Dolni Zandov Dolni Zandov"
  },
  {
    "cast": "Dolní Žďár",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Dolni Zdar"
  },
  {
    "cast": "Dolní Žďár",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Dolní Žďár",
    "val": "37802 Dolni Zdar Dolni Zdar"
  },
  {
    "cast": "Dolní Životice",
    "psc": "74756",
    "okres": "Opava",
    "obec": "Dolní Životice",
    "val": "74756 Dolni Zivotice Dolni Zivotice"
  },
  {
    "cast": "Dolní Žleb-Děčín XIV x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Dolni Zleb-Decin XIV x)"
  },
  {
    "cast": "Dolní Žukov",
    "psc": "73701",
    "okres": "Karviná",
    "obec": "Český Těšín",
    "val": "73701 Cesky Tesin Dolni Zukov"
  },
  {
    "cast": "Doloplazy",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Doloplazy"
  },
  {
    "cast": "Doloplazy",
    "psc": "78356",
    "okres": "Olomouc",
    "obec": "Doloplazy",
    "val": "78356 Doloplazy Doloplazy"
  },
  {
    "cast": "Doloplazy",
    "psc": "79826",
    "okres": "Prostějov",
    "obec": "Doloplazy",
    "val": "79826 Doloplazy Doloplazy"
  },
  {
    "cast": "Dolsko",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nahořany",
    "val": "54901 Nahorany Dolsko"
  },
  {
    "cast": "Doly",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Doly"
  },
  {
    "cast": "Doly",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Doly"
  },
  {
    "cast": "Doly",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34801 Bor Doly"
  },
  {
    "cast": "Doly",
    "psc": "73506",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73506 Karvina Doly"
  },
  {
    "cast": "Domahoř",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zruč nad Sázavou",
    "val": "28522 Zruc nad Sazavou Domahor"
  },
  {
    "cast": "Domamil",
    "psc": "67543",
    "okres": "Třebíč",
    "obec": "Domamil",
    "val": "67543 Domamil Domamil"
  },
  {
    "cast": "Domamyslice",
    "psc": "79604",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79604 Prostejov Domamyslice"
  },
  {
    "cast": "Domamyšl",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Vodice",
    "val": "39155 Vodice Domamysl"
  },
  {
    "cast": "Domanice",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Domanice"
  },
  {
    "cast": "Domanice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Radomyšl",
    "val": "38601 Radomysl Domanice"
  },
  {
    "cast": "Domanín",
    "psc": "69683",
    "okres": "Hodonín",
    "obec": "Domanín",
    "val": "69683 Domanin Domanin"
  },
  {
    "cast": "Domanín",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Domanín",
    "val": "37901 Domanin Domanin"
  },
  {
    "cast": "Domanín",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Domanin"
  },
  {
    "cast": "Domanínek",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Domaninek"
  },
  {
    "cast": "Dománovice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Dománovice",
    "val": "28002 Domanovice Domanovice"
  },
  {
    "cast": "Domaslav",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Lestkov",
    "val": "34953 Lestkov Domaslav"
  },
  {
    "cast": "Domaslavice",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Domaslavice"
  },
  {
    "cast": "Domaslavice",
    "psc": "41722",
    "okres": "Teplice",
    "obec": "Háj u Duchcova",
    "val": "41722 Haj u Duchcova Domaslavice"
  },
  {
    "cast": "Domaslavice",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Proseč pod Ještědem",
    "val": "46343 Prosec pod Jestedem Domaslavice"
  },
  {
    "cast": "Domašice",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Tuhaň",
    "val": "47201 Tuhan Domasice"
  },
  {
    "cast": "Domašín",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vlašim",
    "val": "25801 Vlasim Domasin"
  },
  {
    "cast": "Domašín",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Štědrá",
    "val": "36452 Stedra Domasin"
  },
  {
    "cast": "Domašín",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Domasin"
  },
  {
    "cast": "Domašín",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Domašín",
    "val": "43151 Domasin Domasin"
  },
  {
    "cast": "Domašín",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobruška",
    "val": "51801 Dobruska Domasin"
  },
  {
    "cast": "Domašín",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Černíkovice",
    "val": "51601 Cernikovice Domasin"
  },
  {
    "cast": "Domašov",
    "psc": "66483",
    "okres": "Brno-venkov",
    "obec": "Domašov",
    "val": "66483 Domasov Domasov"
  },
  {
    "cast": "Domašov",
    "psc": "79001",
    "okres": "Jeseník",
    "obec": "Bělá pod Pradědem",
    "val": "79001 Bela pod Pradedem Domasov"
  },
  {
    "cast": "Domašov nad Bystřicí",
    "psc": "78306",
    "okres": "Olomouc",
    "obec": "Domašov nad Bystřicí",
    "val": "78306 Domasov nad Bystrici Domasov nad Bystrici"
  },
  {
    "cast": "Domašov u Šternberka",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Domašov u Šternberka",
    "val": "78501 Domasov u Sternberka Domasov u Sternberka"
  },
  {
    "cast": "Domaželice",
    "psc": "75115",
    "okres": "Přerov",
    "obec": "Domaželice",
    "val": "75115 Domazelice Domazelice"
  },
  {
    "cast": "Domažličky",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bolešiny",
    "val": "33901 Bolesiny Domazlicky"
  },
  {
    "cast": "Domina",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Domina"
  },
  {
    "cast": "Dominikální Paseky",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Bratkovice",
    "val": "26223 Bratkovice Dominikalni Paseky"
  },
  {
    "cast": "Domoradice",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Domoradice"
  },
  {
    "cast": "Domoradice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Domoradice"
  },
  {
    "cast": "Domoradovice",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Hradec nad Moravicí",
    "val": "74741 Hradec nad Moravici Domoradovice"
  },
  {
    "cast": "Domoraz",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Domoraz",
    "val": "34201 Domoraz Domoraz"
  },
  {
    "cast": "Domoslavice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Ostroměř",
    "val": "50801 Ostromer Domoslavice"
  },
  {
    "cast": "Domousnice",
    "psc": "29448",
    "okres": "Mladá Boleslav",
    "obec": "Domousnice",
    "val": "29448 Domousnice Domousnice"
  },
  {
    "cast": "Domoušice (část)",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Domoušice",
    "val": "44001 Domousice Domousice (cast)"
  },
  {
    "cast": "Domoušice (část)",
    "psc": "43968",
    "okres": "Louny",
    "obec": "Domoušice",
    "val": "43968 Domousice Domousice (cast)"
  },
  {
    "cast": "Donín",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Toužetín",
    "val": "44001 Touzetin Donin"
  },
  {
    "cast": "Donín",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Donin"
  },
  {
    "cast": "Doňov",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Doňov",
    "val": "37821 Donov Donov"
  },
  {
    "cast": "Doubek",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Doubek",
    "val": "25101 Doubek Doubek"
  },
  {
    "cast": "Doubí",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Doubi"
  },
  {
    "cast": "Doubí",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Košice",
    "val": "39002 Kosice Doubi"
  },
  {
    "cast": "Doubí",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Čtveřín",
    "val": "46345 Ctverin Doubi"
  },
  {
    "cast": "Doubí",
    "psc": "36007",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36007 Karlovy Vary Doubi"
  },
  {
    "cast": "Doubice",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Doubice",
    "val": "40747 Doubice Doubice"
  },
  {
    "cast": "Doubí-Liberec XXIII x)",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46312 Liberec Doubi-Liberec XXIII x)"
  },
  {
    "cast": "Doublovičky",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Doublovicky"
  },
  {
    "cast": "Doubrava",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Nýřany",
    "val": "33023 Nyrany Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Puclice",
    "val": "34561 Puclice Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "73533",
    "okres": "Karviná",
    "obec": "Doubrava",
    "val": "73533 Doubrava Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Hořice",
    "val": "50801 Horice Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "28921",
    "okres": "Nymburk",
    "obec": "Kostomlátky",
    "val": "28921 Kostomlatky Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Vlachovo Březí",
    "val": "38422 Vlachovo Brezi Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Chrášťany",
    "val": "37501 Chrastany Doubrava"
  },
  {
    "cast": "Doubrava",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Žďár",
    "val": "29411 Zdar Doubrava"
  },
  {
    "cast": "Doubravany",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Košík",
    "val": "28934 Kosik Doubravany"
  },
  {
    "cast": "Doubrava-Karlov x)",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Vidice",
    "val": "28401 Vidice Doubrava-Karlov x)"
  },
  {
    "cast": "Doubravčany",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Zásmuky",
    "val": "28144 Zasmuky Doubravcany"
  },
  {
    "cast": "Doubravčice",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Doubravčice",
    "val": "28201 Doubravcice Doubravcice"
  },
  {
    "cast": "Doubravice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Železnice",
    "val": "50713 Zeleznice Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51101 Hruba Skala Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "78982",
    "okres": "Šumperk",
    "obec": "Moravičany",
    "val": "78982 Moravicany Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Katusice",
    "val": "29426 Katusice Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "53353",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53353 Pardubice Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nahořany",
    "val": "54901 Nahorany Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Doubravice"
  },
  {
    "cast": "Doubravice",
    "psc": "54451",
    "okres": "Trutnov",
    "obec": "Doubravice",
    "val": "54451 Doubravice Doubravice"
  },
  {
    "cast": "Doubravice nad Svitavou",
    "psc": "67911",
    "okres": "Blansko",
    "obec": "Doubravice nad Svitavou",
    "val": "67911 Doubravice nad Svitavou Doubravice nad Svitavou"
  },
  {
    "cast": "Doubravice u České Skalice",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Rychnovek",
    "val": "55203 Rychnovek Doubravice u Ceske Skalice"
  },
  {
    "cast": "Doubravice u Volyně (část)",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38701 Cestice Doubravice u Volyne (cast)"
  },
  {
    "cast": "Doubravice u Volyně (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38601 Cestice Doubravice u Volyne (cast)"
  },
  {
    "cast": "Doubravice 1.díl",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Přestavlky u Čerčan",
    "val": "25722 Prestavlky u Cercan Doubravice 1.dil"
  },
  {
    "cast": "Doubravice 2.díl",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25722 Vranov Doubravice 2.dil"
  },
  {
    "cast": "Doubravice (část)",
    "psc": "53854",
    "okres": "Ústí nad Orlicí",
    "obec": "Leština",
    "val": "53854 Lestina Doubravice (cast)"
  },
  {
    "cast": "Doubravice (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Doubravice",
    "val": "38601 Doubravice Doubravice (cast)"
  },
  {
    "cast": "Doubravice (část)",
    "psc": "53944",
    "okres": "Ústí nad Orlicí",
    "obec": "Leština",
    "val": "53944 Lestina Doubravice (cast)"
  },
  {
    "cast": "Doubravice (část)",
    "psc": "38735",
    "okres": "Strakonice",
    "obec": "Doubravice",
    "val": "38735 Doubravice Doubravice (cast)"
  },
  {
    "cast": "Doubravice (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Doubravice",
    "val": "37006 Doubravice Doubravice (cast)"
  },
  {
    "cast": "Doubravice (část)",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Doubravice",
    "val": "37007 Doubravice Doubravice (cast)"
  },
  {
    "cast": "Doubravice (část)",
    "psc": "37008",
    "okres": "České Budějovice",
    "obec": "Doubravice",
    "val": "37008 Doubravice Doubravice (cast)"
  },
  {
    "cast": "Doubravička",
    "psc": "29430",
    "okres": "Mladá Boleslav",
    "obec": "Doubravička",
    "val": "29430 Doubravicka Doubravicka"
  },
  {
    "cast": "Doubravka",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Doubravka"
  },
  {
    "cast": "Doubravka",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Chrášťany",
    "val": "37501 Chrastany Doubravka"
  },
  {
    "cast": "Doubravka",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Doubravka"
  },
  {
    "cast": "Doubravník",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Doubravník",
    "val": "59261 Doubravnik Doubravnik"
  },
  {
    "cast": "Doubravy (část)",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Doubravy",
    "val": "76001 Doubravy Doubravy (cast)"
  },
  {
    "cast": "Doubravy (část)",
    "psc": "76345",
    "okres": "Zlín",
    "obec": "Doubravy",
    "val": "76345 Doubravy Doubravy (cast)"
  },
  {
    "cast": "Doudleby",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Doudleby",
    "val": "37007 Doudleby Doudleby"
  },
  {
    "cast": "Doudleby nad Orlicí",
    "psc": "51742",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Doudleby nad Orlicí",
    "val": "51742 Doudleby nad Orlici Doudleby nad Orlici"
  },
  {
    "cast": "Doudlevce (část)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Doudlevce (cast)"
  },
  {
    "cast": "Doudlevce (část)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Doudlevce (cast)"
  },
  {
    "cast": "Doupě",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Doupě",
    "val": "58856 Doupe Doupe"
  },
  {
    "cast": "Dožice",
    "psc": "33543",
    "okres": "Plzeň-jih",
    "obec": "Mladý Smolivec",
    "val": "33543 Mlady Smolivec Dozice"
  },
  {
    "cast": "Dráčov",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Dracov"
  },
  {
    "cast": "Drahanovice",
    "psc": "78344",
    "okres": "Olomouc",
    "obec": "Drahanovice",
    "val": "78344 Drahanovice Drahanovice"
  },
  {
    "cast": "Drahany",
    "psc": "79861",
    "okres": "Prostějov",
    "obec": "Drahany",
    "val": "79861 Drahany Drahany"
  },
  {
    "cast": "Drahelčice",
    "psc": "25219",
    "okres": "Praha-západ",
    "obec": "Drahelčice",
    "val": "25219 Drahelcice Drahelcice"
  },
  {
    "cast": "Drahelice (část)",
    "psc": "28913",
    "okres": "Nymburk",
    "obec": "Nymburk",
    "val": "28913 Nymburk Drahelice (cast)"
  },
  {
    "cast": "Drahelice (část)",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Nymburk",
    "val": "28802 Nymburk Drahelice (cast)"
  },
  {
    "cast": "Drahenice",
    "psc": "26285",
    "okres": "Příbram",
    "obec": "Drahenice",
    "val": "26285 Drahenice Drahenice"
  },
  {
    "cast": "Drahenický Málkov",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Drahenicky Malkov"
  },
  {
    "cast": "Draheničky",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mišovice",
    "val": "39804 Misovice Drahenicky"
  },
  {
    "cast": "Drahkov",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Drahkov",
    "val": "33601 Drahkov Drahkov"
  },
  {
    "cast": "Drahkov",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Modlany",
    "val": "41501 Modlany Drahkov"
  },
  {
    "cast": "Drahlín",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Drahlín",
    "val": "26101 Drahlin Drahlin"
  },
  {
    "cast": "Drahlov",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Drahlov"
  },
  {
    "cast": "Drahlov",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Charváty",
    "val": "78375 Charvaty Drahlov"
  },
  {
    "cast": "Drahlovice",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Skuhrov",
    "val": "26727 Skuhrov Drahlovice"
  },
  {
    "cast": "Drahnětice",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Drahnetice"
  },
  {
    "cast": "Drahňovice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Drahňovice",
    "val": "25726 Drahnovice Drahnovice"
  },
  {
    "cast": "Draho",
    "psc": "28931",
    "okres": "Nymburk",
    "obec": "Chleby",
    "val": "28931 Chleby Draho"
  },
  {
    "cast": "Drahobudice",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Drahobudice",
    "val": "28144 Drahobudice Drahobudice"
  },
  {
    "cast": "Drahobuz",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Drahobuz",
    "val": "41145 Drahobuz Drahobuz"
  },
  {
    "cast": "Drahomyšl",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Lipno",
    "val": "43801 Lipno Drahomysl"
  },
  {
    "cast": "Drahonice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Drahonice"
  },
  {
    "cast": "Drahonice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Drahonice",
    "val": "38901 Drahonice Drahonice"
  },
  {
    "cast": "Drahonín (část)",
    "psc": "59262",
    "okres": "Brno-venkov",
    "obec": "Drahonín",
    "val": "59262 Drahonin Drahonin (cast)"
  },
  {
    "cast": "Drahonín (část)",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Drahonín",
    "val": "59261 Drahonin Drahonin (cast)"
  },
  {
    "cast": "Drahoňov",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Těmice",
    "val": "39470 Temice Drahonov"
  },
  {
    "cast": "Drahoňovice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Vyskeř",
    "val": "51101 Vysker Drahonovice"
  },
  {
    "cast": "Drahoňův Újezd",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Drahoňův Újezd",
    "val": "33808 Drahonuv Ujezd Drahonuv Ujezd"
  },
  {
    "cast": "Drahoraz",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Kopidlno",
    "val": "50732 Kopidlno Drahoraz"
  },
  {
    "cast": "Drahoš",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Rokytno",
    "val": "53401 Rokytno Drahos"
  },
  {
    "cast": "Drahotěšice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Drahotěšice",
    "val": "37341 Drahotesice Drahotesice"
  },
  {
    "cast": "Drahotice",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Nasavrky",
    "val": "53825 Nasavrky Drahotice"
  },
  {
    "cast": "Drahotice",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Chocnějovice",
    "val": "29413 Chocnejovice Drahotice"
  },
  {
    "cast": "Drahotín",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Drahotín",
    "val": "34522 Drahotin Drahotin"
  },
  {
    "cast": "Drahotuše-Hranice IV x)",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Drahotuse-Hranice IV x)"
  },
  {
    "cast": "Drahouš",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Drahouš",
    "val": "27033 Drahous Drahous"
  },
  {
    "cast": "Drahov (část)",
    "psc": "37821",
    "okres": "Tábor",
    "obec": "Drahov",
    "val": "37821 Drahov Drahov (cast)"
  },
  {
    "cast": "Drahov (část)",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Drahov",
    "val": "39181 Drahov Drahov (cast)"
  },
  {
    "cast": "Drahovice",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36001 Karlovy Vary Drahovice"
  },
  {
    "cast": "Drahůnky",
    "psc": "41702",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41702 Dubi Drahunky"
  },
  {
    "cast": "Drachkov",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Drachkov",
    "val": "38601 Drachkov Drachkov"
  },
  {
    "cast": "Drachkov (část)",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25753 Bystrice Drachkov (cast)"
  },
  {
    "cast": "Drachkov (část)",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Drachkov (cast)"
  },
  {
    "cast": "Dráchov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Dráchov",
    "val": "39201 Drachov Drachov"
  },
  {
    "cast": "Dráchov",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Těmice",
    "val": "39470 Temice Drachov"
  },
  {
    "cast": "Drásov",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Drásov",
    "val": "26101 Drasov Drasov"
  },
  {
    "cast": "Drásov (část)",
    "psc": "66424",
    "okres": "Brno-venkov",
    "obec": "Drásov",
    "val": "66424 Drasov Drasov (cast)"
  },
  {
    "cast": "Drásov (část)",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Drásov",
    "val": "66601 Drasov Drasov (cast)"
  },
  {
    "cast": "Drasty",
    "psc": "25067",
    "okres": "Praha-východ",
    "obec": "Klecany",
    "val": "25067 Klecany Drasty"
  },
  {
    "cast": "Dražejov",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Drazejov"
  },
  {
    "cast": "Dražejov",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Strakonice",
    "val": "38601 Strakonice Drazejov"
  },
  {
    "cast": "Dražeň",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Dražeň",
    "val": "33101 Drazen Drazen"
  },
  {
    "cast": "Draženov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Draženov",
    "val": "34401 Drazenov Drazenov"
  },
  {
    "cast": "Dražetice (část)",
    "psc": "26215",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26215 Borotice Drazetice (cast)"
  },
  {
    "cast": "Dražetice (část)",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26203 Borotice Drazetice (cast)"
  },
  {
    "cast": "Dražice",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Dražice",
    "val": "39131 Drazice Drazice"
  },
  {
    "cast": "Dražice",
    "psc": "29471",
    "okres": "Mladá Boleslav",
    "obec": "Benátky nad Jizerou",
    "val": "29471 Benatky nad Jizerou Drazice"
  },
  {
    "cast": "Dražíč",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Dražíč",
    "val": "37501 Drazic Drazic"
  },
  {
    "cast": "Dražičky",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Dražičky",
    "val": "39175 Drazicky Drazicky"
  },
  {
    "cast": "Dražka",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Drazka"
  },
  {
    "cast": "Dražkov",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Sezemice",
    "val": "53304 Sezemice Drazkov"
  },
  {
    "cast": "Drážkov",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26256 Svaty Jan Drazkov"
  },
  {
    "cast": "Dražkovice",
    "psc": "53333",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53333 Pardubice Drazkovice"
  },
  {
    "cast": "Dražov",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Stanovice",
    "val": "36001 Stanovice Drazov"
  },
  {
    "cast": "Drážov (část)",
    "psc": "38473",
    "okres": "Strakonice",
    "obec": "Drážov",
    "val": "38473 Drazov Drazov (cast)"
  },
  {
    "cast": "Drážov (část)",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Drážov",
    "val": "38719 Drazov Drazov (cast)"
  },
  {
    "cast": "Dražovice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dražovice",
    "val": "34201 Drazovice Drazovice"
  },
  {
    "cast": "Dražovice",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Dražovice",
    "val": "68301 Drazovice Drazovice"
  },
  {
    "cast": "Dražůvky",
    "psc": "69633",
    "okres": "Hodonín",
    "obec": "Dražůvky",
    "val": "69633 Drazuvky Drazuvky"
  },
  {
    "cast": "Drevníky",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Drevníky",
    "val": "26301 Drevniky Drevniky"
  },
  {
    "cast": "Drhleny",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Drhleny"
  },
  {
    "cast": "Drhovce",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Drevníky",
    "val": "26301 Drevniky Drhovce"
  },
  {
    "cast": "Drhovice",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Drhovice",
    "val": "39131 Drhovice Drhovice"
  },
  {
    "cast": "Drhovle Ves",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Drhovle",
    "val": "39701 Drhovle Drhovle Ves"
  },
  {
    "cast": "Drhovle Zámek",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Drhovle",
    "val": "39701 Drhovle Drhovle Zamek"
  },
  {
    "cast": "Drhovy",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Drhovy",
    "val": "26301 Drhovy Drhovy"
  },
  {
    "cast": "Drchkov",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Dřínov",
    "val": "27401 Drinov Drchkov"
  },
  {
    "cast": "Drchlava",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Chlum",
    "val": "47201 Chlum Drchlava"
  },
  {
    "cast": "Drmaly",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Vysoká Pec",
    "val": "43111 Vysoka Pec Drmaly"
  },
  {
    "cast": "Drmoul",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Drmoul",
    "val": "35301 Drmoul Drmoul"
  },
  {
    "cast": "Drnek",
    "psc": "27377",
    "okres": "Kladno",
    "obec": "Drnek",
    "val": "27377 Drnek Drnek"
  },
  {
    "cast": "Drnholec",
    "psc": "69183",
    "okres": "Břeclav",
    "obec": "Drnholec",
    "val": "69183 Drnholec Drnholec"
  },
  {
    "cast": "Drnov",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Žižice",
    "val": "27401 Zizice Drnov"
  },
  {
    "cast": "Drnovec",
    "psc": "47154",
    "okres": "Česká Lípa",
    "obec": "Cvikov",
    "val": "47154 Cvikov Drnovec"
  },
  {
    "cast": "Drnovice",
    "psc": "68304",
    "okres": "Vyškov",
    "obec": "Drnovice",
    "val": "68304 Drnovice Drnovice"
  },
  {
    "cast": "Drnovice",
    "psc": "67976",
    "okres": "Blansko",
    "obec": "Drnovice",
    "val": "67976 Drnovice Drnovice"
  },
  {
    "cast": "Drnovice",
    "psc": "76325",
    "okres": "Zlín",
    "obec": "Drnovice",
    "val": "76325 Drnovice Drnovice"
  },
  {
    "cast": "Drobovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Drobovice",
    "val": "28601 Drobovice Drobovice"
  },
  {
    "cast": "Drouhavec",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Drouhavec"
  },
  {
    "cast": "Droužetice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Droužetice",
    "val": "38601 Drouzetice Drouzetice"
  },
  {
    "cast": "Droužkovice",
    "psc": "43144",
    "okres": "Chomutov",
    "obec": "Droužkovice",
    "val": "43144 Drouzkovice Drouzkovice"
  },
  {
    "cast": "Drozdice (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Drozdice (cast)"
  },
  {
    "cast": "Drozdice (část)",
    "psc": "53301",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53301 Pardubice Drozdice (cast)"
  },
  {
    "cast": "Drozdov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Drozdov",
    "val": "78901 Drozdov Drozdov"
  },
  {
    "cast": "Drozdov",
    "psc": "26761",
    "okres": "Beroun",
    "obec": "Drozdov",
    "val": "26761 Drozdov Drozdov"
  },
  {
    "cast": "Droždín",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Drozdin"
  },
  {
    "cast": "Drslavice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Drslavice"
  },
  {
    "cast": "Drslavice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Drslavice",
    "val": "38301 Drslavice Drslavice"
  },
  {
    "cast": "Drslavice",
    "psc": "68733",
    "okres": "Uherské Hradiště",
    "obec": "Drslavice",
    "val": "68733 Drslavice Drslavice"
  },
  {
    "cast": "Drsník",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Pečice",
    "val": "26231 Pecice Drsnik"
  },
  {
    "cast": "Drštěkryje",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Samšina",
    "val": "50601 Samsina Drstekryje"
  },
  {
    "cast": "Druhanice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Chotusice",
    "val": "28601 Chotusice Druhanice"
  },
  {
    "cast": "Druhanov",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Druhanov",
    "val": "58291 Druhanov Druhanov"
  },
  {
    "cast": "Druhlice",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Daleké Dušníky",
    "val": "26301 Daleke Dusniky Druhlice"
  },
  {
    "cast": "Drunče",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Drunče",
    "val": "37821 Drunce Drunce"
  },
  {
    "cast": "Druzcov",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Osečná",
    "val": "46352 Osecna Druzcov"
  },
  {
    "cast": "Druztová",
    "psc": "33007",
    "okres": "Plzeň-sever",
    "obec": "Druztová",
    "val": "33007 Druztova Druztova"
  },
  {
    "cast": "Družec",
    "psc": "27362",
    "okres": "Kladno",
    "obec": "Družec",
    "val": "27362 Druzec Druzec"
  },
  {
    "cast": "Drválovice",
    "psc": "67936",
    "okres": "Blansko",
    "obec": "Vanovice",
    "val": "67936 Vanovice Drvalovice"
  },
  {
    "cast": "Drysice",
    "psc": "68321",
    "okres": "Vyškov",
    "obec": "Drysice",
    "val": "68321 Drysice Drysice"
  },
  {
    "cast": "Držkov",
    "psc": "46824",
    "okres": "Jablonec nad Nisou",
    "obec": "Držkov",
    "val": "46824 Drzkov Drzkov"
  },
  {
    "cast": "Držková",
    "psc": "76319",
    "okres": "Zlín",
    "obec": "Držková",
    "val": "76319 Drzkova Drzkova"
  },
  {
    "cast": "Držkrajov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Přeštěnice",
    "val": "39901 Prestenice Drzkrajov"
  },
  {
    "cast": "Držov",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Vojníkov",
    "val": "39701 Vojnikov Drzov"
  },
  {
    "cast": "Držovice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Drzovice"
  },
  {
    "cast": "Držovice",
    "psc": "79607",
    "okres": "Prostějov",
    "obec": "Držovice",
    "val": "79607 Drzovice Drzovice"
  },
  {
    "cast": "Dřemčice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebívlice",
    "val": "41115 Trebivlice Dremcice"
  },
  {
    "cast": "Dřenice",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Drenice"
  },
  {
    "cast": "Dřenice",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Dřenice",
    "val": "53701 Drenice Drenice"
  },
  {
    "cast": "Dřešín (část)",
    "psc": "38473",
    "okres": "Strakonice",
    "obec": "Dřešín",
    "val": "38473 Dresin Dresin (cast)"
  },
  {
    "cast": "Dřešín (část)",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Dřešín",
    "val": "38719 Dresin Dresin (cast)"
  },
  {
    "cast": "Dřešínek",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Dřešín",
    "val": "38719 Dresin Dresinek"
  },
  {
    "cast": "Dřetovice",
    "psc": "27342",
    "okres": "Kladno",
    "obec": "Dřetovice",
    "val": "27342 Dretovice Dretovice"
  },
  {
    "cast": "Dřevce",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebívlice",
    "val": "41115 Trebivlice Drevce"
  },
  {
    "cast": "Dřevčice",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Drevcice"
  },
  {
    "cast": "Dřevčice",
    "psc": "25001",
    "okres": "Praha-východ",
    "obec": "Dřevčice",
    "val": "25001 Drevcice Drevcice"
  },
  {
    "cast": "Dřevec",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kožlany",
    "val": "33141 Kozlany Drevec"
  },
  {
    "cast": "Dřevěnice",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Dřevěnice",
    "val": "50713 Drevenice Drevenice"
  },
  {
    "cast": "Dřeveš",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Tisovec",
    "val": "53973 Tisovec Dreves"
  },
  {
    "cast": "Dřevíkov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Drevikov"
  },
  {
    "cast": "Dřevnovice",
    "psc": "79826",
    "okres": "Prostějov",
    "obec": "Dřevnovice",
    "val": "79826 Drevnovice Drevnovice"
  },
  {
    "cast": "Dřevohostice",
    "psc": "75114",
    "okres": "Přerov",
    "obec": "Dřevohostice",
    "val": "75114 Drevohostice Drevohostice"
  },
  {
    "cast": "Dřínov",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Dřínov",
    "val": "27371 Drinov Drinov"
  },
  {
    "cast": "Dřínov",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Dřínov",
    "val": "76833 Drinov Drinov"
  },
  {
    "cast": "Dřínov",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Dřínov",
    "val": "27745 Drinov Drinov"
  },
  {
    "cast": "Dřísy",
    "psc": "27714",
    "okres": "Praha-východ",
    "obec": "Dřísy",
    "val": "27714 Drisy Drisy"
  },
  {
    "cast": "Dříteč",
    "psc": "53305",
    "okres": "Pardubice",
    "obec": "Dříteč",
    "val": "53305 Dritec Dritec"
  },
  {
    "cast": "Dříteň",
    "psc": "37351",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37351 Driten Driten"
  },
  {
    "cast": "Dub",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Kondrac",
    "val": "25801 Kondrac Dub"
  },
  {
    "cast": "Dub",
    "psc": "38425",
    "okres": "Prachatice",
    "obec": "Dub",
    "val": "38425 Dub Dub"
  },
  {
    "cast": "Dub",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Mžany",
    "val": "50315 Mzany Dub"
  },
  {
    "cast": "Dub",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Ratibořské Hory",
    "val": "39143 Ratiborske Hory Dub"
  },
  {
    "cast": "Dub",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74101 Stary Jicin Dub"
  },
  {
    "cast": "Dub",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Dub"
  },
  {
    "cast": "Dub nad Moravou",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Dub nad Moravou",
    "val": "78375 Dub nad Moravou Dub nad Moravou"
  },
  {
    "cast": "Dubá",
    "psc": "47141",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47141 Duba Duba"
  },
  {
    "cast": "Dubany",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Dubany",
    "val": "53002 Dubany Dubany"
  },
  {
    "cast": "Dubany",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Libochovice",
    "val": "41002 Libochovice Dubany"
  },
  {
    "cast": "Dubany",
    "psc": "79812",
    "okres": "Prostějov",
    "obec": "Vrbátky",
    "val": "79812 Vrbatky Dubany"
  },
  {
    "cast": "Dubčany",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Liběšice",
    "val": "43801 Libesice Dubcany"
  },
  {
    "cast": "Dubčany",
    "psc": "78322",
    "okres": "Olomouc",
    "obec": "Dubčany",
    "val": "78322 Dubcany Dubcany"
  },
  {
    "cast": "Dubec",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Třemešné",
    "val": "34806 Tremesne Dubec"
  },
  {
    "cast": "Dubecko",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Dubecko"
  },
  {
    "cast": "Dubeč",
    "psc": "10700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10700 Praha Dubec"
  },
  {
    "cast": "Dubečno (část)",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Kněžice",
    "val": "28903 Knezice Dubecno (cast)"
  },
  {
    "cast": "Dubečno (část)",
    "psc": "28902",
    "okres": "Nymburk",
    "obec": "Kněžice",
    "val": "28902 Knezice Dubecno (cast)"
  },
  {
    "cast": "Dubějovice",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Trhový Štěpánov",
    "val": "25763 Trhovy Stepanov Dubejovice"
  },
  {
    "cast": "Dubenec",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Dubenec",
    "val": "26101 Dubenec Dubenec"
  },
  {
    "cast": "Dubenec",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dívčice",
    "val": "37348 Divcice Dubenec"
  },
  {
    "cast": "Dubenec",
    "psc": "54455",
    "okres": "Trutnov",
    "obec": "Dubenec",
    "val": "54455 Dubenec Dubenec"
  },
  {
    "cast": "Dubí",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Tutleky",
    "val": "51741 Tutleky Dubi"
  },
  {
    "cast": "Dubí",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Herálec",
    "val": "58255 Heralec Dubi"
  },
  {
    "cast": "Dubí Hora",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Drhovle",
    "val": "39701 Drhovle Dubi Hora"
  },
  {
    "cast": "Dubí (část)",
    "psc": "41702",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41702 Dubi Dubi (cast)"
  },
  {
    "cast": "Dubí (část)",
    "psc": "27201",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27201 Kladno Dubi (cast)"
  },
  {
    "cast": "Dubí (část)",
    "psc": "27203",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27203 Kladno Dubi (cast)"
  },
  {
    "cast": "Dubí (část)",
    "psc": "27309",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27309 Kladno Dubi (cast)"
  },
  {
    "cast": "Dubí (část)",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41501 Dubi Dubi (cast)"
  },
  {
    "cast": "Dubí (část)",
    "psc": "41701",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41701 Dubi Dubi (cast)"
  },
  {
    "cast": "Dubice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Řehlovice",
    "val": "40002 Rehlovice Dubice"
  },
  {
    "cast": "Dubice (část)",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Dubice (cast)"
  },
  {
    "cast": "Dubice (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47002 Ceska Lipa Dubice (cast)"
  },
  {
    "cast": "Dubicko",
    "psc": "78972",
    "okres": "Šumperk",
    "obec": "Dubicko",
    "val": "78972 Dubicko Dubicko"
  },
  {
    "cast": "Dubičná",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Dubicna"
  },
  {
    "cast": "Dubičné (část)",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Dubičné",
    "val": "37371 Dubicne Dubicne (cast)"
  },
  {
    "cast": "Dubičné (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Dubičné",
    "val": "37006 Dubicne Dubicne (cast)"
  },
  {
    "cast": "Dubina",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Šemnice",
    "val": "36272 Semnice Dubina"
  },
  {
    "cast": "Dubina",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Dubina"
  },
  {
    "cast": "Dubina",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Dubina"
  },
  {
    "cast": "Dubina",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zruč nad Sázavou",
    "val": "28522 Zruc nad Sazavou Dubina"
  },
  {
    "cast": "Dubiny",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Dubiny"
  },
  {
    "cast": "Dubliny",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Radíč",
    "val": "26401 Radic Dubliny"
  },
  {
    "cast": "Dublovice",
    "psc": "26251",
    "okres": "Příbram",
    "obec": "Dublovice",
    "val": "26251 Dublovice Dublovice"
  },
  {
    "cast": "Dubňany",
    "psc": "69603",
    "okres": "Hodonín",
    "obec": "Dubňany",
    "val": "69603 Dubnany Dubnany"
  },
  {
    "cast": "Dubné",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Dubné",
    "val": "37384 Dubne Dubne"
  },
  {
    "cast": "Dubnice",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Lichnov",
    "val": "79401 Lichnov Dubnice"
  },
  {
    "cast": "Dubnice",
    "psc": "47126",
    "okres": "Česká Lípa",
    "obec": "Dubnice",
    "val": "47126 Dubnice Dubnice"
  },
  {
    "cast": "Dubno",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Dubno",
    "val": "26101 Dubno Dubno"
  },
  {
    "cast": "Dubová",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53825 Miretice Dubova"
  },
  {
    "cast": "Dubová",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přídolí",
    "val": "38101 Pridoli Dubova"
  },
  {
    "cast": "Dubová Lhota",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Dubova Lhota"
  },
  {
    "cast": "Dubovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Dubovice",
    "val": "39301 Dubovice Dubovice"
  },
  {
    "cast": "Dubovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Žernovice",
    "val": "38301 Zernovice Dubovice"
  },
  {
    "cast": "Dubovka",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Psáře",
    "val": "25801 Psare Dubovka"
  },
  {
    "cast": "Dubovka",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Dubovka"
  },
  {
    "cast": "Dubská Lhota",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Dub",
    "val": "38422 Dub Dubska Lhota"
  },
  {
    "cast": "Dučice",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Přerubenice",
    "val": "27054 Prerubenice Ducice"
  },
  {
    "cast": "Dudín",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Dudín",
    "val": "58805 Dudin Dudin"
  },
  {
    "cast": "Dudov",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Skrýchov u Malšic",
    "val": "39175 Skrychov u Malsic Dudov"
  },
  {
    "cast": "Duchcov",
    "psc": "41901",
    "okres": "Teplice",
    "obec": "Duchcov",
    "val": "41901 Duchcov Duchcov"
  },
  {
    "cast": "Dukovany (část)",
    "psc": "67556",
    "okres": "Třebíč",
    "obec": "Dukovany",
    "val": "67556 Dukovany Dukovany (cast)"
  },
  {
    "cast": "Dukovany (část)",
    "psc": "67550",
    "okres": "Třebíč",
    "obec": "Dukovany",
    "val": "67550 Dukovany Dukovany (cast)"
  },
  {
    "cast": "Důl",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Důl",
    "val": "39501 Dul Dul"
  },
  {
    "cast": "Důl",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Sedlice",
    "val": "38801 Sedlice Dul"
  },
  {
    "cast": "Dunajovice",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Dunajovice",
    "val": "37901 Dunajovice Dunajovice"
  },
  {
    "cast": "Dunávice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Netvořice",
    "val": "25744 Netvorice Dunavice"
  },
  {
    "cast": "Dunice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Dunice",
    "val": "25768 Dunice Dunice"
  },
  {
    "cast": "Dunovice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Cehnice",
    "val": "38901 Cehnice Dunovice"
  },
  {
    "cast": "Durdice",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Durdice"
  },
  {
    "cast": "Dušejov",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Dušejov",
    "val": "58805 Dusejov Dusejov"
  },
  {
    "cast": "Dušníky",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Dušníky",
    "val": "41301 Dusniky Dusniky"
  },
  {
    "cast": "Dušníky nad Vltavou",
    "psc": "27744",
    "okres": "Mělník",
    "obec": "Všestudy",
    "val": "27744 Vsestudy Dusniky nad Vltavou"
  },
  {
    "cast": "Dušníky (část)",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Obříství",
    "val": "27601 Obristvi Dusniky (cast)"
  },
  {
    "cast": "Dušníky (část)",
    "psc": "27742",
    "okres": "Mělník",
    "obec": "Obříství",
    "val": "27742 Obristvi Dusniky (cast)"
  },
  {
    "cast": "Dvakačovice",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Dvakačovice",
    "val": "53862 Dvakacovice Dvakacovice"
  },
  {
    "cast": "Dvérce",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Nepomyšl",
    "val": "44101 Nepomysl Dverce"
  },
  {
    "cast": "Dvorce",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Dvorce"
  },
  {
    "cast": "Dvorce",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Tučapy",
    "val": "39201 Tucapy Dvorce"
  },
  {
    "cast": "Dvorce",
    "psc": "79368",
    "okres": "Bruntál",
    "obec": "Dvorce",
    "val": "79368 Dvorce Dvorce"
  },
  {
    "cast": "Dvorce",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Dvorce"
  },
  {
    "cast": "Dvorce",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Lysá nad Labem",
    "val": "28922 Lysa nad Labem Dvorce"
  },
  {
    "cast": "Dvorce",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Kyjov",
    "val": "58001 Kyjov Dvorce"
  },
  {
    "cast": "Dvorce",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Stráž nad Nežárkou",
    "val": "37802 Straz nad Nezarkou Dvorce"
  },
  {
    "cast": "Dvorce (část)",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Dvorce",
    "val": "58805 Dvorce Dvorce (cast)"
  },
  {
    "cast": "Dvorce (část)",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Dvorce",
    "val": "58851 Dvorce Dvorce (cast)"
  },
  {
    "cast": "Dvorec",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Dvorec"
  },
  {
    "cast": "Dvorec",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Dub",
    "val": "38301 Dub Dvorec"
  },
  {
    "cast": "Dvorec",
    "psc": "33503",
    "okres": "Plzeň-jih",
    "obec": "Nepomuk",
    "val": "33503 Nepomuk Dvorec"
  },
  {
    "cast": "Dvorec",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Borovany",
    "val": "37312 Borovany Dvorec"
  },
  {
    "cast": "Dvorec (část)",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Radhostice",
    "val": "38481 Radhostice Dvorec (cast)"
  },
  {
    "cast": "Dvorec (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Radhostice",
    "val": "38301 Radhostice Dvorec (cast)"
  },
  {
    "cast": "Dvorecko",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Bohdaneč",
    "val": "28522 Bohdanec Dvorecko"
  },
  {
    "cast": "Dvoreček",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Blažejov",
    "val": "37701 Blazejov Dvorecek"
  },
  {
    "cast": "Dvorečky",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kynšperk nad Ohří",
    "val": "35751 Kynsperk nad Ohri Dvorecky"
  },
  {
    "cast": "Dvorek",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Dvorek"
  },
  {
    "cast": "Dvorek",
    "psc": "79857",
    "okres": "Prostějov",
    "obec": "Laškov",
    "val": "79857 Laskov Dvorek"
  },
  {
    "cast": "Dvorska",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Dvorska"
  },
  {
    "cast": "Dvorsko",
    "psc": "47106",
    "okres": "Česká Lípa",
    "obec": "Horní Police",
    "val": "47106 Horni Police Dvorsko"
  },
  {
    "cast": "Dvory",
    "psc": "35733",
    "okres": "Sokolov",
    "obec": "Loket",
    "val": "35733 Loket Dvory"
  },
  {
    "cast": "Dvory",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Dvory",
    "val": "28802 Dvory Dvory"
  },
  {
    "cast": "Dvory",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Dvory",
    "val": "38301 Dvory Dvory"
  },
  {
    "cast": "Dvory",
    "psc": "36006",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36006 Karlovy Vary Dvory"
  },
  {
    "cast": "Dvory nad Lužnicí",
    "psc": "37808",
    "okres": "Jindřichův Hradec",
    "obec": "Dvory nad Lužnicí",
    "val": "37808 Dvory nad Luznici Dvory nad Luznici"
  },
  {
    "cast": "Dvořisko",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Choceň",
    "val": "56501 Chocen Dvorisko"
  },
  {
    "cast": "Dvořisko",
    "psc": "74721",
    "okres": "Opava",
    "obec": "Kravaře",
    "val": "74721 Kravare Dvorisko"
  },
  {
    "cast": "Dvořiště",
    "psc": "53944",
    "okres": "Ústí nad Orlicí",
    "obec": "Leština",
    "val": "53944 Lestina Dvoriste"
  },
  {
    "cast": "Dvořiště",
    "psc": "28902",
    "okres": "Nymburk",
    "obec": "Chroustov",
    "val": "28902 Chroustov Dvoriste"
  },
  {
    "cast": "Dvořiště",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Dvoriste"
  },
  {
    "cast": "Dvořiště (část)",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Mnich",
    "val": "39470 Mnich Dvoriste (cast)"
  },
  {
    "cast": "Dvořiště (část)",
    "psc": "39493",
    "okres": "Pelhřimov",
    "obec": "Mnich",
    "val": "39493 Mnich Dvoriste (cast)"
  },
  {
    "cast": "Dvůr Králové nad Labem",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Dvůr Králové nad Labem",
    "val": "54401 Dvur Kralove nad Labem Dvur Kralove nad Labem"
  },
  {
    "cast": "Dvůr Semtín",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25753 Olbramovice Dvur Semtin"
  },
  {
    "cast": "Dyjákovice",
    "psc": "67126",
    "okres": "Znojmo",
    "obec": "Dyjákovice",
    "val": "67126 Dyjakovice Dyjakovice"
  },
  {
    "cast": "Dyjákovičky",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Dyjákovičky",
    "val": "66902 Dyjakovicky Dyjakovicky"
  },
  {
    "cast": "Dyje",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Dyje",
    "val": "66902 Dyje Dyje"
  },
  {
    "cast": "Dyjice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Dyjice",
    "val": "58856 Dyjice Dyjice"
  },
  {
    "cast": "Dyjička",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Dyjice",
    "val": "58862 Dyjice Dyjicka"
  },
  {
    "cast": "Dymokury",
    "psc": "28901",
    "okres": "Nymburk",
    "obec": "Dymokury",
    "val": "28901 Dymokury Dymokury"
  },
  {
    "cast": "Dynín",
    "psc": "37364",
    "okres": "České Budějovice",
    "obec": "Dynín",
    "val": "37364 Dynin Dynin"
  },
  {
    "cast": "Dýšina",
    "psc": "33002",
    "okres": "Plzeň-město",
    "obec": "Dýšina",
    "val": "33002 Dysina Dysina"
  },
  {
    "cast": "Dzbel",
    "psc": "79853",
    "okres": "Prostějov",
    "obec": "Dzbel",
    "val": "79853 Dzbel Dzbel"
  },
  {
    "cast": "Džbánice",
    "psc": "67171",
    "okres": "Znojmo",
    "obec": "Džbánice",
    "val": "67171 Dzbanice Dzbanice"
  },
  {
    "cast": "Džbánov",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Džbánov",
    "val": "56601 Dzbanov Dzbanov"
  },
  {
    "cast": "Džbánov",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Voděrady",
    "val": "56601 Voderady Dzbanov"
  },
  {
    "cast": "Edrovice",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Rýmařov",
    "val": "79501 Rymarov Edrovice"
  },
  {
    "cast": "Ejpovice",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Ejpovice",
    "val": "33701 Ejpovice Ejpovice"
  },
  {
    "cast": "Elbančice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Běleč",
    "val": "39143 Belec Elbancice"
  },
  {
    "cast": "Emauzy",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Vražné",
    "val": "74235 Vrazne Emauzy"
  },
  {
    "cast": "Encovany",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Polepy",
    "val": "41145 Polepy Encovany"
  },
  {
    "cast": "Erazim",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Mutěnín",
    "val": "34525 Mutenin Erazim"
  },
  {
    "cast": "Erpužice",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Erpužice",
    "val": "34901 Erpuzice Erpuzice"
  },
  {
    "cast": "Eš",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Eš",
    "val": "39501 Es Es"
  },
  {
    "cast": "Evaň",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Evaň",
    "val": "41002 Evan Evan"
  },
  {
    "cast": "Falknov",
    "psc": "40745",
    "okres": "Děčín",
    "obec": "Kytlice",
    "val": "40745 Kytlice Falknov"
  },
  {
    "cast": "Felbabka",
    "psc": "26801",
    "okres": "Beroun",
    "obec": "Felbabka",
    "val": "26801 Felbabka Felbabka"
  },
  {
    "cast": "Ferdinandov",
    "psc": "46362",
    "okres": "Liberec",
    "obec": "Hejnice",
    "val": "46362 Hejnice Ferdinandov"
  },
  {
    "cast": "Filipka",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Oldřichov v Hájích",
    "val": "46331 Oldrichov v Hajich Filipka"
  },
  {
    "cast": "Filipov",
    "psc": "40753",
    "okres": "Děčín",
    "obec": "Jiříkov",
    "val": "40753 Jirikov Filipov"
  },
  {
    "cast": "Filipov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Čáslav",
    "val": "28601 Caslav Filipov"
  },
  {
    "cast": "Filipov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40502 Ceska Kamenice Filipov"
  },
  {
    "cast": "Filipov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Kameničky",
    "val": "53901 Kamenicky Filipov"
  },
  {
    "cast": "Filipová",
    "psc": "78811",
    "okres": "Šumperk",
    "obec": "Loučná nad Desnou",
    "val": "78811 Loucna nad Desnou Filipova"
  },
  {
    "cast": "Filipova Hora",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Tlumačov",
    "val": "34401 Tlumacov Filipova Hora"
  },
  {
    "cast": "Filipova Huť",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Modrava",
    "val": "34192 Modrava Filipova Hut"
  },
  {
    "cast": "Filipovice",
    "psc": "74784",
    "okres": "Opava",
    "obec": "Hradec nad Moravicí",
    "val": "74784 Hradec nad Moravici Filipovice"
  },
  {
    "cast": "Filipovice",
    "psc": "79001",
    "okres": "Jeseník",
    "obec": "Bělá pod Pradědem",
    "val": "79001 Bela pod Pradedem Filipovice"
  },
  {
    "cast": "Filipovka",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46373 Visnova Filipovka"
  },
  {
    "cast": "Fláje",
    "psc": "43601",
    "okres": "Most",
    "obec": "Český Jiřetín",
    "val": "43601 Cesky Jiretin Flaje"
  },
  {
    "cast": "Fleky",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Chudenín",
    "val": "34022 Chudenin Fleky"
  },
  {
    "cast": "Fojtka",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Mníšek",
    "val": "46331 Mnisek Fojtka"
  },
  {
    "cast": "Fojtov",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36225 Nejdek Fojtov"
  },
  {
    "cast": "Fojtovice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Heřmanov",
    "val": "40502 Hermanov Fojtovice"
  },
  {
    "cast": "Fojtovice (část)",
    "psc": "41741",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41741 Krupka Fojtovice (cast)"
  },
  {
    "cast": "Fojtovice (část)",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Fojtovice (cast)"
  },
  {
    "cast": "Folknáře-Děčín XXVIII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Folknare-Decin XXVIII x)"
  },
  {
    "cast": "Fořt",
    "psc": "54372",
    "okres": "Trutnov",
    "obec": "Černý Důl",
    "val": "54372 Cerny Dul Fort"
  },
  {
    "cast": "Frahelž",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Frahelž",
    "val": "37901 Frahelz Frahelz"
  },
  {
    "cast": "Franclina",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Trusnov",
    "val": "53401 Trusnov Franclina"
  },
  {
    "cast": "Francova Lhota",
    "psc": "75614",
    "okres": "Vsetín",
    "obec": "Francova Lhota",
    "val": "75614 Francova Lhota Francova Lhota"
  },
  {
    "cast": "Frankův Zhořec",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Stránecká Zhoř",
    "val": "59401 Stranecka Zhor Frankuv Zhorec"
  },
  {
    "cast": "Františkov",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Kvilda",
    "val": "38501 Kvilda Frantiskov"
  },
  {
    "cast": "Františkov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Smilovy Hory",
    "val": "39143 Smilovy Hory Frantiskov"
  },
  {
    "cast": "Františkov",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Blížejov",
    "val": "34601 Blizejov Frantiskov"
  },
  {
    "cast": "Františkov",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28504 Uzice Frantiskov"
  },
  {
    "cast": "Františkov",
    "psc": "51245",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51245 Rokytnice nad Jizerou Frantiskov"
  },
  {
    "cast": "Františkov",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Suchdol nad Lužnicí",
    "val": "37806 Suchdol nad Luznici Frantiskov"
  },
  {
    "cast": "Františkov nad Ploučnicí",
    "psc": "40723",
    "okres": "Děčín",
    "obec": "Františkov nad Ploučnicí",
    "val": "40723 Frantiskov nad Ploucnici Frantiskov nad Ploucnici"
  },
  {
    "cast": "Františkova Ves",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Frantiskova Ves"
  },
  {
    "cast": "Františkovy Lázně",
    "psc": "35101",
    "okres": "Cheb",
    "obec": "Františkovy Lázně",
    "val": "35101 Frantiskovy Lazne Frantiskovy Lazne"
  },
  {
    "cast": "Františkov-Liberec X x)",
    "psc": "46010",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46010 Liberec Frantiskov-Liberec X x)"
  },
  {
    "cast": "Františkův Vrch",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Huntířov",
    "val": "40502 Huntirov Frantiskuv Vrch"
  },
  {
    "cast": "Františky",
    "psc": "56982",
    "okres": "Chrudim",
    "obec": "Krouna",
    "val": "56982 Krouna Frantisky"
  },
  {
    "cast": "Frantoly",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Mičovice",
    "val": "38301 Micovice Frantoly"
  },
  {
    "cast": "Frenštát pod Radhoštěm",
    "psc": "74401",
    "okres": "Nový Jičín",
    "obec": "Frenštát pod Radhoštěm",
    "val": "74401 Frenstat pod Radhostem Frenstat pod Radhostem"
  },
  {
    "cast": "Fryčovice (část)",
    "psc": "74258",
    "okres": "Frýdek-Místek",
    "obec": "Fryčovice",
    "val": "74258 Frycovice Frycovice (cast)"
  },
  {
    "cast": "Fryčovice (část)",
    "psc": "73946",
    "okres": "Frýdek-Místek",
    "obec": "Fryčovice",
    "val": "73946 Frycovice Frycovice (cast)"
  },
  {
    "cast": "Fryčovice (část)",
    "psc": "73945",
    "okres": "Frýdek-Místek",
    "obec": "Fryčovice",
    "val": "73945 Frycovice Frycovice (cast)"
  },
  {
    "cast": "Frýdek",
    "psc": "73801",
    "okres": "Frýdek-Místek",
    "obec": "Frýdek-Místek",
    "val": "73801 Frydek-Mistek Frydek"
  },
  {
    "cast": "Frýdlant",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Frýdlant",
    "val": "46401 Frydlant Frydlant"
  },
  {
    "cast": "Frýdlant",
    "psc": "73911",
    "okres": "Frýdek-Místek",
    "obec": "Frýdlant nad Ostravicí",
    "val": "73911 Frydlant nad Ostravici Frydlant"
  },
  {
    "cast": "Frýdnava",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Habry",
    "val": "58282 Habry Frydnava"
  },
  {
    "cast": "Frýdštejn",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Frydstejn"
  },
  {
    "cast": "Frymburk",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Frymburk",
    "val": "34201 Frymburk Frymburk"
  },
  {
    "cast": "Frymburk",
    "psc": "38279",
    "okres": "Český Krumlov",
    "obec": "Frymburk",
    "val": "38279 Frymburk Frymburk"
  },
  {
    "cast": "Fryšava pod Žákovou horou",
    "psc": "59204",
    "okres": "Žďár nad Sázavou",
    "obec": "Fryšava pod Žákovou horou",
    "val": "59204 Frysava pod Zakovou horou Frysava pod Zakovou horou"
  },
  {
    "cast": "Fryšták",
    "psc": "76316",
    "okres": "Zlín",
    "obec": "Fryšták",
    "val": "76316 Frystak Frystak"
  },
  {
    "cast": "Fryštát",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Frystat"
  },
  {
    "cast": "Fulnek",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Fulnek"
  },
  {
    "cast": "Gabrhele",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Řehenice",
    "val": "25167 Rehenice Gabrhele"
  },
  {
    "cast": "Gabrielka",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Kamenice nad Lipou",
    "val": "39470 Kamenice nad Lipou Gabrielka"
  },
  {
    "cast": "Gajer",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Janov",
    "val": "57001 Janov Gajer"
  },
  {
    "cast": "Geršov",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Otín",
    "val": "59442 Otin Gersov"
  },
  {
    "cast": "Golčův Jeníkov",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Golčův Jeníkov",
    "val": "58282 Golcuv Jenikov Golcuv Jenikov"
  },
  {
    "cast": "Grabštejn",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Chotyně",
    "val": "46334 Chotyne Grabstejn"
  },
  {
    "cast": "Grešlové Mýto",
    "psc": "67156",
    "okres": "Znojmo",
    "obec": "Grešlové Mýto",
    "val": "67156 Greslove Myto Greslove Myto"
  },
  {
    "cast": "Gručovice",
    "psc": "74744",
    "okres": "Opava",
    "obec": "Březová",
    "val": "74744 Brezova Grucovice"
  },
  {
    "cast": "Gruna",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Gruna",
    "val": "57101 Gruna Gruna"
  },
  {
    "cast": "Grunta",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Grunta",
    "val": "28002 Grunta Grunta"
  },
  {
    "cast": "Grygov",
    "psc": "78373",
    "okres": "Olomouc",
    "obec": "Grygov",
    "val": "78373 Grygov Grygov"
  },
  {
    "cast": "Grymov",
    "psc": "75121",
    "okres": "Přerov",
    "obec": "Grymov",
    "val": "75121 Grymov Grymov"
  },
  {
    "cast": "Guntramovice",
    "psc": "74787",
    "okres": "Opava",
    "obec": "Budišov nad Budišovkou",
    "val": "74787 Budisov nad Budisovkou Guntramovice"
  },
  {
    "cast": "Guty",
    "psc": "73955",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73955 Trinec Guty"
  },
  {
    "cast": "Habartice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Habartice"
  },
  {
    "cast": "Habartice",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Habartice",
    "val": "46373 Habartice Habartice"
  },
  {
    "cast": "Habartice",
    "psc": "78823",
    "okres": "Šumperk",
    "obec": "Jindřichov",
    "val": "78823 Jindrichov Habartice"
  },
  {
    "cast": "Habartov",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Habartov",
    "val": "35709 Habartov Habartov"
  },
  {
    "cast": "Hablov",
    "psc": "79814",
    "okres": "Prostějov",
    "obec": "Olšany u Prostějova",
    "val": "79814 Olsany u Prostejova Hablov"
  },
  {
    "cast": "Habrek",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Ledeč nad Sázavou",
    "val": "58401 Ledec nad Sazavou Habrek"
  },
  {
    "cast": "Habrkovice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Záboří nad Labem",
    "val": "28401 Zabori nad Labem Habrkovice"
  },
  {
    "cast": "Habrová",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Dolany",
    "val": "33011 Dolany Habrova"
  },
  {
    "cast": "Habrovany",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Habrovany",
    "val": "68301 Habrovany Habrovany"
  },
  {
    "cast": "Habrovany",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Habrovany",
    "val": "40002 Habrovany Habrovany"
  },
  {
    "cast": "Habrovčice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58401 Hnevkovice Habrovcice"
  },
  {
    "cast": "Habroveč",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Vrbatův Kostelec",
    "val": "53851 Vrbatuv Kostelec Habrovec"
  },
  {
    "cast": "Habrovice",
    "psc": "40340",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40340 Usti nad Labem Habrovice"
  },
  {
    "cast": "Habrůvka (část)",
    "psc": "67905",
    "okres": "Blansko",
    "obec": "Habrůvka",
    "val": "67905 Habruvka Habruvka (cast)"
  },
  {
    "cast": "Habrůvka (část)",
    "psc": "67904",
    "okres": "Blansko",
    "obec": "Habrůvka",
    "val": "67904 Habruvka Habruvka (cast)"
  },
  {
    "cast": "Habry (část)",
    "psc": "58281",
    "okres": "Havlíčkův Brod",
    "obec": "Habry",
    "val": "58281 Habry Habry (cast)"
  },
  {
    "cast": "Habry (část)",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Habry",
    "val": "58282 Habry Habry (cast)"
  },
  {
    "cast": "Habří",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Habří",
    "val": "37384 Habri Habri"
  },
  {
    "cast": "Habří",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Řehlovice",
    "val": "40002 Rehlovice Habri"
  },
  {
    "cast": "Habří",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Moravecké Pavlovice",
    "val": "59301 Moravecke Pavlovice Habri"
  },
  {
    "cast": "Habřina",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Habrina"
  },
  {
    "cast": "Habřina",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Habřina",
    "val": "50303 Habrina Habrina"
  },
  {
    "cast": "Habřinka",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Bukovka",
    "val": "53341 Bukovka Habrinka"
  },
  {
    "cast": "Hačky",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Hačky",
    "val": "79855 Hacky Hacky"
  },
  {
    "cast": "Hadačka",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Výrov",
    "val": "33141 Vyrov Hadacka"
  },
  {
    "cast": "Hadina",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Čejov",
    "val": "39601 Cejov Hadina"
  },
  {
    "cast": "Hadrava",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Chudenín",
    "val": "34022 Chudenin Hadrava"
  },
  {
    "cast": "Hadravova Rosička",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Hadravova Rosička",
    "val": "37842 Hadravova Rosicka Hadravova Rosicka"
  },
  {
    "cast": "Háj",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43201 Radonice Haj"
  },
  {
    "cast": "Háj",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Kaliště",
    "val": "39601 Kaliste Haj"
  },
  {
    "cast": "Háj",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Jindřichovice",
    "val": "35601 Jindrichovice Haj"
  },
  {
    "cast": "Háj",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Loučná pod Klínovcem",
    "val": "43191 Loucna pod Klinovcem Haj"
  },
  {
    "cast": "Háj",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Habartice",
    "val": "46373 Habartice Haj"
  },
  {
    "cast": "Háj u Duchcova",
    "psc": "41722",
    "okres": "Teplice",
    "obec": "Háj u Duchcova",
    "val": "41722 Haj u Duchcova Haj u Duchcova"
  },
  {
    "cast": "Háj ve Slezsku",
    "psc": "74792",
    "okres": "Opava",
    "obec": "Háj ve Slezsku",
    "val": "74792 Haj ve Slezsku Haj ve Slezsku"
  },
  {
    "cast": "Hajánky",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Tišnov",
    "val": "66601 Tisnov Hajanky"
  },
  {
    "cast": "Hajany",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Hajany",
    "val": "38801 Hajany Hajany"
  },
  {
    "cast": "Hajany",
    "psc": "66443",
    "okres": "Brno-venkov",
    "obec": "Hajany",
    "val": "66443 Hajany Hajany"
  },
  {
    "cast": "Háje",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Haje"
  },
  {
    "cast": "Háje",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Lesná",
    "val": "34701 Lesna Haje"
  },
  {
    "cast": "Háje",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Řenče",
    "val": "33401 Rence Haje"
  },
  {
    "cast": "Háje",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Hřiměždice",
    "val": "26301 Hrimezdice Haje"
  },
  {
    "cast": "Háje",
    "psc": "33452",
    "okres": "Domažlice",
    "obec": "Srbice",
    "val": "33452 Srbice Haje"
  },
  {
    "cast": "Háje",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Kolová",
    "val": "36001 Kolova Haje"
  },
  {
    "cast": "Háje nad Jizerou",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Háje nad Jizerou",
    "val": "51301 Haje nad Jizerou Haje nad Jizerou"
  },
  {
    "cast": "Háje (část)",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Háje",
    "val": "26231 Haje Haje (cast)"
  },
  {
    "cast": "Háje (část)",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Háje",
    "val": "26101 Haje Haje (cast)"
  },
  {
    "cast": "Háje (část)",
    "psc": "10200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10200 Praha Haje (cast)"
  },
  {
    "cast": "Háje (část)",
    "psc": "14900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14900 Praha Haje (cast)"
  },
  {
    "cast": "Hájek",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Vodice",
    "val": "39155 Vodice Hajek"
  },
  {
    "cast": "Hájek",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34506 Vseruby Hajek"
  },
  {
    "cast": "Hájek",
    "psc": "28546",
    "okres": "Kutná Hora",
    "obec": "Úmonín",
    "val": "28546 Umonin Hajek"
  },
  {
    "cast": "Hájek",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Hájek",
    "val": "38773 Hajek Hajek"
  },
  {
    "cast": "Hájek",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Tišnov",
    "val": "66601 Tisnov Hajek"
  },
  {
    "cast": "Hájek",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Hájek",
    "val": "36301 Hajek Hajek"
  },
  {
    "cast": "Hájek u Uhříněvsi",
    "psc": "10400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10400 Praha Hajek u Uhrinevsi"
  },
  {
    "cast": "Hájemství",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Hajemstvi"
  },
  {
    "cast": "Hájky",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Stádlec",
    "val": "39161 Stadlec Hajky"
  },
  {
    "cast": "Hajnice (část)",
    "psc": "54466",
    "okres": "Trutnov",
    "obec": "Hajnice",
    "val": "54466 Hajnice Hajnice (cast)"
  },
  {
    "cast": "Hajnice (část)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Hajnice",
    "val": "54401 Hajnice Hajnice (cast)"
  },
  {
    "cast": "Hajniště",
    "psc": "46365",
    "okres": "Liberec",
    "obec": "Nové Město pod Smrkem",
    "val": "46365 Nove Mesto pod Smrkem Hajniste"
  },
  {
    "cast": "Hájov",
    "psc": "74258",
    "okres": "Nový Jičín",
    "obec": "Příbor",
    "val": "74258 Pribor Hajov"
  },
  {
    "cast": "Hajská",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Strakonice",
    "val": "38601 Strakonice Hajska"
  },
  {
    "cast": "Halámky",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Halámky",
    "val": "37806 Halamky Halamky"
  },
  {
    "cast": "Halenkov",
    "psc": "75603",
    "okres": "Vsetín",
    "obec": "Halenkov",
    "val": "75603 Halenkov Halenkov"
  },
  {
    "cast": "Halenkovice",
    "psc": "76363",
    "okres": "Zlín",
    "obec": "Halenkovice",
    "val": "76363 Halenkovice Halenkovice"
  },
  {
    "cast": "Halouny",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Svinaře",
    "val": "26727 Svinare Halouny"
  },
  {
    "cast": "Haluzice",
    "psc": "76324",
    "okres": "Zlín",
    "obec": "Haluzice",
    "val": "76324 Haluzice Haluzice"
  },
  {
    "cast": "Halže",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Halže",
    "val": "34701 Halze Halze"
  },
  {
    "cast": "Hamiltony",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Hamiltony"
  },
  {
    "cast": "Hamr",
    "psc": "43542",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43542 Litvinov Hamr"
  },
  {
    "cast": "Hamr",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Val",
    "val": "39181 Val Hamr"
  },
  {
    "cast": "Hamr",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Hamr",
    "val": "37806 Hamr Hamr"
  },
  {
    "cast": "Hamr na Jezeře",
    "psc": "47128",
    "okres": "Česká Lípa",
    "obec": "Hamr na Jezeře",
    "val": "47128 Hamr na Jezere Hamr na Jezere"
  },
  {
    "cast": "Hamrníky",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mariánské Lázně",
    "val": "35301 Marianske Lazne Hamrniky"
  },
  {
    "cast": "Hamry",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Hamry",
    "val": "34022 Hamry Hamry"
  },
  {
    "cast": "Hamry",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Plumlov",
    "val": "79803 Plumlov Hamry"
  },
  {
    "cast": "Hamry",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Bystré",
    "val": "56992 Bystre Hamry"
  },
  {
    "cast": "Hamry",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Hamry",
    "val": "53901 Hamry Hamry"
  },
  {
    "cast": "Hamry",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hradec",
    "val": "58401 Hradec Hamry"
  },
  {
    "cast": "Hamry nad Sázavou",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Hamry nad Sázavou",
    "val": "59101 Hamry nad Sazavou Hamry nad Sazavou"
  },
  {
    "cast": "Hamštejn",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Koberovy",
    "val": "46822 Koberovy Hamstejn"
  },
  {
    "cast": "Hanov",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Lestkov",
    "val": "34953 Lestkov Hanov"
  },
  {
    "cast": "Hanov",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Zběšičky",
    "val": "39843 Zbesicky Hanov"
  },
  {
    "cast": "Haňovice",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Haňovice",
    "val": "78321 Hanovice Hanovice"
  },
  {
    "cast": "Hanušov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Hanusov"
  },
  {
    "cast": "Hanušovice",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Hanušovice",
    "val": "78833 Hanusovice Hanusovice"
  },
  {
    "cast": "Haratice",
    "psc": "46846",
    "okres": "Jablonec nad Nisou",
    "obec": "Plavy",
    "val": "46846 Plavy Haratice"
  },
  {
    "cast": "Harrachov",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Rýmařov",
    "val": "79501 Rymarov Harrachov"
  },
  {
    "cast": "Harrachov",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Šluknov",
    "val": "40747 Sluknov Harrachov"
  },
  {
    "cast": "Harrachov",
    "psc": "51246",
    "okres": "Semily",
    "obec": "Harrachov",
    "val": "51246 Harrachov Harrachov"
  },
  {
    "cast": "Hartinkov",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Hartinkov",
    "val": "56943 Hartinkov Hartinkov"
  },
  {
    "cast": "Hartmanice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Hartmanice"
  },
  {
    "cast": "Hartmanice",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Hartmanice",
    "val": "56992 Hartmanice Hartmanice"
  },
  {
    "cast": "Hartmanice",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Hartmanice",
    "val": "37365 Hartmanice Hartmanice"
  },
  {
    "cast": "Hartoušov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Nebanice",
    "val": "35002 Nebanice Hartousov"
  },
  {
    "cast": "Hartunkov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Hartunkov"
  },
  {
    "cast": "Hartvíkov",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Hartvikov"
  },
  {
    "cast": "Hartvíkovice",
    "psc": "67576",
    "okres": "Třebíč",
    "obec": "Hartvíkovice",
    "val": "67576 Hartvikovice Hartvikovice"
  },
  {
    "cast": "Hařilova Lhotka",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Bezděkov",
    "val": "58301 Bezdekov Harilova Lhotka"
  },
  {
    "cast": "Hasina",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Rožďalovice",
    "val": "28934 Rozdalovice Hasina"
  },
  {
    "cast": "Haslice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Haslice"
  },
  {
    "cast": "Haškovcova Lhota",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Haškovcova Lhota",
    "val": "39165 Haskovcova Lhota Haskovcova Lhota"
  },
  {
    "cast": "Hašlovice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38101 Vetrni Haslovice"
  },
  {
    "cast": "Hašov",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34525 Horsovsky Tyn Hasov"
  },
  {
    "cast": "Hať",
    "psc": "74716",
    "okres": "Opava",
    "obec": "Hať",
    "val": "74716 Hat Hat"
  },
  {
    "cast": "Hatě",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Skuhrov",
    "val": "26727 Skuhrov Hate"
  },
  {
    "cast": "Hatě",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Bečváry",
    "val": "28144 Becvary Hate"
  },
  {
    "cast": "Hatě",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Chvalovice",
    "val": "66902 Chvalovice Hate"
  },
  {
    "cast": "Hatín",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Hatín",
    "val": "37701 Hatin Hatin"
  },
  {
    "cast": "Hatov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Hatov"
  },
  {
    "cast": "Haukovice",
    "psc": "78396",
    "okres": "Olomouc",
    "obec": "Újezd",
    "val": "78396 Ujezd Haukovice"
  },
  {
    "cast": "Havírna",
    "psc": "26241",
    "okres": "Příbram",
    "obec": "Bohutín",
    "val": "26241 Bohutin Havirna"
  },
  {
    "cast": "Havlíčkova Borová",
    "psc": "58223",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkova Borová",
    "val": "58223 Havlickova Borova Havlickova Borova"
  },
  {
    "cast": "Havlíčkův Brod",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Havlickuv Brod"
  },
  {
    "cast": "Havlovice",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53825 Miretice Havlovice"
  },
  {
    "cast": "Havlovice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Domažlice",
    "val": "34401 Domazlice Havlovice"
  },
  {
    "cast": "Havlovice",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Kobyly",
    "val": "46345 Kobyly Havlovice"
  },
  {
    "cast": "Havlovice (část)",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Havlovice",
    "val": "54232 Havlovice Havlovice (cast)"
  },
  {
    "cast": "Havlovice (část)",
    "psc": "54233",
    "okres": "Trutnov",
    "obec": "Havlovice",
    "val": "54233 Havlovice Havlovice (cast)"
  },
  {
    "cast": "Havraň",
    "psc": "43501",
    "okres": "Most",
    "obec": "Havraň",
    "val": "43501 Havran Havran"
  },
  {
    "cast": "Havraníky",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Havraníky",
    "val": "66902 Havraniky Havraniky"
  },
  {
    "cast": "Havřice",
    "psc": "68801",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Brod",
    "val": "68801 Uhersky Brod Havrice"
  },
  {
    "cast": "Hazlov",
    "psc": "35132",
    "okres": "Cheb",
    "obec": "Hazlov",
    "val": "35132 Hazlov Hazlov"
  },
  {
    "cast": "Hedčany",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kožlany",
    "val": "33141 Kozlany Hedcany"
  },
  {
    "cast": "Hedvikov",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Třemošnice",
    "val": "53843 Tremosnice Hedvikov"
  },
  {
    "cast": "Hejčín",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Hejcin"
  },
  {
    "cast": "Hejdlov",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Chvalšiny",
    "val": "38101 Chvalsiny Hejdlov"
  },
  {
    "cast": "Hejlov",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Svrabov",
    "val": "39131 Svrabov Hejlov"
  },
  {
    "cast": "Hejná",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Hejná",
    "val": "34101 Hejna Hejna"
  },
  {
    "cast": "Hejnice",
    "psc": "46362",
    "okres": "Liberec",
    "obec": "Hejnice",
    "val": "46362 Hejnice Hejnice"
  },
  {
    "cast": "Hejnice",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Hejnice",
    "val": "56401 Hejnice Hejnice"
  },
  {
    "cast": "Hejnov",
    "psc": "79371",
    "okres": "Bruntál",
    "obec": "Holčovice",
    "val": "79371 Holcovice Hejnov"
  },
  {
    "cast": "Hejtmánkovice",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Hejtmánkovice",
    "val": "55001 Hejtmankovice Hejtmankovice"
  },
  {
    "cast": "Helkovice",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Vysoké nad Jizerou",
    "val": "51301 Vysoke nad Jizerou Helkovice"
  },
  {
    "cast": "Heltínov",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Luboměř",
    "val": "74235 Lubomer Heltinov"
  },
  {
    "cast": "Helvíkov",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Anenská Studánka",
    "val": "56301 Anenska Studanka Helvikov"
  },
  {
    "cast": "Helvíkovice",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Helvíkovice",
    "val": "56401 Helvikovice Helvikovice"
  },
  {
    "cast": "Hely",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40747 Krasna Lipa Hely"
  },
  {
    "cast": "Hemže",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Choceň",
    "val": "56501 Chocen Hemze"
  },
  {
    "cast": "Henčlov-Přerov VIII x)",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Henclov-Prerov VIII x)"
  },
  {
    "cast": "Henčov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Hencov"
  },
  {
    "cast": "Herálec",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Herálec",
    "val": "58255 Heralec Heralec"
  },
  {
    "cast": "Herálec",
    "psc": "59201",
    "okres": "Žďár nad Sázavou",
    "obec": "Herálec",
    "val": "59201 Heralec Heralec"
  },
  {
    "cast": "Heraltice",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Heraltice",
    "val": "67521 Heraltice Heraltice"
  },
  {
    "cast": "Herbertov",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Vyšší Brod",
    "val": "38273 Vyssi Brod Herbertov"
  },
  {
    "cast": "Herbortice",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Cotkytle",
    "val": "56301 Cotkytle Herbortice"
  },
  {
    "cast": "Herink",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Herink",
    "val": "25101 Herink Herink"
  },
  {
    "cast": "Herlify",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Herlify"
  },
  {
    "cast": "Heroltice",
    "psc": "78991",
    "okres": "Šumperk",
    "obec": "Štíty",
    "val": "78991 Stity Heroltice"
  },
  {
    "cast": "Heroltice",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Heroltice"
  },
  {
    "cast": "Heroltice",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Heroltice",
    "val": "66601 Heroltice Heroltice"
  },
  {
    "cast": "Heroltice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Hoštice-Heroltice",
    "val": "68201 Hostice-Heroltice Heroltice"
  },
  {
    "cast": "Heroltovice",
    "psc": "78307",
    "okres": "Olomouc",
    "obec": "Město Libavá",
    "val": "78307 Mesto Libava Heroltovice"
  },
  {
    "cast": "Heroutice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Heroutice"
  },
  {
    "cast": "Herstošice",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Herstosice"
  },
  {
    "cast": "Heršpice (část)",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Heršpice",
    "val": "68501 Herspice Herspice (cast)"
  },
  {
    "cast": "Heršpice (část)",
    "psc": "68401",
    "okres": "Vyškov",
    "obec": "Heršpice",
    "val": "68401 Herspice Herspice (cast)"
  },
  {
    "cast": "Hertice",
    "psc": "74755",
    "okres": "Opava",
    "obec": "Dolní Životice",
    "val": "74755 Dolni Zivotice Hertice"
  },
  {
    "cast": "Hertvíkovice",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Mladé Buky",
    "val": "54101 Mlade Buky Hertvikovice"
  },
  {
    "cast": "Heřmaň",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Heřmaň",
    "val": "39811 Herman Herman"
  },
  {
    "cast": "Heřmaň",
    "psc": "58274",
    "okres": "Havlíčkův Brod",
    "obec": "Jeřišno",
    "val": "58274 Jerisno Herman"
  },
  {
    "cast": "Heřmaň (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Heřmaň",
    "val": "37006 Herman Herman (cast)"
  },
  {
    "cast": "Heřmaň (část)",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Heřmaň",
    "val": "37007 Herman Herman (cast)"
  },
  {
    "cast": "Heřmaneč",
    "psc": "39464",
    "okres": "Pelhřimov",
    "obec": "Počátky",
    "val": "39464 Pocatky Hermanec"
  },
  {
    "cast": "Heřmaneč",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Heřmaneč",
    "val": "37853 Hermanec Hermanec"
  },
  {
    "cast": "Heřmanice",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Hermanice"
  },
  {
    "cast": "Heřmanice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Žandov",
    "val": "47002 Zandov Hermanice"
  },
  {
    "cast": "Heřmanice",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Hermanice"
  },
  {
    "cast": "Heřmanice",
    "psc": "71300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71300 Ostrava Hermanice"
  },
  {
    "cast": "Heřmanice",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74101 Stary Jicin Hermanice"
  },
  {
    "cast": "Heřmanice",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Heřmanice",
    "val": "46401 Hermanice Hermanice"
  },
  {
    "cast": "Heřmanice",
    "psc": "55212",
    "okres": "Náchod",
    "obec": "Heřmanice",
    "val": "55212 Hermanice Hermanice"
  },
  {
    "cast": "Heřmanice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Heřmanice",
    "val": "58282 Hermanice Hermanice"
  },
  {
    "cast": "Heřmanice u Oder",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Heřmanice u Oder",
    "val": "74235 Hermanice u Oder Hermanice u Oder"
  },
  {
    "cast": "Heřmanice v Podještědí",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Hermanice v Podjestedi"
  },
  {
    "cast": "Heřmaničky",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Hermanicky"
  },
  {
    "cast": "Heřmaničky",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Hermanicky"
  },
  {
    "cast": "Heřmánkovice (část)",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Heřmánkovice",
    "val": "55001 Hermankovice Hermankovice (cast)"
  },
  {
    "cast": "Heřmánkovice (část)",
    "psc": "54984",
    "okres": "Náchod",
    "obec": "Heřmánkovice",
    "val": "54984 Hermankovice Hermankovice (cast)"
  },
  {
    "cast": "Heřmánky",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Hermanky"
  },
  {
    "cast": "Heřmánky",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Heřmánky",
    "val": "74235 Hermanky Hermanky"
  },
  {
    "cast": "Heřmanov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Heřmanov",
    "val": "40502 Hermanov Hermanov"
  },
  {
    "cast": "Heřmanov",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Hermanov"
  },
  {
    "cast": "Heřmanov",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Kolešovice",
    "val": "27004 Kolesovice Hermanov"
  },
  {
    "cast": "Heřmanov",
    "psc": "59458",
    "okres": "Žďár nad Sázavou",
    "obec": "Heřmanov",
    "val": "59458 Hermanov Hermanov"
  },
  {
    "cast": "Heřmanovice",
    "psc": "79374",
    "okres": "Bruntál",
    "obec": "Heřmanovice",
    "val": "79374 Hermanovice Hermanovice"
  },
  {
    "cast": "Heřmanův Městec",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Heřmanův Městec",
    "val": "53803 Hermanuv Mestec Hermanuv Mestec"
  },
  {
    "cast": "Hetlín",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Černíny",
    "val": "28401 Cerniny Hetlin"
  },
  {
    "cast": "Hevlín",
    "psc": "67169",
    "okres": "Znojmo",
    "obec": "Hevlín",
    "val": "67169 Hevlin Hevlin"
  },
  {
    "cast": "Hillův Mlýn",
    "psc": "40745",
    "okres": "Děčín",
    "obec": "Kytlice",
    "val": "40745 Kytlice Hilluv Mlyn"
  },
  {
    "cast": "Hladké Životice",
    "psc": "74247",
    "okres": "Nový Jičín",
    "obec": "Hladké Životice",
    "val": "74247 Hladke Zivotice Hladke Zivotice"
  },
  {
    "cast": "Hladná (část)",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Albrechtice nad Vltavou",
    "val": "39811 Albrechtice nad Vltavou Hladna (cast)"
  },
  {
    "cast": "Hladná (část)",
    "psc": "39816",
    "okres": "Písek",
    "obec": "Albrechtice nad Vltavou",
    "val": "39816 Albrechtice nad Vltavou Hladna (cast)"
  },
  {
    "cast": "Hladov",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Hladov",
    "val": "58833 Hladov Hladov"
  },
  {
    "cast": "Hlasívko",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Hlasivo",
    "val": "39143 Hlasivo Hlasivko"
  },
  {
    "cast": "Hlasivo",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Hlasivo",
    "val": "39143 Hlasivo Hlasivo"
  },
  {
    "cast": "Hláska",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Olšovice",
    "val": "38411 Olsovice Hlaska"
  },
  {
    "cast": "Hláska",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51601 Liberk Hlaska"
  },
  {
    "cast": "Hlásná Lhota",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Podhradí",
    "val": "50601 Podhradi Hlasna Lhota"
  },
  {
    "cast": "Hlásná Lhota",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Záblatí",
    "val": "38301 Zablati Hlasna Lhota"
  },
  {
    "cast": "Hlásná Třebaň",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Hlásná Třebaň",
    "val": "26718 Hlasna Treban Hlasna Treban"
  },
  {
    "cast": "Hlásnice",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Hlásnice",
    "val": "78501 Hlasnice Hlasnice"
  },
  {
    "cast": "Hlásnice",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Trpín",
    "val": "56992 Trpin Hlasnice"
  },
  {
    "cast": "Hlaváčkova Lhota",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Ješetice",
    "val": "25789 Jesetice Hlavackova Lhota"
  },
  {
    "cast": "Hlavatce",
    "psc": "39173",
    "okres": "Tábor",
    "obec": "Hlavatce",
    "val": "39173 Hlavatce Hlavatce"
  },
  {
    "cast": "Hlavatce",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Hlavatce",
    "val": "37348 Hlavatce Hlavatce"
  },
  {
    "cast": "Hlavečník",
    "psc": "53315",
    "okres": "Pardubice",
    "obec": "Hlavečník",
    "val": "53315 Hlavecnik Hlavecnik"
  },
  {
    "cast": "Hlavenec",
    "psc": "29474",
    "okres": "Praha-východ",
    "obec": "Hlavenec",
    "val": "29474 Hlavenec Hlavenec"
  },
  {
    "cast": "Hlavice",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Hlavice",
    "val": "46348 Hlavice Hlavice"
  },
  {
    "cast": "Hlávkov",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Vyskytná nad Jihlavou",
    "val": "58841 Vyskytna nad Jihlavou Hlavkov"
  },
  {
    "cast": "Hlavná",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Žampach",
    "val": "56401 Zampach Hlavna"
  },
  {
    "cast": "Hlavnice",
    "psc": "74752",
    "okres": "Opava",
    "obec": "Hlavnice",
    "val": "74752 Hlavnice Hlavnice"
  },
  {
    "cast": "Hlavno",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Citice",
    "val": "35709 Citice Hlavno"
  },
  {
    "cast": "Hlavňov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Budislav",
    "val": "39201 Budislav Hlavnov"
  },
  {
    "cast": "Hlavňov",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Police nad Metují",
    "val": "54954 Police nad Metuji Hlavnov"
  },
  {
    "cast": "Hlavňov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58001 Krasna Hora Hlavnov"
  },
  {
    "cast": "Hlavňovice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Hlavnovice"
  },
  {
    "cast": "Hleďsebe",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Lhotka",
    "val": "27731 Lhotka Hledsebe"
  },
  {
    "cast": "Hleďsebe",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Hledsebe"
  },
  {
    "cast": "Hleďsebe",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Hledsebe"
  },
  {
    "cast": "Hleďsebe 1.díl",
    "psc": "27751",
    "okres": "Mělník",
    "obec": "Nelahozeves",
    "val": "27751 Nelahozeves Hledsebe 1.dil"
  },
  {
    "cast": "Hleďsebe 2.díl",
    "psc": "27751",
    "okres": "Mělník",
    "obec": "Nelahozeves",
    "val": "27751 Nelahozeves Hledsebe 2.dil"
  },
  {
    "cast": "Hlemýždí",
    "psc": "47129",
    "okres": "Česká Lípa",
    "obec": "Brniště",
    "val": "47129 Brniste Hlemyzdi"
  },
  {
    "cast": "Hlína",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Hlína",
    "val": "66491 Hlina Hlina"
  },
  {
    "cast": "Hlína",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Horka",
    "val": "53851 Horka Hlina"
  },
  {
    "cast": "Hliňánky",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Hlinanky"
  },
  {
    "cast": "Hliňany",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Řehlovice",
    "val": "40002 Rehlovice Hlinany"
  },
  {
    "cast": "Hlince",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Hlince",
    "val": "33141 Hlince Hlince"
  },
  {
    "cast": "Hlince",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Kostomlaty pod Milešovkou",
    "val": "41501 Kostomlaty pod Milesovkou Hlince"
  },
  {
    "cast": "Hlincová Hora",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Hlincová Hora",
    "val": "37371 Hlincova Hora Hlincova Hora"
  },
  {
    "cast": "Hlineč",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Hlinec"
  },
  {
    "cast": "Hliněná",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40502 Malsovice Hlinena"
  },
  {
    "cast": "Hliněný Újezd",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Malý Bor",
    "val": "34101 Maly Bor Hlineny Ujezd"
  },
  {
    "cast": "Hlinice",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39002 Tabor Hlinice"
  },
  {
    "cast": "Hliniště",
    "psc": "38443",
    "okres": "Prachatice",
    "obec": "Strážný",
    "val": "38443 Strazny Hliniste"
  },
  {
    "cast": "Hlinka",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Hlinka",
    "val": "79399 Hlinka Hlinka"
  },
  {
    "cast": "Hlinky",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Stanovice",
    "val": "36001 Stanovice Hlinky"
  },
  {
    "cast": "Hlinná",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Hlinná",
    "val": "41201 Hlinna Hlinna"
  },
  {
    "cast": "Hlinné",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobré",
    "val": "51801 Dobre Hlinne"
  },
  {
    "cast": "Hlinné",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Hlinne"
  },
  {
    "cast": "Hlinné (část)",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tisová",
    "val": "34701 Tisova Hlinne (cast)"
  },
  {
    "cast": "Hlinné (část)",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Tisová",
    "val": "34801 Tisova Hlinne (cast)"
  },
  {
    "cast": "Hlinov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Hlinov"
  },
  {
    "cast": "Hlínoviště",
    "psc": "29421",
    "okres": "Mladá Boleslav",
    "obec": "Bělá pod Bezdězem",
    "val": "29421 Bela pod Bezdezem Hlinoviste"
  },
  {
    "cast": "Hlinsko",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Hlinsko",
    "val": "75131 Hlinsko Hlinsko"
  },
  {
    "cast": "Hlinsko",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Hlinsko",
    "val": "53901 Hlinsko Hlinsko"
  },
  {
    "cast": "Hlinsko",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Rudolfov",
    "val": "37001 Rudolfov Hlinsko"
  },
  {
    "cast": "Hlinsko pod Hostýnem",
    "psc": "76841",
    "okres": "Kroměříž",
    "obec": "Bystřice pod Hostýnem",
    "val": "76841 Bystrice pod Hostynem Hlinsko pod Hostynem"
  },
  {
    "cast": "Hlivice",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Medlov",
    "val": "78391 Medlov Hlivice"
  },
  {
    "cast": "Hlivín",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25703 Bystrice Hlivin"
  },
  {
    "cast": "Hlízov",
    "psc": "28532",
    "okres": "Kutná Hora",
    "obec": "Hlízov",
    "val": "28532 Hlizov Hlizov"
  },
  {
    "cast": "Hlohov",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Číhošť",
    "val": "58401 Cihost Hlohov"
  },
  {
    "cast": "Hlohov (část)",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25801 Zvestov Hlohov (cast)"
  },
  {
    "cast": "Hlohov (část)",
    "psc": "25705",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25705 Zvestov Hlohov (cast)"
  },
  {
    "cast": "Hlohov (část)",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Hlohov (cast)"
  },
  {
    "cast": "Hlohová",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Hlohová",
    "val": "34561 Hlohova Hlohova"
  },
  {
    "cast": "Hlohovčice",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Hlohovčice",
    "val": "34561 Hlohovcice Hlohovcice"
  },
  {
    "cast": "Hlohovec",
    "psc": "69143",
    "okres": "Břeclav",
    "obec": "Hlohovec",
    "val": "69143 Hlohovec Hlohovec"
  },
  {
    "cast": "Hlohovice",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Hlohovice",
    "val": "33808 Hlohovice Hlohovice"
  },
  {
    "cast": "Hlohovičky",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Hlohovice",
    "val": "33808 Hlohovice Hlohovicky"
  },
  {
    "cast": "Hloubětín (část)",
    "psc": "19000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19000 Praha Hloubetin (cast)"
  },
  {
    "cast": "Hloubětín (část)",
    "psc": "19800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19800 Praha Hloubetin (cast)"
  },
  {
    "cast": "Hlouška (část)",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Hlouska (cast)"
  },
  {
    "cast": "Hlouška (část)",
    "psc": "28403",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28403 Kutna Hora Hlouska (cast)"
  },
  {
    "cast": "Hlubany",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Hlubany"
  },
  {
    "cast": "Hlubočany",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Hlubočany",
    "val": "68201 Hlubocany Hlubocany"
  },
  {
    "cast": "Hlubočec",
    "psc": "74769",
    "okres": "Opava",
    "obec": "Hlubočec",
    "val": "74769 Hlubocec Hlubocec"
  },
  {
    "cast": "Hlubočepy (část)",
    "psc": "15000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15000 Praha Hlubocepy (cast)"
  },
  {
    "cast": "Hlubočepy (část)",
    "psc": "15200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15200 Praha Hlubocepy (cast)"
  },
  {
    "cast": "Hlubočepy (část)",
    "psc": "15400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15400 Praha Hlubocepy (cast)"
  },
  {
    "cast": "Hlubočinka",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Sulice",
    "val": "25168 Sulice Hlubocinka"
  },
  {
    "cast": "Hlubočky",
    "psc": "78361",
    "okres": "Olomouc",
    "obec": "Hlubočky",
    "val": "78361 Hlubocky Hlubocky"
  },
  {
    "cast": "Hluboká",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Hluboka"
  },
  {
    "cast": "Hluboká",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Milhostov",
    "val": "35134 Milhostov Hluboka"
  },
  {
    "cast": "Hluboká",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Hluboká",
    "val": "53973 Hluboka Hluboka"
  },
  {
    "cast": "Hluboká",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Žihle",
    "val": "33165 Zihle Hluboka"
  },
  {
    "cast": "Hluboká",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nalžovice",
    "val": "26401 Nalzovice Hluboka"
  },
  {
    "cast": "Hluboká",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Dešná",
    "val": "37881 Desna Hluboka"
  },
  {
    "cast": "Hluboká",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Sruby",
    "val": "56601 Sruby Hluboka"
  },
  {
    "cast": "Hluboká",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Trhová Kamenice",
    "val": "53901 Trhova Kamenice Hluboka"
  },
  {
    "cast": "Hluboká",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Krucemburk",
    "val": "58263 Krucemburk Hluboka"
  },
  {
    "cast": "Hluboká nad Vltavou",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Hluboka nad Vltavou"
  },
  {
    "cast": "Hluboká u Borovan",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Borovany",
    "val": "37312 Borovany Hluboka u Borovan"
  },
  {
    "cast": "Hluboká-Liberec XXVIII x)",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46312 Liberec Hluboka-Liberec XXVIII x)"
  },
  {
    "cast": "Hluboké",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Dalečín",
    "val": "59265 Dalecin Hluboke"
  },
  {
    "cast": "Hluboké",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Hluboké",
    "val": "67571 Hluboke Hluboke"
  },
  {
    "cast": "Hluboké Dvory (část)",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Hluboké Dvory",
    "val": "67923 Hluboke Dvory Hluboke Dvory (cast)"
  },
  {
    "cast": "Hluboké Dvory (část)",
    "psc": "67924",
    "okres": "Brno-venkov",
    "obec": "Hluboké Dvory",
    "val": "67924 Hluboke Dvory Hluboke Dvory (cast)"
  },
  {
    "cast": "Hluboké Mašůvky",
    "psc": "67152",
    "okres": "Znojmo",
    "obec": "Hluboké Mašůvky",
    "val": "67152 Hluboke Masuvky Hluboke Masuvky"
  },
  {
    "cast": "Hluboké u Kunštátu",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Kunštát",
    "val": "67972 Kunstat Hluboke u Kunstatu"
  },
  {
    "cast": "Hluboký",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Hluboky"
  },
  {
    "cast": "Hluboký Důl",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Nebovidy",
    "val": "28002 Nebovidy Hluboky Dul"
  },
  {
    "cast": "Hluboš (část)",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Hluboš",
    "val": "26223 Hlubos Hlubos (cast)"
  },
  {
    "cast": "Hluboš (část)",
    "psc": "26222",
    "okres": "Příbram",
    "obec": "Hluboš",
    "val": "26222 Hlubos Hlubos (cast)"
  },
  {
    "cast": "Hluboš (část)",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Hluboš",
    "val": "26101 Hlubos Hlubos (cast)"
  },
  {
    "cast": "Hlubyně",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Hlubyně",
    "val": "26272 Hlubyne Hlubyne"
  },
  {
    "cast": "Hlučín",
    "psc": "74801",
    "okres": "Opava",
    "obec": "Hlučín",
    "val": "74801 Hlucin Hlucin"
  },
  {
    "cast": "Hluchov",
    "psc": "79841",
    "okres": "Prostějov",
    "obec": "Hluchov",
    "val": "79841 Hluchov Hluchov"
  },
  {
    "cast": "Hluk",
    "psc": "68725",
    "okres": "Uherské Hradiště",
    "obec": "Hluk",
    "val": "68725 Hluk Hluk"
  },
  {
    "cast": "Hluky",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kounov",
    "val": "51801 Kounov Hluky"
  },
  {
    "cast": "Hlupenov",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Hlupenov"
  },
  {
    "cast": "Hlupín",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Hlupín",
    "val": "38601 Hlupin Hlupin"
  },
  {
    "cast": "Hlušice",
    "psc": "50356",
    "okres": "Hradec Králové",
    "obec": "Hlušice",
    "val": "50356 Hlusice Hlusice"
  },
  {
    "cast": "Hlušičky",
    "psc": "50356",
    "okres": "Hradec Králové",
    "obec": "Hlušice",
    "val": "50356 Hlusice Hlusicky"
  },
  {
    "cast": "Hlušovice",
    "psc": "78314",
    "okres": "Olomouc",
    "obec": "Hlušovice",
    "val": "78314 Hlusovice Hlusovice"
  },
  {
    "cast": "Hluzov",
    "psc": "75368",
    "okres": "Přerov",
    "obec": "Černotín",
    "val": "75368 Cernotin Hluzov"
  },
  {
    "cast": "Hnačov",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Hnačov",
    "val": "34034 Hnacov Hnacov"
  },
  {
    "cast": "Hnanice",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Hnanice",
    "val": "66902 Hnanice Hnanice"
  },
  {
    "cast": "Hnanice",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51263 Hruba Skala Hnanice"
  },
  {
    "cast": "Hnátnice",
    "psc": "56101",
    "okres": "Ústí nad Orlicí",
    "obec": "Hnátnice",
    "val": "56101 Hnatnice Hnatnice"
  },
  {
    "cast": "Hněvanice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Hnevanice"
  },
  {
    "cast": "Hněvanov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Rožmitál na Šumavě",
    "val": "38241 Rozmital na Sumave Hnevanov"
  },
  {
    "cast": "Hněvčeves",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Hněvčeves",
    "val": "50315 Hnevceves Hnevceves"
  },
  {
    "cast": "Hněvětice",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Hnevetice"
  },
  {
    "cast": "Hněvice",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Hnevice"
  },
  {
    "cast": "Hněvkov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Zábřeh",
    "val": "78901 Zabreh Hnevkov"
  },
  {
    "cast": "Hněvkov",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Hnevkov"
  },
  {
    "cast": "Hněvkovice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Hnevkovice"
  },
  {
    "cast": "Hněvkovice na levém břehu Vltavy",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Týn nad Vltavou",
    "val": "37501 Tyn nad Vltavou Hnevkovice na levem brehu Vltavy"
  },
  {
    "cast": "Hněvkovice (část)",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58401 Hnevkovice Hnevkovice (cast)"
  },
  {
    "cast": "Hněvkovice (část)",
    "psc": "58294",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58294 Hnevkovice Hnevkovice (cast)"
  },
  {
    "cast": "Hněvnice",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Hněvnice",
    "val": "33023 Hnevnice Hnevnice"
  },
  {
    "cast": "Hněvošice",
    "psc": "74735",
    "okres": "Opava",
    "obec": "Hněvošice",
    "val": "74735 Hnevosice Hnevosice"
  },
  {
    "cast": "Hněvotín",
    "psc": "78347",
    "okres": "Olomouc",
    "obec": "Hněvotín",
    "val": "78347 Hnevotin Hnevotin"
  },
  {
    "cast": "Hněvousice",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Hnevousice"
  },
  {
    "cast": "Hněvšín",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Hnevsin"
  },
  {
    "cast": "Hnízdo",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Vrbovec",
    "val": "66902 Vrbovec Hnizdo"
  },
  {
    "cast": "Hnojice",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Hnojice",
    "val": "78501 Hnojice Hnojice"
  },
  {
    "cast": "Hnojná Lhotka",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Slapy",
    "val": "39175 Slapy Hnojna Lhotka"
  },
  {
    "cast": "Hnojnice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Hnojnice"
  },
  {
    "cast": "Hnojník",
    "psc": "73953",
    "okres": "Frýdek-Místek",
    "obec": "Hnojník",
    "val": "73953 Hnojnik Hnojnik"
  },
  {
    "cast": "Hobšovice",
    "psc": "27321",
    "okres": "Kladno",
    "obec": "Hobšovice",
    "val": "27321 Hobsovice Hobsovice"
  },
  {
    "cast": "Hoděčín",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Olešnice",
    "val": "51721 Olesnice Hodecin"
  },
  {
    "cast": "Hodějice (část)",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Hodějice",
    "val": "68501 Hodejice Hodejice (cast)"
  },
  {
    "cast": "Hodějice (část)",
    "psc": "68401",
    "okres": "Vyškov",
    "obec": "Hodějice",
    "val": "68401 Hodejice Hodejice (cast)"
  },
  {
    "cast": "Hodějov",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Hoslovice",
    "val": "38716 Hoslovice Hodejov"
  },
  {
    "cast": "Hodějovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Hodejovice"
  },
  {
    "cast": "Hoděmyšl",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Sedlice",
    "val": "26242 Sedlice Hodemysl"
  },
  {
    "cast": "Hoděšovice",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Býšť",
    "val": "53401 Byst Hodesovice"
  },
  {
    "cast": "Hodětice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Hodetice"
  },
  {
    "cast": "Hodětín (část)",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Hodětín",
    "val": "39165 Hodetin Hodetin (cast)"
  },
  {
    "cast": "Hodětín (část)",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Hodětín",
    "val": "39181 Hodetin Hodetin (cast)"
  },
  {
    "cast": "Hodice",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Hodice",
    "val": "58901 Hodice Hodice"
  },
  {
    "cast": "Hodíškov",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Hodíškov",
    "val": "59101 Hodiskov Hodiskov"
  },
  {
    "cast": "Hodkov",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Hodkov"
  },
  {
    "cast": "Hodkov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Hodkov"
  },
  {
    "cast": "Hodkov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Hodkov"
  },
  {
    "cast": "Hodkovice",
    "psc": "25241",
    "okres": "Praha-západ",
    "obec": "Zlatníky-Hodkovice",
    "val": "25241 Zlatniky-Hodkovice Hodkovice"
  },
  {
    "cast": "Hodkovice nad Mohelkou",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Hodkovice nad Mohelkou",
    "val": "46342 Hodkovice nad Mohelkou Hodkovice nad Mohelkou"
  },
  {
    "cast": "Hodkovičky (část)",
    "psc": "14700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14700 Praha Hodkovicky (cast)"
  },
  {
    "cast": "Hodkovičky (část)",
    "psc": "14200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14200 Praha Hodkovicky (cast)"
  },
  {
    "cast": "Hodky",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Světlá pod Ještědem",
    "val": "46343 Svetla pod Jestedem Hodky"
  },
  {
    "cast": "Hodňov",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Horní Planá",
    "val": "38226 Horni Plana Hodnov"
  },
  {
    "cast": "Hodolany",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Hodolany"
  },
  {
    "cast": "Hodonice",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Hodonice",
    "val": "39165 Hodonice Hodonice"
  },
  {
    "cast": "Hodonice",
    "psc": "67125",
    "okres": "Znojmo",
    "obec": "Hodonice",
    "val": "67125 Hodonice Hodonice"
  },
  {
    "cast": "Hodonín",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Hodonin"
  },
  {
    "cast": "Hodonín",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Hodonín",
    "val": "53825 Hodonin Hodonin"
  },
  {
    "cast": "Hodonín",
    "psc": "69501",
    "okres": "Hodonín",
    "obec": "Hodonín",
    "val": "69501 Hodonin Hodonin"
  },
  {
    "cast": "Hodonín",
    "psc": "67975",
    "okres": "Blansko",
    "obec": "Hodonín",
    "val": "67975 Hodonin Hodonin"
  },
  {
    "cast": "Hodoňovice",
    "psc": "73901",
    "okres": "Frýdek-Místek",
    "obec": "Baška",
    "val": "73901 Baska Hodonovice"
  },
  {
    "cast": "Hodousice",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Nýrsko",
    "val": "34022 Nyrsko Hodousice"
  },
  {
    "cast": "Hodov (část)",
    "psc": "67504",
    "okres": "Třebíč",
    "obec": "Hodov",
    "val": "67504 Hodov Hodov (cast)"
  },
  {
    "cast": "Hodov (část)",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Hodov",
    "val": "67503 Hodov Hodov (cast)"
  },
  {
    "cast": "Hodoviz",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Hvozd",
    "val": "33101 Hvozd Hodoviz"
  },
  {
    "cast": "Hodslavice",
    "psc": "74271",
    "okres": "Nový Jičín",
    "obec": "Hodslavice",
    "val": "74271 Hodslavice Hodslavice"
  },
  {
    "cast": "Hodušín",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Opařany",
    "val": "39161 Oparany Hodusin"
  },
  {
    "cast": "Hodyně",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Skuhrov",
    "val": "26727 Skuhrov Hodyne"
  },
  {
    "cast": "Hodyně",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kožlany",
    "val": "33141 Kozlany Hodyne"
  },
  {
    "cast": "Hojanovice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Hojanovice",
    "val": "39601 Hojanovice Hojanovice"
  },
  {
    "cast": "Hojava",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Lidmaň",
    "val": "39501 Lidman Hojava"
  },
  {
    "cast": "Hoješín",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Hojesin"
  },
  {
    "cast": "Hojkov",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Hojkov",
    "val": "58805 Hojkov Hojkov"
  },
  {
    "cast": "Hojkovy",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Mladé Bříště",
    "val": "39601 Mlade Briste Hojkovy"
  },
  {
    "cast": "Hojná Voda",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Hojna Voda"
  },
  {
    "cast": "Hojovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Hojovice",
    "val": "39501 Hojovice Hojovice"
  },
  {
    "cast": "Hojsova Stráž",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Železná Ruda",
    "val": "34022 Zelezna Ruda Hojsova Straz"
  },
  {
    "cast": "Hojšín",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Hojsin"
  },
  {
    "cast": "Hojšín (část)",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26263 Svaty Jan Hojsin (cast)"
  },
  {
    "cast": "Hojšín (část)",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26256 Svaty Jan Hojsin (cast)"
  },
  {
    "cast": "Hokov",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Hořovičky",
    "val": "27004 Horovicky Hokov"
  },
  {
    "cast": "Holany",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Holany",
    "val": "47002 Holany Holany"
  },
  {
    "cast": "Holasice",
    "psc": "66461",
    "okres": "Brno-venkov",
    "obec": "Holasice",
    "val": "66461 Holasice Holasice"
  },
  {
    "cast": "Holasice",
    "psc": "66471",
    "okres": "Brno-venkov",
    "obec": "Lažánky",
    "val": "66471 Lazanky Holasice"
  },
  {
    "cast": "Holásky",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Holasky"
  },
  {
    "cast": "Holasovice",
    "psc": "74774",
    "okres": "Opava",
    "obec": "Holasovice",
    "val": "74774 Holasovice Holasovice"
  },
  {
    "cast": "Holašovice",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Jankov",
    "val": "37384 Jankov Holasovice"
  },
  {
    "cast": "Holčovice",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Holcovice"
  },
  {
    "cast": "Holčovice",
    "psc": "79371",
    "okres": "Bruntál",
    "obec": "Holčovice",
    "val": "79371 Holcovice Holcovice"
  },
  {
    "cast": "Hole",
    "psc": "25264",
    "okres": "Praha-západ",
    "obec": "Svrkyně",
    "val": "25264 Svrkyne Hole"
  },
  {
    "cast": "Holé Vrchy",
    "psc": "29446",
    "okres": "Mladá Boleslav",
    "obec": "Dobrovice",
    "val": "29446 Dobrovice Hole Vrchy"
  },
  {
    "cast": "Holečkov",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Malovice",
    "val": "38411 Malovice Holeckov"
  },
  {
    "cast": "Holedeč",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Holedeč",
    "val": "43801 Holedec Holedec"
  },
  {
    "cast": "Holedeček",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Holedeč",
    "val": "43801 Holedec Holedecek"
  },
  {
    "cast": "Holenice",
    "psc": "50601",
    "okres": "Semily",
    "obec": "Holenice",
    "val": "50601 Holenice Holenice"
  },
  {
    "cast": "Holešice",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Cizkrajov",
    "val": "37881 Cizkrajov Holesice"
  },
  {
    "cast": "Holešín",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Rájec-Jestřebí",
    "val": "67902 Rajec-Jestrebi Holesin"
  },
  {
    "cast": "Holešov",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Holešov",
    "val": "76901 Holesov Holesov"
  },
  {
    "cast": "Holešovice",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Chroustovice",
    "val": "53863 Chroustovice Holesovice"
  },
  {
    "cast": "Holešovice (část)",
    "psc": "17000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "17000 Praha Holesovice (cast)"
  },
  {
    "cast": "Holešovice (část)",
    "psc": "11800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "11800 Praha Holesovice (cast)"
  },
  {
    "cast": "Holetice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Březno",
    "val": "43801 Brezno Holetice"
  },
  {
    "cast": "Holice",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Holice"
  },
  {
    "cast": "Holice",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Holice",
    "val": "53401 Holice Holice"
  },
  {
    "cast": "Holičky",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Třeboň",
    "val": "37901 Trebon Holicky"
  },
  {
    "cast": "Holičky",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Morašice",
    "val": "53803 Morasice Holicky"
  },
  {
    "cast": "Holín",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Holín",
    "val": "50601 Holin Holin"
  },
  {
    "cast": "Holín",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Holin"
  },
  {
    "cast": "Holínské Předměstí",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Holinske Predmesti"
  },
  {
    "cast": "Holkov",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Velešín",
    "val": "38232 Velesin Holkov"
  },
  {
    "cast": "Holkovice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Chanovice",
    "val": "34101 Chanovice Holkovice"
  },
  {
    "cast": "Holohlavy",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Holohlavy",
    "val": "50303 Holohlavy Holohlavy"
  },
  {
    "cast": "Holostřevy",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Holostrevy"
  },
  {
    "cast": "Hološiny",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Petrovice I",
    "val": "28601 Petrovice I Holosiny"
  },
  {
    "cast": "Holotín",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Holotín",
    "val": "53501 Holotin Holotin"
  },
  {
    "cast": "Holoubkov",
    "psc": "33801",
    "okres": "Rokycany",
    "obec": "Holoubkov",
    "val": "33801 Holoubkov Holoubkov"
  },
  {
    "cast": "Holousy",
    "psc": "27341",
    "okres": "Kladno",
    "obec": "Třebusice",
    "val": "27341 Trebusice Holousy"
  },
  {
    "cast": "Holovousy",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Holovousy",
    "val": "33141 Holovousy Holovousy"
  },
  {
    "cast": "Holovousy",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Holovousy",
    "val": "50801 Holovousy Holovousy"
  },
  {
    "cast": "Holšice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Chabeřice",
    "val": "28522 Chaberice Holsice"
  },
  {
    "cast": "Holštejn",
    "psc": "67913",
    "okres": "Blansko",
    "obec": "Holštejn",
    "val": "67913 Holstejn Holstejn"
  },
  {
    "cast": "Holubeč",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Holubec"
  },
  {
    "cast": "Holubí Zhoř",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Holubi Zhor"
  },
  {
    "cast": "Holubice",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Ptení",
    "val": "79803 Pteni Holubice"
  },
  {
    "cast": "Holubice",
    "psc": "68351",
    "okres": "Vyškov",
    "obec": "Holubice",
    "val": "68351 Holubice Holubice"
  },
  {
    "cast": "Holubice",
    "psc": "25265",
    "okres": "Praha-západ",
    "obec": "Holubice",
    "val": "25265 Holubice Holubice"
  },
  {
    "cast": "Holubín",
    "psc": "34813",
    "okres": "Tachov",
    "obec": "Chodová Planá",
    "val": "34813 Chodova Plana Holubin"
  },
  {
    "cast": "Holubov",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Holubov",
    "val": "38203 Holubov Holubov"
  },
  {
    "cast": "Holubovská Bašta",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Čakov",
    "val": "37384 Cakov Holubovska Basta"
  },
  {
    "cast": "Holušice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Sedlice",
    "val": "38801 Sedlice Holusice"
  },
  {
    "cast": "Holušice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Kaliště",
    "val": "39601 Kaliste Holusice"
  },
  {
    "cast": "Holušice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Kozárovice",
    "val": "26272 Kozarovice Holusice"
  },
  {
    "cast": "Holyně",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Svojšín",
    "val": "34901 Svojsin Holyne"
  },
  {
    "cast": "Holyně",
    "psc": "15400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15400 Praha Holyne"
  },
  {
    "cast": "Holýšov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Mezilesí",
    "val": "39501 Mezilesi Holysov"
  },
  {
    "cast": "Holýšov (část)",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Holýšov",
    "val": "34562 Holysov Holysov (cast)"
  },
  {
    "cast": "Holýšov (část)",
    "psc": "33452",
    "okres": "Domažlice",
    "obec": "Holýšov",
    "val": "33452 Holysov Holysov (cast)"
  },
  {
    "cast": "Homole",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Drhovy",
    "val": "26301 Drhovy Homole"
  },
  {
    "cast": "Homole",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Homole",
    "val": "37001 Homole Homole"
  },
  {
    "cast": "Homole",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Borovnice",
    "val": "51741 Borovnice Homole"
  },
  {
    "cast": "Homole u Panny",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Homole u Panny"
  },
  {
    "cast": "Homyle",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Boharyně",
    "val": "50315 Boharyne Homyle"
  },
  {
    "cast": "Honbice",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Honbice",
    "val": "53862 Honbice Honbice"
  },
  {
    "cast": "Honětice",
    "psc": "76813",
    "okres": "Kroměříž",
    "obec": "Honětice",
    "val": "76813 Honetice Honetice"
  },
  {
    "cast": "Honezovice",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Honezovice",
    "val": "33301 Honezovice Honezovice"
  },
  {
    "cast": "Honice",
    "psc": "27303",
    "okres": "Kladno",
    "obec": "Stochov",
    "val": "27303 Stochov Honice"
  },
  {
    "cast": "Honsob",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Březina",
    "val": "29501 Brezina Honsob"
  },
  {
    "cast": "Hony",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Police nad Metují",
    "val": "54954 Police nad Metuji Hony"
  },
  {
    "cast": "Hora Svaté Kateřiny",
    "psc": "43546",
    "okres": "Most",
    "obec": "Hora Svaté Kateřiny",
    "val": "43546 Hora Svate Kateriny Hora Svate Kateriny"
  },
  {
    "cast": "Hora Svatého Šebestiána",
    "psc": "43182",
    "okres": "Chomutov",
    "obec": "Hora Svatého Šebestiána",
    "val": "43182 Hora Svateho Sebestiana Hora Svateho Sebestiana"
  },
  {
    "cast": "Hora Svatého Václava",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Hora Svatého Václava",
    "val": "34522 Hora Svateho Vaclava Hora Svateho Vaclava"
  },
  {
    "cast": "Horákov",
    "psc": "66404",
    "okres": "Brno-venkov",
    "obec": "Mokrá-Horákov",
    "val": "66404 Mokra-Horakov Horakov"
  },
  {
    "cast": "Horákova Lhota",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Želivsko",
    "val": "56904 Zelivsko Horakova Lhota"
  },
  {
    "cast": "Horažďovice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Horažďovice",
    "val": "34101 Horazdovice Horazdovice"
  },
  {
    "cast": "Horažďovická Lhota",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Horažďovice",
    "val": "34101 Horazdovice Horazdovicka Lhota"
  },
  {
    "cast": "Horčápsko",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Horčápsko",
    "val": "26272 Horcapsko Horcapsko"
  },
  {
    "cast": "Horka",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Nový Kostel",
    "val": "35134 Novy Kostel Horka"
  },
  {
    "cast": "Horka",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Přišimasy",
    "val": "28201 Prisimasy Horka"
  },
  {
    "cast": "Horka",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Evaň",
    "val": "41002 Evan Horka"
  },
  {
    "cast": "Horka",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Horka",
    "val": "53851 Horka Horka"
  },
  {
    "cast": "Horka",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Proseč pod Ještědem",
    "val": "46343 Prosec pod Jestedem Horka"
  },
  {
    "cast": "Horka",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Horka"
  },
  {
    "cast": "Horka I",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Horka I",
    "val": "28601 Horka I Horka I"
  },
  {
    "cast": "Horka II",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Horka II",
    "val": "28522 Horka II Horka II"
  },
  {
    "cast": "Horka nad Moravou",
    "psc": "78335",
    "okres": "Olomouc",
    "obec": "Horka nad Moravou",
    "val": "78335 Horka nad Moravou Horka nad Moravou"
  },
  {
    "cast": "Horka u Staré Paky",
    "psc": "51234",
    "okres": "Semily",
    "obec": "Horka u Staré Paky",
    "val": "51234 Horka u Stare Paky Horka u Stare Paky"
  },
  {
    "cast": "Horka-Domky",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Horka-Domky"
  },
  {
    "cast": "Horky",
    "psc": "39001",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39001 Tabor Horky"
  },
  {
    "cast": "Horky",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Horky"
  },
  {
    "cast": "Horky",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Horky",
    "val": "57001 Horky Horky"
  },
  {
    "cast": "Horky",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Horky",
    "val": "28601 Horky Horky"
  },
  {
    "cast": "Horky",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Želetava",
    "val": "67526 Zeletava Horky"
  },
  {
    "cast": "Horky",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Horky"
  },
  {
    "cast": "Horky nad Jizerou",
    "psc": "29473",
    "okres": "Mladá Boleslav",
    "obec": "Horky nad Jizerou",
    "val": "29473 Horky nad Jizerou Horky nad Jizerou"
  },
  {
    "cast": "Horňátky",
    "psc": "27711",
    "okres": "Mělník",
    "obec": "Neratovice",
    "val": "27711 Neratovice Hornatky"
  },
  {
    "cast": "Horní Adršpach",
    "psc": "54952",
    "okres": "Náchod",
    "obec": "Adršpach",
    "val": "54952 Adrspach Horni Adrspach"
  },
  {
    "cast": "Horní Albeřice",
    "psc": "54226",
    "okres": "Trutnov",
    "obec": "Horní Maršov",
    "val": "54226 Horni Marsov Horni Alberice"
  },
  {
    "cast": "Horní Babákov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Holetín",
    "val": "53901 Holetin Horni Babakov"
  },
  {
    "cast": "Horní Bečva",
    "psc": "75657",
    "okres": "Vsetín",
    "obec": "Horní Bečva",
    "val": "75657 Horni Becva Horni Becva"
  },
  {
    "cast": "Horní Bělá",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Horní Bělá",
    "val": "33152 Horni Bela Horni Bela"
  },
  {
    "cast": "Horní Benešov",
    "psc": "79312",
    "okres": "Bruntál",
    "obec": "Horní Benešov",
    "val": "79312 Horni Benesov Horni Benesov"
  },
  {
    "cast": "Horní Beřkovice",
    "psc": "41185",
    "okres": "Litoměřice",
    "obec": "Horní Beřkovice",
    "val": "41185 Horni Berkovice Horni Berkovice"
  },
  {
    "cast": "Horní Bezděkov",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Horni Bezdekov"
  },
  {
    "cast": "Horní Bezděkov",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Horní Bezděkov",
    "val": "27351 Horni Bezdekov Horni Bezdekov"
  },
  {
    "cast": "Horní Blatná",
    "psc": "36235",
    "okres": "Karlovy Vary",
    "obec": "Horní Blatná",
    "val": "36235 Horni Blatna Horni Blatna"
  },
  {
    "cast": "Horní Bludovice",
    "psc": "73937",
    "okres": "Karviná",
    "obec": "Horní Bludovice",
    "val": "73937 Horni Bludovice Horni Bludovice"
  },
  {
    "cast": "Horní Bojanovice",
    "psc": "69301",
    "okres": "Břeclav",
    "obec": "Horní Bojanovice",
    "val": "69301 Horni Bojanovice Horni Bojanovice"
  },
  {
    "cast": "Horní Bolíkov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Horni Bolikov"
  },
  {
    "cast": "Horní Borek",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Červený Újezd",
    "val": "25786 Cerveny Ujezd Horni Borek"
  },
  {
    "cast": "Horní Bory",
    "psc": "59461",
    "okres": "Žďár nad Sázavou",
    "obec": "Bory",
    "val": "59461 Bory Horni Bory"
  },
  {
    "cast": "Horní Boříkovice",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Horni Borikovice"
  },
  {
    "cast": "Horní Bousov",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Bousov",
    "val": "29404 Dolni Bousov Horni Bousov"
  },
  {
    "cast": "Horní Bradlo (část)",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53825 Horni Bradlo Horni Bradlo (cast)"
  },
  {
    "cast": "Horní Bradlo (část)",
    "psc": "53953",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53953 Horni Bradlo Horni Bradlo (cast)"
  },
  {
    "cast": "Horní Brána",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Horni Brana"
  },
  {
    "cast": "Horní Branná (část)",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Horní Branná",
    "val": "51401 Horni Branna Horni Branna (cast)"
  },
  {
    "cast": "Horní Branná (část)",
    "psc": "51236",
    "okres": "Semily",
    "obec": "Horní Branná",
    "val": "51236 Horni Branna Horni Branna (cast)"
  },
  {
    "cast": "Horní Brusnice (část)",
    "psc": "54475",
    "okres": "Trutnov",
    "obec": "Horní Brusnice",
    "val": "54475 Horni Brusnice Horni Brusnice (cast)"
  },
  {
    "cast": "Horní Brusnice (část)",
    "psc": "54474",
    "okres": "Trutnov",
    "obec": "Horní Brusnice",
    "val": "54474 Horni Brusnice Horni Brusnice (cast)"
  },
  {
    "cast": "Horní Břečkov",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Horní Břečkov",
    "val": "67102 Horni Breckov Horni Breckov"
  },
  {
    "cast": "Horní Březinka",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Horni Brezinka"
  },
  {
    "cast": "Horní Bříza",
    "psc": "33012",
    "okres": "Plzeň-sever",
    "obec": "Horní Bříza",
    "val": "33012 Horni Briza Horni Briza"
  },
  {
    "cast": "Horní Bučice",
    "psc": "28571",
    "okres": "Kutná Hora",
    "obec": "Vrdy",
    "val": "28571 Vrdy Horni Bucice"
  },
  {
    "cast": "Horní Bukovina",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Horní Bukovina",
    "val": "29501 Horni Bukovina Horni Bukovina"
  },
  {
    "cast": "Horní Bukovsko",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Dolní Bukovsko",
    "val": "37365 Dolni Bukovsko Horni Bukovsko"
  },
  {
    "cast": "Horní Cerekev",
    "psc": "39403",
    "okres": "Pelhřimov",
    "obec": "Horní Cerekev",
    "val": "39403 Horni Cerekev Horni Cerekev"
  },
  {
    "cast": "Horní Cetno",
    "psc": "29430",
    "okres": "Mladá Boleslav",
    "obec": "Niměřice",
    "val": "29430 Nimerice Horni Cetno"
  },
  {
    "cast": "Horní Částkov",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Habartov",
    "val": "35709 Habartov Horni Castkov"
  },
  {
    "cast": "Horní Čepí",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Ujčov",
    "val": "59262 Ujcov Horni Cepi"
  },
  {
    "cast": "Horní Čermná (část)",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Horní Čermná",
    "val": "56301 Horni Cermna Horni Cermna (cast)"
  },
  {
    "cast": "Horní Čermná (část)",
    "psc": "56156",
    "okres": "Ústí nad Orlicí",
    "obec": "Horní Čermná",
    "val": "56156 Horni Cermna Horni Cermna (cast)"
  },
  {
    "cast": "Horní Černá Studnice",
    "psc": "46821",
    "okres": "Jablonec nad Nisou",
    "obec": "Nová Ves nad Nisou",
    "val": "46821 Nova Ves nad Nisou Horni Cerna Studnice"
  },
  {
    "cast": "Horní Černilov",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Libníkovice",
    "val": "50346 Libnikovice Horni Cernilov"
  },
  {
    "cast": "Horní Černůtky",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Sovětice",
    "val": "50315 Sovetice Horni Cernutky"
  },
  {
    "cast": "Horní Datyně",
    "psc": "73932",
    "okres": "Ostrava-město",
    "obec": "Vratimov",
    "val": "73932 Vratimov Horni Datyne"
  },
  {
    "cast": "Horní Dehtov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Třebihošť",
    "val": "54401 Trebihost Horni Dehtov"
  },
  {
    "cast": "Horní Dlužiny",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Horni Dluziny"
  },
  {
    "cast": "Horní Dobrouč",
    "psc": "56102",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Dobrouč",
    "val": "56102 Dolni Dobrouc Horni Dobrouc"
  },
  {
    "cast": "Horní Dobřejov",
    "psc": "25791",
    "okres": "Benešov",
    "obec": "Střezimíř",
    "val": "25791 Strezimir Horni Dobrejov"
  },
  {
    "cast": "Horní Dohalice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Dohalice",
    "val": "50315 Dohalice Horni Dohalice"
  },
  {
    "cast": "Horní Dolce",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Zaloňov",
    "val": "55101 Zalonov Horni Dolce"
  },
  {
    "cast": "Horní Domaslavice",
    "psc": "73951",
    "okres": "Frýdek-Místek",
    "obec": "Horní Domaslavice",
    "val": "73951 Horni Domaslavice Horni Domaslavice"
  },
  {
    "cast": "Horní Dřevíč (část)",
    "psc": "54936",
    "okres": "Náchod",
    "obec": "Stárkov",
    "val": "54936 Starkov Horni Drevic (cast)"
  },
  {
    "cast": "Horní Dřevíč (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Stárkov",
    "val": "54931 Starkov Horni Drevic (cast)"
  },
  {
    "cast": "Horní Dubenky",
    "psc": "58852",
    "okres": "Jihlava",
    "obec": "Horní Dubenky",
    "val": "58852 Horni Dubenky Horni Dubenky"
  },
  {
    "cast": "Horní Dubňany",
    "psc": "67173",
    "okres": "Znojmo",
    "obec": "Horní Dubňany",
    "val": "67173 Horni Dubnany Horni Dubnany"
  },
  {
    "cast": "Horní Dubová Hora",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Horni Dubova Hora"
  },
  {
    "cast": "Horní Dunajovice",
    "psc": "67134",
    "okres": "Znojmo",
    "obec": "Horní Dunajovice",
    "val": "67134 Horni Dunajovice Horni Dunajovice"
  },
  {
    "cast": "Horní Dušnice",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Horni Dusnice"
  },
  {
    "cast": "Horní Dvorce",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Zahrádky",
    "val": "37853 Zahradky Horni Dvorce"
  },
  {
    "cast": "Horní Dvory",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Horni Dvory"
  },
  {
    "cast": "Horní Dvořiště (část)",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Horní Dvořiště",
    "val": "38241 Horni Dvoriste Horni Dvoriste (cast)"
  },
  {
    "cast": "Horní Dvořiště (část)",
    "psc": "38293",
    "okres": "Český Krumlov",
    "obec": "Horní Dvořiště",
    "val": "38293 Horni Dvoriste Horni Dvoriste (cast)"
  },
  {
    "cast": "Horní Folmava",
    "psc": "34532",
    "okres": "Domažlice",
    "obec": "Česká Kubice",
    "val": "34532 Ceska Kubice Horni Folmava"
  },
  {
    "cast": "Horní Fořt",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Uhelná",
    "val": "79070 Uhelna Horni Fort"
  },
  {
    "cast": "Horní Habartice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Horní Habartice",
    "val": "40502 Horni Habartice Horni Habartice"
  },
  {
    "cast": "Horní Halže",
    "psc": "43184",
    "okres": "Chomutov",
    "obec": "Měděnec",
    "val": "43184 Medenec Horni Halze"
  },
  {
    "cast": "Horní Hanychov-Liberec XIX x)",
    "psc": "46008",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46008 Liberec Horni Hanychov-Liberec XIX x)"
  },
  {
    "cast": "Horní Hbity",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Jablonná",
    "val": "26263 Jablonna Horni Hbity"
  },
  {
    "cast": "Horní Hedeč",
    "psc": "78833",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "78833 Kraliky Horni Hedec"
  },
  {
    "cast": "Horní Heršpice (část)",
    "psc": "61700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61700 Brno Horni Herspice (cast)"
  },
  {
    "cast": "Horní Heršpice (část)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Horni Herspice (cast)"
  },
  {
    "cast": "Horní Heřmanice",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Horní Heřmanice",
    "val": "67505 Horni Hermanice Horni Hermanice"
  },
  {
    "cast": "Horní Heřmanice",
    "psc": "79057",
    "okres": "Jeseník",
    "obec": "Bernartice",
    "val": "79057 Bernartice Horni Hermanice"
  },
  {
    "cast": "Horní Heřmanice (část)",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Horní Heřmanice",
    "val": "56301 Horni Hermanice Horni Hermanice (cast)"
  },
  {
    "cast": "Horní Heřmanice (část)",
    "psc": "56133",
    "okres": "Ústí nad Orlicí",
    "obec": "Horní Heřmanice",
    "val": "56133 Horni Hermanice Horni Hermanice (cast)"
  },
  {
    "cast": "Horní Hlíny",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Horní Libochová",
    "val": "59451 Horni Libochova Horni Hliny"
  },
  {
    "cast": "Horní Holetín",
    "psc": "53971",
    "okres": "Chrudim",
    "obec": "Holetín",
    "val": "53971 Holetin Horni Holetin"
  },
  {
    "cast": "Horní Hořice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Horni Horice"
  },
  {
    "cast": "Horní Hoštice",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Javorník",
    "val": "79070 Javornik Horni Hostice"
  },
  {
    "cast": "Horní Houžovec",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56201 Usti nad Orlici Horni Houzovec"
  },
  {
    "cast": "Horní Hrad",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Krásný Les",
    "val": "36301 Krasny Les Horni Hrad"
  },
  {
    "cast": "Horní Hradiště",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Plasy",
    "val": "33101 Plasy Horni Hradiste"
  },
  {
    "cast": "Horní Hrachovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Dolní Hrachovice",
    "val": "39143 Dolni Hrachovice Horni Hrachovice"
  },
  {
    "cast": "Horní Hynčina",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Pohledy",
    "val": "56802 Pohledy Horni Hyncina"
  },
  {
    "cast": "Horní Chobolice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41145 Libesice Horni Chobolice"
  },
  {
    "cast": "Horní Chrastava",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Chrastava",
    "val": "46331 Chrastava Horni Chrastava"
  },
  {
    "cast": "Horní Chrášťany",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38411 Lhenice Horni Chrastany"
  },
  {
    "cast": "Horní Chřibská",
    "psc": "40744",
    "okres": "Děčín",
    "obec": "Chřibská",
    "val": "40744 Chribska Horni Chribska"
  },
  {
    "cast": "Horní Chvatliny",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Dolní Chvatliny",
    "val": "28144 Dolni Chvatliny Horni Chvatliny"
  },
  {
    "cast": "Horní Jadruž",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Chodský Újezd",
    "val": "34815 Chodsky Ujezd Horni Jadruz"
  },
  {
    "cast": "Horní Jasenka",
    "psc": "75501",
    "okres": "Vsetín",
    "obec": "Vsetín",
    "val": "75501 Vsetin Horni Jasenka"
  },
  {
    "cast": "Horní Javoří",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Pecka",
    "val": "50782 Pecka Horni Javori"
  },
  {
    "cast": "Horní Jelčany",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Bečváry",
    "val": "28144 Becvary Horni Jelcany"
  },
  {
    "cast": "Horní Jelení",
    "psc": "53374",
    "okres": "Pardubice",
    "obec": "Horní Jelení",
    "val": "53374 Horni Jeleni Horni Jeleni"
  },
  {
    "cast": "Horní Jirčany",
    "psc": "25242",
    "okres": "Praha-západ",
    "obec": "Jesenice",
    "val": "25242 Jesenice Horni Jircany"
  },
  {
    "cast": "Horní Jiřetín",
    "psc": "43543",
    "okres": "Most",
    "obec": "Horní Jiřetín",
    "val": "43543 Horni Jiretin Horni Jiretin"
  },
  {
    "cast": "Horní Kalná",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Horní Kalná",
    "val": "54371 Horni Kalna Horni Kalna"
  },
  {
    "cast": "Horní Kamenice",
    "psc": "27372",
    "okres": "Kladno",
    "obec": "Vraný",
    "val": "27372 Vrany Horni Kamenice"
  },
  {
    "cast": "Horní Kamenice",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Horní Kamenice",
    "val": "34562 Horni Kamenice Horni Kamenice"
  },
  {
    "cast": "Horní Kamenice",
    "psc": "40721",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40721 Ceska Kamenice Horni Kamenice"
  },
  {
    "cast": "Horní Kněžeklady",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Horní Kněžeklady",
    "val": "37501 Horni Knezeklady Horni Knezeklady"
  },
  {
    "cast": "Horní Kosov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Horni Kosov"
  },
  {
    "cast": "Horní Kostelec",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Červený Kostelec",
    "val": "54941 Cerveny Kostelec Horni Kostelec"
  },
  {
    "cast": "Horní Kounice",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Horní Kounice",
    "val": "67140 Horni Kounice Horni Kounice"
  },
  {
    "cast": "Horní Kouty",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Horni Kouty"
  },
  {
    "cast": "Horní Kozolupy",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Horní Kozolupy",
    "val": "34952 Horni Kozolupy Horni Kozolupy"
  },
  {
    "cast": "Horní Kožlí",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Vlachovo Březí",
    "val": "38301 Vlachovo Brezi Horni Kozli"
  },
  {
    "cast": "Horní Kramolín",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Horni Kramolin"
  },
  {
    "cast": "Horní Krupá",
    "psc": "29501",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "29501 Ralsko Horni Krupa"
  },
  {
    "cast": "Horní Krupá",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Horní Krupá",
    "val": "58001 Horni Krupa Horni Krupa"
  },
  {
    "cast": "Horní Krupka (část)",
    "psc": "41741",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41741 Krupka Horni Krupka (cast)"
  },
  {
    "cast": "Horní Krupka (část)",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Horni Krupka (cast)"
  },
  {
    "cast": "Horní Kruty (část)",
    "psc": "28146",
    "okres": "Kolín",
    "obec": "Horní Kruty",
    "val": "28146 Horni Kruty Horni Kruty (cast)"
  },
  {
    "cast": "Horní Kruty (část)",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Horní Kruty",
    "val": "28163 Horni Kruty Horni Kruty (cast)"
  },
  {
    "cast": "Horní Lánov",
    "psc": "54341",
    "okres": "Trutnov",
    "obec": "Lánov",
    "val": "54341 Lanov Horni Lanov"
  },
  {
    "cast": "Horní Lapač",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Horní Lapač",
    "val": "76901 Horni Lapac Horni Lapac"
  },
  {
    "cast": "Horní Lažany",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Horni Lazany"
  },
  {
    "cast": "Horní Lažany",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Lesonice",
    "val": "67544 Lesonice Horni Lazany"
  },
  {
    "cast": "Horní Ledeč",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Ledeč nad Sázavou",
    "val": "58401 Ledec nad Sazavou Horni Ledec"
  },
  {
    "cast": "Horní Lhota",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Horni Lhota"
  },
  {
    "cast": "Horní Lhota",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Horni Lhota"
  },
  {
    "cast": "Horní Lhota",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Týnec",
    "val": "34021 Tynec Horni Lhota"
  },
  {
    "cast": "Horní Lhota",
    "psc": "74764",
    "okres": "Ostrava-město",
    "obec": "Horní Lhota",
    "val": "74764 Horni Lhota Horni Lhota"
  },
  {
    "cast": "Horní Lhota",
    "psc": "76323",
    "okres": "Zlín",
    "obec": "Horní Lhota",
    "val": "76323 Horni Lhota Horni Lhota"
  },
  {
    "cast": "Horní Lhota",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Dolní Žďár",
    "val": "37802 Dolni Zdar Horni Lhota"
  },
  {
    "cast": "Horní Lhotice",
    "psc": "67573",
    "okres": "Třebíč",
    "obec": "Kralice nad Oslavou",
    "val": "67573 Kralice nad Oslavou Horni Lhotice"
  },
  {
    "cast": "Horní Lhotka",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Maleč",
    "val": "58301 Malec Horni Lhotka"
  },
  {
    "cast": "Horní Libchava",
    "psc": "47111",
    "okres": "Česká Lípa",
    "obec": "Horní Libchava",
    "val": "47111 Horni Libchava Horni Libchava"
  },
  {
    "cast": "Horní Libchavy",
    "psc": "56116",
    "okres": "Ústí nad Orlicí",
    "obec": "Libchavy",
    "val": "56116 Libchavy Horni Libchavy"
  },
  {
    "cast": "Horní Libochová",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Horní Libochová",
    "val": "59451 Horni Libochova Horni Libochova"
  },
  {
    "cast": "Horní Lideč",
    "psc": "75612",
    "okres": "Vsetín",
    "obec": "Horní Lideč",
    "val": "75612 Horni Lidec Horni Lidec"
  },
  {
    "cast": "Horní Lipka",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Horni Lipka"
  },
  {
    "cast": "Horní Lipová",
    "psc": "79063",
    "okres": "Jeseník",
    "obec": "Lipová-lázně",
    "val": "79063 Lipova-lazne Horni Lipova"
  },
  {
    "cast": "Horní Líšnice",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Dolní Hbity",
    "val": "26263 Dolni Hbity Horni Lisnice"
  },
  {
    "cast": "Horní Líštná",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Horni Listna"
  },
  {
    "cast": "Horní Litvínov",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Horni Litvinov"
  },
  {
    "cast": "Horní Loděnice",
    "psc": "78305",
    "okres": "Olomouc",
    "obec": "Horní Loděnice",
    "val": "78305 Horni Lodenice Horni Lodenice"
  },
  {
    "cast": "Horní Lochov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Holín",
    "val": "50601 Holin Horni Lochov"
  },
  {
    "cast": "Horní Lomany",
    "psc": "35101",
    "okres": "Cheb",
    "obec": "Františkovy Lázně",
    "val": "35101 Frantiskovy Lazne Horni Lomany"
  },
  {
    "cast": "Horní Lomná",
    "psc": "73991",
    "okres": "Frýdek-Místek",
    "obec": "Horní Lomná",
    "val": "73991 Horni Lomna Horni Lomna"
  },
  {
    "cast": "Horní Lomnice",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Kunice",
    "val": "25169 Kunice Horni Lomnice"
  },
  {
    "cast": "Horní Loučky",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Horní Loučky",
    "val": "59455 Horni Loucky Horni Loucky"
  },
  {
    "cast": "Horní Luby",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Luby",
    "val": "35134 Luby Horni Luby"
  },
  {
    "cast": "Horní Lukavice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Horní Lukavice",
    "val": "33401 Horni Lukavice Horni Lukavice"
  },
  {
    "cast": "Horní Lysečiny",
    "psc": "54226",
    "okres": "Trutnov",
    "obec": "Horní Maršov",
    "val": "54226 Horni Marsov Horni Lyseciny"
  },
  {
    "cast": "Horní Malá Úpa (část)",
    "psc": "54221",
    "okres": "Trutnov",
    "obec": "Malá Úpa",
    "val": "54221 Mala Upa Horni Mala Upa (cast)"
  },
  {
    "cast": "Horní Malá Úpa (část)",
    "psc": "54227",
    "okres": "Trutnov",
    "obec": "Malá Úpa",
    "val": "54227 Mala Upa Horni Mala Upa (cast)"
  },
  {
    "cast": "Horní Maršov",
    "psc": "54226",
    "okres": "Trutnov",
    "obec": "Horní Maršov",
    "val": "54226 Horni Marsov Horni Marsov"
  },
  {
    "cast": "Horní Maxov",
    "psc": "46844",
    "okres": "Jablonec nad Nisou",
    "obec": "Lučany nad Nisou",
    "val": "46844 Lucany nad Nisou Horni Maxov"
  },
  {
    "cast": "Horní Měcholupy (část)",
    "psc": "10200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10200 Praha Horni Mecholupy (cast)"
  },
  {
    "cast": "Horní Měcholupy (část)",
    "psc": "10900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10900 Praha Horni Mecholupy (cast)"
  },
  {
    "cast": "Horní Město",
    "psc": "79344",
    "okres": "Bruntál",
    "obec": "Horní Město",
    "val": "79344 Horni Mesto Horni Mesto"
  },
  {
    "cast": "Horní Metelsko",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Horni Metelsko"
  },
  {
    "cast": "Horní Meziříčko",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Meziříčko",
    "val": "37853 Horni Meziricko Horni Meziricko"
  },
  {
    "cast": "Horní Miletín",
    "psc": "37373",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37373 Lisov Horni Miletin"
  },
  {
    "cast": "Horní Morava",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Morava",
    "val": "56169 Dolni Morava Horni Morava"
  },
  {
    "cast": "Horní Moravice",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Dolní Moravice",
    "val": "79501 Dolni Moravice Horni Moravice"
  },
  {
    "cast": "Horní Moštěnice",
    "psc": "75117",
    "okres": "Přerov",
    "obec": "Horní Moštěnice",
    "val": "75117 Horni Mostenice Horni Mostenice"
  },
  {
    "cast": "Horní Myslová",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Horní Myslová",
    "val": "58856 Horni Myslova Horni Myslova"
  },
  {
    "cast": "Horní Nakvasovice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Bušanovice",
    "val": "38422 Busanovice Horni Nakvasovice"
  },
  {
    "cast": "Horní Němčí",
    "psc": "68764",
    "okres": "Uherské Hradiště",
    "obec": "Horní Němčí",
    "val": "68764 Horni Nemci Horni Nemci"
  },
  {
    "cast": "Horní Němčice",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Horni Nemcice"
  },
  {
    "cast": "Horní Němčice",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Němčice",
    "val": "37853 Horni Nemcice Horni Nemcice"
  },
  {
    "cast": "Horní Nemojov (část)",
    "psc": "54461",
    "okres": "Trutnov",
    "obec": "Nemojov",
    "val": "54461 Nemojov Horni Nemojov (cast)"
  },
  {
    "cast": "Horní Nemojov (část)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Nemojov",
    "val": "54401 Nemojov Horni Nemojov (cast)"
  },
  {
    "cast": "Horní Nerestce",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Nerestce",
    "val": "39804 Nerestce Horni Nerestce"
  },
  {
    "cast": "Horní Nětčice",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Horní Nětčice",
    "val": "75354 Horni Netcice Horni Netcice"
  },
  {
    "cast": "Horní Nezly",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41201 Libesice Horni Nezly"
  },
  {
    "cast": "Horní Nivy",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Dolní Nivy",
    "val": "35601 Dolni Nivy Horni Nivy"
  },
  {
    "cast": "Horní Nová Ves",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Horni Nova Ves"
  },
  {
    "cast": "Horní Novosedly",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dolní Novosedly",
    "val": "39701 Dolni Novosedly Horni Novosedly"
  },
  {
    "cast": "Horní Oldřichov-Děčín XXI x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Horni Oldrichov-Decin XXI x)"
  },
  {
    "cast": "Horní Olešná",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Popelín",
    "val": "37853 Popelin Horni Olesna"
  },
  {
    "cast": "Horní Olešnice",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Horní Olešnice",
    "val": "54371 Horni Olesnice Horni Olesnice"
  },
  {
    "cast": "Horní Orlice",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56169 Cervena Voda Horni Orlice"
  },
  {
    "cast": "Horní Ostrovec",
    "psc": "39833",
    "okres": "Písek",
    "obec": "Ostrovec",
    "val": "39833 Ostrovec Horni Ostrovec"
  },
  {
    "cast": "Horní Paseka",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Horní Paseka",
    "val": "58401 Horni Paseka Horni Paseka"
  },
  {
    "cast": "Horní Paseky",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As Horni Paseky"
  },
  {
    "cast": "Horní Pěna",
    "psc": "37831",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Pěna",
    "val": "37831 Horni Pena Horni Pena"
  },
  {
    "cast": "Horní Pertoltice",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Pertoltice",
    "val": "46373 Pertoltice Horni Pertoltice"
  },
  {
    "cast": "Horní Planá",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Horní Planá",
    "val": "38226 Horni Plana Horni Plana"
  },
  {
    "cast": "Horní Plezom",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Ošelín",
    "val": "34802 Oselin Horni Plezom"
  },
  {
    "cast": "Horní Počaply",
    "psc": "27703",
    "okres": "Mělník",
    "obec": "Horní Počaply",
    "val": "27703 Horni Pocaply Horni Pocaply"
  },
  {
    "cast": "Horní Počernice (část)",
    "psc": "19800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19800 Praha Horni Pocernice (cast)"
  },
  {
    "cast": "Horní Počernice (část)",
    "psc": "19014",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19014 Praha Horni Pocernice (cast)"
  },
  {
    "cast": "Horní Počernice (část)",
    "psc": "19300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19300 Praha Horni Pocernice (cast)"
  },
  {
    "cast": "Horní Podhájí",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Horni Podhaji"
  },
  {
    "cast": "Horní Podluží",
    "psc": "40757",
    "okres": "Děčín",
    "obec": "Horní Podluží",
    "val": "40757 Horni Podluzi Horni Podluzi"
  },
  {
    "cast": "Horní Pochlovice",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kaceřov",
    "val": "35751 Kacerov Horni Pochlovice"
  },
  {
    "cast": "Horní Pole",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Horni Pole"
  },
  {
    "cast": "Horní Police",
    "psc": "47106",
    "okres": "Česká Lípa",
    "obec": "Horní Police",
    "val": "47106 Horni Police Horni Police"
  },
  {
    "cast": "Horní Polžice",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Horni Polzice"
  },
  {
    "cast": "Horní Poříčí",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Horní Poříčí",
    "val": "38601 Horni Porici Horni Porici"
  },
  {
    "cast": "Horní Poříčí (část)",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Horní Poříčí",
    "val": "67962 Horni Porici Horni Porici (cast)"
  },
  {
    "cast": "Horní Poříčí (část)",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Horní Poříčí",
    "val": "67961 Horni Porici Horni Porici (cast)"
  },
  {
    "cast": "Horní Poustevna",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Dolní Poustevna",
    "val": "40747 Dolni Poustevna Horni Poustevna"
  },
  {
    "cast": "Horní Povelice",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Liptaň",
    "val": "79399 Liptan Horni Povelice"
  },
  {
    "cast": "Horní Prosíčka",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Prosíčka",
    "val": "58401 Prosicka Horni Prosicka"
  },
  {
    "cast": "Horní Prysk",
    "psc": "47115",
    "okres": "Česká Lípa",
    "obec": "Prysk",
    "val": "47115 Prysk Horni Prysk"
  },
  {
    "cast": "Horní Předměstí",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Polička",
    "val": "57201 Policka Horni Predmesti"
  },
  {
    "cast": "Horní Předměstí",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Horni Predmesti"
  },
  {
    "cast": "Horní Přím",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Dolní Přím",
    "val": "50315 Dolni Prim Horni Prim"
  },
  {
    "cast": "Horní Radechová (část)",
    "psc": "54946",
    "okres": "Náchod",
    "obec": "Horní Radechová",
    "val": "54946 Horni Radechova Horni Radechova (cast)"
  },
  {
    "cast": "Horní Radechová (část)",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Horní Radechová",
    "val": "54941 Horni Radechova Horni Radechova (cast)"
  },
  {
    "cast": "Horní Radíkov",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "38001 Cesky Rudolec Horni Radikov"
  },
  {
    "cast": "Horní Radouň (část)",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Radouň",
    "val": "37842 Horni Radoun Horni Radoun (cast)"
  },
  {
    "cast": "Horní Radouň (část)",
    "psc": "37843",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Radouň",
    "val": "37843 Horni Radoun Horni Radoun (cast)"
  },
  {
    "cast": "Horní Radslavice",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Horní Radslavice",
    "val": "59401 Horni Radslavice Horni Radslavice"
  },
  {
    "cast": "Horní Rápotice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Horní Rápotice",
    "val": "39601 Horni Rapotice Horni Rapotice"
  },
  {
    "cast": "Horní Raškovice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Svinčany",
    "val": "53501 Svincany Horni Raskovice"
  },
  {
    "cast": "Horní Rokytá",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Rokytá",
    "val": "29501 Rokyta Horni Rokyta"
  },
  {
    "cast": "Horní Rokytňany",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Rokytňany",
    "val": "50723 Rokytnany Horni Rokytnany"
  },
  {
    "cast": "Horní Rokytnice (část)",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Horni Rokytnice (cast)"
  },
  {
    "cast": "Horní Rokytnice (část)",
    "psc": "51245",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51245 Rokytnice nad Jizerou Horni Rokytnice (cast)"
  },
  {
    "cast": "Horní Roveň",
    "psc": "53371",
    "okres": "Pardubice",
    "obec": "Dolní Roveň",
    "val": "53371 Dolni Roven Horni Roven"
  },
  {
    "cast": "Horní Rozmyšl",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Dolní Nivy",
    "val": "35601 Dolni Nivy Horni Rozmysl"
  },
  {
    "cast": "Horní Rozsíčka",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Dolní Rožínka",
    "val": "59251 Dolni Rozinka Horni Rozsicka"
  },
  {
    "cast": "Horní Rožínka",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Horní Rožínka",
    "val": "59251 Horni Rozinka Horni Rozinka"
  },
  {
    "cast": "Horní Růžodol-Liberec VII x)",
    "psc": "46007",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46007 Liberec Horni Ruzodol-Liberec VII x)"
  },
  {
    "cast": "Horní Rybníky",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Zábrodí",
    "val": "54941 Zabrodi Horni Rybniky"
  },
  {
    "cast": "Horní Řasnice",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Horní Řasnice",
    "val": "46401 Horni Rasnice Horni Rasnice"
  },
  {
    "cast": "Horní Ředice",
    "psc": "53375",
    "okres": "Pardubice",
    "obec": "Horní Ředice",
    "val": "53375 Horni Redice Horni Redice"
  },
  {
    "cast": "Horní Řepčice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Horní Řepčice",
    "val": "41145 Horni Repcice Horni Repcice"
  },
  {
    "cast": "Horní Sedlo",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Horni Sedlo"
  },
  {
    "cast": "Horní Sekyřany",
    "psc": "33024",
    "okres": "Plzeň-sever",
    "obec": "Heřmanova Huť",
    "val": "33024 Hermanova Hut Horni Sekyrany"
  },
  {
    "cast": "Horní Sklenov",
    "psc": "73946",
    "okres": "Frýdek-Místek",
    "obec": "Hukvaldy",
    "val": "73946 Hukvaldy Horni Sklenov"
  },
  {
    "cast": "Horní Skrýchov",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Skrýchov",
    "val": "37701 Horni Skrychov Horni Skrychov"
  },
  {
    "cast": "Horní Slatina",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Slatina",
    "val": "38001 Horni Slatina Horni Slatina"
  },
  {
    "cast": "Horní Slavkov",
    "psc": "35731",
    "okres": "Sokolov",
    "obec": "Horní Slavkov",
    "val": "35731 Horni Slavkov Horni Slavkov"
  },
  {
    "cast": "Horní Slivno",
    "psc": "29479",
    "okres": "Mladá Boleslav",
    "obec": "Horní Slivno",
    "val": "29479 Horni Slivno Horni Slivno"
  },
  {
    "cast": "Horní Sloupnice",
    "psc": "56553",
    "okres": "Svitavy",
    "obec": "Sloupnice",
    "val": "56553 Sloupnice Horni Sloupnice"
  },
  {
    "cast": "Horní Slověnice",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Horni Slovenice"
  },
  {
    "cast": "Horní Smrčné",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Horní Smrčné",
    "val": "67507 Horni Smrcne Horni Smrcne"
  },
  {
    "cast": "Horní Smržov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Horní Smržov",
    "val": "67961 Horni Smrzov Horni Smrzov"
  },
  {
    "cast": "Horní Sokolovec",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Sokolovec",
    "val": "58301 Dolni Sokolovec Horni Sokolovec"
  },
  {
    "cast": "Horní Stakory (část)",
    "psc": "29306",
    "okres": "Mladá Boleslav",
    "obec": "Kosmonosy",
    "val": "29306 Kosmonosy Horni Stakory (cast)"
  },
  {
    "cast": "Horní Stakory (část)",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Kosmonosy",
    "val": "29301 Kosmonosy Horni Stakory (cast)"
  },
  {
    "cast": "Horní Staňkov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Horni Stankov"
  },
  {
    "cast": "Horní Staré Buky",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Staré Buky",
    "val": "54101 Stare Buky Horni Stare Buky"
  },
  {
    "cast": "Horní Staré Město (část)",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Horni Stare Mesto (cast)"
  },
  {
    "cast": "Horní Staré Město (část)",
    "psc": "54102",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54102 Trutnov Horni Stare Mesto (cast)"
  },
  {
    "cast": "Horní Stropnice",
    "psc": "37335",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37335 Horni Stropnice Horni Stropnice"
  },
  {
    "cast": "Horní Střítež",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nová Ves u Mladé Vožice",
    "val": "39143 Nova Ves u Mlade Vozice Horni Stritez"
  },
  {
    "cast": "Horní Studenec",
    "psc": "58264",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec nad Doubravou",
    "val": "58264 Zdirec nad Doubravou Horni Studenec"
  },
  {
    "cast": "Horní Studénky",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Horní Studénky",
    "val": "78901 Horni Studenky Horni Studenky"
  },
  {
    "cast": "Horní Suchá",
    "psc": "73535",
    "okres": "Karviná",
    "obec": "Horní Suchá",
    "val": "73535 Horni Sucha Horni Sucha"
  },
  {
    "cast": "Horní Suchá-Liberec XXII x)",
    "psc": "46010",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46010 Liberec Horni Sucha-Liberec XXII x)"
  },
  {
    "cast": "Horní Sukolom",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Horni Sukolom"
  },
  {
    "cast": "Horní Světlá",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Bradáčov",
    "val": "39143 Bradacov Horni Svetla"
  },
  {
    "cast": "Horní Světlá",
    "psc": "47157",
    "okres": "Česká Lípa",
    "obec": "Mařenice",
    "val": "47157 Marenice Horni Svetla"
  },
  {
    "cast": "Horní Svince",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Dolní Třebonín",
    "val": "38232 Dolni Trebonin Horni Svince"
  },
  {
    "cast": "Horní Sytová",
    "psc": "51241",
    "okres": "Semily",
    "obec": "Víchová nad Jizerou",
    "val": "51241 Vichova nad Jizerou Horni Sytova"
  },
  {
    "cast": "Horní Štěpanice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Benecko",
    "val": "51401 Benecko Horni Stepanice"
  },
  {
    "cast": "Horní Štěpánov",
    "psc": "79847",
    "okres": "Prostějov",
    "obec": "Horní Štěpánov",
    "val": "79847 Horni Stepanov Horni Stepanov"
  },
  {
    "cast": "Horní Tašovice",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Stružná",
    "val": "36471 Struzna Horni Tasovice"
  },
  {
    "cast": "Horní Teplice",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Horni Teplice"
  },
  {
    "cast": "Horní Těrlicko",
    "psc": "73542",
    "okres": "Karviná",
    "obec": "Těrlicko",
    "val": "73542 Terlicko Horni Terlicko"
  },
  {
    "cast": "Horní Těšice",
    "psc": "75353",
    "okres": "Přerov",
    "obec": "Horní Těšice",
    "val": "75353 Horni Tesice Horni Tesice"
  },
  {
    "cast": "Horní Tošanovice",
    "psc": "73953",
    "okres": "Frýdek-Místek",
    "obec": "Horní Tošanovice",
    "val": "73953 Horni Tosanovice Horni Tosanovice"
  },
  {
    "cast": "Horní Třebonín",
    "psc": "38201",
    "okres": "Český Krumlov",
    "obec": "Dolní Třebonín",
    "val": "38201 Dolni Trebonin Horni Trebonin"
  },
  {
    "cast": "Horní Třešňovec",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Horní Třešňovec",
    "val": "56301 Horni Tresnovec Horni Tresnovec"
  },
  {
    "cast": "Horní Tříč",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Vysoké nad Jizerou",
    "val": "51301 Vysoke nad Jizerou Horni Tric"
  },
  {
    "cast": "Horní Týnec",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Třebušín",
    "val": "41201 Trebusin Horni Tynec"
  },
  {
    "cast": "Horní Údolí",
    "psc": "79376",
    "okres": "Jeseník",
    "obec": "Zlaté Hory",
    "val": "79376 Zlate Hory Horni Udoli"
  },
  {
    "cast": "Horní Újezd",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Horní Újezd",
    "val": "67522 Horni Ujezd Horni Ujezd"
  },
  {
    "cast": "Horní Újezd",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Horní Újezd",
    "val": "57001 Horni Ujezd Horni Ujezd"
  },
  {
    "cast": "Horní Újezd",
    "psc": "75353",
    "okres": "Přerov",
    "obec": "Horní Újezd",
    "val": "75353 Horni Ujezd Horni Ujezd"
  },
  {
    "cast": "Horní Václavov",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Václavov u Bruntálu",
    "val": "79201 Vaclavov u Bruntalu Horni Vaclavov"
  },
  {
    "cast": "Horní Ves",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35002 Treben Horni Ves"
  },
  {
    "cast": "Horní Ves",
    "psc": "76316",
    "okres": "Zlín",
    "obec": "Fryšták",
    "val": "76316 Frystak Horni Ves"
  },
  {
    "cast": "Horní Ves",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Horni Ves"
  },
  {
    "cast": "Horní Ves",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Horní Ves",
    "val": "39301 Horni Ves Horni Ves"
  },
  {
    "cast": "Horní Ves",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Trstěnice",
    "val": "35301 Trstenice Horni Ves"
  },
  {
    "cast": "Horní Vesce",
    "psc": "37324",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37324 Rimov Horni Vesce"
  },
  {
    "cast": "Horní Vestec",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58301 Slavikov Horni Vestec"
  },
  {
    "cast": "Horní Věstonice",
    "psc": "69181",
    "okres": "Břeclav",
    "obec": "Horní Věstonice",
    "val": "69181 Horni Vestonice Horni Vestonice"
  },
  {
    "cast": "Horní Vilémovice",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Horní Vilémovice",
    "val": "67507 Horni Vilemovice Horni Vilemovice"
  },
  {
    "cast": "Horní Vilímeč",
    "psc": "39464",
    "okres": "Pelhřimov",
    "obec": "Počátky",
    "val": "39464 Pocatky Horni Vilimec"
  },
  {
    "cast": "Horní Vítkov",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Chrastava",
    "val": "46331 Chrastava Horni Vitkov"
  },
  {
    "cast": "Horní Vlčkovice",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vlčkovice v Podkrkonoší",
    "val": "54401 Vlckovice v Podkrkonosi Horni Vlckovice"
  },
  {
    "cast": "Horní Vltavice (část)",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Horní Vltavice",
    "val": "38451 Horni Vltavice Horni Vltavice (cast)"
  },
  {
    "cast": "Horní Vltavice (část)",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Horní Vltavice",
    "val": "38501 Horni Vltavice Horni Vltavice (cast)"
  },
  {
    "cast": "Horní Vltavice (část)",
    "psc": "38491",
    "okres": "Prachatice",
    "obec": "Horní Vltavice",
    "val": "38491 Horni Vltavice Horni Vltavice (cast)"
  },
  {
    "cast": "Horní Vysoké",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Levín",
    "val": "41145 Levin Horni Vysoke"
  },
  {
    "cast": "Horní Výšina",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Halže",
    "val": "34701 Halze Horni Vysina"
  },
  {
    "cast": "Horní Záblatí",
    "psc": "38433",
    "okres": "Prachatice",
    "obec": "Záblatí",
    "val": "38433 Zablati Horni Zablati"
  },
  {
    "cast": "Horní Záhoří",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Horni Zahori"
  },
  {
    "cast": "Horní Záhoří",
    "psc": "39818",
    "okres": "Písek",
    "obec": "Záhoří",
    "val": "39818 Zahori Horni Zahori"
  },
  {
    "cast": "Horní Zálezly",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40002 Malecov Horni Zalezly"
  },
  {
    "cast": "Horní Žandov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Dolní Žandov",
    "val": "35002 Dolni Zandov Horni Zandov"
  },
  {
    "cast": "Horní Žďár",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Horni Zdar"
  },
  {
    "cast": "Horní Žďár",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Hajnice",
    "val": "54401 Hajnice Horni Zdar"
  },
  {
    "cast": "Horní Žďár",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Horni Zdar"
  },
  {
    "cast": "Horní Životice",
    "psc": "79312",
    "okres": "Bruntál",
    "obec": "Horní Životice",
    "val": "79312 Horni Zivotice Horni Zivotice"
  },
  {
    "cast": "Horní Žleb-Děčín XI x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Horni Zleb-Decin XI x)"
  },
  {
    "cast": "Horní Žukov",
    "psc": "73701",
    "okres": "Karviná",
    "obec": "Český Těšín",
    "val": "73701 Cesky Tesin Horni Zukov"
  },
  {
    "cast": "Hornice",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Hornice",
    "val": "67532 Hornice Hornice"
  },
  {
    "cast": "Hornická Čtvrť",
    "psc": "53312",
    "okres": "Pardubice",
    "obec": "Chvaletice",
    "val": "53312 Chvaletice Hornicka Ctvrt"
  },
  {
    "cast": "Hornosín",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Hornosín",
    "val": "38742 Hornosin Hornosin"
  },
  {
    "cast": "Horoměřice",
    "psc": "25262",
    "okres": "Praha-západ",
    "obec": "Horoměřice",
    "val": "25262 Horomerice Horomerice"
  },
  {
    "cast": "Horosedly",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Čkyně",
    "val": "38481 Ckyne Horosedly"
  },
  {
    "cast": "Horosedly (část)",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Horosedly",
    "val": "39804 Horosedly Horosedly (cast)"
  },
  {
    "cast": "Horosedly (část)",
    "psc": "39806",
    "okres": "Písek",
    "obec": "Horosedly",
    "val": "39806 Horosedly Horosedly (cast)"
  },
  {
    "cast": "Horoušánky",
    "psc": "25082",
    "okres": "Praha-východ",
    "obec": "Horoušany",
    "val": "25082 Horousany Horousanky"
  },
  {
    "cast": "Horoušany",
    "psc": "25082",
    "okres": "Praha-východ",
    "obec": "Horoušany",
    "val": "25082 Horousany Horousany"
  },
  {
    "cast": "Horoušany",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Horousany"
  },
  {
    "cast": "Horouty",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Husinec",
    "val": "38301 Husinec Horouty"
  },
  {
    "cast": "Horská Kamenice",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Horska Kamenice"
  },
  {
    "cast": "Horská Kvilda",
    "psc": "38501",
    "okres": "Klatovy",
    "obec": "Horská Kvilda",
    "val": "38501 Horska Kvilda Horska Kvilda"
  },
  {
    "cast": "Horšice",
    "psc": "33455",
    "okres": "Plzeň-jih",
    "obec": "Horšice",
    "val": "33455 Horsice Horsice"
  },
  {
    "cast": "Horšov",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Horsov"
  },
  {
    "cast": "Horusice",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Veselí nad Lužnicí",
    "val": "39181 Veseli nad Luznici Horusice"
  },
  {
    "cast": "Horušany",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Soběkury",
    "val": "33401 Sobekury Horusany"
  },
  {
    "cast": "Horušice (část)",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Horušice",
    "val": "28601 Horusice Horusice (cast)"
  },
  {
    "cast": "Horušice (část)",
    "psc": "28573",
    "okres": "Kutná Hora",
    "obec": "Horušice",
    "val": "28573 Horusice Horusice (cast)"
  },
  {
    "cast": "Horušice (část)",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Horušice",
    "val": "28401 Horusice Horusice (cast)"
  },
  {
    "cast": "Hory",
    "psc": "35707",
    "okres": "Sokolov",
    "obec": "Oloví",
    "val": "35707 Olovi Hory"
  },
  {
    "cast": "Hory",
    "psc": "67527",
    "okres": "Třebíč",
    "obec": "Předín",
    "val": "67527 Predin Hory"
  },
  {
    "cast": "Hory",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Hory"
  },
  {
    "cast": "Hory",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Hory",
    "val": "36001 Hory Hory"
  },
  {
    "cast": "Hory",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Horní Planá",
    "val": "38226 Horni Plana Hory"
  },
  {
    "cast": "Hory Matky Boží",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Hory Matky Bozi"
  },
  {
    "cast": "Hořákov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Běšiny",
    "val": "33901 Besiny Horakov"
  },
  {
    "cast": "Hořany",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Zbrašín",
    "val": "44001 Zbrasin Horany"
  },
  {
    "cast": "Hořany",
    "psc": "28914",
    "okres": "Nymburk",
    "obec": "Hořany",
    "val": "28914 Horany Horany"
  },
  {
    "cast": "Hořany",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Miskovice",
    "val": "28401 Miskovice Horany"
  },
  {
    "cast": "Hořátev",
    "psc": "28913",
    "okres": "Nymburk",
    "obec": "Hořátev",
    "val": "28913 Horatev Horatev"
  },
  {
    "cast": "Hořehledy",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Horehledy"
  },
  {
    "cast": "Hořejany",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Tochovice",
    "val": "26272 Tochovice Horejany"
  },
  {
    "cast": "Hořejší Krušec",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Horejsi Krusec"
  },
  {
    "cast": "Hořejší Kunčice",
    "psc": "74755",
    "okres": "Opava",
    "obec": "Jakartovice",
    "val": "74755 Jakartovice Horejsi Kuncice"
  },
  {
    "cast": "Hořejší Předměstí",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Domažlice",
    "val": "34401 Domazlice Horejsi Predmesti"
  },
  {
    "cast": "Hořejší Těšov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Horejsi Tesov"
  },
  {
    "cast": "Hořejší Vrchlabí (část)",
    "psc": "54301",
    "okres": "Trutnov",
    "obec": "Vrchlabí",
    "val": "54301 Vrchlabi Horejsi Vrchlabi (cast)"
  },
  {
    "cast": "Hořejší Vrchlabí (část)",
    "psc": "54302",
    "okres": "Trutnov",
    "obec": "Vrchlabí",
    "val": "54302 Vrchlabi Horejsi Vrchlabi (cast)"
  },
  {
    "cast": "Hořejší Vrchlabí (část)",
    "psc": "54351",
    "okres": "Trutnov",
    "obec": "Vrchlabí",
    "val": "54351 Vrchlabi Horejsi Vrchlabi (cast)"
  },
  {
    "cast": "Hořejšice",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Dřešín",
    "val": "38719 Dresin Horejsice"
  },
  {
    "cast": "Hořelec",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Horelec"
  },
  {
    "cast": "Hořenec",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Horenec"
  },
  {
    "cast": "Hořenec",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Nezabylice",
    "val": "43001 Nezabylice Horenec"
  },
  {
    "cast": "Hoření Paseky",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Světlá pod Ještědem",
    "val": "46343 Svetla pod Jestedem Horeni Paseky"
  },
  {
    "cast": "Hoření Starý Dub",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Horeni Stary Dub"
  },
  {
    "cast": "Hoření Vinice",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Kly",
    "val": "27741 Kly Horeni Vinice"
  },
  {
    "cast": "Hořenice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43801 Chbany Horenice"
  },
  {
    "cast": "Hořenice",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Hořenice",
    "val": "55101 Horenice Horenice"
  },
  {
    "cast": "Hořensko",
    "psc": "51201",
    "okres": "Semily",
    "obec": "Slaná",
    "val": "51201 Slana Horensko"
  },
  {
    "cast": "Hořepník",
    "psc": "39421",
    "okres": "Pelhřimov",
    "obec": "Hořepník",
    "val": "39421 Horepnik Horepnik"
  },
  {
    "cast": "Hořesedly",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Hořesedly",
    "val": "27004 Horesedly Horesedly"
  },
  {
    "cast": "Hořešovice",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Hořešovice",
    "val": "27374 Horesovice Horesovice"
  },
  {
    "cast": "Hořešovičky",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Hořešovičky",
    "val": "27374 Horesovicky Horesovicky"
  },
  {
    "cast": "Hořetice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žiželice",
    "val": "43801 Zizelice Horetice"
  },
  {
    "cast": "Hořetice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Horetice"
  },
  {
    "cast": "Hořice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Hořice",
    "val": "39601 Horice Horice"
  },
  {
    "cast": "Hořice",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Horice"
  },
  {
    "cast": "Hořice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Hořice",
    "val": "50801 Horice Horice"
  },
  {
    "cast": "Hořice",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33563 Spalene Porici Horice"
  },
  {
    "cast": "Hořice na Šumavě",
    "psc": "38222",
    "okres": "Český Krumlov",
    "obec": "Hořice na Šumavě",
    "val": "38222 Horice na Sumave Horice na Sumave"
  },
  {
    "cast": "Hořičky",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Hořičky",
    "val": "55205 Horicky Horicky"
  },
  {
    "cast": "Hoříkovice",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Chotěšov",
    "val": "33301 Chotesov Horikovice"
  },
  {
    "cast": "Hoříkovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38301 Lhenice Horikovice"
  },
  {
    "cast": "Hořín",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Hořín",
    "val": "27601 Horin Horin"
  },
  {
    "cast": "Hořiněves (část)",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Hořiněves",
    "val": "50303 Horineves Horineves (cast)"
  },
  {
    "cast": "Hořiněves (část)",
    "psc": "50306",
    "okres": "Hradec Králové",
    "obec": "Hořiněves",
    "val": "50306 Horineves Horineves (cast)"
  },
  {
    "cast": "Hořovice",
    "psc": "26801",
    "okres": "Beroun",
    "obec": "Hořovice",
    "val": "26801 Horovice Horovice"
  },
  {
    "cast": "Hořovičky",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Hořovičky",
    "val": "27004 Horovicky Horovicky"
  },
  {
    "cast": "Hosín (část)",
    "psc": "37361",
    "okres": "České Budějovice",
    "obec": "Hosín",
    "val": "37361 Hosin Hosin (cast)"
  },
  {
    "cast": "Hosín (část)",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hosín",
    "val": "37341 Hosin Hosin (cast)"
  },
  {
    "cast": "Hoslovice",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Hoslovice",
    "val": "38719 Hoslovice Hoslovice"
  },
  {
    "cast": "Hosov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Hosov"
  },
  {
    "cast": "Hospozín",
    "psc": "27322",
    "okres": "Kladno",
    "obec": "Hospozín",
    "val": "27322 Hospozin Hospozin"
  },
  {
    "cast": "Hospozínek",
    "psc": "27322",
    "okres": "Kladno",
    "obec": "Hospozín",
    "val": "27322 Hospozin Hospozinek"
  },
  {
    "cast": "Hospříz",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Hospříz",
    "val": "37701 Hospriz Hospriz"
  },
  {
    "cast": "Hostačov",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Skryje",
    "val": "58282 Skryje Hostacov"
  },
  {
    "cast": "Hostákov",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Vladislav",
    "val": "67501 Vladislav Hostakov"
  },
  {
    "cast": "Hostašovice",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Hostašovice",
    "val": "74101 Hostasovice Hostasovice"
  },
  {
    "cast": "Hostavice",
    "psc": "19800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19800 Praha Hostavice"
  },
  {
    "cast": "Hostějeves",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Jarošov nad Nežárkou",
    "val": "37842 Jarosov nad Nezarkou Hostejeves"
  },
  {
    "cast": "Hostějov",
    "psc": "68741",
    "okres": "Uherské Hradiště",
    "obec": "Hostějov",
    "val": "68741 Hostejov Hostejov"
  },
  {
    "cast": "Hostěnice",
    "psc": "66404",
    "okres": "Brno-venkov",
    "obec": "Hostěnice",
    "val": "66404 Hostenice Hostenice"
  },
  {
    "cast": "Hostěnice",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Brozany nad Ohří",
    "val": "41301 Brozany nad Ohri Hostenice"
  },
  {
    "cast": "Hostěradice",
    "psc": "67171",
    "okres": "Znojmo",
    "obec": "Hostěradice",
    "val": "67171 Hosteradice Hosteradice"
  },
  {
    "cast": "Hostěradice",
    "psc": "25282",
    "okres": "Praha-západ",
    "obec": "Kamenný Přívoz",
    "val": "25282 Kamenny Privoz Hosteradice"
  },
  {
    "cast": "Hostěrádky-Rešov",
    "psc": "68352",
    "okres": "Vyškov",
    "obec": "Hostěrádky-Rešov",
    "val": "68352 Hosteradky-Resov Hosteradky-Resov"
  },
  {
    "cast": "Hostětice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Hostětice",
    "val": "58856 Hostetice Hostetice"
  },
  {
    "cast": "Hostětín",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Hostětín",
    "val": "68771 Hostetin Hostetin"
  },
  {
    "cast": "Hostětínky",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Rušinov",
    "val": "58301 Rusinov Hostetinky"
  },
  {
    "cast": "Hostice",
    "psc": "78963",
    "okres": "Šumperk",
    "obec": "Ruda nad Moravou",
    "val": "78963 Ruda nad Moravou Hostice"
  },
  {
    "cast": "Hostíčkov",
    "psc": "34813",
    "okres": "Tachov",
    "obec": "Chodová Planá",
    "val": "34813 Chodova Plana Hostickov"
  },
  {
    "cast": "Hostíkovice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Holany",
    "val": "47002 Holany Hostikovice"
  },
  {
    "cast": "Hostim",
    "psc": "67154",
    "okres": "Znojmo",
    "obec": "Hostim",
    "val": "67154 Hostim Hostim"
  },
  {
    "cast": "Hostim-Beroun x)",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Hostim-Beroun x)"
  },
  {
    "cast": "Hostín",
    "psc": "27732",
    "okres": "Mělník",
    "obec": "Hostín",
    "val": "27732 Hostin Hostin"
  },
  {
    "cast": "Hostín",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Hostin"
  },
  {
    "cast": "Hostín u Vojkovic",
    "psc": "27744",
    "okres": "Mělník",
    "obec": "Hostín u Vojkovic",
    "val": "27744 Hostin u Vojkovic Hostin u Vojkovic"
  },
  {
    "cast": "Hostinka",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Vestec",
    "val": "55205 Vestec Hostinka"
  },
  {
    "cast": "Hostinné",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Hostinné",
    "val": "54371 Hostinne Hostinne"
  },
  {
    "cast": "Hostišov",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Hostisov"
  },
  {
    "cast": "Hostišová",
    "psc": "76301",
    "okres": "Zlín",
    "obec": "Hostišová",
    "val": "76301 Hostisova Hostisova"
  },
  {
    "cast": "Hostišovice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Bělčice",
    "val": "38801 Belcice Hostisovice"
  },
  {
    "cast": "Hostivař (část)",
    "psc": "10200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10200 Praha Hostivar (cast)"
  },
  {
    "cast": "Hostivař (část)",
    "psc": "10900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10900 Praha Hostivar (cast)"
  },
  {
    "cast": "Hostivice",
    "psc": "25301",
    "okres": "Praha-západ",
    "obec": "Hostivice",
    "val": "25301 Hostivice Hostivice"
  },
  {
    "cast": "Hostkovice",
    "psc": "78357",
    "okres": "Olomouc",
    "obec": "Tršice",
    "val": "78357 Trsice Hostkovice"
  },
  {
    "cast": "Hostkovice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Hostkovice"
  },
  {
    "cast": "Hostkovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Třebětín",
    "val": "28522 Trebetin Hostkovice"
  },
  {
    "cast": "Hostokryje (část)",
    "psc": "27031",
    "okres": "Rakovník",
    "obec": "Senomaty",
    "val": "27031 Senomaty Hostokryje (cast)"
  },
  {
    "cast": "Hostokryje (část)",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Senomaty",
    "val": "27035 Senomaty Hostokryje (cast)"
  },
  {
    "cast": "Hostomice",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Hostomice",
    "val": "26724 Hostomice Hostomice"
  },
  {
    "cast": "Hostomice",
    "psc": "41752",
    "okres": "Teplice",
    "obec": "Hostomice",
    "val": "41752 Hostomice Hostomice"
  },
  {
    "cast": "Hostouň",
    "psc": "27353",
    "okres": "Kladno",
    "obec": "Hostouň",
    "val": "27353 Hostoun Hostoun"
  },
  {
    "cast": "Hostouň",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Hostoun"
  },
  {
    "cast": "Hostovice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Hostovice"
  },
  {
    "cast": "Hostovice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40002 Usti nad Labem Hostovice"
  },
  {
    "cast": "Hostovlice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Hostovlice"
  },
  {
    "cast": "Hostovlice",
    "psc": "28562",
    "okres": "Kutná Hora",
    "obec": "Hostovlice",
    "val": "28562 Hostovlice Hostovlice"
  },
  {
    "cast": "Hostovnice",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Hostovnice"
  },
  {
    "cast": "Hosty",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Hosty",
    "val": "37501 Hosty Hosty"
  },
  {
    "cast": "Hoškovice",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Hoskovice"
  },
  {
    "cast": "Hošnice",
    "psc": "43114",
    "okres": "Chomutov",
    "obec": "Strupčice",
    "val": "43114 Strupcice Hosnice"
  },
  {
    "cast": "Hošťálková",
    "psc": "75622",
    "okres": "Vsetín",
    "obec": "Hošťálková",
    "val": "75622 Hostalkova Hostalkova"
  },
  {
    "cast": "Hošťálkovice",
    "psc": "72528",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72528 Ostrava Hostalkovice"
  },
  {
    "cast": "Hošťálkovy",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Hošťálkovy",
    "val": "79401 Hostalkovy Hostalkovy"
  },
  {
    "cast": "Hošťalovice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Hošťalovice",
    "val": "53803 Hostalovice Hostalovice"
  },
  {
    "cast": "Hoštěc",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Hostec"
  },
  {
    "cast": "Hoštejn",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Hoštejn",
    "val": "78901 Hostejn Hostejn"
  },
  {
    "cast": "Hoštice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Hostice"
  },
  {
    "cast": "Hoštice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Hoštice",
    "val": "38701 Hostice Hostice"
  },
  {
    "cast": "Hoštice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nemyšl",
    "val": "39143 Nemysl Hostice"
  },
  {
    "cast": "Hoštice",
    "psc": "76813",
    "okres": "Kroměříž",
    "obec": "Hoštice",
    "val": "76813 Hostice Hostice"
  },
  {
    "cast": "Hoštice",
    "psc": "25069",
    "okres": "Praha-východ",
    "obec": "Vodochody",
    "val": "25069 Vodochody Hostice"
  },
  {
    "cast": "Hoštice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Hoštice-Heroltice",
    "val": "68201 Hostice-Heroltice Hostice"
  },
  {
    "cast": "Hoštice-Heroltice x)",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Hoštice-Heroltice",
    "val": "68201 Hostice-Heroltice Hostice-Heroltice x)"
  },
  {
    "cast": "Hoštičky",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Hosticky"
  },
  {
    "cast": "Hoštka",
    "psc": "41172",
    "okres": "Litoměřice",
    "obec": "Hoštka",
    "val": "41172 Hostka Hostka"
  },
  {
    "cast": "Hošťka",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Hošťka",
    "val": "34806 Hostka Hostka"
  },
  {
    "cast": "Houdkovice",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Trnov",
    "val": "51801 Trnov Houdkovice"
  },
  {
    "cast": "Houkov",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Helvíkovice",
    "val": "56401 Helvikovice Houkov"
  },
  {
    "cast": "Houserovka",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Houserovka"
  },
  {
    "cast": "Houska",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Blatce",
    "val": "47201 Blatce Houska"
  },
  {
    "cast": "Housko",
    "psc": "67913",
    "okres": "Blansko",
    "obec": "Vysočany",
    "val": "67913 Vysocany Housko"
  },
  {
    "cast": "Houžná (část)",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Lenora",
    "val": "38451 Lenora Houzna (cast)"
  },
  {
    "cast": "Houžná (část)",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Lenora",
    "val": "38501 Lenora Houzna (cast)"
  },
  {
    "cast": "Hovězí",
    "psc": "75601",
    "okres": "Vsetín",
    "obec": "Hovězí",
    "val": "75601 Hovezi Hovezi"
  },
  {
    "cast": "Hovorany",
    "psc": "69612",
    "okres": "Hodonín",
    "obec": "Hovorany",
    "val": "69612 Hovorany Hovorany"
  },
  {
    "cast": "Hovorčovice",
    "psc": "25064",
    "okres": "Praha-východ",
    "obec": "Hovorčovice",
    "val": "25064 Hovorcovice Hovorcovice"
  },
  {
    "cast": "Hrabačov",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Jilemnice",
    "val": "51401 Jilemnice Hrabacov"
  },
  {
    "cast": "Hraběcí Huť",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Kvilda",
    "val": "38501 Kvilda Hrabeci Hut"
  },
  {
    "cast": "Hrabenov",
    "psc": "78963",
    "okres": "Šumperk",
    "obec": "Ruda nad Moravou",
    "val": "78963 Ruda nad Moravou Hrabenov"
  },
  {
    "cast": "Hraběšice",
    "psc": "78815",
    "okres": "Šumperk",
    "obec": "Hraběšice",
    "val": "78815 Hrabesice Hrabesice"
  },
  {
    "cast": "Hraběšín",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Hraběšín",
    "val": "28601 Hrabesin Hrabesin"
  },
  {
    "cast": "Hrabětice",
    "psc": "67168",
    "okres": "Znojmo",
    "obec": "Hrabětice",
    "val": "67168 Hrabetice Hrabetice"
  },
  {
    "cast": "Hrabětice",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Jeseník nad Odrou",
    "val": "74101 Jesenik nad Odrou Hrabetice"
  },
  {
    "cast": "Hrabětice",
    "psc": "46811",
    "okres": "Jablonec nad Nisou",
    "obec": "Janov nad Nisou",
    "val": "46811 Janov nad Nisou Hrabetice"
  },
  {
    "cast": "Hrabí",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Bílá Lhota",
    "val": "78321 Bila Lhota Hrabi"
  },
  {
    "cast": "Hrabice",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Hrabice"
  },
  {
    "cast": "Hrabišín",
    "psc": "78804",
    "okres": "Šumperk",
    "obec": "Hrabišín",
    "val": "78804 Hrabisin Hrabisin"
  },
  {
    "cast": "Hrabová",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Hrabová",
    "val": "78901 Hrabova Hrabova"
  },
  {
    "cast": "Hrabová (část)",
    "psc": "71900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71900 Ostrava Hrabova (cast)"
  },
  {
    "cast": "Hrabová (část)",
    "psc": "72000",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72000 Ostrava Hrabova (cast)"
  },
  {
    "cast": "Hrabová (část)",
    "psc": "73932",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "73932 Ostrava Hrabova (cast)"
  },
  {
    "cast": "Hrabří",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Vysoký Chlumec",
    "val": "26401 Vysoky Chlumec Hrabri"
  },
  {
    "cast": "Hrabství",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Skřipov",
    "val": "74741 Skripov Hrabstvi"
  },
  {
    "cast": "Hrabůvka",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Hrabůvka",
    "val": "75301 Hrabuvka Hrabuvka"
  },
  {
    "cast": "Hrabůvka",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Hrabuvka"
  },
  {
    "cast": "Hrabyně (část)",
    "psc": "74763",
    "okres": "Opava",
    "obec": "Hrabyně",
    "val": "74763 Hrabyne Hrabyne (cast)"
  },
  {
    "cast": "Hrabyně (část)",
    "psc": "74767",
    "okres": "Opava",
    "obec": "Hrabyně",
    "val": "74767 Hrabyne Hrabyne (cast)"
  },
  {
    "cast": "Hrad Nečtiny",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Hrad Nectiny"
  },
  {
    "cast": "Hrad Osek",
    "psc": "41705",
    "okres": "Teplice",
    "obec": "Osek",
    "val": "41705 Osek Hrad Osek"
  },
  {
    "cast": "Hradce",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Vysoký Chlumec",
    "val": "26401 Vysoky Chlumec Hradce"
  },
  {
    "cast": "Hradce",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Hradce",
    "val": "37001 Hradce Hradce"
  },
  {
    "cast": "Hradčany",
    "psc": "28905",
    "okres": "Nymburk",
    "obec": "Hradčany",
    "val": "28905 Hradcany Hradcany"
  },
  {
    "cast": "Hradčany",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Hradcany"
  },
  {
    "cast": "Hradčany",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Bošice",
    "val": "38481 Bosice Hradcany"
  },
  {
    "cast": "Hradčany",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "47124 Ralsko Hradcany"
  },
  {
    "cast": "Hradčany",
    "psc": "75111",
    "okres": "Přerov",
    "obec": "Hradčany",
    "val": "75111 Hradcany Hradcany"
  },
  {
    "cast": "Hradčany",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Chlumčany",
    "val": "33401 Chlumcany Hradcany"
  },
  {
    "cast": "Hradčany",
    "psc": "66603",
    "okres": "Brno-venkov",
    "obec": "Hradčany",
    "val": "66603 Hradcany Hradcany"
  },
  {
    "cast": "Hradčany",
    "psc": "79807",
    "okres": "Prostějov",
    "obec": "Hradčany-Kobeřice",
    "val": "79807 Hradcany-Koberice Hradcany"
  },
  {
    "cast": "Hradčany (část)",
    "psc": "16000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16000 Praha Hradcany (cast)"
  },
  {
    "cast": "Hradčany (část)",
    "psc": "16900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16900 Praha Hradcany (cast)"
  },
  {
    "cast": "Hradčany (část)",
    "psc": "11800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "11800 Praha Hradcany (cast)"
  },
  {
    "cast": "Hradčany (část)",
    "psc": "11900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "11900 Praha Hradcany (cast)"
  },
  {
    "cast": "Hradčovice",
    "psc": "68733",
    "okres": "Uherské Hradiště",
    "obec": "Hradčovice",
    "val": "68733 Hradcovice Hradcovice"
  },
  {
    "cast": "Hradec",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Rokle",
    "val": "43201 Rokle Hradec"
  },
  {
    "cast": "Hradec",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hradec",
    "val": "58401 Hradec Hradec"
  },
  {
    "cast": "Hradec",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29413 Mnichovo Hradiste Hradec"
  },
  {
    "cast": "Hradec",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Stříbrná Skalice",
    "val": "28163 Stribrna Skalice Hradec"
  },
  {
    "cast": "Hradec Králové (část)",
    "psc": "50002",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50002 Hradec Kralove Hradec Kralove (cast)"
  },
  {
    "cast": "Hradec Králové (část)",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Hradec Kralove (cast)"
  },
  {
    "cast": "Hradec Králové (část)",
    "psc": "50004",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50004 Hradec Kralove Hradec Kralove (cast)"
  },
  {
    "cast": "Hradec Králové (část)",
    "psc": "50009",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50009 Hradec Kralove Hradec Kralove (cast)"
  },
  {
    "cast": "Hradec Králové (část)",
    "psc": "50341",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50341 Hradec Kralove Hradec Kralove (cast)"
  },
  {
    "cast": "Hradec Králové (část)",
    "psc": "50012",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50012 Hradec Kralove Hradec Kralove (cast)"
  },
  {
    "cast": "Hradec nad Moravicí",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Hradec nad Moravicí",
    "val": "74741 Hradec nad Moravici Hradec nad Moravici"
  },
  {
    "cast": "Hradec nad Svitavou",
    "psc": "56901",
    "okres": "Svitavy",
    "obec": "Hradec nad Svitavou",
    "val": "56901 Hradec nad Svitavou Hradec nad Svitavou"
  },
  {
    "cast": "Hradec (část)",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Hradec",
    "val": "33301 Hradec Hradec (cast)"
  },
  {
    "cast": "Hradec (část)",
    "psc": "33211",
    "okres": "Plzeň-jih",
    "obec": "Hradec",
    "val": "33211 Hradec Hradec (cast)"
  },
  {
    "cast": "Hradecko",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kralovice",
    "val": "33141 Kralovice Hradecko"
  },
  {
    "cast": "Hradec-Nová Ves",
    "psc": "79084",
    "okres": "Jeseník",
    "obec": "Hradec-Nová Ves",
    "val": "79084 Hradec-Nova Ves Hradec-Nova Ves"
  },
  {
    "cast": "Hradečná",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Bílá Lhota",
    "val": "78324 Bila Lhota Hradecna"
  },
  {
    "cast": "Hrádečná",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Blatno",
    "val": "43001 Blatno Hradecna"
  },
  {
    "cast": "Hradečno",
    "psc": "27304",
    "okres": "Kladno",
    "obec": "Hradečno",
    "val": "27304 Hradecno Hradecno"
  },
  {
    "cast": "Hrádek",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Raná",
    "val": "44001 Rana Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Ctiboř",
    "val": "25801 Ctibor Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hrádek",
    "val": "34201 Hradek Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Krajková",
    "val": "35709 Krajkova Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Hrádek",
    "val": "50315 Hradek Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "33842",
    "okres": "Rokycany",
    "obec": "Hrádek",
    "val": "33842 Hradek Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Srch",
    "val": "53345 Srch Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "73997",
    "okres": "Frýdek-Místek",
    "obec": "Hrádek",
    "val": "73997 Hradek Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Horka II",
    "val": "28522 Horka II Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Hrádek",
    "val": "56201 Hradek Hradek"
  },
  {
    "cast": "Hrádek",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Hradek"
  },
  {
    "cast": "Hrádek na Vlárské dráze",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Slavičín",
    "val": "76321 Slavicin Hradek na Vlarske draze"
  },
  {
    "cast": "Hrádek nad Nisou",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Hradek nad Nisou"
  },
  {
    "cast": "Hrádek (část)",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Hrádek",
    "val": "67128 Hradek Hradek (cast)"
  },
  {
    "cast": "Hrádek (část)",
    "psc": "67127",
    "okres": "Znojmo",
    "obec": "Hrádek",
    "val": "67127 Hradek Hradek (cast)"
  },
  {
    "cast": "Hradenín",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Plaňany",
    "val": "28002 Planany Hradenin"
  },
  {
    "cast": "Hradešice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Hradešice",
    "val": "34101 Hradesice Hradesice"
  },
  {
    "cast": "Hradešín",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Hradešín",
    "val": "28201 Hradesin Hradesin"
  },
  {
    "cast": "Hradisko",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Hradisko"
  },
  {
    "cast": "Hradišťany",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Honezovice",
    "val": "33301 Honezovice Hradistany"
  },
  {
    "cast": "Hradiště",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Chlum",
    "val": "47201 Chlum Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Hradiště",
    "val": "25801 Hradiste Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bžany",
    "val": "41501 Bzany Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Hradiště",
    "val": "33808 Hradiste Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "73542",
    "okres": "Karviná",
    "obec": "Těrlicko",
    "val": "73542 Terlicko Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Hradiště",
    "val": "34543 Hradiste Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Malovice",
    "val": "38411 Malovice Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Hradiště",
    "val": "33544 Hradiste Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "České Lhotice",
    "val": "53825 Ceske Lhotice Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Hradiste"
  },
  {
    "cast": "Hradiště",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Hradiste"
  },
  {
    "cast": "Hradiště na Písku",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Staré Hradiště",
    "val": "53352 Stare Hradiste Hradiste na Pisku"
  },
  {
    "cast": "Hradiště (část)",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Hradiště",
    "val": "36471 Hradiste Hradiste (cast)"
  },
  {
    "cast": "Hradiště (část)",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Koldín",
    "val": "56501 Koldin Hradiste (cast)"
  },
  {
    "cast": "Hradiště (část)",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Hradiště",
    "val": "36301 Hradiste Hradiste (cast)"
  },
  {
    "cast": "Hradiště (část)",
    "psc": "51741",
    "okres": "Ústí nad Orlicí",
    "obec": "Koldín",
    "val": "51741 Koldin Hradiste (cast)"
  },
  {
    "cast": "Hradištko",
    "psc": "28912",
    "okres": "Nymburk",
    "obec": "Hradištko",
    "val": "28912 Hradistko Hradistko"
  },
  {
    "cast": "Hradištko",
    "psc": "25209",
    "okres": "Praha-západ",
    "obec": "Hradištko",
    "val": "25209 Hradistko Hradistko"
  },
  {
    "cast": "Hradišťko",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Hradistko"
  },
  {
    "cast": "Hradišťko",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Hradistko"
  },
  {
    "cast": "Hradíšťko",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Žeretice",
    "val": "50703 Zeretice Hradistko"
  },
  {
    "cast": "Hradišťko I",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Veltruby",
    "val": "28002 Veltruby Hradistko I"
  },
  {
    "cast": "Hradišťko II",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Žiželice",
    "val": "28126 Zizelice Hradistko II"
  },
  {
    "cast": "Hradišťská Lhotka",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Hradistska Lhotka"
  },
  {
    "cast": "Hradišťský Újezd",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Hradistsky Ujezd"
  },
  {
    "cast": "Hrádkov",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Boskovice",
    "val": "68001 Boskovice Hradkov"
  },
  {
    "cast": "Hradové Střimelice",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Stříbrná Skalice",
    "val": "28163 Stribrna Skalice Hradove Strimelice"
  },
  {
    "cast": "Hradsko",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Hradsko"
  },
  {
    "cast": "Hradsko",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Hradsko"
  },
  {
    "cast": "Hracholusky",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Hracholusky",
    "val": "27041 Hracholusky Hracholusky"
  },
  {
    "cast": "Hracholusky",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Úlice",
    "val": "33033 Ulice Hracholusky"
  },
  {
    "cast": "Hracholusky (část)",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Hracholusky",
    "val": "38411 Hracholusky Hracholusky (cast)"
  },
  {
    "cast": "Hracholusky (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Hracholusky",
    "val": "38301 Hracholusky Hracholusky (cast)"
  },
  {
    "cast": "Hrachov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Hrachov"
  },
  {
    "cast": "Hrachov",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26256 Svaty Jan Hrachov"
  },
  {
    "cast": "Hrachovec",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Valašské Meziříčí",
    "val": "75701 Valasske Mezirici Hrachovec"
  },
  {
    "cast": "Hrachovice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Hrachovice"
  },
  {
    "cast": "Hrachoviště",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Býšť",
    "val": "53401 Byst Hrachoviste"
  },
  {
    "cast": "Hrachoviště",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Hrachoviště",
    "val": "37901 Hrachoviste Hrachoviste"
  },
  {
    "cast": "Hrajovice",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Kamberk",
    "val": "25706 Kamberk Hrajovice"
  },
  {
    "cast": "Hranice",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Hranice"
  },
  {
    "cast": "Hranice",
    "psc": "35124",
    "okres": "Cheb",
    "obec": "Hranice",
    "val": "35124 Hranice Hranice"
  },
  {
    "cast": "Hranice",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Maleč",
    "val": "58301 Malec Hranice"
  },
  {
    "cast": "Hranice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Hranice",
    "val": "37401 Hranice Hranice"
  },
  {
    "cast": "Hranice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Slavošov",
    "val": "28522 Slavosov Hranice"
  },
  {
    "cast": "Hranice",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Hranice"
  },
  {
    "cast": "Hranice III-Velká",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75301 Hranice Hranice III-Velka"
  },
  {
    "cast": "Hranice II-Lhotka",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75301 Hranice Hranice II-Lhotka"
  },
  {
    "cast": "Hranice IV-Drahotuše",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Hranice IV-Drahotuse"
  },
  {
    "cast": "Hranice IX-Uhřínov",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Hranice IX-Uhrinov"
  },
  {
    "cast": "Hranice I-Město",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75301 Hranice Hranice I-Mesto"
  },
  {
    "cast": "Hranice VIII-Středolesí",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Hranice VIII-Stredolesi"
  },
  {
    "cast": "Hranice VII-Slavíč",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Hranice VII-Slavic"
  },
  {
    "cast": "Hranice VI-Valšovice",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75354 Hranice Hranice VI-Valsovice"
  },
  {
    "cast": "Hranice V-Rybáře",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Hranice V-Rybare"
  },
  {
    "cast": "Hranické Loučky",
    "psc": "75366",
    "okres": "Přerov",
    "obec": "Hustopeče nad Bečvou",
    "val": "75366 Hustopece nad Becvou Hranicke Loucky"
  },
  {
    "cast": "Hraničky",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Uhelná",
    "val": "79065 Uhelna Hranicky"
  },
  {
    "cast": "Hraničná",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Hranicna"
  },
  {
    "cast": "Hraničná",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Pomezí nad Ohří",
    "val": "35002 Pomezi nad Ohri Hranicna"
  },
  {
    "cast": "Hraničná",
    "psc": "46811",
    "okres": "Jablonec nad Nisou",
    "obec": "Janov nad Nisou",
    "val": "46811 Janov nad Nisou Hranicna"
  },
  {
    "cast": "Hraničné Petrovice",
    "psc": "78306",
    "okres": "Olomouc",
    "obec": "Hraničné Petrovice",
    "val": "78306 Hranicne Petrovice Hranicne Petrovice"
  },
  {
    "cast": "Hraštice",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51703 Skuhrov nad Belou Hrastice"
  },
  {
    "cast": "Hráz",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "34012 Mecin Hraz"
  },
  {
    "cast": "Hrazánky",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Hrazany",
    "val": "39901 Hrazany Hrazanky"
  },
  {
    "cast": "Hrazany",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Radíč",
    "val": "26401 Radic Hrazany"
  },
  {
    "cast": "Hrazany",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Hrazany",
    "val": "39901 Hrazany Hrazany"
  },
  {
    "cast": "Hrazená Lhota",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vlašim",
    "val": "25801 Vlasim Hrazena Lhota"
  },
  {
    "cast": "Hrbokov",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Hrbokov"
  },
  {
    "cast": "Hrbov",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Polná",
    "val": "58813 Polna Hrbov"
  },
  {
    "cast": "Hrbov",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Meziříčí",
    "val": "59401 Velke Mezirici Hrbov"
  },
  {
    "cast": "Hrbov (část)",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38411 Lhenice Hrbov (cast)"
  },
  {
    "cast": "Hrbov (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38301 Lhenice Hrbov (cast)"
  },
  {
    "cast": "Hrbovice",
    "psc": "40339",
    "okres": "Ústí nad Labem",
    "obec": "Chlumec",
    "val": "40339 Chlumec Hrbovice"
  },
  {
    "cast": "Hrčava",
    "psc": "73998",
    "okres": "Frýdek-Místek",
    "obec": "Hrčava",
    "val": "73998 Hrcava Hrcava"
  },
  {
    "cast": "Hrdějovice (část)",
    "psc": "37367",
    "okres": "České Budějovice",
    "obec": "Hrdějovice",
    "val": "37367 Hrdejovice Hrdejovice (cast)"
  },
  {
    "cast": "Hrdějovice (část)",
    "psc": "37361",
    "okres": "České Budějovice",
    "obec": "Hrdějovice",
    "val": "37361 Hrdejovice Hrdejovice (cast)"
  },
  {
    "cast": "Hrdějovice (část)",
    "psc": "37010",
    "okres": "České Budějovice",
    "obec": "Hrdějovice",
    "val": "37010 Hrdejovice Hrdejovice (cast)"
  },
  {
    "cast": "Hrdibořice",
    "psc": "79812",
    "okres": "Prostějov",
    "obec": "Hrdibořice",
    "val": "79812 Hrdiborice Hrdiborice"
  },
  {
    "cast": "Hrdlív",
    "psc": "27306",
    "okres": "Kladno",
    "obec": "Hrdlív",
    "val": "27306 Hrdliv Hrdliv"
  },
  {
    "cast": "Hrdlořezy",
    "psc": "19000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19000 Praha Hrdlorezy"
  },
  {
    "cast": "Hrdlořezy",
    "psc": "29307",
    "okres": "Mladá Boleslav",
    "obec": "Hrdlořezy",
    "val": "29307 Hrdlorezy Hrdlorezy"
  },
  {
    "cast": "Hrdlořezy",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Suchdol nad Lužnicí",
    "val": "37806 Suchdol nad Luznici Hrdlorezy"
  },
  {
    "cast": "Hrdly",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Bohušovice nad Ohří",
    "val": "41201 Bohusovice nad Ohri Hrdly"
  },
  {
    "cast": "Hrdoňovice (část)",
    "psc": "50745",
    "okres": "Jičín",
    "obec": "Újezd pod Troskami",
    "val": "50745 Ujezd pod Troskami Hrdonovice (cast)"
  },
  {
    "cast": "Hrdoňovice (část)",
    "psc": "51263",
    "okres": "Jičín",
    "obec": "Újezd pod Troskami",
    "val": "51263 Ujezd pod Troskami Hrdonovice (cast)"
  },
  {
    "cast": "Hrejkovice (část)",
    "psc": "39859",
    "okres": "Písek",
    "obec": "Hrejkovice",
    "val": "39859 Hrejkovice Hrejkovice (cast)"
  },
  {
    "cast": "Hrejkovice (část)",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Hrejkovice",
    "val": "39901 Hrejkovice Hrejkovice (cast)"
  },
  {
    "cast": "Hrnčíře",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Vilice",
    "val": "39143 Vilice Hrncire"
  },
  {
    "cast": "Hrob",
    "psc": "41704",
    "okres": "Teplice",
    "obec": "Hrob",
    "val": "41704 Hrob Hrob"
  },
  {
    "cast": "Hrobce",
    "psc": "41183",
    "okres": "Litoměřice",
    "obec": "Hrobce",
    "val": "41183 Hrobce Hrobce"
  },
  {
    "cast": "Hrobčice",
    "psc": "41757",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41757 Hrobcice Hrobcice"
  },
  {
    "cast": "Hrobice",
    "psc": "76315",
    "okres": "Zlín",
    "obec": "Hrobice",
    "val": "76315 Hrobice Hrobice"
  },
  {
    "cast": "Hrobice",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Hrobice",
    "val": "53352 Hrobice Hrobice"
  },
  {
    "cast": "Hrobičany",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Sběř",
    "val": "50703 Sber Hrobicany"
  },
  {
    "cast": "Hrobská Zahrádka",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Obrataň",
    "val": "39501 Obratan Hrobska Zahradka"
  },
  {
    "cast": "Hroby",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Radenín",
    "val": "39155 Radenin Hroby"
  },
  {
    "cast": "Hrochov",
    "psc": "79845",
    "okres": "Prostějov",
    "obec": "Lipová",
    "val": "79845 Lipova Hrochov"
  },
  {
    "cast": "Hrochův Týnec",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Hrochův Týnec",
    "val": "53862 Hrochuv Tynec Hrochuv Tynec"
  },
  {
    "cast": "Hromnice",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Hromnice",
    "val": "33011 Hromnice Hromnice"
  },
  {
    "cast": "Hronětice",
    "psc": "28921",
    "okres": "Nymburk",
    "obec": "Kostomlaty nad Labem",
    "val": "28921 Kostomlaty nad Labem Hronetice"
  },
  {
    "cast": "Hronov (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54931 Hronov Hronov (cast)"
  },
  {
    "cast": "Hronov (část)",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54941 Hronov Hronov (cast)"
  },
  {
    "cast": "Hronova Vesec",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Hronova Vesec"
  },
  {
    "cast": "Hroška",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bílý Újezd",
    "val": "51801 Bily Ujezd Hroska"
  },
  {
    "cast": "Hrotovice",
    "psc": "67555",
    "okres": "Třebíč",
    "obec": "Hrotovice",
    "val": "67555 Hrotovice Hrotovice"
  },
  {
    "cast": "Hroubovice",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Hroubovice",
    "val": "53854 Hroubovice Hroubovice"
  },
  {
    "cast": "Hroznatín",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Hroznatín",
    "val": "67505 Hroznatin Hroznatin"
  },
  {
    "cast": "Hrozňatov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Hroznatov"
  },
  {
    "cast": "Hroznějovice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Hroznejovice"
  },
  {
    "cast": "Hroznětice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Hořice",
    "val": "39601 Horice Hroznetice"
  },
  {
    "cast": "Hroznětín",
    "psc": "36233",
    "okres": "Karlovy Vary",
    "obec": "Hroznětín",
    "val": "36233 Hroznetin Hroznetin"
  },
  {
    "cast": "Hroznětín",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Číhošť",
    "val": "58401 Cihost Hroznetin"
  },
  {
    "cast": "Hroznice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Zbizuby",
    "val": "28504 Zbizuby Hroznice"
  },
  {
    "cast": "Hroznová Lhota",
    "psc": "69663",
    "okres": "Hodonín",
    "obec": "Hroznová Lhota",
    "val": "69663 Hroznova Lhota Hroznova Lhota"
  },
  {
    "cast": "Hrozová",
    "psc": "79397",
    "okres": "Bruntál",
    "obec": "Rusín",
    "val": "79397 Rusin Hrozova"
  },
  {
    "cast": "Hrubá Horka",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Hruba Horka"
  },
  {
    "cast": "Hrubá Skála",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51101 Hruba Skala Hruba Skala"
  },
  {
    "cast": "Hrubá Voda",
    "psc": "78361",
    "okres": "Olomouc",
    "obec": "Hlubočky",
    "val": "78361 Hlubocky Hruba Voda"
  },
  {
    "cast": "Hrubá Vrbka",
    "psc": "69673",
    "okres": "Hodonín",
    "obec": "Hrubá Vrbka",
    "val": "69673 Hruba Vrbka Hruba Vrbka"
  },
  {
    "cast": "Hrubčice",
    "psc": "79821",
    "okres": "Prostějov",
    "obec": "Hrubčice",
    "val": "79821 Hrubcice Hrubcice"
  },
  {
    "cast": "Hrubšice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Ivančice",
    "val": "66491 Ivancice Hrubsice"
  },
  {
    "cast": "Hrubý Jeseník",
    "psc": "28932",
    "okres": "Nymburk",
    "obec": "Hrubý Jeseník",
    "val": "28932 Hruby Jesenik Hruby Jesenik"
  },
  {
    "cast": "Hrubý Lesnov",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Cetenov",
    "val": "46348 Cetenov Hruby Lesnov"
  },
  {
    "cast": "Hrubý Rohozec",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Hruby Rohozec"
  },
  {
    "cast": "Hrudkov",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Vyšší Brod",
    "val": "38273 Vyssi Brod Hrudkov"
  },
  {
    "cast": "Hrusice",
    "psc": "25166",
    "okres": "Praha-východ",
    "obec": "Hrusice",
    "val": "25166 Hrusice Hrusice"
  },
  {
    "cast": "Hruška",
    "psc": "79827",
    "okres": "Prostějov",
    "obec": "Hruška",
    "val": "79827 Hruska Hruska"
  },
  {
    "cast": "Hrušková",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Sokolov",
    "val": "35601 Sokolov Hruskova"
  },
  {
    "cast": "Hruškové Dvory",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Hruskove Dvory"
  },
  {
    "cast": "Hrušky",
    "psc": "69156",
    "okres": "Břeclav",
    "obec": "Hrušky",
    "val": "69156 Hrusky Hrusky"
  },
  {
    "cast": "Hrušky",
    "psc": "68352",
    "okres": "Vyškov",
    "obec": "Hrušky",
    "val": "68352 Hrusky Hrusky"
  },
  {
    "cast": "Hrušov",
    "psc": "29473",
    "okres": "Mladá Boleslav",
    "obec": "Hrušov",
    "val": "29473 Hrusov Hrusov"
  },
  {
    "cast": "Hrušov",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Žimutice",
    "val": "37501 Zimutice Hrusov"
  },
  {
    "cast": "Hrušov (část)",
    "psc": "71100",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71100 Ostrava Hrusov (cast)"
  },
  {
    "cast": "Hrušov (část)",
    "psc": "71300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71300 Ostrava Hrusov (cast)"
  },
  {
    "cast": "Hrušová",
    "psc": "56555",
    "okres": "Ústí nad Orlicí",
    "obec": "Hrušová",
    "val": "56555 Hrusova Hrusova"
  },
  {
    "cast": "Hrušova Lhota",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Přehořov",
    "val": "39201 Prehorov Hrusova Lhota"
  },
  {
    "cast": "Hrušovany",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Polepy",
    "val": "41145 Polepy Hrusovany"
  },
  {
    "cast": "Hrušovany",
    "psc": "43143",
    "okres": "Chomutov",
    "obec": "Hrušovany",
    "val": "43143 Hrusovany Hrusovany"
  },
  {
    "cast": "Hrušovany nad Jevišovkou",
    "psc": "67167",
    "okres": "Znojmo",
    "obec": "Hrušovany nad Jevišovkou",
    "val": "67167 Hrusovany nad Jevisovkou Hrusovany nad Jevisovkou"
  },
  {
    "cast": "Hrušovany u Brna",
    "psc": "66462",
    "okres": "Brno-venkov",
    "obec": "Hrušovany u Brna",
    "val": "66462 Hrusovany u Brna Hrusovany u Brna"
  },
  {
    "cast": "Hrušovka",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41002 Velemin Hrusovka"
  },
  {
    "cast": "Hrutkov",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Hospříz",
    "val": "37701 Hospriz Hrutkov"
  },
  {
    "cast": "Hrutov",
    "psc": "67527",
    "okres": "Jihlava",
    "obec": "Hrutov",
    "val": "67527 Hrutov Hrutov"
  },
  {
    "cast": "Hrutov",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Hrutov"
  },
  {
    "cast": "Hryzely",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Barchovice",
    "val": "28163 Barchovice Hryzely"
  },
  {
    "cast": "Hrzín",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Nový Kostel",
    "val": "35134 Novy Kostel Hrzin"
  },
  {
    "cast": "Hrzín",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Ratměřice",
    "val": "25703 Ratmerice Hrzin"
  },
  {
    "cast": "Hřebeč",
    "psc": "27345",
    "okres": "Kladno",
    "obec": "Hřebeč",
    "val": "27345 Hrebec Hrebec"
  },
  {
    "cast": "Hřebeč",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Koclířov",
    "val": "57101 Koclirov Hrebec"
  },
  {
    "cast": "Hřebečná",
    "psc": "36235",
    "okres": "Karlovy Vary",
    "obec": "Abertamy",
    "val": "36235 Abertamy Hrebecna"
  },
  {
    "cast": "Hřebečníky",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Hřebečníky",
    "val": "27041 Hrebecniky Hrebecniky"
  },
  {
    "cast": "Hřebeny",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Josefov",
    "val": "35709 Josefov Hrebeny"
  },
  {
    "cast": "Hředle",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Hředle",
    "val": "26751 Hredle Hredle"
  },
  {
    "cast": "Hředle",
    "psc": "27008",
    "okres": "Rakovník",
    "obec": "Hředle",
    "val": "27008 Hredle Hredle"
  },
  {
    "cast": "Hřensko",
    "psc": "40717",
    "okres": "Děčín",
    "obec": "Hřensko",
    "val": "40717 Hrensko Hrensko"
  },
  {
    "cast": "Hřešice",
    "psc": "27376",
    "okres": "Kladno",
    "obec": "Pozdeň",
    "val": "27376 Pozden Hresice"
  },
  {
    "cast": "Hřešihlavy",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Kladruby",
    "val": "33808 Kladruby Hresihlavy"
  },
  {
    "cast": "Hříběcí",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Horní Cerekev",
    "val": "39301 Horni Cerekev Hribeci"
  },
  {
    "cast": "Hřibiny",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Hřibiny-Ledská",
    "val": "51741 Hribiny-Ledska Hribiny"
  },
  {
    "cast": "Hřibojedy",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Hřibojedy",
    "val": "54401 Hribojedy Hribojedy"
  },
  {
    "cast": "Hřibsko",
    "psc": "50321",
    "okres": "Hradec Králové",
    "obec": "Stěžery",
    "val": "50321 Stezery Hribsko"
  },
  {
    "cast": "Hřiby",
    "psc": "28106",
    "okres": "Kolín",
    "obec": "Vitice",
    "val": "28106 Vitice Hriby"
  },
  {
    "cast": "Hřídelec",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Hridelec"
  },
  {
    "cast": "Hříchovice",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Zahořany",
    "val": "34543 Zahorany Hrichovice"
  },
  {
    "cast": "Hřiměždice",
    "psc": "26214",
    "okres": "Příbram",
    "obec": "Hřiměždice",
    "val": "26214 Hrimezdice Hrimezdice"
  },
  {
    "cast": "Hříšice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Hříšice",
    "val": "38001 Hrisice Hrisice"
  },
  {
    "cast": "Hříškov (část)",
    "psc": "43904",
    "okres": "Louny",
    "obec": "Hříškov",
    "val": "43904 Hriskov Hriskov (cast)"
  },
  {
    "cast": "Hříškov (část)",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Hříškov",
    "val": "44001 Hriskov Hriskov (cast)"
  },
  {
    "cast": "Hřiště",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Přibyslav",
    "val": "58222 Pribyslav Hriste"
  },
  {
    "cast": "Hřivčice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Peruc",
    "val": "44001 Peruc Hrivcice"
  },
  {
    "cast": "Hřivice",
    "psc": "43965",
    "okres": "Louny",
    "obec": "Hřivice",
    "val": "43965 Hrivice Hrivice"
  },
  {
    "cast": "Hřivínov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Hrivinov"
  },
  {
    "cast": "Hřivínův Újezd",
    "psc": "76307",
    "okres": "Zlín",
    "obec": "Hřivínův Újezd",
    "val": "76307 Hrivinuv Ujezd Hrivinuv Ujezd"
  },
  {
    "cast": "Hřivno",
    "psc": "29479",
    "okres": "Mladá Boleslav",
    "obec": "Chotětov",
    "val": "29479 Chotetov Hrivno"
  },
  {
    "cast": "Hřmenín",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50723 Markvartice Hrmenin"
  },
  {
    "cast": "Hubálov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Tuř",
    "val": "50601 Tur Hubalov"
  },
  {
    "cast": "Hubálov",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Loukovec",
    "val": "29411 Loukovec Hubalov"
  },
  {
    "cast": "Hubenice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Lhota pod Libčany",
    "val": "50327 Lhota pod Libcany Hubenice"
  },
  {
    "cast": "Hubenov",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26301 Borotice Hubenov"
  },
  {
    "cast": "Hubenov",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Hubenov",
    "val": "58805 Hubenov Hubenov"
  },
  {
    "cast": "Hubenov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Běšiny",
    "val": "33901 Besiny Hubenov"
  },
  {
    "cast": "Hubenov",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Únice",
    "val": "38601 Unice Hubenov"
  },
  {
    "cast": "Hubenov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Hubenov"
  },
  {
    "cast": "Hubenov",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Horní Bělá",
    "val": "33152 Horni Bela Hubenov"
  },
  {
    "cast": "Hubíles",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Smržov",
    "val": "50303 Smrzov Hubiles"
  },
  {
    "cast": "Hubojedy",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50601 Mladejov Hubojedy"
  },
  {
    "cast": "Hubov",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Hubov"
  },
  {
    "cast": "Hudcov",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41501 Teplice Hudcov"
  },
  {
    "cast": "Hudčice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Hudčice",
    "val": "26272 Hudcice Hudcice"
  },
  {
    "cast": "Hudeč",
    "psc": "58264",
    "okres": "Havlíčkův Brod",
    "obec": "Podmoklany",
    "val": "58264 Podmoklany Hudec"
  },
  {
    "cast": "Hudlice (část)",
    "psc": "26703",
    "okres": "Beroun",
    "obec": "Hudlice",
    "val": "26703 Hudlice Hudlice (cast)"
  },
  {
    "cast": "Hudlice (část)",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Hudlice",
    "val": "26601 Hudlice Hudlice (cast)"
  },
  {
    "cast": "Hukovice",
    "psc": "74213",
    "okres": "Nový Jičín",
    "obec": "Bartošovice",
    "val": "74213 Bartosovice Hukovice"
  },
  {
    "cast": "Hukvaldy",
    "psc": "73946",
    "okres": "Frýdek-Místek",
    "obec": "Hukvaldy",
    "val": "73946 Hukvaldy Hukvaldy"
  },
  {
    "cast": "Hulice",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Hulice",
    "val": "25763 Hulice Hulice"
  },
  {
    "cast": "Hulín",
    "psc": "76824",
    "okres": "Kroměříž",
    "obec": "Hulín",
    "val": "76824 Hulin Hulin"
  },
  {
    "cast": "Hulín",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Hulin"
  },
  {
    "cast": "Hulváky (část)",
    "psc": "70300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70300 Ostrava Hulvaky (cast)"
  },
  {
    "cast": "Hulváky (část)",
    "psc": "70900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70900 Ostrava Hulvaky (cast)"
  },
  {
    "cast": "Humburky",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Humburky",
    "val": "50401 Humburky Humburky"
  },
  {
    "cast": "Humenec",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Teplýšovice",
    "val": "25601 Teplysovice Humenec"
  },
  {
    "cast": "Humenice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Humenice"
  },
  {
    "cast": "Humny",
    "psc": "27308",
    "okres": "Kladno",
    "obec": "Pchery",
    "val": "27308 Pchery Humny"
  },
  {
    "cast": "Humpolec",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Humpolec"
  },
  {
    "cast": "Humpolec",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Humpolec"
  },
  {
    "cast": "Hunčice",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33035 Listany Huncice"
  },
  {
    "cast": "Huníkov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40502 Ceska Kamenice Hunikov"
  },
  {
    "cast": "Huntířov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Huntířov",
    "val": "40502 Huntirov Huntirov"
  },
  {
    "cast": "Huntířov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Huntirov"
  },
  {
    "cast": "Huntířov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Skuhrov",
    "val": "46822 Skuhrov Huntirov"
  },
  {
    "cast": "Hůrka",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Libá",
    "val": "35002 Liba Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39131 Jistebnice Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Předslav",
    "val": "33901 Predslav Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25601 Bystrice Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "25755",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25755 Vrchotovy Janovice Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Včelákov",
    "val": "53901 Vcelakov Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Horní Planá",
    "val": "38226 Horni Plana Hurka"
  },
  {
    "cast": "Hůrka",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Jeseník nad Odrou",
    "val": "74101 Jesenik nad Odrou Hurka"
  },
  {
    "cast": "Hůrka Kapinos",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Hurka Kapinos"
  },
  {
    "cast": "Hůrka (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Nová Ves",
    "val": "37006 Nova Ves Hurka (cast)"
  },
  {
    "cast": "Hůrka (část)",
    "psc": "37008",
    "okres": "České Budějovice",
    "obec": "Nová Ves",
    "val": "37008 Nova Ves Hurka (cast)"
  },
  {
    "cast": "Hůrky",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Hůrky",
    "val": "33701 Hurky Hurky"
  },
  {
    "cast": "Hůrky",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Zahrádka",
    "val": "33038 Zahradka Hurky"
  },
  {
    "cast": "Hůrky",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36001 Karlovy Vary Hurky"
  },
  {
    "cast": "Hůrky",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Velká Chmelištná",
    "val": "27034 Velka Chmelistna Hurky"
  },
  {
    "cast": "Hůrky",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Hurky"
  },
  {
    "cast": "Hůrky",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Hurky"
  },
  {
    "cast": "Hurtova Lhota",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Hurtova Lhota",
    "val": "58001 Hurtova Lhota Hurtova Lhota"
  },
  {
    "cast": "Hůry",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Hůry",
    "val": "37371 Hury Hury"
  },
  {
    "cast": "Husa",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Paceřice",
    "val": "46344 Pacerice Husa"
  },
  {
    "cast": "Husí Lhota",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Husí Lhota",
    "val": "29406 Husi Lhota Husi Lhota"
  },
  {
    "cast": "Husinec",
    "psc": "25068",
    "okres": "Praha-východ",
    "obec": "Husinec",
    "val": "25068 Husinec Husinec"
  },
  {
    "cast": "Husinec",
    "psc": "38421",
    "okres": "Prachatice",
    "obec": "Husinec",
    "val": "38421 Husinec Husinec"
  },
  {
    "cast": "Husle",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Pernštejnské Jestřabí",
    "val": "59261 Pernstejnske Jestrabi Husle"
  },
  {
    "cast": "Huslenky (část)",
    "psc": "75602",
    "okres": "Vsetín",
    "obec": "Huslenky",
    "val": "75602 Huslenky Huslenky (cast)"
  },
  {
    "cast": "Huslenky (část)",
    "psc": "75603",
    "okres": "Vsetín",
    "obec": "Huslenky",
    "val": "75603 Huslenky Huslenky (cast)"
  },
  {
    "cast": "Husovice (část)",
    "psc": "61300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61300 Brno Husovice (cast)"
  },
  {
    "cast": "Husovice (část)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Husovice (cast)"
  },
  {
    "cast": "Husovice (část)",
    "psc": "63800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63800 Brno Husovice (cast)"
  },
  {
    "cast": "Hustířany",
    "psc": "55211",
    "okres": "Náchod",
    "obec": "Velichovky",
    "val": "55211 Velichovky Hustirany"
  },
  {
    "cast": "Hustopeče",
    "psc": "69301",
    "okres": "Břeclav",
    "obec": "Hustopeče",
    "val": "69301 Hustopece Hustopece"
  },
  {
    "cast": "Hustopeče nad Bečvou",
    "psc": "75366",
    "okres": "Přerov",
    "obec": "Hustopeče nad Bečvou",
    "val": "75366 Hustopece nad Becvou Hustopece nad Becvou"
  },
  {
    "cast": "Huštěnovice",
    "psc": "68703",
    "okres": "Uherské Hradiště",
    "obec": "Huštěnovice",
    "val": "68703 Hustenovice Hustenovice"
  },
  {
    "cast": "Huštilář",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Hustilar"
  },
  {
    "cast": "Huť",
    "psc": "46826",
    "okres": "Jablonec nad Nisou",
    "obec": "Pěnčín",
    "val": "46826 Pencin Hut"
  },
  {
    "cast": "Hutě",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Cejle",
    "val": "58851 Cejle Hute"
  },
  {
    "cast": "Hutě",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Černýšovice",
    "val": "39165 Cernysovice Hute"
  },
  {
    "cast": "Hutě",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Svojanov",
    "val": "56992 Svojanov Hute"
  },
  {
    "cast": "Hutě pod Třemšínem",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Hute pod Tremsinem"
  },
  {
    "cast": "Hutisko",
    "psc": "75662",
    "okres": "Vsetín",
    "obec": "Hutisko-Solanec",
    "val": "75662 Hutisko-Solanec Hutisko"
  },
  {
    "cast": "Hutisko-Solanec x)",
    "psc": "75662",
    "okres": "Vsetín",
    "obec": "Hutisko-Solanec",
    "val": "75662 Hutisko-Solanec Hutisko-Solanec x)"
  },
  {
    "cast": "Huzová",
    "psc": "79351",
    "okres": "Olomouc",
    "obec": "Huzová",
    "val": "79351 Huzova Huzova"
  },
  {
    "cast": "Hvězda",
    "psc": "27377",
    "okres": "Kladno",
    "obec": "Malíkovice",
    "val": "27377 Malikovice Hvezda"
  },
  {
    "cast": "Hvězda",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Blíževedly",
    "val": "47002 Blizevedly Hvezda"
  },
  {
    "cast": "Hvězda",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Hřibojedy",
    "val": "54401 Hribojedy Hvezda"
  },
  {
    "cast": "Hvězdonice",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Hvězdonice",
    "val": "25724 Hvezdonice Hvezdonice"
  },
  {
    "cast": "Hvězdoňovice",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Hvězdoňovice",
    "val": "67521 Hvezdonovice Hvezdonovice"
  },
  {
    "cast": "Hvězdov",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "47124 Ralsko Hvezdov"
  },
  {
    "cast": "Hvízdalka",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Hvizdalka"
  },
  {
    "cast": "Hvížďalka",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Hříškov",
    "val": "44001 Hriskov Hvizdalka"
  },
  {
    "cast": "Hvozd",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Hvozd",
    "val": "33101 Hvozd Hvozd"
  },
  {
    "cast": "Hvozd",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Hvozd",
    "val": "79855 Hvozd Hvozd"
  },
  {
    "cast": "Hvozd",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Hvozd",
    "val": "27035 Hvozd Hvozd"
  },
  {
    "cast": "Hvozdec",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Hvozdec",
    "val": "26762 Hvozdec Hvozdec"
  },
  {
    "cast": "Hvozdec",
    "psc": "66471",
    "okres": "Brno-venkov",
    "obec": "Hvozdec",
    "val": "66471 Hvozdec Hvozdec"
  },
  {
    "cast": "Hvozdec",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Hvozdec",
    "val": "37372 Hvozdec Hvozdec"
  },
  {
    "cast": "Hvozdec (část)",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Poříčí nad Sázavou",
    "val": "25722 Porici nad Sazavou Hvozdec (cast)"
  },
  {
    "cast": "Hvozdec (část)",
    "psc": "25721",
    "okres": "Benešov",
    "obec": "Poříčí nad Sázavou",
    "val": "25721 Porici nad Sazavou Hvozdec (cast)"
  },
  {
    "cast": "Hvozdečko",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Hvozdecko"
  },
  {
    "cast": "Hvozdná",
    "psc": "76310",
    "okres": "Zlín",
    "obec": "Hvozdná",
    "val": "76310 Hvozdna Hvozdna"
  },
  {
    "cast": "Hvozdnice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Hvozdnice",
    "val": "50327 Hvozdnice Hvozdnice"
  },
  {
    "cast": "Hvozdnice (část)",
    "psc": "25205",
    "okres": "Praha-západ",
    "obec": "Hvozdnice",
    "val": "25205 Hvozdnice Hvozdnice (cast)"
  },
  {
    "cast": "Hvozdnice (část)",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Hvozdnice",
    "val": "25210 Hvozdnice Hvozdnice (cast)"
  },
  {
    "cast": "Hvozdno",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Dolní Bukovsko",
    "val": "37365 Dolni Bukovsko Hvozdno"
  },
  {
    "cast": "Hvožďany",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Hvozdany"
  },
  {
    "cast": "Hvožďany",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33036 Unesov Hvozdany"
  },
  {
    "cast": "Hvožďany",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Hvožďany",
    "val": "34522 Hvozdany Hvozdany"
  },
  {
    "cast": "Hvožďany (část)",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Bechyně",
    "val": "39165 Bechyne Hvozdany (cast)"
  },
  {
    "cast": "Hvožďany (část)",
    "psc": "26244",
    "okres": "Příbram",
    "obec": "Hvožďany",
    "val": "26244 Hvozdany Hvozdany (cast)"
  },
  {
    "cast": "Hvožďany (část)",
    "psc": "37501",
    "okres": "Tábor",
    "obec": "Bechyně",
    "val": "37501 Bechyne Hvozdany (cast)"
  },
  {
    "cast": "Hvožďany (část)",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Hvožďany",
    "val": "26242 Hvozdany Hvozdany (cast)"
  },
  {
    "cast": "Hybrálec (část)",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Hybrálec",
    "val": "58601 Hybralec Hybralec (cast)"
  },
  {
    "cast": "Hybrálec (část)",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Hybrálec",
    "val": "58841 Hybralec Hybralec (cast)"
  },
  {
    "cast": "Hýlov",
    "psc": "74283",
    "okres": "Ostrava-město",
    "obec": "Klimkovice",
    "val": "74283 Klimkovice Hylov"
  },
  {
    "cast": "Hylváty (část)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56201 Usti nad Orlici Hylvaty (cast)"
  },
  {
    "cast": "Hylváty (část)",
    "psc": "56203",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56203 Usti nad Orlici Hylvaty (cast)"
  },
  {
    "cast": "Hynčice",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Vražné",
    "val": "74235 Vrazne Hyncice"
  },
  {
    "cast": "Hynčice",
    "psc": "54983",
    "okres": "Náchod",
    "obec": "Hynčice",
    "val": "54983 Hyncice Hyncice"
  },
  {
    "cast": "Hynčice",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Hyncice"
  },
  {
    "cast": "Hynčice nad Moravou",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Hanušovice",
    "val": "78833 Hanusovice Hyncice nad Moravou"
  },
  {
    "cast": "Hynčina",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Hynčina",
    "val": "78901 Hyncina Hyncina"
  },
  {
    "cast": "Hynkov",
    "psc": "78333",
    "okres": "Olomouc",
    "obec": "Příkazy",
    "val": "78333 Prikazy Hynkov"
  },
  {
    "cast": "Hyršov",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34506 Vseruby Hyrsov"
  },
  {
    "cast": "Hýskov",
    "psc": "26706",
    "okres": "Beroun",
    "obec": "Hýskov",
    "val": "26706 Hyskov Hyskov"
  },
  {
    "cast": "Hýsly",
    "psc": "69650",
    "okres": "Hodonín",
    "obec": "Hýsly",
    "val": "69650 Hysly Hysly"
  },
  {
    "cast": "Chabařovice",
    "psc": "40317",
    "okres": "Ústí nad Labem",
    "obec": "Chabařovice",
    "val": "40317 Chabarovice Chabarovice"
  },
  {
    "cast": "Chabeřice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Chabeřice",
    "val": "28522 Chaberice Chaberice"
  },
  {
    "cast": "Chabičov",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Šternberk",
    "val": "78501 Sternberk Chabicov"
  },
  {
    "cast": "Chabičov",
    "psc": "74792",
    "okres": "Opava",
    "obec": "Háj ve Slezsku",
    "val": "74792 Haj ve Slezsku Chabicov"
  },
  {
    "cast": "Chabičovice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mirkovice",
    "val": "38232 Mirkovice Chabicovice"
  },
  {
    "cast": "Chábory",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobruška",
    "val": "51801 Dobruska Chabory"
  },
  {
    "cast": "Chábory",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Podbřezí",
    "val": "51801 Podbrezi Chabory"
  },
  {
    "cast": "Chabrovice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Skopytce",
    "val": "39201 Skopytce Chabrovice"
  },
  {
    "cast": "Chacholice",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Chrast",
    "val": "53851 Chrast Chacholice"
  },
  {
    "cast": "Chaloupky",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Chaloupky"
  },
  {
    "cast": "Chaloupky",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nový Rychnov",
    "val": "39301 Novy Rychnov Chaloupky"
  },
  {
    "cast": "Chaloupky",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Chaloupky",
    "val": "26762 Chaloupky Chaloupky"
  },
  {
    "cast": "Chalupy",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34506 Vseruby Chalupy"
  },
  {
    "cast": "Chalupy",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Zemětice",
    "val": "33452 Zemetice Chalupy"
  },
  {
    "cast": "Chamutice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Chamutice"
  },
  {
    "cast": "Chanov",
    "psc": "43401",
    "okres": "Most",
    "obec": "Obrnice",
    "val": "43401 Obrnice Chanov"
  },
  {
    "cast": "Chanovice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Chanovice",
    "val": "34101 Chanovice Chanovice"
  },
  {
    "cast": "Charbuzice",
    "psc": "50321",
    "okres": "Hradec Králové",
    "obec": "Stěžery",
    "val": "50321 Stezery Charbuzice"
  },
  {
    "cast": "Charvatce",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Charvatce"
  },
  {
    "cast": "Charvatce",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Martiněves",
    "val": "41119 Martineves Charvatce"
  },
  {
    "cast": "Charvatce",
    "psc": "29445",
    "okres": "Mladá Boleslav",
    "obec": "Charvatce",
    "val": "29445 Charvatce Charvatce"
  },
  {
    "cast": "Charvátská Nová Ves (část)",
    "psc": "69006",
    "okres": "Břeclav",
    "obec": "Břeclav",
    "val": "69006 Breclav Charvatska Nova Ves (cast)"
  },
  {
    "cast": "Charvátská Nová Ves (část)",
    "psc": "69141",
    "okres": "Břeclav",
    "obec": "Břeclav",
    "val": "69141 Breclav Charvatska Nova Ves (cast)"
  },
  {
    "cast": "Charvátská Nová Ves (část)",
    "psc": "69144",
    "okres": "Břeclav",
    "obec": "Břeclav",
    "val": "69144 Breclav Charvatska Nova Ves (cast)"
  },
  {
    "cast": "Charváty",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Charváty",
    "val": "78375 Charvaty Charvaty"
  },
  {
    "cast": "Chářovice (část)",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Chářovice",
    "val": "25744 Charovice Charovice (cast)"
  },
  {
    "cast": "Chářovice (část)",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Chářovice",
    "val": "25741 Charovice Charovice (cast)"
  },
  {
    "cast": "Chbany",
    "psc": "43157",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43157 Chbany Chbany"
  },
  {
    "cast": "Chcebuz",
    "psc": "41173",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41173 Steti Chcebuz"
  },
  {
    "cast": "Cheb",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Cheb"
  },
  {
    "cast": "Chebzí",
    "psc": "79082",
    "okres": "Jeseník",
    "obec": "Písečná",
    "val": "79082 Pisecna Chebzi"
  },
  {
    "cast": "Chedrbí",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Krchleby",
    "val": "28601 Krchleby Chedrbi"
  },
  {
    "cast": "Chelčice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Chelčice",
    "val": "38901 Chelcice Chelcice"
  },
  {
    "cast": "Cheznovice",
    "psc": "33806",
    "okres": "Rokycany",
    "obec": "Cheznovice",
    "val": "33806 Cheznovice Cheznovice"
  },
  {
    "cast": "Chlaponice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Drhovle",
    "val": "39701 Drhovle Chlaponice"
  },
  {
    "cast": "Chlebičov",
    "psc": "74731",
    "okres": "Opava",
    "obec": "Chlebičov",
    "val": "74731 Chlebicov Chlebicov"
  },
  {
    "cast": "Chlebov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Soběslav",
    "val": "39201 Sobeslav Chlebov"
  },
  {
    "cast": "Chlebovice",
    "psc": "73942",
    "okres": "Frýdek-Místek",
    "obec": "Frýdek-Místek",
    "val": "73942 Frydek-Mistek Chlebovice"
  },
  {
    "cast": "Chlébské",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Skorotice",
    "val": "59262 Skorotice Chlebske"
  },
  {
    "cast": "Chleby",
    "psc": "28931",
    "okres": "Nymburk",
    "obec": "Chleby",
    "val": "28931 Chleby Chleby"
  },
  {
    "cast": "Chleby",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Chleby",
    "val": "25741 Chleby Chleby"
  },
  {
    "cast": "Chleny (část)",
    "psc": "51745",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Chleny",
    "val": "51745 Chleny Chleny (cast)"
  },
  {
    "cast": "Chleny (část)",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Chleny",
    "val": "51741 Chleny Chleny (cast)"
  },
  {
    "cast": "Chlínky",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vrbice",
    "val": "51741 Vrbice Chlinky"
  },
  {
    "cast": "Chlistov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Chlistov",
    "val": "33901 Chlistov Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Hořičky",
    "val": "55205 Horicky Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Chlístov",
    "val": "67522 Chlistov Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Kratušín",
    "val": "38301 Kratusin Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Chlístov",
    "val": "25601 Chlistov Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Chlístov",
    "val": "51801 Chlistov Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "29413",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "29413 Vselibice Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Okrouhlice",
    "val": "58001 Okrouhlice Chlistov"
  },
  {
    "cast": "Chlístov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Chlistov"
  },
  {
    "cast": "Chlístovice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28401 Chlistovice Chlistovice"
  },
  {
    "cast": "Chlístovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Pertoltice",
    "val": "28522 Pertoltice Chlistovice"
  },
  {
    "cast": "Chlívce (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Stárkov",
    "val": "54931 Starkov Chlivce (cast)"
  },
  {
    "cast": "Chlívce (část)",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Stárkov",
    "val": "54941 Starkov Chlivce (cast)"
  },
  {
    "cast": "Chlomek",
    "psc": "25206",
    "okres": "Praha-západ",
    "obec": "Petrov",
    "val": "25206 Petrov Chlomek"
  },
  {
    "cast": "Chloudov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Koberovy",
    "val": "46822 Koberovy Chloudov"
  },
  {
    "cast": "Chloumek",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Úbislavice",
    "val": "50901 Ubislavice Chloumek"
  },
  {
    "cast": "Chloumek",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Kasejovice",
    "val": "33544 Kasejovice Chloumek"
  },
  {
    "cast": "Chloumek",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Dobrovice",
    "val": "29441 Dobrovice Chloumek"
  },
  {
    "cast": "Chloumek",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Boháňka",
    "val": "50801 Bohanka Chloumek"
  },
  {
    "cast": "Chloumek",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Chloumek"
  },
  {
    "cast": "Chloumek",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Újezd u Chocně",
    "val": "56501 Ujezd u Chocne Chloumek"
  },
  {
    "cast": "Chloumek",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Chloumek"
  },
  {
    "cast": "Chloumky",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Holovousy",
    "val": "50801 Holovousy Chloumky"
  },
  {
    "cast": "Chlovy",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Onšov",
    "val": "39501 Onsov Chlovy"
  },
  {
    "cast": "Chlum",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76302 Zlin Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Chlum",
    "val": "67507 Chlum Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Chlum",
    "val": "33808 Chlum Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Chlum",
    "val": "47201 Chlum Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Hluboká",
    "val": "53973 Hluboka Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Chlum",
    "val": "38801 Chlum Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Krásné",
    "val": "53825 Krasne Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Zbýšov",
    "val": "28601 Zbysov Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Volary",
    "val": "38451 Volary Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Pšov",
    "val": "36452 Psov Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "33204",
    "okres": "Plzeň-jih",
    "obec": "Chlum",
    "val": "33204 Chlum Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Chlum",
    "val": "25763 Chlum Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Všestary",
    "val": "50312 Vsestary Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Hořice",
    "val": "50801 Horice Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "53962",
    "okres": "Chrudim",
    "obec": "Hlinsko",
    "val": "53962 Hlinsko Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Staňkovice",
    "val": "28504 Stankovice Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Chlum-Korouhvice",
    "val": "59265 Chlum-Korouhvice Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Chlum"
  },
  {
    "cast": "Chlum",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Svatý Jan nad Malší",
    "val": "37401 Svaty Jan nad Malsi Chlum"
  },
  {
    "cast": "Chlum Svaté Maří",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Chlum Svaté Maří",
    "val": "35709 Chlum Svate Mari Chlum Svate Mari"
  },
  {
    "cast": "Chlum u Třeboně (část)",
    "psc": "37804",
    "okres": "Jindřichův Hradec",
    "obec": "Chlum u Třeboně",
    "val": "37804 Chlum u Trebone Chlum u Trebone (cast)"
  },
  {
    "cast": "Chlum u Třeboně (část)",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Chlum u Třeboně",
    "val": "37806 Chlum u Trebone Chlum u Trebone (cast)"
  },
  {
    "cast": "Chlum (část)",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nalžovice",
    "val": "26401 Nalzovice Chlum (cast)"
  },
  {
    "cast": "Chlum (část)",
    "psc": "27021",
    "okres": "Rakovník",
    "obec": "Pavlíkov",
    "val": "27021 Pavlikov Chlum (cast)"
  },
  {
    "cast": "Chlum (část)",
    "psc": "26293",
    "okres": "Příbram",
    "obec": "Nalžovice",
    "val": "26293 Nalzovice Chlum (cast)"
  },
  {
    "cast": "Chlum (část)",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Pavlíkov",
    "val": "26901 Pavlikov Chlum (cast)"
  },
  {
    "cast": "Chlumánky",
    "psc": "33204",
    "okres": "Plzeň-jih",
    "obec": "Vlčtejn",
    "val": "33204 Vlctejn Chlumanky"
  },
  {
    "cast": "Chlumany",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Chlumany",
    "val": "38422 Chlumany Chlumany"
  },
  {
    "cast": "Chlumčany",
    "psc": "43903",
    "okres": "Louny",
    "obec": "Chlumčany",
    "val": "43903 Chlumcany Chlumcany"
  },
  {
    "cast": "Chlumčany",
    "psc": "33442",
    "okres": "Plzeň-jih",
    "obec": "Chlumčany",
    "val": "33442 Chlumcany Chlumcany"
  },
  {
    "cast": "Chlumec",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Chlumec",
    "val": "38232 Chlumec Chlumec"
  },
  {
    "cast": "Chlumec",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Chlumec"
  },
  {
    "cast": "Chlumec",
    "psc": "40339",
    "okres": "Ústí nad Labem",
    "obec": "Chlumec",
    "val": "40339 Chlumec Chlumec"
  },
  {
    "cast": "Chlumec nad Cidlinou I",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Chlumec nad Cidlinou",
    "val": "50351 Chlumec nad Cidlinou Chlumec nad Cidlinou I"
  },
  {
    "cast": "Chlumec nad Cidlinou II",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Chlumec nad Cidlinou",
    "val": "50351 Chlumec nad Cidlinou Chlumec nad Cidlinou II"
  },
  {
    "cast": "Chlumec nad Cidlinou III",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Chlumec nad Cidlinou",
    "val": "50351 Chlumec nad Cidlinou Chlumec nad Cidlinou III"
  },
  {
    "cast": "Chlumec nad Cidlinou IV",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Chlumec nad Cidlinou",
    "val": "50351 Chlumec nad Cidlinou Chlumec nad Cidlinou IV"
  },
  {
    "cast": "Chlumec (část)",
    "psc": "37350",
    "okres": "České Budějovice",
    "obec": "Olešník",
    "val": "37350 Olesnik Chlumec (cast)"
  },
  {
    "cast": "Chlumec (část)",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Olešník",
    "val": "37341 Olesnik Chlumec (cast)"
  },
  {
    "cast": "Chlumeček",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Chlumecek"
  },
  {
    "cast": "Chlumek",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Hrejkovice",
    "val": "39901 Hrejkovice Chlumek"
  },
  {
    "cast": "Chlumek",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Chlumek",
    "val": "59442 Chlumek Chlumek"
  },
  {
    "cast": "Chlumětín",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Chlumětín",
    "val": "59202 Chlumetin Chlumetin"
  },
  {
    "cast": "Chlumín",
    "psc": "27743",
    "okres": "Mělník",
    "obec": "Chlumín",
    "val": "27743 Chlumin Chlumin"
  },
  {
    "cast": "Chlumín",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Chlumin"
  },
  {
    "cast": "Chlumská",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Ježovy",
    "val": "34012 Jezovy Chlumska"
  },
  {
    "cast": "Chlumy",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Chlumy",
    "val": "33501 Chlumy Chlumy"
  },
  {
    "cast": "Chlupatá Ves",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Chlupata Ves"
  },
  {
    "cast": "Chlupice",
    "psc": "67171",
    "okres": "Znojmo",
    "obec": "Hostěradice",
    "val": "67171 Hosteradice Chlupice"
  },
  {
    "cast": "Chlustina",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Chlustina",
    "val": "26751 Chlustina Chlustina"
  },
  {
    "cast": "Chmelík",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Chmelík",
    "val": "57001 Chmelik Chmelik"
  },
  {
    "cast": "Chmeliště",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobré",
    "val": "51801 Dobre Chmeliste"
  },
  {
    "cast": "Chmeliště",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Vavřinec",
    "val": "28504 Vavrinec Chmeliste"
  },
  {
    "cast": "Chmelištná",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Nepomyšl",
    "val": "44101 Nepomysl Chmelistna"
  },
  {
    "cast": "Chmelná",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Chmelna"
  },
  {
    "cast": "Chmelná",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Chmelná",
    "val": "25765 Chmelna Chmelna"
  },
  {
    "cast": "Chmelná",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Chmelna"
  },
  {
    "cast": "Chmelná",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nová Cerekev",
    "val": "39301 Nova Cerekev Chmelna"
  },
  {
    "cast": "Chmelnice-Děčín XXV x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Chmelnice-Decin XXV x)"
  },
  {
    "cast": "Chmelovice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Králíky",
    "val": "50315 Kraliky Chmelovice"
  },
  {
    "cast": "Chobot",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Chobot",
    "val": "38801 Chobot Chobot"
  },
  {
    "cast": "Chobyně",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Šubířov",
    "val": "79852 Subirov Chobyne"
  },
  {
    "cast": "Choceň",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Choceň",
    "val": "56501 Chocen Chocen"
  },
  {
    "cast": "Chocenice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Břežany I",
    "val": "28002 Brezany I Chocenice"
  },
  {
    "cast": "Chocenice",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Chocenice",
    "val": "33601 Chocenice Chocenice"
  },
  {
    "cast": "Chocenická Lhota",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Chocenice",
    "val": "33601 Chocenice Chocenicka Lhota"
  },
  {
    "cast": "Chocenický Újezd",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Letiny",
    "val": "33601 Letiny Chocenicky Ujezd"
  },
  {
    "cast": "Choceňské Předměstí",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Chocenske Predmesti"
  },
  {
    "cast": "Chocerady",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Chocerady",
    "val": "25724 Chocerady Chocerady"
  },
  {
    "cast": "Chockov",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Lhotka u Radnic",
    "val": "33824 Lhotka u Radnic Chockov"
  },
  {
    "cast": "Chocnějovice",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Chocnějovice",
    "val": "29413 Chocnejovice Chocnejovice"
  },
  {
    "cast": "Chocomyšl",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Chocomyšl",
    "val": "34543 Chocomysl Chocomysl"
  },
  {
    "cast": "Chocov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Chocov"
  },
  {
    "cast": "Chocovice",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Chocovice"
  },
  {
    "cast": "Chodeč",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Velešín",
    "val": "38232 Velesin Chodec"
  },
  {
    "cast": "Chodeč",
    "psc": "27724",
    "okres": "Mělník",
    "obec": "Vysoká",
    "val": "27724 Vysoka Chodec"
  },
  {
    "cast": "Chodouň",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Chodouň",
    "val": "26751 Chodoun Chodoun"
  },
  {
    "cast": "Chodouny",
    "psc": "41171",
    "okres": "Litoměřice",
    "obec": "Chodouny",
    "val": "41171 Chodouny Chodouny"
  },
  {
    "cast": "Chodov",
    "psc": "34533",
    "okres": "Domažlice",
    "obec": "Chodov",
    "val": "34533 Chodov Chodov"
  },
  {
    "cast": "Chodov",
    "psc": "36464",
    "okres": "Karlovy Vary",
    "obec": "Chodov",
    "val": "36464 Chodov Chodov"
  },
  {
    "cast": "Chodov",
    "psc": "35735",
    "okres": "Sokolov",
    "obec": "Chodov",
    "val": "35735 Chodov Chodov"
  },
  {
    "cast": "Chodov (část)",
    "psc": "14100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14100 Praha Chodov (cast)"
  },
  {
    "cast": "Chodov (část)",
    "psc": "14800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14800 Praha Chodov (cast)"
  },
  {
    "cast": "Chodov (část)",
    "psc": "14900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14900 Praha Chodov (cast)"
  },
  {
    "cast": "Chodová Planá",
    "psc": "34813",
    "okres": "Tachov",
    "obec": "Chodová Planá",
    "val": "34813 Chodova Plana Chodova Plana"
  },
  {
    "cast": "Chodovice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Holovousy",
    "val": "50801 Holovousy Chodovice"
  },
  {
    "cast": "Chodovlice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Chodovlice",
    "val": "41115 Chodovlice Chodovlice"
  },
  {
    "cast": "Chodovská Huť",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Tři Sekery",
    "val": "35301 Tri Sekery Chodovska Hut"
  },
  {
    "cast": "Chodská Lhota",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Chodská Lhota",
    "val": "34506 Chodska Lhota Chodska Lhota"
  },
  {
    "cast": "Chodský Újezd",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Chodský Újezd",
    "val": "34815 Chodsky Ujezd Chodsky Ujezd"
  },
  {
    "cast": "Chochol",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Tichonice",
    "val": "25763 Tichonice Chochol"
  },
  {
    "cast": "Chocholatá Lhota",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Vlachovo Březí",
    "val": "38422 Vlachovo Brezi Chocholata Lhota"
  },
  {
    "cast": "Cholenice",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Cholenice",
    "val": "50732 Cholenice Cholenice"
  },
  {
    "cast": "Cholín (část)",
    "psc": "26215",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26215 Borotice Cholin (cast)"
  },
  {
    "cast": "Cholín (část)",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Borotice",
    "val": "26203 Borotice Cholin (cast)"
  },
  {
    "cast": "Cholina",
    "psc": "78322",
    "okres": "Olomouc",
    "obec": "Cholina",
    "val": "78322 Cholina Cholina"
  },
  {
    "cast": "Cholín-Boubovny",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Cholin-Boubovny"
  },
  {
    "cast": "Choltice (část)",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Choltice",
    "val": "53501 Choltice Choltice (cast)"
  },
  {
    "cast": "Choltice (část)",
    "psc": "53361",
    "okres": "Pardubice",
    "obec": "Choltice",
    "val": "53361 Choltice Choltice (cast)"
  },
  {
    "cast": "Cholunná",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Žirovnice",
    "val": "39468 Zirovnice Cholunna"
  },
  {
    "cast": "Cholupice",
    "psc": "14300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14300 Praha Cholupice"
  },
  {
    "cast": "Chomle",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Chomle",
    "val": "33828 Chomle Chomle"
  },
  {
    "cast": "Chomoutov",
    "psc": "78335",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "78335 Olomouc Chomoutov"
  },
  {
    "cast": "Chomoutova Lhota",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Chomoutova Lhota"
  },
  {
    "cast": "Chomutice",
    "psc": "50753",
    "okres": "Jičín",
    "obec": "Chomutice",
    "val": "50753 Chomutice Chomutice"
  },
  {
    "cast": "Chomutičky",
    "psc": "50753",
    "okres": "Jičín",
    "obec": "Chomutice",
    "val": "50753 Chomutice Chomuticky"
  },
  {
    "cast": "Chomutov (část)",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Chomutov",
    "val": "43001 Chomutov Chomutov (cast)"
  },
  {
    "cast": "Chomutov (část)",
    "psc": "43003",
    "okres": "Chomutov",
    "obec": "Chomutov",
    "val": "43003 Chomutov Chomutov (cast)"
  },
  {
    "cast": "Chomutov (část)",
    "psc": "43004",
    "okres": "Chomutov",
    "obec": "Chomutov",
    "val": "43004 Chomutov Chomutov (cast)"
  },
  {
    "cast": "Chomutovice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Popovičky",
    "val": "25101 Popovicky Chomutovice"
  },
  {
    "cast": "Chomýž",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Chomýž",
    "val": "76861 Chomyz Chomyz"
  },
  {
    "cast": "Choratice",
    "psc": "28506",
    "okres": "Benešov",
    "obec": "Choratice",
    "val": "28506 Choratice Choratice"
  },
  {
    "cast": "Choratice (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40502 Malsovice Choratice (cast)"
  },
  {
    "cast": "Choratice (část)",
    "psc": "40703",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40703 Malsovice Choratice (cast)"
  },
  {
    "cast": "Chornice (část)",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Chornice",
    "val": "56943 Chornice Chornice (cast)"
  },
  {
    "cast": "Chornice (část)",
    "psc": "56942",
    "okres": "Svitavy",
    "obec": "Chornice",
    "val": "56942 Chornice Chornice (cast)"
  },
  {
    "cast": "Choroušky",
    "psc": "27737",
    "okres": "Mělník",
    "obec": "Chorušice",
    "val": "27737 Chorusice Chorousky"
  },
  {
    "cast": "Chorušice",
    "psc": "27737",
    "okres": "Mělník",
    "obec": "Chorušice",
    "val": "27737 Chorusice Chorusice"
  },
  {
    "cast": "Choryně",
    "psc": "75642",
    "okres": "Vsetín",
    "obec": "Choryně",
    "val": "75642 Choryne Choryne"
  },
  {
    "cast": "Choťánky",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Choťánky",
    "val": "29001 Chotanky Chotanky"
  },
  {
    "cast": "Chotčiny",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Chotciny"
  },
  {
    "cast": "Chotěborky",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vilantice",
    "val": "54401 Vilantice Choteborky"
  },
  {
    "cast": "Chotěboř",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Chotebor"
  },
  {
    "cast": "Chotěbudice",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Chotěbudice",
    "val": "67531 Chotebudice Chotebudice"
  },
  {
    "cast": "Chotěbudice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Krásný Dvůr",
    "val": "44101 Krasny Dvur Chotebudice"
  },
  {
    "cast": "Chotěbuz",
    "psc": "73561",
    "okres": "Karviná",
    "obec": "Chotěbuz",
    "val": "73561 Chotebuz Chotebuz"
  },
  {
    "cast": "Choteč",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Choteč",
    "val": "53304 Chotec Chotec"
  },
  {
    "cast": "Choteč",
    "psc": "25226",
    "okres": "Praha-západ",
    "obec": "Choteč",
    "val": "25226 Chotec Chotec"
  },
  {
    "cast": "Choteč",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Choteč",
    "val": "50781 Chotec Chotec"
  },
  {
    "cast": "Chotějovice",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Světec",
    "val": "41804 Svetec Chotejovice"
  },
  {
    "cast": "Chotělice",
    "psc": "50353",
    "okres": "Hradec Králové",
    "obec": "Smidary",
    "val": "50353 Smidary Chotelice"
  },
  {
    "cast": "Chotěměřice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58401 Hnevkovice Chotemerice"
  },
  {
    "cast": "Chotěměřice t. Pančava",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Chotemerice t. Pancava"
  },
  {
    "cast": "Chotěmice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Chotěmice",
    "val": "39201 Chotemice Chotemice"
  },
  {
    "cast": "Chotěnice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Heřmanův Městec",
    "val": "53803 Hermanuv Mestec Chotenice"
  },
  {
    "cast": "Chotěnov",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Chotěnov",
    "val": "57001 Chotenov Chotenov"
  },
  {
    "cast": "Chotěnov-Skláře",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mariánské Lázně",
    "val": "35301 Marianske Lazne Chotenov-Sklare"
  },
  {
    "cast": "Chotěšice",
    "psc": "28901",
    "okres": "Nymburk",
    "obec": "Chotěšice",
    "val": "28901 Chotesice Chotesice"
  },
  {
    "cast": "Chotěšiny",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "České Heřmanice",
    "val": "56601 Ceske Hermanice Chotesiny"
  },
  {
    "cast": "Chotěšov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Chotesov"
  },
  {
    "cast": "Chotěšov",
    "psc": "33214",
    "okres": "Plzeň-jih",
    "obec": "Chotěšov",
    "val": "33214 Chotesov Chotesov"
  },
  {
    "cast": "Chotěšov",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Chotěšov",
    "val": "41002 Chotesov Chotesov"
  },
  {
    "cast": "Chotěšov",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Jesenice",
    "val": "27033 Jesenice Chotesov"
  },
  {
    "cast": "Chotěšovičky",
    "psc": "34901",
    "okres": "Plzeň-sever",
    "obec": "Pňovany",
    "val": "34901 Pnovany Chotesovicky"
  },
  {
    "cast": "Chotětice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Chotetice"
  },
  {
    "cast": "Chotětín",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Zbiroh",
    "val": "33808 Zbiroh Chotetin"
  },
  {
    "cast": "Chotětov",
    "psc": "29428",
    "okres": "Mladá Boleslav",
    "obec": "Chotětov",
    "val": "29428 Chotetov Chotetov"
  },
  {
    "cast": "Chotěvice (část)",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Chotěvice",
    "val": "54371 Chotevice Chotevice (cast)"
  },
  {
    "cast": "Chotěvice (část)",
    "psc": "54376",
    "okres": "Trutnov",
    "obec": "Chotěvice",
    "val": "54376 Chotevice Chotevice (cast)"
  },
  {
    "cast": "Chotíkov",
    "psc": "33017",
    "okres": "Plzeň-sever",
    "obec": "Chotíkov",
    "val": "33017 Chotikov Chotikov"
  },
  {
    "cast": "Chotíkov",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kynšperk nad Ohří",
    "val": "35751 Kynsperk nad Ohri Chotikov"
  },
  {
    "cast": "Chotilsko",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Chotilsko"
  },
  {
    "cast": "Chotiměř",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Chotiměř",
    "val": "41002 Chotimer Chotimer"
  },
  {
    "cast": "Chotiměř",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Blížejov",
    "val": "34601 Blizejov Chotimer"
  },
  {
    "cast": "Chotiná",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Hromnice",
    "val": "33011 Hromnice Chotina"
  },
  {
    "cast": "Chotiněves",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Chotiněves",
    "val": "41145 Chotineves Chotineves"
  },
  {
    "cast": "Chotiv",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Žďár nad Orlicí",
    "val": "51721 Zdar nad Orlici Chotiv"
  },
  {
    "cast": "Chotouchov",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Kořenice",
    "val": "28144 Korenice Chotouchov"
  },
  {
    "cast": "Chotouň",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Chrášťany",
    "val": "28201 Chrastany Chotoun"
  },
  {
    "cast": "Chotouň",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Pohoří",
    "val": "25401 Pohori Chotoun"
  },
  {
    "cast": "Chotovice",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Chotovice",
    "val": "57001 Chotovice Chotovice"
  },
  {
    "cast": "Chotovice",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Chotovice",
    "val": "47301 Chotovice Chotovice"
  },
  {
    "cast": "Choťovice",
    "psc": "28905",
    "okres": "Kolín",
    "obec": "Choťovice",
    "val": "28905 Chotovice Chotovice"
  },
  {
    "cast": "Chotoviny",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Chotoviny"
  },
  {
    "cast": "Chotusice",
    "psc": "28576",
    "okres": "Kutná Hora",
    "obec": "Chotusice",
    "val": "28576 Chotusice Chotusice"
  },
  {
    "cast": "Chotutice",
    "psc": "28103",
    "okres": "Kolín",
    "obec": "Chotutice",
    "val": "28103 Chotutice Chotutice"
  },
  {
    "cast": "Chotýčany",
    "psc": "37362",
    "okres": "České Budějovice",
    "obec": "Chotýčany",
    "val": "37362 Chotycany Chotycany"
  },
  {
    "cast": "Chotyně",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Chotyně",
    "val": "46334 Chotyne Chotyne"
  },
  {
    "cast": "Chotýš",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Vitice",
    "val": "28163 Vitice Chotys"
  },
  {
    "cast": "Chotýšany",
    "psc": "25728",
    "okres": "Benešov",
    "obec": "Chotýšany",
    "val": "25728 Chotysany Chotysany"
  },
  {
    "cast": "Chouč",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41804 Hrobcice Chouc"
  },
  {
    "cast": "Choustník",
    "psc": "39118",
    "okres": "Tábor",
    "obec": "Choustník",
    "val": "39118 Choustnik Choustnik"
  },
  {
    "cast": "Choustníkovo Hradiště",
    "psc": "54442",
    "okres": "Trutnov",
    "obec": "Choustníkovo Hradiště",
    "val": "54442 Choustnikovo Hradiste Choustnikovo Hradiste"
  },
  {
    "cast": "Chouzavá",
    "psc": "25210",
    "okres": "Příbram",
    "obec": "Voznice",
    "val": "25210 Voznice Chouzava"
  },
  {
    "cast": "Chouzovy",
    "psc": "33204",
    "okres": "Plzeň-město",
    "obec": "Chválenice",
    "val": "33204 Chvalenice Chouzovy"
  },
  {
    "cast": "Chožov",
    "psc": "43922",
    "okres": "Louny",
    "obec": "Chožov",
    "val": "43922 Chozov Chozov"
  },
  {
    "cast": "Chraberce",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Chraberce",
    "val": "44001 Chraberce Chraberce"
  },
  {
    "cast": "Chrámce",
    "psc": "43401",
    "okres": "Most",
    "obec": "Skršín",
    "val": "43401 Skrsin Chramce"
  },
  {
    "cast": "Chramiště",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Nový Knín",
    "val": "26203 Novy Knin Chramiste"
  },
  {
    "cast": "Chramostek",
    "psc": "27706",
    "okres": "Mělník",
    "obec": "Lužec nad Vltavou",
    "val": "27706 Luzec nad Vltavou Chramostek"
  },
  {
    "cast": "Chramosty",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Dublovice",
    "val": "26401 Dublovice Chramosty"
  },
  {
    "cast": "Chrančovice",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Všeruby",
    "val": "33035 Vseruby Chrancovice"
  },
  {
    "cast": "Chranišov",
    "psc": "35735",
    "okres": "Sokolov",
    "obec": "Nové Sedlo",
    "val": "35735 Nove Sedlo Chranisov"
  },
  {
    "cast": "Chrast",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Chrast",
    "val": "53851 Chrast Chrast"
  },
  {
    "cast": "Chrast",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Krupá",
    "val": "58001 Dolni Krupa Chrast"
  },
  {
    "cast": "Chrást",
    "psc": "27715",
    "okres": "Mělník",
    "obec": "Tišice",
    "val": "27715 Tisice Chrast"
  },
  {
    "cast": "Chrást",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Chrást",
    "val": "26272 Chrast Chrast"
  },
  {
    "cast": "Chrást",
    "psc": "28914",
    "okres": "Nymburk",
    "obec": "Chrást",
    "val": "28914 Chrast Chrast"
  },
  {
    "cast": "Chrást",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Chrast"
  },
  {
    "cast": "Chrást",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Pivkovice",
    "val": "38773 Pivkovice Chrast"
  },
  {
    "cast": "Chrást",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Křesetice",
    "val": "28401 Kresetice Chrast"
  },
  {
    "cast": "Chrást",
    "psc": "33003",
    "okres": "Plzeň-město",
    "obec": "Chrást",
    "val": "33003 Chrast Chrast"
  },
  {
    "cast": "Chrást",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Chrast"
  },
  {
    "cast": "Chrást nad Sázavou (část)",
    "psc": "25742",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25742 Tynec nad Sazavou Chrast nad Sazavou (cast)"
  },
  {
    "cast": "Chrást nad Sázavou (část)",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25741 Tynec nad Sazavou Chrast nad Sazavou (cast)"
  },
  {
    "cast": "Chrastava",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Štětkovice",
    "val": "26401 Stetkovice Chrastava"
  },
  {
    "cast": "Chrastava",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Chrastava",
    "val": "46331 Chrastava Chrastava"
  },
  {
    "cast": "Chrastavec",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Chrastavec",
    "val": "56904 Chrastavec Chrastavec"
  },
  {
    "cast": "Chrastavice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Chrastavice",
    "val": "34401 Chrastavice Chrastavice"
  },
  {
    "cast": "Chrastěšov",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Vizovice",
    "val": "76312 Vizovice Chrastesov"
  },
  {
    "cast": "Chrastice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Skryje",
    "val": "58282 Skryje Chrastice"
  },
  {
    "cast": "Chrastice",
    "psc": "78832",
    "okres": "Šumperk",
    "obec": "Staré Město",
    "val": "78832 Stare Mesto Chrastice"
  },
  {
    "cast": "Chrastín",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Peruc",
    "val": "44001 Peruc Chrastin"
  },
  {
    "cast": "Chrastiny",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dolní Novosedly",
    "val": "39701 Dolni Novosedly Chrastiny"
  },
  {
    "cast": "Chrastná",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Osečná",
    "val": "46352 Osecna Chrastna"
  },
  {
    "cast": "Chrastná",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28504 Uzice Chrastna"
  },
  {
    "cast": "Chrástov",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Všeruby",
    "val": "33035 Vseruby Chrastov"
  },
  {
    "cast": "Chrástov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Horní Cerekev",
    "val": "39301 Horni Cerekev Chrastov"
  },
  {
    "cast": "Chrastová Lhota",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Brněnec",
    "val": "56904 Brnenec Chrastova Lhota"
  },
  {
    "cast": "Chrašťany",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Krásný Dvůr",
    "val": "44101 Krasny Dvur Chrastany"
  },
  {
    "cast": "Chrášťany",
    "psc": "76824",
    "okres": "Kroměříž",
    "obec": "Hulín",
    "val": "76824 Hulin Chrastany"
  },
  {
    "cast": "Chrášťany",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Chrášťany",
    "val": "28201 Chrastany Chrastany"
  },
  {
    "cast": "Chrášťany",
    "psc": "25219",
    "okres": "Praha-západ",
    "obec": "Chrášťany",
    "val": "25219 Chrastany Chrastany"
  },
  {
    "cast": "Chrášťany",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Podsedice",
    "val": "41115 Podsedice Chrastany"
  },
  {
    "cast": "Chrášťany",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Chrášťany",
    "val": "25601 Chrastany Chrastany"
  },
  {
    "cast": "Chrášťany",
    "psc": "27001",
    "okres": "Rakovník",
    "obec": "Chrášťany",
    "val": "27001 Chrastany Chrastany"
  },
  {
    "cast": "Chrášťany",
    "psc": "37304",
    "okres": "České Budějovice",
    "obec": "Chrášťany",
    "val": "37304 Chrastany Chrastany"
  },
  {
    "cast": "Chraštice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Chraštice",
    "val": "26272 Chrastice Chrastice"
  },
  {
    "cast": "Chraštičky",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Chraštice",
    "val": "26272 Chrastice Chrasticky"
  },
  {
    "cast": "Chrášťovice",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Mladotice",
    "val": "33141 Mladotice Chrastovice"
  },
  {
    "cast": "Chrášťovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Chrášťovice",
    "val": "38601 Chrastovice Chrastovice"
  },
  {
    "cast": "Chrbonín",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Chrbonín",
    "val": "39155 Chrbonin Chrbonin"
  },
  {
    "cast": "Chrbov",
    "psc": "75101",
    "okres": "Přerov",
    "obec": "Lobodice",
    "val": "75101 Lobodice Chrbov"
  },
  {
    "cast": "Chrlice (část)",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Chrlice (cast)"
  },
  {
    "cast": "Chrlice (část)",
    "psc": "64300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64300 Brno Chrlice (cast)"
  },
  {
    "cast": "Chrlice (část)",
    "psc": "66442",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "66442 Brno Chrlice (cast)"
  },
  {
    "cast": "Chroboly (část)",
    "psc": "38404",
    "okres": "Prachatice",
    "obec": "Chroboly",
    "val": "38404 Chroboly Chroboly (cast)"
  },
  {
    "cast": "Chroboly (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Chroboly",
    "val": "38301 Chroboly Chroboly (cast)"
  },
  {
    "cast": "Chrochvice-Děčín VII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Chrochvice-Decin VII x)"
  },
  {
    "cast": "Chromeč",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Chromeč",
    "val": "78901 Chromec Chromec"
  },
  {
    "cast": "Chropyně",
    "psc": "76811",
    "okres": "Kroměříž",
    "obec": "Chropyně",
    "val": "76811 Chropyne Chropyne"
  },
  {
    "cast": "Chroustkov",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28401 Chlistovice Chroustkov"
  },
  {
    "cast": "Chroustov",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Úhlejov",
    "val": "50771 Uhlejov Chroustov"
  },
  {
    "cast": "Chroustov",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Třebenice",
    "val": "67552 Trebenice Chroustov"
  },
  {
    "cast": "Chroustov",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Bohdalov",
    "val": "59214 Bohdalov Chroustov"
  },
  {
    "cast": "Chroustov (část)",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Chroustov",
    "val": "28903 Chroustov Chroustov (cast)"
  },
  {
    "cast": "Chroustov (část)",
    "psc": "28902",
    "okres": "Nymburk",
    "obec": "Chroustov",
    "val": "28902 Chroustov Chroustov (cast)"
  },
  {
    "cast": "Chroustovice",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Chroustovice",
    "val": "53863 Chroustovice Chroustovice"
  },
  {
    "cast": "Chrtníč",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Chrtníč",
    "val": "58282 Chrtnic Chrtnic"
  },
  {
    "cast": "Chrtníky",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Chrtníky",
    "val": "53501 Chrtniky Chrtniky"
  },
  {
    "cast": "Chrudichromy",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Chrudichromy",
    "val": "68001 Chrudichromy Chrudichromy"
  },
  {
    "cast": "Chrudim I",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53701 Chrudim Chrudim I"
  },
  {
    "cast": "Chrudim II (část)",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53701 Chrudim Chrudim II (cast)"
  },
  {
    "cast": "Chrudim II (část)",
    "psc": "53703",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53703 Chrudim Chrudim II (cast)"
  },
  {
    "cast": "Chrudim II (část)",
    "psc": "53705",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53705 Chrudim Chrudim II (cast)"
  },
  {
    "cast": "Chrudim III (část)",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53701 Chrudim Chrudim III (cast)"
  },
  {
    "cast": "Chrudim III (část)",
    "psc": "53703",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53703 Chrudim Chrudim III (cast)"
  },
  {
    "cast": "Chrudim III (část)",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53821 Chrudim Chrudim III (cast)"
  },
  {
    "cast": "Chrudim IV (část)",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53701 Chrudim Chrudim IV (cast)"
  },
  {
    "cast": "Chrudim IV (část)",
    "psc": "53705",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53705 Chrudim Chrudim IV (cast)"
  },
  {
    "cast": "Chrustenice",
    "psc": "26712",
    "okres": "Beroun",
    "obec": "Chrustenice",
    "val": "26712 Chrustenice Chrustenice"
  },
  {
    "cast": "Chržín",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Chržín",
    "val": "27324 Chrzin Chrzin"
  },
  {
    "cast": "Chřebřany",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Vidice",
    "val": "34601 Vidice Chrebrany"
  },
  {
    "cast": "Chřenovice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Chřenovice",
    "val": "58401 Chrenovice Chrenovice"
  },
  {
    "cast": "Chřepice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Chrepice"
  },
  {
    "cast": "Chřešťovice",
    "psc": "39817",
    "okres": "Písek",
    "obec": "Albrechtice nad Vltavou",
    "val": "39817 Albrechtice nad Vltavou Chrestovice"
  },
  {
    "cast": "Chřibská",
    "psc": "40744",
    "okres": "Děčín",
    "obec": "Chřibská",
    "val": "40744 Chribska Chribska"
  },
  {
    "cast": "Chříč",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Chříč",
    "val": "33141 Chric Chric"
  },
  {
    "cast": "Chudčice",
    "psc": "66471",
    "okres": "Brno-venkov",
    "obec": "Chudčice",
    "val": "66471 Chudcice Chudcice"
  },
  {
    "cast": "Chudeč",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Chudec"
  },
  {
    "cast": "Chudenice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Chudenice",
    "val": "33901 Chudenice Chudenice"
  },
  {
    "cast": "Chudenín",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Chudenín",
    "val": "34022 Chudenin Chudenin"
  },
  {
    "cast": "Chuderov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Chuderov",
    "val": "40002 Chuderov Chuderov"
  },
  {
    "cast": "Chuderovec",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Chuderov",
    "val": "40002 Chuderov Chuderovec"
  },
  {
    "cast": "Chudeřice",
    "psc": "41801",
    "okres": "Teplice",
    "obec": "Bílina",
    "val": "41801 Bilina Chuderice"
  },
  {
    "cast": "Chudeřice",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Chudeřice",
    "val": "50351 Chuderice Chuderice"
  },
  {
    "cast": "Chudeřín",
    "psc": "43603",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43603 Litvinov Chuderin"
  },
  {
    "cast": "Chudeřín",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Nové Sedlo",
    "val": "43801 Nove Sedlo Chuderin"
  },
  {
    "cast": "Chudíř",
    "psc": "29445",
    "okres": "Mladá Boleslav",
    "obec": "Chudíř",
    "val": "29445 Chudir Chudir"
  },
  {
    "cast": "Chudobín",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78321 Litovel Chudobin"
  },
  {
    "cast": "Chudolazy",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Medonosy",
    "val": "27721 Medonosy Chudolazy"
  },
  {
    "cast": "Chudonice",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Nový Bydžov",
    "val": "50401 Novy Bydzov Chudonice"
  },
  {
    "cast": "Chudoplesy",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Chudoplesy"
  },
  {
    "cast": "Chudoslavice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Chudoslavice",
    "val": "41201 Chudoslavice Chudoslavice"
  },
  {
    "cast": "Chuchel",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Jeřišno",
    "val": "58301 Jerisno Chuchel"
  },
  {
    "cast": "Chuchelna",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Chuchelna",
    "val": "51301 Chuchelna Chuchelna"
  },
  {
    "cast": "Chuchelná",
    "psc": "74724",
    "okres": "Opava",
    "obec": "Chuchelná",
    "val": "74724 Chuchelna Chuchelna"
  },
  {
    "cast": "Chutnovka",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Chutnovka"
  },
  {
    "cast": "Chvalatice",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Chvalatice",
    "val": "67102 Chvalatice Chvalatice"
  },
  {
    "cast": "Chvalčov",
    "psc": "76872",
    "okres": "Kroměříž",
    "obec": "Chvalčov",
    "val": "76872 Chvalcov Chvalcov"
  },
  {
    "cast": "Chvalčovice",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Chvalcovice"
  },
  {
    "cast": "Chvaleč",
    "psc": "54211",
    "okres": "Trutnov",
    "obec": "Chvaleč",
    "val": "54211 Chvalec Chvalec"
  },
  {
    "cast": "Chválenice",
    "psc": "33205",
    "okres": "Plzeň-město",
    "obec": "Chválenice",
    "val": "33205 Chvalenice Chvalenice"
  },
  {
    "cast": "Chvalešovice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37501 Driten Chvalesovice"
  },
  {
    "cast": "Chvaletice",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Chvaletice"
  },
  {
    "cast": "Chvaletice",
    "psc": "53312",
    "okres": "Pardubice",
    "obec": "Chvaletice",
    "val": "53312 Chvaletice Chvaletice"
  },
  {
    "cast": "Chvaletín",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Písečné",
    "val": "37881 Pisecne Chvaletin"
  },
  {
    "cast": "Chvalíkovice",
    "psc": "74706",
    "okres": "Opava",
    "obec": "Chvalíkovice",
    "val": "74706 Chvalikovice Chvalikovice"
  },
  {
    "cast": "Chvalín",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Nové Dvory",
    "val": "41301 Nove Dvory Chvalin"
  },
  {
    "cast": "Chvalina",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Hořice",
    "val": "50801 Horice Chvalina"
  },
  {
    "cast": "Chvalkov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Čížkrajice",
    "val": "37401 Cizkrajice Chvalkov"
  },
  {
    "cast": "Chválkov",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Lípa",
    "val": "58253 Lipa Chvalkov"
  },
  {
    "cast": "Chválkov",
    "psc": "39493",
    "okres": "Pelhřimov",
    "obec": "Mnich",
    "val": "39493 Mnich Chvalkov"
  },
  {
    "cast": "Chvalkovice",
    "psc": "68341",
    "okres": "Vyškov",
    "obec": "Chvalkovice",
    "val": "68341 Chvalkovice Chvalkovice"
  },
  {
    "cast": "Chvalkovice",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Dešná",
    "val": "37881 Desna Chvalkovice"
  },
  {
    "cast": "Chvalkovice",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Chvalkovice",
    "val": "55204 Chvalkovice Chvalkovice"
  },
  {
    "cast": "Chválkovice",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Chvalkovice"
  },
  {
    "cast": "Chvalkovice na Hané",
    "psc": "68323",
    "okres": "Vyškov",
    "obec": "Ivanovice na Hané",
    "val": "68323 Ivanovice na Hane Chvalkovice na Hane"
  },
  {
    "cast": "Chvalnov",
    "psc": "76805",
    "okres": "Kroměříž",
    "obec": "Chvalnov-Lísky",
    "val": "76805 Chvalnov-Lisky Chvalnov"
  },
  {
    "cast": "Chvalov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Červené Janovice",
    "val": "28601 Cervene Janovice Chvalov"
  },
  {
    "cast": "Chvalov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Stebno",
    "val": "40002 Stebno Chvalov"
  },
  {
    "cast": "Chválov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Olešná",
    "val": "39301 Olesna Chvalov"
  },
  {
    "cast": "Chválov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Drslavice",
    "val": "38301 Drslavice Chvalov"
  },
  {
    "cast": "Chválov (část)",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Chvalov (cast)"
  },
  {
    "cast": "Chválov (část)",
    "psc": "39901",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "39901 Nechvalice Chvalov (cast)"
  },
  {
    "cast": "Chvalovice",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Kovanice",
    "val": "28802 Kovanice Chvalovice"
  },
  {
    "cast": "Chvalovice",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Chvalovice",
    "val": "66902 Chvalovice Chvalovice"
  },
  {
    "cast": "Chvalovice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Chvalovice",
    "val": "38411 Chvalovice Chvalovice"
  },
  {
    "cast": "Chvalšiny",
    "psc": "38208",
    "okres": "Český Krumlov",
    "obec": "Chvalšiny",
    "val": "38208 Chvalsiny Chvalsiny"
  },
  {
    "cast": "Chvalšovice",
    "psc": "38473",
    "okres": "Strakonice",
    "obec": "Dřešín",
    "val": "38473 Dresin Chvalsovice"
  },
  {
    "cast": "Chvalšovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Chvalsovice"
  },
  {
    "cast": "Chvatěruby",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Chvatěruby",
    "val": "27801 Chvateruby Chvateruby"
  },
  {
    "cast": "Chvoječná",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35134 Cheb Chvojecna"
  },
  {
    "cast": "Chvojen",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Chvojen"
  },
  {
    "cast": "Chvojenec",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Chvojenec",
    "val": "53401 Chvojenec Chvojenec"
  },
  {
    "cast": "Chvojínek",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Chvojinek"
  },
  {
    "cast": "Chvojnov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Chvojnov"
  },
  {
    "cast": "Chyjice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Chyjice",
    "val": "50601 Chyjice Chyjice"
  },
  {
    "cast": "Chylice",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Útvina",
    "val": "36401 Utvina Chylice"
  },
  {
    "cast": "Chylice",
    "psc": "68722",
    "okres": "Uherské Hradiště",
    "obec": "Ostrožská Nová Ves",
    "val": "68722 Ostrozska Nova Ves Chylice"
  },
  {
    "cast": "Chyňava",
    "psc": "26707",
    "okres": "Beroun",
    "obec": "Chyňava",
    "val": "26707 Chynava Chynava"
  },
  {
    "cast": "Chýně",
    "psc": "25301",
    "okres": "Praha-západ",
    "obec": "Chýně",
    "val": "25301 Chyne Chyne"
  },
  {
    "cast": "Chýnice",
    "psc": "25217",
    "okres": "Praha-západ",
    "obec": "Chýnice",
    "val": "25217 Chynice Chynice"
  },
  {
    "cast": "Chynín",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Čížkov",
    "val": "33563 Cizkov Chynin"
  },
  {
    "cast": "Chýnov",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Chýnov",
    "val": "39155 Chynov Chynov"
  },
  {
    "cast": "Chýstovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Chýstovice",
    "val": "39501 Chystovice Chystovice"
  },
  {
    "cast": "Chyše",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Chyse"
  },
  {
    "cast": "Chyška",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Úsobí",
    "val": "58253 Usobi Chyska"
  },
  {
    "cast": "Chyšky",
    "psc": "39853",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39853 Chysky Chysky"
  },
  {
    "cast": "Chýšky",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Chysky"
  },
  {
    "cast": "Chyšná",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Chyšná",
    "val": "39501 Chysna Chysna"
  },
  {
    "cast": "Chýšť",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Chýšť",
    "val": "53316 Chyst Chyst"
  },
  {
    "cast": "Ivaň",
    "psc": "69123",
    "okres": "Brno-venkov",
    "obec": "Ivaň",
    "val": "69123 Ivan Ivan"
  },
  {
    "cast": "Ivaň",
    "psc": "79823",
    "okres": "Prostějov",
    "obec": "Ivaň",
    "val": "79823 Ivan Ivan"
  },
  {
    "cast": "Ivančice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Ivančice",
    "val": "66491 Ivancice Ivancice"
  },
  {
    "cast": "Ivanovice",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Ivanovice"
  },
  {
    "cast": "Ivanovice na Hané",
    "psc": "68323",
    "okres": "Vyškov",
    "obec": "Ivanovice na Hané",
    "val": "68323 Ivanovice na Hane Ivanovice na Hane"
  },
  {
    "cast": "Jabkenice",
    "psc": "29445",
    "okres": "Mladá Boleslav",
    "obec": "Jabkenice",
    "val": "29445 Jabkenice Jabkenice"
  },
  {
    "cast": "Jablečno",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Zbiroh",
    "val": "33808 Zbiroh Jablecno"
  },
  {
    "cast": "Jabloňany",
    "psc": "67901",
    "okres": "Blansko",
    "obec": "Jabloňany",
    "val": "67901 Jablonany Jablonany"
  },
  {
    "cast": "Jablonce",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Nečín",
    "val": "26301 Necin Jablonce"
  },
  {
    "cast": "Jablonec",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Jablonec"
  },
  {
    "cast": "Jablonec nad Jizerou",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Jablonec nad Jizerou"
  },
  {
    "cast": "Jablonec nad Nisou (část)",
    "psc": "46601",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46601 Jablonec nad Nisou Jablonec nad Nisou (cast)"
  },
  {
    "cast": "Jablonec nad Nisou (část)",
    "psc": "46602",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46602 Jablonec nad Nisou Jablonec nad Nisou (cast)"
  },
  {
    "cast": "Jablonecké Paseky (část)",
    "psc": "46601",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46601 Jablonec nad Nisou Jablonecke Paseky (cast)"
  },
  {
    "cast": "Jablonecké Paseky (část)",
    "psc": "46602",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46602 Jablonec nad Nisou Jablonecke Paseky (cast)"
  },
  {
    "cast": "Jabloneček",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "47124 Ralsko Jablonecek"
  },
  {
    "cast": "Jablonná",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Jablonna"
  },
  {
    "cast": "Jablonná",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25744 Neveklov Jablonna"
  },
  {
    "cast": "Jablonná",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Jablonná",
    "val": "26263 Jablonna Jablonna"
  },
  {
    "cast": "Jablonné nad Orlicí",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Jablonné nad Orlicí",
    "val": "56164 Jablonne nad Orlici Jablonne nad Orlici"
  },
  {
    "cast": "Jablonné v Podještědí",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Jablonne v Podjestedi"
  },
  {
    "cast": "Jabloňov",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Jabloňov",
    "val": "59401 Jablonov Jablonov"
  },
  {
    "cast": "Jabloňov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Věžná",
    "val": "59301 Vezna Jablonov"
  },
  {
    "cast": "Jablůnka",
    "psc": "75623",
    "okres": "Vsetín",
    "obec": "Jablůnka",
    "val": "75623 Jablunka Jablunka"
  },
  {
    "cast": "Jablunkov",
    "psc": "73991",
    "okres": "Frýdek-Místek",
    "obec": "Jablunkov",
    "val": "73991 Jablunkov Jablunkov"
  },
  {
    "cast": "Jackov",
    "psc": "67541",
    "okres": "Třebíč",
    "obec": "Moravské Budějovice",
    "val": "67541 Moravske Budejovice Jackov"
  },
  {
    "cast": "Jadruž",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34806 Straz Jadruz"
  },
  {
    "cast": "Jahodov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Rozsochatec",
    "val": "58001 Rozsochatec Jahodov"
  },
  {
    "cast": "Jahodov",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Jahodov",
    "val": "51601 Jahodov Jahodov"
  },
  {
    "cast": "Jáchymov",
    "psc": "47129",
    "okres": "Česká Lípa",
    "obec": "Brniště",
    "val": "47129 Brniste Jachymov"
  },
  {
    "cast": "Jáchymov",
    "psc": "36251",
    "okres": "Karlovy Vary",
    "obec": "Jáchymov",
    "val": "36251 Jachymov Jachymov"
  },
  {
    "cast": "Jáchymov",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59453 Velka Bites Jachymov"
  },
  {
    "cast": "Jakartovice",
    "psc": "74753",
    "okres": "Opava",
    "obec": "Jakartovice",
    "val": "74753 Jakartovice Jakartovice"
  },
  {
    "cast": "Jaktař (část)",
    "psc": "74601",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74601 Opava Jaktar (cast)"
  },
  {
    "cast": "Jaktař (část)",
    "psc": "74707",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74707 Opava Jaktar (cast)"
  },
  {
    "cast": "Jakub",
    "psc": "28533",
    "okres": "Kutná Hora",
    "obec": "Církvice",
    "val": "28533 Cirkvice Jakub"
  },
  {
    "cast": "Jakubčovice",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Hradec nad Moravicí",
    "val": "74741 Hradec nad Moravici Jakubcovice"
  },
  {
    "cast": "Jakubčovice nad Odrou",
    "psc": "74236",
    "okres": "Nový Jičín",
    "obec": "Jakubčovice nad Odrou",
    "val": "74236 Jakubcovice nad Odrou Jakubcovice nad Odrou"
  },
  {
    "cast": "Jakubín",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Častrov",
    "val": "39468 Castrov Jakubin"
  },
  {
    "cast": "Jakubov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Vojkovice",
    "val": "36301 Vojkovice Jakubov"
  },
  {
    "cast": "Jakubov u Moravských Budějovic",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Jakubov u Moravských Budějovic",
    "val": "67544 Jakubov u Moravskych Budejovic Jakubov u Moravskych Budejovic"
  },
  {
    "cast": "Jakubovice",
    "psc": "78991",
    "okres": "Šumperk",
    "obec": "Jakubovice",
    "val": "78991 Jakubovice Jakubovice"
  },
  {
    "cast": "Jakubovice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Jakubovice"
  },
  {
    "cast": "Jakubovice",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Čermná",
    "val": "56301 Dolni Cermna Jakubovice"
  },
  {
    "cast": "Jakubské Předměstí (část)",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Jakubske Predmesti (cast)"
  },
  {
    "cast": "Jakubské Předměstí (část)",
    "psc": "55102",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55102 Jaromer Jakubske Predmesti (cast)"
  },
  {
    "cast": "Jalubí",
    "psc": "68705",
    "okres": "Uherské Hradiště",
    "obec": "Jalubí",
    "val": "68705 Jalubi Jalubi"
  },
  {
    "cast": "Jalůvčí-Děčín XVII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Jaluvci-Decin XVII x)"
  },
  {
    "cast": "Jáma",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Mičovice",
    "val": "38301 Micovice Jama"
  },
  {
    "cast": "Jamartice",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Rýmařov",
    "val": "79501 Rymarov Jamartice"
  },
  {
    "cast": "Jamné",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Tišnov",
    "val": "66601 Tisnov Jamne"
  },
  {
    "cast": "Jamné",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Boršov nad Vltavou",
    "val": "37001 Borsov nad Vltavou Jamne"
  },
  {
    "cast": "Jamné nad Orlicí (část)",
    "psc": "56165",
    "okres": "Ústí nad Orlicí",
    "obec": "Jamné nad Orlicí",
    "val": "56165 Jamne nad Orlici Jamne nad Orlici (cast)"
  },
  {
    "cast": "Jamné nad Orlicí (část)",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Jamné nad Orlicí",
    "val": "56164 Jamne nad Orlici Jamne nad Orlici (cast)"
  },
  {
    "cast": "Jamné (část)",
    "psc": "58821",
    "okres": "Jihlava",
    "obec": "Jamné",
    "val": "58821 Jamne Jamne (cast)"
  },
  {
    "cast": "Jamné (část)",
    "psc": "58827",
    "okres": "Jihlava",
    "obec": "Jamné",
    "val": "58827 Jamne Jamne (cast)"
  },
  {
    "cast": "Jamnice",
    "psc": "74601",
    "okres": "Opava",
    "obec": "Stěbořice",
    "val": "74601 Steborice Jamnice"
  },
  {
    "cast": "Jamný",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Záhoří",
    "val": "39701 Zahori Jamny"
  },
  {
    "cast": "Jamolice",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Jamolice",
    "val": "67201 Jamolice Jamolice"
  },
  {
    "cast": "Jámy",
    "psc": "59232",
    "okres": "Žďár nad Sázavou",
    "obec": "Jámy",
    "val": "59232 Jamy Jamy"
  },
  {
    "cast": "Jámy",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51601 Rychnov nad Kneznou Jamy"
  },
  {
    "cast": "Janatov",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Lodín",
    "val": "50315 Lodin Janatov"
  },
  {
    "cast": "Jančí",
    "psc": "74744",
    "okres": "Opava",
    "obec": "Březová",
    "val": "74744 Brezova Janci"
  },
  {
    "cast": "Jankov",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Jankov"
  },
  {
    "cast": "Jankov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Jankov",
    "val": "39301 Jankov Jankov"
  },
  {
    "cast": "Jankov",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Jankov",
    "val": "37384 Jankov Jankov"
  },
  {
    "cast": "Jankovice",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Jankovice"
  },
  {
    "cast": "Jankovice",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Jankovice",
    "val": "76901 Jankovice Jankovice"
  },
  {
    "cast": "Jankovice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Jankovice",
    "val": "53501 Jankovice Jankovice"
  },
  {
    "cast": "Jankovice",
    "psc": "68704",
    "okres": "Uherské Hradiště",
    "obec": "Jankovice",
    "val": "68704 Jankovice Jankovice"
  },
  {
    "cast": "Jankovská Lhota",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Jankovska Lhota"
  },
  {
    "cast": "Janoslavice",
    "psc": "78974",
    "okres": "Šumperk",
    "obec": "Rohle",
    "val": "78974 Rohle Janoslavice"
  },
  {
    "cast": "Janoušov",
    "psc": "78991",
    "okres": "Šumperk",
    "obec": "Janoušov",
    "val": "78991 Janousov Janousov"
  },
  {
    "cast": "Janoušov",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Cotkytle",
    "val": "56301 Cotkytle Janousov"
  },
  {
    "cast": "Janov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Janov",
    "val": "40502 Janov Janov"
  },
  {
    "cast": "Janov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Roudná",
    "val": "39201 Roudna Janov"
  },
  {
    "cast": "Janov",
    "psc": "43542",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43542 Litvinov Janov"
  },
  {
    "cast": "Janov",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26401 Kosova Hora Janov"
  },
  {
    "cast": "Janov",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Nový Bor",
    "val": "47301 Novy Bor Janov"
  },
  {
    "cast": "Janov",
    "psc": "79384",
    "okres": "Bruntál",
    "obec": "Janov",
    "val": "79384 Janov Janov"
  },
  {
    "cast": "Janov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Janov"
  },
  {
    "cast": "Janov",
    "psc": "56955",
    "okres": "Svitavy",
    "obec": "Janov",
    "val": "56955 Janov Janov"
  },
  {
    "cast": "Janov",
    "psc": "27006",
    "okres": "Rakovník",
    "obec": "Janov",
    "val": "27006 Janov Janov"
  },
  {
    "cast": "Janov",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Janov",
    "val": "51801 Janov Janov"
  },
  {
    "cast": "Janov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Kočov",
    "val": "34815 Kocov Janov"
  },
  {
    "cast": "Janov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Hobzí",
    "val": "37881 Stare Hobzi Janov"
  },
  {
    "cast": "Janov nad Nisou",
    "psc": "46811",
    "okres": "Jablonec nad Nisou",
    "obec": "Janov nad Nisou",
    "val": "46811 Janov nad Nisou Janov nad Nisou"
  },
  {
    "cast": "Janová",
    "psc": "75501",
    "okres": "Vsetín",
    "obec": "Janová",
    "val": "75501 Janova Janova"
  },
  {
    "cast": "Janova Ves",
    "psc": "27723",
    "okres": "Mělník",
    "obec": "Kokořín",
    "val": "27723 Kokorin Janova Ves"
  },
  {
    "cast": "Janova Ves",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Pohorská Ves",
    "val": "38241 Pohorska Ves Janova Ves"
  },
  {
    "cast": "Janovice",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Polná",
    "val": "58813 Polna Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Kobyly",
    "val": "46343 Kobyly Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dlouhá Ves",
    "val": "34201 Dlouha Ves Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "50356",
    "okres": "Hradec Králové",
    "obec": "Vinary",
    "val": "50356 Vinary Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47002 Kravare Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Morašice",
    "val": "53803 Morasice Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "74283",
    "okres": "Ostrava-město",
    "obec": "Olbramice",
    "val": "74283 Olbramice Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74101 Stary Jicin Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "79342",
    "okres": "Bruntál",
    "obec": "Rýmařov",
    "val": "79342 Rymarov Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Janovice"
  },
  {
    "cast": "Janovice",
    "psc": "73911",
    "okres": "Frýdek-Místek",
    "obec": "Janovice",
    "val": "73911 Janovice Janovice"
  },
  {
    "cast": "Janovice nad Úhlavou",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Janovice nad Uhlavou"
  },
  {
    "cast": "Janovice v Podještědí",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Janovice v Podještědí",
    "val": "46353 Janovice v Podjestedi Janovice v Podjestedi"
  },
  {
    "cast": "Janovická Lhota",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Uhlířské Janovice",
    "val": "28504 Uhlirske Janovice Janovicka Lhota"
  },
  {
    "cast": "Janovičky",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Heřmánkovice",
    "val": "55001 Hermankovice Janovicky"
  },
  {
    "cast": "Janovičky",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bohuňov",
    "val": "59301 Bohunov Janovicky"
  },
  {
    "cast": "Janovičky (část)",
    "psc": "56543",
    "okres": "Ústí nad Orlicí",
    "obec": "Zámrsk",
    "val": "56543 Zamrsk Janovicky (cast)"
  },
  {
    "cast": "Janovičky (část)",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Zámrsk",
    "val": "56601 Zamrsk Janovicky (cast)"
  },
  {
    "cast": "Janovka",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Velký Šenov",
    "val": "40747 Velky Senov Janovka"
  },
  {
    "cast": "Janská",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Janská",
    "val": "40502 Janska Janska"
  },
  {
    "cast": "Jánská",
    "psc": "26712",
    "okres": "Beroun",
    "obec": "Loděnice",
    "val": "26712 Lodenice Janska"
  },
  {
    "cast": "Jánské Koupele",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Staré Těchanovice",
    "val": "74901 Stare Techanovice Janske Koupele"
  },
  {
    "cast": "Janské Lázně",
    "psc": "54225",
    "okres": "Trutnov",
    "obec": "Janské Lázně",
    "val": "54225 Janske Lazne Janske Lazne"
  },
  {
    "cast": "Janské Údolí",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Brloh",
    "val": "38203 Brloh Janske Udoli"
  },
  {
    "cast": "Janův Důl",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Janův Důl",
    "val": "46352 Januv Dul Januv Dul"
  },
  {
    "cast": "Janův Důl-Liberec IX x)",
    "psc": "46007",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46007 Liberec Januv Dul-Liberec IX x)"
  },
  {
    "cast": "Janůvky",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Janůvky",
    "val": "56943 Januvky Januvky"
  },
  {
    "cast": "Jarcová (část)",
    "psc": "75624",
    "okres": "Vsetín",
    "obec": "Jarcová",
    "val": "75624 Jarcova Jarcova (cast)"
  },
  {
    "cast": "Jarcová (část)",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Jarcová",
    "val": "75701 Jarcova Jarcova (cast)"
  },
  {
    "cast": "Jarkovice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Jarkovice"
  },
  {
    "cast": "Jarkovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25601 Bystrice Jarkovice"
  },
  {
    "cast": "Jarohněvice",
    "psc": "76801",
    "okres": "Kroměříž",
    "obec": "Jarohněvice",
    "val": "76801 Jarohnevice Jarohnevice"
  },
  {
    "cast": "Jaroměř",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Jaromer"
  },
  {
    "cast": "Jaroměř",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Malonty",
    "val": "38241 Malonty Jaromer"
  },
  {
    "cast": "Jaroměřice nad Rokytnou",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Jaroměřice nad Rokytnou",
    "val": "67551 Jaromerice nad Rokytnou Jaromerice nad Rokytnou"
  },
  {
    "cast": "Jaroměřice (část)",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Jaroměřice",
    "val": "56943 Jaromerice Jaromerice (cast)"
  },
  {
    "cast": "Jaroměřice (část)",
    "psc": "56944",
    "okres": "Svitavy",
    "obec": "Jaroměřice",
    "val": "56944 Jaromerice Jaromerice (cast)"
  },
  {
    "cast": "Jaronice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Dubné",
    "val": "37341 Dubne Jaronice"
  },
  {
    "cast": "Jaronín",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Brloh",
    "val": "38203 Brloh Jaronin"
  },
  {
    "cast": "Jaroslav",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Jaroslav",
    "val": "53401 Jaroslav Jaroslav"
  },
  {
    "cast": "Jaroslav",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Javornice",
    "val": "51601 Javornice Jaroslav"
  },
  {
    "cast": "Jaroslavice",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76001 Zlin Jaroslavice"
  },
  {
    "cast": "Jaroslavice",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Jaroslavice",
    "val": "67128 Jaroslavice Jaroslavice"
  },
  {
    "cast": "Jaroslavice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Jaroslavice"
  },
  {
    "cast": "Jaroškov",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Stachy",
    "val": "38473 Stachy Jaroskov"
  },
  {
    "cast": "Jarošov",
    "psc": "56966",
    "okres": "Svitavy",
    "obec": "Jarošov",
    "val": "56966 Jarosov Jarosov"
  },
  {
    "cast": "Jarošov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Uhelná Příbram",
    "val": "58301 Uhelna Pribram Jarosov"
  },
  {
    "cast": "Jarošov",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68601 Uherske Hradiste Jarosov"
  },
  {
    "cast": "Jarošov nad Nežárkou",
    "psc": "37841",
    "okres": "Jindřichův Hradec",
    "obec": "Jarošov nad Nežárkou",
    "val": "37841 Jarosov nad Nezarkou Jarosov nad Nezarkou"
  },
  {
    "cast": "Jarotice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39804 Mirotice Jarotice"
  },
  {
    "cast": "Jarov",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Jarov",
    "val": "33501 Jarov Jarov"
  },
  {
    "cast": "Jarov",
    "psc": "33151",
    "okres": "Plzeň-sever",
    "obec": "Jarov",
    "val": "33151 Jarov Jarov"
  },
  {
    "cast": "Jarov (část)",
    "psc": "25241",
    "okres": "Praha-západ",
    "obec": "Dolní Břežany",
    "val": "25241 Dolni Brezany Jarov (cast)"
  },
  {
    "cast": "Jarov (část)",
    "psc": "25246",
    "okres": "Praha-západ",
    "obec": "Dolní Břežany",
    "val": "25246 Dolni Brezany Jarov (cast)"
  },
  {
    "cast": "Jarov-Beroun x)",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Jarov-Beroun x)"
  },
  {
    "cast": "Jarpice (část)",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Jarpice",
    "val": "27371 Jarpice Jarpice (cast)"
  },
  {
    "cast": "Jarpice (část)",
    "psc": "27372",
    "okres": "Kladno",
    "obec": "Jarpice",
    "val": "27372 Jarpice Jarpice (cast)"
  },
  {
    "cast": "Jasenice",
    "psc": "75641",
    "okres": "Vsetín",
    "obec": "Lešná",
    "val": "75641 Lesna Jasenice"
  },
  {
    "cast": "Jasenice",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Jasenice",
    "val": "67571 Jasenice Jasenice"
  },
  {
    "cast": "Jasenná",
    "psc": "55222",
    "okres": "Náchod",
    "obec": "Jasenná",
    "val": "55222 Jasenna Jasenna"
  },
  {
    "cast": "Jasenná (část)",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Jasenná",
    "val": "76312 Jasenna Jasenna (cast)"
  },
  {
    "cast": "Jasenná (část)",
    "psc": "76313",
    "okres": "Zlín",
    "obec": "Jasenná",
    "val": "76313 Jasenna Jasenna (cast)"
  },
  {
    "cast": "Jasinov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Jasinov"
  },
  {
    "cast": "Jasné Pole",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Všeradov",
    "val": "53901 Vseradov Jasne Pole"
  },
  {
    "cast": "Javor",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Javor"
  },
  {
    "cast": "Javor",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Slapsko",
    "val": "39143 Slapsko Javor"
  },
  {
    "cast": "Javor",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Javor",
    "val": "34021 Javor Javor"
  },
  {
    "cast": "Javor",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Javor"
  },
  {
    "cast": "Javorek",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Jilemnice",
    "val": "51401 Jilemnice Javorek"
  },
  {
    "cast": "Javorek",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Javorek",
    "val": "59203 Javorek Javorek"
  },
  {
    "cast": "Javorka",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Javorka"
  },
  {
    "cast": "Javorná",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Javorna"
  },
  {
    "cast": "Javorná",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Javorna"
  },
  {
    "cast": "Javorná",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bražec",
    "val": "36471 Brazec Javorna"
  },
  {
    "cast": "Javorné",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53825 Horni Bradlo Javorne"
  },
  {
    "cast": "Javornice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Kněžnice",
    "val": "50601 Kneznice Javornice"
  },
  {
    "cast": "Javornice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Dub",
    "val": "38422 Dub Javornice"
  },
  {
    "cast": "Javornice (část)",
    "psc": "51711",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Javornice",
    "val": "51711 Javornice Javornice (cast)"
  },
  {
    "cast": "Javornice (část)",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Javornice",
    "val": "51601 Javornice Javornice (cast)"
  },
  {
    "cast": "Javorníček",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Libecina",
    "val": "56601 Libecina Javornicek"
  },
  {
    "cast": "Javorník",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Javornik"
  },
  {
    "cast": "Javorník",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Čtyřkoly",
    "val": "25722 Ctyrkoly Javornik"
  },
  {
    "cast": "Javorník",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Javorník",
    "val": "56802 Javornik Javornik"
  },
  {
    "cast": "Javorník",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Javorník",
    "val": "25763 Javornik Javornik"
  },
  {
    "cast": "Javorník",
    "psc": "54372",
    "okres": "Trutnov",
    "obec": "Rudník",
    "val": "54372 Rudnik Javornik"
  },
  {
    "cast": "Javorník",
    "psc": "69674",
    "okres": "Hodonín",
    "obec": "Javorník",
    "val": "69674 Javornik Javornik"
  },
  {
    "cast": "Javorník",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Javorník",
    "val": "56601 Javornik Javornik"
  },
  {
    "cast": "Javorník",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Javorník",
    "val": "79070 Javornik Javornik"
  },
  {
    "cast": "Javorník",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Proseč pod Ještědem",
    "val": "46343 Prosec pod Jestedem Javornik"
  },
  {
    "cast": "Javorovec",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Mistřice",
    "val": "68712 Mistrice Javorovec"
  },
  {
    "cast": "Javory",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40502 Malsovice Javory"
  },
  {
    "cast": "Javoří",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Maletín",
    "val": "78901 Maletin Javori"
  },
  {
    "cast": "Javoří",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Javori"
  },
  {
    "cast": "Javoří",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Javori"
  },
  {
    "cast": "Javoří",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Javori"
  },
  {
    "cast": "Javoříčko",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Luká",
    "val": "78324 Luka Javoricko"
  },
  {
    "cast": "Javoříčko",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Javoricko"
  },
  {
    "cast": "Javoříčko",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Javoricko"
  },
  {
    "cast": "Javůrek (část)",
    "psc": "66483",
    "okres": "Brno-venkov",
    "obec": "Javůrek",
    "val": "66483 Javurek Javurek (cast)"
  },
  {
    "cast": "Javůrek (část)",
    "psc": "66471",
    "okres": "Brno-venkov",
    "obec": "Javůrek",
    "val": "66471 Javurek Javurek (cast)"
  },
  {
    "cast": "Jazovice",
    "psc": "67106",
    "okres": "Znojmo",
    "obec": "Starý Petřín",
    "val": "67106 Stary Petrin Jazovice"
  },
  {
    "cast": "Jažlovice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Říčany",
    "val": "25101 Ricany Jazlovice"
  },
  {
    "cast": "Jeclov",
    "psc": "58821",
    "okres": "Jihlava",
    "obec": "Velký Beranov",
    "val": "58821 Velky Beranov Jeclov"
  },
  {
    "cast": "Ječovice",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Mšené-lázně",
    "val": "41119 Msene-lazne Jecovice"
  },
  {
    "cast": "Jedlá",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Jedlá",
    "val": "58401 Jedla Jedla"
  },
  {
    "cast": "Jedlany",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Jedlany",
    "val": "39137 Jedlany Jedlany"
  },
  {
    "cast": "Jedlí",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Jedlí",
    "val": "78901 Jedli Jedli"
  },
  {
    "cast": "Jedlina",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Chýstovice",
    "val": "39501 Chystovice Jedlina"
  },
  {
    "cast": "Jedlina",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Klášterec nad Orlicí",
    "val": "56401 Klasterec nad Orlici Jedlina"
  },
  {
    "cast": "Jedlina",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Synkov-Slemeno",
    "val": "51601 Synkov-Slemeno Jedlina"
  },
  {
    "cast": "Jedlka",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malá Veleň",
    "val": "40502 Mala Velen Jedlka"
  },
  {
    "cast": "Jedlov",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Mirošov",
    "val": "58805 Mirosov Jedlov"
  },
  {
    "cast": "Jedlová",
    "psc": "56991",
    "okres": "Svitavy",
    "obec": "Jedlová",
    "val": "56991 Jedlova Jedlova"
  },
  {
    "cast": "Jedlová (část)",
    "psc": "40801",
    "okres": "Děčín",
    "obec": "Jiřetín pod Jedlovou",
    "val": "40801 Jiretin pod Jedlovou Jedlova (cast)"
  },
  {
    "cast": "Jedlová (část)",
    "psc": "40756",
    "okres": "Děčín",
    "obec": "Jiřetín pod Jedlovou",
    "val": "40756 Jiretin pod Jedlovou Jedlova (cast)"
  },
  {
    "cast": "Jednov",
    "psc": "79845",
    "okres": "Prostějov",
    "obec": "Suchdol",
    "val": "79845 Suchdol Jednov"
  },
  {
    "cast": "Jedomělice",
    "psc": "27378",
    "okres": "Kladno",
    "obec": "Jedomělice",
    "val": "27378 Jedomelice Jedomelice"
  },
  {
    "cast": "Jedouchov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Věž",
    "val": "58001 Vez Jedouchov"
  },
  {
    "cast": "Jedousov",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Jedousov",
    "val": "53501 Jedousov Jedousov"
  },
  {
    "cast": "Jedov",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Náměšť nad Oslavou",
    "val": "67571 Namest nad Oslavou Jedov"
  },
  {
    "cast": "Jedovary",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Jedovary"
  },
  {
    "cast": "Jedovnice",
    "psc": "67906",
    "okres": "Blansko",
    "obec": "Jedovnice",
    "val": "67906 Jedovnice Jedovnice"
  },
  {
    "cast": "Jedraž",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Radošovice",
    "val": "38701 Radosovice Jedraz"
  },
  {
    "cast": "Jedvaniny",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Jedvaniny"
  },
  {
    "cast": "Jehlice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Dolní Přím",
    "val": "50315 Dolni Prim Jehlice"
  },
  {
    "cast": "Jehličná",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Královské Poříčí",
    "val": "35601 Kralovske Porici Jehlicna"
  },
  {
    "cast": "Jehnědí",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Jehnědí",
    "val": "56201 Jehnedi Jehnedi"
  },
  {
    "cast": "Jehnědno",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Albrechtice nad Vltavou",
    "val": "39701 Albrechtice nad Vltavou Jehnedno"
  },
  {
    "cast": "Jehnice",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Jehnice"
  },
  {
    "cast": "Jejkov",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Jejkov"
  },
  {
    "cast": "Jelcovy Lhotky",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Jelcovy Lhotky"
  },
  {
    "cast": "Jeleč",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41201 Libesice Jelec"
  },
  {
    "cast": "Jelemek",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Nebahovy",
    "val": "38301 Nebahovy Jelemek"
  },
  {
    "cast": "Jelence",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Dolní Hbity",
    "val": "26263 Dolni Hbity Jelence"
  },
  {
    "cast": "Jeleneč",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Jelenec"
  },
  {
    "cast": "Jelení",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Nová Pec",
    "val": "38451 Nova Pec Jeleni"
  },
  {
    "cast": "Jelení",
    "psc": "79371",
    "okres": "Bruntál",
    "obec": "Holčovice",
    "val": "79371 Holcovice Jeleni"
  },
  {
    "cast": "Jelenice",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74901 Vitkov Jelenice"
  },
  {
    "cast": "Jelenice",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Malý Újezd",
    "val": "27731 Maly Ujezd Jelenice"
  },
  {
    "cast": "Jelenov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Čáslavsko",
    "val": "39501 Caslavsko Jelenov"
  },
  {
    "cast": "Jelenov",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Jelenov"
  },
  {
    "cast": "Jelínek",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Kamenec u Poličky",
    "val": "57201 Kamenec u Policky Jelinek"
  },
  {
    "cast": "Jelmo",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Libníč",
    "val": "37371 Libnic Jelmo"
  },
  {
    "cast": "Jemčina (část)",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Hatín",
    "val": "37901 Hatin Jemcina (cast)"
  },
  {
    "cast": "Jemčina (část)",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Hatín",
    "val": "37802 Hatin Jemcina (cast)"
  },
  {
    "cast": "Jemčina (část)",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Hatín",
    "val": "37701 Hatin Jemcina (cast)"
  },
  {
    "cast": "Jemnice",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Jemnice",
    "val": "67531 Jemnice Jemnice"
  },
  {
    "cast": "Jemnice",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Tisová",
    "val": "34801 Tisova Jemnice"
  },
  {
    "cast": "Jemnice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Osek",
    "val": "38601 Osek Jemnice"
  },
  {
    "cast": "Jemnice",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Strážek",
    "val": "59253 Strazek Jemnice"
  },
  {
    "cast": "Jemníky",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Jemníky",
    "val": "27401 Jemniky Jemniky"
  },
  {
    "cast": "Jemníky",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Jemniky"
  },
  {
    "cast": "Jemniště",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Jemniste"
  },
  {
    "cast": "Jenčice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Jenčice",
    "val": "41115 Jencice Jencice"
  },
  {
    "cast": "Jeneč",
    "psc": "25261",
    "okres": "Praha-západ",
    "obec": "Jeneč",
    "val": "25261 Jenec Jenec"
  },
  {
    "cast": "Jeneč",
    "psc": "67921",
    "okres": "Blansko",
    "obec": "Brťov-Jeneč",
    "val": "67921 Brtov-Jenec Jenec"
  },
  {
    "cast": "Jeníčkova Lhota",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Jenickova Lhota"
  },
  {
    "cast": "Jenichov (část)",
    "psc": "27734",
    "okres": "Mělník",
    "obec": "Střemy",
    "val": "27734 Stremy Jenichov (cast)"
  },
  {
    "cast": "Jenichov (část)",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Střemy",
    "val": "27731 Stremy Jenichov (cast)"
  },
  {
    "cast": "Jeníkov",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Jenikov"
  },
  {
    "cast": "Jeníkov",
    "psc": "41724",
    "okres": "Teplice",
    "obec": "Jeníkov",
    "val": "41724 Jenikov Jenikov"
  },
  {
    "cast": "Jeníkov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Jeníkov",
    "val": "53901 Jenikov Jenikov"
  },
  {
    "cast": "Jeníkovec",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Maleč",
    "val": "58301 Malec Jenikovec"
  },
  {
    "cast": "Jeníkovice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Jeníkovice",
    "val": "53501 Jenikovice Jenikovice"
  },
  {
    "cast": "Jeníkovice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34601 Meclov Jenikovice"
  },
  {
    "cast": "Jeníkovice",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Jeníkovice",
    "val": "50346 Jenikovice Jenikovice"
  },
  {
    "cast": "Jenín",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38241 Dolni Dvoriste Jenin"
  },
  {
    "cast": "Jenišov",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Jenišov",
    "val": "36001 Jenisov Jenisov"
  },
  {
    "cast": "Jenišovice",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Býkev",
    "val": "27601 Bykev Jenisovice"
  },
  {
    "cast": "Jenišovice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Křivsoudov",
    "val": "25765 Krivsoudov Jenisovice"
  },
  {
    "cast": "Jenišovice",
    "psc": "46833",
    "okres": "Jablonec nad Nisou",
    "obec": "Jenišovice",
    "val": "46833 Jenisovice Jenisovice"
  },
  {
    "cast": "Jenišovice (část)",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Jenišovice",
    "val": "53863 Jenisovice Jenisovice (cast)"
  },
  {
    "cast": "Jenišovice (část)",
    "psc": "53864",
    "okres": "Chrudim",
    "obec": "Jenišovice",
    "val": "53864 Jenisovice Jenisovice (cast)"
  },
  {
    "cast": "Jenštejn",
    "psc": "25073",
    "okres": "Praha-východ",
    "obec": "Jenštejn",
    "val": "25073 Jenstejn Jenstejn"
  },
  {
    "cast": "Jerlochovice",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Jerlochovice"
  },
  {
    "cast": "Jersice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Hříšice",
    "val": "38001 Hrisice Jersice"
  },
  {
    "cast": "Jersín",
    "psc": "58825",
    "okres": "Jihlava",
    "obec": "Jersín",
    "val": "58825 Jersin Jersin"
  },
  {
    "cast": "Jerusalem",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Jerusalem"
  },
  {
    "cast": "Jeřáb-Liberec III x)",
    "psc": "46007",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46007 Liberec Jerab-Liberec III x)"
  },
  {
    "cast": "Jeřeň",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Valeč",
    "val": "36453 Valec Jeren"
  },
  {
    "cast": "Jeřice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Jeřice",
    "val": "50801 Jerice Jerice"
  },
  {
    "cast": "Jeřičky",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Hořiněves",
    "val": "50303 Horineves Jericky"
  },
  {
    "cast": "Jeřišno",
    "psc": "58274",
    "okres": "Havlíčkův Brod",
    "obec": "Jeřišno",
    "val": "58274 Jerisno Jerisno"
  },
  {
    "cast": "Jeřmaň",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Jerman"
  },
  {
    "cast": "Jeřmanice",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Jeřmanice",
    "val": "46312 Jermanice Jermanice"
  },
  {
    "cast": "Jesenec",
    "psc": "79853",
    "okres": "Prostějov",
    "obec": "Jesenec",
    "val": "79853 Jesenec Jesenec"
  },
  {
    "cast": "Jesení",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Jeseni"
  },
  {
    "cast": "Jesenice",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Okrouhlá",
    "val": "35002 Okrouhla Jesenice"
  },
  {
    "cast": "Jesenice",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26231 Pribram Jesenice"
  },
  {
    "cast": "Jesenice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Jesenice"
  },
  {
    "cast": "Jesenice",
    "psc": "25242",
    "okres": "Praha-západ",
    "obec": "Jesenice",
    "val": "25242 Jesenice Jesenice"
  },
  {
    "cast": "Jesenice",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Jesenice",
    "val": "27033 Jesenice Jesenice"
  },
  {
    "cast": "Jeseník",
    "psc": "79001",
    "okres": "Jeseník",
    "obec": "Jeseník",
    "val": "79001 Jesenik Jesenik"
  },
  {
    "cast": "Jeseník nad Odrou",
    "psc": "74233",
    "okres": "Nový Jičín",
    "obec": "Jeseník nad Odrou",
    "val": "74233 Jesenik nad Odrou Jesenik nad Odrou"
  },
  {
    "cast": "Jesenný (část)",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Jesenný",
    "val": "51301 Jesenny Jesenny (cast)"
  },
  {
    "cast": "Jesenný (část)",
    "psc": "51212",
    "okres": "Semily",
    "obec": "Jesenný",
    "val": "51212 Jesenny Jesenny (cast)"
  },
  {
    "cast": "Jesínky",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Jesinky"
  },
  {
    "cast": "Jestřabí",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Jestrabi"
  },
  {
    "cast": "Jestřabí",
    "psc": "76333",
    "okres": "Zlín",
    "obec": "Jestřabí",
    "val": "76333 Jestrabi Jestrabi"
  },
  {
    "cast": "Jestřabí",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Jestrabi"
  },
  {
    "cast": "Jestřabí Lhota",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Jestřabí Lhota",
    "val": "28002 Jestrabi Lhota Jestrabi Lhota"
  },
  {
    "cast": "Jestřabí v Krkonoších",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Jestřabí v Krkonoších",
    "val": "51401 Jestrabi v Krkonosich Jestrabi v Krkonosich"
  },
  {
    "cast": "Jestřabice",
    "psc": "76805",
    "okres": "Kroměříž",
    "obec": "Koryčany",
    "val": "76805 Korycany Jestrabice"
  },
  {
    "cast": "Jestřebí",
    "psc": "58832",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58832 Brtnice Jestrebi"
  },
  {
    "cast": "Jestřebí",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Jestřebí",
    "val": "78901 Jestrebi Jestrebi"
  },
  {
    "cast": "Jestřebí",
    "psc": "47161",
    "okres": "Česká Lípa",
    "obec": "Jestřebí",
    "val": "47161 Jestrebi Jestrebi"
  },
  {
    "cast": "Jestřebí",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Rájec-Jestřebí",
    "val": "67902 Rajec-Jestrebi Jestrebi"
  },
  {
    "cast": "Jestřebí",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Jestřebí",
    "val": "54901 Jestrebi Jestrebi"
  },
  {
    "cast": "Jestřebice",
    "psc": "27723",
    "okres": "Mělník",
    "obec": "Dobřeň",
    "val": "27723 Dobren Jestrebice"
  },
  {
    "cast": "Jestřebice",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Jestrebice"
  },
  {
    "cast": "Jestřebice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Jestrebice"
  },
  {
    "cast": "Ješetice (část)",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Ješetice",
    "val": "25786 Jesetice Jesetice (cast)"
  },
  {
    "cast": "Ješetice (část)",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Ješetice",
    "val": "25789 Jesetice Jesetice (cast)"
  },
  {
    "cast": "Ješín",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Velvary",
    "val": "27324 Velvary Jesin"
  },
  {
    "cast": "Ješov",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Luká",
    "val": "78324 Luka Jesov"
  },
  {
    "cast": "Ješovice",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Liběchov",
    "val": "27721 Libechov Jesovice"
  },
  {
    "cast": "Ještětice",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Solnice",
    "val": "51601 Solnice Jestetice"
  },
  {
    "cast": "Jetenovice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Velký Bor",
    "val": "34101 Velky Bor Jetenovice"
  },
  {
    "cast": "Jetětice",
    "psc": "39848",
    "okres": "Písek",
    "obec": "Jetětice",
    "val": "39848 Jetetice Jetetice"
  },
  {
    "cast": "Jetišov",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Nihošovice",
    "val": "38719 Nihosovice Jetisov"
  },
  {
    "cast": "Jetonice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Míčov-Sušice",
    "val": "53803 Micov-Susice Jetonice"
  },
  {
    "cast": "Jetřichov",
    "psc": "54983",
    "okres": "Náchod",
    "obec": "Jetřichov",
    "val": "54983 Jetrichov Jetrichov"
  },
  {
    "cast": "Jetřichovec",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pacov",
    "val": "39501 Pacov Jetrichovec"
  },
  {
    "cast": "Jetřichovice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Jetrichovice"
  },
  {
    "cast": "Jetřichovice",
    "psc": "40716",
    "okres": "Děčín",
    "obec": "Jetřichovice",
    "val": "40716 Jetrichovice Jetrichovice"
  },
  {
    "cast": "Jevany (část)",
    "psc": "28166",
    "okres": "Praha-východ",
    "obec": "Jevany",
    "val": "28166 Jevany Jevany (cast)"
  },
  {
    "cast": "Jevany (část)",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Jevany",
    "val": "28163 Jevany Jevany (cast)"
  },
  {
    "cast": "Jevíčko",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Jevíčko",
    "val": "56943 Jevicko Jevicko"
  },
  {
    "cast": "Jeviněves",
    "psc": "27705",
    "okres": "Mělník",
    "obec": "Jeviněves",
    "val": "27705 Jevineves Jevineves"
  },
  {
    "cast": "Jevišovice",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Jevišovice",
    "val": "67153 Jevisovice Jevisovice"
  },
  {
    "cast": "Jevišovka",
    "psc": "69183",
    "okres": "Břeclav",
    "obec": "Jevišovka",
    "val": "69183 Jevisovka Jevisovka"
  },
  {
    "cast": "Jezbiny",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Jezbiny"
  },
  {
    "cast": "Jezbořice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Jezbořice",
    "val": "53002 Jezborice Jezborice"
  },
  {
    "cast": "Jezdkovice",
    "psc": "74755",
    "okres": "Opava",
    "obec": "Jezdkovice",
    "val": "74755 Jezdkovice Jezdkovice"
  },
  {
    "cast": "Jezdovice",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Jezdovice",
    "val": "58901 Jezdovice Jezdovice"
  },
  {
    "cast": "Jezerce",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Stříbro",
    "val": "34901 Stribro Jezerce"
  },
  {
    "cast": "Jezernice",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Jezernice",
    "val": "75131 Jezernice Jezernice"
  },
  {
    "cast": "Jezernice-Lipník nad Bečvou VIII x)",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Jezernice",
    "val": "75131 Jezernice Jezernice-Lipnik nad Becvou VIII x)"
  },
  {
    "cast": "Jezero",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Jezero"
  },
  {
    "cast": "Jezeřany-Maršovice",
    "psc": "67175",
    "okres": "Znojmo",
    "obec": "Jezeřany-Maršovice",
    "val": "67175 Jezerany-Marsovice Jezerany-Marsovice"
  },
  {
    "cast": "Jezeří",
    "psc": "43543",
    "okres": "Most",
    "obec": "Horní Jiřetín",
    "val": "43543 Horni Jiretin Jezeri"
  },
  {
    "cast": "Jezná",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Úlice",
    "val": "33033 Ulice Jezna"
  },
  {
    "cast": "Jeznice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Jeznice"
  },
  {
    "cast": "Jezvé",
    "psc": "47108",
    "okres": "Česká Lípa",
    "obec": "Stružnice",
    "val": "47108 Struznice Jezve"
  },
  {
    "cast": "Jezvina",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Vysoký Chlumec",
    "val": "26401 Vysoky Chlumec Jezvina"
  },
  {
    "cast": "Jezviny",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Jezviny"
  },
  {
    "cast": "Ježená",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Ježená",
    "val": "58841 Jezena Jezena"
  },
  {
    "cast": "Ježkovice",
    "psc": "68304",
    "okres": "Vyškov",
    "obec": "Ježkovice",
    "val": "68304 Jezkovice Jezkovice"
  },
  {
    "cast": "Ježkovice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Voděrady",
    "val": "51721 Voderady Jezkovice"
  },
  {
    "cast": "Ježov",
    "psc": "69648",
    "okres": "Hodonín",
    "obec": "Ježov",
    "val": "69648 Jezov Jezov"
  },
  {
    "cast": "Ježov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Ježov",
    "val": "39601 Jezov Jezov"
  },
  {
    "cast": "Ježovice",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Podveky",
    "val": "28506 Podveky Jezovice"
  },
  {
    "cast": "Ježovy",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Ježovy",
    "val": "34012 Jezovy Jezovy"
  },
  {
    "cast": "Jickovice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Jickovice",
    "val": "39901 Jickovice Jickovice"
  },
  {
    "cast": "Jičina",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74101 Stary Jicin Jicina"
  },
  {
    "cast": "Jičíněves",
    "psc": "50731",
    "okres": "Jičín",
    "obec": "Jičíněves",
    "val": "50731 Jicineves Jicineves"
  },
  {
    "cast": "Jičín-Dvorce x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Dvorce x)"
  },
  {
    "cast": "Jičín-Holínské Předměstí x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Holinske Predmesti x)"
  },
  {
    "cast": "Jičín-Moravčice x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Moravcice x)"
  },
  {
    "cast": "Jičín-Nové Město x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Nove Mesto x)"
  },
  {
    "cast": "Jičín-Popovice x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Popovice x)"
  },
  {
    "cast": "Jičín-Pražské Předměstí x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Prazske Predmesti x)"
  },
  {
    "cast": "Jičín-Robousy x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Robousy x)"
  },
  {
    "cast": "Jičín-Sedličky x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Sedlicky x)"
  },
  {
    "cast": "Jičín-Soudná x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Soudna x)"
  },
  {
    "cast": "Jičín-Staré Město x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Stare Mesto x)"
  },
  {
    "cast": "Jičín-Valdické Předměstí x)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Jicin-Valdicke Predmesti x)"
  },
  {
    "cast": "Jihlava",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Jihlava"
  },
  {
    "cast": "Jihlávka",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Jihlávka",
    "val": "58851 Jihlavka Jihlavka"
  },
  {
    "cast": "Jíkev",
    "psc": "28932",
    "okres": "Nymburk",
    "obec": "Jíkev",
    "val": "28932 Jikev Jikev"
  },
  {
    "cast": "Jilem",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Jilem",
    "val": "58301 Jilem Jilem"
  },
  {
    "cast": "Jilem (část)",
    "psc": "37856",
    "okres": "Jindřichův Hradec",
    "obec": "Jilem",
    "val": "37856 Jilem Jilem (cast)"
  },
  {
    "cast": "Jilem (část)",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Jilem",
    "val": "37853 Jilem Jilem (cast)"
  },
  {
    "cast": "Jilemnice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Jilemnice",
    "val": "51401 Jilemnice Jilemnice"
  },
  {
    "cast": "Jilemník",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Jilemnik"
  },
  {
    "cast": "Jilešovice",
    "psc": "74792",
    "okres": "Opava",
    "obec": "Háj ve Slezsku",
    "val": "74792 Haj ve Slezsku Jilesovice"
  },
  {
    "cast": "Jilmoví",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Pernštejnské Jestřabí",
    "val": "59261 Pernstejnske Jestrabi Jilmovi"
  },
  {
    "cast": "Jílové",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Hodkovice nad Mohelkou",
    "val": "46342 Hodkovice nad Mohelkou Jilove"
  },
  {
    "cast": "Jílové u Držkova",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Jílové u Držkova",
    "val": "46822 Jilove u Drzkova Jilove u Drzkova"
  },
  {
    "cast": "Jílové u Prahy",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Jílové u Prahy",
    "val": "25401 Jilove u Prahy Jilove u Prahy"
  },
  {
    "cast": "Jílové (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Jílové",
    "val": "40502 Jilove Jilove (cast)"
  },
  {
    "cast": "Jílové (část)",
    "psc": "40701",
    "okres": "Děčín",
    "obec": "Jílové",
    "val": "40701 Jilove Jilove (cast)"
  },
  {
    "cast": "Jílovec",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Jilovec"
  },
  {
    "cast": "Jílovice",
    "psc": "51772",
    "okres": "Hradec Králové",
    "obec": "Jílovice",
    "val": "51772 Jilovice Jilovice"
  },
  {
    "cast": "Jílovice",
    "psc": "37332",
    "okres": "České Budějovice",
    "obec": "Jílovice",
    "val": "37332 Jilovice Jilovice"
  },
  {
    "cast": "Jíloviště",
    "psc": "25202",
    "okres": "Praha-západ",
    "obec": "Jíloviště",
    "val": "25202 Jiloviste Jiloviste"
  },
  {
    "cast": "Jimlíkov",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Nová Role",
    "val": "36225 Nova Role Jimlikov"
  },
  {
    "cast": "Jimlín",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Jimlín",
    "val": "44001 Jimlin Jimlin"
  },
  {
    "cast": "Jimramov",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Jimramov",
    "val": "59242 Jimramov Jimramov"
  },
  {
    "cast": "Jimramovské Paseky",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Nový Jimramov",
    "val": "59203 Novy Jimramov Jimramovske Paseky"
  },
  {
    "cast": "Jimramovské Pavlovice",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Věcov",
    "val": "59242 Vecov Jimramovske Pavlovice"
  },
  {
    "cast": "Jinačovice",
    "psc": "66434",
    "okres": "Brno-venkov",
    "obec": "Jinačovice",
    "val": "66434 Jinacovice Jinacovice"
  },
  {
    "cast": "Jince",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Jince",
    "val": "26223 Jince Jince"
  },
  {
    "cast": "Jindice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Rašovice",
    "val": "28504 Rasovice Jindice"
  },
  {
    "cast": "Jindřichov",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35134 Cheb Jindrichov"
  },
  {
    "cast": "Jindřichov",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Jindřichov",
    "val": "75301 Jindrichov Jindrichov"
  },
  {
    "cast": "Jindřichov",
    "psc": "79383",
    "okres": "Bruntál",
    "obec": "Jindřichov",
    "val": "79383 Jindrichov Jindrichov"
  },
  {
    "cast": "Jindřichov",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Jindrichov"
  },
  {
    "cast": "Jindřichov",
    "psc": "78823",
    "okres": "Šumperk",
    "obec": "Jindřichov",
    "val": "78823 Jindrichov Jindrichov"
  },
  {
    "cast": "Jindřichov",
    "psc": "46602",
    "okres": "Jablonec nad Nisou",
    "obec": "Lučany nad Nisou",
    "val": "46602 Lucany nad Nisou Jindrichov"
  },
  {
    "cast": "Jindřichova Hora",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Klenčí pod Čerchovem",
    "val": "34401 Klenci pod Cerchovem Jindrichova Hora"
  },
  {
    "cast": "Jindřichova Ves",
    "psc": "43132",
    "okres": "Chomutov",
    "obec": "Kalek",
    "val": "43132 Kalek Jindrichova Ves"
  },
  {
    "cast": "Jindřichovice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Jindrichovice"
  },
  {
    "cast": "Jindřichovice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Jindrichovice"
  },
  {
    "cast": "Jindřichovice",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Jindřichovice",
    "val": "35801 Jindrichovice Jindrichovice"
  },
  {
    "cast": "Jindřichovice",
    "psc": "67526",
    "okres": "Jihlava",
    "obec": "Jindřichovice",
    "val": "67526 Jindrichovice Jindrichovice"
  },
  {
    "cast": "Jindřichovice pod Smrkem",
    "psc": "46365",
    "okres": "Liberec",
    "obec": "Jindřichovice pod Smrkem",
    "val": "46365 Jindrichovice pod Smrkem Jindrichovice pod Smrkem"
  },
  {
    "cast": "Jindřichův Hradec I",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Jindrichuv Hradec I"
  },
  {
    "cast": "Jindřichův Hradec II",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Jindrichuv Hradec II"
  },
  {
    "cast": "Jindřichův Hradec III",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Jindrichuv Hradec III"
  },
  {
    "cast": "Jindřichův Hradec IV",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Jindrichuv Hradec IV"
  },
  {
    "cast": "Jindřichův Hradec V",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Jindrichuv Hradec V"
  },
  {
    "cast": "Jindřiš",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Rodvínov",
    "val": "37701 Rodvinov Jindris"
  },
  {
    "cast": "Jindřišská",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Jirkov",
    "val": "43111 Jirkov Jindrisska"
  },
  {
    "cast": "Jinín",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Jinín",
    "val": "38601 Jinin Jinin"
  },
  {
    "cast": "Jíno",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Jino"
  },
  {
    "cast": "Jinočany",
    "psc": "25225",
    "okres": "Praha-západ",
    "obec": "Jinočany",
    "val": "25225 Jinocany Jinocany"
  },
  {
    "cast": "Jinolice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jinolice",
    "val": "50601 Jinolice Jinolice"
  },
  {
    "cast": "Jinonice (část)",
    "psc": "15200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15200 Praha Jinonice (cast)"
  },
  {
    "cast": "Jinonice (část)",
    "psc": "15800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15800 Praha Jinonice (cast)"
  },
  {
    "cast": "Jinonice (část)",
    "psc": "15500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15500 Praha Jinonice (cast)"
  },
  {
    "cast": "Jinošice",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Jinosice"
  },
  {
    "cast": "Jinošov",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Jinošov",
    "val": "67571 Jinosov Jinosov"
  },
  {
    "cast": "Jiratice",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Jiratice",
    "val": "67532 Jiratice Jiratice"
  },
  {
    "cast": "Jirkov",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Jirkov",
    "val": "43111 Jirkov Jirkov"
  },
  {
    "cast": "Jirkov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Jirkov"
  },
  {
    "cast": "Jirny",
    "psc": "25090",
    "okres": "Praha-východ",
    "obec": "Jirny",
    "val": "25090 Jirny Jirny"
  },
  {
    "cast": "Jírovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25601 Bystrice Jirovice"
  },
  {
    "cast": "Jirsko 1.díl",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Sezemice",
    "val": "29411 Sezemice Jirsko 1.dil"
  },
  {
    "cast": "Jirsko 2.díl",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Svijanský Újezd",
    "val": "46345 Svijansky Ujezd Jirsko 2.dil"
  },
  {
    "cast": "Jiřetice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Čepřovice",
    "val": "38701 Ceprovice Jiretice"
  },
  {
    "cast": "Jiřetice (část)",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25703 Neustupov Jiretice (cast)"
  },
  {
    "cast": "Jiřetice (část)",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Jiretice (cast)"
  },
  {
    "cast": "Jiřetín pod Bukovou",
    "psc": "46843",
    "okres": "Jablonec nad Nisou",
    "obec": "Jiřetín pod Bukovou",
    "val": "46843 Jiretin pod Bukovou Jiretin pod Bukovou"
  },
  {
    "cast": "Jiřetín pod Jedlovou",
    "psc": "40756",
    "okres": "Děčín",
    "obec": "Jiřetín pod Jedlovou",
    "val": "40756 Jiretin pod Jedlovou Jiretin pod Jedlovou"
  },
  {
    "cast": "Jiřice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Jiřice",
    "val": "39601 Jirice Jirice"
  },
  {
    "cast": "Jiřice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Řendějov",
    "val": "28522 Rendejov Jirice"
  },
  {
    "cast": "Jiřice",
    "psc": "27713",
    "okres": "Mělník",
    "obec": "Kostelec nad Labem",
    "val": "27713 Kostelec nad Labem Jirice"
  },
  {
    "cast": "Jiřice u Miroslavi",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Jiřice u Miroslavi",
    "val": "67178 Jirice u Miroslavi Jirice u Miroslavi"
  },
  {
    "cast": "Jiřice u Moravských Budějovic",
    "psc": "67154",
    "okres": "Znojmo",
    "obec": "Jiřice u Moravských Budějovic",
    "val": "67154 Jirice u Moravskych Budejovic Jirice u Moravskych Budejovic"
  },
  {
    "cast": "Jiřice (část)",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Jiřice",
    "val": "28802 Jirice Jirice (cast)"
  },
  {
    "cast": "Jiřice (část)",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Jiřice",
    "val": "28922 Jirice Jirice (cast)"
  },
  {
    "cast": "Jiříčkov",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Světlá pod Ještědem",
    "val": "46343 Svetla pod Jestedem Jirickov"
  },
  {
    "cast": "Jiřičky",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Křelovice",
    "val": "39601 Krelovice Jiricky"
  },
  {
    "cast": "Jiřičná",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Jiricna"
  },
  {
    "cast": "Jiříkov",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Jiříkov",
    "val": "79351 Jirikov Jirikov"
  },
  {
    "cast": "Jiříkov",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Dolní Újezd",
    "val": "57001 Dolni Ujezd Jirikov"
  },
  {
    "cast": "Jiříkov",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Kámen",
    "val": "58282 Kamen Jirikov"
  },
  {
    "cast": "Jiříkovec",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Jirikovec"
  },
  {
    "cast": "Jiříkovice",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Jirikovice"
  },
  {
    "cast": "Jiříkovice (část)",
    "psc": "66405",
    "okres": "Brno-venkov",
    "obec": "Jiříkovice",
    "val": "66405 Jirikovice Jirikovice (cast)"
  },
  {
    "cast": "Jiříkovice (část)",
    "psc": "66451",
    "okres": "Brno-venkov",
    "obec": "Jiříkovice",
    "val": "66451 Jirikovice Jirikovice (cast)"
  },
  {
    "cast": "Jiřín",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Jirin"
  },
  {
    "cast": "Jiřín",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Vyskytná nad Jihlavou",
    "val": "58841 Vyskytna nad Jihlavou Jirin"
  },
  {
    "cast": "Jistebnice",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Jistebnice"
  },
  {
    "cast": "Jistebník",
    "psc": "74282",
    "okres": "Nový Jičín",
    "obec": "Jistebník",
    "val": "74282 Jistebnik Jistebnik"
  },
  {
    "cast": "Jistebsko",
    "psc": "46821",
    "okres": "Jablonec nad Nisou",
    "obec": "Pěnčín",
    "val": "46821 Pencin Jistebsko"
  },
  {
    "cast": "Jistec",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Vráž",
    "val": "39701 Vraz Jistec"
  },
  {
    "cast": "Jištěrpy",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Chotiněves",
    "val": "41145 Chotineves Jisterpy"
  },
  {
    "cast": "Jiterní Ves",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Jílovice",
    "val": "37312 Jilovice Jiterni Ves"
  },
  {
    "cast": "Jitkov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Jitkov",
    "val": "58301 Jitkov Jitkov"
  },
  {
    "cast": "Jítrava",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Rynoltice",
    "val": "46353 Rynoltice Jitrava"
  },
  {
    "cast": "Jivany",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libuň",
    "val": "50601 Libun Jivany"
  },
  {
    "cast": "Jíví",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Jivi"
  },
  {
    "cast": "Jivina",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Vlastibořice",
    "val": "46344 Vlastiborice Jivina"
  },
  {
    "cast": "Jivina",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Jivina",
    "val": "26762 Jivina Jivina"
  },
  {
    "cast": "Jivina",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Troskovice",
    "val": "51263 Troskovice Jivina"
  },
  {
    "cast": "Jivina",
    "psc": "29414",
    "okres": "Mladá Boleslav",
    "obec": "Jivina",
    "val": "29414 Jivina Jivina"
  },
  {
    "cast": "Jivjany",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Velký Malahov",
    "val": "34601 Velky Malahov Jivjany"
  },
  {
    "cast": "Jívka (část)",
    "psc": "54213",
    "okres": "Trutnov",
    "obec": "Jívka",
    "val": "54213 Jivka Jivka (cast)"
  },
  {
    "cast": "Jívka (část)",
    "psc": "54234",
    "okres": "Trutnov",
    "obec": "Jívka",
    "val": "54234 Jivka Jivka (cast)"
  },
  {
    "cast": "Jivno",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Jivno",
    "val": "37371 Jivno Jivno"
  },
  {
    "cast": "Jívová",
    "psc": "78316",
    "okres": "Olomouc",
    "obec": "Jívová",
    "val": "78316 Jivova Jivova"
  },
  {
    "cast": "Jívoví",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Jívoví",
    "val": "59451 Jivovi Jivovi"
  },
  {
    "cast": "Jizbice",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Jizbice"
  },
  {
    "cast": "Jizbice",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Jizbice",
    "val": "28802 Jizbice Jizbice"
  },
  {
    "cast": "Jizerka",
    "psc": "46850",
    "okres": "Jablonec nad Nisou",
    "obec": "Kořenov",
    "val": "46850 Korenov Jizerka"
  },
  {
    "cast": "Jizerní Vtelno",
    "psc": "29431",
    "okres": "Mladá Boleslav",
    "obec": "Jizerní Vtelno",
    "val": "29431 Jizerni Vtelno Jizerni Vtelno"
  },
  {
    "cast": "Jižná",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Pluhův Žďár",
    "val": "37821 Pluhuv Zdar Jizna"
  },
  {
    "cast": "Jižní Předměstí (část)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Jizni Predmesti (cast)"
  },
  {
    "cast": "Jižní Předměstí (část)",
    "psc": "32100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32100 Plzen Jizni Predmesti (cast)"
  },
  {
    "cast": "Jobova Lhota",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Kněževes",
    "val": "67974 Knezeves Jobova Lhota"
  },
  {
    "cast": "Johanka",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Kamenice nad Lipou",
    "val": "39470 Kamenice nad Lipou Johanka"
  },
  {
    "cast": "Josefodol",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Josefodol"
  },
  {
    "cast": "Josefov",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Josefov",
    "val": "35709 Josefov Josefov"
  },
  {
    "cast": "Josefov",
    "psc": "69621",
    "okres": "Hodonín",
    "obec": "Josefov",
    "val": "69621 Josefov Josefov"
  },
  {
    "cast": "Josefov",
    "psc": "11000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "11000 Praha Josefov"
  },
  {
    "cast": "Josefov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Rožná",
    "val": "59301 Rozna Josefov"
  },
  {
    "cast": "Josefov (část)",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Josefov (cast)"
  },
  {
    "cast": "Josefov (část)",
    "psc": "55102",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55102 Jaromer Josefov (cast)"
  },
  {
    "cast": "Josefovice",
    "psc": "74764",
    "okres": "Opava",
    "obec": "Hrabyně",
    "val": "74764 Hrabyne Josefovice"
  },
  {
    "cast": "Josefovice",
    "psc": "74283",
    "okres": "Ostrava-město",
    "obec": "Klimkovice",
    "val": "74283 Klimkovice Josefovice"
  },
  {
    "cast": "Josefův Důl",
    "psc": "29307",
    "okres": "Mladá Boleslav",
    "obec": "Josefův Důl",
    "val": "29307 Josefuv Dul Josefuv Dul"
  },
  {
    "cast": "Josefův Důl",
    "psc": "46844",
    "okres": "Jablonec nad Nisou",
    "obec": "Josefův Důl",
    "val": "46844 Josefuv Dul Josefuv Dul"
  },
  {
    "cast": "Julčín",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Julcin"
  },
  {
    "cast": "Juliovka",
    "psc": "47157",
    "okres": "Česká Lípa",
    "obec": "Krompach",
    "val": "47157 Krompach Juliovka"
  },
  {
    "cast": "Jundrov",
    "psc": "63700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63700 Brno Jundrov"
  },
  {
    "cast": "Juřinka",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Valašské Meziříčí",
    "val": "75701 Valasske Mezirici Jurinka"
  },
  {
    "cast": "Kabáty",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Jílové u Prahy",
    "val": "25401 Jilove u Prahy Kabaty"
  },
  {
    "cast": "Kacákova Lhota",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Kacákova Lhota",
    "val": "50601 Kacakova Lhota Kacakova Lhota"
  },
  {
    "cast": "Kacanovy",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Kacanovy",
    "val": "51101 Kacanovy Kacanovy"
  },
  {
    "cast": "Kaceřov",
    "psc": "33151",
    "okres": "Plzeň-sever",
    "obec": "Kaceřov",
    "val": "33151 Kacerov Kacerov"
  },
  {
    "cast": "Kaceřov",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kaceřov",
    "val": "35751 Kacerov Kacerov"
  },
  {
    "cast": "Káciň",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Dolní Hbity",
    "val": "26263 Dolni Hbity Kacin"
  },
  {
    "cast": "Kácov (část)",
    "psc": "28509",
    "okres": "Kutná Hora",
    "obec": "Kácov",
    "val": "28509 Kacov Kacov (cast)"
  },
  {
    "cast": "Kácov (část)",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Kácov",
    "val": "28522 Kacov Kacov (cast)"
  },
  {
    "cast": "Kácova Lhota",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Kozmice",
    "val": "25601 Kozmice Kacova Lhota"
  },
  {
    "cast": "Kácovec",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Tichonice",
    "val": "25763 Tichonice Kacovec"
  },
  {
    "cast": "Kácovská Lhota",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Tichonice",
    "val": "25763 Tichonice Kacovska Lhota"
  },
  {
    "cast": "Kačerov",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Loket",
    "val": "25765 Loket Kacerov"
  },
  {
    "cast": "Kačice",
    "psc": "27304",
    "okres": "Kladno",
    "obec": "Kačice",
    "val": "27304 Kacice Kacice"
  },
  {
    "cast": "Kačlehy",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Kačlehy",
    "val": "37701 Kaclehy Kaclehy"
  },
  {
    "cast": "Kačov",
    "psc": "29474",
    "okres": "Mladá Boleslav",
    "obec": "Předměřice nad Jizerou",
    "val": "29474 Predmerice nad Jizerou Kacov"
  },
  {
    "cast": "Kadaň (část)",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Kadan (cast)"
  },
  {
    "cast": "Kadaň (část)",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43001 Kadan Kadan (cast)"
  },
  {
    "cast": "Kadaňská Jeseň",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Kadanska Jesen"
  },
  {
    "cast": "Kadaňský Rohozec",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43201 Radonice Kadansky Rohozec"
  },
  {
    "cast": "Kadeřavec",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Kaderavec"
  },
  {
    "cast": "Kadeřín",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Kaderin"
  },
  {
    "cast": "Kadešice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Žihobce",
    "val": "34201 Zihobce Kadesice"
  },
  {
    "cast": "Kadlín",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Kadlín",
    "val": "27735 Kadlin Kadlin"
  },
  {
    "cast": "Kadolec",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Kadolec",
    "val": "59451 Kadolec Kadolec"
  },
  {
    "cast": "Kadolec",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Slavonice",
    "val": "37881 Slavonice Kadolec"
  },
  {
    "cast": "Kadov",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Kadov",
    "val": "59203 Kadov Kadov"
  },
  {
    "cast": "Kadov",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Kadov",
    "val": "67201 Kadov Kadov"
  },
  {
    "cast": "Kadov",
    "psc": "38733",
    "okres": "Strakonice",
    "obec": "Kadov",
    "val": "38733 Kadov Kadov"
  },
  {
    "cast": "Kahlovice",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Kahlovice"
  },
  {
    "cast": "Kahov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Kahov"
  },
  {
    "cast": "Kajetín",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Choustník",
    "val": "39201 Choustnik Kajetin"
  },
  {
    "cast": "Kajlovec",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Hradec nad Moravicí",
    "val": "74741 Hradec nad Moravici Kajlovec"
  },
  {
    "cast": "Kájov",
    "psc": "38221",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38221 Kajov Kajov"
  },
  {
    "cast": "Kakejcov",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Kakejcov",
    "val": "33843 Kakejcov Kakejcov"
  },
  {
    "cast": "Kakovice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Kakovice"
  },
  {
    "cast": "Kakovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Předslavice",
    "val": "38701 Predslavice Kakovice"
  },
  {
    "cast": "Kal",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Pecka",
    "val": "50782 Pecka Kal"
  },
  {
    "cast": "Kal",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Kal"
  },
  {
    "cast": "Kala",
    "psc": "25228",
    "okres": "Praha-západ",
    "obec": "Třebotov",
    "val": "25228 Trebotov Kala"
  },
  {
    "cast": "Kalec",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Žihle",
    "val": "33165 Zihle Kalec"
  },
  {
    "cast": "Kalek",
    "psc": "43132",
    "okres": "Chomutov",
    "obec": "Kalek",
    "val": "43132 Kalek Kalek"
  },
  {
    "cast": "Kalenice (část)",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Kalenice",
    "val": "38716 Kalenice Kalenice (cast)"
  },
  {
    "cast": "Kalenice (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Kalenice",
    "val": "38601 Kalenice Kalenice (cast)"
  },
  {
    "cast": "Kalhov (část)",
    "psc": "58842",
    "okres": "Jihlava",
    "obec": "Kalhov",
    "val": "58842 Kalhov Kalhov (cast)"
  },
  {
    "cast": "Kalhov (část)",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Kalhov",
    "val": "58841 Kalhov Kalhov (cast)"
  },
  {
    "cast": "Kaliště",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Kaliste"
  },
  {
    "cast": "Kaliště",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Kaliste"
  },
  {
    "cast": "Kaliště",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Kaliště",
    "val": "58851 Kaliste Kaliste"
  },
  {
    "cast": "Kaliště",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Kaliste"
  },
  {
    "cast": "Kaliště",
    "psc": "25165",
    "okres": "Praha-východ",
    "obec": "Kaliště",
    "val": "25165 Kaliste Kaliste"
  },
  {
    "cast": "Kaliště",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Dolní Hbity",
    "val": "26263 Dolni Hbity Kaliste"
  },
  {
    "cast": "Kaliště",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Bohdalovice",
    "val": "38101 Bohdalovice Kaliste"
  },
  {
    "cast": "Kaliště",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Kaliste"
  },
  {
    "cast": "Kaliště u Lipí",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Lipí",
    "val": "37384 Lipi Kaliste u Lipi"
  },
  {
    "cast": "Kaliště (část)",
    "psc": "39451",
    "okres": "Pelhřimov",
    "obec": "Kaliště",
    "val": "39451 Kaliste Kaliste (cast)"
  },
  {
    "cast": "Kaliště (část)",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Kaliště",
    "val": "39601 Kaliste Kaliste (cast)"
  },
  {
    "cast": "Kalivody",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Kalivody",
    "val": "27054 Kalivody Kalivody"
  },
  {
    "cast": "Kalná",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Soutice",
    "val": "25763 Soutice Kalna"
  },
  {
    "cast": "Kalná Voda",
    "psc": "54223",
    "okres": "Trutnov",
    "obec": "Mladé Buky",
    "val": "54223 Mlade Buky Kalna Voda"
  },
  {
    "cast": "Kalovice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Kalovice"
  },
  {
    "cast": "Kalubice",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Velká Buková",
    "val": "27023 Velka Bukova Kalubice"
  },
  {
    "cast": "Kaly",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Kaly",
    "val": "59455 Kaly Kaly"
  },
  {
    "cast": "Kamberk",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Kamberk",
    "val": "25706 Kamberk Kamberk"
  },
  {
    "cast": "Kámen",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Křenice",
    "val": "34012 Krenice Kamen"
  },
  {
    "cast": "Kámen",
    "psc": "40713",
    "okres": "Děčín",
    "obec": "Kámen",
    "val": "40713 Kamen Kamen"
  },
  {
    "cast": "Kámen",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Kamen"
  },
  {
    "cast": "Kámen",
    "psc": "39413",
    "okres": "Pelhřimov",
    "obec": "Kámen",
    "val": "39413 Kamen Kamen"
  },
  {
    "cast": "Kámen",
    "psc": "58242",
    "okres": "Havlíčkův Brod",
    "obec": "Kámen",
    "val": "58242 Kamen Kamen"
  },
  {
    "cast": "Kamenec",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Jílové",
    "val": "40502 Jilove Kamenec"
  },
  {
    "cast": "Kamenec",
    "psc": "74774",
    "okres": "Opava",
    "obec": "Holasovice",
    "val": "74774 Holasovice Kamenec"
  },
  {
    "cast": "Kamenec",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Holice",
    "val": "53401 Holice Kamenec"
  },
  {
    "cast": "Kamenec",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Kamenec",
    "val": "33828 Kamenec Kamenec"
  },
  {
    "cast": "Kamenec",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Kamenec"
  },
  {
    "cast": "Kamenec u Poličky",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Kamenec u Poličky",
    "val": "57201 Kamenec u Policky Kamenec u Policky"
  },
  {
    "cast": "Kamení",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Pěnčín",
    "val": "46344 Pencin Kameni"
  },
  {
    "cast": "Kamenice",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Březová",
    "val": "35601 Brezova Kamenice"
  },
  {
    "cast": "Kamenice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Konecchlumí",
    "val": "50601 Konecchlumi Kamenice"
  },
  {
    "cast": "Kamenice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nedrahovice",
    "val": "26401 Nedrahovice Kamenice"
  },
  {
    "cast": "Kamenice",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Kamenice"
  },
  {
    "cast": "Kamenice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Zákupy",
    "val": "47002 Zakupy Kamenice"
  },
  {
    "cast": "Kamenice",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dobšín",
    "val": "29404 Dobsin Kamenice"
  },
  {
    "cast": "Kamenice",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobré",
    "val": "51801 Dobre Kamenice"
  },
  {
    "cast": "Kamenice",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Klučenice",
    "val": "26256 Klucenice Kamenice"
  },
  {
    "cast": "Kamenice",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Herálec",
    "val": "58255 Heralec Kamenice"
  },
  {
    "cast": "Kamenice nad Lipou",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Kamenice nad Lipou",
    "val": "39470 Kamenice nad Lipou Kamenice nad Lipou"
  },
  {
    "cast": "Kamenice (část)",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Kamenice",
    "val": "58822 Kamenice Kamenice (cast)"
  },
  {
    "cast": "Kamenice (část)",
    "psc": "67503",
    "okres": "Jihlava",
    "obec": "Kamenice",
    "val": "67503 Kamenice Kamenice (cast)"
  },
  {
    "cast": "Kamenice (část)",
    "psc": "58823",
    "okres": "Jihlava",
    "obec": "Kamenice",
    "val": "58823 Kamenice Kamenice (cast)"
  },
  {
    "cast": "Kamenická Nová Víska",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40502 Ceska Kamenice Kamenicka Nova Viska"
  },
  {
    "cast": "Kamenická Stráň",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Růžová",
    "val": "40502 Ruzova Kamenicka Stran"
  },
  {
    "cast": "Kamenický Šenov",
    "psc": "47114",
    "okres": "Česká Lípa",
    "obec": "Kamenický Šenov",
    "val": "47114 Kamenicky Senov Kamenicky Senov"
  },
  {
    "cast": "Kamenička",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Kamenice",
    "val": "58822 Kamenice Kamenicka"
  },
  {
    "cast": "Kamenička",
    "psc": "79069",
    "okres": "Jeseník",
    "obec": "Bílá Voda",
    "val": "79069 Bila Voda Kamenicka"
  },
  {
    "cast": "Kameničky (část)",
    "psc": "53941",
    "okres": "Chrudim",
    "obec": "Kameničky",
    "val": "53941 Kamenicky Kamenicky (cast)"
  },
  {
    "cast": "Kameničky (část)",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Trhová Kamenice",
    "val": "53825 Trhova Kamenice Kamenicky (cast)"
  },
  {
    "cast": "Kameničky (část)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Kameničky",
    "val": "53901 Kamenicky Kamenicky (cast)"
  },
  {
    "cast": "Kameničky (část)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Trhová Kamenice",
    "val": "53901 Trhova Kamenice Kamenicky (cast)"
  },
  {
    "cast": "Kameničná",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Kameničná",
    "val": "56401 Kamenicna Kamenicna"
  },
  {
    "cast": "Kamenka",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74235 Odry Kamenka"
  },
  {
    "cast": "Kamenná",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Krásná",
    "val": "35201 Krasna Kamenna"
  },
  {
    "cast": "Kamenná",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Milín",
    "val": "26231 Milin Kamenna"
  },
  {
    "cast": "Kamenná",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Kamenná",
    "val": "58813 Kamenna Kamenna"
  },
  {
    "cast": "Kamenná",
    "psc": "78974",
    "okres": "Šumperk",
    "obec": "Kamenná",
    "val": "78974 Kamenna Kamenna"
  },
  {
    "cast": "Kamenná",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Bohostice",
    "val": "26231 Bohostice Kamenna"
  },
  {
    "cast": "Kamenná",
    "psc": "40701",
    "okres": "Děčín",
    "obec": "Jílové",
    "val": "40701 Jilove Kamenna"
  },
  {
    "cast": "Kamenná",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Kamenná",
    "val": "67503 Kamenna Kamenna"
  },
  {
    "cast": "Kamenná",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Kamenná",
    "val": "37401 Kamenna Kamenna"
  },
  {
    "cast": "Kamenná Hora",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Kamenna Hora"
  },
  {
    "cast": "Kamenná Horka",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40747 Krasna Lipa Kamenna Horka"
  },
  {
    "cast": "Kamenná Horka",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Kamenná Horka",
    "val": "56802 Kamenna Horka Kamenna Horka"
  },
  {
    "cast": "Kamenná Lhota",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Kamenna Lhota"
  },
  {
    "cast": "Kamenná Lhota",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Popovice",
    "val": "25701 Popovice Kamenna Lhota"
  },
  {
    "cast": "Kamenná Lhota",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28522 Cestin Kamenna Lhota"
  },
  {
    "cast": "Kamenná Lhota",
    "psc": "58292",
    "okres": "Havlíčkův Brod",
    "obec": "Kamenná Lhota",
    "val": "58292 Kamenna Lhota Kamenna Lhota"
  },
  {
    "cast": "Kamenné",
    "psc": "43184",
    "okres": "Chomutov",
    "obec": "Měděnec",
    "val": "43184 Medenec Kamenne"
  },
  {
    "cast": "Kamenné Mosty",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Žleby",
    "val": "28601 Zleby Kamenne Mosty"
  },
  {
    "cast": "Kamenné Zboží",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Kamenné Zboží",
    "val": "28802 Kamenne Zbozi Kamenne Zbozi"
  },
  {
    "cast": "Kamenné Žehrovice",
    "psc": "27301",
    "okres": "Kladno",
    "obec": "Kamenné Žehrovice",
    "val": "27301 Kamenne Zehrovice Kamenne Zehrovice"
  },
  {
    "cast": "Kamenný Dvůr",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kynšperk nad Ohří",
    "val": "35751 Kynsperk nad Ohri Kamenny Dvur"
  },
  {
    "cast": "Kamenný Malíkov",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Kamenný Malíkov",
    "val": "37842 Kamenny Malikov Kamenny Malikov"
  },
  {
    "cast": "Kamenný Most",
    "psc": "27326",
    "okres": "Kladno",
    "obec": "Kamenný Most",
    "val": "27326 Kamenny Most Kamenny Most"
  },
  {
    "cast": "Kamenný Přívoz",
    "psc": "25282",
    "okres": "Praha-západ",
    "obec": "Kamenný Přívoz",
    "val": "25282 Kamenny Privoz Kamenny Privoz"
  },
  {
    "cast": "Kamenný Újezd",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Nýřany",
    "val": "33023 Nyrany Kamenny Ujezd"
  },
  {
    "cast": "Kamenný Újezd",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Kamenný Újezd",
    "val": "33701 Kamenny Ujezd Kamenny Ujezd"
  },
  {
    "cast": "Kamenný Újezd (část)",
    "psc": "37381",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37381 Kamenny Ujezd Kamenny Ujezd (cast)"
  },
  {
    "cast": "Kamenný Újezd (část)",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Kamenny Ujezd (cast)"
  },
  {
    "cast": "Kamenný Újezdec (část)",
    "psc": "25282",
    "okres": "Praha-západ",
    "obec": "Kamenný Přívoz",
    "val": "25282 Kamenny Privoz Kamenny Ujezdec (cast)"
  },
  {
    "cast": "Kamenný Újezdec (část)",
    "psc": "25741",
    "okres": "Praha-západ",
    "obec": "Kamenný Přívoz",
    "val": "25741 Kamenny Privoz Kamenny Ujezdec (cast)"
  },
  {
    "cast": "Kamhajek",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Křečhoř",
    "val": "28002 Krechor Kamhajek"
  },
  {
    "cast": "Kamilov",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Sloveč",
    "val": "28903 Slovec Kamilov"
  },
  {
    "cast": "Kamýk",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Kamyk"
  },
  {
    "cast": "Kamýk",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Kamyk"
  },
  {
    "cast": "Kamýk",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Kamýk",
    "val": "41201 Kamyk Kamyk"
  },
  {
    "cast": "Kamýk nad Vltavou",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Kamýk nad Vltavou",
    "val": "26263 Kamyk nad Vltavou Kamyk nad Vltavou"
  },
  {
    "cast": "Kamýk (část)",
    "psc": "14700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14700 Praha Kamyk (cast)"
  },
  {
    "cast": "Kamýk (část)",
    "psc": "14200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14200 Praha Kamyk (cast)"
  },
  {
    "cast": "Kamýk (část)",
    "psc": "14300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14300 Praha Kamyk (cast)"
  },
  {
    "cast": "Kanada",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Kanada"
  },
  {
    "cast": "Kandia",
    "psc": "79857",
    "okres": "Prostějov",
    "obec": "Laškov",
    "val": "79857 Laskov Kandia"
  },
  {
    "cast": "Kanice",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Kanice",
    "val": "34543 Kanice Kanice"
  },
  {
    "cast": "Kanice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Petrovice",
    "val": "50315 Petrovice Kanice"
  },
  {
    "cast": "Kanice",
    "psc": "66401",
    "okres": "Brno-venkov",
    "obec": "Kanice",
    "val": "66401 Kanice Kanice"
  },
  {
    "cast": "Kaničky (část)",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Kaničky",
    "val": "34543 Kanicky Kanicky (cast)"
  },
  {
    "cast": "Kaničky (část)",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Kaničky",
    "val": "34561 Kanicky Kanicky (cast)"
  },
  {
    "cast": "Kanín",
    "psc": "28907",
    "okres": "Nymburk",
    "obec": "Opolany",
    "val": "28907 Opolany Kanin"
  },
  {
    "cast": "Kanina",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Kanina",
    "val": "27735 Kanina Kanina"
  },
  {
    "cast": "Kaňk",
    "psc": "28404",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28404 Kutna Hora Kank"
  },
  {
    "cast": "Kaňkov",
    "psc": "43401",
    "okres": "Most",
    "obec": "Braňany",
    "val": "43401 Branany Kankov"
  },
  {
    "cast": "Kaňovice",
    "psc": "76341",
    "okres": "Zlín",
    "obec": "Kaňovice",
    "val": "76341 Kanovice Kanovice"
  },
  {
    "cast": "Kaňovice (část)",
    "psc": "73936",
    "okres": "Frýdek-Místek",
    "obec": "Kaňovice",
    "val": "73936 Kanovice Kanovice (cast)"
  },
  {
    "cast": "Kaňovice (část)",
    "psc": "73601",
    "okres": "Frýdek-Místek",
    "obec": "Kaňovice",
    "val": "73601 Kanovice Kanovice (cast)"
  },
  {
    "cast": "Kanovsko",
    "psc": "75119",
    "okres": "Přerov",
    "obec": "Vlkoš",
    "val": "75119 Vlkos Kanovsko"
  },
  {
    "cast": "Kaple",
    "psc": "79841",
    "okres": "Prostějov",
    "obec": "Čelechovice na Hané",
    "val": "79841 Celechovice na Hane Kaple"
  },
  {
    "cast": "Kaplice",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Lenora",
    "val": "38451 Lenora Kaplice"
  },
  {
    "cast": "Kaplice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Kaplice"
  },
  {
    "cast": "Kaplice-nádraží",
    "psc": "38242",
    "okres": "Český Krumlov",
    "obec": "Střítež",
    "val": "38242 Stritez Kaplice-nadrazi"
  },
  {
    "cast": "Kaproun",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Kunžak",
    "val": "37833 Kunzak Kaproun"
  },
  {
    "cast": "Kapsova Lhota",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Radošovice",
    "val": "38601 Radosovice Kapsova Lhota"
  },
  {
    "cast": "Káranice",
    "psc": "50366",
    "okres": "Hradec Králové",
    "obec": "Káranice",
    "val": "50366 Karanice Karanice"
  },
  {
    "cast": "Káraný",
    "psc": "25075",
    "okres": "Praha-východ",
    "obec": "Káraný",
    "val": "25075 Karany Karany"
  },
  {
    "cast": "Karasín",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Karasin"
  },
  {
    "cast": "Karasova Lhota",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Karasova Lhota"
  },
  {
    "cast": "Kardašova Řečice",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Kardašova Řečice",
    "val": "37821 Kardasova Recice Kardasova Recice"
  },
  {
    "cast": "Kardavec",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Hluboš",
    "val": "26101 Hlubos Kardavec"
  },
  {
    "cast": "Karhule",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Pravonín",
    "val": "25708 Pravonin Karhule"
  },
  {
    "cast": "Karle",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Karle",
    "val": "56802 Karle Karle"
  },
  {
    "cast": "Karlík",
    "psc": "25229",
    "okres": "Praha-západ",
    "obec": "Karlík",
    "val": "25229 Karlik Karlik"
  },
  {
    "cast": "Karlín",
    "psc": "69614",
    "okres": "Hodonín",
    "obec": "Karlín",
    "val": "69614 Karlin Karlin"
  },
  {
    "cast": "Karlín",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Dolní Poustevna",
    "val": "40747 Dolni Poustevna Karlin"
  },
  {
    "cast": "Karlín (část)",
    "psc": "18000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18000 Praha Karlin (cast)"
  },
  {
    "cast": "Karlín (část)",
    "psc": "18600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18600 Praha Karlin (cast)"
  },
  {
    "cast": "Karlinky-Liberec XVIII (část) x)",
    "psc": "46008",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46008 Liberec Karlinky-Liberec XVIII (cast) x)"
  },
  {
    "cast": "Karlinky-Liberec XVIII (část) x)",
    "psc": "46010",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46010 Liberec Karlinky-Liberec XVIII (cast) x)"
  },
  {
    "cast": "Karlov",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Bohušov",
    "val": "79399 Bohusov Karlov"
  },
  {
    "cast": "Karlov",
    "psc": "50791",
    "okres": "Jičín",
    "obec": "Stará Paka",
    "val": "50791 Stara Paka Karlov"
  },
  {
    "cast": "Karlov",
    "psc": "78386",
    "okres": "Olomouc",
    "obec": "Paseka",
    "val": "78386 Paseka Karlov"
  },
  {
    "cast": "Karlov",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Smetanova Lhota",
    "val": "39804 Smetanova Lhota Karlov"
  },
  {
    "cast": "Karlov",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Karlov"
  },
  {
    "cast": "Karlov",
    "psc": "59221",
    "okres": "Žďár nad Sázavou",
    "obec": "Karlov",
    "val": "59221 Karlov Karlov"
  },
  {
    "cast": "Karlov",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Karlov"
  },
  {
    "cast": "Karlov",
    "psc": "46844",
    "okres": "Jablonec nad Nisou",
    "obec": "Josefův Důl",
    "val": "46844 Josefuv Dul Karlov"
  },
  {
    "cast": "Karlov pod Ještědem-Liberec XXXV x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Karlov pod Jestedem-Liberec XXXV x)"
  },
  {
    "cast": "Karlov pod Pradědem",
    "psc": "79336",
    "okres": "Bruntál",
    "obec": "Malá Morávka",
    "val": "79336 Mala Moravka Karlov pod Pradedem"
  },
  {
    "cast": "Karlov t. Doubrava",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Vidice",
    "val": "28401 Vidice Karlov t. Doubrava"
  },
  {
    "cast": "Karlova Huť",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Králův Dvůr",
    "val": "26701 Kraluv Dvur Karlova Hut"
  },
  {
    "cast": "Karlova Huť",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Karlova Hut"
  },
  {
    "cast": "Karlova Studánka",
    "psc": "79324",
    "okres": "Bruntál",
    "obec": "Karlova Studánka",
    "val": "79324 Karlova Studanka Karlova Studanka"
  },
  {
    "cast": "Karlova Ves",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Karlova Ves",
    "val": "27023 Karlova Ves Karlova Ves"
  },
  {
    "cast": "Karlovce",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Kejnice",
    "val": "34101 Kejnice Karlovce"
  },
  {
    "cast": "Karlovec",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Bruntál",
    "val": "79201 Bruntal Karlovec"
  },
  {
    "cast": "Karlovice",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Karlovice",
    "val": "76302 Karlovice Karlovice"
  },
  {
    "cast": "Karlovice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Karlovice",
    "val": "51101 Karlovice Karlovice"
  },
  {
    "cast": "Karlovice",
    "psc": "79323",
    "okres": "Bruntál",
    "obec": "Karlovice",
    "val": "79323 Karlovice Karlovice"
  },
  {
    "cast": "Karlovice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28504 Uzice Karlovice"
  },
  {
    "cast": "Karlovice",
    "psc": "76843",
    "okres": "Kroměříž",
    "obec": "Kostelec u Holešova",
    "val": "76843 Kostelec u Holesova Karlovice"
  },
  {
    "cast": "Karlovka",
    "psc": "40729",
    "okres": "Děčín",
    "obec": "Velká Bukovina",
    "val": "40729 Velka Bukovina Karlovka"
  },
  {
    "cast": "Karlovy Vary",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36001 Karlovy Vary Karlovy Vary"
  },
  {
    "cast": "Karlov-Nepomuk",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Dražíč",
    "val": "37501 Drazic Karlov-Nepomuk"
  },
  {
    "cast": "Karlštejn",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Karlštejn",
    "val": "26718 Karlstejn Karlstejn"
  },
  {
    "cast": "Karlštejn",
    "psc": "53942",
    "okres": "Chrudim",
    "obec": "Svratouch",
    "val": "53942 Svratouch Karlstejn"
  },
  {
    "cast": "Karolín",
    "psc": "76821",
    "okres": "Kroměříž",
    "obec": "Karolín",
    "val": "76821 Karolin Karolin"
  },
  {
    "cast": "Karolín",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Rájec-Jestřebí",
    "val": "67902 Rajec-Jestrebi Karolin"
  },
  {
    "cast": "Karolinka",
    "psc": "75605",
    "okres": "Vsetín",
    "obec": "Karolinka",
    "val": "75605 Karolinka Karolinka"
  },
  {
    "cast": "Karpentná",
    "psc": "73994",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73994 Trinec Karpentna"
  },
  {
    "cast": "Karviná-Doly x)",
    "psc": "73506",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73506 Karvina Karvina-Doly x)"
  },
  {
    "cast": "Karviná-Fryštát x)",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Karvina-Frystat x)"
  },
  {
    "cast": "Karviná-Hranice x)",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Karvina-Hranice x)"
  },
  {
    "cast": "Karviná-Lázně Darkov x)",
    "psc": "73503",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73503 Karvina Karvina-Lazne Darkov x)"
  },
  {
    "cast": "Karviná-Louky x)",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Karvina-Louky x)"
  },
  {
    "cast": "Karviná-Mizerov (část) x)",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Karvina-Mizerov (cast) x)"
  },
  {
    "cast": "Karviná-Mizerov (část) x)",
    "psc": "73401",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73401 Karvina Karvina-Mizerov (cast) x)"
  },
  {
    "cast": "Karviná-Nové Město x)",
    "psc": "73506",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73506 Karvina Karvina-Nove Mesto x)"
  },
  {
    "cast": "Karviná-Ráj x)",
    "psc": "73401",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73401 Karvina Karvina-Raj x)"
  },
  {
    "cast": "Karviná-Staré Město x)",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Karvina-Stare Mesto x)"
  },
  {
    "cast": "Kařez",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Kařez",
    "val": "33808 Karez Karez"
  },
  {
    "cast": "Kařízek",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Kařízek",
    "val": "33808 Karizek Karizek"
  },
  {
    "cast": "Kasalice",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Kasalice",
    "val": "53341 Kasalice Kasalice"
  },
  {
    "cast": "Kasaličky",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Kasalice",
    "val": "53341 Kasalice Kasalicky"
  },
  {
    "cast": "Kasanice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28522 Cestin Kasanice"
  },
  {
    "cast": "Kasárna",
    "psc": "67151",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "67151 Znojmo Kasarna"
  },
  {
    "cast": "Kasejovice",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Kasejovice",
    "val": "33544 Kasejovice Kasejovice"
  },
  {
    "cast": "Kašava",
    "psc": "76319",
    "okres": "Zlín",
    "obec": "Kašava",
    "val": "76319 Kasava Kasava"
  },
  {
    "cast": "Kašenec",
    "psc": "67172",
    "okres": "Znojmo",
    "obec": "Miroslav",
    "val": "67172 Miroslav Kasenec"
  },
  {
    "cast": "Kašina Hora",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Záhoří",
    "val": "39701 Zahori Kasina Hora"
  },
  {
    "cast": "Kaškovice",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Kaskovice"
  },
  {
    "cast": "Kašnice",
    "psc": "69172",
    "okres": "Břeclav",
    "obec": "Kašnice",
    "val": "69172 Kasnice Kasnice"
  },
  {
    "cast": "Kašov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Kuks",
    "val": "54401 Kuks Kasov"
  },
  {
    "cast": "Kašovice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hrádek",
    "val": "34201 Hradek Kasovice"
  },
  {
    "cast": "Kašovice",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25163 Strancice Kasovice"
  },
  {
    "cast": "Kášovice",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Řepeč",
    "val": "39161 Repec Kasovice"
  },
  {
    "cast": "Kašperské Hory",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Kasperske Hory"
  },
  {
    "cast": "Kaštice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Kastice"
  },
  {
    "cast": "Kateřina",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Skalná",
    "val": "35134 Skalna Katerina"
  },
  {
    "cast": "Kateřina",
    "psc": "40755",
    "okres": "Děčín",
    "obec": "Dolní Podluží",
    "val": "40755 Dolni Podluzi Katerina"
  },
  {
    "cast": "Kateřinice",
    "psc": "74258",
    "okres": "Nový Jičín",
    "obec": "Kateřinice",
    "val": "74258 Katerinice Katerinice"
  },
  {
    "cast": "Kateřinice",
    "psc": "75621",
    "okres": "Vsetín",
    "obec": "Kateřinice",
    "val": "75621 Katerinice Katerinice"
  },
  {
    "cast": "Kateřinky",
    "psc": "74705",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74705 Opava Katerinky"
  },
  {
    "cast": "Kateřinky",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Vyklantice",
    "val": "39501 Vyklantice Katerinky"
  },
  {
    "cast": "Kateřinky",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28401 Zbraslavice Katerinky"
  },
  {
    "cast": "Kateřinky-Liberec XVII x)",
    "psc": "46014",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46014 Liberec Katerinky-Liberec XVII x)"
  },
  {
    "cast": "Katov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Katov",
    "val": "39201 Katov Katov"
  },
  {
    "cast": "Katov",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Katov",
    "val": "59455 Katov Katov"
  },
  {
    "cast": "Katovice",
    "psc": "38711",
    "okres": "Strakonice",
    "obec": "Katovice",
    "val": "38711 Katovice Katovice"
  },
  {
    "cast": "Katovsko",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Bratronice",
    "val": "38601 Bratronice Katovsko"
  },
  {
    "cast": "Katusice",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Katusice",
    "val": "29425 Katusice Katusice"
  },
  {
    "cast": "Kavrlík",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Kavrlik"
  },
  {
    "cast": "Kaznějov",
    "psc": "33151",
    "okres": "Plzeň-sever",
    "obec": "Kaznějov",
    "val": "33151 Kaznejov Kaznejov"
  },
  {
    "cast": "Kbel",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kbel",
    "val": "28002 Kbel Kbel"
  },
  {
    "cast": "Kbel",
    "psc": "34012",
    "okres": "Plzeň-jih",
    "obec": "Kbel",
    "val": "34012 Kbel Kbel"
  },
  {
    "cast": "Kbel",
    "psc": "29471",
    "okres": "Mladá Boleslav",
    "obec": "Benátky nad Jizerou",
    "val": "29471 Benatky nad Jizerou Kbel"
  },
  {
    "cast": "Kbelany",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Kbelany",
    "val": "33023 Kbelany Kbelany"
  },
  {
    "cast": "Kbelnice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Kbelnice",
    "val": "50601 Kbelnice Kbelnice"
  },
  {
    "cast": "Kbelnice",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Letiny",
    "val": "33601 Letiny Kbelnice"
  },
  {
    "cast": "Kbelnice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Přešťovice",
    "val": "38601 Prestovice Kbelnice"
  },
  {
    "cast": "Kbely",
    "psc": "19700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19700 Praha Kbely"
  },
  {
    "cast": "Kbílek",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kbel",
    "val": "28002 Kbel Kbilek"
  },
  {
    "cast": "Kdanice",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Kdanice"
  },
  {
    "cast": "Kdousov",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Kdousov",
    "val": "67532 Kdousov Kdousov"
  },
  {
    "cast": "Kdyně",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Kdyne"
  },
  {
    "cast": "Keblany",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Slavče",
    "val": "37401 Slavce Keblany"
  },
  {
    "cast": "Keblice",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Keblice",
    "val": "41002 Keblice Keblice"
  },
  {
    "cast": "Keblov",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Keblov",
    "val": "25765 Keblov Keblov"
  },
  {
    "cast": "Kejnice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Kejnice",
    "val": "34101 Kejnice Kejnice"
  },
  {
    "cast": "Kejšovice",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Krsy",
    "val": "33038 Krsy Kejsovice"
  },
  {
    "cast": "Kejžlice",
    "psc": "39452",
    "okres": "Pelhřimov",
    "obec": "Kejžlice",
    "val": "39452 Kejzlice Kejzlice"
  },
  {
    "cast": "Kelč",
    "psc": "75643",
    "okres": "Vsetín",
    "obec": "Kelč",
    "val": "75643 Kelc Kelc"
  },
  {
    "cast": "Kelčany",
    "psc": "69649",
    "okres": "Hodonín",
    "obec": "Kelčany",
    "val": "69649 Kelcany Kelcany"
  },
  {
    "cast": "Kelčice",
    "psc": "79808",
    "okres": "Prostějov",
    "obec": "Vranovice-Kelčice",
    "val": "79808 Vranovice-Kelcice Kelcice"
  },
  {
    "cast": "Kelníky",
    "psc": "76307",
    "okres": "Zlín",
    "obec": "Kelníky",
    "val": "76307 Kelniky Kelniky"
  },
  {
    "cast": "Keply",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34142 Hartmanice Keply"
  },
  {
    "cast": "Kerhartice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40502 Ceska Kamenice Kerhartice"
  },
  {
    "cast": "Kerhartice",
    "psc": "56204",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56204 Usti nad Orlici Kerhartice"
  },
  {
    "cast": "Kestřany (část)",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Kestřany",
    "val": "39701 Kestrany Kestrany (cast)"
  },
  {
    "cast": "Kestřany (část)",
    "psc": "39821",
    "okres": "Písek",
    "obec": "Kestřany",
    "val": "39821 Kestrany Kestrany (cast)"
  },
  {
    "cast": "Keteň",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičíněves",
    "val": "50601 Jicineves Keten"
  },
  {
    "cast": "Ketkovice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Ketkovice",
    "val": "66491 Ketkovice Ketkovice"
  },
  {
    "cast": "Kfely",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Kfely"
  },
  {
    "cast": "Klabava",
    "psc": "33841",
    "okres": "Rokycany",
    "obec": "Klabava",
    "val": "33841 Klabava Klabava"
  },
  {
    "cast": "Kladenské Rovné",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38101 Kajov Kladenske Rovne"
  },
  {
    "cast": "Kladeruby",
    "psc": "75643",
    "okres": "Vsetín",
    "obec": "Kladeruby",
    "val": "75643 Kladeruby Kladeruby"
  },
  {
    "cast": "Kladěruby",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Nová Telib",
    "val": "29406 Nova Telib Kladeruby"
  },
  {
    "cast": "Kladeruby nad Oslavou",
    "psc": "67575",
    "okres": "Třebíč",
    "obec": "Kladeruby nad Oslavou",
    "val": "67575 Kladeruby nad Oslavou Kladeruby nad Oslavou"
  },
  {
    "cast": "Kladina",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Sezemice",
    "val": "53304 Sezemice Kladina"
  },
  {
    "cast": "Kladiny",
    "psc": "37324",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37324 Rimov Kladiny"
  },
  {
    "cast": "Kladky (část)",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Kladky",
    "val": "79852 Kladky Kladky (cast)"
  },
  {
    "cast": "Kladky (část)",
    "psc": "79854",
    "okres": "Prostějov",
    "obec": "Kladky",
    "val": "79854 Kladky Kladky (cast)"
  },
  {
    "cast": "Kladná Žilín",
    "psc": "76326",
    "okres": "Zlín",
    "obec": "Luhačovice",
    "val": "76326 Luhacovice Kladna Zilin"
  },
  {
    "cast": "Kladné",
    "psc": "38221",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38221 Kajov Kladne"
  },
  {
    "cast": "Kladníky",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Kladníky",
    "val": "75131 Kladniky Kladniky"
  },
  {
    "cast": "Kladno",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Kladno",
    "val": "53901 Kladno Kladno"
  },
  {
    "cast": "Kladno (část)",
    "psc": "27201",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27201 Kladno Kladno (cast)"
  },
  {
    "cast": "Kladno (část)",
    "psc": "27204",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27204 Kladno Kladno (cast)"
  },
  {
    "cast": "Kladoruby",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Kladoruby"
  },
  {
    "cast": "Kladrubce",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Kasejovice",
    "val": "33544 Kasejovice Kladrubce"
  },
  {
    "cast": "Kladruby",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Kladruby",
    "val": "25801 Kladruby Kladruby"
  },
  {
    "cast": "Kladruby",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Kladruby",
    "val": "33808 Kladruby Kladruby"
  },
  {
    "cast": "Kladruby",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Kladruby"
  },
  {
    "cast": "Kladruby",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Kladruby"
  },
  {
    "cast": "Kladruby",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Kladruby",
    "val": "41501 Kladruby Kladruby"
  },
  {
    "cast": "Kladruby",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Kladruby",
    "val": "38716 Kladruby Kladruby"
  },
  {
    "cast": "Kladruby",
    "psc": "34961",
    "okres": "Tachov",
    "obec": "Kladruby",
    "val": "34961 Kladruby Kladruby"
  },
  {
    "cast": "Kladruby",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Kladruby"
  },
  {
    "cast": "Kladruby",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Chlumec nad Cidlinou",
    "val": "50351 Chlumec nad Cidlinou Kladruby"
  },
  {
    "cast": "Kladruby nad Labem (část)",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Kladruby nad Labem",
    "val": "53501 Kladruby nad Labem Kladruby nad Labem (cast)"
  },
  {
    "cast": "Kladruby nad Labem (část)",
    "psc": "53314",
    "okres": "Pardubice",
    "obec": "Kladruby nad Labem",
    "val": "53314 Kladruby nad Labem Kladruby nad Labem (cast)"
  },
  {
    "cast": "Kladská",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mariánské Lázně",
    "val": "35301 Marianske Lazne Kladska"
  },
  {
    "cast": "Klamorna",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Klamorna"
  },
  {
    "cast": "Klamoš",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Klamoš",
    "val": "50351 Klamos Klamos"
  },
  {
    "cast": "Klanečná",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Klanecna"
  },
  {
    "cast": "Klánovice",
    "psc": "19014",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19014 Praha Klanovice"
  },
  {
    "cast": "Klapý",
    "psc": "41116",
    "okres": "Litoměřice",
    "obec": "Klapý",
    "val": "41116 Klapy Klapy"
  },
  {
    "cast": "Klášter",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Klaster"
  },
  {
    "cast": "Klášter",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Klášter",
    "val": "33501 Klaster Klaster"
  },
  {
    "cast": "Klášter",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Klaster"
  },
  {
    "cast": "Klášter Hradiště nad Jizerou",
    "psc": "29415",
    "okres": "Mladá Boleslav",
    "obec": "Klášter Hradiště nad Jizerou",
    "val": "29415 Klaster Hradiste nad Jizerou Klaster Hradiste nad Jizerou"
  },
  {
    "cast": "Klášter nad Dědinou",
    "psc": "51771",
    "okres": "Hradec Králové",
    "obec": "Ledce",
    "val": "51771 Ledce Klaster nad Dedinou"
  },
  {
    "cast": "Klášter (část)",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Klaster (cast)"
  },
  {
    "cast": "Klášter (část)",
    "psc": "58283",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58283 Vilemov Klaster (cast)"
  },
  {
    "cast": "Klášterec",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Klasterec"
  },
  {
    "cast": "Klášterec",
    "psc": "78962",
    "okres": "Šumperk",
    "obec": "Olšany",
    "val": "78962 Olsany Klasterec"
  },
  {
    "cast": "Klášterec nad Ohří",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Klasterec nad Ohri"
  },
  {
    "cast": "Klášterec nad Orlicí",
    "psc": "56182",
    "okres": "Ústí nad Orlicí",
    "obec": "Klášterec nad Orlicí",
    "val": "56182 Klasterec nad Orlici Klasterec nad Orlici"
  },
  {
    "cast": "Klášterecká Jeseň",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Klasterecka Jesen"
  },
  {
    "cast": "Klášterní Hradisko",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Klasterni Hradisko"
  },
  {
    "cast": "Klášterní Skalice",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Klášterní Skalice",
    "val": "28163 Klasterni Skalice Klasterni Skalice"
  },
  {
    "cast": "Klášterská Lhota",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Klášterská Lhota",
    "val": "54371 Klasterska Lhota Klasterska Lhota"
  },
  {
    "cast": "Klášterský Mlýn",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Klastersky Mlyn"
  },
  {
    "cast": "Klatovec",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Klatovec",
    "val": "58851 Klatovec Klatovec"
  },
  {
    "cast": "Klatovy I",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Klatovy I"
  },
  {
    "cast": "Klatovy II",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Klatovy II"
  },
  {
    "cast": "Klatovy III",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Klatovy III"
  },
  {
    "cast": "Klatovy IV",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Klatovy IV"
  },
  {
    "cast": "Klatovy V",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Klatovy V"
  },
  {
    "cast": "Klažary",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Kamenná",
    "val": "37401 Kamenna Klazary"
  },
  {
    "cast": "Klec",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Klec",
    "val": "37901 Klec Klec"
  },
  {
    "cast": "Klecánky",
    "psc": "25067",
    "okres": "Praha-východ",
    "obec": "Klecany",
    "val": "25067 Klecany Klecanky"
  },
  {
    "cast": "Klecany",
    "psc": "25067",
    "okres": "Praha-východ",
    "obec": "Klecany",
    "val": "25067 Klecany Klecany"
  },
  {
    "cast": "Klečaty",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Zálší",
    "val": "39181 Zalsi Klecaty"
  },
  {
    "cast": "Klečetné",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Oráčov",
    "val": "27033 Oracov Klecetne"
  },
  {
    "cast": "Klečůvka",
    "psc": "76311",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76311 Zlin Klecuvka"
  },
  {
    "cast": "Klementice",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Kamenná",
    "val": "67503 Kamenna Klementice"
  },
  {
    "cast": "Klenčí pod Čerchovem",
    "psc": "34534",
    "okres": "Domažlice",
    "obec": "Klenčí pod Čerchovem",
    "val": "34534 Klenci pod Cerchovem Klenci pod Cerchovem"
  },
  {
    "cast": "Kleneč",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Kleneč",
    "val": "41301 Klenec Klenec"
  },
  {
    "cast": "Klení",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Kleni"
  },
  {
    "cast": "Klenice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Stračov",
    "val": "50315 Stracov Klenice"
  },
  {
    "cast": "Klenov",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Pluhův Žďár",
    "val": "37821 Pluhuv Zdar Klenov"
  },
  {
    "cast": "Klenová",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Klenová",
    "val": "34021 Klenova Klenova"
  },
  {
    "cast": "Klenová",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Klenova"
  },
  {
    "cast": "Klenové",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Klenove"
  },
  {
    "cast": "Klenovice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Klenovice",
    "val": "39201 Klenovice Klenovice"
  },
  {
    "cast": "Klenovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Mičovice",
    "val": "38301 Micovice Klenovice"
  },
  {
    "cast": "Klenovice",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Milešov",
    "val": "26256 Milesov Klenovice"
  },
  {
    "cast": "Klenovice na Hané",
    "psc": "79823",
    "okres": "Prostějov",
    "obec": "Klenovice na Hané",
    "val": "79823 Klenovice na Hane Klenovice na Hane"
  },
  {
    "cast": "Klenovice (část)",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Všeruby",
    "val": "33038 Vseruby Klenovice (cast)"
  },
  {
    "cast": "Klenovice (část)",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Všeruby",
    "val": "33035 Vseruby Klenovice (cast)"
  },
  {
    "cast": "Klenovka",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Přelouč",
    "val": "53501 Prelouc Klenovka"
  },
  {
    "cast": "Klentnice",
    "psc": "69201",
    "okres": "Břeclav",
    "obec": "Klentnice",
    "val": "69201 Klentnice Klentnice"
  },
  {
    "cast": "Kleny",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Provodov-Šonov",
    "val": "55203 Provodov-Sonov Kleny"
  },
  {
    "cast": "Klepáčov",
    "psc": "78816",
    "okres": "Šumperk",
    "obec": "Sobotín",
    "val": "78816 Sobotin Klepacov"
  },
  {
    "cast": "Klepačov (část)",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Klepacov (cast)"
  },
  {
    "cast": "Klepačov (část)",
    "psc": "67903",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67903 Blansko Klepacov (cast)"
  },
  {
    "cast": "Klest",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Klest"
  },
  {
    "cast": "Klešice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Klešice",
    "val": "53803 Klesice Klesice"
  },
  {
    "cast": "Kleštěnice",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Komárov",
    "val": "26762 Komarov Klestenice"
  },
  {
    "cast": "Kletečná",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Kletecna"
  },
  {
    "cast": "Kletečná",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41002 Velemin Kletecna"
  },
  {
    "cast": "Kletice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Svojšice",
    "val": "26272 Svojsice Kletice"
  },
  {
    "cast": "Kletné",
    "psc": "74201",
    "okres": "Nový Jičín",
    "obec": "Suchdol nad Odrou",
    "val": "74201 Suchdol nad Odrou Kletne"
  },
  {
    "cast": "Klevetov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Klevetov"
  },
  {
    "cast": "Klíčany",
    "psc": "25069",
    "okres": "Praha-východ",
    "obec": "Klíčany",
    "val": "25069 Klicany Klicany"
  },
  {
    "cast": "Klíče",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Konojedy",
    "val": "28163 Konojedy Klice"
  },
  {
    "cast": "Kličín",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Čeradice",
    "val": "43801 Ceradice Klicin"
  },
  {
    "cast": "Klíčnov",
    "psc": "46802",
    "okres": "Jablonec nad Nisou",
    "obec": "Pulečný",
    "val": "46802 Pulecny Klicnov"
  },
  {
    "cast": "Klíčov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Kočov",
    "val": "34815 Kocov Klicov"
  },
  {
    "cast": "Klikařov",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Neurazy",
    "val": "33501 Neurazy Klikarov"
  },
  {
    "cast": "Klikov",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Suchdol nad Lužnicí",
    "val": "37806 Suchdol nad Luznici Klikov"
  },
  {
    "cast": "Klimentov",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Velká Hleďsebe",
    "val": "35301 Velka Hledsebe Klimentov"
  },
  {
    "cast": "Klimětice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Prosenická Lhota",
    "val": "26401 Prosenicka Lhota Klimetice"
  },
  {
    "cast": "Klimkovice (část)",
    "psc": "74283",
    "okres": "Ostrava-město",
    "obec": "Klimkovice",
    "val": "74283 Klimkovice Klimkovice (cast)"
  },
  {
    "cast": "Klimkovice (část)",
    "psc": "74285",
    "okres": "Ostrava-město",
    "obec": "Klimkovice",
    "val": "74285 Klimkovice Klimkovice (cast)"
  },
  {
    "cast": "Klínec",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Klínec",
    "val": "25210 Klinec Klinec"
  },
  {
    "cast": "Klínovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Chrášťovice",
    "val": "38601 Chrastovice Klinovice"
  },
  {
    "cast": "Klíny",
    "psc": "43601",
    "okres": "Most",
    "obec": "Klíny",
    "val": "43601 Kliny Kliny"
  },
  {
    "cast": "Klipec",
    "psc": "28941",
    "okres": "Kolín",
    "obec": "Pňov-Předhradí",
    "val": "28941 Pnov-Predhradi Klipec"
  },
  {
    "cast": "Klisín",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Milevsko",
    "val": "39901 Milevsko Klisin"
  },
  {
    "cast": "Klisinec",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Hrazany",
    "val": "39901 Hrazany Klisinec"
  },
  {
    "cast": "Klíše",
    "psc": "40001",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40001 Usti nad Labem Klise"
  },
  {
    "cast": "Kloboučky",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Bučovice",
    "val": "68501 Bucovice Kloboucky"
  },
  {
    "cast": "Klobouky u Brna",
    "psc": "69172",
    "okres": "Břeclav",
    "obec": "Klobouky u Brna",
    "val": "69172 Klobouky u Brna Klobouky u Brna"
  },
  {
    "cast": "Klobuky",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Klobuky",
    "val": "27374 Klobuky Klobuky"
  },
  {
    "cast": "Klokoč",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41201 Libesice Klokoc"
  },
  {
    "cast": "Klokočí",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Klokočí",
    "val": "51101 Klokoci Klokoci"
  },
  {
    "cast": "Klokočí",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Klokočí",
    "val": "75361 Klokoci Klokoci"
  },
  {
    "cast": "Klokočí",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Olší",
    "val": "59261 Olsi Klokoci"
  },
  {
    "cast": "Klokočka",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Klokocka"
  },
  {
    "cast": "Klokočná",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25722 Vranov Klokocna"
  },
  {
    "cast": "Klokočná",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Klokočná",
    "val": "25164 Klokocna Klokocna"
  },
  {
    "cast": "Klokočov",
    "psc": "74747",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74747 Vitkov Klokocov"
  },
  {
    "cast": "Klokočov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Vlksice",
    "val": "39901 Vlksice Klokocov"
  },
  {
    "cast": "Klokočov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Klokočov",
    "val": "58301 Klokocov Klokocov"
  },
  {
    "cast": "Klokočovská Lhotka",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Klokočov",
    "val": "58301 Klokocov Klokocovska Lhotka"
  },
  {
    "cast": "Klokočůvek",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74235 Odry Klokocuvek"
  },
  {
    "cast": "Klokoty (část)",
    "psc": "39001",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39001 Tabor Klokoty (cast)"
  },
  {
    "cast": "Klokoty (část)",
    "psc": "39003",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39003 Tabor Klokoty (cast)"
  },
  {
    "cast": "Klopina",
    "psc": "78973",
    "okres": "Šumperk",
    "obec": "Klopina",
    "val": "78973 Klopina Klopina"
  },
  {
    "cast": "Klopotovice",
    "psc": "79821",
    "okres": "Prostějov",
    "obec": "Klopotovice",
    "val": "79821 Klopotovice Klopotovice"
  },
  {
    "cast": "Kloub",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Pohorovice",
    "val": "38901 Pohorovice Kloub"
  },
  {
    "cast": "Kloušov",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Merklín",
    "val": "33452 Merklin Klousov"
  },
  {
    "cast": "Klouzovy",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Klouzovy"
  },
  {
    "cast": "Kloužovice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Chýnov",
    "val": "39155 Chynov Klouzovice"
  },
  {
    "cast": "Klucké Chvalovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Zbýšov",
    "val": "28601 Zbysov Klucke Chvalovice"
  },
  {
    "cast": "Kluč",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Habartov",
    "val": "35709 Habartov Kluc"
  },
  {
    "cast": "Kluček",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Liběšice",
    "val": "43801 Libesice Klucek"
  },
  {
    "cast": "Klučenice",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Klučenice",
    "val": "26256 Klucenice Klucenice"
  },
  {
    "cast": "Klučno",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Dobřeň",
    "val": "27735 Dobren Klucno"
  },
  {
    "cast": "Klučov",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Klučov",
    "val": "28201 Klucov Klucov"
  },
  {
    "cast": "Klučov",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Klučov",
    "val": "67552 Klucov Klucov"
  },
  {
    "cast": "Kluk",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Kluk"
  },
  {
    "cast": "Kluk",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Kluk"
  },
  {
    "cast": "Kluky",
    "psc": "39819",
    "okres": "Písek",
    "obec": "Kluky",
    "val": "39819 Kluky Kluky"
  },
  {
    "cast": "Kluky",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Kluky",
    "val": "29426 Kluky Kluky"
  },
  {
    "cast": "Kluky",
    "psc": "28545",
    "okres": "Kutná Hora",
    "obec": "Kluky",
    "val": "28545 Kluky Kluky"
  },
  {
    "cast": "Kluzov",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Haňovice",
    "val": "78321 Hanovice Kluzov"
  },
  {
    "cast": "Klužínek",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Hvozd",
    "val": "79852 Hvozd Kluzinek"
  },
  {
    "cast": "Kly",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Kly",
    "val": "27741 Kly Kly"
  },
  {
    "cast": "Kmetiněves",
    "psc": "27322",
    "okres": "Kladno",
    "obec": "Kmetiněves",
    "val": "27322 Kmetineves Kmetineves"
  },
  {
    "cast": "Knapovec",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56201 Usti nad Orlici Knapovec"
  },
  {
    "cast": "Kněž",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28522 Cestin Knez"
  },
  {
    "cast": "Kněž",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Tis",
    "val": "58291 Tis Knez"
  },
  {
    "cast": "Kněždub",
    "psc": "69664",
    "okres": "Hodonín",
    "obec": "Kněždub",
    "val": "69664 Knezdub Knezdub"
  },
  {
    "cast": "Kněževes",
    "psc": "25268",
    "okres": "Praha-západ",
    "obec": "Kněževes",
    "val": "25268 Knezeves Knezeves"
  },
  {
    "cast": "Kněževes",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Kněževes",
    "val": "67974 Knezeves Knezeves"
  },
  {
    "cast": "Kněževes",
    "psc": "27001",
    "okres": "Rakovník",
    "obec": "Kněževes",
    "val": "27001 Knezeves Knezeves"
  },
  {
    "cast": "Kněževes",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Kněževes",
    "val": "59444 Knezeves Knezeves"
  },
  {
    "cast": "Kněževísko",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Knezevisko"
  },
  {
    "cast": "Kněžice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "43801 Podborany Knezice"
  },
  {
    "cast": "Kněžice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "33901 Strazov Knezice"
  },
  {
    "cast": "Kněžice",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Kněžice",
    "val": "53843 Knezice Knezice"
  },
  {
    "cast": "Kněžice",
    "psc": "67529",
    "okres": "Jihlava",
    "obec": "Kněžice",
    "val": "67529 Knezice Knezice"
  },
  {
    "cast": "Kněžice",
    "psc": "28902",
    "okres": "Nymburk",
    "obec": "Kněžice",
    "val": "28902 Knezice Knezice"
  },
  {
    "cast": "Kněžice",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Knezice"
  },
  {
    "cast": "Kněžičky",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Knezicky"
  },
  {
    "cast": "Kněžičky (část)",
    "psc": "28908",
    "okres": "Nymburk",
    "obec": "Kněžičky",
    "val": "28908 Knezicky Knezicky (cast)"
  },
  {
    "cast": "Kněžičky (část)",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Kněžičky",
    "val": "28903 Knezicky Knezicky (cast)"
  },
  {
    "cast": "Kněžmost",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Knezmost"
  },
  {
    "cast": "Kněžnice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Kněžnice",
    "val": "50601 Kneznice Kneznice"
  },
  {
    "cast": "Kněžpole",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Jiříkov",
    "val": "79351 Jirikov Knezpole"
  },
  {
    "cast": "Kněžpole",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Kněžpole",
    "val": "68712 Knezpole Knezpole"
  },
  {
    "cast": "Kněžská",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Šlapanov",
    "val": "58001 Slapanov Knezska"
  },
  {
    "cast": "Knihy",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Řenče",
    "val": "33401 Rence Knihy"
  },
  {
    "cast": "Knihy",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Knihy"
  },
  {
    "cast": "Kníje",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Úlice",
    "val": "33033 Ulice Knije"
  },
  {
    "cast": "Knín",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Knin"
  },
  {
    "cast": "Knínice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Knínice",
    "val": "58856 Kninice Kninice"
  },
  {
    "cast": "Knínice",
    "psc": "67934",
    "okres": "Blansko",
    "obec": "Knínice",
    "val": "67934 Kninice Kninice"
  },
  {
    "cast": "Knínice",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36452 Zlutice Kninice"
  },
  {
    "cast": "Knínice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Lovečkovice",
    "val": "41145 Loveckovice Kninice"
  },
  {
    "cast": "Knínice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Libouchec",
    "val": "40002 Libouchec Kninice"
  },
  {
    "cast": "Kníničky",
    "psc": "78344",
    "okres": "Olomouc",
    "obec": "Drahanovice",
    "val": "78344 Drahanovice Kninicky"
  },
  {
    "cast": "Kníničky (část)",
    "psc": "66434",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "66434 Brno Kninicky (cast)"
  },
  {
    "cast": "Kníničky (část)",
    "psc": "63500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63500 Brno Kninicky (cast)"
  },
  {
    "cast": "Knířov",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Knirov"
  },
  {
    "cast": "Knížata",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Těmice",
    "val": "39470 Temice Knizata"
  },
  {
    "cast": "Knížecí",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Velký Šenov",
    "val": "40747 Velky Senov Knizeci"
  },
  {
    "cast": "Knížecí Pláně",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Borová Lada",
    "val": "38501 Borova Lada Knizeci Plane"
  },
  {
    "cast": "Knížkovice",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Zdice",
    "val": "26751 Zdice Knizkovice"
  },
  {
    "cast": "Kňovice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kňovice",
    "val": "26401 Knovice Knovice"
  },
  {
    "cast": "Kňovičky",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kňovice",
    "val": "26401 Knovice Knovicky"
  },
  {
    "cast": "Knovíz",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Knovíz",
    "val": "27401 Knoviz Knoviz"
  },
  {
    "cast": "Knyk",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Knyk",
    "val": "58001 Knyk Knyk"
  },
  {
    "cast": "Koberno",
    "psc": "79397",
    "okres": "Bruntál",
    "obec": "Slezské Rudoltice",
    "val": "79397 Slezske Rudoltice Koberno"
  },
  {
    "cast": "Koberovice (část)",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Koberovice",
    "val": "39601 Koberovice Koberovice (cast)"
  },
  {
    "cast": "Koberovice (část)",
    "psc": "39459",
    "okres": "Pelhřimov",
    "obec": "Koberovice",
    "val": "39459 Koberovice Koberovice (cast)"
  },
  {
    "cast": "Koberovy",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Koberovy",
    "val": "46822 Koberovy Koberovy"
  },
  {
    "cast": "Kobeřice",
    "psc": "74727",
    "okres": "Opava",
    "obec": "Kobeřice",
    "val": "74727 Koberice Koberice"
  },
  {
    "cast": "Kobeřice",
    "psc": "79807",
    "okres": "Prostějov",
    "obec": "Hradčany-Kobeřice",
    "val": "79807 Hradcany-Koberice Koberice"
  },
  {
    "cast": "Kobeřice u Brna",
    "psc": "68401",
    "okres": "Vyškov",
    "obec": "Kobeřice u Brna",
    "val": "68401 Koberice u Brna Koberice u Brna"
  },
  {
    "cast": "Koblasko",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Zbizuby",
    "val": "28504 Zbizuby Koblasko"
  },
  {
    "cast": "Koblov",
    "psc": "71100",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71100 Ostrava Koblov"
  },
  {
    "cast": "Koburk",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Výprachtice",
    "val": "56301 Vyprachtice Koburk"
  },
  {
    "cast": "Kobylá nad Vidnavkou",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Kobylá nad Vidnavkou",
    "val": "79065 Kobyla nad Vidnavkou Kobyla nad Vidnavkou"
  },
  {
    "cast": "Kobylé",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Pšov",
    "val": "36452 Psov Kobyle"
  },
  {
    "cast": "Kobylí",
    "psc": "69110",
    "okres": "Břeclav",
    "obec": "Kobylí",
    "val": "69110 Kobyli Kobyli"
  },
  {
    "cast": "Kobylí a Plchov",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Kobyli a Plchov"
  },
  {
    "cast": "Kobylí Hlava",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Golčův Jeníkov",
    "val": "58282 Golcuv Jenikov Kobyli Hlava"
  },
  {
    "cast": "Kobylice",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Kobylice",
    "val": "50401 Kobylice Kobylice"
  },
  {
    "cast": "Kobylisy (část)",
    "psc": "18200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18200 Praha Kobylisy (cast)"
  },
  {
    "cast": "Kobylisy (část)",
    "psc": "18400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18400 Praha Kobylisy (cast)"
  },
  {
    "cast": "Kobylka",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Kobylka"
  },
  {
    "cast": "Kobylnice",
    "psc": "29446",
    "okres": "Mladá Boleslav",
    "obec": "Kobylnice",
    "val": "29446 Kobylnice Kobylnice"
  },
  {
    "cast": "Kobylnice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kobylnice",
    "val": "28401 Kobylnice Kobylnice"
  },
  {
    "cast": "Kobylnice",
    "psc": "66451",
    "okres": "Brno-venkov",
    "obec": "Kobylnice",
    "val": "66451 Kobylnice Kobylnice"
  },
  {
    "cast": "Kobylnice",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Koroužné",
    "val": "59301 Korouzne Kobylnice"
  },
  {
    "cast": "Kobylničky",
    "psc": "79804",
    "okres": "Prostějov",
    "obec": "Myslejovice",
    "val": "79804 Myslejovice Kobylnicky"
  },
  {
    "cast": "Kobylníky",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Kobylniky"
  },
  {
    "cast": "Kobylníky",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Klobuky",
    "val": "27374 Klobuky Kobylniky"
  },
  {
    "cast": "Kobyly",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Kobyly",
    "val": "46345 Kobyly Kobyly"
  },
  {
    "cast": "Kocanda",
    "psc": "33842",
    "okres": "Rokycany",
    "obec": "Kamenný Újezd",
    "val": "33842 Kamenny Ujezd Kocanda"
  },
  {
    "cast": "Kocanda",
    "psc": "59201",
    "okres": "Žďár nad Sázavou",
    "obec": "Herálec",
    "val": "59201 Heralec Kocanda"
  },
  {
    "cast": "Kocbeře",
    "psc": "54464",
    "okres": "Trutnov",
    "obec": "Kocbeře",
    "val": "54464 Kocbere Kocbere"
  },
  {
    "cast": "Kocelovice",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Kocelovice",
    "val": "38742 Kocelovice Kocelovice"
  },
  {
    "cast": "Kociánov",
    "psc": "78811",
    "okres": "Šumperk",
    "obec": "Loučná nad Desnou",
    "val": "78811 Loucna nad Desnou Kocianov"
  },
  {
    "cast": "Kocléřov",
    "psc": "54462",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54462 Vitezna Koclerov"
  },
  {
    "cast": "Koclířov",
    "psc": "56911",
    "okres": "Svitavy",
    "obec": "Koclířov",
    "val": "56911 Koclirov Koclirov"
  },
  {
    "cast": "Kocourov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Kocourov"
  },
  {
    "cast": "Kocourov",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41115 Trebenice Kocourov"
  },
  {
    "cast": "Kocourov",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46342 Bila Kocourov"
  },
  {
    "cast": "Kocourov",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Kocourov"
  },
  {
    "cast": "Kocourov",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58263 Slavikov Kocourov"
  },
  {
    "cast": "Kocourovec",
    "psc": "78356",
    "okres": "Olomouc",
    "obec": "Přáslavice",
    "val": "78356 Praslavice Kocourovec"
  },
  {
    "cast": "Kocourovy Lhotky",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Kocourovy Lhotky"
  },
  {
    "cast": "Kočí",
    "psc": "53861",
    "okres": "Chrudim",
    "obec": "Kočí",
    "val": "53861 Koci Koci"
  },
  {
    "cast": "Kočín",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kočín",
    "val": "33141 Kocin Kocin"
  },
  {
    "cast": "Kočín",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Kocin"
  },
  {
    "cast": "Kočov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Kočov",
    "val": "34815 Kocov Kocov"
  },
  {
    "cast": "Kočvary",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Lochovice",
    "val": "26751 Lochovice Kocvary"
  },
  {
    "cast": "Koda",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Tetín",
    "val": "26601 Tetin Koda"
  },
  {
    "cast": "Kohoutov",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Kohoutov"
  },
  {
    "cast": "Kohoutov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Kohoutov",
    "val": "54401 Kohoutov Kohoutov"
  },
  {
    "cast": "Kohoutov",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec nad Doubravou",
    "val": "58263 Zdirec nad Doubravou Kohoutov"
  },
  {
    "cast": "Kohoutovice",
    "psc": "62300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62300 Brno Kohoutovice"
  },
  {
    "cast": "Kohoutovice",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46342 Bila Kohoutovice"
  },
  {
    "cast": "Kochánky",
    "psc": "29474",
    "okres": "Mladá Boleslav",
    "obec": "Kochánky",
    "val": "29474 Kochanky Kochanky"
  },
  {
    "cast": "Kochánov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Kochanov"
  },
  {
    "cast": "Kochánov",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Kochánov",
    "val": "58253 Kochanov Kochanov"
  },
  {
    "cast": "Kochánov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Teplýšovice",
    "val": "25601 Teplysovice Kochanov"
  },
  {
    "cast": "Kochánov",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Stránecká Zhoř",
    "val": "59442 Stranecka Zhor Kochanov"
  },
  {
    "cast": "Kochánov",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Uhlířské Janovice",
    "val": "28504 Uhlirske Janovice Kochanov"
  },
  {
    "cast": "Kochánov",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Kochanov"
  },
  {
    "cast": "Kochánovice",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Slatiňany",
    "val": "53821 Slatinany Kochanovice"
  },
  {
    "cast": "Kochavec",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Rokytnice",
    "val": "76321 Rokytnice Kochavec"
  },
  {
    "cast": "Kochnov",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25901 Olbramovice Kochnov"
  },
  {
    "cast": "Kochov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Kochov"
  },
  {
    "cast": "Kochovice",
    "psc": "41172",
    "okres": "Litoměřice",
    "obec": "Hoštka",
    "val": "41172 Hostka Kochovice"
  },
  {
    "cast": "Kojákovice",
    "psc": "37901",
    "okres": "České Budějovice",
    "obec": "Jílovice",
    "val": "37901 Jilovice Kojakovice"
  },
  {
    "cast": "Kojatice (část)",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Kojatice",
    "val": "67532 Kojatice Kojatice (cast)"
  },
  {
    "cast": "Kojatice (část)",
    "psc": "67541",
    "okres": "Třebíč",
    "obec": "Kojatice",
    "val": "67541 Kojatice Kojatice (cast)"
  },
  {
    "cast": "Kojatín",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Kojatín",
    "val": "67503 Kojatin Kojatin"
  },
  {
    "cast": "Kojátky",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Kojátky",
    "val": "68501 Kojatky Kojatky"
  },
  {
    "cast": "Kojčice (část)",
    "psc": "39409",
    "okres": "Pelhřimov",
    "obec": "Kojčice",
    "val": "39409 Kojcice Kojcice (cast)"
  },
  {
    "cast": "Kojčice (část)",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Kojčice",
    "val": "39301 Kojcice Kojcice (cast)"
  },
  {
    "cast": "Koječín",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Čepřovice",
    "val": "38701 Ceprovice Kojecin"
  },
  {
    "cast": "Koječín",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Herálec",
    "val": "58255 Heralec Kojecin"
  },
  {
    "cast": "Kojetice",
    "psc": "25072",
    "okres": "Mělník",
    "obec": "Kojetice",
    "val": "25072 Kojetice Kojetice"
  },
  {
    "cast": "Kojetice",
    "psc": "67523",
    "okres": "Třebíč",
    "obec": "Kojetice",
    "val": "67523 Kojetice Kojetice"
  },
  {
    "cast": "Kojetice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40002 Usti nad Labem Kojetice"
  },
  {
    "cast": "Kojetín",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43201 Radonice Kojetin"
  },
  {
    "cast": "Kojetín",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Nový Jičín",
    "val": "74101 Novy Jicin Kojetin"
  },
  {
    "cast": "Kojetín",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Kojetín",
    "val": "58001 Kojetin Kojetin"
  },
  {
    "cast": "Kojetín III-Kovalovice",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Kojetín",
    "val": "75201 Kojetin Kojetin III-Kovalovice"
  },
  {
    "cast": "Kojetín II-Popůvky",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Kojetín",
    "val": "75201 Kojetin Kojetin II-Popuvky"
  },
  {
    "cast": "Kojetín I-Město",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Kojetín",
    "val": "75201 Kojetin Kojetin I-Mesto"
  },
  {
    "cast": "Kojetín (část)",
    "psc": "39901",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "39901 Petrovice Kojetin (cast)"
  },
  {
    "cast": "Kojetín (část)",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Kojetin (cast)"
  },
  {
    "cast": "Kojice",
    "psc": "53312",
    "okres": "Pardubice",
    "obec": "Kojice",
    "val": "53312 Kojice Kojice"
  },
  {
    "cast": "Kojkovice",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Kojkovice"
  },
  {
    "cast": "Kojkovičky",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58001 Krasna Hora Kojkovicky"
  },
  {
    "cast": "Kojovice",
    "psc": "29479",
    "okres": "Mladá Boleslav",
    "obec": "Kropáčova Vrutice",
    "val": "29479 Kropacova Vrutice Kojovice"
  },
  {
    "cast": "Kojšice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Kojsice"
  },
  {
    "cast": "Kojšovice",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Kojsovice"
  },
  {
    "cast": "Kokašice",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Kokašice",
    "val": "34952 Kokasice Kokasice"
  },
  {
    "cast": "Kokonín (část)",
    "psc": "46606",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46606 Jablonec nad Nisou Kokonin (cast)"
  },
  {
    "cast": "Kokonín (část)",
    "psc": "46801",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46801 Jablonec nad Nisou Kokonin (cast)"
  },
  {
    "cast": "Kokory",
    "psc": "75105",
    "okres": "Přerov",
    "obec": "Kokory",
    "val": "75105 Kokory Kokory"
  },
  {
    "cast": "Kokořín",
    "psc": "27723",
    "okres": "Mělník",
    "obec": "Kokořín",
    "val": "27723 Kokorin Kokorin"
  },
  {
    "cast": "Kokořínský Důl",
    "psc": "27723",
    "okres": "Mělník",
    "obec": "Kokořín",
    "val": "27723 Kokorin Kokorinsky Dul"
  },
  {
    "cast": "Kokořov",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Žinkovy",
    "val": "33501 Zinkovy Kokorov"
  },
  {
    "cast": "Kokořov",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Všeruby",
    "val": "33011 Vseruby Kokorov"
  },
  {
    "cast": "Kokovice",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Klobuky",
    "val": "27374 Klobuky Kokovice"
  },
  {
    "cast": "Kokšín",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Koksin"
  },
  {
    "cast": "Kolaje (část)",
    "psc": "28904",
    "okres": "Nymburk",
    "obec": "Kolaje",
    "val": "28904 Kolaje Kolaje (cast)"
  },
  {
    "cast": "Kolaje (část)",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Kolaje",
    "val": "28903 Kolaje Kolaje (cast)"
  },
  {
    "cast": "Koldín",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Koldín",
    "val": "56501 Koldin Koldin"
  },
  {
    "cast": "Koleč",
    "psc": "27329",
    "okres": "Kladno",
    "obec": "Koleč",
    "val": "27329 Kolec Kolec"
  },
  {
    "cast": "Kolence",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Novosedly nad Nežárkou",
    "val": "37901 Novosedly nad Nezarkou Kolence"
  },
  {
    "cast": "Kolesa",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Kladruby nad Labem",
    "val": "53501 Kladruby nad Labem Kolesa"
  },
  {
    "cast": "Kolešov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Pšov",
    "val": "36452 Psov Kolesov"
  },
  {
    "cast": "Kolešov",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Kolešov",
    "val": "27004 Kolesov Kolesov"
  },
  {
    "cast": "Kolešovice",
    "psc": "27002",
    "okres": "Rakovník",
    "obec": "Kolešovice",
    "val": "27002 Kolesovice Kolesovice"
  },
  {
    "cast": "Količín",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Holešov",
    "val": "76901 Holesov Kolicin"
  },
  {
    "cast": "Kolín I",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Kolin I"
  },
  {
    "cast": "Kolín II",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Kolin II"
  },
  {
    "cast": "Kolín III",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Kolin III"
  },
  {
    "cast": "Kolín IV",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Kolin IV"
  },
  {
    "cast": "Kolín V",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Kolin V"
  },
  {
    "cast": "Kolín VI",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Kolin VI"
  },
  {
    "cast": "Kolinec",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Kolinec"
  },
  {
    "cast": "Kolišov",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Kolisov"
  },
  {
    "cast": "Kolná",
    "psc": "74771",
    "okres": "Opava",
    "obec": "Brumovice",
    "val": "74771 Brumovice Kolna"
  },
  {
    "cast": "Kolné",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Stvolínky",
    "val": "47001 Stvolinky Kolne"
  },
  {
    "cast": "Kolnovice",
    "psc": "79084",
    "okres": "Jeseník",
    "obec": "Mikulovice",
    "val": "79084 Mikulovice Kolnovice"
  },
  {
    "cast": "Kolný",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Kolny"
  },
  {
    "cast": "Koloděje",
    "psc": "19016",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19016 Praha Kolodeje"
  },
  {
    "cast": "Koloděje nad Lužnicí",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Týn nad Vltavou",
    "val": "37501 Tyn nad Vltavou Kolodeje nad Luznici"
  },
  {
    "cast": "Kololeč",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41115 Trebenice Kololec"
  },
  {
    "cast": "Koloměřice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Chrášťany",
    "val": "37501 Chrastany Kolomerice"
  },
  {
    "cast": "Kolomuty",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Kolomuty",
    "val": "29301 Kolomuty Kolomuty"
  },
  {
    "cast": "Kolonie 5.května",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Broumov",
    "val": "55001 Broumov Kolonie 5.kvetna"
  },
  {
    "cast": "Kolová",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Kolová",
    "val": "36001 Kolova Kolova"
  },
  {
    "cast": "Koloveč",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Koloveč",
    "val": "34543 Kolovec Kolovec"
  },
  {
    "cast": "Kolovraty",
    "psc": "10300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10300 Praha Kolovraty"
  },
  {
    "cast": "Kolšov",
    "psc": "78821",
    "okres": "Šumperk",
    "obec": "Kolšov",
    "val": "78821 Kolsov Kolsov"
  },
  {
    "cast": "Komárno",
    "psc": "76871",
    "okres": "Kroměříž",
    "obec": "Komárno",
    "val": "76871 Komarno Komarno"
  },
  {
    "cast": "Komárov",
    "psc": "74770",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74770 Opava Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Brzice",
    "val": "55205 Brzice Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Komárov",
    "val": "39201 Komarov Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "76361",
    "okres": "Zlín",
    "obec": "Komárov",
    "val": "76361 Komarov Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Chuchelna",
    "val": "51301 Chuchelna Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Komárov",
    "val": "78501 Komarov Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Komárov",
    "val": "26762 Komarov Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Dolní Roveň",
    "val": "53002 Dolni Roven Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Nechanice",
    "val": "50315 Nechanice Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Kladruby nad Labem",
    "val": "53501 Kladruby nad Labem Komarov"
  },
  {
    "cast": "Komárov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Komarov"
  },
  {
    "cast": "Komárov (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Komarov (cast)"
  },
  {
    "cast": "Komárov (část)",
    "psc": "61700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61700 Brno Komarov (cast)"
  },
  {
    "cast": "Komárov (část)",
    "psc": "61800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61800 Brno Komarov (cast)"
  },
  {
    "cast": "Komárovice",
    "psc": "75643",
    "okres": "Vsetín",
    "obec": "Kelč",
    "val": "75643 Kelc Komarovice"
  },
  {
    "cast": "Komárovice",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Komárovice",
    "val": "67526 Komarovice Komarovice"
  },
  {
    "cast": "Komárovice",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58822 Brtnice Komarovice"
  },
  {
    "cast": "Komárovské Chaloupky",
    "psc": "74706",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74706 Opava Komarovske Chaloupky"
  },
  {
    "cast": "Komařice",
    "psc": "37314",
    "okres": "České Budějovice",
    "obec": "Komařice",
    "val": "37314 Komarice Komarice"
  },
  {
    "cast": "Komín (část)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Komin (cast)"
  },
  {
    "cast": "Komín (část)",
    "psc": "62400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62400 Brno Komin (cast)"
  },
  {
    "cast": "Komín (část)",
    "psc": "63500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63500 Brno Komin (cast)"
  },
  {
    "cast": "Komňa",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Komňa",
    "val": "68771 Komna Komna"
  },
  {
    "cast": "Komňátka",
    "psc": "78964",
    "okres": "Šumperk",
    "obec": "Bohdíkov",
    "val": "78964 Bohdikov Komnatka"
  },
  {
    "cast": "Komora",
    "psc": "79371",
    "okres": "Bruntál",
    "obec": "Holčovice",
    "val": "79371 Holcovice Komora"
  },
  {
    "cast": "Komorní Hrádek",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Chocerady",
    "val": "25724 Chocerady Komorni Hradek"
  },
  {
    "cast": "Komorní Lhotka",
    "psc": "73953",
    "okres": "Frýdek-Místek",
    "obec": "Komorní Lhotka",
    "val": "73953 Komorni Lhotka Komorni Lhotka"
  },
  {
    "cast": "Komorno",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Komorno"
  },
  {
    "cast": "Komorovice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Komorovice",
    "val": "39601 Komorovice Komorovice"
  },
  {
    "cast": "Komořany",
    "psc": "43401",
    "okres": "Most",
    "obec": "Most",
    "val": "43401 Most Komorany"
  },
  {
    "cast": "Komořany",
    "psc": "14300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14300 Praha Komorany"
  },
  {
    "cast": "Komořany",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Komořany",
    "val": "68301 Komorany Komorany"
  },
  {
    "cast": "Komošín",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Komosin"
  },
  {
    "cast": "Komušín",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Horažďovice",
    "val": "34101 Horazdovice Komusin"
  },
  {
    "cast": "Koňákov",
    "psc": "73562",
    "okres": "Karviná",
    "obec": "Český Těšín",
    "val": "73562 Cesky Tesin Konakov"
  },
  {
    "cast": "Konárovice (část)",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Konárovice",
    "val": "28002 Konarovice Konarovice (cast)"
  },
  {
    "cast": "Konárovice (část)",
    "psc": "28125",
    "okres": "Kolín",
    "obec": "Konárovice",
    "val": "28125 Konarovice Konarovice (cast)"
  },
  {
    "cast": "Končice",
    "psc": "28129",
    "okres": "Kolín",
    "obec": "Žiželice",
    "val": "28129 Zizelice Koncice"
  },
  {
    "cast": "Končiny",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Zábrodí",
    "val": "54941 Zabrodi Konciny"
  },
  {
    "cast": "Končiny",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Kunvald",
    "val": "56401 Kunvald Konciny"
  },
  {
    "cast": "Končiny",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Konciny"
  },
  {
    "cast": "Končiny 1.díl",
    "psc": "56553",
    "okres": "Svitavy",
    "obec": "Sloupnice",
    "val": "56553 Sloupnice Konciny 1.dil"
  },
  {
    "cast": "Končiny 2.díl",
    "psc": "56553",
    "okres": "Svitavy",
    "obec": "Sloupnice",
    "val": "56553 Sloupnice Konciny 2.dil"
  },
  {
    "cast": "Kondrac",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Kondrac",
    "val": "25801 Kondrac Kondrac"
  },
  {
    "cast": "Kondrač",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Kamenná",
    "val": "37401 Kamenna Kondrac"
  },
  {
    "cast": "Kondratice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Popovice",
    "val": "25703 Popovice Kondratice"
  },
  {
    "cast": "Konecchlumí",
    "psc": "50705",
    "okres": "Jičín",
    "obec": "Konecchlumí",
    "val": "50705 Konecchlumi Konecchlumi"
  },
  {
    "cast": "Koněprusy",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Koněprusy",
    "val": "26601 Koneprusy Koneprusy"
  },
  {
    "cast": "Koněšín",
    "psc": "67502",
    "okres": "Třebíč",
    "obec": "Koněšín",
    "val": "67502 Konesin Konesin"
  },
  {
    "cast": "Konětopy",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Milín",
    "val": "26231 Milin Konetopy"
  },
  {
    "cast": "Konětopy",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Pnětluky",
    "val": "44001 Pnetluky Konetopy"
  },
  {
    "cast": "Konětopy",
    "psc": "27714",
    "okres": "Praha-východ",
    "obec": "Konětopy",
    "val": "27714 Konetopy Konetopy"
  },
  {
    "cast": "Konice",
    "psc": "43156",
    "okres": "Chomutov",
    "obec": "Mašťov",
    "val": "43156 Mastov Konice"
  },
  {
    "cast": "Konice",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "66902 Znojmo Konice"
  },
  {
    "cast": "Konice",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Konice",
    "val": "79852 Konice Konice"
  },
  {
    "cast": "Koníkov",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Věcov",
    "val": "59242 Vecov Konikov"
  },
  {
    "cast": "Konín",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Konin"
  },
  {
    "cast": "Koňkovice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Trpišovice",
    "val": "58401 Trpisovice Konkovice"
  },
  {
    "cast": "Konojedy",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Konojedy"
  },
  {
    "cast": "Konojedy",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Konojedy",
    "val": "28163 Konojedy Konojedy"
  },
  {
    "cast": "Konopáč",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Heřmanův Městec",
    "val": "53803 Hermanuv Mestec Konopac"
  },
  {
    "cast": "Konopiště",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Konopiste"
  },
  {
    "cast": "Konopiště",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Lipovice",
    "val": "38422 Lipovice Konopiste"
  },
  {
    "cast": "Konrádov",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Blatce",
    "val": "47201 Blatce Konradov"
  },
  {
    "cast": "Konratice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Konratice"
  },
  {
    "cast": "Konská",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Konska"
  },
  {
    "cast": "Konstantinovy Lázně",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Konstantinovy Lázně",
    "val": "34952 Konstantinovy Lazne Konstantinovy Lazne"
  },
  {
    "cast": "Kopanina",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Nový Kostel",
    "val": "35134 Novy Kostel Kopanina"
  },
  {
    "cast": "Kopanina",
    "psc": "46802",
    "okres": "Jablonec nad Nisou",
    "obec": "Pulečný",
    "val": "46802 Pulecny Kopanina"
  },
  {
    "cast": "Kopaniny",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As Kopaniny"
  },
  {
    "cast": "Kopaniny",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Čáslavsko",
    "val": "39501 Caslavsko Kopaniny"
  },
  {
    "cast": "Kopaniny",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Chvalkovice",
    "val": "55204 Chvalkovice Kopaniny"
  },
  {
    "cast": "Kopec",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Prostiboř",
    "val": "34901 Prostibor Kopec"
  },
  {
    "cast": "Kopec",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Staré Křečany",
    "val": "40747 Stare Krecany Kopec"
  },
  {
    "cast": "Kopeč",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Úžice",
    "val": "27745 Uzice Kopec"
  },
  {
    "cast": "Kopeček",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Březno",
    "val": "43801 Brezno Kopecek"
  },
  {
    "cast": "Kopeček",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Kopecek"
  },
  {
    "cast": "Kopidlno",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Kopidlno",
    "val": "50732 Kopidlno Kopidlno"
  },
  {
    "cast": "Kopidlo",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kopidlo",
    "val": "33141 Kopidlo Kopidlo"
  },
  {
    "cast": "Koporeč",
    "psc": "43401",
    "okres": "Most",
    "obec": "Lišnice",
    "val": "43401 Lisnice Koporec"
  },
  {
    "cast": "Koprník",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Koprnik"
  },
  {
    "cast": "Kopřivná",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Kopřivná",
    "val": "78833 Koprivna Koprivna"
  },
  {
    "cast": "Kopřivnice",
    "psc": "74221",
    "okres": "Nový Jičín",
    "obec": "Kopřivnice",
    "val": "74221 Koprivnice Koprivnice"
  },
  {
    "cast": "Korbelova Lhota",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Velké Opatovice",
    "val": "67963 Velke Opatovice Korbelova Lhota"
  },
  {
    "cast": "Korce",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Korce"
  },
  {
    "cast": "Korkusova Huť",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Korkusova Hut"
  },
  {
    "cast": "Korkyně (část)",
    "psc": "26206",
    "okres": "Příbram",
    "obec": "Korkyně",
    "val": "26206 Korkyne Korkyne (cast)"
  },
  {
    "cast": "Korkyně (část)",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Korkyně",
    "val": "26203 Korkyne Korkyne (cast)"
  },
  {
    "cast": "Kornatice",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Kornatice",
    "val": "33843 Kornatice Kornatice"
  },
  {
    "cast": "Kornice",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Kornice"
  },
  {
    "cast": "Korno",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Korno",
    "val": "26727 Korno Korno"
  },
  {
    "cast": "Korolupy",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Korolupy",
    "val": "67107 Korolupy Korolupy"
  },
  {
    "cast": "Koroseky",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Vrábče",
    "val": "37001 Vrabce Koroseky"
  },
  {
    "cast": "Korotice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Úmonín",
    "val": "28601 Umonin Korotice"
  },
  {
    "cast": "Korouhev",
    "psc": "56993",
    "okres": "Svitavy",
    "obec": "Korouhev",
    "val": "56993 Korouhev Korouhev"
  },
  {
    "cast": "Korouhvice",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Chlum-Korouhvice",
    "val": "59265 Chlum-Korouhvice Korouhvice"
  },
  {
    "cast": "Koroužné",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Koroužné",
    "val": "59301 Korouzne Korouzne"
  },
  {
    "cast": "Korozluky",
    "psc": "43401",
    "okres": "Most",
    "obec": "Korozluky",
    "val": "43401 Korozluky Korozluky"
  },
  {
    "cast": "Koruna",
    "psc": "56301",
    "okres": "Svitavy",
    "obec": "Koruna",
    "val": "56301 Koruna Koruna"
  },
  {
    "cast": "Korunka",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Čermná nad Orlicí",
    "val": "51741 Cermna nad Orlici Korunka"
  },
  {
    "cast": "Korunní",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Korunni"
  },
  {
    "cast": "Korycany",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Neratovice",
    "val": "27745 Neratovice Korycany"
  },
  {
    "cast": "Koryčany",
    "psc": "76805",
    "okres": "Kroměříž",
    "obec": "Koryčany",
    "val": "76805 Korycany Korycany"
  },
  {
    "cast": "Koryta",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bezděkov",
    "val": "33901 Bezdekov Koryta"
  },
  {
    "cast": "Koryta",
    "psc": "33151",
    "okres": "Plzeň-sever",
    "obec": "Koryta",
    "val": "33151 Koryta Koryta"
  },
  {
    "cast": "Koryta",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Koryta",
    "val": "29411 Koryta Koryta"
  },
  {
    "cast": "Koryta",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kostelec nad Orlicí",
    "val": "51741 Kostelec nad Orlici Koryta"
  },
  {
    "cast": "Korýtka",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Pláně",
    "val": "33101 Plane Korytka"
  },
  {
    "cast": "Korýtko",
    "psc": "38501",
    "okres": "Klatovy",
    "obec": "Horská Kvilda",
    "val": "38501 Horska Kvilda Korytko"
  },
  {
    "cast": "Korytná",
    "psc": "68752",
    "okres": "Uherské Hradiště",
    "obec": "Korytná",
    "val": "68752 Korytna Korytna"
  },
  {
    "cast": "Koryto",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Zbytiny",
    "val": "38301 Zbytiny Koryto"
  },
  {
    "cast": "Kořen",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Olbramov",
    "val": "34953 Olbramov Koren"
  },
  {
    "cast": "Kořenec",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Kořenec",
    "val": "68001 Korenec Korenec"
  },
  {
    "cast": "Kořenice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kořenice",
    "val": "28002 Korenice Korenice"
  },
  {
    "cast": "Kořenný",
    "psc": "38443",
    "okres": "Prachatice",
    "obec": "Strážný",
    "val": "38443 Strazny Korenny"
  },
  {
    "cast": "Kořenov",
    "psc": "46849",
    "okres": "Jablonec nad Nisou",
    "obec": "Kořenov",
    "val": "46849 Korenov Korenov"
  },
  {
    "cast": "Kosice",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Kosice",
    "val": "50351 Kosice Kosice"
  },
  {
    "cast": "Kosičky",
    "psc": "50365",
    "okres": "Hradec Králové",
    "obec": "Kosičky",
    "val": "50365 Kosicky Kosicky"
  },
  {
    "cast": "Kosmáčov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Kosmacov"
  },
  {
    "cast": "Kosmo",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Šumavské Hoštice",
    "val": "38301 Sumavske Hostice Kosmo"
  },
  {
    "cast": "Kosmonosy",
    "psc": "29306",
    "okres": "Mladá Boleslav",
    "obec": "Kosmonosy",
    "val": "29306 Kosmonosy Kosmonosy"
  },
  {
    "cast": "Kosmová",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Kosmova"
  },
  {
    "cast": "Kosobody",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Jesenice",
    "val": "27033 Jesenice Kosobody"
  },
  {
    "cast": "Kosobudy",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Klučenice",
    "val": "26256 Klucenice Kosobudy"
  },
  {
    "cast": "Kosoř",
    "psc": "25226",
    "okres": "Praha-západ",
    "obec": "Kosoř",
    "val": "25226 Kosor Kosor"
  },
  {
    "cast": "Kosořice",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Kosořice",
    "val": "29441 Kosorice Kosorice"
  },
  {
    "cast": "Kosořín",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Kosořín",
    "val": "56501 Kosorin Kosorin"
  },
  {
    "cast": "Kosov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Kosov",
    "val": "78901 Kosov Kosov"
  },
  {
    "cast": "Kosov",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Kosov"
  },
  {
    "cast": "Kosov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Kosov"
  },
  {
    "cast": "Kosov",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Kosov"
  },
  {
    "cast": "Kosova Hora (část)",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26401 Kosova Hora Kosova Hora (cast)"
  },
  {
    "cast": "Kosova Hora (část)",
    "psc": "26291",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26291 Kosova Hora Kosova Hora (cast)"
  },
  {
    "cast": "Kosovy",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Úsobí",
    "val": "58253 Usobi Kosovy"
  },
  {
    "cast": "Kostelany",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kostelany",
    "val": "76701 Kostelany Kostelany"
  },
  {
    "cast": "Kostelany nad Moravou",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Kostelany nad Moravou",
    "val": "68601 Kostelany nad Moravou Kostelany nad Moravou"
  },
  {
    "cast": "Kostelec",
    "psc": "76314",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76314 Zlin Kostelec"
  },
  {
    "cast": "Kostelec",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Kostelec",
    "val": "50601 Kostelec Kostelec"
  },
  {
    "cast": "Kostelec",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kostelec",
    "val": "34901 Kostelec Kostelec"
  },
  {
    "cast": "Kostelec",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Kostelec"
  },
  {
    "cast": "Kostelec",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Hromnice",
    "val": "33011 Hromnice Kostelec"
  },
  {
    "cast": "Kostelec",
    "psc": "69651",
    "okres": "Hodonín",
    "obec": "Kostelec",
    "val": "69651 Kostelec Kostelec"
  },
  {
    "cast": "Kostelec",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Kostelec"
  },
  {
    "cast": "Kostelec na Hané",
    "psc": "79841",
    "okres": "Prostějov",
    "obec": "Kostelec na Hané",
    "val": "79841 Kostelec na Hane Kostelec na Hane"
  },
  {
    "cast": "Kostelec nad Černými lesy",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Kostelec nad Černými lesy",
    "val": "28163 Kostelec nad Cernymi lesy Kostelec nad Cernymi lesy"
  },
  {
    "cast": "Kostelec nad Labem",
    "psc": "27713",
    "okres": "Mělník",
    "obec": "Kostelec nad Labem",
    "val": "27713 Kostelec nad Labem Kostelec nad Labem"
  },
  {
    "cast": "Kostelec nad Ohří",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Budyně nad Ohří",
    "val": "41301 Budyne nad Ohri Kostelec nad Ohri"
  },
  {
    "cast": "Kostelec nad Orlicí",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kostelec nad Orlicí",
    "val": "51741 Kostelec nad Orlici Kostelec nad Orlici"
  },
  {
    "cast": "Kostelec nad Vltavou",
    "psc": "39858",
    "okres": "Písek",
    "obec": "Kostelec nad Vltavou",
    "val": "39858 Kostelec nad Vltavou Kostelec nad Vltavou"
  },
  {
    "cast": "Kostelec u Heřmanova Městce",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Kostelec u Heřmanova Městce",
    "val": "53803 Kostelec u Hermanova Mestce Kostelec u Hermanova Mestce"
  },
  {
    "cast": "Kostelec u Holešova",
    "psc": "76843",
    "okres": "Kroměříž",
    "obec": "Kostelec u Holešova",
    "val": "76843 Kostelec u Holesova Kostelec u Holesova"
  },
  {
    "cast": "Kostelec u Křížků",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kostelec u Křížků",
    "val": "25168 Kostelec u Krizku Kostelec u Krizku"
  },
  {
    "cast": "Kostelec (část)",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Kostelec",
    "val": "58851 Kostelec Kostelec (cast)"
  },
  {
    "cast": "Kostelec (část)",
    "psc": "58861",
    "okres": "Jihlava",
    "obec": "Kostelec",
    "val": "58861 Kostelec Kostelec (cast)"
  },
  {
    "cast": "Kostelecká Lhota",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kostelec nad Orlicí",
    "val": "51741 Kostelec nad Orlici Kostelecka Lhota"
  },
  {
    "cast": "Kostelecké Horky",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kostelecké Horky",
    "val": "51741 Kostelecke Horky Kostelecke Horky"
  },
  {
    "cast": "Kostelík",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Slabce",
    "val": "27041 Slabce Kostelik"
  },
  {
    "cast": "Kosteliště",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34401 Vseruby Kosteliste"
  },
  {
    "cast": "Kostelní",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Kostelni"
  },
  {
    "cast": "Kostelní Bříza",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Březová",
    "val": "35601 Brezova Kostelni Briza"
  },
  {
    "cast": "Kostelní Hlavno",
    "psc": "29476",
    "okres": "Praha-východ",
    "obec": "Kostelní Hlavno",
    "val": "29476 Kostelni Hlavno Kostelni Hlavno"
  },
  {
    "cast": "Kostelní Lhota",
    "psc": "28912",
    "okres": "Nymburk",
    "obec": "Kostelní Lhota",
    "val": "28912 Kostelni Lhota Kostelni Lhota"
  },
  {
    "cast": "Kostelní Myslová",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Kostelní Myslová",
    "val": "58856 Kostelni Myslova Kostelni Myslova"
  },
  {
    "cast": "Kostelní Radouň",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Kostelní Radouň",
    "val": "37842 Kostelni Radoun Kostelni Radoun"
  },
  {
    "cast": "Kostelní Střimelice",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Stříbrná Skalice",
    "val": "28163 Stribrna Skalice Kostelni Strimelice"
  },
  {
    "cast": "Kostelní Vydří",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Kostelní Vydří",
    "val": "38001 Kostelni Vydri Kostelni Vydri"
  },
  {
    "cast": "Kostěnice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Kostěnice",
    "val": "53002 Kostenice Kostenice"
  },
  {
    "cast": "Kostice",
    "psc": "69152",
    "okres": "Břeclav",
    "obec": "Kostice",
    "val": "69152 Kostice Kostice"
  },
  {
    "cast": "Kostníky",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Kostníky",
    "val": "67532 Kostniky Kostniky"
  },
  {
    "cast": "Kostomlátky",
    "psc": "28921",
    "okres": "Nymburk",
    "obec": "Kostomlátky",
    "val": "28921 Kostomlatky Kostomlatky"
  },
  {
    "cast": "Kostomlaty nad Labem",
    "psc": "28921",
    "okres": "Nymburk",
    "obec": "Kostomlaty nad Labem",
    "val": "28921 Kostomlaty nad Labem Kostomlaty nad Labem"
  },
  {
    "cast": "Kostomlaty pod Milešovkou",
    "psc": "41754",
    "okres": "Teplice",
    "obec": "Kostomlaty pod Milešovkou",
    "val": "41754 Kostomlaty pod Milesovkou Kostomlaty pod Milesovkou"
  },
  {
    "cast": "Kostomlaty pod Řípem",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Kostomlaty pod Řípem",
    "val": "41301 Kostomlaty pod Ripem Kostomlaty pod Ripem"
  },
  {
    "cast": "Kostrčany",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Valeč",
    "val": "36453 Valec Kostrcany"
  },
  {
    "cast": "Košařiska",
    "psc": "73981",
    "okres": "Frýdek-Místek",
    "obec": "Košařiska",
    "val": "73981 Kosariska Kosariska"
  },
  {
    "cast": "Košatka",
    "psc": "73923",
    "okres": "Ostrava-město",
    "obec": "Stará Ves nad Ondřejnicí",
    "val": "73923 Stara Ves nad Ondrejnici Kosatka"
  },
  {
    "cast": "Košátky",
    "psc": "29479",
    "okres": "Mladá Boleslav",
    "obec": "Košátky",
    "val": "29479 Kosatky Kosatky"
  },
  {
    "cast": "Košetice",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33035 Listany Kosetice"
  },
  {
    "cast": "Košetice",
    "psc": "74775",
    "okres": "Opava",
    "obec": "Velké Heraltice",
    "val": "74775 Velke Heraltice Kosetice"
  },
  {
    "cast": "Košetice (část)",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Košetice",
    "val": "39501 Kosetice Kosetice (cast)"
  },
  {
    "cast": "Košetice (část)",
    "psc": "39422",
    "okres": "Pelhřimov",
    "obec": "Košetice",
    "val": "39422 Kosetice Kosetice (cast)"
  },
  {
    "cast": "Košice",
    "psc": "39117",
    "okres": "Tábor",
    "obec": "Košice",
    "val": "39117 Kosice Kosice"
  },
  {
    "cast": "Košice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Košice",
    "val": "28504 Kosice Kosice"
  },
  {
    "cast": "Košík",
    "psc": "28935",
    "okres": "Nymburk",
    "obec": "Košík",
    "val": "28935 Kosik Kosik"
  },
  {
    "cast": "Košíkov",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Kosikov"
  },
  {
    "cast": "Košíky",
    "psc": "68704",
    "okres": "Uherské Hradiště",
    "obec": "Košíky",
    "val": "68704 Kosiky Kosiky"
  },
  {
    "cast": "Košín",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Košín",
    "val": "39137 Kosin Kosin"
  },
  {
    "cast": "Košinov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Studnice",
    "val": "53901 Studnice Kosinov"
  },
  {
    "cast": "Košíře (část)",
    "psc": "15000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15000 Praha Kosire (cast)"
  },
  {
    "cast": "Košíře (část)",
    "psc": "15800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15800 Praha Kosire (cast)"
  },
  {
    "cast": "Košov",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Kosov"
  },
  {
    "cast": "Košovice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Kosovice"
  },
  {
    "cast": "Košťálov (část)",
    "psc": "51202",
    "okres": "Semily",
    "obec": "Košťálov",
    "val": "51202 Kostalov Kostalov (cast)"
  },
  {
    "cast": "Košťálov (část)",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Košťálov",
    "val": "51251 Kostalov Kostalov (cast)"
  },
  {
    "cast": "Košťany",
    "psc": "41723",
    "okres": "Teplice",
    "obec": "Košťany",
    "val": "41723 Kostany Kostany"
  },
  {
    "cast": "Košťany",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Kostany"
  },
  {
    "cast": "Koštice",
    "psc": "43921",
    "okres": "Louny",
    "obec": "Koštice",
    "val": "43921 Kostice Kostice"
  },
  {
    "cast": "Koštov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Trmice",
    "val": "40002 Trmice Kostov"
  },
  {
    "cast": "Košumberk",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Kosumberk"
  },
  {
    "cast": "Kotaneč",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Kotanec"
  },
  {
    "cast": "Kotel",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Osečná",
    "val": "46352 Osecna Kotel"
  },
  {
    "cast": "Kotelice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Třebušín",
    "val": "41201 Trebusin Kotelice"
  },
  {
    "cast": "Kotelsko",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Veselá",
    "val": "51263 Vesela Kotelsko"
  },
  {
    "cast": "Kotenčice",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Kotenčice",
    "val": "26223 Kotencice Kotencice"
  },
  {
    "cast": "Koterov",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Koterov"
  },
  {
    "cast": "Kotlasy",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Kotlasy",
    "val": "59214 Kotlasy Kotlasy"
  },
  {
    "cast": "Kotlina",
    "psc": "43184",
    "okres": "Chomutov",
    "obec": "Měděnec",
    "val": "43184 Medenec Kotlina"
  },
  {
    "cast": "Kotojedy",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Kotojedy"
  },
  {
    "cast": "Kotopeky",
    "psc": "26801",
    "okres": "Beroun",
    "obec": "Kotopeky",
    "val": "26801 Kotopeky Kotopeky"
  },
  {
    "cast": "Kotoučov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Bohdaneč",
    "val": "28522 Bohdanec Kotoucov"
  },
  {
    "cast": "Kotouň",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Oselce",
    "val": "33501 Oselce Kotoun"
  },
  {
    "cast": "Kotousov",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Chocenice",
    "val": "33601 Chocenice Kotousov"
  },
  {
    "cast": "Kotovice",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Kotovice",
    "val": "33301 Kotovice Kotovice"
  },
  {
    "cast": "Kotvina",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Okounov",
    "val": "43151 Okounov Kotvina"
  },
  {
    "cast": "Kotvrdovice (část)",
    "psc": "67906",
    "okres": "Blansko",
    "obec": "Kotvrdovice",
    "val": "67906 Kotvrdovice Kotvrdovice (cast)"
  },
  {
    "cast": "Kotvrdovice (část)",
    "psc": "67907",
    "okres": "Blansko",
    "obec": "Kotvrdovice",
    "val": "67907 Kotvrdovice Kotvrdovice (cast)"
  },
  {
    "cast": "Kotýřina",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Kotyrina"
  },
  {
    "cast": "Koubalova Lhota",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Klučenice",
    "val": "26256 Klucenice Koubalova Lhota"
  },
  {
    "cast": "Koudelka",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Holice",
    "val": "53401 Holice Koudelka"
  },
  {
    "cast": "Koukolná",
    "psc": "73571",
    "okres": "Karviná",
    "obec": "Dětmarovice",
    "val": "73571 Detmarovice Koukolna"
  },
  {
    "cast": "Kounice",
    "psc": "28915",
    "okres": "Nymburk",
    "obec": "Kounice",
    "val": "28915 Kounice Kounice"
  },
  {
    "cast": "Kounice (část)",
    "psc": "25768",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "25768 Vlastejovice Kounice (cast)"
  },
  {
    "cast": "Kounice (část)",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "28522 Vlastejovice Kounice (cast)"
  },
  {
    "cast": "Kounov (část)",
    "psc": "27007",
    "okres": "Rakovník",
    "obec": "Kounov",
    "val": "27007 Kounov Kounov (cast)"
  },
  {
    "cast": "Kounov (část)",
    "psc": "27006",
    "okres": "Rakovník",
    "obec": "Kounov",
    "val": "27006 Kounov Kounov (cast)"
  },
  {
    "cast": "Kounov (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kounov",
    "val": "51801 Kounov Kounov (cast)"
  },
  {
    "cast": "Kounov (část)",
    "psc": "51792",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kounov",
    "val": "51792 Kounov Kounov (cast)"
  },
  {
    "cast": "Koupě",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Koupě",
    "val": "26272 Koupe Koupe"
  },
  {
    "cast": "Kouřim",
    "psc": "28161",
    "okres": "Kolín",
    "obec": "Kouřim",
    "val": "28161 Kourim Kourim"
  },
  {
    "cast": "Kout na Šumavě",
    "psc": "34502",
    "okres": "Domažlice",
    "obec": "Kout na Šumavě",
    "val": "34502 Kout na Sumave Kout na Sumave"
  },
  {
    "cast": "Kouty",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Kouty",
    "val": "29001 Kouty Kouty"
  },
  {
    "cast": "Kouty",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Smilkov",
    "val": "25789 Smilkov Kouty"
  },
  {
    "cast": "Kouty",
    "psc": "67508",
    "okres": "Třebíč",
    "obec": "Kouty",
    "val": "67508 Kouty Kouty"
  },
  {
    "cast": "Kouty",
    "psc": "74721",
    "okres": "Opava",
    "obec": "Kravaře",
    "val": "74721 Kravare Kouty"
  },
  {
    "cast": "Kouty",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Sukorady",
    "val": "50801 Sukorady Kouty"
  },
  {
    "cast": "Kouty",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Hlinsko",
    "val": "53901 Hlinsko Kouty"
  },
  {
    "cast": "Kouty",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kouty",
    "val": "58401 Kouty Kouty"
  },
  {
    "cast": "Kouty nad Desnou",
    "psc": "78811",
    "okres": "Šumperk",
    "obec": "Loučná nad Desnou",
    "val": "78811 Loucna nad Desnou Kouty nad Desnou"
  },
  {
    "cast": "Kovač",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Kovač",
    "val": "50601 Kovac Kovac"
  },
  {
    "cast": "Koválovice u Tištína",
    "psc": "79829",
    "okres": "Prostějov",
    "obec": "Koválovice-Osíčany",
    "val": "79829 Kovalovice-Osicany Kovalovice u Tistina"
  },
  {
    "cast": "Kovalovice (část)",
    "psc": "66406",
    "okres": "Brno-venkov",
    "obec": "Kovalovice",
    "val": "66406 Kovalovice Kovalovice (cast)"
  },
  {
    "cast": "Kovalovice (část)",
    "psc": "68301",
    "okres": "Brno-venkov",
    "obec": "Kovalovice",
    "val": "68301 Kovalovice Kovalovice (cast)"
  },
  {
    "cast": "Kovalovice-Kojetín III x)",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Kojetín",
    "val": "75201 Kojetin Kovalovice-Kojetin III x)"
  },
  {
    "cast": "Kováň (část)",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Kováň",
    "val": "29426 Kovan Kovan (cast)"
  },
  {
    "cast": "Kováň (část)",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Kováň",
    "val": "29425 Kovan Kovan (cast)"
  },
  {
    "cast": "Kovanec",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Kovanec",
    "val": "29426 Kovanec Kovanec"
  },
  {
    "cast": "Kovanice",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Kovanice",
    "val": "28802 Kovanice Kovanice"
  },
  {
    "cast": "Kovanín",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Zálezly",
    "val": "38481 Zalezly Kovanin"
  },
  {
    "cast": "Kovansko",
    "psc": "28931",
    "okres": "Nymburk",
    "obec": "Bobnice",
    "val": "28931 Bobnice Kovansko"
  },
  {
    "cast": "Kováry",
    "psc": "27328",
    "okres": "Kladno",
    "obec": "Zákolany",
    "val": "27328 Zakolany Kovary"
  },
  {
    "cast": "Kovářov",
    "psc": "39855",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39855 Kovarov Kovarov"
  },
  {
    "cast": "Kovářov",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Kovarov"
  },
  {
    "cast": "Kovářov",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Kovarov"
  },
  {
    "cast": "Kovářov",
    "psc": "75362",
    "okres": "Přerov",
    "obec": "Potštát",
    "val": "75362 Potstat Kovarov"
  },
  {
    "cast": "Kovářov",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Brloh",
    "val": "38203 Brloh Kovarov"
  },
  {
    "cast": "Kovářov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Čichalov",
    "val": "36452 Cichalov Kovarov"
  },
  {
    "cast": "Kovářov",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Frymburk",
    "val": "38226 Frymburk Kovarov"
  },
  {
    "cast": "Kovářová",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Ujčov",
    "val": "59262 Ujcov Kovarova"
  },
  {
    "cast": "Kovářovice",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Pyšely",
    "val": "25167 Pysely Kovarovice"
  },
  {
    "cast": "Kovářská",
    "psc": "43186",
    "okres": "Chomutov",
    "obec": "Kovářská",
    "val": "43186 Kovarska Kovarska"
  },
  {
    "cast": "Kovčín",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Kovčín",
    "val": "34101 Kovcin Kovcin"
  },
  {
    "cast": "Kozákov",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Radostná pod Kozákovem",
    "val": "51263 Radostna pod Kozakovem Kozakov"
  },
  {
    "cast": "Kozárov",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Kozárov",
    "val": "67971 Kozarov Kozarov"
  },
  {
    "cast": "Kozárovice",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Zálezlice",
    "val": "27745 Zalezlice Kozarovice"
  },
  {
    "cast": "Kozárovice (část)",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Kozárovice",
    "val": "26272 Kozarovice Kozarovice (cast)"
  },
  {
    "cast": "Kozárovice (část)",
    "psc": "26284",
    "okres": "Příbram",
    "obec": "Kozárovice",
    "val": "26284 Kozarovice Kozarovice (cast)"
  },
  {
    "cast": "Kozašice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Jankovice",
    "val": "53501 Jankovice Kozasice"
  },
  {
    "cast": "Kozí",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Běšiny",
    "val": "33901 Besiny Kozi"
  },
  {
    "cast": "Kozí Hory",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Nový Knín",
    "val": "26203 Novy Knin Kozi Hory"
  },
  {
    "cast": "Kozičín",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Kozicin"
  },
  {
    "cast": "Kozín",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Rataje",
    "val": "39165 Rataje Kozin"
  },
  {
    "cast": "Kozinec",
    "psc": "25265",
    "okres": "Praha-západ",
    "obec": "Holubice",
    "val": "25265 Holubice Kozinec"
  },
  {
    "cast": "Kozinec-Záhoří x)",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Kozinec-Zahori x)"
  },
  {
    "cast": "Kozlany",
    "psc": "67502",
    "okres": "Třebíč",
    "obec": "Kozlany",
    "val": "67502 Kozlany Kozlany"
  },
  {
    "cast": "Kozlany",
    "psc": "68341",
    "okres": "Vyškov",
    "obec": "Kozlany",
    "val": "68341 Kozlany Kozlany"
  },
  {
    "cast": "Kozlíky (část)",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Rtyně nad Bílinou",
    "val": "41501 Rtyne nad Bilinou Kozliky (cast)"
  },
  {
    "cast": "Kozlíky (část)",
    "psc": "41762",
    "okres": "Teplice",
    "obec": "Rtyně nad Bílinou",
    "val": "41762 Rtyne nad Bilinou Kozliky (cast)"
  },
  {
    "cast": "Kozlov",
    "psc": "78357",
    "okres": "Olomouc",
    "obec": "Kozlov",
    "val": "78357 Kozlov Kozlov"
  },
  {
    "cast": "Kozlov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50601 Mladejov Kozlov"
  },
  {
    "cast": "Kozlov",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Kozlov"
  },
  {
    "cast": "Kozlov",
    "psc": "58821",
    "okres": "Jihlava",
    "obec": "Kozlov",
    "val": "58821 Kozlov Kozlov"
  },
  {
    "cast": "Kozlov",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Kozlov",
    "val": "59451 Kozlov Kozlov"
  },
  {
    "cast": "Kozlov",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kozlov",
    "val": "58401 Kozlov Kozlov"
  },
  {
    "cast": "Kozlov",
    "psc": "38715",
    "okres": "Strakonice",
    "obec": "Střelské Hoštice",
    "val": "38715 Strelske Hostice Kozlov"
  },
  {
    "cast": "Kozlov",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Česká Třebová",
    "val": "56002 Ceska Trebova Kozlov"
  },
  {
    "cast": "Kozlov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Kozlov"
  },
  {
    "cast": "Kozlovice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Kozlovice",
    "val": "33501 Kozlovice Kozlovice"
  },
  {
    "cast": "Kozlovice",
    "psc": "73947",
    "okres": "Frýdek-Místek",
    "obec": "Kozlovice",
    "val": "73947 Kozlovice Kozlovice"
  },
  {
    "cast": "Kozlovice",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Záluží",
    "val": "41301 Zaluzi Kozlovice"
  },
  {
    "cast": "Kozlovice-Přerov IV x)",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Kozlovice-Prerov IV x)"
  },
  {
    "cast": "Kozly",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Kozly",
    "val": "44001 Kozly Kozly"
  },
  {
    "cast": "Kozly",
    "psc": "27715",
    "okres": "Mělník",
    "obec": "Tišice",
    "val": "27715 Tisice Kozly"
  },
  {
    "cast": "Kozly (část)",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Kozly",
    "val": "47001 Kozly Kozly (cast)"
  },
  {
    "cast": "Kozly (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Kozly",
    "val": "47002 Kozly Kozly (cast)"
  },
  {
    "cast": "Kozmice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Radenín",
    "val": "39155 Radenin Kozmice"
  },
  {
    "cast": "Kozmice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Kozmice",
    "val": "25601 Kozmice Kozmice"
  },
  {
    "cast": "Kozmice",
    "psc": "74711",
    "okres": "Opava",
    "obec": "Kozmice",
    "val": "74711 Kozmice Kozmice"
  },
  {
    "cast": "Kozmice",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Strážiště",
    "val": "29413 Straziste Kozmice"
  },
  {
    "cast": "Kozodírky",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Libáň",
    "val": "50723 Liban Kozodirky"
  },
  {
    "cast": "Kozodry",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kostelec nad Orlicí",
    "val": "51741 Kostelec nad Orlici Kozodry"
  },
  {
    "cast": "Kozohlody",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vlkaneč",
    "val": "28601 Vlkanec Kozohlody"
  },
  {
    "cast": "Kozojedy",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Lány",
    "val": "53701 Lany Kozojedy"
  },
  {
    "cast": "Kozojedy",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Kozojedy",
    "val": "27054 Kozojedy Kozojedy"
  },
  {
    "cast": "Kozojedy",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Kozojedy",
    "val": "50703 Kozojedy Kozojedy"
  },
  {
    "cast": "Kozojedy",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kozojedy",
    "val": "33141 Kozojedy Kozojedy"
  },
  {
    "cast": "Kozojedy",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Kozojedy",
    "val": "28163 Kozojedy Kozojedy"
  },
  {
    "cast": "Kozojídky",
    "psc": "69663",
    "okres": "Hodonín",
    "obec": "Kozojídky",
    "val": "69663 Kozojidky Kozojidky"
  },
  {
    "cast": "Kozojídky",
    "psc": "50703",
    "okres": "Hradec Králové",
    "obec": "Vinary",
    "val": "50703 Vinary Kozojidky"
  },
  {
    "cast": "Kozolupy",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Vysoký Újezd",
    "val": "26718 Vysoky Ujezd Kozolupy"
  },
  {
    "cast": "Kozolupy",
    "psc": "33032",
    "okres": "Plzeň-sever",
    "obec": "Kozolupy",
    "val": "33032 Kozolupy Kozolupy"
  },
  {
    "cast": "Kozomín",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Kozomín",
    "val": "27745 Kozomin Kozomin"
  },
  {
    "cast": "Kozov",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Kozov"
  },
  {
    "cast": "Kozovazy (část)",
    "psc": "25087",
    "okres": "Praha-východ",
    "obec": "Vyšehořovice",
    "val": "25087 Vysehorovice Kozovazy (cast)"
  },
  {
    "cast": "Kozovazy (část)",
    "psc": "25088",
    "okres": "Praha-východ",
    "obec": "Vyšehořovice",
    "val": "25088 Vysehorovice Kozovazy (cast)"
  },
  {
    "cast": "Kožichovice (část)",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Kožichovice",
    "val": "67401 Kozichovice Kozichovice (cast)"
  },
  {
    "cast": "Kožichovice (část)",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Kožichovice",
    "val": "67501 Kozichovice Kozichovice (cast)"
  },
  {
    "cast": "Kožlany",
    "psc": "33144",
    "okres": "Plzeň-sever",
    "obec": "Kožlany",
    "val": "33144 Kozlany Kozlany"
  },
  {
    "cast": "Kožlí",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Kožlí",
    "val": "39804 Kozli Kozli"
  },
  {
    "cast": "Kožlí",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Myštice",
    "val": "38801 Mystice Kozli"
  },
  {
    "cast": "Kožlí",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25601 Neveklov Kozli"
  },
  {
    "cast": "Kožlí u Čížové",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Kozli u Cizove"
  },
  {
    "cast": "Kožlí (část)",
    "psc": "58293",
    "okres": "Havlíčkův Brod",
    "obec": "Kožlí",
    "val": "58293 Kozli Kozli (cast)"
  },
  {
    "cast": "Kožlí (část)",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kožlí",
    "val": "58401 Kozli Kozli (cast)"
  },
  {
    "cast": "Kožušany",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Kožušany-Tážaly",
    "val": "78375 Kozusany-Tazaly Kozusany"
  },
  {
    "cast": "Kožušice",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Kožušice",
    "val": "68333 Kozusice Kozusice"
  },
  {
    "cast": "Krabčice",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Dolany",
    "val": "55204 Dolany Krabcice"
  },
  {
    "cast": "Krabčice",
    "psc": "41187",
    "okres": "Litoměřice",
    "obec": "Krabčice",
    "val": "41187 Krabcice Krabcice"
  },
  {
    "cast": "Kraborovice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Kraborovice",
    "val": "58282 Kraborovice Kraborovice"
  },
  {
    "cast": "Kracovice",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Stařeč",
    "val": "67522 Starec Kracovice"
  },
  {
    "cast": "Kračín",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Tis u Blatna",
    "val": "33165 Tis u Blatna Kracin"
  },
  {
    "cast": "Krahulčí",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Krahulčí",
    "val": "58856 Krahulci Krahulci"
  },
  {
    "cast": "Krahulčí",
    "psc": "54922",
    "okres": "Náchod",
    "obec": "Nový Hrádek",
    "val": "54922 Novy Hradek Krahulci"
  },
  {
    "cast": "Krahulčí",
    "psc": "79305",
    "okres": "Bruntál",
    "obec": "Dětřichov nad Bystřicí",
    "val": "79305 Detrichov nad Bystrici Krahulci"
  },
  {
    "cast": "Krahulov",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Krahulov",
    "val": "67521 Krahulov Krahulov"
  },
  {
    "cast": "Krajková (část)",
    "psc": "35708",
    "okres": "Sokolov",
    "obec": "Krajková",
    "val": "35708 Krajkova Krajkova (cast)"
  },
  {
    "cast": "Krajková (část)",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Krajková",
    "val": "35709 Krajkova Krajkova (cast)"
  },
  {
    "cast": "Krajníčko",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Krajníčko",
    "val": "38773 Krajnicko Krajnicko"
  },
  {
    "cast": "Krakořice",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Šternberk",
    "val": "78501 Sternberk Krakorice"
  },
  {
    "cast": "Krakov",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Krakov",
    "val": "27035 Krakov Krakov"
  },
  {
    "cast": "Krakovany",
    "psc": "28127",
    "okres": "Kolín",
    "obec": "Krakovany",
    "val": "28127 Krakovany Krakovany"
  },
  {
    "cast": "Krakovčice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Žimutice",
    "val": "37501 Zimutice Krakovcice"
  },
  {
    "cast": "Krakovec",
    "psc": "79857",
    "okres": "Prostějov",
    "obec": "Laškov",
    "val": "79857 Laskov Krakovec"
  },
  {
    "cast": "Krakovec",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Krakovec",
    "val": "27035 Krakovec Krakovec"
  },
  {
    "cast": "Králec",
    "psc": "78820",
    "okres": "Šumperk",
    "obec": "Dolní Studénky",
    "val": "78820 Dolni Studenky Kralec"
  },
  {
    "cast": "Kralice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28504 Chlistovice Kralice"
  },
  {
    "cast": "Kralice na Hané",
    "psc": "79812",
    "okres": "Prostějov",
    "obec": "Kralice na Hané",
    "val": "79812 Kralice na Hane Kralice na Hane"
  },
  {
    "cast": "Kralice nad Oslavou (část)",
    "psc": "67573",
    "okres": "Třebíč",
    "obec": "Kralice nad Oslavou",
    "val": "67573 Kralice nad Oslavou Kralice nad Oslavou (cast)"
  },
  {
    "cast": "Kralice nad Oslavou (část)",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Kralice nad Oslavou",
    "val": "67571 Kralice nad Oslavou Kralice nad Oslavou (cast)"
  },
  {
    "cast": "Kraličky",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28504 Chlistovice Kralicky"
  },
  {
    "cast": "Kraličky",
    "psc": "79812",
    "okres": "Prostějov",
    "obec": "Kralice na Hané",
    "val": "79812 Kralice na Hane Kralicky"
  },
  {
    "cast": "Králíky",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Kraliky"
  },
  {
    "cast": "Králíky",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Králíky",
    "val": "50401 Kraliky Kraliky"
  },
  {
    "cast": "Králka",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Oleška",
    "val": "28163 Oleska Kralka"
  },
  {
    "cast": "Králová",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Medlov",
    "val": "78391 Medlov Kralova"
  },
  {
    "cast": "Králova Lhota",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Králova Lhota",
    "val": "39804 Kralova Lhota Kralova Lhota"
  },
  {
    "cast": "Králova Lhota",
    "psc": "51771",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Králova Lhota",
    "val": "51771 Kralova Lhota Kralova Lhota"
  },
  {
    "cast": "Královec",
    "psc": "54203",
    "okres": "Trutnov",
    "obec": "Královec",
    "val": "54203 Kralovec Kralovec"
  },
  {
    "cast": "Kralovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Nebahovy",
    "val": "38301 Nebahovy Kralovice"
  },
  {
    "cast": "Kralovice",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kralovice",
    "val": "33141 Kralovice Kralovice"
  },
  {
    "cast": "Královice",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Královice",
    "val": "27401 Kralovice Kralovice"
  },
  {
    "cast": "Královice",
    "psc": "10400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10400 Praha Kralovice"
  },
  {
    "cast": "Královka",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Šluknov",
    "val": "40747 Sluknov Kralovka"
  },
  {
    "cast": "Královna",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25703 Neustupov Kralovna"
  },
  {
    "cast": "Královo Pole (část)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Kralovo Pole (cast)"
  },
  {
    "cast": "Královo Pole (část)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Kralovo Pole (cast)"
  },
  {
    "cast": "Královopolské Vážany",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Rousínov",
    "val": "68301 Rousinov Kralovopolske Vazany"
  },
  {
    "cast": "Královské Poříčí",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Královské Poříčí",
    "val": "35601 Kralovske Porici Kralovske Porici"
  },
  {
    "cast": "Království",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Šluknov",
    "val": "40747 Sluknov Kralovstvi"
  },
  {
    "cast": "Království",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Třebovle",
    "val": "28163 Trebovle Kralovstvi"
  },
  {
    "cast": "Kralupy nad Vltavou",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Kralupy nad Vltavou",
    "val": "27801 Kralupy nad Vltavou Kralupy nad Vltavou"
  },
  {
    "cast": "Králův Dvůr",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Králův Dvůr",
    "val": "26701 Kraluv Dvur Kraluv Dvur"
  },
  {
    "cast": "Kramolín",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Křešín",
    "val": "39501 Kresin Kramolin"
  },
  {
    "cast": "Kramolín",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Kramolín",
    "val": "33501 Kramolin Kramolin"
  },
  {
    "cast": "Kramolín",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Jílovice",
    "val": "37312 Jilovice Kramolin"
  },
  {
    "cast": "Kramolín",
    "psc": "67577",
    "okres": "Třebíč",
    "obec": "Kramolín",
    "val": "67577 Kramolin Kramolin"
  },
  {
    "cast": "Kramolna",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Kramolna",
    "val": "54701 Kramolna Kramolna"
  },
  {
    "cast": "Krámský",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Kramsky"
  },
  {
    "cast": "Krámy",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Nové Dvory",
    "val": "26203 Nove Dvory Kramy"
  },
  {
    "cast": "Krapice",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Františkovy Lázně",
    "val": "35002 Frantiskovy Lazne Krapice"
  },
  {
    "cast": "Krasavce",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Dolní Lukavice",
    "val": "33401 Dolni Lukavice Krasavce"
  },
  {
    "cast": "Krasejovka",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Krasejovka"
  },
  {
    "cast": "Kraselov",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Kraselov",
    "val": "38716 Kraselov Kraselov"
  },
  {
    "cast": "Krásensko",
    "psc": "68304",
    "okres": "Vyškov",
    "obec": "Krásensko",
    "val": "68304 Krasensko Krasensko"
  },
  {
    "cast": "Krasetín",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Holubov",
    "val": "38203 Holubov Krasetin"
  },
  {
    "cast": "Krasice (část)",
    "psc": "79601",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79601 Prostejov Krasice (cast)"
  },
  {
    "cast": "Krasice (část)",
    "psc": "79604",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79604 Prostejov Krasice (cast)"
  },
  {
    "cast": "Krasíkov",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Krasíkov",
    "val": "56301 Krasikov Krasikov"
  },
  {
    "cast": "Krasíkov",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Kokašice",
    "val": "34952 Kokasice Krasikov"
  },
  {
    "cast": "Krasíkovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Krasíkovice",
    "val": "39301 Krasikovice Krasikovice"
  },
  {
    "cast": "Kraskov",
    "psc": "53805",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53805 Sec Kraskov"
  },
  {
    "cast": "Kraslice",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Kraslice"
  },
  {
    "cast": "Krásná",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Krásná",
    "val": "35201 Krasna Krasna"
  },
  {
    "cast": "Krásná",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Krasna"
  },
  {
    "cast": "Krásná",
    "psc": "73904",
    "okres": "Frýdek-Místek",
    "obec": "Krásná",
    "val": "73904 Krasna Krasna"
  },
  {
    "cast": "Krásná",
    "psc": "46821",
    "okres": "Jablonec nad Nisou",
    "obec": "Pěnčín",
    "val": "46821 Pencin Krasna"
  },
  {
    "cast": "Krásná Hora nad Vltavou",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Krasna Hora nad Vltavou"
  },
  {
    "cast": "Krásná Hora (část)",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58291 Krasna Hora Krasna Hora (cast)"
  },
  {
    "cast": "Krásná Hora (část)",
    "psc": "58234",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58234 Krasna Hora Krasna Hora (cast)"
  },
  {
    "cast": "Krásná Lípa",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Šindelová",
    "val": "35801 Sindelova Krasna Lipa"
  },
  {
    "cast": "Krásná Lípa",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Krasna Lipa"
  },
  {
    "cast": "Krásná Lípa",
    "psc": "40746",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40746 Krasna Lipa Krasna Lipa"
  },
  {
    "cast": "Krásná Studánka-Liberec XXXI x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Krasna Studanka-Liberec XXXI x)"
  },
  {
    "cast": "Krásná Ves",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Krásná Ves",
    "val": "29425 Krasna Ves Krasna Ves"
  },
  {
    "cast": "Krásné",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Krásné",
    "val": "53825 Krasne Krasne"
  },
  {
    "cast": "Krásné",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Krásné",
    "val": "59203 Krasne Krasne"
  },
  {
    "cast": "Krásné",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Tři Sekery",
    "val": "35301 Tri Sekery Krasne"
  },
  {
    "cast": "Krásné Březno",
    "psc": "40007",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40007 Usti nad Labem Krasne Brezno"
  },
  {
    "cast": "Krásné Loučky",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Krnov",
    "val": "79401 Krnov Krasne Loucky"
  },
  {
    "cast": "Krásné Pole",
    "psc": "40744",
    "okres": "Děčín",
    "obec": "Chřibská",
    "val": "40744 Chribska Krasne Pole"
  },
  {
    "cast": "Krásné Pole",
    "psc": "72526",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72526 Ostrava Krasne Pole"
  },
  {
    "cast": "Krásné Údolí",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34901 Cernosin Krasne Udoli"
  },
  {
    "cast": "Krásné Údolí",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Krásné Údolí",
    "val": "36401 Krasne Udoli Krasne Udoli"
  },
  {
    "cast": "Krásněves",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Krásněves",
    "val": "59444 Krasneves Krasneves"
  },
  {
    "cast": "Krasnice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Litošice",
    "val": "53501 Litosice Krasnice"
  },
  {
    "cast": "Krásnice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Praskačka",
    "val": "50327 Praskacka Krasnice"
  },
  {
    "cast": "Krásno",
    "psc": "35731",
    "okres": "Sokolov",
    "obec": "Krásno",
    "val": "35731 Krasno Krasno"
  },
  {
    "cast": "Krásno nad Bečvou",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Valašské Meziříčí",
    "val": "75701 Valasske Mezirici Krasno nad Becvou"
  },
  {
    "cast": "Krásný Buk",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40747 Krasna Lipa Krasny Buk"
  },
  {
    "cast": "Krásný Dvoreček",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Rokle",
    "val": "43201 Rokle Krasny Dvorecek"
  },
  {
    "cast": "Krásný Dvůr",
    "psc": "43972",
    "okres": "Louny",
    "obec": "Krásný Dvůr",
    "val": "43972 Krasny Dvur Krasny Dvur"
  },
  {
    "cast": "Krásný Jez",
    "psc": "36464",
    "okres": "Karlovy Vary",
    "obec": "Bečov nad Teplou",
    "val": "36464 Becov nad Teplou Krasny Jez"
  },
  {
    "cast": "Krásný Les",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Krásný Les",
    "val": "46401 Krasny Les Krasny Les"
  },
  {
    "cast": "Krásný Les",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Krásný Les",
    "val": "36301 Krasny Les Krasny Les"
  },
  {
    "cast": "Krásný Les (část)",
    "psc": "40338",
    "okres": "Ústí nad Labem",
    "obec": "Petrovice",
    "val": "40338 Petrovice Krasny Les (cast)"
  },
  {
    "cast": "Krásný Les (část)",
    "psc": "40337",
    "okres": "Ústí nad Labem",
    "obec": "Petrovice",
    "val": "40337 Petrovice Krasny Les (cast)"
  },
  {
    "cast": "Krásný Studenec-Děčín XXIV x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Krasny Studenec-Decin XXIV x)"
  },
  {
    "cast": "Krasonice (část)",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Krasonice",
    "val": "58856 Krasonice Krasonice (cast)"
  },
  {
    "cast": "Krasonice (část)",
    "psc": "58864",
    "okres": "Jihlava",
    "obec": "Krasonice",
    "val": "58864 Krasonice Krasonice (cast)"
  },
  {
    "cast": "Krasoňov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Krasonov"
  },
  {
    "cast": "Krasoňovice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Černíny",
    "val": "28401 Cerniny Krasonovice"
  },
  {
    "cast": "Krasoňovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Krasonovice"
  },
  {
    "cast": "Krasov (část)",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Krasov",
    "val": "79401 Krasov Krasov (cast)"
  },
  {
    "cast": "Krasov (část)",
    "psc": "79326",
    "okres": "Bruntál",
    "obec": "Krasov",
    "val": "79326 Krasov Krasov (cast)"
  },
  {
    "cast": "Krasová",
    "psc": "67906",
    "okres": "Blansko",
    "obec": "Krasová",
    "val": "67906 Krasova Krasova"
  },
  {
    "cast": "Krasovice",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Kondrac",
    "val": "25801 Kondrac Krasovice"
  },
  {
    "cast": "Krašlovice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Krašlovice",
    "val": "38901 Kraslovice Kraslovice"
  },
  {
    "cast": "Krašov",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Krasov"
  },
  {
    "cast": "Krašovice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Čížová",
    "val": "39701 Cizova Krasovice"
  },
  {
    "cast": "Krašovice",
    "psc": "33013",
    "okres": "Plzeň-sever",
    "obec": "Krašovice",
    "val": "33013 Krasovice Krasovice"
  },
  {
    "cast": "Krašovice (část)",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26255 Krasna Hora nad Vltavou Krasovice (cast)"
  },
  {
    "cast": "Krašovice (část)",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Krasovice (cast)"
  },
  {
    "cast": "Krátká",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Sněžné",
    "val": "59203 Snezne Kratka"
  },
  {
    "cast": "Krátká Ves",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Krátká Ves",
    "val": "58222 Kratka Ves Kratka Ves"
  },
  {
    "cast": "Kratochvilka",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Kratochvilka",
    "val": "66491 Kratochvilka Kratochvilka"
  },
  {
    "cast": "Kratonohy",
    "psc": "50324",
    "okres": "Hradec Králové",
    "obec": "Kratonohy",
    "val": "50324 Kratonohy Kratonohy"
  },
  {
    "cast": "Krátošice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Krátošice",
    "val": "39201 Kratosice Kratosice"
  },
  {
    "cast": "Kratušín",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Kratušín",
    "val": "38301 Kratusin Kratusin"
  },
  {
    "cast": "Krauzovna",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Kly",
    "val": "27741 Kly Krauzovna"
  },
  {
    "cast": "Kravaře",
    "psc": "74721",
    "okres": "Opava",
    "obec": "Kravaře",
    "val": "74721 Kravare Kravare"
  },
  {
    "cast": "Kravaře",
    "psc": "47103",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47103 Kravare Kravare"
  },
  {
    "cast": "Kravsko",
    "psc": "67151",
    "okres": "Znojmo",
    "obec": "Kravsko",
    "val": "67151 Kravsko Kravsko"
  },
  {
    "cast": "Krč",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Krc"
  },
  {
    "cast": "Krč (část)",
    "psc": "14000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14000 Praha Krc (cast)"
  },
  {
    "cast": "Krč (část)",
    "psc": "14700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14700 Praha Krc (cast)"
  },
  {
    "cast": "Krč (část)",
    "psc": "14200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14200 Praha Krc (cast)"
  },
  {
    "cast": "Krčín",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Krcin"
  },
  {
    "cast": "Krčín",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nové Město nad Metují",
    "val": "54901 Nove Mesto nad Metuji Krcin"
  },
  {
    "cast": "Krčkovice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51101 Hruba Skala Krckovice"
  },
  {
    "cast": "Krčma",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Strážek",
    "val": "59253 Strazek Krcma"
  },
  {
    "cast": "Krčmaň",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Krčmaň",
    "val": "77900 Krcman Krcman"
  },
  {
    "cast": "Krčmy",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Krcmy"
  },
  {
    "cast": "Krejnice (část)",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Krejnice",
    "val": "38716 Krejnice Krejnice (cast)"
  },
  {
    "cast": "Krejnice (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Krejnice",
    "val": "38601 Krejnice Krejnice (cast)"
  },
  {
    "cast": "Krhanice",
    "psc": "25742",
    "okres": "Benešov",
    "obec": "Krhanice",
    "val": "25742 Krhanice Krhanice"
  },
  {
    "cast": "Krhov",
    "psc": "67555",
    "okres": "Třebíč",
    "obec": "Krhov",
    "val": "67555 Krhov Krhov"
  },
  {
    "cast": "Krhov",
    "psc": "67901",
    "okres": "Blansko",
    "obec": "Krhov",
    "val": "67901 Krhov Krhov"
  },
  {
    "cast": "Krhov (část)",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Bojkovice",
    "val": "68771 Bojkovice Krhov (cast)"
  },
  {
    "cast": "Krhov (část)",
    "psc": "68774",
    "okres": "Uherské Hradiště",
    "obec": "Bojkovice",
    "val": "68774 Bojkovice Krhov (cast)"
  },
  {
    "cast": "Krhová",
    "psc": "75663",
    "okres": "Vsetín",
    "obec": "Krhová",
    "val": "75663 Krhova Krhova"
  },
  {
    "cast": "Krhovice",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Krhovice",
    "val": "67128 Krhovice Krhovice"
  },
  {
    "cast": "Krchlebská Lhota",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Zbýšov",
    "val": "28601 Zbysov Krchlebska Lhota"
  },
  {
    "cast": "Krchleby",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Krchleby",
    "val": "78901 Krchleby Krchleby"
  },
  {
    "cast": "Krchleby",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Staňkov",
    "val": "34561 Stankov Krchleby"
  },
  {
    "cast": "Krchleby",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Krchleby"
  },
  {
    "cast": "Krchleby",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Krchleby",
    "val": "28601 Krchleby Krchleby"
  },
  {
    "cast": "Krchleby",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Krchleby",
    "val": "28802 Krchleby Krchleby"
  },
  {
    "cast": "Krchleby",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Krchleby",
    "val": "51741 Krchleby Krchleby"
  },
  {
    "cast": "Krchov",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Krchov"
  },
  {
    "cast": "Krchova Lomná",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Krchova Lomna"
  },
  {
    "cast": "Kristiánov-Liberec V x)",
    "psc": "46005",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46005 Liberec Kristianov-Liberec V x)"
  },
  {
    "cast": "Krmelín",
    "psc": "73924",
    "okres": "Frýdek-Místek",
    "obec": "Krmelín",
    "val": "73924 Krmelin Krmelin"
  },
  {
    "cast": "Krnalovice",
    "psc": "73946",
    "okres": "Frýdek-Místek",
    "obec": "Hukvaldy",
    "val": "73946 Hukvaldy Krnalovice"
  },
  {
    "cast": "Krňany",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Krňany",
    "val": "25744 Krnany Krnany"
  },
  {
    "cast": "Krnčice",
    "psc": "67541",
    "okres": "Třebíč",
    "obec": "Nové Syrovice",
    "val": "67541 Nove Syrovice Krncice"
  },
  {
    "cast": "Krnín",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Chlumec",
    "val": "38232 Chlumec Krnin"
  },
  {
    "cast": "Krňovice",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Třebechovice pod Orebem",
    "val": "50346 Trebechovice pod Orebem Krnovice"
  },
  {
    "cast": "Krnsko",
    "psc": "29431",
    "okres": "Mladá Boleslav",
    "obec": "Krnsko",
    "val": "29431 Krnsko Krnsko"
  },
  {
    "cast": "Kroclov",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Vrábče",
    "val": "37001 Vrabce Kroclov"
  },
  {
    "cast": "Kročehlavy",
    "psc": "27201",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27201 Kladno Krocehlavy"
  },
  {
    "cast": "Krokočín",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Krokočín",
    "val": "67571 Krokocin Krokocin"
  },
  {
    "cast": "Kroměříž",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Kromeriz"
  },
  {
    "cast": "Kroměždice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bolešiny",
    "val": "33901 Bolesiny Kromezdice"
  },
  {
    "cast": "Krompach (část)",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Krompach",
    "val": "47301 Krompach Krompach (cast)"
  },
  {
    "cast": "Krompach (část)",
    "psc": "47157",
    "okres": "Česká Lípa",
    "obec": "Krompach",
    "val": "47157 Krompach Krompach (cast)"
  },
  {
    "cast": "Kropáčova Vrutice",
    "psc": "29479",
    "okres": "Mladá Boleslav",
    "obec": "Kropáčova Vrutice",
    "val": "29479 Kropacova Vrutice Kropacova Vrutice"
  },
  {
    "cast": "Krotějov",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Krotejov"
  },
  {
    "cast": "Kroučová",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Kroučová",
    "val": "27054 Kroucova Kroucova"
  },
  {
    "cast": "Krouna",
    "psc": "53943",
    "okres": "Chrudim",
    "obec": "Krouna",
    "val": "53943 Krouna Krouna"
  },
  {
    "cast": "Kroužek",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Rousínov",
    "val": "68301 Rousinov Krouzek"
  },
  {
    "cast": "Krpy",
    "psc": "29479",
    "okres": "Mladá Boleslav",
    "obec": "Kropáčova Vrutice",
    "val": "29479 Kropacova Vrutice Krpy"
  },
  {
    "cast": "Krsice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Čimelice",
    "val": "39804 Cimelice Krsice"
  },
  {
    "cast": "Krsmol",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Stará Paka",
    "val": "50901 Stara Paka Krsmol"
  },
  {
    "cast": "Krsov",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Ostrov u Bezdružic",
    "val": "33036 Ostrov u Bezdruzic Krsov"
  },
  {
    "cast": "Krsovice-Svatý Jan x)",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28504 Chlistovice Krsovice-Svaty Jan x)"
  },
  {
    "cast": "Krsy",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Krsy",
    "val": "33038 Krsy Krsy"
  },
  {
    "cast": "Krtely",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Malovice",
    "val": "38411 Malovice Krtely"
  },
  {
    "cast": "Krtín",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Skapce",
    "val": "34901 Skapce Krtin"
  },
  {
    "cast": "Krtov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Krtov",
    "val": "39201 Krtov Krtov"
  },
  {
    "cast": "Krty",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Krty",
    "val": "27033 Krty Krty"
  },
  {
    "cast": "Krty-Hradec",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Krty-Hradec",
    "val": "38601 Krty-Hradec Krty-Hradec"
  },
  {
    "cast": "Krucemburk (část)",
    "psc": "58266",
    "okres": "Havlíčkův Brod",
    "obec": "Krucemburk",
    "val": "58266 Krucemburk Krucemburk (cast)"
  },
  {
    "cast": "Krucemburk (část)",
    "psc": "53901",
    "okres": "Havlíčkův Brod",
    "obec": "Krucemburk",
    "val": "53901 Krucemburk Krucemburk (cast)"
  },
  {
    "cast": "Kruh",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Kruh",
    "val": "51401 Kruh Kruh"
  },
  {
    "cast": "Kruh",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Doksy",
    "val": "47201 Doksy Kruh"
  },
  {
    "cast": "Kruhy",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29413 Mnichovo Hradiste Kruhy"
  },
  {
    "cast": "Krukanice",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Pernarec",
    "val": "33036 Pernarec Krukanice"
  },
  {
    "cast": "Krumsín",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Krumsín",
    "val": "79803 Krumsin Krumsin"
  },
  {
    "cast": "Krumvald",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Střítež",
    "val": "39470 Stritez Krumvald"
  },
  {
    "cast": "Krumvíř",
    "psc": "69173",
    "okres": "Břeclav",
    "obec": "Krumvíř",
    "val": "69173 Krumvir Krumvir"
  },
  {
    "cast": "Krupá",
    "psc": "27009",
    "okres": "Rakovník",
    "obec": "Krupá",
    "val": "27009 Krupa Krupa"
  },
  {
    "cast": "Krupá",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Křesetice",
    "val": "28401 Kresetice Krupa"
  },
  {
    "cast": "Krupá",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Krupá",
    "val": "28163 Krupa Krupa"
  },
  {
    "cast": "Krupice",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Okounov",
    "val": "43151 Okounov Krupice"
  },
  {
    "cast": "Krupín",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53825 Miretice Krupin"
  },
  {
    "cast": "Krupka (část)",
    "psc": "41741",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41741 Krupka Krupka (cast)"
  },
  {
    "cast": "Krupka (část)",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Krupka (cast)"
  },
  {
    "cast": "Kruplov",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Jarošov nad Nežárkou",
    "val": "37842 Jarosov nad Nezarkou Kruplov"
  },
  {
    "cast": "Krusičany",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25741 Tynec nad Sazavou Krusicany"
  },
  {
    "cast": "Krušiny",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Velké Všelisy",
    "val": "29426 Velke Vselisy Krusiny"
  },
  {
    "cast": "Krušlov",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38719 Cestice Kruslov"
  },
  {
    "cast": "Krušovice",
    "psc": "27053",
    "okres": "Rakovník",
    "obec": "Krušovice",
    "val": "27053 Krusovice Krusovice"
  },
  {
    "cast": "Krutěnice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34142 Nalzovske Hory Krutenice"
  },
  {
    "cast": "Kružberk",
    "psc": "74786",
    "okres": "Opava",
    "obec": "Kružberk",
    "val": "74786 Kruzberk Kruzberk"
  },
  {
    "cast": "Kryblice",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Kryblice"
  },
  {
    "cast": "Krychnov",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Krychnov",
    "val": "28002 Krychnov Krychnov"
  },
  {
    "cast": "Krymlov",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Oleška",
    "val": "28163 Oleska Krymlov"
  },
  {
    "cast": "Kryry",
    "psc": "43981",
    "okres": "Louny",
    "obec": "Kryry",
    "val": "43981 Kryry Kryry"
  },
  {
    "cast": "Kryštofovo Údolí",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Kryštofovo Údolí",
    "val": "46001 Krystofovo Udoli Krystofovo Udoli"
  },
  {
    "cast": "Kryštofovy Hamry",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Kryštofovy Hamry",
    "val": "43191 Krystofovy Hamry Krystofovy Hamry"
  },
  {
    "cast": "Křakov",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Mířkov",
    "val": "34601 Mirkov Krakov"
  },
  {
    "cast": "Křeč",
    "psc": "39495",
    "okres": "Pelhřimov",
    "obec": "Křeč",
    "val": "39495 Krec Krec"
  },
  {
    "cast": "Křečhoř",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Křečhoř",
    "val": "28002 Krechor Krechor"
  },
  {
    "cast": "Křečkov",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Křečkov",
    "val": "29001 Kreckov Kreckov"
  },
  {
    "cast": "Křečkovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Kreckovice"
  },
  {
    "cast": "Křečov",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Štichovice",
    "val": "33141 Stichovice Krecov"
  },
  {
    "cast": "Křečovice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Krecovice"
  },
  {
    "cast": "Křečovice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Onomyšl",
    "val": "28504 Onomysl Krecovice"
  },
  {
    "cast": "Křečovice 1.díl",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Žernov",
    "val": "51263 Zernov Krecovice 1.dil"
  },
  {
    "cast": "Křečovice 2.díl",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Rovensko pod Troskami",
    "val": "51263 Rovensko pod Troskami Krecovice 2.dil"
  },
  {
    "cast": "Křekov",
    "psc": "76601",
    "okres": "Zlín",
    "obec": "Křekov",
    "val": "76601 Krekov Krekov"
  },
  {
    "cast": "Křekovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Krekovice"
  },
  {
    "cast": "Křekovice",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Čistá",
    "val": "27034 Cista Krekovice"
  },
  {
    "cast": "Křekovická Lhota",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Krekovicka Lhota"
  },
  {
    "cast": "Křelina",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Bukvice",
    "val": "50601 Bukvice Krelina"
  },
  {
    "cast": "Křelov",
    "psc": "78336",
    "okres": "Olomouc",
    "obec": "Křelov-Břuchotín",
    "val": "78336 Krelov-Bruchotin Krelov"
  },
  {
    "cast": "Křelovice",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Křelovice",
    "val": "33036 Krelovice Krelovice"
  },
  {
    "cast": "Křelovice",
    "psc": "39445",
    "okres": "Pelhřimov",
    "obec": "Křelovice",
    "val": "39445 Krelovice Krelovice"
  },
  {
    "cast": "Křemačov",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Mohelnice",
    "val": "78985 Mohelnice Kremacov"
  },
  {
    "cast": "Křemenec",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Konice",
    "val": "79852 Konice Kremenec"
  },
  {
    "cast": "Křemení",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Chotýšany",
    "val": "25701 Chotysany Kremeni"
  },
  {
    "cast": "Křemenice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Kremenice"
  },
  {
    "cast": "Křemenice",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Kremenice"
  },
  {
    "cast": "Křemešník",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nový Rychnov",
    "val": "39301 Novy Rychnov Kremesnik"
  },
  {
    "cast": "Křemýž",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Ohníč",
    "val": "41501 Ohnic Kremyz"
  },
  {
    "cast": "Křemže",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Kremze"
  },
  {
    "cast": "Křenek",
    "psc": "27714",
    "okres": "Praha-východ",
    "obec": "Křenek",
    "val": "27714 Krenek Krenek"
  },
  {
    "cast": "Křenice",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Křenice",
    "val": "34012 Krenice Krenice"
  },
  {
    "cast": "Křenice",
    "psc": "25084",
    "okres": "Praha-východ",
    "obec": "Křenice",
    "val": "25084 Krenice Krenice"
  },
  {
    "cast": "Křeničná",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Krenicna"
  },
  {
    "cast": "Křenov",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Krenov"
  },
  {
    "cast": "Křenov",
    "psc": "56922",
    "okres": "Svitavy",
    "obec": "Křenov",
    "val": "56922 Krenov Krenov"
  },
  {
    "cast": "Křenov",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Bernartice",
    "val": "54101 Bernartice Krenov"
  },
  {
    "cast": "Křenov",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38101 Kajov Krenov"
  },
  {
    "cast": "Křenovice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25901 Vojkov Krenovice"
  },
  {
    "cast": "Křenovice",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Křenovice",
    "val": "75201 Krenovice Krenovice"
  },
  {
    "cast": "Křenovice",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Dubné",
    "val": "37384 Dubne Krenovice"
  },
  {
    "cast": "Křenovice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Křenovice",
    "val": "39843 Krenovice Krenovice"
  },
  {
    "cast": "Křenovice",
    "psc": "68352",
    "okres": "Vyškov",
    "obec": "Křenovice",
    "val": "68352 Krenovice Krenovice"
  },
  {
    "cast": "Křenovičky",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Krenovicky"
  },
  {
    "cast": "Křenovy",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Křenovy",
    "val": "34561 Krenovy Krenovy"
  },
  {
    "cast": "Křenovy",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Troskovice",
    "val": "51263 Troskovice Krenovy"
  },
  {
    "cast": "Křenovy Dvory",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Krenovy Dvory"
  },
  {
    "cast": "Křenůvky",
    "psc": "79804",
    "okres": "Prostějov",
    "obec": "Myslejovice",
    "val": "79804 Myslejovice Krenuvky"
  },
  {
    "cast": "Křepenice (část)",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Křepenice",
    "val": "26401 Krepenice Krepenice (cast)"
  },
  {
    "cast": "Křepenice (část)",
    "psc": "26293",
    "okres": "Příbram",
    "obec": "Křepenice",
    "val": "26293 Krepenice Krepenice (cast)"
  },
  {
    "cast": "Křepice",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Křepice",
    "val": "67140 Krepice Krepice"
  },
  {
    "cast": "Křepice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Stožice",
    "val": "38901 Stozice Krepice"
  },
  {
    "cast": "Křepice",
    "psc": "69165",
    "okres": "Břeclav",
    "obec": "Křepice",
    "val": "69165 Krepice Krepice"
  },
  {
    "cast": "Křepiny",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Řečice",
    "val": "39601 Recice Krepiny"
  },
  {
    "cast": "Křepkovice",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Krepkovice"
  },
  {
    "cast": "Křeptov",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Běleč",
    "val": "67923 Belec Kreptov"
  },
  {
    "cast": "Křesanov (část)",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38473 Vimperk Kresanov (cast)"
  },
  {
    "cast": "Křesanov (část)",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Kresanov (cast)"
  },
  {
    "cast": "Křesetice",
    "psc": "28547",
    "okres": "Kutná Hora",
    "obec": "Křesetice",
    "val": "28547 Kresetice Kresetice"
  },
  {
    "cast": "Křesín",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Křesín",
    "val": "41002 Kresin Kresin"
  },
  {
    "cast": "Křeslice",
    "psc": "10400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10400 Praha Kreslice"
  },
  {
    "cast": "Křešice",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Libáň",
    "val": "50723 Liban Kresice"
  },
  {
    "cast": "Křešice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Divišov",
    "val": "25726 Divisov Kresice"
  },
  {
    "cast": "Křešice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Kresice"
  },
  {
    "cast": "Křešice",
    "psc": "41148",
    "okres": "Litoměřice",
    "obec": "Křešice",
    "val": "41148 Kresice Kresice"
  },
  {
    "cast": "Křešice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25753 Olbramovice Kresice"
  },
  {
    "cast": "Křešice-Děčín XXXI x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Kresice-Decin XXXI x)"
  },
  {
    "cast": "Křešín",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Křešín",
    "val": "26223 Kresin Kresin"
  },
  {
    "cast": "Křešín (část)",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Křešín",
    "val": "39501 Kresin Kresin (cast)"
  },
  {
    "cast": "Křešín (část)",
    "psc": "39424",
    "okres": "Pelhřimov",
    "obec": "Křešín",
    "val": "39424 Kresin Kresin (cast)"
  },
  {
    "cast": "Křešov",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Snědovice",
    "val": "41108 Snedovice Kresov"
  },
  {
    "cast": "Křetín",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Křetín",
    "val": "67962 Kretin Kretin"
  },
  {
    "cast": "Křičeň",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Křičeň",
    "val": "53341 Kricen Kricen"
  },
  {
    "cast": "Křičov",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Smidary",
    "val": "50401 Smidary Kricov"
  },
  {
    "cast": "Křída",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Stádlec",
    "val": "39165 Stadlec Krida"
  },
  {
    "cast": "Křídla",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Křídla",
    "val": "59231 Kridla Kridla"
  },
  {
    "cast": "Křídlůvky",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Křídlůvky",
    "val": "67128 Kridluvky Kridluvky"
  },
  {
    "cast": "Křimice (část)",
    "psc": "31800",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31800 Plzen Krimice (cast)"
  },
  {
    "cast": "Křimice (část)",
    "psc": "32200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32200 Plzen Krimice (cast)"
  },
  {
    "cast": "Křimov",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Krimov"
  },
  {
    "cast": "Křinec",
    "psc": "28933",
    "okres": "Nymburk",
    "obec": "Křinec",
    "val": "28933 Krinec Krinec"
  },
  {
    "cast": "Křinice",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Křinice",
    "val": "55001 Krinice Krinice"
  },
  {
    "cast": "Křínov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Krinov"
  },
  {
    "cast": "Kříše",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Břasy",
    "val": "33824 Brasy Krise"
  },
  {
    "cast": "Křišťanov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Křišťanov",
    "val": "38301 Kristanov Kristanov"
  },
  {
    "cast": "Křišťanovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Záblatí",
    "val": "38301 Zablati Kristanovice"
  },
  {
    "cast": "Křišťanovice",
    "psc": "79368",
    "okres": "Bruntál",
    "obec": "Křišťanovice",
    "val": "79368 Kristanovice Kristanovice"
  },
  {
    "cast": "Křištín",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Kristin"
  },
  {
    "cast": "Křivá",
    "psc": "78386",
    "okres": "Olomouc",
    "obec": "Dlouhá Loučka",
    "val": "78386 Dlouha Loucka Kriva"
  },
  {
    "cast": "Křivá Ves",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Kriva Ves"
  },
  {
    "cast": "Křivá Voda",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Kriva Voda"
  },
  {
    "cast": "Křiváček",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Řehenice",
    "val": "25167 Rehenice Krivacek"
  },
  {
    "cast": "Křivce",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Krivce"
  },
  {
    "cast": "Křivenice",
    "psc": "27703",
    "okres": "Mělník",
    "obec": "Horní Počaply",
    "val": "27703 Horni Pocaply Krivenice"
  },
  {
    "cast": "Křivice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Týniště nad Orlicí",
    "val": "51721 Tyniste nad Orlici Krivice"
  },
  {
    "cast": "Křivoklát",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Křivoklát",
    "val": "27023 Krivoklat Krivoklat"
  },
  {
    "cast": "Křivošín",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Krivosin"
  },
  {
    "cast": "Křivousy",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Vojkovice",
    "val": "27745 Vojkovice Krivousy"
  },
  {
    "cast": "Křivsoudov (část)",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Křivsoudov",
    "val": "25765 Krivsoudov Krivsoudov (cast)"
  },
  {
    "cast": "Křivsoudov (část)",
    "psc": "25766",
    "okres": "Benešov",
    "obec": "Křivsoudov",
    "val": "25766 Krivsoudov Krivsoudov (cast)"
  },
  {
    "cast": "Křížánky",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Hejnice",
    "val": "56401 Hejnice Krizanky"
  },
  {
    "cast": "Křižanov",
    "psc": "41704",
    "okres": "Teplice",
    "obec": "Hrob",
    "val": "41704 Hrob Krizanov"
  },
  {
    "cast": "Křižanov",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Hořičky",
    "val": "55205 Horicky Krizanov"
  },
  {
    "cast": "Křižanov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Hynčina",
    "val": "78901 Hyncina Krizanov"
  },
  {
    "cast": "Křižanov",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Křižanov",
    "val": "59451 Krizanov Krizanov"
  },
  {
    "cast": "Křižanov",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Křižanov",
    "val": "39843 Krizanov Krizanov"
  },
  {
    "cast": "Křižanovice",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Křižanovice",
    "val": "68501 Krizanovice Krizanovice"
  },
  {
    "cast": "Křižanovice",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Křižanovice",
    "val": "53821 Krizanovice Krizanovice"
  },
  {
    "cast": "Křižanovice u Vyškova",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Křižanovice u Vyškova",
    "val": "68201 Krizanovice u Vyskova Krizanovice u Vyskova"
  },
  {
    "cast": "Křižany",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Křižany",
    "val": "46353 Krizany Krizany"
  },
  {
    "cast": "Křižany",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Světlá pod Ještědem",
    "val": "46343 Svetla pod Jestedem Krizany"
  },
  {
    "cast": "Křižatky",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Králův Dvůr",
    "val": "26701 Kraluv Dvur Krizatky"
  },
  {
    "cast": "Křížatky",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Krizatky"
  },
  {
    "cast": "Kříženec",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Krizenec"
  },
  {
    "cast": "Kříženec",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Krizenec"
  },
  {
    "cast": "Kříženec",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Krizenec"
  },
  {
    "cast": "Křižínkov",
    "psc": "59453",
    "okres": "Brno-venkov",
    "obec": "Křižínkov",
    "val": "59453 Krizinkov Krizinkov"
  },
  {
    "cast": "Křížkový Újezdec",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Křížkový Újezdec",
    "val": "25168 Krizkovy Ujezdec Krizkovy Ujezdec"
  },
  {
    "cast": "Křížky",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Krizky"
  },
  {
    "cast": "Křížlice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Jestřabí v Krkonoších",
    "val": "51401 Jestrabi v Krkonosich Krizlice"
  },
  {
    "cast": "Křížov",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Korkyně",
    "val": "26203 Korkyne Krizov"
  },
  {
    "cast": "Křížov",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Jiříkov",
    "val": "79351 Jirikov Krizov"
  },
  {
    "cast": "Křížov",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Pravonín",
    "val": "25708 Pravonin Krizov"
  },
  {
    "cast": "Křížová",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Hošťálkovy",
    "val": "79401 Hostalkovy Krizova"
  },
  {
    "cast": "Křižovatka",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Křižovatka",
    "val": "35134 Krizovatka Krizovatka"
  },
  {
    "cast": "Křížovice",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34034 Planice Krizovice"
  },
  {
    "cast": "Křížovice",
    "psc": "59262",
    "okres": "Brno-venkov",
    "obec": "Doubravník",
    "val": "59262 Doubravnik Krizovice"
  },
  {
    "cast": "Křoví",
    "psc": "59454",
    "okres": "Žďár nad Sázavou",
    "obec": "Křoví",
    "val": "59454 Krovi Krovi"
  },
  {
    "cast": "Křovice",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobruška",
    "val": "51801 Dobruska Krovice"
  },
  {
    "cast": "Křtěnov",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Křtěnov",
    "val": "67974 Krtenov Krtenov"
  },
  {
    "cast": "Křtěnov",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Krtenov"
  },
  {
    "cast": "Křtěnovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nová Ves u Mladé Vožice",
    "val": "39143 Nova Ves u Mlade Vozice Krtenovice"
  },
  {
    "cast": "Křtětice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Krtetice"
  },
  {
    "cast": "Křtiny",
    "psc": "67905",
    "okres": "Blansko",
    "obec": "Křtiny",
    "val": "67905 Krtiny Krtiny"
  },
  {
    "cast": "Křtomil",
    "psc": "75114",
    "okres": "Přerov",
    "obec": "Křtomil",
    "val": "75114 Krtomil Krtomil"
  },
  {
    "cast": "Kšely",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Kšely",
    "val": "28201 Ksely Ksely"
  },
  {
    "cast": "Kšice",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kšice",
    "val": "34901 Ksice Ksice"
  },
  {
    "cast": "Ktiš",
    "psc": "38403",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38403 Ktis Ktis"
  },
  {
    "cast": "Ktiš-Pila (část)",
    "psc": "38404",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38404 Ktis Ktis-Pila (cast)"
  },
  {
    "cast": "Ktiš-Pila (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38301 Ktis Ktis-Pila (cast)"
  },
  {
    "cast": "Ktová",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Ktová",
    "val": "51263 Ktova Ktova"
  },
  {
    "cast": "Kubíkovy Duby",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Třemošnice",
    "val": "53843 Tremosnice Kubikovy Duby"
  },
  {
    "cast": "Kublov",
    "psc": "26741",
    "okres": "Beroun",
    "obec": "Kublov",
    "val": "26741 Kublov Kublov"
  },
  {
    "cast": "Kubova Huť",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Kubova Huť",
    "val": "38501 Kubova Hut Kubova Hut"
  },
  {
    "cast": "Kubšice",
    "psc": "67176",
    "okres": "Znojmo",
    "obec": "Kubšice",
    "val": "67176 Kubsice Kubsice"
  },
  {
    "cast": "Kucíny",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Příchovice",
    "val": "33401 Prichovice Kuciny"
  },
  {
    "cast": "Kučerov",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Kučerov",
    "val": "68201 Kucerov Kucerov"
  },
  {
    "cast": "Kučeř",
    "psc": "39834",
    "okres": "Písek",
    "obec": "Kučeř",
    "val": "39834 Kucer Kucer"
  },
  {
    "cast": "Kučlín",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41804 Hrobcice Kuclin"
  },
  {
    "cast": "Kudlov",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76001 Zlin Kudlov"
  },
  {
    "cast": "Kudlovice",
    "psc": "68703",
    "okres": "Uherské Hradiště",
    "obec": "Kudlovice",
    "val": "68703 Kudlovice Kudlovice"
  },
  {
    "cast": "Kuchař",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Vysoký Újezd",
    "val": "26718 Vysoky Ujezd Kuchar"
  },
  {
    "cast": "Kuchařík",
    "psc": "25226",
    "okres": "Praha-západ",
    "obec": "Roblín",
    "val": "25226 Roblin Kucharik"
  },
  {
    "cast": "Kuchařovice",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Kuchařovice",
    "val": "66902 Kucharovice Kucharovice"
  },
  {
    "cast": "Kuchyně",
    "psc": "59201",
    "okres": "Žďár nad Sázavou",
    "obec": "Herálec",
    "val": "59201 Heralec Kuchyne"
  },
  {
    "cast": "Kujavy",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Kujavy",
    "val": "74245 Kujavy Kujavy"
  },
  {
    "cast": "Kukle",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Tálín",
    "val": "39811 Talin Kukle"
  },
  {
    "cast": "Kukle",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Kukle",
    "val": "56802 Kukle Kukle"
  },
  {
    "cast": "Kukleny (část)",
    "psc": "50321",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50321 Hradec Kralove Kukleny (cast)"
  },
  {
    "cast": "Kukleny (část)",
    "psc": "50002",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50002 Hradec Kralove Kukleny (cast)"
  },
  {
    "cast": "Kukleny (část)",
    "psc": "50004",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50004 Hradec Kralove Kukleny (cast)"
  },
  {
    "cast": "Kukleny (část)",
    "psc": "50311",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50311 Hradec Kralove Kukleny (cast)"
  },
  {
    "cast": "Kuklík",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Kuklík",
    "val": "59203 Kuklik Kuklik"
  },
  {
    "cast": "Kuks",
    "psc": "54443",
    "okres": "Trutnov",
    "obec": "Kuks",
    "val": "54443 Kuks Kuks"
  },
  {
    "cast": "Kulířov",
    "psc": "67906",
    "okres": "Blansko",
    "obec": "Kulířov",
    "val": "67906 Kulirov Kulirov"
  },
  {
    "cast": "Kumburský Újezd",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Kumbursky Ujezd"
  },
  {
    "cast": "Kumpolec",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Tisová",
    "val": "34801 Tisova Kumpolec"
  },
  {
    "cast": "Kunačice",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Kunvald",
    "val": "56401 Kunvald Kunacice"
  },
  {
    "cast": "Kunčí",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Slatiňany",
    "val": "53821 Slatinany Kunci"
  },
  {
    "cast": "Kunčice",
    "psc": "75364",
    "okres": "Přerov",
    "obec": "Bělotín",
    "val": "75364 Belotin Kuncice"
  },
  {
    "cast": "Kunčice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Kunčice",
    "val": "50315 Kuncice Kuncice"
  },
  {
    "cast": "Kunčice",
    "psc": "71900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71900 Ostrava Kuncice"
  },
  {
    "cast": "Kunčice",
    "psc": "56151",
    "okres": "Ústí nad Orlicí",
    "obec": "Letohrad",
    "val": "56151 Letohrad Kuncice"
  },
  {
    "cast": "Kunčice",
    "psc": "78832",
    "okres": "Šumperk",
    "obec": "Staré Město",
    "val": "78832 Stare Mesto Kuncice"
  },
  {
    "cast": "Kunčice nad Labem (část)",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Kunčice nad Labem",
    "val": "54371 Kuncice nad Labem Kuncice nad Labem (cast)"
  },
  {
    "cast": "Kunčice nad Labem (část)",
    "psc": "54361",
    "okres": "Trutnov",
    "obec": "Kunčice nad Labem",
    "val": "54361 Kuncice nad Labem Kuncice nad Labem (cast)"
  },
  {
    "cast": "Kunčice pod Ondřejníkem",
    "psc": "73913",
    "okres": "Frýdek-Místek",
    "obec": "Kunčice pod Ondřejníkem",
    "val": "73913 Kuncice pod Ondrejnikem Kuncice pod Ondrejnikem"
  },
  {
    "cast": "Kunčičky",
    "psc": "71800",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71800 Ostrava Kuncicky"
  },
  {
    "cast": "Kunčičky u Bašky",
    "psc": "73901",
    "okres": "Frýdek-Místek",
    "obec": "Baška",
    "val": "73901 Baska Kuncicky u Basky"
  },
  {
    "cast": "Kunčina Ves",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Kunčina Ves",
    "val": "67971 Kuncina Ves Kuncina Ves"
  },
  {
    "cast": "Kunčina (část)",
    "psc": "56924",
    "okres": "Svitavy",
    "obec": "Kunčina",
    "val": "56924 Kuncina Kuncina (cast)"
  },
  {
    "cast": "Kunčina (část)",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Kunčina",
    "val": "57101 Kuncina Kuncina (cast)"
  },
  {
    "cast": "Kundratice",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Kundratice"
  },
  {
    "cast": "Kundratice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Košťálov",
    "val": "51401 Kostalov Kundratice"
  },
  {
    "cast": "Kundratice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Kundratice"
  },
  {
    "cast": "Kundratice",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Žiželice",
    "val": "28126 Zizelice Kundratice"
  },
  {
    "cast": "Kundratice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Hlinná",
    "val": "41201 Hlinna Kundratice"
  },
  {
    "cast": "Kundratice",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Sviny",
    "val": "39181 Sviny Kundratice"
  },
  {
    "cast": "Kundratice",
    "psc": "59257",
    "okres": "Žďár nad Sázavou",
    "obec": "Rozsochy",
    "val": "59257 Rozsochy Kundratice"
  },
  {
    "cast": "Kundratice",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Kundratice",
    "val": "59451 Kundratice Kundratice"
  },
  {
    "cast": "Kunějov",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Člunek",
    "val": "37833 Clunek Kunejov"
  },
  {
    "cast": "Kunějovice",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Kunějovice",
    "val": "33035 Kunejovice Kunejovice"
  },
  {
    "cast": "Kunemil",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Kunemil",
    "val": "58291 Kunemil Kunemil"
  },
  {
    "cast": "Kunětice",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Kunětice",
    "val": "53304 Kunetice Kunetice"
  },
  {
    "cast": "Kuní",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Kuni"
  },
  {
    "cast": "Kunice",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Kunice",
    "val": "67971 Kunice Kunice"
  },
  {
    "cast": "Kunice",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Kunice",
    "val": "25163 Kunice Kunice"
  },
  {
    "cast": "Kuníček",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Kunicek"
  },
  {
    "cast": "Kuničky",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Kuničky",
    "val": "67902 Kunicky Kunicky"
  },
  {
    "cast": "Kunín",
    "psc": "74253",
    "okres": "Nový Jičín",
    "obec": "Kunín",
    "val": "74253 Kunin Kunin"
  },
  {
    "cast": "Kunkovice",
    "psc": "76813",
    "okres": "Kroměříž",
    "obec": "Kunkovice",
    "val": "76813 Kunkovice Kunkovice"
  },
  {
    "cast": "Kunkovice (část)",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "34142 Cachrov Kunkovice (cast)"
  },
  {
    "cast": "Kunkovice (část)",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Kunkovice (cast)"
  },
  {
    "cast": "Kunov",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Bruntál",
    "val": "79201 Bruntal Kunov"
  },
  {
    "cast": "Kunovice",
    "psc": "75644",
    "okres": "Vsetín",
    "obec": "Kunovice",
    "val": "75644 Kunovice Kunovice"
  },
  {
    "cast": "Kunovice",
    "psc": "68604",
    "okres": "Uherské Hradiště",
    "obec": "Kunovice",
    "val": "68604 Kunovice Kunovice"
  },
  {
    "cast": "Kuňovice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Kuňovice",
    "val": "25765 Kunovice Kunovice"
  },
  {
    "cast": "Kunratice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Kunratice",
    "val": "40502 Kunratice Kunratice"
  },
  {
    "cast": "Kunratice",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Šluknov",
    "val": "40747 Sluknov Kunratice"
  },
  {
    "cast": "Kunratice",
    "psc": "14800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14800 Praha Kunratice"
  },
  {
    "cast": "Kunratice",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Kunratice",
    "val": "46401 Kunratice Kunratice"
  },
  {
    "cast": "Kunratice u Cvikova",
    "psc": "47155",
    "okres": "Česká Lípa",
    "obec": "Kunratice u Cvikova",
    "val": "47155 Kunratice u Cvikova Kunratice u Cvikova"
  },
  {
    "cast": "Kunratice-Liberec XXIX x)",
    "psc": "46015",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46015 Liberec Kunratice-Liberec XXIX x)"
  },
  {
    "cast": "Kunštát",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Kunštát",
    "val": "67972 Kunstat Kunstat"
  },
  {
    "cast": "Kunvald",
    "psc": "56181",
    "okres": "Ústí nad Orlicí",
    "obec": "Kunvald",
    "val": "56181 Kunvald Kunvald"
  },
  {
    "cast": "Kunžak (část)",
    "psc": "37862",
    "okres": "Jindřichův Hradec",
    "obec": "Kunžak",
    "val": "37862 Kunzak Kunzak (cast)"
  },
  {
    "cast": "Kunžak (část)",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Kunžak",
    "val": "37853 Kunzak Kunzak (cast)"
  },
  {
    "cast": "Kupařovice",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Kupařovice",
    "val": "66464 Kuparovice Kuparovice"
  },
  {
    "cast": "Kurdějov",
    "psc": "69301",
    "okres": "Břeclav",
    "obec": "Kurdějov",
    "val": "69301 Kurdejov Kurdejov"
  },
  {
    "cast": "Kurojedy",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Kurojedy"
  },
  {
    "cast": "Kuroslepy",
    "psc": "67575",
    "okres": "Třebíč",
    "obec": "Kuroslepy",
    "val": "67575 Kuroslepy Kuroslepy"
  },
  {
    "cast": "Kurovice",
    "psc": "76852",
    "okres": "Kroměříž",
    "obec": "Kurovice",
    "val": "76852 Kurovice Kurovice"
  },
  {
    "cast": "Kuří",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Říčany",
    "val": "25101 Ricany Kuri"
  },
  {
    "cast": "Kuří",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Kuri"
  },
  {
    "cast": "Kuřim",
    "psc": "66434",
    "okres": "Brno-venkov",
    "obec": "Kuřim",
    "val": "66434 Kurim Kurim"
  },
  {
    "cast": "Kuřimany",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Kuřimany",
    "val": "38601 Kurimany Kurimany"
  },
  {
    "cast": "Kuřimská Nová Ves (část)",
    "psc": "59456",
    "okres": "Brno-venkov",
    "obec": "Kuřimská Nová Ves",
    "val": "59456 Kurimska Nova Ves Kurimska Nova Ves (cast)"
  },
  {
    "cast": "Kuřimská Nová Ves (část)",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Kuřimská Nová Ves",
    "val": "59455 Kurimska Nova Ves Kurimska Nova Ves (cast)"
  },
  {
    "cast": "Kuřimské Jestřabí",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Kuřimské Jestřabí",
    "val": "59455 Kurimske Jestrabi Kurimske Jestrabi"
  },
  {
    "cast": "Kuřívody",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "47124 Ralsko Kurivody"
  },
  {
    "cast": "Kúsky",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Meziříčí",
    "val": "59401 Velke Mezirici Kusky"
  },
  {
    "cast": "Kůští",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Město Touškov",
    "val": "33033 Mesto Touskov Kusti"
  },
  {
    "cast": "Kutlíře",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Křečhoř",
    "val": "28002 Krechor Kutlire"
  },
  {
    "cast": "Kutná Hora-Vnitřní Město",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Kutna Hora-Vnitrni Mesto"
  },
  {
    "cast": "Kutrovice",
    "psc": "27375",
    "okres": "Kladno",
    "obec": "Kutrovice",
    "val": "27375 Kutrovice Kutrovice"
  },
  {
    "cast": "Kutřín",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Perálec",
    "val": "53944 Peralec Kutrin"
  },
  {
    "cast": "Kůzová",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Čistá",
    "val": "27034 Cista Kuzova"
  },
  {
    "cast": "Kuželov",
    "psc": "69673",
    "okres": "Hodonín",
    "obec": "Kuželov",
    "val": "69673 Kuzelov Kuzelov"
  },
  {
    "cast": "Kvačice",
    "psc": "68724",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Ostroh",
    "val": "68724 Uhersky Ostroh Kvacice"
  },
  {
    "cast": "Kvaň (část)",
    "psc": "26763",
    "okres": "Beroun",
    "obec": "Zaječov",
    "val": "26763 Zajecov Kvan (cast)"
  },
  {
    "cast": "Kvaň (část)",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Zaječov",
    "val": "26762 Zajecov Kvan (cast)"
  },
  {
    "cast": "Kvasejovice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Přehořov",
    "val": "39201 Prehorov Kvasejovice"
  },
  {
    "cast": "Kvasejovice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Kvasejovice"
  },
  {
    "cast": "Kvasetice",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34034 Planice Kvasetice"
  },
  {
    "cast": "Kvasetice",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Květinov",
    "val": "58001 Kvetinov Kvasetice"
  },
  {
    "cast": "Kvasice",
    "psc": "76821",
    "okres": "Kroměříž",
    "obec": "Kvasice",
    "val": "76821 Kvasice Kvasice"
  },
  {
    "cast": "Kvasín",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Tisovec",
    "val": "53973 Tisovec Kvasin"
  },
  {
    "cast": "Kvasiny",
    "psc": "51702",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kvasiny",
    "val": "51702 Kvasiny Kvasiny"
  },
  {
    "cast": "Kváskovice",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Drážov",
    "val": "38719 Drazov Kvaskovice"
  },
  {
    "cast": "Kváskovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Kváskovice",
    "val": "38601 Kvaskovice Kvaskovice"
  },
  {
    "cast": "Kvaslice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Kvaslice"
  },
  {
    "cast": "Kvášňovice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Kvášňovice",
    "val": "34101 Kvasnovice Kvasnovice"
  },
  {
    "cast": "Kvašťov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Kvastov"
  },
  {
    "cast": "Kvašťov",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Kvastov"
  },
  {
    "cast": "Květín",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Mohelnice",
    "val": "78985 Mohelnice Kvetin"
  },
  {
    "cast": "Květinov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Květinov",
    "val": "58001 Kvetinov Kvetinov"
  },
  {
    "cast": "Květná",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Květná",
    "val": "57201 Kvetna Kvetna"
  },
  {
    "cast": "Květná",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Krajková",
    "val": "35709 Krajkova Kvetna"
  },
  {
    "cast": "Květná",
    "psc": "68766",
    "okres": "Uherské Hradiště",
    "obec": "Strání",
    "val": "68766 Strani Kvetna"
  },
  {
    "cast": "Květná",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Luková",
    "val": "56301 Lukova Kvetna"
  },
  {
    "cast": "Květnice (část)",
    "psc": "25082",
    "okres": "Praha-východ",
    "obec": "Květnice",
    "val": "25082 Kvetnice Kvetnice (cast)"
  },
  {
    "cast": "Květnice (část)",
    "psc": "25084",
    "okres": "Praha-východ",
    "obec": "Květnice",
    "val": "25084 Kvetnice Kvetnice (cast)"
  },
  {
    "cast": "Květnov",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Blatno",
    "val": "43001 Blatno Kvetnov"
  },
  {
    "cast": "Květnov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Kvetnov"
  },
  {
    "cast": "Květnová",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Kvetnova"
  },
  {
    "cast": "Květoňov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Kvetonov"
  },
  {
    "cast": "Květov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Květov",
    "val": "39901 Kvetov Kvetov"
  },
  {
    "cast": "Květuš",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Kvetus"
  },
  {
    "cast": "Květušín",
    "psc": "38229",
    "okres": "Český Krumlov",
    "obec": "Polná na Šumavě",
    "val": "38229 Polna na Sumave Kvetusin"
  },
  {
    "cast": "Kvíc",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Kvic"
  },
  {
    "cast": "Kvíček",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Kvicek"
  },
  {
    "cast": "Kvíčovice",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Kvíčovice",
    "val": "34562 Kvicovice Kvicovice"
  },
  {
    "cast": "Kvilda",
    "psc": "38493",
    "okres": "Prachatice",
    "obec": "Kvilda",
    "val": "38493 Kvilda Kvilda"
  },
  {
    "cast": "Kvílice",
    "psc": "27375",
    "okres": "Kladno",
    "obec": "Kvílice",
    "val": "27375 Kvilice Kvilice"
  },
  {
    "cast": "Kvítkov",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Modlany",
    "val": "41501 Modlany Kvitkov"
  },
  {
    "cast": "Kvítkov",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Kvítkov",
    "val": "47001 Kvitkov Kvitkov"
  },
  {
    "cast": "Kvítkovice",
    "psc": "76502",
    "okres": "Zlín",
    "obec": "Otrokovice",
    "val": "76502 Otrokovice Kvitkovice"
  },
  {
    "cast": "Kvítkovice",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Kvítkovice",
    "val": "37384 Kvitkovice Kvitkovice"
  },
  {
    "cast": "Kvítkovice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Kvitkovice"
  },
  {
    "cast": "Kydliny",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Kydliny"
  },
  {
    "cast": "Kyje",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Kyje",
    "val": "50713 Kyje Kyje"
  },
  {
    "cast": "Kyje",
    "psc": "19800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19800 Praha Kyje"
  },
  {
    "cast": "Kyjov",
    "psc": "69701",
    "okres": "Hodonín",
    "obec": "Kyjov",
    "val": "69701 Kyjov Kyjov"
  },
  {
    "cast": "Kyjov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Buřenice",
    "val": "39501 Burenice Kyjov"
  },
  {
    "cast": "Kyjov",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40747 Krasna Lipa Kyjov"
  },
  {
    "cast": "Kyjov",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Kyjov",
    "val": "59214 Kyjov Kyjov"
  },
  {
    "cast": "Kyjov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Kyjov",
    "val": "58001 Kyjov Kyjov"
  },
  {
    "cast": "Kyjov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Zadní Chodov",
    "val": "34815 Zadni Chodov Kyjov"
  },
  {
    "cast": "Kyjovice",
    "psc": "74768",
    "okres": "Opava",
    "obec": "Kyjovice",
    "val": "74768 Kyjovice Kyjovice"
  },
  {
    "cast": "Kyjovice",
    "psc": "67161",
    "okres": "Znojmo",
    "obec": "Kyjovice",
    "val": "67161 Kyjovice Kyjovice"
  },
  {
    "cast": "Kylešovice",
    "psc": "74706",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74706 Opava Kylesovice"
  },
  {
    "cast": "Kynice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kynice",
    "val": "58401 Kynice Kynice"
  },
  {
    "cast": "Kynšperk nad Ohří",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kynšperk nad Ohří",
    "val": "35751 Kynsperk nad Ohri Kynsperk nad Ohri"
  },
  {
    "cast": "Kyselka",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Kyselka",
    "val": "36272 Kyselka Kyselka"
  },
  {
    "cast": "Kyselovice",
    "psc": "76811",
    "okres": "Kroměříž",
    "obec": "Kyselovice",
    "val": "76811 Kyselovice Kyselovice"
  },
  {
    "cast": "Kystra",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Slavětín",
    "val": "44001 Slavetin Kystra"
  },
  {
    "cast": "Kyšice",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Kyšice",
    "val": "27351 Kysice Kysice"
  },
  {
    "cast": "Kyšice",
    "psc": "33001",
    "okres": "Plzeň-město",
    "obec": "Kyšice",
    "val": "33001 Kysice Kysice"
  },
  {
    "cast": "Kyškovice",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Kyškovice",
    "val": "41301 Kyskovice Kyskovice"
  },
  {
    "cast": "Kýšovice",
    "psc": "43183",
    "okres": "Chomutov",
    "obec": "Výsluní",
    "val": "43183 Vysluni Kysovice"
  },
  {
    "cast": "Kytín",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Kytín",
    "val": "25210 Kytin Kytin"
  },
  {
    "cast": "Kytlice",
    "psc": "40745",
    "okres": "Děčín",
    "obec": "Kytlice",
    "val": "40745 Kytlice Kytlice"
  },
  {
    "cast": "Kyžlířov",
    "psc": "75362",
    "okres": "Přerov",
    "obec": "Potštát",
    "val": "75362 Potstat Kyzlirov"
  },
  {
    "cast": "Labe",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Labe"
  },
  {
    "cast": "Labětín",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Řečany nad Labem",
    "val": "53501 Recany nad Labem Labetin"
  },
  {
    "cast": "Labouň",
    "psc": "50733",
    "okres": "Jičín",
    "obec": "Jičíněves",
    "val": "50733 Jicineves Laboun"
  },
  {
    "cast": "Labská",
    "psc": "54351",
    "okres": "Trutnov",
    "obec": "Špindlerův Mlýn",
    "val": "54351 Spindleruv Mlyn Labska"
  },
  {
    "cast": "Labská Stráň",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Labská Stráň",
    "val": "40502 Labska Stran Labska Stran"
  },
  {
    "cast": "Labské Chrčice",
    "psc": "28126",
    "okres": "Pardubice",
    "obec": "Labské Chrčice",
    "val": "28126 Labske Chrcice Labske Chrcice"
  },
  {
    "cast": "Labuť",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Staré Sedliště",
    "val": "34801 Stare Sedliste Labut"
  },
  {
    "cast": "Labutice",
    "psc": "79845",
    "okres": "Prostějov",
    "obec": "Suchdol",
    "val": "79845 Suchdol Labutice"
  },
  {
    "cast": "Labuty",
    "psc": "69648",
    "okres": "Hodonín",
    "obec": "Labuty",
    "val": "69648 Labuty Labuty"
  },
  {
    "cast": "Laby (část)",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25801 Zvestov Laby (cast)"
  },
  {
    "cast": "Laby (část)",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Laby (cast)"
  },
  {
    "cast": "Laciná",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Myštice",
    "val": "38801 Mystice Lacina"
  },
  {
    "cast": "Lačnov",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Štěchov",
    "val": "67971 Stechov Lacnov"
  },
  {
    "cast": "Lačnov",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Korouhev",
    "val": "57201 Korouhev Lacnov"
  },
  {
    "cast": "Lačnov",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Svitavy",
    "val": "56802 Svitavy Lacnov"
  },
  {
    "cast": "Lačnov",
    "psc": "75612",
    "okres": "Vsetín",
    "obec": "Lačnov",
    "val": "75612 Lacnov Lacnov"
  },
  {
    "cast": "Lada",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Lada"
  },
  {
    "cast": "Lada v Podještědí",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Lada v Podjestedi"
  },
  {
    "cast": "Ladečka",
    "psc": "40757",
    "okres": "Děčín",
    "obec": "Horní Podluží",
    "val": "40757 Horni Podluzi Ladecka"
  },
  {
    "cast": "Ládeves",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Ladeves"
  },
  {
    "cast": "Ladín",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Konice",
    "val": "79852 Konice Ladin"
  },
  {
    "cast": "Ladná",
    "psc": "69146",
    "okres": "Břeclav",
    "obec": "Ladná",
    "val": "69146 Ladna Ladna"
  },
  {
    "cast": "Ládví",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Ladvi"
  },
  {
    "cast": "Lahošť",
    "psc": "41725",
    "okres": "Teplice",
    "obec": "Lahošť",
    "val": "41725 Lahost Lahost"
  },
  {
    "cast": "Lahovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Lahovice"
  },
  {
    "cast": "Lahovice",
    "psc": "15900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15900 Praha Lahovice"
  },
  {
    "cast": "Lahuť",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Mokrý Lom",
    "val": "37401 Mokry Lom Lahut"
  },
  {
    "cast": "Lachov",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Lachov"
  },
  {
    "cast": "Lachovice",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Lachovice"
  },
  {
    "cast": "Lachovice",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Vyšší Brod",
    "val": "38273 Vyssi Brod Lachovice"
  },
  {
    "cast": "Lampertice (část)",
    "psc": "54201",
    "okres": "Trutnov",
    "obec": "Lampertice",
    "val": "54201 Lampertice Lampertice (cast)"
  },
  {
    "cast": "Lampertice (část)",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Lampertice",
    "val": "54101 Lampertice Lampertice (cast)"
  },
  {
    "cast": "Lančov",
    "psc": "67106",
    "okres": "Znojmo",
    "obec": "Lančov",
    "val": "67106 Lancov Lancov"
  },
  {
    "cast": "Landštejn",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Město pod Landštejnem",
    "val": "37881 Stare Mesto pod Landstejnem Landstejn"
  },
  {
    "cast": "Lanškroun-Dolní Třešňovec x)",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Lanškroun",
    "val": "56301 Lanskroun Lanskroun-Dolni Tresnovec x)"
  },
  {
    "cast": "Lanškroun-Ostrovské Předměstí x)",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Lanškroun",
    "val": "56301 Lanskroun Lanskroun-Ostrovske Predmesti x)"
  },
  {
    "cast": "Lanškroun-Vnitřní Město",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Lanškroun",
    "val": "56301 Lanskroun Lanskroun-Vnitrni Mesto"
  },
  {
    "cast": "Lanškroun-Žichlínské Předměstí x)",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Lanškroun",
    "val": "56301 Lanskroun Lanskroun-Zichlinske Predmesti x)"
  },
  {
    "cast": "Lanšperk (část)",
    "psc": "56101",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Dobrouč",
    "val": "56101 Dolni Dobrouc Lansperk (cast)"
  },
  {
    "cast": "Lanšperk (část)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Dobrouč",
    "val": "56201 Dolni Dobrouc Lansperk (cast)"
  },
  {
    "cast": "Lány",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Lány",
    "val": "53701 Lany Lany"
  },
  {
    "cast": "Lány",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Svitavy",
    "val": "56802 Svitavy Lany"
  },
  {
    "cast": "Lány",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Lany"
  },
  {
    "cast": "Lány",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Lány",
    "val": "58301 Lany Lany"
  },
  {
    "cast": "Lány",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Červené Janovice",
    "val": "28601 Cervene Janovice Lany"
  },
  {
    "cast": "Lány",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Lany"
  },
  {
    "cast": "Lány",
    "psc": "28921",
    "okres": "Nymburk",
    "obec": "Kostomlaty nad Labem",
    "val": "28921 Kostomlaty nad Labem Lany"
  },
  {
    "cast": "Lány na Důlku",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Lany na Dulku"
  },
  {
    "cast": "Lány u Dašic",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Lány u Dašic",
    "val": "53002 Lany u Dasic Lany u Dasic"
  },
  {
    "cast": "Lány (část)",
    "psc": "27061",
    "okres": "Kladno",
    "obec": "Lány",
    "val": "27061 Lany Lany (cast)"
  },
  {
    "cast": "Lány (část)",
    "psc": "27101",
    "okres": "Kladno",
    "obec": "Lány",
    "val": "27101 Lany Lany (cast)"
  },
  {
    "cast": "Lanžhot",
    "psc": "69151",
    "okres": "Břeclav",
    "obec": "Lanžhot",
    "val": "69151 Lanzhot Lanzhot"
  },
  {
    "cast": "Lanžov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Lanžov",
    "val": "54401 Lanzov Lanzov"
  },
  {
    "cast": "Láryšov",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Býkov-Láryšov",
    "val": "79401 Bykov-Larysov Larysov"
  },
  {
    "cast": "Lásenice",
    "psc": "37801",
    "okres": "Jindřichův Hradec",
    "obec": "Lásenice",
    "val": "37801 Lasenice Lasenice"
  },
  {
    "cast": "Lasvice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Zákupy",
    "val": "47002 Zakupy Lasvice"
  },
  {
    "cast": "Laškov",
    "psc": "79857",
    "okres": "Prostějov",
    "obec": "Laškov",
    "val": "79857 Laskov Laskov"
  },
  {
    "cast": "Lašovice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Lasovice"
  },
  {
    "cast": "Lašovice",
    "psc": "27021",
    "okres": "Rakovník",
    "obec": "Lašovice",
    "val": "27021 Lasovice Lasovice"
  },
  {
    "cast": "Lašťany-Bělkovice x)",
    "psc": "78316",
    "okres": "Olomouc",
    "obec": "Bělkovice-Lašťany",
    "val": "78316 Belkovice-Lastany Lastany-Belkovice x)"
  },
  {
    "cast": "Laštovičky",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Rousměrov",
    "val": "59101 Rousmerov Lastovicky"
  },
  {
    "cast": "Latrán",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Latran"
  },
  {
    "cast": "Lavice",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Lavice"
  },
  {
    "cast": "Lavičky",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26401 Kosova Hora Lavicky"
  },
  {
    "cast": "Lavičky",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Lavičky",
    "val": "59401 Lavicky Lavicky"
  },
  {
    "cast": "Lavičné",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Lavičné",
    "val": "56904 Lavicne Lavicne"
  },
  {
    "cast": "Láz",
    "psc": "26241",
    "okres": "Příbram",
    "obec": "Láz",
    "val": "26241 Laz Laz"
  },
  {
    "cast": "Láz",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kladruby",
    "val": "34901 Kladruby Laz"
  },
  {
    "cast": "Láz",
    "psc": "67541",
    "okres": "Třebíč",
    "obec": "Láz",
    "val": "67541 Laz Laz"
  },
  {
    "cast": "Láz",
    "psc": "38462",
    "okres": "Prachatice",
    "obec": "Nová Pec",
    "val": "38462 Nova Pec Laz"
  },
  {
    "cast": "Láz",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Radomyšl",
    "val": "38601 Radomysl Laz"
  },
  {
    "cast": "Lazce",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Lazce"
  },
  {
    "cast": "Lazce",
    "psc": "78383",
    "okres": "Olomouc",
    "obec": "Troubelice",
    "val": "78383 Troubelice Lazce"
  },
  {
    "cast": "Lazce",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Lazce"
  },
  {
    "cast": "Lazec",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38101 Kajov Lazec"
  },
  {
    "cast": "Lazec (část)",
    "psc": "26241",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26241 Pribram Lazec (cast)"
  },
  {
    "cast": "Lazec (část)",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Lazec (cast)"
  },
  {
    "cast": "Lazinov",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Lazinov",
    "val": "67962 Lazinov Lazinov"
  },
  {
    "cast": "Laziště",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Králova Lhota",
    "val": "39804 Kralova Lhota Laziste"
  },
  {
    "cast": "Laziště",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Pertoltice",
    "val": "28522 Pertoltice Laziste"
  },
  {
    "cast": "Lázně Bělohrad",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Lazne Belohrad"
  },
  {
    "cast": "Lázně Bohdaneč",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Lázně Bohdaneč",
    "val": "53341 Lazne Bohdanec Lazne Bohdanec"
  },
  {
    "cast": "Lázně Darkov",
    "psc": "73503",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73503 Karvina Lazne Darkov"
  },
  {
    "cast": "Lázně Kundratice (část)",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Osečná",
    "val": "46352 Osecna Lazne Kundratice (cast)"
  },
  {
    "cast": "Lázně Kundratice (část)",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Osečná",
    "val": "46343 Osecna Lazne Kundratice (cast)"
  },
  {
    "cast": "Lázně Kynžvart",
    "psc": "35491",
    "okres": "Cheb",
    "obec": "Lázně Kynžvart",
    "val": "35491 Lazne Kynzvart Lazne Kynzvart"
  },
  {
    "cast": "Lázně Libverda",
    "psc": "46362",
    "okres": "Liberec",
    "obec": "Lázně Libverda",
    "val": "46362 Lazne Libverda Lazne Libverda"
  },
  {
    "cast": "Lázně Toušeň",
    "psc": "25089",
    "okres": "Praha-východ",
    "obec": "Lázně Toušeň",
    "val": "25089 Lazne Tousen Lazne Tousen"
  },
  {
    "cast": "Lazníčky",
    "psc": "75125",
    "okres": "Přerov",
    "obec": "Lazníčky",
    "val": "75125 Laznicky Laznicky"
  },
  {
    "cast": "Lazníky",
    "psc": "75125",
    "okres": "Přerov",
    "obec": "Lazníky",
    "val": "75125 Lazniky Lazniky"
  },
  {
    "cast": "Lazsko",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Lazsko",
    "val": "26231 Lazsko Lazsko"
  },
  {
    "cast": "Lazy",
    "psc": "73511",
    "okres": "Karviná",
    "obec": "Orlová",
    "val": "73511 Orlova Lazy"
  },
  {
    "cast": "Lazy",
    "psc": "35491",
    "okres": "Cheb",
    "obec": "Lázně Kynžvart",
    "val": "35491 Lazne Kynzvart Lazy"
  },
  {
    "cast": "Lázy",
    "psc": "75644",
    "okres": "Vsetín",
    "obec": "Loučka",
    "val": "75644 Loucka Lazy"
  },
  {
    "cast": "Lázy",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "56943 Mestecko Trnavka Lazy"
  },
  {
    "cast": "Lažánky",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Lazanky"
  },
  {
    "cast": "Lažánky",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Lažánky",
    "val": "38801 Lazanky Lazanky"
  },
  {
    "cast": "Lažánky",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Lazanky"
  },
  {
    "cast": "Lažánky",
    "psc": "66471",
    "okres": "Brno-venkov",
    "obec": "Lažánky",
    "val": "66471 Lazanky Lazanky"
  },
  {
    "cast": "Lažany",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Radenín",
    "val": "39155 Radenin Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Mezno",
    "val": "25786 Mezno Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Vyskeř",
    "val": "51101 Vysker Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "67922",
    "okres": "Blansko",
    "obec": "Lažany",
    "val": "67922 Lazany Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34901 Cernosin Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Lažany",
    "val": "38801 Lazany Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Morašice",
    "val": "57001 Morasice Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Štědrá",
    "val": "36452 Stedra Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Přestavlky",
    "val": "33401 Prestavlky Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Hrušovany",
    "val": "43001 Hrusovany Lazany"
  },
  {
    "cast": "Lažany",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Lažany",
    "val": "46345 Lazany Lazany"
  },
  {
    "cast": "Lažínky",
    "psc": "67602",
    "okres": "Třebíč",
    "obec": "Moravské Budějovice",
    "val": "67602 Moravske Budejovice Lazinky"
  },
  {
    "cast": "Lažiště",
    "psc": "38432",
    "okres": "Prachatice",
    "obec": "Lažiště",
    "val": "38432 Laziste Laziste"
  },
  {
    "cast": "Lažišťka",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Nebahovy",
    "val": "38301 Nebahovy Lazistka"
  },
  {
    "cast": "Lážovice",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Lážovice",
    "val": "26724 Lazovice Lazovice"
  },
  {
    "cast": "Lbín",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bžany",
    "val": "41501 Bzany Lbin"
  },
  {
    "cast": "Lbín",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Hlinná",
    "val": "41201 Hlinna Lbin"
  },
  {
    "cast": "Lbosín",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Divišov",
    "val": "25726 Divisov Lbosin"
  },
  {
    "cast": "Lčovice",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Lčovice",
    "val": "38481 Lcovice Lcovice"
  },
  {
    "cast": "Lebedov",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Zdounky",
    "val": "76802 Zdounky Lebedov"
  },
  {
    "cast": "Leč",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Liteň",
    "val": "26727 Liten Lec"
  },
  {
    "cast": "Leč",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Skuhrov",
    "val": "26727 Skuhrov Lec"
  },
  {
    "cast": "Ledce",
    "psc": "27305",
    "okres": "Kladno",
    "obec": "Ledce",
    "val": "27305 Ledce Ledce"
  },
  {
    "cast": "Ledce",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Nespeky",
    "val": "25722 Nespeky Ledce"
  },
  {
    "cast": "Ledce",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Kadlín",
    "val": "27735 Kadlin Ledce"
  },
  {
    "cast": "Ledce",
    "psc": "33014",
    "okres": "Plzeň-sever",
    "obec": "Ledce",
    "val": "33014 Ledce Ledce"
  },
  {
    "cast": "Ledce",
    "psc": "66462",
    "okres": "Brno-venkov",
    "obec": "Ledce",
    "val": "66462 Ledce Ledce"
  },
  {
    "cast": "Ledce",
    "psc": "51771",
    "okres": "Hradec Králové",
    "obec": "Ledce",
    "val": "51771 Ledce Ledce"
  },
  {
    "cast": "Ledce",
    "psc": "29447",
    "okres": "Mladá Boleslav",
    "obec": "Ledce",
    "val": "29447 Ledce Ledce"
  },
  {
    "cast": "Ledčice",
    "psc": "27708",
    "okres": "Mělník",
    "obec": "Ledčice",
    "val": "27708 Ledcice Ledcice"
  },
  {
    "cast": "Ledec",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Choltice",
    "val": "53501 Choltice Ledec"
  },
  {
    "cast": "Ledeč nad Sázavou",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Ledeč nad Sázavou",
    "val": "58401 Ledec nad Sazavou Ledec nad Sazavou"
  },
  {
    "cast": "Ledečko",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Ledečko",
    "val": "28506 Ledecko Ledecko"
  },
  {
    "cast": "Ledečky",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Rožďalovice",
    "val": "28934 Rozdalovice Ledecky"
  },
  {
    "cast": "Ledenice",
    "psc": "37311",
    "okres": "České Budějovice",
    "obec": "Ledenice",
    "val": "37311 Ledenice Ledenice"
  },
  {
    "cast": "Ledkov",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Kopidlno",
    "val": "50732 Kopidlno Ledkov"
  },
  {
    "cast": "Lednice",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kozojedy",
    "val": "33141 Kozojedy Lednice"
  },
  {
    "cast": "Lednice",
    "psc": "69144",
    "okres": "Břeclav",
    "obec": "Lednice",
    "val": "69144 Lednice Lednice"
  },
  {
    "cast": "Ledská",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Hřibiny-Ledská",
    "val": "51741 Hribiny-Ledska Ledska"
  },
  {
    "cast": "Ledvice",
    "psc": "41772",
    "okres": "Teplice",
    "obec": "Ledvice",
    "val": "41772 Ledvice Ledvice"
  },
  {
    "cast": "Lehom",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Lehom"
  },
  {
    "cast": "Lechotice",
    "psc": "76852",
    "okres": "Kroměříž",
    "obec": "Lechotice",
    "val": "76852 Lechotice Lechotice"
  },
  {
    "cast": "Lechovice",
    "psc": "67163",
    "okres": "Znojmo",
    "obec": "Lechovice",
    "val": "67163 Lechovice Lechovice"
  },
  {
    "cast": "Lejčkov",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Lejckov"
  },
  {
    "cast": "Lejšovka",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Lejšovka",
    "val": "50303 Lejsovka Lejsovka"
  },
  {
    "cast": "Lékařova Lhota",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Sedlec",
    "val": "37348 Sedlec Lekarova Lhota"
  },
  {
    "cast": "Lelekovice",
    "psc": "66431",
    "okres": "Brno-venkov",
    "obec": "Lelekovice",
    "val": "66431 Lelekovice Lelekovice"
  },
  {
    "cast": "Leletice",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Hvožďany",
    "val": "26242 Hvozdany Leletice"
  },
  {
    "cast": "Lelov",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Stod",
    "val": "33301 Stod Lelov"
  },
  {
    "cast": "Lelov",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Žalany",
    "val": "41501 Zalany Lelov"
  },
  {
    "cast": "Lenešice",
    "psc": "43923",
    "okres": "Louny",
    "obec": "Lenešice",
    "val": "43923 Lenesice Lenesice"
  },
  {
    "cast": "Lenora",
    "psc": "38442",
    "okres": "Prachatice",
    "obec": "Lenora",
    "val": "38442 Lenora Lenora"
  },
  {
    "cast": "Lensedly",
    "psc": "25165",
    "okres": "Praha-východ",
    "obec": "Kaliště",
    "val": "25165 Kaliste Lensedly"
  },
  {
    "cast": "Leopoldka",
    "psc": "40778",
    "okres": "Děčín",
    "obec": "Velký Šenov",
    "val": "40778 Velky Senov Leopoldka"
  },
  {
    "cast": "Leopoldov",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Leopoldov"
  },
  {
    "cast": "Leptač",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Chroboly",
    "val": "38301 Chroboly Leptac"
  },
  {
    "cast": "Lesáky",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Pravonín",
    "val": "25708 Pravonin Lesaky"
  },
  {
    "cast": "Lesík",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36221 Nejdek Lesik"
  },
  {
    "cast": "Lesina",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Lesina"
  },
  {
    "cast": "Lesinka",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Lesinka"
  },
  {
    "cast": "Leská",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebívlice",
    "val": "41115 Trebivlice Leska"
  },
  {
    "cast": "Leskovec",
    "psc": "74744",
    "okres": "Opava",
    "obec": "Březová",
    "val": "74744 Brezova Leskovec"
  },
  {
    "cast": "Leskovec",
    "psc": "75611",
    "okres": "Vsetín",
    "obec": "Leskovec",
    "val": "75611 Leskovec Leskovec"
  },
  {
    "cast": "Léskovec",
    "psc": "39464",
    "okres": "Pelhřimov",
    "obec": "Počátky",
    "val": "39464 Pocatky Leskovec"
  },
  {
    "cast": "Leskovec nad Moravicí",
    "psc": "79368",
    "okres": "Bruntál",
    "obec": "Leskovec nad Moravicí",
    "val": "79368 Leskovec nad Moravici Leskovec nad Moravici"
  },
  {
    "cast": "Leskovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Radomyšl",
    "val": "38601 Radomysl Leskovice"
  },
  {
    "cast": "Leskovice (část)",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Leskovice",
    "val": "39301 Leskovice Leskovice (cast)"
  },
  {
    "cast": "Leskovice (část)",
    "psc": "39414",
    "okres": "Pelhřimov",
    "obec": "Leskovice",
    "val": "39414 Leskovice Leskovice (cast)"
  },
  {
    "cast": "Lesná",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Lesná",
    "val": "67102 Lesna Lesna"
  },
  {
    "cast": "Lesná",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Lesná",
    "val": "34701 Lesna Lesna"
  },
  {
    "cast": "Lesná",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Lesná",
    "val": "39501 Lesna Lesna"
  },
  {
    "cast": "Lesná",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Lesná",
    "val": "67526 Lesna Lesna"
  },
  {
    "cast": "Lesná",
    "psc": "43545",
    "okres": "Most",
    "obec": "Nová Ves v Horách",
    "val": "43545 Nova Ves v Horach Lesna"
  },
  {
    "cast": "Lesná (část)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Lesna (cast)"
  },
  {
    "cast": "Lesná (část)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Lesna (cast)"
  },
  {
    "cast": "Lesná (část)",
    "psc": "63800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63800 Brno Lesna (cast)"
  },
  {
    "cast": "Lesná-Děčín XXXV x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Lesna-Decin XXXV x)"
  },
  {
    "cast": "Lesné",
    "psc": "40756",
    "okres": "Děčín",
    "obec": "Jiřetín pod Jedlovou",
    "val": "40756 Jiretin pod Jedlovou Lesne"
  },
  {
    "cast": "Lesní Albrechtice",
    "psc": "74744",
    "okres": "Opava",
    "obec": "Březová",
    "val": "74744 Brezova Lesni Albrechtice"
  },
  {
    "cast": "Lesní Hluboké",
    "psc": "66483",
    "okres": "Brno-venkov",
    "obec": "Lesní Hluboké",
    "val": "66483 Lesni Hluboke Lesni Hluboke"
  },
  {
    "cast": "Lesní Jakubov",
    "psc": "67573",
    "okres": "Třebíč",
    "obec": "Lesní Jakubov",
    "val": "67573 Lesni Jakubov Lesni Jakubov"
  },
  {
    "cast": "Lesnice",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Lesnice",
    "val": "78901 Lesnice Lesnice"
  },
  {
    "cast": "Lesnovek",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Hlavice",
    "val": "46348 Hlavice Lesnovek"
  },
  {
    "cast": "Lesonice",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Lesonice",
    "val": "67544 Lesonice Lesonice"
  },
  {
    "cast": "Lesonice",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Lesonice",
    "val": "67201 Lesonice Lesonice"
  },
  {
    "cast": "Lesoňovice",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Lesonovice"
  },
  {
    "cast": "Lesov",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Sadov",
    "val": "36001 Sadov Lesov"
  },
  {
    "cast": "Lestkov",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Lestkov",
    "val": "34953 Lestkov Lestkov"
  },
  {
    "cast": "Lestkov",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Lestkov"
  },
  {
    "cast": "Lestkov",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Radostná pod Kozákovem",
    "val": "51263 Radostna pod Kozakovem Lestkov"
  },
  {
    "cast": "Lesůňky",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Lesůňky",
    "val": "67551 Lesunky Lesunky"
  },
  {
    "cast": "Lešany",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Lesany"
  },
  {
    "cast": "Lešany",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Lešany",
    "val": "25744 Lesany Lesany"
  },
  {
    "cast": "Lešany",
    "psc": "27751",
    "okres": "Mělník",
    "obec": "Nelahozeves",
    "val": "27751 Nelahozeves Lesany"
  },
  {
    "cast": "Lešany",
    "psc": "79842",
    "okres": "Prostějov",
    "obec": "Lešany",
    "val": "79842 Lesany Lesany"
  },
  {
    "cast": "Lešetice",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Lešetice",
    "val": "26231 Lesetice Lesetice"
  },
  {
    "cast": "Lešišov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Mokrosuky",
    "val": "34201 Mokrosuky Lesisov"
  },
  {
    "cast": "Leškovice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Leškovice",
    "val": "58282 Leskovice Leskovice"
  },
  {
    "cast": "Lešná (část)",
    "psc": "75641",
    "okres": "Vsetín",
    "obec": "Lešná",
    "val": "75641 Lesna Lesna (cast)"
  },
  {
    "cast": "Lešná (část)",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Lešná",
    "val": "75701 Lesna Lesna (cast)"
  },
  {
    "cast": "Lešov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Lesov"
  },
  {
    "cast": "Lešovice",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Lesovice"
  },
  {
    "cast": "Leština",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50743 Markvartice Lestina"
  },
  {
    "cast": "Leština",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Slapsko",
    "val": "39143 Slapsko Lestina"
  },
  {
    "cast": "Leština",
    "psc": "78971",
    "okres": "Šumperk",
    "obec": "Leština",
    "val": "78971 Lestina Lestina"
  },
  {
    "cast": "Leština",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Strmilov",
    "val": "37853 Strmilov Lestina"
  },
  {
    "cast": "Leština",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Věž",
    "val": "58001 Vez Lestina"
  },
  {
    "cast": "Leština",
    "psc": "53944",
    "okres": "Ústí nad Orlicí",
    "obec": "Leština",
    "val": "53944 Lestina Lestina"
  },
  {
    "cast": "Leština",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kozlov",
    "val": "58401 Kozlov Lestina"
  },
  {
    "cast": "Leština",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malé Březno",
    "val": "40002 Male Brezno Lestina"
  },
  {
    "cast": "Leština u Světlé (část)",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Leština u Světlé",
    "val": "58401 Lestina u Svetle Lestina u Svetle (cast)"
  },
  {
    "cast": "Leština u Světlé (část)",
    "psc": "58286",
    "okres": "Havlíčkův Brod",
    "obec": "Leština u Světlé",
    "val": "58286 Lestina u Svetle Lestina u Svetle (cast)"
  },
  {
    "cast": "Leštinka",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Leštinka",
    "val": "53973 Lestinka Lestinka"
  },
  {
    "cast": "Leštinka",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Lestinka"
  },
  {
    "cast": "Letařovice",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Letarovice"
  },
  {
    "cast": "Letiny",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Letiny",
    "val": "33601 Letiny Letiny"
  },
  {
    "cast": "Letkov",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Letkov",
    "val": "32600 Letkov Letkov"
  },
  {
    "cast": "Letkovice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Ivančice",
    "val": "66491 Ivancice Letkovice"
  },
  {
    "cast": "Letňany (část)",
    "psc": "19000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19000 Praha Letnany (cast)"
  },
  {
    "cast": "Letňany (část)",
    "psc": "19900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19900 Praha Letnany (cast)"
  },
  {
    "cast": "Letná-Děčín VI x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Letna-Decin VI x)"
  },
  {
    "cast": "Letny",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Dobrá Voda",
    "val": "39301 Dobra Voda Letny"
  },
  {
    "cast": "Letohrad",
    "psc": "56151",
    "okres": "Ústí nad Orlicí",
    "obec": "Letohrad",
    "val": "56151 Letohrad Letohrad"
  },
  {
    "cast": "Letonice (část)",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Letonice",
    "val": "68501 Letonice Letonice (cast)"
  },
  {
    "cast": "Letonice (část)",
    "psc": "68335",
    "okres": "Vyškov",
    "obec": "Letonice",
    "val": "68335 Letonice Letonice (cast)"
  },
  {
    "cast": "Letošov",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Nesovice",
    "val": "68333 Nesovice Letosov"
  },
  {
    "cast": "Letov",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Letov"
  },
  {
    "cast": "Letovice",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Letovice"
  },
  {
    "cast": "Letovy",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Letovy"
  },
  {
    "cast": "Lety",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Lety",
    "val": "39804 Lety Lety"
  },
  {
    "cast": "Lety (část)",
    "psc": "25230",
    "okres": "Praha-západ",
    "obec": "Lety",
    "val": "25230 Lety Lety (cast)"
  },
  {
    "cast": "Lety (část)",
    "psc": "25229",
    "okres": "Praha-západ",
    "obec": "Lety",
    "val": "25229 Lety Lety (cast)"
  },
  {
    "cast": "Levín",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Levín",
    "val": "41145 Levin Levin"
  },
  {
    "cast": "Levín",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Králův Dvůr",
    "val": "26701 Kraluv Dvur Levin"
  },
  {
    "cast": "Levín",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Olešnice",
    "val": "50351 Olesnice Levin"
  },
  {
    "cast": "Levín",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Levin"
  },
  {
    "cast": "Levínská Olešnice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Levínská Olešnice",
    "val": "51401 Levinska Olesnice Levinska Olesnice"
  },
  {
    "cast": "Levínské Petrovice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Lovečkovice",
    "val": "41145 Loveckovice Levinske Petrovice"
  },
  {
    "cast": "Levonice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Levonice"
  },
  {
    "cast": "Levousy",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Křesín",
    "val": "41002 Kresin Levousy"
  },
  {
    "cast": "Lezník",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Polička",
    "val": "57201 Policka Leznik"
  },
  {
    "cast": "Ležky",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Lezky"
  },
  {
    "cast": "Lháň",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Radim",
    "val": "50713 Radim Lhan"
  },
  {
    "cast": "Lhánice",
    "psc": "67575",
    "okres": "Třebíč",
    "obec": "Lhánice",
    "val": "67575 Lhanice Lhanice"
  },
  {
    "cast": "Lhenice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bžany",
    "val": "41501 Bzany Lhenice"
  },
  {
    "cast": "Lhenice (část)",
    "psc": "38402",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38402 Lhenice Lhenice (cast)"
  },
  {
    "cast": "Lhenice (část)",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38411 Lhenice Lhenice (cast)"
  },
  {
    "cast": "Lhota",
    "psc": "75643",
    "okres": "Vsetín",
    "obec": "Kelč",
    "val": "75643 Kelc Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Lhota",
    "val": "76302 Lhota Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Liběšice",
    "val": "43801 Libesice Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34901 Cernosin Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Chuchelna",
    "val": "51301 Chuchelna Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "27714",
    "okres": "Praha-východ",
    "obec": "Lhota",
    "val": "27714 Lhota Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Přelouč",
    "val": "53501 Prelouc Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Netvořice",
    "val": "25744 Netvorice Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Chříč",
    "val": "33141 Chric Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "59245",
    "okres": "Žďár nad Sázavou",
    "obec": "Lísek",
    "val": "59245 Lisek Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "76834",
    "okres": "Kroměříž",
    "obec": "Pačlavice",
    "val": "76834 Paclavice Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lhota",
    "val": "75131 Lhota Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41115 Trebenice Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Čistá",
    "val": "27034 Cista Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "75642",
    "okres": "Vsetín",
    "obec": "Valašské Meziříčí",
    "val": "75642 Valasske Mezirici Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Merklín",
    "val": "33452 Merklin Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "74792",
    "okres": "Opava",
    "obec": "Háj ve Slezsku",
    "val": "74792 Haj ve Slezsku Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Mladošovice",
    "val": "37312 Mladosovice Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Dynín",
    "val": "37365 Dynin Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Číměř",
    "val": "37833 Cimer Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "25241",
    "okres": "Praha-západ",
    "obec": "Dolní Břežany",
    "val": "25241 Dolni Brezany Lhota"
  },
  {
    "cast": "Lhota",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Lhota-Vlasenice",
    "val": "39470 Lhota-Vlasenice Lhota"
  },
  {
    "cast": "Lhota Bubeneč",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Křivsoudov",
    "val": "25765 Krivsoudov Lhota Bubenec"
  },
  {
    "cast": "Lhota nad Moravou",
    "psc": "78332",
    "okres": "Olomouc",
    "obec": "Náklo",
    "val": "78332 Naklo Lhota nad Moravou"
  },
  {
    "cast": "Lhota nad Rohanovem",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Lhota nad Rohanovem"
  },
  {
    "cast": "Lhota Netřeba",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Podbřezí",
    "val": "51801 Podbrezi Lhota Netreba"
  },
  {
    "cast": "Lhota pod Džbánem",
    "psc": "27007",
    "okres": "Rakovník",
    "obec": "Mutějovice",
    "val": "27007 Mutejovice Lhota pod Dzbanem"
  },
  {
    "cast": "Lhota pod Horami",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Lhota pod Horami"
  },
  {
    "cast": "Lhota pod Hořičkami",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Lhota pod Hořičkami",
    "val": "55205 Lhota pod Horickami Lhota pod Horickami"
  },
  {
    "cast": "Lhota pod Kosířem",
    "psc": "78344",
    "okres": "Olomouc",
    "obec": "Drahanovice",
    "val": "78344 Drahanovice Lhota pod Kosirem"
  },
  {
    "cast": "Lhota pod Kůstrým",
    "psc": "34201",
    "okres": "Strakonice",
    "obec": "Nová Ves",
    "val": "34201 Nova Ves Lhota pod Kustrym"
  },
  {
    "cast": "Lhota pod Libčany",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Lhota pod Libčany",
    "val": "50327 Lhota pod Libcany Lhota pod Libcany"
  },
  {
    "cast": "Lhota pod Pannou",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Lhota pod Pannou"
  },
  {
    "cast": "Lhota pod Radčem",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Lhota pod Radčem",
    "val": "33701 Lhota pod Radcem Lhota pod Radcem"
  },
  {
    "cast": "Lhota Rapotina",
    "psc": "67901",
    "okres": "Blansko",
    "obec": "Lhota Rapotina",
    "val": "67901 Lhota Rapotina Lhota Rapotina"
  },
  {
    "cast": "Lhota Samoty (část)",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Planá nad Lužnicí",
    "val": "39002 Plana nad Luznici Lhota Samoty (cast)"
  },
  {
    "cast": "Lhota Samoty (část)",
    "psc": "39101",
    "okres": "Tábor",
    "obec": "Planá nad Lužnicí",
    "val": "39101 Plana nad Luznici Lhota Samoty (cast)"
  },
  {
    "cast": "Lhota Samoty (část)",
    "psc": "39102",
    "okres": "Tábor",
    "obec": "Planá nad Lužnicí",
    "val": "39102 Plana nad Luznici Lhota Samoty (cast)"
  },
  {
    "cast": "Lhota Samoty (část)",
    "psc": "39111",
    "okres": "Tábor",
    "obec": "Planá nad Lužnicí",
    "val": "39111 Plana nad Luznici Lhota Samoty (cast)"
  },
  {
    "cast": "Lhota u Chroustovic",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Chroustovice",
    "val": "53863 Chroustovice Lhota u Chroustovic"
  },
  {
    "cast": "Lhota u Kestřan",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Kestřany",
    "val": "39701 Kestrany Lhota u Kestran"
  },
  {
    "cast": "Lhota u Konice",
    "psc": "79845",
    "okres": "Prostějov",
    "obec": "Brodek u Konice",
    "val": "79845 Brodek u Konice Lhota u Konice"
  },
  {
    "cast": "Lhota u Lysic",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Lhota u Lysic",
    "val": "67971 Lhota u Lysic Lhota u Lysic"
  },
  {
    "cast": "Lhota u Olešnice",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Lhota u Olešnice",
    "val": "67974 Lhota u Olesnice Lhota u Olesnice"
  },
  {
    "cast": "Lhota u Příbramě",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Lhota u Příbramě",
    "val": "26101 Lhota u Pribrame Lhota u Pribrame"
  },
  {
    "cast": "Lhota u Skutče",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Lhota u Skutce"
  },
  {
    "cast": "Lhota u Stříbra",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Stříbro",
    "val": "34901 Stribro Lhota u Stribra"
  },
  {
    "cast": "Lhota u Svaté Anny",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Kraselov",
    "val": "38716 Kraselov Lhota u Svate Anny"
  },
  {
    "cast": "Lhota u Vsetína",
    "psc": "75501",
    "okres": "Vsetín",
    "obec": "Lhota u Vsetína",
    "val": "75501 Lhota u Vsetina Lhota u Vsetina"
  },
  {
    "cast": "Lhota Veselka",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Lhota Veselka"
  },
  {
    "cast": "Lhota za Červeným Kostelcem",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Červený Kostelec",
    "val": "54941 Cerveny Kostelec Lhota za Cervenym Kostelcem"
  },
  {
    "cast": "Lhota (část)",
    "psc": "27101",
    "okres": "Kladno",
    "obec": "Lhota",
    "val": "27101 Lhota Lhota (cast)"
  },
  {
    "cast": "Lhota (část)",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Nahořany",
    "val": "55203 Nahorany Lhota (cast)"
  },
  {
    "cast": "Lhota (část)",
    "psc": "27301",
    "okres": "Kladno",
    "obec": "Lhota",
    "val": "27301 Lhota Lhota (cast)"
  },
  {
    "cast": "Lhota (část)",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nahořany",
    "val": "54901 Nahorany Lhota (cast)"
  },
  {
    "cast": "Lhotice",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Lhotice",
    "val": "67531 Lhotice Lhotice"
  },
  {
    "cast": "Lhotice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Želiv",
    "val": "39601 Zeliv Lhotice"
  },
  {
    "cast": "Lhotice",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Lhotice"
  },
  {
    "cast": "Lhotice",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Lhotice"
  },
  {
    "cast": "Lhotka",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76302 Zlin Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Lhotka",
    "val": "58856 Lhotka Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Svinaře",
    "val": "26727 Svinare Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74901 Vitkov Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Lhotka",
    "val": "75124 Lhotka Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Obořiště",
    "val": "26301 Oboriste Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "26723",
    "okres": "Beroun",
    "obec": "Lhotka",
    "val": "26723 Lhotka Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Tisová",
    "val": "34801 Tisova Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Bílovec",
    "val": "74301 Bilovec Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Nekmíř",
    "val": "33152 Nekmir Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kostelany",
    "val": "76701 Kostelany Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "73947",
    "okres": "Frýdek-Místek",
    "obec": "Lhotka",
    "val": "73947 Lhotka Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Ostrovec-Lhotka",
    "val": "33808 Ostrovec-Lhotka Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "72528",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72528 Ostrava Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25753 Vojkov Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Ruda",
    "val": "59401 Ruda Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Lanžov",
    "val": "54401 Lanzov Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "68733",
    "okres": "Uherské Hradiště",
    "obec": "Hradčovice",
    "val": "68733 Hradcovice Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Lhotka",
    "val": "59101 Lhotka Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Klášterec nad Orlicí",
    "val": "56401 Klasterec nad Orlici Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Česká Třebová",
    "val": "56002 Ceska Trebova Lhotka"
  },
  {
    "cast": "Lhotka",
    "psc": "46847",
    "okres": "Jablonec nad Nisou",
    "obec": "Zlatá Olešnice",
    "val": "46847 Zlata Olesnice Lhotka"
  },
  {
    "cast": "Lhotka nad Bečvou",
    "psc": "75641",
    "okres": "Vsetín",
    "obec": "Lešná",
    "val": "75641 Lesna Lhotka nad Becvou"
  },
  {
    "cast": "Lhotka nad Labem",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Lhotka nad Labem",
    "val": "41002 Lhotka nad Labem Lhotka nad Labem"
  },
  {
    "cast": "Lhotka u Berouna",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Chyňava",
    "val": "26601 Chynava Lhotka u Berouna"
  },
  {
    "cast": "Lhotka u Litultovic",
    "psc": "74755",
    "okres": "Opava",
    "obec": "Lhotka u Litultovic",
    "val": "74755 Lhotka u Litultovic Lhotka u Litultovic"
  },
  {
    "cast": "Lhotka u Radnic",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Lhotka u Radnic",
    "val": "33824 Lhotka u Radnic Lhotka u Radnic"
  },
  {
    "cast": "Lhotka (část)",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Lhotka",
    "val": "27601 Lhotka Lhotka (cast)"
  },
  {
    "cast": "Lhotka (část)",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Lhotka",
    "val": "27731 Lhotka Lhotka (cast)"
  },
  {
    "cast": "Lhotka (část)",
    "psc": "14700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14700 Praha Lhotka (cast)"
  },
  {
    "cast": "Lhotka (část)",
    "psc": "14200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14200 Praha Lhotka (cast)"
  },
  {
    "cast": "Lhotka (část)",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Olešnice",
    "val": "37401 Olesnice Lhotka (cast)"
  },
  {
    "cast": "Lhotka (část)",
    "psc": "37331",
    "okres": "České Budějovice",
    "obec": "Olešnice",
    "val": "37331 Olesnice Lhotka (cast)"
  },
  {
    "cast": "Lhotka-Hranice II x)",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75301 Hranice Lhotka-Hranice II x)"
  },
  {
    "cast": "Lhotky",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Kramolna",
    "val": "54701 Kramolna Lhotky"
  },
  {
    "cast": "Lhotky",
    "psc": "67905",
    "okres": "Brno-venkov",
    "obec": "Hostěnice",
    "val": "67905 Hostenice Lhotky"
  },
  {
    "cast": "Lhotky",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Malotice",
    "val": "28163 Malotice Lhotky"
  },
  {
    "cast": "Lhotky",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Lhotky",
    "val": "29406 Lhotky Lhotky"
  },
  {
    "cast": "Lhotky",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Meziříčí",
    "val": "59401 Velke Mezirici Lhotky"
  },
  {
    "cast": "Lhotsko",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Lhotsko",
    "val": "76312 Lhotsko Lhotsko"
  },
  {
    "cast": "Lhotsko",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41201 Libesice Lhotsko"
  },
  {
    "cast": "Lhoty",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vortová",
    "val": "53901 Vortova Lhoty"
  },
  {
    "cast": "Lhoty u Potštejna",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lhoty u Potštejna",
    "val": "51741 Lhoty u Potstejna Lhoty u Potstejna"
  },
  {
    "cast": "Lhovice",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Lhovice"
  },
  {
    "cast": "Lhůta",
    "psc": "33201",
    "okres": "Plzeň-město",
    "obec": "Lhůta",
    "val": "33201 Lhuta Lhuta"
  },
  {
    "cast": "Lhůta",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Lhuta"
  },
  {
    "cast": "Lhůta",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Lhuta"
  },
  {
    "cast": "Lhůta",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Lhuta"
  },
  {
    "cast": "Lhůty",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Třemošnice",
    "val": "53843 Tremosnice Lhuty"
  },
  {
    "cast": "Lhýšov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Lhysov"
  },
  {
    "cast": "Libá",
    "psc": "35131",
    "okres": "Cheb",
    "obec": "Libá",
    "val": "35131 Liba Liba"
  },
  {
    "cast": "Libákovice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Řenče",
    "val": "33401 Rence Libakovice"
  },
  {
    "cast": "Libáň",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Libáň",
    "val": "50723 Liban Liban"
  },
  {
    "cast": "Libáň",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Nasavrky",
    "val": "53825 Nasavrky Liban"
  },
  {
    "cast": "Libanice",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Honbice",
    "val": "53862 Honbice Libanice"
  },
  {
    "cast": "Libavá",
    "psc": "78307",
    "okres": "Olomouc",
    "obec": "Libavá",
    "val": "78307 Libava Libava"
  },
  {
    "cast": "Libavské Údolí",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Libavské Údolí",
    "val": "35751 Libavske Udoli Libavske Udoli"
  },
  {
    "cast": "Libčany",
    "psc": "50322",
    "okres": "Hradec Králové",
    "obec": "Libčany",
    "val": "50322 Libcany Libcany"
  },
  {
    "cast": "Libčeves",
    "psc": "43926",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "43926 Libceves Libceves"
  },
  {
    "cast": "Libčice",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Nový Knín",
    "val": "26203 Novy Knin Libcice"
  },
  {
    "cast": "Libčice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Libcice"
  },
  {
    "cast": "Libčice nad Vltavou",
    "psc": "25266",
    "okres": "Praha-západ",
    "obec": "Libčice nad Vltavou",
    "val": "25266 Libcice nad Vltavou Libcice nad Vltavou"
  },
  {
    "cast": "Libecina",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Libecina",
    "val": "56601 Libecina Libecina"
  },
  {
    "cast": "Libeč",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Libec"
  },
  {
    "cast": "Libeč",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Libec"
  },
  {
    "cast": "Libečov",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Chyňava",
    "val": "26601 Chynava Libecov"
  },
  {
    "cast": "Libědice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Libědice",
    "val": "43801 Libedice Libedice"
  },
  {
    "cast": "Liběchov",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Liběchov",
    "val": "27721 Libechov Libechov"
  },
  {
    "cast": "Libějice",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Libějice",
    "val": "39002 Libejice Libejice"
  },
  {
    "cast": "Libějovice",
    "psc": "38772",
    "okres": "Strakonice",
    "obec": "Libějovice",
    "val": "38772 Libejovice Libejovice"
  },
  {
    "cast": "Libějovické Svobodné Hory",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Stožice",
    "val": "38901 Stozice Libejovicke Svobodne Hory"
  },
  {
    "cast": "Libel",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Libel",
    "val": "51741 Libel Libel"
  },
  {
    "cast": "Libeň",
    "psc": "25241",
    "okres": "Praha-západ",
    "obec": "Libeř",
    "val": "25241 Liber Liben"
  },
  {
    "cast": "Libeň",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Měník",
    "val": "50401 Menik Liben"
  },
  {
    "cast": "Libeň (část)",
    "psc": "18000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18000 Praha Liben (cast)"
  },
  {
    "cast": "Libeň (část)",
    "psc": "19000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19000 Praha Liben (cast)"
  },
  {
    "cast": "Libeň (část)",
    "psc": "18200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18200 Praha Liben (cast)"
  },
  {
    "cast": "Libenice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Libenice",
    "val": "28002 Libenice Libenice"
  },
  {
    "cast": "Libenice",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Libenice"
  },
  {
    "cast": "Libentiny",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Líšný",
    "val": "46822 Lisny Libentiny"
  },
  {
    "cast": "Liberec III-Jeřáb",
    "psc": "46007",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46007 Liberec Liberec III-Jerab"
  },
  {
    "cast": "Liberec II-Nové Město",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec II-Nove Mesto"
  },
  {
    "cast": "Liberec IV-Perštýn",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec IV-Perstyn"
  },
  {
    "cast": "Liberec IX-Janův Důl",
    "psc": "46007",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46007 Liberec Liberec IX-Januv Dul"
  },
  {
    "cast": "Liberec I-Staré Město",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec I-Stare Mesto"
  },
  {
    "cast": "Liberec VIII-Dolní Hanychov",
    "psc": "46008",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46008 Liberec Liberec VIII-Dolni Hanychov"
  },
  {
    "cast": "Liberec VII-Horní Růžodol",
    "psc": "46007",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46007 Liberec Liberec VII-Horni Ruzodol"
  },
  {
    "cast": "Liberec VI-Rochlice",
    "psc": "46006",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46006 Liberec Liberec VI-Rochlice"
  },
  {
    "cast": "Liberec V-Kristiánov",
    "psc": "46005",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46005 Liberec Liberec V-Kristianov"
  },
  {
    "cast": "Liberec XIII-Nové Pavlovice",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XIII-Nove Pavlovice"
  },
  {
    "cast": "Liberec XII-Staré Pavlovice",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XII-Stare Pavlovice"
  },
  {
    "cast": "Liberec XIV-Ruprechtice (část)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XIV-Ruprechtice (cast)"
  },
  {
    "cast": "Liberec XIV-Ruprechtice (část)",
    "psc": "46014",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46014 Liberec Liberec XIV-Ruprechtice (cast)"
  },
  {
    "cast": "Liberec XIX-Horní Hanychov",
    "psc": "46008",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46008 Liberec Liberec XIX-Horni Hanychov"
  },
  {
    "cast": "Liberec XI-Růžodol I",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XI-Ruzodol I"
  },
  {
    "cast": "Liberec XVIII-Karlinky (část)",
    "psc": "46008",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46008 Liberec Liberec XVIII-Karlinky (cast)"
  },
  {
    "cast": "Liberec XVIII-Karlinky (část)",
    "psc": "46010",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46010 Liberec Liberec XVIII-Karlinky (cast)"
  },
  {
    "cast": "Liberec XVII-Kateřinky",
    "psc": "46014",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46014 Liberec Liberec XVII-Katerinky"
  },
  {
    "cast": "Liberec XVI-Nový Harcov",
    "psc": "46015",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46015 Liberec Liberec XVI-Novy Harcov"
  },
  {
    "cast": "Liberec XV-Starý Harcov",
    "psc": "46015",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46015 Liberec Liberec XV-Stary Harcov"
  },
  {
    "cast": "Liberec XXIII-Doubí",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46312 Liberec Liberec XXIII-Doubi"
  },
  {
    "cast": "Liberec XXII-Horní Suchá",
    "psc": "46010",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46010 Liberec Liberec XXII-Horni Sucha"
  },
  {
    "cast": "Liberec XXIV-Pilínkov",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46312 Liberec Liberec XXIV-Pilinkov"
  },
  {
    "cast": "Liberec XXIX-Kunratice",
    "psc": "46015",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46015 Liberec Liberec XXIX-Kunratice"
  },
  {
    "cast": "Liberec XXI-Rudolfov",
    "psc": "46014",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46014 Liberec Liberec XXI-Rudolfov"
  },
  {
    "cast": "Liberec XXVIII-Hluboká",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46312 Liberec Liberec XXVIII-Hluboka"
  },
  {
    "cast": "Liberec XXV-Vesec",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46312 Liberec Liberec XXV-Vesec"
  },
  {
    "cast": "Liberec XXXIII-Machnín",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XXXIII-Machnin"
  },
  {
    "cast": "Liberec XXXII-Radčice",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XXXII-Radcice"
  },
  {
    "cast": "Liberec XXXIV-Bedřichovka",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XXXIV-Bedrichovka"
  },
  {
    "cast": "Liberec XXXI-Krásná Studánka",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XXXI-Krasna Studanka"
  },
  {
    "cast": "Liberec XXXV-Karlov pod Ještědem",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Liberec XXXV-Karlov pod Jestedem"
  },
  {
    "cast": "Liberec XXX-Vratislavice nad Nisou",
    "psc": "46311",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46311 Liberec Liberec XXX-Vratislavice nad Nisou"
  },
  {
    "cast": "Liberec XX-Ostašov",
    "psc": "46010",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46010 Liberec Liberec XX-Ostasov"
  },
  {
    "cast": "Liberec X-Františkov",
    "psc": "46010",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46010 Liberec Liberec X-Frantiskov"
  },
  {
    "cast": "Liberk (část)",
    "psc": "51712",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51712 Liberk Liberk (cast)"
  },
  {
    "cast": "Liberk (část)",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51601 Liberk Liberk (cast)"
  },
  {
    "cast": "Libeř (část)",
    "psc": "25241",
    "okres": "Praha-západ",
    "obec": "Libeř",
    "val": "25241 Liber Liber (cast)"
  },
  {
    "cast": "Libeř (část)",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Libeř",
    "val": "25401 Liber Liber (cast)"
  },
  {
    "cast": "Liběšice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Češov",
    "val": "50601 Cesov Libesice"
  },
  {
    "cast": "Liběšice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Želenice",
    "val": "43401 Zelenice Libesice"
  },
  {
    "cast": "Liběšice",
    "psc": "43963",
    "okres": "Louny",
    "obec": "Liběšice",
    "val": "43963 Libesice Libesice"
  },
  {
    "cast": "Liběšice",
    "psc": "41146",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41146 Libesice Libesice"
  },
  {
    "cast": "Liběšovice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Blšany",
    "val": "43801 Blsany Libesovice"
  },
  {
    "cast": "Libětice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34201 Hlavnovice Libetice"
  },
  {
    "cast": "Libětice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Libětice",
    "val": "38601 Libetice Libetice"
  },
  {
    "cast": "Líbeznice",
    "psc": "25065",
    "okres": "Praha-východ",
    "obec": "Líbeznice",
    "val": "25065 Libeznice Libeznice"
  },
  {
    "cast": "Libež",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Libež",
    "val": "25726 Libez Libez"
  },
  {
    "cast": "Libhošť",
    "psc": "74257",
    "okres": "Nový Jičín",
    "obec": "Libhošť",
    "val": "74257 Libhost Libhost"
  },
  {
    "cast": "Libchyně",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Libchyně",
    "val": "54901 Libchyne Libchyne"
  },
  {
    "cast": "Libice",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Rybníky",
    "val": "26301 Rybniky Libice"
  },
  {
    "cast": "Libice nad Cidlinou",
    "psc": "28907",
    "okres": "Nymburk",
    "obec": "Libice nad Cidlinou",
    "val": "28907 Libice nad Cidlinou Libice nad Cidlinou"
  },
  {
    "cast": "Libice nad Doubravou",
    "psc": "58277",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58277 Libice nad Doubravou Libice nad Doubravou"
  },
  {
    "cast": "Libická Lhotka",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Libicka Lhotka"
  },
  {
    "cast": "Libíč",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Libic"
  },
  {
    "cast": "Libichov",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Dobrovice",
    "val": "29442 Dobrovice Libichov"
  },
  {
    "cast": "Libín",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Šárovcova Lhota",
    "val": "50781 Sarovcova Lhota Libin"
  },
  {
    "cast": "Libín",
    "psc": "37373",
    "okres": "České Budějovice",
    "obec": "Libín",
    "val": "37373 Libin Libin"
  },
  {
    "cast": "Libíň",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Libin"
  },
  {
    "cast": "Libina",
    "psc": "78805",
    "okres": "Šumperk",
    "obec": "Libina",
    "val": "78805 Libina Libina"
  },
  {
    "cast": "Libínky",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Polepy",
    "val": "41145 Polepy Libinky"
  },
  {
    "cast": "Libínské Sedlo",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Libinske Sedlo"
  },
  {
    "cast": "Libiš",
    "psc": "27711",
    "okres": "Mělník",
    "obec": "Libiš",
    "val": "27711 Libis Libis"
  },
  {
    "cast": "Libišany",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Libišany",
    "val": "53345 Libisany Libisany"
  },
  {
    "cast": "Libív",
    "psc": "37351",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37351 Driten Libiv"
  },
  {
    "cast": "Libivá",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Mohelnice",
    "val": "78985 Mohelnice Libiva"
  },
  {
    "cast": "Libkov",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Libkov",
    "val": "34506 Libkov Libkov"
  },
  {
    "cast": "Libkov",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Libkov",
    "val": "53825 Libkov Libkov"
  },
  {
    "cast": "Libkova Voda",
    "psc": "39462",
    "okres": "Pelhřimov",
    "obec": "Libkova Voda",
    "val": "39462 Libkova Voda Libkova Voda"
  },
  {
    "cast": "Libkovice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Libkovice"
  },
  {
    "cast": "Libkovice",
    "psc": "43532",
    "okres": "Most",
    "obec": "Mariánské Radčice",
    "val": "43532 Marianske Radcice Libkovice"
  },
  {
    "cast": "Libkovice pod Řípem",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Libkovice pod Řípem",
    "val": "41301 Libkovice pod Ripem Libkovice pod Ripem"
  },
  {
    "cast": "Liblice",
    "psc": "27732",
    "okres": "Mělník",
    "obec": "Liblice",
    "val": "27732 Liblice Liblice"
  },
  {
    "cast": "Liblice",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Český Brod",
    "val": "28201 Cesky Brod Liblice"
  },
  {
    "cast": "Liblín",
    "psc": "33141",
    "okres": "Rokycany",
    "obec": "Liblín",
    "val": "33141 Liblin Liblin"
  },
  {
    "cast": "Libná",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Libna"
  },
  {
    "cast": "Libňatov (část)",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Libňatov",
    "val": "54232 Libnatov Libnatov (cast)"
  },
  {
    "cast": "Libňatov (část)",
    "psc": "54236",
    "okres": "Trutnov",
    "obec": "Libňatov",
    "val": "54236 Libnatov Libnatov (cast)"
  },
  {
    "cast": "Libníč (část)",
    "psc": "37367",
    "okres": "České Budějovice",
    "obec": "Libníč",
    "val": "37367 Libnic Libnic (cast)"
  },
  {
    "cast": "Libníč (část)",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Libníč",
    "val": "37371 Libnic Libnic (cast)"
  },
  {
    "cast": "Libníkovice",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Libníkovice",
    "val": "50346 Libnikovice Libnikovice"
  },
  {
    "cast": "Libnov",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Krajková",
    "val": "35709 Krajkova Libnov"
  },
  {
    "cast": "Liboc",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Liboc"
  },
  {
    "cast": "Liboc",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kynšperk nad Ohří",
    "val": "35751 Kynsperk nad Ohri Liboc"
  },
  {
    "cast": "Liboc (část)",
    "psc": "16100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16100 Praha Liboc (cast)"
  },
  {
    "cast": "Liboc (část)",
    "psc": "16200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16200 Praha Liboc (cast)"
  },
  {
    "cast": "Liboc (část)",
    "psc": "16400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16400 Praha Liboc (cast)"
  },
  {
    "cast": "Libočany",
    "psc": "43975",
    "okres": "Louny",
    "obec": "Libočany",
    "val": "43975 Libocany Libocany"
  },
  {
    "cast": "Libodřice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Libodřice",
    "val": "28002 Libodrice Libodrice"
  },
  {
    "cast": "Libohošť",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Libohost"
  },
  {
    "cast": "Libochovany",
    "psc": "41103",
    "okres": "Litoměřice",
    "obec": "Libochovany",
    "val": "41103 Libochovany Libochovany"
  },
  {
    "cast": "Libochovice",
    "psc": "41117",
    "okres": "Litoměřice",
    "obec": "Libochovice",
    "val": "41117 Libochovice Libochovice"
  },
  {
    "cast": "Libochovičky",
    "psc": "27342",
    "okres": "Kladno",
    "obec": "Libochovičky",
    "val": "27342 Libochovicky Libochovicky"
  },
  {
    "cast": "Liboměřice",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Liboměřice",
    "val": "53821 Libomerice Libomerice"
  },
  {
    "cast": "Libomyšl (část)",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Libomyšl",
    "val": "26751 Libomysl Libomysl (cast)"
  },
  {
    "cast": "Libomyšl (část)",
    "psc": "26723",
    "okres": "Beroun",
    "obec": "Libomyšl",
    "val": "26723 Libomysl Libomysl (cast)"
  },
  {
    "cast": "Libonice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Hořice",
    "val": "50801 Horice Libonice"
  },
  {
    "cast": "Liboňov",
    "psc": "40338",
    "okres": "Ústí nad Labem",
    "obec": "Telnice",
    "val": "40338 Telnice Libonov"
  },
  {
    "cast": "Libořezy",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Stříbřec",
    "val": "37901 Stribrec Liborezy"
  },
  {
    "cast": "Libořice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Libořice",
    "val": "43801 Liborice Liborice"
  },
  {
    "cast": "Libosváry",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Vidice",
    "val": "34601 Vidice Libosvary"
  },
  {
    "cast": "Libosváry",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Loukov",
    "val": "76861 Loukov Libosvary"
  },
  {
    "cast": "Liboš",
    "psc": "78313",
    "okres": "Olomouc",
    "obec": "Liboš",
    "val": "78313 Libos Libos"
  },
  {
    "cast": "Libošovice",
    "psc": "50744",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50744 Libosovice Libosovice"
  },
  {
    "cast": "Libotenice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Libotenice",
    "val": "41201 Libotenice Libotenice"
  },
  {
    "cast": "Libotov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Libotov",
    "val": "54401 Libotov Libotov"
  },
  {
    "cast": "Libotyně",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Radhostice",
    "val": "38481 Radhostice Libotyne"
  },
  {
    "cast": "Libouchec",
    "psc": "40335",
    "okres": "Ústí nad Labem",
    "obec": "Libouchec",
    "val": "40335 Libouchec Libouchec"
  },
  {
    "cast": "Libouň (část)",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25801 Zvestov Liboun (cast)"
  },
  {
    "cast": "Libouň (část)",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Liboun (cast)"
  },
  {
    "cast": "Libov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Chuderov",
    "val": "40002 Chuderov Libov"
  },
  {
    "cast": "Libovice",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Nosálov",
    "val": "27735 Nosalov Libovice"
  },
  {
    "cast": "Libovice",
    "psc": "27379",
    "okres": "Kladno",
    "obec": "Libovice",
    "val": "27379 Libovice Libovice"
  },
  {
    "cast": "Librantice",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Librantice",
    "val": "50346 Librantice Librantice"
  },
  {
    "cast": "Libřice",
    "psc": "50344",
    "okres": "Hradec Králové",
    "obec": "Libřice",
    "val": "50344 Librice Librice"
  },
  {
    "cast": "Libštát",
    "psc": "51203",
    "okres": "Semily",
    "obec": "Libštát",
    "val": "51203 Libstat Libstat"
  },
  {
    "cast": "Libuň",
    "psc": "50715",
    "okres": "Jičín",
    "obec": "Libuň",
    "val": "50715 Libun Libun"
  },
  {
    "cast": "Libunec",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libuň",
    "val": "50601 Libun Libunec"
  },
  {
    "cast": "Libuš",
    "psc": "14200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14200 Praha Libus"
  },
  {
    "cast": "Libušín",
    "psc": "27306",
    "okres": "Kladno",
    "obec": "Libušín",
    "val": "27306 Libusin Libusin"
  },
  {
    "cast": "Libyně",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Libyne"
  },
  {
    "cast": "Licibořice",
    "psc": "53823",
    "okres": "Chrudim",
    "obec": "Licibořice",
    "val": "53823 Liciborice Liciborice"
  },
  {
    "cast": "Licomělice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Načešice",
    "val": "53803 Nacesice Licomelice"
  },
  {
    "cast": "Licoměřice",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Lipovec",
    "val": "53843 Lipovec Licomerice"
  },
  {
    "cast": "Ličenice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Licenice"
  },
  {
    "cast": "Líčkov",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Liběšice",
    "val": "43801 Libesice Lickov"
  },
  {
    "cast": "Lično",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Bačalky",
    "val": "50723 Bacalky Licno"
  },
  {
    "cast": "Lično (část)",
    "psc": "51735",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lično",
    "val": "51735 Licno Licno (cast)"
  },
  {
    "cast": "Lično (část)",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lično",
    "val": "51741 Licno Licno (cast)"
  },
  {
    "cast": "Ličov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Licov"
  },
  {
    "cast": "Lidečko",
    "psc": "75612",
    "okres": "Vsetín",
    "obec": "Lidečko",
    "val": "75612 Lidecko Lidecko"
  },
  {
    "cast": "Lideň",
    "psc": "43102",
    "okres": "Chomutov",
    "obec": "Málkov",
    "val": "43102 Malkov Liden"
  },
  {
    "cast": "Liderovice",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Liderovice"
  },
  {
    "cast": "Lidéřovice",
    "psc": "69661",
    "okres": "Hodonín",
    "obec": "Vnorovy",
    "val": "69661 Vnorovy Liderovice"
  },
  {
    "cast": "Lidéřovice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Peč",
    "val": "38001 Pec Liderovice"
  },
  {
    "cast": "Lidice",
    "psc": "27354",
    "okres": "Kladno",
    "obec": "Lidice",
    "val": "27354 Lidice Lidice"
  },
  {
    "cast": "Lidkovice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Lidkovice"
  },
  {
    "cast": "Lídlovy Dvory",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Lidlovy Dvory"
  },
  {
    "cast": "Lidmaň",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Lidmaň",
    "val": "39501 Lidman Lidman"
  },
  {
    "cast": "Lidmaňka",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Lidmaň",
    "val": "39501 Lidman Lidmanka"
  },
  {
    "cast": "Lidmovice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Skočice",
    "val": "38901 Skocice Lidmovice"
  },
  {
    "cast": "Líha",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Suchodol",
    "val": "26101 Suchodol Liha"
  },
  {
    "cast": "Lichkov",
    "psc": "56168",
    "okres": "Ústí nad Orlicí",
    "obec": "Lichkov",
    "val": "56168 Lichkov Lichkov"
  },
  {
    "cast": "Lichnov",
    "psc": "79315",
    "okres": "Bruntál",
    "obec": "Lichnov",
    "val": "79315 Lichnov Lichnov"
  },
  {
    "cast": "Lichnov",
    "psc": "74275",
    "okres": "Nový Jičín",
    "obec": "Lichnov",
    "val": "74275 Lichnov Lichnov"
  },
  {
    "cast": "Lichoceves",
    "psc": "25264",
    "okres": "Praha-západ",
    "obec": "Lichoceves",
    "val": "25264 Lichoceves Lichoceves"
  },
  {
    "cast": "Líchovy (část)",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Dublovice",
    "val": "26401 Dublovice Lichovy (cast)"
  },
  {
    "cast": "Líchovy (část)",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Dublovice",
    "val": "26256 Dublovice Lichovy (cast)"
  },
  {
    "cast": "Limuzy",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Tismice",
    "val": "28201 Tismice Limuzy"
  },
  {
    "cast": "Lindava",
    "psc": "47158",
    "okres": "Česká Lípa",
    "obec": "Cvikov",
    "val": "47158 Cvikov Lindava"
  },
  {
    "cast": "Líně",
    "psc": "33021",
    "okres": "Plzeň-sever",
    "obec": "Líně",
    "val": "33021 Line Line"
  },
  {
    "cast": "Linhartice",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Linhartice",
    "val": "57101 Linhartice Linhartice"
  },
  {
    "cast": "Linhartovy",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Linhartovy"
  },
  {
    "cast": "Líny",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Bukovno",
    "val": "29425 Bukovno Liny"
  },
  {
    "cast": "Lipá",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41115 Trebenice Lipa"
  },
  {
    "cast": "Lípa",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33035 Unesov Lipa"
  },
  {
    "cast": "Lípa",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Všestary",
    "val": "50312 Vsestary Lipa"
  },
  {
    "cast": "Lípa",
    "psc": "76311",
    "okres": "Zlín",
    "obec": "Lípa",
    "val": "76311 Lipa Lipa"
  },
  {
    "cast": "Lípa",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Merklín",
    "val": "36301 Merklin Lipa"
  },
  {
    "cast": "Lípa",
    "psc": "58257",
    "okres": "Havlíčkův Brod",
    "obec": "Lípa",
    "val": "58257 Lipa Lipa"
  },
  {
    "cast": "Lípa nad Orlicí",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lípa nad Orlicí",
    "val": "51721 Lipa nad Orlici Lipa nad Orlici"
  },
  {
    "cast": "Lipanovice",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Záboří",
    "val": "37384 Zabori Lipanovice"
  },
  {
    "cast": "Lipany",
    "psc": "10300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10300 Praha Lipany"
  },
  {
    "cast": "Lipany",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Vitice",
    "val": "28163 Vitice Lipany"
  },
  {
    "cast": "Lipec",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Lipec",
    "val": "28126 Lipec Lipec"
  },
  {
    "cast": "Lipec",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Slepotice",
    "val": "53002 Slepotice Lipec"
  },
  {
    "cast": "Lipence (část)",
    "psc": "15531",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15531 Praha Lipence (cast)"
  },
  {
    "cast": "Lipence (část)",
    "psc": "25228",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "25228 Praha Lipence (cast)"
  },
  {
    "cast": "Lipenec",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Lipno",
    "val": "44001 Lipno Lipenec"
  },
  {
    "cast": "Lipí",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Lipi"
  },
  {
    "cast": "Lipí",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Lipi"
  },
  {
    "cast": "Lipí",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Lipi"
  },
  {
    "cast": "Lipí",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Lipí",
    "val": "37384 Lipi Lipi"
  },
  {
    "cast": "Lipice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Lipice"
  },
  {
    "cast": "Lipina",
    "psc": "74784",
    "okres": "Opava",
    "obec": "Štáblovice",
    "val": "74784 Stablovice Lipina"
  },
  {
    "cast": "Lipina",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Lipina",
    "val": "78501 Lipina Lipina"
  },
  {
    "cast": "Lipina",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Mladoňovice",
    "val": "53821 Mladonovice Lipina"
  },
  {
    "cast": "Lipina",
    "psc": "58827",
    "okres": "Jihlava",
    "obec": "Jamné",
    "val": "58827 Jamne Lipina"
  },
  {
    "cast": "Lipina",
    "psc": "76601",
    "okres": "Zlín",
    "obec": "Valašské Klobouky",
    "val": "76601 Valasske Klobouky Lipina"
  },
  {
    "cast": "Lipina",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Lipina"
  },
  {
    "cast": "Lipinka",
    "psc": "78383",
    "okres": "Olomouc",
    "obec": "Lipinka",
    "val": "78383 Lipinka Lipinka"
  },
  {
    "cast": "Lipiny",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Nečín",
    "val": "26301 Necin Lipiny"
  },
  {
    "cast": "Lipiny",
    "psc": "51731",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bolehošť",
    "val": "51731 Bolehost Lipiny"
  },
  {
    "cast": "Lipiny u Radošovic",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Radošovice",
    "val": "25726 Radosovice Lipiny u Radosovic"
  },
  {
    "cast": "Lipiny u Veliše",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Veliš",
    "val": "25706 Velis Lipiny u Velise"
  },
  {
    "cast": "Lipka",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Lipka"
  },
  {
    "cast": "Lipka",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Lipka"
  },
  {
    "cast": "Lipka",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53825 Horni Bradlo Lipka"
  },
  {
    "cast": "Lipná",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Hazlov",
    "val": "35201 Hazlov Lipna"
  },
  {
    "cast": "Lipná",
    "psc": "75362",
    "okres": "Přerov",
    "obec": "Potštát",
    "val": "75362 Potstat Lipna"
  },
  {
    "cast": "Lipňany",
    "psc": "78357",
    "okres": "Olomouc",
    "obec": "Tršice",
    "val": "78357 Trsice Lipnany"
  },
  {
    "cast": "Lipnice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Kunratice",
    "val": "40502 Kunratice Lipnice"
  },
  {
    "cast": "Lipnice",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Jílovice",
    "val": "37312 Jilovice Lipnice"
  },
  {
    "cast": "Lipnice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "38001 Cesky Rudolec Lipnice"
  },
  {
    "cast": "Lipnice",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Lipnice"
  },
  {
    "cast": "Lipnice",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Dvůr Králové nad Labem",
    "val": "54401 Dvur Kralove nad Labem Lipnice"
  },
  {
    "cast": "Lipnice nad Sázavou (část)",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Lipnice nad Sázavou",
    "val": "58291 Lipnice nad Sazavou Lipnice nad Sazavou (cast)"
  },
  {
    "cast": "Lipnice nad Sázavou (část)",
    "psc": "58232",
    "okres": "Havlíčkův Brod",
    "obec": "Lipnice nad Sázavou",
    "val": "58232 Lipnice nad Sazavou Lipnice nad Sazavou (cast)"
  },
  {
    "cast": "Lipnička",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Lipnicka"
  },
  {
    "cast": "Lipník",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Lipník",
    "val": "67552 Lipnik Lipnik"
  },
  {
    "cast": "Lipník",
    "psc": "29443",
    "okres": "Mladá Boleslav",
    "obec": "Lipník",
    "val": "29443 Lipnik Lipnik"
  },
  {
    "cast": "Lipník nad Bečvou III-Nové Dvory",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lipník nad Bečvou",
    "val": "75131 Lipnik nad Becvou Lipnik nad Becvou III-Nove Dvory"
  },
  {
    "cast": "Lipník nad Bečvou I-Město",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lipník nad Bečvou",
    "val": "75131 Lipnik nad Becvou Lipnik nad Becvou I-Mesto"
  },
  {
    "cast": "Lipník nad Bečvou VII-Trnávka",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lipník nad Bečvou",
    "val": "75131 Lipnik nad Becvou Lipnik nad Becvou VII-Trnavka"
  },
  {
    "cast": "Lipník nad Bečvou VI-Loučka",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lipník nad Bečvou",
    "val": "75131 Lipnik nad Becvou Lipnik nad Becvou VI-Loucka"
  },
  {
    "cast": "Lipník nad Bečvou V-Podhoří",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lipník nad Bečvou",
    "val": "75131 Lipnik nad Becvou Lipnik nad Becvou V-Podhori"
  },
  {
    "cast": "Lipno",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Lipno",
    "val": "43801 Lipno Lipno"
  },
  {
    "cast": "Lipno",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33035 Listany Lipno"
  },
  {
    "cast": "Lipno nad Vltavou",
    "psc": "38278",
    "okres": "Český Krumlov",
    "obec": "Lipno nad Vltavou",
    "val": "38278 Lipno nad Vltavou Lipno nad Vltavou"
  },
  {
    "cast": "Lipolec",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Lipolec"
  },
  {
    "cast": "Lipoltice",
    "psc": "53364",
    "okres": "Pardubice",
    "obec": "Lipoltice",
    "val": "53364 Lipoltice Lipoltice"
  },
  {
    "cast": "Lipoltov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Tuřany",
    "val": "35002 Turany Lipoltov"
  },
  {
    "cast": "Lipov",
    "psc": "69672",
    "okres": "Hodonín",
    "obec": "Lipov",
    "val": "69672 Lipov Lipov"
  },
  {
    "cast": "Lipová",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Lipova"
  },
  {
    "cast": "Lipová",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Lipová",
    "val": "76321 Lipova Lipova"
  },
  {
    "cast": "Lipová",
    "psc": "75114",
    "okres": "Přerov",
    "obec": "Lipová",
    "val": "75114 Lipova Lipova"
  },
  {
    "cast": "Lipová",
    "psc": "40781",
    "okres": "Děčín",
    "obec": "Lipová",
    "val": "40781 Lipova Lipova"
  },
  {
    "cast": "Lipová",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Volfířov",
    "val": "38001 Volfirov Lipova"
  },
  {
    "cast": "Lipová",
    "psc": "79845",
    "okres": "Prostějov",
    "obec": "Lipová",
    "val": "79845 Lipova Lipova"
  },
  {
    "cast": "Lipová",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Chuderov",
    "val": "40002 Chuderov Lipova"
  },
  {
    "cast": "Lipová Lhota",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Budětice",
    "val": "34201 Budetice Lipova Lhota"
  },
  {
    "cast": "Lipová-lázně",
    "psc": "79061",
    "okres": "Jeseník",
    "obec": "Lipová-lázně",
    "val": "79061 Lipova-lazne Lipova-lazne"
  },
  {
    "cast": "Lipovec",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Lipovec",
    "val": "53843 Lipovec Lipovec"
  },
  {
    "cast": "Lipovec",
    "psc": "67915",
    "okres": "Blansko",
    "obec": "Lipovec",
    "val": "67915 Lipovec Lipovec"
  },
  {
    "cast": "Lipovice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Lipovice",
    "val": "38422 Lipovice Lipovice"
  },
  {
    "cast": "Lipovka",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Deštná",
    "val": "37821 Destna Lipovka"
  },
  {
    "cast": "Lipovka",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51601 Rychnov nad Kneznou Lipovka"
  },
  {
    "cast": "Liptál",
    "psc": "75631",
    "okres": "Vsetín",
    "obec": "Liptál",
    "val": "75631 Liptal Liptal"
  },
  {
    "cast": "Liptaň",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Liptaň",
    "val": "79399 Liptan Liptan"
  },
  {
    "cast": "Lipůvka",
    "psc": "67922",
    "okres": "Blansko",
    "obec": "Lipůvka",
    "val": "67922 Lipuvka Lipuvka"
  },
  {
    "cast": "Lípy",
    "psc": "78342",
    "okres": "Olomouc",
    "obec": "Slatinice",
    "val": "78342 Slatinice Lipy"
  },
  {
    "cast": "Lísek",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Lisek"
  },
  {
    "cast": "Lísek",
    "psc": "59245",
    "okres": "Žďár nad Sázavou",
    "obec": "Lísek",
    "val": "59245 Lisek Lisek"
  },
  {
    "cast": "Líska",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40502 Ceska Kamenice Liska"
  },
  {
    "cast": "Lísková",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nemanice",
    "val": "34401 Nemanice Liskova"
  },
  {
    "cast": "Lískovec",
    "psc": "76805",
    "okres": "Kroměříž",
    "obec": "Koryčany",
    "val": "76805 Korycany Liskovec"
  },
  {
    "cast": "Lískovec",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Ujčov",
    "val": "59262 Ujcov Liskovec"
  },
  {
    "cast": "Lískovec",
    "psc": "73801",
    "okres": "Frýdek-Místek",
    "obec": "Frýdek-Místek",
    "val": "73801 Frydek-Mistek Liskovec"
  },
  {
    "cast": "Lískovice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Želiv",
    "val": "39601 Zeliv Liskovice"
  },
  {
    "cast": "Lískovice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Lískovice",
    "val": "50801 Liskovice Liskovice"
  },
  {
    "cast": "Lísky",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Lisky"
  },
  {
    "cast": "Lísky",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Koberovice",
    "val": "39601 Koberovice Lisky"
  },
  {
    "cast": "Lísky",
    "psc": "76805",
    "okres": "Kroměříž",
    "obec": "Chvalnov-Lísky",
    "val": "76805 Chvalnov-Lisky Lisky"
  },
  {
    "cast": "Líský",
    "psc": "27376",
    "okres": "Kladno",
    "obec": "Líský",
    "val": "27376 Lisky Lisky"
  },
  {
    "cast": "Lisov",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Lisov",
    "val": "33301 Lisov Lisov"
  },
  {
    "cast": "Lisovice",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Zlonice",
    "val": "27371 Zlonice Lisovice"
  },
  {
    "cast": "Lisovice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Chrást",
    "val": "26272 Chrast Lisovice"
  },
  {
    "cast": "Lišany",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Lišany",
    "val": "44001 Lisany Lisany"
  },
  {
    "cast": "Lišany (část)",
    "psc": "27052",
    "okres": "Rakovník",
    "obec": "Lišany",
    "val": "27052 Lisany Lisany (cast)"
  },
  {
    "cast": "Lišany (část)",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Lišany",
    "val": "26901 Lisany Lisany (cast)"
  },
  {
    "cast": "Liščí",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Chudenín",
    "val": "34022 Chudenin Lisci"
  },
  {
    "cast": "Liščí",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Lipová",
    "val": "40747 Lipova Lisci"
  },
  {
    "cast": "Liščí Kotce",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Rovensko pod Troskami",
    "val": "51263 Rovensko pod Troskami Lisci Kotce"
  },
  {
    "cast": "Líšeň (část)",
    "psc": "62800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62800 Brno Lisen (cast)"
  },
  {
    "cast": "Líšeň (část)",
    "psc": "63600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63600 Brno Lisen (cast)"
  },
  {
    "cast": "Lišice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Dolní Lukavice",
    "val": "33401 Dolni Lukavice Lisice"
  },
  {
    "cast": "Lišice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Svatý Mikuláš",
    "val": "28401 Svaty Mikulas Lisice"
  },
  {
    "cast": "Lišice",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Lišice",
    "val": "50351 Lisice Lisice"
  },
  {
    "cast": "Líšina",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Líšina",
    "val": "33301 Lisina Lisina"
  },
  {
    "cast": "Liškov",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Čížkov",
    "val": "33501 Cizkov Liskov"
  },
  {
    "cast": "Líšná",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Líšná",
    "val": "33808 Lisna Lisna"
  },
  {
    "cast": "Líšná",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Líšná",
    "val": "59203 Lisna Lisna"
  },
  {
    "cast": "Líšná",
    "psc": "75115",
    "okres": "Přerov",
    "obec": "Líšná",
    "val": "75115 Lisna Lisna"
  },
  {
    "cast": "Lišnice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Lišnice",
    "val": "43401 Lisnice Lisnice"
  },
  {
    "cast": "Líšnice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Sepekov",
    "val": "39901 Sepekov Lisnice"
  },
  {
    "cast": "Líšnice",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Líšnice",
    "val": "78985 Lisnice Lisnice"
  },
  {
    "cast": "Líšnice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Lisnice"
  },
  {
    "cast": "Líšnice (část)",
    "psc": "25203",
    "okres": "Praha-západ",
    "obec": "Líšnice",
    "val": "25203 Lisnice Lisnice (cast)"
  },
  {
    "cast": "Líšnice (část)",
    "psc": "56184",
    "okres": "Ústí nad Orlicí",
    "obec": "Líšnice",
    "val": "56184 Lisnice Lisnice (cast)"
  },
  {
    "cast": "Líšnice (část)",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Líšnice",
    "val": "56401 Lisnice Lisnice (cast)"
  },
  {
    "cast": "Líšnice (část)",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Líšnice",
    "val": "25210 Lisnice Lisnice (cast)"
  },
  {
    "cast": "Líšno",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Lisno"
  },
  {
    "cast": "Líšný 1.díl",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Líšný",
    "val": "46822 Lisny Lisny 1.dil"
  },
  {
    "cast": "Líšný 2.díl",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Líšný",
    "val": "46822 Lisny Lisny 2.dil"
  },
  {
    "cast": "Lišov (část)",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Lisov (cast)"
  },
  {
    "cast": "Lišov (část)",
    "psc": "37373",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37373 Lisov Lisov (cast)"
  },
  {
    "cast": "Líšťany",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Líšťany",
    "val": "44001 Listany Listany"
  },
  {
    "cast": "Líšťany",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33035 Listany Listany"
  },
  {
    "cast": "Líštěnec",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Smilkov",
    "val": "25789 Smilkov Listenec"
  },
  {
    "cast": "Líštěnec",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Listenec"
  },
  {
    "cast": "Litava",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Olší",
    "val": "59261 Olsi Litava"
  },
  {
    "cast": "Líté",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Líté",
    "val": "33152 Lite Lite"
  },
  {
    "cast": "Liteň",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Liteň",
    "val": "26727 Liten Liten"
  },
  {
    "cast": "Litenčice",
    "psc": "76813",
    "okres": "Kroměříž",
    "obec": "Litenčice",
    "val": "76813 Litencice Litencice"
  },
  {
    "cast": "Litětiny",
    "psc": "53371",
    "okres": "Pardubice",
    "obec": "Dolní Roveň",
    "val": "53371 Dolni Roven Litetiny"
  },
  {
    "cast": "Litice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Blíževedly",
    "val": "47002 Blizevedly Litice"
  },
  {
    "cast": "Litice nad Orlicí",
    "psc": "56186",
    "okres": "Ústí nad Orlicí",
    "obec": "Záchlumí",
    "val": "56186 Zachlumi Litice nad Orlici"
  },
  {
    "cast": "Litice (část)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Litice (cast)"
  },
  {
    "cast": "Litice (část)",
    "psc": "32100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32100 Plzen Litice (cast)"
  },
  {
    "cast": "Litice (část)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Litice (cast)"
  },
  {
    "cast": "Liticov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Liticov"
  },
  {
    "cast": "Litíč",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Litíč",
    "val": "54401 Litic Litic"
  },
  {
    "cast": "Litichovice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Litichovice",
    "val": "25726 Litichovice Litichovice"
  },
  {
    "cast": "Litkovice",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Žirovnice",
    "val": "39468 Zirovnice Litkovice"
  },
  {
    "cast": "Lítkovice",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Litkovice"
  },
  {
    "cast": "Litoboř (část)",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Litoboř",
    "val": "55205 Litobor Litobor (cast)"
  },
  {
    "cast": "Litoboř (část)",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Litoboř",
    "val": "55203 Litobor Litobor (cast)"
  },
  {
    "cast": "Litobratřice",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Litobratřice",
    "val": "67178 Litobratrice Litobratrice"
  },
  {
    "cast": "Litohlavy",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Litohlavy",
    "val": "33701 Litohlavy Litohlavy"
  },
  {
    "cast": "Litohoř",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Litohoř",
    "val": "67544 Litohor Litohor"
  },
  {
    "cast": "Litohošť",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Litohošť",
    "val": "39501 Litohost Litohost"
  },
  {
    "cast": "Litohrady",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51601 Rychnov nad Kneznou Litohrady"
  },
  {
    "cast": "Litochovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Litochovice",
    "val": "38701 Litochovice Litochovice"
  },
  {
    "cast": "Litochovice nad Labem",
    "psc": "41133",
    "okres": "Litoměřice",
    "obec": "Prackovice nad Labem",
    "val": "41133 Prackovice nad Labem Litochovice nad Labem"
  },
  {
    "cast": "Litol",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Lysá nad Labem",
    "val": "28922 Lysa nad Labem Litol"
  },
  {
    "cast": "Litoměřice-Město",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Litoměřice",
    "val": "41201 Litomerice Litomerice-Mesto"
  },
  {
    "cast": "Litomyšlské Předměstí",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Litomyslske Predmesti"
  },
  {
    "cast": "Litomyšl-Město (část)",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Litomysl-Mesto (cast)"
  },
  {
    "cast": "Litomyšl-Město (část)",
    "psc": "56967",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "56967 Litomysl Litomysl-Mesto (cast)"
  },
  {
    "cast": "Litoradlice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Litoradlice"
  },
  {
    "cast": "Litostrov",
    "psc": "66483",
    "okres": "Brno-venkov",
    "obec": "Litostrov",
    "val": "66483 Litostrov Litostrov"
  },
  {
    "cast": "Litošice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Litošice",
    "val": "53501 Litosice Litosice"
  },
  {
    "cast": "Lítov",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Habartov",
    "val": "35709 Habartov Litov"
  },
  {
    "cast": "Litovany",
    "psc": "67557",
    "okres": "Třebíč",
    "obec": "Litovany",
    "val": "67557 Litovany Litovany"
  },
  {
    "cast": "Litovel",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78401 Litovel Litovel"
  },
  {
    "cast": "Litultovice",
    "psc": "74755",
    "okres": "Opava",
    "obec": "Litultovice",
    "val": "74755 Litultovice Litultovice"
  },
  {
    "cast": "Litvínovice",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Litvínovice",
    "val": "37001 Litvinovice Litvinovice"
  },
  {
    "cast": "Litvínov-Hamr x)",
    "psc": "43542",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43542 Litvinov Litvinov-Hamr x)"
  },
  {
    "cast": "Litvínov-Horní Litvínov x)",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Litvinov-Horni Litvinov x)"
  },
  {
    "cast": "Litvínov-Horní Ves x)",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Litvinov-Horni Ves x)"
  },
  {
    "cast": "Litvínov-Chudeřín x)",
    "psc": "43603",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43603 Litvinov Litvinov-Chuderin x)"
  },
  {
    "cast": "Litvínov-Janov x)",
    "psc": "43542",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43542 Litvinov Litvinov-Janov x)"
  },
  {
    "cast": "Litvínov-Křížatky x)",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Litvinov-Krizatky x)"
  },
  {
    "cast": "Litvínov-Lounice x)",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Litvinov-Lounice x)"
  },
  {
    "cast": "Litvínov-Písečná x)",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Litvinov-Pisecna x)"
  },
  {
    "cast": "Litvínov-Šumná x)",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Litvinov-Sumna x)"
  },
  {
    "cast": "Lkáň",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Lkáň",
    "val": "41115 Lkan Lkan"
  },
  {
    "cast": "Lnáře",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Lnáře",
    "val": "38742 Lnare Lnare"
  },
  {
    "cast": "Lnářský Málkov",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Kadov",
    "val": "38801 Kadov Lnarsky Malkov"
  },
  {
    "cast": "Lniště",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Slavče",
    "val": "37401 Slavce Lniste"
  },
  {
    "cast": "Lobeč (část)",
    "psc": "27736",
    "okres": "Mělník",
    "obec": "Lobeč",
    "val": "27736 Lobec Lobec (cast)"
  },
  {
    "cast": "Lobeč (část)",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Lobeč",
    "val": "27735 Lobec Lobec (cast)"
  },
  {
    "cast": "Lobeček",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Kralupy nad Vltavou",
    "val": "27801 Kralupy nad Vltavou Lobecek"
  },
  {
    "cast": "Lobendava",
    "psc": "40784",
    "okres": "Děčín",
    "obec": "Lobendava",
    "val": "40784 Lobendava Lobendava"
  },
  {
    "cast": "Lobkovice",
    "psc": "27711",
    "okres": "Mělník",
    "obec": "Neratovice",
    "val": "27711 Neratovice Lobkovice"
  },
  {
    "cast": "Lobodice",
    "psc": "75101",
    "okres": "Přerov",
    "obec": "Lobodice",
    "val": "75101 Lobodice Lobodice"
  },
  {
    "cast": "Lobzy",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Březová",
    "val": "35601 Brezova Lobzy"
  },
  {
    "cast": "Lobzy",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Ošelín",
    "val": "34802 Oselin Lobzy"
  },
  {
    "cast": "Lobzy (část)",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Lobzy (cast)"
  },
  {
    "cast": "Lobzy (část)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Lobzy (cast)"
  },
  {
    "cast": "Ločenice",
    "psc": "37322",
    "okres": "České Budějovice",
    "obec": "Ločenice",
    "val": "37322 Locenice Locenice"
  },
  {
    "cast": "Lodenice",
    "psc": "27064",
    "okres": "Rakovník",
    "obec": "Mšecké Žehrovice",
    "val": "27064 Msecke Zehrovice Lodenice"
  },
  {
    "cast": "Loděnice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Jedousov",
    "val": "53501 Jedousov Lodenice"
  },
  {
    "cast": "Loděnice",
    "psc": "74774",
    "okres": "Opava",
    "obec": "Holasovice",
    "val": "74774 Holasovice Lodenice"
  },
  {
    "cast": "Loděnice",
    "psc": "26712",
    "okres": "Beroun",
    "obec": "Loděnice",
    "val": "26712 Lodenice Lodenice"
  },
  {
    "cast": "Loděnice",
    "psc": "67175",
    "okres": "Brno-venkov",
    "obec": "Loděnice",
    "val": "67175 Lodenice Lodenice"
  },
  {
    "cast": "Lodhéřov",
    "psc": "37826",
    "okres": "Jindřichův Hradec",
    "obec": "Lodhéřov",
    "val": "37826 Lodherov Lodherov"
  },
  {
    "cast": "Lodín",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Lodín",
    "val": "50315 Lodin Lodin"
  },
  {
    "cast": "Lohenice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Přelouč",
    "val": "53501 Prelouc Lohenice"
  },
  {
    "cast": "Lohenice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Koberovice",
    "val": "39601 Koberovice Lohenice"
  },
  {
    "cast": "Lochenice",
    "psc": "50302",
    "okres": "Hradec Králové",
    "obec": "Lochenice",
    "val": "50302 Lochenice Lochenice"
  },
  {
    "cast": "Lochkov",
    "psc": "15400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15400 Praha Lochkov"
  },
  {
    "cast": "Lochousice",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Lochousice",
    "val": "33023 Lochousice Lochousice"
  },
  {
    "cast": "Lochovice",
    "psc": "26723",
    "okres": "Beroun",
    "obec": "Lochovice",
    "val": "26723 Lochovice Lochovice"
  },
  {
    "cast": "Lojovice",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Lojovice"
  },
  {
    "cast": "Loket",
    "psc": "35733",
    "okres": "Sokolov",
    "obec": "Loket",
    "val": "35733 Loket Loket"
  },
  {
    "cast": "Loket",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Loket",
    "val": "25765 Loket Loket"
  },
  {
    "cast": "Lokot",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51601 Rychnov nad Kneznou Lokot"
  },
  {
    "cast": "Loktuše",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Loktuse"
  },
  {
    "cast": "Lom",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Kly",
    "val": "27741 Kly Lom"
  },
  {
    "cast": "Lom",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Lom",
    "val": "39002 Lom Lom"
  },
  {
    "cast": "Lom",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Lom",
    "val": "38801 Lom Lom"
  },
  {
    "cast": "Lom",
    "psc": "43511",
    "okres": "Most",
    "obec": "Lom",
    "val": "43511 Lom Lom"
  },
  {
    "cast": "Lom u Stříbra",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Benešovice",
    "val": "34901 Benesovice Lom u Stribra"
  },
  {
    "cast": "Lom u Tachova",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Lom u Tachova",
    "val": "34701 Lom u Tachova Lom u Tachova"
  },
  {
    "cast": "Lomec",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Lomec",
    "val": "33901 Lomec Lomec"
  },
  {
    "cast": "Lomec",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Úmonín",
    "val": "28601 Umonin Lomec"
  },
  {
    "cast": "Lomec",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Strážkovice",
    "val": "37401 Strazkovice Lomec"
  },
  {
    "cast": "Lomeček",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Úmonín",
    "val": "28601 Umonin Lomecek"
  },
  {
    "cast": "Lomnice",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Lomnice",
    "val": "35601 Lomnice Lomnice"
  },
  {
    "cast": "Lomnice",
    "psc": "79302",
    "okres": "Bruntál",
    "obec": "Lomnice",
    "val": "79302 Lomnice Lomnice"
  },
  {
    "cast": "Lomnice",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Lomnice",
    "val": "67923 Lomnice Lomnice"
  },
  {
    "cast": "Lomnice nad Lužnicí (část)",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Lomnice nad Lužnicí",
    "val": "37901 Lomnice nad Luznici Lomnice nad Luznici (cast)"
  },
  {
    "cast": "Lomnice nad Lužnicí (část)",
    "psc": "37816",
    "okres": "Jindřichův Hradec",
    "obec": "Lomnice nad Lužnicí",
    "val": "37816 Lomnice nad Luznici Lomnice nad Luznici (cast)"
  },
  {
    "cast": "Lomnice nad Popelkou (část)",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51101 Lomnice nad Popelkou Lomnice nad Popelkou (cast)"
  },
  {
    "cast": "Lomnice nad Popelkou (část)",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Lomnice nad Popelkou (cast)"
  },
  {
    "cast": "Lomnička",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Plesná",
    "val": "35134 Plesna Lomnicka"
  },
  {
    "cast": "Lomnička",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kšice",
    "val": "34901 Ksice Lomnicka"
  },
  {
    "cast": "Lomnička",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Plasy",
    "val": "33101 Plasy Lomnicka"
  },
  {
    "cast": "Lomnička",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Lomnička",
    "val": "66601 Lomnicka Lomnicka"
  },
  {
    "cast": "Lomy",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Lomy",
    "val": "67531 Lomy Lomy"
  },
  {
    "cast": "Lomy",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Člunek",
    "val": "37853 Clunek Lomy"
  },
  {
    "cast": "Lomy",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Kokašice",
    "val": "34952 Kokasice Lomy"
  },
  {
    "cast": "Lomy",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Osečnice",
    "val": "51703 Osecnice Lomy"
  },
  {
    "cast": "Lopeník (část)",
    "psc": "68774",
    "okres": "Uherské Hradiště",
    "obec": "Lopeník",
    "val": "68774 Lopenik Lopenik (cast)"
  },
  {
    "cast": "Lopeník (část)",
    "psc": "68767",
    "okres": "Uherské Hradiště",
    "obec": "Lopeník",
    "val": "68767 Lopenik Lopenik (cast)"
  },
  {
    "cast": "Loreta",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Týnec",
    "val": "34021 Tynec Loreta"
  },
  {
    "cast": "Losina",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Chotěšov",
    "val": "33301 Chotesov Losina"
  },
  {
    "cast": "Losiná",
    "psc": "33204",
    "okres": "Plzeň-město",
    "obec": "Losiná",
    "val": "33204 Losina Losina"
  },
  {
    "cast": "Losiny",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Petrovice II",
    "val": "28522 Petrovice II Losiny"
  },
  {
    "cast": "Lošánky",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Lošany",
    "val": "28002 Losany Losanky"
  },
  {
    "cast": "Lošany",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Lošany",
    "val": "28002 Losany Losany"
  },
  {
    "cast": "Lošov",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Losov"
  },
  {
    "cast": "Loštice",
    "psc": "78983",
    "okres": "Šumperk",
    "obec": "Loštice",
    "val": "78983 Lostice Lostice"
  },
  {
    "cast": "Lotouš",
    "psc": "27379",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27379 Slany Lotous"
  },
  {
    "cast": "Loubí",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Holany",
    "val": "47002 Holany Loubi"
  },
  {
    "cast": "Loubí-Děčín XIII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Loubi-Decin XIII x)"
  },
  {
    "cast": "Loucká",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Loucká",
    "val": "27324 Loucka Loucka"
  },
  {
    "cast": "Loučany",
    "psc": "78344",
    "okres": "Olomouc",
    "obec": "Loučany",
    "val": "78344 Loucany Loucany"
  },
  {
    "cast": "Loučany",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Javor",
    "val": "34021 Javor Loucany"
  },
  {
    "cast": "Loučej",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Loucej"
  },
  {
    "cast": "Loučeň (část)",
    "psc": "28933",
    "okres": "Nymburk",
    "obec": "Loučeň",
    "val": "28933 Loucen Loucen (cast)"
  },
  {
    "cast": "Loučeň (část)",
    "psc": "28937",
    "okres": "Nymburk",
    "obec": "Loučeň",
    "val": "28937 Loucen Loucen (cast)"
  },
  {
    "cast": "Loučim",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Loučim",
    "val": "34506 Loucim Loucim"
  },
  {
    "cast": "Loučka",
    "psc": "75644",
    "okres": "Vsetín",
    "obec": "Loučka",
    "val": "75644 Loucka Loucka"
  },
  {
    "cast": "Loučka",
    "psc": "78322",
    "okres": "Olomouc",
    "obec": "Loučka",
    "val": "78322 Loucka Loucka"
  },
  {
    "cast": "Loučka",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Nový Jičín",
    "val": "74101 Novy Jicin Loucka"
  },
  {
    "cast": "Loučka",
    "psc": "76325",
    "okres": "Zlín",
    "obec": "Loučka",
    "val": "76325 Loucka Loucka"
  },
  {
    "cast": "Loučky",
    "psc": "79316",
    "okres": "Bruntál",
    "obec": "Zátor",
    "val": "79316 Zator Loucky"
  },
  {
    "cast": "Loučky",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Loučky",
    "val": "51101 Loucky Loucky"
  },
  {
    "cast": "Loučky",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Verneřice",
    "val": "40502 Vernerice Loucky"
  },
  {
    "cast": "Loučky",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Vílanec",
    "val": "58833 Vilanec Loucky"
  },
  {
    "cast": "Loučky",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Lukavice",
    "val": "53821 Lukavice Loucky"
  },
  {
    "cast": "Loučky",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Svatý Jiří",
    "val": "56501 Svaty Jiri Loucky"
  },
  {
    "cast": "Loučky",
    "psc": "74236",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74236 Odry Loucky"
  },
  {
    "cast": "Loučky",
    "psc": "35735",
    "okres": "Sokolov",
    "obec": "Nové Sedlo",
    "val": "35735 Nove Sedlo Loucky"
  },
  {
    "cast": "Loučná",
    "psc": "43511",
    "okres": "Most",
    "obec": "Lom",
    "val": "43511 Lom Loucna"
  },
  {
    "cast": "Loučná",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Loučná pod Klínovcem",
    "val": "43191 Loucna pod Klinovcem Loucna"
  },
  {
    "cast": "Loučná",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46373 Visnova Loucna"
  },
  {
    "cast": "Loučná",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Loucna"
  },
  {
    "cast": "Loučná Hora",
    "psc": "50353",
    "okres": "Hradec Králové",
    "obec": "Smidary",
    "val": "50353 Smidary Loucna Hora"
  },
  {
    "cast": "Loučná nad Desnou",
    "psc": "78811",
    "okres": "Šumperk",
    "obec": "Loučná nad Desnou",
    "val": "78811 Loucna nad Desnou Loucna nad Desnou"
  },
  {
    "cast": "Loučná nad Nisou",
    "psc": "46811",
    "okres": "Jablonec nad Nisou",
    "obec": "Janov nad Nisou",
    "val": "46811 Janov nad Nisou Loucna nad Nisou"
  },
  {
    "cast": "Loučné",
    "psc": "40753",
    "okres": "Děčín",
    "obec": "Jiříkov",
    "val": "40753 Jirikov Loucne"
  },
  {
    "cast": "Loučová",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Loucova"
  },
  {
    "cast": "Loučovice (část)",
    "psc": "38276",
    "okres": "Český Krumlov",
    "obec": "Loučovice",
    "val": "38276 Loucovice Loucovice (cast)"
  },
  {
    "cast": "Loučovice (část)",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Loučovice",
    "val": "38273 Loucovice Loucovice (cast)"
  },
  {
    "cast": "Loudilka",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Loudilka"
  },
  {
    "cast": "Louchov",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Domašín",
    "val": "43151 Domasin Louchov"
  },
  {
    "cast": "Louka",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Vojníkov",
    "val": "39701 Vojnikov Louka"
  },
  {
    "cast": "Louka",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Jemnice",
    "val": "67531 Jemnice Louka"
  },
  {
    "cast": "Louka",
    "psc": "69676",
    "okres": "Hodonín",
    "obec": "Louka",
    "val": "69676 Louka Louka"
  },
  {
    "cast": "Louka",
    "psc": "35301",
    "okres": "Sokolov",
    "obec": "Nová Ves",
    "val": "35301 Nova Ves Louka"
  },
  {
    "cast": "Louka",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Vrbatův Kostelec",
    "val": "53851 Vrbatuv Kostelec Louka"
  },
  {
    "cast": "Louka u Litvínova",
    "psc": "43533",
    "okres": "Most",
    "obec": "Louka u Litvínova",
    "val": "43533 Louka u Litvinova Louka u Litvinova"
  },
  {
    "cast": "Louka (část)",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Louka",
    "val": "67974 Louka Louka (cast)"
  },
  {
    "cast": "Louka (část)",
    "psc": "59301",
    "okres": "Blansko",
    "obec": "Louka",
    "val": "59301 Louka Louka (cast)"
  },
  {
    "cast": "Loukonosy",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Žiželice",
    "val": "28126 Zizelice Loukonosy"
  },
  {
    "cast": "Loukov",
    "psc": "76875",
    "okres": "Kroměříž",
    "obec": "Loukov",
    "val": "76875 Loukov Loukov"
  },
  {
    "cast": "Loukov",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Háje nad Jizerou",
    "val": "51301 Haje nad Jizerou Loukov"
  },
  {
    "cast": "Loukov",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Město",
    "val": "58401 Dolni Mesto Loukov"
  },
  {
    "cast": "Loukov",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Loukov",
    "val": "29411 Loukov Loukov"
  },
  {
    "cast": "Loukovec",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Loukovec",
    "val": "29411 Loukovec Loukovec"
  },
  {
    "cast": "Loukovice",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Loukovice",
    "val": "67522 Loukovice Loukovice"
  },
  {
    "cast": "Loukovičky",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Loukovicky"
  },
  {
    "cast": "Louky",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76302 Zlin Louky"
  },
  {
    "cast": "Louky",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Louky"
  },
  {
    "cast": "Lounice",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Lounice"
  },
  {
    "cast": "Lounín",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Tmaň",
    "val": "26701 Tman Lounin"
  },
  {
    "cast": "Lounky",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Chodouny",
    "val": "41301 Chodouny Lounky"
  },
  {
    "cast": "Louňová",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Louňová",
    "val": "33601 Lounova Lounova"
  },
  {
    "cast": "Louňovice",
    "psc": "25162",
    "okres": "Praha-východ",
    "obec": "Louňovice",
    "val": "25162 Lounovice Lounovice"
  },
  {
    "cast": "Louňovice pod Blaníkem",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Louňovice pod Blaníkem",
    "val": "25706 Lounovice pod Blanikem Lounovice pod Blanikem"
  },
  {
    "cast": "Louny",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Louny",
    "val": "44001 Louny Louny"
  },
  {
    "cast": "Loutí",
    "psc": "25208",
    "okres": "Benešov",
    "obec": "Rabyně",
    "val": "25208 Rabyne Louti"
  },
  {
    "cast": "Loužek",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Louzek"
  },
  {
    "cast": "Loužek",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Louzek"
  },
  {
    "cast": "Loužná",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Myslív",
    "val": "34101 Mysliv Louzna"
  },
  {
    "cast": "Loužnice",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Loužnice",
    "val": "46822 Louznice Louznice"
  },
  {
    "cast": "Lovčice",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34034 Planice Lovcice"
  },
  {
    "cast": "Lovčice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26401 Kosova Hora Lovcice"
  },
  {
    "cast": "Lovčice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Bílé Podolí",
    "val": "28601 Bile Podoli Lovcice"
  },
  {
    "cast": "Lovčice",
    "psc": "69639",
    "okres": "Hodonín",
    "obec": "Lovčice",
    "val": "69639 Lovcice Lovcice"
  },
  {
    "cast": "Lovčice",
    "psc": "50361",
    "okres": "Hradec Králové",
    "obec": "Lovčice",
    "val": "50361 Lovcice Lovcice"
  },
  {
    "cast": "Lovčičky",
    "psc": "68354",
    "okres": "Vyškov",
    "obec": "Lovčičky",
    "val": "68354 Lovcicky Lovcicky"
  },
  {
    "cast": "Lovčovice",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Lovčovice",
    "val": "67531 Lovcovice Lovcovice"
  },
  {
    "cast": "Loveč",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50601 Mladejov Lovec"
  },
  {
    "cast": "Lovečkovice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Lovečkovice",
    "val": "41145 Loveckovice Loveckovice"
  },
  {
    "cast": "Lověšice-Přerov III x)",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Lovesice-Prerov III x)"
  },
  {
    "cast": "Lovětín",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Batelov",
    "val": "58851 Batelov Lovetin"
  },
  {
    "cast": "Lovětín",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Jarošov nad Nežárkou",
    "val": "37842 Jarosov nad Nezarkou Lovetin"
  },
  {
    "cast": "Lovosice",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Lovosice",
    "val": "41002 Lovosice Lovosice"
  },
  {
    "cast": "Loza",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Loza",
    "val": "33152 Loza Loza"
  },
  {
    "cast": "Lozice",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Lozice",
    "val": "53854 Lozice Lozice"
  },
  {
    "cast": "Lstiboř",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Klučov",
    "val": "28201 Klucov Lstibor"
  },
  {
    "cast": "Lšelín",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kostelec",
    "val": "34901 Kostelec Lselin"
  },
  {
    "cast": "Lštěň",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Hostomice",
    "val": "26724 Hostomice Lsten"
  },
  {
    "cast": "Lštění",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Lštění",
    "val": "25722 Lsteni Lsteni"
  },
  {
    "cast": "Lštění",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Radhostice",
    "val": "38481 Radhostice Lsteni"
  },
  {
    "cast": "Lštění",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Blížejov",
    "val": "34601 Blizejov Lsteni"
  },
  {
    "cast": "Lubě",
    "psc": "67921",
    "okres": "Blansko",
    "obec": "Lubě",
    "val": "67921 Lube Lube"
  },
  {
    "cast": "Lubenec",
    "psc": "43983",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "43983 Lubenec Lubenec"
  },
  {
    "cast": "Luběnice",
    "psc": "78346",
    "okres": "Olomouc",
    "obec": "Luběnice",
    "val": "78346 Lubenice Lubenice"
  },
  {
    "cast": "Lubina",
    "psc": "74221",
    "okres": "Nový Jičín",
    "obec": "Kopřivnice",
    "val": "74221 Koprivnice Lubina"
  },
  {
    "cast": "Lubná",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Lubná",
    "val": "76701 Lubna Lubna"
  },
  {
    "cast": "Lubná",
    "psc": "56963",
    "okres": "Svitavy",
    "obec": "Lubná",
    "val": "56963 Lubna Lubna"
  },
  {
    "cast": "Lubná",
    "psc": "27036",
    "okres": "Rakovník",
    "obec": "Lubná",
    "val": "27036 Lubna Lubna"
  },
  {
    "cast": "Lubné",
    "psc": "59451",
    "okres": "Brno-venkov",
    "obec": "Lubné",
    "val": "59451 Lubne Lubne"
  },
  {
    "cast": "Lubnice",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Lubnice",
    "val": "67107 Lubnice Lubnice"
  },
  {
    "cast": "Lubník",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Lubník",
    "val": "56301 Lubnik Lubnik"
  },
  {
    "cast": "Lubno",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Nechanice",
    "val": "50315 Nechanice Lubno"
  },
  {
    "cast": "Lubno",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Habry",
    "val": "58282 Habry Lubno"
  },
  {
    "cast": "Lubno",
    "psc": "73911",
    "okres": "Frýdek-Místek",
    "obec": "Frýdlant nad Ostravicí",
    "val": "73911 Frydlant nad Ostravici Lubno"
  },
  {
    "cast": "Lubojaty",
    "psc": "74292",
    "okres": "Nový Jičín",
    "obec": "Bílovec",
    "val": "74292 Bilovec Lubojaty"
  },
  {
    "cast": "Luboměř",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Luboměř",
    "val": "74235 Lubomer Lubomer"
  },
  {
    "cast": "Luboměř pod Strážnou",
    "psc": "75362",
    "okres": "Přerov",
    "obec": "Luboměř pod Strážnou",
    "val": "75362 Lubomer pod Straznou Lubomer pod Straznou"
  },
  {
    "cast": "Luby",
    "psc": "35137",
    "okres": "Cheb",
    "obec": "Luby",
    "val": "35137 Luby Luby"
  },
  {
    "cast": "Luby",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Luby"
  },
  {
    "cast": "Luby",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Luby"
  },
  {
    "cast": "Lučany nad Nisou",
    "psc": "46871",
    "okres": "Jablonec nad Nisou",
    "obec": "Lučany nad Nisou",
    "val": "46871 Lucany nad Nisou Lucany nad Nisou"
  },
  {
    "cast": "Lučenice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Chroboly",
    "val": "38301 Chroboly Lucenice"
  },
  {
    "cast": "Lučice",
    "psc": "75364",
    "okres": "Přerov",
    "obec": "Bělotín",
    "val": "75364 Belotin Lucice"
  },
  {
    "cast": "Lučice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Chudenice",
    "val": "33901 Chudenice Lucice"
  },
  {
    "cast": "Lučice",
    "psc": "58235",
    "okres": "Havlíčkův Brod",
    "obec": "Lučice",
    "val": "58235 Lucice Lucice"
  },
  {
    "cast": "Lučice",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Chlumec nad Cidlinou",
    "val": "50351 Chlumec nad Cidlinou Lucice"
  },
  {
    "cast": "Lučina",
    "psc": "73939",
    "okres": "Frýdek-Místek",
    "obec": "Lučina",
    "val": "73939 Lucina Lucina"
  },
  {
    "cast": "Lučiny",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Doupovské Hradiště",
    "val": "36272 Doupovske Hradiste Luciny"
  },
  {
    "cast": "Lučiště",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Luciste"
  },
  {
    "cast": "Lučkovice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39804 Mirotice Luckovice"
  },
  {
    "cast": "Luční Chvojno",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Velké Chvojno",
    "val": "40002 Velke Chvojno Lucni Chvojno"
  },
  {
    "cast": "Ludéřov",
    "psc": "78344",
    "okres": "Olomouc",
    "obec": "Drahanovice",
    "val": "78344 Drahanovice Luderov"
  },
  {
    "cast": "Ludgeřovice",
    "psc": "74714",
    "okres": "Opava",
    "obec": "Ludgeřovice",
    "val": "74714 Ludgerovice Ludgerovice"
  },
  {
    "cast": "Ludíkov",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Ludíkov",
    "val": "68001 Ludikov Ludikov"
  },
  {
    "cast": "Ludkovice",
    "psc": "76341",
    "okres": "Zlín",
    "obec": "Ludkovice",
    "val": "76341 Ludkovice Ludkovice"
  },
  {
    "cast": "Ludmírov",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Ludmírov",
    "val": "79855 Ludmirov Ludmirov"
  },
  {
    "cast": "Ludslavice",
    "psc": "76852",
    "okres": "Kroměříž",
    "obec": "Ludslavice",
    "val": "76852 Ludslavice Ludslavice"
  },
  {
    "cast": "Ludvíkov",
    "psc": "78815",
    "okres": "Šumperk",
    "obec": "Velké Losiny",
    "val": "78815 Velke Losiny Ludvikov"
  },
  {
    "cast": "Ludvíkov",
    "psc": "79326",
    "okres": "Bruntál",
    "obec": "Ludvíkov",
    "val": "79326 Ludvikov Ludvikov"
  },
  {
    "cast": "Ludvíkov",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Ludvikov"
  },
  {
    "cast": "Ludvíkov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Ludvikov"
  },
  {
    "cast": "Ludvíkov pod Smrkem",
    "psc": "46365",
    "okres": "Liberec",
    "obec": "Nové Město pod Smrkem",
    "val": "46365 Nove Mesto pod Smrkem Ludvikov pod Smrkem"
  },
  {
    "cast": "Ludvíkovice",
    "psc": "40713",
    "okres": "Děčín",
    "obec": "Ludvíkovice",
    "val": "40713 Ludvikovice Ludvikovice"
  },
  {
    "cast": "Luh nad Svatavou",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Josefov",
    "val": "35709 Josefov Luh nad Svatavou"
  },
  {
    "cast": "Luhačovice",
    "psc": "76326",
    "okres": "Zlín",
    "obec": "Luhačovice",
    "val": "76326 Luhacovice Luhacovice"
  },
  {
    "cast": "Luhov",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Luhov"
  },
  {
    "cast": "Luhov",
    "psc": "47129",
    "okres": "Česká Lípa",
    "obec": "Brniště",
    "val": "47129 Brniste Luhov"
  },
  {
    "cast": "Luhov (část)",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33038 Listany Luhov (cast)"
  },
  {
    "cast": "Luhov (část)",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33035 Listany Luhov (cast)"
  },
  {
    "cast": "Luhy",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Prosenická Lhota",
    "val": "26401 Prosenicka Lhota Luhy"
  },
  {
    "cast": "Luhy",
    "psc": "79312",
    "okres": "Bruntál",
    "obec": "Horní Benešov",
    "val": "79312 Horni Benesov Luhy"
  },
  {
    "cast": "Luhy",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Dolní Hbity",
    "val": "26263 Dolni Hbity Luhy"
  },
  {
    "cast": "Luka",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Luka",
    "val": "47201 Luka Luka"
  },
  {
    "cast": "Luka",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Luka"
  },
  {
    "cast": "Luká",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Luká",
    "val": "78324 Luka Luka"
  },
  {
    "cast": "Luka nad Jihlavou",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Luka nad Jihlavou",
    "val": "58822 Luka nad Jihlavou Luka nad Jihlavou"
  },
  {
    "cast": "Luka pod Medníkem",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Jílové u Prahy",
    "val": "25401 Jilove u Prahy Luka pod Mednikem"
  },
  {
    "cast": "Lukášov",
    "psc": "46605",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46605 Jablonec nad Nisou Lukasov"
  },
  {
    "cast": "Lukavec",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Lukavec"
  },
  {
    "cast": "Lukavec",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Lukavec",
    "val": "41002 Lukavec Lukavec"
  },
  {
    "cast": "Lukavec",
    "psc": "39426",
    "okres": "Pelhřimov",
    "obec": "Lukavec",
    "val": "39426 Lukavec Lukavec"
  },
  {
    "cast": "Lukavec u Hořic",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Lukavec u Hořic",
    "val": "50801 Lukavec u Horic Lukavec u Horic"
  },
  {
    "cast": "Lukavice",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Lukavice",
    "val": "78901 Lukavice Lukavice"
  },
  {
    "cast": "Lukavice",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Lukavice",
    "val": "53821 Lukavice Lukavice"
  },
  {
    "cast": "Lukavice",
    "psc": "56151",
    "okres": "Ústí nad Orlicí",
    "obec": "Lukavice",
    "val": "56151 Lukavice Lukavice"
  },
  {
    "cast": "Lukavice",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Lukavice"
  },
  {
    "cast": "Lukavice (část)",
    "psc": "51603",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lukavice",
    "val": "51603 Lukavice Lukavice (cast)"
  },
  {
    "cast": "Lukavice (část)",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lukavice",
    "val": "51703 Lukavice Lukavice (cast)"
  },
  {
    "cast": "Lukavička",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Lukavice",
    "val": "53821 Lukavice Lukavicka"
  },
  {
    "cast": "Lukohořany",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Děčany",
    "val": "41115 Decany Lukohorany"
  },
  {
    "cast": "Lukov",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Lukov",
    "val": "66902 Lukov Lukov"
  },
  {
    "cast": "Lukov",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Lukov"
  },
  {
    "cast": "Lukov",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Lukov",
    "val": "41804 Lukov Lukov"
  },
  {
    "cast": "Lukov",
    "psc": "76317",
    "okres": "Zlín",
    "obec": "Lukov",
    "val": "76317 Lukov Lukov"
  },
  {
    "cast": "Lukov",
    "psc": "27373",
    "okres": "Kladno",
    "obec": "Vraný",
    "val": "27373 Vrany Lukov"
  },
  {
    "cast": "Lukov",
    "psc": "67602",
    "okres": "Třebíč",
    "obec": "Lukov",
    "val": "67602 Lukov Lukov"
  },
  {
    "cast": "Luková",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Lukova"
  },
  {
    "cast": "Luková",
    "psc": "56123",
    "okres": "Ústí nad Orlicí",
    "obec": "Luková",
    "val": "56123 Lukova Lukova"
  },
  {
    "cast": "Luková",
    "psc": "75103",
    "okres": "Přerov",
    "obec": "Brodek u Přerova",
    "val": "75103 Brodek u Prerova Lukova"
  },
  {
    "cast": "Luková",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Nepolisy",
    "val": "50351 Nepolisy Lukova"
  },
  {
    "cast": "Lukovany",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Lukovany",
    "val": "66484 Lukovany Lukovany"
  },
  {
    "cast": "Lukoveček (část)",
    "psc": "76316",
    "okres": "Zlín",
    "obec": "Lukoveček",
    "val": "76316 Lukovecek Lukovecek (cast)"
  },
  {
    "cast": "Lukoveček (část)",
    "psc": "76841",
    "okres": "Zlín",
    "obec": "Lukoveček",
    "val": "76841 Lukovecek Lukovecek (cast)"
  },
  {
    "cast": "Lukoveček (část)",
    "psc": "76861",
    "okres": "Zlín",
    "obec": "Lukoveček",
    "val": "76861 Lukovecek Lukovecek (cast)"
  },
  {
    "cast": "Lukoviště",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Lukoviste"
  },
  {
    "cast": "Lukovna",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Sezemice",
    "val": "53304 Sezemice Lukovna"
  },
  {
    "cast": "Luleč",
    "psc": "68303",
    "okres": "Vyškov",
    "obec": "Luleč",
    "val": "68303 Lulec Lulec"
  },
  {
    "cast": "Luníkov",
    "psc": "27321",
    "okres": "Kladno",
    "obec": "Žižice",
    "val": "27321 Zizice Lunikov"
  },
  {
    "cast": "Lupěné",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Nemile",
    "val": "78901 Nemile Lupene"
  },
  {
    "cast": "Lupenice",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lupenice",
    "val": "51741 Lupenice Lupenice"
  },
  {
    "cast": "Luštěnice",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Luštěnice",
    "val": "29442 Lustenice Lustenice"
  },
  {
    "cast": "Lutín",
    "psc": "78349",
    "okres": "Olomouc",
    "obec": "Lutín",
    "val": "78349 Lutin Lutin"
  },
  {
    "cast": "Lutonina (část)",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Lutonina",
    "val": "76312 Lutonina Lutonina (cast)"
  },
  {
    "cast": "Lutonina (část)",
    "psc": "76313",
    "okres": "Zlín",
    "obec": "Lutonina",
    "val": "76313 Lutonina Lutonina (cast)"
  },
  {
    "cast": "Lutopecny",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Lutopecny",
    "val": "76701 Lutopecny Lutopecny"
  },
  {
    "cast": "Lutotín",
    "psc": "79841",
    "okres": "Prostějov",
    "obec": "Bílovice-Lutotín",
    "val": "79841 Bilovice-Lutotin Lutotin"
  },
  {
    "cast": "Lutová",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Chlum u Třeboně",
    "val": "37806 Chlum u Trebone Lutova"
  },
  {
    "cast": "Lutyně",
    "psc": "73514",
    "okres": "Karviná",
    "obec": "Orlová",
    "val": "73514 Orlova Lutyne"
  },
  {
    "cast": "Lužany",
    "psc": "50706",
    "okres": "Jičín",
    "obec": "Lužany",
    "val": "50706 Luzany Luzany"
  },
  {
    "cast": "Lužany",
    "psc": "50305",
    "okres": "Hradec Králové",
    "obec": "Lužany",
    "val": "50305 Luzany Luzany"
  },
  {
    "cast": "Lužany",
    "psc": "33454",
    "okres": "Plzeň-jih",
    "obec": "Lužany",
    "val": "33454 Luzany Luzany"
  },
  {
    "cast": "Lužce",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Lužce",
    "val": "26718 Luzce Luzce"
  },
  {
    "cast": "Luže",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Luze"
  },
  {
    "cast": "Lužec",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Vroutek",
    "val": "44101 Vroutek Luzec"
  },
  {
    "cast": "Lužec",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36225 Nejdek Luzec"
  },
  {
    "cast": "Lužec nad Cidlinou",
    "psc": "50362",
    "okres": "Hradec Králové",
    "obec": "Lužec nad Cidlinou",
    "val": "50362 Luzec nad Cidlinou Luzec nad Cidlinou"
  },
  {
    "cast": "Lužec nad Vltavou (část)",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Lužec nad Vltavou",
    "val": "27601 Luzec nad Vltavou Luzec nad Vltavou (cast)"
  },
  {
    "cast": "Lužec nad Vltavou (část)",
    "psc": "27706",
    "okres": "Mělník",
    "obec": "Lužec nad Vltavou",
    "val": "27706 Luzec nad Vltavou Luzec nad Vltavou (cast)"
  },
  {
    "cast": "Luženice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Luženičky",
    "val": "34401 Luzenicky Luzenice"
  },
  {
    "cast": "Luženičky",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Luženičky",
    "val": "34401 Luzenicky Luzenicky"
  },
  {
    "cast": "Lužice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Lužice",
    "val": "38411 Luzice Luzice"
  },
  {
    "cast": "Lužice",
    "psc": "43524",
    "okres": "Most",
    "obec": "Lužice",
    "val": "43524 Luzice Luzice"
  },
  {
    "cast": "Lužice",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Lužice",
    "val": "78501 Luzice Luzice"
  },
  {
    "cast": "Lužice",
    "psc": "69618",
    "okres": "Hodonín",
    "obec": "Lužice",
    "val": "69618 Luzice Luzice"
  },
  {
    "cast": "Lužkovice (část)",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76001 Zlin Luzkovice (cast)"
  },
  {
    "cast": "Lužkovice (část)",
    "psc": "76311",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76311 Zlin Luzkovice (cast)"
  },
  {
    "cast": "Lužná",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Luzna"
  },
  {
    "cast": "Lužná",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Kopřivná",
    "val": "78833 Koprivna Luzna"
  },
  {
    "cast": "Lužná",
    "psc": "75611",
    "okres": "Vsetín",
    "obec": "Lužná",
    "val": "75611 Luzna Luzna"
  },
  {
    "cast": "Lužná (část)",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Lužná",
    "val": "26901 Luzna Luzna (cast)"
  },
  {
    "cast": "Lužná (část)",
    "psc": "38211",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38211 Vetrni Luzna (cast)"
  },
  {
    "cast": "Lužná (část)",
    "psc": "27051",
    "okres": "Rakovník",
    "obec": "Lužná",
    "val": "27051 Luzna Luzna (cast)"
  },
  {
    "cast": "Lužná (část)",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38101 Vetrni Luzna (cast)"
  },
  {
    "cast": "Lužnice",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Lužnice",
    "val": "37901 Luznice Luznice"
  },
  {
    "cast": "Lužnice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Pohorská Ves",
    "val": "38241 Pohorska Ves Luznice"
  },
  {
    "cast": "Lužný",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Perštejn",
    "val": "43151 Perstejn Luzny"
  },
  {
    "cast": "Lvová",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Lvova"
  },
  {
    "cast": "Lysá",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Lysa"
  },
  {
    "cast": "Lysá",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Horní Krupá",
    "val": "58001 Horni Krupa Lysa"
  },
  {
    "cast": "Lysá nad Labem",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Lysá nad Labem",
    "val": "28922 Lysa nad Labem Lysa nad Labem"
  },
  {
    "cast": "Lysec",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bžany",
    "val": "41501 Bzany Lysec"
  },
  {
    "cast": "Lysice (část)",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Lysice",
    "val": "67971 Lysice Lysice (cast)"
  },
  {
    "cast": "Lysice (část)",
    "psc": "67901",
    "okres": "Blansko",
    "obec": "Lysice",
    "val": "67901 Lysice Lysice (cast)"
  },
  {
    "cast": "Lýsky-Přerov IX x)",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Lysky-Prerov IX x)"
  },
  {
    "cast": "Lysolaje",
    "psc": "16500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16500 Praha Lysolaje"
  },
  {
    "cast": "Lysovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Lysovice",
    "val": "68201 Lysovice Lysovice"
  },
  {
    "cast": "Lysůvky",
    "psc": "73942",
    "okres": "Frýdek-Místek",
    "obec": "Frýdek-Místek",
    "val": "73942 Frydek-Mistek Lysuvky"
  },
  {
    "cast": "Lyžbice",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Lyzbice"
  },
  {
    "cast": "Lžín",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Dírná",
    "val": "39201 Dirna Lzin"
  },
  {
    "cast": "Lžovice",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Týnec nad Labem",
    "val": "28126 Tynec nad Labem Lzovice"
  },
  {
    "cast": "Mackovice",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Mackovice",
    "val": "67178 Mackovice Mackovice"
  },
  {
    "cast": "Macourov",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Žižkovo Pole",
    "val": "58222 Zizkovo Pole Macourov"
  },
  {
    "cast": "Mačice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Soběšice",
    "val": "34201 Sobesice Macice"
  },
  {
    "cast": "Mačkov",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Mačkov",
    "val": "38801 Mackov Mackov"
  },
  {
    "cast": "Mačovice",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25722 Vranov Macovice"
  },
  {
    "cast": "Mahouš",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Mahouš",
    "val": "38411 Mahous Mahous"
  },
  {
    "cast": "Machnín-Liberec XXXIII x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Machnin-Liberec XXXIII x)"
  },
  {
    "cast": "Machov",
    "psc": "54963",
    "okres": "Náchod",
    "obec": "Machov",
    "val": "54963 Machov Machov"
  },
  {
    "cast": "Machová",
    "psc": "76301",
    "okres": "Zlín",
    "obec": "Machová",
    "val": "76301 Machova Machova"
  },
  {
    "cast": "Machovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Pertoltice",
    "val": "28522 Pertoltice Machovice"
  },
  {
    "cast": "Machovská Lhota",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Machov",
    "val": "54931 Machov Machovska Lhota"
  },
  {
    "cast": "Majdalena",
    "psc": "37803",
    "okres": "Jindřichův Hradec",
    "obec": "Majdalena",
    "val": "37803 Majdalena Majdalena"
  },
  {
    "cast": "Majetín",
    "psc": "75103",
    "okres": "Olomouc",
    "obec": "Majetín",
    "val": "75103 Majetin Majetin"
  },
  {
    "cast": "Májůvka",
    "psc": "79368",
    "okres": "Bruntál",
    "obec": "Bílčice",
    "val": "79368 Bilcice Majuvka"
  },
  {
    "cast": "Makalovy",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Ostřetice",
    "val": "33901 Ostretice Makalovy"
  },
  {
    "cast": "Makarov",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Pracejovice",
    "val": "38716 Pracejovice Makarov"
  },
  {
    "cast": "Makolusky",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Zbizuby",
    "val": "28506 Zbizuby Makolusky"
  },
  {
    "cast": "Makotřasy",
    "psc": "27354",
    "okres": "Kladno",
    "obec": "Makotřasy",
    "val": "27354 Makotrasy Makotrasy"
  },
  {
    "cast": "Makov",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Makov",
    "val": "57001 Makov Makov"
  },
  {
    "cast": "Makov",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39131 Jistebnice Makov"
  },
  {
    "cast": "Makov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Předslav",
    "val": "33901 Predslav Makov"
  },
  {
    "cast": "Makov",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Makov",
    "val": "67972 Makov Makov"
  },
  {
    "cast": "Malá Bělá",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Mala Bela"
  },
  {
    "cast": "Malá Bučina",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Velvary",
    "val": "27324 Velvary Mala Bucina"
  },
  {
    "cast": "Malá Buková",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Velká Buková",
    "val": "27023 Velka Bukova Mala Bukova"
  },
  {
    "cast": "Malá Bukovina",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Chvalkovice",
    "val": "55204 Chvalkovice Mala Bukovina"
  },
  {
    "cast": "Malá Bukovina",
    "psc": "40729",
    "okres": "Děčín",
    "obec": "Velká Bukovina",
    "val": "40729 Velka Bukovina Mala Bukovina"
  },
  {
    "cast": "Malá Bystřice",
    "psc": "75627",
    "okres": "Vsetín",
    "obec": "Malá Bystřice",
    "val": "75627 Mala Bystrice Mala Bystrice"
  },
  {
    "cast": "Malá Čermná",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54931 Hronov Mala Cermna"
  },
  {
    "cast": "Malá Čermná (část)",
    "psc": "51725",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Čermná nad Orlicí",
    "val": "51725 Cermna nad Orlici Mala Cermna (cast)"
  },
  {
    "cast": "Malá Čermná (část)",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Čermná nad Orlicí",
    "val": "51741 Cermna nad Orlici Mala Cermna (cast)"
  },
  {
    "cast": "Malá Černá",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Salačova Lhota",
    "val": "39501 Salacova Lhota Mala Cerna"
  },
  {
    "cast": "Malá Černoc",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Blšany",
    "val": "43801 Blsany Mala Cernoc"
  },
  {
    "cast": "Malá Hleďsebe",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Velká Hleďsebe",
    "val": "35301 Velka Hledsebe Mala Hledsebe"
  },
  {
    "cast": "Malá Horka",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Mala Horka"
  },
  {
    "cast": "Malá Hraštice (část)",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Malá Hraštice",
    "val": "26203 Mala Hrastice Mala Hrastice (cast)"
  },
  {
    "cast": "Malá Hraštice (část)",
    "psc": "26204",
    "okres": "Příbram",
    "obec": "Malá Hraštice",
    "val": "26204 Mala Hrastice Mala Hrastice (cast)"
  },
  {
    "cast": "Malá Chuchle",
    "psc": "15900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15900 Praha Mala Chuchle"
  },
  {
    "cast": "Malá Lečice (část)",
    "psc": "26203",
    "okres": "Praha-západ",
    "obec": "Bojanovice",
    "val": "26203 Bojanovice Mala Lecice (cast)"
  },
  {
    "cast": "Malá Lečice (část)",
    "psc": "26205",
    "okres": "Praha-západ",
    "obec": "Bojanovice",
    "val": "26205 Bojanovice Mala Lecice (cast)"
  },
  {
    "cast": "Malá Lhota",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50601 Libosovice Mala Lhota"
  },
  {
    "cast": "Malá Lhota",
    "psc": "67921",
    "okres": "Blansko",
    "obec": "Malá Lhota",
    "val": "67921 Mala Lhota Mala Lhota"
  },
  {
    "cast": "Malá Lhota",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Velká Lhota",
    "val": "75701 Velka Lhota Mala Lhota"
  },
  {
    "cast": "Malá Losenice",
    "psc": "59211",
    "okres": "Žďár nad Sázavou",
    "obec": "Malá Losenice",
    "val": "59211 Mala Losenice Mala Losenice"
  },
  {
    "cast": "Malá Morava",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Mala Morava"
  },
  {
    "cast": "Malá Morávka",
    "psc": "79336",
    "okres": "Bruntál",
    "obec": "Malá Morávka",
    "val": "79336 Mala Moravka Mala Moravka"
  },
  {
    "cast": "Malá Paseka",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Mala Paseka"
  },
  {
    "cast": "Malá Rosička",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Žďár",
    "val": "37842 Zdar Mala Rosicka"
  },
  {
    "cast": "Malá Roudka",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Malá Roudka",
    "val": "67963 Mala Roudka Mala Roudka"
  },
  {
    "cast": "Malá Skála",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Mala Skala"
  },
  {
    "cast": "Malá Skalice",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Česká Skalice",
    "val": "55203 Ceska Skalice Mala Skalice"
  },
  {
    "cast": "Malá Skalice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28401 Zbraslavice Mala Skalice"
  },
  {
    "cast": "Malá Skrovnice",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Velká Skrovnice",
    "val": "56201 Velka Skrovnice Mala Skrovnice"
  },
  {
    "cast": "Malá Strana",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Chotěšice",
    "val": "28903 Chotesice Mala Strana"
  },
  {
    "cast": "Malá Strana",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Týn nad Vltavou",
    "val": "37501 Tyn nad Vltavou Mala Strana"
  },
  {
    "cast": "Malá Strana (část)",
    "psc": "15000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15000 Praha Mala Strana (cast)"
  },
  {
    "cast": "Malá Strana (část)",
    "psc": "11800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "11800 Praha Mala Strana (cast)"
  },
  {
    "cast": "Malá Šitboř",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Milíkov",
    "val": "35002 Milikov Mala Sitbor"
  },
  {
    "cast": "Malá Štáhle",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Malá Štáhle",
    "val": "79501 Mala Stahle Mala Stahle"
  },
  {
    "cast": "Malá Turná",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Osek",
    "val": "38601 Osek Mala Turna"
  },
  {
    "cast": "Malá Veleň",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malá Veleň",
    "val": "40502 Mala Velen Mala Velen"
  },
  {
    "cast": "Malá Víska",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Vrhaveč",
    "val": "33901 Vrhavec Mala Viska"
  },
  {
    "cast": "Malá Víska",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Malá Víska",
    "val": "26762 Mala Viska Mala Viska"
  },
  {
    "cast": "Malá Vrbka",
    "psc": "69673",
    "okres": "Hodonín",
    "obec": "Malá Vrbka",
    "val": "69673 Mala Vrbka Mala Vrbka"
  },
  {
    "cast": "Malče",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Besednice",
    "val": "38241 Besednice Malce"
  },
  {
    "cast": "Malčice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Malcice"
  },
  {
    "cast": "Malčice",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Malcice"
  },
  {
    "cast": "Malčice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mirkovice",
    "val": "38232 Mirkovice Malcice"
  },
  {
    "cast": "Malčín",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Malčín",
    "val": "58291 Malcin Malcin"
  },
  {
    "cast": "Malé",
    "psc": "58832",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58832 Brtnice Male"
  },
  {
    "cast": "Malé Březno",
    "psc": "43401",
    "okres": "Most",
    "obec": "Malé Březno",
    "val": "43401 Male Brezno Male Brezno"
  },
  {
    "cast": "Malé Březno",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malé Březno",
    "val": "40002 Male Brezno Male Brezno"
  },
  {
    "cast": "Malé Dvorce",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Male Dvorce"
  },
  {
    "cast": "Malé Heraltice",
    "psc": "74775",
    "okres": "Opava",
    "obec": "Velké Heraltice",
    "val": "74775 Velke Heraltice Male Heraltice"
  },
  {
    "cast": "Malé Horky",
    "psc": "29430",
    "okres": "Mladá Boleslav",
    "obec": "Rokytovec",
    "val": "29430 Rokytovec Male Horky"
  },
  {
    "cast": "Malé Hoštice",
    "psc": "74705",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74705 Opava Male Hostice"
  },
  {
    "cast": "Malé Hradisko",
    "psc": "79849",
    "okres": "Prostějov",
    "obec": "Malé Hradisko",
    "val": "79849 Male Hradisko Male Hradisko"
  },
  {
    "cast": "Malé Hydčice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Malý Bor",
    "val": "34101 Maly Bor Male Hydcice"
  },
  {
    "cast": "Malé Chrášťany",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Sedlec",
    "val": "37341 Sedlec Male Chrastany"
  },
  {
    "cast": "Malé Chvojno",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Velké Chvojno",
    "val": "40002 Velke Chvojno Male Chvojno"
  },
  {
    "cast": "Malé Karlovice",
    "psc": "75606",
    "okres": "Vsetín",
    "obec": "Velké Karlovice",
    "val": "75606 Velke Karlovice Male Karlovice"
  },
  {
    "cast": "Malé Krhovice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43801 Chbany Male Krhovice"
  },
  {
    "cast": "Malé Kyšice",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Malé Kyšice",
    "val": "27351 Male Kysice Male Kysice"
  },
  {
    "cast": "Malé Nepodřice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dobev",
    "val": "39701 Dobev Male Nepodrice"
  },
  {
    "cast": "Malé Poříčí",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Male Porici"
  },
  {
    "cast": "Malé Předměstí",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Male Predmesti"
  },
  {
    "cast": "Malé Přílepy (část)",
    "psc": "26707",
    "okres": "Beroun",
    "obec": "Chyňava",
    "val": "26707 Chynava Male Prilepy (cast)"
  },
  {
    "cast": "Malé Přílepy (část)",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Chyňava",
    "val": "26601 Chynava Male Prilepy (cast)"
  },
  {
    "cast": "Malé Přítočno",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Malé Přítočno",
    "val": "27351 Male Pritocno Male Pritocno"
  },
  {
    "cast": "Malé Slabce",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Slabce",
    "val": "27041 Slabce Male Slabce"
  },
  {
    "cast": "Malé Svatoňovice",
    "psc": "54234",
    "okres": "Trutnov",
    "obec": "Malé Svatoňovice",
    "val": "54234 Male Svatonovice Male Svatonovice"
  },
  {
    "cast": "Malé Tresné",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Rovečné",
    "val": "59265 Rovecne Male Tresne"
  },
  {
    "cast": "Malé Všelisy",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Velké Všelisy",
    "val": "29426 Velke Vselisy Male Vselisy"
  },
  {
    "cast": "Malé Výkleky",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Malé Výkleky",
    "val": "53316 Male Vykleky Male Vykleky"
  },
  {
    "cast": "Malé Žernoseky",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Malé Žernoseky",
    "val": "41002 Male Zernoseky Male Zernoseky"
  },
  {
    "cast": "Maleč",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Strašín",
    "val": "34201 Strasin Malec"
  },
  {
    "cast": "Maleč",
    "psc": "58276",
    "okres": "Havlíčkův Brod",
    "obec": "Maleč",
    "val": "58276 Malec Malec"
  },
  {
    "cast": "Malečov",
    "psc": "40327",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40327 Malecov Malecov"
  },
  {
    "cast": "Malechov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Malechov"
  },
  {
    "cast": "Malechovice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50601 Libosovice Malechovice"
  },
  {
    "cast": "Malejovice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Uhlířské Janovice",
    "val": "28504 Uhlirske Janovice Malejovice"
  },
  {
    "cast": "Malenice",
    "psc": "38706",
    "okres": "Strakonice",
    "obec": "Malenice",
    "val": "38706 Malenice Malenice"
  },
  {
    "cast": "Malenín",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Ratibořské Hory",
    "val": "39143 Ratiborske Hory Malenin"
  },
  {
    "cast": "Malenovice",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76302 Zlin Malenovice"
  },
  {
    "cast": "Malenovice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Suchdol",
    "val": "28401 Suchdol Malenovice"
  },
  {
    "cast": "Malenovice",
    "psc": "73911",
    "okres": "Frýdek-Místek",
    "obec": "Malenovice",
    "val": "73911 Malenovice Malenovice"
  },
  {
    "cast": "Maleny",
    "psc": "79844",
    "okres": "Prostějov",
    "obec": "Stražisko",
    "val": "79844 Strazisko Maleny"
  },
  {
    "cast": "Malesice",
    "psc": "31800",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31800 Plzen Malesice"
  },
  {
    "cast": "Malešice (část)",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37348 Driten Malesice (cast)"
  },
  {
    "cast": "Malešice (část)",
    "psc": "19000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19000 Praha Malesice (cast)"
  },
  {
    "cast": "Malešice (část)",
    "psc": "10000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10000 Praha Malesice (cast)"
  },
  {
    "cast": "Malešice (část)",
    "psc": "10800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10800 Praha Malesice (cast)"
  },
  {
    "cast": "Malešice (část)",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37501 Driten Malesice (cast)"
  },
  {
    "cast": "Malešín",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Vodice",
    "val": "39155 Vodice Malesin"
  },
  {
    "cast": "Malešín",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Řehenice",
    "val": "25167 Rehenice Malesin"
  },
  {
    "cast": "Malešov",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Hoštka",
    "val": "41108 Hostka Malesov"
  },
  {
    "cast": "Malešov",
    "psc": "28541",
    "okres": "Kutná Hora",
    "obec": "Malešov",
    "val": "28541 Malesov Malesov"
  },
  {
    "cast": "Malešovice (část)",
    "psc": "66465",
    "okres": "Brno-venkov",
    "obec": "Malešovice",
    "val": "66465 Malesovice Malesovice (cast)"
  },
  {
    "cast": "Malešovice (část)",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Malešovice",
    "val": "66464 Malesovice Malesovice (cast)"
  },
  {
    "cast": "Maletice",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Maletice"
  },
  {
    "cast": "Malhostice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Rtyně nad Bílinou",
    "val": "41501 Rtyne nad Bilinou Malhostice"
  },
  {
    "cast": "Malhostovice",
    "psc": "66603",
    "okres": "Brno-venkov",
    "obec": "Malhostovice",
    "val": "66603 Malhostovice Malhostovice"
  },
  {
    "cast": "Malhotice",
    "psc": "75353",
    "okres": "Přerov",
    "obec": "Malhotice",
    "val": "75353 Malhotice Malhotice"
  },
  {
    "cast": "Malíč",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Malíč",
    "val": "41201 Malic Malic"
  },
  {
    "cast": "Malíkov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Malíkov",
    "val": "57101 Malikov Malikov"
  },
  {
    "cast": "Malíkov nad Nežárkou",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Pěna",
    "val": "37701 Horni Pena Malikov nad Nezarkou"
  },
  {
    "cast": "Malíkovice",
    "psc": "27377",
    "okres": "Kladno",
    "obec": "Malíkovice",
    "val": "27377 Malikovice Malikovice"
  },
  {
    "cast": "Malín",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Malin"
  },
  {
    "cast": "Malinec",
    "psc": "34012",
    "okres": "Plzeň-jih",
    "obec": "Kbel",
    "val": "34012 Kbel Malinec"
  },
  {
    "cast": "Malínky",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Malínky",
    "val": "68333 Malinky Malinky"
  },
  {
    "cast": "Malinné",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Prosetín",
    "val": "53973 Prosetin Malinne"
  },
  {
    "cast": "Malinová",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Malinová",
    "val": "27035 Malinova Malinova"
  },
  {
    "cast": "Málkov",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Malkov"
  },
  {
    "cast": "Málkov",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Málkov",
    "val": "43001 Malkov Malkov"
  },
  {
    "cast": "Málkov",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Málkov",
    "val": "26701 Malkov Malkov"
  },
  {
    "cast": "Malkovice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Malkovice"
  },
  {
    "cast": "Málkovice",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Malkovice"
  },
  {
    "cast": "Málkovice",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Pernarec",
    "val": "33036 Pernarec Malkovice"
  },
  {
    "cast": "Malměřice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Blatno",
    "val": "44101 Blatno Malmerice"
  },
  {
    "cast": "Malnice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Malnice"
  },
  {
    "cast": "Malobratřice",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Malobratrice"
  },
  {
    "cast": "Malochyně",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Malochyne"
  },
  {
    "cast": "Malolánské",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Dašice",
    "val": "53002 Dasice Malolanske"
  },
  {
    "cast": "Maloměřice (část)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Malomerice (cast)"
  },
  {
    "cast": "Maloměřice (část)",
    "psc": "61500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61500 Brno Malomerice (cast)"
  },
  {
    "cast": "Maloměřice (část)",
    "psc": "62800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62800 Brno Malomerice (cast)"
  },
  {
    "cast": "Malonice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Malonice"
  },
  {
    "cast": "Malonice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Blížejov",
    "val": "34601 Blizejov Malonice"
  },
  {
    "cast": "Malonty",
    "psc": "38291",
    "okres": "Český Krumlov",
    "obec": "Malonty",
    "val": "38291 Malonty Malonty"
  },
  {
    "cast": "Malotice",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Malotice",
    "val": "28163 Malotice Malotice"
  },
  {
    "cast": "Malovice",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Malovice"
  },
  {
    "cast": "Malovice",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Erpužice",
    "val": "34901 Erpuzice Malovice"
  },
  {
    "cast": "Malovice",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Malovice"
  },
  {
    "cast": "Malovice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Malovice",
    "val": "38411 Malovice Malovice"
  },
  {
    "cast": "Malovičky",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Malovice",
    "val": "38411 Malovice Malovicky"
  },
  {
    "cast": "Malovidy",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vracovice",
    "val": "25801 Vracovice Malovidy"
  },
  {
    "cast": "Malovidy",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Rataje nad Sázavou",
    "val": "28506 Rataje nad Sazavou Malovidy"
  },
  {
    "cast": "Malšice",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Malsice"
  },
  {
    "cast": "Malšín",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Malšín",
    "val": "38273 Malsin Malsin"
  },
  {
    "cast": "Malšova Lhota",
    "psc": "50009",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50009 Hradec Kralove Malsova Lhota"
  },
  {
    "cast": "Malšovice",
    "psc": "50009",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50009 Hradec Kralove Malsovice"
  },
  {
    "cast": "Malšovice (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40502 Malsovice Malsovice (cast)"
  },
  {
    "cast": "Malšovice (část)",
    "psc": "40703",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40703 Malsovice Malsovice (cast)"
  },
  {
    "cast": "Malý Beranov",
    "psc": "58603",
    "okres": "Jihlava",
    "obec": "Malý Beranov",
    "val": "58603 Maly Beranov Maly Beranov"
  },
  {
    "cast": "Malý Bor",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Malý Bor",
    "val": "34101 Maly Bor Maly Bor"
  },
  {
    "cast": "Malý Bor",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Strunkovice nad Blanicí",
    "val": "38301 Strunkovice nad Blanici Maly Bor"
  },
  {
    "cast": "Malý Budíkov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Budíkov",
    "val": "39601 Budikov Maly Budikov"
  },
  {
    "cast": "Malý Dub",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Maly Dub"
  },
  {
    "cast": "Malý Háj",
    "psc": "43546",
    "okres": "Most",
    "obec": "Hora Svaté Kateřiny",
    "val": "43546 Hora Svate Kateriny Maly Haj"
  },
  {
    "cast": "Malý Hlavákov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Maly Hlavakov"
  },
  {
    "cast": "Malý Hrzín",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Maly Hrzin"
  },
  {
    "cast": "Malý Chlumec",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Velký Chlumec",
    "val": "26724 Velky Chlumec Maly Chlumec"
  },
  {
    "cast": "Malý Jeníkov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Strmilov",
    "val": "37853 Strmilov Maly Jenikov"
  },
  {
    "cast": "Malý Ježov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Smilovy Hory",
    "val": "39143 Smilovy Hory Maly Jezov"
  },
  {
    "cast": "Malý Kozí Hřbet",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Maly Kozi Hrbet"
  },
  {
    "cast": "Malý Malahov",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Puclice",
    "val": "34561 Puclice Maly Malahov"
  },
  {
    "cast": "Malý Pěčín",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Maly Pecin"
  },
  {
    "cast": "Malý Radkov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Maly Radkov"
  },
  {
    "cast": "Malý Rapotín",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Maly Rapotin"
  },
  {
    "cast": "Malý Ratmírov",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Blažejov",
    "val": "37701 Blazejov Maly Ratmirov"
  },
  {
    "cast": "Malý Rečkov",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Maly Reckov"
  },
  {
    "cast": "Malý Rohozec",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Maly Rohozec"
  },
  {
    "cast": "Malý Šachov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Starý Šachov",
    "val": "40502 Stary Sachov Maly Sachov"
  },
  {
    "cast": "Malý Šenov",
    "psc": "40778",
    "okres": "Děčín",
    "obec": "Velký Šenov",
    "val": "40778 Velky Senov Maly Senov"
  },
  {
    "cast": "Malý Újezd",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Malý Újezd",
    "val": "27731 Maly Ujezd Maly Ujezd"
  },
  {
    "cast": "Mančice",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Dolní Chvatliny",
    "val": "28144 Dolni Chvatliny Mancice"
  },
  {
    "cast": "Mančice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Rašovice",
    "val": "28504 Rasovice Mancice"
  },
  {
    "cast": "Manělovice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Manelovice"
  },
  {
    "cast": "Manerov",
    "psc": "68341",
    "okres": "Vyškov",
    "obec": "Bohdalice-Pavlovice",
    "val": "68341 Bohdalice-Pavlovice Manerov"
  },
  {
    "cast": "Manešovice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Budíškovice",
    "val": "38001 Budiskovice Manesovice"
  },
  {
    "cast": "Manětín",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Manetin"
  },
  {
    "cast": "Maníkovice",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Ptýrov",
    "val": "29501 Ptyrov Manikovice"
  },
  {
    "cast": "Mankovice",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Mankovice",
    "val": "74235 Mankovice Mankovice"
  },
  {
    "cast": "Maňová",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Pernštejnské Jestřabí",
    "val": "59261 Pernstejnske Jestrabi Manova"
  },
  {
    "cast": "Manova Lhota",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Rohozná",
    "val": "56992 Rohozna Manova Lhota"
  },
  {
    "cast": "Maňovice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mileč",
    "val": "33501 Milec Manovice"
  },
  {
    "cast": "Maňovice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Maňovice",
    "val": "34101 Manovice Manovice"
  },
  {
    "cast": "Mantov",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Chotěšov",
    "val": "33301 Chotesov Mantov"
  },
  {
    "cast": "Manušice",
    "psc": "47111",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47111 Ceska Lipa Manusice"
  },
  {
    "cast": "Marčovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Předslavice",
    "val": "38701 Predslavice Marcovice"
  },
  {
    "cast": "Marefy",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Bučovice",
    "val": "68501 Bucovice Marefy"
  },
  {
    "cast": "Marianín",
    "psc": "67906",
    "okres": "Blansko",
    "obec": "Lipovec",
    "val": "67906 Lipovec Marianin"
  },
  {
    "cast": "Mariánovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Marianovice"
  },
  {
    "cast": "Mariánská",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Jáchymov",
    "val": "36301 Jachymov Marianska"
  },
  {
    "cast": "Mariánská Hora",
    "psc": "46843",
    "okres": "Jablonec nad Nisou",
    "obec": "Albrechtice v Jizerských horách",
    "val": "46843 Albrechtice v Jizerskych horach Marianska Hora"
  },
  {
    "cast": "Mariánské Hory (část)",
    "psc": "70200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70200 Ostrava Marianske Hory (cast)"
  },
  {
    "cast": "Mariánské Hory (část)",
    "psc": "70900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70900 Ostrava Marianske Hory (cast)"
  },
  {
    "cast": "Mariánské Lázně",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mariánské Lázně",
    "val": "35301 Marianske Lazne Marianske Lazne"
  },
  {
    "cast": "Mariánské Radčice",
    "psc": "43532",
    "okres": "Most",
    "obec": "Mariánské Radčice",
    "val": "43532 Marianske Radcice Marianske Radcice"
  },
  {
    "cast": "Mariánské Údolí",
    "psc": "78365",
    "okres": "Olomouc",
    "obec": "Hlubočky",
    "val": "78365 Hlubocky Marianske Udoli"
  },
  {
    "cast": "Mariánské Údolí",
    "psc": "43543",
    "okres": "Most",
    "obec": "Horní Jiřetín",
    "val": "43543 Horni Jiretin Marianske Udoli"
  },
  {
    "cast": "Mariánský Týnec",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kralovice",
    "val": "33141 Kralovice Mariansky Tynec"
  },
  {
    "cast": "Marketa",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Dolní Poustevna",
    "val": "40747 Dolni Poustevna Marketa"
  },
  {
    "cast": "Marketa",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Písečné",
    "val": "37881 Pisecne Marketa"
  },
  {
    "cast": "Markoušovice",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Velké Svatoňovice",
    "val": "54232 Velke Svatonovice Markousovice"
  },
  {
    "cast": "Markov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Křišťanov",
    "val": "38301 Kristanov Markov"
  },
  {
    "cast": "Markovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Žleby",
    "val": "28601 Zleby Markovice"
  },
  {
    "cast": "Markvarec",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Hřivice",
    "val": "44001 Hrivice Markvarec"
  },
  {
    "cast": "Markvarec",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "38001 Cesky Rudolec Markvarec"
  },
  {
    "cast": "Markvarec",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Nová Cerekev",
    "val": "39470 Nova Cerekev Markvarec"
  },
  {
    "cast": "Markvartice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Markvartice",
    "val": "58856 Markvartice Markvartice"
  },
  {
    "cast": "Markvartice",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Markvartice",
    "val": "67522 Markvartice Markvartice"
  },
  {
    "cast": "Markvartice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Zubčice",
    "val": "38232 Zubcice Markvartice"
  },
  {
    "cast": "Markvartice",
    "psc": "40742",
    "okres": "Děčín",
    "obec": "Markvartice",
    "val": "40742 Markvartice Markvartice"
  },
  {
    "cast": "Markvartice",
    "psc": "50742",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50742 Markvartice Markvartice"
  },
  {
    "cast": "Markvartice",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Markvartice"
  },
  {
    "cast": "Markvartovice",
    "psc": "74714",
    "okres": "Opava",
    "obec": "Markvartovice",
    "val": "74714 Markvartovice Markvartovice"
  },
  {
    "cast": "Maroltov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Maroltov"
  },
  {
    "cast": "Maršíkov",
    "psc": "78815",
    "okres": "Šumperk",
    "obec": "Velké Losiny",
    "val": "78815 Velke Losiny Marsikov"
  },
  {
    "cast": "Maršov",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Marsov"
  },
  {
    "cast": "Maršov",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Marsov"
  },
  {
    "cast": "Maršov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Marsov"
  },
  {
    "cast": "Maršov",
    "psc": "66471",
    "okres": "Brno-venkov",
    "obec": "Maršov",
    "val": "66471 Marsov Marsov"
  },
  {
    "cast": "Maršov",
    "psc": "68801",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Brod",
    "val": "68801 Uhersky Brod Marsov"
  },
  {
    "cast": "Maršov nad Metují",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Velké Petrovice",
    "val": "54931 Velke Petrovice Marsov nad Metuji"
  },
  {
    "cast": "Maršov u Úpice",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Maršov u Úpice",
    "val": "54232 Marsov u Upice Marsov u Upice"
  },
  {
    "cast": "Maršovice",
    "psc": "47161",
    "okres": "Česká Lípa",
    "obec": "Chlum",
    "val": "47161 Chlum Marsovice"
  },
  {
    "cast": "Maršovice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Marsovice"
  },
  {
    "cast": "Maršovice",
    "psc": "46801",
    "okres": "Jablonec nad Nisou",
    "obec": "Maršovice",
    "val": "46801 Marsovice Marsovice"
  },
  {
    "cast": "Maršovice",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Marsovice"
  },
  {
    "cast": "Maršovice (část)",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25901 Marsovice Marsovice (cast)"
  },
  {
    "cast": "Maršovice (část)",
    "psc": "25755",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25755 Marsovice Marsovice (cast)"
  },
  {
    "cast": "Maršovy Chody",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Částkov",
    "val": "34801 Castkov Marsovy Chody"
  },
  {
    "cast": "Martiněves (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Jílové",
    "val": "40502 Jilove Martineves (cast)"
  },
  {
    "cast": "Martiněves (část)",
    "psc": "40701",
    "okres": "Děčín",
    "obec": "Jílové",
    "val": "40701 Jilove Martineves (cast)"
  },
  {
    "cast": "Martiněves (část)",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Martiněves",
    "val": "41119 Martineves Martineves (cast)"
  },
  {
    "cast": "Martiněves (část)",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Martiněves",
    "val": "41301 Martineves Martineves (cast)"
  },
  {
    "cast": "Martinice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Martinice"
  },
  {
    "cast": "Martinice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Březnice",
    "val": "26272 Breznice Martinice"
  },
  {
    "cast": "Martinice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Martinice"
  },
  {
    "cast": "Martinice",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Martinice",
    "val": "76901 Martinice Martinice"
  },
  {
    "cast": "Martinice",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Proseč",
    "val": "53944 Prosec Martinice"
  },
  {
    "cast": "Martinice",
    "psc": "53864",
    "okres": "Chrudim",
    "obec": "Jenišovice",
    "val": "53864 Jenisovice Martinice"
  },
  {
    "cast": "Martinice",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Martinice",
    "val": "59401 Martinice Martinice"
  },
  {
    "cast": "Martinice u Dolních Kralovic",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Dolní Kralovice",
    "val": "25768 Dolni Kralovice Martinice u Dolnich Kralovic"
  },
  {
    "cast": "Martinice u Onšova",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Martinice u Onšova",
    "val": "39501 Martinice u Onsova Martinice u Onsova"
  },
  {
    "cast": "Martinice v Krkonoších",
    "psc": "51232",
    "okres": "Semily",
    "obec": "Martinice v Krkonoších",
    "val": "51232 Martinice v Krkonosich Martinice v Krkonosich"
  },
  {
    "cast": "Martínkov",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Martínkov",
    "val": "67544 Martinkov Martinkov"
  },
  {
    "cast": "Martínkovice",
    "psc": "54973",
    "okres": "Náchod",
    "obec": "Martínkovice",
    "val": "54973 Martinkovice Martinkovice"
  },
  {
    "cast": "Martinov",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Vlkovice",
    "val": "35301 Vlkovice Martinov"
  },
  {
    "cast": "Martinov",
    "psc": "72300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72300 Ostrava Martinov"
  },
  {
    "cast": "Martinov",
    "psc": "27713",
    "okres": "Praha-východ",
    "obec": "Záryby",
    "val": "27713 Zaryby Martinov"
  },
  {
    "cast": "Martinovice",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Sukorady",
    "val": "29406 Sukorady Martinovice"
  },
  {
    "cast": "Mařatice (část)",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68601 Uherske Hradiste Maratice (cast)"
  },
  {
    "cast": "Mařatice (část)",
    "psc": "68605",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68605 Uherske Hradiste Maratice (cast)"
  },
  {
    "cast": "Mařenice",
    "psc": "47156",
    "okres": "Česká Lípa",
    "obec": "Mařenice",
    "val": "47156 Marenice Marenice"
  },
  {
    "cast": "Mařeničky",
    "psc": "47156",
    "okres": "Česká Lípa",
    "obec": "Mařenice",
    "val": "47156 Marenice Marenicky"
  },
  {
    "cast": "Maříž",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Slavonice",
    "val": "37881 Slavonice Mariz"
  },
  {
    "cast": "Masákova Lhota (část)",
    "psc": "38472",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38472 Zdikov Masakova Lhota (cast)"
  },
  {
    "cast": "Masákova Lhota (část)",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Masakova Lhota (cast)"
  },
  {
    "cast": "Masečín",
    "psc": "25207",
    "okres": "Praha-západ",
    "obec": "Štěchovice",
    "val": "25207 Stechovice Masecin"
  },
  {
    "cast": "Maskovice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Netvořice",
    "val": "25744 Netvorice Maskovice"
  },
  {
    "cast": "Máslojedy",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Máslojedy",
    "val": "50303 Maslojedy Maslojedy"
  },
  {
    "cast": "Máslovice (část)",
    "psc": "25069",
    "okres": "Praha-východ",
    "obec": "Máslovice",
    "val": "25069 Maslovice Maslovice (cast)"
  },
  {
    "cast": "Máslovice (část)",
    "psc": "25266",
    "okres": "Praha-východ",
    "obec": "Máslovice",
    "val": "25266 Maslovice Maslovice (cast)"
  },
  {
    "cast": "Masojedy",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Masojedy",
    "val": "28201 Masojedy Masojedy"
  },
  {
    "cast": "Mastířovice",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Vrbice",
    "val": "41301 Vrbice Mastirovice"
  },
  {
    "cast": "Mastník",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Mastník",
    "val": "67522 Mastnik Mastnik"
  },
  {
    "cast": "Masty",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bílý Újezd",
    "val": "51801 Bily Ujezd Masty"
  },
  {
    "cast": "Maškovice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Ploskovice",
    "val": "41201 Ploskovice Maskovice"
  },
  {
    "cast": "Mašov",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Masov"
  },
  {
    "cast": "Mašov",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Masov"
  },
  {
    "cast": "Mašovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Hořepník",
    "val": "39501 Horepnik Masovice"
  },
  {
    "cast": "Mašovice",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Mašovice",
    "val": "66902 Masovice Masovice"
  },
  {
    "cast": "Mašovice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Masovice"
  },
  {
    "cast": "Mašovice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34601 Meclov Masovice"
  },
  {
    "cast": "Mašťov",
    "psc": "43156",
    "okres": "Chomutov",
    "obec": "Mašťov",
    "val": "43156 Mastov Mastov"
  },
  {
    "cast": "Matějov",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Matějov",
    "val": "59212 Matejov Matejov"
  },
  {
    "cast": "Matějov",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Matejov"
  },
  {
    "cast": "Matějovec",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "37881 Cesky Rudolec Matejovec"
  },
  {
    "cast": "Matějovec",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Jarošov nad Nežárkou",
    "val": "37842 Jarosov nad Nezarkou Matejovec"
  },
  {
    "cast": "Matějovice",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34022 Desenice Matejovice"
  },
  {
    "cast": "Matějovice",
    "psc": "79397",
    "okres": "Bruntál",
    "obec": "Rusín",
    "val": "79397 Rusin Matejovice"
  },
  {
    "cast": "Matná",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Matna"
  },
  {
    "cast": "Maxičky-Děčín XVIII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Maxicky-Decin XVIII x)"
  },
  {
    "cast": "Maxov",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Radvanec",
    "val": "47301 Radvanec Maxov"
  },
  {
    "cast": "Maxov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34401 Vseruby Maxov"
  },
  {
    "cast": "Maxovna",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Malešov",
    "val": "28401 Malesov Maxovna"
  },
  {
    "cast": "Mazelov",
    "psc": "37363",
    "okres": "České Budějovice",
    "obec": "Mazelov",
    "val": "37363 Mazelov Mazelov"
  },
  {
    "cast": "Mažice",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Mažice",
    "val": "39181 Mazice Mazice"
  },
  {
    "cast": "Mcely",
    "psc": "28936",
    "okres": "Nymburk",
    "obec": "Mcely",
    "val": "28936 Mcely Mcely"
  },
  {
    "cast": "Meclov",
    "psc": "34521",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34521 Meclov Meclov"
  },
  {
    "cast": "Mečeříž",
    "psc": "29477",
    "okres": "Mladá Boleslav",
    "obec": "Mečeříž",
    "val": "29477 Meceriz Meceriz"
  },
  {
    "cast": "Mečichov",
    "psc": "38736",
    "okres": "Strakonice",
    "obec": "Mečichov",
    "val": "38736 Mecichov Mecichov"
  },
  {
    "cast": "Měčín",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "34012 Mecin Mecin"
  },
  {
    "cast": "Mečíř",
    "psc": "28933",
    "okres": "Nymburk",
    "obec": "Křinec",
    "val": "28933 Krinec Mecir"
  },
  {
    "cast": "Mečkov",
    "psc": "34012",
    "okres": "Plzeň-jih",
    "obec": "Kbel",
    "val": "34012 Kbel Meckov"
  },
  {
    "cast": "Mečov",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Hořičky",
    "val": "55205 Horicky Mecov"
  },
  {
    "cast": "Měděnec",
    "psc": "43184",
    "okres": "Chomutov",
    "obec": "Měděnec",
    "val": "43184 Medenec Medenec"
  },
  {
    "cast": "Medkovy Kopce",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Raná",
    "val": "53901 Rana Medkovy Kopce"
  },
  {
    "cast": "Medlánky (část)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Medlanky (cast)"
  },
  {
    "cast": "Medlánky (část)",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Medlanky (cast)"
  },
  {
    "cast": "Medlešice",
    "psc": "53831",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53831 Chrudim Medlesice"
  },
  {
    "cast": "Medlice",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Medlice",
    "val": "67140 Medlice Medlice"
  },
  {
    "cast": "Medlov",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Zborovice",
    "val": "76802 Zborovice Medlov"
  },
  {
    "cast": "Medlov",
    "psc": "66466",
    "okres": "Brno-venkov",
    "obec": "Medlov",
    "val": "66466 Medlov Medlov"
  },
  {
    "cast": "Medlov (část)",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Medlov",
    "val": "78391 Medlov Medlov (cast)"
  },
  {
    "cast": "Medlov (část)",
    "psc": "78383",
    "okres": "Olomouc",
    "obec": "Medlov",
    "val": "78383 Medlov Medlov (cast)"
  },
  {
    "cast": "Medlovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Medlovice",
    "val": "68201 Medlovice Medlovice"
  },
  {
    "cast": "Medlovice",
    "psc": "68741",
    "okres": "Uherské Hradiště",
    "obec": "Medlovice",
    "val": "68741 Medlovice Medlovice"
  },
  {
    "cast": "Medná",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Srby",
    "val": "34601 Srby Medna"
  },
  {
    "cast": "Medonosy",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Medonosy",
    "val": "27721 Medonosy Medonosy"
  },
  {
    "cast": "Medový Újezd",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Medový Újezd",
    "val": "33701 Medovy Ujezd Medovy Ujezd"
  },
  {
    "cast": "Medvědice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41115 Trebenice Medvedice"
  },
  {
    "cast": "Měchenice",
    "psc": "25206",
    "okres": "Praha-západ",
    "obec": "Měchenice",
    "val": "25206 Mechenice Mechenice"
  },
  {
    "cast": "Měchnov",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Divišov",
    "val": "25726 Divisov Mechnov"
  },
  {
    "cast": "Měcholupy",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Předslav",
    "val": "33901 Predslav Mecholupy"
  },
  {
    "cast": "Měcholupy",
    "psc": "43931",
    "okres": "Louny",
    "obec": "Měcholupy",
    "val": "43931 Mecholupy Mecholupy"
  },
  {
    "cast": "Měcholupy",
    "psc": "33551",
    "okres": "Plzeň-jih",
    "obec": "Měcholupy",
    "val": "33551 Mecholupy Mecholupy"
  },
  {
    "cast": "Měchonice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Dolní Pohleď",
    "val": "28522 Dolni Pohled Mechonice"
  },
  {
    "cast": "Měchov",
    "psc": "36464",
    "okres": "Karlovy Vary",
    "obec": "Otročín",
    "val": "36464 Otrocin Mechov"
  },
  {
    "cast": "Mechová",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Mechova"
  },
  {
    "cast": "Měkynec",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Měkynec",
    "val": "38773 Mekynec Mekynec"
  },
  {
    "cast": "Melč",
    "psc": "74784",
    "okres": "Opava",
    "obec": "Melč",
    "val": "74784 Melc Melc"
  },
  {
    "cast": "Mělčany",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Mělčany",
    "val": "66464 Melcany Melcany"
  },
  {
    "cast": "Mělčany",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobruška",
    "val": "51801 Dobruska Melcany"
  },
  {
    "cast": "Mělice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Přelouč",
    "val": "53501 Prelouc Melice"
  },
  {
    "cast": "Mělkovice",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Melkovice"
  },
  {
    "cast": "Mělnice",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Melnice"
  },
  {
    "cast": "Mělnická Vrutice",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Velký Borek",
    "val": "27731 Velky Borek Melnicka Vrutice"
  },
  {
    "cast": "Mělnické Vtelno",
    "psc": "27738",
    "okres": "Mělník",
    "obec": "Mělnické Vtelno",
    "val": "27738 Melnicke Vtelno Melnicke Vtelno"
  },
  {
    "cast": "Mělník",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28506 Uzice Melnik"
  },
  {
    "cast": "Mělník (část)",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Mělník",
    "val": "27741 Melnik Melnik (cast)"
  },
  {
    "cast": "Mělník (část)",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Mělník",
    "val": "27601 Melnik Melnik (cast)"
  },
  {
    "cast": "Mělník (část)",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Mělník",
    "val": "27731 Melnik Melnik (cast)"
  },
  {
    "cast": "Měňany",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Měňany",
    "val": "26727 Menany Menany"
  },
  {
    "cast": "Menčice",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Všestary",
    "val": "25163 Vsestary Mencice"
  },
  {
    "cast": "Mendryka",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Janov",
    "val": "57001 Janov Mendryka"
  },
  {
    "cast": "Menhartice",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Menhartice",
    "val": "67531 Menhartice Menhartice"
  },
  {
    "cast": "Menhartice",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Menhartice"
  },
  {
    "cast": "Měník",
    "psc": "50364",
    "okres": "Hradec Králové",
    "obec": "Měník",
    "val": "50364 Menik Menik"
  },
  {
    "cast": "Měník",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Bílá Lhota",
    "val": "78321 Bila Lhota Menik"
  },
  {
    "cast": "Měnín (část)",
    "psc": "66457",
    "okres": "Brno-venkov",
    "obec": "Měnín",
    "val": "66457 Menin Menin (cast)"
  },
  {
    "cast": "Měnín (část)",
    "psc": "66455",
    "okres": "Brno-venkov",
    "obec": "Měnín",
    "val": "66455 Menin Menin (cast)"
  },
  {
    "cast": "Mentour",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Chroustovice",
    "val": "53863 Chroustovice Mentour"
  },
  {
    "cast": "Merboltice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Merboltice",
    "val": "40502 Merboltice Merboltice"
  },
  {
    "cast": "Měrčín",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Čížkov",
    "val": "33501 Cizkov Mercin"
  },
  {
    "cast": "Merklín",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Merklín",
    "val": "33452 Merklin Merklin"
  },
  {
    "cast": "Merklín",
    "psc": "36234",
    "okres": "Karlovy Vary",
    "obec": "Merklín",
    "val": "36234 Merklin Merklin"
  },
  {
    "cast": "Merklovice",
    "psc": "51754",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vamberk",
    "val": "51754 Vamberk Merklovice"
  },
  {
    "cast": "Měrkovice",
    "psc": "73947",
    "okres": "Frýdek-Místek",
    "obec": "Kozlovice",
    "val": "73947 Kozlovice Merkovice"
  },
  {
    "cast": "Měrotín",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Měrotín",
    "val": "78324 Merotin Merotin"
  },
  {
    "cast": "Měrovice nad Hanou",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Měrovice nad Hanou",
    "val": "75201 Merovice nad Hanou Merovice nad Hanou"
  },
  {
    "cast": "Měrunice",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Měrunice",
    "val": "41804 Merunice Merunice"
  },
  {
    "cast": "Měrůtky",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Lutopecny",
    "val": "76701 Lutopecny Merutky"
  },
  {
    "cast": "Měřín",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Rabyně",
    "val": "25744 Rabyne Merin"
  },
  {
    "cast": "Měřín (část)",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Měřín",
    "val": "59442 Merin Merin (cast)"
  },
  {
    "cast": "Měřín (část)",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Měřín",
    "val": "59401 Merin Merin (cast)"
  },
  {
    "cast": "Městec",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Nahořany",
    "val": "55101 Nahorany Mestec"
  },
  {
    "cast": "Městec",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Chroustovice",
    "val": "53863 Chroustovice Mestec"
  },
  {
    "cast": "Městec",
    "psc": "51771",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Očelice",
    "val": "51771 Ocelice Mestec"
  },
  {
    "cast": "Městec Králové",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Městec Králové",
    "val": "28903 Mestec Kralove Mestec Kralove"
  },
  {
    "cast": "Městečko",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Nespeky",
    "val": "25722 Nespeky Mestecko"
  },
  {
    "cast": "Městečko",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Chotýšany",
    "val": "25701 Chotysany Mestecko"
  },
  {
    "cast": "Městečko",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Městečko",
    "val": "27023 Mestecko Mestecko"
  },
  {
    "cast": "Městečko Trnávka (část)",
    "psc": "56941",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "56941 Mestecko Trnavka Mestecko Trnavka (cast)"
  },
  {
    "cast": "Městečko Trnávka (část)",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Mestecko Trnavka (cast)"
  },
  {
    "cast": "Městiště",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34022 Desenice Mestiste"
  },
  {
    "cast": "Město",
    "psc": "74601",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74601 Opava Mesto"
  },
  {
    "cast": "Město",
    "psc": "73511",
    "okres": "Karviná",
    "obec": "Orlová",
    "val": "73511 Orlova Mesto"
  },
  {
    "cast": "Město",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Svitavy",
    "val": "56802 Svitavy Mesto"
  },
  {
    "cast": "Město",
    "psc": "73601",
    "okres": "Karviná",
    "obec": "Havířov",
    "val": "73601 Havirov Mesto"
  },
  {
    "cast": "Město",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Domažlice",
    "val": "34401 Domazlice Mesto"
  },
  {
    "cast": "Město",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Mesto"
  },
  {
    "cast": "Město",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Moravská Třebová",
    "val": "57101 Moravska Trebova Mesto"
  },
  {
    "cast": "Město Albrechtice",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Mesto Albrechtice"
  },
  {
    "cast": "Město Libavá",
    "psc": "78307",
    "okres": "Olomouc",
    "obec": "Město Libavá",
    "val": "78307 Mesto Libava Mesto Libava"
  },
  {
    "cast": "Město Touškov",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Město Touškov",
    "val": "33033 Mesto Touskov Mesto Touskov"
  },
  {
    "cast": "Městská Lhotka",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Mestska Lhotka"
  },
  {
    "cast": "Městys Bílá Voda",
    "psc": "79069",
    "okres": "Jeseník",
    "obec": "Bílá Voda",
    "val": "79069 Bila Voda Mestys Bila Voda"
  },
  {
    "cast": "Měšetice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Mesetice"
  },
  {
    "cast": "Měšice",
    "psc": "25064",
    "okres": "Praha-východ",
    "obec": "Měšice",
    "val": "25064 Mesice Mesice"
  },
  {
    "cast": "Měšice (část)",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39002 Tabor Mesice (cast)"
  },
  {
    "cast": "Měšice (část)",
    "psc": "39156",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39156 Tabor Mesice (cast)"
  },
  {
    "cast": "Měšín",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Měšín",
    "val": "58601 Mesin Mesin"
  },
  {
    "cast": "Mešno",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Mešno",
    "val": "33843 Mesno Mesno"
  },
  {
    "cast": "Mešovice",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Uherčice",
    "val": "67107 Uhercice Mesovice"
  },
  {
    "cast": "Metánov (část)",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Častrov",
    "val": "39468 Castrov Metanov (cast)"
  },
  {
    "cast": "Metánov (část)",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Častrov",
    "val": "39470 Castrov Metanov (cast)"
  },
  {
    "cast": "Metly",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Předmíř",
    "val": "38742 Predmir Metly"
  },
  {
    "cast": "Metylovice",
    "psc": "73949",
    "okres": "Frýdek-Místek",
    "obec": "Metylovice",
    "val": "73949 Metylovice Metylovice"
  },
  {
    "cast": "Mezholezy",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Mezholezy",
    "val": "34506 Mezholezy Mezholezy"
  },
  {
    "cast": "Mezholezy",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Miskovice",
    "val": "28401 Miskovice Mezholezy"
  },
  {
    "cast": "Mezholezy",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Mezholezy",
    "val": "34601 Mezholezy Mezholezy"
  },
  {
    "cast": "Mezí",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Mezi"
  },
  {
    "cast": "Meziboří",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Strážek",
    "val": "59253 Strazek Mezibori"
  },
  {
    "cast": "Meziboří",
    "psc": "43513",
    "okres": "Most",
    "obec": "Meziboří",
    "val": "43513 Mezibori Mezibori"
  },
  {
    "cast": "Mezice",
    "psc": "78332",
    "okres": "Olomouc",
    "obec": "Náklo",
    "val": "78332 Naklo Mezice"
  },
  {
    "cast": "Mezihoří",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Mezihoří",
    "val": "34012 Mezihori Mezihori"
  },
  {
    "cast": "Mezihoří",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Blatno",
    "val": "43001 Blatno Mezihori"
  },
  {
    "cast": "Mezihoří",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Mlázovice",
    "val": "50781 Mlazovice Mezihori"
  },
  {
    "cast": "Mezihoří",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Horka",
    "val": "53851 Horka Mezihori"
  },
  {
    "cast": "Mezihoří",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Soběhrdy",
    "val": "25601 Sobehrdy Mezihori"
  },
  {
    "cast": "Mezihoří",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Mezihori"
  },
  {
    "cast": "Mezihoří",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Mezihori"
  },
  {
    "cast": "Meziklasí",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Město",
    "val": "58291 Dolni Mesto Meziklasi"
  },
  {
    "cast": "Mezilečí",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Mezilečí",
    "val": "55205 Mezileci Mezileci"
  },
  {
    "cast": "Mezilesí",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Mezilesí",
    "val": "39501 Mezilesi Mezilesi"
  },
  {
    "cast": "Mezilesí",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Kryštofovy Hamry",
    "val": "43191 Krystofovy Hamry Mezilesi"
  },
  {
    "cast": "Mezilesí",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Cotkytle",
    "val": "56301 Cotkytle Mezilesi"
  },
  {
    "cast": "Mezilesí",
    "psc": "54923",
    "okres": "Náchod",
    "obec": "Mezilesí",
    "val": "54923 Mezilesi Mezilesi"
  },
  {
    "cast": "Mezilesí",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Čížkrajice",
    "val": "37401 Cizkrajice Mezilesi"
  },
  {
    "cast": "Meziluží",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50601 Libosovice Meziluzi"
  },
  {
    "cast": "Meziluží",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Meziluzi"
  },
  {
    "cast": "Meziměstí (část)",
    "psc": "54981",
    "okres": "Náchod",
    "obec": "Meziměstí",
    "val": "54981 Mezimesti Mezimesti (cast)"
  },
  {
    "cast": "Meziměstí (část)",
    "psc": "54983",
    "okres": "Náchod",
    "obec": "Meziměstí",
    "val": "54983 Mezimesti Mezimesti (cast)"
  },
  {
    "cast": "Mezina",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Mezina",
    "val": "79201 Mezina Mezina"
  },
  {
    "cast": "Mezipotočí",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38101 Kajov Mezipotoci"
  },
  {
    "cast": "Mezirolí",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Nová Role",
    "val": "36225 Nova Role Meziroli"
  },
  {
    "cast": "Meziříčí",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Meziříčí",
    "val": "39131 Mezirici Mezirici"
  },
  {
    "cast": "Meziříčí",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Mezirici"
  },
  {
    "cast": "Meziříčí",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Malonty",
    "val": "38241 Malonty Mezirici"
  },
  {
    "cast": "Meziříčko",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Meziříčko",
    "val": "67526 Meziricko Meziricko"
  },
  {
    "cast": "Meziříčko",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Meziricko"
  },
  {
    "cast": "Meziříčko",
    "psc": "58827",
    "okres": "Žďár nad Sázavou",
    "obec": "Meziříčko",
    "val": "58827 Meziricko Meziricko"
  },
  {
    "cast": "Mezná",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Mezná",
    "val": "39201 Mezna Mezna"
  },
  {
    "cast": "Mezná",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Hřensko",
    "val": "40502 Hrensko Mezna"
  },
  {
    "cast": "Mezná",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Mezná",
    "val": "39301 Mezna Mezna"
  },
  {
    "cast": "Mezné",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Mezne"
  },
  {
    "cast": "Mezno",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Mezno",
    "val": "25786 Mezno Mezno"
  },
  {
    "cast": "Mezný",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Mezny"
  },
  {
    "cast": "Mezouň",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Mezouň",
    "val": "26718 Mezoun Mezoun"
  },
  {
    "cast": "Mchov",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Staré Sedliště",
    "val": "34801 Stare Sedliste Mchov"
  },
  {
    "cast": "Micmanice",
    "psc": "67129",
    "okres": "Znojmo",
    "obec": "Strachotice",
    "val": "67129 Strachotice Micmanice"
  },
  {
    "cast": "Míčov",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Míčov-Sušice",
    "val": "53803 Micov-Susice Micov"
  },
  {
    "cast": "Mičovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Mičovice",
    "val": "38301 Micovice Micovice"
  },
  {
    "cast": "Mihoukovice",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Budišov",
    "val": "67503 Budisov Mihoukovice"
  },
  {
    "cast": "Michálkovice",
    "psc": "71500",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71500 Ostrava Michalkovice"
  },
  {
    "cast": "Michalovice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Michalovice",
    "val": "41201 Michalovice Michalovice"
  },
  {
    "cast": "Michalovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Petrovice I",
    "val": "28522 Petrovice I Michalovice"
  },
  {
    "cast": "Michalovice",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Michalovice",
    "val": "58001 Michalovice Michalovice"
  },
  {
    "cast": "Michalovice",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Michalovice"
  },
  {
    "cast": "Michalovy Hory",
    "psc": "34813",
    "okres": "Tachov",
    "obec": "Chodová Planá",
    "val": "34813 Chodova Plana Michalovy Hory"
  },
  {
    "cast": "Michle (část)",
    "psc": "14000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14000 Praha Michle (cast)"
  },
  {
    "cast": "Michle (část)",
    "psc": "14100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14100 Praha Michle (cast)"
  },
  {
    "cast": "Michle (část)",
    "psc": "10100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10100 Praha Michle (cast)"
  },
  {
    "cast": "Michle (část)",
    "psc": "10600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10600 Praha Michle (cast)"
  },
  {
    "cast": "Michlova Huť",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Michlova Hut"
  },
  {
    "cast": "Michnice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Rožmitál na Šumavě",
    "val": "38241 Rozmital na Sumave Michnice"
  },
  {
    "cast": "Michnovka",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Kratonohy",
    "val": "50351 Kratonohy Michnovka"
  },
  {
    "cast": "Míchov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Míchov",
    "val": "67961 Michov Michov"
  },
  {
    "cast": "Míchov",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Věcov",
    "val": "59242 Vecov Michov"
  },
  {
    "cast": "Michovka",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Koberovy",
    "val": "46822 Koberovy Michovka"
  },
  {
    "cast": "Mikolajice",
    "psc": "74784",
    "okres": "Opava",
    "obec": "Mikolajice",
    "val": "74784 Mikolajice Mikolajice"
  },
  {
    "cast": "Mikovice",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Kralupy nad Vltavou",
    "val": "27801 Kralupy nad Vltavou Mikovice"
  },
  {
    "cast": "Míkovice",
    "psc": "68609",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68609 Uherske Hradiste Mikovice"
  },
  {
    "cast": "Mikulášov",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Herálec",
    "val": "58255 Heralec Mikulasov"
  },
  {
    "cast": "Mikulášovice",
    "psc": "40779",
    "okres": "Děčín",
    "obec": "Mikulášovice",
    "val": "40779 Mikulasovice Mikulasovice"
  },
  {
    "cast": "Mikulášovičky",
    "psc": "40779",
    "okres": "Děčín",
    "obec": "Mikulášovice",
    "val": "40779 Mikulasovice Mikulasovicky"
  },
  {
    "cast": "Mikulčice",
    "psc": "69619",
    "okres": "Hodonín",
    "obec": "Mikulčice",
    "val": "69619 Mikulcice Mikulcice"
  },
  {
    "cast": "Mikuleč",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Mikuleč",
    "val": "56802 Mikulec Mikulec"
  },
  {
    "cast": "Mikulov",
    "psc": "41901",
    "okres": "Teplice",
    "obec": "Mikulov",
    "val": "41901 Mikulov Mikulov"
  },
  {
    "cast": "Mikulov",
    "psc": "69201",
    "okres": "Břeclav",
    "obec": "Mikulov",
    "val": "69201 Mikulov Mikulov"
  },
  {
    "cast": "Mikulovice",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Mikulovice",
    "val": "67522 Mikulovice Mikulovice"
  },
  {
    "cast": "Mikulovice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Mikulovice",
    "val": "53002 Mikulovice Mikulovice"
  },
  {
    "cast": "Mikulovice",
    "psc": "67133",
    "okres": "Znojmo",
    "obec": "Mikulovice",
    "val": "67133 Mikulovice Mikulovice"
  },
  {
    "cast": "Mikulovice",
    "psc": "43545",
    "okres": "Most",
    "obec": "Nová Ves v Horách",
    "val": "43545 Nova Ves v Horach Mikulovice"
  },
  {
    "cast": "Mikulovice",
    "psc": "79084",
    "okres": "Jeseník",
    "obec": "Mikulovice",
    "val": "79084 Mikulovice Mikulovice"
  },
  {
    "cast": "Mikulovice",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Mikulovice"
  },
  {
    "cast": "Mikulůvka (část)",
    "psc": "75624",
    "okres": "Vsetín",
    "obec": "Mikulůvka",
    "val": "75624 Mikuluvka Mikuluvka (cast)"
  },
  {
    "cast": "Mikulůvka (část)",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Mikulůvka",
    "val": "75701 Mikuluvka Mikuluvka (cast)"
  },
  {
    "cast": "Milá",
    "psc": "43401",
    "okres": "Most",
    "obec": "Bečov",
    "val": "43401 Becov Mila"
  },
  {
    "cast": "Milanovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Pertoltice",
    "val": "28522 Pertoltice Milanovice"
  },
  {
    "cast": "Milasín",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Milasín",
    "val": "59251 Milasin Milasin"
  },
  {
    "cast": "Milavče",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Milavče",
    "val": "34401 Milavce Milavce"
  },
  {
    "cast": "Milbohov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Stebno",
    "val": "40002 Stebno Milbohov"
  },
  {
    "cast": "Milčeves",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žatec",
    "val": "43801 Zatec Milceves"
  },
  {
    "cast": "Milčice",
    "psc": "28911",
    "okres": "Nymburk",
    "obec": "Milčice",
    "val": "28911 Milcice Milcice"
  },
  {
    "cast": "Milčice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Milcice"
  },
  {
    "cast": "Milčice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Milcice"
  },
  {
    "cast": "Milčice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Myslív",
    "val": "34101 Mysliv Milcice"
  },
  {
    "cast": "Milčice",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Kraselov",
    "val": "38716 Kraselov Milcice"
  },
  {
    "cast": "Mileč",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mileč",
    "val": "33501 Milec Milec"
  },
  {
    "cast": "Milejovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Milejovice",
    "val": "38701 Milejovice Milejovice"
  },
  {
    "cast": "Milence",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34022 Desenice Milence"
  },
  {
    "cast": "Milenov",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Milenov",
    "val": "75361 Milenov Milenov"
  },
  {
    "cast": "Milenovice",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Milenovice"
  },
  {
    "cast": "Milesimov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Všeradov",
    "val": "53901 Vseradov Milesimov"
  },
  {
    "cast": "Milešín",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Milešín",
    "val": "59451 Milesin Milesin"
  },
  {
    "cast": "Milešov",
    "psc": "41132",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41132 Velemin Milesov"
  },
  {
    "cast": "Milešov (část)",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Milešov",
    "val": "26263 Milesov Milesov (cast)"
  },
  {
    "cast": "Milešov (část)",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Milešov",
    "val": "26256 Milesov Milesov (cast)"
  },
  {
    "cast": "Milešovice",
    "psc": "68354",
    "okres": "Vyškov",
    "obec": "Milešovice",
    "val": "68354 Milesovice Milesovice"
  },
  {
    "cast": "Miletice",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Černuc",
    "val": "27324 Cernuc Miletice"
  },
  {
    "cast": "Miletice",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Dlažov",
    "val": "34021 Dlazov Miletice"
  },
  {
    "cast": "Miletice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Nepoměřice",
    "val": "28504 Nepomerice Miletice"
  },
  {
    "cast": "Miletín",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Miletín",
    "val": "50771 Miletin Miletin"
  },
  {
    "cast": "Miletín",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Želiv",
    "val": "39601 Zeliv Miletin"
  },
  {
    "cast": "Miletín",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Onomyšl",
    "val": "28504 Onomysl Miletin"
  },
  {
    "cast": "Miletínky",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38301 Ktis Miletinky"
  },
  {
    "cast": "Milevo",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kladruby",
    "val": "34901 Kladruby Milevo"
  },
  {
    "cast": "Milevsko",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Milevsko",
    "val": "39901 Milevsko Milevsko"
  },
  {
    "cast": "Milhostice",
    "psc": "25791",
    "okres": "Benešov",
    "obec": "Červený Újezd",
    "val": "25791 Cerveny Ujezd Milhostice"
  },
  {
    "cast": "Milhostov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Milhostov",
    "val": "35002 Milhostov Milhostov"
  },
  {
    "cast": "Milhostov",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Zádub-Závišín",
    "val": "35301 Zadub-Zavisin Milhostov"
  },
  {
    "cast": "Milíčeves",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Slatiny",
    "val": "50601 Slatiny Miliceves"
  },
  {
    "cast": "Miličín",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Milicin"
  },
  {
    "cast": "Milíčov",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Milíčov",
    "val": "58805 Milicov Milicov"
  },
  {
    "cast": "Milíčov",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Šípy",
    "val": "27034 Sipy Milicov"
  },
  {
    "cast": "Milíčovice",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Milíčovice",
    "val": "66902 Milicovice Milicovice"
  },
  {
    "cast": "Milíkov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Milíkov",
    "val": "35002 Milikov Milikov"
  },
  {
    "cast": "Milíkov",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Stříbro",
    "val": "34901 Stribro Milikov"
  },
  {
    "cast": "Milíkov",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Milikov"
  },
  {
    "cast": "Milíkov",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Černá",
    "val": "59442 Cerna Milikov"
  },
  {
    "cast": "Milíkov",
    "psc": "73981",
    "okres": "Frýdek-Místek",
    "obec": "Milíkov",
    "val": "73981 Milikov Milikov"
  },
  {
    "cast": "Milíkovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Radošovice",
    "val": "38701 Radosovice Milikovice"
  },
  {
    "cast": "Milíkovice",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Milikovice"
  },
  {
    "cast": "Milín",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Milín",
    "val": "26231 Milin Milin"
  },
  {
    "cast": "Milínov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Milinov"
  },
  {
    "cast": "Milínov (část)",
    "psc": "33843",
    "okres": "Plzeň-jih",
    "obec": "Milínov",
    "val": "33843 Milinov Milinov (cast)"
  },
  {
    "cast": "Milínov (část)",
    "psc": "33204",
    "okres": "Plzeň-jih",
    "obec": "Milínov",
    "val": "33204 Milinov Milinov (cast)"
  },
  {
    "cast": "Milíře",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Milíře",
    "val": "34701 Milire Milire"
  },
  {
    "cast": "Milíře",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Rozvadov",
    "val": "34806 Rozvadov Milire"
  },
  {
    "cast": "Milíře",
    "psc": "46803",
    "okres": "Jablonec nad Nisou",
    "obec": "Rádlo",
    "val": "46803 Radlo Milire"
  },
  {
    "cast": "Milkov",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Ludmírov",
    "val": "79855 Ludmirov Milkov"
  },
  {
    "cast": "Milná",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Frymburk",
    "val": "38226 Frymburk Milna"
  },
  {
    "cast": "Milokošť",
    "psc": "69801",
    "okres": "Hodonín",
    "obec": "Veselí nad Moravou",
    "val": "69801 Veseli nad Moravou Milokost"
  },
  {
    "cast": "Milonice",
    "psc": "67922",
    "okres": "Blansko",
    "obec": "Milonice",
    "val": "67922 Milonice Milonice"
  },
  {
    "cast": "Milonice",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Milonice",
    "val": "68333 Milonice Milonice"
  },
  {
    "cast": "Miloňovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Miloňovice",
    "val": "38601 Milonovice Milonovice"
  },
  {
    "cast": "Milostín",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Milostín",
    "val": "27004 Milostin Milostin"
  },
  {
    "cast": "Milostovice",
    "psc": "74601",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74601 Opava Milostovice"
  },
  {
    "cast": "Milošice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Měcholupy",
    "val": "43801 Mecholupy Milosice"
  },
  {
    "cast": "Milošovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "28522 Vlastejovice Milosovice"
  },
  {
    "cast": "Milotice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Dehtáře",
    "val": "39301 Dehtare Milotice"
  },
  {
    "cast": "Milotice",
    "psc": "69605",
    "okres": "Hodonín",
    "obec": "Milotice",
    "val": "69605 Milotice Milotice"
  },
  {
    "cast": "Milotice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28522 Cestin Milotice"
  },
  {
    "cast": "Milotice nad Bečvou",
    "psc": "75367",
    "okres": "Přerov",
    "obec": "Milotice nad Bečvou",
    "val": "75367 Milotice nad Becvou Milotice nad Becvou"
  },
  {
    "cast": "Milotice nad Opavou",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Milotice nad Opavou",
    "val": "79201 Milotice nad Opavou Milotice nad Opavou"
  },
  {
    "cast": "Milotičky",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Červená Řečice",
    "val": "39301 Cervena Recice Miloticky"
  },
  {
    "cast": "Milovanice",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Milovanice"
  },
  {
    "cast": "Milovice",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Soběsuky",
    "val": "76802 Sobesuky Milovice"
  },
  {
    "cast": "Milovice",
    "psc": "28924",
    "okres": "Nymburk",
    "obec": "Milovice",
    "val": "28924 Milovice Milovice"
  },
  {
    "cast": "Milovice u Hořic",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Milovice u Hořic",
    "val": "50801 Milovice u Horic Milovice u Horic"
  },
  {
    "cast": "Milovice (část)",
    "psc": "69201",
    "okres": "Břeclav",
    "obec": "Milovice",
    "val": "69201 Milovice Milovice (cast)"
  },
  {
    "cast": "Milovice (část)",
    "psc": "69188",
    "okres": "Břeclav",
    "obec": "Milovice",
    "val": "69188 Milovice Milovice (cast)"
  },
  {
    "cast": "Milovy",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Sněžné",
    "val": "59202 Snezne Milovy"
  },
  {
    "cast": "Milý",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Milý",
    "val": "27054 Mily Mily"
  },
  {
    "cast": "Mimoň I",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Mimoň",
    "val": "47124 Mimon Mimon I"
  },
  {
    "cast": "Mimoň II",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Mimoň",
    "val": "47124 Mimon Mimon II"
  },
  {
    "cast": "Mimoň III",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Mimoň",
    "val": "47124 Mimon Mimon III"
  },
  {
    "cast": "Mimoň IV",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Mimoň",
    "val": "47124 Mimon Mimon IV"
  },
  {
    "cast": "Mimoň V",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Mimoň",
    "val": "47124 Mimon Mimon V"
  },
  {
    "cast": "Mimoň VI",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Mimoň",
    "val": "47124 Mimon Mimon VI"
  },
  {
    "cast": "Mimov",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Osvračín",
    "val": "34561 Osvracin Mimov"
  },
  {
    "cast": "Minartice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25753 Vojkov Minartice"
  },
  {
    "cast": "Minice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Minice",
    "val": "39804 Minice Minice"
  },
  {
    "cast": "Minice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Velemyšleves",
    "val": "43801 Velemysleves Minice"
  },
  {
    "cast": "Minice",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Kralupy nad Vltavou",
    "val": "27801 Kralupy nad Vltavou Minice"
  },
  {
    "cast": "Minkovice",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Šimonovice",
    "val": "46312 Simonovice Minkovice"
  },
  {
    "cast": "Minkovice",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46401 Visnova Minkovice"
  },
  {
    "cast": "Míreč",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Lom",
    "val": "38801 Lom Mirec"
  },
  {
    "cast": "Mírkov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Povrly",
    "val": "40002 Povrly Mirkov"
  },
  {
    "cast": "Mirkovice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mirkovice",
    "val": "38232 Mirkovice Mirkovice"
  },
  {
    "cast": "Mírkovice",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Mirkovice"
  },
  {
    "cast": "Mirochov",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Chlum u Třeboně",
    "val": "37806 Chlum u Trebone Mirochov"
  },
  {
    "cast": "Miroslav",
    "psc": "67172",
    "okres": "Znojmo",
    "obec": "Miroslav",
    "val": "67172 Miroslav Miroslav"
  },
  {
    "cast": "Miroslav",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Miroslav"
  },
  {
    "cast": "Miroslavské Knínice",
    "psc": "67172",
    "okres": "Znojmo",
    "obec": "Miroslavské Knínice",
    "val": "67172 Miroslavske Kninice Miroslavske Kninice"
  },
  {
    "cast": "Mirošov",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Mirošov",
    "val": "58805 Mirosov Mirosov"
  },
  {
    "cast": "Mirošov",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Mirošov",
    "val": "33843 Mirosov Mirosov"
  },
  {
    "cast": "Mirošov",
    "psc": "59255",
    "okres": "Žďár nad Sázavou",
    "obec": "Mirošov",
    "val": "59255 Mirosov Mirosov"
  },
  {
    "cast": "Mirošov",
    "psc": "76601",
    "okres": "Zlín",
    "obec": "Valašské Klobouky",
    "val": "76601 Valasske Klobouky Mirosov"
  },
  {
    "cast": "Mirošovice",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41804 Hrobcice Mirosovice"
  },
  {
    "cast": "Mirošovice",
    "psc": "25166",
    "okres": "Praha-východ",
    "obec": "Mirošovice",
    "val": "25166 Mirosovice Mirosovice"
  },
  {
    "cast": "Mirošovice",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Rataje nad Sázavou",
    "val": "28506 Rataje nad Sazavou Mirosovice"
  },
  {
    "cast": "Mirotice",
    "psc": "39801",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39801 Mirotice Mirotice"
  },
  {
    "cast": "Mirotice",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Mirotice"
  },
  {
    "cast": "Mirotín",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Mnich",
    "val": "39470 Mnich Mirotin"
  },
  {
    "cast": "Mirotínek",
    "psc": "79344",
    "okres": "Bruntál",
    "obec": "Tvrdkov",
    "val": "79344 Tvrdkov Mirotinek"
  },
  {
    "cast": "Mírov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Mírov",
    "val": "78901 Mirov Mirov"
  },
  {
    "cast": "Mírová",
    "psc": "35735",
    "okres": "Karlovy Vary",
    "obec": "Mírová",
    "val": "35735 Mirova Mirova"
  },
  {
    "cast": "Mírovice",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Veleň",
    "val": "25063 Velen Mirovice"
  },
  {
    "cast": "Mirovice (část)",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Mirovice (cast)"
  },
  {
    "cast": "Mirovice (část)",
    "psc": "39806",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39806 Mirovice Mirovice (cast)"
  },
  {
    "cast": "Mírovka",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Mirovka"
  },
  {
    "cast": "Miřátky",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vepříkov",
    "val": "58282 Veprikov Miratky"
  },
  {
    "cast": "Miřejov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Lanžov",
    "val": "54401 Lanzov Mirejov"
  },
  {
    "cast": "Miřejovice",
    "psc": "27751",
    "okres": "Mělník",
    "obec": "Nová Ves",
    "val": "27751 Nova Ves Mirejovice"
  },
  {
    "cast": "Miřejovice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Miřejovice",
    "val": "41201 Mirejovice Mirejovice"
  },
  {
    "cast": "Miřenice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Mirenice"
  },
  {
    "cast": "Miřetice",
    "psc": "38486",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38486 Vacov Miretice"
  },
  {
    "cast": "Miřetice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Miřetice",
    "val": "25765 Miretice Miretice"
  },
  {
    "cast": "Miřetice u Klášterce nad Ohří",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Miretice u Klasterce nad Ohri"
  },
  {
    "cast": "Miřetice u Vintířova",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43201 Radonice Miretice u Vintirova"
  },
  {
    "cast": "Miřetice (část)",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53825 Miretice Miretice (cast)"
  },
  {
    "cast": "Miřetice (část)",
    "psc": "53955",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53955 Miretice Miretice (cast)"
  },
  {
    "cast": "Miřetín",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Proseč",
    "val": "53944 Prosec Miretin"
  },
  {
    "cast": "Mířkov",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Mířkov",
    "val": "34601 Mirkov Mirkov"
  },
  {
    "cast": "Mířovice",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Ves Touškov",
    "val": "33301 Ves Touskov Mirovice"
  },
  {
    "cast": "Miskolezy",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Chvalkovice",
    "val": "55204 Chvalkovice Miskolezy"
  },
  {
    "cast": "Miskovice",
    "psc": "28501",
    "okres": "Kutná Hora",
    "obec": "Miskovice",
    "val": "28501 Miskovice Miskovice"
  },
  {
    "cast": "Místek",
    "psc": "73801",
    "okres": "Frýdek-Místek",
    "obec": "Frýdek-Místek",
    "val": "73801 Frydek-Mistek Mistek"
  },
  {
    "cast": "Místo",
    "psc": "43158",
    "okres": "Chomutov",
    "obec": "Místo",
    "val": "43158 Misto Misto"
  },
  {
    "cast": "Mistrovice",
    "psc": "47113",
    "okres": "Česká Lípa",
    "obec": "Nový Oldřichov",
    "val": "47113 Novy Oldrichov Mistrovice"
  },
  {
    "cast": "Mistrovice",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Mistrovice",
    "val": "56164 Mistrovice Mistrovice"
  },
  {
    "cast": "Mistřice",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Mistřice",
    "val": "68712 Mistrice Mistrice"
  },
  {
    "cast": "Mistřín",
    "psc": "69604",
    "okres": "Hodonín",
    "obec": "Svatobořice-Mistřín",
    "val": "69604 Svatoborice-Mistrin Mistrin"
  },
  {
    "cast": "Mistřovice",
    "psc": "73562",
    "okres": "Karviná",
    "obec": "Český Těšín",
    "val": "73562 Cesky Tesin Mistrovice"
  },
  {
    "cast": "Miškovice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Třebovle",
    "val": "28002 Trebovle Miskovice"
  },
  {
    "cast": "Miškovice",
    "psc": "19600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19600 Praha Miskovice"
  },
  {
    "cast": "Míškovice",
    "psc": "76852",
    "okres": "Kroměříž",
    "obec": "Míškovice",
    "val": "76852 Miskovice Miskovice"
  },
  {
    "cast": "Míšov",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Míšov",
    "val": "33563 Misov Misov"
  },
  {
    "cast": "Mišovice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mišovice",
    "val": "39804 Misovice Misovice"
  },
  {
    "cast": "Míšovice",
    "psc": "67171",
    "okres": "Znojmo",
    "obec": "Hostěradice",
    "val": "67171 Hosteradice Misovice"
  },
  {
    "cast": "Mítov",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Nové Mitrovice",
    "val": "33563 Nove Mitrovice Mitov"
  },
  {
    "cast": "Mitrov",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Strážek",
    "val": "59253 Strazek Mitrov"
  },
  {
    "cast": "Mitrov",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Uhlířské Janovice",
    "val": "28504 Uhlirske Janovice Mitrov"
  },
  {
    "cast": "Mitrovice",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Mezno",
    "val": "25786 Mezno Mitrovice"
  },
  {
    "cast": "Mitrovice",
    "psc": "78982",
    "okres": "Šumperk",
    "obec": "Moravičany",
    "val": "78982 Moravicany Mitrovice"
  },
  {
    "cast": "Mizerov (část)",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Mizerov (cast)"
  },
  {
    "cast": "Mizerov (část)",
    "psc": "73401",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73401 Karvina Mizerov (cast)"
  },
  {
    "cast": "Mladá Boleslav I",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Mlada Boleslav I"
  },
  {
    "cast": "Mladá Boleslav II",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Mlada Boleslav II"
  },
  {
    "cast": "Mladá Boleslav III",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Mlada Boleslav III"
  },
  {
    "cast": "Mladá Boleslav IV",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Mlada Boleslav IV"
  },
  {
    "cast": "Mladá Vožice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Mlada Vozice"
  },
  {
    "cast": "Mladá (část)",
    "psc": "28923",
    "okres": "Nymburk",
    "obec": "Milovice",
    "val": "28923 Milovice Mlada (cast)"
  },
  {
    "cast": "Mladá (část)",
    "psc": "28924",
    "okres": "Nymburk",
    "obec": "Milovice",
    "val": "28924 Milovice Mlada (cast)"
  },
  {
    "cast": "Mladcová",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76001 Zlin Mladcova"
  },
  {
    "cast": "Mladé",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41145 Libesice Mlade"
  },
  {
    "cast": "Mladé Bříště",
    "psc": "39443",
    "okres": "Pelhřimov",
    "obec": "Mladé Bříště",
    "val": "39443 Mlade Briste Mlade Briste"
  },
  {
    "cast": "Mladé Buky (část)",
    "psc": "54223",
    "okres": "Trutnov",
    "obec": "Mladé Buky",
    "val": "54223 Mlade Buky Mlade Buky (cast)"
  },
  {
    "cast": "Mladé Buky (část)",
    "psc": "54224",
    "okres": "Trutnov",
    "obec": "Mladé Buky",
    "val": "54224 Mlade Buky Mlade Buky (cast)"
  },
  {
    "cast": "Mladecko",
    "psc": "74754",
    "okres": "Opava",
    "obec": "Mladecko",
    "val": "74754 Mladecko Mladecko"
  },
  {
    "cast": "Mladeč",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Mladeč",
    "val": "78321 Mladec Mladec"
  },
  {
    "cast": "Mladějov na Moravě",
    "psc": "56935",
    "okres": "Svitavy",
    "obec": "Mladějov na Moravě",
    "val": "56935 Mladejov na Morave Mladejov na Morave"
  },
  {
    "cast": "Mladějov (část)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50601 Mladejov Mladejov (cast)"
  },
  {
    "cast": "Mladějov (část)",
    "psc": "50745",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50745 Mladejov Mladejov (cast)"
  },
  {
    "cast": "Mladějovice",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Mladějovice",
    "val": "78501 Mladejovice Mladejovice"
  },
  {
    "cast": "Mladějovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Čejetice",
    "val": "38601 Cejetice Mladejovice"
  },
  {
    "cast": "Mladice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Zavlekov",
    "val": "34142 Zavlekov Mladice"
  },
  {
    "cast": "Mladíkov",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Mladikov"
  },
  {
    "cast": "Mladkov",
    "psc": "67901",
    "okres": "Blansko",
    "obec": "Boskovice",
    "val": "67901 Boskovice Mladkov"
  },
  {
    "cast": "Mladkov (část)",
    "psc": "56167",
    "okres": "Ústí nad Orlicí",
    "obec": "Mladkov",
    "val": "56167 Mladkov Mladkov (cast)"
  },
  {
    "cast": "Mladkov (část)",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Mladkov",
    "val": "56401 Mladkov Mladkov (cast)"
  },
  {
    "cast": "Mladočov",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Poříčí u Litomyšle",
    "val": "57001 Porici u Litomysle Mladocov"
  },
  {
    "cast": "Mladoňov",
    "psc": "78803",
    "okres": "Šumperk",
    "obec": "Nový Malín",
    "val": "78803 Novy Malin Mladonov"
  },
  {
    "cast": "Mladoňovice",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Mladoňovice",
    "val": "53821 Mladonovice Mladonovice"
  },
  {
    "cast": "Mladoňovice",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Mladoňovice",
    "val": "67532 Mladonovice Mladonovice"
  },
  {
    "cast": "Mladostov",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Vyskeř",
    "val": "51101 Vysker Mladostov"
  },
  {
    "cast": "Mladošovice",
    "psc": "37901",
    "okres": "České Budějovice",
    "obec": "Mladošovice",
    "val": "37901 Mladosovice Mladosovice"
  },
  {
    "cast": "Mladotice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Drhovle",
    "val": "39701 Drhovle Mladotice"
  },
  {
    "cast": "Mladotice",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Kraselov",
    "val": "38716 Kraselov Mladotice"
  },
  {
    "cast": "Mladotice",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Mladotice",
    "val": "33141 Mladotice Mladotice"
  },
  {
    "cast": "Mladotice",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Mladotice"
  },
  {
    "cast": "Mladotice",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Ronov nad Doubravou",
    "val": "53843 Ronov nad Doubravou Mladotice"
  },
  {
    "cast": "Mladoušov",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Mladousov"
  },
  {
    "cast": "Mladovice",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Popovice",
    "val": "25701 Popovice Mladovice"
  },
  {
    "cast": "Mladý Smolivec",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mladý Smolivec",
    "val": "33501 Mlady Smolivec Mlady Smolivec"
  },
  {
    "cast": "Mláka (část)",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Novosedly nad Nežárkou",
    "val": "37901 Novosedly nad Nezarkou Mlaka (cast)"
  },
  {
    "cast": "Mláka (část)",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Novosedly nad Nežárkou",
    "val": "37802 Novosedly nad Nezarkou Mlaka (cast)"
  },
  {
    "cast": "Mlatce",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Františkov nad Ploučnicí",
    "val": "40502 Frantiskov nad Ploucnici Mlatce"
  },
  {
    "cast": "Mlázovice (část)",
    "psc": "50758",
    "okres": "Jičín",
    "obec": "Mlázovice",
    "val": "50758 Mlazovice Mlazovice (cast)"
  },
  {
    "cast": "Mlázovice (část)",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Mlázovice",
    "val": "50781 Mlazovice Mlazovice (cast)"
  },
  {
    "cast": "Mlázovy",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Mlazovy"
  },
  {
    "cast": "Mlčechvosty",
    "psc": "27707",
    "okres": "Mělník",
    "obec": "Vraňany",
    "val": "27707 Vranany Mlcechvosty"
  },
  {
    "cast": "Mlčkov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Přeštěnice",
    "val": "39901 Prestenice Mlckov"
  },
  {
    "cast": "Mlečice",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Mlečice",
    "val": "33808 Mlecice Mlecice"
  },
  {
    "cast": "Mlékojedy",
    "psc": "27711",
    "okres": "Mělník",
    "obec": "Neratovice",
    "val": "27711 Neratovice Mlekojedy"
  },
  {
    "cast": "Mlékojedy",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Mlékojedy",
    "val": "41201 Mlekojedy Mlekojedy"
  },
  {
    "cast": "Mlékosrby",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Mlékosrby",
    "val": "50351 Mlekosrby Mlekosrby"
  },
  {
    "cast": "Mlékovice",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Toušice",
    "val": "28144 Tousice Mlekovice"
  },
  {
    "cast": "Mlékovice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Mlekovice"
  },
  {
    "cast": "Mlynářovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "33901 Planice Mlynarovice"
  },
  {
    "cast": "Mlynářovice (část)",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Volary",
    "val": "38451 Volary Mlynarovice (cast)"
  },
  {
    "cast": "Mlynářovice (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Volary",
    "val": "38301 Volary Mlynarovice (cast)"
  },
  {
    "cast": "Mlýnce",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Vroutek",
    "val": "44101 Vroutek Mlynce"
  },
  {
    "cast": "Mlýnec",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Mlynec"
  },
  {
    "cast": "Mlýnec",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Poleň",
    "val": "33901 Polen Mlynec"
  },
  {
    "cast": "Mlýnec",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Kopidlno",
    "val": "50732 Kopidlno Mlynec"
  },
  {
    "cast": "Mlýnec",
    "psc": "34535",
    "okres": "Domažlice",
    "obec": "Postřekov",
    "val": "34535 Postrekov Mlynec"
  },
  {
    "cast": "Mlýneček",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Mrákov",
    "val": "34401 Mrakov Mlynecek"
  },
  {
    "cast": "Mlýnek",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Nový Kostel",
    "val": "35134 Novy Kostel Mlynek"
  },
  {
    "cast": "Mlýnice",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Nová Ves",
    "val": "46331 Nova Ves Mlynice"
  },
  {
    "cast": "Mlýnice",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56169 Cervena Voda Mlynice"
  },
  {
    "cast": "Mlýnický Dvůr",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56169 Cervena Voda Mlynicky Dvur"
  },
  {
    "cast": "Mlýnská",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Mlynska"
  },
  {
    "cast": "Mlýnské Struhadlo",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mlýnské Struhadlo",
    "val": "33901 Mlynske Struhadlo Mlynske Struhadlo"
  },
  {
    "cast": "Mlýny",
    "psc": "41704",
    "okres": "Teplice",
    "obec": "Hrob",
    "val": "41704 Hrob Mlyny"
  },
  {
    "cast": "Mlýny",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Mlýny",
    "val": "39201 Mlyny Mlyny"
  },
  {
    "cast": "Mlýny",
    "psc": "40745",
    "okres": "Děčín",
    "obec": "Kytlice",
    "val": "40745 Kytlice Mlyny"
  },
  {
    "cast": "Mlýny",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Mlyny"
  },
  {
    "cast": "Mnetěš",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Mnetěš",
    "val": "41301 Mnetes Mnetes"
  },
  {
    "cast": "Mnětice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Mnetice"
  },
  {
    "cast": "Mnich",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Kardašova Řečice",
    "val": "37821 Kardasova Recice Mnich"
  },
  {
    "cast": "Mnich (část)",
    "psc": "39492",
    "okres": "Pelhřimov",
    "obec": "Mnich",
    "val": "39492 Mnich Mnich (cast)"
  },
  {
    "cast": "Mnich (část)",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Mnich",
    "val": "39470 Mnich Mnich (cast)"
  },
  {
    "cast": "Mnichov",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Mnichov"
  },
  {
    "cast": "Mnichov",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Mnichov",
    "val": "34522 Mnichov Mnichov"
  },
  {
    "cast": "Mnichov",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mnichov",
    "val": "35301 Mnichov Mnichov"
  },
  {
    "cast": "Mnichov",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Mnichov",
    "val": "38601 Mnichov Mnichov"
  },
  {
    "cast": "Mnichov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Velké Chvojno",
    "val": "40002 Velke Chvojno Mnichov"
  },
  {
    "cast": "Mnichov",
    "psc": "79326",
    "okres": "Bruntál",
    "obec": "Vrbno pod Pradědem",
    "val": "79326 Vrbno pod Pradedem Mnichov"
  },
  {
    "cast": "Mnichovice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Mnichovice",
    "val": "25765 Mnichovice Mnichovice"
  },
  {
    "cast": "Mnichovice",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Mnichovice",
    "val": "25164 Mnichovice Mnichovice"
  },
  {
    "cast": "Mnichovo Hradiště",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Mnichovo Hradiste"
  },
  {
    "cast": "Mnichovský Týnec",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Chožov",
    "val": "44001 Chozov Mnichovsky Tynec"
  },
  {
    "cast": "Mníšek",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Mníšek",
    "val": "46331 Mnisek Mnisek"
  },
  {
    "cast": "Mníšek",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Stříbřec",
    "val": "37901 Stribrec Mnisek"
  },
  {
    "cast": "Mníšek",
    "psc": "43545",
    "okres": "Most",
    "obec": "Nová Ves v Horách",
    "val": "43545 Nova Ves v Horach Mnisek"
  },
  {
    "cast": "Mníšek pod Brdy",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Mníšek pod Brdy",
    "val": "25210 Mnisek pod Brdy Mnisek pod Brdy"
  },
  {
    "cast": "Mniší",
    "psc": "74221",
    "okres": "Nový Jičín",
    "obec": "Kopřivnice",
    "val": "74221 Koprivnice Mnisi"
  },
  {
    "cast": "Močedník",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Vitice",
    "val": "28163 Vitice Mocednik"
  },
  {
    "cast": "Močerady",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Močerady",
    "val": "34561 Mocerady Mocerady"
  },
  {
    "cast": "Močidla",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Jiřice",
    "val": "39601 Jirice Mocidla"
  },
  {
    "cast": "Močidlec",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Pšov",
    "val": "36452 Psov Mocidlec"
  },
  {
    "cast": "Močítka",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Svijanský Újezd",
    "val": "46345 Svijansky Ujezd Mocitka"
  },
  {
    "cast": "Močovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Močovice",
    "val": "28601 Mocovice Mocovice"
  },
  {
    "cast": "Modlany",
    "psc": "41713",
    "okres": "Teplice",
    "obec": "Modlany",
    "val": "41713 Modlany Modlany"
  },
  {
    "cast": "Modlenice",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Modlenice"
  },
  {
    "cast": "Modlešovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Strakonice",
    "val": "38601 Strakonice Modlesovice"
  },
  {
    "cast": "Modletice",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Písečné",
    "val": "37881 Pisecne Modletice"
  },
  {
    "cast": "Modletice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Modletice",
    "val": "25101 Modletice Modletice"
  },
  {
    "cast": "Modletín",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Rušinov",
    "val": "58301 Rusinov Modletin"
  },
  {
    "cast": "Modlibohov",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Modlibohov"
  },
  {
    "cast": "Modlíkov",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Modlikov"
  },
  {
    "cast": "Modlíkov",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Modlíkov",
    "val": "58222 Modlikov Modlikov"
  },
  {
    "cast": "Modlín",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Modlin"
  },
  {
    "cast": "Modrá",
    "psc": "40702",
    "okres": "Děčín",
    "obec": "Jílové",
    "val": "40702 Jilove Modra"
  },
  {
    "cast": "Modrá",
    "psc": "68706",
    "okres": "Uherské Hradiště",
    "obec": "Modrá",
    "val": "68706 Modra Modra"
  },
  {
    "cast": "Modrá Hůrka",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Modrá Hůrka",
    "val": "37501 Modra Hurka Modra Hurka"
  },
  {
    "cast": "Modrava",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Modrava",
    "val": "34192 Modrava Modrava"
  },
  {
    "cast": "Modřany",
    "psc": "14300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14300 Praha Modrany"
  },
  {
    "cast": "Modřec",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Polička",
    "val": "57201 Policka Modrec"
  },
  {
    "cast": "Modřejovice",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Slabce",
    "val": "27041 Slabce Modrejovice"
  },
  {
    "cast": "Modřice",
    "psc": "66442",
    "okres": "Brno-venkov",
    "obec": "Modřice",
    "val": "66442 Modrice Modrice"
  },
  {
    "cast": "Modřišice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Modřišice",
    "val": "51101 Modrisice Modrisice"
  },
  {
    "cast": "Modřovice",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Modřovice",
    "val": "26242 Modrovice Modrovice"
  },
  {
    "cast": "Mohelnice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Křešín",
    "val": "39501 Kresin Mohelnice"
  },
  {
    "cast": "Mohelnice",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Mohelnice",
    "val": "78985 Mohelnice Mohelnice"
  },
  {
    "cast": "Mohelnice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mohelnice",
    "val": "33501 Mohelnice Mohelnice"
  },
  {
    "cast": "Mohelnice nad Jizerou",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Mohelnice nad Jizerou",
    "val": "29413 Mohelnice nad Jizerou Mohelnice nad Jizerou"
  },
  {
    "cast": "Mohelno",
    "psc": "67575",
    "okres": "Třebíč",
    "obec": "Mohelno",
    "val": "67575 Mohelno Mohelno"
  },
  {
    "cast": "Mohuřice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Slavče",
    "val": "37401 Slavce Mohurice"
  },
  {
    "cast": "Mochov",
    "psc": "25087",
    "okres": "Praha-východ",
    "obec": "Mochov",
    "val": "25087 Mochov Mochov"
  },
  {
    "cast": "Mochov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Mochov"
  },
  {
    "cast": "Mochtín",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Mochtin"
  },
  {
    "cast": "Mojkov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Vlachovo Březí",
    "val": "38301 Vlachovo Brezi Mojkov"
  },
  {
    "cast": "Mojné",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mojné",
    "val": "38232 Mojne Mojne"
  },
  {
    "cast": "Mojžíř",
    "psc": "40331",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40331 Usti nad Labem Mojzir"
  },
  {
    "cast": "Mokliny",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Mokliny"
  },
  {
    "cast": "Mokošín",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Mokošín",
    "val": "53501 Mokosin Mokosin"
  },
  {
    "cast": "Mokrá",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Vesce",
    "val": "39201 Vesce Mokra"
  },
  {
    "cast": "Mokrá",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Čichalov",
    "val": "36453 Cichalov Mokra"
  },
  {
    "cast": "Mokrá",
    "psc": "66404",
    "okres": "Brno-venkov",
    "obec": "Mokrá-Horákov",
    "val": "66404 Mokra-Horakov Mokra"
  },
  {
    "cast": "Mokrá",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Černá v Pošumaví",
    "val": "38226 Cerna v Posumavi Mokra"
  },
  {
    "cast": "Mokrá Hora",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Mokra Hora"
  },
  {
    "cast": "Mokrá Lhota",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Mokra Lhota"
  },
  {
    "cast": "Mokrá Lhota",
    "psc": "53944",
    "okres": "Ústí nad Orlicí",
    "obec": "Nové Hrady",
    "val": "53944 Nove Hrady Mokra Lhota"
  },
  {
    "cast": "Mokré",
    "psc": "51771",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Mokré",
    "val": "51771 Mokre Mokre"
  },
  {
    "cast": "Mokré",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Litvínovice",
    "val": "37001 Litvinovice Mokre"
  },
  {
    "cast": "Mokré Lazce",
    "psc": "74762",
    "okres": "Opava",
    "obec": "Mokré Lazce",
    "val": "74762 Mokre Lazce Mokre Lazce"
  },
  {
    "cast": "Mokrosuky",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Mokrosuky",
    "val": "34201 Mokrosuky Mokrosuky"
  },
  {
    "cast": "Mokrouše",
    "psc": "33201",
    "okres": "Plzeň-město",
    "obec": "Mokrouše",
    "val": "33201 Mokrouse Mokrouse"
  },
  {
    "cast": "Mokrovousy",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Mokrovousy",
    "val": "50315 Mokrovousy Mokrovousy"
  },
  {
    "cast": "Mokrovraty",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Mokrovraty",
    "val": "26203 Mokrovraty Mokrovraty"
  },
  {
    "cast": "Mokrsko",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Mokrsko"
  },
  {
    "cast": "Mokrý",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Všeň",
    "val": "51101 Vsen Mokry"
  },
  {
    "cast": "Mokrý Lom",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Mokrý Lom",
    "val": "37401 Mokry Lom Mokry Lom"
  },
  {
    "cast": "Mokrýšov",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Prosetín",
    "val": "53973 Prosetin Mokrysov"
  },
  {
    "cast": "Mokřany",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25901 Olbramovice Mokrany"
  },
  {
    "cast": "Mokřany",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Mokrany"
  },
  {
    "cast": "Mokřany",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Mokrany"
  },
  {
    "cast": "Mokřice",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Mokrice"
  },
  {
    "cast": "Mokřina",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Milíkov",
    "val": "35002 Milikov Mokrina"
  },
  {
    "cast": "Mokřiny",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As Mokriny"
  },
  {
    "cast": "Mokřiny",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Mokriny"
  },
  {
    "cast": "Moldava",
    "psc": "41781",
    "okres": "Teplice",
    "obec": "Moldava",
    "val": "41781 Moldava Moldava"
  },
  {
    "cast": "Molenburk",
    "psc": "67913",
    "okres": "Blansko",
    "obec": "Vysočany",
    "val": "67913 Vysocany Molenburk"
  },
  {
    "cast": "Molitorov",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Kouřim",
    "val": "28163 Kourim Molitorov"
  },
  {
    "cast": "Monín",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Monin"
  },
  {
    "cast": "Moninec",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Moninec"
  },
  {
    "cast": "Morány",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28522 Cestin Morany"
  },
  {
    "cast": "Morašice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Morašice",
    "val": "53501 Morasice Morasice"
  },
  {
    "cast": "Morašice",
    "psc": "67171",
    "okres": "Znojmo",
    "obec": "Morašice",
    "val": "67171 Morasice Morasice"
  },
  {
    "cast": "Morašice",
    "psc": "56951",
    "okres": "Svitavy",
    "obec": "Morašice",
    "val": "56951 Morasice Morasice"
  },
  {
    "cast": "Morašice (část)",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Morašice",
    "val": "53803 Morasice Morasice (cast)"
  },
  {
    "cast": "Morašice (část)",
    "psc": "53802",
    "okres": "Chrudim",
    "obec": "Morašice",
    "val": "53802 Morasice Morasice (cast)"
  },
  {
    "cast": "Moravanský",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Moravany",
    "val": "53002 Moravany Moravansky"
  },
  {
    "cast": "Moravany",
    "psc": "69650",
    "okres": "Hodonín",
    "obec": "Moravany",
    "val": "69650 Moravany Moravany"
  },
  {
    "cast": "Moravany",
    "psc": "53372",
    "okres": "Pardubice",
    "obec": "Moravany",
    "val": "53372 Moravany Moravany"
  },
  {
    "cast": "Moravany",
    "psc": "66448",
    "okres": "Brno-venkov",
    "obec": "Moravany",
    "val": "66448 Moravany Moravany"
  },
  {
    "cast": "Moravany",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Ronov nad Doubravou",
    "val": "53843 Ronov nad Doubravou Moravany"
  },
  {
    "cast": "Moravany",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Řehlovice",
    "val": "40002 Rehlovice Moravany"
  },
  {
    "cast": "Moravčice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Moravcice"
  },
  {
    "cast": "Moravec",
    "psc": "59254",
    "okres": "Žďár nad Sázavou",
    "obec": "Moravec",
    "val": "59254 Moravec Moravec"
  },
  {
    "cast": "Moravecké Janovice",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Strážek",
    "val": "59253 Strazek Moravecke Janovice"
  },
  {
    "cast": "Moravecké Pavlovice",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Moravecké Pavlovice",
    "val": "59262 Moravecke Pavlovice Moravecke Pavlovice"
  },
  {
    "cast": "Moraveč",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Moravec"
  },
  {
    "cast": "Moraveč",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Slapsko",
    "val": "39143 Slapsko Moravec"
  },
  {
    "cast": "Moraveč",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Moraveč",
    "val": "39301 Moravec Moravec"
  },
  {
    "cast": "Moravěves",
    "psc": "43401",
    "okres": "Most",
    "obec": "Havraň",
    "val": "43401 Havran Moraveves"
  },
  {
    "cast": "Moravice",
    "psc": "74784",
    "okres": "Opava",
    "obec": "Moravice",
    "val": "74784 Moravice Moravice"
  },
  {
    "cast": "Moravičany",
    "psc": "78982",
    "okres": "Šumperk",
    "obec": "Moravičany",
    "val": "78982 Moravicany Moravicany"
  },
  {
    "cast": "Morávka",
    "psc": "73904",
    "okres": "Frýdek-Místek",
    "obec": "Morávka",
    "val": "73904 Moravka Moravka"
  },
  {
    "cast": "Moravská Cikánka",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Svratka",
    "val": "59202 Svratka Moravska Cikanka"
  },
  {
    "cast": "Moravská Huzová (část)",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Štěpánov",
    "val": "78501 Stepanov Moravska Huzova (cast)"
  },
  {
    "cast": "Moravská Huzová (část)",
    "psc": "78313",
    "okres": "Olomouc",
    "obec": "Štěpánov",
    "val": "78313 Stepanov Moravska Huzova (cast)"
  },
  {
    "cast": "Moravská Chrastová",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Brněnec",
    "val": "56904 Brnenec Moravska Chrastova"
  },
  {
    "cast": "Moravská Nová Ves",
    "psc": "69155",
    "okres": "Břeclav",
    "obec": "Moravská Nová Ves",
    "val": "69155 Moravska Nova Ves Moravska Nova Ves"
  },
  {
    "cast": "Moravská Ostrava (část)",
    "psc": "70200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70200 Ostrava Moravska Ostrava (cast)"
  },
  {
    "cast": "Moravská Ostrava (část)",
    "psc": "70300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70300 Ostrava Moravska Ostrava (cast)"
  },
  {
    "cast": "Moravská Svratka",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Svratka",
    "val": "59202 Svratka Moravska Svratka"
  },
  {
    "cast": "Moravská Třebová-Město x)",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Moravská Třebová",
    "val": "57101 Moravska Trebova Moravska Trebova-Mesto x)"
  },
  {
    "cast": "Moravské Bránice",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Moravské Bránice",
    "val": "66464 Moravske Branice Moravske Branice"
  },
  {
    "cast": "Moravské Budějovice",
    "psc": "67602",
    "okres": "Třebíč",
    "obec": "Moravské Budějovice",
    "val": "67602 Moravske Budejovice Moravske Budejovice"
  },
  {
    "cast": "Moravské Knínice",
    "psc": "66434",
    "okres": "Brno-venkov",
    "obec": "Moravské Knínice",
    "val": "66434 Moravske Kninice Moravske Kninice"
  },
  {
    "cast": "Moravské Křižánky",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Křižánky",
    "val": "59202 Krizanky Moravske Krizanky"
  },
  {
    "cast": "Moravské Málkovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Moravské Málkovice",
    "val": "68201 Moravske Malkovice Moravske Malkovice"
  },
  {
    "cast": "Moravské Prusy",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Prusy-Boškůvky",
    "val": "68201 Prusy-Boskuvky Moravske Prusy"
  },
  {
    "cast": "Moravské Předměstí (část)",
    "psc": "50006",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50006 Hradec Kralove Moravske Predmesti (cast)"
  },
  {
    "cast": "Moravské Předměstí (část)",
    "psc": "50011",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50011 Hradec Kralove Moravske Predmesti (cast)"
  },
  {
    "cast": "Moravsko",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Bílkovice",
    "val": "25726 Bilkovice Moravsko"
  },
  {
    "cast": "Moravský Beroun",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Moravský Beroun",
    "val": "79305 Moravsky Beroun Moravsky Beroun"
  },
  {
    "cast": "Moravský Karlov",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56169 Cervena Voda Moravsky Karlov"
  },
  {
    "cast": "Moravský Kočov",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Moravskoslezský Kočov",
    "val": "79201 Moravskoslezsky Kocov Moravsky Kocov"
  },
  {
    "cast": "Moravský Krumlov",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Moravský Krumlov",
    "val": "67201 Moravsky Krumlov Moravsky Krumlov"
  },
  {
    "cast": "Moravský Písek",
    "psc": "69685",
    "okres": "Hodonín",
    "obec": "Moravský Písek",
    "val": "69685 Moravsky Pisek Moravsky Pisek"
  },
  {
    "cast": "Moravský Žižkov",
    "psc": "69101",
    "okres": "Břeclav",
    "obec": "Moravský Žižkov",
    "val": "69101 Moravsky Zizkov Moravsky Zizkov"
  },
  {
    "cast": "Morcinov",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Morcinov"
  },
  {
    "cast": "Morkovice",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Morkovice-Slížany",
    "val": "76833 Morkovice-Slizany Morkovice"
  },
  {
    "cast": "Morkůvky",
    "psc": "69172",
    "okres": "Břeclav",
    "obec": "Morkůvky",
    "val": "69172 Morkuvky Morkuvky"
  },
  {
    "cast": "Mory",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "43801 Podborany Mory"
  },
  {
    "cast": "Mořice",
    "psc": "79828",
    "okres": "Prostějov",
    "obec": "Mořice",
    "val": "79828 Morice Morice"
  },
  {
    "cast": "Mořičov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Moricov"
  },
  {
    "cast": "Mořina",
    "psc": "26717",
    "okres": "Beroun",
    "obec": "Mořina",
    "val": "26717 Morina Morina"
  },
  {
    "cast": "Mořinka",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Mořinka",
    "val": "26718 Morinka Morinka"
  },
  {
    "cast": "Mořkov",
    "psc": "74272",
    "okres": "Nový Jičín",
    "obec": "Mořkov",
    "val": "74272 Morkov Morkov"
  },
  {
    "cast": "Most (část)",
    "psc": "43401",
    "okres": "Most",
    "obec": "Most",
    "val": "43401 Most Most (cast)"
  },
  {
    "cast": "Most (část)",
    "psc": "43502",
    "okres": "Most",
    "obec": "Most",
    "val": "43502 Most Most (cast)"
  },
  {
    "cast": "Mostec",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Štědrá",
    "val": "36452 Stedra Mostec"
  },
  {
    "cast": "Mostecké Předměstí",
    "psc": "41801",
    "okres": "Teplice",
    "obec": "Bílina",
    "val": "41801 Bilina Mostecke Predmesti"
  },
  {
    "cast": "Mostečný",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Pluhův Žďár",
    "val": "37821 Pluhuv Zdar Mostecny"
  },
  {
    "cast": "Mostek",
    "psc": "54475",
    "okres": "Trutnov",
    "obec": "Mostek",
    "val": "54475 Mostek Mostek"
  },
  {
    "cast": "Mostek",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Mostek",
    "val": "56501 Mostek Mostek"
  },
  {
    "cast": "Mostek",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Dolní Hrachovice",
    "val": "39143 Dolni Hrachovice Mostek"
  },
  {
    "cast": "Mostek",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Rybník",
    "val": "34525 Rybnik Mostek"
  },
  {
    "cast": "Mostice",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Zahrádka",
    "val": "33035 Zahradka Mostice"
  },
  {
    "cast": "Mostiště",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Hlohovice",
    "val": "33828 Hlohovice Mostiste"
  },
  {
    "cast": "Mostiště",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Meziříčí",
    "val": "59401 Velke Mezirici Mostiste"
  },
  {
    "cast": "Mostkov",
    "psc": "78801",
    "okres": "Šumperk",
    "obec": "Oskava",
    "val": "78801 Oskava Mostkov"
  },
  {
    "cast": "Mostkovice",
    "psc": "79802",
    "okres": "Prostějov",
    "obec": "Mostkovice",
    "val": "79802 Mostkovice Mostkovice"
  },
  {
    "cast": "Mostky",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Mostky"
  },
  {
    "cast": "Mostov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Odrava",
    "val": "35002 Odrava Mostov"
  },
  {
    "cast": "Mosty",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Kunžak",
    "val": "37853 Kunzak Mosty"
  },
  {
    "cast": "Mosty",
    "psc": "73562",
    "okres": "Karviná",
    "obec": "Český Těšín",
    "val": "73562 Cesky Tesin Mosty"
  },
  {
    "cast": "Mosty u Jablunkova",
    "psc": "73998",
    "okres": "Frýdek-Místek",
    "obec": "Mosty u Jablunkova",
    "val": "73998 Mosty u Jablunkova Mosty u Jablunkova"
  },
  {
    "cast": "Mošnice",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Snědovice",
    "val": "41108 Snedovice Mosnice"
  },
  {
    "cast": "Mošnov",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bžany",
    "val": "41501 Bzany Mosnov"
  },
  {
    "cast": "Mošnov",
    "psc": "74251",
    "okres": "Nový Jičín",
    "obec": "Mošnov",
    "val": "74251 Mosnov Mosnov"
  },
  {
    "cast": "Motol (část)",
    "psc": "15000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15000 Praha Motol (cast)"
  },
  {
    "cast": "Motol (část)",
    "psc": "16900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16900 Praha Motol (cast)"
  },
  {
    "cast": "Moudrov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Obrataň",
    "val": "39501 Obratan Moudrov"
  },
  {
    "cast": "Mouchnice",
    "psc": "68333",
    "okres": "Hodonín",
    "obec": "Mouchnice",
    "val": "68333 Mouchnice Mouchnice"
  },
  {
    "cast": "Mouřínov",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Mouřínov",
    "val": "68501 Mourinov Mourinov"
  },
  {
    "cast": "Moutnice",
    "psc": "66455",
    "okres": "Brno-venkov",
    "obec": "Moutnice",
    "val": "66455 Moutnice Moutnice"
  },
  {
    "cast": "Mozerov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Věž",
    "val": "58001 Vez Mozerov"
  },
  {
    "cast": "Mozolín",
    "psc": "27329",
    "okres": "Kladno",
    "obec": "Koleč",
    "val": "27329 Kolec Mozolin"
  },
  {
    "cast": "Mozolov",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Mozolov"
  },
  {
    "cast": "Možděnice",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Mozdenice"
  },
  {
    "cast": "Mrač",
    "psc": "25721",
    "okres": "Benešov",
    "obec": "Mrač",
    "val": "25721 Mrac Mrac"
  },
  {
    "cast": "Mračnice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34601 Meclov Mracnice"
  },
  {
    "cast": "Mračov",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Kadov",
    "val": "38801 Kadov Mracov"
  },
  {
    "cast": "Mradice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Mradice"
  },
  {
    "cast": "Mrákotice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Mrakotice"
  },
  {
    "cast": "Mrákotín",
    "psc": "58854",
    "okres": "Jihlava",
    "obec": "Mrákotín",
    "val": "58854 Mrakotin Mrakotin"
  },
  {
    "cast": "Mrákotín",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Mrákotín",
    "val": "53901 Mrakotin Mrakotin"
  },
  {
    "cast": "Mrákov",
    "psc": "34501",
    "okres": "Domažlice",
    "obec": "Mrákov",
    "val": "34501 Mrakov Mrakov"
  },
  {
    "cast": "Mramotice",
    "psc": "67151",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "67151 Znojmo Mramotice"
  },
  {
    "cast": "Mratín",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Mratín",
    "val": "25063 Mratin Mratin"
  },
  {
    "cast": "Mravín",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Jenišovice",
    "val": "53854 Jenisovice Mravin"
  },
  {
    "cast": "Mrázov",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Mrazov"
  },
  {
    "cast": "Mrhov",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Krásné",
    "val": "59203 Krasne Mrhov"
  },
  {
    "cast": "Mrchojedy",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Samopše",
    "val": "28506 Samopse Mrchojedy"
  },
  {
    "cast": "Mrchojedy",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34601 Meclov Mrchojedy"
  },
  {
    "cast": "Mrklov",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Benecko",
    "val": "51401 Benecko Mrklov"
  },
  {
    "cast": "Mrkvojedy",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50743 Markvartice Mrkvojedy"
  },
  {
    "cast": "Mrkvová Lhota",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Louňovice pod Blaníkem",
    "val": "25706 Lounovice pod Blanikem Mrkvova Lhota"
  },
  {
    "cast": "Mrlínek",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Mrlínek",
    "val": "76861 Mrlinek Mrlinek"
  },
  {
    "cast": "Mrsklesy",
    "psc": "78365",
    "okres": "Olomouc",
    "obec": "Mrsklesy",
    "val": "78365 Mrsklesy Mrsklesy"
  },
  {
    "cast": "Mrsklesy",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41115 Trebenice Mrsklesy"
  },
  {
    "cast": "Mrtník",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Mrtník",
    "val": "33152 Mrtnik Mrtnik"
  },
  {
    "cast": "Mrtník",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Hvozdec",
    "val": "26762 Hvozdec Mrtnik"
  },
  {
    "cast": "Mrvice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Mrvice"
  },
  {
    "cast": "Mrzkovice",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Mrzkovice"
  },
  {
    "cast": "Mrzky",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Mrzky",
    "val": "28201 Mrzky Mrzky"
  },
  {
    "cast": "Mrzlice",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41804 Hrobcice Mrzlice"
  },
  {
    "cast": "Mříč",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Mric"
  },
  {
    "cast": "Mříčná",
    "psc": "51204",
    "okres": "Semily",
    "obec": "Mříčná",
    "val": "51204 Mricna Mricna"
  },
  {
    "cast": "Mstětice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Mstetice"
  },
  {
    "cast": "Mstětice",
    "psc": "25091",
    "okres": "Praha-východ",
    "obec": "Zeleneč",
    "val": "25091 Zelenec Mstetice"
  },
  {
    "cast": "Mstětín",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Červený Kostelec",
    "val": "54941 Cerveny Kostelec Mstetin"
  },
  {
    "cast": "Mstice",
    "psc": "33401",
    "okres": "Klatovy",
    "obec": "Vřeskovice",
    "val": "33401 Vreskovice Mstice"
  },
  {
    "cast": "Mstislavice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Bojiště",
    "val": "58401 Bojiste Mstislavice"
  },
  {
    "cast": "Mstišov (část)",
    "psc": "41703",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41703 Dubi Mstisov (cast)"
  },
  {
    "cast": "Mstišov (část)",
    "psc": "41701",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41701 Dubi Mstisov (cast)"
  },
  {
    "cast": "Mšec",
    "psc": "27064",
    "okres": "Rakovník",
    "obec": "Mšec",
    "val": "27064 Msec Msec"
  },
  {
    "cast": "Mšecké Žehrovice",
    "psc": "27064",
    "okres": "Rakovník",
    "obec": "Mšecké Žehrovice",
    "val": "27064 Msecke Zehrovice Msecke Zehrovice"
  },
  {
    "cast": "Mšené-lázně (část)",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Mšené-lázně",
    "val": "41119 Msene-lazne Msene-lazne (cast)"
  },
  {
    "cast": "Mšené-lázně (část)",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Mšené-lázně",
    "val": "41301 Msene-lazne Msene-lazne (cast)"
  },
  {
    "cast": "Mšeno nad Nisou (část)",
    "psc": "46602",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46602 Jablonec nad Nisou Mseno nad Nisou (cast)"
  },
  {
    "cast": "Mšeno nad Nisou (část)",
    "psc": "46604",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46604 Jablonec nad Nisou Mseno nad Nisou (cast)"
  },
  {
    "cast": "Mšeno (část)",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Mseno (cast)"
  },
  {
    "cast": "Mšeno (část)",
    "psc": "27738",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27738 Mseno Mseno (cast)"
  },
  {
    "cast": "Mštěnovice",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Lešná",
    "val": "75701 Lesna Mstenovice"
  },
  {
    "cast": "Muckov",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Muckov"
  },
  {
    "cast": "Muckov",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Černá v Pošumaví",
    "val": "38226 Cerna v Posumavi Muckov"
  },
  {
    "cast": "Muglinov (část)",
    "psc": "71000",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71000 Ostrava Muglinov (cast)"
  },
  {
    "cast": "Muglinov (část)",
    "psc": "71200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71200 Ostrava Muglinov (cast)"
  },
  {
    "cast": "Mukařov",
    "psc": "25162",
    "okres": "Praha-východ",
    "obec": "Mukařov",
    "val": "25162 Mukarov Mukarov"
  },
  {
    "cast": "Mukařov",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Lovečkovice",
    "val": "41145 Loveckovice Mukarov"
  },
  {
    "cast": "Mukařov",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mukařov",
    "val": "29501 Mukarov Mukarov"
  },
  {
    "cast": "Mukařov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Mukarov"
  },
  {
    "cast": "Mukoděly",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Vroutek",
    "val": "44101 Vroutek Mukodely"
  },
  {
    "cast": "Mukov",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41804 Hrobcice Mukov"
  },
  {
    "cast": "Munice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Munice"
  },
  {
    "cast": "Mutějovice",
    "psc": "27007",
    "okres": "Rakovník",
    "obec": "Mutějovice",
    "val": "27007 Mutejovice Mutejovice"
  },
  {
    "cast": "Mutěnice",
    "psc": "69611",
    "okres": "Hodonín",
    "obec": "Mutěnice",
    "val": "69611 Mutenice Mutenice"
  },
  {
    "cast": "Mutěnice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Mutěnice",
    "val": "38601 Mutenice Mutenice"
  },
  {
    "cast": "Mutěnín",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Mutěnín",
    "val": "34525 Mutenin Mutenin"
  },
  {
    "cast": "Mutice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nová Ves u Mladé Vožice",
    "val": "39143 Nova Ves u Mlade Vozice Mutice"
  },
  {
    "cast": "Mutišov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Slavonice",
    "val": "37881 Slavonice Mutisov"
  },
  {
    "cast": "Mutkov",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Mutkov",
    "val": "78501 Mutkov Mutkov"
  },
  {
    "cast": "Mutná",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Cizkrajov",
    "val": "37881 Cizkrajov Mutna"
  },
  {
    "cast": "Mutyněves",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Blažejov",
    "val": "37701 Blazejov Mutyneves"
  },
  {
    "cast": "Mužetice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Sedlice",
    "val": "38801 Sedlice Muzetice"
  },
  {
    "cast": "Mužský",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Boseň",
    "val": "29501 Bosen Muzsky"
  },
  {
    "cast": "Mydlovary",
    "psc": "34952",
    "okres": "Plzeň-sever",
    "obec": "Křelovice",
    "val": "34952 Krelovice Mydlovary"
  },
  {
    "cast": "Mydlovary (část)",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Mydlovary",
    "val": "37348 Mydlovary Mydlovary (cast)"
  },
  {
    "cast": "Mydlovary (část)",
    "psc": "37349",
    "okres": "České Budějovice",
    "obec": "Mydlovary",
    "val": "37349 Mydlovary Mydlovary (cast)"
  },
  {
    "cast": "Myslechovice",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78321 Litovel Myslechovice"
  },
  {
    "cast": "Myslejovice",
    "psc": "79805",
    "okres": "Prostějov",
    "obec": "Myslejovice",
    "val": "79805 Myslejovice Myslejovice"
  },
  {
    "cast": "Mysletice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Mysletice"
  },
  {
    "cast": "Mysletice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Mysletice",
    "val": "58856 Mysletice Mysletice"
  },
  {
    "cast": "Mysletín",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Mysletín",
    "val": "39601 Mysletin Mysletin"
  },
  {
    "cast": "Mysliboř",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Mysliboř",
    "val": "58862 Myslibor Myslibor"
  },
  {
    "cast": "Myslibořice (část)",
    "psc": "67560",
    "okres": "Třebíč",
    "obec": "Myslibořice",
    "val": "67560 Mysliborice Mysliborice (cast)"
  },
  {
    "cast": "Myslibořice (část)",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Myslibořice",
    "val": "67552 Mysliborice Mysliborice (cast)"
  },
  {
    "cast": "Myslíč",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Myslic"
  },
  {
    "cast": "Myslík (část)",
    "psc": "73941",
    "okres": "Frýdek-Místek",
    "obec": "Palkovice",
    "val": "73941 Palkovice Myslik (cast)"
  },
  {
    "cast": "Myslík (část)",
    "psc": "73947",
    "okres": "Frýdek-Místek",
    "obec": "Palkovice",
    "val": "73947 Palkovice Myslik (cast)"
  },
  {
    "cast": "Myslín",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Myslín",
    "val": "39804 Myslin Myslin"
  },
  {
    "cast": "Myslinka",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Myslinka",
    "val": "33023 Myslinka Myslinka"
  },
  {
    "cast": "Myslív",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Myslív",
    "val": "34101 Mysliv Mysliv"
  },
  {
    "cast": "Myslkov",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Myslkov"
  },
  {
    "cast": "Myslkovice",
    "psc": "39116",
    "okres": "Tábor",
    "obec": "Myslkovice",
    "val": "39116 Myslkovice Myslkovice"
  },
  {
    "cast": "Mysločovice",
    "psc": "76301",
    "okres": "Zlín",
    "obec": "Mysločovice",
    "val": "76301 Myslocovice Myslocovice"
  },
  {
    "cast": "Myslotín",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Myslotin"
  },
  {
    "cast": "Myslov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nová Cerekev",
    "val": "39301 Nova Cerekev Myslov"
  },
  {
    "cast": "Myslovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Myslovice",
    "val": "33901 Myslovice Myslovice"
  },
  {
    "cast": "Myslůvka",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Černíč",
    "val": "58856 Cernic Mysluvka"
  },
  {
    "cast": "Myšenec",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Mysenec"
  },
  {
    "cast": "Myšlín",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Mnichovice",
    "val": "25164 Mnichovice Myslin"
  },
  {
    "cast": "Mýšlovice",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Vrančice",
    "val": "26231 Vrancice Myslovice"
  },
  {
    "cast": "Myštěves",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Myštěves",
    "val": "50315 Mysteves Mysteves"
  },
  {
    "cast": "Myštice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Myštice",
    "val": "38801 Mystice Mystice"
  },
  {
    "cast": "Myštice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Chudoslavice",
    "val": "41201 Chudoslavice Mystice"
  },
  {
    "cast": "Myť",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Ždírec",
    "val": "33601 Zdirec Myt"
  },
  {
    "cast": "Myť",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Mirošov",
    "val": "33843 Mirosov Myt"
  },
  {
    "cast": "Mýtina",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Mytina"
  },
  {
    "cast": "Mýtinka",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Vojtanov",
    "val": "35002 Vojtanov Mytinka"
  },
  {
    "cast": "Mýtinka",
    "psc": "43184",
    "okres": "Chomutov",
    "obec": "Měděnec",
    "val": "43184 Medenec Mytinka"
  },
  {
    "cast": "Mýtiny",
    "psc": "51246",
    "okres": "Semily",
    "obec": "Harrachov",
    "val": "51246 Harrachov Mytiny"
  },
  {
    "cast": "Mýtka",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Mladoňovice",
    "val": "53821 Mladonovice Mytka"
  },
  {
    "cast": "Mýto",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Myto"
  },
  {
    "cast": "Mýto",
    "psc": "33805",
    "okres": "Rokycany",
    "obec": "Mýto",
    "val": "33805 Myto Myto"
  },
  {
    "cast": "Mýto",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Hořice na Šumavě",
    "val": "38101 Horice na Sumave Myto"
  },
  {
    "cast": "Mžany",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Mžany",
    "val": "50315 Mzany Mzany"
  },
  {
    "cast": "Mžižovice",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Ostředek",
    "val": "25724 Ostredek Mzizovice"
  },
  {
    "cast": "Na Lhotkách",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Bavoryně",
    "val": "26751 Bavoryne Na Lhotkach"
  },
  {
    "cast": "Na Výšině",
    "psc": "47106",
    "okres": "Česká Lípa",
    "obec": "Horní Police",
    "val": "47106 Horni Police Na Vysine"
  },
  {
    "cast": "Nabdín",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Černuc",
    "val": "27324 Cernuc Nabdin"
  },
  {
    "cast": "Nabočany",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Nabočany",
    "val": "53862 Nabocany Nabocany"
  },
  {
    "cast": "Načeradec",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Naceradec"
  },
  {
    "cast": "Načeratice",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "66902 Znojmo Naceratice"
  },
  {
    "cast": "Načešice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Načešice",
    "val": "53803 Nacesice Nacesice"
  },
  {
    "cast": "Načetín",
    "psc": "43132",
    "okres": "Chomutov",
    "obec": "Kalek",
    "val": "43132 Kalek Nacetin"
  },
  {
    "cast": "Načetín",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Hora Svatého Václava",
    "val": "34522 Hora Svateho Vaclava Nacetin"
  },
  {
    "cast": "Náčkovice (část)",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Lovečkovice",
    "val": "41145 Loveckovice Nackovice (cast)"
  },
  {
    "cast": "Náčkovice (část)",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Lovečkovice",
    "val": "41201 Loveckovice Nackovice (cast)"
  },
  {
    "cast": "Naděje",
    "psc": "47156",
    "okres": "Česká Lípa",
    "obec": "Cvikov",
    "val": "47156 Cvikov Nadeje"
  },
  {
    "cast": "Nadějkov",
    "psc": "39852",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39852 Nadejkov Nadejkov"
  },
  {
    "cast": "Nadějov",
    "psc": "58827",
    "okres": "Jihlava",
    "obec": "Nadějov",
    "val": "58827 Nadejov Nadejov"
  },
  {
    "cast": "Nadlesí",
    "psc": "35731",
    "okres": "Sokolov",
    "obec": "Loket",
    "val": "35731 Loket Nadlesi"
  },
  {
    "cast": "Nádražní Předměstí",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Nadrazni Predmesti"
  },
  {
    "cast": "Nadryby",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Nadryby",
    "val": "33011 Nadryby Nadryby"
  },
  {
    "cast": "Nadslav",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Střevač",
    "val": "50601 Strevac Nadslav"
  },
  {
    "cast": "Naháč",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25724 Vranov Nahac"
  },
  {
    "cast": "Náhlík",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Nahlik"
  },
  {
    "cast": "Náhlov",
    "psc": "46352",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "46352 Ralsko Nahlov"
  },
  {
    "cast": "Nahoruby",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Nahoruby"
  },
  {
    "cast": "Nahořánky",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Strašín",
    "val": "34201 Strasin Nahoranky"
  },
  {
    "cast": "Nahořany",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Rodná",
    "val": "39143 Rodna Nahorany"
  },
  {
    "cast": "Nahořany",
    "psc": "54907",
    "okres": "Náchod",
    "obec": "Nahořany",
    "val": "54907 Nahorany Nahorany"
  },
  {
    "cast": "Nahořany",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38719 Cestice Nahorany"
  },
  {
    "cast": "Nahořany",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38101 Vetrni Nahorany"
  },
  {
    "cast": "Nahořečice",
    "psc": "44101",
    "okres": "Karlovy Vary",
    "obec": "Valeč",
    "val": "44101 Valec Nahorecice"
  },
  {
    "cast": "Nahošice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Blížejov",
    "val": "34601 Blizejov Nahosice"
  },
  {
    "cast": "Nahošín",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Doubravice",
    "val": "38601 Doubravice Nahosin"
  },
  {
    "cast": "Nahošovice",
    "psc": "75114",
    "okres": "Přerov",
    "obec": "Nahošovice",
    "val": "75114 Nahosovice Nahosovice"
  },
  {
    "cast": "Nahý Újezdec",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Chodský Újezd",
    "val": "34815 Chodsky Ujezd Nahy Ujezdec"
  },
  {
    "cast": "Náchod",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Nachod"
  },
  {
    "cast": "Náchod (část)",
    "psc": "39003",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39003 Tabor Nachod (cast)"
  },
  {
    "cast": "Náchod (část)",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39137 Tabor Nachod (cast)"
  },
  {
    "cast": "Náchodsko",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Kacákova Lhota",
    "val": "50601 Kacakova Lhota Nachodsko"
  },
  {
    "cast": "Najdek",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Lodhéřov",
    "val": "37701 Lodherov Najdek"
  },
  {
    "cast": "Najdek",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Hamry nad Sázavou",
    "val": "59101 Hamry nad Sazavou Najdek"
  },
  {
    "cast": "Nákle",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Klešice",
    "val": "53803 Klesice Nakle"
  },
  {
    "cast": "Náklo",
    "psc": "78332",
    "okres": "Olomouc",
    "obec": "Náklo",
    "val": "78332 Naklo Naklo"
  },
  {
    "cast": "Náklov",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33035 Listany Naklov"
  },
  {
    "cast": "Nakolice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37401 Nove Hrady Nakolice"
  },
  {
    "cast": "Nákří",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Nákří",
    "val": "37348 Nakri Nakri"
  },
  {
    "cast": "Nakvasovice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Nakvasovice"
  },
  {
    "cast": "Nálesí",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Nalesi"
  },
  {
    "cast": "Naloučany",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Naloučany",
    "val": "67571 Naloucany Naloucany"
  },
  {
    "cast": "Nalžovice (část)",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nalžovice",
    "val": "26401 Nalzovice Nalzovice (cast)"
  },
  {
    "cast": "Nalžovice (část)",
    "psc": "26293",
    "okres": "Příbram",
    "obec": "Nalžovice",
    "val": "26293 Nalzovice Nalzovice (cast)"
  },
  {
    "cast": "Nalžovické Podhájí",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nalžovice",
    "val": "26401 Nalzovice Nalzovicke Podhaji"
  },
  {
    "cast": "Nalžovské Hory-Krutěnice x)",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34142 Nalzovske Hory Nalzovske Hory-Krutenice x)"
  },
  {
    "cast": "Nalžovské Hory-Letovy x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Letovy x)"
  },
  {
    "cast": "Nalžovské Hory-Miřenice x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Mirenice x)"
  },
  {
    "cast": "Nalžovské Hory-Nalžovy x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Nalzovy x)"
  },
  {
    "cast": "Nalžovské Hory-Neprochovy x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Neprochovy x)"
  },
  {
    "cast": "Nalžovské Hory-Otěšín x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Otesin x)"
  },
  {
    "cast": "Nalžovské Hory-Sedlečko x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Sedlecko x)"
  },
  {
    "cast": "Nalžovské Hory-Stříbrné Hory x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Stribrne Hory x)"
  },
  {
    "cast": "Nalžovské Hory-Těchonice x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Techonice x)"
  },
  {
    "cast": "Nalžovské Hory-Ústaleč x)",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34142 Nalzovske Hory Nalzovske Hory-Ustalec x)"
  },
  {
    "cast": "Nalžovské Hory-Velenovy x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Velenovy x)"
  },
  {
    "cast": "Nalžovské Hory-Zahrádka x)",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "34142 Cachrov Nalzovske Hory-Zahradka x)"
  },
  {
    "cast": "Nalžovské Hory-Žďár x)",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovske Hory-Zdar x)"
  },
  {
    "cast": "Nalžovy",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Nalzovy"
  },
  {
    "cast": "Náměšť na Hané",
    "psc": "78344",
    "okres": "Olomouc",
    "obec": "Náměšť na Hané",
    "val": "78344 Namest na Hane Namest na Hane"
  },
  {
    "cast": "Náměšť nad Oslavou",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Náměšť nad Oslavou",
    "val": "67571 Namest nad Oslavou Namest nad Oslavou"
  },
  {
    "cast": "Namnice",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Chrást",
    "val": "26242 Chrast Namnice"
  },
  {
    "cast": "Nantiškov",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Nantiskov"
  },
  {
    "cast": "Napajedla",
    "psc": "76361",
    "okres": "Zlín",
    "obec": "Napajedla",
    "val": "76361 Napajedla Napajedla"
  },
  {
    "cast": "Nárameč",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Nárameč",
    "val": "67503 Naramec Naramec"
  },
  {
    "cast": "Narysov",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Narysov",
    "val": "26101 Narysov Narysov"
  },
  {
    "cast": "Nasavrky",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Nasavrky",
    "val": "39131 Nasavrky Nasavrky"
  },
  {
    "cast": "Nasavrky",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Nasavrky"
  },
  {
    "cast": "Nasavrky",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Nasavrky",
    "val": "53825 Nasavrky Nasavrky"
  },
  {
    "cast": "Nasavrky",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Nasavrky",
    "val": "56501 Nasavrky Nasavrky"
  },
  {
    "cast": "Nasavrky",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Golčův Jeníkov",
    "val": "58282 Golcuv Jenikov Nasavrky"
  },
  {
    "cast": "Násedlnice",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Nasedlnice"
  },
  {
    "cast": "Násedlovice",
    "psc": "69636",
    "okres": "Hodonín",
    "obec": "Násedlovice",
    "val": "69636 Nasedlovice Nasedlovice"
  },
  {
    "cast": "Násilov",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Nasilov"
  },
  {
    "cast": "Nasobůrky",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78321 Litovel Nasoburky"
  },
  {
    "cast": "Našiměřice",
    "psc": "67176",
    "okres": "Znojmo",
    "obec": "Našiměřice",
    "val": "67176 Nasimerice Nasimerice"
  },
  {
    "cast": "Návarov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Zlatá Olešnice",
    "val": "46822 Zlata Olesnice Navarov"
  },
  {
    "cast": "Návary",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Město pod Landštejnem",
    "val": "37881 Stare Mesto pod Landstejnem Navary"
  },
  {
    "cast": "Návojná",
    "psc": "76332",
    "okres": "Zlín",
    "obec": "Návojná",
    "val": "76332 Navojna Navojna"
  },
  {
    "cast": "Návrší",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Tuřany",
    "val": "35002 Turany Navrsi"
  },
  {
    "cast": "Návsí",
    "psc": "73992",
    "okres": "Frýdek-Místek",
    "obec": "Návsí",
    "val": "73992 Navsi Navsi"
  },
  {
    "cast": "Nazdice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Nazdice"
  },
  {
    "cast": "Nebahovy (část)",
    "psc": "38401",
    "okres": "Prachatice",
    "obec": "Nebahovy",
    "val": "38401 Nebahovy Nebahovy (cast)"
  },
  {
    "cast": "Nebahovy (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Nebahovy",
    "val": "38301 Nebahovy Nebahovy (cast)"
  },
  {
    "cast": "Nebanice",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Nebanice",
    "val": "35002 Nebanice Nebanice"
  },
  {
    "cast": "Nebesa",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As Nebesa"
  },
  {
    "cast": "Nebeská Rybná (část)",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rokytnice v Orlických horách",
    "val": "51601 Rokytnice v Orlickych horach Nebeska Rybna (cast)"
  },
  {
    "cast": "Nebeská Rybná (část)",
    "psc": "51761",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rokytnice v Orlických horách",
    "val": "51761 Rokytnice v Orlickych horach Nebeska Rybna (cast)"
  },
  {
    "cast": "Nebílovský Borek",
    "psc": "33209",
    "okres": "Plzeň-město",
    "obec": "Štěnovický Borek",
    "val": "33209 Stenovicky Borek Nebilovsky Borek"
  },
  {
    "cast": "Nebílovy",
    "psc": "33204",
    "okres": "Plzeň-jih",
    "obec": "Nebílovy",
    "val": "33204 Nebilovy Nebilovy"
  },
  {
    "cast": "Neblažov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Chodský Újezd",
    "val": "34815 Chodsky Ujezd Neblazov"
  },
  {
    "cast": "Nebočady-Děčín XXXIII (část) x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Nebocady-Decin XXXIII (cast) x)"
  },
  {
    "cast": "Nebočady-Děčín XXXIII (část) x)",
    "psc": "40711",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40711 Decin Nebocady-Decin XXXIII (cast) x)"
  },
  {
    "cast": "Nebory",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Nebory"
  },
  {
    "cast": "Nebovazy",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Nebovazy"
  },
  {
    "cast": "Nebovidy",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Nebovidy",
    "val": "28002 Nebovidy Nebovidy"
  },
  {
    "cast": "Nebovidy",
    "psc": "66448",
    "okres": "Brno-venkov",
    "obec": "Nebovidy",
    "val": "66448 Nebovidy Nebovidy"
  },
  {
    "cast": "Nebřehovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Nebřehovice",
    "val": "38601 Nebrehovice Nebrehovice"
  },
  {
    "cast": "Nebřenice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Popovičky",
    "val": "25101 Popovicky Nebrenice"
  },
  {
    "cast": "Nebřeziny",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Plasy",
    "val": "33101 Plasy Nebreziny"
  },
  {
    "cast": "Nebřich",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25744 Neveklov Nebrich"
  },
  {
    "cast": "Nebušice",
    "psc": "16400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16400 Praha Nebusice"
  },
  {
    "cast": "Nebužely",
    "psc": "27734",
    "okres": "Mělník",
    "obec": "Nebužely",
    "val": "27734 Nebuzely Nebuzely"
  },
  {
    "cast": "Nectava",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Březinky",
    "val": "56943 Brezinky Nectava"
  },
  {
    "cast": "Nečas",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Budčeves",
    "val": "50732 Budceves Necas"
  },
  {
    "cast": "Nečemice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Tuchořice",
    "val": "43801 Tuchorice Necemice"
  },
  {
    "cast": "Nečice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Senožaty",
    "val": "39601 Senozaty Necice"
  },
  {
    "cast": "Nečichy",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Louny",
    "val": "44001 Louny Necichy"
  },
  {
    "cast": "Nečín",
    "psc": "26213",
    "okres": "Příbram",
    "obec": "Nečín",
    "val": "26213 Necin Necin"
  },
  {
    "cast": "Nečtiny",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Nectiny"
  },
  {
    "cast": "Nedabyle (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Nedabyle",
    "val": "37006 Nedabyle Nedabyle (cast)"
  },
  {
    "cast": "Nedabyle (část)",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Nedabyle",
    "val": "37007 Nedabyle Nedabyle (cast)"
  },
  {
    "cast": "Nedabyle (část)",
    "psc": "37008",
    "okres": "České Budějovice",
    "obec": "Nedabyle",
    "val": "37008 Nedabyle Nedabyle (cast)"
  },
  {
    "cast": "Nedachlebice",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Nedachlebice",
    "val": "68712 Nedachlebice Nedachlebice"
  },
  {
    "cast": "Nedakonice",
    "psc": "68738",
    "okres": "Uherské Hradiště",
    "obec": "Nedakonice",
    "val": "68738 Nedakonice Nedakonice"
  },
  {
    "cast": "Nedamov",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Nedamov"
  },
  {
    "cast": "Nedanice",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "34012 Mecin Nedanice"
  },
  {
    "cast": "Nedaničky",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "34012 Mecin Nedanicky"
  },
  {
    "cast": "Nedaříž",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Horka u Staré Paky",
    "val": "51401 Horka u Stare Paky Nedariz"
  },
  {
    "cast": "Nedašov",
    "psc": "76332",
    "okres": "Zlín",
    "obec": "Nedašov",
    "val": "76332 Nedasov Nedasov"
  },
  {
    "cast": "Nedašova Lhota",
    "psc": "76332",
    "okres": "Zlín",
    "obec": "Nedašova Lhota",
    "val": "76332 Nedasova Lhota Nedasova Lhota"
  },
  {
    "cast": "Neděliště",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Neděliště",
    "val": "50312 Nedeliste Nedeliste"
  },
  {
    "cast": "Nedomice",
    "psc": "27714",
    "okres": "Mělník",
    "obec": "Nedomice",
    "val": "27714 Nedomice Nedomice"
  },
  {
    "cast": "Nedošín",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Nedosin"
  },
  {
    "cast": "Nedrahovice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nedrahovice",
    "val": "26401 Nedrahovice Nedrahovice"
  },
  {
    "cast": "Nedrahovické Podhájí",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nedrahovice",
    "val": "26401 Nedrahovice Nedrahovicke Podhaji"
  },
  {
    "cast": "Nedražice",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kostelec",
    "val": "34901 Kostelec Nedrazice"
  },
  {
    "cast": "Nedvědice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Soběslav",
    "val": "39201 Sobeslav Nedvedice"
  },
  {
    "cast": "Nedvědice",
    "psc": "59262",
    "okres": "Brno-venkov",
    "obec": "Nedvědice",
    "val": "59262 Nedvedice Nedvedice"
  },
  {
    "cast": "Nedvězí",
    "psc": "78974",
    "okres": "Šumperk",
    "obec": "Rohle",
    "val": "78974 Rohle Nedvezi"
  },
  {
    "cast": "Nedvězí",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Nedvezi"
  },
  {
    "cast": "Nedvězí",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Rabyně",
    "val": "25744 Rabyne Nedvezi"
  },
  {
    "cast": "Nedvězí",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Nedvezi"
  },
  {
    "cast": "Nedvězí",
    "psc": "51201",
    "okres": "Semily",
    "obec": "Slaná",
    "val": "51201 Slana Nedvezi"
  },
  {
    "cast": "Nedvězí",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Nedvězí",
    "val": "56992 Nedvezi Nedvezi"
  },
  {
    "cast": "Nedvězí",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kounov",
    "val": "51801 Kounov Nedvezi"
  },
  {
    "cast": "Nedvězí u Říčan",
    "psc": "10300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10300 Praha Nedvezi u Rican"
  },
  {
    "cast": "Nehasice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Bitozeves",
    "val": "43801 Bitozeves Nehasice"
  },
  {
    "cast": "Nehodiv",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nehodiv",
    "val": "34101 Nehodiv Nehodiv"
  },
  {
    "cast": "Nehodovka",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Nehodovka"
  },
  {
    "cast": "Nehonín",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Nehonin"
  },
  {
    "cast": "Nehvízdky",
    "psc": "25081",
    "okres": "Praha-východ",
    "obec": "Nehvizdy",
    "val": "25081 Nehvizdy Nehvizdky"
  },
  {
    "cast": "Nehvizdy",
    "psc": "25081",
    "okres": "Praha-východ",
    "obec": "Nehvizdy",
    "val": "25081 Nehvizdy Nehvizdy"
  },
  {
    "cast": "Nechalov",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Drevníky",
    "val": "26301 Drevniky Nechalov"
  },
  {
    "cast": "Nechanice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Nechanice",
    "val": "50315 Nechanice Nechanice"
  },
  {
    "cast": "Nechanice",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Nové Mitrovice",
    "val": "33563 Nove Mitrovice Nechanice"
  },
  {
    "cast": "Nechánice",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Sulice",
    "val": "25168 Sulice Nechanice"
  },
  {
    "cast": "Něchov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Nechov"
  },
  {
    "cast": "Nechranice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Březno",
    "val": "43801 Brezno Nechranice"
  },
  {
    "cast": "Nechvalice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bystřany",
    "val": "41501 Bystrany Nechvalice"
  },
  {
    "cast": "Nechvalice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Nechvalice"
  },
  {
    "cast": "Nechvalín",
    "psc": "69631",
    "okres": "Hodonín",
    "obec": "Nechvalín",
    "val": "69631 Nechvalin Nechvalin"
  },
  {
    "cast": "Nechyba",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28506 Uzice Nechyba"
  },
  {
    "cast": "Nechyba",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Zbizuby",
    "val": "28504 Zbizuby Nechyba"
  },
  {
    "cast": "Nejdek",
    "psc": "75364",
    "okres": "Přerov",
    "obec": "Bělotín",
    "val": "75364 Belotin Nejdek"
  },
  {
    "cast": "Nejdek",
    "psc": "69144",
    "okres": "Břeclav",
    "obec": "Lednice",
    "val": "69144 Lednice Nejdek"
  },
  {
    "cast": "Nejdek (část)",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36221 Nejdek Nejdek (cast)"
  },
  {
    "cast": "Nejdek (část)",
    "psc": "36222",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36222 Nejdek Nejdek (cast)"
  },
  {
    "cast": "Nejepín",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Nejepín",
    "val": "58301 Nejepin Nejepin"
  },
  {
    "cast": "Nekmíř",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Nekmíř",
    "val": "33152 Nekmir Nekmir"
  },
  {
    "cast": "Nekoř (část)",
    "psc": "56163",
    "okres": "Ústí nad Orlicí",
    "obec": "Nekoř",
    "val": "56163 Nekor Nekor (cast)"
  },
  {
    "cast": "Nekoř (část)",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Nekoř",
    "val": "56164 Nekor Nekor (cast)"
  },
  {
    "cast": "Nekrasín",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Jarošov nad Nežárkou",
    "val": "37842 Jarosov nad Nezarkou Nekrasin"
  },
  {
    "cast": "Nekvasovy",
    "psc": "33547",
    "okres": "Plzeň-jih",
    "obec": "Nekvasovy",
    "val": "33547 Nekvasovy Nekvasovy"
  },
  {
    "cast": "Nelahozeves",
    "psc": "27751",
    "okres": "Mělník",
    "obec": "Nelahozeves",
    "val": "27751 Nelahozeves Nelahozeves"
  },
  {
    "cast": "Nelepeč",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Nelepeč-Žernůvka",
    "val": "66601 Nelepec-Zernuvka Nelepec"
  },
  {
    "cast": "Nelešovice",
    "psc": "75103",
    "okres": "Přerov",
    "obec": "Nelešovice",
    "val": "75103 Nelesovice Nelesovice"
  },
  {
    "cast": "Nemanice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nemanice",
    "val": "34401 Nemanice Nemanice"
  },
  {
    "cast": "Nemaničky",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nemanice",
    "val": "34401 Nemanice Nemanicky"
  },
  {
    "cast": "Němčany",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Krásný Dvůr",
    "val": "44101 Krasny Dvur Nemcany"
  },
  {
    "cast": "Němčany",
    "psc": "68401",
    "okres": "Vyškov",
    "obec": "Němčany",
    "val": "68401 Nemcany Nemcany"
  },
  {
    "cast": "Němče (část)",
    "psc": "38211",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38211 Vetrni Nemce (cast)"
  },
  {
    "cast": "Němče (část)",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38101 Vetrni Nemce (cast)"
  },
  {
    "cast": "Němčí",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40002 Malecov Nemci"
  },
  {
    "cast": "Němčí",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Podlesí",
    "val": "56201 Podlesi Nemci"
  },
  {
    "cast": "Němčice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Němčice",
    "val": "28002 Nemcice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Loket",
    "val": "25765 Loket Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Němčice",
    "val": "34506 Nemcice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Sedlice",
    "val": "38801 Sedlice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Předslav",
    "val": "33901 Predslav Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Němčice",
    "val": "38719 Nemcice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Němčice",
    "val": "38411 Nemcice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Ivančice",
    "val": "66491 Ivancice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34601 Meclov Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Němčice",
    "val": "29442 Nemcice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "67951",
    "okres": "Blansko",
    "obec": "Němčice",
    "val": "67951 Nemcice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "76843",
    "okres": "Kroměříž",
    "obec": "Němčice",
    "val": "76843 Nemcice Nemcice"
  },
  {
    "cast": "Němčice",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Němčice",
    "val": "53352 Nemcice Nemcice"
  },
  {
    "cast": "Němčice nad Hanou",
    "psc": "79827",
    "okres": "Prostějov",
    "obec": "Němčice nad Hanou",
    "val": "79827 Nemcice nad Hanou Nemcice nad Hanou"
  },
  {
    "cast": "Němčice (část)",
    "psc": "56118",
    "okres": "Svitavy",
    "obec": "Němčice",
    "val": "56118 Nemcice Nemcice (cast)"
  },
  {
    "cast": "Němčice (část)",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Němčice",
    "val": "57001 Nemcice Nemcice (cast)"
  },
  {
    "cast": "Němčičky",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Němčičky",
    "val": "67153 Nemcicky Nemcicky"
  },
  {
    "cast": "Němčičky",
    "psc": "69107",
    "okres": "Břeclav",
    "obec": "Němčičky",
    "val": "69107 Nemcicky Nemcicky"
  },
  {
    "cast": "Němčičky",
    "psc": "66466",
    "okres": "Brno-venkov",
    "obec": "Němčičky",
    "val": "66466 Nemcicky Nemcicky"
  },
  {
    "cast": "Němčovice",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Němčovice",
    "val": "33824 Nemcovice Nemcovice"
  },
  {
    "cast": "Německý Chloumek",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Nemecky Chloumek"
  },
  {
    "cast": "Němečky",
    "psc": "41765",
    "okres": "Teplice",
    "obec": "Ohníč",
    "val": "41765 Ohnic Nemecky"
  },
  {
    "cast": "Nemějice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Slabčice",
    "val": "39843 Slabcice Nemejice"
  },
  {
    "cast": "Němetice",
    "psc": "75643",
    "okres": "Vsetín",
    "obec": "Kelč",
    "val": "75643 Kelc Nemetice"
  },
  {
    "cast": "Němětice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Němětice",
    "val": "38701 Nemetice Nemetice"
  },
  {
    "cast": "Nemilany",
    "psc": "78301",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "78301 Olomouc Nemilany"
  },
  {
    "cast": "Nemile",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Nemile",
    "val": "78901 Nemile Nemile"
  },
  {
    "cast": "Nemilkov",
    "psc": "43401",
    "okres": "Most",
    "obec": "Lišnice",
    "val": "43401 Lisnice Nemilkov"
  },
  {
    "cast": "Nemilkov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Nemilkov"
  },
  {
    "cast": "Nemíž",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Tehov",
    "val": "25801 Tehov Nemiz"
  },
  {
    "cast": "Nemněnice",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Černovice",
    "val": "34562 Cernovice Nemnenice"
  },
  {
    "cast": "Nemochovice",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Nemochovice",
    "val": "68333 Nemochovice Nemochovice"
  },
  {
    "cast": "Nemojany",
    "psc": "68303",
    "okres": "Vyškov",
    "obec": "Nemojany",
    "val": "68303 Nemojany Nemojany"
  },
  {
    "cast": "Nemojov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Nemojov"
  },
  {
    "cast": "Nemošice (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Nemosice (cast)"
  },
  {
    "cast": "Nemošice (část)",
    "psc": "53003",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53003 Pardubice Nemosice (cast)"
  },
  {
    "cast": "Nemotice",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Nemotice",
    "val": "68333 Nemotice Nemotice"
  },
  {
    "cast": "Nemyčeves",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Nemyčeves",
    "val": "50601 Nemyceves Nemyceves"
  },
  {
    "cast": "Nemyslovice",
    "psc": "29429",
    "okres": "Mladá Boleslav",
    "obec": "Nemyslovice",
    "val": "29429 Nemyslovice Nemyslovice"
  },
  {
    "cast": "Nemyšl",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nemyšl",
    "val": "39143 Nemysl Nemysl"
  },
  {
    "cast": "Nenačovice",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Nenačovice",
    "val": "26601 Nenacovice Nenacovice"
  },
  {
    "cast": "Nenakonice",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Věrovany",
    "val": "78375 Verovany Nenakonice"
  },
  {
    "cast": "Nenkovice",
    "psc": "69637",
    "okres": "Hodonín",
    "obec": "Nenkovice",
    "val": "69637 Nenkovice Nenkovice"
  },
  {
    "cast": "Nepasice",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Třebechovice pod Orebem",
    "val": "50346 Trebechovice pod Orebem Nepasice"
  },
  {
    "cast": "Neplachov",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Neplachov",
    "val": "37365 Neplachov Neplachov"
  },
  {
    "cast": "Neplachovice",
    "psc": "74774",
    "okres": "Opava",
    "obec": "Neplachovice",
    "val": "74774 Neplachovice Neplachovice"
  },
  {
    "cast": "Nepolisy (část)",
    "psc": "50363",
    "okres": "Hradec Králové",
    "obec": "Nepolisy",
    "val": "50363 Nepolisy Nepolisy (cast)"
  },
  {
    "cast": "Nepolisy (část)",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Nepolisy",
    "val": "50351 Nepolisy Nepolisy (cast)"
  },
  {
    "cast": "Nepoměřice",
    "psc": "28511",
    "okres": "Kutná Hora",
    "obec": "Nepoměřice",
    "val": "28511 Nepomerice Nepomerice"
  },
  {
    "cast": "Nepomuk",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Nepomuk",
    "val": "33501 Nepomuk Nepomuk"
  },
  {
    "cast": "Nepomuk",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Jílovice",
    "val": "37312 Jilovice Nepomuk"
  },
  {
    "cast": "Nepomuk",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Nepomuk",
    "val": "26242 Nepomuk Nepomuk"
  },
  {
    "cast": "Nepomuky",
    "psc": "58867",
    "okres": "Jihlava",
    "obec": "Stará Říše",
    "val": "58867 Stara Rise Nepomuky"
  },
  {
    "cast": "Nepomuky",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Horní Čermná",
    "val": "56301 Horni Cermna Nepomuky"
  },
  {
    "cast": "Nepomyšl",
    "psc": "43971",
    "okres": "Louny",
    "obec": "Nepomyšl",
    "val": "43971 Nepomysl Nepomysl"
  },
  {
    "cast": "Neprobylice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "43801 Podborany Neprobylice"
  },
  {
    "cast": "Neprobylice",
    "psc": "27375",
    "okres": "Kladno",
    "obec": "Neprobylice",
    "val": "27375 Neprobylice Neprobylice"
  },
  {
    "cast": "Neprochovy",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Neprochovy"
  },
  {
    "cast": "Nepřejov",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Neprejov"
  },
  {
    "cast": "Nepřejov",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Dolní Hbity",
    "val": "26263 Dolni Hbity Neprejov"
  },
  {
    "cast": "Nepřevázka",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Nepřevázka",
    "val": "29301 Neprevazka Neprevazka"
  },
  {
    "cast": "Nepřívěc",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50601 Libosovice Neprivec"
  },
  {
    "cast": "Nerad",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Živanice",
    "val": "53341 Zivanice Nerad"
  },
  {
    "cast": "Neratov",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Neratov",
    "val": "53341 Neratov Neratov"
  },
  {
    "cast": "Neratovice",
    "psc": "27711",
    "okres": "Mělník",
    "obec": "Neratovice",
    "val": "27711 Neratovice Neratovice"
  },
  {
    "cast": "Nerošov",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Nechanice",
    "val": "50315 Nechanice Nerosov"
  },
  {
    "cast": "Nerozhovice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Vápenný Podol",
    "val": "53803 Vapenny Podol Nerozhovice"
  },
  {
    "cast": "Neředín",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Neredin"
  },
  {
    "cast": "Neřežín",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Chaloupky",
    "val": "26762 Chaloupky Nerezin"
  },
  {
    "cast": "Neslovice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Neslovice",
    "val": "66491 Neslovice Neslovice"
  },
  {
    "cast": "Nesměň",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Zásmuky",
    "val": "28144 Zasmuky Nesmen"
  },
  {
    "cast": "Nesměň",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Ločenice",
    "val": "37401 Locenice Nesmen"
  },
  {
    "cast": "Nesměřice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zruč nad Sázavou",
    "val": "28522 Zruc nad Sazavou Nesmerice"
  },
  {
    "cast": "Nesovice",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Nesovice",
    "val": "68333 Nesovice Nesovice"
  },
  {
    "cast": "Nespeky (část)",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Nespeky",
    "val": "25167 Nespeky Nespeky (cast)"
  },
  {
    "cast": "Nespeky (část)",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Nespeky",
    "val": "25722 Nespeky Nespeky (cast)"
  },
  {
    "cast": "Nesperská Lhota",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vlašim",
    "val": "25801 Vlasim Nesperska Lhota"
  },
  {
    "cast": "Nespery",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Veliš",
    "val": "25701 Velis Nespery"
  },
  {
    "cast": "Nespice",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Nespice"
  },
  {
    "cast": "Nestanice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Libějovice",
    "val": "38901 Libejovice Nestanice"
  },
  {
    "cast": "Nestrašovice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Nestrašovice",
    "val": "26272 Nestrasovice Nestrasovice"
  },
  {
    "cast": "Nesuchyně",
    "psc": "27007",
    "okres": "Rakovník",
    "obec": "Nesuchyně",
    "val": "27007 Nesuchyne Nesuchyne"
  },
  {
    "cast": "Nesvačilka",
    "psc": "66454",
    "okres": "Brno-venkov",
    "obec": "Nesvačilka",
    "val": "66454 Nesvacilka Nesvacilka"
  },
  {
    "cast": "Nesvačily",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pošná",
    "val": "39501 Posna Nesvacily"
  },
  {
    "cast": "Nesvačily",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Nesvačily",
    "val": "26727 Nesvacily Nesvacily"
  },
  {
    "cast": "Nesvačily",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Nesvacily"
  },
  {
    "cast": "Nesvačily",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Nesvacily"
  },
  {
    "cast": "Nesvačily",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Nesvacily"
  },
  {
    "cast": "Neškaredice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Neskaredice"
  },
  {
    "cast": "Něšov",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Pernarec",
    "val": "33036 Pernarec Nesov"
  },
  {
    "cast": "Neštědice",
    "psc": "40332",
    "okres": "Ústí nad Labem",
    "obec": "Povrly",
    "val": "40332 Povrly Nestedice"
  },
  {
    "cast": "Neštěmice",
    "psc": "40331",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40331 Usti nad Labem Nestemice"
  },
  {
    "cast": "Neštětice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Nestetice"
  },
  {
    "cast": "Nětčice",
    "psc": "69701",
    "okres": "Hodonín",
    "obec": "Kyjov",
    "val": "69701 Kyjov Netcice"
  },
  {
    "cast": "Nětčice",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Zdounky",
    "val": "76802 Zdounky Netcice"
  },
  {
    "cast": "Netěchovice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Týn nad Vltavou",
    "val": "37501 Tyn nad Vltavou Netechovice"
  },
  {
    "cast": "Netín",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Netín",
    "val": "59444 Netin Netin"
  },
  {
    "cast": "Netolice",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50743 Markvartice Netolice"
  },
  {
    "cast": "Netolice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Netolice",
    "val": "38411 Netolice Netolice"
  },
  {
    "cast": "Netolice (část)",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Lochovice",
    "val": "26751 Lochovice Netolice (cast)"
  },
  {
    "cast": "Netolice (část)",
    "psc": "26723",
    "okres": "Beroun",
    "obec": "Lochovice",
    "val": "26723 Lochovice Netolice (cast)"
  },
  {
    "cast": "Netonice",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Bílsko",
    "val": "38773 Bilsko Netonice"
  },
  {
    "cast": "Netovice",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Netovice"
  },
  {
    "cast": "Netřeba",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Úžice",
    "val": "27745 Uzice Netreba"
  },
  {
    "cast": "Netřebice",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Netřebice",
    "val": "28802 Netrebice Netrebice"
  },
  {
    "cast": "Netřebice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Netřebice",
    "val": "38232 Netrebice Netrebice"
  },
  {
    "cast": "Netřeby",
    "psc": "27345",
    "okres": "Kladno",
    "obec": "Hřebeč",
    "val": "27345 Hrebec Netreby"
  },
  {
    "cast": "Netřeby",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "České Heřmanice",
    "val": "56601 Ceske Hermanice Netreby"
  },
  {
    "cast": "Netunice",
    "psc": "33204",
    "okres": "Plzeň-jih",
    "obec": "Netunice",
    "val": "33204 Netunice Netunice"
  },
  {
    "cast": "Netušil",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Rašovice",
    "val": "28504 Rasovice Netusil"
  },
  {
    "cast": "Netvořice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Netvořice",
    "val": "25744 Netvorice Netvorice"
  },
  {
    "cast": "Neubuz",
    "psc": "76315",
    "okres": "Zlín",
    "obec": "Neubuz",
    "val": "76315 Neubuz Neubuz"
  },
  {
    "cast": "Neuměř",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Neuměř",
    "val": "34562 Neumer Neumer"
  },
  {
    "cast": "Neuměřice (část)",
    "psc": "27326",
    "okres": "Kladno",
    "obec": "Neuměřice",
    "val": "27326 Neumerice Neumerice (cast)"
  },
  {
    "cast": "Neuměřice (část)",
    "psc": "27325",
    "okres": "Kladno",
    "obec": "Neuměřice",
    "val": "27325 Neumerice Neumerice (cast)"
  },
  {
    "cast": "Neumětely",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Neumětely",
    "val": "26724 Neumetely Neumetely"
  },
  {
    "cast": "Neurazy",
    "psc": "33555",
    "okres": "Plzeň-jih",
    "obec": "Neurazy",
    "val": "33555 Neurazy Neurazy"
  },
  {
    "cast": "Neuslužice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Litochovice",
    "val": "38701 Litochovice Neusluzice"
  },
  {
    "cast": "Neustupov",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Neustupov"
  },
  {
    "cast": "Nevcehle",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Nevcehle",
    "val": "58862 Nevcehle Nevcehle"
  },
  {
    "cast": "Nevděk",
    "psc": "34506",
    "okres": "Klatovy",
    "obec": "Černíkov",
    "val": "34506 Cernikov Nevdek"
  },
  {
    "cast": "Neveklov",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Neveklov"
  },
  {
    "cast": "Neveklovice",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Neveklovice",
    "val": "29413 Neveklovice Neveklovice"
  },
  {
    "cast": "Nevězice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Nevězice",
    "val": "39804 Nevezice Nevezice"
  },
  {
    "cast": "Nevid",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Nevid",
    "val": "33701 Nevid Nevid"
  },
  {
    "cast": "Nevojice",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Nevojice",
    "val": "68501 Nevojice Nevojice"
  },
  {
    "cast": "Nevolice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nevolice",
    "val": "34401 Nevolice Nevolice"
  },
  {
    "cast": "Nevratice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Nevratice",
    "val": "50801 Nevratice Nevratice"
  },
  {
    "cast": "Nevřeň",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Nevřeň",
    "val": "33011 Nevren Nevren"
  },
  {
    "cast": "Nevšová",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Slavičín",
    "val": "76321 Slavicin Nevsova"
  },
  {
    "cast": "Nezabudice",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Nezabudice",
    "val": "27023 Nezabudice Nezabudice"
  },
  {
    "cast": "Nezabylice",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Nezabylice",
    "val": "43001 Nezabylice Nezabylice"
  },
  {
    "cast": "Nezamyslice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Nezamyslice",
    "val": "34201 Nezamyslice Nezamyslice"
  },
  {
    "cast": "Nezamyslice",
    "psc": "79826",
    "okres": "Prostějov",
    "obec": "Nezamyslice",
    "val": "79826 Nezamyslice Nezamyslice"
  },
  {
    "cast": "Nezbavětice",
    "psc": "33204",
    "okres": "Plzeň-město",
    "obec": "Nezbavětice",
    "val": "33204 Nezbavetice Nezbavetice"
  },
  {
    "cast": "Nezdenice (část)",
    "psc": "68732",
    "okres": "Uherské Hradiště",
    "obec": "Nezdenice",
    "val": "68732 Nezdenice Nezdenice (cast)"
  },
  {
    "cast": "Nezdenice (část)",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Nezdenice",
    "val": "68771 Nezdenice Nezdenice (cast)"
  },
  {
    "cast": "Nezdice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Nezdice"
  },
  {
    "cast": "Nezdice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Nezdice",
    "val": "33401 Nezdice Nezdice"
  },
  {
    "cast": "Nezdice",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Nezdice"
  },
  {
    "cast": "Nezdice na Šumavě",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Nezdice na Šumavě",
    "val": "34201 Nezdice na Sumave Nezdice na Sumave"
  },
  {
    "cast": "Nezdín",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Prosíčka",
    "val": "58401 Prosicka Nezdin"
  },
  {
    "cast": "Nezdřev",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Nezdřev",
    "val": "33544 Nezdrev Nezdrev"
  },
  {
    "cast": "Neznášov",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Rožnov",
    "val": "55101 Roznov Neznasov"
  },
  {
    "cast": "Neznašov (část)",
    "psc": "37302",
    "okres": "České Budějovice",
    "obec": "Všemyslice",
    "val": "37302 Vsemyslice Neznasov (cast)"
  },
  {
    "cast": "Neznašov (část)",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Všemyslice",
    "val": "37501 Vsemyslice Neznasov (cast)"
  },
  {
    "cast": "Neznašovy",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Vrhaveč",
    "val": "33901 Vrhavec Neznasovy"
  },
  {
    "cast": "Nezvěstice",
    "psc": "33204",
    "okres": "Plzeň-město",
    "obec": "Nezvěstice",
    "val": "33204 Nezvestice Nezvestice"
  },
  {
    "cast": "Nežetice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Nezetice"
  },
  {
    "cast": "Nežichov",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Nezichov"
  },
  {
    "cast": "Něžovice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Milevsko",
    "val": "39901 Milevsko Nezovice"
  },
  {
    "cast": "Nicov",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Nicov",
    "val": "38473 Nicov Nicov"
  },
  {
    "cast": "Nihošovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Nihošovice",
    "val": "38701 Nihosovice Nihosovice"
  },
  {
    "cast": "Níhov",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Níhov",
    "val": "59455 Nihov Nihov"
  },
  {
    "cast": "Nikolčice (část)",
    "psc": "69171",
    "okres": "Břeclav",
    "obec": "Nikolčice",
    "val": "69171 Nikolcice Nikolcice (cast)"
  },
  {
    "cast": "Nikolčice (část)",
    "psc": "69165",
    "okres": "Břeclav",
    "obec": "Nikolčice",
    "val": "69165 Nikolcice Nikolcice (cast)"
  },
  {
    "cast": "Níkovice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Hrejkovice",
    "val": "39901 Hrejkovice Nikovice"
  },
  {
    "cast": "Niměřice",
    "psc": "29430",
    "okres": "Mladá Boleslav",
    "obec": "Niměřice",
    "val": "29430 Nimerice Nimerice"
  },
  {
    "cast": "Nimpšov",
    "psc": "67541",
    "okres": "Třebíč",
    "obec": "Nimpšov",
    "val": "67541 Nimpsov Nimpsov"
  },
  {
    "cast": "Nišovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Nišovice",
    "val": "38701 Nisovice Nisovice"
  },
  {
    "cast": "Nítkovice",
    "psc": "76813",
    "okres": "Kroměříž",
    "obec": "Nítkovice",
    "val": "76813 Nitkovice Nitkovice"
  },
  {
    "cast": "Nítovice",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Kardašova Řečice",
    "val": "37821 Kardasova Recice Nitovice"
  },
  {
    "cast": "Niva",
    "psc": "79861",
    "okres": "Prostějov",
    "obec": "Niva",
    "val": "79861 Niva Niva"
  },
  {
    "cast": "Nivnice",
    "psc": "68751",
    "okres": "Uherské Hradiště",
    "obec": "Nivnice",
    "val": "68751 Nivnice Nivnice"
  },
  {
    "cast": "Nivy",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Děpoltovice",
    "val": "36225 Depoltovice Nivy"
  },
  {
    "cast": "Nivy",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Střítež",
    "val": "59251 Stritez Nivy"
  },
  {
    "cast": "Nízká Lhota",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Kámen",
    "val": "39501 Kamen Nizka Lhota"
  },
  {
    "cast": "Nízká Srbská (část)",
    "psc": "54963",
    "okres": "Náchod",
    "obec": "Machov",
    "val": "54963 Machov Nizka Srbska (cast)"
  },
  {
    "cast": "Nízká Srbská (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Machov",
    "val": "54931 Machov Nizka Srbska (cast)"
  },
  {
    "cast": "Nižbor",
    "psc": "26705",
    "okres": "Beroun",
    "obec": "Nižbor",
    "val": "26705 Nizbor Nizbor"
  },
  {
    "cast": "Nížebohy",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Budyně nad Ohří",
    "val": "41301 Budyne nad Ohri Nizebohy"
  },
  {
    "cast": "Nížkov",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Nížkov",
    "val": "59212 Nizkov Nizkov"
  },
  {
    "cast": "Nížkovice",
    "psc": "68401",
    "okres": "Vyškov",
    "obec": "Nížkovice",
    "val": "68401 Nizkovice Nizkovice"
  },
  {
    "cast": "Nižní Lhoty",
    "psc": "73951",
    "okres": "Frýdek-Místek",
    "obec": "Nižní Lhoty",
    "val": "73951 Nizni Lhoty Nizni Lhoty"
  },
  {
    "cast": "Norberčany",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Norberčany",
    "val": "79305 Norbercany Norbercany"
  },
  {
    "cast": "Nořín",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Zálší",
    "val": "56501 Zalsi Norin"
  },
  {
    "cast": "Nosákov",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Nosakov"
  },
  {
    "cast": "Nosálov",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Nosálov",
    "val": "27735 Nosalov Nosalov"
  },
  {
    "cast": "Nosálovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Nosalovice"
  },
  {
    "cast": "Nosetín",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Nosetin"
  },
  {
    "cast": "Nosislav",
    "psc": "69164",
    "okres": "Brno-venkov",
    "obec": "Nosislav",
    "val": "69164 Nosislav Nosislav"
  },
  {
    "cast": "Noskov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Noskov"
  },
  {
    "cast": "Nošovice",
    "psc": "73951",
    "okres": "Frýdek-Místek",
    "obec": "Nošovice",
    "val": "73951 Nosovice Nosovice"
  },
  {
    "cast": "Noutonice",
    "psc": "25264",
    "okres": "Praha-západ",
    "obec": "Lichoceves",
    "val": "25264 Lichoceves Noutonice"
  },
  {
    "cast": "Nouzka",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Nouzka"
  },
  {
    "cast": "Nouzov",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Volenice",
    "val": "26272 Volenice Nouzov"
  },
  {
    "cast": "Nouzov",
    "psc": "27031",
    "okres": "Rakovník",
    "obec": "Senomaty",
    "val": "27031 Senomaty Nouzov"
  },
  {
    "cast": "Nouzov",
    "psc": "28901",
    "okres": "Nymburk",
    "obec": "Chotěšice",
    "val": "28901 Chotesice Nouzov"
  },
  {
    "cast": "Nouzov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Litíč",
    "val": "54401 Litic Nouzov"
  },
  {
    "cast": "Nová Bělá (část)",
    "psc": "73924",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "73924 Ostrava Nova Bela (cast)"
  },
  {
    "cast": "Nová Bělá (část)",
    "psc": "72400",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72400 Ostrava Nova Bela (cast)"
  },
  {
    "cast": "Nová Bohyně",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40502 Malsovice Nova Bohyne"
  },
  {
    "cast": "Nová Brtnice",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Zašovice",
    "val": "67521 Zasovice Nova Brtnice"
  },
  {
    "cast": "Nová Buková",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nová Buková",
    "val": "39301 Nova Bukova Nova Bukova"
  },
  {
    "cast": "Nová Bystřice",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Nova Bystrice"
  },
  {
    "cast": "Nová Cerekev (část)",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nová Cerekev",
    "val": "39301 Nova Cerekev Nova Cerekev (cast)"
  },
  {
    "cast": "Nová Cerekev (část)",
    "psc": "39415",
    "okres": "Pelhřimov",
    "obec": "Nová Cerekev",
    "val": "39415 Nova Cerekev Nova Cerekev (cast)"
  },
  {
    "cast": "Nová Červená Voda",
    "psc": "79053",
    "okres": "Jeseník",
    "obec": "Stará Červená Voda",
    "val": "79053 Stara Cervena Voda Nova Cervena Voda"
  },
  {
    "cast": "Nová Dědina",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Nova Dedina"
  },
  {
    "cast": "Nová Dědina",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Konice",
    "val": "79852 Konice Nova Dedina"
  },
  {
    "cast": "Nová Dědina",
    "psc": "76821",
    "okres": "Kroměříž",
    "obec": "Nová Dědina",
    "val": "76821 Nova Dedina Nova Dedina"
  },
  {
    "cast": "Nová Dobev",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dobev",
    "val": "39701 Dobev Nova Dobev"
  },
  {
    "cast": "Nová Hlína",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Třeboň",
    "val": "37901 Trebon Nova Hlina"
  },
  {
    "cast": "Nová Horka",
    "psc": "74213",
    "okres": "Nový Jičín",
    "obec": "Studénka",
    "val": "74213 Studenka Nova Horka"
  },
  {
    "cast": "Nová Hospoda",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Nova Hospoda"
  },
  {
    "cast": "Nová Hospoda",
    "psc": "31800",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31800 Plzen Nova Hospoda"
  },
  {
    "cast": "Nová Hospoda",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Nova Hospoda"
  },
  {
    "cast": "Nová Hradečná",
    "psc": "78383",
    "okres": "Olomouc",
    "obec": "Nová Hradečná",
    "val": "78383 Nova Hradecna Nova Hradecna"
  },
  {
    "cast": "Nová Hůrka",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Prášily",
    "val": "34201 Prasily Nova Hurka"
  },
  {
    "cast": "Nová Huť",
    "psc": "33002",
    "okres": "Plzeň-město",
    "obec": "Dýšina",
    "val": "33002 Dysina Nova Hut"
  },
  {
    "cast": "Nová Huť",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nemanice",
    "val": "34401 Nemanice Nova Hut"
  },
  {
    "cast": "Nová Huť",
    "psc": "33842",
    "okres": "Rokycany",
    "obec": "Hrádek",
    "val": "33842 Hradek Nova Hut"
  },
  {
    "cast": "Nová Huť",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Vojnův Městec",
    "val": "59101 Vojnuv Mestec Nova Hut"
  },
  {
    "cast": "Nová Chřibská",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Rybniště",
    "val": "40747 Rybniste Nova Chribska"
  },
  {
    "cast": "Nová Jezná",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Úlice",
    "val": "33033 Ulice Nova Jezna"
  },
  {
    "cast": "Nová Kubice",
    "psc": "34532",
    "okres": "Domažlice",
    "obec": "Česká Kubice",
    "val": "34532 Ceska Kubice Nova Kubice"
  },
  {
    "cast": "Nová Kyselka",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Kyselka",
    "val": "36272 Kyselka Nova Kyselka"
  },
  {
    "cast": "Nová Lhota",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Kluky",
    "val": "28601 Kluky Nova Lhota"
  },
  {
    "cast": "Nová Lhota",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Vidice",
    "val": "28401 Vidice Nova Lhota"
  },
  {
    "cast": "Nová Lhota",
    "psc": "69674",
    "okres": "Hodonín",
    "obec": "Nová Lhota",
    "val": "69674 Nova Lhota Nova Lhota"
  },
  {
    "cast": "Nová Oleška",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Huntířov",
    "val": "40502 Huntirov Nova Oleska"
  },
  {
    "cast": "Nová Olešná",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Olešná",
    "val": "37853 Nova Olesna Nova Olesna"
  },
  {
    "cast": "Nová Paka (část)",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Nova Paka (cast)"
  },
  {
    "cast": "Nová Paka (část)",
    "psc": "50791",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50791 Nova Paka Nova Paka (cast)"
  },
  {
    "cast": "Nová Pasečnice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Pasečnice",
    "val": "34401 Pasecnice Nova Pasecnice"
  },
  {
    "cast": "Nová Pec",
    "psc": "38462",
    "okres": "Prachatice",
    "obec": "Nová Pec",
    "val": "38462 Nova Pec Nova Pec"
  },
  {
    "cast": "Nová Pláň",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Nová Pláň",
    "val": "79201 Nova Plan Nova Plan"
  },
  {
    "cast": "Nová Plánice",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34034 Planice Nova Planice"
  },
  {
    "cast": "Nová Role",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Nová Role",
    "val": "36225 Nova Role Nova Role"
  },
  {
    "cast": "Nová Roveň",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Nova Roven"
  },
  {
    "cast": "Nová Rudná",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Rudná pod Pradědem",
    "val": "79331 Rudna pod Pradedem Nova Rudna"
  },
  {
    "cast": "Nová Říše (část)",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Nová Říše",
    "val": "58856 Nova Rise Nova Rise (cast)"
  },
  {
    "cast": "Nová Říše (část)",
    "psc": "58865",
    "okres": "Jihlava",
    "obec": "Nová Říše",
    "val": "58865 Nova Rise Nova Rise (cast)"
  },
  {
    "cast": "Nová Seninka",
    "psc": "78832",
    "okres": "Šumperk",
    "obec": "Staré Město",
    "val": "78832 Stare Mesto Nova Seninka"
  },
  {
    "cast": "Nová Sídla",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Nová Sídla",
    "val": "57001 Nova Sidla Nova Sidla"
  },
  {
    "cast": "Nová Skřeněř",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Nový Bydžov",
    "val": "50401 Novy Bydzov Nova Skrener"
  },
  {
    "cast": "Nová Starost",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Rynoltice",
    "val": "46353 Rynoltice Nova Starost"
  },
  {
    "cast": "Nová Studnice",
    "psc": "27304",
    "okres": "Kladno",
    "obec": "Hradečno",
    "val": "27304 Hradecno Nova Studnice"
  },
  {
    "cast": "Nová Telib",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Nová Telib",
    "val": "29406 Nova Telib Nova Telib"
  },
  {
    "cast": "Nová Třešně",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dolní Novosedly",
    "val": "39701 Dolni Novosedly Nova Tresne"
  },
  {
    "cast": "Nová Ulice",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Nova Ulice"
  },
  {
    "cast": "Nová Včelnice",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Včelnice",
    "val": "37842 Nova Vcelnice Nova Vcelnice"
  },
  {
    "cast": "Nová Ves",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Důl",
    "val": "39501 Dul Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Dírná",
    "val": "39201 Dirna Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Čížová",
    "val": "39701 Cizova Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Pyšely",
    "val": "25167 Pysely Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "34012",
    "okres": "Plzeň-jih",
    "obec": "Kbel",
    "val": "34012 Kbel Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Hodětín",
    "val": "39165 Hodetin Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "26763",
    "okres": "Beroun",
    "obec": "Zaječov",
    "val": "26763 Zajecov Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Slabce",
    "val": "27041 Slabce Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "27304",
    "okres": "Kladno",
    "obec": "Hradečno",
    "val": "27304 Hradecno Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Třemešné",
    "val": "34806 Tremesne Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Křižovatka",
    "val": "35134 Krizovatka Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Nová Ves",
    "val": "44001 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "56924",
    "okres": "Svitavy",
    "obec": "Kunčina",
    "val": "56924 Kuncina Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Batelov",
    "val": "58851 Batelov Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Nová Ves",
    "val": "67521 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Lešany",
    "val": "25744 Lesany Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Děkov",
    "val": "27004 Dekov Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Nová Ves",
    "val": "34506 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Košetice",
    "val": "39501 Kosetice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Nepomyšl",
    "val": "44101 Nepomysl Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78321 Litovel Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41501 Teplice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Nasavrky",
    "val": "53825 Nasavrky Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nalžovice",
    "val": "26401 Nalzovice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "33441",
    "okres": "Plzeň-jih",
    "obec": "Nová Ves",
    "val": "33441 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Oselce",
    "val": "33501 Oselce Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Nová Ves",
    "val": "46331 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Nová Ves",
    "val": "38719 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Božejov",
    "val": "39301 Bozejov Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Nová Ves",
    "val": "25063 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Nová Ves",
    "val": "38203 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "56543",
    "okres": "Ústí nad Orlicí",
    "obec": "Zámrsk",
    "val": "56543 Zamrsk Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Nová Ves",
    "val": "66491 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Dolní Moravice",
    "val": "79501 Dolni Moravice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Branžež",
    "val": "29402 Branzez Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Choceň",
    "val": "56501 Chocen Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "70900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70900 Ostrava Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Čistá",
    "val": "27034 Cista Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "47112",
    "okres": "Česká Lípa",
    "obec": "Volfartice",
    "val": "47112 Volfartice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "36464",
    "okres": "Sokolov",
    "obec": "Nová Ves",
    "val": "36464 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "69123",
    "okres": "Brno-venkov",
    "obec": "Pohořelice",
    "val": "69123 Pohorelice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "27752",
    "okres": "Mělník",
    "obec": "Nová Ves",
    "val": "27752 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Miloňovice",
    "val": "38601 Milonovice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Nová Ves",
    "val": "59451 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Konstantinovy Lázně",
    "val": "34953 Konstantinovy Lazne Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Kocbeře",
    "val": "54401 Kocbere Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Staňkovice",
    "val": "28504 Stankovice Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "37881 Cesky Rudolec Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Olešník",
    "val": "37501 Olesnik Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Číměř",
    "val": "37802 Cimer Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Hora Svatého Šebestiána",
    "val": "43001 Hora Svateho Sebestiana Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Kamenice nad Lipou",
    "val": "39470 Kamenice nad Lipou Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Nová Ves",
    "val": "51721 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Voděrady",
    "val": "51721 Voderady Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "37315",
    "okres": "České Budějovice",
    "obec": "Nová Ves",
    "val": "37315 Nova Ves Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51703 Skuhrov nad Belou Nova Ves"
  },
  {
    "cast": "Nová Ves",
    "psc": "73911",
    "okres": "Frýdek-Místek",
    "obec": "Frýdlant nad Ostravicí",
    "val": "73911 Frydlant nad Ostravici Nova Ves"
  },
  {
    "cast": "Nová Ves I",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Nová Ves I",
    "val": "28002 Nova Ves I Nova Ves I"
  },
  {
    "cast": "Nová Ves II",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Rostoklaty",
    "val": "28201 Rostoklaty Nova Ves II"
  },
  {
    "cast": "Nová Ves III",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Svojšice",
    "val": "28002 Svojsice Nova Ves III"
  },
  {
    "cast": "Nová Ves nad Lužnicí",
    "psc": "37809",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Ves nad Lužnicí",
    "val": "37809 Nova Ves nad Luznici Nova Ves nad Luznici"
  },
  {
    "cast": "Nová Ves nad Nisou",
    "psc": "46827",
    "okres": "Jablonec nad Nisou",
    "obec": "Nová Ves nad Nisou",
    "val": "46827 Nova Ves nad Nisou Nova Ves nad Nisou"
  },
  {
    "cast": "Nová Ves nad Popelkou",
    "psc": "51271",
    "okres": "Semily",
    "obec": "Nová Ves nad Popelkou",
    "val": "51271 Nova Ves nad Popelkou Nova Ves nad Popelkou"
  },
  {
    "cast": "Nová Ves pod Pleší",
    "psc": "26204",
    "okres": "Příbram",
    "obec": "Nová Ves pod Pleší",
    "val": "26204 Nova Ves pod Plesi Nova Ves pod Plesi"
  },
  {
    "cast": "Nová Ves u Bakova",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Nová Ves u Bakova",
    "val": "29401 Nova Ves u Bakova Nova Ves u Bakova"
  },
  {
    "cast": "Nová Ves u Dolních Kralovic",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58401 Hnevkovice Nova Ves u Dolnich Kralovic"
  },
  {
    "cast": "Nová Ves u Chotěboře (část)",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Nová Ves u Chotěboře",
    "val": "58301 Nova Ves u Chotebore Nova Ves u Chotebore (cast)"
  },
  {
    "cast": "Nová Ves u Chotěboře (část)",
    "psc": "58273",
    "okres": "Havlíčkův Brod",
    "obec": "Nová Ves u Chotěboře",
    "val": "58273 Nova Ves u Chotebore Nova Ves u Chotebore (cast)"
  },
  {
    "cast": "Nová Ves u Chýnova",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Nová Ves u Chýnova",
    "val": "39155 Nova Ves u Chynova Nova Ves u Chynova"
  },
  {
    "cast": "Nová Ves u Jarošova",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Nová Ves u Jarošova",
    "val": "57001 Nova Ves u Jarosova Nova Ves u Jarosova"
  },
  {
    "cast": "Nová Ves u Klikova",
    "psc": "37807",
    "okres": "Jindřichův Hradec",
    "obec": "Rapšach",
    "val": "37807 Rapsach Nova Ves u Klikova"
  },
  {
    "cast": "Nová Ves u Leštiny",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Nová Ves u Leštiny",
    "val": "58282 Nova Ves u Lestiny Nova Ves u Lestiny"
  },
  {
    "cast": "Nová Ves u Litomyšle",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Nova Ves u Litomysle"
  },
  {
    "cast": "Nová Ves u Mladé Vožice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nová Ves u Mladé Vožice",
    "val": "39143 Nova Ves u Mlade Vozice Nova Ves u Mlade Vozice"
  },
  {
    "cast": "Nová Ves u Nepomuka",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Neurazy",
    "val": "33501 Neurazy Nova Ves u Nepomuka"
  },
  {
    "cast": "Nová Ves u Nového Města na Moravě",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nová Ves u Nového Města na Moravě",
    "val": "59231 Nova Ves u Noveho Mesta na Morave Nova Ves u Noveho Mesta na Morave"
  },
  {
    "cast": "Nová Ves u Pláně",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Nova Ves u Plane"
  },
  {
    "cast": "Nová Ves u Protivína",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Žďár",
    "val": "39811 Zdar Nova Ves u Protivina"
  },
  {
    "cast": "Nová Ves u Světlé",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Nová Ves u Světlé",
    "val": "58291 Nova Ves u Svetle Nova Ves u Svetle"
  },
  {
    "cast": "Nová Ves v Horách",
    "psc": "43545",
    "okres": "Most",
    "obec": "Nová Ves v Horách",
    "val": "43545 Nova Ves v Horach Nova Ves v Horach"
  },
  {
    "cast": "Nová Ves (část)",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Chotěšice",
    "val": "28903 Chotesice Nova Ves (cast)"
  },
  {
    "cast": "Nová Ves (část)",
    "psc": "28902",
    "okres": "Nymburk",
    "obec": "Chotěšice",
    "val": "28902 Chotesice Nova Ves (cast)"
  },
  {
    "cast": "Nová Véska",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Staré Město",
    "val": "79201 Stare Mesto Nova Veska"
  },
  {
    "cast": "Nová Véska",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Norberčany",
    "val": "79305 Norbercany Nova Veska"
  },
  {
    "cast": "Nová Vesnička",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41201 Libesice Nova Vesnicka"
  },
  {
    "cast": "Nová Ves-Děčín XX (část) x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Nova Ves-Decin XX (cast) x)"
  },
  {
    "cast": "Nová Ves-Děčín XX (část) x)",
    "psc": "40505",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40505 Decin Nova Ves-Decin XX (cast) x)"
  },
  {
    "cast": "Nová Víska",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Nova Viska"
  },
  {
    "cast": "Nová Víska",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dlažov",
    "val": "33901 Dlazov Nova Viska"
  },
  {
    "cast": "Nová Víska",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Domašín",
    "val": "43201 Domasin Nova Viska"
  },
  {
    "cast": "Nová Víska",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Nová Ves",
    "val": "46331 Nova Ves Nova Viska"
  },
  {
    "cast": "Nová Víska",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Stružná",
    "val": "36471 Struzna Nova Viska"
  },
  {
    "cast": "Nová Víska",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Dolní Poustevna",
    "val": "40747 Dolni Poustevna Nova Viska"
  },
  {
    "cast": "Nová Víska",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Hájek",
    "val": "36301 Hajek Nova Viska"
  },
  {
    "cast": "Nová Víska",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Nova Viska"
  },
  {
    "cast": "Nová Víska u Rokle",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Rokle",
    "val": "43201 Rokle Nova Viska u Rokle"
  },
  {
    "cast": "Nová Víska (část)",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33038 Bezverov Nova Viska (cast)"
  },
  {
    "cast": "Nová Víska (část)",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Nova Viska (cast)"
  },
  {
    "cast": "Nová Vráž",
    "psc": "39832",
    "okres": "Písek",
    "obec": "Vráž",
    "val": "39832 Vraz Nova Vraz"
  },
  {
    "cast": "Nová Zhoř",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Stránecká Zhoř",
    "val": "59442 Stranecka Zhor Nova Zhor"
  },
  {
    "cast": "Novákovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Lomec",
    "val": "33901 Lomec Novakovice"
  },
  {
    "cast": "Nové Bránice",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Nové Bránice",
    "val": "66464 Nove Branice Nove Branice"
  },
  {
    "cast": "Nové Dobrkovice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Nove Dobrkovice"
  },
  {
    "cast": "Nové Domky",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Rozvadov",
    "val": "34806 Rozvadov Nove Domky"
  },
  {
    "cast": "Nové Domky",
    "psc": "38276",
    "okres": "Český Krumlov",
    "obec": "Loučovice",
    "val": "38276 Loucovice Nove Domky"
  },
  {
    "cast": "Nové Domy",
    "psc": "35707",
    "okres": "Sokolov",
    "obec": "Oloví",
    "val": "35707 Olovi Nove Domy"
  },
  {
    "cast": "Nové Dvory",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Polná",
    "val": "58813 Polna Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Opařany",
    "val": "39161 Oparany Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Močerady",
    "val": "34561 Mocerady Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bystřany",
    "val": "41501 Bystrany Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Nové Dvory",
    "val": "26203 Nove Dvory Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Lážovice",
    "val": "26724 Lazovice Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Dvory",
    "val": "59212 Nove Dvory Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Hobzí",
    "val": "38001 Stare Hobzi Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Nové Dvory",
    "val": "41301 Nove Dvory Nove Dvory"
  },
  {
    "cast": "Nové Dvory",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Nove Dvory"
  },
  {
    "cast": "Nové Dvory (část)",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Červený Újezd",
    "val": "25789 Cerveny Ujezd Nove Dvory (cast)"
  },
  {
    "cast": "Nové Dvory (část)",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Nové Dvory",
    "val": "28401 Nove Dvory Nove Dvory (cast)"
  },
  {
    "cast": "Nové Dvory (část)",
    "psc": "25788",
    "okres": "Benešov",
    "obec": "Červený Újezd",
    "val": "25788 Cerveny Ujezd Nove Dvory (cast)"
  },
  {
    "cast": "Nové Dvory (část)",
    "psc": "28531",
    "okres": "Kutná Hora",
    "obec": "Nové Dvory",
    "val": "28531 Nove Dvory Nove Dvory (cast)"
  },
  {
    "cast": "Nové Dvory-Lipník nad Bečvou III x)",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lipník nad Bečvou",
    "val": "75131 Lipnik nad Becvou Nove Dvory-Lipnik nad Becvou III x)"
  },
  {
    "cast": "Nové Hamry",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nové Hamry",
    "val": "36221 Nove Hamry Nove Hamry"
  },
  {
    "cast": "Nové Heřminovy",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Nové Heřminovy",
    "val": "79201 Nove Herminovy Nove Herminovy"
  },
  {
    "cast": "Nové Hobzí",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Hobzí",
    "val": "37881 Stare Hobzi Nove Hobzi"
  },
  {
    "cast": "Nové Holešovice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Slepotice",
    "val": "53002 Slepotice Nove Holesovice"
  },
  {
    "cast": "Nové Homole",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Homole",
    "val": "37001 Homole Nove Homole"
  },
  {
    "cast": "Nové Hraběcí",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Šluknov",
    "val": "40747 Sluknov Nove Hrabeci"
  },
  {
    "cast": "Nové Hrady (část)",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37401 Nove Hrady Nove Hrady (cast)"
  },
  {
    "cast": "Nové Hrady (část)",
    "psc": "53944",
    "okres": "Ústí nad Orlicí",
    "obec": "Nové Hrady",
    "val": "53944 Nove Hrady Nove Hrady (cast)"
  },
  {
    "cast": "Nové Hrady (část)",
    "psc": "53945",
    "okres": "Ústí nad Orlicí",
    "obec": "Nové Hrady",
    "val": "53945 Nove Hrady Nove Hrady (cast)"
  },
  {
    "cast": "Nové Hrady (část)",
    "psc": "37333",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37333 Nove Hrady Nove Hrady (cast)"
  },
  {
    "cast": "Nové Hutě",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Nové Hutě",
    "val": "38501 Nove Hute Nove Hute"
  },
  {
    "cast": "Nové Hvězdlice",
    "psc": "68341",
    "okres": "Vyškov",
    "obec": "Hvězdlice",
    "val": "68341 Hvezdlice Nove Hvezdlice"
  },
  {
    "cast": "Nové Chalupy",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Nove Chalupy"
  },
  {
    "cast": "Nové Chalupy",
    "psc": "38462",
    "okres": "Prachatice",
    "obec": "Nová Pec",
    "val": "38462 Nova Pec Nove Chalupy"
  },
  {
    "cast": "Nové Jesenčany",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Nove Jesencany"
  },
  {
    "cast": "Nové Jirny",
    "psc": "25090",
    "okres": "Praha-východ",
    "obec": "Jirny",
    "val": "25090 Jirny Nove Jirny"
  },
  {
    "cast": "Nové Kestřany",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Štěkeň",
    "val": "38601 Steken Nove Kestrany"
  },
  {
    "cast": "Nové Kocbeře",
    "psc": "54464",
    "okres": "Trutnov",
    "obec": "Kocbeře",
    "val": "54464 Kocbere Nove Kocbere"
  },
  {
    "cast": "Nové Kopisty",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Terezín",
    "val": "41201 Terezin Nove Kopisty"
  },
  {
    "cast": "Nové Kounice",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Nove Kounice"
  },
  {
    "cast": "Nové Křečany",
    "psc": "40761",
    "okres": "Děčín",
    "obec": "Staré Křečany",
    "val": "40761 Stare Krecany Nove Krecany"
  },
  {
    "cast": "Nové Lány",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Nove Lany"
  },
  {
    "cast": "Nové Lesy",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Bílá Třemešná",
    "val": "54401 Bila Tremesna Nove Lesy"
  },
  {
    "cast": "Nové Lhotice (část)",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Liboměřice",
    "val": "53807 Libomerice Nove Lhotice (cast)"
  },
  {
    "cast": "Nové Lhotice (část)",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Liboměřice",
    "val": "53825 Libomerice Nove Lhotice (cast)"
  },
  {
    "cast": "Nové Losiny",
    "psc": "78823",
    "okres": "Šumperk",
    "obec": "Jindřichov",
    "val": "78823 Jindrichov Nove Losiny"
  },
  {
    "cast": "Nové Lublice",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Nové Lublice",
    "val": "74901 Nove Lublice Nove Lublice"
  },
  {
    "cast": "Nové Městečko",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Nove Mestecko"
  },
  {
    "cast": "Nové Městečko",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dlouhá Ves",
    "val": "34201 Dlouha Ves Nove Mestecko"
  },
  {
    "cast": "Nové Město",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Nove Mesto"
  },
  {
    "cast": "Nové Město",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Nove Mesto"
  },
  {
    "cast": "Nové Město",
    "psc": "41781",
    "okres": "Teplice",
    "obec": "Moldava",
    "val": "41781 Moldava Nove Mesto"
  },
  {
    "cast": "Nové Město",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Broumov",
    "val": "55001 Broumov Nove Mesto"
  },
  {
    "cast": "Nové Město",
    "psc": "73506",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73506 Karvina Nove Mesto"
  },
  {
    "cast": "Nové Město",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Rokycany",
    "val": "33701 Rokycany Nove Mesto"
  },
  {
    "cast": "Nové Město",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Jáchymov",
    "val": "36301 Jachymov Nove Mesto"
  },
  {
    "cast": "Nové Město",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Nové Město",
    "val": "50351 Nove Mesto Nove Mesto"
  },
  {
    "cast": "Nové Město na Moravě",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Nove Mesto na Morave"
  },
  {
    "cast": "Nové Město nad Metují",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nové Město nad Metují",
    "val": "54901 Nove Mesto nad Metuji Nove Mesto nad Metuji"
  },
  {
    "cast": "Nové Město pod Smrkem",
    "psc": "46365",
    "okres": "Liberec",
    "obec": "Nové Město pod Smrkem",
    "val": "46365 Nove Mesto pod Smrkem Nove Mesto pod Smrkem"
  },
  {
    "cast": "Nové Město (část)",
    "psc": "11000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "11000 Praha Nove Mesto (cast)"
  },
  {
    "cast": "Nové Město (část)",
    "psc": "12000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "12000 Praha Nove Mesto (cast)"
  },
  {
    "cast": "Nové Město (část)",
    "psc": "12800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "12800 Praha Nove Mesto (cast)"
  },
  {
    "cast": "Nové Město (část)",
    "psc": "18600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18600 Praha Nove Mesto (cast)"
  },
  {
    "cast": "Nové Mitrovice",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Nové Mitrovice",
    "val": "33563 Nove Mitrovice Nove Mitrovice"
  },
  {
    "cast": "Nové Mlýny",
    "psc": "69201",
    "okres": "Břeclav",
    "obec": "Přítluky",
    "val": "69201 Pritluky Nove Mlyny"
  },
  {
    "cast": "Nové Modlany",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Nove Modlany"
  },
  {
    "cast": "Nové Nespeřice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Petrovice II",
    "val": "28504 Petrovice II Nove Nesperice"
  },
  {
    "cast": "Nové Osinalice",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Medonosy",
    "val": "27721 Medonosy Nove Osinalice"
  },
  {
    "cast": "Nové Ouholice",
    "psc": "27752",
    "okres": "Mělník",
    "obec": "Nová Ves",
    "val": "27752 Nova Ves Nove Ouholice"
  },
  {
    "cast": "Nové Pavlovice-Liberec XIII x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Nove Pavlovice-Liberec XIII x)"
  },
  {
    "cast": "Nové Práchňany",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Nove Prachnany"
  },
  {
    "cast": "Nové Ransko",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec nad Doubravou",
    "val": "58263 Zdirec nad Doubravou Nove Ransko"
  },
  {
    "cast": "Nové Sady",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Nove Sady"
  },
  {
    "cast": "Nové Sady",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Písečné",
    "val": "37881 Pisecne Nove Sady"
  },
  {
    "cast": "Nové Sady",
    "psc": "68308",
    "okres": "Vyškov",
    "obec": "Nové Sady",
    "val": "68308 Nove Sady Nove Sady"
  },
  {
    "cast": "Nové Sady",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Sady",
    "val": "59501 Nove Sady Nove Sady"
  },
  {
    "cast": "Nové Sady",
    "psc": "79847",
    "okres": "Prostějov",
    "obec": "Horní Štěpánov",
    "val": "79847 Horni Stepanov Nove Sady"
  },
  {
    "cast": "Nové Sedlice",
    "psc": "74706",
    "okres": "Opava",
    "obec": "Nové Sedlice",
    "val": "74706 Nove Sedlice Nove Sedlice"
  },
  {
    "cast": "Nové Sedliště",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Staré Sedliště",
    "val": "34801 Stare Sedliste Nove Sedliste"
  },
  {
    "cast": "Nové Sedlo",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Nové Sedlo",
    "val": "43801 Nove Sedlo Nove Sedlo"
  },
  {
    "cast": "Nové Sedlo",
    "psc": "35734",
    "okres": "Sokolov",
    "obec": "Nové Sedlo",
    "val": "35734 Nove Sedlo Nove Sedlo"
  },
  {
    "cast": "Nové Smrkovice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Ostroměř",
    "val": "50801 Ostromer Nove Smrkovice"
  },
  {
    "cast": "Nové Spolí",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Nove Spoli"
  },
  {
    "cast": "Nové Stanovice",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Stanovice",
    "val": "36001 Stanovice Nove Stanovice"
  },
  {
    "cast": "Nové Strašecí",
    "psc": "27101",
    "okres": "Rakovník",
    "obec": "Nové Strašecí",
    "val": "27101 Nove Straseci Nove Straseci"
  },
  {
    "cast": "Nové Syrovice",
    "psc": "67541",
    "okres": "Třebíč",
    "obec": "Nové Syrovice",
    "val": "67541 Nove Syrovice Nove Syrovice"
  },
  {
    "cast": "Nové Těchanovice",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74901 Vitkov Nove Techanovice"
  },
  {
    "cast": "Nové Třebčice",
    "psc": "44101",
    "okres": "Chomutov",
    "obec": "Veliká Ves",
    "val": "44101 Velika Ves Nove Trebcice"
  },
  {
    "cast": "Nové Tupadly",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Želízy",
    "val": "27721 Zelizy Nove Tupadly"
  },
  {
    "cast": "Nové Valteřice",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Moravský Beroun",
    "val": "79305 Moravsky Beroun Nove Valterice"
  },
  {
    "cast": "Nové Veselí",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Veselí",
    "val": "59214 Nove Veseli Nove Veseli"
  },
  {
    "cast": "Nové Vilémovice",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Uhelná",
    "val": "79070 Uhelna Nove Vilemovice"
  },
  {
    "cast": "Nové Vrbno",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Větřkovice",
    "val": "74901 Vetrkovice Nove Vrbno"
  },
  {
    "cast": "Nové Vyklantice",
    "psc": "39427",
    "okres": "Pelhřimov",
    "obec": "Vyklantice",
    "val": "39427 Vyklantice Nove Vyklantice"
  },
  {
    "cast": "Nové Záboří",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Nove Zabori"
  },
  {
    "cast": "Nové Zámky",
    "psc": "28933",
    "okres": "Nymburk",
    "obec": "Křinec",
    "val": "28933 Krinec Nove Zamky"
  },
  {
    "cast": "Nové Zámky",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Mladeč",
    "val": "78401 Mladec Nove Zamky"
  },
  {
    "cast": "Novičí",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Novici"
  },
  {
    "cast": "Novina",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Sokolov",
    "val": "35601 Sokolov Novina"
  },
  {
    "cast": "Novina",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Stvolínky",
    "val": "47002 Stvolinky Novina"
  },
  {
    "cast": "Novina",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Kryštofovo Údolí",
    "val": "46001 Krystofovo Udoli Novina"
  },
  {
    "cast": "Noviny pod Ralskem",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Noviny pod Ralskem",
    "val": "47124 Noviny pod Ralskem Noviny pod Ralskem"
  },
  {
    "cast": "Novosedelské Hutě",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nemanice",
    "val": "34401 Nemanice Novosedelske Hute"
  },
  {
    "cast": "Novosedlice (část)",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Novosedlice",
    "val": "41501 Novosedlice Novosedlice (cast)"
  },
  {
    "cast": "Novosedlice (část)",
    "psc": "41731",
    "okres": "Teplice",
    "obec": "Novosedlice",
    "val": "41731 Novosedlice Novosedlice (cast)"
  },
  {
    "cast": "Novosedlo",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Žandov",
    "val": "47002 Zandov Novosedlo"
  },
  {
    "cast": "Novosedly",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Pšov",
    "val": "36452 Psov Novosedly"
  },
  {
    "cast": "Novosedly",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Hřebečníky",
    "val": "27041 Hrebecniky Novosedly"
  },
  {
    "cast": "Novosedly",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nemanice",
    "val": "34401 Nemanice Novosedly"
  },
  {
    "cast": "Novosedly",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dívčice",
    "val": "37348 Divcice Novosedly"
  },
  {
    "cast": "Novosedly",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38101 Kajov Novosedly"
  },
  {
    "cast": "Novosedly",
    "psc": "69182",
    "okres": "Břeclav",
    "obec": "Novosedly",
    "val": "69182 Novosedly Novosedly"
  },
  {
    "cast": "Novosedly nad Nežárkou (část)",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Novosedly nad Nežárkou",
    "val": "37901 Novosedly nad Nezarkou Novosedly nad Nezarkou (cast)"
  },
  {
    "cast": "Novosedly nad Nežárkou (část)",
    "psc": "37817",
    "okres": "Jindřichův Hradec",
    "obec": "Novosedly nad Nežárkou",
    "val": "37817 Novosedly nad Nezarkou Novosedly nad Nezarkou (cast)"
  },
  {
    "cast": "Novosedly (část)",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Novosedly",
    "val": "38716 Novosedly Novosedly (cast)"
  },
  {
    "cast": "Novosedly (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Novosedly",
    "val": "38601 Novosedly Novosedly (cast)"
  },
  {
    "cast": "Novotinky",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Novotinky"
  },
  {
    "cast": "Novotníky",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Prádlo",
    "val": "33501 Pradlo Novotniky"
  },
  {
    "cast": "Nový",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Kotovice",
    "val": "33301 Kotovice Novy"
  },
  {
    "cast": "Nový",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Městec Králové",
    "val": "28903 Mestec Kralove Novy"
  },
  {
    "cast": "Nový Berštejn",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Novy Berstejn"
  },
  {
    "cast": "Nový Bohumín",
    "psc": "73581",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73581 Bohumin Novy Bohumin"
  },
  {
    "cast": "Nový Bor",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Nový Bor",
    "val": "47301 Novy Bor Novy Bor"
  },
  {
    "cast": "Nový Bozděchov",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Radouň",
    "val": "37842 Horni Radoun Novy Bozdechov"
  },
  {
    "cast": "Nový Brázdim",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Brázdim",
    "val": "25063 Brazdim Novy Brazdim"
  },
  {
    "cast": "Nový Bydžov",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Nový Bydžov",
    "val": "50401 Novy Bydzov Novy Bydzov"
  },
  {
    "cast": "Nový Čestín",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Novy Cestin"
  },
  {
    "cast": "Nový Drahoňov",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Těmice",
    "val": "39470 Temice Novy Drahonov"
  },
  {
    "cast": "Nový Drahov",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Novy Drahov"
  },
  {
    "cast": "Nový Dům",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Nový Dům",
    "val": "26901 Novy Dum Novy Dum"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Číhaň",
    "val": "34142 Cihan Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Kámen",
    "val": "39501 Kamen Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Hořičky",
    "val": "55205 Horicky Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Žihle",
    "val": "33165 Zihle Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "74601",
    "okres": "Opava",
    "obec": "Stěbořice",
    "val": "74601 Steborice Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Myslív",
    "val": "34101 Mysliv Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Jaroměřice",
    "val": "56943 Jaromerice Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "28932",
    "okres": "Nymburk",
    "obec": "Nový Dvůr",
    "val": "28932 Novy Dvur Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kout na Šumavě",
    "val": "34506 Kout na Sumave Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Řeřichy",
    "val": "27035 Rerichy Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "27001",
    "okres": "Rakovník",
    "obec": "Chrášťany",
    "val": "27001 Chrastany Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Podhořany u Ronova",
    "val": "53803 Podhorany u Ronova Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Nová Ves u Chotěboře",
    "val": "58301 Nova Ves u Chotebore Novy Dvur"
  },
  {
    "cast": "Nový Dvůr",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Novy Dvur"
  },
  {
    "cast": "Nový Harcov-Liberec XVI x)",
    "psc": "46015",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46015 Liberec Novy Harcov-Liberec XVI x)"
  },
  {
    "cast": "Nový Hradec Králové (část)",
    "psc": "50002",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50002 Hradec Kralove Novy Hradec Kralove (cast)"
  },
  {
    "cast": "Nový Hradec Králové (část)",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Novy Hradec Kralove (cast)"
  },
  {
    "cast": "Nový Hradec Králové (část)",
    "psc": "50006",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50006 Hradec Kralove Novy Hradec Kralove (cast)"
  },
  {
    "cast": "Nový Hradec Králové (část)",
    "psc": "50008",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50008 Hradec Kralove Novy Hradec Kralove (cast)"
  },
  {
    "cast": "Nový Hradec Králové (část)",
    "psc": "50009",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50009 Hradec Kralove Novy Hradec Kralove (cast)"
  },
  {
    "cast": "Nový Hradec Králové (část)",
    "psc": "50011",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50011 Hradec Kralove Novy Hradec Kralove (cast)"
  },
  {
    "cast": "Nový Hradec Králové (část)",
    "psc": "50012",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50012 Hradec Kralove Novy Hradec Kralove (cast)"
  },
  {
    "cast": "Nový Hrádek",
    "psc": "54922",
    "okres": "Náchod",
    "obec": "Nový Hrádek",
    "val": "54922 Novy Hradek Novy Hradek"
  },
  {
    "cast": "Nový Hrozenkov",
    "psc": "75604",
    "okres": "Vsetín",
    "obec": "Nový Hrozenkov",
    "val": "75604 Novy Hrozenkov Novy Hrozenkov"
  },
  {
    "cast": "Nový Jáchymov",
    "psc": "26703",
    "okres": "Beroun",
    "obec": "Nový Jáchymov",
    "val": "26703 Novy Jachymov Novy Jachymov"
  },
  {
    "cast": "Nový Jičín",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Nový Jičín",
    "val": "74101 Novy Jicin Novy Jicin"
  },
  {
    "cast": "Nový Jimramov",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Nový Jimramov",
    "val": "59242 Novy Jimramov Novy Jimramov"
  },
  {
    "cast": "Nový Jiříkov",
    "psc": "40753",
    "okres": "Děčín",
    "obec": "Jiříkov",
    "val": "40753 Jirikov Novy Jirikov"
  },
  {
    "cast": "Nový Klíčov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Mrákov",
    "val": "34401 Mrakov Novy Klicov"
  },
  {
    "cast": "Nový Knín",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Nový Knín",
    "val": "26203 Novy Knin Novy Knin"
  },
  {
    "cast": "Nový Kostel",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Nový Kostel",
    "val": "35134 Novy Kostel Novy Kostel"
  },
  {
    "cast": "Nový Kostelec",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Novy Kostelec"
  },
  {
    "cast": "Nový Kramolín",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nový Kramolín",
    "val": "34401 Novy Kramolin Novy Kramolin"
  },
  {
    "cast": "Nový Lískovec",
    "psc": "63400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63400 Brno Novy Liskovec"
  },
  {
    "cast": "Nový Luhov",
    "psc": "47129",
    "okres": "Česká Lípa",
    "obec": "Brniště",
    "val": "47129 Brniste Novy Luhov"
  },
  {
    "cast": "Nový Maletín",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Maletín",
    "val": "78901 Maletin Novy Maletin"
  },
  {
    "cast": "Nový Malín",
    "psc": "78803",
    "okres": "Šumperk",
    "obec": "Nový Malín",
    "val": "78803 Novy Malin Novy Malin"
  },
  {
    "cast": "Nový Nemojov",
    "psc": "54461",
    "okres": "Trutnov",
    "obec": "Nemojov",
    "val": "54461 Nemojov Novy Nemojov"
  },
  {
    "cast": "Nový Oldřichov",
    "psc": "47113",
    "okres": "Česká Lípa",
    "obec": "Nový Oldřichov",
    "val": "47113 Novy Oldrichov Novy Oldrichov"
  },
  {
    "cast": "Nový Pařezov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Pařezov",
    "val": "34401 Parezov Novy Parezov"
  },
  {
    "cast": "Nový Petřín",
    "psc": "67106",
    "okres": "Znojmo",
    "obec": "Starý Petřín",
    "val": "67106 Stary Petrin Novy Petrin"
  },
  {
    "cast": "Nový Ples",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Nový Ples",
    "val": "55101 Novy Ples Novy Ples"
  },
  {
    "cast": "Nový Poddvorov",
    "psc": "69616",
    "okres": "Hodonín",
    "obec": "Nový Poddvorov",
    "val": "69616 Novy Poddvorov Novy Poddvorov"
  },
  {
    "cast": "Nový Přerov",
    "psc": "69181",
    "okres": "Břeclav",
    "obec": "Nový Přerov",
    "val": "69181 Novy Prerov Novy Prerov"
  },
  {
    "cast": "Nový Přím",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Dolní Přím",
    "val": "50315 Dolni Prim Novy Prim"
  },
  {
    "cast": "Nový Rokytník",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Novy Rokytnik"
  },
  {
    "cast": "Nový Rychnov",
    "psc": "39404",
    "okres": "Pelhřimov",
    "obec": "Nový Rychnov",
    "val": "39404 Novy Rychnov Novy Rychnov"
  },
  {
    "cast": "Nový Samechov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Řendějov",
    "val": "28522 Rendejov Novy Samechov"
  },
  {
    "cast": "Nový Smrdov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Vyklantice",
    "val": "39501 Vyklantice Novy Smrdov"
  },
  {
    "cast": "Nový Spálenec",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Česká Kubice",
    "val": "34401 Ceska Kubice Novy Spalenec"
  },
  {
    "cast": "Nový Studenec",
    "psc": "58264",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec nad Doubravou",
    "val": "58264 Zdirec nad Doubravou Novy Studenec"
  },
  {
    "cast": "Nový Svět",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Novy Svet"
  },
  {
    "cast": "Nový Svět",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Slatina",
    "val": "74301 Slatina Novy Svet"
  },
  {
    "cast": "Nový Svět",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Dolní Cerekev",
    "val": "58851 Dolni Cerekev Novy Svet"
  },
  {
    "cast": "Nový Svět",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Borová Lada",
    "val": "38501 Borova Lada Novy Svet"
  },
  {
    "cast": "Nový Svět",
    "psc": "51246",
    "okres": "Semily",
    "obec": "Harrachov",
    "val": "51246 Harrachov Novy Svet"
  },
  {
    "cast": "Nový Svět",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "37853 Cesky Rudolec Novy Svet"
  },
  {
    "cast": "Nový Šaldorf (část)",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Nový Šaldorf-Sedlešovice",
    "val": "66902 Novy Saldorf-Sedlesovice Novy Saldorf (cast)"
  },
  {
    "cast": "Nový Šaldorf (část)",
    "psc": "67181",
    "okres": "Znojmo",
    "obec": "Nový Šaldorf-Sedlešovice",
    "val": "67181 Novy Saldorf-Sedlesovice Novy Saldorf (cast)"
  },
  {
    "cast": "Nový Telečkov",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Nový Telečkov",
    "val": "67505 Novy Teleckov Novy Teleckov"
  },
  {
    "cast": "Nový Vestec",
    "psc": "25075",
    "okres": "Praha-východ",
    "obec": "Nový Vestec",
    "val": "25075 Novy Vestec Novy Vestec"
  },
  {
    "cast": "Nový Vojířov",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Novy Vojirov"
  },
  {
    "cast": "Nový Žďár",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As Novy Zdar"
  },
  {
    "cast": "Nučice",
    "psc": "25216",
    "okres": "Praha-západ",
    "obec": "Nučice",
    "val": "25216 Nucice Nucice"
  },
  {
    "cast": "Nučice",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Nučice",
    "val": "28163 Nucice Nucice"
  },
  {
    "cast": "Nučnice",
    "psc": "41148",
    "okres": "Litoměřice",
    "obec": "Křešice",
    "val": "41148 Kresice Nucnice"
  },
  {
    "cast": "Nučničky",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Travčice",
    "val": "41201 Travcice Nucnicky"
  },
  {
    "cast": "Nupaky",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Nupaky",
    "val": "25101 Nupaky Nupaky"
  },
  {
    "cast": "Nusle (část)",
    "psc": "12000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "12000 Praha Nusle (cast)"
  },
  {
    "cast": "Nusle (část)",
    "psc": "14000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14000 Praha Nusle (cast)"
  },
  {
    "cast": "Nusle (část)",
    "psc": "12800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "12800 Praha Nusle (cast)"
  },
  {
    "cast": "Nuzbely",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Radenín",
    "val": "39155 Radenin Nuzbely"
  },
  {
    "cast": "Nuzerov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Nuzerov"
  },
  {
    "cast": "Nuzice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Týn nad Vltavou",
    "val": "37501 Tyn nad Vltavou Nuzice"
  },
  {
    "cast": "Nuzín",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38719 Cestice Nuzin"
  },
  {
    "cast": "Nuzířov",
    "psc": "66603",
    "okres": "Brno-venkov",
    "obec": "Malhostovice",
    "val": "66603 Malhostovice Nuzirov"
  },
  {
    "cast": "Nuzov",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Paseky",
    "val": "39811 Paseky Nuzov"
  },
  {
    "cast": "Nýdek",
    "psc": "73995",
    "okres": "Frýdek-Místek",
    "obec": "Nýdek",
    "val": "73995 Nydek Nydek"
  },
  {
    "cast": "Nyklovice",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Nyklovice",
    "val": "59265 Nyklovice Nyklovice"
  },
  {
    "cast": "Nymburk (část)",
    "psc": "28913",
    "okres": "Nymburk",
    "obec": "Nymburk",
    "val": "28913 Nymburk Nymburk (cast)"
  },
  {
    "cast": "Nymburk (část)",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Nymburk",
    "val": "28802 Nymburk Nymburk (cast)"
  },
  {
    "cast": "Nynice",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Hromnice",
    "val": "33011 Hromnice Nynice"
  },
  {
    "cast": "Nynkov",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Svojšín",
    "val": "34901 Svojsin Nynkov"
  },
  {
    "cast": "Nýrov (část)",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Nýrov",
    "val": "67961 Nyrov Nyrov (cast)"
  },
  {
    "cast": "Nýrov (část)",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Nýrov",
    "val": "67972 Nyrov Nyrov (cast)"
  },
  {
    "cast": "Nýrsko",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Nýrsko",
    "val": "34022 Nyrsko Nyrsko"
  },
  {
    "cast": "Nýřany",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Nýřany",
    "val": "33023 Nyrany Nyrany"
  },
  {
    "cast": "Občov",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Občov",
    "val": "26101 Obcov Obcov"
  },
  {
    "cast": "Obděnice",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Obdenice"
  },
  {
    "cast": "Obecnice",
    "psc": "26221",
    "okres": "Příbram",
    "obec": "Obecnice",
    "val": "26221 Obecnice Obecnice"
  },
  {
    "cast": "Obectov",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Obectov"
  },
  {
    "cast": "Obědkovice",
    "psc": "79823",
    "okres": "Prostějov",
    "obec": "Obědkovice",
    "val": "79823 Obedkovice Obedkovice"
  },
  {
    "cast": "Obědné",
    "psc": "78974",
    "okres": "Šumperk",
    "obec": "Libina",
    "val": "78974 Libina Obedne"
  },
  {
    "cast": "Obědovice",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Obědovice",
    "val": "50351 Obedovice Obedovice"
  },
  {
    "cast": "Obilná",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Odrava",
    "val": "35002 Odrava Obilna"
  },
  {
    "cast": "Oblajovice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Oblajovice"
  },
  {
    "cast": "Oblanov",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Oblanov"
  },
  {
    "cast": "Oblekovice (část)",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "66902 Znojmo Oblekovice (cast)"
  },
  {
    "cast": "Oblekovice (část)",
    "psc": "67181",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "67181 Znojmo Oblekovice (cast)"
  },
  {
    "cast": "Obora",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Obora",
    "val": "44001 Obora Obora"
  },
  {
    "cast": "Obora",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Obora",
    "val": "34701 Obora Obora"
  },
  {
    "cast": "Obora",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Obora"
  },
  {
    "cast": "Obora",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Doksy",
    "val": "47201 Doksy Obora"
  },
  {
    "cast": "Obora",
    "psc": "26723",
    "okres": "Beroun",
    "obec": "Lochovice",
    "val": "26723 Lochovice Obora"
  },
  {
    "cast": "Obora",
    "psc": "33151",
    "okres": "Plzeň-sever",
    "obec": "Obora",
    "val": "33151 Obora Obora"
  },
  {
    "cast": "Obora",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Šindelová",
    "val": "35801 Sindelova Obora"
  },
  {
    "cast": "Obora",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Hracholusky",
    "val": "38411 Hracholusky Obora"
  },
  {
    "cast": "Obora",
    "psc": "67901",
    "okres": "Blansko",
    "obec": "Obora",
    "val": "67901 Obora Obora"
  },
  {
    "cast": "Obora",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Obrubce",
    "val": "29404 Obrubce Obora"
  },
  {
    "cast": "Obora",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Chomutice",
    "val": "50801 Chomutice Obora"
  },
  {
    "cast": "Obora",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37401 Nove Hrady Obora"
  },
  {
    "cast": "Obora u Cerhonic",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Cerhonice",
    "val": "39804 Cerhonice Obora u Cerhonic"
  },
  {
    "cast": "Obora u Radobytec",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39804 Mirotice Obora u Radobytec"
  },
  {
    "cast": "Oborná",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Oborná",
    "val": "79201 Oborna Oborna"
  },
  {
    "cast": "Obory",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Obory",
    "val": "26301 Obory Obory"
  },
  {
    "cast": "Obořice",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Nasavrky",
    "val": "53825 Nasavrky Oborice"
  },
  {
    "cast": "Obořiště",
    "psc": "26212",
    "okres": "Příbram",
    "obec": "Obořiště",
    "val": "26212 Oboriste Oboriste"
  },
  {
    "cast": "Oboz",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nalžovice",
    "val": "26401 Nalzovice Oboz"
  },
  {
    "cast": "Obrataň",
    "psc": "39412",
    "okres": "Pelhřimov",
    "obec": "Obrataň",
    "val": "39412 Obratan Obratan"
  },
  {
    "cast": "Obrátice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Smilovy Hory",
    "val": "39143 Smilovy Hory Obratice"
  },
  {
    "cast": "Obrnice",
    "psc": "43521",
    "okres": "Most",
    "obec": "Obrnice",
    "val": "43521 Obrnice Obrnice"
  },
  {
    "cast": "Obrok",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Tuhaň",
    "val": "47201 Tuhan Obrok"
  },
  {
    "cast": "Obrovice",
    "psc": "43155",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43155 Radonice Obrovice"
  },
  {
    "cast": "Obrubce",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Obrubce",
    "val": "29404 Obrubce Obrubce"
  },
  {
    "cast": "Obruby",
    "psc": "29403",
    "okres": "Mladá Boleslav",
    "obec": "Obruby",
    "val": "29403 Obruby Obruby"
  },
  {
    "cast": "Obrvaň",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Ledeč nad Sázavou",
    "val": "58401 Ledec nad Sazavou Obrvan"
  },
  {
    "cast": "Obřany (část)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Obrany (cast)"
  },
  {
    "cast": "Obřany (část)",
    "psc": "64400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64400 Brno Obrany (cast)"
  },
  {
    "cast": "Obřice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Podsedice",
    "val": "41115 Podsedice Obrice"
  },
  {
    "cast": "Obříství",
    "psc": "27742",
    "okres": "Mělník",
    "obec": "Obříství",
    "val": "27742 Obristvi Obristvi"
  },
  {
    "cast": "Obůrka",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Oburka"
  },
  {
    "cast": "Obyčtov",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Obyčtov",
    "val": "59101 Obyctov Obyctov"
  },
  {
    "cast": "Obytce",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Obytce",
    "val": "33901 Obytce Obytce"
  },
  {
    "cast": "Ocmanice",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Ocmanice",
    "val": "67571 Ocmanice Ocmanice"
  },
  {
    "cast": "Očelice",
    "psc": "51771",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Očelice",
    "val": "51771 Ocelice Ocelice"
  },
  {
    "cast": "Očihov",
    "psc": "43987",
    "okres": "Louny",
    "obec": "Očihov",
    "val": "43987 Ocihov Ocihov"
  },
  {
    "cast": "Očihovec",
    "psc": "43987",
    "okres": "Louny",
    "obec": "Očihov",
    "val": "43987 Ocihov Ocihovec"
  },
  {
    "cast": "Očín",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Horní Kozolupy",
    "val": "34952 Horni Kozolupy Ocin"
  },
  {
    "cast": "Odeř",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Hroznětín",
    "val": "36301 Hroznetin Oder"
  },
  {
    "cast": "Odlezly",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Žihle",
    "val": "33165 Zihle Odlezly"
  },
  {
    "cast": "Odlochovice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Odlochovice"
  },
  {
    "cast": "Odolena Voda",
    "psc": "25070",
    "okres": "Praha-východ",
    "obec": "Odolena Voda",
    "val": "25070 Odolena Voda Odolena Voda"
  },
  {
    "cast": "Odolenov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hrádek",
    "val": "34201 Hradek Odolenov"
  },
  {
    "cast": "Odolenovice",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Krásné Údolí",
    "val": "36401 Krasne Udoli Odolenovice"
  },
  {
    "cast": "Odolenovice",
    "psc": "46833",
    "okres": "Jablonec nad Nisou",
    "obec": "Jenišovice",
    "val": "46833 Jenisovice Odolenovice"
  },
  {
    "cast": "Odolice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Bělušice",
    "val": "43401 Belusice Odolice"
  },
  {
    "cast": "Odolov",
    "psc": "54234",
    "okres": "Trutnov",
    "obec": "Malé Svatoňovice",
    "val": "54234 Male Svatonovice Odolov"
  },
  {
    "cast": "Odranec",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Věcov",
    "val": "59242 Vecov Odranec"
  },
  {
    "cast": "Odrava",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Odrava",
    "val": "35002 Odrava Odrava"
  },
  {
    "cast": "Odrlice",
    "psc": "78322",
    "okres": "Olomouc",
    "obec": "Senice na Hané",
    "val": "78322 Senice na Hane Odrlice"
  },
  {
    "cast": "Odrovice",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Odrovice",
    "val": "66464 Odrovice Odrovice"
  },
  {
    "cast": "Odrůvky",
    "psc": "68308",
    "okres": "Vyškov",
    "obec": "Studnice",
    "val": "68308 Studnice Odruvky"
  },
  {
    "cast": "Odry",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74235 Odry Odry"
  },
  {
    "cast": "Odřepsy",
    "psc": "28907",
    "okres": "Nymburk",
    "obec": "Odřepsy",
    "val": "28907 Odrepsy Odrepsy"
  },
  {
    "cast": "Odunec",
    "psc": "67555",
    "okres": "Třebíč",
    "obec": "Odunec",
    "val": "67555 Odunec Odunec"
  },
  {
    "cast": "Oflenda",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Mrákotín",
    "val": "53901 Mrakotin Oflenda"
  },
  {
    "cast": "Ohař",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Ohar"
  },
  {
    "cast": "Ohaře",
    "psc": "28130",
    "okres": "Kolín",
    "obec": "Ohaře",
    "val": "28130 Ohare Ohare"
  },
  {
    "cast": "Ohařice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Ohařice",
    "val": "50601 Oharice Oharice"
  },
  {
    "cast": "Ohaveč",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Ohaveč",
    "val": "50601 Ohavec Ohavec"
  },
  {
    "cast": "Ohníč",
    "psc": "41765",
    "okres": "Teplice",
    "obec": "Ohníč",
    "val": "41765 Ohnic Ohnic"
  },
  {
    "cast": "Ohnišov (část)",
    "psc": "51784",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Ohnišov",
    "val": "51784 Ohnisov Ohnisov (cast)"
  },
  {
    "cast": "Ohnišov (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Ohnišov",
    "val": "51801 Ohnisov Ohnisov (cast)"
  },
  {
    "cast": "Ohnišťany",
    "psc": "50354",
    "okres": "Hradec Králové",
    "obec": "Ohnišťany",
    "val": "50354 Ohnistany Ohnistany"
  },
  {
    "cast": "Ohnišťovice",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Poběžovice",
    "val": "34522 Pobezovice Ohnistovice"
  },
  {
    "cast": "Ohrada",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Nová Ves I",
    "val": "28002 Nova Ves I Ohrada"
  },
  {
    "cast": "Ohrada",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Bílovec",
    "val": "74301 Bilovec Ohrada"
  },
  {
    "cast": "Ohrada",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Ohrada"
  },
  {
    "cast": "Ohrazení",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Ledenice",
    "val": "37006 Ledenice Ohrazeni"
  },
  {
    "cast": "Ohrazenice",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Ohrazenice",
    "val": "26223 Ohrazenice Ohrazenice"
  },
  {
    "cast": "Ohrazenice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Ohrazenice",
    "val": "51101 Ohrazenice Ohrazenice"
  },
  {
    "cast": "Ohrazenice",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Volenice",
    "val": "38716 Volenice Ohrazenice"
  },
  {
    "cast": "Ohrazenice",
    "psc": "53353",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53353 Pardubice Ohrazenice"
  },
  {
    "cast": "Ohrazenice",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Jaroměřice nad Rokytnou",
    "val": "67551 Jaromerice nad Rokytnou Ohrazenice"
  },
  {
    "cast": "Ohrazeníčko (část)",
    "psc": "37311",
    "okres": "České Budějovice",
    "obec": "Ledenice",
    "val": "37311 Ledenice Ohrazenicko (cast)"
  },
  {
    "cast": "Ohrazeníčko (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Ledenice",
    "val": "37006 Ledenice Ohrazenicko (cast)"
  },
  {
    "cast": "Ohrobec (část)",
    "psc": "25245",
    "okres": "Praha-západ",
    "obec": "Ohrobec",
    "val": "25245 Ohrobec Ohrobec (cast)"
  },
  {
    "cast": "Ohrobec (část)",
    "psc": "25246",
    "okres": "Praha-západ",
    "obec": "Ohrobec",
    "val": "25246 Ohrobec Ohrobec (cast)"
  },
  {
    "cast": "Ohrozim",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Ohrozim",
    "val": "79803 Ohrozim Ohrozim"
  },
  {
    "cast": "Ohučov",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Staňkov",
    "val": "34561 Stankov Ohucov"
  },
  {
    "cast": "Ochoz",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Ochoz",
    "val": "79852 Ochoz Ochoz"
  },
  {
    "cast": "Ochoz",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Nasavrky",
    "val": "53825 Nasavrky Ochoz"
  },
  {
    "cast": "Ochoz u Brna (část)",
    "psc": "66402",
    "okres": "Brno-venkov",
    "obec": "Ochoz u Brna",
    "val": "66402 Ochoz u Brna Ochoz u Brna (cast)"
  },
  {
    "cast": "Ochoz u Brna (část)",
    "psc": "66401",
    "okres": "Brno-venkov",
    "obec": "Ochoz u Brna",
    "val": "66401 Ochoz u Brna Ochoz u Brna (cast)"
  },
  {
    "cast": "Ochoz u Tišnova",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Ochoz u Tišnova",
    "val": "67923 Ochoz u Tisnova Ochoz u Tisnova"
  },
  {
    "cast": "Okarec",
    "psc": "67502",
    "okres": "Třebíč",
    "obec": "Okarec",
    "val": "67502 Okarec Okarec"
  },
  {
    "cast": "Okluky",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Malé Hradisko",
    "val": "79803 Male Hradisko Okluky"
  },
  {
    "cast": "Okna",
    "psc": "47162",
    "okres": "Česká Lípa",
    "obec": "Okna",
    "val": "47162 Okna Okna"
  },
  {
    "cast": "Okna",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Polepy",
    "val": "41201 Polepy Okna"
  },
  {
    "cast": "Okoř",
    "psc": "25264",
    "okres": "Praha-západ",
    "obec": "Okoř",
    "val": "25264 Okor Okor"
  },
  {
    "cast": "Okořín",
    "psc": "43114",
    "okres": "Chomutov",
    "obec": "Strupčice",
    "val": "43114 Strupcice Okorin"
  },
  {
    "cast": "Okounov",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Okounov",
    "val": "43151 Okounov Okounov"
  },
  {
    "cast": "Okrašovice",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Slavičky",
    "val": "67501 Slavicky Okrasovice"
  },
  {
    "cast": "Okrouhlá",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Okrouhlá",
    "val": "35002 Okrouhla Okrouhla"
  },
  {
    "cast": "Okrouhlá",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Okrouhlá",
    "val": "47301 Okrouhla Okrouhla"
  },
  {
    "cast": "Okrouhlá",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Okrouhlá",
    "val": "39843 Okrouhla Okrouhla"
  },
  {
    "cast": "Okrouhlá Radouň",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Okrouhlá Radouň",
    "val": "37842 Okrouhla Radoun Okrouhla Radoun"
  },
  {
    "cast": "Okrouhlá (část)",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Okrouhlá",
    "val": "68001 Okrouhla Okrouhla (cast)"
  },
  {
    "cast": "Okrouhlá (část)",
    "psc": "67953",
    "okres": "Blansko",
    "obec": "Okrouhlá",
    "val": "67953 Okrouhla Okrouhla (cast)"
  },
  {
    "cast": "Okrouhlé Hradiště",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Konstantinovy Lázně",
    "val": "34952 Konstantinovy Lazne Okrouhle Hradiste"
  },
  {
    "cast": "Okrouhlice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Okrouhlice"
  },
  {
    "cast": "Okrouhlice",
    "psc": "58231",
    "okres": "Havlíčkův Brod",
    "obec": "Okrouhlice",
    "val": "58231 Okrouhlice Okrouhlice"
  },
  {
    "cast": "Okrouhlička",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Okrouhlička",
    "val": "58253 Okrouhlicka Okrouhlicka"
  },
  {
    "cast": "Okrouhlo",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Okrouhlo",
    "val": "25401 Okrouhlo Okrouhlo"
  },
  {
    "cast": "Okřesaneč",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Okřesaneč",
    "val": "28601 Okresanec Okresanec"
  },
  {
    "cast": "Okřešice",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Okřešice",
    "val": "67401 Okresice Okresice"
  },
  {
    "cast": "Okřešice",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Okresice"
  },
  {
    "cast": "Okřínek",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Okřínek",
    "val": "29001 Okrinek Okrinek"
  },
  {
    "cast": "Okříšky",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Okříšky",
    "val": "67521 Okrisky Okrisky"
  },
  {
    "cast": "Olbramice",
    "psc": "78322",
    "okres": "Olomouc",
    "obec": "Olbramice",
    "val": "78322 Olbramice Olbramice"
  },
  {
    "cast": "Olbramice (část)",
    "psc": "74301",
    "okres": "Ostrava-město",
    "obec": "Olbramice",
    "val": "74301 Olbramice Olbramice (cast)"
  },
  {
    "cast": "Olbramice (část)",
    "psc": "74283",
    "okres": "Ostrava-město",
    "obec": "Olbramice",
    "val": "74283 Olbramice Olbramice (cast)"
  },
  {
    "cast": "Olbramkostel",
    "psc": "67151",
    "okres": "Znojmo",
    "obec": "Olbramkostel",
    "val": "67151 Olbramkostel Olbramkostel"
  },
  {
    "cast": "Olbramov",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Olbramov",
    "val": "34901 Olbramov Olbramov"
  },
  {
    "cast": "Olbramov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Olbramov"
  },
  {
    "cast": "Olbramovice Městečko",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25901 Olbramovice Olbramovice Mestecko"
  },
  {
    "cast": "Olbramovice Ves",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25901 Olbramovice Olbramovice Ves"
  },
  {
    "cast": "Olbramovice (část)",
    "psc": "67175",
    "okres": "Znojmo",
    "obec": "Olbramovice",
    "val": "67175 Olbramovice Olbramovice (cast)"
  },
  {
    "cast": "Olbramovice (část)",
    "psc": "67176",
    "okres": "Znojmo",
    "obec": "Olbramovice",
    "val": "67176 Olbramovice Olbramovice (cast)"
  },
  {
    "cast": "Oldřetice",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Raná",
    "val": "53901 Rana Oldretice"
  },
  {
    "cast": "Oldřichov",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dobev",
    "val": "39701 Dobev Oldrichov"
  },
  {
    "cast": "Oldřichov",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Oldrichov"
  },
  {
    "cast": "Oldřichov",
    "psc": "41724",
    "okres": "Teplice",
    "obec": "Jeníkov",
    "val": "41724 Jenikov Oldrichov"
  },
  {
    "cast": "Oldřichov",
    "psc": "75111",
    "okres": "Přerov",
    "obec": "Oldřichov",
    "val": "75111 Oldrichov Oldrichov"
  },
  {
    "cast": "Oldřichov",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36221 Nejdek Oldrichov"
  },
  {
    "cast": "Oldřichov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Oldřichov",
    "val": "39143 Oldrichov Oldrichov"
  },
  {
    "cast": "Oldřichov na Hranicích",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Oldrichov na Hranicich"
  },
  {
    "cast": "Oldřichov v Hájích",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Oldřichov v Hájích",
    "val": "46331 Oldrichov v Hajich Oldrichov v Hajich"
  },
  {
    "cast": "Oldřichovec",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Smilkov",
    "val": "25786 Smilkov Oldrichovec"
  },
  {
    "cast": "Oldřichovice",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34022 Desenice Oldrichovice"
  },
  {
    "cast": "Oldřichovice",
    "psc": "76361",
    "okres": "Zlín",
    "obec": "Oldřichovice",
    "val": "76361 Oldrichovice Oldrichovice"
  },
  {
    "cast": "Oldřichovice",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Oldrichovice"
  },
  {
    "cast": "Oldřichovice (část)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56201 Usti nad Orlici Oldrichovice (cast)"
  },
  {
    "cast": "Oldřichovice (část)",
    "psc": "56206",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56206 Usti nad Orlici Oldrichovice (cast)"
  },
  {
    "cast": "Oldřiš",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Krouna",
    "val": "53901 Krouna Oldris"
  },
  {
    "cast": "Oldřiš",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Merklín",
    "val": "36301 Merklin Oldris"
  },
  {
    "cast": "Oldřiš",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Blažejov",
    "val": "37701 Blazejov Oldris"
  },
  {
    "cast": "Oldřiš (část)",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Oldřiš",
    "val": "57201 Oldris Oldris (cast)"
  },
  {
    "cast": "Oldřiš (část)",
    "psc": "56982",
    "okres": "Svitavy",
    "obec": "Oldřiš",
    "val": "56982 Oldris Oldris (cast)"
  },
  {
    "cast": "Oldřišov",
    "psc": "74733",
    "okres": "Opava",
    "obec": "Oldřišov",
    "val": "74733 Oldrisov Oldrisov"
  },
  {
    "cast": "Oleksovice",
    "psc": "67162",
    "okres": "Znojmo",
    "obec": "Oleksovice",
    "val": "67162 Oleksovice Oleksovice"
  },
  {
    "cast": "Oleksovičky",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Slup",
    "val": "67128 Slup Oleksovicky"
  },
  {
    "cast": "Olešenka",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Olešenka",
    "val": "58222 Olesenka Olesenka"
  },
  {
    "cast": "Olešínky",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Zvole",
    "val": "59251 Zvole Olesinky"
  },
  {
    "cast": "Oleška",
    "psc": "28162",
    "okres": "Praha-východ",
    "obec": "Oleška",
    "val": "28162 Oleska Oleska"
  },
  {
    "cast": "Oleško",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Oleško",
    "val": "41201 Olesko Olesko"
  },
  {
    "cast": "Oleško",
    "psc": "25245",
    "okres": "Praha-západ",
    "obec": "Březová-Oleško",
    "val": "25245 Brezova-Olesko Olesko"
  },
  {
    "cast": "Olešky",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Radějovice",
    "val": "25168 Radejovice Olesky"
  },
  {
    "cast": "Olešná",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Olešná",
    "val": "26901 Olesna Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Němčovice",
    "val": "33824 Nemcovice Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Olešná",
    "val": "39301 Olesna Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "26764",
    "okres": "Beroun",
    "obec": "Olešná",
    "val": "26764 Olesna Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "33204",
    "okres": "Plzeň-město",
    "obec": "Nezvěstice",
    "val": "33204 Nezvestice Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Olešná",
    "val": "39843 Olesna Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kozlov",
    "val": "58401 Kozlov Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Podlesí",
    "val": "56201 Podlesi Olesna"
  },
  {
    "cast": "Olešná",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Olesna"
  },
  {
    "cast": "Olešná (část)",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Olešná",
    "val": "58001 Olesna Olesna (cast)"
  },
  {
    "cast": "Olešná (část)",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Olešná",
    "val": "58291 Olesna Olesna (cast)"
  },
  {
    "cast": "Olešná (část)",
    "psc": "58241",
    "okres": "Havlíčkův Brod",
    "obec": "Olešná",
    "val": "58241 Olesna Olesna (cast)"
  },
  {
    "cast": "Olešnice",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Olesnice"
  },
  {
    "cast": "Olešnice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Olešnice",
    "val": "51101 Olesnice Olesnice"
  },
  {
    "cast": "Olešnice",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Olešnice",
    "val": "67974 Olesnice Olesnice"
  },
  {
    "cast": "Olešnice",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Červený Kostelec",
    "val": "54941 Cerveny Kostelec Olesnice"
  },
  {
    "cast": "Olešnice",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Okrouhlice",
    "val": "58001 Okrouhlice Olesnice"
  },
  {
    "cast": "Olešnice",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Olešnice",
    "val": "50351 Olesnice Olesnice"
  },
  {
    "cast": "Olešnice",
    "psc": "40322",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40322 Usti nad Labem Olesnice"
  },
  {
    "cast": "Olešnice",
    "psc": "37331",
    "okres": "České Budějovice",
    "obec": "Olešnice",
    "val": "37331 Olesnice Olesnice"
  },
  {
    "cast": "Olešnice",
    "psc": "51736",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Olešnice",
    "val": "51736 Olesnice Olesnice"
  },
  {
    "cast": "Olešnice v Orlických horách (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Olešnice v Orlických horách",
    "val": "51801 Olesnice v Orlickych horach Olesnice v Orlickych horach (cast)"
  },
  {
    "cast": "Olešnice v Orlických horách (část)",
    "psc": "51783",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Olešnice v Orlických horách",
    "val": "51783 Olesnice v Orlickych horach Olesnice v Orlickych horach (cast)"
  },
  {
    "cast": "Olešník",
    "psc": "37350",
    "okres": "České Budějovice",
    "obec": "Olešník",
    "val": "37350 Olesnik Olesnik"
  },
  {
    "cast": "Olešno",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Olesno"
  },
  {
    "cast": "Olešovice",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Úterý",
    "val": "33041 Utery Olesovice"
  },
  {
    "cast": "Olešovice",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Olesovice"
  },
  {
    "cast": "Olivětín",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Broumov",
    "val": "55001 Broumov Olivetin"
  },
  {
    "cast": "Olomouc",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Olomouc"
  },
  {
    "cast": "Olomučany (část)",
    "psc": "67904",
    "okres": "Blansko",
    "obec": "Olomučany",
    "val": "67904 Olomucany Olomucany (cast)"
  },
  {
    "cast": "Olomučany (část)",
    "psc": "67903",
    "okres": "Blansko",
    "obec": "Olomučany",
    "val": "67903 Olomucany Olomucany (cast)"
  },
  {
    "cast": "Oloví",
    "psc": "35707",
    "okres": "Sokolov",
    "obec": "Oloví",
    "val": "35707 Olovi Olovi"
  },
  {
    "cast": "Olovnice (část)",
    "psc": "27326",
    "okres": "Mělník",
    "obec": "Olovnice",
    "val": "27326 Olovnice Olovnice (cast)"
  },
  {
    "cast": "Olovnice (část)",
    "psc": "27325",
    "okres": "Mělník",
    "obec": "Olovnice",
    "val": "27325 Olovnice Olovnice (cast)"
  },
  {
    "cast": "Olšany",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Olšany",
    "val": "58856 Olsany Olsany"
  },
  {
    "cast": "Olšany",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Kluky",
    "val": "28601 Kluky Olsany"
  },
  {
    "cast": "Olšany",
    "psc": "27341",
    "okres": "Kladno",
    "obec": "Brandýsek",
    "val": "27341 Brandysek Olsany"
  },
  {
    "cast": "Olšany",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Olšany",
    "val": "34101 Olsany Olsany"
  },
  {
    "cast": "Olšany",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Olšany",
    "val": "68301 Olsany Olsany"
  },
  {
    "cast": "Olšany",
    "psc": "78962",
    "okres": "Šumperk",
    "obec": "Olšany",
    "val": "78962 Olsany Olsany"
  },
  {
    "cast": "Olšany",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Olsany"
  },
  {
    "cast": "Olšany u Prostějova",
    "psc": "79814",
    "okres": "Prostějov",
    "obec": "Olšany u Prostějova",
    "val": "79814 Olsany u Prostejova Olsany u Prostejova"
  },
  {
    "cast": "Olší",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Olší",
    "val": "58856 Olsi Olsi"
  },
  {
    "cast": "Olší",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Opařany",
    "val": "39161 Oparany Olsi"
  },
  {
    "cast": "Olší",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Olší",
    "val": "59261 Olsi Olsi"
  },
  {
    "cast": "Olší nad Oslavou",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Meziříčí",
    "val": "59401 Velke Mezirici Olsi nad Oslavou"
  },
  {
    "cast": "Olšina",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Horní Planá",
    "val": "38226 Horni Plana Olsina"
  },
  {
    "cast": "Olšina",
    "psc": "38229",
    "okres": "Český Krumlov",
    "obec": "Polná na Šumavě",
    "val": "38229 Polna na Sumave Olsina"
  },
  {
    "cast": "Olšina",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29411 Mnichovo Hradiste Olsina"
  },
  {
    "cast": "Olšová Vrata",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36001 Karlovy Vary Olsova Vrata"
  },
  {
    "cast": "Olšovec",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Olšovec",
    "val": "75301 Olsovec Olsovec"
  },
  {
    "cast": "Olšovice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Olšovice",
    "val": "38411 Olsovice Olsovice"
  },
  {
    "cast": "Oltyně",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Opařany",
    "val": "39161 Oparany Oltyne"
  },
  {
    "cast": "Omice (část)",
    "psc": "66417",
    "okres": "Brno-venkov",
    "obec": "Omice",
    "val": "66417 Omice Omice (cast)"
  },
  {
    "cast": "Omice (část)",
    "psc": "66441",
    "okres": "Brno-venkov",
    "obec": "Omice",
    "val": "66441 Omice Omice (cast)"
  },
  {
    "cast": "Omice (část)",
    "psc": "66501",
    "okres": "Brno-venkov",
    "obec": "Omice",
    "val": "66501 Omice Omice (cast)"
  },
  {
    "cast": "Omlenice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Omlenice",
    "val": "38241 Omlenice Omlenice"
  },
  {
    "cast": "Omlenička",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Omlenice",
    "val": "38241 Omlenice Omlenicka"
  },
  {
    "cast": "Ondrášov",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Moravský Beroun",
    "val": "79305 Moravsky Beroun Ondrasov"
  },
  {
    "cast": "Ondratice",
    "psc": "79807",
    "okres": "Prostějov",
    "obec": "Ondratice",
    "val": "79807 Ondratice Ondratice"
  },
  {
    "cast": "Ondrušky",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Březí",
    "val": "59453 Brezi Ondrusky"
  },
  {
    "cast": "Ondřejov",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Pláně",
    "val": "33101 Plane Ondrejov"
  },
  {
    "cast": "Ondřejov",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Rýmařov",
    "val": "79501 Rymarov Ondrejov"
  },
  {
    "cast": "Ondřejov",
    "psc": "43163",
    "okres": "Chomutov",
    "obec": "Perštejn",
    "val": "43163 Perstejn Ondrejov"
  },
  {
    "cast": "Ondřejov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Ondřejov",
    "val": "39301 Ondrejov Ondrejov"
  },
  {
    "cast": "Ondřejov",
    "psc": "25165",
    "okres": "Praha-východ",
    "obec": "Ondřejov",
    "val": "25165 Ondrejov Ondrejov"
  },
  {
    "cast": "Ondřejovec",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Ondrejovec"
  },
  {
    "cast": "Ondřejovice",
    "psc": "79376",
    "okres": "Jeseník",
    "obec": "Zlaté Hory",
    "val": "79376 Zlate Hory Ondrejovice"
  },
  {
    "cast": "Ondřejovice",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Ondrejovice"
  },
  {
    "cast": "Ondříkovice",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Ondrikovice"
  },
  {
    "cast": "Onen Svět",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Onen Svet"
  },
  {
    "cast": "Onen Svět",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Onen Svet"
  },
  {
    "cast": "Onomyšl",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Onomyšl",
    "val": "28504 Onomysl Onomysl"
  },
  {
    "cast": "Onšov",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Onšov",
    "val": "67102 Onsov Onsov"
  },
  {
    "cast": "Onšov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Onšov",
    "val": "39501 Onsov Onsov"
  },
  {
    "cast": "Onšovec",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Horka II",
    "val": "28522 Horka II Onsovec"
  },
  {
    "cast": "Onšovice",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Čkyně",
    "val": "38481 Ckyne Onsovice"
  },
  {
    "cast": "Onšovice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Radošovice",
    "val": "25726 Radosovice Onsovice"
  },
  {
    "cast": "Onšovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Dehtáře",
    "val": "39301 Dehtare Onsovice"
  },
  {
    "cast": "Opalice",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Opalice"
  },
  {
    "cast": "Opálka",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Opalka"
  },
  {
    "cast": "Oparno",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41002 Velemin Oparno"
  },
  {
    "cast": "Opařany",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Opařany",
    "val": "39161 Oparany Oparany"
  },
  {
    "cast": "Opatov",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Luby",
    "val": "35134 Luby Opatov"
  },
  {
    "cast": "Opatov",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Opatov",
    "val": "58805 Opatov Opatov"
  },
  {
    "cast": "Opatov",
    "psc": "67528",
    "okres": "Třebíč",
    "obec": "Opatov",
    "val": "67528 Opatov Opatov"
  },
  {
    "cast": "Opatov",
    "psc": "56912",
    "okres": "Svitavy",
    "obec": "Opatov",
    "val": "56912 Opatov Opatov"
  },
  {
    "cast": "Opatovec",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Opatovec",
    "val": "56802 Opatovec Opatovec"
  },
  {
    "cast": "Opatovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Opatovice"
  },
  {
    "cast": "Opatovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Zbýšov",
    "val": "28601 Zbysov Opatovice"
  },
  {
    "cast": "Opatovice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Červené Pečky",
    "val": "28002 Cervene Pecky Opatovice"
  },
  {
    "cast": "Opatovice",
    "psc": "66461",
    "okres": "Brno-venkov",
    "obec": "Opatovice",
    "val": "66461 Opatovice Opatovice"
  },
  {
    "cast": "Opatovice",
    "psc": "75356",
    "okres": "Přerov",
    "obec": "Opatovice",
    "val": "75356 Opatovice Opatovice"
  },
  {
    "cast": "Opatovice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hrdějovice",
    "val": "37341 Hrdejovice Opatovice"
  },
  {
    "cast": "Opatovice",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Opatovice"
  },
  {
    "cast": "Opatovice I",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Opatovice I",
    "val": "28601 Opatovice I Opatovice I"
  },
  {
    "cast": "Opatovice II",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Uhlířské Janovice",
    "val": "28504 Uhlirske Janovice Opatovice II"
  },
  {
    "cast": "Opatovice nad Labem (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Opatovice nad Labem",
    "val": "53002 Opatovice nad Labem Opatovice nad Labem (cast)"
  },
  {
    "cast": "Opatovice nad Labem (část)",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Opatovice nad Labem",
    "val": "53345 Opatovice nad Labem Opatovice nad Labem (cast)"
  },
  {
    "cast": "Opavice",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Opavice"
  },
  {
    "cast": "Oplany",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Oplany",
    "val": "28163 Oplany Oplany"
  },
  {
    "cast": "Oplocany",
    "psc": "75101",
    "okres": "Přerov",
    "obec": "Oplocany",
    "val": "75101 Oplocany Oplocany"
  },
  {
    "cast": "Oplot",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Oplot",
    "val": "33401 Oplot Oplot"
  },
  {
    "cast": "Oplotec",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34525 Horsovsky Tyn Oplotec"
  },
  {
    "cast": "Oploty",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "43801 Podborany Oploty"
  },
  {
    "cast": "Opočínek",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Opocinek"
  },
  {
    "cast": "Opočnice",
    "psc": "28904",
    "okres": "Nymburk",
    "obec": "Opočnice",
    "val": "28904 Opocnice Opocnice"
  },
  {
    "cast": "Opočno",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Opočno",
    "val": "44001 Opocno Opocno"
  },
  {
    "cast": "Opočno",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Trusnov",
    "val": "53401 Trusnov Opocno"
  },
  {
    "cast": "Opočno (část)",
    "psc": "51773",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Opočno",
    "val": "51773 Opocno Opocno (cast)"
  },
  {
    "cast": "Opočno (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Opočno",
    "val": "51801 Opocno Opocno (cast)"
  },
  {
    "cast": "Opolánky",
    "psc": "28906",
    "okres": "Nymburk",
    "obec": "Opolany",
    "val": "28906 Opolany Opolanky"
  },
  {
    "cast": "Opolany",
    "psc": "28907",
    "okres": "Nymburk",
    "obec": "Opolany",
    "val": "28907 Opolany Opolany"
  },
  {
    "cast": "Opolenec",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Opolenec"
  },
  {
    "cast": "Oponešice",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Oponešice",
    "val": "67532 Oponesice Oponesice"
  },
  {
    "cast": "Oprechtice",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Zahořany",
    "val": "34506 Zahorany Oprechtice"
  },
  {
    "cast": "Oprechtice",
    "psc": "73921",
    "okres": "Frýdek-Místek",
    "obec": "Paskov",
    "val": "73921 Paskov Oprechtice"
  },
  {
    "cast": "Oprostovice",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Oprostovice",
    "val": "75354 Oprostovice Oprostovice"
  },
  {
    "cast": "Opřetice",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Opretice"
  },
  {
    "cast": "Oráčov (část)",
    "psc": "27032",
    "okres": "Rakovník",
    "obec": "Oráčov",
    "val": "27032 Oracov Oracov (cast)"
  },
  {
    "cast": "Oráčov (část)",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Oráčov",
    "val": "27033 Oracov Oracov (cast)"
  },
  {
    "cast": "Orasice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Počedělice",
    "val": "44001 Pocedelice Orasice"
  },
  {
    "cast": "Orasín",
    "psc": "43121",
    "okres": "Chomutov",
    "obec": "Boleboř",
    "val": "43121 Bolebor Orasin"
  },
  {
    "cast": "Orel",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Orel",
    "val": "53821 Orel Orel"
  },
  {
    "cast": "Orlice",
    "psc": "56151",
    "okres": "Ústí nad Orlicí",
    "obec": "Letohrad",
    "val": "56151 Letohrad Orlice"
  },
  {
    "cast": "Orlické Podhůří-Dobrá Voda x)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Orlicke Podhuri-Dobra Voda x)"
  },
  {
    "cast": "Orlické Podhůří-Kaliště x)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Orlicke Podhuri-Kaliste x)"
  },
  {
    "cast": "Orlické Podhůří-Perná x)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Orlicke Podhuri-Perna x)"
  },
  {
    "cast": "Orlické Podhůří-Rozsocha x)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Orlicke Podhuri-Rozsocha x)"
  },
  {
    "cast": "Orlické Podhůří-Rviště x)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Orlicke Podhuri-Rviste x)"
  },
  {
    "cast": "Orlické Podhůří-Říčky x)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Orlicke Podhuri-Ricky x)"
  },
  {
    "cast": "Orlické Záhoří",
    "psc": "51764",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Orlické Záhoří",
    "val": "51764 Orlicke Zahori Orlicke Zahori"
  },
  {
    "cast": "Orličky",
    "psc": "56155",
    "okres": "Ústí nad Orlicí",
    "obec": "Orličky",
    "val": "56155 Orlicky Orlicky"
  },
  {
    "cast": "Orlík",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Sudislav nad Orlicí",
    "val": "56201 Sudislav nad Orlici Orlik"
  },
  {
    "cast": "Orlík nad Vltavou",
    "psc": "39807",
    "okres": "Písek",
    "obec": "Orlík nad Vltavou",
    "val": "39807 Orlik nad Vltavou Orlik nad Vltavou"
  },
  {
    "cast": "Orlov",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Orlov"
  },
  {
    "cast": "Orlov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Orlov"
  },
  {
    "cast": "Orlov",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vračovice-Orlov",
    "val": "56601 Vracovice-Orlov Orlov"
  },
  {
    "cast": "Orlovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Orlovice",
    "val": "68201 Orlovice Orlovice"
  },
  {
    "cast": "Orlovice",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Pocinovice",
    "val": "34506 Pocinovice Orlovice"
  },
  {
    "cast": "Ořech",
    "psc": "25225",
    "okres": "Praha-západ",
    "obec": "Ořech",
    "val": "25225 Orech Orech"
  },
  {
    "cast": "Ořechov",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Ořechov",
    "val": "58862 Orechov Orechov"
  },
  {
    "cast": "Ořechov",
    "psc": "66444",
    "okres": "Brno-venkov",
    "obec": "Ořechov",
    "val": "66444 Orechov Orechov"
  },
  {
    "cast": "Ořechov",
    "psc": "68737",
    "okres": "Uherské Hradiště",
    "obec": "Ořechov",
    "val": "68737 Orechov Orechov"
  },
  {
    "cast": "Ořechov",
    "psc": "59452",
    "okres": "Žďár nad Sázavou",
    "obec": "Ořechov",
    "val": "59452 Orechov Orechov"
  },
  {
    "cast": "Ořešín",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Oresin"
  },
  {
    "cast": "Oříkov",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Orikov"
  },
  {
    "cast": "Oseč",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Obecnice",
    "val": "26101 Obecnice Osec"
  },
  {
    "cast": "Osečany",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Osečany",
    "val": "26401 Osecany Osecany"
  },
  {
    "cast": "Oseček",
    "psc": "28941",
    "okres": "Nymburk",
    "obec": "Oseček",
    "val": "28941 Osecek Osecek"
  },
  {
    "cast": "Osečná",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Osečná",
    "val": "46352 Osecna Osecna"
  },
  {
    "cast": "Osečnice",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Osečnice",
    "val": "51703 Osecnice Osecnice"
  },
  {
    "cast": "Osek",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Osek",
    "val": "39901 Osek Osek"
  },
  {
    "cast": "Osek",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Řenče",
    "val": "33401 Rence Osek"
  },
  {
    "cast": "Osek",
    "psc": "33821",
    "okres": "Rokycany",
    "obec": "Osek",
    "val": "33821 Osek Osek"
  },
  {
    "cast": "Osek",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Osek",
    "val": "38601 Osek Osek"
  },
  {
    "cast": "Osek",
    "psc": "41705",
    "okres": "Teplice",
    "obec": "Osek",
    "val": "41705 Osek Osek"
  },
  {
    "cast": "Osek",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Osek",
    "val": "26762 Osek Osek"
  },
  {
    "cast": "Osek nad Bečvou",
    "psc": "75122",
    "okres": "Přerov",
    "obec": "Osek nad Bečvou",
    "val": "75122 Osek nad Becvou Osek nad Becvou"
  },
  {
    "cast": "Osek (část)",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Osek",
    "val": "50743 Osek Osek (cast)"
  },
  {
    "cast": "Osek (část)",
    "psc": "29404",
    "okres": "Jičín",
    "obec": "Osek",
    "val": "29404 Osek Osek (cast)"
  },
  {
    "cast": "Osek (část)",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Kněžice",
    "val": "28903 Knezice Osek (cast)"
  },
  {
    "cast": "Osek (část)",
    "psc": "28902",
    "okres": "Nymburk",
    "obec": "Kněžice",
    "val": "28902 Knezice Osek (cast)"
  },
  {
    "cast": "Oseky",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Oseky"
  },
  {
    "cast": "Oselce",
    "psc": "33546",
    "okres": "Plzeň-jih",
    "obec": "Oselce",
    "val": "33546 Oselce Oselce"
  },
  {
    "cast": "Osenice",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Dětenice",
    "val": "50723 Detenice Osenice"
  },
  {
    "cast": "Osice",
    "psc": "50326",
    "okres": "Hradec Králové",
    "obec": "Osice",
    "val": "50326 Osice Osice"
  },
  {
    "cast": "Osíčany",
    "psc": "79829",
    "okres": "Prostějov",
    "obec": "Koválovice-Osíčany",
    "val": "79829 Kovalovice-Osicany Osicany"
  },
  {
    "cast": "Osíčko",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Osíčko",
    "val": "76861 Osicko Osicko"
  },
  {
    "cast": "Osičky",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Osičky",
    "val": "50327 Osicky Osicky"
  },
  {
    "cast": "Osík (část)",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Osík",
    "val": "57001 Osik Osik (cast)"
  },
  {
    "cast": "Osík (část)",
    "psc": "56967",
    "okres": "Svitavy",
    "obec": "Osík",
    "val": "56967 Osik Osik (cast)"
  },
  {
    "cast": "Osikov",
    "psc": "78701",
    "okres": "Šumperk",
    "obec": "Bratrušov",
    "val": "78701 Bratrusov Osikov"
  },
  {
    "cast": "Osikovec",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Vodice",
    "val": "39155 Vodice Osikovec"
  },
  {
    "cast": "Osiky",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Osiky",
    "val": "67923 Osiky Osiky"
  },
  {
    "cast": "Osinalice",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Medonosy",
    "val": "27721 Medonosy Osinalice"
  },
  {
    "cast": "Osinaličky",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Medonosy",
    "val": "27721 Medonosy Osinalicky"
  },
  {
    "cast": "Oskava",
    "psc": "78801",
    "okres": "Šumperk",
    "obec": "Oskava",
    "val": "78801 Oskava Oskava"
  },
  {
    "cast": "Oskořínek",
    "psc": "28932",
    "okres": "Nymburk",
    "obec": "Oskořínek",
    "val": "28932 Oskorinek Oskorinek"
  },
  {
    "cast": "Oslava",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Dolní Heřmanice",
    "val": "59401 Dolni Hermanice Oslava"
  },
  {
    "cast": "Oslavany (část)",
    "psc": "66412",
    "okres": "Brno-venkov",
    "obec": "Oslavany",
    "val": "66412 Oslavany Oslavany (cast)"
  },
  {
    "cast": "Oslavany (část)",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Oslavany",
    "val": "66491 Oslavany Oslavany (cast)"
  },
  {
    "cast": "Oslavice",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Oslavice",
    "val": "59401 Oslavice Oslavice"
  },
  {
    "cast": "Oslavička",
    "psc": "67505",
    "okres": "Žďár nad Sázavou",
    "obec": "Oslavička",
    "val": "67505 Oslavicka Oslavicka"
  },
  {
    "cast": "Osletín",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Zhoř",
    "val": "39901 Zhor Osletin"
  },
  {
    "cast": "Oslí",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Chrást",
    "val": "26242 Chrast Osli"
  },
  {
    "cast": "Oslnovice",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Oslnovice",
    "val": "67107 Oslnovice Oslnovice"
  },
  {
    "cast": "Oslov",
    "psc": "39835",
    "okres": "Písek",
    "obec": "Oslov",
    "val": "39835 Oslov Oslov"
  },
  {
    "cast": "Oslovice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Holany",
    "val": "47002 Holany Oslovice"
  },
  {
    "cast": "Oslovice",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Okounov",
    "val": "43151 Okounov Oslovice"
  },
  {
    "cast": "Osluchov",
    "psc": "27325",
    "okres": "Kladno",
    "obec": "Žižice",
    "val": "27325 Zizice Osluchov"
  },
  {
    "cast": "Osnice",
    "psc": "25242",
    "okres": "Praha-západ",
    "obec": "Jesenice",
    "val": "25242 Jesenice Osnice"
  },
  {
    "cast": "Osoblaha",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Osoblaha",
    "val": "79399 Osoblaha Osoblaha"
  },
  {
    "cast": "Osobovy",
    "psc": "33501",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "33501 Mecin Osobovy"
  },
  {
    "cast": "Osov",
    "psc": "26725",
    "okres": "Beroun",
    "obec": "Osov",
    "val": "26725 Osov Osov"
  },
  {
    "cast": "Osová",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Osová Bítýška",
    "val": "59453 Osova Bityska Osova"
  },
  {
    "cast": "Osová Bítýška",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Osová Bítýška",
    "val": "59453 Osova Bityska Osova Bityska"
  },
  {
    "cast": "Osové",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Osové",
    "val": "59401 Osove Osove"
  },
  {
    "cast": "Osovec",
    "psc": "26725",
    "okres": "Beroun",
    "obec": "Osov",
    "val": "26725 Osov Osovec"
  },
  {
    "cast": "Ospělov",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Ludmírov",
    "val": "79855 Ludmirov Ospelov"
  },
  {
    "cast": "Ostašov",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Ostašov",
    "val": "67552 Ostasov Ostasov"
  },
  {
    "cast": "Ostašov",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Staňkovice",
    "val": "28504 Stankovice Ostasov"
  },
  {
    "cast": "Ostašovice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lično",
    "val": "51721 Licno Ostasovice"
  },
  {
    "cast": "Ostašov-Liberec XX x)",
    "psc": "46010",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46010 Liberec Ostasov-Liberec XX x)"
  },
  {
    "cast": "Ostojkovice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Budíškovice",
    "val": "38001 Budiskovice Ostojkovice"
  },
  {
    "cast": "Ostopovice",
    "psc": "66449",
    "okres": "Brno-venkov",
    "obec": "Ostopovice",
    "val": "66449 Ostopovice Ostopovice"
  },
  {
    "cast": "Ostrá",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Ostrá",
    "val": "28922 Ostra Ostra"
  },
  {
    "cast": "Ostrá Hora",
    "psc": "79397",
    "okres": "Bruntál",
    "obec": "Bohušov",
    "val": "79397 Bohusov Ostra Hora"
  },
  {
    "cast": "Ostrata",
    "psc": "76311",
    "okres": "Zlín",
    "obec": "Ostrata",
    "val": "76311 Ostrata Ostrata"
  },
  {
    "cast": "Ostrava-Antošovice x)",
    "psc": "71100",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71100 Ostrava Ostrava-Antosovice x)"
  },
  {
    "cast": "Ostrava-Bartovice (část) x)",
    "psc": "71700",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71700 Ostrava Ostrava-Bartovice (cast) x)"
  },
  {
    "cast": "Ostrava-Bartovice (část) x)",
    "psc": "73934",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "73934 Ostrava Ostrava-Bartovice (cast) x)"
  },
  {
    "cast": "Ostrava-Bělský Les x)",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Ostrava-Belsky Les x)"
  },
  {
    "cast": "Ostrava-Dubina x)",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Ostrava-Dubina x)"
  },
  {
    "cast": "Ostrava-Heřmanice x)",
    "psc": "71300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71300 Ostrava Ostrava-Hermanice x)"
  },
  {
    "cast": "Ostrava-Hošťálkovice x)",
    "psc": "72528",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72528 Ostrava Ostrava-Hostalkovice x)"
  },
  {
    "cast": "Ostrava-Hrabová (část) x)",
    "psc": "71900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71900 Ostrava Ostrava-Hrabova (cast) x)"
  },
  {
    "cast": "Ostrava-Hrabová (část) x)",
    "psc": "72000",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72000 Ostrava Ostrava-Hrabova (cast) x)"
  },
  {
    "cast": "Ostrava-Hrabová (část) x)",
    "psc": "73932",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "73932 Ostrava Ostrava-Hrabova (cast) x)"
  },
  {
    "cast": "Ostrava-Hrabůvka x)",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Ostrava-Hrabuvka x)"
  },
  {
    "cast": "Ostrava-Hrušov (část) x)",
    "psc": "71100",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71100 Ostrava Ostrava-Hrusov (cast) x)"
  },
  {
    "cast": "Ostrava-Hrušov (část) x)",
    "psc": "71300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71300 Ostrava Ostrava-Hrusov (cast) x)"
  },
  {
    "cast": "Ostrava-Hulváky (část) x)",
    "psc": "70300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70300 Ostrava Ostrava-Hulvaky (cast) x)"
  },
  {
    "cast": "Ostrava-Hulváky (část) x)",
    "psc": "70900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70900 Ostrava Ostrava-Hulvaky (cast) x)"
  },
  {
    "cast": "Ostrava-Koblov x)",
    "psc": "71100",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71100 Ostrava Ostrava-Koblov x)"
  },
  {
    "cast": "Ostrava-Krásné Pole x)",
    "psc": "72526",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72526 Ostrava Ostrava-Krasne Pole x)"
  },
  {
    "cast": "Ostrava-Kunčice x)",
    "psc": "71900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71900 Ostrava Ostrava-Kuncice x)"
  },
  {
    "cast": "Ostrava-Kunčičky x)",
    "psc": "71800",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71800 Ostrava Ostrava-Kuncicky x)"
  },
  {
    "cast": "Ostrava-Lhotka x)",
    "psc": "72528",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72528 Ostrava Ostrava-Lhotka x)"
  },
  {
    "cast": "Ostrava-Mariánské Hory (část) x)",
    "psc": "70200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70200 Ostrava Ostrava-Marianske Hory (cast) x)"
  },
  {
    "cast": "Ostrava-Mariánské Hory (část) x)",
    "psc": "70900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70900 Ostrava Ostrava-Marianske Hory (cast) x)"
  },
  {
    "cast": "Ostrava-Martinov x)",
    "psc": "72300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72300 Ostrava Ostrava-Martinov x)"
  },
  {
    "cast": "Ostrava-Michálkovice x)",
    "psc": "71500",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71500 Ostrava Ostrava-Michalkovice x)"
  },
  {
    "cast": "Ostrava-Moravská Ostrava (část) x)",
    "psc": "70200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70200 Ostrava Ostrava-Moravska Ostrava (cast) x)"
  },
  {
    "cast": "Ostrava-Moravská Ostrava (část) x)",
    "psc": "70300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70300 Ostrava Ostrava-Moravska Ostrava (cast) x)"
  },
  {
    "cast": "Ostrava-Muglinov (část) x)",
    "psc": "71000",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71000 Ostrava Ostrava-Muglinov (cast) x)"
  },
  {
    "cast": "Ostrava-Muglinov (část) x)",
    "psc": "71200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71200 Ostrava Ostrava-Muglinov (cast) x)"
  },
  {
    "cast": "Ostrava-Nová Bělá (část) x)",
    "psc": "73924",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "73924 Ostrava Ostrava-Nova Bela (cast) x)"
  },
  {
    "cast": "Ostrava-Nová Bělá (část) x)",
    "psc": "72400",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72400 Ostrava Ostrava-Nova Bela (cast) x)"
  },
  {
    "cast": "Ostrava-Nová Ves x)",
    "psc": "70900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70900 Ostrava Ostrava-Nova Ves x)"
  },
  {
    "cast": "Ostrava-Petřkovice x)",
    "psc": "72529",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72529 Ostrava Ostrava-Petrkovice x)"
  },
  {
    "cast": "Ostrava-Plesná x)",
    "psc": "72527",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72527 Ostrava Ostrava-Plesna x)"
  },
  {
    "cast": "Ostrava-Polanka nad Odrou x)",
    "psc": "72525",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72525 Ostrava Ostrava-Polanka nad Odrou x)"
  },
  {
    "cast": "Ostrava-Poruba x)",
    "psc": "70800",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70800 Ostrava Ostrava-Poruba x)"
  },
  {
    "cast": "Ostrava-Proskovice x)",
    "psc": "72400",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72400 Ostrava Ostrava-Proskovice x)"
  },
  {
    "cast": "Ostrava-Přívoz x)",
    "psc": "70200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70200 Ostrava Ostrava-Privoz x)"
  },
  {
    "cast": "Ostrava-Pustkovec x)",
    "psc": "70800",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70800 Ostrava Ostrava-Pustkovec x)"
  },
  {
    "cast": "Ostrava-Radvanice x)",
    "psc": "71600",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71600 Ostrava Ostrava-Radvanice x)"
  },
  {
    "cast": "Ostrava-Slezská Ostrava (část) x)",
    "psc": "71000",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71000 Ostrava Ostrava-Slezska Ostrava (cast) x)"
  },
  {
    "cast": "Ostrava-Slezská Ostrava (část) x)",
    "psc": "71300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71300 Ostrava Ostrava-Slezska Ostrava (cast) x)"
  },
  {
    "cast": "Ostrava-Slezská Ostrava (část) x)",
    "psc": "71500",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71500 Ostrava Ostrava-Slezska Ostrava (cast) x)"
  },
  {
    "cast": "Ostrava-Stará Bělá x)",
    "psc": "72400",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72400 Ostrava Ostrava-Stara Bela x)"
  },
  {
    "cast": "Ostrava-Svinov (část) x)",
    "psc": "72100",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72100 Ostrava Ostrava-Svinov (cast) x)"
  },
  {
    "cast": "Ostrava-Svinov (část) x)",
    "psc": "72525",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72525 Ostrava Ostrava-Svinov (cast) x)"
  },
  {
    "cast": "Ostrava-Třebovice x)",
    "psc": "72200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72200 Ostrava Ostrava-Trebovice x)"
  },
  {
    "cast": "Ostrava-Vítkovice x)",
    "psc": "70300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70300 Ostrava Ostrava-Vitkovice x)"
  },
  {
    "cast": "Ostrava-Výškovice x)",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Ostrava-Vyskovice x)"
  },
  {
    "cast": "Ostrava-Zábřeh (část) x)",
    "psc": "70900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70900 Ostrava Ostrava-Zabreh (cast) x)"
  },
  {
    "cast": "Ostrava-Zábřeh (část) x)",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Ostrava-Zabreh (cast) x)"
  },
  {
    "cast": "Ostravice",
    "psc": "73914",
    "okres": "Frýdek-Místek",
    "obec": "Ostravice",
    "val": "73914 Ostravice Ostravice"
  },
  {
    "cast": "Ostré",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Ostre"
  },
  {
    "cast": "Ostroh",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Poustka",
    "val": "35002 Poustka Ostroh"
  },
  {
    "cast": "Ostrolovský Újezd",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Ostrolovský Újezd",
    "val": "37401 Ostrolovsky Ujezd Ostrolovsky Ujezd"
  },
  {
    "cast": "Ostromeč",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Velký Malahov",
    "val": "34601 Velky Malahov Ostromec"
  },
  {
    "cast": "Ostroměř",
    "psc": "50752",
    "okres": "Jičín",
    "obec": "Ostroměř",
    "val": "50752 Ostromer Ostromer"
  },
  {
    "cast": "Ostrov",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Ostrov",
    "val": "26272 Ostrov Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Ouběnice",
    "val": "26301 Oubenice Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Ostrov",
    "val": "53863 Ostrov Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "59451",
    "okres": "Brno-venkov",
    "obec": "Žďárec",
    "val": "59451 Zdarec Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "56122",
    "okres": "Ústí nad Orlicí",
    "obec": "Ostrov",
    "val": "56122 Ostrov Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Úmyslovice",
    "val": "29001 Umyslovice Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Ostrov",
    "val": "25706 Ostrov Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Třebnouševes",
    "val": "50801 Trebnouseves Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Ostrov",
    "val": "58401 Ostrov Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Ostrov"
  },
  {
    "cast": "Ostrov",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Mutěnín",
    "val": "34525 Mutenin Ostrov"
  },
  {
    "cast": "Ostrov nad Oslavou",
    "psc": "59445",
    "okres": "Žďár nad Sázavou",
    "obec": "Ostrov nad Oslavou",
    "val": "59445 Ostrov nad Oslavou Ostrov nad Oslavou"
  },
  {
    "cast": "Ostrov u Bezdružic",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Ostrov u Bezdružic",
    "val": "33038 Ostrov u Bezdruzic Ostrov u Bezdruzic"
  },
  {
    "cast": "Ostrov u Macochy",
    "psc": "67914",
    "okres": "Blansko",
    "obec": "Ostrov u Macochy",
    "val": "67914 Ostrov u Macochy Ostrov u Macochy"
  },
  {
    "cast": "Ostrov u Stříbra",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kostelec",
    "val": "34901 Kostelec Ostrov u Stribra"
  },
  {
    "cast": "Ostrov (část)",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Malšín",
    "val": "38273 Malsin Ostrov (cast)"
  },
  {
    "cast": "Ostrov (část)",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Malšín",
    "val": "38101 Malsin Ostrov (cast)"
  },
  {
    "cast": "Ostrovačice",
    "psc": "66481",
    "okres": "Brno-venkov",
    "obec": "Ostrovačice",
    "val": "66481 Ostrovacice Ostrovacice"
  },
  {
    "cast": "Ostrovánky",
    "psc": "69631",
    "okres": "Hodonín",
    "obec": "Ostrovánky",
    "val": "69631 Ostrovanky Ostrovanky"
  },
  {
    "cast": "Ostrovce",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34901 Cernosin Ostrovce"
  },
  {
    "cast": "Ostrovec",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Velečín",
    "val": "33165 Velecin Ostrovec"
  },
  {
    "cast": "Ostrovec",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Ostrovec"
  },
  {
    "cast": "Ostrovec",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Ostrovec-Lhotka",
    "val": "33808 Ostrovec-Lhotka Ostrovec"
  },
  {
    "cast": "Ostrovské Předměstí",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Lanškroun",
    "val": "56301 Lanskroun Ostrovske Predmesti"
  },
  {
    "cast": "Ostrožská Lhota",
    "psc": "68723",
    "okres": "Uherské Hradiště",
    "obec": "Ostrožská Lhota",
    "val": "68723 Ostrozska Lhota Ostrozska Lhota"
  },
  {
    "cast": "Ostrožská Nová Ves",
    "psc": "68722",
    "okres": "Uherské Hradiště",
    "obec": "Ostrožská Nová Ves",
    "val": "68722 Ostrozska Nova Ves Ostrozska Nova Ves"
  },
  {
    "cast": "Ostrožské Předměstí",
    "psc": "68724",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Ostroh",
    "val": "68724 Uhersky Ostroh Ostrozske Predmesti"
  },
  {
    "cast": "Ostružná",
    "psc": "78825",
    "okres": "Jeseník",
    "obec": "Ostružná",
    "val": "78825 Ostruzna Ostruzna"
  },
  {
    "cast": "Ostružno",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Ostružno",
    "val": "50601 Ostruzno Ostruzno"
  },
  {
    "cast": "Ostružno",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Nezdice na Šumavě",
    "val": "34201 Nezdice na Sumave Ostruzno"
  },
  {
    "cast": "Ostružno",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Borek",
    "val": "58282 Borek Ostruzno"
  },
  {
    "cast": "Ostrý",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Ostry"
  },
  {
    "cast": "Ostrý",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Stránka",
    "val": "27735 Stranka Ostry"
  },
  {
    "cast": "Ostrý Kámen",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Karle",
    "val": "56802 Karle Ostry Kamen"
  },
  {
    "cast": "Ostředek",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Ostředek",
    "val": "25724 Ostredek Ostredek"
  },
  {
    "cast": "Ostřešany",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Ostřešany",
    "val": "53002 Ostresany Ostresany"
  },
  {
    "cast": "Ostřetice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Ostřetice",
    "val": "33901 Ostretice Ostretice"
  },
  {
    "cast": "Ostřetín",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Ostřetín",
    "val": "53401 Ostretin Ostretin"
  },
  {
    "cast": "Osůvky",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Osuvky"
  },
  {
    "cast": "Osvětimany (část)",
    "psc": "68742",
    "okres": "Uherské Hradiště",
    "obec": "Osvětimany",
    "val": "68742 Osvetimany Osvetimany (cast)"
  },
  {
    "cast": "Osvětimany (část)",
    "psc": "68709",
    "okres": "Uherské Hradiště",
    "obec": "Osvětimany",
    "val": "68709 Osvetimany Osvetimany (cast)"
  },
  {
    "cast": "Osvinov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Osvinov"
  },
  {
    "cast": "Osvračín",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Osvračín",
    "val": "34561 Osvracin Osvracin"
  },
  {
    "cast": "Ošelín",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Ošelín",
    "val": "34901 Oselin Oselin"
  },
  {
    "cast": "Oškobrh",
    "psc": "28906",
    "okres": "Nymburk",
    "obec": "Opolany",
    "val": "28906 Opolany Oskobrh"
  },
  {
    "cast": "Ošťovice",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Bousov",
    "val": "29404 Dolni Bousov Ostovice"
  },
  {
    "cast": "Otáňka",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Tisovec",
    "val": "53973 Tisovec Otanka"
  },
  {
    "cast": "Otaslavice",
    "psc": "79806",
    "okres": "Prostějov",
    "obec": "Otaslavice",
    "val": "79806 Otaslavice Otaslavice"
  },
  {
    "cast": "Otavožaty",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Senožaty",
    "val": "39601 Senozaty Otavozaty"
  },
  {
    "cast": "Otěšice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Otěšice",
    "val": "33401 Otesice Otesice"
  },
  {
    "cast": "Otěšín",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Otesin"
  },
  {
    "cast": "Otěvěk",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Otevek"
  },
  {
    "cast": "Otěvěky",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Žďár",
    "val": "27033 Zdar Oteveky"
  },
  {
    "cast": "Otice",
    "psc": "74781",
    "okres": "Opava",
    "obec": "Otice",
    "val": "74781 Otice Otice"
  },
  {
    "cast": "Otice",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25163 Strancice Otice"
  },
  {
    "cast": "Otice",
    "psc": "38229",
    "okres": "Český Krumlov",
    "obec": "Polná na Šumavě",
    "val": "38229 Polna na Sumave Otice"
  },
  {
    "cast": "Otín",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Otín",
    "val": "58833 Otin Otin"
  },
  {
    "cast": "Otín",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Otin"
  },
  {
    "cast": "Otín",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Otín",
    "val": "59401 Otin Otin"
  },
  {
    "cast": "Otín",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Otin"
  },
  {
    "cast": "Otín",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Luka nad Jihlavou",
    "val": "58822 Luka nad Jihlavou Otin"
  },
  {
    "cast": "Otín",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Otin"
  },
  {
    "cast": "Otinoves",
    "psc": "79861",
    "okres": "Prostějov",
    "obec": "Otinoves",
    "val": "79861 Otinoves Otinoves"
  },
  {
    "cast": "Otmarov",
    "psc": "66457",
    "okres": "Brno-venkov",
    "obec": "Otmarov",
    "val": "66457 Otmarov Otmarov"
  },
  {
    "cast": "Otmíče",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Otmíče",
    "val": "26751 Otmice Otmice"
  },
  {
    "cast": "Otnice",
    "psc": "68354",
    "okres": "Vyškov",
    "obec": "Otnice",
    "val": "68354 Otnice Otnice"
  },
  {
    "cast": "Otonovice",
    "psc": "79821",
    "okres": "Prostějov",
    "obec": "Hrubčice",
    "val": "79821 Hrubcice Otonovice"
  },
  {
    "cast": "Otov",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Otov",
    "val": "34522 Otov Otov"
  },
  {
    "cast": "Otovice",
    "psc": "54972",
    "okres": "Náchod",
    "obec": "Otovice",
    "val": "54972 Otovice Otovice"
  },
  {
    "cast": "Otovice",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Otovice",
    "val": "36001 Otovice Otovice"
  },
  {
    "cast": "Otradice",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Náměšť nad Oslavou",
    "val": "67571 Namest nad Oslavou Otradice"
  },
  {
    "cast": "Otradov",
    "psc": "53943",
    "okres": "Chrudim",
    "obec": "Otradov",
    "val": "53943 Otradov Otradov"
  },
  {
    "cast": "Otradov",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Otradov"
  },
  {
    "cast": "Otradovice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Otradovice"
  },
  {
    "cast": "Otradovice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Otradovice"
  },
  {
    "cast": "Otradovice",
    "psc": "29474",
    "okres": "Mladá Boleslav",
    "obec": "Skorkov",
    "val": "29474 Skorkov Otradovice"
  },
  {
    "cast": "Otročice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Otrocice"
  },
  {
    "cast": "Otročín",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Stříbro",
    "val": "34901 Stribro Otrocin"
  },
  {
    "cast": "Otročín",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Otročín",
    "val": "36401 Otrocin Otrocin"
  },
  {
    "cast": "Otročiněves",
    "psc": "26703",
    "okres": "Beroun",
    "obec": "Otročiněves",
    "val": "26703 Otrocineves Otrocineves"
  },
  {
    "cast": "Otročkov",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Hvozd",
    "val": "79855 Hvozd Otrockov"
  },
  {
    "cast": "Otrokovice",
    "psc": "76502",
    "okres": "Zlín",
    "obec": "Otrokovice",
    "val": "76502 Otrokovice Otrokovice"
  },
  {
    "cast": "Otruby",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Otruby"
  },
  {
    "cast": "Otryby (část)",
    "psc": "28509",
    "okres": "Kutná Hora",
    "obec": "Soběšín",
    "val": "28509 Sobesin Otryby (cast)"
  },
  {
    "cast": "Otryby (část)",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Soběšín",
    "val": "28506 Sobesin Otryby (cast)"
  },
  {
    "cast": "Otvice",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Otvice",
    "val": "43111 Otvice Otvice"
  },
  {
    "cast": "Otvovice",
    "psc": "27327",
    "okres": "Kladno",
    "obec": "Otvovice",
    "val": "27327 Otvovice Otvovice"
  },
  {
    "cast": "Ouběnice",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Ouběnice",
    "val": "26301 Oubenice Oubenice"
  },
  {
    "cast": "Ouběnice",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Oubenice"
  },
  {
    "cast": "Oucmanice",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Oucmanice",
    "val": "56201 Oucmanice Oucmanice"
  },
  {
    "cast": "Ouč",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Chocnějovice",
    "val": "29413 Chocnejovice Ouc"
  },
  {
    "cast": "Oudoleň",
    "psc": "58224",
    "okres": "Havlíčkův Brod",
    "obec": "Oudoleň",
    "val": "58224 Oudolen Oudolen"
  },
  {
    "cast": "Oukřtalov",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Počepice",
    "val": "26255 Pocepice Oukrtalov"
  },
  {
    "cast": "Ounuz",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Ounuz"
  },
  {
    "cast": "Ouštice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Oustice"
  },
  {
    "cast": "Ovčárna",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Ovcarna"
  },
  {
    "cast": "Ovčáry",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Ovčáry",
    "val": "28002 Ovcary Ovcary"
  },
  {
    "cast": "Ovčáry",
    "psc": "28531",
    "okres": "Kutná Hora",
    "obec": "Nové Dvory",
    "val": "28531 Nove Dvory Ovcary"
  },
  {
    "cast": "Ovčáry (část)",
    "psc": "27714",
    "okres": "Mělník",
    "obec": "Ovčáry",
    "val": "27714 Ovcary Ovcary (cast)"
  },
  {
    "cast": "Ovčáry (část)",
    "psc": "27713",
    "okres": "Mělník",
    "obec": "Ovčáry",
    "val": "27713 Ovcary Ovcary (cast)"
  },
  {
    "cast": "Ovesná",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Benešov nad Ploučnicí",
    "val": "40502 Benesov nad Ploucnici Ovesna"
  },
  {
    "cast": "Ovesná Lhota",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Ovesná Lhota",
    "val": "58291 Ovesna Lhota Ovesna Lhota"
  },
  {
    "cast": "Ovesné",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Chroboly",
    "val": "38301 Chroboly Ovesne"
  },
  {
    "cast": "Ovesné Kladruby",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Ovesné Kladruby",
    "val": "35301 Ovesne Kladruby Ovesne Kladruby"
  },
  {
    "cast": "Oznice",
    "psc": "75624",
    "okres": "Vsetín",
    "obec": "Oznice",
    "val": "75624 Oznice Oznice"
  },
  {
    "cast": "Paběnice",
    "psc": "28543",
    "okres": "Kutná Hora",
    "obec": "Paběnice",
    "val": "28543 Pabenice Pabenice"
  },
  {
    "cast": "Pacelice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Škvořetice",
    "val": "38801 Skvoretice Pacelice"
  },
  {
    "cast": "Paceřice",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Paceřice",
    "val": "46344 Pacerice Pacerice"
  },
  {
    "cast": "Pacetluky",
    "psc": "76843",
    "okres": "Kroměříž",
    "obec": "Pacetluky",
    "val": "76843 Pacetluky Pacetluky"
  },
  {
    "cast": "Pacov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pacov",
    "val": "39501 Pacov Pacov"
  },
  {
    "cast": "Pacov",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Říčany",
    "val": "25101 Ricany Pacov"
  },
  {
    "cast": "Pacov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Pacov"
  },
  {
    "cast": "Pačejov",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Pačejov",
    "val": "34101 Pacejov Pacejov"
  },
  {
    "cast": "Pačejov-nádraží",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Pačejov",
    "val": "34101 Pacejov Pacejov-nadrazi"
  },
  {
    "cast": "Pačín",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Pacin"
  },
  {
    "cast": "Pačlavice",
    "psc": "76834",
    "okres": "Kroměříž",
    "obec": "Pačlavice",
    "val": "76834 Paclavice Paclavice"
  },
  {
    "cast": "Padařov",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39131 Jistebnice Padarov"
  },
  {
    "cast": "Padařovice",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Soběslavice",
    "val": "46345 Sobeslavice Padarovice"
  },
  {
    "cast": "Padochov",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Oslavany",
    "val": "66491 Oslavany Padochov"
  },
  {
    "cast": "Padouchov",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Proseč pod Ještědem",
    "val": "46343 Prosec pod Jestedem Padouchov"
  },
  {
    "cast": "Pakoměřice",
    "psc": "25065",
    "okres": "Praha-východ",
    "obec": "Bořanovice",
    "val": "25065 Boranovice Pakomerice"
  },
  {
    "cast": "Pakoslav",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Křelovice",
    "val": "33036 Krelovice Pakoslav"
  },
  {
    "cast": "Palačov",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74101 Stary Jicin Palacov"
  },
  {
    "cast": "Palčice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Palcice"
  },
  {
    "cast": "Páleč",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Páleč",
    "val": "27371 Palec Palec"
  },
  {
    "cast": "Páleček",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Klobuky",
    "val": "27374 Klobuky Palecek"
  },
  {
    "cast": "Palič",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Palic"
  },
  {
    "cast": "Palivo",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Radětice",
    "val": "26231 Radetice Palivo"
  },
  {
    "cast": "Palkovice",
    "psc": "73941",
    "okres": "Frýdek-Místek",
    "obec": "Palkovice",
    "val": "73941 Palkovice Palkovice"
  },
  {
    "cast": "Palonín",
    "psc": "78983",
    "okres": "Šumperk",
    "obec": "Palonín",
    "val": "78983 Palonin Palonin"
  },
  {
    "cast": "Pálovice",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Pálovice",
    "val": "67531 Palovice Palovice"
  },
  {
    "cast": "Palupín",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Strmilov",
    "val": "37853 Strmilov Palupin"
  },
  {
    "cast": "Palvinov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Palvinov"
  },
  {
    "cast": "Pamětice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Drhovle",
    "val": "39701 Drhovle Pametice"
  },
  {
    "cast": "Pamětice",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Pamětice",
    "val": "67961 Pametice Pametice"
  },
  {
    "cast": "Pamětník",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Chlumec nad Cidlinou",
    "val": "50351 Chlumec nad Cidlinou Pametnik"
  },
  {
    "cast": "Pancíř",
    "psc": "34004",
    "okres": "Klatovy",
    "obec": "Železná Ruda",
    "val": "34004 Zelezna Ruda Pancir"
  },
  {
    "cast": "Pančava-Chotěměřice x)",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Pancava-Chotemerice x)"
  },
  {
    "cast": "Panenská",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Jemnice",
    "val": "67531 Jemnice Panenska"
  },
  {
    "cast": "Panenská Hůrka",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Bílý Kostel nad Nisou",
    "val": "46331 Bily Kostel nad Nisou Panenska Hurka"
  },
  {
    "cast": "Panenská Rozsíčka",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Panenská Rozsíčka",
    "val": "58901 Panenska Rozsicka Panenska Rozsicka"
  },
  {
    "cast": "Panenské Břežany",
    "psc": "25070",
    "okres": "Praha-východ",
    "obec": "Panenské Břežany",
    "val": "25070 Panenske Brezany Panenske Brezany"
  },
  {
    "cast": "Panenský Týnec",
    "psc": "43905",
    "okres": "Louny",
    "obec": "Panenský Týnec",
    "val": "43905 Panensky Tynec Panensky Tynec"
  },
  {
    "cast": "Panoší Újezd",
    "psc": "27021",
    "okres": "Rakovník",
    "obec": "Panoší Újezd",
    "val": "27021 Panosi Ujezd Panosi Ujezd"
  },
  {
    "cast": "Pánov",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59453 Velka Bites Panov"
  },
  {
    "cast": "Panská Habrová (část)",
    "psc": "51603",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51603 Rychnov nad Kneznou Panska Habrova (cast)"
  },
  {
    "cast": "Panská Habrová (část)",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51601 Rychnov nad Kneznou Panska Habrova (cast)"
  },
  {
    "cast": "Panská Lhota",
    "psc": "58832",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58832 Brtnice Panska Lhota"
  },
  {
    "cast": "Panská Ves",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Panska Ves"
  },
  {
    "cast": "Panské Dubenky",
    "psc": "37853",
    "okres": "Jihlava",
    "obec": "Panské Dubenky",
    "val": "37853 Panske Dubenky Panske Dubenky"
  },
  {
    "cast": "Panské Mlýny",
    "psc": "39494",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39494 Cernovice Panske Mlyny"
  },
  {
    "cast": "Panský",
    "psc": "40761",
    "okres": "Děčín",
    "obec": "Staré Křečany",
    "val": "40761 Stare Krecany Pansky"
  },
  {
    "cast": "Paračov",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Paračov",
    "val": "38601 Paracov Paracov"
  },
  {
    "cast": "Pardubice-Staré Město",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Pardubice-Stare Mesto"
  },
  {
    "cast": "Pardubičky (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Pardubicky (cast)"
  },
  {
    "cast": "Pardubičky (část)",
    "psc": "53003",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53003 Pardubice Pardubicky (cast)"
  },
  {
    "cast": "Pardubičky (část)",
    "psc": "53301",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53301 Pardubice Pardubicky (cast)"
  },
  {
    "cast": "Parník",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Česká Třebová",
    "val": "56002 Ceska Trebova Parnik"
  },
  {
    "cast": "Paršovice",
    "psc": "75355",
    "okres": "Přerov",
    "obec": "Paršovice",
    "val": "75355 Parsovice Parsovice"
  },
  {
    "cast": "Partoltice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Neurazy",
    "val": "33501 Neurazy Partoltice"
  },
  {
    "cast": "Partutovice",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Partutovice",
    "val": "75301 Partutovice Partutovice"
  },
  {
    "cast": "Pařezí",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Chotýšany",
    "val": "25701 Chotysany Parezi"
  },
  {
    "cast": "Pařezí",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Parezi"
  },
  {
    "cast": "Pařezovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Parezovice"
  },
  {
    "cast": "Pařezská Lhota",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Holín",
    "val": "50601 Holin Parezska Lhota"
  },
  {
    "cast": "Pařízek",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50601 Mladejov Parizek"
  },
  {
    "cast": "Pařížov",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Běstvina",
    "val": "53843 Bestvina Parizov"
  },
  {
    "cast": "Pasecký Žleb",
    "psc": "78397",
    "okres": "Olomouc",
    "obec": "Paseka",
    "val": "78397 Paseka Pasecky Zleb"
  },
  {
    "cast": "Paseka",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Radkov",
    "val": "39131 Radkov Paseka"
  },
  {
    "cast": "Paseka",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Borová Lada",
    "val": "38501 Borova Lada Paseka"
  },
  {
    "cast": "Paseka",
    "psc": "78397",
    "okres": "Olomouc",
    "obec": "Paseka",
    "val": "78397 Paseka Paseka"
  },
  {
    "cast": "Paseky",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Paseky",
    "val": "39811 Paseky Paseky"
  },
  {
    "cast": "Paseky",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Osečany",
    "val": "26401 Osecany Paseky"
  },
  {
    "cast": "Paseky",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Proseč",
    "val": "53944 Prosec Paseky"
  },
  {
    "cast": "Paseky",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Paseky"
  },
  {
    "cast": "Paseky",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Hřibiny-Ledská",
    "val": "51741 Hribiny-Ledska Paseky"
  },
  {
    "cast": "Paseky nad Jizerou",
    "psc": "51247",
    "okres": "Semily",
    "obec": "Paseky nad Jizerou",
    "val": "51247 Paseky nad Jizerou Paseky nad Jizerou"
  },
  {
    "cast": "Paskov",
    "psc": "73921",
    "okres": "Frýdek-Místek",
    "obec": "Paskov",
    "val": "73921 Paskov Paskov"
  },
  {
    "cast": "Pasohlávky",
    "psc": "69122",
    "okres": "Brno-venkov",
    "obec": "Pasohlávky",
    "val": "69122 Pasohlavky Pasohlavky"
  },
  {
    "cast": "Pastuchovice",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Pastuchovice",
    "val": "33165 Pastuchovice Pastuchovice"
  },
  {
    "cast": "Pastviny",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Hranice",
    "val": "35201 Hranice Pastviny"
  },
  {
    "cast": "Pastviny",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Pastviny",
    "val": "56401 Pastviny Pastviny"
  },
  {
    "cast": "Pašice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Pištín",
    "val": "37341 Pistin Pasice"
  },
  {
    "cast": "Pašinka",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Pašinka",
    "val": "28002 Pasinka Pasinka"
  },
  {
    "cast": "Pašinovice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Komařice",
    "val": "37401 Komarice Pasinovice"
  },
  {
    "cast": "Pašovice",
    "psc": "68756",
    "okres": "Uherské Hradiště",
    "obec": "Pašovice",
    "val": "68756 Pasovice Pasovice"
  },
  {
    "cast": "Pašovice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Chrášťany",
    "val": "37501 Chrastany Pasovice"
  },
  {
    "cast": "Paštiky",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Bezdědovice",
    "val": "38801 Bezdedovice Pastiky"
  },
  {
    "cast": "Páteček",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Patecek"
  },
  {
    "cast": "Pátek",
    "psc": "43908",
    "okres": "Louny",
    "obec": "Peruc",
    "val": "43908 Peruc Patek"
  },
  {
    "cast": "Pátek",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Pátek",
    "val": "29001 Patek Patek"
  },
  {
    "cast": "Pateřín",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Bílá Lhota",
    "val": "78321 Bila Lhota Paterin"
  },
  {
    "cast": "Patokryje",
    "psc": "43401",
    "okres": "Most",
    "obec": "Patokryje",
    "val": "43401 Patokryje Patokryje"
  },
  {
    "cast": "Patřín",
    "psc": "28937",
    "okres": "Nymburk",
    "obec": "Loučeň",
    "val": "28937 Loucen Patrin"
  },
  {
    "cast": "Pavlice",
    "psc": "67156",
    "okres": "Znojmo",
    "obec": "Pavlice",
    "val": "67156 Pavlice Pavlice"
  },
  {
    "cast": "Pavličky",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Tuhaň",
    "val": "47201 Tuhan Pavlicky"
  },
  {
    "cast": "Pavlíkov",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Třemešné",
    "val": "34806 Tremesne Pavlikov"
  },
  {
    "cast": "Pavlíkov (část)",
    "psc": "27021",
    "okres": "Rakovník",
    "obec": "Pavlíkov",
    "val": "27021 Pavlikov Pavlikov (cast)"
  },
  {
    "cast": "Pavlíkov (část)",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Pavlíkov",
    "val": "26901 Pavlikov Pavlikov (cast)"
  },
  {
    "cast": "Pavlínov",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Pavlínov",
    "val": "59401 Pavlinov Pavlinov"
  },
  {
    "cast": "Pavlišov",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Pavlisov"
  },
  {
    "cast": "Pavlov",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Pavlov",
    "val": "27351 Pavlov Pavlov"
  },
  {
    "cast": "Pavlov",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Pavlov",
    "val": "58833 Pavlov Pavlov"
  },
  {
    "cast": "Pavlov",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Pavlov",
    "val": "78985 Pavlov Pavlov"
  },
  {
    "cast": "Pavlov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pavlov",
    "val": "39301 Pavlov Pavlov"
  },
  {
    "cast": "Pavlov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Pavlov"
  },
  {
    "cast": "Pavlov",
    "psc": "69201",
    "okres": "Břeclav",
    "obec": "Pavlov",
    "val": "69201 Pavlov Pavlov"
  },
  {
    "cast": "Pavlov",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Pavlov",
    "val": "58401 Pavlov Pavlov"
  },
  {
    "cast": "Pavlov",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Pavlov",
    "val": "59444 Pavlov Pavlov"
  },
  {
    "cast": "Pavlov u Herálce",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Herálec",
    "val": "58255 Heralec Pavlov u Heralce"
  },
  {
    "cast": "Pavlovice",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Pavlovice",
    "val": "25801 Pavlovice Pavlovice"
  },
  {
    "cast": "Pavlovice",
    "psc": "68341",
    "okres": "Vyškov",
    "obec": "Bohdalice-Pavlovice",
    "val": "68341 Bohdalice-Pavlovice Pavlovice"
  },
  {
    "cast": "Pavlovice",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Pavlovice"
  },
  {
    "cast": "Pavlovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "28522 Vlastejovice Pavlovice"
  },
  {
    "cast": "Pavlovice u Kojetína",
    "psc": "79830",
    "okres": "Prostějov",
    "obec": "Pavlovice u Kojetína",
    "val": "79830 Pavlovice u Kojetina Pavlovice u Kojetina"
  },
  {
    "cast": "Pavlovice u Přerova",
    "psc": "75111",
    "okres": "Přerov",
    "obec": "Pavlovice u Přerova",
    "val": "75111 Pavlovice u Prerova Pavlovice u Prerova"
  },
  {
    "cast": "Pavlovice (část)",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Jestřebí",
    "val": "47201 Jestrebi Pavlovice (cast)"
  },
  {
    "cast": "Pavlovice (část)",
    "psc": "47161",
    "okres": "Česká Lípa",
    "obec": "Jestřebí",
    "val": "47161 Jestrebi Pavlovice (cast)"
  },
  {
    "cast": "Pavlovičky",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Pavlovicky"
  },
  {
    "cast": "Pavlovsko",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Dobřív",
    "val": "33701 Dobriv Pavlovsko"
  },
  {
    "cast": "Pávov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Pavov"
  },
  {
    "cast": "Pazderna",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Pazderna"
  },
  {
    "cast": "Pazderna",
    "psc": "73951",
    "okres": "Frýdek-Místek",
    "obec": "Pazderna",
    "val": "73951 Pazderna Pazderna"
  },
  {
    "cast": "Pazderná Lhota",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Popovice",
    "val": "25703 Popovice Pazderna Lhota"
  },
  {
    "cast": "Pazucha",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Pazucha"
  },
  {
    "cast": "Pec",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Pec",
    "val": "34401 Pec Pec"
  },
  {
    "cast": "Pec pod Sněžkou",
    "psc": "54221",
    "okres": "Trutnov",
    "obec": "Pec pod Sněžkou",
    "val": "54221 Pec pod Snezkou Pec pod Snezkou"
  },
  {
    "cast": "Pecerady",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25741 Tynec nad Sazavou Pecerady"
  },
  {
    "cast": "Pecínov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Pecinov"
  },
  {
    "cast": "Pecínov",
    "psc": "27101",
    "okres": "Rakovník",
    "obec": "Nové Strašecí",
    "val": "27101 Nove Straseci Pecinov"
  },
  {
    "cast": "Pecka",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Pecka",
    "val": "50782 Pecka Pecka"
  },
  {
    "cast": "Peč",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Peč",
    "val": "38001 Pec Pec"
  },
  {
    "cast": "Pečetín",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bolešiny",
    "val": "33901 Bolesiny Pecetin"
  },
  {
    "cast": "Pěčice",
    "psc": "29446",
    "okres": "Mladá Boleslav",
    "obec": "Pěčice",
    "val": "29446 Pecice Pecice"
  },
  {
    "cast": "Pečice (část)",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Pečice",
    "val": "26231 Pecice Pecice (cast)"
  },
  {
    "cast": "Pečice (část)",
    "psc": "26232",
    "okres": "Příbram",
    "obec": "Pečice",
    "val": "26232 Pecice Pecice (cast)"
  },
  {
    "cast": "Pečičky",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Pečice",
    "val": "26231 Pecice Pecicky"
  },
  {
    "cast": "Pěčíkov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Pecikov"
  },
  {
    "cast": "Pěčín",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Pecin"
  },
  {
    "cast": "Pěčín (část)",
    "psc": "51757",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Pěčín",
    "val": "51757 Pecin Pecin (cast)"
  },
  {
    "cast": "Pěčín (část)",
    "psc": "51761",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Pěčín",
    "val": "51761 Pecin Pecin (cast)"
  },
  {
    "cast": "Pečky",
    "psc": "28911",
    "okres": "Kolín",
    "obec": "Pečky",
    "val": "28911 Pecky Pecky"
  },
  {
    "cast": "Pěčnov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Pěčnov",
    "val": "38301 Pecnov Pecnov"
  },
  {
    "cast": "Pechova Lhota",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Hrejkovice",
    "val": "39901 Hrejkovice Pechova Lhota"
  },
  {
    "cast": "Pejdlova Rosička",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Jarošov nad Nežárkou",
    "val": "37842 Jarosov nad Nezarkou Pejdlova Rosicka"
  },
  {
    "cast": "Pejškov",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Tišnov",
    "val": "66601 Tisnov Pejskov"
  },
  {
    "cast": "Pejškov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Pejskov"
  },
  {
    "cast": "Pejšova Lhota",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Pejsova Lhota"
  },
  {
    "cast": "Pekařka",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Bílý Kostel nad Nisou",
    "val": "46331 Bily Kostel nad Nisou Pekarka"
  },
  {
    "cast": "Pekelský Důl",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40502 Ceska Kamenice Pekelsky Dul"
  },
  {
    "cast": "Pekla",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Cerekvice nad Loučnou",
    "val": "57001 Cerekvice nad Loucnou Pekla"
  },
  {
    "cast": "Peklo",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Stružná",
    "val": "36471 Struzna Peklo"
  },
  {
    "cast": "Peklo",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Peklo"
  },
  {
    "cast": "Peklo",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Peklo"
  },
  {
    "cast": "Peklo (část)",
    "psc": "51755",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vamberk",
    "val": "51755 Vamberk Peklo (cast)"
  },
  {
    "cast": "Peklo (část)",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vamberk",
    "val": "51601 Vamberk Peklo (cast)"
  },
  {
    "cast": "Peklo (část)",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vamberk",
    "val": "51741 Vamberk Peklo (cast)"
  },
  {
    "cast": "Pekloves",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Železnice",
    "val": "50713 Zeleznice Pekloves"
  },
  {
    "cast": "Pěkná",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Nová Pec",
    "val": "38451 Nova Pec Pekna"
  },
  {
    "cast": "Pěkov",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Police nad Metují",
    "val": "54954 Police nad Metuji Pekov"
  },
  {
    "cast": "Pěkovice",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Pekovice"
  },
  {
    "cast": "Pelec",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Častrov",
    "val": "39470 Castrov Pelec"
  },
  {
    "cast": "Pelechov",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Lipoltice",
    "val": "53501 Lipoltice Pelechov"
  },
  {
    "cast": "Pelechov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Pelechov"
  },
  {
    "cast": "Pelechy",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Pelechy",
    "val": "34401 Pelechy Pelechy"
  },
  {
    "cast": "Pelejovice",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Dolní Bukovsko",
    "val": "37365 Dolni Bukovsko Pelejovice"
  },
  {
    "cast": "Pelešany",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Pelesany"
  },
  {
    "cast": "Pelhřimov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Pelhrimov"
  },
  {
    "cast": "Pelhřimov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Pelhrimov"
  },
  {
    "cast": "Pelíkovice",
    "psc": "46802",
    "okres": "Jablonec nad Nisou",
    "obec": "Rychnov u Jablonce nad Nisou",
    "val": "46802 Rychnov u Jablonce nad Nisou Pelikovice"
  },
  {
    "cast": "Pelíškův Most",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Tichonice",
    "val": "25763 Tichonice Peliskuv Most"
  },
  {
    "cast": "Penčice-Přerov XIII x)",
    "psc": "75127",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75127 Prerov Pencice-Prerov XIII x)"
  },
  {
    "cast": "Pěnčín",
    "psc": "79857",
    "okres": "Prostějov",
    "obec": "Pěnčín",
    "val": "79857 Pencin Pencin"
  },
  {
    "cast": "Pěnčín",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Pěnčín",
    "val": "46345 Pencin Pencin"
  },
  {
    "cast": "Pěnčín",
    "psc": "46821",
    "okres": "Jablonec nad Nisou",
    "obec": "Pěnčín",
    "val": "46821 Pencin Pencin"
  },
  {
    "cast": "Perálec",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Perálec",
    "val": "53944 Peralec Peralec"
  },
  {
    "cast": "Perky",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Častrov",
    "val": "39470 Castrov Perky"
  },
  {
    "cast": "Perlovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Perlovice"
  },
  {
    "cast": "Perná",
    "psc": "75641",
    "okres": "Vsetín",
    "obec": "Lešná",
    "val": "75641 Lesna Perna"
  },
  {
    "cast": "Perná",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Perna"
  },
  {
    "cast": "Perná (část)",
    "psc": "69186",
    "okres": "Břeclav",
    "obec": "Perná",
    "val": "69186 Perna Perna (cast)"
  },
  {
    "cast": "Perná (část)",
    "psc": "69181",
    "okres": "Břeclav",
    "obec": "Perná",
    "val": "69181 Perna Perna (cast)"
  },
  {
    "cast": "Pernarec",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Pernarec",
    "val": "33036 Pernarec Pernarec"
  },
  {
    "cast": "Pernek",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Horní Planá",
    "val": "38226 Horni Plana Pernek"
  },
  {
    "cast": "Pernink",
    "psc": "36236",
    "okres": "Karlovy Vary",
    "obec": "Pernink",
    "val": "36236 Pernink Pernink"
  },
  {
    "cast": "Pernolec",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Částkov",
    "val": "34801 Castkov Pernolec"
  },
  {
    "cast": "Pernštejn",
    "psc": "59262",
    "okres": "Brno-venkov",
    "obec": "Nedvědice",
    "val": "59262 Nedvedice Pernstejn"
  },
  {
    "cast": "Pernštejnské Janovice",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Věžná",
    "val": "59301 Vezna Pernstejnske Janovice"
  },
  {
    "cast": "Pernštejnské Jestřabí",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Pernštejnské Jestřabí",
    "val": "59261 Pernstejnske Jestrabi Pernstejnske Jestrabi"
  },
  {
    "cast": "Peršíkov",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkova Borová",
    "val": "58263 Havlickova Borova Persikov"
  },
  {
    "cast": "Perštejn",
    "psc": "43163",
    "okres": "Chomutov",
    "obec": "Perštejn",
    "val": "43163 Perstejn Perstejn"
  },
  {
    "cast": "Perštejnec",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Perstejnec"
  },
  {
    "cast": "Perštýn-Liberec IV x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Perstyn-Liberec IV x)"
  },
  {
    "cast": "Pertoltice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Pertoltice",
    "val": "28522 Pertoltice Pertoltice"
  },
  {
    "cast": "Pertoltice pod Ralskem",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Pertoltice pod Ralskem",
    "val": "47124 Pertoltice pod Ralskem Pertoltice pod Ralskem"
  },
  {
    "cast": "Peruc",
    "psc": "43907",
    "okres": "Louny",
    "obec": "Peruc",
    "val": "43907 Peruc Peruc"
  },
  {
    "cast": "Peřimov",
    "psc": "51204",
    "okres": "Semily",
    "obec": "Peřimov",
    "val": "51204 Perimov Perimov"
  },
  {
    "cast": "Pesvice",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Pesvice",
    "val": "43111 Pesvice Pesvice"
  },
  {
    "cast": "Pěšice",
    "psc": "53854",
    "okres": "Ústí nad Orlicí",
    "obec": "Řepníky",
    "val": "53854 Repniky Pesice"
  },
  {
    "cast": "Pětihosty",
    "psc": "25167",
    "okres": "Praha-východ",
    "obec": "Pětihosty",
    "val": "25167 Petihosty Petihosty"
  },
  {
    "cast": "Pětikozly",
    "psc": "29430",
    "okres": "Mladá Boleslav",
    "obec": "Pětikozly",
    "val": "29430 Petikozly Petikozly"
  },
  {
    "cast": "Pětipsy",
    "psc": "43153",
    "okres": "Chomutov",
    "obec": "Pětipsy",
    "val": "43153 Petipsy Petipsy"
  },
  {
    "cast": "Petkovy",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Petkovy",
    "val": "29404 Petkovy Petkovy"
  },
  {
    "cast": "Petlery",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Domašín",
    "val": "43151 Domasin Petlery"
  },
  {
    "cast": "Petrašovice",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46342 Bila Petrasovice"
  },
  {
    "cast": "Petráveč",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Petráveč",
    "val": "59401 Petravec Petravec"
  },
  {
    "cast": "Petrkov",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Petrkov"
  },
  {
    "cast": "Petrkov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Zachotín",
    "val": "39301 Zachotin Petrkov"
  },
  {
    "cast": "Petrkov",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Lípa",
    "val": "58001 Lipa Petrkov"
  },
  {
    "cast": "Petrkov 1.díl",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Petrkov 1.dil"
  },
  {
    "cast": "Petrkov 3.díl",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Trhová Kamenice",
    "val": "53901 Trhova Kamenice Petrkov 3.dil"
  },
  {
    "cast": "Petrohrad",
    "psc": "43985",
    "okres": "Louny",
    "obec": "Petrohrad",
    "val": "43985 Petrohrad Petrohrad"
  },
  {
    "cast": "Petroupec",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Petroupim",
    "val": "25601 Petroupim Petroupec"
  },
  {
    "cast": "Petroupim",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Petroupim",
    "val": "25601 Petroupim Petroupim"
  },
  {
    "cast": "Petrov",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Petrov",
    "val": "67962 Petrov Petrov"
  },
  {
    "cast": "Petrov",
    "psc": "69665",
    "okres": "Hodonín",
    "obec": "Petrov",
    "val": "69665 Petrov Petrov"
  },
  {
    "cast": "Petrov nad Desnou (část)",
    "psc": "78814",
    "okres": "Šumperk",
    "obec": "Petrov nad Desnou",
    "val": "78814 Petrov nad Desnou Petrov nad Desnou (cast)"
  },
  {
    "cast": "Petrov nad Desnou (část)",
    "psc": "78816",
    "okres": "Šumperk",
    "obec": "Petrov nad Desnou",
    "val": "78816 Petrov nad Desnou Petrov nad Desnou (cast)"
  },
  {
    "cast": "Petrov (část)",
    "psc": "25206",
    "okres": "Praha-západ",
    "obec": "Petrov",
    "val": "25206 Petrov Petrov (cast)"
  },
  {
    "cast": "Petrov (část)",
    "psc": "25281",
    "okres": "Praha-západ",
    "obec": "Petrov",
    "val": "25281 Petrov Petrov (cast)"
  },
  {
    "cast": "Petrov (část)",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Petrov",
    "val": "25401 Petrov Petrov (cast)"
  },
  {
    "cast": "Petrova Lhota",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Studený",
    "val": "25768 Studeny Petrova Lhota"
  },
  {
    "cast": "Petrovice",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "34012 Mecin Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "58831",
    "okres": "Jihlava",
    "obec": "Puklice",
    "val": "58831 Puklice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Petrovice",
    "val": "67521 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Skorošice",
    "val": "79065 Skorosice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Štoky",
    "val": "58253 Stoky Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Újezd",
    "val": "34401 Ujezd Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Osek",
    "val": "38601 Osek Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Petrovice",
    "val": "67902 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "79384",
    "okres": "Bruntál",
    "obec": "Petrovice",
    "val": "79384 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Petrovice",
    "val": "67201 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "10900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10900 Praha Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Petrovice",
    "val": "56301 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Mladošovice",
    "val": "37312 Mladosovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Petrovice",
    "val": "27035 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "54234",
    "okres": "Trutnov",
    "obec": "Malé Svatoňovice",
    "val": "54234 Male Svatonovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "40337",
    "okres": "Ústí nad Labem",
    "obec": "Petrovice",
    "val": "40337 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "50355",
    "okres": "Hradec Králové",
    "obec": "Petrovice",
    "val": "50355 Petrovice Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Týniště nad Orlicí",
    "val": "51721 Tyniste nad Orlici Petrovice"
  },
  {
    "cast": "Petrovice",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Petrovice"
  },
  {
    "cast": "Petrovice I",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Petrovice I",
    "val": "28601 Petrovice I Petrovice I"
  },
  {
    "cast": "Petrovice II",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Petrovice II",
    "val": "28522 Petrovice II Petrovice II"
  },
  {
    "cast": "Petrovice nad Úhlavou",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34022 Janovice nad Uhlavou Petrovice nad Uhlavou"
  },
  {
    "cast": "Petrovice u Karviné",
    "psc": "73572",
    "okres": "Karviná",
    "obec": "Petrovice u Karviné",
    "val": "73572 Petrovice u Karvine Petrovice u Karvine"
  },
  {
    "cast": "Petrovice u Sušice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Petrovice u Susice"
  },
  {
    "cast": "Petrovice u Uhelné Příbramě",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Uhelná Příbram",
    "val": "58282 Uhelna Pribram Petrovice u Uhelne Pribrame"
  },
  {
    "cast": "Petrovice (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Velké Petrovice",
    "val": "54931 Velke Petrovice Petrovice (cast)"
  },
  {
    "cast": "Petrovice (část)",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Velké Petrovice",
    "val": "54954 Velke Petrovice Petrovice (cast)"
  },
  {
    "cast": "Petrovičky",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Předslav",
    "val": "33901 Predslav Petrovicky"
  },
  {
    "cast": "Petrovičky",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Petrovičky",
    "val": "50801 Petrovicky Petrovicky"
  },
  {
    "cast": "Petrovičky",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Velké Petrovice",
    "val": "54954 Velke Petrovice Petrovicky"
  },
  {
    "cast": "Petrovičky",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Mladkov",
    "val": "56164 Mladkov Petrovicky"
  },
  {
    "cast": "Petrovičky (část)",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Týniště nad Orlicí",
    "val": "51721 Tyniste nad Orlici Petrovicky (cast)"
  },
  {
    "cast": "Petrovičky (část)",
    "psc": "50346",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Týniště nad Orlicí",
    "val": "50346 Tyniste nad Orlici Petrovicky (cast)"
  },
  {
    "cast": "Petrovsko",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Vyklantice",
    "val": "39501 Vyklantice Petrovsko"
  },
  {
    "cast": "Petrušov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Staré Město",
    "val": "57101 Stare Mesto Petrusov"
  },
  {
    "cast": "Petrův Dvůr",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Netolice",
    "val": "38411 Netolice Petruv Dvur"
  },
  {
    "cast": "Petrůvka",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Petrůvka",
    "val": "76321 Petruvka Petruvka"
  },
  {
    "cast": "Petrůvka",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Petruvka"
  },
  {
    "cast": "Petrůvky",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Petrůvky",
    "val": "67552 Petruvky Petruvky"
  },
  {
    "cast": "Petříkov",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Petříkov",
    "val": "25169 Petrikov Petrikov"
  },
  {
    "cast": "Petříkov",
    "psc": "78825",
    "okres": "Jeseník",
    "obec": "Ostružná",
    "val": "78825 Ostruzna Petrikov"
  },
  {
    "cast": "Petříkov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Petříkov",
    "val": "37401 Petrikov Petrikov"
  },
  {
    "cast": "Petříkovice",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Petrikovice"
  },
  {
    "cast": "Petříkovice",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Chvaleč",
    "val": "54101 Chvalec Petrikovice"
  },
  {
    "cast": "Petříkovice",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Mladoňovice",
    "val": "53821 Mladonovice Petrikovice"
  },
  {
    "cast": "Petříny",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Tehov",
    "val": "25801 Tehov Petriny"
  },
  {
    "cast": "Petřkovice",
    "psc": "72529",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72529 Ostrava Petrkovice"
  },
  {
    "cast": "Petřkovice",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74101 Stary Jicin Petrkovice"
  },
  {
    "cast": "Petřvald 1-Petřvald",
    "psc": "74260",
    "okres": "Nový Jičín",
    "obec": "Petřvald",
    "val": "74260 Petrvald Petrvald 1-Petrvald"
  },
  {
    "cast": "Petřvald 2-Petřvaldík",
    "psc": "74260",
    "okres": "Nový Jičín",
    "obec": "Petřvald",
    "val": "74260 Petrvald Petrvald 2-Petrvaldik"
  },
  {
    "cast": "Petřvald (část)",
    "psc": "73511",
    "okres": "Karviná",
    "obec": "Petřvald",
    "val": "73511 Petrvald Petrvald (cast)"
  },
  {
    "cast": "Petřvald (část)",
    "psc": "73541",
    "okres": "Karviná",
    "obec": "Petřvald",
    "val": "73541 Petrvald Petrvald (cast)"
  },
  {
    "cast": "Petřvaldík-Petřvald 2 x)",
    "psc": "74260",
    "okres": "Nový Jičín",
    "obec": "Petřvald",
    "val": "74260 Petrvald Petrvaldik-Petrvald 2 x)"
  },
  {
    "cast": "Phov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Soběhrdy",
    "val": "25601 Sobehrdy Phov"
  },
  {
    "cast": "Pchery",
    "psc": "27308",
    "okres": "Kladno",
    "obec": "Pchery",
    "val": "27308 Pchery Pchery"
  },
  {
    "cast": "Pičín",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Picin"
  },
  {
    "cast": "Pičín (část)",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Pičín",
    "val": "26223 Picin Picin (cast)"
  },
  {
    "cast": "Pičín (část)",
    "psc": "26225",
    "okres": "Příbram",
    "obec": "Pičín",
    "val": "26225 Picin Picin (cast)"
  },
  {
    "cast": "Pihel",
    "psc": "47118",
    "okres": "Česká Lípa",
    "obec": "Nový Bor",
    "val": "47118 Novy Bor Pihel"
  },
  {
    "cast": "Pihovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Pihovice"
  },
  {
    "cast": "Pích",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34201 Hlavnovice Pich"
  },
  {
    "cast": "Pikárec",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Pikárec",
    "val": "59253 Pikarec Pikarec"
  },
  {
    "cast": "Pikov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Pikov"
  },
  {
    "cast": "Pikovice",
    "psc": "25209",
    "okres": "Praha-západ",
    "obec": "Hradištko",
    "val": "25209 Hradistko Pikovice"
  },
  {
    "cast": "Pila",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Trhanov",
    "val": "34401 Trhanov Pila"
  },
  {
    "cast": "Pila",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Pila",
    "val": "36001 Pila Pila"
  },
  {
    "cast": "Piletice",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Piletice"
  },
  {
    "cast": "Pilínkov-Liberec XXIV x)",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46312 Liberec Pilinkov-Liberec XXIV x)"
  },
  {
    "cast": "Pilníkov",
    "psc": "54242",
    "okres": "Trutnov",
    "obec": "Pilníkov",
    "val": "54242 Pilnikov Pilnikov"
  },
  {
    "cast": "Pipice",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Záhoří",
    "val": "51301 Zahori Pipice"
  },
  {
    "cast": "Pisárky (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Pisarky (cast)"
  },
  {
    "cast": "Pisárky (část)",
    "psc": "60300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60300 Brno Pisarky (cast)"
  },
  {
    "cast": "Pisárky (část)",
    "psc": "62300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62300 Brno Pisarky (cast)"
  },
  {
    "cast": "Pisárky (část)",
    "psc": "63400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63400 Brno Pisarky (cast)"
  },
  {
    "cast": "Pisárky (část)",
    "psc": "63700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63700 Brno Pisarky (cast)"
  },
  {
    "cast": "Pisárky (část)",
    "psc": "63900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63900 Brno Pisarky (cast)"
  },
  {
    "cast": "Písařov",
    "psc": "78991",
    "okres": "Šumperk",
    "obec": "Písařov",
    "val": "78991 Pisarov Pisarov"
  },
  {
    "cast": "Písařova Vesce",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Lesná",
    "val": "34701 Lesna Pisarova Vesce"
  },
  {
    "cast": "Písecká Smoleč",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Slabčice",
    "val": "39843 Slabcice Pisecka Smolec"
  },
  {
    "cast": "Písečná",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Pisecna"
  },
  {
    "cast": "Písečná",
    "psc": "56170",
    "okres": "Ústí nad Orlicí",
    "obec": "Písečná",
    "val": "56170 Pisecna Pisecna"
  },
  {
    "cast": "Písečná",
    "psc": "73991",
    "okres": "Frýdek-Místek",
    "obec": "Písečná",
    "val": "73991 Pisecna Pisecna"
  },
  {
    "cast": "Písečná",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Pisecna"
  },
  {
    "cast": "Písečná",
    "psc": "79082",
    "okres": "Jeseník",
    "obec": "Písečná",
    "val": "79082 Pisecna Pisecna"
  },
  {
    "cast": "Písečné",
    "psc": "37872",
    "okres": "Jindřichův Hradec",
    "obec": "Písečné",
    "val": "37872 Pisecne Pisecne"
  },
  {
    "cast": "Písečné",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Písečné",
    "val": "59301 Pisecne Pisecne"
  },
  {
    "cast": "Písek",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33035 Listany Pisek"
  },
  {
    "cast": "Písek",
    "psc": "73984",
    "okres": "Frýdek-Místek",
    "obec": "Písek",
    "val": "73984 Pisek Pisek"
  },
  {
    "cast": "Písek",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Písek",
    "val": "50351 Pisek Pisek"
  },
  {
    "cast": "Piskořov",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Piskorov"
  },
  {
    "cast": "Pískov",
    "psc": "78383",
    "okres": "Olomouc",
    "obec": "Troubelice",
    "val": "78383 Troubelice Piskov"
  },
  {
    "cast": "Písková Lhota",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Písková Lhota",
    "val": "29001 Piskova Lhota Piskova Lhota"
  },
  {
    "cast": "Písková Lhota",
    "psc": "29431",
    "okres": "Mladá Boleslav",
    "obec": "Písková Lhota",
    "val": "29431 Piskova Lhota Piskova Lhota"
  },
  {
    "cast": "Písky",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Křivoklát",
    "val": "27023 Krivoklat Pisky"
  },
  {
    "cast": "Písnice",
    "psc": "14200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14200 Praha Pisnice"
  },
  {
    "cast": "Pístina (část)",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Pístina",
    "val": "37802 Pistina Pistina (cast)"
  },
  {
    "cast": "Pístina (část)",
    "psc": "37818",
    "okres": "Jindřichův Hradec",
    "obec": "Pístina",
    "val": "37818 Pistina Pistina (cast)"
  },
  {
    "cast": "Pístov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Pistov"
  },
  {
    "cast": "Pístov",
    "psc": "34813",
    "okres": "Tachov",
    "obec": "Chodová Planá",
    "val": "34813 Chodova Plana Pistov"
  },
  {
    "cast": "Pístovice",
    "psc": "68305",
    "okres": "Vyškov",
    "obec": "Račice-Pístovice",
    "val": "68305 Racice-Pistovice Pistovice"
  },
  {
    "cast": "Písty",
    "psc": "28913",
    "okres": "Nymburk",
    "obec": "Písty",
    "val": "28913 Pisty Pisty"
  },
  {
    "cast": "Písty",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Budyně nad Ohří",
    "val": "41301 Budyne nad Ohri Pisty"
  },
  {
    "cast": "Píšť",
    "psc": "74718",
    "okres": "Opava",
    "obec": "Píšť",
    "val": "74718 Pist Pist"
  },
  {
    "cast": "Píšť",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Píšť",
    "val": "39601 Pist Pist"
  },
  {
    "cast": "Píšťany",
    "psc": "41101",
    "okres": "Litoměřice",
    "obec": "Píšťany",
    "val": "41101 Pistany Pistany"
  },
  {
    "cast": "Pištín",
    "psc": "37346",
    "okres": "České Budějovice",
    "obec": "Pištín",
    "val": "37346 Pistin Pistin"
  },
  {
    "cast": "Pitárné",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Vysoká",
    "val": "79399 Vysoka Pitarne"
  },
  {
    "cast": "Pitín",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Pitín",
    "val": "68771 Pitin Pitin"
  },
  {
    "cast": "Pitkovice",
    "psc": "10400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10400 Praha Pitkovice"
  },
  {
    "cast": "Pivín",
    "psc": "79824",
    "okres": "Prostějov",
    "obec": "Pivín",
    "val": "79824 Pivin Pivin"
  },
  {
    "cast": "Pivkovice",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Pivkovice",
    "val": "38773 Pivkovice Pivkovice"
  },
  {
    "cast": "Pivnisko",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28504 Chlistovice Pivnisko"
  },
  {
    "cast": "Pivoň",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Mnichov",
    "val": "34522 Mnichov Pivon"
  },
  {
    "cast": "Pivonice",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Pivonice"
  },
  {
    "cast": "Pivonín",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Zábřeh",
    "val": "78901 Zabreh Pivonin"
  },
  {
    "cast": "Plácky (část)",
    "psc": "50002",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50002 Hradec Kralove Placky (cast)"
  },
  {
    "cast": "Plácky (část)",
    "psc": "50301",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50301 Hradec Kralove Placky (cast)"
  },
  {
    "cast": "Plačice (část)",
    "psc": "50002",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50002 Hradec Kralove Placice (cast)"
  },
  {
    "cast": "Plačice (část)",
    "psc": "50004",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50004 Hradec Kralove Placice (cast)"
  },
  {
    "cast": "Plačice (část)",
    "psc": "50332",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50332 Hradec Kralove Placice (cast)"
  },
  {
    "cast": "Plačkov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Plackov"
  },
  {
    "cast": "Plačovice",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Dešná",
    "val": "37881 Desna Placovice"
  },
  {
    "cast": "Plachova Lhota",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Smilkov",
    "val": "25789 Smilkov Plachova Lhota"
  },
  {
    "cast": "Plachtín",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Plachtin"
  },
  {
    "cast": "Pláň",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Ostrov u Bezdružic",
    "val": "33038 Ostrov u Bezdruzic Plan"
  },
  {
    "cast": "Planá",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Hromnice",
    "val": "33011 Hromnice Plana"
  },
  {
    "cast": "Planá",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Plana"
  },
  {
    "cast": "Planá",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Klučenice",
    "val": "26256 Klucenice Plana"
  },
  {
    "cast": "Planá",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Planá",
    "val": "37001 Plana Plana"
  },
  {
    "cast": "Planá nad Lužnicí (část)",
    "psc": "39102",
    "okres": "Tábor",
    "obec": "Planá nad Lužnicí",
    "val": "39102 Plana nad Luznici Plana nad Luznici (cast)"
  },
  {
    "cast": "Planá nad Lužnicí (část)",
    "psc": "39111",
    "okres": "Tábor",
    "obec": "Planá nad Lužnicí",
    "val": "39111 Plana nad Luznici Plana nad Luznici (cast)"
  },
  {
    "cast": "Plaňany",
    "psc": "28104",
    "okres": "Kolín",
    "obec": "Plaňany",
    "val": "28104 Planany Planany"
  },
  {
    "cast": "Pláňavy",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vojtěchov",
    "val": "53901 Vojtechov Planavy"
  },
  {
    "cast": "Plandry",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Plandry",
    "val": "58841 Plandry Plandry"
  },
  {
    "cast": "Pláně",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Pláně",
    "val": "33101 Plane Plane"
  },
  {
    "cast": "Pláně",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34506 Vseruby Plane"
  },
  {
    "cast": "Plánice",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34034 Planice Planice"
  },
  {
    "cast": "Plánička",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Číhaň",
    "val": "34142 Cihan Planicka"
  },
  {
    "cast": "Plánička",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Černá v Pošumaví",
    "val": "38226 Cerna v Posumavi Planicka"
  },
  {
    "cast": "Planiny",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Hvožďany",
    "val": "26242 Hvozdany Planiny"
  },
  {
    "cast": "Planiny",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Nové Mitrovice",
    "val": "33563 Nove Mitrovice Planiny"
  },
  {
    "cast": "Plasná",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Pluhův Žďár",
    "val": "37821 Pluhuv Zdar Plasna"
  },
  {
    "cast": "Plástovice",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Sedlec",
    "val": "37348 Sedlec Plastovice"
  },
  {
    "cast": "Plasy",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Plasy",
    "val": "33101 Plasy Plasy"
  },
  {
    "cast": "Platěnice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Moravany",
    "val": "53002 Moravany Platenice"
  },
  {
    "cast": "Platěnsko",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Moravany",
    "val": "53002 Moravany Platensko"
  },
  {
    "cast": "Platoř",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dlouhá Ves",
    "val": "34201 Dlouha Ves Plator"
  },
  {
    "cast": "Plav",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Plav",
    "val": "37007 Plav Plav"
  },
  {
    "cast": "Plaveč (část)",
    "psc": "67132",
    "okres": "Znojmo",
    "obec": "Plaveč",
    "val": "67132 Plavec Plavec (cast)"
  },
  {
    "cast": "Plaveč (část)",
    "psc": "67152",
    "okres": "Znojmo",
    "obec": "Plaveč",
    "val": "67152 Plavec Plavec (cast)"
  },
  {
    "cast": "Plavsko",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Plavsko",
    "val": "37802 Plavsko Plavsko"
  },
  {
    "cast": "Plavy",
    "psc": "46846",
    "okres": "Jablonec nad Nisou",
    "obec": "Plavy",
    "val": "46846 Plavy Plavy"
  },
  {
    "cast": "Plazy",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Plazy",
    "val": "29301 Plazy Plazy"
  },
  {
    "cast": "Plechov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Plechov"
  },
  {
    "cast": "Plechtinec",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Plechtinec"
  },
  {
    "cast": "Plechy",
    "psc": "78803",
    "okres": "Šumperk",
    "obec": "Nový Malín",
    "val": "78803 Novy Malin Plechy"
  },
  {
    "cast": "Plenkovice",
    "psc": "67151",
    "okres": "Znojmo",
    "obec": "Plenkovice",
    "val": "67151 Plenkovice Plenkovice"
  },
  {
    "cast": "Plesná",
    "psc": "35135",
    "okres": "Cheb",
    "obec": "Plesná",
    "val": "35135 Plesna Plesna"
  },
  {
    "cast": "Plesná",
    "psc": "72527",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72527 Ostrava Plesna"
  },
  {
    "cast": "Pleš",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Ples"
  },
  {
    "cast": "Pleše",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Pleše",
    "val": "37821 Plese Plese"
  },
  {
    "cast": "Plešice",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Třebenice",
    "val": "67552 Trebenice Plesice"
  },
  {
    "cast": "Plešiny",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Plesiny"
  },
  {
    "cast": "Plešiště",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Plesiste"
  },
  {
    "cast": "Plešivec",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Plesivec"
  },
  {
    "cast": "Plešivec",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Plesivec"
  },
  {
    "cast": "Plešnice",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Plešnice",
    "val": "33033 Plesnice Plesnice"
  },
  {
    "cast": "Plešovec",
    "psc": "76811",
    "okres": "Kroměříž",
    "obec": "Chropyně",
    "val": "76811 Chropyne Plesovec"
  },
  {
    "cast": "Plešovice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Zlatá Koruna",
    "val": "38101 Zlata Koruna Plesovice"
  },
  {
    "cast": "Pletený Újezd",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Pletený Újezd",
    "val": "27351 Pleteny Ujezd Pleteny Ujezd"
  },
  {
    "cast": "Plevnice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Olešná",
    "val": "39301 Olesna Plevnice"
  },
  {
    "cast": "Plevňov",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Řenče",
    "val": "33401 Rence Plevnov"
  },
  {
    "cast": "Plezom",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Ošelín",
    "val": "34802 Oselin Plezom"
  },
  {
    "cast": "Plhov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Samšina",
    "val": "50601 Samsina Plhov"
  },
  {
    "cast": "Plhov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Červené Janovice",
    "val": "28601 Cervene Janovice Plhov"
  },
  {
    "cast": "Plch",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Plch",
    "val": "53345 Plch Plch"
  },
  {
    "cast": "Plchov",
    "psc": "27375",
    "okres": "Kladno",
    "obec": "Plchov",
    "val": "27375 Plchov Plchov"
  },
  {
    "cast": "Plchovice",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Plchovice",
    "val": "56501 Plchovice Plchovice"
  },
  {
    "cast": "Plchov-Kobylí x)",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Plchov-Kobyli x)"
  },
  {
    "cast": "Plchůvky",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Choceň",
    "val": "56501 Chocen Plchuvky"
  },
  {
    "cast": "Plichtice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Zavlekov",
    "val": "34142 Zavlekov Plichtice"
  },
  {
    "cast": "Plinkout",
    "psc": "78386",
    "okres": "Olomouc",
    "obec": "Dlouhá Loučka",
    "val": "78386 Dlouha Loucka Plinkout"
  },
  {
    "cast": "Plískov",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Plískov",
    "val": "33808 Pliskov Pliskov"
  },
  {
    "cast": "Plíškovice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Pliskovice"
  },
  {
    "cast": "Ploskovice",
    "psc": "41142",
    "okres": "Litoměřice",
    "obec": "Ploskovice",
    "val": "41142 Ploskovice Ploskovice"
  },
  {
    "cast": "Plotiště nad Labem (část)",
    "psc": "50301",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50301 Hradec Kralove Plotiste nad Labem (cast)"
  },
  {
    "cast": "Plotiště nad Labem (část)",
    "psc": "50311",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50311 Hradec Kralove Plotiste nad Labem (cast)"
  },
  {
    "cast": "Ploukonice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Všeň",
    "val": "51101 Vsen Ploukonice"
  },
  {
    "cast": "Ploužnice",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "47124 Ralsko Plouznice"
  },
  {
    "cast": "Ploužnice",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Plouznice"
  },
  {
    "cast": "Pluhův Žďár",
    "psc": "37824",
    "okres": "Jindřichův Hradec",
    "obec": "Pluhův Žďár",
    "val": "37824 Pluhuv Zdar Pluhuv Zdar"
  },
  {
    "cast": "Plumlov",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Plumlov",
    "val": "79803 Plumlov Plumlov"
  },
  {
    "cast": "Plužná",
    "psc": "29423",
    "okres": "Mladá Boleslav",
    "obec": "Plužná",
    "val": "29423 Pluzna Pluzna"
  },
  {
    "cast": "Plzeň 1-Bolevec (část) x)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Plzen 1-Bolevec (cast) x)"
  },
  {
    "cast": "Plzeň 1-Bolevec (část) x)",
    "psc": "31600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31600 Plzen Plzen 1-Bolevec (cast) x)"
  },
  {
    "cast": "Plzeň 1-Bolevec (část) x)",
    "psc": "32300",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32300 Plzen Plzen 1-Bolevec (cast) x)"
  },
  {
    "cast": "Plzeň 1-Severní Předměstí (část) x)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Plzen 1-Severni Predmesti (cast) x)"
  },
  {
    "cast": "Plzeň 1-Severní Předměstí (část) x)",
    "psc": "32300",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32300 Plzen Plzen 1-Severni Predmesti (cast) x)"
  },
  {
    "cast": "Plzeň 2-Božkov x)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Plzen 2-Bozkov x)"
  },
  {
    "cast": "Plzeň 2-Hradiště x)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Plzen 2-Hradiste x)"
  },
  {
    "cast": "Plzeň 2-Koterov x)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Plzen 2-Koterov x)"
  },
  {
    "cast": "Plzeň 3-Jižní Předměstí (část) x)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Plzen 3-Jizni Predmesti (cast) x)"
  },
  {
    "cast": "Plzeň 3-Jižní Předměstí (část) x)",
    "psc": "32100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32100 Plzen Plzen 3-Jizni Predmesti (cast) x)"
  },
  {
    "cast": "Plzeň 3-Nová Hospoda x)",
    "psc": "31800",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31800 Plzen Plzen 3-Nova Hospoda x)"
  },
  {
    "cast": "Plzeň 3-Radobyčice x)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Plzen 3-Radobycice x)"
  },
  {
    "cast": "Plzeň 3-Skvrňany (část) x)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Plzen 3-Skvrnany (cast) x)"
  },
  {
    "cast": "Plzeň 3-Skvrňany (část) x)",
    "psc": "31800",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31800 Plzen Plzen 3-Skvrnany (cast) x)"
  },
  {
    "cast": "Plzeň 3-Valcha (část) x)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Plzen 3-Valcha (cast) x)"
  },
  {
    "cast": "Plzeň 3-Valcha (část) x)",
    "psc": "32100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32100 Plzen Plzen 3-Valcha (cast) x)"
  },
  {
    "cast": "Plzeň 3-Valcha (část) x)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Plzen 3-Valcha (cast) x)"
  },
  {
    "cast": "Plzeň 3-Vnitřní Město x)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Plzen 3-Vnitrni Mesto x)"
  },
  {
    "cast": "Plzeň 4-Bukovec x)",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Plzen 4-Bukovec x)"
  },
  {
    "cast": "Plzeň 4-Červený Hrádek x)",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Plzen 4-Cerveny Hradek x)"
  },
  {
    "cast": "Plzeň 4-Doubravka x)",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Plzen 4-Doubravka x)"
  },
  {
    "cast": "Plzeň 4-Újezd x)",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Plzen 4-Ujezd x)"
  },
  {
    "cast": "Plzeňské Předměstí",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Rokycany",
    "val": "33701 Rokycany Plzenske Predmesti"
  },
  {
    "cast": "Plzeňské Předměstí",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Plzenske Predmesti"
  },
  {
    "cast": "Plzeň-Křimice (část) x)",
    "psc": "31800",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31800 Plzen Plzen-Krimice (cast) x)"
  },
  {
    "cast": "Plzeň-Křimice (část) x)",
    "psc": "32200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32200 Plzen Plzen-Krimice (cast) x)"
  },
  {
    "cast": "Plzeň-Radčice x)",
    "psc": "32200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32200 Plzen Plzen-Radcice x)"
  },
  {
    "cast": "Pnětluky",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Pnětluky",
    "val": "44001 Pnetluky Pnetluky"
  },
  {
    "cast": "Pnětluky",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Podsedice",
    "val": "41115 Podsedice Pnetluky"
  },
  {
    "cast": "Pňov",
    "psc": "28941",
    "okres": "Kolín",
    "obec": "Pňov-Předhradí",
    "val": "28941 Pnov-Predhradi Pnov"
  },
  {
    "cast": "Pňovany",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Pňovany",
    "val": "33033 Pnovany Pnovany"
  },
  {
    "cast": "Pňovice",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Pňovice",
    "val": "78401 Pnovice Pnovice"
  },
  {
    "cast": "Pňovice",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Pnovice"
  },
  {
    "cast": "Pňovičky",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Ohníč",
    "val": "41501 Ohnic Pnovicky"
  },
  {
    "cast": "Poběžovice",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Poběžovice",
    "val": "34522 Pobezovice Pobezovice"
  },
  {
    "cast": "Poběžovice u Holic",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Poběžovice u Holic",
    "val": "53401 Pobezovice u Holic Pobezovice u Holic"
  },
  {
    "cast": "Poběžovice u Přelouče",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Poběžovice u Přelouče",
    "val": "53501 Pobezovice u Prelouce Pobezovice u Prelouce"
  },
  {
    "cast": "Pobistrýce",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Pobistryce"
  },
  {
    "cast": "Poborovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bezděkov",
    "val": "33901 Bezdekov Poborovice"
  },
  {
    "cast": "Poboří",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Plaňany",
    "val": "28002 Planany Pobori"
  },
  {
    "cast": "Pobučí",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Jestřebí",
    "val": "78901 Jestrebi Pobuci"
  },
  {
    "cast": "Pocinovice",
    "psc": "34509",
    "okres": "Domažlice",
    "obec": "Pocinovice",
    "val": "34509 Pocinovice Pocinovice"
  },
  {
    "cast": "Pocinovice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Semněvice",
    "val": "34601 Semnevice Pocinovice"
  },
  {
    "cast": "Pocoucov",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Pocoucov"
  },
  {
    "cast": "Počaply",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Počaply",
    "val": "26272 Pocaply Pocaply"
  },
  {
    "cast": "Počaply",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Sezemice",
    "val": "53304 Sezemice Pocaply"
  },
  {
    "cast": "Počaply",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Terezín",
    "val": "41201 Terezin Pocaply"
  },
  {
    "cast": "Počaply",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Králův Dvůr",
    "val": "26701 Kraluv Dvur Pocaply"
  },
  {
    "cast": "Počátky",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Pocatky"
  },
  {
    "cast": "Počátky",
    "psc": "39464",
    "okres": "Pelhřimov",
    "obec": "Počátky",
    "val": "39464 Pocatky Pocatky"
  },
  {
    "cast": "Počátky",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Pocatky"
  },
  {
    "cast": "Počátky (část)",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Pocatky (cast)"
  },
  {
    "cast": "Počátky (část)",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53843 Sec Pocatky (cast)"
  },
  {
    "cast": "Počedělice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Počedělice",
    "val": "44001 Pocedelice Pocedelice"
  },
  {
    "cast": "Počenice",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Počenice-Tetětice",
    "val": "76833 Pocenice-Tetetice Pocenice"
  },
  {
    "cast": "Počepice",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Počepice",
    "val": "26255 Pocepice Pocepice"
  },
  {
    "cast": "Počeplice",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Poceplice"
  },
  {
    "cast": "Počerady",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Výškov",
    "val": "44001 Vyskov Pocerady"
  },
  {
    "cast": "Počerny",
    "psc": "36017",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36017 Karlovy Vary Pocerny"
  },
  {
    "cast": "Počítky",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Počítky",
    "val": "59101 Pocitky Pocitky"
  },
  {
    "cast": "Pod Bezručovým vrchem",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Krnov",
    "val": "79401 Krnov Pod Bezrucovym vrchem"
  },
  {
    "cast": "Pod Cvilínem",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Krnov",
    "val": "79401 Krnov Pod Cvilinem"
  },
  {
    "cast": "Pod Dubem",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Dašice",
    "val": "53002 Dasice Pod Dubem"
  },
  {
    "cast": "Pod Průhony",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Bavoryně",
    "val": "26751 Bavoryne Pod Pruhony"
  },
  {
    "cast": "Pod Rohem",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Jenišov",
    "val": "36001 Jenisov Pod Rohem"
  },
  {
    "cast": "Pod Školou",
    "psc": "47106",
    "okres": "Česká Lípa",
    "obec": "Horní Police",
    "val": "47106 Horni Police Pod Skolou"
  },
  {
    "cast": "Pod Vinicí",
    "psc": "28129",
    "okres": "Kolín",
    "obec": "Žiželice",
    "val": "28129 Zizelice Pod Vinici"
  },
  {
    "cast": "Podbořánky",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Jesenice",
    "val": "27033 Jesenice Podboranky"
  },
  {
    "cast": "Podbořanský Rohozec",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořanský Rohozec",
    "val": "44101 Podboransky Rohozec Podboransky Rohozec"
  },
  {
    "cast": "Podbořany",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Podborany"
  },
  {
    "cast": "Podboří",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Opařany",
    "val": "39161 Oparany Podbori"
  },
  {
    "cast": "Podbradec",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Mšené-lázně",
    "val": "41119 Msene-lazne Podbradec"
  },
  {
    "cast": "Podbrahy",
    "psc": "29474",
    "okres": "Mladá Boleslav",
    "obec": "Skorkov",
    "val": "29474 Skorkov Podbrahy"
  },
  {
    "cast": "Podbrdy",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Podbrdy",
    "val": "26727 Podbrdy Podbrdy"
  },
  {
    "cast": "Podbřezí (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Podbřezí",
    "val": "51801 Podbrezi Podbrezi (cast)"
  },
  {
    "cast": "Podbřezí (část)",
    "psc": "51803",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Podbřezí",
    "val": "51803 Podbrezi Podbrezi (cast)"
  },
  {
    "cast": "Podbřežice",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Podbřežice",
    "val": "68301 Podbrezice Podbrezice"
  },
  {
    "cast": "Poddoubí",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Vyskeř",
    "val": "51101 Vysker Poddoubi"
  },
  {
    "cast": "Poddubí",
    "psc": "25165",
    "okres": "Praha-východ",
    "obec": "Kaliště",
    "val": "25165 Kaliste Poddubi"
  },
  {
    "cast": "Poděbaby",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Podebaby"
  },
  {
    "cast": "Poděbrady I",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Podebrady I"
  },
  {
    "cast": "Poděbrady II",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Podebrady II"
  },
  {
    "cast": "Poděbrady III",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Podebrady III"
  },
  {
    "cast": "Poděbrady IV",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Podebrady IV"
  },
  {
    "cast": "Poděbrady V",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Podebrady V"
  },
  {
    "cast": "Poděčely",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Chroustovice",
    "val": "53863 Chroustovice Podecely"
  },
  {
    "cast": "Podělusy",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25741 Tynec nad Sazavou Podelusy"
  },
  {
    "cast": "Podeřiště",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Malovice",
    "val": "38411 Malovice Poderiste"
  },
  {
    "cast": "Poděšín",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Poděšín",
    "val": "59212 Podesin Podesin"
  },
  {
    "cast": "Poděvousy",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Poděvousy",
    "val": "34561 Podevousy Podevousy"
  },
  {
    "cast": "Podhájí",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Radim",
    "val": "50713 Radim Podhaji"
  },
  {
    "cast": "Podhájí",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Podhaji"
  },
  {
    "cast": "Podhájí",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Podhaji"
  },
  {
    "cast": "Podhora",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Kobyly",
    "val": "46343 Kobyly Podhora"
  },
  {
    "cast": "Podhora",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Mohelnice nad Jizerou",
    "val": "29413 Mohelnice nad Jizerou Podhora"
  },
  {
    "cast": "Podhorky",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Choltice",
    "val": "53501 Choltice Podhorky"
  },
  {
    "cast": "Podhorní Újezd",
    "psc": "50754",
    "okres": "Jičín",
    "obec": "Podhorní Újezd a Vojice",
    "val": "50754 Podhorni Ujezd a Vojice Podhorni Ujezd"
  },
  {
    "cast": "Podhořany",
    "psc": "27751",
    "okres": "Mělník",
    "obec": "Nelahozeves",
    "val": "27751 Nelahozeves Podhorany"
  },
  {
    "cast": "Podhořany u Nových Hradů",
    "psc": "53944",
    "okres": "Ústí nad Orlicí",
    "obec": "Leština",
    "val": "53944 Lestina Podhorany u Novych Hradu"
  },
  {
    "cast": "Podhořany u Ronova (část)",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Podhořany u Ronova",
    "val": "53803 Podhorany u Ronova Podhorany u Ronova (cast)"
  },
  {
    "cast": "Podhořany u Ronova (část)",
    "psc": "53841",
    "okres": "Chrudim",
    "obec": "Podhořany u Ronova",
    "val": "53841 Podhorany u Ronova Podhorany u Ronova (cast)"
  },
  {
    "cast": "Podhoří",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Podhori"
  },
  {
    "cast": "Podhořice",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Jeřišno",
    "val": "58301 Jerisno Podhorice"
  },
  {
    "cast": "Podhoří-Lipník nad Bečvou V x)",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lipník nad Bečvou",
    "val": "75131 Lipnik nad Becvou Podhori-Lipnik nad Becvou V x)"
  },
  {
    "cast": "Podhrad",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Podhrad"
  },
  {
    "cast": "Podhradí",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Podhradí",
    "val": "35201 Podhradi Podhradi"
  },
  {
    "cast": "Podhradí",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74901 Vitkov Podhradi"
  },
  {
    "cast": "Podhradí",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Podhradí",
    "val": "50601 Podhradi Podhradi"
  },
  {
    "cast": "Podhradí",
    "psc": "76326",
    "okres": "Zlín",
    "obec": "Podhradí",
    "val": "76326 Podhradi Podhradi"
  },
  {
    "cast": "Podhradí",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Třemošnice",
    "val": "53843 Tremosnice Podhradi"
  },
  {
    "cast": "Podhradí",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Podhradi"
  },
  {
    "cast": "Podhradí nad Dyjí (část)",
    "psc": "67106",
    "okres": "Znojmo",
    "obec": "Podhradí nad Dyjí",
    "val": "67106 Podhradi nad Dyji Podhradi nad Dyji (cast)"
  },
  {
    "cast": "Podhradí nad Dyjí (část)",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Podhradí nad Dyjí",
    "val": "67107 Podhradi nad Dyji Podhradi nad Dyji (cast)"
  },
  {
    "cast": "Podhradní Lhota",
    "psc": "76871",
    "okres": "Kroměříž",
    "obec": "Podhradní Lhota",
    "val": "76871 Podhradni Lhota Podhradni Lhota"
  },
  {
    "cast": "Podhráz",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Holice",
    "val": "53401 Holice Podhraz"
  },
  {
    "cast": "Podhůří",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Kasejovice",
    "val": "33501 Kasejovice Podhuri"
  },
  {
    "cast": "Podhůří (část)",
    "psc": "54301",
    "okres": "Trutnov",
    "obec": "Vrchlabí",
    "val": "54301 Vrchlabi Podhuri (cast)"
  },
  {
    "cast": "Podhůří (část)",
    "psc": "54303",
    "okres": "Trutnov",
    "obec": "Vrchlabí",
    "val": "54303 Vrchlabi Podhuri (cast)"
  },
  {
    "cast": "Podchlumí",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Semechnice",
    "val": "51801 Semechnice Podchlumi"
  },
  {
    "cast": "Podchlumí",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Podchlumi"
  },
  {
    "cast": "Podchýšská Lhota",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Podchysska Lhota"
  },
  {
    "cast": "Podivice",
    "psc": "68321",
    "okres": "Vyškov",
    "obec": "Podivice",
    "val": "68321 Podivice Podivice"
  },
  {
    "cast": "Podivice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Kaliště",
    "val": "39601 Kaliste Podivice"
  },
  {
    "cast": "Podivín",
    "psc": "69145",
    "okres": "Břeclav",
    "obec": "Podivín",
    "val": "69145 Podivin Podivin"
  },
  {
    "cast": "Podjestřábí",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46343 Vselibice Podjestrabi"
  },
  {
    "cast": "Podklášteří",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Podklasteri"
  },
  {
    "cast": "Podkopná Lhota",
    "psc": "76318",
    "okres": "Zlín",
    "obec": "Podkopná Lhota",
    "val": "76318 Podkopna Lhota Podkopna Lhota"
  },
  {
    "cast": "Podkost",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50601 Libosovice Podkost"
  },
  {
    "cast": "Podkozí",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Chyňava",
    "val": "26601 Chynava Podkozi"
  },
  {
    "cast": "Podlázky",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Mladá Boleslav",
    "val": "29301 Mlada Boleslav Podlazky"
  },
  {
    "cast": "Podlažice",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Chrast",
    "val": "53851 Chrast Podlazice"
  },
  {
    "cast": "Podlesí",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Dolní Žandov",
    "val": "35002 Dolni Zandov Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Podlesí",
    "val": "26101 Podlesi Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "73601",
    "okres": "Karviná",
    "obec": "Havířov",
    "val": "73601 Havirov Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Sněžné",
    "val": "59202 Snezne Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Světlá Hora",
    "val": "79331 Svetla Hora Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Sadov",
    "val": "36001 Sadov Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Holice",
    "val": "53401 Holice Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Horní Police",
    "val": "47002 Horni Police Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Valašské Meziříčí",
    "val": "75701 Valasske Mezirici Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "74787",
    "okres": "Opava",
    "obec": "Budišov nad Budišovkou",
    "val": "74787 Budisov nad Budisovkou Podlesi"
  },
  {
    "cast": "Podlesí",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Město pod Landštejnem",
    "val": "37881 Stare Mesto pod Landstejnem Podlesi"
  },
  {
    "cast": "Podlesí (část)",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Brněnec",
    "val": "56904 Brnenec Podlesi (cast)"
  },
  {
    "cast": "Podlesí (část)",
    "psc": "56902",
    "okres": "Svitavy",
    "obec": "Brněnec",
    "val": "56902 Brnenec Podlesi (cast)"
  },
  {
    "cast": "Podlesice",
    "psc": "44101",
    "okres": "Chomutov",
    "obec": "Veliká Ves",
    "val": "44101 Velika Ves Podlesice"
  },
  {
    "cast": "Podlešín",
    "psc": "27325",
    "okres": "Kladno",
    "obec": "Podlešín",
    "val": "27325 Podlesin Podlesin"
  },
  {
    "cast": "Podlešín",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Stebno",
    "val": "40002 Stebno Podlesin"
  },
  {
    "cast": "Podlevín",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Podlevin"
  },
  {
    "cast": "Podlíšťany",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Nasavrky",
    "val": "53825 Nasavrky Podlistany"
  },
  {
    "cast": "Podluhy",
    "psc": "26801",
    "okres": "Beroun",
    "obec": "Podluhy",
    "val": "26801 Podluhy Podluhy"
  },
  {
    "cast": "Podlusky",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Roudnice nad Labem",
    "val": "41301 Roudnice nad Labem Podlusky"
  },
  {
    "cast": "Podlužany",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Rožďalovice",
    "val": "28934 Rozdalovice Podluzany"
  },
  {
    "cast": "Podmaršovice",
    "psc": "25755",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25755 Marsovice Podmarsovice"
  },
  {
    "cast": "Podměstí",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Proseč",
    "val": "53944 Prosec Podmesti"
  },
  {
    "cast": "Podmoklany",
    "psc": "58264",
    "okres": "Havlíčkův Brod",
    "obec": "Podmoklany",
    "val": "58264 Podmoklany Podmoklany"
  },
  {
    "cast": "Podmoklice",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Semily",
    "val": "51301 Semily Podmoklice"
  },
  {
    "cast": "Podmokly",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Podmokly",
    "val": "33808 Podmokly Podmokly"
  },
  {
    "cast": "Podmokly",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Podmokly",
    "val": "34201 Podmokly Podmokly"
  },
  {
    "cast": "Podmokly",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33035 Unesov Podmokly"
  },
  {
    "cast": "Podmokly-Děčín IV x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Podmokly-Decin IV x)"
  },
  {
    "cast": "Podmoky",
    "psc": "28904",
    "okres": "Nymburk",
    "obec": "Podmoky",
    "val": "28904 Podmoky Podmoky"
  },
  {
    "cast": "Podmoky",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Podmoky",
    "val": "58282 Podmoky Podmoky"
  },
  {
    "cast": "Podmoky",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Podmoky"
  },
  {
    "cast": "Podmolí",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Podmolí",
    "val": "66902 Podmoli Podmoli"
  },
  {
    "cast": "Podmyče",
    "psc": "67106",
    "okres": "Znojmo",
    "obec": "Podmyče",
    "val": "67106 Podmyce Podmyce"
  },
  {
    "cast": "Podol",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Podol"
  },
  {
    "cast": "Podolanka (část)",
    "psc": "25073",
    "okres": "Praha-východ",
    "obec": "Podolanka",
    "val": "25073 Podolanka Podolanka (cast)"
  },
  {
    "cast": "Podolanka (část)",
    "psc": "25001",
    "okres": "Praha-východ",
    "obec": "Podolanka",
    "val": "25001 Podolanka Podolanka (cast)"
  },
  {
    "cast": "Podolí",
    "psc": "75644",
    "okres": "Vsetín",
    "obec": "Podolí",
    "val": "75644 Podoli Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Jankov",
    "val": "25703 Jankov Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "75116",
    "okres": "Přerov",
    "obec": "Podolí",
    "val": "75116 Podoli Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Mohelnice",
    "val": "78985 Mohelnice Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Borač",
    "val": "59261 Borac Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Rožďalovice",
    "val": "28934 Rozdalovice Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "59255",
    "okres": "Žďár nad Sázavou",
    "obec": "Podolí",
    "val": "59255 Podoli Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Radomyšl",
    "val": "38601 Radomysl Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "68604",
    "okres": "Uherské Hradiště",
    "obec": "Podolí",
    "val": "68604 Podoli Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25753 Vojkov Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Ratibořské Hory",
    "val": "39143 Ratiborske Hory Podoli"
  },
  {
    "cast": "Podolí",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25753 Olbramovice Podoli"
  },
  {
    "cast": "Podolí I",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Podolí I",
    "val": "39843 Podoli I Podoli I"
  },
  {
    "cast": "Podolí II",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Podoli II"
  },
  {
    "cast": "Podolí (část)",
    "psc": "62700",
    "okres": "Brno-venkov",
    "obec": "Podolí",
    "val": "62700 Podoli Podoli (cast)"
  },
  {
    "cast": "Podolí (část)",
    "psc": "14000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14000 Praha Podoli (cast)"
  },
  {
    "cast": "Podolí (část)",
    "psc": "66403",
    "okres": "Brno-venkov",
    "obec": "Podolí",
    "val": "66403 Podoli Podoli (cast)"
  },
  {
    "cast": "Podolí (část)",
    "psc": "14700",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14700 Praha Podoli (cast)"
  },
  {
    "cast": "Podolí (část)",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Podoli (cast)"
  },
  {
    "cast": "Podolí (část)",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29413 Mnichovo Hradiste Podoli (cast)"
  },
  {
    "cast": "Podoliby",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Králíky",
    "val": "50315 Kraliky Podoliby"
  },
  {
    "cast": "Podolsko",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Podolí I",
    "val": "39843 Podoli I Podolsko"
  },
  {
    "cast": "Podomí",
    "psc": "68304",
    "okres": "Vyškov",
    "obec": "Podomí",
    "val": "68304 Podomi Podomi"
  },
  {
    "cast": "Poďousy",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Bečváry",
    "val": "28144 Becvary Podousy"
  },
  {
    "cast": "Podrážek",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Choceň",
    "val": "56501 Chocen Podrazek"
  },
  {
    "cast": "Podražnice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Podraznice"
  },
  {
    "cast": "Podruhlí",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Bělčice",
    "val": "38801 Belcice Podruhli"
  },
  {
    "cast": "Podsedice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Podsedice",
    "val": "41115 Podsedice Podsedice"
  },
  {
    "cast": "Podstrání",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Rovná",
    "val": "35601 Rovna Podstrani"
  },
  {
    "cast": "Podštěly",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Podstely"
  },
  {
    "cast": "Podtýn",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Žernov",
    "val": "51263 Zernov Podtyn"
  },
  {
    "cast": "Podůlšany",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Podůlšany",
    "val": "53345 Podulsany Podulsany"
  },
  {
    "cast": "Podůlší",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Podůlší",
    "val": "50601 Podulsi Podulsi"
  },
  {
    "cast": "Podveky",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Podveky",
    "val": "28506 Podveky Podveky"
  },
  {
    "cast": "Podvihov",
    "psc": "74706",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74706 Opava Podvihov"
  },
  {
    "cast": "Podviní",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Trnovany",
    "val": "41201 Trnovany Podvini"
  },
  {
    "cast": "Podvlčí",
    "psc": "27701",
    "okres": "Mělník",
    "obec": "Dolní Beřkovice",
    "val": "27701 Dolni Berkovice Podvlci"
  },
  {
    "cast": "Podzámčí",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Podzamci"
  },
  {
    "cast": "Pohled",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Mladoňovice",
    "val": "53821 Mladonovice Pohled"
  },
  {
    "cast": "Pohleď",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Pohleď",
    "val": "58291 Pohled Pohled"
  },
  {
    "cast": "Pohled (část)",
    "psc": "58221",
    "okres": "Havlíčkův Brod",
    "obec": "Pohled",
    "val": "58221 Pohled Pohled (cast)"
  },
  {
    "cast": "Pohled (část)",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Pohled",
    "val": "58222 Pohled Pohled (cast)"
  },
  {
    "cast": "Pohledec",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Pohledec"
  },
  {
    "cast": "Pohledy",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Pohledy",
    "val": "56802 Pohledy Pohledy"
  },
  {
    "cast": "Pohnánec",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Pohnánec",
    "val": "39143 Pohnanec Pohnanec"
  },
  {
    "cast": "Pohnání",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Pohnání",
    "val": "39143 Pohnani Pohnani"
  },
  {
    "cast": "Pohodlí",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Pohodli"
  },
  {
    "cast": "Pohora",
    "psc": "79847",
    "okres": "Prostějov",
    "obec": "Horní Štěpánov",
    "val": "79847 Horni Stepanov Pohora"
  },
  {
    "cast": "Pohorovice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Pohorovice",
    "val": "38901 Pohorovice Pohorovice"
  },
  {
    "cast": "Pohorská Ves",
    "psc": "38283",
    "okres": "Český Krumlov",
    "obec": "Pohorská Ves",
    "val": "38283 Pohorska Ves Pohorska Ves"
  },
  {
    "cast": "Pohorsko",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Nezdice na Šumavě",
    "val": "34201 Nezdice na Sumave Pohorsko"
  },
  {
    "cast": "Pohoř",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74235 Odry Pohor"
  },
  {
    "cast": "Pohořalka",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Liboměřice",
    "val": "53821 Libomerice Pohoralka"
  },
  {
    "cast": "Pohořany",
    "psc": "41141",
    "okres": "Litoměřice",
    "obec": "Žitenice",
    "val": "41141 Zitenice Pohorany"
  },
  {
    "cast": "Pohořany",
    "psc": "78316",
    "okres": "Olomouc",
    "obec": "Dolany",
    "val": "78316 Dolany Pohorany"
  },
  {
    "cast": "Pohořelice",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Pohorelice"
  },
  {
    "cast": "Pohořelice",
    "psc": "76361",
    "okres": "Zlín",
    "obec": "Pohořelice",
    "val": "76361 Pohorelice Pohorelice"
  },
  {
    "cast": "Pohořelice",
    "psc": "69123",
    "okres": "Brno-venkov",
    "obec": "Pohořelice",
    "val": "69123 Pohorelice Pohorelice"
  },
  {
    "cast": "Pohoří",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34034 Planice Pohori"
  },
  {
    "cast": "Pohoří",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mišovice",
    "val": "39804 Misovice Pohori"
  },
  {
    "cast": "Pohoří",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Olešnice",
    "val": "51101 Olesnice Pohori"
  },
  {
    "cast": "Pohoří",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Pohori"
  },
  {
    "cast": "Pohoří",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Pohoří",
    "val": "25401 Pohori Pohori"
  },
  {
    "cast": "Pohoří",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Pohoří",
    "val": "51801 Pohori Pohori"
  },
  {
    "cast": "Pohoří",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Stružinec",
    "val": "51251 Struzinec Pohori"
  },
  {
    "cast": "Pohoří",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40002 Malecov Pohori"
  },
  {
    "cast": "Pohoří",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Pluhův Žďár",
    "val": "37821 Pluhuv Zdar Pohori"
  },
  {
    "cast": "Pohoří na Šumavě",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Pohorská Ves",
    "val": "38241 Pohorska Ves Pohori na Sumave"
  },
  {
    "cast": "Pohořice",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Martiněves",
    "val": "41119 Martineves Pohorice"
  },
  {
    "cast": "Pohořílky",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Pohorilky"
  },
  {
    "cast": "Pohořílky",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Otín",
    "val": "59401 Otin Pohorilky"
  },
  {
    "cast": "Pohránov",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Srch",
    "val": "53345 Srch Pohranov"
  },
  {
    "cast": "Pohřebačka",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Opatovice nad Labem",
    "val": "53345 Opatovice nad Labem Pohrebacka"
  },
  {
    "cast": "Pocheň",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Široká Niva",
    "val": "79201 Siroka Niva Pochen"
  },
  {
    "cast": "Pocheň",
    "psc": "74771",
    "okres": "Opava",
    "obec": "Brumovice",
    "val": "74771 Brumovice Pochen"
  },
  {
    "cast": "Pochvalov",
    "psc": "27055",
    "okres": "Rakovník",
    "obec": "Pochvalov",
    "val": "27055 Pochvalov Pochvalov"
  },
  {
    "cast": "Pojbuky",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Pojbuky",
    "val": "39143 Pojbuky Pojbuky"
  },
  {
    "cast": "Pojedy",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Žitovlice",
    "val": "28934 Zitovlice Pojedy"
  },
  {
    "cast": "Pokojov",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Pokojov",
    "val": "59214 Pokojov Pokojov"
  },
  {
    "cast": "Pokojovice",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Pokojovice",
    "val": "67521 Pokojovice Pokojovice"
  },
  {
    "cast": "Pokratice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Litoměřice",
    "val": "41201 Litomerice Pokratice"
  },
  {
    "cast": "Pokřikov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Pokřikov",
    "val": "53901 Pokrikov Pokrikov"
  },
  {
    "cast": "Pokutice",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Pokutice"
  },
  {
    "cast": "Polabec",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Polabec"
  },
  {
    "cast": "Polabiny (část)",
    "psc": "53009",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53009 Pardubice Polabiny (cast)"
  },
  {
    "cast": "Polabiny (část)",
    "psc": "53353",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53353 Pardubice Polabiny (cast)"
  },
  {
    "cast": "Polabiny (část)",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53352 Pardubice Polabiny (cast)"
  },
  {
    "cast": "Poláky",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43801 Chbany Polaky"
  },
  {
    "cast": "Polánka",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vlašim",
    "val": "25801 Vlasim Polanka"
  },
  {
    "cast": "Polánka",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Krásné",
    "val": "53825 Krasne Polanka"
  },
  {
    "cast": "Polánka",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Polanka"
  },
  {
    "cast": "Polánka",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Polánka",
    "val": "33501 Polanka Polanka"
  },
  {
    "cast": "Polánka",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Malešov",
    "val": "28401 Malesov Polanka"
  },
  {
    "cast": "Polánka",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Kasejovice",
    "val": "33544 Kasejovice Polanka"
  },
  {
    "cast": "Polánka",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Moravský Krumlov",
    "val": "67201 Moravsky Krumlov Polanka"
  },
  {
    "cast": "Polanka nad Odrou",
    "psc": "72525",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72525 Ostrava Polanka nad Odrou"
  },
  {
    "cast": "Polánky nad Dědinou (část)",
    "psc": "51771",
    "okres": "Hradec Králové",
    "obec": "Třebechovice pod Orebem",
    "val": "51771 Trebechovice pod Orebem Polanky nad Dedinou (cast)"
  },
  {
    "cast": "Polánky nad Dědinou (část)",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Třebechovice pod Orebem",
    "val": "50346 Trebechovice pod Orebem Polanky nad Dedinou (cast)"
  },
  {
    "cast": "Poldovka",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Volfířov",
    "val": "38001 Volfirov Poldovka"
  },
  {
    "cast": "Pole",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Kadov",
    "val": "38801 Kadov Pole"
  },
  {
    "cast": "Pole",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Pole"
  },
  {
    "cast": "Poleň",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Poleň",
    "val": "33901 Polen Polen"
  },
  {
    "cast": "Poleňka",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Poleň",
    "val": "33901 Polen Polenka"
  },
  {
    "cast": "Polepy",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Polepy",
    "val": "28002 Polepy Polepy"
  },
  {
    "cast": "Polepy (část)",
    "psc": "41147",
    "okres": "Litoměřice",
    "obec": "Polepy",
    "val": "41147 Polepy Polepy (cast)"
  },
  {
    "cast": "Polepy (část)",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Polepy",
    "val": "41201 Polepy Polepy (cast)"
  },
  {
    "cast": "Polerady",
    "psc": "43401",
    "okres": "Most",
    "obec": "Polerady",
    "val": "43401 Polerady Polerady"
  },
  {
    "cast": "Polerady",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Polerady",
    "val": "25063 Polerady Polerady"
  },
  {
    "cast": "Polesí",
    "psc": "39464",
    "okres": "Pelhřimov",
    "obec": "Polesí",
    "val": "39464 Polesi Polesi"
  },
  {
    "cast": "Polesí",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Rynoltice",
    "val": "46353 Rynoltice Polesi"
  },
  {
    "cast": "Polešovice",
    "psc": "68737",
    "okres": "Uherské Hradiště",
    "obec": "Polešovice",
    "val": "68737 Polesovice Polesovice"
  },
  {
    "cast": "Polevsko",
    "psc": "47116",
    "okres": "Česká Lípa",
    "obec": "Polevsko",
    "val": "47116 Polevsko Polevsko"
  },
  {
    "cast": "Police",
    "psc": "78973",
    "okres": "Šumperk",
    "obec": "Police",
    "val": "78973 Police Police"
  },
  {
    "cast": "Police",
    "psc": "75644",
    "okres": "Vsetín",
    "obec": "Police",
    "val": "75644 Police Police"
  },
  {
    "cast": "Police",
    "psc": "67534",
    "okres": "Třebíč",
    "obec": "Police",
    "val": "67534 Police Police"
  },
  {
    "cast": "Police nad Metují",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Police nad Metují",
    "val": "54954 Police nad Metuji Police nad Metuji"
  },
  {
    "cast": "Poličany",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Policany"
  },
  {
    "cast": "Poličany",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Policany"
  },
  {
    "cast": "Polička-Město",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Polička",
    "val": "57201 Policka Policka-Mesto"
  },
  {
    "cast": "Poličky",
    "psc": "79826",
    "okres": "Prostějov",
    "obec": "Doloplazy",
    "val": "79826 Doloplazy Policky"
  },
  {
    "cast": "Poličná",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Poličná",
    "val": "75701 Policna Policna"
  },
  {
    "cast": "Polichno",
    "psc": "76341",
    "okres": "Zlín",
    "obec": "Luhačovice",
    "val": "76341 Luhacovice Polichno"
  },
  {
    "cast": "Políkno",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Polikno"
  },
  {
    "cast": "Políkno",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Polikno"
  },
  {
    "cast": "Polínka",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Krsy",
    "val": "33038 Krsy Polinka"
  },
  {
    "cast": "Polipsy",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Čestín",
    "val": "28522 Cestin Polipsy"
  },
  {
    "cast": "Polizy",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Osice",
    "val": "50327 Osice Polizy"
  },
  {
    "cast": "Polka",
    "psc": "79064",
    "okres": "Jeseník",
    "obec": "Vápenná",
    "val": "79064 Vapenna Polka"
  },
  {
    "cast": "Polka",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Horní Vltavice",
    "val": "38501 Horni Vltavice Polka"
  },
  {
    "cast": "Polkovice",
    "psc": "75144",
    "okres": "Přerov",
    "obec": "Polkovice",
    "val": "75144 Polkovice Polkovice"
  },
  {
    "cast": "Polná",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Hazlov",
    "val": "35201 Hazlov Polna"
  },
  {
    "cast": "Polná na Šumavě",
    "psc": "38229",
    "okres": "Český Krumlov",
    "obec": "Polná na Šumavě",
    "val": "38229 Polna na Sumave Polna na Sumave"
  },
  {
    "cast": "Polná (část)",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Polná",
    "val": "58813 Polna Polna (cast)"
  },
  {
    "cast": "Polná (část)",
    "psc": "58252",
    "okres": "Jihlava",
    "obec": "Polná",
    "val": "58252 Polna Polna (cast)"
  },
  {
    "cast": "Polní Chrčice (část)",
    "psc": "28130",
    "okres": "Kolín",
    "obec": "Polní Chrčice",
    "val": "28130 Polni Chrcice Polni Chrcice (cast)"
  },
  {
    "cast": "Polní Chrčice (část)",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Polní Chrčice",
    "val": "28002 Polni Chrcice Polni Chrcice (cast)"
  },
  {
    "cast": "Polní Voděrady",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Polní Voděrady",
    "val": "28002 Polni Voderady Polni Voderady"
  },
  {
    "cast": "Polnička",
    "psc": "59102",
    "okres": "Žďár nad Sázavou",
    "obec": "Polnička",
    "val": "59102 Polnicka Polnicka"
  },
  {
    "cast": "Polom",
    "psc": "75364",
    "okres": "Přerov",
    "obec": "Polom",
    "val": "75364 Polom Polom"
  },
  {
    "cast": "Polom",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Polom"
  },
  {
    "cast": "Polom",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Sulkovec",
    "val": "59265 Sulkovec Polom"
  },
  {
    "cast": "Polom",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Trhová Kamenice",
    "val": "53901 Trhova Kamenice Polom"
  },
  {
    "cast": "Polom",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Polom",
    "val": "51741 Polom Polom"
  },
  {
    "cast": "Polom",
    "psc": "51791",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Sedloňov",
    "val": "51791 Sedlonov Polom"
  },
  {
    "cast": "Polomí",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Polomí",
    "val": "79855 Polomi Polomi"
  },
  {
    "cast": "Poloučany",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Konstantinovy Lázně",
    "val": "34952 Konstantinovy Lazne Poloucany"
  },
  {
    "cast": "Polouvsí",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Jeseník nad Odrou",
    "val": "74101 Jesenik nad Odrou Polouvsi"
  },
  {
    "cast": "Polště",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Polště",
    "val": "37701 Polste Polste"
  },
  {
    "cast": "Polubný",
    "psc": "46850",
    "okres": "Jablonec nad Nisou",
    "obec": "Kořenov",
    "val": "46850 Korenov Polubny"
  },
  {
    "cast": "Polžice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Srby",
    "val": "34601 Srby Polzice"
  },
  {
    "cast": "Polžov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Mokrý Lom",
    "val": "37401 Mokry Lom Polzov"
  },
  {
    "cast": "Pomezí",
    "psc": "56971",
    "okres": "Svitavy",
    "obec": "Pomezí",
    "val": "56971 Pomezi Pomezi"
  },
  {
    "cast": "Pomezí",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34506 Vseruby Pomezi"
  },
  {
    "cast": "Pomezí",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Město pod Landštejnem",
    "val": "37881 Stare Mesto pod Landstejnem Pomezi"
  },
  {
    "cast": "Pomezí nad Ohří",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Pomezí nad Ohří",
    "val": "35002 Pomezi nad Ohri Pomezi nad Ohri"
  },
  {
    "cast": "Pomeznice",
    "psc": "54983",
    "okres": "Náchod",
    "obec": "Meziměstí",
    "val": "54983 Mezimesti Pomeznice"
  },
  {
    "cast": "Pomněnice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Pomnenice"
  },
  {
    "cast": "Ponava (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Ponava (cast)"
  },
  {
    "cast": "Ponava (část)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Ponava (cast)"
  },
  {
    "cast": "Ponědraž",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Ponědraž",
    "val": "37901 Ponedraz Ponedraz"
  },
  {
    "cast": "Ponědrážka",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Ponědrážka",
    "val": "37901 Ponedrazka Ponedrazka"
  },
  {
    "cast": "Poněšice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37341 Hluboka nad Vltavou Ponesice"
  },
  {
    "cast": "Ponětovice",
    "psc": "66451",
    "okres": "Brno-venkov",
    "obec": "Ponětovice",
    "val": "66451 Ponetovice Ponetovice"
  },
  {
    "cast": "Ponikev",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Ludmírov",
    "val": "79852 Ludmirov Ponikev"
  },
  {
    "cast": "Poniklá (část)",
    "psc": "51242",
    "okres": "Semily",
    "obec": "Poniklá",
    "val": "51242 Ponikla Ponikla (cast)"
  },
  {
    "cast": "Poniklá (část)",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Poniklá",
    "val": "51401 Ponikla Ponikla (cast)"
  },
  {
    "cast": "Popelín",
    "psc": "37855",
    "okres": "Jindřichův Hradec",
    "obec": "Popelín",
    "val": "37855 Popelin Popelin"
  },
  {
    "cast": "Popelištná",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Červená Řečice",
    "val": "39301 Cervena Recice Popelistna"
  },
  {
    "cast": "Popelná",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Nicov",
    "val": "38473 Nicov Popelna"
  },
  {
    "cast": "Popice",
    "psc": "69127",
    "okres": "Břeclav",
    "obec": "Popice",
    "val": "69127 Popice Popice"
  },
  {
    "cast": "Popice",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "66902 Znojmo Popice"
  },
  {
    "cast": "Popice",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Popice"
  },
  {
    "cast": "Popkovice",
    "psc": "53006",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53006 Pardubice Popkovice"
  },
  {
    "cast": "Poplze",
    "psc": "41117",
    "okres": "Litoměřice",
    "obec": "Libochovice",
    "val": "41117 Libochovice Poplze"
  },
  {
    "cast": "Popov",
    "psc": "33023",
    "okres": "Tachov",
    "obec": "Kostelec",
    "val": "33023 Kostelec Popov"
  },
  {
    "cast": "Popov",
    "psc": "76333",
    "okres": "Zlín",
    "obec": "Štítná nad Vláří-Popov",
    "val": "76333 Stitna nad Vlari-Popov Popov"
  },
  {
    "cast": "Popovec",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Zběšičky",
    "val": "39843 Zbesicky Popovec"
  },
  {
    "cast": "Popovec (část)",
    "psc": "53854",
    "okres": "Ústí nad Orlicí",
    "obec": "Řepníky",
    "val": "53854 Repniky Popovec (cast)"
  },
  {
    "cast": "Popovec (část)",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Řepníky",
    "val": "56601 Repniky Popovec (cast)"
  },
  {
    "cast": "Popovec (část)",
    "psc": "53863",
    "okres": "Ústí nad Orlicí",
    "obec": "Řepníky",
    "val": "53863 Repniky Popovec (cast)"
  },
  {
    "cast": "Popovice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Popovice",
    "val": "25701 Popovice Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Všeruby",
    "val": "33035 Vseruby Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "35301 Tepla Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "66461",
    "okres": "Brno-venkov",
    "obec": "Popovice",
    "val": "66461 Popovice Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Třesovice",
    "val": "50315 Tresovice Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "68604",
    "okres": "Uherské Hradiště",
    "obec": "Popovice",
    "val": "68604 Popovice Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "76812",
    "okres": "Kroměříž",
    "obec": "Rataje",
    "val": "76812 Rataje Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Králův Dvůr",
    "val": "26701 Kraluv Dvur Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Dolní Bukovsko",
    "val": "37365 Dolni Bukovsko Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Jaroměřice nad Rokytnou",
    "val": "67551 Jaromerice nad Rokytnou Popovice"
  },
  {
    "cast": "Popovice",
    "psc": "25001",
    "okres": "Praha-východ",
    "obec": "Brandýs nad Labem-Stará Boleslav",
    "val": "25001 Brandys nad Labem-Stara Boleslav Popovice"
  },
  {
    "cast": "Popovice-Děčín XXIII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Popovice-Decin XXIII x)"
  },
  {
    "cast": "Popovice-Přerov X x)",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Popovice-Prerov X x)"
  },
  {
    "cast": "Popovičky",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Popovičky",
    "val": "25101 Popovicky Popovicky"
  },
  {
    "cast": "Popůvky",
    "psc": "67575",
    "okres": "Třebíč",
    "obec": "Popůvky",
    "val": "67575 Popuvky Popuvky"
  },
  {
    "cast": "Popůvky",
    "psc": "66441",
    "okres": "Brno-venkov",
    "obec": "Popůvky",
    "val": "66441 Popuvky Popuvky"
  },
  {
    "cast": "Popůvky-Kojetín II x)",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Kojetín",
    "val": "75201 Kojetin Popuvky-Kojetin II x)"
  },
  {
    "cast": "Porešín",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Poresin"
  },
  {
    "cast": "Pornice",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Pačlavice",
    "val": "76833 Paclavice Pornice"
  },
  {
    "cast": "Poruba",
    "psc": "70800",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70800 Ostrava Poruba"
  },
  {
    "cast": "Poruba",
    "psc": "75366",
    "okres": "Přerov",
    "obec": "Hustopeče nad Bečvou",
    "val": "75366 Hustopece nad Becvou Poruba"
  },
  {
    "cast": "Poruba (část)",
    "psc": "73511",
    "okres": "Karviná",
    "obec": "Orlová",
    "val": "73511 Orlova Poruba (cast)"
  },
  {
    "cast": "Poruba (část)",
    "psc": "73514",
    "okres": "Karviná",
    "obec": "Orlová",
    "val": "73514 Orlova Poruba (cast)"
  },
  {
    "cast": "Pořešice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Vysoký Chlumec",
    "val": "26401 Vysoky Chlumec Poresice"
  },
  {
    "cast": "Pořešín",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Poresin"
  },
  {
    "cast": "Pořešinec",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Poresinec"
  },
  {
    "cast": "Pořežánky",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Modrá Hůrka",
    "val": "37501 Modra Hurka Porezanky"
  },
  {
    "cast": "Pořežany",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Žimutice",
    "val": "37501 Zimutice Porezany"
  },
  {
    "cast": "Pořežín",
    "psc": "59211",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Losenice",
    "val": "59211 Velka Losenice Porezin"
  },
  {
    "cast": "Poříčany",
    "psc": "28914",
    "okres": "Kolín",
    "obec": "Poříčany",
    "val": "28914 Poricany Poricany"
  },
  {
    "cast": "Poříčí",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Porici"
  },
  {
    "cast": "Poříčí",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Broumov",
    "val": "55001 Broumov Porici"
  },
  {
    "cast": "Poříčí",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Křelovice",
    "val": "39601 Krelovice Porici"
  },
  {
    "cast": "Poříčí",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Přibyslav",
    "val": "58222 Pribyslav Porici"
  },
  {
    "cast": "Poříčí",
    "psc": "37382",
    "okres": "České Budějovice",
    "obec": "Boršov nad Vltavou",
    "val": "37382 Borsov nad Vltavou Porici"
  },
  {
    "cast": "Poříčí nad Sázavou (část)",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Poříčí nad Sázavou",
    "val": "25722 Porici nad Sazavou Porici nad Sazavou (cast)"
  },
  {
    "cast": "Poříčí nad Sázavou (část)",
    "psc": "25721",
    "okres": "Benešov",
    "obec": "Poříčí nad Sázavou",
    "val": "25721 Porici nad Sazavou Porici nad Sazavou (cast)"
  },
  {
    "cast": "Poříčí u Litomyšle",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Poříčí u Litomyšle",
    "val": "57001 Porici u Litomysle Porici u Litomysle"
  },
  {
    "cast": "Poříčí (část)",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Porici (cast)"
  },
  {
    "cast": "Poříčí (část)",
    "psc": "54103",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54103 Trutnov Porici (cast)"
  },
  {
    "cast": "Pořín",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Porin"
  },
  {
    "cast": "Posadov",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Mezilečí",
    "val": "55205 Mezileci Posadov"
  },
  {
    "cast": "Poseč",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Otročín",
    "val": "36401 Otrocin Posec"
  },
  {
    "cast": "Posluchov",
    "psc": "78365",
    "okres": "Olomouc",
    "obec": "Hlubočky",
    "val": "78365 Hlubocky Posluchov"
  },
  {
    "cast": "Posobice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Posobice"
  },
  {
    "cast": "Postoloprty",
    "psc": "43942",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "43942 Postoloprty Postoloprty"
  },
  {
    "cast": "Postoupky",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Postoupky"
  },
  {
    "cast": "Postřekov",
    "psc": "34535",
    "okres": "Domažlice",
    "obec": "Postřekov",
    "val": "34535 Postrekov Postrekov"
  },
  {
    "cast": "Postřelmov",
    "psc": "78969",
    "okres": "Šumperk",
    "obec": "Postřelmov",
    "val": "78969 Postrelmov Postrelmov"
  },
  {
    "cast": "Postřelmůvek",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Postřelmůvek",
    "val": "78901 Postrelmuvek Postrelmuvek"
  },
  {
    "cast": "Postřelná",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Postrelna"
  },
  {
    "cast": "Postřižín",
    "psc": "25070",
    "okres": "Mělník",
    "obec": "Postřižín",
    "val": "25070 Postrizin Postrizin"
  },
  {
    "cast": "Postupice",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Postupice"
  },
  {
    "cast": "Pošná",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pošná",
    "val": "39501 Posna Posna"
  },
  {
    "cast": "Poštorná",
    "psc": "69141",
    "okres": "Břeclav",
    "obec": "Břeclav",
    "val": "69141 Breclav Postorna"
  },
  {
    "cast": "Poštovice",
    "psc": "27372",
    "okres": "Kladno",
    "obec": "Poštovice",
    "val": "27372 Postovice Postovice"
  },
  {
    "cast": "Poteč",
    "psc": "76601",
    "okres": "Zlín",
    "obec": "Poteč",
    "val": "76601 Potec Potec"
  },
  {
    "cast": "Potěhy",
    "psc": "28563",
    "okres": "Kutná Hora",
    "obec": "Potěhy",
    "val": "28563 Potehy Potehy"
  },
  {
    "cast": "Potín",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Konstantinovy Lázně",
    "val": "34953 Konstantinovy Lazne Potin"
  },
  {
    "cast": "Potočiště",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Odrava",
    "val": "35002 Odrava Potociste"
  },
  {
    "cast": "Potočná",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Číměř",
    "val": "37833 Cimer Potocna"
  },
  {
    "cast": "Potok",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Potok"
  },
  {
    "cast": "Potštát",
    "psc": "75362",
    "okres": "Přerov",
    "obec": "Potštát",
    "val": "75362 Potstat Potstat"
  },
  {
    "cast": "Potštejn",
    "psc": "51743",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Potštejn",
    "val": "51743 Potstejn Potstejn"
  },
  {
    "cast": "Potůčky",
    "psc": "36235",
    "okres": "Karlovy Vary",
    "obec": "Potůčky",
    "val": "36235 Potucky Potucky"
  },
  {
    "cast": "Potůčník",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Hanušovice",
    "val": "78833 Hanusovice Potucnik"
  },
  {
    "cast": "Potvorov",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Potvorov",
    "val": "33141 Potvorov Potvorov"
  },
  {
    "cast": "Pouchobrady",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Sobětuchy",
    "val": "53701 Sobetuchy Pouchobrady"
  },
  {
    "cast": "Pouchov (část)",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Pouchov (cast)"
  },
  {
    "cast": "Pouchov (část)",
    "psc": "50341",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50341 Hradec Kralove Pouchov (cast)"
  },
  {
    "cast": "Poustka",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Poustka",
    "val": "35002 Poustka Poustka"
  },
  {
    "cast": "Poustka",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Dobkovice",
    "val": "40502 Dobkovice Poustka"
  },
  {
    "cast": "Poustka",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46401 Visnova Poustka"
  },
  {
    "cast": "Poušť",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Záhornice",
    "val": "28903 Zahornice Poust"
  },
  {
    "cast": "Pouště",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Mokrovraty",
    "val": "26203 Mokrovraty Pouste"
  },
  {
    "cast": "Poutnov",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "35301 Tepla Poutnov"
  },
  {
    "cast": "Pouzdřany (část)",
    "psc": "69126",
    "okres": "Břeclav",
    "obec": "Pouzdřany",
    "val": "69126 Pouzdrany Pouzdrany (cast)"
  },
  {
    "cast": "Pouzdřany (část)",
    "psc": "69123",
    "okres": "Břeclav",
    "obec": "Pouzdřany",
    "val": "69123 Pouzdrany Pouzdrany (cast)"
  },
  {
    "cast": "Povel",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Povel"
  },
  {
    "cast": "Povlčín",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Milostín",
    "val": "27004 Milostin Povlcin"
  },
  {
    "cast": "Povodí",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Povodi"
  },
  {
    "cast": "Povrly (část)",
    "psc": "40332",
    "okres": "Ústí nad Labem",
    "obec": "Povrly",
    "val": "40332 Povrly Povrly (cast)"
  },
  {
    "cast": "Povrly (část)",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Povrly",
    "val": "40002 Povrly Povrly (cast)"
  },
  {
    "cast": "Pozďatín",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Pozďatín",
    "val": "67503 Pozdatin Pozdatin"
  },
  {
    "cast": "Pozďátky",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Slavičky",
    "val": "67501 Slavicky Pozdatky"
  },
  {
    "cast": "Pozděchov",
    "psc": "75611",
    "okres": "Vsetín",
    "obec": "Pozděchov",
    "val": "75611 Pozdechov Pozdechov"
  },
  {
    "cast": "Pozdeň",
    "psc": "27376",
    "okres": "Kladno",
    "obec": "Pozdeň",
    "val": "27376 Pozden Pozden"
  },
  {
    "cast": "Pozdyně",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Hvožďany",
    "val": "26242 Hvozdany Pozdyne"
  },
  {
    "cast": "Pozlovice",
    "psc": "76326",
    "okres": "Zlín",
    "obec": "Pozlovice",
    "val": "76326 Pozlovice Pozlovice"
  },
  {
    "cast": "Pozorka",
    "psc": "41703",
    "okres": "Teplice",
    "obec": "Dubí",
    "val": "41703 Dubi Pozorka"
  },
  {
    "cast": "Pozorka",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36221 Nejdek Pozorka"
  },
  {
    "cast": "Pozorka",
    "psc": "34961",
    "okres": "Tachov",
    "obec": "Kladruby",
    "val": "34961 Kladruby Pozorka"
  },
  {
    "cast": "Pozořice",
    "psc": "66407",
    "okres": "Brno-venkov",
    "obec": "Pozořice",
    "val": "66407 Pozorice Pozorice"
  },
  {
    "cast": "Pozov",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Pozov"
  },
  {
    "cast": "Pozovice",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Štoky",
    "val": "58253 Stoky Pozovice"
  },
  {
    "cast": "Prace",
    "psc": "66458",
    "okres": "Brno-venkov",
    "obec": "Prace",
    "val": "66458 Prace Prace"
  },
  {
    "cast": "Pracejovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Pracejovice",
    "val": "38601 Pracejovice Pracejovice"
  },
  {
    "cast": "Prackov",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Prackov"
  },
  {
    "cast": "Prackovice nad Labem",
    "psc": "41133",
    "okres": "Litoměřice",
    "obec": "Prackovice nad Labem",
    "val": "41133 Prackovice nad Labem Prackovice nad Labem"
  },
  {
    "cast": "Práče",
    "psc": "67161",
    "okres": "Znojmo",
    "obec": "Práče",
    "val": "67161 Prace Prace"
  },
  {
    "cast": "Práčov",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Svídnice",
    "val": "53821 Svidnice Pracov"
  },
  {
    "cast": "Práčov",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přídolí",
    "val": "38101 Pridoli Pracov"
  },
  {
    "cast": "Pradlisko",
    "psc": "76341",
    "okres": "Zlín",
    "obec": "Ludkovice",
    "val": "76341 Ludkovice Pradlisko"
  },
  {
    "cast": "Prádlo",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Prádlo",
    "val": "33501 Pradlo Pradlo"
  },
  {
    "cast": "Prachatice I",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Prachatice I"
  },
  {
    "cast": "Prachatice II",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Prachatice II"
  },
  {
    "cast": "Prácheň",
    "psc": "47114",
    "okres": "Česká Lípa",
    "obec": "Kamenický Šenov",
    "val": "47114 Kamenicky Senov Prachen"
  },
  {
    "cast": "Prachomety",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Prachomety"
  },
  {
    "cast": "Prachov",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Holín",
    "val": "50601 Holin Prachov"
  },
  {
    "cast": "Prachovice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Dašice",
    "val": "53002 Dasice Prachovice"
  },
  {
    "cast": "Prachovice",
    "psc": "53804",
    "okres": "Chrudim",
    "obec": "Prachovice",
    "val": "53804 Prachovice Prachovice"
  },
  {
    "cast": "Prakšice",
    "psc": "68756",
    "okres": "Uherské Hradiště",
    "obec": "Prakšice",
    "val": "68756 Praksice Praksice"
  },
  {
    "cast": "Prameny",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Prameny",
    "val": "35301 Prameny Prameny"
  },
  {
    "cast": "Prapořiště",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Praporiste"
  },
  {
    "cast": "Prasek",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Prasek",
    "val": "50401 Prasek Prasek"
  },
  {
    "cast": "Prasetín",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Prasetin"
  },
  {
    "cast": "Praskačka",
    "psc": "50333",
    "okres": "Hradec Králové",
    "obec": "Praskačka",
    "val": "50333 Praskacka Praskacka"
  },
  {
    "cast": "Prasklice",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Prasklice",
    "val": "76833 Prasklice Prasklice"
  },
  {
    "cast": "Praskolesy",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Mrákotín",
    "val": "58856 Mrakotin Praskolesy"
  },
  {
    "cast": "Praskolesy",
    "psc": "26754",
    "okres": "Beroun",
    "obec": "Praskolesy",
    "val": "26754 Praskolesy Praskolesy"
  },
  {
    "cast": "Prášily",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Prášily",
    "val": "34201 Prasily Prasily"
  },
  {
    "cast": "Prašný Újezd",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Mlečice",
    "val": "33808 Mlecice Prasny Ujezd"
  },
  {
    "cast": "Pravčice",
    "psc": "76824",
    "okres": "Kroměříž",
    "obec": "Pravčice",
    "val": "76824 Pravcice Pravcice"
  },
  {
    "cast": "Pravětice",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Pravetice"
  },
  {
    "cast": "Pravětín",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Pravetin"
  },
  {
    "cast": "Pravice",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Pravice",
    "val": "67178 Pravice Pravice"
  },
  {
    "cast": "Pravíkov",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Kamenice nad Lipou",
    "val": "39470 Kamenice nad Lipou Pravikov"
  },
  {
    "cast": "Pravlov",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Pravlov",
    "val": "66464 Pravlov Pravlov"
  },
  {
    "cast": "Pravonín (část)",
    "psc": "25709",
    "okres": "Benešov",
    "obec": "Pravonín",
    "val": "25709 Pravonin Pravonin (cast)"
  },
  {
    "cast": "Pravonín (část)",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Pravonín",
    "val": "25765 Pravonin Pravonin (cast)"
  },
  {
    "cast": "Pravy",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Pravy",
    "val": "53341 Pravy Pravy"
  },
  {
    "cast": "Pražák",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Prazak"
  },
  {
    "cast": "Pražmo",
    "psc": "73904",
    "okres": "Frýdek-Místek",
    "obec": "Pražmo",
    "val": "73904 Prazmo Prazmo"
  },
  {
    "cast": "Pražské Předměstí",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Prazske Predmesti"
  },
  {
    "cast": "Pražské Předměstí",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Prazske Predmesti"
  },
  {
    "cast": "Pražské Předměstí",
    "psc": "41801",
    "okres": "Teplice",
    "obec": "Bílina",
    "val": "41801 Bilina Prazske Predmesti"
  },
  {
    "cast": "Pražské Předměstí",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Prazske Predmesti"
  },
  {
    "cast": "Pražské Předměstí (část)",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Prazske Predmesti (cast)"
  },
  {
    "cast": "Pražské Předměstí (část)",
    "psc": "55102",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55102 Jaromer Prazske Predmesti (cast)"
  },
  {
    "cast": "Pražské Předměstí (část)",
    "psc": "50002",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50002 Hradec Kralove Prazske Predmesti (cast)"
  },
  {
    "cast": "Pražské Předměstí (část)",
    "psc": "50004",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50004 Hradec Kralove Prazske Predmesti (cast)"
  },
  {
    "cast": "Prčice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Prcice"
  },
  {
    "cast": "Prchalov",
    "psc": "74258",
    "okres": "Nový Jičín",
    "obec": "Příbor",
    "val": "74258 Pribor Prchalov"
  },
  {
    "cast": "Prkenný Důl",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Žacléř",
    "val": "54101 Zacler Prkenny Dul"
  },
  {
    "cast": "Prlov",
    "psc": "75611",
    "okres": "Vsetín",
    "obec": "Prlov",
    "val": "75611 Prlov Prlov"
  },
  {
    "cast": "Probluz",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Dolní Přím",
    "val": "50315 Dolni Prim Probluz"
  },
  {
    "cast": "Proboštov",
    "psc": "41712",
    "okres": "Teplice",
    "obec": "Proboštov",
    "val": "41712 Probostov Probostov"
  },
  {
    "cast": "Proboštov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40002 Malecov Probostov"
  },
  {
    "cast": "Probulov",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Probulov",
    "val": "39804 Probulov Probulov"
  },
  {
    "cast": "Pročevily",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Volenice",
    "val": "26272 Volenice Procevily"
  },
  {
    "cast": "Prodašice",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Prodašice",
    "val": "29404 Prodasice Prodasice"
  },
  {
    "cast": "Prohoř",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Štědrá",
    "val": "36452 Stedra Prohor"
  },
  {
    "cast": "Prochody",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Újezd u Chocně",
    "val": "56501 Ujezd u Chocne Prochody"
  },
  {
    "cast": "Prokopov",
    "psc": "67154",
    "okres": "Znojmo",
    "obec": "Prokopov",
    "val": "67154 Prokopov Prokopov"
  },
  {
    "cast": "Proloh",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Osečnice",
    "val": "51703 Osecnice Proloh"
  },
  {
    "cast": "Prorubky",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51601 Liberk Prorubky"
  },
  {
    "cast": "Proruby",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Brzice",
    "val": "55205 Brzice Proruby"
  },
  {
    "cast": "Proruby",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Proruby",
    "val": "51741 Proruby Proruby"
  },
  {
    "cast": "Prosatín",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Kuřimská Nová Ves",
    "val": "59455 Kurimska Nova Ves Prosatin"
  },
  {
    "cast": "Proseč",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Prosec"
  },
  {
    "cast": "Proseč",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Záhoří",
    "val": "51301 Zahori Prosec"
  },
  {
    "cast": "Proseč",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pošná",
    "val": "39501 Posna Prosec"
  },
  {
    "cast": "Proseč",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Proseč",
    "val": "39601 Prosec Prosec"
  },
  {
    "cast": "Proseč",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Proseč",
    "val": "53944 Prosec Prosec"
  },
  {
    "cast": "Proseč",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Žernov",
    "val": "51263 Zernov Prosec"
  },
  {
    "cast": "Proseč",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Kámen",
    "val": "58282 Kamen Prosec"
  },
  {
    "cast": "Proseč nad Nisou",
    "psc": "46804",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46804 Jablonec nad Nisou Prosec nad Nisou"
  },
  {
    "cast": "Proseč pod Ještědem",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Proseč pod Ještědem",
    "val": "46343 Prosec pod Jestedem Prosec pod Jestedem"
  },
  {
    "cast": "Proseč pod Křemešníkem",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Proseč pod Křemešníkem",
    "val": "39301 Prosec pod Kremesnikem Prosec pod Kremesnikem"
  },
  {
    "cast": "Prosečné",
    "psc": "54373",
    "okres": "Trutnov",
    "obec": "Prosečné",
    "val": "54373 Prosecne Prosecne"
  },
  {
    "cast": "Prosečnice (část)",
    "psc": "25742",
    "okres": "Benešov",
    "obec": "Krhanice",
    "val": "25742 Krhanice Prosecnice (cast)"
  },
  {
    "cast": "Prosečnice (část)",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Krhanice",
    "val": "25741 Krhanice Prosecnice (cast)"
  },
  {
    "cast": "Proseč-Obořiště",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nová Cerekev",
    "val": "39301 Nova Cerekev Prosec-Oboriste"
  },
  {
    "cast": "Prosek",
    "psc": "19000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19000 Praha Prosek"
  },
  {
    "cast": "Prosenice",
    "psc": "75121",
    "okres": "Přerov",
    "obec": "Prosenice",
    "val": "75121 Prosenice Prosenice"
  },
  {
    "cast": "Prosenice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Prosenická Lhota",
    "val": "26401 Prosenicka Lhota Prosenice"
  },
  {
    "cast": "Prosenická Lhota",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Prosenická Lhota",
    "val": "26401 Prosenicka Lhota Prosenicka Lhota"
  },
  {
    "cast": "Prosetice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41501 Teplice Prosetice"
  },
  {
    "cast": "Prosetín",
    "psc": "53976",
    "okres": "Chrudim",
    "obec": "Prosetín",
    "val": "53976 Prosetin Prosetin"
  },
  {
    "cast": "Prosetín",
    "psc": "59264",
    "okres": "Žďár nad Sázavou",
    "obec": "Prosetín",
    "val": "59264 Prosetin Prosetin"
  },
  {
    "cast": "Prosetín (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Dobkovice",
    "val": "40502 Dobkovice Prosetin (cast)"
  },
  {
    "cast": "Prosetín (část)",
    "psc": "40703",
    "okres": "Děčín",
    "obec": "Dobkovice",
    "val": "40703 Dobkovice Prosetin (cast)"
  },
  {
    "cast": "Prosíčka",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Prosicka"
  },
  {
    "cast": "Prosíčka",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Koberovy",
    "val": "46822 Koberovy Prosicka"
  },
  {
    "cast": "Prosiměřice",
    "psc": "67161",
    "okres": "Znojmo",
    "obec": "Prosiměřice",
    "val": "67161 Prosimerice Prosimerice"
  },
  {
    "cast": "Proskovice",
    "psc": "72400",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72400 Ostrava Proskovice"
  },
  {
    "cast": "Prostějov",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Žumberk",
    "val": "53821 Zumberk Prostejov"
  },
  {
    "cast": "Prostějov (část)",
    "psc": "79601",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79601 Prostejov Prostejov (cast)"
  },
  {
    "cast": "Prostějov (část)",
    "psc": "79603",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79603 Prostejov Prostejov (cast)"
  },
  {
    "cast": "Prostějov (část)",
    "psc": "79604",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79604 Prostejov Prostejov (cast)"
  },
  {
    "cast": "Prostějovičky",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Prostějovičky",
    "val": "79803 Prostejovicky Prostejovicky"
  },
  {
    "cast": "Prostiboř",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Prostiboř",
    "val": "34901 Prostibor Prostibor"
  },
  {
    "cast": "Prostředkovice",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Suchá",
    "val": "58833 Sucha Prostredkovice"
  },
  {
    "cast": "Prostřední Bečva",
    "psc": "75656",
    "okres": "Vsetín",
    "obec": "Prostřední Bečva",
    "val": "75656 Prostredni Becva Prostredni Becva"
  },
  {
    "cast": "Prostřední Bludovice",
    "psc": "73937",
    "okres": "Karviná",
    "obec": "Horní Bludovice",
    "val": "73937 Horni Bludovice Prostredni Bludovice"
  },
  {
    "cast": "Prostřední Dvůr",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74901 Vitkov Prostredni Dvur"
  },
  {
    "cast": "Prostřední Krušec",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Prostredni Krusec"
  },
  {
    "cast": "Prostřední Lánov (část)",
    "psc": "54341",
    "okres": "Trutnov",
    "obec": "Lánov",
    "val": "54341 Lanov Prostredni Lanov (cast)"
  },
  {
    "cast": "Prostřední Lánov (část)",
    "psc": "54301",
    "okres": "Trutnov",
    "obec": "Lánov",
    "val": "54301 Lanov Prostredni Lanov (cast)"
  },
  {
    "cast": "Prostřední Lhota",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Prostredni Lhota"
  },
  {
    "cast": "Prostřední Lipka",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Králíky",
    "val": "56169 Kraliky Prostredni Lipka"
  },
  {
    "cast": "Prostřední Nová Ves",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Prostredni Nova Ves"
  },
  {
    "cast": "Prostřední Poříčí",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Prostřední Poříčí",
    "val": "67962 Prostredni Porici Prostredni Porici"
  },
  {
    "cast": "Prostřední Staré Buky",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Staré Buky",
    "val": "54101 Stare Buky Prostredni Stare Buky"
  },
  {
    "cast": "Prostřední Suchá",
    "psc": "73564",
    "okres": "Karviná",
    "obec": "Havířov",
    "val": "73564 Havirov Prostredni Sucha"
  },
  {
    "cast": "Prostřední Svince",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Dolní Třebonín",
    "val": "38232 Dolni Trebonin Prostredni Svince"
  },
  {
    "cast": "Prostřední Ves",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Bohdaneč",
    "val": "28522 Bohdanec Prostredni Ves"
  },
  {
    "cast": "Prostřední Vydří",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Prostredni Vydri"
  },
  {
    "cast": "Prostřední Žleb-Děčín XV x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Prostredni Zleb-Decin XV x)"
  },
  {
    "cast": "Prostý",
    "psc": "39464",
    "okres": "Pelhřimov",
    "obec": "Počátky",
    "val": "39464 Pocatky Prosty"
  },
  {
    "cast": "Protivanov",
    "psc": "79848",
    "okres": "Prostějov",
    "obec": "Protivanov",
    "val": "79848 Protivanov Protivanov"
  },
  {
    "cast": "Protivec",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36453 Zlutice Protivec"
  },
  {
    "cast": "Protivec",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Strunkovice nad Blanicí",
    "val": "38301 Strunkovice nad Blanici Protivec"
  },
  {
    "cast": "Protivín",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Protivin"
  },
  {
    "cast": "Provodice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Hořice na Šumavě",
    "val": "38101 Horice na Sumave Provodice"
  },
  {
    "cast": "Provodín",
    "psc": "47167",
    "okres": "Česká Lípa",
    "obec": "Provodín",
    "val": "47167 Provodin Provodin"
  },
  {
    "cast": "Provodov",
    "psc": "54908",
    "okres": "Náchod",
    "obec": "Provodov-Šonov",
    "val": "54908 Provodov-Sonov Provodov"
  },
  {
    "cast": "Provodov (část)",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Provodov",
    "val": "76001 Provodov Provodov (cast)"
  },
  {
    "cast": "Provodov (část)",
    "psc": "76345",
    "okres": "Zlín",
    "obec": "Provodov",
    "val": "76345 Provodov Provodov (cast)"
  },
  {
    "cast": "Provodovice",
    "psc": "75353",
    "okres": "Přerov",
    "obec": "Provodovice",
    "val": "75353 Provodovice Provodovice"
  },
  {
    "cast": "Provoz",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Val",
    "val": "51801 Val Provoz"
  },
  {
    "cast": "Prstná",
    "psc": "73572",
    "okres": "Karviná",
    "obec": "Petrovice u Karviné",
    "val": "73572 Petrovice u Karvine Prstna"
  },
  {
    "cast": "Prštice",
    "psc": "66446",
    "okres": "Brno-venkov",
    "obec": "Prštice",
    "val": "66446 Prstice Prstice"
  },
  {
    "cast": "Prštné (část)",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76001 Zlin Prstne (cast)"
  },
  {
    "cast": "Prštné (část)",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76302 Zlin Prstne (cast)"
  },
  {
    "cast": "Prudice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nemyšl",
    "val": "39143 Nemysl Prudice"
  },
  {
    "cast": "Průhonice",
    "psc": "25243",
    "okres": "Praha-západ",
    "obec": "Průhonice",
    "val": "25243 Pruhonice Pruhonice"
  },
  {
    "cast": "Průmyslová zóna",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Bavoryně",
    "val": "26751 Bavoryne Prumyslova zona"
  },
  {
    "cast": "Průmyslová zóna Triangle",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Velemyšleves",
    "val": "43801 Velemysleves Prumyslova zona Triangle"
  },
  {
    "cast": "Průmyslová zóna Triangle",
    "psc": "43949",
    "okres": "Louny",
    "obec": "Staňkovice",
    "val": "43949 Stankovice Prumyslova zona Triangle"
  },
  {
    "cast": "Prunéřov",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Prunerov"
  },
  {
    "cast": "Prusice",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Prusice",
    "val": "28163 Prusice Prusice"
  },
  {
    "cast": "Prusinovice",
    "psc": "76842",
    "okres": "Kroměříž",
    "obec": "Prusinovice",
    "val": "76842 Prusinovice Prusinovice"
  },
  {
    "cast": "Prusy",
    "psc": "75115",
    "okres": "Přerov",
    "obec": "Beňov",
    "val": "75115 Benov Prusy"
  },
  {
    "cast": "Prušánky",
    "psc": "69621",
    "okres": "Hodonín",
    "obec": "Prušánky",
    "val": "69621 Prusanky Prusanky"
  },
  {
    "cast": "Pržno",
    "psc": "75623",
    "okres": "Vsetín",
    "obec": "Pržno",
    "val": "75623 Przno Przno"
  },
  {
    "cast": "Pržno",
    "psc": "73911",
    "okres": "Frýdek-Místek",
    "obec": "Pržno",
    "val": "73911 Przno Przno"
  },
  {
    "cast": "Přáslavice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Samšín",
    "val": "39501 Samsin Praslavice"
  },
  {
    "cast": "Přáslavice",
    "psc": "78354",
    "okres": "Olomouc",
    "obec": "Přáslavice",
    "val": "78354 Praslavice Praslavice"
  },
  {
    "cast": "Přeborov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Přeborov",
    "val": "39901 Preborov Preborov"
  },
  {
    "cast": "Přebozy",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Zalešany",
    "val": "28002 Zalesany Prebozy"
  },
  {
    "cast": "Přebudov",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Kasejovice",
    "val": "33544 Kasejovice Prebudov"
  },
  {
    "cast": "Přebuz",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Přebuz",
    "val": "35801 Prebuz Prebuz"
  },
  {
    "cast": "Přeckov",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Přeckov",
    "val": "67505 Preckov Preckov"
  },
  {
    "cast": "Přečaply",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Údlice",
    "val": "43001 Udlice Precaply"
  },
  {
    "cast": "Přečín",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Precin"
  },
  {
    "cast": "Přečkovice",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Bojkovice",
    "val": "68771 Bojkovice Preckovice"
  },
  {
    "cast": "Předboj",
    "psc": "25072",
    "okres": "Praha-východ",
    "obec": "Předboj",
    "val": "25072 Predboj Predboj"
  },
  {
    "cast": "Předbojov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Predbojov"
  },
  {
    "cast": "Předboř",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Choustník",
    "val": "39201 Choustnik Predbor"
  },
  {
    "cast": "Předboř",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Maleč",
    "val": "58301 Malec Predbor"
  },
  {
    "cast": "Předboř",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25163 Strancice Predbor"
  },
  {
    "cast": "Předboř",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Luka nad Jihlavou",
    "val": "58822 Luka nad Jihlavou Predbor"
  },
  {
    "cast": "Předbořice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Predborice"
  },
  {
    "cast": "Předbořice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Černíny",
    "val": "28401 Cerniny Predborice"
  },
  {
    "cast": "Předbořice",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Kamberk",
    "val": "25706 Kamberk Predborice"
  },
  {
    "cast": "Předčice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Týn nad Vltavou",
    "val": "37501 Tyn nad Vltavou Predcice"
  },
  {
    "cast": "Předenice",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Čkyně",
    "val": "38481 Ckyne Predenice"
  },
  {
    "cast": "Předenice",
    "psc": "33209",
    "okres": "Plzeň-jih",
    "obec": "Předenice",
    "val": "33209 Predenice Predenice"
  },
  {
    "cast": "Předhradí",
    "psc": "28941",
    "okres": "Kolín",
    "obec": "Pňov-Předhradí",
    "val": "28941 Pnov-Predhradi Predhradi"
  },
  {
    "cast": "Předhradí",
    "psc": "53974",
    "okres": "Chrudim",
    "obec": "Předhradí",
    "val": "53974 Predhradi Predhradi"
  },
  {
    "cast": "Předín",
    "psc": "67527",
    "okres": "Třebíč",
    "obec": "Předín",
    "val": "67527 Predin Predin"
  },
  {
    "cast": "Předklášteří (část)",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Předklášteří",
    "val": "66601 Predklasteri Predklasteri (cast)"
  },
  {
    "cast": "Předklášteří (část)",
    "psc": "66602",
    "okres": "Brno-venkov",
    "obec": "Předklášteří",
    "val": "66602 Predklasteri Predklasteri (cast)"
  },
  {
    "cast": "Předlánce",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46401 Visnova Predlance"
  },
  {
    "cast": "Předlice",
    "psc": "40001",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40001 Usti nad Labem Predlice"
  },
  {
    "cast": "Předměřice nad Jizerou",
    "psc": "29474",
    "okres": "Mladá Boleslav",
    "obec": "Předměřice nad Jizerou",
    "val": "29474 Predmerice nad Jizerou Predmerice nad Jizerou"
  },
  {
    "cast": "Předměřice nad Labem",
    "psc": "50302",
    "okres": "Hradec Králové",
    "obec": "Předměřice nad Labem",
    "val": "50302 Predmerice nad Labem Predmerice nad Labem"
  },
  {
    "cast": "Předměstí",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Svitavy",
    "val": "56802 Svitavy Predmesti"
  },
  {
    "cast": "Předměstí",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Svojanov",
    "val": "56992 Svojanov Predmesti"
  },
  {
    "cast": "Předměstí",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Moravská Třebová",
    "val": "57101 Moravska Trebova Predmesti"
  },
  {
    "cast": "Předměstí (část)",
    "psc": "74601",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74601 Opava Predmesti (cast)"
  },
  {
    "cast": "Předměstí (část)",
    "psc": "74707",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74707 Opava Predmesti (cast)"
  },
  {
    "cast": "Předměstí (část)",
    "psc": "41101",
    "okres": "Litoměřice",
    "obec": "Litoměřice",
    "val": "41101 Litomerice Predmesti (cast)"
  },
  {
    "cast": "Předměstí (část)",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Litoměřice",
    "val": "41201 Litomerice Predmesti (cast)"
  },
  {
    "cast": "Předmíř",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Předmíř",
    "val": "38742 Predmir Predmir"
  },
  {
    "cast": "Předmostí-Přerov II x)",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Predmosti-Prerov II x)"
  },
  {
    "cast": "Přední Arnoštov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Predni Arnostov"
  },
  {
    "cast": "Přední Chlum",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Milešov",
    "val": "26256 Milesov Predni Chlum"
  },
  {
    "cast": "Přední Kopanina",
    "psc": "16400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16400 Praha Predni Kopanina"
  },
  {
    "cast": "Přední Labská",
    "psc": "54351",
    "okres": "Trutnov",
    "obec": "Špindlerův Mlýn",
    "val": "54351 Spindleruv Mlyn Predni Labska"
  },
  {
    "cast": "Přední Lhota",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Predni Lhota"
  },
  {
    "cast": "Přední Poříčí",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Březnice",
    "val": "26272 Breznice Predni Porici"
  },
  {
    "cast": "Přední Ptákovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Strakonice",
    "val": "38601 Strakonice Predni Ptakovice"
  },
  {
    "cast": "Přední Výtoň",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Přední Výtoň",
    "val": "38273 Predni Vyton Predni Vyton"
  },
  {
    "cast": "Přední Zborovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Přední Zborovice",
    "val": "38701 Predni Zborovice Predni Zborovice"
  },
  {
    "cast": "Předonín",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Bechlín",
    "val": "41108 Bechlin Predonin"
  },
  {
    "cast": "Předotice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Predotice"
  },
  {
    "cast": "Předslav",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Předslav",
    "val": "33901 Predslav Predslav"
  },
  {
    "cast": "Předslavice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Předslavice",
    "val": "38701 Predslavice Predslavice"
  },
  {
    "cast": "Předvojovice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "34142 Cachrov Predvojovice"
  },
  {
    "cast": "Přehořov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Přehořov",
    "val": "39201 Prehorov Prehorov"
  },
  {
    "cast": "Přehořov (část)",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Žihle",
    "val": "33165 Zihle Prehorov (cast)"
  },
  {
    "cast": "Přehořov (část)",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Žihle",
    "val": "33141 Zihle Prehorov (cast)"
  },
  {
    "cast": "Přehvozdí",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Přehvozdí",
    "val": "28163 Prehvozdi Prehvozdi"
  },
  {
    "cast": "Přehýšov",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Přehýšov",
    "val": "33023 Prehysov Prehysov"
  },
  {
    "cast": "Přechovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Přechovice",
    "val": "38701 Prechovice Prechovice"
  },
  {
    "cast": "Přelíc",
    "psc": "27305",
    "okres": "Kladno",
    "obec": "Přelíc",
    "val": "27305 Prelic Prelic"
  },
  {
    "cast": "Přelouč",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Přelouč",
    "val": "53501 Prelouc Prelouc"
  },
  {
    "cast": "Přelovice",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Přelovice",
    "val": "53341 Prelovice Prelovice"
  },
  {
    "cast": "Přelštice",
    "psc": "38221",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38221 Kajov Prelstice"
  },
  {
    "cast": "Přemilov",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Premilov"
  },
  {
    "cast": "Přemyslov",
    "psc": "78811",
    "okres": "Šumperk",
    "obec": "Loučná nad Desnou",
    "val": "78811 Loucna nad Desnou Premyslov"
  },
  {
    "cast": "Přemyslovice",
    "psc": "79851",
    "okres": "Prostějov",
    "obec": "Přemyslovice",
    "val": "79851 Premyslovice Premyslovice"
  },
  {
    "cast": "Přemyšlení",
    "psc": "25066",
    "okres": "Praha-východ",
    "obec": "Zdiby",
    "val": "25066 Zdiby Premysleni"
  },
  {
    "cast": "Přepeře",
    "psc": "51261",
    "okres": "Semily",
    "obec": "Přepeře",
    "val": "51261 Prepere Prepere"
  },
  {
    "cast": "Přepeře",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Přepeře",
    "val": "29404 Prepere Prepere"
  },
  {
    "cast": "Přepychy",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Přepychy",
    "val": "53316 Prepychy Prepychy"
  },
  {
    "cast": "Přepychy",
    "psc": "51732",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Přepychy",
    "val": "51732 Prepychy Prepychy"
  },
  {
    "cast": "Přerov III-Lověšice",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Prerov III-Lovesice"
  },
  {
    "cast": "Přerov II-Předmostí",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Prerov II-Predmosti"
  },
  {
    "cast": "Přerov IV-Kozlovice",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Prerov IV-Kozlovice"
  },
  {
    "cast": "Přerov IX-Lýsky",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Prerov IX-Lysky"
  },
  {
    "cast": "Přerov I-Město",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Prerov I-Mesto"
  },
  {
    "cast": "Přerov nad Labem",
    "psc": "28916",
    "okres": "Nymburk",
    "obec": "Přerov nad Labem",
    "val": "28916 Prerov nad Labem Prerov nad Labem"
  },
  {
    "cast": "Přerov VIII-Henčlov",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Prerov VIII-Henclov"
  },
  {
    "cast": "Přerov VII-Čekyně",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Prerov VII-Cekyne"
  },
  {
    "cast": "Přerov VI-Újezdec",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Prerov VI-Ujezdec"
  },
  {
    "cast": "Přerov V-Dluhonice",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Prerov V-Dluhonice"
  },
  {
    "cast": "Přerov XIII-Penčice",
    "psc": "75127",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75127 Prerov Prerov XIII-Pencice"
  },
  {
    "cast": "Přerov XII-Žeravice",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Prerov XII-Zeravice"
  },
  {
    "cast": "Přerov XI-Vinary",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Prerov XI-Vinary"
  },
  {
    "cast": "Přerov X-Popovice",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Prerov X-Popovice"
  },
  {
    "cast": "Přerubenice",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Přerubenice",
    "val": "27054 Prerubenice Prerubenice"
  },
  {
    "cast": "Přes",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Pres"
  },
  {
    "cast": "Přeseka",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Třeboň",
    "val": "37901 Trebon Preseka"
  },
  {
    "cast": "Přeskače",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Přeskače",
    "val": "67140 Preskace Preskace"
  },
  {
    "cast": "Přeskaky",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43801 Chbany Preskaky"
  },
  {
    "cast": "Přestání",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Štědrá",
    "val": "36452 Stedra Prestani"
  },
  {
    "cast": "Přestanice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Prestanice"
  },
  {
    "cast": "Přestanov",
    "psc": "40317",
    "okres": "Ústí nad Labem",
    "obec": "Přestanov",
    "val": "40317 Prestanov Prestanov"
  },
  {
    "cast": "Přestavlky",
    "psc": "78357",
    "okres": "Olomouc",
    "obec": "Tršice",
    "val": "78357 Trsice Prestavlky"
  },
  {
    "cast": "Přestavlky",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přestavlky",
    "val": "75002 Prestavlky Prestavlky"
  },
  {
    "cast": "Přestavlky",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Přestavlky",
    "val": "33401 Prestavlky Prestavlky"
  },
  {
    "cast": "Přestavlky",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Přestavlky",
    "val": "53862 Prestavlky Prestavlky"
  },
  {
    "cast": "Přestavlky",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Prestavlky"
  },
  {
    "cast": "Přestavlky",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Přestavlky",
    "val": "41301 Prestavlky Prestavlky"
  },
  {
    "cast": "Přestavlky",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Horní Kruty",
    "val": "28163 Horni Kruty Prestavlky"
  },
  {
    "cast": "Přestavlky",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Borovnice",
    "val": "51741 Borovnice Prestavlky"
  },
  {
    "cast": "Přestavlky u Čerčan (část)",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Přestavlky u Čerčan",
    "val": "25722 Prestavlky u Cercan Prestavlky u Cercan (cast)"
  },
  {
    "cast": "Přestavlky u Čerčan (část)",
    "psc": "25723",
    "okres": "Benešov",
    "obec": "Přestavlky u Čerčan",
    "val": "25723 Prestavlky u Cercan Prestavlky u Cercan (cast)"
  },
  {
    "cast": "Přešín",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Čížkov",
    "val": "33563 Cizkov Presin"
  },
  {
    "cast": "Přešovice",
    "psc": "67557",
    "okres": "Třebíč",
    "obec": "Přešovice",
    "val": "67557 Presovice Presovice"
  },
  {
    "cast": "Přeštěnice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Přeštěnice",
    "val": "39901 Prestenice Prestenice"
  },
  {
    "cast": "Přeštice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Přeštice",
    "val": "33401 Prestice Prestice"
  },
  {
    "cast": "Přešťovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Přešťovice",
    "val": "38601 Prestovice Prestovice"
  },
  {
    "cast": "Přetín",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Křenice",
    "val": "34012 Krenice Pretin"
  },
  {
    "cast": "Převýšov",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Převýšov",
    "val": "50351 Prevysov Prevysov"
  },
  {
    "cast": "Přezletice",
    "psc": "25073",
    "okres": "Praha-východ",
    "obec": "Přezletice",
    "val": "25073 Prezletice Prezletice"
  },
  {
    "cast": "Přibenice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Pribenice"
  },
  {
    "cast": "Přibice",
    "psc": "69124",
    "okres": "Brno-venkov",
    "obec": "Přibice",
    "val": "69124 Pribice Pribice"
  },
  {
    "cast": "Příbohy",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Nosálov",
    "val": "27735 Nosalov Pribohy"
  },
  {
    "cast": "Příbor",
    "psc": "74258",
    "okres": "Nový Jičín",
    "obec": "Příbor",
    "val": "74258 Pribor Pribor"
  },
  {
    "cast": "Příbram",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Verneřice",
    "val": "40502 Vernerice Pribram"
  },
  {
    "cast": "Příbram I",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram I"
  },
  {
    "cast": "Příbram II",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram II"
  },
  {
    "cast": "Příbram III",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram III"
  },
  {
    "cast": "Příbram IV",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram IV"
  },
  {
    "cast": "Příbram IX",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram IX"
  },
  {
    "cast": "Příbram na Moravě",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Příbram na Moravě",
    "val": "66484 Pribram na Morave Pribram na Morave"
  },
  {
    "cast": "Příbram VII",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram VII"
  },
  {
    "cast": "Příbram VIII",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram VIII"
  },
  {
    "cast": "Příbram VI-Březové Hory",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram VI-Brezove Hory"
  },
  {
    "cast": "Příbram V-Zdaboř",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Pribram V-Zdabor"
  },
  {
    "cast": "Příbraz (část)",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Příbraz",
    "val": "37901 Pribraz Pribraz (cast)"
  },
  {
    "cast": "Příbraz (část)",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Příbraz",
    "val": "37802 Pribraz Pribraz (cast)"
  },
  {
    "cast": "Přibyslav",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Pribyslav"
  },
  {
    "cast": "Přibyslav",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Přibyslav",
    "val": "58222 Pribyslav Pribyslav"
  },
  {
    "cast": "Přibyslav",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Přibyslav",
    "val": "54901 Pribyslav Pribyslav"
  },
  {
    "cast": "Přibyslavice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vlkaneč",
    "val": "28601 Vlkanec Pribyslavice"
  },
  {
    "cast": "Přibyslavice",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Pribyslavice"
  },
  {
    "cast": "Přibyslavice",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Přibyslavice",
    "val": "67521 Pribyslavice Pribyslavice"
  },
  {
    "cast": "Přibyslavice (část)",
    "psc": "66501",
    "okres": "Brno-venkov",
    "obec": "Přibyslavice",
    "val": "66501 Pribyslavice Pribyslavice (cast)"
  },
  {
    "cast": "Přibyslavice (část)",
    "psc": "66483",
    "okres": "Brno-venkov",
    "obec": "Přibyslavice",
    "val": "66483 Pribyslavice Pribyslavice (cast)"
  },
  {
    "cast": "Přibyšice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Pribysice"
  },
  {
    "cast": "Přibýška",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26401 Kosova Hora Pribyska"
  },
  {
    "cast": "Příčina",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Příčina",
    "val": "27035 Pricina Pricina"
  },
  {
    "cast": "Příčovy",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Příčovy",
    "val": "26401 Pricovy Pricovy"
  },
  {
    "cast": "Přídolí",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přídolí",
    "val": "38101 Pridoli Pridoli"
  },
  {
    "cast": "Příhrazy",
    "psc": "29412",
    "okres": "Mladá Boleslav",
    "obec": "Žďár",
    "val": "29412 Zdar Prihrazy"
  },
  {
    "cast": "Příchovice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Příchovice",
    "val": "33401 Prichovice Prichovice"
  },
  {
    "cast": "Příchovice",
    "psc": "46848",
    "okres": "Jablonec nad Nisou",
    "obec": "Kořenov",
    "val": "46848 Korenov Prichovice"
  },
  {
    "cast": "Příchvoj",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50743 Markvartice Prichvoj"
  },
  {
    "cast": "Příjemky",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Prijemky"
  },
  {
    "cast": "Příkazy",
    "psc": "78333",
    "okres": "Olomouc",
    "obec": "Příkazy",
    "val": "78333 Prikazy Prikazy"
  },
  {
    "cast": "Příkosice",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Příkosice",
    "val": "33843 Prikosice Prikosice"
  },
  {
    "cast": "Příkrakov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Včelákov",
    "val": "53901 Vcelakov Prikrakov"
  },
  {
    "cast": "Příkrý",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Příkrý",
    "val": "51301 Prikry Prikry"
  },
  {
    "cast": "Přílepov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kostelec nad Vltavou",
    "val": "39901 Kostelec nad Vltavou Prilepov"
  },
  {
    "cast": "Přílepy",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Přílepy",
    "val": "76901 Prilepy Prilepy"
  },
  {
    "cast": "Přílepy",
    "psc": "27001",
    "okres": "Rakovník",
    "obec": "Přílepy",
    "val": "27001 Prilepy Prilepy"
  },
  {
    "cast": "Přílezy",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Útvina",
    "val": "36401 Utvina Prilezy"
  },
  {
    "cast": "Příložany",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Jaroměřice nad Rokytnou",
    "val": "67551 Jaromerice nad Rokytnou Prilozany"
  },
  {
    "cast": "Příluka",
    "psc": "53944",
    "okres": "Svitavy",
    "obec": "Příluka",
    "val": "53944 Priluka Priluka"
  },
  {
    "cast": "Příluky",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76001 Zlin Priluky"
  },
  {
    "cast": "Příluky",
    "psc": "75641",
    "okres": "Vsetín",
    "obec": "Lešná",
    "val": "75641 Lesna Priluky"
  },
  {
    "cast": "Přím",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Javornice",
    "val": "51601 Javornice Prim"
  },
  {
    "cast": "Přimda",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Primda"
  },
  {
    "cast": "Přímělkov",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58822 Brtnice Primelkov"
  },
  {
    "cast": "Přímětice (část)",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "66902 Znojmo Primetice (cast)"
  },
  {
    "cast": "Přímětice (část)",
    "psc": "66904",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "66904 Znojmo Primetice (cast)"
  },
  {
    "cast": "Přípeř-Děčín XVI x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Priper-Decin XVI x)"
  },
  {
    "cast": "Přísečná",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přísečná",
    "val": "38101 Prisecna Prisecna"
  },
  {
    "cast": "Přísečno",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Soběnov",
    "val": "38241 Sobenov Prisecno"
  },
  {
    "cast": "Přísečno",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Uhelná Příbram",
    "val": "58282 Uhelna Pribram Prisecno"
  },
  {
    "cast": "Přísednice",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Zbiroh",
    "val": "33808 Zbiroh Prisednice"
  },
  {
    "cast": "Příseka",
    "psc": "58832",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58832 Brtnice Priseka"
  },
  {
    "cast": "Příseka",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Příseka",
    "val": "58291 Priseka Priseka"
  },
  {
    "cast": "Příslop",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Chroboly",
    "val": "38301 Chroboly Prislop"
  },
  {
    "cast": "Přísnotice",
    "psc": "66463",
    "okres": "Brno-venkov",
    "obec": "Přísnotice",
    "val": "66463 Prisnotice Prisnotice"
  },
  {
    "cast": "Přistoupim",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Přistoupim",
    "val": "28201 Pristoupim Pristoupim"
  },
  {
    "cast": "Přišimasy",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Přišimasy",
    "val": "28201 Prisimasy Prisimasy"
  },
  {
    "cast": "Příšov",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Příšov",
    "val": "33011 Prisov Prisov"
  },
  {
    "cast": "Příšovice",
    "psc": "46346",
    "okres": "Liberec",
    "obec": "Příšovice",
    "val": "46346 Prisovice Prisovice"
  },
  {
    "cast": "Příštpo",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Příštpo",
    "val": "67551 Pristpo Pristpo"
  },
  {
    "cast": "Přítkov",
    "psc": "41712",
    "okres": "Teplice",
    "obec": "Proboštov",
    "val": "41712 Probostov Pritkov"
  },
  {
    "cast": "Přítluky",
    "psc": "69104",
    "okres": "Břeclav",
    "obec": "Přítluky",
    "val": "69104 Pritluky Pritluky"
  },
  {
    "cast": "Přítoky",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Miskovice",
    "val": "28401 Miskovice Pritoky"
  },
  {
    "cast": "Přívětice",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Přívětice",
    "val": "33828 Privetice Privetice"
  },
  {
    "cast": "Přívlaky",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žiželice",
    "val": "43801 Zizelice Privlaky"
  },
  {
    "cast": "Přívlaky",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Samopše",
    "val": "28506 Samopse Privlaky"
  },
  {
    "cast": "Přívory",
    "psc": "27716",
    "okres": "Mělník",
    "obec": "Všetaty",
    "val": "27716 Vsetaty Privory"
  },
  {
    "cast": "Přívoz",
    "psc": "70200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70200 Ostrava Privoz"
  },
  {
    "cast": "Přívozec",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Blížejov",
    "val": "34601 Blizejov Privozec"
  },
  {
    "cast": "Přívrat",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Přívrat",
    "val": "56002 Privrat Privrat"
  },
  {
    "cast": "Přízeř",
    "psc": "38218",
    "okres": "Český Krumlov",
    "obec": "Rožmberk nad Vltavou",
    "val": "38218 Rozmberk nad Vltavou Prizer"
  },
  {
    "cast": "Přízřenice",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Prizrenice"
  },
  {
    "cast": "Psárov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Psárov",
    "val": "39201 Psarov Psarov"
  },
  {
    "cast": "Psáry",
    "psc": "25244",
    "okres": "Praha-západ",
    "obec": "Psáry",
    "val": "25244 Psary Psary"
  },
  {
    "cast": "Psáře",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Psáře",
    "val": "25801 Psare Psare"
  },
  {
    "cast": "Psinice",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Libáň",
    "val": "50723 Liban Psinice"
  },
  {
    "cast": "Pstruží",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Merklín",
    "val": "36301 Merklin Pstruzi"
  },
  {
    "cast": "Pstruží",
    "psc": "73911",
    "okres": "Frýdek-Místek",
    "obec": "Pstruží",
    "val": "73911 Pstruzi Pstruzi"
  },
  {
    "cast": "Pšánky",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Pšánky",
    "val": "50315 Psanky Psanky"
  },
  {
    "cast": "Pševes",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Kopidlno",
    "val": "50732 Kopidlno Pseves"
  },
  {
    "cast": "Pšov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Pšov",
    "val": "36452 Psov Psov"
  },
  {
    "cast": "Pšov",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Psov"
  },
  {
    "cast": "Pšovlky",
    "psc": "27031",
    "okres": "Rakovník",
    "obec": "Pšovlky",
    "val": "27031 Psovlky Psovlky"
  },
  {
    "cast": "Ptáčník",
    "psc": "73945",
    "okres": "Frýdek-Místek",
    "obec": "Fryčovice",
    "val": "73945 Frycovice Ptacnik"
  },
  {
    "cast": "Ptáčov",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Ptacov"
  },
  {
    "cast": "Ptákova Lhota",
    "psc": "38486",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38486 Vacov Ptakova Lhota"
  },
  {
    "cast": "Ptení",
    "psc": "79843",
    "okres": "Prostějov",
    "obec": "Ptení",
    "val": "79843 Pteni Pteni"
  },
  {
    "cast": "Ptenín",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Ptenín",
    "val": "33452 Ptenin Ptenin"
  },
  {
    "cast": "Ptenský Dvorek",
    "psc": "79843",
    "okres": "Prostějov",
    "obec": "Ptení",
    "val": "79843 Pteni Ptensky Dvorek"
  },
  {
    "cast": "Ptice",
    "psc": "25218",
    "okres": "Praha-západ",
    "obec": "Ptice",
    "val": "25218 Ptice Ptice"
  },
  {
    "cast": "Ptýrov",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Ptýrov",
    "val": "29501 Ptyrov Ptyrov"
  },
  {
    "cast": "Ptýrovec",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Ptýrov",
    "val": "29501 Ptyrov Ptyrovec"
  },
  {
    "cast": "Puclice",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Puclice",
    "val": "34561 Puclice Puclice"
  },
  {
    "cast": "Pucov",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Pucov",
    "val": "67571 Pucov Pucov"
  },
  {
    "cast": "Pučery",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Kořenice",
    "val": "28144 Korenice Pucery"
  },
  {
    "cast": "Pudilka",
    "psc": "56002",
    "okres": "Svitavy",
    "obec": "Němčice",
    "val": "56002 Nemcice Pudilka"
  },
  {
    "cast": "Pudlov",
    "psc": "73551",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73551 Bohumin Pudlov"
  },
  {
    "cast": "Pucheř",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Kluky",
    "val": "28601 Kluky Pucher"
  },
  {
    "cast": "Puchlovice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Puchlovice",
    "val": "50315 Puchlovice Puchlovice"
  },
  {
    "cast": "Puchverk",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34201 Hlavnovice Puchverk"
  },
  {
    "cast": "Puklice",
    "psc": "58831",
    "okres": "Jihlava",
    "obec": "Puklice",
    "val": "58831 Puklice Puklice"
  },
  {
    "cast": "Pukňov",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Lety",
    "val": "39804 Lety Puknov"
  },
  {
    "cast": "Pukšice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Uhelná Příbram",
    "val": "58282 Uhelna Pribram Puksice"
  },
  {
    "cast": "Pulčín (část)",
    "psc": "75612",
    "okres": "Vsetín",
    "obec": "Francova Lhota",
    "val": "75612 Francova Lhota Pulcin (cast)"
  },
  {
    "cast": "Pulčín (část)",
    "psc": "75614",
    "okres": "Vsetín",
    "obec": "Francova Lhota",
    "val": "75614 Francova Lhota Pulcin (cast)"
  },
  {
    "cast": "Pulečný",
    "psc": "46802",
    "okres": "Jablonec nad Nisou",
    "obec": "Pulečný",
    "val": "46802 Pulecny Pulecny"
  },
  {
    "cast": "Pulice",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobruška",
    "val": "51801 Dobruska Pulice"
  },
  {
    "cast": "Pulkov",
    "psc": "67557",
    "okres": "Třebíč",
    "obec": "Biskupice-Pulkov",
    "val": "67557 Biskupice-Pulkov Pulkov"
  },
  {
    "cast": "Pulovice",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Šemnice",
    "val": "36272 Semnice Pulovice"
  },
  {
    "cast": "Půlpecen",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Chrastavec",
    "val": "56904 Chrastavec Pulpecen"
  },
  {
    "cast": "Purkarec",
    "psc": "37343",
    "okres": "České Budějovice",
    "obec": "Hluboká nad Vltavou",
    "val": "37343 Hluboka nad Vltavou Purkarec"
  },
  {
    "cast": "Purkratice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Purkratice"
  },
  {
    "cast": "Pustá Kamenice",
    "psc": "56982",
    "okres": "Svitavy",
    "obec": "Pustá Kamenice",
    "val": "56982 Pusta Kamenice Pusta Kamenice"
  },
  {
    "cast": "Pustá Polom",
    "psc": "74769",
    "okres": "Opava",
    "obec": "Pustá Polom",
    "val": "74769 Pusta Polom Pusta Polom"
  },
  {
    "cast": "Pustá Proseč",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Pusta Prosec"
  },
  {
    "cast": "Pustá Rudná",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Andělská Hora",
    "val": "79331 Andelska Hora Pusta Rudna"
  },
  {
    "cast": "Pustá Rybná (část)",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Pustá Rybná",
    "val": "57201 Pusta Rybna Pusta Rybna (cast)"
  },
  {
    "cast": "Pustá Rybná (část)",
    "psc": "56982",
    "okres": "Svitavy",
    "obec": "Pustá Rybná",
    "val": "56982 Pusta Rybna Pusta Rybna (cast)"
  },
  {
    "cast": "Pusté Jakartice",
    "psc": "74728",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74728 Opava Puste Jakartice"
  },
  {
    "cast": "Pusté Lhotsko",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Budíkov",
    "val": "39601 Budikov Puste Lhotsko"
  },
  {
    "cast": "Pusté Skaliny",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Puste Skaliny"
  },
  {
    "cast": "Pusté Žibřidovice",
    "psc": "78823",
    "okres": "Šumperk",
    "obec": "Jindřichov",
    "val": "78823 Jindrichov Puste Zibridovice"
  },
  {
    "cast": "Pustějov",
    "psc": "74243",
    "okres": "Nový Jičín",
    "obec": "Pustějov",
    "val": "74243 Pustejov Pustejov"
  },
  {
    "cast": "Pustiměř",
    "psc": "68321",
    "okres": "Vyškov",
    "obec": "Pustiměř",
    "val": "68321 Pustimer Pustimer"
  },
  {
    "cast": "Pustiměřské Prusy",
    "psc": "68321",
    "okres": "Vyškov",
    "obec": "Pustiměř",
    "val": "68321 Pustimer Pustimerske Prusy"
  },
  {
    "cast": "Pustina",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Měřín",
    "val": "59442 Merin Pustina"
  },
  {
    "cast": "Pustina",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Pustina",
    "val": "56601 Pustina Pustina"
  },
  {
    "cast": "Pustkovec",
    "psc": "70800",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70800 Ostrava Pustkovec"
  },
  {
    "cast": "Pustověty",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Pustověty",
    "val": "27023 Pustovety Pustovety"
  },
  {
    "cast": "Pustý Mlýn",
    "psc": "74771",
    "okres": "Opava",
    "obec": "Brumovice",
    "val": "74771 Brumovice Pusty Mlyn"
  },
  {
    "cast": "Pušperk",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Poleň",
    "val": "33901 Polen Pusperk"
  },
  {
    "cast": "Putim",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Putim",
    "val": "39701 Putim Putim"
  },
  {
    "cast": "Putimov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Putimov",
    "val": "39301 Putimov Putimov"
  },
  {
    "cast": "Putkov",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Putkov"
  },
  {
    "cast": "Pyskočely",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Vlkančice",
    "val": "28163 Vlkancice Pyskocely"
  },
  {
    "cast": "Pyšel",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Pyšel",
    "val": "67571 Pysel Pysel"
  },
  {
    "cast": "Pyšely",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Pyšely",
    "val": "25167 Pysely Pysely"
  },
  {
    "cast": "Pyšná",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Vysoká Pec",
    "val": "43111 Vysoka Pec Pysna"
  },
  {
    "cast": "Pytlíkov",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bžany",
    "val": "41501 Bzany Pytlikov"
  },
  {
    "cast": "Pytlov",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34901 Cernosin Pytlov"
  },
  {
    "cast": "Ráb",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Rab"
  },
  {
    "cast": "Rabakov",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Rabakov",
    "val": "29404 Rabakov Rabakov"
  },
  {
    "cast": "Rabí",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Rabí",
    "val": "34201 Rabi Rabi"
  },
  {
    "cast": "Rabouň",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Raboun"
  },
  {
    "cast": "Rabštejn",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Rabštejnská Lhota",
    "val": "53701 Rabstejnska Lhota Rabstejn"
  },
  {
    "cast": "Rabštejn nad Střelou",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Rabstejn nad Strelou"
  },
  {
    "cast": "Rabštejnská Lhota",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Rabštejnská Lhota",
    "val": "53701 Rabstejnska Lhota Rabstejnska Lhota"
  },
  {
    "cast": "Ráby",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Ráby",
    "val": "53352 Raby Raby"
  },
  {
    "cast": "Rabyně",
    "psc": "25208",
    "okres": "Benešov",
    "obec": "Rabyně",
    "val": "25208 Rabyne Rabyne"
  },
  {
    "cast": "Racek",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Chlístov",
    "val": "25601 Chlistov Racek"
  },
  {
    "cast": "Racková",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Racková",
    "val": "76001 Rackova Rackova"
  },
  {
    "cast": "Racov",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Staré Sedlo",
    "val": "34802 Stare Sedlo Racov"
  },
  {
    "cast": "Rácov",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Batelov",
    "val": "58851 Batelov Racov"
  },
  {
    "cast": "Rácovice",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Rácovice",
    "val": "67532 Racovice Racovice"
  },
  {
    "cast": "Račerovice",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Racerovice"
  },
  {
    "cast": "Račetice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Račetice",
    "val": "43801 Racetice Racetice"
  },
  {
    "cast": "Račí",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Volyně",
    "val": "38701 Volyne Raci"
  },
  {
    "cast": "Račí",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Horní Vltavice",
    "val": "38501 Horni Vltavice Raci"
  },
  {
    "cast": "Račice",
    "psc": "27024",
    "okres": "Rakovník",
    "obec": "Račice",
    "val": "27024 Racice Racice"
  },
  {
    "cast": "Račice",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Račice",
    "val": "41108 Racice Racice"
  },
  {
    "cast": "Račice",
    "psc": "67555",
    "okres": "Třebíč",
    "obec": "Račice",
    "val": "67555 Racice Racice"
  },
  {
    "cast": "Račice",
    "psc": "59255",
    "okres": "Žďár nad Sázavou",
    "obec": "Račice",
    "val": "59255 Racice Racice"
  },
  {
    "cast": "Račice",
    "psc": "68305",
    "okres": "Vyškov",
    "obec": "Račice-Pístovice",
    "val": "68305 Racice-Pistovice Racice"
  },
  {
    "cast": "Račice nad Trotinou",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Račice nad Trotinou",
    "val": "50303 Racice nad Trotinou Racice nad Trotinou"
  },
  {
    "cast": "Račín",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Nečtiny",
    "val": "33162 Nectiny Racin"
  },
  {
    "cast": "Račín",
    "psc": "59211",
    "okres": "Žďár nad Sázavou",
    "obec": "Račín",
    "val": "59211 Racin Racin"
  },
  {
    "cast": "Račiněves",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Račiněves",
    "val": "41301 Racineves Racineves"
  },
  {
    "cast": "Račíněves",
    "psc": "28509",
    "okres": "Kutná Hora",
    "obec": "Kácov",
    "val": "28509 Kacov Racineves"
  },
  {
    "cast": "Račov",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Racov"
  },
  {
    "cast": "Radčice",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Radcice"
  },
  {
    "cast": "Radčice",
    "psc": "32200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32200 Plzen Radcice"
  },
  {
    "cast": "Radčice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Radcice"
  },
  {
    "cast": "Radčice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Malonty",
    "val": "38241 Malonty Radcice"
  },
  {
    "cast": "Radčice",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Radčice",
    "val": "46822 Radcice Radcice"
  },
  {
    "cast": "Radčice-Liberec XXXII x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Radcice-Liberec XXXII x)"
  },
  {
    "cast": "Radeč",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Úpice",
    "val": "54232 Upice Radec"
  },
  {
    "cast": "Radeč",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nedrahovice",
    "val": "26401 Nedrahovice Radec"
  },
  {
    "cast": "Radeč",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Žandov",
    "val": "47002 Zandov Radec"
  },
  {
    "cast": "Radechov",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43201 Radonice Radechov"
  },
  {
    "cast": "Radejčín",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Řehlovice",
    "val": "40002 Rehlovice Radejcin"
  },
  {
    "cast": "Radějov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Buřenice",
    "val": "39501 Burenice Radejov"
  },
  {
    "cast": "Radějov",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Radejov"
  },
  {
    "cast": "Radějov",
    "psc": "69667",
    "okres": "Hodonín",
    "obec": "Radějov",
    "val": "69667 Radejov Radejov"
  },
  {
    "cast": "Radějovice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Netvořice",
    "val": "25744 Netvorice Radejovice"
  },
  {
    "cast": "Radějovice",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Přehýšov",
    "val": "33023 Prehysov Radejovice"
  },
  {
    "cast": "Radějovice",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Radějovice",
    "val": "38773 Radejovice Radejovice"
  },
  {
    "cast": "Radějovice",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Radějovice",
    "val": "25168 Radejovice Radejovice"
  },
  {
    "cast": "Radenice",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Radenice",
    "val": "59101 Radenice Radenice"
  },
  {
    "cast": "Radenín",
    "psc": "39120",
    "okres": "Tábor",
    "obec": "Radenín",
    "val": "39120 Radenin Radenin"
  },
  {
    "cast": "Radenov",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Blatno",
    "val": "43001 Blatno Radenov"
  },
  {
    "cast": "Radešice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26401 Petrovice Radesice"
  },
  {
    "cast": "Radešín",
    "psc": "59255",
    "okres": "Žďár nad Sázavou",
    "obec": "Radešín",
    "val": "59255 Radesin Radesin"
  },
  {
    "cast": "Radešín",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Martiněves",
    "val": "41119 Martineves Radesin"
  },
  {
    "cast": "Radešín",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Radesin"
  },
  {
    "cast": "Radešín",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Chuderov",
    "val": "40002 Chuderov Radesin"
  },
  {
    "cast": "Radešínská Svratka",
    "psc": "59233",
    "okres": "Žďár nad Sázavou",
    "obec": "Radešínská Svratka",
    "val": "59233 Radesinska Svratka Radesinska Svratka"
  },
  {
    "cast": "Radešov",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38719 Cestice Radesov"
  },
  {
    "cast": "Radešov",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Radesov"
  },
  {
    "cast": "Radešov",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Police nad Metují",
    "val": "54954 Police nad Metuji Radesov"
  },
  {
    "cast": "Radětice",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Radětice",
    "val": "26231 Radetice Radetice"
  },
  {
    "cast": "Radětice",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Radětice",
    "val": "39165 Radetice Radetice"
  },
  {
    "cast": "Radětín",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Radetin"
  },
  {
    "cast": "Radhostice",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Radhostice",
    "val": "38481 Radhostice Radhostice"
  },
  {
    "cast": "Radhošť",
    "psc": "53401",
    "okres": "Ústí nad Orlicí",
    "obec": "Radhošť",
    "val": "53401 Radhost Radhost"
  },
  {
    "cast": "Radíč",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Radíč",
    "val": "26401 Radic Radic"
  },
  {
    "cast": "Radíč",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Ješetice",
    "val": "25789 Jesetice Radic"
  },
  {
    "cast": "Radíčeves",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žatec",
    "val": "43801 Zatec Radiceves"
  },
  {
    "cast": "Radihošť",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Božetice",
    "val": "39901 Bozetice Radihost"
  },
  {
    "cast": "Radíkov",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Radíkov",
    "val": "75301 Radikov Radikov"
  },
  {
    "cast": "Radíkov",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Radikov"
  },
  {
    "cast": "Radíkov",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "38001 Cesky Rudolec Radikov"
  },
  {
    "cast": "Radíkovice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Loket",
    "val": "25768 Loket Radikovice"
  },
  {
    "cast": "Radíkovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Radikovice"
  },
  {
    "cast": "Radíkovice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Radíkovice",
    "val": "50327 Radikovice Radikovice"
  },
  {
    "cast": "Radíkovy",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Radikovy"
  },
  {
    "cast": "Radim",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Radim"
  },
  {
    "cast": "Radim",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Brantice",
    "val": "79401 Brantice Radim"
  },
  {
    "cast": "Radim",
    "psc": "50712",
    "okres": "Jičín",
    "obec": "Radim",
    "val": "50712 Radim Radim"
  },
  {
    "cast": "Radim (část)",
    "psc": "28911",
    "okres": "Kolín",
    "obec": "Radim",
    "val": "28911 Radim Radim (cast)"
  },
  {
    "cast": "Radim (část)",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Radim",
    "val": "28002 Radim Radim (cast)"
  },
  {
    "cast": "Radim (část)",
    "psc": "28103",
    "okres": "Kolín",
    "obec": "Radim",
    "val": "28103 Radim Radim (cast)"
  },
  {
    "cast": "Radiměř",
    "psc": "56907",
    "okres": "Svitavy",
    "obec": "Radiměř",
    "val": "56907 Radimer Radimer"
  },
  {
    "cast": "Radimov",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Skalice",
    "val": "39201 Skalice Radimov"
  },
  {
    "cast": "Radimovice",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Radimovice",
    "val": "46344 Radimovice Radimovice"
  },
  {
    "cast": "Radimovice",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Všeruby",
    "val": "33035 Vseruby Radimovice"
  },
  {
    "cast": "Radimovice",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Petříkov",
    "val": "25169 Petrikov Radimovice"
  },
  {
    "cast": "Radimovice u Tábora",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Radimovice u Tábora",
    "val": "39131 Radimovice u Tabora Radimovice u Tabora"
  },
  {
    "cast": "Radimovice u Želče",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Radimovice u Želče",
    "val": "39002 Radimovice u Zelce Radimovice u Zelce"
  },
  {
    "cast": "Radinovy",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Vrhaveč",
    "val": "33901 Vrhavec Radinovy"
  },
  {
    "cast": "Radišov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Staré Město",
    "val": "57101 Stare Mesto Radisov"
  },
  {
    "cast": "Radkov",
    "psc": "74784",
    "okres": "Opava",
    "obec": "Radkov",
    "val": "74784 Radkov Radkov"
  },
  {
    "cast": "Radkov",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Radkov",
    "val": "58856 Radkov Radkov"
  },
  {
    "cast": "Radkov",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Radkov",
    "val": "39131 Radkov Radkov"
  },
  {
    "cast": "Radkov",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Radkov",
    "val": "59253 Radkov Radkov"
  },
  {
    "cast": "Radkov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Radkov",
    "val": "57101 Radkov Radkov"
  },
  {
    "cast": "Radkova Lhota",
    "psc": "75114",
    "okres": "Přerov",
    "obec": "Radkova Lhota",
    "val": "75114 Radkova Lhota Radkova Lhota"
  },
  {
    "cast": "Radkovice",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "34012 Mecin Radkovice"
  },
  {
    "cast": "Radkovice",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Úlehle",
    "val": "38719 Ulehle Radkovice"
  },
  {
    "cast": "Radkovice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Radkovice",
    "val": "33401 Radkovice Radkovice"
  },
  {
    "cast": "Radkovice u Budče",
    "psc": "38001",
    "okres": "Třebíč",
    "obec": "Radkovice u Budče",
    "val": "38001 Radkovice u Budce Radkovice u Budce"
  },
  {
    "cast": "Radkovice u Hrotovic",
    "psc": "67559",
    "okres": "Třebíč",
    "obec": "Radkovice u Hrotovic",
    "val": "67559 Radkovice u Hrotovic Radkovice u Hrotovic"
  },
  {
    "cast": "Radkovy",
    "psc": "75114",
    "okres": "Přerov",
    "obec": "Radkovy",
    "val": "75114 Radkovy Radkovy"
  },
  {
    "cast": "Radkyně",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Radkyne"
  },
  {
    "cast": "Radlice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Volfířov",
    "val": "38001 Volfirov Radlice"
  },
  {
    "cast": "Radlice",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Barchovice",
    "val": "28163 Barchovice Radlice"
  },
  {
    "cast": "Radlice (část)",
    "psc": "15000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15000 Praha Radlice (cast)"
  },
  {
    "cast": "Radlice (část)",
    "psc": "15800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15800 Praha Radlice (cast)"
  },
  {
    "cast": "Radlík",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Jílové u Prahy",
    "val": "25401 Jilove u Prahy Radlik"
  },
  {
    "cast": "Radlín",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Heřmanův Městec",
    "val": "53803 Hermanuv Mestec Radlin"
  },
  {
    "cast": "Rádlo",
    "psc": "46803",
    "okres": "Jablonec nad Nisou",
    "obec": "Rádlo",
    "val": "46803 Radlo Radlo"
  },
  {
    "cast": "Radnice",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Pavlov",
    "val": "78985 Pavlov Radnice"
  },
  {
    "cast": "Radnice",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Radnice",
    "val": "33828 Radnice Radnice"
  },
  {
    "cast": "Radňov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Radnov"
  },
  {
    "cast": "Radňov",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Květinov",
    "val": "58255 Kvetinov Radnov"
  },
  {
    "cast": "Radňoves",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Radňoves",
    "val": "59451 Radnoves Radnoves"
  },
  {
    "cast": "Radňovice",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Radňovice",
    "val": "59231 Radnovice Radnovice"
  },
  {
    "cast": "Radobyčice",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Radobycice"
  },
  {
    "cast": "Radobytce",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39804 Mirotice Radobytce"
  },
  {
    "cast": "Radochlín",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Lukavice",
    "val": "53821 Lukavice Radochlin"
  },
  {
    "cast": "Radochovy",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Neurazy",
    "val": "33501 Neurazy Radochovy"
  },
  {
    "cast": "Radomilice",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37348 Driten Radomilice"
  },
  {
    "cast": "Radomilov",
    "psc": "78963",
    "okres": "Šumperk",
    "obec": "Ruda nad Moravou",
    "val": "78963 Ruda nad Moravou Radomilov"
  },
  {
    "cast": "Radomyšl (část)",
    "psc": "38731",
    "okres": "Strakonice",
    "obec": "Radomyšl",
    "val": "38731 Radomysl Radomysl (cast)"
  },
  {
    "cast": "Radomyšl (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Radomyšl",
    "val": "38601 Radomysl Radomysl (cast)"
  },
  {
    "cast": "Radonice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Divišov",
    "val": "25726 Divisov Radonice"
  },
  {
    "cast": "Radonice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Milavče",
    "val": "34401 Milavce Radonice"
  },
  {
    "cast": "Radonice",
    "psc": "43155",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43155 Radonice Radonice"
  },
  {
    "cast": "Radonice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Dolní Bukovsko",
    "val": "37341 Dolni Bukovsko Radonice"
  },
  {
    "cast": "Radonice nad Ohří",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Peruc",
    "val": "44001 Peruc Radonice nad Ohri"
  },
  {
    "cast": "Radonice (část)",
    "psc": "25073",
    "okres": "Praha-východ",
    "obec": "Radonice",
    "val": "25073 Radonice Radonice (cast)"
  },
  {
    "cast": "Radonice (část)",
    "psc": "25074",
    "okres": "Praha-východ",
    "obec": "Radonice",
    "val": "25074 Radonice Radonice (cast)"
  },
  {
    "cast": "Radonín",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Radonín",
    "val": "67521 Radonin Radonin"
  },
  {
    "cast": "Radonín",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Radonin"
  },
  {
    "cast": "Radoňovice",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Hodkovice nad Mohelkou",
    "val": "46342 Hodkovice nad Mohelkou Radonovice"
  },
  {
    "cast": "Radostice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Radostice"
  },
  {
    "cast": "Radostice",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Vchynice",
    "val": "41002 Vchynice Radostice"
  },
  {
    "cast": "Radostice",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Borovany",
    "val": "37312 Borovany Radostice"
  },
  {
    "cast": "Radostice",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Radostice"
  },
  {
    "cast": "Radostice (část)",
    "psc": "66446",
    "okres": "Brno-venkov",
    "obec": "Radostice",
    "val": "66446 Radostice Radostice (cast)"
  },
  {
    "cast": "Radostice (část)",
    "psc": "66447",
    "okres": "Brno-venkov",
    "obec": "Radostice",
    "val": "66447 Radostice Radostice (cast)"
  },
  {
    "cast": "Radostín",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Sychrov",
    "val": "46344 Sychrov Radostin"
  },
  {
    "cast": "Radostín",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Radostín",
    "val": "58001 Radostin Radostin"
  },
  {
    "cast": "Radostín",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Radostín",
    "val": "59101 Radostin Radostin"
  },
  {
    "cast": "Radostín nad Oslavou",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Radostín nad Oslavou",
    "val": "59444 Radostin nad Oslavou Radostin nad Oslavou"
  },
  {
    "cast": "Radostov",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Radostov",
    "val": "50327 Radostov Radostov"
  },
  {
    "cast": "Radostovice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Dolní Hořice",
    "val": "39155 Dolni Horice Radostovice"
  },
  {
    "cast": "Radostovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Smilovy Hory",
    "val": "39143 Smilovy Hory Radostovice"
  },
  {
    "cast": "Radostovice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Lično",
    "val": "51721 Licno Radostovice"
  },
  {
    "cast": "Radostovice",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Radostovice"
  },
  {
    "cast": "Radošice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mladý Smolivec",
    "val": "33501 Mlady Smolivec Radosice"
  },
  {
    "cast": "Radoškov",
    "psc": "66483",
    "okres": "Brno-venkov",
    "obec": "Přibyslavice",
    "val": "66483 Pribyslavice Radoskov"
  },
  {
    "cast": "Radošov",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Radošov",
    "val": "67507 Radosov Radosov"
  },
  {
    "cast": "Radošov",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Kyselka",
    "val": "36272 Kyselka Radosov"
  },
  {
    "cast": "Radošovice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Radošovice",
    "val": "25726 Radosovice Radosovice"
  },
  {
    "cast": "Radošovice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Říčany",
    "val": "25101 Ricany Radosovice"
  },
  {
    "cast": "Radošovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Radošovice",
    "val": "38601 Radosovice Radosovice"
  },
  {
    "cast": "Radošovice",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Radosovice"
  },
  {
    "cast": "Radošovice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Radošovice",
    "val": "37341 Radosovice Radosovice"
  },
  {
    "cast": "Radotice",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Radotice",
    "val": "67532 Radotice Radotice"
  },
  {
    "cast": "Radotín",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Radotin"
  },
  {
    "cast": "Radotín",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Radotín",
    "val": "75354 Radotin Radotin"
  },
  {
    "cast": "Radotín",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25753 Olbramovice Radotin"
  },
  {
    "cast": "Radotín (část)",
    "psc": "15900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15900 Praha Radotin (cast)"
  },
  {
    "cast": "Radotín (část)",
    "psc": "25226",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "25226 Praha Radotin (cast)"
  },
  {
    "cast": "Radotín (část)",
    "psc": "15300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15300 Praha Radotin (cast)"
  },
  {
    "cast": "Radouň",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Radoun"
  },
  {
    "cast": "Radouň",
    "psc": "27738",
    "okres": "Mělník",
    "obec": "Mělnické Vtelno",
    "val": "27738 Melnicke Vtelno Radoun"
  },
  {
    "cast": "Radouňka",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Jindřichův Hradec",
    "val": "37701 Jindrichuv Hradec Radounka"
  },
  {
    "cast": "Radouš",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Hostomice",
    "val": "26724 Hostomice Radous"
  },
  {
    "cast": "Radovesice",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Radovesice",
    "val": "41002 Radovesice Radovesice"
  },
  {
    "cast": "Radovesnice I",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Radovesnice I",
    "val": "28002 Radovesnice I Radovesnice I"
  },
  {
    "cast": "Radovesnice II (část)",
    "psc": "28130",
    "okres": "Kolín",
    "obec": "Radovesnice II",
    "val": "28130 Radovesnice II Radovesnice II (cast)"
  },
  {
    "cast": "Radovesnice II (část)",
    "psc": "28128",
    "okres": "Kolín",
    "obec": "Radovesnice II",
    "val": "28128 Radovesnice II Radovesnice II (cast)"
  },
  {
    "cast": "Radslavice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Radslavice"
  },
  {
    "cast": "Radslavice",
    "psc": "68321",
    "okres": "Vyškov",
    "obec": "Radslavice",
    "val": "68321 Radslavice Radslavice"
  },
  {
    "cast": "Radslavice",
    "psc": "75111",
    "okres": "Přerov",
    "obec": "Radslavice",
    "val": "75111 Radslavice Radslavice"
  },
  {
    "cast": "Radslavičky",
    "psc": "68321",
    "okres": "Vyškov",
    "obec": "Radslavice",
    "val": "68321 Radslavice Radslavicky"
  },
  {
    "cast": "Raduň",
    "psc": "74761",
    "okres": "Opava",
    "obec": "Raduň",
    "val": "74761 Radun Radun"
  },
  {
    "cast": "Radvančice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Radvancice"
  },
  {
    "cast": "Radvanec",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Radvanec",
    "val": "47301 Radvanec Radvanec"
  },
  {
    "cast": "Radvanice",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28506 Uzice Radvanice"
  },
  {
    "cast": "Radvanice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Radvanice"
  },
  {
    "cast": "Radvanice",
    "psc": "75121",
    "okres": "Přerov",
    "obec": "Radvanice",
    "val": "75121 Radvanice Radvanice"
  },
  {
    "cast": "Radvanice",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Kobyly",
    "val": "46345 Kobyly Radvanice"
  },
  {
    "cast": "Radvanice",
    "psc": "71600",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71600 Ostrava Radvanice"
  },
  {
    "cast": "Radvanice",
    "psc": "54212",
    "okres": "Trutnov",
    "obec": "Radvanice",
    "val": "54212 Radvanice Radvanice"
  },
  {
    "cast": "Radvanov",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Josefov",
    "val": "35709 Josefov Radvanov"
  },
  {
    "cast": "Radvanov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Radvanov"
  },
  {
    "cast": "Radvánov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Radvanov"
  },
  {
    "cast": "Radvánovice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Karlovice",
    "val": "51101 Karlovice Radvanovice"
  },
  {
    "cast": "Radyně",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Radyne"
  },
  {
    "cast": "Ráj",
    "psc": "73401",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73401 Karvina Raj"
  },
  {
    "cast": "Ráj",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Raj"
  },
  {
    "cast": "Rájec",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Rájec",
    "val": "78901 Rajec Rajec"
  },
  {
    "cast": "Rájec",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Černava",
    "val": "36221 Cernava Rajec"
  },
  {
    "cast": "Rájec",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Rájec-Jestřebí",
    "val": "67902 Rajec-Jestrebi Rajec"
  },
  {
    "cast": "Rájec",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Borovnice",
    "val": "51741 Borovnice Rajec"
  },
  {
    "cast": "Ráječko",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Ráječko",
    "val": "67902 Rajecko Rajecko"
  },
  {
    "cast": "Rajhrad",
    "psc": "66461",
    "okres": "Brno-venkov",
    "obec": "Rajhrad",
    "val": "66461 Rajhrad Rajhrad"
  },
  {
    "cast": "Rajhradice",
    "psc": "66461",
    "okres": "Brno-venkov",
    "obec": "Rajhradice",
    "val": "66461 Rajhradice Rajhradice"
  },
  {
    "cast": "Rajchardov",
    "psc": "25209",
    "okres": "Praha-západ",
    "obec": "Hradištko",
    "val": "25209 Hradistko Rajchardov"
  },
  {
    "cast": "Rajnochovice",
    "psc": "76871",
    "okres": "Kroměříž",
    "obec": "Rajnochovice",
    "val": "76871 Rajnochovice Rajnochovice"
  },
  {
    "cast": "Rájov",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Rajov"
  },
  {
    "cast": "Rájov",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mnichov",
    "val": "35301 Mnichov Rajov"
  },
  {
    "cast": "Rájov",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Pňovany",
    "val": "33033 Pnovany Rajov"
  },
  {
    "cast": "Rájov",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Perštejn",
    "val": "43151 Perstejn Rajov"
  },
  {
    "cast": "Rájov (část)",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Zlatá Koruna",
    "val": "38232 Zlata Koruna Rajov (cast)"
  },
  {
    "cast": "Rájov (část)",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Zlatá Koruna",
    "val": "38101 Zlata Koruna Rajov (cast)"
  },
  {
    "cast": "Rajské",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Běšiny",
    "val": "33901 Besiny Rajske"
  },
  {
    "cast": "Rajsko",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Dlouhá Ves",
    "val": "34201 Dlouha Ves Rajsko"
  },
  {
    "cast": "Rakodavy",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Věrovany",
    "val": "78375 Verovany Rakodavy"
  },
  {
    "cast": "Rakolusky",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Bohy",
    "val": "33141 Bohy Rakolusky"
  },
  {
    "cast": "Rakousy",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Rakousy",
    "val": "51101 Rakousy Rakousy"
  },
  {
    "cast": "Rakov",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Rakov",
    "val": "75354 Rakov Rakov"
  },
  {
    "cast": "Rakov",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50743 Markvartice Rakov"
  },
  {
    "cast": "Rakov",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Rakov"
  },
  {
    "cast": "Raková",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Raková",
    "val": "33701 Rakova Rakova"
  },
  {
    "cast": "Raková",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Zádveřice-Raková",
    "val": "76312 Zadverice-Rakova Rakova"
  },
  {
    "cast": "Raková u Konice",
    "psc": "79857",
    "okres": "Prostějov",
    "obec": "Raková u Konice",
    "val": "79857 Rakova u Konice Rakova u Konice"
  },
  {
    "cast": "Rakové",
    "psc": "59261",
    "okres": "Brno-venkov",
    "obec": "Olší",
    "val": "59261 Olsi Rakove"
  },
  {
    "cast": "Rakovice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Rakovice",
    "val": "39804 Rakovice Rakovice"
  },
  {
    "cast": "Rakovické Chalupy",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39804 Mirotice Rakovicke Chalupy"
  },
  {
    "cast": "Rakovník I",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Rakovník",
    "val": "26901 Rakovnik Rakovnik I"
  },
  {
    "cast": "Rakovník II (část)",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Rakovník",
    "val": "26901 Rakovnik Rakovnik II (cast)"
  },
  {
    "cast": "Rakovník II (část)",
    "psc": "27036",
    "okres": "Rakovník",
    "obec": "Rakovník",
    "val": "27036 Rakovnik Rakovnik II (cast)"
  },
  {
    "cast": "Rakšice (část)",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Moravský Krumlov",
    "val": "67201 Moravsky Krumlov Raksice (cast)"
  },
  {
    "cast": "Rakšice (část)",
    "psc": "67175",
    "okres": "Znojmo",
    "obec": "Moravský Krumlov",
    "val": "67175 Moravsky Krumlov Raksice (cast)"
  },
  {
    "cast": "Rakůvka",
    "psc": "79857",
    "okres": "Prostějov",
    "obec": "Rakůvka",
    "val": "79857 Rakuvka Rakuvka"
  },
  {
    "cast": "Rakvice",
    "psc": "69103",
    "okres": "Břeclav",
    "obec": "Rakvice",
    "val": "69103 Rakvice Rakvice"
  },
  {
    "cast": "Rampuše",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51601 Liberk Rampuse"
  },
  {
    "cast": "Ramzová",
    "psc": "78825",
    "okres": "Jeseník",
    "obec": "Ostružná",
    "val": "78825 Ostruzna Ramzova"
  },
  {
    "cast": "Raná",
    "psc": "43924",
    "okres": "Louny",
    "obec": "Raná",
    "val": "43924 Rana Rana"
  },
  {
    "cast": "Raná",
    "psc": "53972",
    "okres": "Chrudim",
    "obec": "Raná",
    "val": "53972 Rana Rana"
  },
  {
    "cast": "Rancířov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Dešná",
    "val": "37881 Desna Rancirov"
  },
  {
    "cast": "Rančice",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Kamenný Újezd",
    "val": "37007 Kamenny Ujezd Rancice"
  },
  {
    "cast": "Rančířov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Rančířov",
    "val": "58601 Rancirov Rancirov"
  },
  {
    "cast": "Rané (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47002 Kravare Rane (cast)"
  },
  {
    "cast": "Rané (část)",
    "psc": "47103",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47103 Kravare Rane (cast)"
  },
  {
    "cast": "Rané (část)",
    "psc": "47102",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47102 Kravare Rane (cast)"
  },
  {
    "cast": "Rankov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Rankov"
  },
  {
    "cast": "Rankov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Rankov"
  },
  {
    "cast": "Rankovice",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Rankovice"
  },
  {
    "cast": "Rantířov",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Rantířov",
    "val": "58841 Rantirov Rantirov"
  },
  {
    "cast": "Rápošov",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28401 Zbraslavice Raposov"
  },
  {
    "cast": "Rapotice",
    "psc": "67573",
    "okres": "Třebíč",
    "obec": "Rapotice",
    "val": "67573 Rapotice Rapotice"
  },
  {
    "cast": "Rapotice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Malonty",
    "val": "38241 Malonty Rapotice"
  },
  {
    "cast": "Rapotín (část)",
    "psc": "78814",
    "okres": "Šumperk",
    "obec": "Rapotín",
    "val": "78814 Rapotin Rapotin (cast)"
  },
  {
    "cast": "Rapotín (část)",
    "psc": "78701",
    "okres": "Šumperk",
    "obec": "Rapotín",
    "val": "78701 Rapotin Rapotin (cast)"
  },
  {
    "cast": "Rapotín (část)",
    "psc": "78813",
    "okres": "Šumperk",
    "obec": "Rapotín",
    "val": "78813 Rapotin Rapotin (cast)"
  },
  {
    "cast": "Rapšach",
    "psc": "37807",
    "okres": "Jindřichův Hradec",
    "obec": "Rapšach",
    "val": "37807 Rapsach Rapsach"
  },
  {
    "cast": "Rasochy",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Uhlířská Lhota",
    "val": "28126 Uhlirska Lhota Rasochy"
  },
  {
    "cast": "Rasošky (část)",
    "psc": "55221",
    "okres": "Náchod",
    "obec": "Rasošky",
    "val": "55221 Rasosky Rasosky (cast)"
  },
  {
    "cast": "Rasošky (část)",
    "psc": "55102",
    "okres": "Náchod",
    "obec": "Rasošky",
    "val": "55102 Rasosky Rasosky (cast)"
  },
  {
    "cast": "Raspenava",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Raspenava",
    "val": "46401 Raspenava Raspenava"
  },
  {
    "cast": "Rastory",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Podolí I",
    "val": "39843 Podoli I Rastory"
  },
  {
    "cast": "Rašín",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Rašín",
    "val": "50801 Rasin Rasin"
  },
  {
    "cast": "Raškov",
    "psc": "78964",
    "okres": "Šumperk",
    "obec": "Bohdíkov",
    "val": "78964 Bohdikov Raskov"
  },
  {
    "cast": "Raškovice",
    "psc": "73904",
    "okres": "Frýdek-Místek",
    "obec": "Raškovice",
    "val": "73904 Raskovice Raskovice"
  },
  {
    "cast": "Rašov",
    "psc": "43601",
    "okres": "Most",
    "obec": "Klíny",
    "val": "43601 Kliny Rasov"
  },
  {
    "cast": "Rašov",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Rašov",
    "val": "67923 Rasov Rasov"
  },
  {
    "cast": "Rašovice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Rasovice"
  },
  {
    "cast": "Rašovice",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Rašovice",
    "val": "68501 Rasovice Rasovice"
  },
  {
    "cast": "Rašovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Hlasivo",
    "val": "39143 Hlasivo Rasovice"
  },
  {
    "cast": "Rašovice",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Budiměřice",
    "val": "28802 Budimerice Rasovice"
  },
  {
    "cast": "Rašovice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Rašovice",
    "val": "28504 Rasovice Rasovice"
  },
  {
    "cast": "Rašovice",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Rasovice"
  },
  {
    "cast": "Rašovice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Týniště nad Orlicí",
    "val": "51721 Tyniste nad Orlici Rasovice"
  },
  {
    "cast": "Rašovka",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Šimonovice",
    "val": "46312 Simonovice Rasovka"
  },
  {
    "cast": "Rašovy",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Turkovice",
    "val": "53501 Turkovice Rasovy"
  },
  {
    "cast": "Rataje",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Rataje",
    "val": "39165 Rataje Rataje"
  },
  {
    "cast": "Rataje",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Rataje",
    "val": "25801 Rataje Rataje"
  },
  {
    "cast": "Rataje",
    "psc": "78346",
    "okres": "Olomouc",
    "obec": "Těšetice",
    "val": "78346 Tesetice Rataje"
  },
  {
    "cast": "Rataje",
    "psc": "76812",
    "okres": "Kroměříž",
    "obec": "Rataje",
    "val": "76812 Rataje Rataje"
  },
  {
    "cast": "Rataje nad Sázavou (část)",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Rataje nad Sázavou",
    "val": "28506 Rataje nad Sazavou Rataje nad Sazavou (cast)"
  },
  {
    "cast": "Rataje nad Sázavou (část)",
    "psc": "28507",
    "okres": "Kutná Hora",
    "obec": "Rataje nad Sázavou",
    "val": "28507 Rataje nad Sazavou Rataje nad Sazavou (cast)"
  },
  {
    "cast": "Ratboř",
    "psc": "28141",
    "okres": "Kolín",
    "obec": "Ratboř",
    "val": "28141 Ratbor Ratbor"
  },
  {
    "cast": "Ratenice",
    "psc": "28911",
    "okres": "Kolín",
    "obec": "Ratenice",
    "val": "28911 Ratenice Ratenice"
  },
  {
    "cast": "Ratiborova Lhota",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Mičovice",
    "val": "38301 Micovice Ratiborova Lhota"
  },
  {
    "cast": "Ratiboř",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Ratibor"
  },
  {
    "cast": "Ratiboř",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36452 Zlutice Ratibor"
  },
  {
    "cast": "Ratiboř",
    "psc": "75621",
    "okres": "Vsetín",
    "obec": "Ratiboř",
    "val": "75621 Ratibor Ratibor"
  },
  {
    "cast": "Ratiboř (část)",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Ratiboř",
    "val": "37821 Ratibor Ratibor (cast)"
  },
  {
    "cast": "Ratiboř (část)",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Ratiboř",
    "val": "37701 Ratibor Ratibor (cast)"
  },
  {
    "cast": "Ratibořec",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Ratiborec"
  },
  {
    "cast": "Ratibořice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Ratibořské Hory",
    "val": "39143 Ratiborske Hory Ratiborice"
  },
  {
    "cast": "Ratibořice",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Česká Skalice",
    "val": "55203 Ceska Skalice Ratiborice"
  },
  {
    "cast": "Ratibořice",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Jaroměřice nad Rokytnou",
    "val": "67551 Jaromerice nad Rokytnou Ratiborice"
  },
  {
    "cast": "Ratibořské Hory (část)",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Ratibořské Hory",
    "val": "39143 Ratiborske Hory Ratiborske Hory (cast)"
  },
  {
    "cast": "Ratibořské Hory (část)",
    "psc": "39142",
    "okres": "Tábor",
    "obec": "Ratibořské Hory",
    "val": "39142 Ratiborske Hory Ratiborske Hory (cast)"
  },
  {
    "cast": "Ratíškovice",
    "psc": "69602",
    "okres": "Hodonín",
    "obec": "Ratíškovice",
    "val": "69602 Ratiskovice Ratiskovice"
  },
  {
    "cast": "Ratišovice",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Běhařovice",
    "val": "67140 Beharovice Ratisovice"
  },
  {
    "cast": "Ratměřice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Ratměřice",
    "val": "25703 Ratmerice Ratmerice"
  },
  {
    "cast": "Raveň",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Střítež",
    "val": "38241 Stritez Raven"
  },
  {
    "cast": "Razice",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41804 Hrobcice Razice"
  },
  {
    "cast": "Razová",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Razová",
    "val": "79201 Razova Razova"
  },
  {
    "cast": "Ráztely",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Raztely"
  },
  {
    "cast": "Ražice",
    "psc": "39822",
    "okres": "Písek",
    "obec": "Ražice",
    "val": "39822 Razice Razice"
  },
  {
    "cast": "Rážkovy",
    "psc": "39901",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "39901 Nechvalice Razkovy"
  },
  {
    "cast": "Rebešovice",
    "psc": "66461",
    "okres": "Brno-venkov",
    "obec": "Rebešovice",
    "val": "66461 Rebesovice Rebesovice"
  },
  {
    "cast": "Rejčkov",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Město",
    "val": "58401 Dolni Mesto Rejckov"
  },
  {
    "cast": "Rejdice",
    "psc": "46848",
    "okres": "Jablonec nad Nisou",
    "obec": "Kořenov",
    "val": "46848 Korenov Rejdice"
  },
  {
    "cast": "Rejhotice",
    "psc": "78811",
    "okres": "Šumperk",
    "obec": "Loučná nad Desnou",
    "val": "78811 Loucna nad Desnou Rejhotice"
  },
  {
    "cast": "Rejchartice",
    "psc": "78701",
    "okres": "Šumperk",
    "obec": "Rejchartice",
    "val": "78701 Rejchartice Rejchartice"
  },
  {
    "cast": "Rejchartice",
    "psc": "79368",
    "okres": "Bruntál",
    "obec": "Dvorce",
    "val": "79368 Dvorce Rejchartice"
  },
  {
    "cast": "Rejkovice",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Jince",
    "val": "26223 Jince Rejkovice"
  },
  {
    "cast": "Rejkovice",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Louňovice pod Blaníkem",
    "val": "25706 Lounovice pod Blanikem Rejkovice"
  },
  {
    "cast": "Rejšice",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Smilovice",
    "val": "29442 Smilovice Rejsice"
  },
  {
    "cast": "Rejštejn",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Rejstejn"
  },
  {
    "cast": "Rejvíz",
    "psc": "79376",
    "okres": "Jeseník",
    "obec": "Zlaté Hory",
    "val": "79376 Zlate Hory Rejviz"
  },
  {
    "cast": "Reksyně",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Reksyne"
  },
  {
    "cast": "Remuta",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Trpišovice",
    "val": "58401 Trpisovice Remuta"
  },
  {
    "cast": "Renoty",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Renoty"
  },
  {
    "cast": "Repechy",
    "psc": "79861",
    "okres": "Prostějov",
    "obec": "Bousín",
    "val": "79861 Bousin Repechy"
  },
  {
    "cast": "Rešice",
    "psc": "67173",
    "okres": "Znojmo",
    "obec": "Rešice",
    "val": "67173 Resice Resice"
  },
  {
    "cast": "Rešov",
    "psc": "79344",
    "okres": "Bruntál",
    "obec": "Horní Město",
    "val": "79344 Horni Mesto Resov"
  },
  {
    "cast": "Režný Újezd",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41002 Velemin Rezny Ujezd"
  },
  {
    "cast": "Robčice",
    "psc": "33209",
    "okres": "Plzeň-jih",
    "obec": "Útušice",
    "val": "33209 Utusice Robcice"
  },
  {
    "cast": "Robčice",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kozojedy",
    "val": "33141 Kozojedy Robcice"
  },
  {
    "cast": "Robeč",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41108 Ustek Robec"
  },
  {
    "cast": "Roblín",
    "psc": "25226",
    "okres": "Praha-západ",
    "obec": "Roblín",
    "val": "25226 Roblin Roblin"
  },
  {
    "cast": "Robousy",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Robousy"
  },
  {
    "cast": "Ročov",
    "psc": "43967",
    "okres": "Louny",
    "obec": "Ročov",
    "val": "43967 Rocov Rocov"
  },
  {
    "cast": "Rodinov",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Rodinov",
    "val": "39470 Rodinov Rodinov"
  },
  {
    "cast": "Rodkov",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Rodkov",
    "val": "59251 Rodkov Rodkov"
  },
  {
    "cast": "Rodná",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Rodná",
    "val": "39143 Rodna Rodna"
  },
  {
    "cast": "Rodov",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Smiřice",
    "val": "50303 Smirice Rodov"
  },
  {
    "cast": "Rodvínov",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Rodvínov",
    "val": "37701 Rodvinov Rodvinov"
  },
  {
    "cast": "Rohanov",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Rohanov"
  },
  {
    "cast": "Rohanov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Chroboly",
    "val": "38301 Chroboly Rohanov"
  },
  {
    "cast": "Rohatce",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Hrobce",
    "val": "41201 Hrobce Rohatce"
  },
  {
    "cast": "Rohatec",
    "psc": "69601",
    "okres": "Hodonín",
    "obec": "Rohatec",
    "val": "69601 Rohatec Rohatec"
  },
  {
    "cast": "Rohatsko",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Rohatsko",
    "val": "29404 Rohatsko Rohatsko"
  },
  {
    "cast": "Rohenice",
    "psc": "51771",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rohenice",
    "val": "51771 Rohenice Rohenice"
  },
  {
    "cast": "Rohle",
    "psc": "78974",
    "okres": "Šumperk",
    "obec": "Rohle",
    "val": "78974 Rohle Rohle"
  },
  {
    "cast": "Rohliny",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Rohliny"
  },
  {
    "cast": "Rohov",
    "psc": "74725",
    "okres": "Opava",
    "obec": "Rohov",
    "val": "74725 Rohov Rohov"
  },
  {
    "cast": "Rohov",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Rohov"
  },
  {
    "cast": "Rohovka",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Dobrá Voda",
    "val": "39301 Dobra Voda Rohovka"
  },
  {
    "cast": "Rohovládova Bělá",
    "psc": "53343",
    "okres": "Pardubice",
    "obec": "Rohovládova Bělá",
    "val": "53343 Rohovladova Bela Rohovladova Bela"
  },
  {
    "cast": "Rohozec",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Rohozec",
    "val": "28401 Rohozec Rohozec"
  },
  {
    "cast": "Rohozec (část)",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Rohozec",
    "val": "66601 Rohozec Rohozec (cast)"
  },
  {
    "cast": "Rohozec (část)",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Rohozec",
    "val": "67923 Rohozec Rohozec (cast)"
  },
  {
    "cast": "Rohozná",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Osek",
    "val": "38601 Osek Rohozna"
  },
  {
    "cast": "Rohozná",
    "psc": "56972",
    "okres": "Svitavy",
    "obec": "Rohozná",
    "val": "56972 Rohozna Rohozna"
  },
  {
    "cast": "Rohozná",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Trhová Kamenice",
    "val": "53901 Trhova Kamenice Rohozna"
  },
  {
    "cast": "Rohozná (část)",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Rohozná",
    "val": "58851 Rohozna Rohozna (cast)"
  },
  {
    "cast": "Rohozná (část)",
    "psc": "58844",
    "okres": "Jihlava",
    "obec": "Rohozná",
    "val": "58844 Rohozna Rohozna (cast)"
  },
  {
    "cast": "Rohoznice",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Rohoznice",
    "val": "50771 Rohoznice Rohoznice"
  },
  {
    "cast": "Rohoznice",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Rohoznice",
    "val": "53341 Rohoznice Rohoznice"
  },
  {
    "cast": "Rohozno",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Rohozno"
  },
  {
    "cast": "Rohozov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Rohozov"
  },
  {
    "cast": "Rohy",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Rohy",
    "val": "67505 Rohy Rohy"
  },
  {
    "cast": "Rochlice-Liberec VI x)",
    "psc": "46006",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46006 Liberec Rochlice-Liberec VI x)"
  },
  {
    "cast": "Rochlov",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Rochlov",
    "val": "33023 Rochlov Rochlov"
  },
  {
    "cast": "Rochov",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Rochov"
  },
  {
    "cast": "Rochov",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Rochov",
    "val": "41301 Rochov Rochov"
  },
  {
    "cast": "Rojetín",
    "psc": "59451",
    "okres": "Brno-venkov",
    "obec": "Rojetín",
    "val": "59451 Rojetin Rojetin"
  },
  {
    "cast": "Rojice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Radomyšl",
    "val": "38601 Radomysl Rojice"
  },
  {
    "cast": "Rojšín",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Brloh",
    "val": "38203 Brloh Rojsin"
  },
  {
    "cast": "Rok",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Rok"
  },
  {
    "cast": "Rokle",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Rokle",
    "val": "43201 Rokle Rokle"
  },
  {
    "cast": "Rokytná",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Moravský Krumlov",
    "val": "67201 Moravsky Krumlov Rokytna"
  },
  {
    "cast": "Rokytnice",
    "psc": "75501",
    "okres": "Vsetín",
    "obec": "Vsetín",
    "val": "75501 Vsetin Rokytnice"
  },
  {
    "cast": "Rokytnice",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Rokytnice",
    "val": "76321 Rokytnice Rokytnice"
  },
  {
    "cast": "Rokytnice",
    "psc": "75104",
    "okres": "Přerov",
    "obec": "Rokytnice",
    "val": "75104 Rokytnice Rokytnice"
  },
  {
    "cast": "Rokytnice nad Jizerou-Dolní Rokytnice x)",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Rokytnice nad Jizerou-Dolni Rokytnice x)"
  },
  {
    "cast": "Rokytnice nad Jizerou-Františkov x)",
    "psc": "51245",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51245 Rokytnice nad Jizerou Rokytnice nad Jizerou-Frantiskov x)"
  },
  {
    "cast": "Rokytnice nad Jizerou-Hleďsebe x)",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Rokytnice nad Jizerou-Hledsebe x)"
  },
  {
    "cast": "Rokytnice nad Jizerou-Horní Rokytnice (část)",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Rokytnice nad Jizerou-Horni Rokytnice (cast)"
  },
  {
    "cast": "Rokytnice nad Jizerou-Horní Rokytnice (část)",
    "psc": "51245",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51245 Rokytnice nad Jizerou Rokytnice nad Jizerou-Horni Rokytnice (cast)"
  },
  {
    "cast": "Rokytnice nad Jizerou-Hranice x)",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Rokytnice nad Jizerou-Hranice x)"
  },
  {
    "cast": "Rokytnice nad Jizerou-Paseky nad Jizerou x)",
    "psc": "51247",
    "okres": "Semily",
    "obec": "Paseky nad Jizerou",
    "val": "51247 Paseky nad Jizerou Rokytnice nad Jizerou-Paseky nad Jizerou x)"
  },
  {
    "cast": "Rokytnice nad Jizerou-Rokytno x)",
    "psc": "51245",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51245 Rokytnice nad Jizerou Rokytnice nad Jizerou-Rokytno x)"
  },
  {
    "cast": "Rokytnice nad Jizerou-Studenov x)",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Rokytnice nad Jizerou-Studenov x)"
  },
  {
    "cast": "Rokytnice nad Rokytnou (část)",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Rokytnice nad Rokytnou",
    "val": "67522 Rokytnice nad Rokytnou Rokytnice nad Rokytnou (cast)"
  },
  {
    "cast": "Rokytnice nad Rokytnou (část)",
    "psc": "67525",
    "okres": "Třebíč",
    "obec": "Rokytnice nad Rokytnou",
    "val": "67525 Rokytnice nad Rokytnou Rokytnice nad Rokytnou (cast)"
  },
  {
    "cast": "Rokytnice v Orlických horách",
    "psc": "51761",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rokytnice v Orlických horách",
    "val": "51761 Rokytnice v Orlickych horach Rokytnice v Orlickych horach"
  },
  {
    "cast": "Rokytnice (část)",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51101 Hruba Skala Rokytnice (cast)"
  },
  {
    "cast": "Rokytnice (část)",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51263 Hruba Skala Rokytnice (cast)"
  },
  {
    "cast": "Rokytník",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54931 Hronov Rokytnik"
  },
  {
    "cast": "Rokytno",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Rokytno",
    "val": "53304 Rokytno Rokytno"
  },
  {
    "cast": "Rokytno",
    "psc": "51245",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51245 Rokytnice nad Jizerou Rokytno"
  },
  {
    "cast": "Rokytno",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Rokytno"
  },
  {
    "cast": "Rokytovec",
    "psc": "29430",
    "okres": "Mladá Boleslav",
    "obec": "Rokytovec",
    "val": "29430 Rokytovec Rokytovec"
  },
  {
    "cast": "Romanov",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Romanov"
  },
  {
    "cast": "Ronov",
    "psc": "59452",
    "okres": "Žďár nad Sázavou",
    "obec": "Ořechov",
    "val": "59452 Orechov Ronov"
  },
  {
    "cast": "Ronov nad Doubravou",
    "psc": "53842",
    "okres": "Chrudim",
    "obec": "Ronov nad Doubravou",
    "val": "53842 Ronov nad Doubravou Ronov nad Doubravou"
  },
  {
    "cast": "Ronov nad Sázavou",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Přibyslav",
    "val": "58222 Pribyslav Ronov nad Sazavou"
  },
  {
    "cast": "Ropice",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Ropice",
    "val": "73961 Ropice Ropice"
  },
  {
    "cast": "Roprachtice",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Roprachtice",
    "val": "51301 Roprachtice Roprachtice"
  },
  {
    "cast": "Roseč",
    "psc": "37846",
    "okres": "Jindřichův Hradec",
    "obec": "Roseč",
    "val": "37846 Rosec Rosec"
  },
  {
    "cast": "Rosice",
    "psc": "53834",
    "okres": "Chrudim",
    "obec": "Rosice",
    "val": "53834 Rosice Rosice"
  },
  {
    "cast": "Rosice",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Cerekvička-Rosice",
    "val": "58833 Cerekvicka-Rosice Rosice"
  },
  {
    "cast": "Rosice (část)",
    "psc": "53351",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53351 Pardubice Rosice (cast)"
  },
  {
    "cast": "Rosice (část)",
    "psc": "53353",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53353 Pardubice Rosice (cast)"
  },
  {
    "cast": "Rosice (část)",
    "psc": "66501",
    "okres": "Brno-venkov",
    "obec": "Rosice",
    "val": "66501 Rosice Rosice (cast)"
  },
  {
    "cast": "Rosice (část)",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Rosice",
    "val": "66484 Rosice Rosice (cast)"
  },
  {
    "cast": "Rosička",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Rosička",
    "val": "59212 Rosicka Rosicka"
  },
  {
    "cast": "Rosička",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Rosička",
    "val": "37821 Rosicka Rosicka"
  },
  {
    "cast": "Rosnice",
    "psc": "36017",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36017 Karlovy Vary Rosnice"
  },
  {
    "cast": "Rosnice (část)",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Všestary",
    "val": "50312 Vsestary Rosnice (cast)"
  },
  {
    "cast": "Rosnice (část)",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Všestary",
    "val": "50315 Vsestary Rosnice (cast)"
  },
  {
    "cast": "Rosovice (část)",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Rosovice",
    "val": "26301 Rosovice Rosovice (cast)"
  },
  {
    "cast": "Rosovice (část)",
    "psc": "26211",
    "okres": "Příbram",
    "obec": "Rosovice",
    "val": "26211 Rosovice Rosovice (cast)"
  },
  {
    "cast": "Rostejn",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Běstvina",
    "val": "53843 Bestvina Rostejn"
  },
  {
    "cast": "Rostěnice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Rostěnice-Zvonovice",
    "val": "68201 Rostenice-Zvonovice Rostenice"
  },
  {
    "cast": "Rostkov",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Chocnějovice",
    "val": "29413 Chocnejovice Rostkov"
  },
  {
    "cast": "Rostoklaty",
    "psc": "28171",
    "okres": "Kolín",
    "obec": "Rostoklaty",
    "val": "28171 Rostoklaty Rostoklaty"
  },
  {
    "cast": "Roškopov",
    "psc": "50791",
    "okres": "Jičín",
    "obec": "Stará Paka",
    "val": "50791 Stara Paka Roskopov"
  },
  {
    "cast": "Roštění (část)",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Roštění",
    "val": "76901 Rosteni Rosteni (cast)"
  },
  {
    "cast": "Roštění (část)",
    "psc": "76843",
    "okres": "Kroměříž",
    "obec": "Roštění",
    "val": "76843 Rosteni Rosteni (cast)"
  },
  {
    "cast": "Roštín",
    "psc": "76803",
    "okres": "Kroměříž",
    "obec": "Roštín",
    "val": "76803 Rostin Rostin"
  },
  {
    "cast": "Rotava (část)",
    "psc": "35701",
    "okres": "Sokolov",
    "obec": "Rotava",
    "val": "35701 Rotava Rotava (cast)"
  },
  {
    "cast": "Rotava (část)",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Rotava",
    "val": "35801 Rotava Rotava (cast)"
  },
  {
    "cast": "Roubanina",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Roubanina",
    "val": "67961 Roubanina Roubanina"
  },
  {
    "cast": "Roubíčkova Lhota",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Roubickova Lhota"
  },
  {
    "cast": "Roučkovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pacov",
    "val": "39501 Pacov Rouckovice"
  },
  {
    "cast": "Roudná",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Roudná",
    "val": "39201 Roudna Roudna"
  },
  {
    "cast": "Roudná",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Srby",
    "val": "34601 Srby Roudna"
  },
  {
    "cast": "Roudné",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bílý Újezd",
    "val": "51801 Bily Ujezd Roudne"
  },
  {
    "cast": "Roudné",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Roudné",
    "val": "37007 Roudne Roudne"
  },
  {
    "cast": "Roudnice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Jestřabí v Krkonoších",
    "val": "51401 Jestrabi v Krkonosich Roudnice"
  },
  {
    "cast": "Roudnice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Roudnice",
    "val": "50327 Roudnice Roudnice"
  },
  {
    "cast": "Roudnice nad Labem",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Roudnice nad Labem",
    "val": "41301 Roudnice nad Labem Roudnice nad Labem"
  },
  {
    "cast": "Roudníček",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Budyně nad Ohří",
    "val": "41301 Budyne nad Ohri Roudnicek"
  },
  {
    "cast": "Roudnička",
    "psc": "50002",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50002 Hradec Kralove Roudnicka"
  },
  {
    "cast": "Roudníky",
    "psc": "40317",
    "okres": "Ústí nad Labem",
    "obec": "Chabařovice",
    "val": "40317 Chabarovice Roudniky"
  },
  {
    "cast": "Roudno",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Roudno",
    "val": "79201 Roudno Roudno"
  },
  {
    "cast": "Roudný",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Karlovice",
    "val": "51101 Karlovice Roudny"
  },
  {
    "cast": "Roudný",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Roudny"
  },
  {
    "cast": "Roudný",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Roudny"
  },
  {
    "cast": "Rouchovany",
    "psc": "67557",
    "okres": "Třebíč",
    "obec": "Rouchovany",
    "val": "67557 Rouchovany Rouchovany"
  },
  {
    "cast": "Rounek",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Vyskytná nad Jihlavou",
    "val": "58841 Vyskytna nad Jihlavou Rounek"
  },
  {
    "cast": "Roupov",
    "psc": "33453",
    "okres": "Plzeň-jih",
    "obec": "Roupov",
    "val": "33453 Roupov Roupov"
  },
  {
    "cast": "Rousínov",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Slabce",
    "val": "27041 Slabce Rousinov"
  },
  {
    "cast": "Rousínov",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Svor",
    "val": "47301 Svor Rousinov"
  },
  {
    "cast": "Rousínov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Kozmice",
    "val": "25601 Kozmice Rousinov"
  },
  {
    "cast": "Rousínov",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Rousínov",
    "val": "68301 Rousinov Rousinov"
  },
  {
    "cast": "Rousínov",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Horní Jelení",
    "val": "53401 Horni Jeleni Rousinov"
  },
  {
    "cast": "Rousínovec",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Rousínov",
    "val": "68301 Rousinov Rousinovec"
  },
  {
    "cast": "Rouské",
    "psc": "75353",
    "okres": "Přerov",
    "obec": "Rouské",
    "val": "75353 Rouske Rouske"
  },
  {
    "cast": "Rousměrov",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Rousměrov",
    "val": "59101 Rousmerov Rousmerov"
  },
  {
    "cast": "Rovečné",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Rovečné",
    "val": "59265 Rovecne Rovecne"
  },
  {
    "cast": "Roveň",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50601 Mladejov Roven"
  },
  {
    "cast": "Roveň",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Roven"
  },
  {
    "cast": "Roveň",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51601 Rychnov nad Kneznou Roven"
  },
  {
    "cast": "Rovensko",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Rovensko",
    "val": "78901 Rovensko Rovensko"
  },
  {
    "cast": "Roveňsko",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Holice",
    "val": "53401 Holice Rovensko"
  },
  {
    "cast": "Rovensko pod Troskami (část)",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Rovensko pod Troskami",
    "val": "51101 Rovensko pod Troskami Rovensko pod Troskami (cast)"
  },
  {
    "cast": "Rovensko pod Troskami (část)",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Rovensko pod Troskami",
    "val": "51263 Rovensko pod Troskami Rovensko pod Troskami (cast)"
  },
  {
    "cast": "Rovina",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Počepice",
    "val": "26401 Pocepice Rovina"
  },
  {
    "cast": "Rovina (část)",
    "psc": "25230",
    "okres": "Beroun",
    "obec": "Hlásná Třebaň",
    "val": "25230 Hlasna Treban Rovina (cast)"
  },
  {
    "cast": "Rovina (část)",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Hlásná Třebaň",
    "val": "26718 Hlasna Treban Rovina (cast)"
  },
  {
    "cast": "Rovná",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Rovná",
    "val": "39501 Rovna Rovna"
  },
  {
    "cast": "Rovná",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Rovná",
    "val": "35601 Rovna Rovna"
  },
  {
    "cast": "Rovná",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Zajíčkov",
    "val": "39301 Zajickov Rovna"
  },
  {
    "cast": "Rovná",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Rovná",
    "val": "38601 Rovna Rovna"
  },
  {
    "cast": "Rovná",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Rovna"
  },
  {
    "cast": "Rovná",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Rovna"
  },
  {
    "cast": "Rovnáčov",
    "psc": "51233",
    "okres": "Semily",
    "obec": "Studenec",
    "val": "51233 Studenec Rovnacov"
  },
  {
    "cast": "Rovné",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobré",
    "val": "51801 Dobre Rovne"
  },
  {
    "cast": "Rovné",
    "psc": "41187",
    "okres": "Litoměřice",
    "obec": "Krabčice",
    "val": "41187 Krabcice Rovne"
  },
  {
    "cast": "Rovné",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Rovne"
  },
  {
    "cast": "Rovný",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58263 Slavikov Rovny"
  },
  {
    "cast": "Rozbělesy-Děčín V x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Rozbelesy-Decin V x)"
  },
  {
    "cast": "Rozběřice",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Všestary",
    "val": "50312 Vsestary Rozberice"
  },
  {
    "cast": "Rozcestí",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Rozvadov",
    "val": "34806 Rozvadov Rozcesti"
  },
  {
    "cast": "Rozdělov (část)",
    "psc": "27201",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27201 Kladno Rozdelov (cast)"
  },
  {
    "cast": "Rozdělov (část)",
    "psc": "27204",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27204 Kladno Rozdelov (cast)"
  },
  {
    "cast": "Rozdrojovice",
    "psc": "66434",
    "okres": "Brno-venkov",
    "obec": "Rozdrojovice",
    "val": "66434 Rozdrojovice Rozdrojovice"
  },
  {
    "cast": "Rozehnaly",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Radovesnice II",
    "val": "28126 Radovesnice II Rozehnaly"
  },
  {
    "cast": "Rozhled",
    "psc": "40756",
    "okres": "Děčín",
    "obec": "Jiřetín pod Jedlovou",
    "val": "40756 Jiretin pod Jedlovou Rozhled"
  },
  {
    "cast": "Rozhovice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Rozhovice",
    "val": "53803 Rozhovice Rozhovice"
  },
  {
    "cast": "Rozhraní",
    "psc": "56903",
    "okres": "Svitavy",
    "obec": "Rozhraní",
    "val": "56903 Rozhrani Rozhrani"
  },
  {
    "cast": "Rozkoš",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Rozkoš",
    "val": "67153 Rozkos Rozkos"
  },
  {
    "cast": "Rozkoš",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Rozkos"
  },
  {
    "cast": "Rozkoš",
    "psc": "25243",
    "okres": "Praha-západ",
    "obec": "Průhonice",
    "val": "25243 Pruhonice Rozkos"
  },
  {
    "cast": "Rozkoš",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kounov",
    "val": "51801 Kounov Rozkos"
  },
  {
    "cast": "Rozkoš",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Onomyšl",
    "val": "28504 Onomysl Rozkos"
  },
  {
    "cast": "Rozkoš",
    "psc": "28921",
    "okres": "Nymburk",
    "obec": "Kostomlaty nad Labem",
    "val": "28921 Kostomlaty nad Labem Rozkos"
  },
  {
    "cast": "Rozňák",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Knyk",
    "val": "58001 Knyk Roznak"
  },
  {
    "cast": "Rozněvice",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Křelovice",
    "val": "33036 Krelovice Roznevice"
  },
  {
    "cast": "Rozpáralka",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Týnec",
    "val": "34021 Tynec Rozparalka"
  },
  {
    "cast": "Rozpoutí",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38232 Kaplice Rozpouti"
  },
  {
    "cast": "Rozseč",
    "psc": "58866",
    "okres": "Jihlava",
    "obec": "Rozseč",
    "val": "58866 Rozsec Rozsec"
  },
  {
    "cast": "Rozseč",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Rozseč",
    "val": "59451 Rozsec Rozsec"
  },
  {
    "cast": "Rozseč nad Kunštátem",
    "psc": "67973",
    "okres": "Blansko",
    "obec": "Rozseč nad Kunštátem",
    "val": "67973 Rozsec nad Kunstatem Rozsec nad Kunstatem"
  },
  {
    "cast": "Rozsedly",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Žihobce",
    "val": "34201 Zihobce Rozsedly"
  },
  {
    "cast": "Rozsíčka",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Rozsíčka",
    "val": "67974 Rozsicka Rozsicka"
  },
  {
    "cast": "Rozsocha",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Rozsocha"
  },
  {
    "cast": "Rozsochatec",
    "psc": "58272",
    "okres": "Havlíčkův Brod",
    "obec": "Rozsochatec",
    "val": "58272 Rozsochatec Rozsochatec"
  },
  {
    "cast": "Rozsochy (část)",
    "psc": "59257",
    "okres": "Žďár nad Sázavou",
    "obec": "Rozsochy",
    "val": "59257 Rozsochy Rozsochy (cast)"
  },
  {
    "cast": "Rozsochy (část)",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Rozsochy",
    "val": "59251 Rozsochy Rozsochy (cast)"
  },
  {
    "cast": "Rozstání",
    "psc": "79862",
    "okres": "Prostějov",
    "obec": "Rozstání",
    "val": "79862 Rozstani Rozstani"
  },
  {
    "cast": "Rozstání",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Rozstání",
    "val": "57101 Rozstani Rozstani"
  },
  {
    "cast": "Rozstání",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Světlá pod Ještědem",
    "val": "46343 Svetla pod Jestedem Rozstani"
  },
  {
    "cast": "Roztěž",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Vidice",
    "val": "28401 Vidice Roztez"
  },
  {
    "cast": "Roztoky",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Roztoky",
    "val": "27023 Roztoky Roztoky"
  },
  {
    "cast": "Roztoky",
    "psc": "40332",
    "okres": "Ústí nad Labem",
    "obec": "Povrly",
    "val": "40332 Povrly Roztoky"
  },
  {
    "cast": "Roztoky",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Šestajovice",
    "val": "55101 Sestajovice Roztoky"
  },
  {
    "cast": "Roztoky",
    "psc": "25263",
    "okres": "Praha-západ",
    "obec": "Roztoky",
    "val": "25263 Roztoky Roztoky"
  },
  {
    "cast": "Roztoky u Jilemnice (část)",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Roztoky u Jilemnice",
    "val": "51401 Roztoky u Jilemnice Roztoky u Jilemnice (cast)"
  },
  {
    "cast": "Roztoky u Jilemnice (část)",
    "psc": "51231",
    "okres": "Semily",
    "obec": "Roztoky u Jilemnice",
    "val": "51231 Roztoky u Jilemnice Roztoky u Jilemnice (cast)"
  },
  {
    "cast": "Roztoky u Jilemnice (část)",
    "psc": "51232",
    "okres": "Semily",
    "obec": "Roztoky u Jilemnice",
    "val": "51232 Roztoky u Jilemnice Roztoky u Jilemnice (cast)"
  },
  {
    "cast": "Roztoky u Semil",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Roztoky u Semil",
    "val": "51301 Roztoky u Semil Roztoky u Semil"
  },
  {
    "cast": "Roztyly",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43801 Chbany Roztyly"
  },
  {
    "cast": "Rozvadov",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Rozvadov",
    "val": "34806 Rozvadov Rozvadov"
  },
  {
    "cast": "Rozvadovice",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78401 Litovel Rozvadovice"
  },
  {
    "cast": "Rožany",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Šluknov",
    "val": "40747 Sluknov Rozany"
  },
  {
    "cast": "Rožďalovice",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Rožďalovice",
    "val": "28934 Rozdalovice Rozdalovice"
  },
  {
    "cast": "Roželov",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Hvožďany",
    "val": "26242 Hvozdany Rozelov"
  },
  {
    "cast": "Roženecké Paseky",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Věcov",
    "val": "59242 Vecov Rozenecke Paseky"
  },
  {
    "cast": "Rožmberk nad Vltavou",
    "psc": "38218",
    "okres": "Český Krumlov",
    "obec": "Rožmberk nad Vltavou",
    "val": "38218 Rozmberk nad Vltavou Rozmberk nad Vltavou"
  },
  {
    "cast": "Rožmitál",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Broumov",
    "val": "55001 Broumov Rozmital"
  },
  {
    "cast": "Rožmitál",
    "psc": "79376",
    "okres": "Jeseník",
    "obec": "Zlaté Hory",
    "val": "79376 Zlate Hory Rozmital"
  },
  {
    "cast": "Rožmitál na Šumavě",
    "psc": "38292",
    "okres": "Český Krumlov",
    "obec": "Rožmitál na Šumavě",
    "val": "38292 Rozmital na Sumave Rozmital na Sumave"
  },
  {
    "cast": "Rožmitál pod Třemšínem",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Rozmital pod Tremsinem"
  },
  {
    "cast": "Rožná",
    "psc": "59252",
    "okres": "Žďár nad Sázavou",
    "obec": "Rožná",
    "val": "59252 Rozna Rozna"
  },
  {
    "cast": "Rožnov",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Rožnov",
    "val": "55101 Roznov Roznov"
  },
  {
    "cast": "Rožnov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "37881 Cesky Rudolec Roznov"
  },
  {
    "cast": "Rožnov pod Radhoštěm",
    "psc": "75661",
    "okres": "Vsetín",
    "obec": "Rožnov pod Radhoštěm",
    "val": "75661 Roznov pod Radhostem Roznov pod Radhostem"
  },
  {
    "cast": "Rpety",
    "psc": "26801",
    "okres": "Beroun",
    "obec": "Rpety",
    "val": "26801 Rpety Rpety"
  },
  {
    "cast": "Rtenín",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Mladoňovice",
    "val": "53821 Mladonovice Rtenin"
  },
  {
    "cast": "Rtišovice",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Milín",
    "val": "26231 Milin Rtisovice"
  },
  {
    "cast": "Rtyně",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Zaloňov",
    "val": "55101 Zalonov Rtyne"
  },
  {
    "cast": "Rtyně nad Bílinou",
    "psc": "41762",
    "okres": "Teplice",
    "obec": "Rtyně nad Bílinou",
    "val": "41762 Rtyne nad Bilinou Rtyne nad Bilinou"
  },
  {
    "cast": "Rtyně v Podkrkonoší (část)",
    "psc": "54234",
    "okres": "Trutnov",
    "obec": "Rtyně v Podkrkonoší",
    "val": "54234 Rtyne v Podkrkonosi Rtyne v Podkrkonosi (cast)"
  },
  {
    "cast": "Rtyně v Podkrkonoší (část)",
    "psc": "54941",
    "okres": "Trutnov",
    "obec": "Rtyně v Podkrkonoší",
    "val": "54941 Rtyne v Podkrkonosi Rtyne v Podkrkonosi (cast)"
  },
  {
    "cast": "Rtyně v Podkrkonoší (část)",
    "psc": "54233",
    "okres": "Trutnov",
    "obec": "Rtyně v Podkrkonoší",
    "val": "54233 Rtyne v Podkrkonosi Rtyne v Podkrkonosi (cast)"
  },
  {
    "cast": "Rubašov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Slavonice",
    "val": "37881 Slavonice Rubasov"
  },
  {
    "cast": "Ruda",
    "psc": "79344",
    "okres": "Bruntál",
    "obec": "Tvrdkov",
    "val": "79344 Tvrdkov Ruda"
  },
  {
    "cast": "Ruda",
    "psc": "56982",
    "okres": "Chrudim",
    "obec": "Krouna",
    "val": "56982 Krouna Ruda"
  },
  {
    "cast": "Ruda",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Ruda",
    "val": "59401 Ruda Ruda"
  },
  {
    "cast": "Ruda nad Moravou",
    "psc": "78963",
    "okres": "Šumperk",
    "obec": "Ruda nad Moravou",
    "val": "78963 Ruda nad Moravou Ruda nad Moravou"
  },
  {
    "cast": "Ruda (část)",
    "psc": "26901",
    "okres": "Rakovník",
    "obec": "Ruda",
    "val": "26901 Ruda Ruda (cast)"
  },
  {
    "cast": "Ruda (část)",
    "psc": "27101",
    "okres": "Rakovník",
    "obec": "Ruda",
    "val": "27101 Ruda Ruda (cast)"
  },
  {
    "cast": "Rudice",
    "psc": "67906",
    "okres": "Blansko",
    "obec": "Rudice",
    "val": "67906 Rudice Rudice"
  },
  {
    "cast": "Rudice",
    "psc": "68732",
    "okres": "Uherské Hradiště",
    "obec": "Rudice",
    "val": "68732 Rudice Rudice"
  },
  {
    "cast": "Rudíkov",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Rudíkov",
    "val": "67505 Rudikov Rudikov"
  },
  {
    "cast": "Rudíkovy",
    "psc": "79382",
    "okres": "Bruntál",
    "obec": "Třemešná",
    "val": "79382 Tremesna Rudikovy"
  },
  {
    "cast": "Rudimov",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Rudimov",
    "val": "76321 Rudimov Rudimov"
  },
  {
    "cast": "Rudka",
    "psc": "66483",
    "okres": "Brno-venkov",
    "obec": "Rudka",
    "val": "66483 Rudka Rudka"
  },
  {
    "cast": "Rudka",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Kunštát",
    "val": "67972 Kunstat Rudka"
  },
  {
    "cast": "Rudlice",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Rudlice",
    "val": "67153 Rudlice Rudlice"
  },
  {
    "cast": "Rudná",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Rudná",
    "val": "56904 Rudna Rudna"
  },
  {
    "cast": "Rudná",
    "psc": "25219",
    "okres": "Praha-západ",
    "obec": "Rudná",
    "val": "25219 Rudna Rudna"
  },
  {
    "cast": "Rudné",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Vysoká Pec",
    "val": "36221 Vysoka Pec Rudne"
  },
  {
    "cast": "Rudník",
    "psc": "54372",
    "okres": "Trutnov",
    "obec": "Rudník",
    "val": "54372 Rudnik Rudnik"
  },
  {
    "cast": "Rudolec",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Březová",
    "val": "35601 Brezova Rudolec"
  },
  {
    "cast": "Rudolec",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nedrahovice",
    "val": "26401 Nedrahovice Rudolec"
  },
  {
    "cast": "Rudolec",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Rudolec",
    "val": "59214 Rudolec Rudolec"
  },
  {
    "cast": "Rudolfov",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Rudolfov",
    "val": "37371 Rudolfov Rudolfov"
  },
  {
    "cast": "Rudolfov-Liberec XXI x)",
    "psc": "46014",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46014 Liberec Rudolfov-Liberec XXI x)"
  },
  {
    "cast": "Rudolice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Most",
    "val": "43401 Most Rudolice"
  },
  {
    "cast": "Rudolice v Horách",
    "psc": "43546",
    "okres": "Most",
    "obec": "Hora Svaté Kateřiny",
    "val": "43546 Hora Svate Kateriny Rudolice v Horach"
  },
  {
    "cast": "Rudoltice",
    "psc": "34506",
    "okres": "Klatovy",
    "obec": "Černíkov",
    "val": "34506 Cernikov Rudoltice"
  },
  {
    "cast": "Rudoltice",
    "psc": "78816",
    "okres": "Šumperk",
    "obec": "Sobotín",
    "val": "78816 Sobotin Rudoltice"
  },
  {
    "cast": "Rudoltice",
    "psc": "56125",
    "okres": "Ústí nad Orlicí",
    "obec": "Rudoltice",
    "val": "56125 Rudoltice Rudoltice"
  },
  {
    "cast": "Rudoltice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Rudoltice"
  },
  {
    "cast": "Rudov",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Míčov-Sušice",
    "val": "53803 Micov-Susice Rudov"
  },
  {
    "cast": "Rukáveč",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Milevsko",
    "val": "39901 Milevsko Rukavec"
  },
  {
    "cast": "Rumberk",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Deštná",
    "val": "67961 Destna Rumberk"
  },
  {
    "cast": "Rumburk 1",
    "psc": "40801",
    "okres": "Děčín",
    "obec": "Rumburk",
    "val": "40801 Rumburk Rumburk 1"
  },
  {
    "cast": "Rumburk 2-Horní Jindřichov",
    "psc": "40801",
    "okres": "Děčín",
    "obec": "Rumburk",
    "val": "40801 Rumburk Rumburk 2-Horni Jindrichov"
  },
  {
    "cast": "Rumburk 3-Dolní Křečany",
    "psc": "40801",
    "okres": "Děčín",
    "obec": "Rumburk",
    "val": "40801 Rumburk Rumburk 3-Dolni Krecany"
  },
  {
    "cast": "Runářov",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Konice",
    "val": "79852 Konice Runarov"
  },
  {
    "cast": "Ruprechtice",
    "psc": "54983",
    "okres": "Náchod",
    "obec": "Meziměstí",
    "val": "54983 Mezimesti Ruprechtice"
  },
  {
    "cast": "Ruprechtice-Liberec XIV (část) x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Ruprechtice-Liberec XIV (cast) x)"
  },
  {
    "cast": "Ruprechtice-Liberec XIV (část) x)",
    "psc": "46014",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46014 Liberec Ruprechtice-Liberec XIV (cast) x)"
  },
  {
    "cast": "Ruprechtov",
    "psc": "68304",
    "okres": "Vyškov",
    "obec": "Ruprechtov",
    "val": "68304 Ruprechtov Ruprechtov"
  },
  {
    "cast": "Ruprechtov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Hroznětín",
    "val": "36301 Hroznetin Ruprechtov"
  },
  {
    "cast": "Rusava",
    "psc": "76841",
    "okres": "Kroměříž",
    "obec": "Rusava",
    "val": "76841 Rusava Rusava"
  },
  {
    "cast": "Rusek",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Rusek"
  },
  {
    "cast": "Rusín",
    "psc": "79397",
    "okres": "Bruntál",
    "obec": "Rusín",
    "val": "79397 Rusin Rusin"
  },
  {
    "cast": "Rusová",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Kryštofovy Hamry",
    "val": "43191 Krystofovy Hamry Rusova"
  },
  {
    "cast": "Rušinov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Rušinov",
    "val": "58301 Rusinov Rusinov"
  },
  {
    "cast": "Rutov",
    "psc": "39493",
    "okres": "Pelhřimov",
    "obec": "Mnich",
    "val": "39493 Mnich Rutov"
  },
  {
    "cast": "Ruzyně",
    "psc": "16100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16100 Praha Ruzyne"
  },
  {
    "cast": "Růžďka (část)",
    "psc": "75625",
    "okres": "Vsetín",
    "obec": "Růžďka",
    "val": "75625 Ruzdka Ruzdka (cast)"
  },
  {
    "cast": "Růžďka (část)",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Růžďka",
    "val": "75701 Ruzdka Ruzdka (cast)"
  },
  {
    "cast": "Růžek",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Nová Ves",
    "val": "46331 Nova Ves Ruzek"
  },
  {
    "cast": "Růžená",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Růžená",
    "val": "58901 Ruzena Ruzena"
  },
  {
    "cast": "Růžená",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Ruzena"
  },
  {
    "cast": "Růžkovy Lhotice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Ruzkovy Lhotice"
  },
  {
    "cast": "Růžodol",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Ruzodol"
  },
  {
    "cast": "Růžodol I-Liberec XI x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Ruzodol I-Liberec XI x)"
  },
  {
    "cast": "Růžov (část)",
    "psc": "79843",
    "okres": "Prostějov",
    "obec": "Stražisko",
    "val": "79843 Strazisko Ruzov (cast)"
  },
  {
    "cast": "Růžov (část)",
    "psc": "79844",
    "okres": "Prostějov",
    "obec": "Stražisko",
    "val": "79844 Strazisko Ruzov (cast)"
  },
  {
    "cast": "Růžov (část)",
    "psc": "37311",
    "okres": "České Budějovice",
    "obec": "Ledenice",
    "val": "37311 Ledenice Ruzov (cast)"
  },
  {
    "cast": "Růžov (část)",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Ledenice",
    "val": "37312 Ledenice Ruzov (cast)"
  },
  {
    "cast": "Růžová (část)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Růžová",
    "val": "40502 Ruzova Ruzova (cast)"
  },
  {
    "cast": "Růžová (část)",
    "psc": "40714",
    "okres": "Děčín",
    "obec": "Růžová",
    "val": "40714 Ruzova Ruzova (cast)"
  },
  {
    "cast": "Rváčov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Rvacov"
  },
  {
    "cast": "Rváčov",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Rvacov"
  },
  {
    "cast": "Rvenice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Rvenice"
  },
  {
    "cast": "Rviště",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Rviste"
  },
  {
    "cast": "Rybárny",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68601 Uherske Hradiste Rybarny"
  },
  {
    "cast": "Rybáře (část)",
    "psc": "36005",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36005 Karlovy Vary Rybare (cast)"
  },
  {
    "cast": "Rybáře (část)",
    "psc": "36010",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36010 Karlovy Vary Rybare (cast)"
  },
  {
    "cast": "Rybáře-Hranice V x)",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Rybare-Hranice V x)"
  },
  {
    "cast": "Rybí",
    "psc": "74265",
    "okres": "Nový Jičín",
    "obec": "Rybí",
    "val": "74265 Rybi Rybi"
  },
  {
    "cast": "Rybitví",
    "psc": "53354",
    "okres": "Pardubice",
    "obec": "Rybitví",
    "val": "53354 Rybitvi Rybitvi"
  },
  {
    "cast": "Rybná",
    "psc": "36235",
    "okres": "Karlovy Vary",
    "obec": "Pernink",
    "val": "36235 Pernink Rybna"
  },
  {
    "cast": "Rybná nad Zdobnicí",
    "psc": "51755",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rybná nad Zdobnicí",
    "val": "51755 Rybna nad Zdobnici Rybna nad Zdobnici"
  },
  {
    "cast": "Rybňany",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Zálužice",
    "val": "43801 Zaluzice Rybnany"
  },
  {
    "cast": "Rybné",
    "psc": "58827",
    "okres": "Jihlava",
    "obec": "Rybné",
    "val": "58827 Rybne Rybne"
  },
  {
    "cast": "Rybnice",
    "psc": "33151",
    "okres": "Plzeň-sever",
    "obec": "Rybnice",
    "val": "33151 Rybnice Rybnice"
  },
  {
    "cast": "Rybnice",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Háje nad Jizerou",
    "val": "51301 Haje nad Jizerou Rybnice"
  },
  {
    "cast": "Rybníček",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Rybníček",
    "val": "68201 Rybnicek Rybnicek"
  },
  {
    "cast": "Rybníček",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Brada-Rybníček",
    "val": "50601 Brada-Rybnicek Rybnicek"
  },
  {
    "cast": "Rybníček",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Rybnicek"
  },
  {
    "cast": "Rybníček",
    "psc": "78396",
    "okres": "Olomouc",
    "obec": "Újezd",
    "val": "78396 Ujezd Rybnicek"
  },
  {
    "cast": "Rybníček",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Rybníček",
    "val": "58282 Rybnicek Rybnicek"
  },
  {
    "cast": "Rybníček",
    "psc": "53944",
    "okres": "Ústí nad Orlicí",
    "obec": "Nové Hrady",
    "val": "53944 Nove Hrady Rybnicek"
  },
  {
    "cast": "Rybníčky",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51703 Skuhrov nad Belou Rybnicky"
  },
  {
    "cast": "Rybničná",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Rybnicna"
  },
  {
    "cast": "Rybník",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Rybník",
    "val": "56002 Rybnik Rybnik"
  },
  {
    "cast": "Rybník",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Rybník",
    "val": "34525 Rybnik Rybnik"
  },
  {
    "cast": "Rybník (část)",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38241 Dolni Dvoriste Rybnik (cast)"
  },
  {
    "cast": "Rybník (část)",
    "psc": "38272",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38272 Dolni Dvoriste Rybnik (cast)"
  },
  {
    "cast": "Rybníky",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Rybníky",
    "val": "26301 Rybniky Rybniky"
  },
  {
    "cast": "Rybníky",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Rybníky",
    "val": "67201 Rybniky Rybniky"
  },
  {
    "cast": "Rybniště",
    "psc": "40751",
    "okres": "Děčín",
    "obec": "Rybniště",
    "val": "40751 Rybniste Rybniste"
  },
  {
    "cast": "Rybnov",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Holany",
    "val": "47002 Holany Rybnov"
  },
  {
    "cast": "Rybova Lhota",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Skalice",
    "val": "39201 Skalice Rybova Lhota"
  },
  {
    "cast": "Rýdeč",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40002 Malecov Rydec"
  },
  {
    "cast": "Rýdrovice",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Horní Heřmanice",
    "val": "56301 Horni Hermanice Rydrovice"
  },
  {
    "cast": "Rychaltice (část)",
    "psc": "74258",
    "okres": "Frýdek-Místek",
    "obec": "Hukvaldy",
    "val": "74258 Hukvaldy Rychaltice (cast)"
  },
  {
    "cast": "Rychaltice (část)",
    "psc": "73946",
    "okres": "Frýdek-Místek",
    "obec": "Hukvaldy",
    "val": "73946 Hukvaldy Rychaltice (cast)"
  },
  {
    "cast": "Rychlov",
    "psc": "67521",
    "okres": "Jihlava",
    "obec": "Kněžice",
    "val": "67521 Knezice Rychlov"
  },
  {
    "cast": "Rychlov",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Benecko",
    "val": "51401 Benecko Rychlov"
  },
  {
    "cast": "Rychlov",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Bystřice pod Hostýnem",
    "val": "76861 Bystrice pod Hostynem Rychlov"
  },
  {
    "cast": "Rychnov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Verneřice",
    "val": "40502 Vernerice Rychnov"
  },
  {
    "cast": "Rychnov na Moravě",
    "psc": "56934",
    "okres": "Svitavy",
    "obec": "Rychnov na Moravě",
    "val": "56934 Rychnov na Morave Rychnov na Morave"
  },
  {
    "cast": "Rychnov nad Kněžnou",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Rychnov nad Kněžnou",
    "val": "51601 Rychnov nad Kneznou Rychnov nad Kneznou"
  },
  {
    "cast": "Rychnov nad Malší",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38241 Dolni Dvoriste Rychnov nad Malsi"
  },
  {
    "cast": "Rychnov u Jablonce nad Nisou",
    "psc": "46802",
    "okres": "Jablonec nad Nisou",
    "obec": "Rychnov u Jablonce nad Nisou",
    "val": "46802 Rychnov u Jablonce nad Nisou Rychnov u Jablonce nad Nisou"
  },
  {
    "cast": "Rychnov u Nových Hradů",
    "psc": "37336",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37336 Horni Stropnice Rychnov u Novych Hradu"
  },
  {
    "cast": "Rychnov (část)",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Krouna",
    "val": "53944 Krouna Rychnov (cast)"
  },
  {
    "cast": "Rychnov (část)",
    "psc": "56982",
    "okres": "Chrudim",
    "obec": "Krouna",
    "val": "56982 Krouna Rychnov (cast)"
  },
  {
    "cast": "Rychnovek",
    "psc": "55225",
    "okres": "Náchod",
    "obec": "Rychnovek",
    "val": "55225 Rychnovek Rychnovek"
  },
  {
    "cast": "Rychtářov",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Rychtarov"
  },
  {
    "cast": "Rychtářov",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Brloh",
    "val": "38203 Brloh Rychtarov"
  },
  {
    "cast": "Rychvald (část)",
    "psc": "73514",
    "okres": "Karviná",
    "obec": "Rychvald",
    "val": "73514 Rychvald Rychvald (cast)"
  },
  {
    "cast": "Rychvald (část)",
    "psc": "73532",
    "okres": "Karviná",
    "obec": "Rychvald",
    "val": "73532 Rychvald Rychvald (cast)"
  },
  {
    "cast": "Ryjice",
    "psc": "40331",
    "okres": "Ústí nad Labem",
    "obec": "Ryjice",
    "val": "40331 Ryjice Ryjice"
  },
  {
    "cast": "Rýmařov",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Rýmařov",
    "val": "79501 Rymarov Rymarov"
  },
  {
    "cast": "Rymice",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Rymice",
    "val": "76901 Rymice Rymice"
  },
  {
    "cast": "Rynárec (část)",
    "psc": "39401",
    "okres": "Pelhřimov",
    "obec": "Rynárec",
    "val": "39401 Rynarec Rynarec (cast)"
  },
  {
    "cast": "Rynárec (část)",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Rynárec",
    "val": "39301 Rynarec Rynarec (cast)"
  },
  {
    "cast": "Rynartice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Jetřichovice",
    "val": "40502 Jetrichovice Rynartice"
  },
  {
    "cast": "Rynholec (část)",
    "psc": "27062",
    "okres": "Rakovník",
    "obec": "Rynholec",
    "val": "27062 Rynholec Rynholec (cast)"
  },
  {
    "cast": "Rynholec (část)",
    "psc": "27101",
    "okres": "Rakovník",
    "obec": "Rynholec",
    "val": "27101 Rynholec Rynholec (cast)"
  },
  {
    "cast": "Rynoltice",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Rynoltice",
    "val": "46353 Rynoltice Rynoltice"
  },
  {
    "cast": "Rýnovice",
    "psc": "46605",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46605 Jablonec nad Nisou Rynovice"
  },
  {
    "cast": "Ryšín",
    "psc": "27021",
    "okres": "Rakovník",
    "obec": "Pavlíkov",
    "val": "27021 Pavlikov Rysin"
  },
  {
    "cast": "Rytířov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Verneřice",
    "val": "40502 Vernerice Rytirov"
  },
  {
    "cast": "Rytířova Lhota",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50601 Libosovice Rytirova Lhota"
  },
  {
    "cast": "Rytov",
    "psc": "39494",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39494 Cernovice Rytov"
  },
  {
    "cast": "Rýzmburk",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Žernov",
    "val": "55203 Zernov Ryzmburk"
  },
  {
    "cast": "Rýzmburk",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Hulice",
    "val": "25763 Hulice Ryzmburk"
  },
  {
    "cast": "Ryžoviště",
    "psc": "79356",
    "okres": "Bruntál",
    "obec": "Ryžoviště",
    "val": "79356 Ryzoviste Ryzoviste"
  },
  {
    "cast": "Ryžoviště",
    "psc": "51246",
    "okres": "Semily",
    "obec": "Harrachov",
    "val": "51246 Harrachov Ryzoviste"
  },
  {
    "cast": "Ryžovna",
    "psc": "36262",
    "okres": "Karlovy Vary",
    "obec": "Boží Dar",
    "val": "36262 Bozi Dar Ryzovna"
  },
  {
    "cast": "Rzavá",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Rzava"
  },
  {
    "cast": "Rzy",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Dobříkov",
    "val": "56601 Dobrikov Rzy"
  },
  {
    "cast": "Rzy",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nový Hrádek",
    "val": "54901 Novy Hradek Rzy"
  },
  {
    "cast": "Řadovy",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26256 Svaty Jan Radovy"
  },
  {
    "cast": "Řakom",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Rakom"
  },
  {
    "cast": "Řásná",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Řásná",
    "val": "58856 Rasna Rasna"
  },
  {
    "cast": "Řasnice",
    "psc": "38443",
    "okres": "Prachatice",
    "obec": "Strážný",
    "val": "38443 Strazny Rasnice"
  },
  {
    "cast": "Řebří",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Svojšín",
    "val": "34901 Svojsin Rebri"
  },
  {
    "cast": "Řečany nad Labem",
    "psc": "53313",
    "okres": "Pardubice",
    "obec": "Řečany nad Labem",
    "val": "53313 Recany nad Labem Recany nad Labem"
  },
  {
    "cast": "Řečice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Recice"
  },
  {
    "cast": "Řečice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Řečice",
    "val": "39601 Recice Recice"
  },
  {
    "cast": "Řečice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Volfířov",
    "val": "38001 Volfirov Recice"
  },
  {
    "cast": "Řečice",
    "psc": "59233",
    "okres": "Žďár nad Sázavou",
    "obec": "Řečice",
    "val": "59233 Recice Recice"
  },
  {
    "cast": "Řečice",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Zábřezí-Řečice",
    "val": "54401 Zabrezi-Recice Recice"
  },
  {
    "cast": "Řečkovice (část)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Reckovice (cast)"
  },
  {
    "cast": "Řečkovice (část)",
    "psc": "62100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62100 Brno Reckovice (cast)"
  },
  {
    "cast": "Ředhošť",
    "psc": "41120",
    "okres": "Litoměřice",
    "obec": "Mšené-lázně",
    "val": "41120 Msene-lazne Redhost"
  },
  {
    "cast": "Ředice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Redice"
  },
  {
    "cast": "Ředičky",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Redicky"
  },
  {
    "cast": "Řeheč",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Úlibice",
    "val": "50601 Ulibice Rehec"
  },
  {
    "cast": "Řehenice",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Řehenice",
    "val": "25167 Rehenice Rehenice"
  },
  {
    "cast": "Řehlovice",
    "psc": "40313",
    "okres": "Ústí nad Labem",
    "obec": "Řehlovice",
    "val": "40313 Rehlovice Rehlovice"
  },
  {
    "cast": "Řehnice",
    "psc": "29431",
    "okres": "Mladá Boleslav",
    "obec": "Krnsko",
    "val": "29431 Krnsko Rehnice"
  },
  {
    "cast": "Řehnice",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Lhotky",
    "val": "29406 Lhotky Rehnice"
  },
  {
    "cast": "Řehořov",
    "psc": "58824",
    "okres": "Jihlava",
    "obec": "Kamenice",
    "val": "58824 Kamenice Rehorov"
  },
  {
    "cast": "Řehoty",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Králíky",
    "val": "50401 Kraliky Rehoty"
  },
  {
    "cast": "Řehovice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Rehovice"
  },
  {
    "cast": "Řeka",
    "psc": "73955",
    "okres": "Frýdek-Místek",
    "obec": "Řeka",
    "val": "73955 Reka Reka"
  },
  {
    "cast": "Řemenov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Olešná",
    "val": "39301 Olesna Remenov"
  },
  {
    "cast": "Řemešín",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kralovice",
    "val": "33141 Kralovice Remesin"
  },
  {
    "cast": "Řemíčov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Řemíčov",
    "val": "39143 Remicov Remicov"
  },
  {
    "cast": "Řenče (část)",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Řenče",
    "val": "33601 Rence Rence (cast)"
  },
  {
    "cast": "Řenče (část)",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Řenče",
    "val": "33401 Rence Rence (cast)"
  },
  {
    "cast": "Řendějov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Řendějov",
    "val": "28522 Rendejov Rendejov"
  },
  {
    "cast": "Řenkov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Renkov"
  },
  {
    "cast": "Řepany",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Repany"
  },
  {
    "cast": "Řepčice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Třebušín",
    "val": "41201 Trebusin Repcice"
  },
  {
    "cast": "Řepčice",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Repcice"
  },
  {
    "cast": "Řepčín",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Repcin"
  },
  {
    "cast": "Řepeč",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Řepeč",
    "val": "39161 Repec Repec"
  },
  {
    "cast": "Řepešín",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Záblatí",
    "val": "38301 Zablati Repesin"
  },
  {
    "cast": "Řepice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Řepice",
    "val": "38601 Repice Repice"
  },
  {
    "cast": "Řepín",
    "psc": "27733",
    "okres": "Mělník",
    "obec": "Řepín",
    "val": "27733 Repin Repin"
  },
  {
    "cast": "Řepiště",
    "psc": "73932",
    "okres": "Frýdek-Místek",
    "obec": "Řepiště",
    "val": "73932 Repiste Repiste"
  },
  {
    "cast": "Řepka",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Lomnice",
    "val": "67923 Lomnice Repka"
  },
  {
    "cast": "Řeplice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Bohdaneč",
    "val": "28522 Bohdanec Replice"
  },
  {
    "cast": "Řepnice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Libochovany",
    "val": "41201 Libochovany Repnice"
  },
  {
    "cast": "Řepníky",
    "psc": "53865",
    "okres": "Ústí nad Orlicí",
    "obec": "Řepníky",
    "val": "53865 Repniky Repniky"
  },
  {
    "cast": "Řeporyje",
    "psc": "15500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15500 Praha Reporyje"
  },
  {
    "cast": "Řepov",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Řepov",
    "val": "29301 Repov Repov"
  },
  {
    "cast": "Řepová",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Mohelnice",
    "val": "78985 Mohelnice Repova"
  },
  {
    "cast": "Řepy (část)",
    "psc": "16100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16100 Praha Repy (cast)"
  },
  {
    "cast": "Řepy (část)",
    "psc": "16300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16300 Praha Repy (cast)"
  },
  {
    "cast": "Řeřichy",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Řeřichy",
    "val": "27035 Rerichy Rerichy"
  },
  {
    "cast": "Řesanice",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Kasejovice",
    "val": "33544 Kasejovice Resanice"
  },
  {
    "cast": "Řestoky",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Řestoky",
    "val": "53851 Restoky Restoky"
  },
  {
    "cast": "Řešetova Lhota",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Studnice",
    "val": "54701 Studnice Resetova Lhota"
  },
  {
    "cast": "Řešín",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Resin"
  },
  {
    "cast": "Řeteč",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Retec"
  },
  {
    "cast": "Řetechov",
    "psc": "76326",
    "okres": "Zlín",
    "obec": "Luhačovice",
    "val": "76326 Luhacovice Retechov"
  },
  {
    "cast": "Řetenice",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Nicov",
    "val": "38473 Nicov Retenice"
  },
  {
    "cast": "Řetenice (část)",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41501 Teplice Retenice (cast)"
  },
  {
    "cast": "Řetenice (část)",
    "psc": "41503",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41503 Teplice Retenice (cast)"
  },
  {
    "cast": "Řetouň",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Malečov",
    "val": "40002 Malecov Retoun"
  },
  {
    "cast": "Řetová",
    "psc": "56141",
    "okres": "Ústí nad Orlicí",
    "obec": "Řetová",
    "val": "56141 Retova Retova"
  },
  {
    "cast": "Řetůvka",
    "psc": "56141",
    "okres": "Ústí nad Orlicí",
    "obec": "Řetůvka",
    "val": "56141 Retuvka Retuvka"
  },
  {
    "cast": "Řevnice",
    "psc": "25230",
    "okres": "Praha-západ",
    "obec": "Řevnice",
    "val": "25230 Revnice Revnice"
  },
  {
    "cast": "Řevničov (část)",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Řevničov",
    "val": "27054 Revnicov Revnicov (cast)"
  },
  {
    "cast": "Řevničov (část)",
    "psc": "27101",
    "okres": "Rakovník",
    "obec": "Řevničov",
    "val": "27101 Revnicov Revnicov (cast)"
  },
  {
    "cast": "Řevnov",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Revnov"
  },
  {
    "cast": "Řevňovice (část)",
    "psc": "37314",
    "okres": "České Budějovice",
    "obec": "Strážkovice",
    "val": "37314 Strazkovice Revnovice (cast)"
  },
  {
    "cast": "Řevňovice (část)",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Strážkovice",
    "val": "37401 Strazkovice Revnovice (cast)"
  },
  {
    "cast": "Řeznovice",
    "psc": "66491",
    "okres": "Brno-venkov",
    "obec": "Ivančice",
    "val": "66491 Ivancice Reznovice"
  },
  {
    "cast": "Řež",
    "psc": "25068",
    "okres": "Praha-východ",
    "obec": "Husinec",
    "val": "25068 Husinec Rez"
  },
  {
    "cast": "Řeženčice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nový Rychnov",
    "val": "39301 Novy Rychnov Rezencice"
  },
  {
    "cast": "Řícmanice",
    "psc": "66401",
    "okres": "Brno-venkov",
    "obec": "Řícmanice",
    "val": "66401 Ricmanice Ricmanice"
  },
  {
    "cast": "Říčany",
    "psc": "66482",
    "okres": "Brno-venkov",
    "obec": "Říčany",
    "val": "66482 Ricany Ricany"
  },
  {
    "cast": "Říčany",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Říčany",
    "val": "25101 Ricany Ricany"
  },
  {
    "cast": "Říčky",
    "psc": "66483",
    "okres": "Brno-venkov",
    "obec": "Říčky",
    "val": "66483 Ricky Ricky"
  },
  {
    "cast": "Říčky",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Orlické Podhůří",
    "val": "56201 Orlicke Podhuri Ricky"
  },
  {
    "cast": "Říčky v Orlických horách",
    "psc": "51761",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Říčky v Orlických horách",
    "val": "51761 Ricky v Orlickych horach Ricky v Orlickych horach"
  },
  {
    "cast": "Řídeč",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Řídeč",
    "val": "78501 Ridec Ridec"
  },
  {
    "cast": "Řídelov",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Řídelov",
    "val": "58856 Ridelov Ridelov"
  },
  {
    "cast": "Řídký",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Řídký",
    "val": "57001 Ridky Ridky"
  },
  {
    "cast": "Řikonín",
    "psc": "59451",
    "okres": "Brno-venkov",
    "obec": "Řikonín",
    "val": "59451 Rikonin Rikonin"
  },
  {
    "cast": "Řikov",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Ješetice",
    "val": "25789 Jesetice Rikov"
  },
  {
    "cast": "Říkov",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Říkov",
    "val": "55203 Rikov Rikov"
  },
  {
    "cast": "Řikovice",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Morašice",
    "val": "57001 Morasice Rikovice"
  },
  {
    "cast": "Říkovice",
    "psc": "75118",
    "okres": "Přerov",
    "obec": "Říkovice",
    "val": "75118 Rikovice Rikovice"
  },
  {
    "cast": "Řimice",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Bílá Lhota",
    "val": "78321 Bila Lhota Rimice"
  },
  {
    "cast": "Římov",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Římov",
    "val": "67522 Rimov Rimov"
  },
  {
    "cast": "Římov (část)",
    "psc": "37324",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37324 Rimov Rimov (cast)"
  },
  {
    "cast": "Římov (část)",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Římov",
    "val": "37007 Rimov Rimov (cast)"
  },
  {
    "cast": "Řimovice",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Řimovice",
    "val": "25801 Rimovice Rimovice"
  },
  {
    "cast": "Římovice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Golčův Jeníkov",
    "val": "58282 Golcuv Jenikov Rimovice"
  },
  {
    "cast": "Řípec (část)",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Řípec",
    "val": "39201 Ripec Ripec (cast)"
  },
  {
    "cast": "Řípec (část)",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Řípec",
    "val": "39181 Ripec Ripec (cast)"
  },
  {
    "cast": "Řípov",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Ripov"
  },
  {
    "cast": "Řísnice",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Risnice"
  },
  {
    "cast": "Řisuty",
    "psc": "27378",
    "okres": "Kladno",
    "obec": "Řisuty",
    "val": "27378 Risuty Risuty"
  },
  {
    "cast": "Řisuty",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Risuty"
  },
  {
    "cast": "Řiště",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Předmíř",
    "val": "38742 Predmir Riste"
  },
  {
    "cast": "Řitka",
    "psc": "25203",
    "okres": "Praha-západ",
    "obec": "Řitka",
    "val": "25203 Ritka Ritka"
  },
  {
    "cast": "Řitonice",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Řitonice",
    "val": "29404 Ritonice Ritonice"
  },
  {
    "cast": "Saběnice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Havraň",
    "val": "43401 Havran Sabenice"
  },
  {
    "cast": "Sádek",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Sádek",
    "val": "57201 Sadek Sadek"
  },
  {
    "cast": "Sádek",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Deštnice",
    "val": "43801 Destnice Sadek"
  },
  {
    "cast": "Sádek",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Sádek",
    "val": "26101 Sadek Sadek"
  },
  {
    "cast": "Sádek",
    "psc": "74775",
    "okres": "Opava",
    "obec": "Velké Heraltice",
    "val": "74775 Velke Heraltice Sadek"
  },
  {
    "cast": "Sadov",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Sadov",
    "val": "36001 Sadov Sadov"
  },
  {
    "cast": "Sadová",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Sadova"
  },
  {
    "cast": "Sadová",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Sadová",
    "val": "50315 Sadova Sadova"
  },
  {
    "cast": "Sadská",
    "psc": "28912",
    "okres": "Nymburk",
    "obec": "Sadská",
    "val": "28912 Sadska Sadska"
  },
  {
    "cast": "Sady (část)",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68601 Uherske Hradiste Sady (cast)"
  },
  {
    "cast": "Sady (část)",
    "psc": "68605",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68605 Uherske Hradiste Sady (cast)"
  },
  {
    "cast": "Saky",
    "psc": "27308",
    "okres": "Kladno",
    "obec": "Třebichovice",
    "val": "27308 Trebichovice Saky"
  },
  {
    "cast": "Salačova Lhota",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Salačova Lhota",
    "val": "39501 Salacova Lhota Salacova Lhota"
  },
  {
    "cast": "Saladín",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Záblatí",
    "val": "38301 Zablati Saladin"
  },
  {
    "cast": "Salajna",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Dolní Žandov",
    "val": "35002 Dolni Zandov Salajna"
  },
  {
    "cast": "Salaš",
    "psc": "76351",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76351 Zlin Salas"
  },
  {
    "cast": "Salaš",
    "psc": "68706",
    "okres": "Uherské Hradiště",
    "obec": "Salaš",
    "val": "68706 Salas Salas"
  },
  {
    "cast": "Salavice",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Třešť",
    "val": "58901 Trest Salavice"
  },
  {
    "cast": "Salisov",
    "psc": "79376",
    "okres": "Jeseník",
    "obec": "Zlaté Hory",
    "val": "79376 Zlate Hory Salisov"
  },
  {
    "cast": "Salmov",
    "psc": "40779",
    "okres": "Děčín",
    "obec": "Mikulášovice",
    "val": "40779 Mikulasovice Salmov"
  },
  {
    "cast": "Samařov",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Liboměřice",
    "val": "53807 Libomerice Samarov"
  },
  {
    "cast": "Samechov",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Chocerady",
    "val": "25724 Chocerady Samechov"
  },
  {
    "cast": "Samopše",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Samopše",
    "val": "28506 Samopse Samopse"
  },
  {
    "cast": "Samosoly",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Pluhův Žďár",
    "val": "37821 Pluhuv Zdar Samosoly"
  },
  {
    "cast": "Samotín",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Sněžné",
    "val": "59203 Snezne Samotin"
  },
  {
    "cast": "Samotišky",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Samotišky",
    "val": "77900 Samotisky Samotisky"
  },
  {
    "cast": "Samšín",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Samšín",
    "val": "39501 Samsin Samsin"
  },
  {
    "cast": "Samšina",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Samšina",
    "val": "50601 Samsina Samsina"
  },
  {
    "cast": "Saň",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46373 Visnova San"
  },
  {
    "cast": "Sány",
    "psc": "28906",
    "okres": "Nymburk",
    "obec": "Sány",
    "val": "28906 Sany Sany"
  },
  {
    "cast": "Sasina",
    "psc": "67932",
    "okres": "Blansko",
    "obec": "Svitávka",
    "val": "67932 Svitavka Sasina"
  },
  {
    "cast": "Sasov",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Sasov"
  },
  {
    "cast": "Satalice",
    "psc": "19015",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19015 Praha Satalice"
  },
  {
    "cast": "Savín",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78324 Litovel Savin"
  },
  {
    "cast": "Sázava",
    "psc": "28506",
    "okres": "Benešov",
    "obec": "Sázava",
    "val": "28506 Sazava Sazava"
  },
  {
    "cast": "Sázava",
    "psc": "25206",
    "okres": "Praha-západ",
    "obec": "Davle",
    "val": "25206 Davle Sazava"
  },
  {
    "cast": "Sázava",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nový Rychnov",
    "val": "39301 Novy Rychnov Sazava"
  },
  {
    "cast": "Sázava",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Sázava",
    "val": "56301 Sazava Sazava"
  },
  {
    "cast": "Sázava (část)",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Sázava",
    "val": "59212 Sazava Sazava (cast)"
  },
  {
    "cast": "Sázava (část)",
    "psc": "59211",
    "okres": "Žďár nad Sázavou",
    "obec": "Sázava",
    "val": "59211 Sazava Sazava (cast)"
  },
  {
    "cast": "Sázavka",
    "psc": "58244",
    "okres": "Havlíčkův Brod",
    "obec": "Sázavka",
    "val": "58244 Sazavka Sazavka"
  },
  {
    "cast": "Sazená",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Sazená",
    "val": "27324 Sazena Sazena"
  },
  {
    "cast": "Sazomín",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Sazomín",
    "val": "59101 Sazomin Sazomin"
  },
  {
    "cast": "Sazovice",
    "psc": "76301",
    "okres": "Zlín",
    "obec": "Sazovice",
    "val": "76301 Sazovice Sazovice"
  },
  {
    "cast": "Sběř",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Sběř",
    "val": "50703 Sber Sber"
  },
  {
    "cast": "Sebečice",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Sebečice",
    "val": "33808 Sebecice Sebecice"
  },
  {
    "cast": "Sebranice",
    "psc": "67931",
    "okres": "Blansko",
    "obec": "Sebranice",
    "val": "67931 Sebranice Sebranice"
  },
  {
    "cast": "Sebranice",
    "psc": "56962",
    "okres": "Svitavy",
    "obec": "Sebranice",
    "val": "56962 Sebranice Sebranice"
  },
  {
    "cast": "Sebuč",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Dolany",
    "val": "55204 Dolany Sebuc"
  },
  {
    "cast": "Sebuzín",
    "psc": "40302",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40302 Usti nad Labem Sebuzin"
  },
  {
    "cast": "Seč",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Sec"
  },
  {
    "cast": "Seč",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Seč",
    "val": "33601 Sec Sec"
  },
  {
    "cast": "Seč",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Seč",
    "val": "56201 Sec Sec"
  },
  {
    "cast": "Seč",
    "psc": "79845",
    "okres": "Prostějov",
    "obec": "Lipová",
    "val": "79845 Lipova Sec"
  },
  {
    "cast": "Sedčice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Nové Sedlo",
    "val": "43801 Nove Sedlo Sedcice"
  },
  {
    "cast": "Sedlatice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Sedlatice",
    "val": "58856 Sedlatice Sedlatice"
  },
  {
    "cast": "Sedlce",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Svatý Jan nad Malší",
    "val": "37401 Svaty Jan nad Malsi Sedlce"
  },
  {
    "cast": "Sedlčánky",
    "psc": "25088",
    "okres": "Praha-východ",
    "obec": "Čelákovice",
    "val": "25088 Celakovice Sedlcanky"
  },
  {
    "cast": "Sedlčany",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Sedlcany"
  },
  {
    "cast": "Sedlec",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Žebrák",
    "val": "26751 Zebrak Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "43401",
    "okres": "Most",
    "obec": "Korozluky",
    "val": "43401 Korozluky Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Sedlec",
    "val": "33141 Sedlec Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Sedlec",
    "val": "41115 Sedlec Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "25065",
    "okres": "Praha-východ",
    "obec": "Sedlec",
    "val": "25065 Sedlec Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Poběžovice",
    "val": "34522 Pobezovice Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Křešice",
    "val": "41201 Kresice Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "16000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16000 Praha Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Sedlec",
    "val": "67571 Sedlec Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "69121",
    "okres": "Břeclav",
    "obec": "Sedlec",
    "val": "69121 Sedlec Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vraclav",
    "val": "56601 Vraclav Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Svatý Jan pod Skalou",
    "val": "26601 Svaty Jan pod Skalou Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Lanžov",
    "val": "54401 Lanzov Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "33202",
    "okres": "Plzeň-město",
    "obec": "Starý Plzenec",
    "val": "33202 Stary Plzenec Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "36010",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36010 Karlovy Vary Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "29471",
    "okres": "Mladá Boleslav",
    "obec": "Sedlec",
    "val": "29471 Sedlec Sedlec"
  },
  {
    "cast": "Sedlec",
    "psc": "37347",
    "okres": "České Budějovice",
    "obec": "Sedlec",
    "val": "37347 Sedlec Sedlec"
  },
  {
    "cast": "Sedlec u Radonic",
    "psc": "43155",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43155 Radonice Sedlec u Radonic"
  },
  {
    "cast": "Sedlec (část)",
    "psc": "28532",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28532 Kutna Hora Sedlec (cast)"
  },
  {
    "cast": "Sedlec (část)",
    "psc": "28403",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28403 Kutna Hora Sedlec (cast)"
  },
  {
    "cast": "Sedlecko",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Bušovice",
    "val": "33824 Busovice Sedlecko"
  },
  {
    "cast": "Sedlečko",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Sedlecko"
  },
  {
    "cast": "Sedlečko",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Bukovany",
    "val": "26272 Bukovany Sedlecko"
  },
  {
    "cast": "Sedlečko",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Sedlecko"
  },
  {
    "cast": "Sedlečko",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Štětkovice",
    "val": "26401 Stetkovice Sedlecko"
  },
  {
    "cast": "Sedlečko",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Šemnice",
    "val": "36272 Semnice Sedlecko"
  },
  {
    "cast": "Sedlečko",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Sedlecko"
  },
  {
    "cast": "Sedlečko",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Veliš",
    "val": "25706 Velis Sedlecko"
  },
  {
    "cast": "Sedlečko",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Sedlecko"
  },
  {
    "cast": "Sedlečko u Soběslavě",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Sedlečko u Soběslavě",
    "val": "39201 Sedlecko u Sobeslave Sedlecko u Sobeslave"
  },
  {
    "cast": "Sedlejov",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Sedlejov",
    "val": "58862 Sedlejov Sedlejov"
  },
  {
    "cast": "Sedlejovice",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Sychrov",
    "val": "46344 Sychrov Sedlejovice"
  },
  {
    "cast": "Sedlešovice",
    "psc": "67181",
    "okres": "Znojmo",
    "obec": "Nový Šaldorf-Sedlešovice",
    "val": "67181 Novy Saldorf-Sedlesovice Sedlesovice"
  },
  {
    "cast": "Sedletín",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Sedletín",
    "val": "58301 Sedletin Sedletin"
  },
  {
    "cast": "Sedlice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Keblov",
    "val": "25765 Keblov Sedlice"
  },
  {
    "cast": "Sedlice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Sedlice",
    "val": "39601 Sedlice Sedlice"
  },
  {
    "cast": "Sedlice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Zahořany",
    "val": "34401 Zahorany Sedlice"
  },
  {
    "cast": "Sedlice",
    "psc": "38732",
    "okres": "Strakonice",
    "obec": "Sedlice",
    "val": "38732 Sedlice Sedlice"
  },
  {
    "cast": "Sedlice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přídolí",
    "val": "38101 Pridoli Sedlice"
  },
  {
    "cast": "Sedlice",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Sedlice",
    "val": "26242 Sedlice Sedlice"
  },
  {
    "cast": "Sedlice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Praskačka",
    "val": "50327 Praskacka Sedlice"
  },
  {
    "cast": "Sedličky",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Sedlicky"
  },
  {
    "cast": "Sedlíkovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Čejetice",
    "val": "38601 Cejetice Sedlikovice"
  },
  {
    "cast": "Sedlíkovice",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Dolní Bukovsko",
    "val": "37365 Dolni Bukovsko Sedlikovice"
  },
  {
    "cast": "Sedlisko",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Kobyly",
    "val": "46345 Kobyly Sedlisko"
  },
  {
    "cast": "Sedliště",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Sedliště",
    "val": "50723 Sedliste Sedliste"
  },
  {
    "cast": "Sedliště",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Sedliště",
    "val": "57001 Sedliste Sedliste"
  },
  {
    "cast": "Sedliště",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Čejetice",
    "val": "38901 Cejetice Sedliste"
  },
  {
    "cast": "Sedliště",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Sedliště",
    "val": "33501 Sedliste Sedliste"
  },
  {
    "cast": "Sedliště",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Vyskytná",
    "val": "39301 Vyskytna Sedliste"
  },
  {
    "cast": "Sedliště",
    "psc": "73936",
    "okres": "Frýdek-Místek",
    "obec": "Sedliště",
    "val": "73936 Sedliste Sedliste"
  },
  {
    "cast": "Sedliště",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Jimramov",
    "val": "59242 Jimramov Sedliste"
  },
  {
    "cast": "Sedlíšťka",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Nová Sídla",
    "val": "57001 Nova Sidla Sedlistka"
  },
  {
    "cast": "Sedlíšťka",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Vlastibořice",
    "val": "46344 Vlastiborice Sedlistka"
  },
  {
    "cast": "Sedlíšťka",
    "psc": "53401",
    "okres": "Ústí nad Orlicí",
    "obec": "Radhošť",
    "val": "53401 Radhost Sedlistka"
  },
  {
    "cast": "Sedlnice",
    "psc": "74256",
    "okres": "Nový Jičín",
    "obec": "Sedlnice",
    "val": "74256 Sedlnice Sedlnice"
  },
  {
    "cast": "Sedlo",
    "psc": "43601",
    "okres": "Most",
    "obec": "Klíny",
    "val": "43601 Kliny Sedlo"
  },
  {
    "cast": "Sedlo",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Útvina",
    "val": "36401 Utvina Sedlo"
  },
  {
    "cast": "Sedlo",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Číměř",
    "val": "37833 Cimer Sedlo"
  },
  {
    "cast": "Sedlo",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Komařice",
    "val": "37401 Komarice Sedlo"
  },
  {
    "cast": "Sedlo",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Střelské Hoštice",
    "val": "38601 Strelske Hostice Sedlo"
  },
  {
    "cast": "Sedloňov",
    "psc": "51791",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Sedloňov",
    "val": "51791 Sedlonov Sedlonov"
  },
  {
    "cast": "Sedlov",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Ratboř",
    "val": "28002 Ratbor Sedlov"
  },
  {
    "cast": "Sedlovice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Němčice",
    "val": "38411 Nemcice Sedlovice"
  },
  {
    "cast": "Sedm Dvorů",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Moravský Beroun",
    "val": "79305 Moravsky Beroun Sedm Dvoru"
  },
  {
    "cast": "Sedm Chalup",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Brloh",
    "val": "38203 Brloh Sedm Chalup"
  },
  {
    "cast": "Sedmihorky",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Karlovice",
    "val": "51101 Karlovice Sedmihorky"
  },
  {
    "cast": "Sedmpány",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Trhový Štěpánov",
    "val": "25763 Trhovy Stepanov Sedmpany"
  },
  {
    "cast": "Sehradice",
    "psc": "76323",
    "okres": "Zlín",
    "obec": "Sehradice",
    "val": "76323 Sehradice Sehradice"
  },
  {
    "cast": "Sechov",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kožlí",
    "val": "58401 Kozli Sechov"
  },
  {
    "cast": "Sejcká Lhota",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Sejcka Lhota"
  },
  {
    "cast": "Sejřek",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Sejřek",
    "val": "59262 Sejrek Sejrek"
  },
  {
    "cast": "Sekerkovy Loučky",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Sekerkovy Loucky"
  },
  {
    "cast": "Sekerské Chalupy",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Stará Voda",
    "val": "35301 Stara Voda Sekerske Chalupy"
  },
  {
    "cast": "Sekeřice",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Sekeřice",
    "val": "50703 Sekerice Sekerice"
  },
  {
    "cast": "Sekrýt",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Sekryt"
  },
  {
    "cast": "Sekyrka",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Osečnice",
    "val": "51703 Osecnice Sekyrka"
  },
  {
    "cast": "Seletice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Seletice"
  },
  {
    "cast": "Seletice (část)",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Seletice",
    "val": "28802 Seletice Seletice (cast)"
  },
  {
    "cast": "Seletice (část)",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Seletice",
    "val": "28934 Seletice Seletice (cast)"
  },
  {
    "cast": "Selibice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Staňkovice",
    "val": "44001 Stankovice Selibice"
  },
  {
    "cast": "Selibov",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Selibov"
  },
  {
    "cast": "Selmice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Selmice",
    "val": "53501 Selmice Selmice"
  },
  {
    "cast": "Seloutky",
    "psc": "79804",
    "okres": "Prostějov",
    "obec": "Seloutky",
    "val": "79804 Seloutky Seloutky"
  },
  {
    "cast": "Semanín",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Semanín",
    "val": "56002 Semanin Semanin"
  },
  {
    "cast": "Sembratec",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Petroupim",
    "val": "25601 Petroupim Sembratec"
  },
  {
    "cast": "Semčice",
    "psc": "29446",
    "okres": "Mladá Boleslav",
    "obec": "Semčice",
    "val": "29446 Semcice Semcice"
  },
  {
    "cast": "Semeč",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Děčany",
    "val": "41115 Decany Semec"
  },
  {
    "cast": "Semechnice",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Semechnice",
    "val": "51801 Semechnice Semechnice"
  },
  {
    "cast": "Seménkovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Semenkovice"
  },
  {
    "cast": "Semice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Semice"
  },
  {
    "cast": "Semice",
    "psc": "28917",
    "okres": "Nymburk",
    "obec": "Semice",
    "val": "28917 Semice Semice"
  },
  {
    "cast": "Semilkovice",
    "psc": "27742",
    "okres": "Mělník",
    "obec": "Obříství",
    "val": "27742 Obristvi Semilkovice"
  },
  {
    "cast": "Semily (část)",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Semily",
    "val": "51301 Semily Semily (cast)"
  },
  {
    "cast": "Semily (část)",
    "psc": "51206",
    "okres": "Semily",
    "obec": "Semily",
    "val": "51206 Semily Semily (cast)"
  },
  {
    "cast": "Semín",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Semín",
    "val": "53501 Semin Semin"
  },
  {
    "cast": "Semínova Lhota (část)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Újezd pod Troskami",
    "val": "50601 Ujezd pod Troskami Seminova Lhota (cast)"
  },
  {
    "cast": "Semínova Lhota (část)",
    "psc": "51263",
    "okres": "Jičín",
    "obec": "Újezd pod Troskami",
    "val": "51263 Ujezd pod Troskami Seminova Lhota (cast)"
  },
  {
    "cast": "Semněvice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Semněvice",
    "val": "34601 Semnevice Semnevice"
  },
  {
    "cast": "Semonice",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Semonice"
  },
  {
    "cast": "Semošice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Semosice"
  },
  {
    "cast": "Semovice",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Semovice"
  },
  {
    "cast": "Semtěš",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Semtěš",
    "val": "28601 Semtes Semtes"
  },
  {
    "cast": "Semtěš",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Pšov",
    "val": "36452 Psov Semtes"
  },
  {
    "cast": "Semtín",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25901 Olbramovice Semtin"
  },
  {
    "cast": "Semtín (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Semtin (cast)"
  },
  {
    "cast": "Semtín (část)",
    "psc": "53353",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53353 Pardubice Semtin (cast)"
  },
  {
    "cast": "Semtínek",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25901 Olbramovice Semtinek"
  },
  {
    "cast": "Sendraž",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Sendraž",
    "val": "54901 Sendraz Sendraz"
  },
  {
    "cast": "Sendražice",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Sendrazice"
  },
  {
    "cast": "Sendražice",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Sendražice",
    "val": "50303 Sendrazice Sendrazice"
  },
  {
    "cast": "Senec",
    "psc": "33008",
    "okres": "Plzeň-sever",
    "obec": "Zruč-Senec",
    "val": "33008 Zruc-Senec Senec"
  },
  {
    "cast": "Senec (část)",
    "psc": "27036",
    "okres": "Rakovník",
    "obec": "Senec",
    "val": "27036 Senec Senec (cast)"
  },
  {
    "cast": "Senec (část)",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Senec",
    "val": "27035 Senec Senec (cast)"
  },
  {
    "cast": "Senešnice (část)",
    "psc": "26203",
    "okres": "Praha-západ",
    "obec": "Bojanovice",
    "val": "26203 Bojanovice Senesnice (cast)"
  },
  {
    "cast": "Senešnice (část)",
    "psc": "26205",
    "okres": "Praha-západ",
    "obec": "Bojanovice",
    "val": "26205 Bojanovice Senesnice (cast)"
  },
  {
    "cast": "Senetářov",
    "psc": "67906",
    "okres": "Blansko",
    "obec": "Senetářov",
    "val": "67906 Senetarov Senetarov"
  },
  {
    "cast": "Senetín",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Petrovice I",
    "val": "28601 Petrovice I Senetin"
  },
  {
    "cast": "Senice",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Senice",
    "val": "29001 Senice Senice"
  },
  {
    "cast": "Senice na Hané",
    "psc": "78345",
    "okres": "Olomouc",
    "obec": "Senice na Hané",
    "val": "78345 Senice na Hane Senice na Hane"
  },
  {
    "cast": "Senička",
    "psc": "78345",
    "okres": "Olomouc",
    "obec": "Senička",
    "val": "78345 Senicka Senicka"
  },
  {
    "cast": "Seník",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Jankovice",
    "val": "53501 Jankovice Senik"
  },
  {
    "cast": "Seninka",
    "psc": "75611",
    "okres": "Vsetín",
    "obec": "Seninka",
    "val": "75611 Seninka Seninka"
  },
  {
    "cast": "Senkov",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Zbrašín",
    "val": "44001 Zbrasin Senkov"
  },
  {
    "cast": "Senohraby",
    "psc": "25166",
    "okres": "Praha-východ",
    "obec": "Senohraby",
    "val": "25166 Senohraby Senohraby"
  },
  {
    "cast": "Senomaty",
    "psc": "27031",
    "okres": "Rakovník",
    "obec": "Senomaty",
    "val": "27031 Senomaty Senomaty"
  },
  {
    "cast": "Senorady",
    "psc": "67575",
    "okres": "Brno-venkov",
    "obec": "Senorady",
    "val": "67575 Senorady Senorady"
  },
  {
    "cast": "Senotín",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Senotin"
  },
  {
    "cast": "Senožaty",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Bechyně",
    "val": "39165 Bechyne Senozaty"
  },
  {
    "cast": "Senožaty",
    "psc": "39456",
    "okres": "Pelhřimov",
    "obec": "Senožaty",
    "val": "39456 Senozaty Senozaty"
  },
  {
    "cast": "Sentice",
    "psc": "66603",
    "okres": "Brno-venkov",
    "obec": "Sentice",
    "val": "66603 Sentice Sentice"
  },
  {
    "cast": "Sepekov (část)",
    "psc": "39851",
    "okres": "Písek",
    "obec": "Sepekov",
    "val": "39851 Sepekov Sepekov (cast)"
  },
  {
    "cast": "Sepekov (část)",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Sepekov",
    "val": "39901 Sepekov Sepekov (cast)"
  },
  {
    "cast": "Sestroňovice",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Sestronovice"
  },
  {
    "cast": "Sestrouň",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Sestroun"
  },
  {
    "cast": "Setěchovice",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Zálezly",
    "val": "38481 Zalezly Setechovice"
  },
  {
    "cast": "Setěkovy",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "26401 Nechvalice Setekovy"
  },
  {
    "cast": "Severní",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Lobendava",
    "val": "40747 Lobendava Severni"
  },
  {
    "cast": "Severní Předměstí (část)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Severni Predmesti (cast)"
  },
  {
    "cast": "Severní Předměstí (část)",
    "psc": "32300",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32300 Plzen Severni Predmesti (cast)"
  },
  {
    "cast": "Severní Terasa",
    "psc": "40011",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40011 Usti nad Labem Severni Terasa"
  },
  {
    "cast": "Sezemice",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Sezemice",
    "val": "53304 Sezemice Sezemice"
  },
  {
    "cast": "Sezemice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Rtyně nad Bílinou",
    "val": "41501 Rtyne nad Bilinou Sezemice"
  },
  {
    "cast": "Sezemice",
    "psc": "29411",
    "okres": "Mladá Boleslav",
    "obec": "Sezemice",
    "val": "29411 Sezemice Sezemice"
  },
  {
    "cast": "Sezemín",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Poběžovice",
    "val": "34522 Pobezovice Sezemin"
  },
  {
    "cast": "Sezímky (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47002 Kravare Sezimky (cast)"
  },
  {
    "cast": "Sezímky (část)",
    "psc": "47102",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47102 Kravare Sezimky (cast)"
  },
  {
    "cast": "Sezimovo Ústí (část)",
    "psc": "39156",
    "okres": "Tábor",
    "obec": "Sezimovo Ústí",
    "val": "39156 Sezimovo Usti Sezimovo Usti (cast)"
  },
  {
    "cast": "Sezimovo Ústí (část)",
    "psc": "39101",
    "okres": "Tábor",
    "obec": "Sezimovo Ústí",
    "val": "39101 Sezimovo Usti Sezimovo Usti (cast)"
  },
  {
    "cast": "Sezimovo Ústí (část)",
    "psc": "39102",
    "okres": "Tábor",
    "obec": "Sezimovo Ústí",
    "val": "39102 Sezimovo Usti Sezimovo Usti (cast)"
  },
  {
    "cast": "Schořov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Schořov",
    "val": "28601 Schorov Schorov"
  },
  {
    "cast": "Sibřina",
    "psc": "25084",
    "okres": "Praha-východ",
    "obec": "Sibřina",
    "val": "25084 Sibrina Sibrina"
  },
  {
    "cast": "Sidonie",
    "psc": "76334",
    "okres": "Zlín",
    "obec": "Brumov-Bylnice",
    "val": "76334 Brumov-Bylnice Sidonie"
  },
  {
    "cast": "Silnice",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Horka",
    "val": "53851 Horka Silnice"
  },
  {
    "cast": "Silničná",
    "psc": "69634",
    "okres": "Hodonín",
    "obec": "Žarošice",
    "val": "69634 Zarosice Silnicna"
  },
  {
    "cast": "Silůvky",
    "psc": "66446",
    "okres": "Brno-venkov",
    "obec": "Silůvky",
    "val": "66446 Siluvky Siluvky"
  },
  {
    "cast": "Silvánka",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Uhlířské Janovice",
    "val": "28504 Uhlirske Janovice Silvanka"
  },
  {
    "cast": "Simtany",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Pohled",
    "val": "58222 Pohled Simtany"
  },
  {
    "cast": "Sinutec",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Sinutec"
  },
  {
    "cast": "Sirá",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Sirá",
    "val": "33701 Sira Sira"
  },
  {
    "cast": "Sirákov",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Sirákov",
    "val": "59212 Sirakov Sirakov"
  },
  {
    "cast": "Sirákovice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Golčův Jeníkov",
    "val": "58282 Golcuv Jenikov Sirakovice"
  },
  {
    "cast": "Siřejovice",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Siřejovice",
    "val": "41002 Sirejovice Sirejovice"
  },
  {
    "cast": "Siřem",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Blšany",
    "val": "43801 Blsany Sirem"
  },
  {
    "cast": "Sítiny",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mnichov",
    "val": "35301 Mnichov Sitiny"
  },
  {
    "cast": "Sítiny",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Svatý Jiří",
    "val": "56501 Svaty Jiri Sitiny"
  },
  {
    "cast": "Sitné",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Želízy",
    "val": "27721 Zelizy Sitne"
  },
  {
    "cast": "Sivice",
    "psc": "66407",
    "okres": "Brno-venkov",
    "obec": "Sivice",
    "val": "66407 Sivice Sivice"
  },
  {
    "cast": "Skala",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "28522 Vlastejovice Skala"
  },
  {
    "cast": "Skála",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Chrast",
    "val": "53851 Chrast Skala"
  },
  {
    "cast": "Skála",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Boháňka",
    "val": "50801 Bohanka Skala"
  },
  {
    "cast": "Skála",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Věž",
    "val": "58001 Vez Skala"
  },
  {
    "cast": "Skalany",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Vyskeř",
    "val": "51101 Vysker Skalany"
  },
  {
    "cast": "Skalice",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Nečín",
    "val": "26301 Necin Skalice"
  },
  {
    "cast": "Skalice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Skalice",
    "val": "39201 Skalice Skalice"
  },
  {
    "cast": "Skalice",
    "psc": "67171",
    "okres": "Znojmo",
    "obec": "Skalice",
    "val": "67171 Skalice Skalice"
  },
  {
    "cast": "Skalice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebívlice",
    "val": "41115 Trebivlice Skalice"
  },
  {
    "cast": "Skalice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Žitenice",
    "val": "41201 Zitenice Skalice"
  },
  {
    "cast": "Skalice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Skalice"
  },
  {
    "cast": "Skalice",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Hrochův Týnec",
    "val": "53862 Hrochuv Tynec Skalice"
  },
  {
    "cast": "Skalice",
    "psc": "73801",
    "okres": "Frýdek-Místek",
    "obec": "Frýdek-Místek",
    "val": "73801 Frydek-Mistek Skalice"
  },
  {
    "cast": "Skalice nad Svitavou",
    "psc": "67901",
    "okres": "Blansko",
    "obec": "Skalice nad Svitavou",
    "val": "67901 Skalice nad Svitavou Skalice nad Svitavou"
  },
  {
    "cast": "Skalice u České Lípy (část)",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Skalice u České Lípy",
    "val": "47301 Skalice u Ceske Lipy Skalice u Ceske Lipy (cast)"
  },
  {
    "cast": "Skalice u České Lípy (část)",
    "psc": "47117",
    "okres": "Česká Lípa",
    "obec": "Skalice u České Lípy",
    "val": "47117 Skalice u Ceske Lipy Skalice u Ceske Lipy (cast)"
  },
  {
    "cast": "Skalice (část)",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Skalice",
    "val": "50303 Skalice Skalice (cast)"
  },
  {
    "cast": "Skalice (část)",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Skalice",
    "val": "50003 Skalice Skalice (cast)"
  },
  {
    "cast": "Skaličany",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Blatná",
    "val": "38801 Blatna Skalicany"
  },
  {
    "cast": "Skalička",
    "psc": "75352",
    "okres": "Přerov",
    "obec": "Skalička",
    "val": "75352 Skalicka Skalicka"
  },
  {
    "cast": "Skalička",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Skalice",
    "val": "50003 Skalice Skalicka"
  },
  {
    "cast": "Skalička (část)",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Skalička",
    "val": "66601 Skalicka Skalicka (cast)"
  },
  {
    "cast": "Skalička (část)",
    "psc": "66603",
    "okres": "Brno-venkov",
    "obec": "Skalička",
    "val": "66603 Skalicka Skalicka (cast)"
  },
  {
    "cast": "Skalka",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Skalka"
  },
  {
    "cast": "Skalka",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Hazlov",
    "val": "35201 Hazlov Skalka"
  },
  {
    "cast": "Skalka",
    "psc": "69648",
    "okres": "Hodonín",
    "obec": "Skalka",
    "val": "69648 Skalka Skalka"
  },
  {
    "cast": "Skalka",
    "psc": "79824",
    "okres": "Prostějov",
    "obec": "Skalka",
    "val": "79824 Skalka Skalka"
  },
  {
    "cast": "Skalka",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Drásov",
    "val": "26101 Drasov Skalka"
  },
  {
    "cast": "Skalka",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Česká Metuje",
    "val": "54931 Ceska Metuje Skalka"
  },
  {
    "cast": "Skalka",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Blíževedly",
    "val": "47002 Blizevedly Skalka"
  },
  {
    "cast": "Skalka",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37881 Nova Bystrice Skalka"
  },
  {
    "cast": "Skalka u Doks",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Skalka u Doks",
    "val": "47201 Skalka u Doks Skalka u Doks"
  },
  {
    "cast": "Skalná",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Skalná",
    "val": "35134 Skalna Skalna"
  },
  {
    "cast": "Skalní Mlýn",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Skalni Mlyn"
  },
  {
    "cast": "Skalsko",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Skalsko",
    "val": "29426 Skalsko Skalsko"
  },
  {
    "cast": "Skalsko",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Pohoří",
    "val": "25401 Pohori Skalsko"
  },
  {
    "cast": "Skály",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Skály",
    "val": "39811 Skaly Skaly"
  },
  {
    "cast": "Skály",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Skály",
    "val": "38601 Skaly Skaly"
  },
  {
    "cast": "Skály",
    "psc": "79344",
    "okres": "Bruntál",
    "obec": "Horní Město",
    "val": "79344 Horni Mesto Skaly"
  },
  {
    "cast": "Skály",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Skaly"
  },
  {
    "cast": "Skapce",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Skapce",
    "val": "34901 Skapce Skapce"
  },
  {
    "cast": "Skařez",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Skarez"
  },
  {
    "cast": "Skašov",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Skašov",
    "val": "33601 Skasov Skasov"
  },
  {
    "cast": "Skaštice",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Skaštice",
    "val": "76701 Skastice Skastice"
  },
  {
    "cast": "Skelná Huť",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Chudenín",
    "val": "34022 Chudenin Skelna Hut"
  },
  {
    "cast": "Skelná Huť",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Krsy",
    "val": "33162 Krsy Skelna Hut"
  },
  {
    "cast": "Skláře",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Sklare"
  },
  {
    "cast": "Skláře",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Hořice na Šumavě",
    "val": "38101 Horice na Sumave Sklare"
  },
  {
    "cast": "Skláře-Chotěnov x)",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mariánské Lázně",
    "val": "35301 Marianske Lazne Sklare-Chotenov x)"
  },
  {
    "cast": "Sklená",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Sklena"
  },
  {
    "cast": "Sklená Huť",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Přívětice",
    "val": "33828 Privetice Sklena Hut"
  },
  {
    "cast": "Sklenařice",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Vysoké nad Jizerou",
    "val": "51243 Vysoke nad Jizerou Sklenarice"
  },
  {
    "cast": "Sklenářovice",
    "psc": "54223",
    "okres": "Trutnov",
    "obec": "Mladé Buky",
    "val": "54223 Mlade Buky Sklenarovice"
  },
  {
    "cast": "Sklené",
    "psc": "56802",
    "okres": "Svitavy",
    "obec": "Sklené",
    "val": "56802 Sklene Sklene"
  },
  {
    "cast": "Sklené",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Sklene"
  },
  {
    "cast": "Sklené",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Sklené",
    "val": "59101 Sklene Sklene"
  },
  {
    "cast": "Sklené nad Oslavou",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Sklené nad Oslavou",
    "val": "59101 Sklene nad Oslavou Sklene nad Oslavou"
  },
  {
    "cast": "Sklenka (část)",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25163 Strancice Sklenka (cast)"
  },
  {
    "cast": "Sklenka (část)",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25164 Strancice Sklenka (cast)"
  },
  {
    "cast": "Skočice",
    "psc": "38775",
    "okres": "Strakonice",
    "obec": "Skočice",
    "val": "38775 Skocice Skocice"
  },
  {
    "cast": "Skočice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Přeštice",
    "val": "33401 Prestice Skocice"
  },
  {
    "cast": "Skočidolovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Čáslavsko",
    "val": "39501 Caslavsko Skocidolovice"
  },
  {
    "cast": "Skočova Lhota",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Malá Roudka",
    "val": "67963 Mala Roudka Skocova Lhota"
  },
  {
    "cast": "Skochovice",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Nový Bydžov",
    "val": "50351 Novy Bydzov Skochovice"
  },
  {
    "cast": "Skokovy",
    "psc": "29412",
    "okres": "Mladá Boleslav",
    "obec": "Žďár",
    "val": "29412 Zdar Skokovy"
  },
  {
    "cast": "Skoky",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36471 Zlutice Skoky"
  },
  {
    "cast": "Skoky",
    "psc": "75125",
    "okres": "Přerov",
    "obec": "Dolní Újezd",
    "val": "75125 Dolni Ujezd Skoky"
  },
  {
    "cast": "Skomelno",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Skomelno",
    "val": "33828 Skomelno Skomelno"
  },
  {
    "cast": "Skopytce",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Skopytce",
    "val": "39201 Skopytce Skopytce"
  },
  {
    "cast": "Skoranov",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Třemošnice",
    "val": "53843 Tremosnice Skoranov"
  },
  {
    "cast": "Skoranovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Martinice u Onšova",
    "val": "39501 Martinice u Onsova Skoranovice"
  },
  {
    "cast": "Skorkov",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Skorkov",
    "val": "58253 Skorkov Skorkov"
  },
  {
    "cast": "Skorkov",
    "psc": "29474",
    "okres": "Mladá Boleslav",
    "obec": "Skorkov",
    "val": "29474 Skorkov Skorkov"
  },
  {
    "cast": "Skoronice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Bujanov",
    "val": "38241 Bujanov Skoronice"
  },
  {
    "cast": "Skoronice",
    "psc": "69641",
    "okres": "Hodonín",
    "obec": "Skoronice",
    "val": "69641 Skoronice Skoronice"
  },
  {
    "cast": "Skorošice",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Skorošice",
    "val": "79065 Skorosice Skorosice"
  },
  {
    "cast": "Skorotice",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Skorotice",
    "val": "59262 Skorotice Skorotice"
  },
  {
    "cast": "Skorotice (část)",
    "psc": "40001",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40001 Usti nad Labem Skorotice (cast)"
  },
  {
    "cast": "Skorotice (část)",
    "psc": "40340",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40340 Usti nad Labem Skorotice (cast)"
  },
  {
    "cast": "Skořenice",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Skořenice",
    "val": "56501 Skorenice Skorenice"
  },
  {
    "cast": "Skořice",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Skořice",
    "val": "33843 Skorice Skorice"
  },
  {
    "cast": "Skotnice",
    "psc": "74258",
    "okres": "Nový Jičín",
    "obec": "Skotnice",
    "val": "74258 Skotnice Skotnice"
  },
  {
    "cast": "Skoupý",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Mlečice",
    "val": "33808 Mlecice Skoupy"
  },
  {
    "cast": "Skoupý",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Skoupy"
  },
  {
    "cast": "Skramníky",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Klučov",
    "val": "28201 Klucov Skramniky"
  },
  {
    "cast": "Skramouš",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Skramous"
  },
  {
    "cast": "Skránčice",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Zavlekov",
    "val": "34034 Zavlekov Skrancice"
  },
  {
    "cast": "Skrbeň",
    "psc": "78335",
    "okres": "Olomouc",
    "obec": "Skrbeň",
    "val": "78335 Skrben Skrben"
  },
  {
    "cast": "Skrbovice",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Široká Niva",
    "val": "79201 Siroka Niva Skrbovice"
  },
  {
    "cast": "Skrchov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Skrchov",
    "val": "67961 Skrchov Skrchov"
  },
  {
    "cast": "Skrochovice",
    "psc": "74771",
    "okres": "Opava",
    "obec": "Brumovice",
    "val": "74771 Brumovice Skrochovice"
  },
  {
    "cast": "Skršice",
    "psc": "51771",
    "okres": "Rychnov nad Kněžnou",
    "obec": "České Meziříčí",
    "val": "51771 Ceske Mezirici Skrsice"
  },
  {
    "cast": "Skršín",
    "psc": "43401",
    "okres": "Most",
    "obec": "Skršín",
    "val": "43401 Skrsin Skrsin"
  },
  {
    "cast": "Skrýchov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Skrychov"
  },
  {
    "cast": "Skrýchov u Malšic",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Skrýchov u Malšic",
    "val": "39175 Skrychov u Malsic Skrychov u Malsic"
  },
  {
    "cast": "Skrýchov u Opařan",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Opařany",
    "val": "39161 Oparany Skrychov u Oparan"
  },
  {
    "cast": "Skryje",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Skryje",
    "val": "59455 Skryje Skryje"
  },
  {
    "cast": "Skryje",
    "psc": "27042",
    "okres": "Rakovník",
    "obec": "Skryje",
    "val": "27042 Skryje Skryje"
  },
  {
    "cast": "Skryje",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Skryje",
    "val": "58282 Skryje Skryje"
  },
  {
    "cast": "Skrýšov",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Polná",
    "val": "58813 Polna Skrysov"
  },
  {
    "cast": "Skrýšov",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Ratměřice",
    "val": "25703 Ratmerice Skrysov"
  },
  {
    "cast": "Skrýšov",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Skrysov"
  },
  {
    "cast": "Skrýšov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Skrysov"
  },
  {
    "cast": "Skrýšov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Skrysov"
  },
  {
    "cast": "Skrýšov",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26256 Svaty Jan Skrysov"
  },
  {
    "cast": "Skržice",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Soběsuky",
    "val": "76802 Sobesuky Skrzice"
  },
  {
    "cast": "Skřečoň",
    "psc": "73531",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73531 Bohumin Skrecon"
  },
  {
    "cast": "Skřib",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Stvolová",
    "val": "67961 Stvolova Skrib"
  },
  {
    "cast": "Skřidla",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Velešín",
    "val": "38232 Velesin Skridla"
  },
  {
    "cast": "Skřinářov",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Skřinářov",
    "val": "59453 Skrinarov Skrinarov"
  },
  {
    "cast": "Skříněřov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Zbytiny",
    "val": "38301 Zbytiny Skrinerov"
  },
  {
    "cast": "Skřipel (část)",
    "psc": "26725",
    "okres": "Beroun",
    "obec": "Skřipel",
    "val": "26725 Skripel Skripel (cast)"
  },
  {
    "cast": "Skřipel (část)",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Skřipel",
    "val": "26724 Skripel Skripel (cast)"
  },
  {
    "cast": "Skřípov",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Skřípov",
    "val": "79852 Skripov Skripov"
  },
  {
    "cast": "Skřipov (část)",
    "psc": "74301",
    "okres": "Opava",
    "obec": "Skřipov",
    "val": "74301 Skripov Skripov (cast)"
  },
  {
    "cast": "Skřipov (část)",
    "psc": "74745",
    "okres": "Opava",
    "obec": "Skřipov",
    "val": "74745 Skripov Skripov (cast)"
  },
  {
    "cast": "Skřipová",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Vrbice",
    "val": "36453 Vrbice Skripova"
  },
  {
    "cast": "Skřivaň",
    "psc": "27021",
    "okres": "Rakovník",
    "obec": "Pavlíkov",
    "val": "27021 Pavlikov Skrivan"
  },
  {
    "cast": "Skřivánek",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Okrouhlička",
    "val": "58253 Okrouhlicka Skrivanek"
  },
  {
    "cast": "Skřivany",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Přišimasy",
    "val": "28201 Prisimasy Skrivany"
  },
  {
    "cast": "Skřivany",
    "psc": "50352",
    "okres": "Hradec Králové",
    "obec": "Skřivany",
    "val": "50352 Skrivany Skrivany"
  },
  {
    "cast": "Skuheř",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Skuher"
  },
  {
    "cast": "Skuhrov",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Skuhrov",
    "val": "26727 Skuhrov Skuhrov"
  },
  {
    "cast": "Skuhrov",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Počepice",
    "val": "26255 Pocepice Skuhrov"
  },
  {
    "cast": "Skuhrov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Skuhrov",
    "val": "46822 Skuhrov Skuhrov"
  },
  {
    "cast": "Skuhrov",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Česká Třebová",
    "val": "56002 Ceska Trebova Skuhrov"
  },
  {
    "cast": "Skuhrov",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Skuhrov"
  },
  {
    "cast": "Skuhrov",
    "psc": "58241",
    "okres": "Havlíčkův Brod",
    "obec": "Skuhrov",
    "val": "58241 Skuhrov Skuhrov"
  },
  {
    "cast": "Skuhrov",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Skuhrov"
  },
  {
    "cast": "Skuhrov nad Bělou",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51703 Skuhrov nad Belou Skuhrov nad Belou"
  },
  {
    "cast": "Skuhrov (část)",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Velký Borek",
    "val": "27741 Velky Borek Skuhrov (cast)"
  },
  {
    "cast": "Skuhrov (část)",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Velký Borek",
    "val": "27601 Velky Borek Skuhrov (cast)"
  },
  {
    "cast": "Skuhrov (část)",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Velký Borek",
    "val": "27731 Velky Borek Skuhrov (cast)"
  },
  {
    "cast": "Skupá",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Slabce",
    "val": "27041 Slabce Skupa"
  },
  {
    "cast": "Skupeč",
    "psc": "33036",
    "okres": "Plzeň-sever",
    "obec": "Pernarec",
    "val": "33036 Pernarec Skupec"
  },
  {
    "cast": "Skupice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Skupice"
  },
  {
    "cast": "Skupice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Morašice",
    "val": "53803 Morasice Skupice"
  },
  {
    "cast": "Skůry",
    "psc": "27321",
    "okres": "Kladno",
    "obec": "Hobšovice",
    "val": "27321 Hobsovice Skury"
  },
  {
    "cast": "Skuřina",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50743 Markvartice Skurina"
  },
  {
    "cast": "Skuteč",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Skutec"
  },
  {
    "cast": "Skutíčko",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Skuticko"
  },
  {
    "cast": "Skviřín",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Skvirin"
  },
  {
    "cast": "Skvrňany (část)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Skvrnany (cast)"
  },
  {
    "cast": "Skvrňany (část)",
    "psc": "31800",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31800 Plzen Skvrnany (cast)"
  },
  {
    "cast": "Skvrňov",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Skvrňov",
    "val": "28144 Skvrnov Skvrnov"
  },
  {
    "cast": "Skyšice",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Domousnice",
    "val": "29404 Domousnice Skysice"
  },
  {
    "cast": "Skytaly",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Vroutek",
    "val": "44101 Vroutek Skytaly"
  },
  {
    "cast": "Slabce",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Slabce",
    "val": "27041 Slabce Slabce"
  },
  {
    "cast": "Slabčice",
    "psc": "39847",
    "okres": "Písek",
    "obec": "Slabčice",
    "val": "39847 Slabcice Slabcice"
  },
  {
    "cast": "Slaná",
    "psc": "51201",
    "okres": "Semily",
    "obec": "Slaná",
    "val": "51201 Slana Slana"
  },
  {
    "cast": "Slaník",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Slaník",
    "val": "38601 Slanik Slanik"
  },
  {
    "cast": "Slaný",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Slany"
  },
  {
    "cast": "Slapsko",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Slapsko",
    "val": "39143 Slapsko Slapsko"
  },
  {
    "cast": "Slapy",
    "psc": "25208",
    "okres": "Praha-západ",
    "obec": "Slapy",
    "val": "25208 Slapy Slapy"
  },
  {
    "cast": "Slapy",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46822 Frydstejn Slapy"
  },
  {
    "cast": "Slapy (část)",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Slapy",
    "val": "39002 Slapy Slapy (cast)"
  },
  {
    "cast": "Slapy (část)",
    "psc": "39176",
    "okres": "Tábor",
    "obec": "Slapy",
    "val": "39176 Slapy Slapy (cast)"
  },
  {
    "cast": "Slatina",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Slatina",
    "val": "56943 Slatina Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "62700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62700 Brno Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Slatina",
    "val": "67153 Slatina Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Chudenice",
    "val": "33901 Chudenice Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Slatina",
    "val": "34101 Slatina Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Slatina",
    "val": "33141 Slatina Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Slatina",
    "val": "41002 Slatina Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Horní Vltavice",
    "val": "38501 Horni Vltavice Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Slatina",
    "val": "56601 Slatina Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "74293",
    "okres": "Nový Jičín",
    "obec": "Slatina",
    "val": "74293 Slatina Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "35101",
    "okres": "Cheb",
    "obec": "Františkovy Lázně",
    "val": "35101 Frantiskovy Lazne Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Slatina"
  },
  {
    "cast": "Slatina",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Slatina"
  },
  {
    "cast": "Slatina nad Úpou (část)",
    "psc": "54232",
    "okres": "Náchod",
    "obec": "Slatina nad Úpou",
    "val": "54232 Slatina nad Upou Slatina nad Upou (cast)"
  },
  {
    "cast": "Slatina nad Úpou (část)",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Slatina nad Úpou",
    "val": "55205 Slatina nad Upou Slatina nad Upou (cast)"
  },
  {
    "cast": "Slatina nad Úpou (část)",
    "psc": "54947",
    "okres": "Náchod",
    "obec": "Slatina nad Úpou",
    "val": "54947 Slatina nad Upou Slatina nad Upou (cast)"
  },
  {
    "cast": "Slatina nad Zdobnicí (část)",
    "psc": "51756",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Slatina nad Zdobnicí",
    "val": "51756 Slatina nad Zdobnici Slatina nad Zdobnici (cast)"
  },
  {
    "cast": "Slatina nad Zdobnicí (část)",
    "psc": "51757",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Slatina nad Zdobnicí",
    "val": "51757 Slatina nad Zdobnici Slatina nad Zdobnici (cast)"
  },
  {
    "cast": "Slatina (část)",
    "psc": "27326",
    "okres": "Kladno",
    "obec": "Slatina",
    "val": "27326 Slatina Slatina (cast)"
  },
  {
    "cast": "Slatina (část)",
    "psc": "27325",
    "okres": "Kladno",
    "obec": "Slatina",
    "val": "27325 Slatina Slatina (cast)"
  },
  {
    "cast": "Slatiňany (část)",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Slatiňany",
    "val": "53701 Slatinany Slatinany (cast)"
  },
  {
    "cast": "Slatiňany (část)",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Slatiňany",
    "val": "53821 Slatinany Slatinany (cast)"
  },
  {
    "cast": "Slatinice",
    "psc": "78342",
    "okres": "Olomouc",
    "obec": "Slatinice",
    "val": "78342 Slatinice Slatinice"
  },
  {
    "cast": "Slatinka",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Slatinka"
  },
  {
    "cast": "Slatinky",
    "psc": "78342",
    "okres": "Prostějov",
    "obec": "Slatinky",
    "val": "78342 Slatinky Slatinky"
  },
  {
    "cast": "Slatiny",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Slatiny",
    "val": "50601 Slatiny Slatiny"
  },
  {
    "cast": "Slavče",
    "psc": "37321",
    "okres": "České Budějovice",
    "obec": "Slavče",
    "val": "37321 Slavce Slavce"
  },
  {
    "cast": "Slavče",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Vrábče",
    "val": "37001 Vrabce Slavce"
  },
  {
    "cast": "Slavětice",
    "psc": "67555",
    "okres": "Třebíč",
    "obec": "Slavětice",
    "val": "67555 Slavetice Slavetice"
  },
  {
    "cast": "Slavětice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Všemyslice",
    "val": "37501 Vsemyslice Slavetice"
  },
  {
    "cast": "Slavětín",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Hudčice",
    "val": "26272 Hudcice Slavetin"
  },
  {
    "cast": "Slavětín",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Slavětín",
    "val": "78324 Slavetin Slavetin"
  },
  {
    "cast": "Slavětín",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Slavetin"
  },
  {
    "cast": "Slavětín",
    "psc": "43909",
    "okres": "Louny",
    "obec": "Slavětín",
    "val": "43909 Slavetin Slavetin"
  },
  {
    "cast": "Slavětín",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Písečné",
    "val": "37881 Pisecne Slavetin"
  },
  {
    "cast": "Slavětín",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Slavětín",
    "val": "58263 Slavetin Slavetin"
  },
  {
    "cast": "Slavětín nad Metují",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Slavětín nad Metují",
    "val": "54901 Slavetin nad Metuji Slavetin nad Metuji"
  },
  {
    "cast": "Slavhostice",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Slavhostice",
    "val": "50732 Slavhostice Slavhostice"
  },
  {
    "cast": "Slaviboř",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Černíč",
    "val": "58856 Cernic Slavibor"
  },
  {
    "cast": "Slavice",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Slavice"
  },
  {
    "cast": "Slavice",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Licibořice",
    "val": "53821 Liciborice Slavice"
  },
  {
    "cast": "Slavice",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Horní Kozolupy",
    "val": "34901 Horni Kozolupy Slavice"
  },
  {
    "cast": "Slavičín",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Slavičín",
    "val": "76321 Slavicin Slavicin"
  },
  {
    "cast": "Slavičky",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Slavičky",
    "val": "67501 Slavicky Slavicky"
  },
  {
    "cast": "Slavíč-Hranice VII x)",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Slavic-Hranice VII x)"
  },
  {
    "cast": "Slavíkov",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Budětsko",
    "val": "79852 Budetsko Slavikov"
  },
  {
    "cast": "Slavíkov",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Vlastibořice",
    "val": "46344 Vlastiborice Slavikov"
  },
  {
    "cast": "Slavíkov",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Horní Radechová",
    "val": "54941 Horni Radechova Slavikov"
  },
  {
    "cast": "Slavíkov (část)",
    "psc": "58265",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58265 Slavikov Slavikov (cast)"
  },
  {
    "cast": "Slavíkov (část)",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58301 Slavikov Slavikov (cast)"
  },
  {
    "cast": "Slavíkovice",
    "psc": "34506",
    "okres": "Klatovy",
    "obec": "Černíkov",
    "val": "34506 Cernikov Slavikovice"
  },
  {
    "cast": "Slavíkovice",
    "psc": "67531",
    "okres": "Třebíč",
    "obec": "Slavíkovice",
    "val": "67531 Slavikovice Slavikovice"
  },
  {
    "cast": "Slavíkovice",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Rousínov",
    "val": "68301 Rousinov Slavikovice"
  },
  {
    "cast": "Slavíky",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Tmaň",
    "val": "26701 Tman Slaviky"
  },
  {
    "cast": "Slavín",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25703 Neustupov Slavin"
  },
  {
    "cast": "Slavkov",
    "psc": "74757",
    "okres": "Opava",
    "obec": "Slavkov",
    "val": "74757 Slavkov Slavkov"
  },
  {
    "cast": "Slavkov",
    "psc": "75131",
    "okres": "Olomouc",
    "obec": "Kozlov",
    "val": "75131 Kozlov Slavkov"
  },
  {
    "cast": "Slavkov",
    "psc": "68764",
    "okres": "Uherské Hradiště",
    "obec": "Slavkov",
    "val": "68764 Slavkov Slavkov"
  },
  {
    "cast": "Slavkov",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25753 Olbramovice Slavkov"
  },
  {
    "cast": "Slavkov",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Bohdalovice",
    "val": "38101 Bohdalovice Slavkov"
  },
  {
    "cast": "Slavkov pod Hostýnem",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Slavkov pod Hostýnem",
    "val": "76861 Slavkov pod Hostynem Slavkov pod Hostynem"
  },
  {
    "cast": "Slavkov u Brna",
    "psc": "68401",
    "okres": "Vyškov",
    "obec": "Slavkov u Brna",
    "val": "68401 Slavkov u Brna Slavkov u Brna"
  },
  {
    "cast": "Slavkovice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mišovice",
    "val": "39804 Misovice Slavkovice"
  },
  {
    "cast": "Slavkovice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Vyžice",
    "val": "53803 Vyzice Slavkovice"
  },
  {
    "cast": "Slavkovice",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Slavkovice"
  },
  {
    "cast": "Slavníč",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Slavníč",
    "val": "58255 Slavnic Slavnic"
  },
  {
    "cast": "Slavňovice",
    "psc": "39161",
    "okres": "Tábor",
    "obec": "Stádlec",
    "val": "39161 Stadlec Slavnovice"
  },
  {
    "cast": "Slavný",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Suchý Důl",
    "val": "54954 Suchy Dul Slavny"
  },
  {
    "cast": "Slavonice",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Slavonice",
    "val": "37881 Slavonice Slavonice"
  },
  {
    "cast": "Slavonín",
    "psc": "78301",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "78301 Olomouc Slavonin"
  },
  {
    "cast": "Slavoňov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Lukavice",
    "val": "78901 Lukavice Slavonov"
  },
  {
    "cast": "Slavoňov",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Slavoňov",
    "val": "54901 Slavonov Slavonov"
  },
  {
    "cast": "Slavošov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Slavošov",
    "val": "28522 Slavosov Slavosov"
  },
  {
    "cast": "Slavošov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Povrly",
    "val": "40002 Povrly Slavosov"
  },
  {
    "cast": "Slavošovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bolešiny",
    "val": "33901 Bolesiny Slavosovice"
  },
  {
    "cast": "Slavošovice",
    "psc": "37373",
    "okres": "České Budějovice",
    "obec": "Libín",
    "val": "37373 Libin Slavosovice"
  },
  {
    "cast": "Sledovice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25753 Vojkov Sledovice"
  },
  {
    "cast": "Slemeno",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Dolní Kalná",
    "val": "54371 Dolni Kalna Slemeno"
  },
  {
    "cast": "Slemeno",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Synkov-Slemeno",
    "val": "51601 Synkov-Slemeno Slemeno"
  },
  {
    "cast": "Slepotice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Slepotice",
    "val": "53002 Slepotice Slepotice"
  },
  {
    "cast": "Slezská Harta",
    "psc": "79368",
    "okres": "Bruntál",
    "obec": "Leskovec nad Moravicí",
    "val": "79368 Leskovec nad Moravici Slezska Harta"
  },
  {
    "cast": "Slezská Ostrava (část)",
    "psc": "71000",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71000 Ostrava Slezska Ostrava (cast)"
  },
  {
    "cast": "Slezská Ostrava (část)",
    "psc": "71300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71300 Ostrava Slezska Ostrava (cast)"
  },
  {
    "cast": "Slezská Ostrava (část)",
    "psc": "71500",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "71500 Ostrava Slezska Ostrava (cast)"
  },
  {
    "cast": "Slezské Pavlovice",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Slezské Pavlovice",
    "val": "79399 Slezske Pavlovice Slezske Pavlovice"
  },
  {
    "cast": "Slezské Předměstí",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Slezske Predmesti"
  },
  {
    "cast": "Slezské Rudoltice",
    "psc": "79397",
    "okres": "Bruntál",
    "obec": "Slezské Rudoltice",
    "val": "79397 Slezske Rudoltice Slezske Rudoltice"
  },
  {
    "cast": "Slezský Kočov",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Moravskoslezský Kočov",
    "val": "79201 Moravskoslezsky Kocov Slezsky Kocov"
  },
  {
    "cast": "Slibovice",
    "psc": "28908",
    "okres": "Nymburk",
    "obec": "Běrunice",
    "val": "28908 Berunice Slibovice"
  },
  {
    "cast": "Slivenec",
    "psc": "15400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15400 Praha Slivenec"
  },
  {
    "cast": "Slivínko",
    "psc": "29478",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Slivno",
    "val": "29478 Dolni Slivno Slivinko"
  },
  {
    "cast": "Slivonice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Velký Bor",
    "val": "34101 Velky Bor Slivonice"
  },
  {
    "cast": "Slížany",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Morkovice-Slížany",
    "val": "76833 Morkovice-Slizany Slizany"
  },
  {
    "cast": "Slopné",
    "psc": "76323",
    "okres": "Zlín",
    "obec": "Slopné",
    "val": "76323 Slopne Slopne"
  },
  {
    "cast": "Slotov (část)",
    "psc": "54443",
    "okres": "Náchod",
    "obec": "Heřmanice",
    "val": "54443 Hermanice Slotov (cast)"
  },
  {
    "cast": "Slotov (část)",
    "psc": "54401",
    "okres": "Náchod",
    "obec": "Heřmanice",
    "val": "54401 Hermanice Slotov (cast)"
  },
  {
    "cast": "Sloup",
    "psc": "25206",
    "okres": "Praha-západ",
    "obec": "Davle",
    "val": "25206 Davle Sloup"
  },
  {
    "cast": "Sloup",
    "psc": "67913",
    "okres": "Blansko",
    "obec": "Sloup",
    "val": "67913 Sloup Sloup"
  },
  {
    "cast": "Sloup v Čechách",
    "psc": "47152",
    "okres": "Česká Lípa",
    "obec": "Sloup v Čechách",
    "val": "47152 Sloup v Cechach Sloup v Cechach"
  },
  {
    "cast": "Sloupno",
    "psc": "50353",
    "okres": "Hradec Králové",
    "obec": "Sloupno",
    "val": "50353 Sloupno Sloupno"
  },
  {
    "cast": "Sloupno",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Sloupno",
    "val": "58301 Sloupno Sloupno"
  },
  {
    "cast": "Slovanská Lhota",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Drevníky",
    "val": "26301 Drevniky Slovanska Lhota"
  },
  {
    "cast": "Sloveč",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Sloveč",
    "val": "28903 Slovec Slovec"
  },
  {
    "cast": "Slověnice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Slověnice",
    "val": "25726 Slovenice Slovenice"
  },
  {
    "cast": "Slubice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Bohdalovice",
    "val": "38101 Bohdalovice Slubice"
  },
  {
    "cast": "Sluhov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Sluhov"
  },
  {
    "cast": "Sluhy",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Sluhy",
    "val": "25063 Sluhy Sluhy"
  },
  {
    "cast": "Sluková",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Valkeřice",
    "val": "40502 Valkerice Slukova"
  },
  {
    "cast": "Slunečná",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Želnava",
    "val": "38451 Zelnava Slunecna"
  },
  {
    "cast": "Slunečná",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Slunečná",
    "val": "47301 Slunecna Slunecna"
  },
  {
    "cast": "Slup",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Slup",
    "val": "67128 Slup Slup"
  },
  {
    "cast": "Slupečná",
    "psc": "38278",
    "okres": "Český Krumlov",
    "obec": "Lipno nad Vltavou",
    "val": "38278 Lipno nad Vltavou Slupecna"
  },
  {
    "cast": "Slupenec",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Slupenec"
  },
  {
    "cast": "Slupy",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Slapsko",
    "val": "39143 Slapsko Slupy"
  },
  {
    "cast": "Slušovice",
    "psc": "76315",
    "okres": "Zlín",
    "obec": "Slušovice",
    "val": "76315 Slusovice Slusovice"
  },
  {
    "cast": "Sluštice",
    "psc": "25084",
    "okres": "Praha-východ",
    "obec": "Sluštice",
    "val": "25084 Slustice Slustice"
  },
  {
    "cast": "Služátky",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Sluzatky"
  },
  {
    "cast": "Služátky",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Služátky",
    "val": "58291 Sluzatky Sluzatky"
  },
  {
    "cast": "Služetín",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Sluzetin"
  },
  {
    "cast": "Služetín",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Sluzetin"
  },
  {
    "cast": "Služín",
    "psc": "79841",
    "okres": "Prostějov",
    "obec": "Stařechovice",
    "val": "79841 Starechovice Sluzin"
  },
  {
    "cast": "Služovice",
    "psc": "74728",
    "okres": "Opava",
    "obec": "Služovice",
    "val": "74728 Sluzovice Sluzovice"
  },
  {
    "cast": "Smečno",
    "psc": "27305",
    "okres": "Kladno",
    "obec": "Smečno",
    "val": "27305 Smecno Smecno"
  },
  {
    "cast": "Smědčice",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Smědčice",
    "val": "33824 Smedcice Smedcice"
  },
  {
    "cast": "Smědeč",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38301 Ktis Smedec"
  },
  {
    "cast": "Smědeček",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38301 Ktis Smedecek"
  },
  {
    "cast": "Smederov",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Ždírec",
    "val": "33601 Zdirec Smederov"
  },
  {
    "cast": "Smetana",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Plchovice",
    "val": "56501 Plchovice Smetana"
  },
  {
    "cast": "Smetanova Lhota (část)",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Smetanova Lhota",
    "val": "39701 Smetanova Lhota Smetanova Lhota (cast)"
  },
  {
    "cast": "Smetanova Lhota (část)",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Smetanova Lhota",
    "val": "39804 Smetanova Lhota Smetanova Lhota (cast)"
  },
  {
    "cast": "Smidarská Lhota",
    "psc": "50353",
    "okres": "Hradec Králové",
    "obec": "Vinary",
    "val": "50353 Vinary Smidarska Lhota"
  },
  {
    "cast": "Smidary",
    "psc": "50353",
    "okres": "Hradec Králové",
    "obec": "Smidary",
    "val": "50353 Smidary Smidary"
  },
  {
    "cast": "Smíchov (část)",
    "psc": "15000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15000 Praha Smichov (cast)"
  },
  {
    "cast": "Smíchov (část)",
    "psc": "15800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15800 Praha Smichov (cast)"
  },
  {
    "cast": "Smilkov",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Smilkov",
    "val": "25789 Smilkov Smilkov"
  },
  {
    "cast": "Smilov",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Smilov"
  },
  {
    "cast": "Smilov",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Štoky",
    "val": "58253 Stoky Smilov"
  },
  {
    "cast": "Smilov (část)",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Smilov (cast)"
  },
  {
    "cast": "Smilov (část)",
    "psc": "43151",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "43151 Straz nad Ohri Smilov (cast)"
  },
  {
    "cast": "Smilovice",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Smilovice"
  },
  {
    "cast": "Smilovice",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Smilovice",
    "val": "27054 Smilovice Smilovice"
  },
  {
    "cast": "Smilovice",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Smilovice",
    "val": "29442 Smilovice Smilovice"
  },
  {
    "cast": "Smilovice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Staňkovice",
    "val": "28504 Stankovice Smilovice"
  },
  {
    "cast": "Smilovice",
    "psc": "73955",
    "okres": "Frýdek-Místek",
    "obec": "Smilovice",
    "val": "73955 Smilovice Smilovice"
  },
  {
    "cast": "Smilovice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Žimutice",
    "val": "37501 Zimutice Smilovice"
  },
  {
    "cast": "Smilovy Hory",
    "psc": "39152",
    "okres": "Tábor",
    "obec": "Smilovy Hory",
    "val": "39152 Smilovy Hory Smilovy Hory"
  },
  {
    "cast": "Smiradice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Sousedovice",
    "val": "38601 Sousedovice Smiradice"
  },
  {
    "cast": "Smiřice",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Smiřice",
    "val": "50303 Smirice Smirice"
  },
  {
    "cast": "Smolín",
    "psc": "69123",
    "okres": "Brno-venkov",
    "obec": "Pohořelice",
    "val": "69123 Pohorelice Smolin"
  },
  {
    "cast": "Smolina",
    "psc": "76601",
    "okres": "Zlín",
    "obec": "Valašské Klobouky",
    "val": "76601 Valasske Klobouky Smolina"
  },
  {
    "cast": "Smolkov",
    "psc": "74792",
    "okres": "Opava",
    "obec": "Háj ve Slezsku",
    "val": "74792 Haj ve Slezsku Smolkov"
  },
  {
    "cast": "Smolná",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Rotava",
    "val": "35801 Rotava Smolna"
  },
  {
    "cast": "Smolná",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Bělá u Jevíčka",
    "val": "56943 Bela u Jevicka Smolna"
  },
  {
    "cast": "Smolné Pece",
    "psc": "36225",
    "okres": "Karlovy Vary",
    "obec": "Smolné Pece",
    "val": "36225 Smolne Pece Smolne Pece"
  },
  {
    "cast": "Smolnice",
    "psc": "43914",
    "okres": "Louny",
    "obec": "Smolnice",
    "val": "43914 Smolnice Smolnice"
  },
  {
    "cast": "Smolotely",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Smolotely",
    "val": "26263 Smolotely Smolotely"
  },
  {
    "cast": "Smolov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Mrákov",
    "val": "34401 Mrakov Smolov"
  },
  {
    "cast": "Smolov",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Smolov"
  },
  {
    "cast": "Smrček",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Smrček",
    "val": "53851 Smrcek Smrcek"
  },
  {
    "cast": "Smrček",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Býšovec",
    "val": "59262 Bysovec Smrcek"
  },
  {
    "cast": "Smrčensko",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Dolní Město",
    "val": "58291 Dolni Mesto Smrcensko"
  },
  {
    "cast": "Smrčí",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Záhoří",
    "val": "51301 Zahori Smrci"
  },
  {
    "cast": "Smrčí",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Smrci"
  },
  {
    "cast": "Smrčina",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Plesná",
    "val": "35134 Plesna Smrcina"
  },
  {
    "cast": "Smrčná",
    "psc": "58801",
    "okres": "Jihlava",
    "obec": "Smrčná",
    "val": "58801 Smrcna Smrcna"
  },
  {
    "cast": "Smrčná",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Trpišovice",
    "val": "58291 Trpisovice Smrcna"
  },
  {
    "cast": "Smrčná",
    "psc": "37833",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Bystřice",
    "val": "37833 Nova Bystrice Smrcna"
  },
  {
    "cast": "Smrčná (část)",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Svatá Maří",
    "val": "38481 Svata Mari Smrcna (cast)"
  },
  {
    "cast": "Smrčná (část)",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Svatá Maří",
    "val": "38501 Svata Mari Smrcna (cast)"
  },
  {
    "cast": "Smrhov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Soběnov",
    "val": "38241 Sobenov Smrhov"
  },
  {
    "cast": "Smrk",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Smrk",
    "val": "67501 Smrk Smrk"
  },
  {
    "cast": "Smrk",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Čistá",
    "val": "27034 Cista Smrk"
  },
  {
    "cast": "Smrk",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28504 Uzice Smrk"
  },
  {
    "cast": "Smrkov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Smrkov"
  },
  {
    "cast": "Smrkovec",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Hradešice",
    "val": "34101 Hradesice Smrkovec"
  },
  {
    "cast": "Smrkovice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Smrkovice"
  },
  {
    "cast": "Smrkový Týnec",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Rabštejnská Lhota",
    "val": "53821 Rabstejnska Lhota Smrkovy Tynec"
  },
  {
    "cast": "Smržice",
    "psc": "79817",
    "okres": "Prostějov",
    "obec": "Smržice",
    "val": "79817 Smrzice Smrzice"
  },
  {
    "cast": "Smržov",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Smrzov"
  },
  {
    "cast": "Smržov",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Smržov",
    "val": "50303 Smrzov Smrzov"
  },
  {
    "cast": "Smržov",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Smržov",
    "val": "37901 Smrzov Smrzov"
  },
  {
    "cast": "Smržovice",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Smrzovice"
  },
  {
    "cast": "Smržovka",
    "psc": "46851",
    "okres": "Jablonec nad Nisou",
    "obec": "Smržovka",
    "val": "46851 Smrzovka Smrzovka"
  },
  {
    "cast": "Smyslov",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39002 Tabor Smyslov"
  },
  {
    "cast": "Snědovice",
    "psc": "41174",
    "okres": "Litoměřice",
    "obec": "Snědovice",
    "val": "41174 Snedovice Snedovice"
  },
  {
    "cast": "Sněhotice",
    "psc": "79807",
    "okres": "Prostějov",
    "obec": "Brodek u Prostějova",
    "val": "79807 Brodek u Prostejova Snehotice"
  },
  {
    "cast": "Sněhov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Snehov"
  },
  {
    "cast": "Snět",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Snět",
    "val": "25768 Snet Snet"
  },
  {
    "cast": "Sněžná",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Snezna"
  },
  {
    "cast": "Sněžná",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40747 Krasna Lipa Snezna"
  },
  {
    "cast": "Sněžné",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Sněžné",
    "val": "59203 Snezne Snezne"
  },
  {
    "cast": "Sněžné",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Sněžné",
    "val": "51801 Snezne Snezne"
  },
  {
    "cast": "Sněžník",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Jílové",
    "val": "40502 Jilove Sneznik"
  },
  {
    "cast": "Snopoušovy",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Dolní Lukavice",
    "val": "33401 Dolni Lukavice Snopousovy"
  },
  {
    "cast": "Snovídky",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Snovídky",
    "val": "68333 Snovidky Snovidky"
  },
  {
    "cast": "Sobáčov",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Mladeč",
    "val": "78321 Mladec Sobacov"
  },
  {
    "cast": "Sobákov",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Sobakov"
  },
  {
    "cast": "Sobčice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Sobčice",
    "val": "50801 Sobcice Sobcice"
  },
  {
    "cast": "Sobědraž",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kostelec nad Vltavou",
    "val": "39901 Kostelec nad Vltavou Sobedraz"
  },
  {
    "cast": "Sobědruhy (část)",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41501 Teplice Sobedruhy (cast)"
  },
  {
    "cast": "Sobědruhy (část)",
    "psc": "41510",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41510 Teplice Sobedruhy (cast)"
  },
  {
    "cast": "Soběhrdy",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Soběhrdy",
    "val": "25601 Sobehrdy Sobehrdy"
  },
  {
    "cast": "Soběchleby",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Blšany",
    "val": "43801 Blsany Sobechleby"
  },
  {
    "cast": "Soběchleby",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Sobechleby"
  },
  {
    "cast": "Soběchleby",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Soběchleby",
    "val": "75354 Sobechleby Sobechleby"
  },
  {
    "cast": "Soběkury",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Soběkury",
    "val": "33401 Sobekury Sobekury"
  },
  {
    "cast": "Sobělice",
    "psc": "76812",
    "okres": "Kroměříž",
    "obec": "Rataje",
    "val": "76812 Rataje Sobelice"
  },
  {
    "cast": "Soběnice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41145 Libesice Sobenice"
  },
  {
    "cast": "Soběnov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Soběnov",
    "val": "38241 Sobenov Sobenov"
  },
  {
    "cast": "Soběraz",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Soběraz",
    "val": "50713 Soberaz Soberaz"
  },
  {
    "cast": "Soběslav I",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Soběslav",
    "val": "39201 Sobeslav Sobeslav I"
  },
  {
    "cast": "Soběslav II",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Soběslav",
    "val": "39201 Sobeslav Sobeslav II"
  },
  {
    "cast": "Soběslav III",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Soběslav",
    "val": "39201 Sobeslav Sobeslav III"
  },
  {
    "cast": "Soběslavice",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Soběslavice",
    "val": "46345 Sobeslavice Sobeslavice"
  },
  {
    "cast": "Soběsuky",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43801 Chbany Sobesuky"
  },
  {
    "cast": "Soběsuky",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Soběsuky",
    "val": "76802 Sobesuky Sobesuky"
  },
  {
    "cast": "Soběsuky",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Plumlov",
    "val": "79803 Plumlov Sobesuky"
  },
  {
    "cast": "Soběsuky",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Neurazy",
    "val": "33501 Neurazy Sobesuky"
  },
  {
    "cast": "Soběšice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Sobesice"
  },
  {
    "cast": "Soběšice",
    "psc": "64400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64400 Brno Sobesice"
  },
  {
    "cast": "Soběšice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Soběšice",
    "val": "34201 Sobesice Sobesice"
  },
  {
    "cast": "Soběšín (část)",
    "psc": "28509",
    "okres": "Kutná Hora",
    "obec": "Soběšín",
    "val": "28509 Sobesin Sobesin (cast)"
  },
  {
    "cast": "Soběšín (část)",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Soběšín",
    "val": "28506 Sobesin Sobesin (cast)"
  },
  {
    "cast": "Soběšovice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Chrášťany",
    "val": "25744 Chrastany Sobesovice"
  },
  {
    "cast": "Soběšovice",
    "psc": "73938",
    "okres": "Frýdek-Místek",
    "obec": "Soběšovice",
    "val": "73938 Sobesovice Sobesovice"
  },
  {
    "cast": "Sobětice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Sobetice"
  },
  {
    "cast": "Sobětice",
    "psc": "43183",
    "okres": "Chomutov",
    "obec": "Výsluní",
    "val": "43183 Vysluni Sobetice"
  },
  {
    "cast": "Sobětice",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Žimutice",
    "val": "37365 Zimutice Sobetice"
  },
  {
    "cast": "Sobětuchy",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Sobětuchy",
    "val": "53701 Sobetuchy Sobetuchy"
  },
  {
    "cast": "Sobětuchy",
    "psc": "29474",
    "okres": "Mladá Boleslav",
    "obec": "Tuřice",
    "val": "29474 Turice Sobetuchy"
  },
  {
    "cast": "Sobětuš",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Nechanice",
    "val": "50315 Nechanice Sobetus"
  },
  {
    "cast": "Sobín (část)",
    "psc": "15500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15500 Praha Sobin (cast)"
  },
  {
    "cast": "Sobín (část)",
    "psc": "15521",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15521 Praha Sobin (cast)"
  },
  {
    "cast": "Sobíňov (část)",
    "psc": "58262",
    "okres": "Havlíčkův Brod",
    "obec": "Sobíňov",
    "val": "58262 Sobinov Sobinov (cast)"
  },
  {
    "cast": "Sobíňov (část)",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Sobíňov",
    "val": "58263 Sobinov Sobinov (cast)"
  },
  {
    "cast": "Sobíšky",
    "psc": "75121",
    "okres": "Přerov",
    "obec": "Sobíšky",
    "val": "75121 Sobisky Sobisky"
  },
  {
    "cast": "Sobkovice",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Sobkovice",
    "val": "56164 Sobkovice Sobkovice"
  },
  {
    "cast": "Sobočice",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Zásmuky",
    "val": "28144 Zasmuky Sobocice"
  },
  {
    "cast": "Sobotice",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Sobotice"
  },
  {
    "cast": "Sobotín",
    "psc": "78816",
    "okres": "Šumperk",
    "obec": "Sobotín",
    "val": "78816 Sobotin Sobotin"
  },
  {
    "cast": "Sobotka",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Sobotka"
  },
  {
    "cast": "Sobotovice",
    "psc": "66467",
    "okres": "Brno-venkov",
    "obec": "Sobotovice",
    "val": "66467 Sobotovice Sobotovice"
  },
  {
    "cast": "Sobůlky",
    "psc": "69701",
    "okres": "Hodonín",
    "obec": "Sobůlky",
    "val": "69701 Sobulky Sobulky"
  },
  {
    "cast": "Sochovice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Sochovice"
  },
  {
    "cast": "Sojovice",
    "psc": "29475",
    "okres": "Mladá Boleslav",
    "obec": "Sojovice",
    "val": "29475 Sojovice Sojovice"
  },
  {
    "cast": "Sokoleč",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Sokoleč",
    "val": "29001 Sokolec Sokolec"
  },
  {
    "cast": "Sokolí",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Sokoli"
  },
  {
    "cast": "Sokolíčko",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Stonařov",
    "val": "58833 Stonarov Sokolicko"
  },
  {
    "cast": "Sokolnice",
    "psc": "66452",
    "okres": "Brno-venkov",
    "obec": "Sokolnice",
    "val": "66452 Sokolnice Sokolnice"
  },
  {
    "cast": "Sokolov",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Sokolov",
    "val": "35601 Sokolov Sokolov"
  },
  {
    "cast": "Solanec pod Soláněm",
    "psc": "75662",
    "okres": "Vsetín",
    "obec": "Hutisko-Solanec",
    "val": "75662 Hutisko-Solanec Solanec pod Solanem"
  },
  {
    "cast": "Solany",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Děčany",
    "val": "41115 Decany Solany"
  },
  {
    "cast": "Solec",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Solec"
  },
  {
    "cast": "Soleček",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Solecek"
  },
  {
    "cast": "Solenice",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Solenice",
    "val": "26263 Solenice Solenice"
  },
  {
    "cast": "Solná Lhota",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Solna Lhota"
  },
  {
    "cast": "Solnice (část)",
    "psc": "51701",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Solnice",
    "val": "51701 Solnice Solnice (cast)"
  },
  {
    "cast": "Solnice (část)",
    "psc": "51702",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Solnice",
    "val": "51702 Solnice Solnice (cast)"
  },
  {
    "cast": "Solopisky",
    "psc": "25228",
    "okres": "Praha-západ",
    "obec": "Třebotov",
    "val": "25228 Trebotov Solopisky"
  },
  {
    "cast": "Solopysky",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Domoušice",
    "val": "44001 Domousice Solopysky"
  },
  {
    "cast": "Solopysky",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Solopysky"
  },
  {
    "cast": "Solopysky",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Suchdol",
    "val": "28401 Suchdol Solopysky"
  },
  {
    "cast": "Sopotnice",
    "psc": "56115",
    "okres": "Ústí nad Orlicí",
    "obec": "Sopotnice",
    "val": "56115 Sopotnice Sopotnice"
  },
  {
    "cast": "Sopřeč",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Sopřeč",
    "val": "53316 Soprec Soprec"
  },
  {
    "cast": "Soseň",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Jesenice",
    "val": "27033 Jesenice Sosen"
  },
  {
    "cast": "Sosnová",
    "psc": "79312",
    "okres": "Opava",
    "obec": "Sosnová",
    "val": "79312 Sosnova Sosnova"
  },
  {
    "cast": "Sosnová",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Sosnová",
    "val": "47001 Sosnova Sosnova"
  },
  {
    "cast": "Souboř",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Ledeč nad Sázavou",
    "val": "58401 Ledec nad Sazavou Soubor"
  },
  {
    "cast": "Soudná",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Soudna"
  },
  {
    "cast": "Souměř",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Soumer"
  },
  {
    "cast": "Souňov",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Souňov",
    "val": "28601 Sounov Sounov"
  },
  {
    "cast": "Sousedovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Sousedovice",
    "val": "38601 Sousedovice Sousedovice"
  },
  {
    "cast": "Soustov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dlažov",
    "val": "33901 Dlazov Soustov"
  },
  {
    "cast": "Souš (část)",
    "psc": "43401",
    "okres": "Most",
    "obec": "Most",
    "val": "43401 Most Sous (cast)"
  },
  {
    "cast": "Souš (část)",
    "psc": "43502",
    "okres": "Most",
    "obec": "Most",
    "val": "43502 Most Sous (cast)"
  },
  {
    "cast": "Soušice",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Tichonice",
    "val": "25763 Tichonice Sousice"
  },
  {
    "cast": "Soutěsky",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malá Veleň",
    "val": "40502 Mala Velen Soutesky"
  },
  {
    "cast": "Soutice",
    "psc": "25771",
    "okres": "Benešov",
    "obec": "Soutice",
    "val": "25771 Soutice Soutice"
  },
  {
    "cast": "Souvrať",
    "psc": "54475",
    "okres": "Trutnov",
    "obec": "Mostek",
    "val": "54475 Mostek Souvrat"
  },
  {
    "cast": "Sovadina",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Bystřice pod Hostýnem",
    "val": "76861 Bystrice pod Hostynem Sovadina"
  },
  {
    "cast": "Sovenice",
    "psc": "28933",
    "okres": "Nymburk",
    "obec": "Křinec",
    "val": "28933 Krinec Sovenice"
  },
  {
    "cast": "Sovenice",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Chocnějovice",
    "val": "29413 Chocnejovice Sovenice"
  },
  {
    "cast": "Sovětice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Sovětice",
    "val": "50315 Sovetice Sovetice"
  },
  {
    "cast": "Sovinec (část)",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Jiříkov",
    "val": "79351 Jirikov Sovinec (cast)"
  },
  {
    "cast": "Sovinec (část)",
    "psc": "78386",
    "okres": "Bruntál",
    "obec": "Jiříkov",
    "val": "78386 Jirikov Sovinec (cast)"
  },
  {
    "cast": "Sovínky",
    "psc": "29429",
    "okres": "Mladá Boleslav",
    "obec": "Sovínky",
    "val": "29429 Sovinky Sovinky"
  },
  {
    "cast": "Sovoluská Lhota",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Lipoltice",
    "val": "53501 Lipoltice Sovoluska Lhota"
  },
  {
    "cast": "Sovolusky",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Košík",
    "val": "28934 Kosik Sovolusky"
  },
  {
    "cast": "Sovolusky",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Sovolusky"
  },
  {
    "cast": "Sovolusky",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Sovolusky",
    "val": "53501 Sovolusky Sovolusky"
  },
  {
    "cast": "Spačice",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Běstvina",
    "val": "53843 Bestvina Spacice"
  },
  {
    "cast": "Spálava",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Libice nad Doubravou",
    "val": "58301 Libice nad Doubravou Spalava"
  },
  {
    "cast": "Spálená",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Nový Kostel",
    "val": "35134 Novy Kostel Spalena"
  },
  {
    "cast": "Spálené",
    "psc": "79371",
    "okres": "Bruntál",
    "obec": "Holčovice",
    "val": "79371 Holcovice Spalene"
  },
  {
    "cast": "Spálené Poříčí",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Spalene Porici"
  },
  {
    "cast": "Spálenec",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Zbytiny",
    "val": "38301 Zbytiny Spalenec"
  },
  {
    "cast": "Spáleneček",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Česká Kubice",
    "val": "34401 Ceska Kubice Spalenecek"
  },
  {
    "cast": "Spáleniště",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobruška",
    "val": "51801 Dobruska Spaleniste"
  },
  {
    "cast": "Spálov",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Semily",
    "val": "51301 Semily Spalov"
  },
  {
    "cast": "Spálov",
    "psc": "74237",
    "okres": "Nový Jičín",
    "obec": "Spálov",
    "val": "74237 Spalov Spalov"
  },
  {
    "cast": "Spankov",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Líté",
    "val": "33152 Lite Spankov"
  },
  {
    "cast": "Spáňov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Spáňov",
    "val": "34401 Spanov Spanov"
  },
  {
    "cast": "Spařence",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Markvartice",
    "val": "50743 Markvartice Sparence"
  },
  {
    "cast": "Spělkov",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Spělkov",
    "val": "59203 Spelkov Spelkov"
  },
  {
    "cast": "Spělov",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Dolní Cerekev",
    "val": "58851 Dolni Cerekev Spelov"
  },
  {
    "cast": "Speřice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Jiřice",
    "val": "39601 Jirice Sperice"
  },
  {
    "cast": "Spešov",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Spešov",
    "val": "67902 Spesov Spesov"
  },
  {
    "cast": "Spikaly",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Katusice",
    "val": "29425 Katusice Spikaly"
  },
  {
    "cast": "Splzov",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Splzov"
  },
  {
    "cast": "Splž",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Splz"
  },
  {
    "cast": "Spojil",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Spojil",
    "val": "53002 Spojil Spojil"
  },
  {
    "cast": "Spolí",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Spoli"
  },
  {
    "cast": "Spolí",
    "psc": "37901",
    "okres": "České Budějovice",
    "obec": "Libín",
    "val": "37901 Libin Spoli"
  },
  {
    "cast": "Spolí",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přídolí",
    "val": "38101 Pridoli Spoli"
  },
  {
    "cast": "Spomyšl",
    "psc": "27705",
    "okres": "Mělník",
    "obec": "Spomyšl",
    "val": "27705 Spomysl Spomysl"
  },
  {
    "cast": "Spořice (část)",
    "psc": "43101",
    "okres": "Chomutov",
    "obec": "Spořice",
    "val": "43101 Sporice Sporice (cast)"
  },
  {
    "cast": "Spořice (část)",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Spořice",
    "val": "43001 Sporice Sporice (cast)"
  },
  {
    "cast": "Spůle",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Čkyně",
    "val": "38481 Ckyne Spule"
  },
  {
    "cast": "Spůle",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Spule"
  },
  {
    "cast": "Spy",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nové Město nad Metují",
    "val": "54901 Nove Mesto nad Metuji Spy"
  },
  {
    "cast": "Spyšova",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Spysova"
  },
  {
    "cast": "Spyta",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Česká Skalice",
    "val": "55203 Ceska Skalice Spyta"
  },
  {
    "cast": "Spytice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Spytice"
  },
  {
    "cast": "Spytihněv (část)",
    "psc": "76361",
    "okres": "Zlín",
    "obec": "Spytihněv",
    "val": "76361 Spytihnev Spytihnev (cast)"
  },
  {
    "cast": "Spytihněv (část)",
    "psc": "76364",
    "okres": "Zlín",
    "obec": "Spytihněv",
    "val": "76364 Spytihnev Spytihnev (cast)"
  },
  {
    "cast": "Spytovice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Zdechovice",
    "val": "53501 Zdechovice Spytovice"
  },
  {
    "cast": "Srbce",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Srbce"
  },
  {
    "cast": "Srbce",
    "psc": "28904",
    "okres": "Nymburk",
    "obec": "Okřínek",
    "val": "28904 Okrinek Srbce"
  },
  {
    "cast": "Srbce",
    "psc": "79827",
    "okres": "Prostějov",
    "obec": "Srbce",
    "val": "79827 Srbce Srbce"
  },
  {
    "cast": "Srbeč",
    "psc": "27065",
    "okres": "Rakovník",
    "obec": "Srbeč",
    "val": "27065 Srbec Srbec"
  },
  {
    "cast": "Srbice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Srbice"
  },
  {
    "cast": "Srbice",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Srbice",
    "val": "34543 Srbice Srbice"
  },
  {
    "cast": "Srbice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Srbice",
    "val": "41501 Srbice Srbice"
  },
  {
    "cast": "Srbice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Srbice"
  },
  {
    "cast": "Srbín",
    "psc": "25162",
    "okres": "Praha-východ",
    "obec": "Mukařov",
    "val": "25162 Mukarov Srbin"
  },
  {
    "cast": "Srbská",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Horní Řasnice",
    "val": "46401 Horni Rasnice Srbska"
  },
  {
    "cast": "Srbská Kamenice",
    "psc": "40715",
    "okres": "Děčín",
    "obec": "Srbská Kamenice",
    "val": "40715 Srbska Kamenice Srbska Kamenice"
  },
  {
    "cast": "Srbsko",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Srbsko",
    "val": "26718 Srbsko Srbsko"
  },
  {
    "cast": "Srbsko",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Srbsko"
  },
  {
    "cast": "Srby",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Srby",
    "val": "33501 Srby Srby"
  },
  {
    "cast": "Srby",
    "psc": "27302",
    "okres": "Kladno",
    "obec": "Tuchlovice",
    "val": "27302 Tuchlovice Srby"
  },
  {
    "cast": "Srby",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Srby",
    "val": "34601 Srby Srby"
  },
  {
    "cast": "Srdov",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41145 Libesice Srdov"
  },
  {
    "cast": "Srch",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Srch",
    "val": "53352 Srch Srch"
  },
  {
    "cast": "Srlín",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Srlin"
  },
  {
    "cast": "Srní",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Srní",
    "val": "34192 Srni Srni"
  },
  {
    "cast": "Srní",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Hlinsko",
    "val": "53901 Hlinsko Srni"
  },
  {
    "cast": "Srní",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Srni"
  },
  {
    "cast": "Srní Potok",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Mimoň",
    "val": "47124 Mimon Srni Potok"
  },
  {
    "cast": "Srní u České Lípy",
    "psc": "47167",
    "okres": "Česká Lípa",
    "obec": "Provodín",
    "val": "47167 Provodin Srni u Ceske Lipy"
  },
  {
    "cast": "Srnín",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Srnín",
    "val": "38101 Srnin Srnin"
  },
  {
    "cast": "Srnojedy",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Srnojedy",
    "val": "53002 Srnojedy Srnojedy"
  },
  {
    "cast": "Srubec (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Srubec",
    "val": "37006 Srubec Srubec (cast)"
  },
  {
    "cast": "Srubec (část)",
    "psc": "37316",
    "okres": "České Budějovice",
    "obec": "Srubec",
    "val": "37316 Srubec Srubec (cast)"
  },
  {
    "cast": "Sruby",
    "psc": "56544",
    "okres": "Ústí nad Orlicí",
    "obec": "Sruby",
    "val": "56544 Sruby Sruby"
  },
  {
    "cast": "Stadice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Řehlovice",
    "val": "40002 Rehlovice Stadice"
  },
  {
    "cast": "Stádla",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Stadla"
  },
  {
    "cast": "Stádlec",
    "psc": "39162",
    "okres": "Tábor",
    "obec": "Stádlec",
    "val": "39162 Stadlec Stadlec"
  },
  {
    "cast": "Stachov",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Blšany",
    "val": "43801 Blsany Stachov"
  },
  {
    "cast": "Stachovice",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Stachovice"
  },
  {
    "cast": "Stachy",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Stachy",
    "val": "38473 Stachy Stachy"
  },
  {
    "cast": "Stáj",
    "psc": "58827",
    "okres": "Jihlava",
    "obec": "Stáj",
    "val": "58827 Staj Staj"
  },
  {
    "cast": "Stajiště",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Pavlov",
    "val": "58901 Pavlov Stajiste"
  },
  {
    "cast": "Stajka",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Hatín",
    "val": "37701 Hatin Stajka"
  },
  {
    "cast": "Stálkov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Slavonice",
    "val": "37881 Slavonice Stalkov"
  },
  {
    "cast": "Stálky",
    "psc": "67106",
    "okres": "Znojmo",
    "obec": "Stálky",
    "val": "67106 Stalky Stalky"
  },
  {
    "cast": "Staměřice",
    "psc": "75125",
    "okres": "Přerov",
    "obec": "Dolní Újezd",
    "val": "75125 Dolni Ujezd Stamerice"
  },
  {
    "cast": "Stan",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Lestkov",
    "val": "34953 Lestkov Stan"
  },
  {
    "cast": "Stan",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vítanov",
    "val": "53901 Vitanov Stan"
  },
  {
    "cast": "Stanětice",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Zahořany",
    "val": "34506 Zahorany Stanetice"
  },
  {
    "cast": "Staniměřice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Stanimerice"
  },
  {
    "cast": "Stanislavice",
    "psc": "73562",
    "okres": "Karviná",
    "obec": "Český Těšín",
    "val": "73562 Cesky Tesin Stanislavice"
  },
  {
    "cast": "Staňkov",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Pecka",
    "val": "50782 Pecka Stankov"
  },
  {
    "cast": "Staňkov",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Staňkov",
    "val": "37806 Stankov Stankov"
  },
  {
    "cast": "Staňkov I",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Staňkov",
    "val": "34561 Stankov Stankov I"
  },
  {
    "cast": "Staňkov II",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Staňkov",
    "val": "34561 Stankov Stankov II"
  },
  {
    "cast": "Staňkova Lhota",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Stankova Lhota"
  },
  {
    "cast": "Staňkovice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Staňkovice",
    "val": "41201 Stankovice Stankovice"
  },
  {
    "cast": "Staňkovice",
    "psc": "43949",
    "okres": "Louny",
    "obec": "Staňkovice",
    "val": "43949 Stankovice Stankovice"
  },
  {
    "cast": "Staňkovice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Staňkovice",
    "val": "28504 Stankovice Stankovice"
  },
  {
    "cast": "Stanovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nová Cerekev",
    "val": "39301 Nova Cerekev Stanovice"
  },
  {
    "cast": "Stanovice",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Stanovice",
    "val": "36001 Stanovice Stanovice"
  },
  {
    "cast": "Stanovice",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Stanovice",
    "val": "54401 Stanovice Stanovice"
  },
  {
    "cast": "Stanoviště",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mariánské Lázně",
    "val": "35301 Marianske Lazne Stanoviste"
  },
  {
    "cast": "Stanoviště",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Stanoviště",
    "val": "66484 Stanoviste Stanoviste"
  },
  {
    "cast": "Stanovník",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Těchonín",
    "val": "56164 Techonin Stanovnik"
  },
  {
    "cast": "Stanový",
    "psc": "46847",
    "okres": "Jablonec nad Nisou",
    "obec": "Zlatá Olešnice",
    "val": "46847 Zlata Olesnice Stanovy"
  },
  {
    "cast": "Stará Bělá",
    "psc": "72400",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72400 Ostrava Stara Bela"
  },
  {
    "cast": "Stará Bohyně",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Malšovice",
    "val": "40502 Malsovice Stara Bohyne"
  },
  {
    "cast": "Stará Boleslav",
    "psc": "25001",
    "okres": "Praha-východ",
    "obec": "Brandýs nad Labem-Stará Boleslav",
    "val": "25001 Brandys nad Labem-Stara Boleslav Stara Boleslav"
  },
  {
    "cast": "Stará Červená Voda",
    "psc": "79053",
    "okres": "Jeseník",
    "obec": "Stará Červená Voda",
    "val": "79053 Stara Cervena Voda Stara Cervena Voda"
  },
  {
    "cast": "Stará Dobev",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dobev",
    "val": "39701 Dobev Stara Dobev"
  },
  {
    "cast": "Stará Hlína",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Třeboň",
    "val": "37901 Trebon Stara Hlina"
  },
  {
    "cast": "Stará Huť",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Stara Hut"
  },
  {
    "cast": "Stará Huť",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Nemanice",
    "val": "34401 Nemanice Stara Hut"
  },
  {
    "cast": "Stará Huť",
    "psc": "26202",
    "okres": "Příbram",
    "obec": "Stará Huť",
    "val": "26202 Stara Hut Stara Hut"
  },
  {
    "cast": "Stará Huť",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Petrovice II",
    "val": "28504 Petrovice II Stara Hut"
  },
  {
    "cast": "Stará Chodovská",
    "psc": "35735",
    "okres": "Sokolov",
    "obec": "Chodov",
    "val": "35735 Chodov Stara Chodovska"
  },
  {
    "cast": "Stará Knížecí Huť",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Lesná",
    "val": "34701 Lesna Stara Knizeci Hut"
  },
  {
    "cast": "Stará Lhota",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Nýrsko",
    "val": "34022 Nyrsko Stara Lhota"
  },
  {
    "cast": "Stará Libavá",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Norberčany",
    "val": "79305 Norbercany Stara Libava"
  },
  {
    "cast": "Stará Lípa (část)",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Stara Lipa (cast)"
  },
  {
    "cast": "Stará Lípa (část)",
    "psc": "47006",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47006 Ceska Lipa Stara Lipa (cast)"
  },
  {
    "cast": "Stará Lysá",
    "psc": "28926",
    "okres": "Nymburk",
    "obec": "Stará Lysá",
    "val": "28926 Stara Lysa Stara Lysa"
  },
  {
    "cast": "Stará Oleška",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Huntířov",
    "val": "40502 Huntirov Stara Oleska"
  },
  {
    "cast": "Stará Paka (část)",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Stará Paka",
    "val": "50901 Stara Paka Stara Paka (cast)"
  },
  {
    "cast": "Stará Paka (část)",
    "psc": "50791",
    "okres": "Jičín",
    "obec": "Stará Paka",
    "val": "50791 Stara Paka Stara Paka (cast)"
  },
  {
    "cast": "Stará Pasečnice",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Pasečnice",
    "val": "34401 Pasecnice Stara Pasecnice"
  },
  {
    "cast": "Stará Pohůrka",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Srubec",
    "val": "37006 Srubec Stara Pohurka"
  },
  {
    "cast": "Stará Role",
    "psc": "36017",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36017 Karlovy Vary Stara Role"
  },
  {
    "cast": "Stará Roveň",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Městečko Trnávka",
    "val": "57101 Mestecko Trnavka Stara Roven"
  },
  {
    "cast": "Stará Rudná",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Rudná pod Pradědem",
    "val": "79331 Rudna pod Pradedem Stara Rudna"
  },
  {
    "cast": "Stará Říše",
    "psc": "58867",
    "okres": "Jihlava",
    "obec": "Stará Říše",
    "val": "58867 Stara Rise Stara Rise"
  },
  {
    "cast": "Stará Skřeněř",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Nový Bydžov",
    "val": "50401 Novy Bydzov Stara Skrener"
  },
  {
    "cast": "Stará Ves",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Stará Ves",
    "val": "75002 Stara Ves Stara Ves"
  },
  {
    "cast": "Stará Ves",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Stará Ves",
    "val": "79501 Stara Ves Stara Ves"
  },
  {
    "cast": "Stará Ves",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Bílovec",
    "val": "74301 Bilovec Stara Ves"
  },
  {
    "cast": "Stará Ves",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Vysoké nad Jizerou",
    "val": "51301 Vysoke nad Jizerou Stara Ves"
  },
  {
    "cast": "Stará Ves (část)",
    "psc": "73924",
    "okres": "Ostrava-město",
    "obec": "Stará Ves nad Ondřejnicí",
    "val": "73924 Stara Ves nad Ondrejnici Stara Ves (cast)"
  },
  {
    "cast": "Stará Ves (část)",
    "psc": "73923",
    "okres": "Ostrava-město",
    "obec": "Stará Ves nad Ondřejnicí",
    "val": "73923 Stara Ves nad Ondrejnici Stara Ves (cast)"
  },
  {
    "cast": "Stará Voda",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Horčápsko",
    "val": "26272 Horcapsko Stara Voda"
  },
  {
    "cast": "Stará Voda",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Světlá Hora",
    "val": "79331 Svetla Hora Stara Voda"
  },
  {
    "cast": "Stará Voda",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Stará Voda",
    "val": "35301 Stara Voda Stara Voda"
  },
  {
    "cast": "Stará Voda",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Stará Voda",
    "val": "50351 Stara Voda Stara Voda"
  },
  {
    "cast": "Stará Vožice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Stara Vozice"
  },
  {
    "cast": "Stará Vráž",
    "psc": "39832",
    "okres": "Písek",
    "obec": "Vráž",
    "val": "39832 Vraz Stara Vraz"
  },
  {
    "cast": "Starcova Lhota",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Starcova Lhota"
  },
  {
    "cast": "Staré",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebívlice",
    "val": "41115 Trebivlice Stare"
  },
  {
    "cast": "Staré Brno (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Stare Brno (cast)"
  },
  {
    "cast": "Staré Brno (část)",
    "psc": "60300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60300 Brno Stare Brno (cast)"
  },
  {
    "cast": "Staré Brno (část)",
    "psc": "63900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63900 Brno Stare Brno (cast)"
  },
  {
    "cast": "Staré Bříště",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Staré Bříště",
    "val": "39601 Stare Briste Stare Briste"
  },
  {
    "cast": "Staré Čívice",
    "psc": "53006",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53006 Pardubice Stare Civice"
  },
  {
    "cast": "Staré Dobrkovice",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Kájov",
    "val": "38101 Kajov Stare Dobrkovice"
  },
  {
    "cast": "Staré Hamry",
    "psc": "73915",
    "okres": "Frýdek-Místek",
    "obec": "Staré Hamry",
    "val": "73915 Stare Hamry Stare Hamry"
  },
  {
    "cast": "Staré Heřminovy",
    "psc": "79312",
    "okres": "Bruntál",
    "obec": "Staré Heřminovy",
    "val": "79312 Stare Herminovy Stare Herminovy"
  },
  {
    "cast": "Staré Hobzí (část)",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Hobzí",
    "val": "38001 Stare Hobzi Stare Hobzi (cast)"
  },
  {
    "cast": "Staré Hobzí (část)",
    "psc": "37871",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Hobzí",
    "val": "37871 Stare Hobzi Stare Hobzi (cast)"
  },
  {
    "cast": "Staré Hodějovice (část)",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Staré Hodějovice",
    "val": "37006 Stare Hodejovice Stare Hodejovice (cast)"
  },
  {
    "cast": "Staré Hodějovice (část)",
    "psc": "37008",
    "okres": "České Budějovice",
    "obec": "Staré Hodějovice",
    "val": "37008 Stare Hodejovice Stare Hodejovice (cast)"
  },
  {
    "cast": "Staré Holice",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Holice",
    "val": "53401 Holice Stare Holice"
  },
  {
    "cast": "Staré Hory",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Stare Hory"
  },
  {
    "cast": "Staré Hraběcí",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Velký Šenov",
    "val": "40747 Velky Senov Stare Hrabeci"
  },
  {
    "cast": "Staré Hradiště",
    "psc": "53352",
    "okres": "Pardubice",
    "obec": "Staré Hradiště",
    "val": "53352 Stare Hradiste Stare Hradiste"
  },
  {
    "cast": "Staré Hrady",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Staré Hrady",
    "val": "50723 Stare Hrady Stare Hrady"
  },
  {
    "cast": "Staré Hutě",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Kaliště",
    "val": "39601 Kaliste Stare Hute"
  },
  {
    "cast": "Staré Hutě",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Stare Hute"
  },
  {
    "cast": "Staré Hutě",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Staré Hutě",
    "val": "68601 Stare Hute Stare Hute"
  },
  {
    "cast": "Staré Hvězdlice",
    "psc": "68341",
    "okres": "Vyškov",
    "obec": "Hvězdlice",
    "val": "68341 Hvezdlice Stare Hvezdlice"
  },
  {
    "cast": "Staré Jesenčany",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Staré Jesenčany",
    "val": "53002 Stare Jesencany Stare Jesencany"
  },
  {
    "cast": "Staré Křečany",
    "psc": "40761",
    "okres": "Děčín",
    "obec": "Staré Křečany",
    "val": "40761 Stare Krecany Stare Krecany"
  },
  {
    "cast": "Staré Lány",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Stare Lany"
  },
  {
    "cast": "Staré Město",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Stare Mesto"
  },
  {
    "cast": "Staré Město",
    "psc": "73301",
    "okres": "Karviná",
    "obec": "Karviná",
    "val": "73301 Karvina Stare Mesto"
  },
  {
    "cast": "Staré Město",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Stare Mesto"
  },
  {
    "cast": "Staré Město",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Staré Město",
    "val": "79201 Stare Mesto Stare Mesto"
  },
  {
    "cast": "Staré Město",
    "psc": "11000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "11000 Praha Stare Mesto"
  },
  {
    "cast": "Staré Město",
    "psc": "78832",
    "okres": "Šumperk",
    "obec": "Staré Město",
    "val": "78832 Stare Mesto Stare Mesto"
  },
  {
    "cast": "Staré Město",
    "psc": "56932",
    "okres": "Svitavy",
    "obec": "Staré Město",
    "val": "56932 Stare Mesto Stare Mesto"
  },
  {
    "cast": "Staré Město nad Metují",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Náchod",
    "val": "54701 Nachod Stare Mesto nad Metuji"
  },
  {
    "cast": "Staré Město pod Landštejnem",
    "psc": "37882",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Město pod Landštejnem",
    "val": "37882 Stare Mesto pod Landstejnem Stare Mesto pod Landstejnem"
  },
  {
    "cast": "Staré Město (část)",
    "psc": "73901",
    "okres": "Frýdek-Místek",
    "obec": "Staré Město",
    "val": "73901 Stare Mesto Stare Mesto (cast)"
  },
  {
    "cast": "Staré Město (část)",
    "psc": "73801",
    "okres": "Frýdek-Místek",
    "obec": "Staré Město",
    "val": "73801 Stare Mesto Stare Mesto (cast)"
  },
  {
    "cast": "Staré Město (část)",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Staré Město",
    "val": "68601 Stare Mesto Stare Mesto (cast)"
  },
  {
    "cast": "Staré Město (část)",
    "psc": "68603",
    "okres": "Uherské Hradiště",
    "obec": "Staré Město",
    "val": "68603 Stare Mesto Stare Mesto (cast)"
  },
  {
    "cast": "Staré Místo",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Staré Místo",
    "val": "50601 Stare Misto Stare Misto"
  },
  {
    "cast": "Staré Mitrovice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Stare Mitrovice"
  },
  {
    "cast": "Staré Nechanice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Nechanice",
    "val": "50315 Nechanice Stare Nechanice"
  },
  {
    "cast": "Staré Nespeřice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Petrovice II",
    "val": "28504 Petrovice II Stare Nesperice"
  },
  {
    "cast": "Staré Oldřůvky",
    "psc": "74787",
    "okres": "Opava",
    "obec": "Budišov nad Budišovkou",
    "val": "74787 Budisov nad Budisovkou Stare Oldruvky"
  },
  {
    "cast": "Staré Ouholice",
    "psc": "27752",
    "okres": "Mělník",
    "obec": "Nová Ves",
    "val": "27752 Nova Ves Stare Ouholice"
  },
  {
    "cast": "Staré Pavlovice-Liberec XII x)",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46001 Liberec Stare Pavlovice-Liberec XII x)"
  },
  {
    "cast": "Staré Prachatice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Stare Prachatice"
  },
  {
    "cast": "Staré Práchňany",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Stare Prachnany"
  },
  {
    "cast": "Staré Purkartice",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Hošťálkovy",
    "val": "79401 Hostalkovy Stare Purkartice"
  },
  {
    "cast": "Staré Ransko",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Krucemburk",
    "val": "58263 Krucemburk Stare Ransko"
  },
  {
    "cast": "Staré Sedliště",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Staré Sedliště",
    "val": "34801 Stare Sedliste Stare Sedliste"
  },
  {
    "cast": "Staré Sedlo",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Stádlec",
    "val": "39165 Stadlec Stare Sedlo"
  },
  {
    "cast": "Staré Sedlo",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Stare Sedlo"
  },
  {
    "cast": "Staré Sedlo",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Staré Sedlo",
    "val": "35601 Stare Sedlo Stare Sedlo"
  },
  {
    "cast": "Staré Sedlo",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Staré Sedlo",
    "val": "34802 Stare Sedlo Stare Sedlo"
  },
  {
    "cast": "Staré Sedlo",
    "psc": "39807",
    "okres": "Písek",
    "obec": "Orlík nad Vltavou",
    "val": "39807 Orlik nad Vltavou Stare Sedlo"
  },
  {
    "cast": "Staré Smrkovice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Staré Smrkovice",
    "val": "50801 Stare Smrkovice Stare Smrkovice"
  },
  {
    "cast": "Staré Splavy",
    "psc": "47163",
    "okres": "Česká Lípa",
    "obec": "Doksy",
    "val": "47163 Doksy Stare Splavy"
  },
  {
    "cast": "Staré Těchanovice",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Staré Těchanovice",
    "val": "74901 Stare Techanovice Stare Techanovice"
  },
  {
    "cast": "Staré Vyklantice",
    "psc": "39427",
    "okres": "Pelhřimov",
    "obec": "Vyklantice",
    "val": "39427 Vyklantice Stare Vyklantice"
  },
  {
    "cast": "Staré Ždánice",
    "psc": "53344",
    "okres": "Pardubice",
    "obec": "Staré Ždánice",
    "val": "53344 Stare Zdanice Stare Zdanice"
  },
  {
    "cast": "Starec",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kdyně",
    "val": "34506 Kdyne Starec"
  },
  {
    "cast": "Starkoč",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Studnice",
    "val": "54701 Studnice Starkoc"
  },
  {
    "cast": "Starkoč",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Starkoč",
    "val": "28601 Starkoc Starkoc"
  },
  {
    "cast": "Stárkov",
    "psc": "54936",
    "okres": "Náchod",
    "obec": "Stárkov",
    "val": "54936 Starkov Starkov"
  },
  {
    "cast": "Starobucké Debrné",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Nemojov",
    "val": "54401 Nemojov Starobucke Debrne"
  },
  {
    "cast": "Staročernsko",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Starocernsko"
  },
  {
    "cast": "Starojická Lhota",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74101 Stary Jicin Starojicka Lhota"
  },
  {
    "cast": "Starosedlský Hrádek",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Starosedlský Hrádek",
    "val": "26272 Starosedlsky Hradek Starosedlsky Hradek"
  },
  {
    "cast": "Starostín",
    "psc": "54983",
    "okres": "Náchod",
    "obec": "Meziměstí",
    "val": "54983 Mezimesti Starostin"
  },
  {
    "cast": "Starov",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Volyně",
    "val": "38701 Volyne Starov"
  },
  {
    "cast": "Starovice",
    "psc": "69301",
    "okres": "Břeclav",
    "obec": "Starovice",
    "val": "69301 Starovice Starovice"
  },
  {
    "cast": "Starovičky",
    "psc": "69301",
    "okres": "Břeclav",
    "obec": "Starovičky",
    "val": "69301 Starovicky Starovicky"
  },
  {
    "cast": "Starý Bohumín",
    "psc": "73581",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73581 Bohumin Stary Bohumin"
  },
  {
    "cast": "Starý Bozděchov",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Horní Radouň",
    "val": "37842 Horni Radoun Stary Bozdechov"
  },
  {
    "cast": "Starý Brázdim",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Brázdim",
    "val": "25063 Brazdim Stary Brazdim"
  },
  {
    "cast": "Starý Bydžov",
    "psc": "50357",
    "okres": "Hradec Králové",
    "obec": "Starý Bydžov",
    "val": "50357 Stary Bydzov Stary Bydzov"
  },
  {
    "cast": "Starý Dub",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Český Dub",
    "val": "46343 Cesky Dub Stary Dub"
  },
  {
    "cast": "Starý Dvůr",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Třemošnice",
    "val": "53843 Tremosnice Stary Dvur"
  },
  {
    "cast": "Starý Dvůr",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Kout na Šumavě",
    "val": "34506 Kout na Sumave Stary Dvur"
  },
  {
    "cast": "Starý Harcov-Liberec XV x)",
    "psc": "46015",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46015 Liberec Stary Harcov-Liberec XV x)"
  },
  {
    "cast": "Starý Hrozenkov",
    "psc": "68774",
    "okres": "Uherské Hradiště",
    "obec": "Starý Hrozenkov",
    "val": "68774 Stary Hrozenkov Stary Hrozenkov"
  },
  {
    "cast": "Starý Jičín",
    "psc": "74231",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74231 Stary Jicin Stary Jicin"
  },
  {
    "cast": "Starý Jiříkov",
    "psc": "40753",
    "okres": "Děčín",
    "obec": "Jiříkov",
    "val": "40753 Jirikov Stary Jirikov"
  },
  {
    "cast": "Starý Klíčov",
    "psc": "34501",
    "okres": "Domažlice",
    "obec": "Mrákov",
    "val": "34501 Mrakov Stary Klicov"
  },
  {
    "cast": "Starý Kolín",
    "psc": "28123",
    "okres": "Kolín",
    "obec": "Starý Kolín",
    "val": "28123 Stary Kolin Stary Kolin"
  },
  {
    "cast": "Starý Kramolín",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Mutěnín",
    "val": "34525 Mutenin Stary Kramolin"
  },
  {
    "cast": "Starý Láz",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Nýrsko",
    "val": "34022 Nyrsko Stary Laz"
  },
  {
    "cast": "Starý Lískovec",
    "psc": "62500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62500 Brno Stary Liskovec"
  },
  {
    "cast": "Starý Maletín",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Maletín",
    "val": "78901 Maletin Stary Maletin"
  },
  {
    "cast": "Starý Mateřov",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Starý Mateřov",
    "val": "53002 Stary Materov Stary Materov"
  },
  {
    "cast": "Starý Mlýnec",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Ploskovice",
    "val": "41201 Ploskovice Stary Mlynec"
  },
  {
    "cast": "Starý Most",
    "psc": "43401",
    "okres": "Most",
    "obec": "Most",
    "val": "43401 Most Stary Most"
  },
  {
    "cast": "Starý Pařezov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Pařezov",
    "val": "34401 Parezov Stary Parezov"
  },
  {
    "cast": "Starý Pelhřimov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Stary Pelhrimov"
  },
  {
    "cast": "Starý Petřín",
    "psc": "67106",
    "okres": "Znojmo",
    "obec": "Starý Petřín",
    "val": "67106 Stary Petrin Stary Petrin"
  },
  {
    "cast": "Starý Ples",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Jaroměř",
    "val": "55101 Jaromer Stary Ples"
  },
  {
    "cast": "Starý Plzenec",
    "psc": "33202",
    "okres": "Plzeň-město",
    "obec": "Starý Plzenec",
    "val": "33202 Stary Plzenec Stary Plzenec"
  },
  {
    "cast": "Starý Poddvorov",
    "psc": "69616",
    "okres": "Hodonín",
    "obec": "Starý Poddvorov",
    "val": "69616 Stary Poddvorov Stary Poddvorov"
  },
  {
    "cast": "Starý Rokytník",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Stary Rokytnik"
  },
  {
    "cast": "Starý Rožmitál",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Stary Rozmital"
  },
  {
    "cast": "Starý Rybník",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Skalná",
    "val": "35134 Skalna Stary Rybnik"
  },
  {
    "cast": "Starý Samechov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Řendějov",
    "val": "28522 Rendejov Stary Samechov"
  },
  {
    "cast": "Starý Smolivec",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mladý Smolivec",
    "val": "33501 Mlady Smolivec Stary Smolivec"
  },
  {
    "cast": "Starý Smrdov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Vyklantice",
    "val": "39501 Vyklantice Stary Smrdov"
  },
  {
    "cast": "Starý Spálenec",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Česká Kubice",
    "val": "34401 Ceska Kubice Stary Spalenec"
  },
  {
    "cast": "Starý Svojanov",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Svojanov",
    "val": "56992 Svojanov Stary Svojanov"
  },
  {
    "cast": "Starý Šachov",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Starý Šachov",
    "val": "40502 Stary Sachov Stary Sachov"
  },
  {
    "cast": "Starý Telečkov",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Pavlov",
    "val": "59444 Pavlov Stary Teleckov"
  },
  {
    "cast": "Starý Týn",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Stary Tyn"
  },
  {
    "cast": "Starý Vestec",
    "psc": "28916",
    "okres": "Nymburk",
    "obec": "Starý Vestec",
    "val": "28916 Stary Vestec Stary Vestec"
  },
  {
    "cast": "Stařeč",
    "psc": "67522",
    "okres": "Třebíč",
    "obec": "Stařeč",
    "val": "67522 Starec Starec"
  },
  {
    "cast": "Stařečka",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Starecka"
  },
  {
    "cast": "Stařechovice",
    "psc": "79841",
    "okres": "Prostějov",
    "obec": "Stařechovice",
    "val": "79841 Starechovice Starechovice"
  },
  {
    "cast": "Staříč",
    "psc": "73943",
    "okres": "Frýdek-Místek",
    "obec": "Staříč",
    "val": "73943 Staric Staric"
  },
  {
    "cast": "Stašov",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Stašov",
    "val": "26751 Stasov Stasov"
  },
  {
    "cast": "Stašov",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Stašov",
    "val": "57201 Stasov Stasov"
  },
  {
    "cast": "Statenice",
    "psc": "25262",
    "okres": "Praha-západ",
    "obec": "Statenice",
    "val": "25262 Statenice Statenice"
  },
  {
    "cast": "Stav",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Úbislavice",
    "val": "50901 Ubislavice Stav"
  },
  {
    "cast": "Stavenice",
    "psc": "78973",
    "okres": "Šumperk",
    "obec": "Stavenice",
    "val": "78973 Stavenice Stavenice"
  },
  {
    "cast": "Stavěšice",
    "psc": "69638",
    "okres": "Hodonín",
    "obec": "Stavěšice",
    "val": "69638 Stavesice Stavesice"
  },
  {
    "cast": "Stéblová",
    "psc": "53345",
    "okres": "Pardubice",
    "obec": "Stéblová",
    "val": "53345 Steblova Steblova"
  },
  {
    "cast": "Stéblovice",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Steblovice"
  },
  {
    "cast": "Stebnice",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Lipová",
    "val": "35002 Lipova Stebnice"
  },
  {
    "cast": "Stebno",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Kryry",
    "val": "44101 Kryry Stebno"
  },
  {
    "cast": "Stebno",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Stebno"
  },
  {
    "cast": "Stebno",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Stebno",
    "val": "40002 Stebno Stebno"
  },
  {
    "cast": "Stěbořice",
    "psc": "74751",
    "okres": "Opava",
    "obec": "Stěbořice",
    "val": "74751 Steborice Steborice"
  },
  {
    "cast": "Stehelčeves",
    "psc": "27342",
    "okres": "Kladno",
    "obec": "Stehelčeves",
    "val": "27342 Stehelceves Stehelceves"
  },
  {
    "cast": "Stehlovice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Stehlovice",
    "val": "39843 Stehlovice Stehlovice"
  },
  {
    "cast": "Stekník",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Zálužice",
    "val": "43801 Zaluzice Steknik"
  },
  {
    "cast": "Stěžerov",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Hořice na Šumavě",
    "val": "38101 Horice na Sumave Stezerov"
  },
  {
    "cast": "Stěžery",
    "psc": "50321",
    "okres": "Hradec Králové",
    "obec": "Stěžery",
    "val": "50321 Stezery Stezery"
  },
  {
    "cast": "Stěžírky",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Stěžery",
    "val": "50312 Stezery Stezirky"
  },
  {
    "cast": "Stěžov (část)",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Milín",
    "val": "26231 Milin Stezov (cast)"
  },
  {
    "cast": "Stěžov (část)",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Milín",
    "val": "26263 Milin Stezov (cast)"
  },
  {
    "cast": "Stíčany",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Hrochův Týnec",
    "val": "53862 Hrochuv Tynec Sticany"
  },
  {
    "cast": "Stínava",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Stínava",
    "val": "79803 Stinava Stinava"
  },
  {
    "cast": "Stod",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Stod",
    "val": "33301 Stod Stod"
  },
  {
    "cast": "Stodůlky (část)",
    "psc": "15800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15800 Praha Stodulky (cast)"
  },
  {
    "cast": "Stodůlky (část)",
    "psc": "15500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15500 Praha Stodulky (cast)"
  },
  {
    "cast": "Stochov",
    "psc": "27303",
    "okres": "Kladno",
    "obec": "Stochov",
    "val": "27303 Stochov Stochov"
  },
  {
    "cast": "Stojanovice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Stojanovice"
  },
  {
    "cast": "Stojčín",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Stojčín",
    "val": "39468 Stojcin Stojcin"
  },
  {
    "cast": "Stoječín",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Český Rudolec",
    "val": "37881 Cesky Rudolec Stojecin"
  },
  {
    "cast": "Stojice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Stojice",
    "val": "53501 Stojice Stojice"
  },
  {
    "cast": "Stojslavice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Smilovy Hory",
    "val": "39143 Smilovy Hory Stojslavice"
  },
  {
    "cast": "Stoklasná Lhota",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39137 Tabor Stoklasna Lhota"
  },
  {
    "cast": "Stolany",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Stolany",
    "val": "53803 Stolany Stolany"
  },
  {
    "cast": "Stolín (část)",
    "psc": "54232",
    "okres": "Náchod",
    "obec": "Červený Kostelec",
    "val": "54232 Cerveny Kostelec Stolin (cast)"
  },
  {
    "cast": "Stolín (část)",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Červený Kostelec",
    "val": "54941 Cerveny Kostelec Stolin (cast)"
  },
  {
    "cast": "Stonařov (část)",
    "psc": "58832",
    "okres": "Jihlava",
    "obec": "Stonařov",
    "val": "58832 Stonarov Stonarov (cast)"
  },
  {
    "cast": "Stonařov (část)",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Stonařov",
    "val": "58833 Stonarov Stonarov (cast)"
  },
  {
    "cast": "Stonava",
    "psc": "73534",
    "okres": "Karviná",
    "obec": "Stonava",
    "val": "73534 Stonava Stonava"
  },
  {
    "cast": "Stošíkovice na Louce",
    "psc": "67161",
    "okres": "Znojmo",
    "obec": "Stošíkovice na Louce",
    "val": "67161 Stosikovice na Louce Stosikovice na Louce"
  },
  {
    "cast": "Stožec",
    "psc": "38444",
    "okres": "Prachatice",
    "obec": "Stožec",
    "val": "38444 Stozec Stozec"
  },
  {
    "cast": "Stožice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Stožice",
    "val": "38901 Stozice Stozice"
  },
  {
    "cast": "Strabenice",
    "psc": "76813",
    "okres": "Kroměříž",
    "obec": "Litenčice",
    "val": "76813 Litencice Strabenice"
  },
  {
    "cast": "Stračí",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Straci"
  },
  {
    "cast": "Stračov",
    "psc": "50314",
    "okres": "Hradec Králové",
    "obec": "Stračov",
    "val": "50314 Stracov Stracov"
  },
  {
    "cast": "Stračovská Lhota",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Mžany",
    "val": "50315 Mzany Stracovska Lhota"
  },
  {
    "cast": "Stradonice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Peruc",
    "val": "44001 Peruc Stradonice"
  },
  {
    "cast": "Stradonice",
    "psc": "26705",
    "okres": "Beroun",
    "obec": "Nižbor",
    "val": "26705 Nizbor Stradonice"
  },
  {
    "cast": "Stradonice",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Stradonice",
    "val": "27371 Stradonice Stradonice"
  },
  {
    "cast": "Stradouň",
    "psc": "53863",
    "okres": "Ústí nad Orlicí",
    "obec": "Stradouň",
    "val": "53863 Stradoun Stradoun"
  },
  {
    "cast": "Stradov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Omlenice",
    "val": "38241 Omlenice Stradov"
  },
  {
    "cast": "Stradov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Komařice",
    "val": "37401 Komarice Stradov"
  },
  {
    "cast": "Stradov",
    "psc": "40339",
    "okres": "Ústí nad Labem",
    "obec": "Chlumec",
    "val": "40339 Chlumec Stradov"
  },
  {
    "cast": "Strahov",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Horní Kozolupy",
    "val": "34952 Horni Kozolupy Strahov"
  },
  {
    "cast": "Strahovice",
    "psc": "74724",
    "okres": "Opava",
    "obec": "Strahovice",
    "val": "74724 Strahovice Strahovice"
  },
  {
    "cast": "Strachaly",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Snědovice",
    "val": "41108 Snedovice Strachaly"
  },
  {
    "cast": "Strachoňovice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Strachoňovice",
    "val": "58856 Strachonovice Strachonovice"
  },
  {
    "cast": "Strachotice",
    "psc": "67129",
    "okres": "Znojmo",
    "obec": "Strachotice",
    "val": "67129 Strachotice Strachotice"
  },
  {
    "cast": "Strachotín",
    "psc": "69301",
    "okres": "Břeclav",
    "obec": "Strachotín",
    "val": "69301 Strachotin Strachotin"
  },
  {
    "cast": "Strachovice",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Strachovice"
  },
  {
    "cast": "Strachovice",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37348 Driten Strachovice"
  },
  {
    "cast": "Strachovice",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Čistá",
    "val": "27034 Cista Strachovice"
  },
  {
    "cast": "Strachujov",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Strachujov",
    "val": "59242 Strachujov Strachujov"
  },
  {
    "cast": "Strakonice I",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Strakonice",
    "val": "38601 Strakonice Strakonice I"
  },
  {
    "cast": "Strakonice II",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Strakonice",
    "val": "38601 Strakonice Strakonice II"
  },
  {
    "cast": "Strakov",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Strakov",
    "val": "57001 Strakov Strakov"
  },
  {
    "cast": "Straky",
    "psc": "28925",
    "okres": "Nymburk",
    "obec": "Straky",
    "val": "28925 Straky Straky"
  },
  {
    "cast": "Straky",
    "psc": "41771",
    "okres": "Teplice",
    "obec": "Zabrušany",
    "val": "41771 Zabrusany Straky"
  },
  {
    "cast": "Stráň",
    "psc": "36235",
    "okres": "Karlovy Vary",
    "obec": "Potůčky",
    "val": "36235 Potucky Stran"
  },
  {
    "cast": "Stráň",
    "psc": "36001",
    "okres": "Karlovy Vary",
    "obec": "Sadov",
    "val": "36001 Sadov Stran"
  },
  {
    "cast": "Straňany",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Doudleby",
    "val": "37007 Doudleby Stranany"
  },
  {
    "cast": "Strančice (část)",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25163 Strancice Strancice (cast)"
  },
  {
    "cast": "Strančice (část)",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25164 Strancice Strancice (cast)"
  },
  {
    "cast": "Stránecká Zhoř",
    "psc": "59442",
    "okres": "Žďár nad Sázavou",
    "obec": "Stránecká Zhoř",
    "val": "59442 Stranecka Zhor Stranecka Zhor"
  },
  {
    "cast": "Strání",
    "psc": "68765",
    "okres": "Uherské Hradiště",
    "obec": "Strání",
    "val": "68765 Strani Strani"
  },
  {
    "cast": "Stránice (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Stranice (cast)"
  },
  {
    "cast": "Stránice (část)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Stranice (cast)"
  },
  {
    "cast": "Straník",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Nový Jičín",
    "val": "74101 Novy Jicin Stranik"
  },
  {
    "cast": "Stránka",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Stránka",
    "val": "27735 Stranka Stranka"
  },
  {
    "cast": "Stránky",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Holedeč",
    "val": "43801 Holedec Stranky"
  },
  {
    "cast": "Stranná",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Dyjice",
    "val": "58862 Dyjice Stranna"
  },
  {
    "cast": "Stranná",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Březno",
    "val": "43801 Brezno Stranna"
  },
  {
    "cast": "Stranná",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Žirovnice",
    "val": "39468 Zirovnice Stranna"
  },
  {
    "cast": "Stranný",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Stranný",
    "val": "25756 Stranny Stranny"
  },
  {
    "cast": "Straňovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Malenice",
    "val": "38701 Malenice Stranovice"
  },
  {
    "cast": "Stránské",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Rýmařov",
    "val": "79351 Rymarov Stranske"
  },
  {
    "cast": "Strašice",
    "psc": "33845",
    "okres": "Rokycany",
    "obec": "Strašice",
    "val": "33845 Strasice Strasice"
  },
  {
    "cast": "Strašice",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Strašice",
    "val": "38716 Strasice Strasice"
  },
  {
    "cast": "Strašín",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Strašín",
    "val": "34201 Strasin Strasin"
  },
  {
    "cast": "Strašín",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Říčany",
    "val": "25101 Ricany Strasin"
  },
  {
    "cast": "Straškov",
    "psc": "41184",
    "okres": "Litoměřice",
    "obec": "Straškov-Vodochody",
    "val": "41184 Straskov-Vodochody Straskov"
  },
  {
    "cast": "Strašnice (část)",
    "psc": "13000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "13000 Praha Strasnice (cast)"
  },
  {
    "cast": "Strašnice (část)",
    "psc": "10000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10000 Praha Strasnice (cast)"
  },
  {
    "cast": "Strašnice (část)",
    "psc": "10100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10100 Praha Strasnice (cast)"
  },
  {
    "cast": "Strašnice (část)",
    "psc": "10800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10800 Praha Strasnice (cast)"
  },
  {
    "cast": "Strašnov",
    "psc": "29431",
    "okres": "Mladá Boleslav",
    "obec": "Strašnov",
    "val": "29431 Strasnov Strasnov"
  },
  {
    "cast": "Strašov",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Strašov",
    "val": "53316 Strasov Strasov"
  },
  {
    "cast": "Stratov",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Stratov",
    "val": "28922 Stratov Stratov"
  },
  {
    "cast": "Stráž",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Straz"
  },
  {
    "cast": "Stráž",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39804 Mirotice Straz"
  },
  {
    "cast": "Stráž",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Straz"
  },
  {
    "cast": "Stráž",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Straz"
  },
  {
    "cast": "Stráž",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Stráž",
    "val": "34401 Straz Straz"
  },
  {
    "cast": "Stráž nad Nežárkou",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Stráž nad Nežárkou",
    "val": "37802 Straz nad Nezarkou Straz nad Nezarkou"
  },
  {
    "cast": "Stráž nad Nisou",
    "psc": "46303",
    "okres": "Liberec",
    "obec": "Stráž nad Nisou",
    "val": "46303 Straz nad Nisou Straz nad Nisou"
  },
  {
    "cast": "Stráž nad Ohří",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Stráž nad Ohří",
    "val": "36301 Straz nad Ohri Straz nad Ohri"
  },
  {
    "cast": "Stráž pod Ralskem",
    "psc": "47127",
    "okres": "Česká Lípa",
    "obec": "Stráž pod Ralskem",
    "val": "47127 Straz pod Ralskem Straz pod Ralskem"
  },
  {
    "cast": "Stráž u České Lípy",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Stružnice",
    "val": "47002 Struznice Straz u Ceske Lipy"
  },
  {
    "cast": "Strážek (část)",
    "psc": "59253",
    "okres": "Žďár nad Sázavou",
    "obec": "Strážek",
    "val": "59253 Strazek Strazek (cast)"
  },
  {
    "cast": "Strážek (část)",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Strážek",
    "val": "59301 Strazek Strazek (cast)"
  },
  {
    "cast": "Stražisko",
    "psc": "79844",
    "okres": "Prostějov",
    "obec": "Stražisko",
    "val": "79844 Strazisko Strazisko"
  },
  {
    "cast": "Stražiště",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Počaply",
    "val": "26272 Pocaply Straziste"
  },
  {
    "cast": "Strážiště",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Drahobuz",
    "val": "41145 Drahobuz Straziste"
  },
  {
    "cast": "Strážiště",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Mladotice",
    "val": "33141 Mladotice Straziste"
  },
  {
    "cast": "Strážiště",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Strážiště",
    "val": "29413 Straziste Straziste"
  },
  {
    "cast": "Strážkovice",
    "psc": "54234",
    "okres": "Trutnov",
    "obec": "Malé Svatoňovice",
    "val": "54234 Male Svatonovice Strazkovice"
  },
  {
    "cast": "Strážkovice (část)",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Strážkovice",
    "val": "37312 Strazkovice Strazkovice (cast)"
  },
  {
    "cast": "Strážkovice (část)",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Strážkovice",
    "val": "37401 Strazkovice Strazkovice (cast)"
  },
  {
    "cast": "Strážky",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Strazky"
  },
  {
    "cast": "Strážky",
    "psc": "40340",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40340 Usti nad Labem Strazky"
  },
  {
    "cast": "Strážná",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Strážná",
    "val": "56301 Strazna Strazna"
  },
  {
    "cast": "Strážné",
    "psc": "54352",
    "okres": "Trutnov",
    "obec": "Strážné",
    "val": "54352 Strazne Strazne"
  },
  {
    "cast": "Strážnice",
    "psc": "69662",
    "okres": "Hodonín",
    "obec": "Strážnice",
    "val": "69662 Straznice Straznice"
  },
  {
    "cast": "Strážnice (část)",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Vysoká",
    "val": "27721 Vysoka Straznice (cast)"
  },
  {
    "cast": "Strážnice (část)",
    "psc": "27724",
    "okres": "Mělník",
    "obec": "Vysoká",
    "val": "27724 Vysoka Straznice (cast)"
  },
  {
    "cast": "Strážný",
    "psc": "38443",
    "okres": "Prachatice",
    "obec": "Strážný",
    "val": "38443 Strazny Strazny"
  },
  {
    "cast": "Strážov",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Strazov"
  },
  {
    "cast": "Strážovice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirotice",
    "val": "39804 Mirotice Strazovice"
  },
  {
    "cast": "Strážovice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Strazovice"
  },
  {
    "cast": "Strážovice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Pačejov",
    "val": "34101 Pacejov Strazovice"
  },
  {
    "cast": "Strážovice",
    "psc": "69638",
    "okres": "Hodonín",
    "obec": "Strážovice",
    "val": "69638 Strazovice Strazovice"
  },
  {
    "cast": "Strenice",
    "psc": "29430",
    "okres": "Mladá Boleslav",
    "obec": "Strenice",
    "val": "29430 Strenice Strenice"
  },
  {
    "cast": "Strhaře",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Strhaře",
    "val": "67923 Strhare Strhare"
  },
  {
    "cast": "Strkov",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Ctětín",
    "val": "53825 Ctetin Strkov"
  },
  {
    "cast": "Strkov",
    "psc": "39111",
    "okres": "Tábor",
    "obec": "Planá nad Lužnicí",
    "val": "39111 Plana nad Luznici Strkov"
  },
  {
    "cast": "Strkovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Strkovice"
  },
  {
    "cast": "Strměchy",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Strmechy"
  },
  {
    "cast": "Strmilov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Strmilov",
    "val": "37853 Strmilov Strmilov"
  },
  {
    "cast": "Strnadice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25753 Marsovice Strnadice"
  },
  {
    "cast": "Strojetice",
    "psc": "43986",
    "okres": "Louny",
    "obec": "Kryry",
    "val": "43986 Kryry Strojetice"
  },
  {
    "cast": "Strojetice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Strojetice",
    "val": "25765 Strojetice Strojetice"
  },
  {
    "cast": "Stromkovice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51401 Jablonec nad Jizerou Stromkovice"
  },
  {
    "cast": "Stropčice",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Stropcice"
  },
  {
    "cast": "Stropešín",
    "psc": "67555",
    "okres": "Třebíč",
    "obec": "Stropešín",
    "val": "67555 Stropesin Stropesin"
  },
  {
    "cast": "Stroupeč",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žiželice",
    "val": "43801 Zizelice Stroupec"
  },
  {
    "cast": "Strpí",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Číčenice",
    "val": "38901 Cicenice Strpi"
  },
  {
    "cast": "Struhadlo",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bezděkov",
    "val": "33901 Bezdekov Struhadlo"
  },
  {
    "cast": "Struhaře",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Struhare"
  },
  {
    "cast": "Struhařov",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Struharov"
  },
  {
    "cast": "Struhařov",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Struhařov",
    "val": "25164 Struharov Struharov"
  },
  {
    "cast": "Struhařov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Struharov"
  },
  {
    "cast": "Struhy",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Vlastec",
    "val": "39701 Vlastec Struhy"
  },
  {
    "cast": "Struhy",
    "psc": "29443",
    "okres": "Mladá Boleslav",
    "obec": "Čachovice",
    "val": "29443 Cachovice Struhy"
  },
  {
    "cast": "Strukov",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Strukov",
    "val": "78401 Strukov Strukov"
  },
  {
    "cast": "Strunkov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Strunkov"
  },
  {
    "cast": "Strunkovice nad Blanicí",
    "psc": "38426",
    "okres": "Prachatice",
    "obec": "Strunkovice nad Blanicí",
    "val": "38426 Strunkovice nad Blanici Strunkovice nad Blanici"
  },
  {
    "cast": "Strunkovice nad Volyňkou",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Strunkovice nad Volyňkou",
    "val": "38701 Strunkovice nad Volynkou Strunkovice nad Volynkou"
  },
  {
    "cast": "Strupčice",
    "psc": "43114",
    "okres": "Chomutov",
    "obec": "Strupčice",
    "val": "43114 Strupcice Strupcice"
  },
  {
    "cast": "Strupina",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Nečín",
    "val": "26301 Necin Strupina"
  },
  {
    "cast": "Strupšín",
    "psc": "78975",
    "okres": "Šumperk",
    "obec": "Brníčko",
    "val": "78975 Brnicko Strupsin"
  },
  {
    "cast": "Stružinec",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Struzinec"
  },
  {
    "cast": "Stružinec",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Stružinec",
    "val": "51251 Struzinec Struzinec"
  },
  {
    "cast": "Stružinec",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec nad Doubravou",
    "val": "58263 Zdirec nad Doubravou Struzinec"
  },
  {
    "cast": "Stružná",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Stružná",
    "val": "36471 Struzna Struzna"
  },
  {
    "cast": "Stružnice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Stružnice",
    "val": "47002 Struznice Struznice"
  },
  {
    "cast": "Strýčice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Strýčice",
    "val": "37341 Strycice Strycice"
  },
  {
    "cast": "Strýčkovice",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Srbice",
    "val": "34543 Srbice Stryckovice"
  },
  {
    "cast": "Strýčkovy",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Stryckovy"
  },
  {
    "cast": "Stržanov",
    "psc": "59102",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59102 Zdar nad Sazavou Strzanov"
  },
  {
    "cast": "Strženec",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25703 Bystrice Strzenec"
  },
  {
    "cast": "Střapole",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Bušovice",
    "val": "33824 Busovice Strapole"
  },
  {
    "cast": "Střed",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Rokycany",
    "val": "33701 Rokycany Stred"
  },
  {
    "cast": "Střední Předměstí",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Stredni Predmesti"
  },
  {
    "cast": "Střednice",
    "psc": "27724",
    "okres": "Mělník",
    "obec": "Vysoká",
    "val": "27724 Vysoka Strednice"
  },
  {
    "cast": "Středokluky",
    "psc": "25268",
    "okres": "Praha-západ",
    "obec": "Středokluky",
    "val": "25268 Stredokluky Stredokluky"
  },
  {
    "cast": "Středolesí-Hranice VIII x)",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Stredolesi-Hranice VIII x)"
  },
  {
    "cast": "Střehom",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Bousov",
    "val": "29404 Dolni Bousov Strehom"
  },
  {
    "cast": "Střechov nad Sázavou",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Trhový Štěpánov",
    "val": "25763 Trhovy Stepanov Strechov nad Sazavou"
  },
  {
    "cast": "Střekov",
    "psc": "40003",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40003 Usti nad Labem Strekov"
  },
  {
    "cast": "Střela",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Strakonice",
    "val": "38601 Strakonice Strela"
  },
  {
    "cast": "Střeleč",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Mladějov",
    "val": "50601 Mladejov Strelec"
  },
  {
    "cast": "Střelice",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Střelice",
    "val": "33301 Strelice Strelice"
  },
  {
    "cast": "Střelice",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Strelice"
  },
  {
    "cast": "Střelice",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Střelice",
    "val": "67153 Strelice Strelice"
  },
  {
    "cast": "Střelice",
    "psc": "66447",
    "okres": "Brno-venkov",
    "obec": "Střelice",
    "val": "66447 Strelice Strelice"
  },
  {
    "cast": "Střelítov",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Strelitov"
  },
  {
    "cast": "Střelná",
    "psc": "75612",
    "okres": "Vsetín",
    "obec": "Střelná",
    "val": "75612 Strelna Strelna"
  },
  {
    "cast": "Střelná",
    "psc": "41723",
    "okres": "Teplice",
    "obec": "Košťany",
    "val": "41723 Kostany Strelna"
  },
  {
    "cast": "Střelské Hoštice",
    "psc": "38715",
    "okres": "Strakonice",
    "obec": "Střelské Hoštice",
    "val": "38715 Strelske Hostice Strelske Hostice"
  },
  {
    "cast": "Střelskohoštická Lhota (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Střelské Hoštice",
    "val": "38601 Strelske Hostice Strelskohosticka Lhota (cast)"
  },
  {
    "cast": "Střelskohoštická Lhota (část)",
    "psc": "38715",
    "okres": "Strakonice",
    "obec": "Střelské Hoštice",
    "val": "38715 Strelske Hostice Strelskohosticka Lhota (cast)"
  },
  {
    "cast": "Střemeníčko",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Luká",
    "val": "78324 Luka Stremenicko"
  },
  {
    "cast": "Střemchoví",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Dolní Loučky",
    "val": "59455 Dolni Loucky Stremchovi"
  },
  {
    "cast": "Střemošice",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Střemošice",
    "val": "53854 Stremosice Stremosice"
  },
  {
    "cast": "Střemy",
    "psc": "27734",
    "okres": "Mělník",
    "obec": "Střemy",
    "val": "27734 Stremy Stremy"
  },
  {
    "cast": "Střeň",
    "psc": "78332",
    "okres": "Olomouc",
    "obec": "Střeň",
    "val": "78332 Stren Stren"
  },
  {
    "cast": "Střešovice (část)",
    "psc": "16000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16000 Praha Stresovice (cast)"
  },
  {
    "cast": "Střešovice (část)",
    "psc": "16900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16900 Praha Stresovice (cast)"
  },
  {
    "cast": "Střešovice (část)",
    "psc": "16200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16200 Praha Stresovice (cast)"
  },
  {
    "cast": "Střevač (část)",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Střevač",
    "val": "50601 Strevac Strevac (cast)"
  },
  {
    "cast": "Střevač (část)",
    "psc": "50722",
    "okres": "Jičín",
    "obec": "Střevač",
    "val": "50722 Strevac Strevac (cast)"
  },
  {
    "cast": "Střevelná",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Strevelna"
  },
  {
    "cast": "Střezetice",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Střezetice",
    "val": "50312 Strezetice Strezetice"
  },
  {
    "cast": "Střeziměř",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Strezimer"
  },
  {
    "cast": "Střeziměřice",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Chvalkovice",
    "val": "55204 Chvalkovice Strezimerice"
  },
  {
    "cast": "Střeziměřice",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Strezimerice"
  },
  {
    "cast": "Střezimíř (část)",
    "psc": "25787",
    "okres": "Benešov",
    "obec": "Střezimíř",
    "val": "25787 Strezimir Strezimir (cast)"
  },
  {
    "cast": "Střezimíř (část)",
    "psc": "25791",
    "okres": "Benešov",
    "obec": "Střezimíř",
    "val": "25791 Strezimir Strezimir (cast)"
  },
  {
    "cast": "Střezivojice",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Dobřeň",
    "val": "27721 Dobren Strezivojice"
  },
  {
    "cast": "Střezov",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Březno",
    "val": "43801 Brezno Strezov"
  },
  {
    "cast": "Stříbrná",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Stříbrná",
    "val": "35801 Stribrna Stribrna"
  },
  {
    "cast": "Stříbrná Skalice (část)",
    "psc": "28167",
    "okres": "Praha-východ",
    "obec": "Stříbrná Skalice",
    "val": "28167 Stribrna Skalice Stribrna Skalice (cast)"
  },
  {
    "cast": "Stříbrná Skalice (část)",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Stříbrná Skalice",
    "val": "28163 Stribrna Skalice Stribrna Skalice (cast)"
  },
  {
    "cast": "Stříbrné Hory",
    "psc": "79344",
    "okres": "Bruntál",
    "obec": "Horní Město",
    "val": "79344 Horni Mesto Stribrne Hory"
  },
  {
    "cast": "Stříbrné Hory",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Stribrne Hory"
  },
  {
    "cast": "Stříbrné Hory",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Stříbrné Hory",
    "val": "58222 Stribrne Hory Stribrne Hory"
  },
  {
    "cast": "Stříbrnice",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Stříbrnice",
    "val": "75201 Stribrnice Stribrnice"
  },
  {
    "cast": "Stříbrnice",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Vrbice",
    "val": "50703 Vrbice Stribrnice"
  },
  {
    "cast": "Stříbrnice",
    "psc": "78832",
    "okres": "Šumperk",
    "obec": "Staré Město",
    "val": "78832 Stare Mesto Stribrnice"
  },
  {
    "cast": "Stříbrnice",
    "psc": "68709",
    "okres": "Uherské Hradiště",
    "obec": "Stříbrnice",
    "val": "68709 Stribrnice Stribrnice"
  },
  {
    "cast": "Stříbro",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Stříbro",
    "val": "34901 Stribro Stribro"
  },
  {
    "cast": "Stříbřec",
    "psc": "37818",
    "okres": "Jindřichův Hradec",
    "obec": "Stříbřec",
    "val": "37818 Stribrec Stribrec"
  },
  {
    "cast": "Střídka",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Čestice",
    "val": "38719 Cestice Stridka"
  },
  {
    "cast": "Stříhanov",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Zádolí",
    "val": "56601 Zadoli Strihanov"
  },
  {
    "cast": "Střihov",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Sloveč",
    "val": "28903 Slovec Strihov"
  },
  {
    "cast": "Střílky (část)",
    "psc": "76804",
    "okres": "Kroměříž",
    "obec": "Střílky",
    "val": "76804 Strilky Strilky (cast)"
  },
  {
    "cast": "Střílky (část)",
    "psc": "76805",
    "okres": "Kroměříž",
    "obec": "Střílky",
    "val": "76805 Strilky Strilky (cast)"
  },
  {
    "cast": "Střítež",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Hluboká",
    "val": "53973 Hluboka Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Polička",
    "val": "57201 Policka Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Střítež",
    "val": "67401 Stritez Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Vlksice",
    "val": "39901 Vlksice Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Střítež",
    "val": "39301 Stritez Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Střítež",
    "val": "38232 Stritez Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Litochovice",
    "val": "38701 Litochovice Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "58811",
    "okres": "Jihlava",
    "obec": "Střítež",
    "val": "58811 Stritez Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Včelákov",
    "val": "53901 Vcelakov Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "39494",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39494 Cernovice Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Střítež",
    "val": "59251 Stritez Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Dolní Kralovice",
    "val": "25768 Dolni Kralovice Stritez"
  },
  {
    "cast": "Střítež",
    "psc": "73959",
    "okres": "Frýdek-Místek",
    "obec": "Střítež",
    "val": "73959 Stritez Stritez"
  },
  {
    "cast": "Střítež nad Bečvou",
    "psc": "75652",
    "okres": "Vsetín",
    "obec": "Střítež nad Bečvou",
    "val": "75652 Stritez nad Becvou Stritez nad Becvou"
  },
  {
    "cast": "Střítež nad Ludinou",
    "psc": "75363",
    "okres": "Přerov",
    "obec": "Střítež nad Ludinou",
    "val": "75363 Stritez nad Ludinou Stritez nad Ludinou"
  },
  {
    "cast": "Střítež pod Křemešníkem",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Střítež pod Křemešníkem",
    "val": "39301 Stritez pod Kremesnikem Stritez pod Kremesnikem"
  },
  {
    "cast": "Střížkov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Strizkov"
  },
  {
    "cast": "Střížkov (část)",
    "psc": "18000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18000 Praha Strizkov (cast)"
  },
  {
    "cast": "Střížkov (část)",
    "psc": "19000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19000 Praha Strizkov (cast)"
  },
  {
    "cast": "Střížkov (část)",
    "psc": "18200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18200 Praha Strizkov (cast)"
  },
  {
    "cast": "Střížov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35002 Cheb Strizov"
  },
  {
    "cast": "Střížov",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Vladislav",
    "val": "67501 Vladislav Strizov"
  },
  {
    "cast": "Střížov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Strizov"
  },
  {
    "cast": "Střížov",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58822 Brtnice Strizov"
  },
  {
    "cast": "Střížov",
    "psc": "78344",
    "okres": "Olomouc",
    "obec": "Drahanovice",
    "val": "78344 Drahanovice Strizov"
  },
  {
    "cast": "Střížov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Střížov",
    "val": "37401 Strizov Strizov"
  },
  {
    "cast": "Střížovice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Myštice",
    "val": "38801 Mystice Strizovice"
  },
  {
    "cast": "Střížovice",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Snědovice",
    "val": "41108 Snedovice Strizovice"
  },
  {
    "cast": "Střížovice",
    "psc": "76821",
    "okres": "Kroměříž",
    "obec": "Střížovice",
    "val": "76821 Strizovice Strizovice"
  },
  {
    "cast": "Střížovice",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Pěnčín",
    "val": "46345 Pencin Strizovice"
  },
  {
    "cast": "Střížovice",
    "psc": "40010",
    "okres": "Ústí nad Labem",
    "obec": "Chlumec",
    "val": "40010 Chlumec Strizovice"
  },
  {
    "cast": "Střížovice",
    "psc": "33207",
    "okres": "Plzeň-jih",
    "obec": "Střížovice",
    "val": "33207 Strizovice Strizovice"
  },
  {
    "cast": "Střížovice",
    "psc": "29479",
    "okres": "Mladá Boleslav",
    "obec": "Kropáčova Vrutice",
    "val": "29479 Kropacova Vrutice Strizovice"
  },
  {
    "cast": "Střížovice (část)",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Střížovice",
    "val": "37853 Strizovice Strizovice (cast)"
  },
  {
    "cast": "Střížovice (část)",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Střížovice",
    "val": "37701 Strizovice Strizovice (cast)"
  },
  {
    "cast": "Studánka",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Hranice",
    "val": "35201 Hranice Studanka"
  },
  {
    "cast": "Studánka",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Studánka",
    "val": "34701 Studanka Studanka"
  },
  {
    "cast": "Studánka",
    "psc": "40752",
    "okres": "Děčín",
    "obec": "Varnsdorf",
    "val": "40752 Varnsdorf Studanka"
  },
  {
    "cast": "Studánka (část)",
    "psc": "53003",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53003 Pardubice Studanka (cast)"
  },
  {
    "cast": "Studánka (část)",
    "psc": "53012",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53012 Pardubice Studanka (cast)"
  },
  {
    "cast": "Studánka (část)",
    "psc": "53301",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53301 Pardubice Studanka (cast)"
  },
  {
    "cast": "Studánky",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34506 Vseruby Studanky"
  },
  {
    "cast": "Studánky",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Vyšší Brod",
    "val": "38273 Vyssi Brod Studanky"
  },
  {
    "cast": "Studce",
    "psc": "28937",
    "okres": "Nymburk",
    "obec": "Loučeň",
    "val": "28937 Loucen Studce"
  },
  {
    "cast": "Studečky",
    "psc": "28937",
    "okres": "Nymburk",
    "obec": "Loučeň",
    "val": "28937 Loucen Studecky"
  },
  {
    "cast": "Studená",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Studená",
    "val": "33141 Studena Studena"
  },
  {
    "cast": "Studená",
    "psc": "37856",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37856 Studena Studena"
  },
  {
    "cast": "Studená Loučka",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Mohelnice",
    "val": "78985 Mohelnice Studena Loucka"
  },
  {
    "cast": "Studená Voda",
    "psc": "54974",
    "okres": "Náchod",
    "obec": "Božanov",
    "val": "54974 Bozanov Studena Voda"
  },
  {
    "cast": "Studená Voda",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Zaječice",
    "val": "53851 Zajecice Studena Voda"
  },
  {
    "cast": "Studeňany",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Radim",
    "val": "50713 Radim Studenany"
  },
  {
    "cast": "Studené",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Jílové u Prahy",
    "val": "25401 Jilove u Prahy Studene"
  },
  {
    "cast": "Studené",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Studené",
    "val": "56164 Studene Studene"
  },
  {
    "cast": "Studenec",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Nicov",
    "val": "38473 Nicov Studenec"
  },
  {
    "cast": "Studenec",
    "psc": "67502",
    "okres": "Třebíč",
    "obec": "Studenec",
    "val": "67502 Studenec Studenec"
  },
  {
    "cast": "Studenec",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Studenec"
  },
  {
    "cast": "Studenec",
    "psc": "51233",
    "okres": "Semily",
    "obec": "Studenec",
    "val": "51233 Studenec Studenec"
  },
  {
    "cast": "Studenec",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Svojanov",
    "val": "56992 Svojanov Studenec"
  },
  {
    "cast": "Studenec",
    "psc": "79816",
    "okres": "Prostějov",
    "obec": "Čelechovice na Hané",
    "val": "79816 Celechovice na Hane Studenec"
  },
  {
    "cast": "Studenec (část)",
    "psc": "35707",
    "okres": "Sokolov",
    "obec": "Oloví",
    "val": "35707 Olovi Studenec (cast)"
  },
  {
    "cast": "Studenec (část)",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Oloví",
    "val": "35709 Olovi Studenec (cast)"
  },
  {
    "cast": "Studeněves",
    "psc": "27379",
    "okres": "Kladno",
    "obec": "Studeněves",
    "val": "27379 Studeneves Studeneves"
  },
  {
    "cast": "Studénka",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Studenka"
  },
  {
    "cast": "Studénka",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Štoky",
    "val": "58253 Stoky Studenka"
  },
  {
    "cast": "Studénka",
    "psc": "74213",
    "okres": "Nový Jičín",
    "obec": "Studénka",
    "val": "74213 Studenka Studenka"
  },
  {
    "cast": "Studénka",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Studenka"
  },
  {
    "cast": "Studénky",
    "psc": "58831",
    "okres": "Jihlava",
    "obec": "Puklice",
    "val": "58831 Puklice Studenky"
  },
  {
    "cast": "Studenov",
    "psc": "51244",
    "okres": "Semily",
    "obec": "Rokytnice nad Jizerou",
    "val": "51244 Rokytnice nad Jizerou Studenov"
  },
  {
    "cast": "Studený",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Kunratice",
    "val": "40502 Kunratice Studeny"
  },
  {
    "cast": "Studený",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Studený",
    "val": "25768 Studeny Studeny"
  },
  {
    "cast": "Studený Zejf",
    "psc": "79082",
    "okres": "Jeseník",
    "obec": "Písečná",
    "val": "79082 Pisecna Studeny Zejf"
  },
  {
    "cast": "Studnice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Telč",
    "val": "58856 Telc Studnice"
  },
  {
    "cast": "Studnice",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Studnice",
    "val": "67503 Studnice Studnice"
  },
  {
    "cast": "Studnice",
    "psc": "54948",
    "okres": "Náchod",
    "obec": "Studnice",
    "val": "54948 Studnice Studnice"
  },
  {
    "cast": "Studnice",
    "psc": "68308",
    "okres": "Vyškov",
    "obec": "Studnice",
    "val": "68308 Studnice Studnice"
  },
  {
    "cast": "Studnice",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Studnice",
    "val": "53901 Studnice Studnice"
  },
  {
    "cast": "Studnice",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Lodhéřov",
    "val": "37701 Lodherov Studnice"
  },
  {
    "cast": "Studnice",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Nové Město na Moravě",
    "val": "59231 Nove Mesto na Morave Studnice"
  },
  {
    "cast": "Stuchanov",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Stuchanov"
  },
  {
    "cast": "Stupárovice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Golčův Jeníkov",
    "val": "58282 Golcuv Jenikov Stuparovice"
  },
  {
    "cast": "Stupava",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Stupava",
    "val": "68601 Stupava Stupava"
  },
  {
    "cast": "Stupčice",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Mezno",
    "val": "25786 Mezno Stupcice"
  },
  {
    "cast": "Stupešice",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Běhařovice",
    "val": "67140 Beharovice Stupesice"
  },
  {
    "cast": "Stupice",
    "psc": "25084",
    "okres": "Praha-východ",
    "obec": "Sibřina",
    "val": "25084 Sibrina Stupice"
  },
  {
    "cast": "Stupná",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Vidochov",
    "val": "50782 Vidochov Stupna"
  },
  {
    "cast": "Stupná",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Stupna"
  },
  {
    "cast": "Stupno",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Břasy",
    "val": "33824 Brasy Stupno"
  },
  {
    "cast": "Stvolínecké Petrovice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Stvolínky",
    "val": "47002 Stvolinky Stvolinecke Petrovice"
  },
  {
    "cast": "Stvolínky",
    "psc": "47102",
    "okres": "Česká Lípa",
    "obec": "Stvolínky",
    "val": "47102 Stvolinky Stvolinky"
  },
  {
    "cast": "Stvolny",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Stvolny"
  },
  {
    "cast": "Stvolová",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Stvolová",
    "val": "67961 Stvolova Stvolova"
  },
  {
    "cast": "Styrov",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Červený Újezd",
    "val": "25789 Cerveny Ujezd Styrov"
  },
  {
    "cast": "Stýskaly",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Žilov",
    "val": "33011 Zilov Styskaly"
  },
  {
    "cast": "Sudějov",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Sudějov",
    "val": "28504 Sudejov Sudejov"
  },
  {
    "cast": "Sudice",
    "psc": "74725",
    "okres": "Opava",
    "obec": "Sudice",
    "val": "74725 Sudice Sudice"
  },
  {
    "cast": "Sudice",
    "psc": "67573",
    "okres": "Třebíč",
    "obec": "Sudice",
    "val": "67573 Sudice Sudice"
  },
  {
    "cast": "Sudice",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Sudice",
    "val": "68001 Sudice Sudice"
  },
  {
    "cast": "Sudín",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bačetín",
    "val": "51801 Bacetin Sudin"
  },
  {
    "cast": "Sudislav nad Orlicí",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Sudislav nad Orlicí",
    "val": "56201 Sudislav nad Orlici Sudislav nad Orlici"
  },
  {
    "cast": "Sudislavice",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Sudislavice"
  },
  {
    "cast": "Sudkov",
    "psc": "78821",
    "okres": "Šumperk",
    "obec": "Sudkov",
    "val": "78821 Sudkov Sudkov"
  },
  {
    "cast": "Sudkovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Miloňovice",
    "val": "38601 Milonovice Sudkovice"
  },
  {
    "cast": "Sudkův Důl",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Obrataň",
    "val": "39501 Obratan Sudkuv Dul"
  },
  {
    "cast": "Sudličkova Lhota",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Mostek",
    "val": "56501 Mostek Sudlickova Lhota"
  },
  {
    "cast": "Sudoměř",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Čejetice",
    "val": "38601 Cejetice Sudomer"
  },
  {
    "cast": "Sudoměř (část)",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Sudoměř",
    "val": "29426 Sudomer Sudomer (cast)"
  },
  {
    "cast": "Sudoměř (část)",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Sudoměř",
    "val": "29425 Sudomer Sudomer (cast)"
  },
  {
    "cast": "Sudoměřice u Bechyně (část)",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Sudoměřice u Bechyně",
    "val": "39165 Sudomerice u Bechyne Sudomerice u Bechyne (cast)"
  },
  {
    "cast": "Sudoměřice u Bechyně (část)",
    "psc": "39172",
    "okres": "Tábor",
    "obec": "Sudoměřice u Bechyně",
    "val": "39172 Sudomerice u Bechyne Sudomerice u Bechyne (cast)"
  },
  {
    "cast": "Sudoměřice u Tábora",
    "psc": "39136",
    "okres": "Tábor",
    "obec": "Sudoměřice u Tábora",
    "val": "39136 Sudomerice u Tabora Sudomerice u Tabora"
  },
  {
    "cast": "Sudoměřice (část)",
    "psc": "69662",
    "okres": "Hodonín",
    "obec": "Sudoměřice",
    "val": "69662 Sudomerice Sudomerice (cast)"
  },
  {
    "cast": "Sudoměřice (část)",
    "psc": "69666",
    "okres": "Hodonín",
    "obec": "Sudoměřice",
    "val": "69666 Sudomerice Sudomerice (cast)"
  },
  {
    "cast": "Sudovice",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Nový Knín",
    "val": "26203 Novy Knin Sudovice"
  },
  {
    "cast": "Sudovo Hlavno",
    "psc": "29476",
    "okres": "Praha-východ",
    "obec": "Sudovo Hlavno",
    "val": "29476 Sudovo Hlavno Sudovo Hlavno"
  },
  {
    "cast": "Sudslava",
    "psc": "56113",
    "okres": "Ústí nad Orlicí",
    "obec": "Sudslava",
    "val": "56113 Sudslava Sudslava"
  },
  {
    "cast": "Sudslavice",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Sudslavice"
  },
  {
    "cast": "Suhrovice",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Suhrovice"
  },
  {
    "cast": "Suchá",
    "psc": "58833",
    "okres": "Jihlava",
    "obec": "Suchá",
    "val": "58833 Sucha Sucha"
  },
  {
    "cast": "Suchá",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Sucha"
  },
  {
    "cast": "Suchá",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34201 Hlavnovice Sucha"
  },
  {
    "cast": "Suchá",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36221 Nejdek Sucha"
  },
  {
    "cast": "Suchá",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Nechanice",
    "val": "50315 Nechanice Sucha"
  },
  {
    "cast": "Suchá",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Jáchymov",
    "val": "36301 Jachymov Sucha"
  },
  {
    "cast": "Suchá",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Stebno",
    "val": "40002 Stebno Sucha"
  },
  {
    "cast": "Suchá",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Sucha"
  },
  {
    "cast": "Suchá Lhota",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Suchá Lhota",
    "val": "57001 Sucha Lhota Sucha Lhota"
  },
  {
    "cast": "Suchá Loz",
    "psc": "68753",
    "okres": "Uherské Hradiště",
    "obec": "Suchá Loz",
    "val": "68753 Sucha Loz Sucha Loz"
  },
  {
    "cast": "Suchá Rudná",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Světlá Hora",
    "val": "79331 Svetla Hora Sucha Rudna"
  },
  {
    "cast": "Suchá Rybná",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Svídnice",
    "val": "51741 Svidnice Sucha Rybna"
  },
  {
    "cast": "Suchdol",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Křimov",
    "val": "43001 Krimov Suchdol"
  },
  {
    "cast": "Suchdol",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Bujanov",
    "val": "38241 Bujanov Suchdol"
  },
  {
    "cast": "Suchdol",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Prosenická Lhota",
    "val": "26401 Prosenicka Lhota Suchdol"
  },
  {
    "cast": "Suchdol",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Kunžak",
    "val": "37853 Kunzak Suchdol"
  },
  {
    "cast": "Suchdol",
    "psc": "16500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16500 Praha Suchdol"
  },
  {
    "cast": "Suchdol",
    "psc": "79845",
    "okres": "Prostějov",
    "obec": "Suchdol",
    "val": "79845 Suchdol Suchdol"
  },
  {
    "cast": "Suchdol",
    "psc": "28502",
    "okres": "Kutná Hora",
    "obec": "Suchdol",
    "val": "28502 Suchdol Suchdol"
  },
  {
    "cast": "Suchdol",
    "psc": "67913",
    "okres": "Blansko",
    "obec": "Vavřinec",
    "val": "67913 Vavrinec Suchdol"
  },
  {
    "cast": "Suchdol nad Lužnicí",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Suchdol nad Lužnicí",
    "val": "37806 Suchdol nad Luznici Suchdol nad Luznici"
  },
  {
    "cast": "Suchdol nad Odrou",
    "psc": "74201",
    "okres": "Nový Jičín",
    "obec": "Suchdol nad Odrou",
    "val": "74201 Suchdol nad Odrou Suchdol nad Odrou"
  },
  {
    "cast": "Suché",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Modlany",
    "val": "41501 Modlany Suche"
  },
  {
    "cast": "Suché Lazce",
    "psc": "74795",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74795 Opava Suche Lazce"
  },
  {
    "cast": "Suchodol",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Suchodol",
    "val": "26101 Suchodol Suchodol"
  },
  {
    "cast": "Suchohrdly",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Suchohrdly",
    "val": "66902 Suchohrdly Suchohrdly"
  },
  {
    "cast": "Suchohrdly u Miroslavi",
    "psc": "67172",
    "okres": "Znojmo",
    "obec": "Suchohrdly u Miroslavi",
    "val": "67172 Suchohrdly u Miroslavi Suchohrdly u Miroslavi"
  },
  {
    "cast": "Suchomasty",
    "psc": "26722",
    "okres": "Beroun",
    "obec": "Suchomasty",
    "val": "26722 Suchomasty Suchomasty"
  },
  {
    "cast": "Suchonice",
    "psc": "78357",
    "okres": "Olomouc",
    "obec": "Suchonice",
    "val": "78357 Suchonice Suchonice"
  },
  {
    "cast": "Suchov (část)",
    "psc": "69674",
    "okres": "Hodonín",
    "obec": "Suchov",
    "val": "69674 Suchov Suchov (cast)"
  },
  {
    "cast": "Suchov (část)",
    "psc": "69671",
    "okres": "Hodonín",
    "obec": "Suchov",
    "val": "69671 Suchov Suchov (cast)"
  },
  {
    "cast": "Suchovršice",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Suchovršice",
    "val": "54232 Suchovrsice Suchovrsice"
  },
  {
    "cast": "Suchý",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Suchý",
    "val": "68001 Suchy Suchy"
  },
  {
    "cast": "Suchý Důl",
    "psc": "54962",
    "okres": "Náchod",
    "obec": "Suchý Důl",
    "val": "54962 Suchy Dul Suchy Dul"
  },
  {
    "cast": "Suchý Důl",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Suchy Dul"
  },
  {
    "cast": "Suchý Kámen",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Chudenín",
    "val": "34022 Chudenin Suchy Kamen"
  },
  {
    "cast": "Sukorady",
    "psc": "41162",
    "okres": "Litoměřice",
    "obec": "Snědovice",
    "val": "41162 Snedovice Sukorady"
  },
  {
    "cast": "Sukorady",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Sukorady",
    "val": "50801 Sukorady Sukorady"
  },
  {
    "cast": "Sukorady",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Sukorady",
    "val": "29406 Sukorady Sukorady"
  },
  {
    "cast": "Suky",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Ostrov nad Oslavou",
    "val": "59101 Ostrov nad Oslavou Suky"
  },
  {
    "cast": "Sulec",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Toužetín",
    "val": "44001 Touzetin Sulec"
  },
  {
    "cast": "Sulejovice",
    "psc": "41111",
    "okres": "Litoměřice",
    "obec": "Sulejovice",
    "val": "41111 Sulejovice Sulejovice"
  },
  {
    "cast": "Suletice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Homole u Panny",
    "val": "40002 Homole u Panny Suletice"
  },
  {
    "cast": "Sulice",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Sulice",
    "val": "25168 Sulice Sulice"
  },
  {
    "cast": "Sulíkov",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Sulíkov",
    "val": "67962 Sulikov Sulikov"
  },
  {
    "cast": "Sulimov",
    "psc": "76821",
    "okres": "Kroměříž",
    "obec": "Sulimov",
    "val": "76821 Sulimov Sulimov"
  },
  {
    "cast": "Sulislav",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Sulislav",
    "val": "34901 Sulislav Sulislav"
  },
  {
    "cast": "Sulkovec",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Sulkovec",
    "val": "59265 Sulkovec Sulkovec"
  },
  {
    "cast": "Sulovice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Svatý Mikuláš",
    "val": "28401 Svaty Mikulas Sulovice"
  },
  {
    "cast": "Sumrakov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Sumrakov"
  },
  {
    "cast": "Supíkovice",
    "psc": "79051",
    "okres": "Jeseník",
    "obec": "Supíkovice",
    "val": "79051 Supikovice Supikovice"
  },
  {
    "cast": "Suš",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Bohdalovice",
    "val": "38101 Bohdalovice Sus"
  },
  {
    "cast": "Sušany",
    "psc": "43114",
    "okres": "Chomutov",
    "obec": "Strupčice",
    "val": "43114 Strupcice Susany"
  },
  {
    "cast": "Sušetice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Susetice"
  },
  {
    "cast": "Sušice",
    "psc": "75111",
    "okres": "Přerov",
    "obec": "Sušice",
    "val": "75111 Susice Susice"
  },
  {
    "cast": "Sušice",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Susice"
  },
  {
    "cast": "Sušice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47002 Duba Susice"
  },
  {
    "cast": "Sušice",
    "psc": "68704",
    "okres": "Uherské Hradiště",
    "obec": "Sušice",
    "val": "68704 Susice Susice"
  },
  {
    "cast": "Sušice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Míčov-Sušice",
    "val": "53803 Micov-Susice Susice"
  },
  {
    "cast": "Sušice",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Moravská Třebová",
    "val": "57101 Moravska Trebova Susice"
  },
  {
    "cast": "Sušice I",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Susice I"
  },
  {
    "cast": "Sušice II",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Susice II"
  },
  {
    "cast": "Sušice III",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Susice III"
  },
  {
    "cast": "Sušno",
    "psc": "29479",
    "okres": "Mladá Boleslav",
    "obec": "Kropáčova Vrutice",
    "val": "29479 Kropacova Vrutice Susno"
  },
  {
    "cast": "Sutice",
    "psc": "51201",
    "okres": "Semily",
    "obec": "Slaná",
    "val": "51201 Slana Sutice"
  },
  {
    "cast": "Sutom",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41115 Trebenice Sutom"
  },
  {
    "cast": "Svádov",
    "psc": "40322",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40322 Usti nad Labem Svadov"
  },
  {
    "cast": "Svahová",
    "psc": "43121",
    "okres": "Chomutov",
    "obec": "Boleboř",
    "val": "43121 Bolebor Svahova"
  },
  {
    "cast": "Svahy",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Svahy"
  },
  {
    "cast": "Svachova Lhotka",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mirkovice",
    "val": "38232 Mirkovice Svachova Lhotka"
  },
  {
    "cast": "Svárkov",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Letiny",
    "val": "33601 Letiny Svarkov"
  },
  {
    "cast": "Svárov",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Svárov",
    "val": "27351 Svarov Svarov"
  },
  {
    "cast": "Svárov",
    "psc": "46001",
    "okres": "Liberec",
    "obec": "Stráž nad Nisou",
    "val": "46001 Straz nad Nisou Svarov"
  },
  {
    "cast": "Svárov",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Velké Opatovice",
    "val": "67963 Velke Opatovice Svarov"
  },
  {
    "cast": "Svárov",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Svárov",
    "val": "68712 Svarov Svarov"
  },
  {
    "cast": "Svaryšov",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Radošovice",
    "val": "38701 Radosovice Svarysov"
  },
  {
    "cast": "Svařeň",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Svaren"
  },
  {
    "cast": "Svařenice",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Vrutice",
    "val": "41301 Vrutice Svarenice"
  },
  {
    "cast": "Svařenov",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Meziříčí",
    "val": "59401 Velke Mezirici Svarenov"
  },
  {
    "cast": "Svatá",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Svatá",
    "val": "26751 Svata Svata"
  },
  {
    "cast": "Svatá Anna",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Oslov",
    "val": "39701 Oslov Svata Anna"
  },
  {
    "cast": "Svatá Anna",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Vlčeves",
    "val": "39201 Vlceves Svata Anna"
  },
  {
    "cast": "Svatá Anna",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Svata Anna"
  },
  {
    "cast": "Svatá Barbora",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Radnice",
    "val": "33828 Radnice Svata Barbora"
  },
  {
    "cast": "Svatá Kateřina",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Rozvadov",
    "val": "34806 Rozvadov Svata Katerina"
  },
  {
    "cast": "Svatá Kateřina",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Chudenín",
    "val": "34022 Chudenin Svata Katerina"
  },
  {
    "cast": "Svatá Kateřina",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Šebrov-Kateřina",
    "val": "67801 Sebrov-Katerina Svata Katerina"
  },
  {
    "cast": "Svatá Kateřina",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Svatý Mikuláš",
    "val": "28401 Svaty Mikulas Svata Katerina"
  },
  {
    "cast": "Svatá Maří",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Svatá Maří",
    "val": "38501 Svata Mari Svata Mari"
  },
  {
    "cast": "Svatava",
    "psc": "39494",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39494 Cernovice Svatava"
  },
  {
    "cast": "Svatava (část)",
    "psc": "35703",
    "okres": "Sokolov",
    "obec": "Svatava",
    "val": "35703 Svatava Svatava (cast)"
  },
  {
    "cast": "Svatava (část)",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Svatava",
    "val": "35601 Svatava Svatava (cast)"
  },
  {
    "cast": "Svatbín",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Kostelec nad Černými lesy",
    "val": "28163 Kostelec nad Cernymi lesy Svatbin"
  },
  {
    "cast": "Svaté Pole",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Svaté Pole",
    "val": "26301 Svate Pole Svate Pole"
  },
  {
    "cast": "Svaté Pole",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Horažďovice",
    "val": "34101 Horazdovice Svate Pole"
  },
  {
    "cast": "Svatkovice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Svatkovice"
  },
  {
    "cast": "Svatobor",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Doupovské Hradiště",
    "val": "36272 Doupovske Hradiste Svatobor"
  },
  {
    "cast": "Svatobořice",
    "psc": "69604",
    "okres": "Hodonín",
    "obec": "Svatobořice-Mistřín",
    "val": "69604 Svatoborice-Mistrin Svatoborice"
  },
  {
    "cast": "Svatogothardská Lhota",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Hořice",
    "val": "50801 Horice Svatogothardska Lhota"
  },
  {
    "cast": "Svatojanský Újezd",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Svatojanský Újezd",
    "val": "50781 Svatojansky Ujezd Svatojansky Ujezd"
  },
  {
    "cast": "Svatonice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Záhoří",
    "val": "39701 Zahori Svatonice"
  },
  {
    "cast": "Svatoňovice",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Karlovice",
    "val": "51101 Karlovice Svatonovice"
  },
  {
    "cast": "Svatoňovice",
    "psc": "74787",
    "okres": "Opava",
    "obec": "Svatoňovice",
    "val": "74787 Svatonovice Svatonovice"
  },
  {
    "cast": "Svatoslav",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Svatoslav",
    "val": "67507 Svatoslav Svatoslav"
  },
  {
    "cast": "Svatoslav",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Svatoslav",
    "val": "66601 Svatoslav Svatoslav"
  },
  {
    "cast": "Svatoslav",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Luka nad Jihlavou",
    "val": "58822 Luka nad Jihlavou Svatoslav"
  },
  {
    "cast": "Svatý Hubert",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Drahouš",
    "val": "27033 Drahous Svaty Hubert"
  },
  {
    "cast": "Svatý Jan",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Svaty Jan"
  },
  {
    "cast": "Svatý Jan",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Svatý Jan",
    "val": "26256 Svaty Jan Svaty Jan"
  },
  {
    "cast": "Svatý Jan nad Malší (část)",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Svatý Jan nad Malší",
    "val": "37401 Svaty Jan nad Malsi Svaty Jan nad Malsi (cast)"
  },
  {
    "cast": "Svatý Jan nad Malší (část)",
    "psc": "37323",
    "okres": "České Budějovice",
    "obec": "Svatý Jan nad Malší",
    "val": "37323 Svaty Jan nad Malsi Svaty Jan nad Malsi (cast)"
  },
  {
    "cast": "Svatý Jan pod Skalou",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Svatý Jan pod Skalou",
    "val": "26601 Svaty Jan pod Skalou Svaty Jan pod Skalou"
  },
  {
    "cast": "Svatý Jan t. Krsovice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28504 Chlistovice Svaty Jan t. Krsovice"
  },
  {
    "cast": "Svatý Jiří",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Svatý Jiří",
    "val": "56501 Svaty Jiri Svaty Jiri"
  },
  {
    "cast": "Svatý Kopeček",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Svaty Kopecek"
  },
  {
    "cast": "Svatý Kříž",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Svaty Kriz"
  },
  {
    "cast": "Svatý Mikuláš",
    "psc": "56542",
    "okres": "Ústí nad Orlicí",
    "obec": "Vraclav",
    "val": "56542 Vraclav Svaty Mikulas"
  },
  {
    "cast": "Svatý Mikuláš",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Svaty Mikulas"
  },
  {
    "cast": "Svatý Mikuláš",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Svatý Mikuláš",
    "val": "28401 Svaty Mikulas Svaty Mikulas"
  },
  {
    "cast": "Svatý Štěpán",
    "psc": "76334",
    "okres": "Zlín",
    "obec": "Brumov-Bylnice",
    "val": "76334 Brumov-Bylnice Svaty Stepan"
  },
  {
    "cast": "Svébohov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Svébohov",
    "val": "78901 Svebohov Svebohov"
  },
  {
    "cast": "Svébohy",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Svebohy"
  },
  {
    "cast": "Svébořice",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Ralsko",
    "val": "47124 Ralsko Sveborice"
  },
  {
    "cast": "Svémyslice",
    "psc": "25091",
    "okres": "Praha-východ",
    "obec": "Svémyslice",
    "val": "25091 Svemyslice Svemyslice"
  },
  {
    "cast": "Svépravice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Svépravice",
    "val": "39301 Svepravice Svepravice"
  },
  {
    "cast": "Svéradice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Svéradice",
    "val": "34101 Sveradice Sveradice"
  },
  {
    "cast": "Svéraz (část)",
    "psc": "38211",
    "okres": "Český Krumlov",
    "obec": "Bohdalovice",
    "val": "38211 Bohdalovice Sveraz (cast)"
  },
  {
    "cast": "Svéraz (část)",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Bohdalovice",
    "val": "38101 Bohdalovice Sveraz (cast)"
  },
  {
    "cast": "Svésedlice",
    "psc": "78354",
    "okres": "Olomouc",
    "obec": "Svésedlice",
    "val": "78354 Svesedlice Svesedlice"
  },
  {
    "cast": "Světce",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Svetce"
  },
  {
    "cast": "Světce",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Světce",
    "val": "37821 Svetce Svetce"
  },
  {
    "cast": "Světec",
    "psc": "41753",
    "okres": "Teplice",
    "obec": "Světec",
    "val": "41753 Svetec Svetec"
  },
  {
    "cast": "Světec",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Svetec"
  },
  {
    "cast": "Světí",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Světí",
    "val": "50312 Sveti Sveti"
  },
  {
    "cast": "Světice",
    "psc": "41761",
    "okres": "Teplice",
    "obec": "Bystřany",
    "val": "41761 Bystrany Svetice"
  },
  {
    "cast": "Světice",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Světice",
    "val": "25101 Svetice Svetice"
  },
  {
    "cast": "Světlá",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Slaná",
    "val": "51301 Slana Svetla"
  },
  {
    "cast": "Světlá",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Svetla"
  },
  {
    "cast": "Světlá",
    "psc": "79331",
    "okres": "Bruntál",
    "obec": "Světlá Hora",
    "val": "79331 Svetla Hora Svetla"
  },
  {
    "cast": "Světlá",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Svetla"
  },
  {
    "cast": "Světlá",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Lhota pod Hořičkami",
    "val": "55205 Lhota pod Horickami Svetla"
  },
  {
    "cast": "Světlá",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Louňovice pod Blaníkem",
    "val": "25706 Lounovice pod Blanikem Svetla"
  },
  {
    "cast": "Světlá",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Žďár nad Orlicí",
    "val": "51721 Zdar nad Orlici Svetla"
  },
  {
    "cast": "Světlá nad Sázavou",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Svetla nad Sazavou"
  },
  {
    "cast": "Světlá pod Ještědem",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Světlá pod Ještědem",
    "val": "46343 Svetla pod Jestedem Svetla pod Jestedem"
  },
  {
    "cast": "Světlá (část)",
    "psc": "67935",
    "okres": "Blansko",
    "obec": "Světlá",
    "val": "67935 Svetla Svetla (cast)"
  },
  {
    "cast": "Světlá (část)",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Světlá",
    "val": "67963 Svetla Svetla (cast)"
  },
  {
    "cast": "Světlice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Svetlice"
  },
  {
    "cast": "Světlický Dvůr",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Svetlicky Dvur"
  },
  {
    "cast": "Světlík",
    "psc": "38216",
    "okres": "Český Krumlov",
    "obec": "Světlík",
    "val": "38216 Svetlik Svetlik"
  },
  {
    "cast": "Světlík",
    "psc": "40757",
    "okres": "Děčín",
    "obec": "Horní Podluží",
    "val": "40757 Horni Podluzi Svetlik"
  },
  {
    "cast": "Světliny 1.díl",
    "psc": "40752",
    "okres": "Děčín",
    "obec": "Varnsdorf",
    "val": "40752 Varnsdorf Svetliny 1.dil"
  },
  {
    "cast": "Světliny 2.díl",
    "psc": "40755",
    "okres": "Děčín",
    "obec": "Dolní Podluží",
    "val": "40755 Dolni Podluzi Svetliny 2.dil"
  },
  {
    "cast": "Světnov",
    "psc": "59102",
    "okres": "Žďár nad Sázavou",
    "obec": "Světnov",
    "val": "59102 Svetnov Svetnov"
  },
  {
    "cast": "Světví",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Svetvi"
  },
  {
    "cast": "Sviadnov",
    "psc": "73925",
    "okres": "Frýdek-Místek",
    "obec": "Sviadnov",
    "val": "73925 Sviadnov Sviadnov"
  },
  {
    "cast": "Svídnice",
    "psc": "28901",
    "okres": "Nymburk",
    "obec": "Dymokury",
    "val": "28901 Dymokury Svidnice"
  },
  {
    "cast": "Svídnice",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Svídnice",
    "val": "51741 Svidnice Svidnice"
  },
  {
    "cast": "Svídnice (část)",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Svídnice",
    "val": "53821 Svidnice Svidnice (cast)"
  },
  {
    "cast": "Svídnice (část)",
    "psc": "53824",
    "okres": "Chrudim",
    "obec": "Svídnice",
    "val": "53824 Svidnice Svidnice (cast)"
  },
  {
    "cast": "Svijanský Újezd",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Svijanský Újezd",
    "val": "46345 Svijansky Ujezd Svijansky Ujezd"
  },
  {
    "cast": "Svijany",
    "psc": "46346",
    "okres": "Liberec",
    "obec": "Svijany",
    "val": "46346 Svijany Svijany"
  },
  {
    "cast": "Svinary (část)",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Svinary (cast)"
  },
  {
    "cast": "Svinary (část)",
    "psc": "50009",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50009 Hradec Kralove Svinary (cast)"
  },
  {
    "cast": "Svinaře (část)",
    "psc": "25230",
    "okres": "Beroun",
    "obec": "Svinaře",
    "val": "25230 Svinare Svinare (cast)"
  },
  {
    "cast": "Svinaře (část)",
    "psc": "26728",
    "okres": "Beroun",
    "obec": "Svinaře",
    "val": "26728 Svinare Svinare (cast)"
  },
  {
    "cast": "Svinařov",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Slabce",
    "val": "27041 Slabce Svinarov"
  },
  {
    "cast": "Svinařov",
    "psc": "27305",
    "okres": "Kladno",
    "obec": "Svinařov",
    "val": "27305 Svinarov Svinarov"
  },
  {
    "cast": "Svinčany",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Svinčany",
    "val": "53501 Svincany Svincany"
  },
  {
    "cast": "Svinčice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Lužice",
    "val": "43401 Luzice Svincice"
  },
  {
    "cast": "Svinětice",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Bavorov",
    "val": "38773 Bavorov Svinetice"
  },
  {
    "cast": "Svinišťany",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Dolany",
    "val": "55204 Dolany Svinistany"
  },
  {
    "cast": "Svinky",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Vlastiboř",
    "val": "39201 Vlastibor Svinky"
  },
  {
    "cast": "Svinná",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Vranov",
    "val": "34901 Vranov Svinna"
  },
  {
    "cast": "Svinná",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Hlohovice",
    "val": "33808 Hlohovice Svinna"
  },
  {
    "cast": "Svinná",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "33901 Cachrov Svinna"
  },
  {
    "cast": "Svinná",
    "psc": "56002",
    "okres": "Ústí nad Orlicí",
    "obec": "Česká Třebová",
    "val": "56002 Ceska Trebova Svinna"
  },
  {
    "cast": "Svinná",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34525 Horsovsky Tyn Svinna"
  },
  {
    "cast": "Svinná Lada",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Borová Lada",
    "val": "38501 Borova Lada Svinna Lada"
  },
  {
    "cast": "Svinná (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51801 Skuhrov nad Belou Svinna (cast)"
  },
  {
    "cast": "Svinná (část)",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Skuhrov nad Bělou",
    "val": "51703 Skuhrov nad Belou Svinna (cast)"
  },
  {
    "cast": "Svinný",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Chotěboř",
    "val": "58301 Chotebor Svinny"
  },
  {
    "cast": "Sviňomazy",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Trpísty",
    "val": "34901 Trpisty Svinomazy"
  },
  {
    "cast": "Svinošice",
    "psc": "67922",
    "okres": "Blansko",
    "obec": "Svinošice",
    "val": "67922 Svinosice Svinosice"
  },
  {
    "cast": "Svinov",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Útvina",
    "val": "36401 Utvina Svinov"
  },
  {
    "cast": "Svinov (část)",
    "psc": "72100",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72100 Ostrava Svinov (cast)"
  },
  {
    "cast": "Svinov (část)",
    "psc": "72525",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72525 Ostrava Svinov (cast)"
  },
  {
    "cast": "Sviňovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Zbytiny",
    "val": "38301 Zbytiny Svinovice"
  },
  {
    "cast": "Sviny",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Sviny",
    "val": "39181 Sviny Sviny"
  },
  {
    "cast": "Sviny (část)",
    "psc": "59451",
    "okres": "Žďár nad Sázavou",
    "obec": "Sviny",
    "val": "59451 Sviny Sviny (cast)"
  },
  {
    "cast": "Sviny (část)",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Sviny",
    "val": "59401 Sviny Sviny (cast)"
  },
  {
    "cast": "Svitava",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Cvikov",
    "val": "47301 Cvikov Svitava"
  },
  {
    "cast": "Svitávka (část)",
    "psc": "67932",
    "okres": "Blansko",
    "obec": "Svitávka",
    "val": "67932 Svitavka Svitavka (cast)"
  },
  {
    "cast": "Svitávka (část)",
    "psc": "67931",
    "okres": "Blansko",
    "obec": "Svitávka",
    "val": "67931 Svitavka Svitavka (cast)"
  },
  {
    "cast": "Svítkov (část)",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Svitkov (cast)"
  },
  {
    "cast": "Svítkov (část)",
    "psc": "53006",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53006 Pardubice Svitkov (cast)"
  },
  {
    "cast": "Svoboda",
    "psc": "74728",
    "okres": "Opava",
    "obec": "Štěpánkovice",
    "val": "74728 Stepankovice Svoboda"
  },
  {
    "cast": "Svoboda nad Úpou",
    "psc": "54224",
    "okres": "Trutnov",
    "obec": "Svoboda nad Úpou",
    "val": "54224 Svoboda nad Upou Svoboda nad Upou"
  },
  {
    "cast": "Svobodín",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Bousov",
    "val": "29404 Dolni Bousov Svobodin"
  },
  {
    "cast": "Svobodka",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Halže",
    "val": "34701 Halze Svobodka"
  },
  {
    "cast": "Svobodka",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Myštice",
    "val": "38801 Mystice Svobodka"
  },
  {
    "cast": "Svobodná Ves",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Horka I",
    "val": "28601 Horka I Svobodna Ves"
  },
  {
    "cast": "Svobodné Dvory",
    "psc": "50311",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50311 Hradec Kralove Svobodne Dvory"
  },
  {
    "cast": "Svobodné Hamry",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Svobodne Hamry"
  },
  {
    "cast": "Svobodné Heřmanice",
    "psc": "79312",
    "okres": "Bruntál",
    "obec": "Svobodné Heřmanice",
    "val": "79312 Svobodne Hermanice Svobodne Hermanice"
  },
  {
    "cast": "Svojanov",
    "psc": "78325",
    "okres": "Olomouc",
    "obec": "Bouzov",
    "val": "78325 Bouzov Svojanov"
  },
  {
    "cast": "Svojanov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Borušov",
    "val": "57101 Borusov Svojanov"
  },
  {
    "cast": "Svojanov (část)",
    "psc": "56973",
    "okres": "Svitavy",
    "obec": "Svojanov",
    "val": "56973 Svojanov Svojanov (cast)"
  },
  {
    "cast": "Svojanov (část)",
    "psc": "56992",
    "okres": "Svitavy",
    "obec": "Svojanov",
    "val": "56992 Svojanov Svojanov (cast)"
  },
  {
    "cast": "Svojek",
    "psc": "50791",
    "okres": "Semily",
    "obec": "Svojek",
    "val": "50791 Svojek Svojek"
  },
  {
    "cast": "Svojetice",
    "psc": "25162",
    "okres": "Praha-východ",
    "obec": "Svojetice",
    "val": "25162 Svojetice Svojetice"
  },
  {
    "cast": "Svojetín",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Svojetín",
    "val": "27004 Svojetin Svojetin"
  },
  {
    "cast": "Svojkov",
    "psc": "47153",
    "okres": "Česká Lípa",
    "obec": "Svojkov",
    "val": "47153 Svojkov Svojkov"
  },
  {
    "cast": "Svojkovice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Svojkovice",
    "val": "58856 Svojkovice Svojkovice"
  },
  {
    "cast": "Svojkovice",
    "psc": "33822",
    "okres": "Rokycany",
    "obec": "Svojkovice",
    "val": "33822 Svojkovice Svojkovice"
  },
  {
    "cast": "Svojnice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Strunkovice nad Blanicí",
    "val": "38301 Strunkovice nad Blanici Svojnice"
  },
  {
    "cast": "Svojše",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Svojse"
  },
  {
    "cast": "Svojšice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Svojšice",
    "val": "26272 Svojsice Svojsice"
  },
  {
    "cast": "Svojšice",
    "psc": "28107",
    "okres": "Kolín",
    "obec": "Svojšice",
    "val": "28107 Svojsice Svojsice"
  },
  {
    "cast": "Svojšice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Svojsice"
  },
  {
    "cast": "Svojšice",
    "psc": "53362",
    "okres": "Pardubice",
    "obec": "Svojšice",
    "val": "53362 Svojsice Svojsice"
  },
  {
    "cast": "Svojšín",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Svojšín",
    "val": "34901 Svojsin Svojsin"
  },
  {
    "cast": "Svojšovice",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25163 Strancice Svojsovice"
  },
  {
    "cast": "Svor",
    "psc": "47151",
    "okres": "Česká Lípa",
    "obec": "Svor",
    "val": "47151 Svor Svor"
  },
  {
    "cast": "Svoříž",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Svoriz"
  },
  {
    "cast": "Svrabov",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Svrabov",
    "val": "39131 Svrabov Svrabov"
  },
  {
    "cast": "Svratka",
    "psc": "59202",
    "okres": "Žďár nad Sázavou",
    "obec": "Svratka",
    "val": "59202 Svratka Svratka"
  },
  {
    "cast": "Svratouch",
    "psc": "53942",
    "okres": "Chrudim",
    "obec": "Svratouch",
    "val": "53942 Svratouch Svratouch"
  },
  {
    "cast": "Svrčov",
    "psc": "75125",
    "okres": "Přerov",
    "obec": "Lazníky",
    "val": "75125 Lazniky Svrcov"
  },
  {
    "cast": "Svrčovec",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Svrcovec"
  },
  {
    "cast": "Svrkyně",
    "psc": "25264",
    "okres": "Praha-západ",
    "obec": "Svrkyně",
    "val": "25264 Svrkyne Svrkyne"
  },
  {
    "cast": "Svržno",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Svrzno"
  },
  {
    "cast": "Svučice",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mišovice",
    "val": "39804 Misovice Svucice"
  },
  {
    "cast": "Sýčina",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Dobrovice",
    "val": "29441 Dobrovice Sycina"
  },
  {
    "cast": "Sychotín",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Kunštát",
    "val": "67972 Kunstat Sychotin"
  },
  {
    "cast": "Sychrov",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Rosovice",
    "val": "26301 Rosovice Sychrov"
  },
  {
    "cast": "Sychrov",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Sychrov",
    "val": "46344 Sychrov Sychrov"
  },
  {
    "cast": "Sychrov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Borotín",
    "val": "39133 Borotin Sychrov"
  },
  {
    "cast": "Sychrov",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kozlov",
    "val": "58401 Kozlov Sychrov"
  },
  {
    "cast": "Sychrov",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Sychrov"
  },
  {
    "cast": "Sychrov (část)",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Sychrov (cast)"
  },
  {
    "cast": "Sychrov (část)",
    "psc": "29413",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29413 Mnichovo Hradiste Sychrov (cast)"
  },
  {
    "cast": "Sýkořice",
    "psc": "27024",
    "okres": "Rakovník",
    "obec": "Sýkořice",
    "val": "27024 Sykorice Sykorice"
  },
  {
    "cast": "Sýkořice",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Žernov",
    "val": "51263 Zernov Sykorice"
  },
  {
    "cast": "Sylvárův Újezd",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Ostroměř",
    "val": "50801 Ostromer Sylvaruv Ujezd"
  },
  {
    "cast": "Synalov",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Synalov",
    "val": "67923 Synalov Synalov"
  },
  {
    "cast": "Synčany",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Rosice",
    "val": "53862 Rosice Syncany"
  },
  {
    "cast": "Syneč",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Krupá",
    "val": "28163 Krupa Synec"
  },
  {
    "cast": "Synkov",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Synkov-Slemeno",
    "val": "51601 Synkov-Slemeno Synkov"
  },
  {
    "cast": "Syrov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Syrov",
    "val": "39601 Syrov Syrov"
  },
  {
    "cast": "Syrovátka",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Syrovátka",
    "val": "50327 Syrovatka Syrovatka"
  },
  {
    "cast": "Syrovice",
    "psc": "66467",
    "okres": "Brno-venkov",
    "obec": "Syrovice",
    "val": "66467 Syrovice Syrovice"
  },
  {
    "cast": "Sýrovice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Syrovice"
  },
  {
    "cast": "Syrovín",
    "psc": "69684",
    "okres": "Hodonín",
    "obec": "Syrovín",
    "val": "69684 Syrovin Syrovin"
  },
  {
    "cast": "Syřenov",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Syřenov",
    "val": "51251 Syrenov Syrenov"
  },
  {
    "cast": "Sytno",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Sytno",
    "val": "34901 Sytno Sytno"
  },
  {
    "cast": "Šabina (část)",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Šabina",
    "val": "35601 Sabina Sabina (cast)"
  },
  {
    "cast": "Šabina (část)",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Šabina",
    "val": "35751 Sabina Sabina (cast)"
  },
  {
    "cast": "Šafov",
    "psc": "67106",
    "okres": "Znojmo",
    "obec": "Šafov",
    "val": "67106 Safov Safov"
  },
  {
    "cast": "Šach",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Volfířov",
    "val": "38001 Volfirov Sach"
  },
  {
    "cast": "Šachotín",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Šlapanov",
    "val": "58001 Slapanov Sachotin"
  },
  {
    "cast": "Šachov",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Borohrádek",
    "val": "51721 Borohradek Sachov"
  },
  {
    "cast": "Šakvice",
    "psc": "69167",
    "okres": "Břeclav",
    "obec": "Šakvice",
    "val": "69167 Sakvice Sakvice"
  },
  {
    "cast": "Šalmanovice",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Jílovice",
    "val": "37312 Jilovice Salmanovice"
  },
  {
    "cast": "Šamonice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Samonice"
  },
  {
    "cast": "Šanov",
    "psc": "76321",
    "okres": "Zlín",
    "obec": "Šanov",
    "val": "76321 Sanov Sanov"
  },
  {
    "cast": "Šanov",
    "psc": "27031",
    "okres": "Rakovník",
    "obec": "Šanov",
    "val": "27031 Sanov Sanov"
  },
  {
    "cast": "Šanov",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Červená Voda",
    "val": "56169 Cervena Voda Sanov"
  },
  {
    "cast": "Šanov (část)",
    "psc": "67164",
    "okres": "Znojmo",
    "obec": "Šanov",
    "val": "67164 Sanov Sanov (cast)"
  },
  {
    "cast": "Šanov (část)",
    "psc": "67168",
    "okres": "Znojmo",
    "obec": "Šanov",
    "val": "67168 Sanov Sanov (cast)"
  },
  {
    "cast": "Šanov (část)",
    "psc": "67167",
    "okres": "Znojmo",
    "obec": "Šanov",
    "val": "67167 Sanov Sanov (cast)"
  },
  {
    "cast": "Šanovice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Sanovice"
  },
  {
    "cast": "Šaplava",
    "psc": "50353",
    "okres": "Hradec Králové",
    "obec": "Šaplava",
    "val": "50353 Saplava Saplava"
  },
  {
    "cast": "Šaratice",
    "psc": "68352",
    "okres": "Vyškov",
    "obec": "Šaratice",
    "val": "68352 Saratice Saratice"
  },
  {
    "cast": "Šardice",
    "psc": "69613",
    "okres": "Hodonín",
    "obec": "Šardice",
    "val": "69613 Sardice Sardice"
  },
  {
    "cast": "Šardičky",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Kojátky",
    "val": "68501 Kojatky Sardicky"
  },
  {
    "cast": "Šárovcova Lhota",
    "psc": "50759",
    "okres": "Jičín",
    "obec": "Šárovcova Lhota",
    "val": "50759 Sarovcova Lhota Sarovcova Lhota"
  },
  {
    "cast": "Šarovy",
    "psc": "76351",
    "okres": "Zlín",
    "obec": "Šarovy",
    "val": "76351 Sarovy Sarovy"
  },
  {
    "cast": "Šašovice",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Želetava",
    "val": "67526 Zeletava Sasovice"
  },
  {
    "cast": "Šatov",
    "psc": "67122",
    "okres": "Znojmo",
    "obec": "Šatov",
    "val": "67122 Satov Satov"
  },
  {
    "cast": "Šebanov",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Hořice na Šumavě",
    "val": "38101 Horice na Sumave Sebanov"
  },
  {
    "cast": "Šebáňovice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Sebanovice"
  },
  {
    "cast": "Šeberov",
    "psc": "14900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14900 Praha Seberov"
  },
  {
    "cast": "Šebestěnice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Šebestěnice",
    "val": "28601 Sebestenice Sebestenice"
  },
  {
    "cast": "Šebetov (část)",
    "psc": "67935",
    "okres": "Blansko",
    "obec": "Šebetov",
    "val": "67935 Sebetov Sebetov (cast)"
  },
  {
    "cast": "Šebetov (část)",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Šebetov",
    "val": "67963 Sebetov Sebetov (cast)"
  },
  {
    "cast": "Šebířov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Sebirov"
  },
  {
    "cast": "Šebkovice",
    "psc": "67545",
    "okres": "Třebíč",
    "obec": "Šebkovice",
    "val": "67545 Sebkovice Sebkovice"
  },
  {
    "cast": "Šeborov",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Uhřínov",
    "val": "59401 Uhrinov Seborov"
  },
  {
    "cast": "Šebrov",
    "psc": "67922",
    "okres": "Blansko",
    "obec": "Šebrov-Kateřina",
    "val": "67922 Sebrov-Katerina Sebrov"
  },
  {
    "cast": "Šedivec",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Šedivec",
    "val": "56401 Sedivec Sedivec"
  },
  {
    "cast": "Šediviny",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Dobré",
    "val": "51801 Dobre Sediviny"
  },
  {
    "cast": "Šediviny",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Kounov",
    "val": "51801 Kounov Sediviny"
  },
  {
    "cast": "Šejby",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Sejby"
  },
  {
    "cast": "Šelešovice (část)",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Šelešovice",
    "val": "76802 Selesovice Selesovice (cast)"
  },
  {
    "cast": "Šelešovice (část)",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Šelešovice",
    "val": "76701 Selesovice Selesovice (cast)"
  },
  {
    "cast": "Šemanovice",
    "psc": "27723",
    "okres": "Mělník",
    "obec": "Kokořín",
    "val": "27723 Kokorin Semanovice"
  },
  {
    "cast": "Šemíkovice",
    "psc": "67557",
    "okres": "Třebíč",
    "obec": "Rouchovany",
    "val": "67557 Rouchovany Semikovice"
  },
  {
    "cast": "Šemnice",
    "psc": "36272",
    "okres": "Karlovy Vary",
    "obec": "Šemnice",
    "val": "36272 Semnice Semnice"
  },
  {
    "cast": "Šenov",
    "psc": "73934",
    "okres": "Ostrava-město",
    "obec": "Šenov",
    "val": "73934 Senov Senov"
  },
  {
    "cast": "Šenov u Nového Jičína",
    "psc": "74242",
    "okres": "Nový Jičín",
    "obec": "Šenov u Nového Jičína",
    "val": "74242 Senov u Noveho Jicina Senov u Noveho Jicina"
  },
  {
    "cast": "Šepetely",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebívlice",
    "val": "41115 Trebivlice Sepetely"
  },
  {
    "cast": "Šerchov",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Blatno",
    "val": "43001 Blatno Serchov"
  },
  {
    "cast": "Šerkov",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Lety",
    "val": "39804 Lety Serkov"
  },
  {
    "cast": "Šerkovice",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Šerkovice",
    "val": "66601 Serkovice Serkovice"
  },
  {
    "cast": "Šeřeč",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Provodov-Šonov",
    "val": "55203 Provodov-Sonov Serec"
  },
  {
    "cast": "Šestajovice",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Šestajovice",
    "val": "55101 Sestajovice Sestajovice"
  },
  {
    "cast": "Šestajovice (část)",
    "psc": "25082",
    "okres": "Praha-východ",
    "obec": "Šestajovice",
    "val": "25082 Sestajovice Sestajovice (cast)"
  },
  {
    "cast": "Šestajovice (část)",
    "psc": "25092",
    "okres": "Praha-východ",
    "obec": "Šestajovice",
    "val": "25092 Sestajovice Sestajovice (cast)"
  },
  {
    "cast": "Šetějovice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Šetějovice",
    "val": "25768 Setejovice Setejovice"
  },
  {
    "cast": "Ševětín (část)",
    "psc": "37363",
    "okres": "České Budějovice",
    "obec": "Ševětín",
    "val": "37363 Sevetin Sevetin (cast)"
  },
  {
    "cast": "Ševětín (část)",
    "psc": "37365",
    "okres": "České Budějovice",
    "obec": "Ševětín",
    "val": "37365 Sevetin Sevetin (cast)"
  },
  {
    "cast": "Šibanov",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Poběžovice",
    "val": "34522 Pobezovice Sibanov"
  },
  {
    "cast": "Šidlákov",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Hora Svatého Václava",
    "val": "34522 Hora Svateho Vaclava Sidlakov"
  },
  {
    "cast": "Šidlov",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Zákupy",
    "val": "47301 Zakupy Sidlov"
  },
  {
    "cast": "Šichova Vesec",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Sichova Vesec"
  },
  {
    "cast": "Šilheřovice (část)",
    "psc": "71100",
    "okres": "Opava",
    "obec": "Šilheřovice",
    "val": "71100 Silherovice Silherovice (cast)"
  },
  {
    "cast": "Šilheřovice (část)",
    "psc": "74715",
    "okres": "Opava",
    "obec": "Šilheřovice",
    "val": "74715 Silherovice Silherovice (cast)"
  },
  {
    "cast": "Šimanov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Žihobce",
    "val": "34201 Zihobce Simanov"
  },
  {
    "cast": "Šimanov",
    "psc": "58842",
    "okres": "Jihlava",
    "obec": "Šimanov",
    "val": "58842 Simanov Simanov"
  },
  {
    "cast": "Šimonovice",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Šimonovice",
    "val": "46312 Simonovice Simonovice"
  },
  {
    "cast": "Šimpach",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Obrataň",
    "val": "39501 Obratan Simpach"
  },
  {
    "cast": "Šindelová",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Šindelová",
    "val": "35801 Sindelova Sindelova"
  },
  {
    "cast": "Šindlov",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Borová Lada",
    "val": "38501 Borova Lada Sindlov"
  },
  {
    "cast": "Šindlovy Dvory",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Litvínovice",
    "val": "37001 Litvinovice Sindlovy Dvory"
  },
  {
    "cast": "Šipín",
    "psc": "34952",
    "okres": "Tachov",
    "obec": "Konstantinovy Lázně",
    "val": "34952 Konstantinovy Lazne Sipin"
  },
  {
    "cast": "Šipoun",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Strunkovice nad Blanicí",
    "val": "38301 Strunkovice nad Blanici Sipoun"
  },
  {
    "cast": "Šipší",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Sipsi"
  },
  {
    "cast": "Šípy",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Šípy",
    "val": "27034 Sipy Sipy"
  },
  {
    "cast": "Široká Niva",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Široká Niva",
    "val": "79201 Siroka Niva Siroka Niva"
  },
  {
    "cast": "Široké Pole",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Nový Jimramov",
    "val": "59242 Novy Jimramov Siroke Pole"
  },
  {
    "cast": "Široké Třebčice",
    "psc": "44101",
    "okres": "Chomutov",
    "obec": "Veliká Ves",
    "val": "44101 Velika Ves Siroke Trebcice"
  },
  {
    "cast": "Široký Brod",
    "psc": "79084",
    "okres": "Jeseník",
    "obec": "Mikulovice",
    "val": "79084 Mikulovice Siroky Brod"
  },
  {
    "cast": "Široký Důl",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Široký Důl",
    "val": "57201 Siroky Dul Siroky Dul"
  },
  {
    "cast": "Šiškovice",
    "psc": "53823",
    "okres": "Chrudim",
    "obec": "Licibořice",
    "val": "53823 Liciborice Siskovice"
  },
  {
    "cast": "Šišma",
    "psc": "75111",
    "okres": "Přerov",
    "obec": "Šišma",
    "val": "75111 Sisma Sisma"
  },
  {
    "cast": "Šitboř",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Poběžovice",
    "val": "34522 Pobezovice Sitbor"
  },
  {
    "cast": "Šitbořice",
    "psc": "69176",
    "okres": "Břeclav",
    "obec": "Šitbořice",
    "val": "69176 Sitborice Sitborice"
  },
  {
    "cast": "Škarez 1.díl",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Drslavice",
    "val": "38301 Drslavice Skarez 1.dil"
  },
  {
    "cast": "Škarez 2.díl (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Šumavské Hoštice",
    "val": "38301 Sumavske Hostice Skarez 2.dil (cast)"
  },
  {
    "cast": "Škarez 2.díl (část)",
    "psc": "38471",
    "okres": "Prachatice",
    "obec": "Šumavské Hoštice",
    "val": "38471 Sumavske Hostice Skarez 2.dil (cast)"
  },
  {
    "cast": "Škodějov",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Příkrý",
    "val": "51301 Prikry Skodejov"
  },
  {
    "cast": "Škrdlovice",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Škrdlovice",
    "val": "59101 Skrdlovice Skrdlovice"
  },
  {
    "cast": "Škrle",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Bílence",
    "val": "43001 Bilence Skrle"
  },
  {
    "cast": "Škrobočov",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Hoslovice",
    "val": "38716 Hoslovice Skrobocov"
  },
  {
    "cast": "Škrovád",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Slatiňany",
    "val": "53821 Slatinany Skrovad"
  },
  {
    "cast": "Škudly",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Přelouč",
    "val": "53501 Prelouc Skudly"
  },
  {
    "cast": "Škůdra",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Strašice",
    "val": "38716 Strasice Skudra"
  },
  {
    "cast": "Škvorec",
    "psc": "25083",
    "okres": "Praha-východ",
    "obec": "Škvorec",
    "val": "25083 Skvorec Skvorec"
  },
  {
    "cast": "Škvořetice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Škvořetice",
    "val": "38801 Skvoretice Skvoretice"
  },
  {
    "cast": "Šlakhamry",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Hamry nad Sázavou",
    "val": "59101 Hamry nad Sazavou Slakhamry"
  },
  {
    "cast": "Šlapanice",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Šlapanice",
    "val": "27371 Slapanice Slapanice"
  },
  {
    "cast": "Šlapanice (část)",
    "psc": "62700",
    "okres": "Brno-venkov",
    "obec": "Šlapanice",
    "val": "62700 Slapanice Slapanice (cast)"
  },
  {
    "cast": "Šlapanice (část)",
    "psc": "66451",
    "okres": "Brno-venkov",
    "obec": "Šlapanice",
    "val": "66451 Slapanice Slapanice (cast)"
  },
  {
    "cast": "Šlapánov",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Slapanov"
  },
  {
    "cast": "Šlapanov (část)",
    "psc": "58251",
    "okres": "Havlíčkův Brod",
    "obec": "Šlapanov",
    "val": "58251 Slapanov Slapanov (cast)"
  },
  {
    "cast": "Šlapanov (část)",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Šlapanov",
    "val": "58001 Slapanov Slapanov (cast)"
  },
  {
    "cast": "Šléglov",
    "psc": "78825",
    "okres": "Šumperk",
    "obec": "Šléglov",
    "val": "78825 Sleglov Sleglov"
  },
  {
    "cast": "Šlechtín",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Bohdaneč",
    "val": "28522 Bohdanec Slechtin"
  },
  {
    "cast": "Šlikova Ves",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Podhradí",
    "val": "50601 Podhradi Slikova Ves"
  },
  {
    "cast": "Šlotava",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Budiměřice",
    "val": "28802 Budimerice Slotava"
  },
  {
    "cast": "Šlovice",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Hřebečníky",
    "val": "27041 Hrebecniky Slovice"
  },
  {
    "cast": "Šlovice",
    "psc": "32100",
    "okres": "Plzeň-jih",
    "obec": "Dobřany",
    "val": "32100 Dobrany Slovice"
  },
  {
    "cast": "Šlovice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Semněvice",
    "val": "34601 Semnevice Slovice"
  },
  {
    "cast": "Šluknov",
    "psc": "40777",
    "okres": "Děčín",
    "obec": "Šluknov",
    "val": "40777 Sluknov Sluknov"
  },
  {
    "cast": "Šmolovy",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Smolovy"
  },
  {
    "cast": "Šnekov",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Březina",
    "val": "56943 Brezina Snekov"
  },
  {
    "cast": "Šnepov",
    "psc": "28922",
    "okres": "Nymburk",
    "obec": "Ostrá",
    "val": "28922 Ostra Snepov"
  },
  {
    "cast": "Šonov",
    "psc": "54971",
    "okres": "Náchod",
    "obec": "Šonov",
    "val": "54971 Sonov Sonov"
  },
  {
    "cast": "Šonov u Nového Města nad Metují",
    "psc": "54908",
    "okres": "Náchod",
    "obec": "Provodov-Šonov",
    "val": "54908 Provodov-Sonov Sonov u Noveho Mesta nad Metuji"
  },
  {
    "cast": "Šošůvka",
    "psc": "67913",
    "okres": "Blansko",
    "obec": "Šošůvka",
    "val": "67913 Sosuvka Sosuvka"
  },
  {
    "cast": "Špičák",
    "psc": "34004",
    "okres": "Klatovy",
    "obec": "Železná Ruda",
    "val": "34004 Zelezna Ruda Spicak"
  },
  {
    "cast": "Špičky",
    "psc": "75366",
    "okres": "Přerov",
    "obec": "Špičky",
    "val": "75366 Spicky Spicky"
  },
  {
    "cast": "Špindlerův Mlýn",
    "psc": "54351",
    "okres": "Trutnov",
    "obec": "Špindlerův Mlýn",
    "val": "54351 Spindleruv Mlyn Spindleruv Mlyn"
  },
  {
    "cast": "Špinov",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Nížkov",
    "val": "59212 Nizkov Spinov"
  },
  {
    "cast": "Štáblovice",
    "psc": "74782",
    "okres": "Opava",
    "obec": "Štáblovice",
    "val": "74782 Stablovice Stablovice"
  },
  {
    "cast": "Šťáhlavice",
    "psc": "33204",
    "okres": "Plzeň-město",
    "obec": "Šťáhlavy",
    "val": "33204 Stahlavy Stahlavice"
  },
  {
    "cast": "Šťáhlavy",
    "psc": "33203",
    "okres": "Plzeň-město",
    "obec": "Šťáhlavy",
    "val": "33203 Stahlavy Stahlavy"
  },
  {
    "cast": "Šťáralka",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Staralka"
  },
  {
    "cast": "Štarnov",
    "psc": "78314",
    "okres": "Olomouc",
    "obec": "Štarnov",
    "val": "78314 Starnov Starnov"
  },
  {
    "cast": "Štarnov",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Přemyslovice",
    "val": "79852 Premyslovice Starnov"
  },
  {
    "cast": "Štědrá",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Štědrá",
    "val": "36452 Stedra Stedra"
  },
  {
    "cast": "Štědrá",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kynšperk nad Ohří",
    "val": "35751 Kynsperk nad Ohri Stedra"
  },
  {
    "cast": "Štědrákova Lhota",
    "psc": "78963",
    "okres": "Šumperk",
    "obec": "Ruda nad Moravou",
    "val": "78963 Ruda nad Moravou Stedrakova Lhota"
  },
  {
    "cast": "Štědronín-Plazy",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Varvažov",
    "val": "39701 Varvazov Stedronin-Plazy"
  },
  {
    "cast": "Štědrovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Čáslavsko",
    "val": "39501 Caslavsko Stedrovice"
  },
  {
    "cast": "Štěchov",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Štěchov",
    "val": "67971 Stechov Stechov"
  },
  {
    "cast": "Štěchovice",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Štěchovice",
    "val": "38716 Stechovice Stechovice"
  },
  {
    "cast": "Štěchovice",
    "psc": "25207",
    "okres": "Praha-západ",
    "obec": "Štěchovice",
    "val": "25207 Stechovice Stechovice"
  },
  {
    "cast": "Štěkeň (část)",
    "psc": "38751",
    "okres": "Strakonice",
    "obec": "Štěkeň",
    "val": "38751 Steken Steken (cast)"
  },
  {
    "cast": "Štěkeň (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Štěkeň",
    "val": "38601 Steken Steken (cast)"
  },
  {
    "cast": "Štěkře",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Dolní Třebonín",
    "val": "38232 Dolni Trebonin Stekre"
  },
  {
    "cast": "Štěměchy",
    "psc": "67527",
    "okres": "Třebíč",
    "obec": "Štěměchy",
    "val": "67527 Stemechy Stemechy"
  },
  {
    "cast": "Štemplovec",
    "psc": "74774",
    "okres": "Opava",
    "obec": "Holasovice",
    "val": "74774 Holasovice Stemplovec"
  },
  {
    "cast": "Štěnec",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Jenišovice",
    "val": "53854 Jenisovice Stenec"
  },
  {
    "cast": "Štěnkov",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Třebechovice pod Orebem",
    "val": "50346 Trebechovice pod Orebem Stenkov"
  },
  {
    "cast": "Štěnovice",
    "psc": "33209",
    "okres": "Plzeň-jih",
    "obec": "Štěnovice",
    "val": "33209 Stenovice Stenovice"
  },
  {
    "cast": "Štěnovický Borek",
    "psc": "33209",
    "okres": "Plzeň-město",
    "obec": "Štěnovický Borek",
    "val": "33209 Stenovicky Borek Stenovicky Borek"
  },
  {
    "cast": "Štěpanice",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Úbislavice",
    "val": "50901 Ubislavice Stepanice"
  },
  {
    "cast": "Štěpanice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Stepanice"
  },
  {
    "cast": "Štěpanická Lhota",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Benecko",
    "val": "51401 Benecko Stepanicka Lhota"
  },
  {
    "cast": "Štěpánkovice",
    "psc": "74728",
    "okres": "Opava",
    "obec": "Štěpánkovice",
    "val": "74728 Stepankovice Stepankovice"
  },
  {
    "cast": "Štěpánov",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Stepanov"
  },
  {
    "cast": "Štěpánov",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Lukov",
    "val": "41804 Lukov Stepanov"
  },
  {
    "cast": "Štěpánov",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Přelouč",
    "val": "53501 Prelouc Stepanov"
  },
  {
    "cast": "Štěpánov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Bezděkov",
    "val": "58301 Bezdekov Stepanov"
  },
  {
    "cast": "Štěpánov",
    "psc": "78313",
    "okres": "Olomouc",
    "obec": "Štěpánov",
    "val": "78313 Stepanov Stepanov"
  },
  {
    "cast": "Štěpánov",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Leština u Světlé",
    "val": "58282 Lestina u Svetle Stepanov"
  },
  {
    "cast": "Štěpánov nad Svratkou (část)",
    "psc": "59263",
    "okres": "Žďár nad Sázavou",
    "obec": "Štěpánov nad Svratkou",
    "val": "59263 Stepanov nad Svratkou Stepanov nad Svratkou (cast)"
  },
  {
    "cast": "Štěpánov nad Svratkou (část)",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Štěpánov nad Svratkou",
    "val": "59301 Stepanov nad Svratkou Stepanov nad Svratkou (cast)"
  },
  {
    "cast": "Štěpánovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Stepanovice"
  },
  {
    "cast": "Štěpánovice",
    "psc": "66602",
    "okres": "Brno-venkov",
    "obec": "Štěpánovice",
    "val": "66602 Stepanovice Stepanovice"
  },
  {
    "cast": "Štěpánovice",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Výčapy",
    "val": "67551 Vycapy Stepanovice"
  },
  {
    "cast": "Štěpánovice",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Rovensko pod Troskami",
    "val": "51263 Rovensko pod Troskami Stepanovice"
  },
  {
    "cast": "Štěpánovice",
    "psc": "37373",
    "okres": "České Budějovice",
    "obec": "Štěpánovice",
    "val": "37373 Stepanovice Stepanovice"
  },
  {
    "cast": "Štěpánovská Lhota",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Trhový Štěpánov",
    "val": "25763 Trhovy Stepanov Stepanovska Lhota"
  },
  {
    "cast": "Štěpánovsko",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Týniště nad Orlicí",
    "val": "51721 Tyniste nad Orlici Stepanovsko"
  },
  {
    "cast": "Štěpkov",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Štěpkov",
    "val": "67526 Stepkov Stepkov"
  },
  {
    "cast": "Štěrbina",
    "psc": "41771",
    "okres": "Teplice",
    "obec": "Zabrušany",
    "val": "41771 Zabrusany Sterbina"
  },
  {
    "cast": "Štěrboholy (část)",
    "psc": "10200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10200 Praha Sterboholy (cast)"
  },
  {
    "cast": "Štěrboholy (část)",
    "psc": "10800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10800 Praha Sterboholy (cast)"
  },
  {
    "cast": "Štěrboholy (část)",
    "psc": "10900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10900 Praha Sterboholy (cast)"
  },
  {
    "cast": "Šternberk",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Šternberk",
    "val": "78501 Sternberk Sternberk"
  },
  {
    "cast": "Šternov",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Divišov",
    "val": "25726 Divisov Sternov"
  },
  {
    "cast": "Štětí",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Steti"
  },
  {
    "cast": "Štětice",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Ražice",
    "val": "39811 Razice Stetice"
  },
  {
    "cast": "Štětkovice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Štětkovice",
    "val": "26401 Stetkovice Stetkovice"
  },
  {
    "cast": "Štětovice",
    "psc": "79812",
    "okres": "Prostějov",
    "obec": "Vrbátky",
    "val": "79812 Vrbatky Stetovice"
  },
  {
    "cast": "Štičí",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58401 Hnevkovice Stici"
  },
  {
    "cast": "Štidla",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Střevač",
    "val": "50601 Strevac Stidla"
  },
  {
    "cast": "Štíhlice",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Štíhlice",
    "val": "28163 Stihlice Stihlice"
  },
  {
    "cast": "Štichov",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Štichov",
    "val": "34562 Stichov Stichov"
  },
  {
    "cast": "Štichovice",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Štichovice",
    "val": "33141 Stichovice Stichovice"
  },
  {
    "cast": "Štikov",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Stikov"
  },
  {
    "cast": "Štikov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58301 Slavikov Stikov"
  },
  {
    "cast": "Štípa",
    "psc": "76314",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76314 Zlin Stipa"
  },
  {
    "cast": "Štipoklasy",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33038 Unesov Stipoklasy"
  },
  {
    "cast": "Štipoklasy",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34101 Planice Stipoklasy"
  },
  {
    "cast": "Štipoklasy",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Štipoklasy",
    "val": "28401 Stipoklasy Stipoklasy"
  },
  {
    "cast": "Štipoklasy",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Horní Kněžeklady",
    "val": "37501 Horni Knezeklady Stipoklasy"
  },
  {
    "cast": "Štiptoň",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37401 Nove Hrady Stipton"
  },
  {
    "cast": "Štiřín",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Stirin"
  },
  {
    "cast": "Štít",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Klamoš",
    "val": "50351 Klamos Stit"
  },
  {
    "cast": "Štítary",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Stitary"
  },
  {
    "cast": "Štítary",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Štítary",
    "val": "67102 Stitary Stitary"
  },
  {
    "cast": "Štítary",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Hostouň",
    "val": "34525 Hostoun Stitary"
  },
  {
    "cast": "Štítina",
    "psc": "74791",
    "okres": "Opava",
    "obec": "Štítina",
    "val": "74791 Stitina Stitina"
  },
  {
    "cast": "Štítkov",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Svatá Maří",
    "val": "38501 Svata Mari Stitkov"
  },
  {
    "cast": "Štítná nad Vláří",
    "psc": "76333",
    "okres": "Zlín",
    "obec": "Štítná nad Vláří-Popov",
    "val": "76333 Stitna nad Vlari-Popov Stitna nad Vlari"
  },
  {
    "cast": "Štítné",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Žirovnice",
    "val": "39468 Zirovnice Stitne"
  },
  {
    "cast": "Štítov",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Stitov"
  },
  {
    "cast": "Štítov",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Štítov",
    "val": "33843 Stitov Stitov"
  },
  {
    "cast": "Štíty",
    "psc": "78991",
    "okres": "Šumperk",
    "obec": "Štíty",
    "val": "78991 Stity Stity"
  },
  {
    "cast": "Štokov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Chodský Újezd",
    "val": "34815 Chodsky Ujezd Stokov"
  },
  {
    "cast": "Štoky",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Štoky",
    "val": "58253 Stoky Stoky"
  },
  {
    "cast": "Štolmíř",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Český Brod",
    "val": "28201 Cesky Brod Stolmir"
  },
  {
    "cast": "Štoutov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Čichalov",
    "val": "36452 Cichalov Stoutov"
  },
  {
    "cast": "Štramberk",
    "psc": "74266",
    "okres": "Nový Jičín",
    "obec": "Štramberk",
    "val": "74266 Stramberk Stramberk"
  },
  {
    "cast": "Štrampouch",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Žáky",
    "val": "28601 Zaky Strampouch"
  },
  {
    "cast": "Štrbice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Světec",
    "val": "41501 Svetec Strbice"
  },
  {
    "cast": "Študlov",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Študlov",
    "val": "56904 Studlov Studlov"
  },
  {
    "cast": "Študlov",
    "psc": "75612",
    "okres": "Vsetín",
    "obec": "Študlov",
    "val": "75612 Studlov Studlov"
  },
  {
    "cast": "Štýřice (část)",
    "psc": "61900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61900 Brno Styrice (cast)"
  },
  {
    "cast": "Štýřice (část)",
    "psc": "63900",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63900 Brno Styrice (cast)"
  },
  {
    "cast": "Šubířov",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Šubířov",
    "val": "79852 Subirov Subirov"
  },
  {
    "cast": "Šumavské Hoštice",
    "psc": "38471",
    "okres": "Prachatice",
    "obec": "Šumavské Hoštice",
    "val": "38471 Sumavske Hostice Sumavske Hostice"
  },
  {
    "cast": "Šumbark",
    "psc": "73601",
    "okres": "Karviná",
    "obec": "Havířov",
    "val": "73601 Havirov Sumbark"
  },
  {
    "cast": "Šumburk nad Desnou",
    "psc": "46841",
    "okres": "Jablonec nad Nisou",
    "obec": "Tanvald",
    "val": "46841 Tanvald Sumburk nad Desnou"
  },
  {
    "cast": "Šumice",
    "psc": "68731",
    "okres": "Uherské Hradiště",
    "obec": "Šumice",
    "val": "68731 Sumice Sumice"
  },
  {
    "cast": "Šumice",
    "psc": "67175",
    "okres": "Brno-venkov",
    "obec": "Šumice",
    "val": "67175 Sumice Sumice"
  },
  {
    "cast": "Šumná",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Šumná",
    "val": "67102 Sumna Sumna"
  },
  {
    "cast": "Šumná",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Sumna"
  },
  {
    "cast": "Šumná",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Sumna"
  },
  {
    "cast": "Šumperk",
    "psc": "78701",
    "okres": "Šumperk",
    "obec": "Šumperk",
    "val": "78701 Sumperk Sumperk"
  },
  {
    "cast": "Šumvald",
    "psc": "78385",
    "okres": "Olomouc",
    "obec": "Šumvald",
    "val": "78385 Sumvald Sumvald"
  },
  {
    "cast": "Šunychl",
    "psc": "73581",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73581 Bohumin Sunychl"
  },
  {
    "cast": "Švábenice",
    "psc": "68323",
    "okres": "Vyškov",
    "obec": "Švábenice",
    "val": "68323 Svabenice Svabenice"
  },
  {
    "cast": "Švábínov",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28401 Chlistovice Svabinov"
  },
  {
    "cast": "Švábov",
    "psc": "58851",
    "okres": "Jihlava",
    "obec": "Švábov",
    "val": "58851 Svabov Svabov"
  },
  {
    "cast": "Šváby",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Zahrádky",
    "val": "47002 Zahradky Svaby"
  },
  {
    "cast": "Švařec",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Koroužné",
    "val": "59301 Korouzne Svarec"
  },
  {
    "cast": "Švastalova Lhota",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Svastalova Lhota"
  },
  {
    "cast": "Švejcarova Lhota",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Úlehle",
    "val": "38601 Ulehle Svejcarova Lhota"
  },
  {
    "cast": "Švermov",
    "psc": "27309",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27309 Kladno Svermov"
  },
  {
    "cast": "Švihov",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Svihov"
  },
  {
    "cast": "Švihov",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Miřetice",
    "val": "53825 Miretice Svihov"
  },
  {
    "cast": "Švihov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Drslavice",
    "val": "38301 Drslavice Svihov"
  },
  {
    "cast": "Švihov",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Švihov",
    "val": "27033 Svihov Svihov"
  },
  {
    "cast": "Tábor",
    "psc": "74775",
    "okres": "Opava",
    "obec": "Velké Heraltice",
    "val": "74775 Velke Heraltice Tabor"
  },
  {
    "cast": "Tábor (část)",
    "psc": "39001",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39001 Tabor Tabor (cast)"
  },
  {
    "cast": "Tábor (část)",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39002 Tabor Tabor (cast)"
  },
  {
    "cast": "Tábor (část)",
    "psc": "39003",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39003 Tabor Tabor (cast)"
  },
  {
    "cast": "Tábor (část)",
    "psc": "39005",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39005 Tabor Tabor (cast)"
  },
  {
    "cast": "Táborská",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Hazlov",
    "val": "35201 Hazlov Taborska"
  },
  {
    "cast": "Tachlovice",
    "psc": "25217",
    "okres": "Praha-západ",
    "obec": "Tachlovice",
    "val": "25217 Tachlovice Tachlovice"
  },
  {
    "cast": "Tachov",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Tachov"
  },
  {
    "cast": "Tachov",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Tachov",
    "val": "47201 Tachov Tachov"
  },
  {
    "cast": "Tachov",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Troskovice",
    "val": "51263 Troskovice Tachov"
  },
  {
    "cast": "Tachovská Huť",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Tři Sekery",
    "val": "35301 Tri Sekery Tachovska Hut"
  },
  {
    "cast": "Tajanov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Tajanov"
  },
  {
    "cast": "Tajanov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Tajanov"
  },
  {
    "cast": "Tajná",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Stránka",
    "val": "27735 Stranka Tajna"
  },
  {
    "cast": "Takonín",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Bílkovice",
    "val": "25601 Bilkovice Takonin"
  },
  {
    "cast": "Tálín",
    "psc": "39815",
    "okres": "Písek",
    "obec": "Tálín",
    "val": "39815 Talin Talin"
  },
  {
    "cast": "Talmberk",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Samopše",
    "val": "28506 Samopse Talmberk"
  },
  {
    "cast": "Tample",
    "psc": "50791",
    "okres": "Semily",
    "obec": "Svojek",
    "val": "50791 Svojek Tample"
  },
  {
    "cast": "Taneček",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Stvolínky",
    "val": "47002 Stvolinky Tanecek"
  },
  {
    "cast": "Tanvald",
    "psc": "46841",
    "okres": "Jablonec nad Nisou",
    "obec": "Tanvald",
    "val": "46841 Tanvald Tanvald"
  },
  {
    "cast": "Tasice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Bělá",
    "val": "58401 Bela Tasice"
  },
  {
    "cast": "Tasnovice",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34525 Horsovsky Tyn Tasnovice"
  },
  {
    "cast": "Tasov",
    "psc": "67579",
    "okres": "Žďár nad Sázavou",
    "obec": "Tasov",
    "val": "67579 Tasov Tasov"
  },
  {
    "cast": "Tasov",
    "psc": "69663",
    "okres": "Hodonín",
    "obec": "Tasov",
    "val": "69663 Tasov Tasov"
  },
  {
    "cast": "Tasovice",
    "psc": "67125",
    "okres": "Znojmo",
    "obec": "Tasovice",
    "val": "67125 Tasovice Tasovice"
  },
  {
    "cast": "Tasovice",
    "psc": "67975",
    "okres": "Blansko",
    "obec": "Tasovice",
    "val": "67975 Tasovice Tasovice"
  },
  {
    "cast": "Tasovice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Kostelec u Heřmanova Městce",
    "val": "53803 Kostelec u Hermanova Mestce Tasovice"
  },
  {
    "cast": "Tašov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Tašov",
    "val": "40002 Tasov Tasov"
  },
  {
    "cast": "Tašovice",
    "psc": "36018",
    "okres": "Karlovy Vary",
    "obec": "Karlovy Vary",
    "val": "36018 Karlovy Vary Tasovice"
  },
  {
    "cast": "Tatce",
    "psc": "28911",
    "okres": "Kolín",
    "obec": "Tatce",
    "val": "28911 Tatce Tatce"
  },
  {
    "cast": "Tatenice",
    "psc": "56131",
    "okres": "Ústí nad Orlicí",
    "obec": "Tatenice",
    "val": "56131 Tatenice Tatenice"
  },
  {
    "cast": "Tatiná",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Tatiná",
    "val": "33011 Tatina Tatina"
  },
  {
    "cast": "Tatinná",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Bitozeves",
    "val": "43801 Bitozeves Tatinna"
  },
  {
    "cast": "Tatobity (část)",
    "psc": "51253",
    "okres": "Semily",
    "obec": "Tatobity",
    "val": "51253 Tatobity Tatobity (cast)"
  },
  {
    "cast": "Tatobity (část)",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Tatobity",
    "val": "51263 Tatobity Tatobity (cast)"
  },
  {
    "cast": "Tatouňovice",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Čakov",
    "val": "25724 Cakov Tatounovice"
  },
  {
    "cast": "Tatrovice",
    "psc": "35735",
    "okres": "Sokolov",
    "obec": "Tatrovice",
    "val": "35735 Tatrovice Tatrovice"
  },
  {
    "cast": "Tavíkovice",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Tavíkovice",
    "val": "67140 Tavikovice Tavikovice"
  },
  {
    "cast": "Tážaly",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Kožušany-Tážaly",
    "val": "78375 Kozusany-Tazaly Tazaly"
  },
  {
    "cast": "Tažovice",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Volenice",
    "val": "38716 Volenice Tazovice"
  },
  {
    "cast": "Tažovická Lhota",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Volenice",
    "val": "38716 Volenice Tazovicka Lhota"
  },
  {
    "cast": "Tečovice",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Tečovice",
    "val": "76302 Tecovice Tecovice"
  },
  {
    "cast": "Tedražice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hrádek",
    "val": "34201 Hradek Tedrazice"
  },
  {
    "cast": "Tehov",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Tehov",
    "val": "25801 Tehov Tehov"
  },
  {
    "cast": "Tehov",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Tehov",
    "val": "25101 Tehov Tehov"
  },
  {
    "cast": "Tehovec",
    "psc": "25162",
    "okres": "Praha-východ",
    "obec": "Tehovec",
    "val": "25162 Tehovec Tehovec"
  },
  {
    "cast": "Těchanov",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Jiříkov",
    "val": "79351 Jirikov Techanov"
  },
  {
    "cast": "Těchařovice (část)",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Těchařovice",
    "val": "26231 Techarovice Techarovice (cast)"
  },
  {
    "cast": "Těchařovice (část)",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Těchařovice",
    "val": "26272 Techarovice Techarovice (cast)"
  },
  {
    "cast": "Těchlovice",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Stříbro",
    "val": "34901 Stribro Techlovice"
  },
  {
    "cast": "Těchlovice",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Těchlovice",
    "val": "40502 Techlovice Techlovice"
  },
  {
    "cast": "Těchlovice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Těchlovice",
    "val": "50327 Techlovice Techlovice"
  },
  {
    "cast": "Těchobuz",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Těchobuz",
    "val": "39501 Techobuz Techobuz"
  },
  {
    "cast": "Těchobuzice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Ploskovice",
    "val": "41201 Ploskovice Techobuzice"
  },
  {
    "cast": "Těchonice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Techonice"
  },
  {
    "cast": "Těchonín (část)",
    "psc": "56166",
    "okres": "Ústí nad Orlicí",
    "obec": "Těchonín",
    "val": "56166 Techonin Techonin (cast)"
  },
  {
    "cast": "Těchonín (část)",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Těchonín",
    "val": "56164 Techonin Techonin (cast)"
  },
  {
    "cast": "Těchoraz",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Červená Řečice",
    "val": "39301 Cervena Recice Techoraz"
  },
  {
    "cast": "Těchoraz",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Vyšší Brod",
    "val": "38273 Vyssi Brod Techoraz"
  },
  {
    "cast": "Těchov",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Techov"
  },
  {
    "cast": "Telce",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Peruc",
    "val": "44001 Peruc Telce"
  },
  {
    "cast": "Telč-Podolí",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Telč",
    "val": "58856 Telc Telc-Podoli"
  },
  {
    "cast": "Telč-Staré Město",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Telč",
    "val": "58856 Telc Telc-Stare Mesto"
  },
  {
    "cast": "Telč-Štěpnice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Telč",
    "val": "58856 Telc Telc-Stepnice"
  },
  {
    "cast": "Telč-Vnitřní Město",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Telč",
    "val": "58856 Telc Telc-Vnitrni Mesto"
  },
  {
    "cast": "Telecí (část)",
    "psc": "56994",
    "okres": "Svitavy",
    "obec": "Telecí",
    "val": "56994 Teleci Teleci (cast)"
  },
  {
    "cast": "Telecí (část)",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Telecí",
    "val": "57201 Teleci Teleci (cast)"
  },
  {
    "cast": "Teleč",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Telec"
  },
  {
    "cast": "Teletín",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Krňany",
    "val": "25744 Krnany Teletin"
  },
  {
    "cast": "Telice",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Prostiboř",
    "val": "34901 Prostibor Telice"
  },
  {
    "cast": "Telnice",
    "psc": "40338",
    "okres": "Ústí nad Labem",
    "obec": "Telnice",
    "val": "40338 Telnice Telnice"
  },
  {
    "cast": "Telnice",
    "psc": "66459",
    "okres": "Brno-venkov",
    "obec": "Telnice",
    "val": "66459 Telnice Telnice"
  },
  {
    "cast": "Temelín (část)",
    "psc": "37301",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37301 Temelin Temelin (cast)"
  },
  {
    "cast": "Temelín (část)",
    "psc": "37305",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37305 Temelin Temelin (cast)"
  },
  {
    "cast": "Temelínec",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Temelinec"
  },
  {
    "cast": "Temešvár",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Temešvár",
    "val": "39701 Temesvar Temesvar"
  },
  {
    "cast": "Temešvár",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Hlasivo",
    "val": "39143 Hlasivo Temesvar"
  },
  {
    "cast": "Těmice",
    "psc": "69684",
    "okres": "Hodonín",
    "obec": "Těmice",
    "val": "69684 Temice Temice"
  },
  {
    "cast": "Těmice (část)",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Těmice",
    "val": "39470 Temice Temice (cast)"
  },
  {
    "cast": "Těmice (část)",
    "psc": "39496",
    "okres": "Pelhřimov",
    "obec": "Těmice",
    "val": "39496 Temice Temice (cast)"
  },
  {
    "cast": "Temný Důl",
    "psc": "54226",
    "okres": "Trutnov",
    "obec": "Horní Maršov",
    "val": "54226 Horni Marsov Temny Dul"
  },
  {
    "cast": "Těně",
    "psc": "33845",
    "okres": "Rokycany",
    "obec": "Těně",
    "val": "33845 Tene Tene"
  },
  {
    "cast": "Těnovice (část)",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33601 Spalene Porici Tenovice (cast)"
  },
  {
    "cast": "Těnovice (část)",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Tenovice (cast)"
  },
  {
    "cast": "Těpeře",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Tepere"
  },
  {
    "cast": "Teplá",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Tepla"
  },
  {
    "cast": "Teplá",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41115 Trebenice Tepla"
  },
  {
    "cast": "Teplice",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41501 Teplice Teplice"
  },
  {
    "cast": "Teplice nad Bečvou",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Teplice nad Bečvou",
    "val": "75301 Teplice nad Becvou Teplice nad Becvou"
  },
  {
    "cast": "Teplice nad Metují",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Teplice nad Metuji"
  },
  {
    "cast": "Teplické Předměstí",
    "psc": "41801",
    "okres": "Teplice",
    "obec": "Bílina",
    "val": "41801 Bilina Teplicke Predmesti"
  },
  {
    "cast": "Teplička",
    "psc": "36464",
    "okres": "Karlovy Vary",
    "obec": "Teplička",
    "val": "36464 Teplicka Teplicka"
  },
  {
    "cast": "Teplýšovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Teplýšovice",
    "val": "25601 Teplysovice Teplysovice"
  },
  {
    "cast": "Těptín",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Teptin"
  },
  {
    "cast": "Terešov",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Terešov",
    "val": "33808 Teresov Teresov"
  },
  {
    "cast": "Terešov",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Hlubočany",
    "val": "68201 Hlubocany Teresov"
  },
  {
    "cast": "Terezín",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Radenín",
    "val": "39155 Radenin Terezin"
  },
  {
    "cast": "Terezín",
    "psc": "69614",
    "okres": "Hodonín",
    "obec": "Terezín",
    "val": "69614 Terezin Terezin"
  },
  {
    "cast": "Terezín",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Kunžak",
    "val": "37853 Kunzak Terezin"
  },
  {
    "cast": "Terezín",
    "psc": "78814",
    "okres": "Šumperk",
    "obec": "Petrov nad Desnou",
    "val": "78814 Petrov nad Desnou Terezin"
  },
  {
    "cast": "Terezín (část)",
    "psc": "41155",
    "okres": "Litoměřice",
    "obec": "Terezín",
    "val": "41155 Terezin Terezin (cast)"
  },
  {
    "cast": "Terezín (část)",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Terezín",
    "val": "41201 Terezin Terezin (cast)"
  },
  {
    "cast": "Tereziny Dary",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Lískovice",
    "val": "50801 Liskovice Tereziny Dary"
  },
  {
    "cast": "Termesivy",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Termesivy"
  },
  {
    "cast": "Těšánky",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Zdounky",
    "val": "76802 Zdounky Tesanky"
  },
  {
    "cast": "Těšany",
    "psc": "66454",
    "okres": "Brno-venkov",
    "obec": "Těšany",
    "val": "66454 Tesany Tesany"
  },
  {
    "cast": "Těšenov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Horní Cerekev",
    "val": "39301 Horni Cerekev Tesenov"
  },
  {
    "cast": "Těšetice",
    "psc": "78346",
    "okres": "Olomouc",
    "obec": "Těšetice",
    "val": "78346 Tesetice Tesetice"
  },
  {
    "cast": "Těšetice",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Tesetice"
  },
  {
    "cast": "Těšetice",
    "psc": "67161",
    "okres": "Znojmo",
    "obec": "Těšetice",
    "val": "67161 Tesetice Tesetice"
  },
  {
    "cast": "Těšetiny",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Tesetiny"
  },
  {
    "cast": "Těšice",
    "psc": "69619",
    "okres": "Hodonín",
    "obec": "Mikulčice",
    "val": "69619 Mikulcice Tesice"
  },
  {
    "cast": "Těšice",
    "psc": "79826",
    "okres": "Prostějov",
    "obec": "Nezamyslice",
    "val": "79826 Nezamyslice Tesice"
  },
  {
    "cast": "Těšíkov",
    "psc": "78501",
    "okres": "Olomouc",
    "obec": "Šternberk",
    "val": "78501 Sternberk Tesikov"
  },
  {
    "cast": "Těšín (část)",
    "psc": "50711",
    "okres": "Jičín",
    "obec": "Železnice",
    "val": "50711 Zeleznice Tesin (cast)"
  },
  {
    "cast": "Těšín (část)",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Železnice",
    "val": "50713 Zeleznice Tesin (cast)"
  },
  {
    "cast": "Těšínky",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Ratboř",
    "val": "28002 Ratbor Tesinky"
  },
  {
    "cast": "Těšínov",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Tesinov"
  },
  {
    "cast": "Těšínov",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Petříkov",
    "val": "37401 Petrikov Tesinov"
  },
  {
    "cast": "Těškov (část)",
    "psc": "33801",
    "okres": "Rokycany",
    "obec": "Těškov",
    "val": "33801 Teskov Teskov (cast)"
  },
  {
    "cast": "Těškov (část)",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Těškov",
    "val": "33701 Teskov Teskov (cast)"
  },
  {
    "cast": "Těškovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Onšov",
    "val": "39501 Onsov Teskovice"
  },
  {
    "cast": "Těškovice",
    "psc": "74764",
    "okres": "Opava",
    "obec": "Těškovice",
    "val": "74764 Teskovice Teskovice"
  },
  {
    "cast": "Těšnice",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Tesnice"
  },
  {
    "cast": "Těšnov",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Cetenov",
    "val": "46352 Cetenov Tesnov"
  },
  {
    "cast": "Těšnovice",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Tesnovice"
  },
  {
    "cast": "Těšov",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Milíkov",
    "val": "35002 Milikov Tesov"
  },
  {
    "cast": "Těšov",
    "psc": "68734",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Brod",
    "val": "68734 Uhersky Brod Tesov"
  },
  {
    "cast": "Těšovice",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Srbice",
    "val": "34543 Srbice Tesovice"
  },
  {
    "cast": "Těšovice",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Těšovice",
    "val": "35601 Tesovice Tesovice"
  },
  {
    "cast": "Těšovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Těšovice",
    "val": "38301 Tesovice Tesovice"
  },
  {
    "cast": "Tetčice",
    "psc": "66417",
    "okres": "Brno-venkov",
    "obec": "Tetčice",
    "val": "66417 Tetcice Tetcice"
  },
  {
    "cast": "Tetčiněves",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Tetcineves"
  },
  {
    "cast": "Tetětice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bezděkov",
    "val": "33901 Bezdekov Tetetice"
  },
  {
    "cast": "Tetětice",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Počenice-Tetětice",
    "val": "76833 Pocenice-Tetetice Tetetice"
  },
  {
    "cast": "Tetín",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Tetín",
    "val": "50771 Tetin Tetin"
  },
  {
    "cast": "Tetín",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Tetín",
    "val": "26601 Tetin Tetin"
  },
  {
    "cast": "Tetov",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Tetov",
    "val": "53316 Tetov Tetov"
  },
  {
    "cast": "Tchořovice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Tchořovice",
    "val": "38801 Tchorovice Tchorovice"
  },
  {
    "cast": "Tihava",
    "psc": "26801",
    "okres": "Beroun",
    "obec": "Kotopeky",
    "val": "26801 Kotopeky Tihava"
  },
  {
    "cast": "Tichá",
    "psc": "74274",
    "okres": "Nový Jičín",
    "obec": "Tichá",
    "val": "74274 Ticha Ticha"
  },
  {
    "cast": "Tichá",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38241 Dolni Dvoriste Ticha"
  },
  {
    "cast": "Tichonice",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Tichonice",
    "val": "25763 Tichonice Tichonice"
  },
  {
    "cast": "Tichov",
    "psc": "76601",
    "okres": "Zlín",
    "obec": "Tichov",
    "val": "76601 Tichov Tichov"
  },
  {
    "cast": "Tikov",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Šárovcova Lhota",
    "val": "50801 Sarovcova Lhota Tikov"
  },
  {
    "cast": "Tikov",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51263 Lomnice nad Popelkou Tikov"
  },
  {
    "cast": "Tikovice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Tikovice"
  },
  {
    "cast": "Tis",
    "psc": "58243",
    "okres": "Havlíčkův Brod",
    "obec": "Tis",
    "val": "58243 Tis Tis"
  },
  {
    "cast": "Tis u Blatna",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Tis u Blatna",
    "val": "33165 Tis u Blatna Tis u Blatna"
  },
  {
    "cast": "Tis (část)",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Janov",
    "val": "51801 Janov Tis (cast)"
  },
  {
    "cast": "Tis (část)",
    "psc": "54901",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Janov",
    "val": "54901 Janov Tis (cast)"
  },
  {
    "cast": "Tisá",
    "psc": "40336",
    "okres": "Ústí nad Labem",
    "obec": "Tisá",
    "val": "40336 Tisa Tisa"
  },
  {
    "cast": "Tisek",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Pravonín",
    "val": "25708 Pravonin Tisek"
  },
  {
    "cast": "Tísek",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Tísek",
    "val": "74301 Tisek Tisek"
  },
  {
    "cast": "Tisem",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Tisem",
    "val": "25756 Tisem Tisem"
  },
  {
    "cast": "Tismice",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Tismice",
    "val": "28201 Tismice Tismice"
  },
  {
    "cast": "Tisov",
    "psc": "26242",
    "okres": "Strakonice",
    "obec": "Bělčice",
    "val": "26242 Belcice Tisov"
  },
  {
    "cast": "Tisová",
    "psc": "26241",
    "okres": "Příbram",
    "obec": "Bohutín",
    "val": "26241 Bohutin Tisova"
  },
  {
    "cast": "Tisová",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Březová",
    "val": "35601 Brezova Tisova"
  },
  {
    "cast": "Tisová",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Tisova"
  },
  {
    "cast": "Tisová",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Otročín",
    "val": "36401 Otrocin Tisova"
  },
  {
    "cast": "Tisová",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Tisová",
    "val": "34801 Tisova Tisova"
  },
  {
    "cast": "Tisová",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36221 Nejdek Tisova"
  },
  {
    "cast": "Tisová",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Tisová",
    "val": "56601 Tisova Tisova"
  },
  {
    "cast": "Tisovec",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Tisovec",
    "val": "53973 Tisovec Tisovec"
  },
  {
    "cast": "Tisovka (část)",
    "psc": "38404",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38404 Ktis Tisovka (cast)"
  },
  {
    "cast": "Tisovka (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38301 Ktis Tisovka (cast)"
  },
  {
    "cast": "Tisovnice",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Tisovnice"
  },
  {
    "cast": "Tišice",
    "psc": "27715",
    "okres": "Mělník",
    "obec": "Tišice",
    "val": "27715 Tisice Tisice"
  },
  {
    "cast": "Tišnov (část)",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Tišnov",
    "val": "66601 Tisnov Tisnov (cast)"
  },
  {
    "cast": "Tišnov (část)",
    "psc": "66603",
    "okres": "Brno-venkov",
    "obec": "Tišnov",
    "val": "66603 Tisnov Tisnov (cast)"
  },
  {
    "cast": "Tišnovská Nová Ves",
    "psc": "59451",
    "okres": "Brno-venkov",
    "obec": "Tišnovská Nová Ves",
    "val": "59451 Tisnovska Nova Ves Tisnovska Nova Ves"
  },
  {
    "cast": "Tištín",
    "psc": "79829",
    "okres": "Prostějov",
    "obec": "Tištín",
    "val": "79829 Tistin Tistin"
  },
  {
    "cast": "Tlestky",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Drahouš",
    "val": "27033 Drahous Tlestky"
  },
  {
    "cast": "Tloskov",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Tloskov"
  },
  {
    "cast": "Tlucná",
    "psc": "33152",
    "okres": "Plzeň-sever",
    "obec": "Horní Bělá",
    "val": "33152 Horni Bela Tlucna"
  },
  {
    "cast": "Tlučeň",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Hlinná",
    "val": "41201 Hlinna Tlucen"
  },
  {
    "cast": "Tlučeň",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Petrovice II",
    "val": "28522 Petrovice II Tlucen"
  },
  {
    "cast": "Tlučná",
    "psc": "33026",
    "okres": "Plzeň-sever",
    "obec": "Tlučná",
    "val": "33026 Tlucna Tlucna"
  },
  {
    "cast": "Tlumačov",
    "psc": "76362",
    "okres": "Zlín",
    "obec": "Tlumačov",
    "val": "76362 Tlumacov Tlumacov"
  },
  {
    "cast": "Tlumačov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Tlumačov",
    "val": "34401 Tlumacov Tlumacov"
  },
  {
    "cast": "Tlustice",
    "psc": "26801",
    "okres": "Beroun",
    "obec": "Tlustice",
    "val": "26801 Tlustice Tlustice"
  },
  {
    "cast": "Tlustovousy",
    "psc": "25082",
    "okres": "Kolín",
    "obec": "Tuklaty",
    "val": "25082 Tuklaty Tlustovousy"
  },
  {
    "cast": "Tmáň",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Zlonice",
    "val": "27371 Zlonice Tman"
  },
  {
    "cast": "Tmaň (část)",
    "psc": "26721",
    "okres": "Beroun",
    "obec": "Tmaň",
    "val": "26721 Tman Tman (cast)"
  },
  {
    "cast": "Tmaň (část)",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Tmaň",
    "val": "26701 Tman Tman (cast)"
  },
  {
    "cast": "Tobolka",
    "psc": "26727",
    "okres": "Beroun",
    "obec": "Měňany",
    "val": "26727 Menany Tobolka"
  },
  {
    "cast": "Točná",
    "psc": "14300",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14300 Praha Tocna"
  },
  {
    "cast": "Točník",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Točník",
    "val": "26751 Tocnik Tocnik"
  },
  {
    "cast": "Točník",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Tocnik"
  },
  {
    "cast": "Todně",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Todne"
  },
  {
    "cast": "Tochovice",
    "psc": "26281",
    "okres": "Příbram",
    "obec": "Tochovice",
    "val": "26281 Tochovice Tochovice"
  },
  {
    "cast": "Tojice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Tojice",
    "val": "33501 Tojice Tojice"
  },
  {
    "cast": "Tomášov",
    "psc": "40779",
    "okres": "Děčín",
    "obec": "Mikulášovice",
    "val": "40779 Mikulasovice Tomasov"
  },
  {
    "cast": "Tomice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Tomice",
    "val": "25768 Tomice Tomice"
  },
  {
    "cast": "Tomice II (část)",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25753 Olbramovice Tomice II (cast)"
  },
  {
    "cast": "Tomice II (část)",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25751 Olbramovice Tomice II (cast)"
  },
  {
    "cast": "Tomíkovice",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Žulová",
    "val": "79065 Zulova Tomikovice"
  },
  {
    "cast": "Topělec",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Čížová",
    "val": "39701 Cizova Topelec"
  },
  {
    "cast": "Topol",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53701 Chrudim Topol"
  },
  {
    "cast": "Topolany",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Topolany",
    "val": "68201 Topolany Topolany"
  },
  {
    "cast": "Topolany",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Topolany"
  },
  {
    "cast": "Topolná",
    "psc": "68711",
    "okres": "Uherské Hradiště",
    "obec": "Topolná",
    "val": "68711 Topolna Topolna"
  },
  {
    "cast": "Tošov",
    "psc": "51771",
    "okres": "Rychnov nad Kněžnou",
    "obec": "České Meziříčí",
    "val": "51771 Ceske Mezirici Tosov"
  },
  {
    "cast": "Tošovice",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74235 Odry Tosovice"
  },
  {
    "cast": "Touboř",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Kunštát",
    "val": "67972 Kunstat Toubor"
  },
  {
    "cast": "Touchořiny",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Lovečkovice",
    "val": "41145 Loveckovice Touchoriny"
  },
  {
    "cast": "Touchovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Hřivice",
    "val": "44001 Hrivice Touchovice"
  },
  {
    "cast": "Tourov",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Bavorov",
    "val": "38773 Bavorov Tourov"
  },
  {
    "cast": "Toušice",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Toušice",
    "val": "28163 Tousice Tousice"
  },
  {
    "cast": "Touškov",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Mirovice",
    "val": "39804 Mirovice Touskov"
  },
  {
    "cast": "Toužetín",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Toužetín",
    "val": "44001 Touzetin Touzetin"
  },
  {
    "cast": "Toužim",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Touzim"
  },
  {
    "cast": "Toužín",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Touzin"
  },
  {
    "cast": "Tovačov II-Annín",
    "psc": "75101",
    "okres": "Přerov",
    "obec": "Tovačov",
    "val": "75101 Tovacov Tovacov II-Annin"
  },
  {
    "cast": "Tovačov I-Město",
    "psc": "75101",
    "okres": "Přerov",
    "obec": "Tovačov",
    "val": "75101 Tovacov Tovacov I-Mesto"
  },
  {
    "cast": "Tovéř",
    "psc": "78316",
    "okres": "Olomouc",
    "obec": "Tovéř",
    "val": "78316 Tover Tover"
  },
  {
    "cast": "Tožice",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Tozice"
  },
  {
    "cast": "Traplice",
    "psc": "68704",
    "okres": "Uherské Hradiště",
    "obec": "Traplice",
    "val": "68704 Traplice Traplice"
  },
  {
    "cast": "Travčice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Travčice",
    "val": "41201 Travcice Travcice"
  },
  {
    "cast": "Travná",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Javorník",
    "val": "79070 Javornik Travna"
  },
  {
    "cast": "Travná (část)",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53825 Horni Bradlo Travna (cast)"
  },
  {
    "cast": "Travná (část)",
    "psc": "53953",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53953 Horni Bradlo Travna (cast)"
  },
  {
    "cast": "Trávníček",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Travnicek"
  },
  {
    "cast": "Trávník",
    "psc": "47156",
    "okres": "Česká Lípa",
    "obec": "Cvikov",
    "val": "47156 Cvikov Travnik"
  },
  {
    "cast": "Trávník",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Travnik"
  },
  {
    "cast": "Trávník",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Osice",
    "val": "50327 Osice Travnik"
  },
  {
    "cast": "Trboušany",
    "psc": "66464",
    "okres": "Brno-venkov",
    "obec": "Trboušany",
    "val": "66464 Trbousany Trbousany"
  },
  {
    "cast": "Trhanov",
    "psc": "34533",
    "okres": "Domažlice",
    "obec": "Trhanov",
    "val": "34533 Trhanov Trhanov"
  },
  {
    "cast": "Trhavice",
    "psc": "79305",
    "okres": "Olomouc",
    "obec": "Norberčany",
    "val": "79305 Norbercany Trhavice"
  },
  {
    "cast": "Trhomné",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Krsy",
    "val": "33162 Krsy Trhomne"
  },
  {
    "cast": "Trhonice",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Jimramov",
    "val": "59242 Jimramov Trhonice"
  },
  {
    "cast": "Trhonín",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Svatá Maří",
    "val": "38501 Svata Mari Trhonin"
  },
  {
    "cast": "Trhová Kamenice",
    "psc": "53952",
    "okres": "Chrudim",
    "obec": "Trhová Kamenice",
    "val": "53952 Trhova Kamenice Trhova Kamenice"
  },
  {
    "cast": "Trhové Dušníky",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Trhové Dušníky",
    "val": "26101 Trhove Dusniky Trhove Dusniky"
  },
  {
    "cast": "Trhové Sviny",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Trhove Sviny"
  },
  {
    "cast": "Trhový Štěpánov",
    "psc": "25763",
    "okres": "Benešov",
    "obec": "Trhový Štěpánov",
    "val": "25763 Trhovy Stepanov Trhovy Stepanov"
  },
  {
    "cast": "Trkov",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nedrahovice",
    "val": "26401 Nedrahovice Trkov"
  },
  {
    "cast": "Trmice",
    "psc": "40004",
    "okres": "Ústí nad Labem",
    "obec": "Trmice",
    "val": "40004 Trmice Trmice"
  },
  {
    "cast": "Trnava",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Trnava",
    "val": "67401 Trnava Trnava"
  },
  {
    "cast": "Trnava",
    "psc": "76318",
    "okres": "Zlín",
    "obec": "Trnava",
    "val": "76318 Trnava Trnava"
  },
  {
    "cast": "Trnava",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Boharyně",
    "val": "50315 Boharyne Trnava"
  },
  {
    "cast": "Trnávka",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Trnávka",
    "val": "53501 Trnavka Trnavka"
  },
  {
    "cast": "Trnávka",
    "psc": "74258",
    "okres": "Nový Jičín",
    "obec": "Trnávka",
    "val": "74258 Trnavka Trnavka"
  },
  {
    "cast": "Trnávka-Lipník nad Bečvou VII x)",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Lipník nad Bečvou",
    "val": "75131 Lipnik nad Becvou Trnavka-Lipnik nad Becvou VII x)"
  },
  {
    "cast": "Trnčí",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Ježovy",
    "val": "34012 Jezovy Trnci"
  },
  {
    "cast": "Trněný Újezd",
    "psc": "26718",
    "okres": "Beroun",
    "obec": "Mořina",
    "val": "26718 Morina Trneny Ujezd"
  },
  {
    "cast": "Trněný Újezd",
    "psc": "27328",
    "okres": "Kladno",
    "obec": "Zákolany",
    "val": "27328 Zakolany Trneny Ujezd"
  },
  {
    "cast": "Trní",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Trni"
  },
  {
    "cast": "Trnitá (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Trnita (cast)"
  },
  {
    "cast": "Trnitá (část)",
    "psc": "61700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61700 Brno Trnita (cast)"
  },
  {
    "cast": "Trnitá (část)",
    "psc": "61800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61800 Brno Trnita (cast)"
  },
  {
    "cast": "Trnobrany",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41145 Libesice Trnobrany"
  },
  {
    "cast": "Trnov",
    "psc": "51733",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Trnov",
    "val": "51733 Trnov Trnov"
  },
  {
    "cast": "Trnová",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Dobříš",
    "val": "26301 Dobris Trnova"
  },
  {
    "cast": "Trnová",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Tisová",
    "val": "34801 Tisova Trnova"
  },
  {
    "cast": "Trnová",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Katusice",
    "val": "29426 Katusice Trnova"
  },
  {
    "cast": "Trnová",
    "psc": "53009",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53009 Pardubice Trnova"
  },
  {
    "cast": "Trnová",
    "psc": "33013",
    "okres": "Plzeň-sever",
    "obec": "Trnová",
    "val": "33013 Trnova Trnova"
  },
  {
    "cast": "Trnová",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Trnová",
    "val": "25210 Trnova Trnova"
  },
  {
    "cast": "Trnovany",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žatec",
    "val": "43801 Zatec Trnovany"
  },
  {
    "cast": "Trnovany",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Teplice",
    "val": "41501 Teplice Trnovany"
  },
  {
    "cast": "Trnovany",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Trnovany",
    "val": "41201 Trnovany Trnovany"
  },
  {
    "cast": "Trnové Pole",
    "psc": "67178",
    "okres": "Znojmo",
    "obec": "Trnové Pole",
    "val": "67178 Trnove Pole Trnove Pole"
  },
  {
    "cast": "Trocnov",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Borovany",
    "val": "37312 Borovany Trocnov"
  },
  {
    "cast": "Troja (část)",
    "psc": "17100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "17100 Praha Troja (cast)"
  },
  {
    "cast": "Troja (část)",
    "psc": "18100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18100 Praha Troja (cast)"
  },
  {
    "cast": "Troja (část)",
    "psc": "18200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18200 Praha Troja (cast)"
  },
  {
    "cast": "Trojanovice",
    "psc": "74401",
    "okres": "Nový Jičín",
    "obec": "Trojanovice",
    "val": "74401 Trojanovice Trojanovice"
  },
  {
    "cast": "Trojany",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Kralovice",
    "val": "33141 Kralovice Trojany"
  },
  {
    "cast": "Trojany",
    "psc": "38272",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38272 Dolni Dvoriste Trojany"
  },
  {
    "cast": "Trojmezí",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Hranice",
    "val": "35201 Hranice Trojmezi"
  },
  {
    "cast": "Trojovice",
    "psc": "53833",
    "okres": "Chrudim",
    "obec": "Trojovice",
    "val": "53833 Trojovice Trojovice"
  },
  {
    "cast": "Trokavec",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Trokavec",
    "val": "33843 Trokavec Trokavec"
  },
  {
    "cast": "Troskotovice",
    "psc": "67178",
    "okres": "Brno-venkov",
    "obec": "Troskotovice",
    "val": "67178 Troskotovice Troskotovice"
  },
  {
    "cast": "Troskovice (část)",
    "psc": "50601",
    "okres": "Semily",
    "obec": "Troskovice",
    "val": "50601 Troskovice Troskovice (cast)"
  },
  {
    "cast": "Troskovice (část)",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Troskovice",
    "val": "51263 Troskovice Troskovice (cast)"
  },
  {
    "cast": "Trotina",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Smiřice",
    "val": "50303 Smirice Trotina"
  },
  {
    "cast": "Trotina",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Trotina",
    "val": "54401 Trotina Trotina"
  },
  {
    "cast": "Troubelice",
    "psc": "78383",
    "okres": "Olomouc",
    "obec": "Troubelice",
    "val": "78383 Troubelice Troubelice"
  },
  {
    "cast": "Troubky",
    "psc": "75102",
    "okres": "Přerov",
    "obec": "Troubky",
    "val": "75102 Troubky Troubky"
  },
  {
    "cast": "Troubky",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Troubky-Zdislavice",
    "val": "76802 Troubky-Zdislavice Troubky"
  },
  {
    "cast": "Troubsko (část)",
    "psc": "66441",
    "okres": "Brno-venkov",
    "obec": "Troubsko",
    "val": "66441 Troubsko Troubsko (cast)"
  },
  {
    "cast": "Troubsko (část)",
    "psc": "66447",
    "okres": "Brno-venkov",
    "obec": "Troubsko",
    "val": "66447 Troubsko Troubsko (cast)"
  },
  {
    "cast": "Trpěšice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Trpesice"
  },
  {
    "cast": "Trpík",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Trpík",
    "val": "56301 Trpik Trpik"
  },
  {
    "cast": "Trpín",
    "psc": "56974",
    "okres": "Svitavy",
    "obec": "Trpín",
    "val": "56974 Trpin Trpin"
  },
  {
    "cast": "Trpín",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Drslavice",
    "val": "38301 Drslavice Trpin"
  },
  {
    "cast": "Trpísty (část)",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Trpísty",
    "val": "34901 Trpisty Trpisty (cast)"
  },
  {
    "cast": "Trpísty (část)",
    "psc": "34972",
    "okres": "Tachov",
    "obec": "Trpísty",
    "val": "34972 Trpisty Trpisty (cast)"
  },
  {
    "cast": "Trpišov",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Slatiňany",
    "val": "53821 Slatinany Trpisov"
  },
  {
    "cast": "Trpišovice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Trpišovice",
    "val": "58401 Trpisovice Trpisovice"
  },
  {
    "cast": "Trpnouze",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Hranice",
    "val": "37401 Hranice Trpnouze"
  },
  {
    "cast": "Trpoměchy",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Trpomechy"
  },
  {
    "cast": "Trsice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Trsice"
  },
  {
    "cast": "Trsov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Nový Rychnov",
    "val": "39301 Novy Rychnov Trsov"
  },
  {
    "cast": "Trstěnice",
    "psc": "67171",
    "okres": "Znojmo",
    "obec": "Trstěnice",
    "val": "67171 Trstenice Trstenice"
  },
  {
    "cast": "Trstěnice",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Trstěnice",
    "val": "35301 Trstenice Trstenice"
  },
  {
    "cast": "Trstěnice",
    "psc": "56957",
    "okres": "Svitavy",
    "obec": "Trstěnice",
    "val": "56957 Trstenice Trstenice"
  },
  {
    "cast": "Tršice",
    "psc": "78357",
    "okres": "Olomouc",
    "obec": "Tršice",
    "val": "78357 Trsice Trsice"
  },
  {
    "cast": "Tršnice",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Cheb",
    "val": "35134 Cheb Trsnice"
  },
  {
    "cast": "Trubějov",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Kramolna",
    "val": "54701 Kramolna Trubejov"
  },
  {
    "cast": "Trubín",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Trubín",
    "val": "26701 Trubin Trubin"
  },
  {
    "cast": "Trubská",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Trubská",
    "val": "26601 Trubska Trubska"
  },
  {
    "cast": "Truskavna",
    "psc": "27723",
    "okres": "Mělník",
    "obec": "Kokořín",
    "val": "27723 Kokorin Truskavna"
  },
  {
    "cast": "Truskovice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Truskovice",
    "val": "38901 Truskovice Truskovice"
  },
  {
    "cast": "Trusnov",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Trusnov",
    "val": "53401 Trusnov Trusnov"
  },
  {
    "cast": "Truzenice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Velemyšleves",
    "val": "43801 Velemysleves Truzenice"
  },
  {
    "cast": "Tržek",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Tržek",
    "val": "57001 Trzek Trzek"
  },
  {
    "cast": "Tržek",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Trzek"
  },
  {
    "cast": "Třanovice",
    "psc": "73953",
    "okres": "Frýdek-Místek",
    "obec": "Třanovice",
    "val": "73953 Tranovice Tranovice"
  },
  {
    "cast": "Třebanice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38301 Lhenice Trebanice"
  },
  {
    "cast": "Třebařov",
    "psc": "56933",
    "okres": "Svitavy",
    "obec": "Třebařov",
    "val": "56933 Trebarov Trebarov"
  },
  {
    "cast": "Třebčice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Třebčice",
    "val": "33501 Trebcice Trebcice"
  },
  {
    "cast": "Třebčín",
    "psc": "78342",
    "okres": "Olomouc",
    "obec": "Lutín",
    "val": "78342 Lutin Trebcin"
  },
  {
    "cast": "Třebeč",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Borovany",
    "val": "37312 Borovany Trebec"
  },
  {
    "cast": "Třebechovice pod Orebem",
    "psc": "50346",
    "okres": "Hradec Králové",
    "obec": "Třebechovice pod Orebem",
    "val": "50346 Trebechovice pod Orebem Trebechovice pod Orebem"
  },
  {
    "cast": "Třebějice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Třebějice",
    "val": "39201 Trebejice Trebejice"
  },
  {
    "cast": "Třebel",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34901 Cernosin Trebel"
  },
  {
    "cast": "Třebelice",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Trebelice"
  },
  {
    "cast": "Třebelovice",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Třebelovice",
    "val": "67532 Trebelovice Trebelovice"
  },
  {
    "cast": "Třebeň",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Treben"
  },
  {
    "cast": "Třebenice",
    "psc": "41113",
    "okres": "Litoměřice",
    "obec": "Třebenice",
    "val": "41113 Trebenice Trebenice"
  },
  {
    "cast": "Třebenice",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Třebenice",
    "val": "67552 Trebenice Trebenice"
  },
  {
    "cast": "Třebenice",
    "psc": "25208",
    "okres": "Praha-západ",
    "obec": "Štěchovice",
    "val": "25208 Stechovice Trebenice"
  },
  {
    "cast": "Třebestovice",
    "psc": "28912",
    "okres": "Nymburk",
    "obec": "Třebestovice",
    "val": "28912 Trebestovice Trebestovice"
  },
  {
    "cast": "Třebeš (část)",
    "psc": "50002",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50002 Hradec Kralove Trebes (cast)"
  },
  {
    "cast": "Třebeš (část)",
    "psc": "50006",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50006 Hradec Kralove Trebes (cast)"
  },
  {
    "cast": "Třebeš (část)",
    "psc": "50008",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50008 Hradec Kralove Trebes (cast)"
  },
  {
    "cast": "Třebeš (část)",
    "psc": "50011",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50011 Hradec Kralove Trebes (cast)"
  },
  {
    "cast": "Třebeš (část)",
    "psc": "50012",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50012 Hradec Kralove Trebes (cast)"
  },
  {
    "cast": "Třebešice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Třebešice",
    "val": "25726 Trebesice Trebesice"
  },
  {
    "cast": "Třebešice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Třebešice",
    "val": "28601 Trebesice Trebesice"
  },
  {
    "cast": "Třebešov",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Třebešov",
    "val": "51601 Trebesov Trebesov"
  },
  {
    "cast": "Třebětice",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Třebětice",
    "val": "76901 Trebetice Trebetice"
  },
  {
    "cast": "Třebětice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Třebětice",
    "val": "38001 Trebetice Trebetice"
  },
  {
    "cast": "Třebětín",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Trebetin"
  },
  {
    "cast": "Třebětín",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Třebětín",
    "val": "28522 Trebetin Trebetin"
  },
  {
    "cast": "Třebíčko",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Trebicko"
  },
  {
    "cast": "Třebihošť (část)",
    "psc": "54475",
    "okres": "Trutnov",
    "obec": "Třebihošť",
    "val": "54475 Trebihost Trebihost (cast)"
  },
  {
    "cast": "Třebihošť (část)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Třebihošť",
    "val": "54401 Trebihost Trebihost (cast)"
  },
  {
    "cast": "Třebichovice",
    "psc": "27306",
    "okres": "Kladno",
    "obec": "Třebichovice",
    "val": "27306 Trebichovice Trebichovice"
  },
  {
    "cast": "Třebín",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Trebin"
  },
  {
    "cast": "Třebín",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Dubné",
    "val": "37384 Dubne Trebin"
  },
  {
    "cast": "Třebíška",
    "psc": "43183",
    "okres": "Chomutov",
    "obec": "Výsluní",
    "val": "43183 Vysluni Trebiska"
  },
  {
    "cast": "Třebíšov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Předslav",
    "val": "33901 Predslav Trebisov"
  },
  {
    "cast": "Třebiště",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Skalice",
    "val": "39201 Skalice Trebiste"
  },
  {
    "cast": "Třebívlice",
    "psc": "41115",
    "okres": "Litoměřice",
    "obec": "Třebívlice",
    "val": "41115 Trebivlice Trebivlice"
  },
  {
    "cast": "Třebíz",
    "psc": "27375",
    "okres": "Kladno",
    "obec": "Třebíz",
    "val": "27375 Trebiz Trebiz"
  },
  {
    "cast": "Třebkov",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Trebkov"
  },
  {
    "cast": "Třebnice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Trebnice"
  },
  {
    "cast": "Třebnice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Meclov",
    "val": "34601 Meclov Trebnice"
  },
  {
    "cast": "Třebnouševes",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Třebnouševes",
    "val": "50801 Trebnouseves Trebnouseves"
  },
  {
    "cast": "Třebnuška",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Zbiroh",
    "val": "33808 Zbiroh Trebnuska"
  },
  {
    "cast": "Třebobuz",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Líšťany",
    "val": "33035 Listany Trebobuz"
  },
  {
    "cast": "Třeboc",
    "psc": "27054",
    "okres": "Rakovník",
    "obec": "Třeboc",
    "val": "27054 Treboc Treboc"
  },
  {
    "cast": "Třebohostice",
    "psc": "25083",
    "okres": "Praha-východ",
    "obec": "Škvorec",
    "val": "25083 Skvorec Trebohostice"
  },
  {
    "cast": "Třebohostice (část)",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Třebohostice",
    "val": "38601 Trebohostice Trebohostice (cast)"
  },
  {
    "cast": "Třebohostice (část)",
    "psc": "38737",
    "okres": "Strakonice",
    "obec": "Třebohostice",
    "val": "38737 Trebohostice Trebohostice (cast)"
  },
  {
    "cast": "Třebom",
    "psc": "74725",
    "okres": "Opava",
    "obec": "Třebom",
    "val": "74725 Trebom Trebom"
  },
  {
    "cast": "Třebomyslice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Horažďovice",
    "val": "34101 Horazdovice Trebomyslice"
  },
  {
    "cast": "Třeboň I",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Třeboň",
    "val": "37901 Trebon Trebon I"
  },
  {
    "cast": "Třeboň II",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Třeboň",
    "val": "37901 Trebon Trebon II"
  },
  {
    "cast": "Třebonice (část)",
    "psc": "15500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15500 Praha Trebonice (cast)"
  },
  {
    "cast": "Třebonice (část)",
    "psc": "15521",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15521 Praha Trebonice (cast)"
  },
  {
    "cast": "Třebonín",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Třebonín",
    "val": "28601 Trebonin Trebonin"
  },
  {
    "cast": "Třeboradice",
    "psc": "19600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19600 Praha Treboradice"
  },
  {
    "cast": "Třebosice",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Třebosice",
    "val": "53002 Trebosice Trebosice"
  },
  {
    "cast": "Třebotov",
    "psc": "25226",
    "okres": "Praha-západ",
    "obec": "Třebotov",
    "val": "25226 Trebotov Trebotov"
  },
  {
    "cast": "Třebouň",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Toužim",
    "val": "36401 Touzim Treboun"
  },
  {
    "cast": "Třeboutice",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Křešice",
    "val": "41201 Kresice Treboutice"
  },
  {
    "cast": "Třebovětice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Cerekvice nad Bystřicí",
    "val": "50801 Cerekvice nad Bystrici Trebovetice"
  },
  {
    "cast": "Třebovice",
    "psc": "38403",
    "okres": "Prachatice",
    "obec": "Ktiš",
    "val": "38403 Ktis Trebovice"
  },
  {
    "cast": "Třebovice",
    "psc": "72200",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "72200 Ostrava Trebovice"
  },
  {
    "cast": "Třebovice",
    "psc": "56124",
    "okres": "Ústí nad Orlicí",
    "obec": "Třebovice",
    "val": "56124 Trebovice Trebovice"
  },
  {
    "cast": "Třebovle",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Třebovle",
    "val": "28163 Trebovle Trebovle"
  },
  {
    "cast": "Třebsín",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Krňany",
    "val": "25744 Krnany Trebsin"
  },
  {
    "cast": "Třebsko",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Třebsko",
    "val": "26242 Trebsko Trebsko"
  },
  {
    "cast": "Třebusice",
    "psc": "27341",
    "okres": "Kladno",
    "obec": "Třebusice",
    "val": "27341 Trebusice Trebusice"
  },
  {
    "cast": "Třebušín",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Třebušín",
    "val": "41201 Trebusin Trebusin"
  },
  {
    "cast": "Třebutičky",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Polepy",
    "val": "41145 Polepy Trebuticky"
  },
  {
    "cast": "Třebýcina",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Měčín",
    "val": "34012 Mecin Trebycina"
  },
  {
    "cast": "Třebýcinka",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Trebycinka"
  },
  {
    "cast": "Třemblat",
    "psc": "25165",
    "okres": "Praha-východ",
    "obec": "Ondřejov",
    "val": "25165 Ondrejov Tremblat"
  },
  {
    "cast": "Třemešek",
    "psc": "78801",
    "okres": "Šumperk",
    "obec": "Oskava",
    "val": "78801 Oskava Tremesek"
  },
  {
    "cast": "Třemešná",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39131 Jistebnice Tremesna"
  },
  {
    "cast": "Třemešná",
    "psc": "79382",
    "okres": "Bruntál",
    "obec": "Třemešná",
    "val": "79382 Tremesna Tremesna"
  },
  {
    "cast": "Třemešné",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Třemešné",
    "val": "34806 Tremesne Tremesne"
  },
  {
    "cast": "Třemošná",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Třemošná",
    "val": "33011 Tremosna Tremosna"
  },
  {
    "cast": "Třemošnice",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Ostředek",
    "val": "25726 Ostredek Tremosnice"
  },
  {
    "cast": "Třemošnice",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Třemošnice",
    "val": "53843 Tremosnice Tremosnice"
  },
  {
    "cast": "Třenice",
    "psc": "26761",
    "okres": "Beroun",
    "obec": "Cerhovice",
    "val": "26761 Cerhovice Trenice"
  },
  {
    "cast": "Třeskonice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Tuchořice",
    "val": "43801 Tuchorice Treskonice"
  },
  {
    "cast": "Třesov",
    "psc": "67502",
    "okres": "Třebíč",
    "obec": "Třesov",
    "val": "67502 Tresov Tresov"
  },
  {
    "cast": "Třesovice",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Třesovice",
    "val": "50315 Tresovice Tresovice"
  },
  {
    "cast": "Třešně",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Záhoří",
    "val": "39701 Zahori Tresne"
  },
  {
    "cast": "Třešňový Újezdec",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38411 Lhenice Tresnovy Ujezdec"
  },
  {
    "cast": "Třešovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Třešovice",
    "val": "38601 Tresovice Tresovice"
  },
  {
    "cast": "Třešť",
    "psc": "58901",
    "okres": "Jihlava",
    "obec": "Třešť",
    "val": "58901 Trest Trest"
  },
  {
    "cast": "Třeštice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Třeštice",
    "val": "58856 Trestice Trestice"
  },
  {
    "cast": "Třeština",
    "psc": "78973",
    "okres": "Šumperk",
    "obec": "Třeština",
    "val": "78973 Trestina Trestina"
  },
  {
    "cast": "Třetužel",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Červený Újezd",
    "val": "25786 Cerveny Ujezd Tretuzel"
  },
  {
    "cast": "Tři Bubny",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Orel",
    "val": "53701 Orel Tri Bubny"
  },
  {
    "cast": "Tři Dvory",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Tři Dvory",
    "val": "28002 Tri Dvory Tri Dvory"
  },
  {
    "cast": "Tři Dvory",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78401 Litovel Tri Dvory"
  },
  {
    "cast": "Tři Sekery",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Tři Sekery",
    "val": "35301 Tri Sekery Tri Sekery"
  },
  {
    "cast": "Tři Studně (část)",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Tři Studně",
    "val": "59231 Tri Studne Tri Studne (cast)"
  },
  {
    "cast": "Tři Studně (část)",
    "psc": "59204",
    "okres": "Žďár nad Sázavou",
    "obec": "Tři Studně",
    "val": "59204 Tri Studne Tri Studne (cast)"
  },
  {
    "cast": "Třibřichy",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Třibřichy",
    "val": "53701 Tribrichy Tribrichy"
  },
  {
    "cast": "Tříklasovice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Psárov",
    "val": "39201 Psarov Triklasovice"
  },
  {
    "cast": "Třímany",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Kladruby",
    "val": "33808 Kladruby Trimany"
  },
  {
    "cast": "Třískolupy",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Triskolupy"
  },
  {
    "cast": "Třísov",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Holubov",
    "val": "38203 Holubov Trisov"
  },
  {
    "cast": "Třitim",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Žimutice",
    "val": "37501 Zimutice Tritim"
  },
  {
    "cast": "Třtěnice",
    "psc": "50704",
    "okres": "Jičín",
    "obec": "Třtěnice",
    "val": "50704 Trtenice Trtenice"
  },
  {
    "cast": "Třtěno",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Chožov",
    "val": "44001 Chozov Trteno"
  },
  {
    "cast": "Třtí",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Dolní Hbity",
    "val": "26263 Dolni Hbity Trti"
  },
  {
    "cast": "Třtí (část)",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Sychrov",
    "val": "46344 Sychrov Trti (cast)"
  },
  {
    "cast": "Třtí (část)",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Sychrov",
    "val": "46343 Sychrov Trti (cast)"
  },
  {
    "cast": "Třtice",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Studnice",
    "val": "54701 Studnice Trtice"
  },
  {
    "cast": "Třtice",
    "psc": "27101",
    "okres": "Rakovník",
    "obec": "Třtice",
    "val": "27101 Trtice Trtice"
  },
  {
    "cast": "Tubož",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Blatce",
    "val": "47201 Blatce Tuboz"
  },
  {
    "cast": "Tučapy",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Holešov",
    "val": "76901 Holesov Tucapy"
  },
  {
    "cast": "Tučapy",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Tučapy",
    "val": "68301 Tucapy Tucapy"
  },
  {
    "cast": "Tučapy",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Dub nad Moravou",
    "val": "78375 Dub nad Moravou Tucapy"
  },
  {
    "cast": "Tučapy",
    "psc": "68709",
    "okres": "Uherské Hradiště",
    "obec": "Tučapy",
    "val": "68709 Tucapy Tucapy"
  },
  {
    "cast": "Tučapy (část)",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Tučapy",
    "val": "39201 Tucapy Tucapy (cast)"
  },
  {
    "cast": "Tučapy (část)",
    "psc": "39126",
    "okres": "Tábor",
    "obec": "Tučapy",
    "val": "39126 Tucapy Tucapy (cast)"
  },
  {
    "cast": "Tučín",
    "psc": "75116",
    "okres": "Přerov",
    "obec": "Tučín",
    "val": "75116 Tucin Tucin"
  },
  {
    "cast": "Tuhaň",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Tuhaň",
    "val": "27741 Tuhan Tuhan"
  },
  {
    "cast": "Tuhaň",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Tuhaň",
    "val": "47201 Tuhan Tuhan"
  },
  {
    "cast": "Tuhaň",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Stružinec",
    "val": "51251 Struzinec Tuhan"
  },
  {
    "cast": "Tuhanec",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Tuhaň",
    "val": "47201 Tuhan Tuhanec"
  },
  {
    "cast": "Tuchlovice",
    "psc": "27302",
    "okres": "Kladno",
    "obec": "Tuchlovice",
    "val": "27302 Tuchlovice Tuchlovice"
  },
  {
    "cast": "Tuchom",
    "psc": "28935",
    "okres": "Nymburk",
    "obec": "Košík",
    "val": "28935 Kosik Tuchom"
  },
  {
    "cast": "Tuchoměřice",
    "psc": "25267",
    "okres": "Praha-západ",
    "obec": "Tuchoměřice",
    "val": "25267 Tuchomerice Tuchomerice"
  },
  {
    "cast": "Tuchonice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Žimutice",
    "val": "37501 Zimutice Tuchonice"
  },
  {
    "cast": "Tuchoraz",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Tuchoraz",
    "val": "28201 Tuchoraz Tuchoraz"
  },
  {
    "cast": "Tuchořice",
    "psc": "43969",
    "okres": "Louny",
    "obec": "Tuchořice",
    "val": "43969 Tuchorice Tuchorice"
  },
  {
    "cast": "Tuchotice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Vidice",
    "val": "28401 Vidice Tuchotice"
  },
  {
    "cast": "Tuchov",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Bousov",
    "val": "53843 Bousov Tuchov"
  },
  {
    "cast": "Tuchyně",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Netvořice",
    "val": "25744 Netvorice Tuchyne"
  },
  {
    "cast": "Tuklaty",
    "psc": "25082",
    "okres": "Kolín",
    "obec": "Tuklaty",
    "val": "25082 Tuklaty Tuklaty"
  },
  {
    "cast": "Tukleky",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Oslov",
    "val": "39701 Oslov Tukleky"
  },
  {
    "cast": "Tukleky",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Senožaty",
    "val": "39601 Senozaty Tukleky"
  },
  {
    "cast": "Tulešice (část)",
    "psc": "67173",
    "okres": "Znojmo",
    "obec": "Tulešice",
    "val": "67173 Tulesice Tulesice (cast)"
  },
  {
    "cast": "Tulešice (část)",
    "psc": "67201",
    "okres": "Znojmo",
    "obec": "Tulešice",
    "val": "67201 Tulesice Tulesice (cast)"
  },
  {
    "cast": "Tůně",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Nechanice",
    "val": "50315 Nechanice Tune"
  },
  {
    "cast": "Tuněchody",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kladruby",
    "val": "34901 Kladruby Tunechody"
  },
  {
    "cast": "Tuněchody",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Tuněchody",
    "val": "53701 Tunechody Tunechody"
  },
  {
    "cast": "Tunochody",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Číhošť",
    "val": "58401 Cihost Tunochody"
  },
  {
    "cast": "Tupadly",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Tupadly",
    "val": "27721 Tupadly Tupadly"
  },
  {
    "cast": "Tupadly",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Tupadly"
  },
  {
    "cast": "Tupadly",
    "psc": "28563",
    "okres": "Kutná Hora",
    "obec": "Tupadly",
    "val": "28563 Tupadly Tupadly"
  },
  {
    "cast": "Tupec",
    "psc": "75125",
    "okres": "Přerov",
    "obec": "Veselíčko",
    "val": "75125 Veselicko Tupec"
  },
  {
    "cast": "Tupesy",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Přelouč",
    "val": "53501 Prelouc Tupesy"
  },
  {
    "cast": "Tupesy",
    "psc": "68707",
    "okres": "Uherské Hradiště",
    "obec": "Tupesy",
    "val": "68707 Tupesy Tupesy"
  },
  {
    "cast": "Tupesy",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Radošovice",
    "val": "37341 Radosovice Tupesy"
  },
  {
    "cast": "Turkovice",
    "psc": "53363",
    "okres": "Pardubice",
    "obec": "Turkovice",
    "val": "53363 Turkovice Turkovice"
  },
  {
    "cast": "Turkovice (část)",
    "psc": "25165",
    "okres": "Praha-východ",
    "obec": "Ondřejov",
    "val": "25165 Ondrejov Turkovice (cast)"
  },
  {
    "cast": "Turkovice (část)",
    "psc": "25166",
    "okres": "Praha-východ",
    "obec": "Ondřejov",
    "val": "25166 Ondrejov Turkovice (cast)"
  },
  {
    "cast": "Turnov",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Turnov"
  },
  {
    "cast": "Turov",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Moravany",
    "val": "53401 Moravany Turov"
  },
  {
    "cast": "Turov",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Podlesí",
    "val": "56201 Podlesi Turov"
  },
  {
    "cast": "Turovec (část)",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Turovec",
    "val": "39155 Turovec Turovec (cast)"
  },
  {
    "cast": "Turovec (část)",
    "psc": "39121",
    "okres": "Tábor",
    "obec": "Turovec",
    "val": "39121 Turovec Turovec (cast)"
  },
  {
    "cast": "Turovec (část)",
    "psc": "39156",
    "okres": "Tábor",
    "obec": "Turovec",
    "val": "39156 Turovec Turovec (cast)"
  },
  {
    "cast": "Turovice",
    "psc": "75114",
    "okres": "Přerov",
    "obec": "Turovice",
    "val": "75114 Turovice Turovice"
  },
  {
    "cast": "Turovka",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Horní Cerekev",
    "val": "39301 Horni Cerekev Turovka"
  },
  {
    "cast": "Tursko",
    "psc": "25265",
    "okres": "Praha-západ",
    "obec": "Tursko",
    "val": "25265 Tursko Tursko"
  },
  {
    "cast": "Tuř",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Tuř",
    "val": "50601 Tur Tur"
  },
  {
    "cast": "Tuřany",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Tuřany",
    "val": "35002 Turany Turany"
  },
  {
    "cast": "Tuřany",
    "psc": "27379",
    "okres": "Kladno",
    "obec": "Tuřany",
    "val": "27379 Turany Turany"
  },
  {
    "cast": "Tuřany (část)",
    "psc": "62000",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62000 Brno Turany (cast)"
  },
  {
    "cast": "Tuřany (část)",
    "psc": "62700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62700 Brno Turany (cast)"
  },
  {
    "cast": "Tuřice",
    "psc": "29474",
    "okres": "Mladá Boleslav",
    "obec": "Tuřice",
    "val": "29474 Turice Turice"
  },
  {
    "cast": "Tušimice",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Tusimice"
  },
  {
    "cast": "Tuškov",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Tuskov"
  },
  {
    "cast": "Tušovice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Tušovice",
    "val": "26272 Tusovice Tusovice"
  },
  {
    "cast": "Tušť",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Suchdol nad Lužnicí",
    "val": "37806 Suchdol nad Luznici Tust"
  },
  {
    "cast": "Tutleky",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Tutleky",
    "val": "51741 Tutleky Tutleky"
  },
  {
    "cast": "Tužice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Tužice",
    "val": "34142 Tuzice Tuzice"
  },
  {
    "cast": "Tužín",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Radim",
    "val": "50713 Radim Tuzin"
  },
  {
    "cast": "Tvarožná",
    "psc": "66405",
    "okres": "Brno-venkov",
    "obec": "Tvarožná",
    "val": "66405 Tvarozna Tvarozna"
  },
  {
    "cast": "Tvarožná Lhota",
    "psc": "69662",
    "okres": "Hodonín",
    "obec": "Tvarožná Lhota",
    "val": "69662 Tvarozna Lhota Tvarozna Lhota"
  },
  {
    "cast": "Tvorovice",
    "psc": "79823",
    "okres": "Prostějov",
    "obec": "Tvorovice",
    "val": "79823 Tvorovice Tvorovice"
  },
  {
    "cast": "Tvoršovice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25601 Bystrice Tvorsovice"
  },
  {
    "cast": "Tvořihráz",
    "psc": "67134",
    "okres": "Znojmo",
    "obec": "Tvořihráz",
    "val": "67134 Tvorihraz Tvorihraz"
  },
  {
    "cast": "Tvrdín",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Hrobčice",
    "val": "41804 Hrobcice Tvrdin"
  },
  {
    "cast": "Tvrdkov",
    "psc": "79344",
    "okres": "Bruntál",
    "obec": "Tvrdkov",
    "val": "79344 Tvrdkov Tvrdkov"
  },
  {
    "cast": "Tvrdonice (část)",
    "psc": "69002",
    "okres": "Břeclav",
    "obec": "Tvrdonice",
    "val": "69002 Tvrdonice Tvrdonice (cast)"
  },
  {
    "cast": "Tvrdonice (část)",
    "psc": "69153",
    "okres": "Břeclav",
    "obec": "Tvrdonice",
    "val": "69153 Tvrdonice Tvrdonice (cast)"
  },
  {
    "cast": "Tvrdonice (část)",
    "psc": "69152",
    "okres": "Břeclav",
    "obec": "Tvrdonice",
    "val": "69152 Tvrdonice Tvrdonice (cast)"
  },
  {
    "cast": "Tvrdoslav",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Tvrdoslav"
  },
  {
    "cast": "Tvršice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Staňkovice",
    "val": "43801 Stankovice Tvrsice"
  },
  {
    "cast": "Tvrzice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Tvrzice",
    "val": "38422 Tvrzice Tvrzice"
  },
  {
    "cast": "Týček",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Týček",
    "val": "33808 Tycek Tycek"
  },
  {
    "cast": "Tylov (část)",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Lomnice",
    "val": "79201 Lomnice Tylov (cast)"
  },
  {
    "cast": "Tylov (část)",
    "psc": "79302",
    "okres": "Bruntál",
    "obec": "Lomnice",
    "val": "79302 Lomnice Tylov (cast)"
  },
  {
    "cast": "Tymákov",
    "psc": "33201",
    "okres": "Plzeň-město",
    "obec": "Tymákov",
    "val": "33201 Tymakov Tymakov"
  },
  {
    "cast": "Týmova Ves",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Lukavec",
    "val": "39501 Lukavec Tymova Ves"
  },
  {
    "cast": "Týn",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Luka",
    "val": "47201 Luka Tyn"
  },
  {
    "cast": "Týn",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Tyn"
  },
  {
    "cast": "Týn",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Lomnice",
    "val": "35601 Lomnice Tyn"
  },
  {
    "cast": "Týn nad Bečvou",
    "psc": "75131",
    "okres": "Přerov",
    "obec": "Týn nad Bečvou",
    "val": "75131 Tyn nad Becvou Tyn nad Becvou"
  },
  {
    "cast": "Týn nad Vltavou",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Týn nad Vltavou",
    "val": "37501 Tyn nad Vltavou Tyn nad Vltavou"
  },
  {
    "cast": "Týnčany",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Tyncany"
  },
  {
    "cast": "Týnec",
    "psc": "27329",
    "okres": "Kladno",
    "obec": "Koleč",
    "val": "27329 Kolec Tynec"
  },
  {
    "cast": "Týnec",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Chotěšov",
    "val": "33301 Chotesov Tynec"
  },
  {
    "cast": "Týnec",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Malý Bor",
    "val": "34101 Maly Bor Tynec"
  },
  {
    "cast": "Týnec",
    "psc": "69154",
    "okres": "Břeclav",
    "obec": "Týnec",
    "val": "69154 Tynec Tynec"
  },
  {
    "cast": "Týnec",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Dobrovice",
    "val": "29441 Dobrovice Tynec"
  },
  {
    "cast": "Týnec",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Týnec",
    "val": "34021 Tynec Tynec"
  },
  {
    "cast": "Týnec",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Tynec"
  },
  {
    "cast": "Týnec nad Labem",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Týnec nad Labem",
    "val": "28126 Tynec nad Labem Tynec nad Labem"
  },
  {
    "cast": "Týnec nad Sázavou",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25741 Tynec nad Sazavou Tynec nad Sazavou"
  },
  {
    "cast": "Týneček",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Olomouc",
    "val": "77900 Olomouc Tynecek"
  },
  {
    "cast": "Týnice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Přeštěnice",
    "val": "39901 Prestenice Tynice"
  },
  {
    "cast": "Týniště",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Týniště",
    "val": "33401 Tyniste Tyniste"
  },
  {
    "cast": "Týniště",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Tyniste"
  },
  {
    "cast": "Týniště",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Malešov",
    "val": "28401 Malesov Tyniste"
  },
  {
    "cast": "Týniště",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Zubrnice",
    "val": "40002 Zubrnice Tyniste"
  },
  {
    "cast": "Týniště nad Orlicí",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Týniště nad Orlicí",
    "val": "51721 Tyniste nad Orlici Tyniste nad Orlici"
  },
  {
    "cast": "Týnišťko",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Týnišťko",
    "val": "56601 Tynistko Tynistko"
  },
  {
    "cast": "Týnské Předměstí",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Domažlice",
    "val": "34401 Domazlice Tynske Predmesti"
  },
  {
    "cast": "Tyra",
    "psc": "73961",
    "okres": "Frýdek-Místek",
    "obec": "Třinec",
    "val": "73961 Trinec Tyra"
  },
  {
    "cast": "Týřovice",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Hřebečníky",
    "val": "27041 Hrebecniky Tyrovice"
  },
  {
    "cast": "Týřovice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Pačejov",
    "val": "34101 Pacejov Tyrovice"
  },
  {
    "cast": "Tytry",
    "psc": "27021",
    "okres": "Rakovník",
    "obec": "Pavlíkov",
    "val": "27021 Pavlikov Tytry"
  },
  {
    "cast": "U Česany",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Dalovice",
    "val": "29301 Dalovice U Cesany"
  },
  {
    "cast": "U Sloupů",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk U Sloupu"
  },
  {
    "cast": "U Vodojemu",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Bavoryně",
    "val": "26751 Bavoryne U Vodojemu"
  },
  {
    "cast": "Úbislav",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Stachy",
    "val": "38473 Stachy Ubislav"
  },
  {
    "cast": "Úbislavice",
    "psc": "50792",
    "okres": "Jičín",
    "obec": "Úbislavice",
    "val": "50792 Ubislavice Ubislavice"
  },
  {
    "cast": "Ublo",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Ublo",
    "val": "76312 Ublo Ublo"
  },
  {
    "cast": "Úblo",
    "psc": "74771",
    "okres": "Opava",
    "obec": "Brumovice",
    "val": "74771 Brumovice Ublo"
  },
  {
    "cast": "Úboč",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Úboč",
    "val": "34543 Uboc Uboc"
  },
  {
    "cast": "Úbočí",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Dolní Žandov",
    "val": "35002 Dolni Zandov Uboci"
  },
  {
    "cast": "Úbočí",
    "psc": "43183",
    "okres": "Chomutov",
    "obec": "Výsluní",
    "val": "43183 Vysluni Uboci"
  },
  {
    "cast": "Úborsko",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Běhařov",
    "val": "34021 Beharov Uborsko"
  },
  {
    "cast": "Ubušín",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Jimramov",
    "val": "59242 Jimramov Ubusin"
  },
  {
    "cast": "Ubušínek",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Ubušínek",
    "val": "59265 Ubusinek Ubusinek"
  },
  {
    "cast": "Udánky",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Moravská Třebová",
    "val": "57101 Moravska Trebova Udanky"
  },
  {
    "cast": "Údavy",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec nad Doubravou",
    "val": "58263 Zdirec nad Doubravou Udavy"
  },
  {
    "cast": "Udeřice",
    "psc": "67555",
    "okres": "Třebíč",
    "obec": "Bačice",
    "val": "67555 Bacice Uderice"
  },
  {
    "cast": "Údlice",
    "psc": "43141",
    "okres": "Chomutov",
    "obec": "Údlice",
    "val": "43141 Udlice Udlice"
  },
  {
    "cast": "Údolí",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Obrataň",
    "val": "39501 Obratan Udoli"
  },
  {
    "cast": "Údolí",
    "psc": "56163",
    "okres": "Ústí nad Orlicí",
    "obec": "Nekoř",
    "val": "56163 Nekor Udoli"
  },
  {
    "cast": "Údolí",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37401 Nove Hrady Udoli"
  },
  {
    "cast": "Údolí",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Horní Krupá",
    "val": "58001 Horni Krupa Udoli"
  },
  {
    "cast": "Údolí (část)",
    "psc": "35733",
    "okres": "Sokolov",
    "obec": "Loket",
    "val": "35733 Loket Udoli (cast)"
  },
  {
    "cast": "Údolí (část)",
    "psc": "35731",
    "okres": "Sokolov",
    "obec": "Loket",
    "val": "35731 Loket Udoli (cast)"
  },
  {
    "cast": "Údolíčko",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Perštejn",
    "val": "43151 Perstejn Udolicko"
  },
  {
    "cast": "Údolnice",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25724 Vranov Udolnice"
  },
  {
    "cast": "Údraž",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Albrechtice nad Vltavou",
    "val": "39701 Albrechtice nad Vltavou Udraz"
  },
  {
    "cast": "Údrč",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Bochov",
    "val": "36471 Bochov Udrc"
  },
  {
    "cast": "Údrnice",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Údrnice",
    "val": "50723 Udrnice Udrnice"
  },
  {
    "cast": "Uhelná",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Uhelná",
    "val": "79070 Uhelna Uhelna"
  },
  {
    "cast": "Uhelná",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Uhelna"
  },
  {
    "cast": "Uhelná Příbram",
    "psc": "58245",
    "okres": "Havlíčkův Brod",
    "obec": "Uhelná Příbram",
    "val": "58245 Uhelna Pribram Uhelna Pribram"
  },
  {
    "cast": "Úhelnice",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29406 Knezmost Uhelnice"
  },
  {
    "cast": "Úherce",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Úherce",
    "val": "44001 Uherce Uherce"
  },
  {
    "cast": "Úherce",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Úherce",
    "val": "33023 Uherce Uherce"
  },
  {
    "cast": "Úherce",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Dobrovice",
    "val": "29441 Dobrovice Uherce"
  },
  {
    "cast": "Uherčice",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Uherčice",
    "val": "67107 Uhercice Uhercice"
  },
  {
    "cast": "Uherčice",
    "psc": "69162",
    "okres": "Břeclav",
    "obec": "Uherčice",
    "val": "69162 Uhercice Uhercice"
  },
  {
    "cast": "Úherčice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Úherčice",
    "val": "53803 Uhercice Uhercice"
  },
  {
    "cast": "Uherské Hradiště (část)",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68601 Uherske Hradiste Uherske Hradiste (cast)"
  },
  {
    "cast": "Uherské Hradiště (část)",
    "psc": "68606",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68606 Uherske Hradiste Uherske Hradiste (cast)"
  },
  {
    "cast": "Uhersko (část)",
    "psc": "53373",
    "okres": "Pardubice",
    "obec": "Uhersko",
    "val": "53373 Uhersko Uhersko (cast)"
  },
  {
    "cast": "Uhersko (část)",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Uhersko",
    "val": "53401 Uhersko Uhersko (cast)"
  },
  {
    "cast": "Uherský Brod (část)",
    "psc": "68734",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Brod",
    "val": "68734 Uhersky Brod Uhersky Brod (cast)"
  },
  {
    "cast": "Uherský Brod (část)",
    "psc": "68801",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Brod",
    "val": "68801 Uhersky Brod Uhersky Brod (cast)"
  },
  {
    "cast": "Uherský Ostroh",
    "psc": "68724",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Ostroh",
    "val": "68724 Uhersky Ostroh Uhersky Ostroh"
  },
  {
    "cast": "Úhlejov",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Úhlejov",
    "val": "50771 Uhlejov Uhlejov"
  },
  {
    "cast": "Uhlíře",
    "psc": "50781",
    "okres": "Jičín",
    "obec": "Lázně Bělohrad",
    "val": "50781 Lazne Belohrad Uhlire"
  },
  {
    "cast": "Uhlířov",
    "psc": "74784",
    "okres": "Opava",
    "obec": "Uhlířov",
    "val": "74784 Uhlirov Uhlirov"
  },
  {
    "cast": "Uhlířská Lhota",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Uhlířská Lhota",
    "val": "28126 Uhlirska Lhota Uhlirska Lhota"
  },
  {
    "cast": "Uhlířské Janovice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Uhlířské Janovice",
    "val": "28504 Uhlirske Janovice Uhlirske Janovice"
  },
  {
    "cast": "Uhliště",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Chudenín",
    "val": "34022 Chudenin Uhliste"
  },
  {
    "cast": "Úholičky",
    "psc": "25264",
    "okres": "Praha-západ",
    "obec": "Úholičky",
    "val": "25264 Uholicky Uholicky"
  },
  {
    "cast": "Úhonice",
    "psc": "25218",
    "okres": "Praha-západ",
    "obec": "Úhonice",
    "val": "25218 Uhonice Uhonice"
  },
  {
    "cast": "Úhořilka",
    "psc": "58253",
    "okres": "Havlíčkův Brod",
    "obec": "Úhořilka",
    "val": "58253 Uhorilka Uhorilka"
  },
  {
    "cast": "Úhošťany",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Uhostany"
  },
  {
    "cast": "Úhrov",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Kraborovice",
    "val": "58282 Kraborovice Uhrov"
  },
  {
    "cast": "Úhřetice",
    "psc": "53832",
    "okres": "Chrudim",
    "obec": "Úhřetice",
    "val": "53832 Uhretice Uhretice"
  },
  {
    "cast": "Úhřetická Lhota",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Úhřetická Lhota",
    "val": "53002 Uhreticka Lhota Uhreticka Lhota"
  },
  {
    "cast": "Uhřice",
    "psc": "68333",
    "okres": "Vyškov",
    "obec": "Uhřice",
    "val": "68333 Uhrice Uhrice"
  },
  {
    "cast": "Uhřice",
    "psc": "69634",
    "okres": "Hodonín",
    "obec": "Uhřice",
    "val": "69634 Uhrice Uhrice"
  },
  {
    "cast": "Uhřice",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Uhřice",
    "val": "67963 Uhrice Uhrice"
  },
  {
    "cast": "Uhřice",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Uhřice",
    "val": "76833 Uhrice Uhrice"
  },
  {
    "cast": "Uhřice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Uhrice"
  },
  {
    "cast": "Uhřice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Vlachovo Březí",
    "val": "38422 Vlachovo Brezi Uhrice"
  },
  {
    "cast": "Uhřičice",
    "psc": "75201",
    "okres": "Přerov",
    "obec": "Uhřičice",
    "val": "75201 Uhricice Uhricice"
  },
  {
    "cast": "Uhříněves",
    "psc": "10400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10400 Praha Uhrineves"
  },
  {
    "cast": "Uhřínov",
    "psc": "59441",
    "okres": "Žďár nad Sázavou",
    "obec": "Uhřínov",
    "val": "59441 Uhrinov Uhrinov"
  },
  {
    "cast": "Uhřínov (část)",
    "psc": "51703",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51703 Liberk Uhrinov (cast)"
  },
  {
    "cast": "Uhřínov (část)",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51601 Liberk Uhrinov (cast)"
  },
  {
    "cast": "Uhřínov (část)",
    "psc": "51791",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Liberk",
    "val": "51791 Liberk Uhrinov (cast)"
  },
  {
    "cast": "Uhřínovice",
    "psc": "58832",
    "okres": "Jihlava",
    "obec": "Brtnice",
    "val": "58832 Brtnice Uhrinovice"
  },
  {
    "cast": "Uhřínovice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Voděrady",
    "val": "51721 Voderady Uhrinovice"
  },
  {
    "cast": "Uhřínov-Hranice IX x)",
    "psc": "75361",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75361 Hranice Uhrinov-Hranice IX x)"
  },
  {
    "cast": "Uhy",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Uhy",
    "val": "27324 Uhy Uhy"
  },
  {
    "cast": "Ujčín",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Ujcin"
  },
  {
    "cast": "Ujčov",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Ujčov",
    "val": "59262 Ujcov Ujcov"
  },
  {
    "cast": "Újezd",
    "psc": "26761",
    "okres": "Beroun",
    "obec": "Újezd",
    "val": "26761 Ujezd Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "67140",
    "okres": "Znojmo",
    "obec": "Újezd",
    "val": "67140 Ujezd Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "31200",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "31200 Plzen Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Horšice",
    "val": "33401 Horsice Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Újezd",
    "val": "34401 Ujezd Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Mohelnice",
    "val": "78985 Mohelnice Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "47161",
    "okres": "Česká Lípa",
    "obec": "Jestřebí",
    "val": "47161 Jestrebi Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "78396",
    "okres": "Olomouc",
    "obec": "Újezd",
    "val": "78396 Ujezd Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Kunštát",
    "val": "67972 Kunstat Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Smilovice",
    "val": "29442 Smilovice Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "76325",
    "okres": "Zlín",
    "obec": "Újezd",
    "val": "76325 Ujezd Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Trmice",
    "val": "40002 Trmice Ujezd"
  },
  {
    "cast": "Újezd",
    "psc": "37501",
    "okres": "Písek",
    "obec": "Albrechtice nad Vltavou",
    "val": "37501 Albrechtice nad Vltavou Ujezd"
  },
  {
    "cast": "Újezd nad Lesy",
    "psc": "19016",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19016 Praha Ujezd nad Lesy"
  },
  {
    "cast": "Újezd nad Zbečnem",
    "psc": "27024",
    "okres": "Rakovník",
    "obec": "Zbečno",
    "val": "27024 Zbecno Ujezd nad Zbecnem"
  },
  {
    "cast": "Újezd nade Mží",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Újezd nade Mží",
    "val": "33033 Ujezd nade Mzi Ujezd nade Mzi"
  },
  {
    "cast": "Újezd pod Přimdou",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Ujezd pod Primdou"
  },
  {
    "cast": "Újezd pod Troskami",
    "psc": "51263",
    "okres": "Jičín",
    "obec": "Újezd pod Troskami",
    "val": "51263 Ujezd pod Troskami Ujezd pod Troskami"
  },
  {
    "cast": "Újezd Svatého Kříže",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Ujezd Svateho Krize"
  },
  {
    "cast": "Újezd u Boskovic",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Újezd u Boskovic",
    "val": "68001 Ujezd u Boskovic Ujezd u Boskovic"
  },
  {
    "cast": "Újezd u Brna",
    "psc": "66453",
    "okres": "Brno-venkov",
    "obec": "Újezd u Brna",
    "val": "66453 Ujezd u Brna Ujezd u Brna"
  },
  {
    "cast": "Újezd u Černé Hory",
    "psc": "67922",
    "okres": "Blansko",
    "obec": "Újezd u Černé Hory",
    "val": "67922 Ujezd u Cerne Hory Ujezd u Cerne Hory"
  },
  {
    "cast": "Újezd u Chanovic",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Chanovice",
    "val": "34101 Chanovice Ujezd u Chanovic"
  },
  {
    "cast": "Újezd u Chocně",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Újezd u Chocně",
    "val": "56501 Ujezd u Chocne Ujezd u Chocne"
  },
  {
    "cast": "Újezd u Kasejovic",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Kasejovice",
    "val": "33544 Kasejovice Ujezd u Kasejovic"
  },
  {
    "cast": "Újezd u Plánice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Újezd u Plánice",
    "val": "33901 Ujezd u Planice Ujezd u Planice"
  },
  {
    "cast": "Újezd u Průhonic",
    "psc": "14900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14900 Praha Ujezd u Pruhonic"
  },
  {
    "cast": "Újezd u Přelouče",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Újezd u Přelouče",
    "val": "53316 Ujezd u Prelouce Ujezd u Prelouce"
  },
  {
    "cast": "Újezd u Rosic",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Újezd u Rosic",
    "val": "66484 Ujezd u Rosic Ujezd u Rosic"
  },
  {
    "cast": "Újezd u Sezemic",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Újezd u Sezemic",
    "val": "53304 Ujezd u Sezemic Ujezd u Sezemic"
  },
  {
    "cast": "Újezd u Skaličan",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Chobot",
    "val": "38801 Chobot Ujezd u Skalican"
  },
  {
    "cast": "Újezd u Svatého Kříže",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Újezd u Svatého Kříže",
    "val": "33824 Ujezd u Svateho Krize Ujezd u Svateho Krize"
  },
  {
    "cast": "Újezd u Tišnova",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Újezd u Tišnova",
    "val": "59455 Ujezd u Tisnova Ujezd u Tisnova"
  },
  {
    "cast": "Újezd (část)",
    "psc": "59212",
    "okres": "Žďár nad Sázavou",
    "obec": "Újezd",
    "val": "59212 Ujezd Ujezd (cast)"
  },
  {
    "cast": "Újezd (část)",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Černilov",
    "val": "50303 Cernilov Ujezd (cast)"
  },
  {
    "cast": "Újezd (část)",
    "psc": "59214",
    "okres": "Žďár nad Sázavou",
    "obec": "Újezd",
    "val": "59214 Ujezd Ujezd (cast)"
  },
  {
    "cast": "Újezd (část)",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Černilov",
    "val": "50003 Cernilov Ujezd (cast)"
  },
  {
    "cast": "Újezdec",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Bělčice",
    "val": "38742 Belcice Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Újezdec",
    "val": "57001 Ujezdec Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Mochtín",
    "val": "33901 Mochtin Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "27041",
    "okres": "Rakovník",
    "obec": "Hřebečníky",
    "val": "27041 Hrebecniky Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bolešiny",
    "val": "33901 Bolesiny Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Číčenice",
    "val": "38901 Cicenice Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Petrovice I",
    "val": "28601 Petrovice I Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Újezdec",
    "val": "38422 Ujezdec Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Smilovice",
    "val": "29442 Smilovice Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Ptenín",
    "val": "33452 Ptenin Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Lhota pod Hořičkami",
    "val": "55205 Lhota pod Horickami Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "68741",
    "okres": "Uherské Hradiště",
    "obec": "Újezdec",
    "val": "68741 Ujezdec Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Syřenov",
    "val": "51251 Syrenov Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "51771",
    "okres": "Hradec Králové",
    "obec": "Ledce",
    "val": "51771 Ledce Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Újezdec",
    "val": "27745 Ujezdec Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Újezdec",
    "val": "37821 Ujezdec Ujezdec"
  },
  {
    "cast": "Újezdec",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Horní Kruty",
    "val": "28163 Horni Kruty Ujezdec"
  },
  {
    "cast": "Újezdec (část)",
    "psc": "68734",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Brod",
    "val": "68734 Uhersky Brod Ujezdec (cast)"
  },
  {
    "cast": "Újezdec (část)",
    "psc": "68801",
    "okres": "Uherské Hradiště",
    "obec": "Uherský Brod",
    "val": "68801 Uhersky Brod Ujezdec (cast)"
  },
  {
    "cast": "Újezdec-Přerov VI x)",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Ujezdec-Prerov VI x)"
  },
  {
    "cast": "Újezdeček",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Újezdeček",
    "val": "41501 Ujezdecek Ujezdecek"
  },
  {
    "cast": "Újezdské Předměstí",
    "psc": "41801",
    "okres": "Teplice",
    "obec": "Bílina",
    "val": "41801 Bilina Ujezdske Predmesti"
  },
  {
    "cast": "Újezdsko",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kostelany",
    "val": "76701 Kostelany Ujezdsko"
  },
  {
    "cast": "Ujkovice",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Ujkovice",
    "val": "29404 Ujkovice Ujkovice"
  },
  {
    "cast": "Úklid",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Nedrahovice",
    "val": "26401 Nedrahovice Uklid"
  },
  {
    "cast": "Úlehle",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Úlehle",
    "val": "38719 Ulehle Ulehle"
  },
  {
    "cast": "Úlehle",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nemyšl",
    "val": "39143 Nemysl Ulehle"
  },
  {
    "cast": "Úlehle",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Předslavice",
    "val": "38701 Predslavice Ulehle"
  },
  {
    "cast": "Úlibice",
    "psc": "50707",
    "okres": "Jičín",
    "obec": "Úlibice",
    "val": "50707 Ulibice Ulibice"
  },
  {
    "cast": "Úlice",
    "psc": "33033",
    "okres": "Plzeň-sever",
    "obec": "Úlice",
    "val": "33033 Ulice Ulice"
  },
  {
    "cast": "Úlíkov",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Němčice",
    "val": "34506 Nemcice Ulikov"
  },
  {
    "cast": "Úloh",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Běšiny",
    "val": "33901 Besiny Uloh"
  },
  {
    "cast": "Úlovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Ročov",
    "val": "44001 Rocov Ulovice"
  },
  {
    "cast": "Úmonín",
    "psc": "28546",
    "okres": "Kutná Hora",
    "obec": "Úmonín",
    "val": "28546 Umonin Umonin"
  },
  {
    "cast": "Úmyslovice",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Úmyslovice",
    "val": "29001 Umyslovice Umyslovice"
  },
  {
    "cast": "Únanov",
    "psc": "67131",
    "okres": "Znojmo",
    "obec": "Únanov",
    "val": "67131 Unanov Unanov"
  },
  {
    "cast": "Unčice",
    "psc": "79827",
    "okres": "Prostějov",
    "obec": "Pavlovice u Kojetína",
    "val": "79827 Pavlovice u Kojetina Uncice"
  },
  {
    "cast": "Unčín",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Unčín",
    "val": "59242 Uncin Uncin"
  },
  {
    "cast": "Unčín (část)",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Uncin (cast)"
  },
  {
    "cast": "Unčín (část)",
    "psc": "40317",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "40317 Krupka Uncin (cast)"
  },
  {
    "cast": "Unčovice",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78401 Litovel Uncovice"
  },
  {
    "cast": "Únehle",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Únehle",
    "val": "34901 Unehle Unehle"
  },
  {
    "cast": "Únějovice",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Únějovice",
    "val": "34543 Unejovice Unejovice"
  },
  {
    "cast": "Unerázka",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Bezděčí u Trnávky",
    "val": "57101 Bezdeci u Trnavky Unerazka"
  },
  {
    "cast": "Úněšov",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33038 Unesov Unesov"
  },
  {
    "cast": "Únětice",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Údrnice",
    "val": "50723 Udrnice Unetice"
  },
  {
    "cast": "Únětice",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Únětice",
    "val": "33601 Unetice Unetice"
  },
  {
    "cast": "Únětice",
    "psc": "25262",
    "okres": "Praha-západ",
    "obec": "Únětice",
    "val": "25262 Unetice Unetice"
  },
  {
    "cast": "Unhošť (část)",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Unhošť",
    "val": "27351 Unhost Unhost (cast)"
  },
  {
    "cast": "Unhošť (část)",
    "psc": "26707",
    "okres": "Kladno",
    "obec": "Unhošť",
    "val": "26707 Unhost Unhost (cast)"
  },
  {
    "cast": "Únice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Únice",
    "val": "38601 Unice Unice"
  },
  {
    "cast": "Uničov",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Uničov",
    "val": "78391 Unicov Unicov"
  },
  {
    "cast": "Unín",
    "psc": "67924",
    "okres": "Brno-venkov",
    "obec": "Unín",
    "val": "67924 Unin Unin"
  },
  {
    "cast": "Unkovice",
    "psc": "66463",
    "okres": "Brno-venkov",
    "obec": "Unkovice",
    "val": "66463 Unkovice Unkovice"
  },
  {
    "cast": "Úpice",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Úpice",
    "val": "54232 Upice Upice"
  },
  {
    "cast": "Úpohlavy",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Úpohlavy",
    "val": "41002 Upohlavy Upohlavy"
  },
  {
    "cast": "Úpoř",
    "psc": "41753",
    "okres": "Teplice",
    "obec": "Světec",
    "val": "41753 Svetec Upor"
  },
  {
    "cast": "Úpořiny (část)",
    "psc": "41761",
    "okres": "Teplice",
    "obec": "Bystřany",
    "val": "41761 Bystrany Uporiny (cast)"
  },
  {
    "cast": "Úpořiny (část)",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Bystřany",
    "val": "41501 Bystrany Uporiny (cast)"
  },
  {
    "cast": "Úraz",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nemyšl",
    "val": "39143 Nemysl Uraz"
  },
  {
    "cast": "Urbaneč",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Peč",
    "val": "38001 Pec Urbanec"
  },
  {
    "cast": "Urbanice",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Urbanice",
    "val": "53501 Urbanice Urbanice"
  },
  {
    "cast": "Urbanice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Urbanice",
    "val": "50327 Urbanice Urbanice"
  },
  {
    "cast": "Urbanov",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Urbanov",
    "val": "58862 Urbanov Urbanov"
  },
  {
    "cast": "Určice",
    "psc": "79804",
    "okres": "Prostějov",
    "obec": "Určice",
    "val": "79804 Urcice Urcice"
  },
  {
    "cast": "Úročnice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Urocnice"
  },
  {
    "cast": "Úsilné",
    "psc": "37010",
    "okres": "České Budějovice",
    "obec": "Úsilné",
    "val": "37010 Usilne Usilne"
  },
  {
    "cast": "Úsilov",
    "psc": "34506",
    "okres": "Domažlice",
    "obec": "Úsilov",
    "val": "34506 Usilov Usilov"
  },
  {
    "cast": "Úsobí",
    "psc": "58254",
    "okres": "Havlíčkův Brod",
    "obec": "Úsobí",
    "val": "58254 Usobi Usobi"
  },
  {
    "cast": "Úsobrno",
    "psc": "67939",
    "okres": "Blansko",
    "obec": "Úsobrno",
    "val": "67939 Usobrno Usobrno"
  },
  {
    "cast": "Úsov",
    "psc": "78973",
    "okres": "Šumperk",
    "obec": "Úsov",
    "val": "78973 Usov Usov"
  },
  {
    "cast": "Ústaleč",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34142 Nalzovske Hory Ustalec"
  },
  {
    "cast": "Ústějov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Mladá Vožice",
    "val": "39143 Mlada Vozice Ustejov"
  },
  {
    "cast": "Ústí",
    "psc": "75501",
    "okres": "Vsetín",
    "obec": "Ústí",
    "val": "75501 Usti Usti"
  },
  {
    "cast": "Ústí",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Ústí",
    "val": "75301 Usti Usti"
  },
  {
    "cast": "Ústí",
    "psc": "50791",
    "okres": "Jičín",
    "obec": "Stará Paka",
    "val": "50791 Stara Paka Usti"
  },
  {
    "cast": "Ústí",
    "psc": "58842",
    "okres": "Jihlava",
    "obec": "Ústí",
    "val": "58842 Usti Usti"
  },
  {
    "cast": "Ústí",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Kočov",
    "val": "34815 Kocov Usti"
  },
  {
    "cast": "Ústí nad Labem-centrum (část)",
    "psc": "40001",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40001 Usti nad Labem Usti nad Labem-centrum (cast)"
  },
  {
    "cast": "Ústí nad Labem-centrum (část)",
    "psc": "40011",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40011 Usti nad Labem Usti nad Labem-centrum (cast)"
  },
  {
    "cast": "Ústí nad Orlicí (část)",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56201 Usti nad Orlici Usti nad Orlici (cast)"
  },
  {
    "cast": "Ústí nad Orlicí (část)",
    "psc": "56203",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56203 Usti nad Orlici Usti nad Orlici (cast)"
  },
  {
    "cast": "Ústí nad Orlicí (část)",
    "psc": "56206",
    "okres": "Ústí nad Orlicí",
    "obec": "Ústí nad Orlicí",
    "val": "56206 Usti nad Orlici Usti nad Orlici (cast)"
  },
  {
    "cast": "Ústín",
    "psc": "78346",
    "okres": "Olomouc",
    "obec": "Ústín",
    "val": "78346 Ustin Ustin"
  },
  {
    "cast": "Ústrašice",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Ústrašice",
    "val": "39002 Ustrasice Ustrasice"
  },
  {
    "cast": "Ústrašín",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Ústrašín",
    "val": "39301 Ustrasin Ustrasin"
  },
  {
    "cast": "Ústup",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Ústup",
    "val": "67974 Ustup Ustup"
  },
  {
    "cast": "Ústupky",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Ustupky"
  },
  {
    "cast": "Úsuší",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kňovice",
    "val": "26401 Knovice Ususi"
  },
  {
    "cast": "Úsuší",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Úsuší",
    "val": "66601 Ususi Ususi"
  },
  {
    "cast": "Úšava",
    "psc": "34801",
    "okres": "Tachov",
    "obec": "Staré Sedliště",
    "val": "34801 Stare Sedliste Usava"
  },
  {
    "cast": "Úšovice",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Mariánské Lázně",
    "val": "35301 Marianske Lazne Usovice"
  },
  {
    "cast": "Úštěk-České Předměstí",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Ustek-Ceske Predmesti"
  },
  {
    "cast": "Úštěk-Českolipské Předměstí",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Ustek-Ceskolipske Predmesti"
  },
  {
    "cast": "Úštěk-Vnitřní Město",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Ustek-Vnitrni Mesto"
  },
  {
    "cast": "Útěchov",
    "psc": "64400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64400 Brno Utechov"
  },
  {
    "cast": "Útěchov",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Útěchov",
    "val": "57101 Utechov Utechov"
  },
  {
    "cast": "Útěchovice",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Útěchovice",
    "val": "39501 Utechovice Utechovice"
  },
  {
    "cast": "Útěchovice",
    "psc": "47128",
    "okres": "Česká Lípa",
    "obec": "Hamr na Jezeře",
    "val": "47128 Hamr na Jezere Utechovice"
  },
  {
    "cast": "Útěchovice pod Stražištěm",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Útěchovice pod Stražištěm",
    "val": "39501 Utechovice pod Strazistem Utechovice pod Strazistem"
  },
  {
    "cast": "Útěchovičky",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Útěchovičky",
    "val": "39501 Utechovicky Utechovicky"
  },
  {
    "cast": "Útěchovičky",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Utechovicky"
  },
  {
    "cast": "Útěchvosty",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Podveky",
    "val": "28506 Podveky Utechvosty"
  },
  {
    "cast": "Úterý",
    "psc": "33040",
    "okres": "Plzeň-sever",
    "obec": "Úterý",
    "val": "33040 Utery Utery"
  },
  {
    "cast": "Útěšenovice",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Utesenovice"
  },
  {
    "cast": "Útěšov",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Bavorov",
    "val": "38773 Bavorov Utesov"
  },
  {
    "cast": "Utín",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Přibyslav",
    "val": "58222 Pribyslav Utin"
  },
  {
    "cast": "Útočiště",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Utociste"
  },
  {
    "cast": "Útušice",
    "psc": "33209",
    "okres": "Plzeň-jih",
    "obec": "Útušice",
    "val": "33209 Utusice Utusice"
  },
  {
    "cast": "Útvina",
    "psc": "36401",
    "okres": "Karlovy Vary",
    "obec": "Útvina",
    "val": "36401 Utvina Utvina"
  },
  {
    "cast": "Úvalno",
    "psc": "79391",
    "okres": "Bruntál",
    "obec": "Úvalno",
    "val": "79391 Uvalno Uvalno"
  },
  {
    "cast": "Úvaly",
    "psc": "69142",
    "okres": "Břeclav",
    "obec": "Valtice",
    "val": "69142 Valtice Uvaly"
  },
  {
    "cast": "Úvaly",
    "psc": "25082",
    "okres": "Praha-východ",
    "obec": "Úvaly",
    "val": "25082 Uvaly Uvaly"
  },
  {
    "cast": "Uzenice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Uzenice",
    "val": "38801 Uzenice Uzenice"
  },
  {
    "cast": "Uzeničky",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Uzeničky",
    "val": "38801 Uzenicky Uzenicky"
  },
  {
    "cast": "Úžice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Úžice",
    "val": "28504 Uzice Uzice"
  },
  {
    "cast": "Úžice",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Úžice",
    "val": "27745 Uzice Uzice"
  },
  {
    "cast": "Úžlabí",
    "psc": "35709",
    "okres": "Sokolov",
    "obec": "Habartov",
    "val": "35709 Habartov Uzlabi"
  },
  {
    "cast": "Vacanovice",
    "psc": "78357",
    "okres": "Olomouc",
    "obec": "Tršice",
    "val": "78357 Trsice Vacanovice"
  },
  {
    "cast": "Vacenovice",
    "psc": "69606",
    "okres": "Hodonín",
    "obec": "Vacenovice",
    "val": "69606 Vacenovice Vacenovice"
  },
  {
    "cast": "Vacenovice",
    "psc": "67551",
    "okres": "Třebíč",
    "obec": "Jaroměřice nad Rokytnou",
    "val": "67551 Jaromerice nad Rokytnou Vacenovice"
  },
  {
    "cast": "Vacíkov",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Hvožďany",
    "val": "26242 Hvozdany Vacikov"
  },
  {
    "cast": "Vackov",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Plesná",
    "val": "35134 Plesna Vackov"
  },
  {
    "cast": "Vackov",
    "psc": "39494",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39494 Cernovice Vackov"
  },
  {
    "cast": "Vackovec",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Milhostov",
    "val": "35002 Milhostov Vackovec"
  },
  {
    "cast": "Václaví",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Rovensko pod Troskami",
    "val": "51263 Rovensko pod Troskami Vaclavi"
  },
  {
    "cast": "Václavice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Václavice",
    "val": "25601 Vaclavice Vaclavice"
  },
  {
    "cast": "Václavice",
    "psc": "54908",
    "okres": "Náchod",
    "obec": "Provodov-Šonov",
    "val": "54908 Provodov-Sonov Vaclavice"
  },
  {
    "cast": "Václavice",
    "psc": "46334",
    "okres": "Liberec",
    "obec": "Hrádek nad Nisou",
    "val": "46334 Hradek nad Nisou Vaclavice"
  },
  {
    "cast": "Václavky",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Dolní Újezd",
    "val": "57001 Dolni Ujezd Vaclavky"
  },
  {
    "cast": "Václavov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Zábřeh",
    "val": "78901 Zabreh Vaclavov"
  },
  {
    "cast": "Václavov",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Buzice",
    "val": "38801 Buzice Vaclavov"
  },
  {
    "cast": "Václavov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Písečné",
    "val": "37881 Pisecne Vaclavov"
  },
  {
    "cast": "Václavovice",
    "psc": "74283",
    "okres": "Ostrava-město",
    "obec": "Klimkovice",
    "val": "74283 Klimkovice Vaclavovice"
  },
  {
    "cast": "Václavovice",
    "psc": "73934",
    "okres": "Ostrava-město",
    "obec": "Václavovice",
    "val": "73934 Vaclavovice Vaclavovice"
  },
  {
    "cast": "Václavov-Děčín XXII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Vaclavov-Decin XXII x)"
  },
  {
    "cast": "Václavské Předměstí",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Vaclavske Predmesti"
  },
  {
    "cast": "Václavy",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Václavy",
    "val": "27035 Vaclavy Vaclavy"
  },
  {
    "cast": "Vacov (část)",
    "psc": "38486",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38486 Vacov Vacov (cast)"
  },
  {
    "cast": "Vacov (část)",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Vacov (cast)"
  },
  {
    "cast": "Vacovice (část)",
    "psc": "38473",
    "okres": "Strakonice",
    "obec": "Vacovice",
    "val": "38473 Vacovice Vacovice (cast)"
  },
  {
    "cast": "Vacovice (část)",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Vacovice",
    "val": "38719 Vacovice Vacovice (cast)"
  },
  {
    "cast": "Vacovy",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Vacovy"
  },
  {
    "cast": "Vadčice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Dehtáře",
    "val": "39301 Dehtare Vadcice"
  },
  {
    "cast": "Vadín (část)",
    "psc": "58231",
    "okres": "Havlíčkův Brod",
    "obec": "Okrouhlice",
    "val": "58231 Okrouhlice Vadin (cast)"
  },
  {
    "cast": "Vadín (část)",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Okrouhlice",
    "val": "58001 Okrouhlice Vadin (cast)"
  },
  {
    "cast": "Vadkov",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38301 Lhenice Vadkov"
  },
  {
    "cast": "Vadkovice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Předotice",
    "val": "39701 Predotice Vadkovice"
  },
  {
    "cast": "Vadkovice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43801 Chbany Vadkovice"
  },
  {
    "cast": "Vahaneč",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Vahanec"
  },
  {
    "cast": "Vahlovice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Myštice",
    "val": "38801 Mystice Vahlovice"
  },
  {
    "cast": "Vaječník",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Nečín",
    "val": "26301 Necin Vajecnik"
  },
  {
    "cast": "Vajglov",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Břidličná",
    "val": "79351 Bridlicna Vajglov"
  },
  {
    "cast": "Val",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Val",
    "val": "39181 Val Val"
  },
  {
    "cast": "Val",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Val",
    "val": "51801 Val Val"
  },
  {
    "cast": "Valašská Bystřice",
    "psc": "75627",
    "okres": "Vsetín",
    "obec": "Valašská Bystřice",
    "val": "75627 Valasska Bystrice Valasska Bystrice"
  },
  {
    "cast": "Valašská Polanka",
    "psc": "75611",
    "okres": "Vsetín",
    "obec": "Valašská Polanka",
    "val": "75611 Valasska Polanka Valasska Polanka"
  },
  {
    "cast": "Valašská Senice",
    "psc": "75614",
    "okres": "Vsetín",
    "obec": "Valašská Senice",
    "val": "75614 Valasska Senice Valasska Senice"
  },
  {
    "cast": "Valašské Klobouky",
    "psc": "76601",
    "okres": "Zlín",
    "obec": "Valašské Klobouky",
    "val": "76601 Valasske Klobouky Valasske Klobouky"
  },
  {
    "cast": "Valašské Meziříčí",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Valašské Meziříčí",
    "val": "75701 Valasske Mezirici Valasske Mezirici"
  },
  {
    "cast": "Valašské Příkazy",
    "psc": "75612",
    "okres": "Vsetín",
    "obec": "Valašské Příkazy",
    "val": "75612 Valasske Prikazy Valasske Prikazy"
  },
  {
    "cast": "Valdek",
    "psc": "40801",
    "okres": "Děčín",
    "obec": "Staré Křečany",
    "val": "40801 Stare Krecany Valdek"
  },
  {
    "cast": "Valdice",
    "psc": "50711",
    "okres": "Jičín",
    "obec": "Valdice",
    "val": "50711 Valdice Valdice"
  },
  {
    "cast": "Valdice",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Košťálov",
    "val": "51251 Kostalov Valdice"
  },
  {
    "cast": "Valdické Předměstí",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičín",
    "val": "50601 Jicin Valdicke Predmesti"
  },
  {
    "cast": "Valdíkov",
    "psc": "67503",
    "okres": "Třebíč",
    "obec": "Valdíkov",
    "val": "67503 Valdikov Valdikov"
  },
  {
    "cast": "Valdorf",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Valdorf"
  },
  {
    "cast": "Valdov",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Valdov"
  },
  {
    "cast": "Valdov",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Valdov"
  },
  {
    "cast": "Valeč",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Valeč",
    "val": "36453 Valec Valec"
  },
  {
    "cast": "Valeč",
    "psc": "67553",
    "okres": "Třebíč",
    "obec": "Valeč",
    "val": "67553 Valec Valec"
  },
  {
    "cast": "Valcha",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Stráž",
    "val": "34802 Straz Valcha"
  },
  {
    "cast": "Valcha (část)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Valcha (cast)"
  },
  {
    "cast": "Valcha (část)",
    "psc": "32100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32100 Plzen Valcha (cast)"
  },
  {
    "cast": "Valcha (část)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Valcha (cast)"
  },
  {
    "cast": "Valchov",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Valchov",
    "val": "68001 Valchov Valchov"
  },
  {
    "cast": "Valkeřice",
    "psc": "40724",
    "okres": "Děčín",
    "obec": "Valkeřice",
    "val": "40724 Valkerice Valkerice"
  },
  {
    "cast": "Valov",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Podbořany",
    "val": "44101 Podborany Valov"
  },
  {
    "cast": "Valovice",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Katusice",
    "val": "29425 Katusice Valovice"
  },
  {
    "cast": "Valšov",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Valšov",
    "val": "79201 Valsov Valsov"
  },
  {
    "cast": "Valšovice-Hranice VI x)",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75354 Hranice Valsovice-Hranice VI x)"
  },
  {
    "cast": "Valštejn",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Valstejn"
  },
  {
    "cast": "Valteřice",
    "psc": "47105",
    "okres": "Česká Lípa",
    "obec": "Žandov",
    "val": "47105 Zandov Valterice"
  },
  {
    "cast": "Valteřice",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Horní Branná",
    "val": "51401 Horni Branna Valterice"
  },
  {
    "cast": "Valteřice",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Výprachtice",
    "val": "56301 Vyprachtice Valterice"
  },
  {
    "cast": "Valtéřov",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Valterov"
  },
  {
    "cast": "Valtéřov",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Valterov"
  },
  {
    "cast": "Valtice",
    "psc": "69142",
    "okres": "Břeclav",
    "obec": "Valtice",
    "val": "69142 Valtice Valtice"
  },
  {
    "cast": "Valtínov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Kunžak",
    "val": "37853 Kunzak Valtinov"
  },
  {
    "cast": "Valtířov",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Velké Březno",
    "val": "40002 Velke Brezno Valtirov"
  },
  {
    "cast": "Valtrovice",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Valtrovice",
    "val": "67128 Valtrovice Valtrovice"
  },
  {
    "cast": "Valy",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Valy",
    "val": "53501 Valy Valy"
  },
  {
    "cast": "Valy",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Valy",
    "val": "35301 Valy Valy"
  },
  {
    "cast": "Valy",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Plazy",
    "val": "29301 Plazy Valy"
  },
  {
    "cast": "Valy",
    "psc": "47157",
    "okres": "Česká Lípa",
    "obec": "Krompach",
    "val": "47157 Krompach Valy"
  },
  {
    "cast": "Vamberk (část)",
    "psc": "51754",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vamberk",
    "val": "51754 Vamberk Vamberk (cast)"
  },
  {
    "cast": "Vamberk (část)",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vamberk",
    "val": "51601 Vamberk Vamberk (cast)"
  },
  {
    "cast": "Vamberk (část)",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vamberk",
    "val": "51741 Vamberk Vamberk (cast)"
  },
  {
    "cast": "Vaneč",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Pyšel",
    "val": "67571 Pysel Vanec"
  },
  {
    "cast": "Vanice",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Vanice"
  },
  {
    "cast": "Vanov",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Vanov",
    "val": "58856 Vanov Vanov"
  },
  {
    "cast": "Vaňov",
    "psc": "40001",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40001 Usti nad Labem Vanov"
  },
  {
    "cast": "Vanovice",
    "psc": "67936",
    "okres": "Blansko",
    "obec": "Vanovice",
    "val": "67936 Vanovice Vanovice"
  },
  {
    "cast": "Vanovice",
    "psc": "29443",
    "okres": "Mladá Boleslav",
    "obec": "Všejany",
    "val": "29443 Vsejany Vanovice"
  },
  {
    "cast": "Vanovka",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Bohdašín",
    "val": "51801 Bohdasin Vanovka"
  },
  {
    "cast": "Vanůvek",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Vanůvek",
    "val": "58856 Vanuvek Vanuvek"
  },
  {
    "cast": "Vápenice",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Obory",
    "val": "26301 Obory Vapenice"
  },
  {
    "cast": "Vápenice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Vysoký Chlumec",
    "val": "26401 Vysoky Chlumec Vapenice"
  },
  {
    "cast": "Vápenice",
    "psc": "68774",
    "okres": "Uherské Hradiště",
    "obec": "Vápenice",
    "val": "68774 Vapenice Vapenice"
  },
  {
    "cast": "Vápenka",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Stárkov",
    "val": "54931 Starkov Vapenka"
  },
  {
    "cast": "Vápenky",
    "psc": "69674",
    "okres": "Hodonín",
    "obec": "Nová Lhota",
    "val": "69674 Nova Lhota Vapenky"
  },
  {
    "cast": "Vápenná",
    "psc": "79064",
    "okres": "Jeseník",
    "obec": "Vápenná",
    "val": "79064 Vapenna Vapenna"
  },
  {
    "cast": "Vápenný Podol",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Vápenný Podol",
    "val": "53803 Vapenny Podol Vapenny Podol"
  },
  {
    "cast": "Vápensko",
    "psc": "28921",
    "okres": "Nymburk",
    "obec": "Kostomlaty nad Labem",
    "val": "28921 Kostomlaty nad Labem Vapensko"
  },
  {
    "cast": "Vápno",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Vápno",
    "val": "53316 Vapno Vapno"
  },
  {
    "cast": "Vápno",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Hlavice",
    "val": "46348 Hlavice Vapno"
  },
  {
    "cast": "Vápovice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Vápovice",
    "val": "58856 Vapovice Vapovice"
  },
  {
    "cast": "Varnsdorf",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Varnsdorf",
    "val": "40747 Varnsdorf Varnsdorf"
  },
  {
    "cast": "Varta",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Jickovice",
    "val": "39901 Jickovice Varta"
  },
  {
    "cast": "Varvažov",
    "psc": "40338",
    "okres": "Ústí nad Labem",
    "obec": "Telnice",
    "val": "40338 Telnice Varvazov"
  },
  {
    "cast": "Varvažov (část)",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Varvažov",
    "val": "39701 Varvazov Varvazov (cast)"
  },
  {
    "cast": "Varvažov (část)",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Varvažov",
    "val": "39804 Varvazov Varvazov (cast)"
  },
  {
    "cast": "Vašírov",
    "psc": "27061",
    "okres": "Kladno",
    "obec": "Lány",
    "val": "27061 Lany Vasirov"
  },
  {
    "cast": "Vatěkov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Václavice",
    "val": "25601 Vaclavice Vatekov"
  },
  {
    "cast": "Vatětice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Vatetice"
  },
  {
    "cast": "Vatín",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Vatín",
    "val": "59101 Vatin Vatin"
  },
  {
    "cast": "Vávrovice (část)",
    "psc": "74707",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74707 Opava Vavrovice (cast)"
  },
  {
    "cast": "Vávrovice (část)",
    "psc": "74773",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74773 Opava Vavrovice (cast)"
  },
  {
    "cast": "Vavřetice",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Řehenice",
    "val": "25167 Rehenice Vavretice"
  },
  {
    "cast": "Vavřinec",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Vavřinec",
    "val": "28504 Vavrinec Vavrinec"
  },
  {
    "cast": "Vavřinec",
    "psc": "67913",
    "okres": "Blansko",
    "obec": "Vavřinec",
    "val": "67913 Vavrinec Vavrinec"
  },
  {
    "cast": "Vavřineč",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Malý Újezd",
    "val": "27731 Maly Ujezd Vavrinec"
  },
  {
    "cast": "Vazovec",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Turnov",
    "val": "51101 Turnov Vazovec"
  },
  {
    "cast": "Vážany",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vážany",
    "val": "68201 Vazany Vazany"
  },
  {
    "cast": "Vážany",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Vážany",
    "val": "68001 Vazany Vazany"
  },
  {
    "cast": "Vážany",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Vazany"
  },
  {
    "cast": "Vážany",
    "psc": "68737",
    "okres": "Uherské Hradiště",
    "obec": "Vážany",
    "val": "68737 Vazany Vazany"
  },
  {
    "cast": "Vážany nad Litavou",
    "psc": "68401",
    "okres": "Vyškov",
    "obec": "Vážany nad Litavou",
    "val": "68401 Vazany nad Litavou Vazany nad Litavou"
  },
  {
    "cast": "Važice",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Bystřice",
    "val": "50723 Bystrice Vazice"
  },
  {
    "cast": "Včelákov",
    "psc": "53957",
    "okres": "Chrudim",
    "obec": "Včelákov",
    "val": "53957 Vcelakov Vcelakov"
  },
  {
    "cast": "Včelákova Lhota",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Vcelakova Lhota"
  },
  {
    "cast": "Včelary",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Bílovice",
    "val": "68712 Bilovice Vcelary"
  },
  {
    "cast": "Včelná",
    "psc": "37382",
    "okres": "České Budějovice",
    "obec": "Včelná",
    "val": "37382 Vcelna Vcelna"
  },
  {
    "cast": "Včelná pod Boubínem (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Buk",
    "val": "38301 Buk Vcelna pod Boubinem (cast)"
  },
  {
    "cast": "Včelná pod Boubínem (část)",
    "psc": "38471",
    "okres": "Prachatice",
    "obec": "Buk",
    "val": "38471 Buk Vcelna pod Boubinem (cast)"
  },
  {
    "cast": "Včelnička",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Včelnička",
    "val": "39470 Vcelnicka Vcelnicka"
  },
  {
    "cast": "Věckovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Veckovice"
  },
  {
    "cast": "Veclov",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Svojetín",
    "val": "27004 Svojetin Veclov"
  },
  {
    "cast": "Veclov",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Město pod Landštejnem",
    "val": "37881 Stare Mesto pod Landstejnem Veclov"
  },
  {
    "cast": "Věcov (část)",
    "psc": "59244",
    "okres": "Žďár nad Sázavou",
    "obec": "Věcov",
    "val": "59244 Vecov Vecov (cast)"
  },
  {
    "cast": "Věcov (část)",
    "psc": "59242",
    "okres": "Žďár nad Sázavou",
    "obec": "Věcov",
    "val": "59242 Vecov Vecov (cast)"
  },
  {
    "cast": "Vědlice",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Vedlice"
  },
  {
    "cast": "Vědomice",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Vědomice",
    "val": "41301 Vedomice Vedomice"
  },
  {
    "cast": "Vedrovice",
    "psc": "67175",
    "okres": "Znojmo",
    "obec": "Vedrovice",
    "val": "67175 Vedrovice Vedrovice"
  },
  {
    "cast": "Věchnov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Věchnov",
    "val": "59301 Vechnov Vechnov"
  },
  {
    "cast": "Vejprnice",
    "psc": "33027",
    "okres": "Plzeň-sever",
    "obec": "Vejprnice",
    "val": "33027 Vejprnice Vejprnice"
  },
  {
    "cast": "Vejprty",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Vejprty",
    "val": "43191 Vejprty Vejprty"
  },
  {
    "cast": "Vejvanov",
    "psc": "33828",
    "okres": "Rokycany",
    "obec": "Vejvanov",
    "val": "33828 Vejvanov Vejvanov"
  },
  {
    "cast": "Vejvanovice",
    "psc": "53862",
    "okres": "Chrudim",
    "obec": "Vejvanovice",
    "val": "53862 Vejvanovice Vejvanovice"
  },
  {
    "cast": "Věkoše (část)",
    "psc": "50003",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50003 Hradec Kralove Vekose (cast)"
  },
  {
    "cast": "Věkoše (část)",
    "psc": "50341",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50341 Hradec Kralove Vekose (cast)"
  },
  {
    "cast": "Věkoše (část)",
    "psc": "50302",
    "okres": "Hradec Králové",
    "obec": "Hradec Králové",
    "val": "50302 Hradec Kralove Vekose (cast)"
  },
  {
    "cast": "Velatice",
    "psc": "66405",
    "okres": "Brno-venkov",
    "obec": "Velatice",
    "val": "66405 Velatice Velatice"
  },
  {
    "cast": "Velběhy",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Osečany",
    "val": "26401 Osecany Velbehy"
  },
  {
    "cast": "Velcí",
    "psc": "26223",
    "okres": "Příbram",
    "obec": "Jince",
    "val": "26223 Jince Velci"
  },
  {
    "cast": "Veleboř",
    "psc": "78973",
    "okres": "Šumperk",
    "obec": "Klopina",
    "val": "78973 Klopina Velebor"
  },
  {
    "cast": "Velebudice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Most",
    "val": "43401 Most Velebudice"
  },
  {
    "cast": "Velečín",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Velečín",
    "val": "33165 Velecin Velecin"
  },
  {
    "cast": "Velehrad",
    "psc": "68706",
    "okres": "Uherské Hradiště",
    "obec": "Velehrad",
    "val": "68706 Velehrad Velehrad"
  },
  {
    "cast": "Velehrádek",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Doubravice",
    "val": "54401 Doubravice Velehradek"
  },
  {
    "cast": "Velechvín",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37372 Lisov Velechvin"
  },
  {
    "cast": "Veleliby",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Dvory",
    "val": "28802 Dvory Veleliby"
  },
  {
    "cast": "Velemín",
    "psc": "41131",
    "okres": "Litoměřice",
    "obec": "Velemín",
    "val": "41131 Velemin Velemin"
  },
  {
    "cast": "Velemyšleves",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Velemyšleves",
    "val": "43801 Velemysleves Velemysleves"
  },
  {
    "cast": "Veleň",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Veleň",
    "val": "25063 Velen Velen"
  },
  {
    "cast": "Velenice",
    "psc": "28901",
    "okres": "Nymburk",
    "obec": "Velenice",
    "val": "28901 Velenice Velenice"
  },
  {
    "cast": "Velenice",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Velenice",
    "val": "47002 Velenice Velenice"
  },
  {
    "cast": "Velenka",
    "psc": "28912",
    "okres": "Nymburk",
    "obec": "Velenka",
    "val": "28912 Velenka Velenka"
  },
  {
    "cast": "Velenov",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Velenov",
    "val": "68001 Velenov Velenov"
  },
  {
    "cast": "Velenovy",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Velenovy"
  },
  {
    "cast": "Veleslavín",
    "psc": "16200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16200 Praha Veleslavin"
  },
  {
    "cast": "Velešice",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Hoštka",
    "val": "41108 Hostka Velesice"
  },
  {
    "cast": "Velešice",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Sběř",
    "val": "50703 Sber Velesice"
  },
  {
    "cast": "Velešice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Pačejov",
    "val": "34101 Pacejov Velesice"
  },
  {
    "cast": "Velešín",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Velešín",
    "val": "38232 Velesin Velesin"
  },
  {
    "cast": "Velešov",
    "psc": "58842",
    "okres": "Jihlava",
    "obec": "Větrný Jeníkov",
    "val": "58842 Vetrny Jenikov Velesov"
  },
  {
    "cast": "Velešovice",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Velešovice",
    "val": "68301 Velesovice Velesovice"
  },
  {
    "cast": "Veletice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Holedeč",
    "val": "43801 Holedec Veletice"
  },
  {
    "cast": "Veletín",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Veletin"
  },
  {
    "cast": "Veletiny",
    "psc": "68733",
    "okres": "Uherské Hradiště",
    "obec": "Veletiny",
    "val": "68733 Veletiny Veletiny"
  },
  {
    "cast": "Veletov",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Veletov",
    "val": "28002 Veletov Veletov"
  },
  {
    "cast": "Velhartice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Velhartice",
    "val": "34142 Velhartice Velhartice"
  },
  {
    "cast": "Velice",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37348 Driten Velice"
  },
  {
    "cast": "Velichov",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žatec",
    "val": "43801 Zatec Velichov"
  },
  {
    "cast": "Velichov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Velichov",
    "val": "36301 Velichov Velichov"
  },
  {
    "cast": "Velichovky",
    "psc": "55211",
    "okres": "Náchod",
    "obec": "Velichovky",
    "val": "55211 Velichovky Velichovky"
  },
  {
    "cast": "Veliká",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47002 Kravare Velika"
  },
  {
    "cast": "Veliká",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Bojiště",
    "val": "58401 Bojiste Velika"
  },
  {
    "cast": "Veliká Ves",
    "psc": "44101",
    "okres": "Chomutov",
    "obec": "Veliká Ves",
    "val": "44101 Velika Ves Velika Ves"
  },
  {
    "cast": "Veliká Ves",
    "psc": "25070",
    "okres": "Praha-východ",
    "obec": "Veliká Ves",
    "val": "25070 Velika Ves Velika Ves"
  },
  {
    "cast": "Velíková",
    "psc": "76314",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76314 Zlin Velikova"
  },
  {
    "cast": "Veliký Brázdim",
    "psc": "25063",
    "okres": "Praha-východ",
    "obec": "Brázdim",
    "val": "25063 Brazdim Veliky Brazdim"
  },
  {
    "cast": "Velim",
    "psc": "28101",
    "okres": "Kolín",
    "obec": "Velim",
    "val": "28101 Velim Velim"
  },
  {
    "cast": "Veliny",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Veliny",
    "val": "53401 Veliny Veliny"
  },
  {
    "cast": "Veliš",
    "psc": "50721",
    "okres": "Jičín",
    "obec": "Veliš",
    "val": "50721 Velis Velis"
  },
  {
    "cast": "Veliš",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Veliš",
    "val": "25706 Velis Velis"
  },
  {
    "cast": "Velká",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Milevsko",
    "val": "39901 Milevsko Velka"
  },
  {
    "cast": "Velká",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Kamýk nad Vltavou",
    "val": "26263 Kamyk nad Vltavou Velka"
  },
  {
    "cast": "Velká Bíteš",
    "psc": "59501",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Bíteš",
    "val": "59501 Velka Bites Velka Bites"
  },
  {
    "cast": "Velká Bučina",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Velvary",
    "val": "27324 Velvary Velka Bucina"
  },
  {
    "cast": "Velká Buková",
    "psc": "27023",
    "okres": "Rakovník",
    "obec": "Velká Buková",
    "val": "27023 Velka Bukova Velka Bukova"
  },
  {
    "cast": "Velká Bukovina",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Chvalkovice",
    "val": "55204 Chvalkovice Velka Bukovina"
  },
  {
    "cast": "Velká Bukovina",
    "psc": "40729",
    "okres": "Děčín",
    "obec": "Velká Bukovina",
    "val": "40729 Velka Bukovina Velka Bukovina"
  },
  {
    "cast": "Velká Bystřice",
    "psc": "78353",
    "okres": "Olomouc",
    "obec": "Velká Bystřice",
    "val": "78353 Velka Bystrice Velka Bystrice"
  },
  {
    "cast": "Velká Čermná (část)",
    "psc": "51725",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Čermná nad Orlicí",
    "val": "51725 Cermna nad Orlici Velka Cermna (cast)"
  },
  {
    "cast": "Velká Čermná (část)",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Čermná nad Orlicí",
    "val": "51741 Cermna nad Orlici Velka Cermna (cast)"
  },
  {
    "cast": "Velká Černá",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Salačova Lhota",
    "val": "39501 Salacova Lhota Velka Cerna"
  },
  {
    "cast": "Velká Černoc",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Měcholupy",
    "val": "43801 Mecholupy Velka Cernoc"
  },
  {
    "cast": "Velká Dobrá",
    "psc": "27361",
    "okres": "Kladno",
    "obec": "Velká Dobrá",
    "val": "27361 Velka Dobra Velka Dobra"
  },
  {
    "cast": "Velká Hleďsebe",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Velká Hleďsebe",
    "val": "35301 Velka Hledsebe Velka Hledsebe"
  },
  {
    "cast": "Velká Hraštice",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Malá Hraštice",
    "val": "26203 Mala Hrastice Velka Hrastice"
  },
  {
    "cast": "Velká Chmelištná",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Velká Chmelištná",
    "val": "27034 Velka Chmelistna Velka Chmelistna"
  },
  {
    "cast": "Velká Chuchle",
    "psc": "15900",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15900 Praha Velka Chuchle"
  },
  {
    "cast": "Velká Chyška",
    "psc": "39428",
    "okres": "Pelhřimov",
    "obec": "Velká Chyška",
    "val": "39428 Velka Chyska Velka Chyska"
  },
  {
    "cast": "Velká Javorská",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Žandov",
    "val": "47002 Zandov Velka Javorska"
  },
  {
    "cast": "Velká Jesenice",
    "psc": "55224",
    "okres": "Náchod",
    "obec": "Velká Jesenice",
    "val": "55224 Velka Jesenice Velka Jesenice"
  },
  {
    "cast": "Velká Kraš",
    "psc": "79058",
    "okres": "Jeseník",
    "obec": "Velká Kraš",
    "val": "79058 Velka Kras Velka Kras"
  },
  {
    "cast": "Velká Lečice",
    "psc": "26205",
    "okres": "Příbram",
    "obec": "Velká Lečice",
    "val": "26205 Velka Lecice Velka Lecice"
  },
  {
    "cast": "Velká Ledhuje",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Police nad Metují",
    "val": "54954 Police nad Metuji Velka Ledhuje"
  },
  {
    "cast": "Velká Lhota",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Volfířov",
    "val": "38001 Volfirov Velka Lhota"
  },
  {
    "cast": "Velká Lhota",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Velka Lhota"
  },
  {
    "cast": "Velká Lhota (část)",
    "psc": "75627",
    "okres": "Vsetín",
    "obec": "Velká Lhota",
    "val": "75627 Velka Lhota Velka Lhota (cast)"
  },
  {
    "cast": "Velká Lhota (část)",
    "psc": "75701",
    "okres": "Vsetín",
    "obec": "Velká Lhota",
    "val": "75701 Velka Lhota Velka Lhota (cast)"
  },
  {
    "cast": "Velká Losenice",
    "psc": "59211",
    "okres": "Žďár nad Sázavou",
    "obec": "Velká Losenice",
    "val": "59211 Velka Losenice Velka Losenice"
  },
  {
    "cast": "Velká Morava",
    "psc": "56169",
    "okres": "Ústí nad Orlicí",
    "obec": "Dolní Morava",
    "val": "56169 Dolni Morava Velka Morava"
  },
  {
    "cast": "Velká nad Veličkou",
    "psc": "69674",
    "okres": "Hodonín",
    "obec": "Velká nad Veličkou",
    "val": "69674 Velka nad Velickou Velka nad Velickou"
  },
  {
    "cast": "Velká Paseka",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58401 Hnevkovice Velka Paseka"
  },
  {
    "cast": "Velká Polom",
    "psc": "74764",
    "okres": "Ostrava-město",
    "obec": "Velká Polom",
    "val": "74764 Velka Polom Velka Polom"
  },
  {
    "cast": "Velká Roudka",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Velké Opatovice",
    "val": "67963 Velke Opatovice Velka Roudka"
  },
  {
    "cast": "Velká Rovná",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pacov",
    "val": "39501 Pacov Velka Rovna"
  },
  {
    "cast": "Velká Skalice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28401 Zbraslavice Velka Skalice"
  },
  {
    "cast": "Velká Skrovnice",
    "psc": "56201",
    "okres": "Ústí nad Orlicí",
    "obec": "Velká Skrovnice",
    "val": "56201 Velka Skrovnice Velka Skrovnice"
  },
  {
    "cast": "Velká Střítež",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53825 Horni Bradlo Velka Stritez"
  },
  {
    "cast": "Velká Šitboř",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Milíkov",
    "val": "35002 Milikov Velka Sitbor"
  },
  {
    "cast": "Velká Štáhle",
    "psc": "79351",
    "okres": "Bruntál",
    "obec": "Velká Štáhle",
    "val": "79351 Velka Stahle Velka Stahle"
  },
  {
    "cast": "Velká Turná",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Velká Turná",
    "val": "38601 Velka Turna Velka Turna"
  },
  {
    "cast": "Velká Úpa",
    "psc": "54221",
    "okres": "Trutnov",
    "obec": "Pec pod Sněžkou",
    "val": "54221 Pec pod Snezkou Velka Upa"
  },
  {
    "cast": "Velká Veleň-Děčín XXX x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Velka Velen-Decin XXX x)"
  },
  {
    "cast": "Velká Ves",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Lukavec",
    "val": "39501 Lukavec Velka Ves"
  },
  {
    "cast": "Velká Ves",
    "psc": "55001",
    "okres": "Náchod",
    "obec": "Broumov",
    "val": "55001 Broumov Velka Ves"
  },
  {
    "cast": "Velká Ves",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34815 Bor Velka Ves"
  },
  {
    "cast": "Velká-Hranice III x)",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Hranice",
    "val": "75301 Hranice Velka-Hranice III x)"
  },
  {
    "cast": "Velké Albrechtice",
    "psc": "74291",
    "okres": "Nový Jičín",
    "obec": "Velké Albrechtice",
    "val": "74291 Velke Albrechtice Velke Albrechtice"
  },
  {
    "cast": "Velké Bílovice",
    "psc": "69102",
    "okres": "Břeclav",
    "obec": "Velké Bílovice",
    "val": "69102 Velke Bilovice Velke Bilovice"
  },
  {
    "cast": "Velké Březno",
    "psc": "40323",
    "okres": "Ústí nad Labem",
    "obec": "Velké Březno",
    "val": "40323 Velke Brezno Velke Brezno"
  },
  {
    "cast": "Velké Dvorce",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Přimda",
    "val": "34806 Primda Velke Dvorce"
  },
  {
    "cast": "Velké Hamry",
    "psc": "46845",
    "okres": "Jablonec nad Nisou",
    "obec": "Velké Hamry",
    "val": "46845 Velke Hamry Velke Hamry"
  },
  {
    "cast": "Velké Heraltice",
    "psc": "74775",
    "okres": "Opava",
    "obec": "Velké Heraltice",
    "val": "74775 Velke Heraltice Velke Heraltice"
  },
  {
    "cast": "Velké Heřmanice",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Heřmaničky",
    "val": "25789 Hermanicky Velke Hermanice"
  },
  {
    "cast": "Velké Hostěrádky",
    "psc": "69174",
    "okres": "Břeclav",
    "obec": "Velké Hostěrádky",
    "val": "69174 Velke Hosteradky Velke Hosteradky"
  },
  {
    "cast": "Velké Hoštice",
    "psc": "74731",
    "okres": "Opava",
    "obec": "Velké Hoštice",
    "val": "74731 Velke Hostice Velke Hostice"
  },
  {
    "cast": "Velké Hydčice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Velké Hydčice",
    "val": "34101 Velke Hydcice Velke Hydcice"
  },
  {
    "cast": "Velké Chvalovice",
    "psc": "28911",
    "okres": "Kolín",
    "obec": "Pečky",
    "val": "28911 Pecky Velke Chvalovice"
  },
  {
    "cast": "Velké Chvojno",
    "psc": "40334",
    "okres": "Ústí nad Labem",
    "obec": "Velké Chvojno",
    "val": "40334 Velke Chvojno Velke Chvojno"
  },
  {
    "cast": "Velké Janovice",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Janovice",
    "val": "59301 Velke Janovice Velke Janovice"
  },
  {
    "cast": "Velké Karlovice",
    "psc": "75606",
    "okres": "Vsetín",
    "obec": "Velké Karlovice",
    "val": "75606 Velke Karlovice Velke Karlovice"
  },
  {
    "cast": "Velké Koloděje",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Sezemice",
    "val": "53304 Sezemice Velke Kolodeje"
  },
  {
    "cast": "Velké Kunětice",
    "psc": "79052",
    "okres": "Jeseník",
    "obec": "Velké Kunětice",
    "val": "79052 Velke Kunetice Velke Kunetice"
  },
  {
    "cast": "Velké Losiny",
    "psc": "78815",
    "okres": "Šumperk",
    "obec": "Velké Losiny",
    "val": "78815 Velke Losiny Velke Losiny"
  },
  {
    "cast": "Velké Meziříčí",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Meziříčí",
    "val": "59401 Velke Mezirici Velke Mezirici"
  },
  {
    "cast": "Velké Němčice (část)",
    "psc": "69164",
    "okres": "Břeclav",
    "obec": "Velké Němčice",
    "val": "69164 Velke Nemcice Velke Nemcice (cast)"
  },
  {
    "cast": "Velké Němčice (část)",
    "psc": "69163",
    "okres": "Břeclav",
    "obec": "Velké Němčice",
    "val": "69163 Velke Nemcice Velke Nemcice (cast)"
  },
  {
    "cast": "Velké Nepodřice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Dobev",
    "val": "39701 Dobev Velke Nepodrice"
  },
  {
    "cast": "Velké Opatovice",
    "psc": "67963",
    "okres": "Blansko",
    "obec": "Velké Opatovice",
    "val": "67963 Velke Opatovice Velke Opatovice"
  },
  {
    "cast": "Velké Pavlovice",
    "psc": "69106",
    "okres": "Břeclav",
    "obec": "Velké Pavlovice",
    "val": "69106 Velke Pavlovice Velke Pavlovice"
  },
  {
    "cast": "Velké Petrovice-Maršov nad Metují x)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Velké Petrovice",
    "val": "54931 Velke Petrovice Velke Petrovice-Marsov nad Metuji x)"
  },
  {
    "cast": "Velké Petrovice-Petrovice (část) x)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Velké Petrovice",
    "val": "54931 Velke Petrovice Velke Petrovice-Petrovice (cast) x)"
  },
  {
    "cast": "Velké Petrovice-Petrovice (část) x)",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Velké Petrovice",
    "val": "54954 Velke Petrovice Velke Petrovice-Petrovice (cast) x)"
  },
  {
    "cast": "Velké Petrovice-Petrovičky x)",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Velké Petrovice",
    "val": "54954 Velke Petrovice Velke Petrovice-Petrovicky x)"
  },
  {
    "cast": "Velké Popovice",
    "psc": "25169",
    "okres": "Praha-východ",
    "obec": "Velké Popovice",
    "val": "25169 Velke Popovice Velke Popovice"
  },
  {
    "cast": "Velké Poříčí (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Velké Poříčí",
    "val": "54931 Velke Porici Velke Porici (cast)"
  },
  {
    "cast": "Velké Poříčí (část)",
    "psc": "54932",
    "okres": "Náchod",
    "obec": "Velké Poříčí",
    "val": "54932 Velke Porici Velke Porici (cast)"
  },
  {
    "cast": "Velké Předměstí",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Velke Predmesti"
  },
  {
    "cast": "Velké Přílepy",
    "psc": "25264",
    "okres": "Praha-západ",
    "obec": "Velké Přílepy",
    "val": "25264 Velke Prilepy Velke Prilepy"
  },
  {
    "cast": "Velké Přítočno",
    "psc": "27351",
    "okres": "Kladno",
    "obec": "Velké Přítočno",
    "val": "27351 Velke Pritocno Velke Pritocno"
  },
  {
    "cast": "Velké Skaliny",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38241 Benesov nad Cernou Velke Skaliny"
  },
  {
    "cast": "Velké Svatoňovice (část)",
    "psc": "54232",
    "okres": "Trutnov",
    "obec": "Velké Svatoňovice",
    "val": "54232 Velke Svatonovice Velke Svatonovice (cast)"
  },
  {
    "cast": "Velké Svatoňovice (část)",
    "psc": "54234",
    "okres": "Trutnov",
    "obec": "Velké Svatoňovice",
    "val": "54234 Velke Svatonovice Velke Svatonovice (cast)"
  },
  {
    "cast": "Velké Svatoňovice (část)",
    "psc": "54235",
    "okres": "Trutnov",
    "obec": "Velké Svatoňovice",
    "val": "54235 Velke Svatonovice Velke Svatonovice (cast)"
  },
  {
    "cast": "Velké Těšany",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Bařice-Velké Těšany",
    "val": "76701 Barice-Velke Tesany Velke Tesany"
  },
  {
    "cast": "Velké Tresné",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Velké Tresné",
    "val": "59265 Velke Tresne Velke Tresne"
  },
  {
    "cast": "Velké Všelisy (část)",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Velké Všelisy",
    "val": "29426 Velke Vselisy Velke Vselisy (cast)"
  },
  {
    "cast": "Velké Všelisy (část)",
    "psc": "29427",
    "okres": "Mladá Boleslav",
    "obec": "Velké Všelisy",
    "val": "29427 Velke Vselisy Velke Vselisy (cast)"
  },
  {
    "cast": "Velké Výkleky",
    "psc": "28908",
    "okres": "Nymburk",
    "obec": "Běrunice",
    "val": "28908 Berunice Velke Vykleky"
  },
  {
    "cast": "Velké Zboží",
    "psc": "29001",
    "okres": "Nymburk",
    "obec": "Poděbrady",
    "val": "29001 Podebrady Velke Zbozi"
  },
  {
    "cast": "Velké Žernoseky",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Velké Žernoseky",
    "val": "41201 Velke Zernoseky Velke Zernoseky"
  },
  {
    "cast": "Velkolánské",
    "psc": "53303",
    "okres": "Pardubice",
    "obec": "Dašice",
    "val": "53303 Dasice Velkolanske"
  },
  {
    "cast": "Velký Beranov",
    "psc": "58821",
    "okres": "Jihlava",
    "obec": "Velký Beranov",
    "val": "58821 Velky Beranov Velky Beranov"
  },
  {
    "cast": "Velký Bor",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Velký Bor",
    "val": "34101 Velky Bor Velky Bor"
  },
  {
    "cast": "Velký Bor",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Strunkovice nad Blanicí",
    "val": "38411 Strunkovice nad Blanici Velky Bor"
  },
  {
    "cast": "Velký Borek",
    "psc": "27731",
    "okres": "Mělník",
    "obec": "Velký Borek",
    "val": "27731 Velky Borek Velky Borek"
  },
  {
    "cast": "Velký Dřevíč",
    "psc": "54934",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54934 Hronov Velky Drevic"
  },
  {
    "cast": "Velký Grunov",
    "psc": "47129",
    "okres": "Česká Lípa",
    "obec": "Brniště",
    "val": "47129 Brniste Velky Grunov"
  },
  {
    "cast": "Velký Hlavákov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Valeč",
    "val": "36452 Valec Velky Hlavakov"
  },
  {
    "cast": "Velký Hubenov",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Snědovice",
    "val": "41108 Snedovice Velky Hubenov"
  },
  {
    "cast": "Velký Chlumec",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Velký Chlumec",
    "val": "26724 Velky Chlumec Velky Chlumec"
  },
  {
    "cast": "Velký Jeníkov",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Studená",
    "val": "37853 Studena Velky Jenikov"
  },
  {
    "cast": "Velký Ježov",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Smilovy Hory",
    "val": "39143 Smilovy Hory Velky Jezov"
  },
  {
    "cast": "Velký Jindřichov",
    "psc": "38282",
    "okres": "Český Krumlov",
    "obec": "Benešov nad Černou",
    "val": "38282 Benesov nad Cernou Velky Jindrichov"
  },
  {
    "cast": "Velký Karlov",
    "psc": "67128",
    "okres": "Znojmo",
    "obec": "Velký Karlov",
    "val": "67128 Velky Karlov Velky Karlov"
  },
  {
    "cast": "Velký Kozí Hřbet",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Velky Kozi Hrbet"
  },
  {
    "cast": "Velký Luh",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Velký Luh",
    "val": "35134 Velky Luh Velky Luh"
  },
  {
    "cast": "Velký Malahov",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Velký Malahov",
    "val": "34601 Velky Malahov Velky Malahov"
  },
  {
    "cast": "Velký Ořechov (část)",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Velký Ořechov",
    "val": "76001 Velky Orechov Velky Orechov (cast)"
  },
  {
    "cast": "Velký Ořechov (část)",
    "psc": "76307",
    "okres": "Zlín",
    "obec": "Velký Ořechov",
    "val": "76307 Velky Orechov Velky Orechov (cast)"
  },
  {
    "cast": "Velký Osek",
    "psc": "28151",
    "okres": "Kolín",
    "obec": "Velký Osek",
    "val": "28151 Velky Osek Velky Osek"
  },
  {
    "cast": "Velký Pěčín",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Dačice",
    "val": "38001 Dacice Velky Pecin"
  },
  {
    "cast": "Velký Radkov",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Velky Radkov"
  },
  {
    "cast": "Velký Rapotín",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Velky Rapotin"
  },
  {
    "cast": "Velký Ratmírov (část)",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Velký Ratmírov",
    "val": "37821 Velky Ratmirov Velky Ratmirov (cast)"
  },
  {
    "cast": "Velký Ratmírov (část)",
    "psc": "37701",
    "okres": "Jindřichův Hradec",
    "obec": "Velký Ratmírov",
    "val": "37701 Velky Ratmirov Velky Ratmirov (cast)"
  },
  {
    "cast": "Velký Rečkov",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Velky Reckov"
  },
  {
    "cast": "Velký Rybník",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Velký Rybník",
    "val": "39301 Velky Rybnik Velky Rybnik"
  },
  {
    "cast": "Velký Rybník",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Hroznětín",
    "val": "36301 Hroznetin Velky Rybnik"
  },
  {
    "cast": "Velký Šenov",
    "psc": "40778",
    "okres": "Děčín",
    "obec": "Velký Šenov",
    "val": "40778 Velky Senov Velky Senov"
  },
  {
    "cast": "Velký Třebešov",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Velký Třebešov",
    "val": "55203 Velky Trebesov Velky Trebesov"
  },
  {
    "cast": "Velký Týnec",
    "psc": "78372",
    "okres": "Olomouc",
    "obec": "Velký Týnec",
    "val": "78372 Velky Tynec Velky Tynec"
  },
  {
    "cast": "Velký Újezd",
    "psc": "67532",
    "okres": "Třebíč",
    "obec": "Kojatice",
    "val": "67532 Kojatice Velky Ujezd"
  },
  {
    "cast": "Velký Újezd",
    "psc": "78355",
    "okres": "Olomouc",
    "obec": "Velký Újezd",
    "val": "78355 Velky Ujezd Velky Ujezd"
  },
  {
    "cast": "Velký Újezd",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Chorušice",
    "val": "27735 Chorusice Velky Ujezd"
  },
  {
    "cast": "Velký Újezd",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Býčkovice",
    "val": "41201 Byckovice Velky Ujezd"
  },
  {
    "cast": "Velký Valtinov",
    "psc": "47125",
    "okres": "Česká Lípa",
    "obec": "Velký Valtinov",
    "val": "47125 Velky Valtinov Velky Valtinov"
  },
  {
    "cast": "Velký Vřešťov",
    "psc": "54454",
    "okres": "Trutnov",
    "obec": "Velký Vřešťov",
    "val": "54454 Velky Vrestov Velky Vrestov"
  },
  {
    "cast": "Velmovice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Chýnov",
    "val": "39155 Chynov Velmovice"
  },
  {
    "cast": "Vělopolí",
    "psc": "73959",
    "okres": "Frýdek-Místek",
    "obec": "Vělopolí",
    "val": "73959 Velopoli Velopoli"
  },
  {
    "cast": "Veltěž",
    "psc": "25066",
    "okres": "Praha-východ",
    "obec": "Zdiby",
    "val": "25066 Zdiby Veltez"
  },
  {
    "cast": "Veltěže",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Veltěže",
    "val": "44001 Velteze Velteze"
  },
  {
    "cast": "Veltruby",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Veltruby",
    "val": "28002 Veltruby Veltruby"
  },
  {
    "cast": "Veltrusy",
    "psc": "27746",
    "okres": "Mělník",
    "obec": "Veltrusy",
    "val": "27746 Veltrusy Veltrusy"
  },
  {
    "cast": "Velvary",
    "psc": "27324",
    "okres": "Kladno",
    "obec": "Velvary",
    "val": "27324 Velvary Velvary"
  },
  {
    "cast": "Velvěty (část)",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Rtyně nad Bílinou",
    "val": "41501 Rtyne nad Bilinou Velvety (cast)"
  },
  {
    "cast": "Velvěty (část)",
    "psc": "41762",
    "okres": "Teplice",
    "obec": "Rtyně nad Bílinou",
    "val": "41762 Rtyne nad Bilinou Velvety (cast)"
  },
  {
    "cast": "Vémyslice",
    "psc": "67142",
    "okres": "Znojmo",
    "obec": "Vémyslice",
    "val": "67142 Vemyslice Vemyslice"
  },
  {
    "cast": "Vendolí",
    "psc": "56914",
    "okres": "Svitavy",
    "obec": "Vendolí",
    "val": "56914 Vendoli Vendoli"
  },
  {
    "cast": "Vendryně (část)",
    "psc": "73994",
    "okres": "Frýdek-Místek",
    "obec": "Vendryně",
    "val": "73994 Vendryne Vendryne (cast)"
  },
  {
    "cast": "Vendryně (část)",
    "psc": "73995",
    "okres": "Frýdek-Místek",
    "obec": "Vendryně",
    "val": "73995 Vendryne Vendryne (cast)"
  },
  {
    "cast": "Vepice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Vepice"
  },
  {
    "cast": "Vepřek",
    "psc": "27752",
    "okres": "Mělník",
    "obec": "Nová Ves",
    "val": "27752 Nova Ves Veprek"
  },
  {
    "cast": "Vepříkov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Vepříkov",
    "val": "58301 Veprikov Veprikov"
  },
  {
    "cast": "Vepřová",
    "psc": "59211",
    "okres": "Žďár nad Sázavou",
    "obec": "Vepřová",
    "val": "59211 Veprova Veprova"
  },
  {
    "cast": "Verdek",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Dvůr Králové nad Labem",
    "val": "54401 Dvur Kralove nad Labem Verdek"
  },
  {
    "cast": "Verměřovice",
    "psc": "56152",
    "okres": "Ústí nad Orlicí",
    "obec": "Verměřovice",
    "val": "56152 Vermerovice Vermerovice"
  },
  {
    "cast": "Verneřice",
    "psc": "41704",
    "okres": "Teplice",
    "obec": "Hrob",
    "val": "41704 Hrob Vernerice"
  },
  {
    "cast": "Verneřice",
    "psc": "40725",
    "okres": "Děčín",
    "obec": "Verneřice",
    "val": "40725 Vernerice Vernerice"
  },
  {
    "cast": "Vernéřov",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Aš",
    "val": "35201 As Vernerov"
  },
  {
    "cast": "Vernéřov",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Klášterec nad Ohří",
    "val": "43151 Klasterec nad Ohri Vernerov"
  },
  {
    "cast": "Vernéřovice (část)",
    "psc": "54982",
    "okres": "Náchod",
    "obec": "Vernéřovice",
    "val": "54982 Vernerovice Vernerovice (cast)"
  },
  {
    "cast": "Vernéřovice (část)",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Vernéřovice",
    "val": "54957 Vernerovice Vernerovice (cast)"
  },
  {
    "cast": "Vernířovice",
    "psc": "78815",
    "okres": "Šumperk",
    "obec": "Vernířovice",
    "val": "78815 Vernirovice Vernirovice"
  },
  {
    "cast": "Vernýřov",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28401 Chlistovice Vernyrov"
  },
  {
    "cast": "Věrovany",
    "psc": "78375",
    "okres": "Olomouc",
    "obec": "Věrovany",
    "val": "78375 Verovany Verovany"
  },
  {
    "cast": "Verušice",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36452 Zlutice Verusice"
  },
  {
    "cast": "Verušičky",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Verusicky"
  },
  {
    "cast": "Veřechov",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Horažďovice",
    "val": "34101 Horazdovice Verechov"
  },
  {
    "cast": "Věřice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Struhařov",
    "val": "25601 Struharov Verice"
  },
  {
    "cast": "Věřňovice",
    "psc": "73553",
    "okres": "Karviná",
    "obec": "Dolní Lutyně",
    "val": "73553 Dolni Lutyne Vernovice"
  },
  {
    "cast": "Veřovice",
    "psc": "74273",
    "okres": "Nový Jičín",
    "obec": "Veřovice",
    "val": "74273 Verovice Verovice"
  },
  {
    "cast": "Ves",
    "psc": "46373",
    "okres": "Liberec",
    "obec": "Černousy",
    "val": "46373 Cernousy Ves"
  },
  {
    "cast": "Ves Bílá Voda",
    "psc": "79069",
    "okres": "Jeseník",
    "obec": "Bílá Voda",
    "val": "79069 Bila Voda Ves Bila Voda"
  },
  {
    "cast": "Ves Touškov",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Ves Touškov",
    "val": "33301 Ves Touskov Ves Touskov"
  },
  {
    "cast": "Vesce",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Vesce",
    "val": "39201 Vesce Vesce"
  },
  {
    "cast": "Vesce",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Vroutek",
    "val": "44101 Vroutek Vesce"
  },
  {
    "cast": "Vesce",
    "psc": "39464",
    "okres": "Pelhřimov",
    "obec": "Počátky",
    "val": "39464 Pocatky Vesce"
  },
  {
    "cast": "Vesce",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Budíškovice",
    "val": "38001 Budiskovice Vesce"
  },
  {
    "cast": "Vesce",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Krabčice",
    "val": "41301 Krabcice Vesce"
  },
  {
    "cast": "Vesce",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Vesce"
  },
  {
    "cast": "Vesce",
    "psc": "67602",
    "okres": "Třebíč",
    "obec": "Moravské Budějovice",
    "val": "67602 Moravske Budejovice Vesce"
  },
  {
    "cast": "Vesce",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Týn nad Vltavou",
    "val": "37501 Tyn nad Vltavou Vesce"
  },
  {
    "cast": "Vesec",
    "psc": "50721",
    "okres": "Jičín",
    "obec": "Veliš",
    "val": "50721 Velis Vesec"
  },
  {
    "cast": "Vesec",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Vesec"
  },
  {
    "cast": "Vesec",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46342 Bila Vesec"
  },
  {
    "cast": "Vesec",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Mírová pod Kozákovem",
    "val": "51101 Mirova pod Kozakovem Vesec"
  },
  {
    "cast": "Vesec",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Světlá pod Ještědem",
    "val": "46343 Svetla pod Jestedem Vesec"
  },
  {
    "cast": "Vesec u Sobotky",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Libošovice",
    "val": "50601 Libosovice Vesec u Sobotky"
  },
  {
    "cast": "Vesec-Liberec XXV x)",
    "psc": "46312",
    "okres": "Liberec",
    "obec": "Liberec",
    "val": "46312 Liberec Vesec-Liberec XXV x)"
  },
  {
    "cast": "Veselá",
    "psc": "75651",
    "okres": "Vsetín",
    "obec": "Zašová",
    "val": "75651 Zasova Vesela"
  },
  {
    "cast": "Veselá",
    "psc": "76315",
    "okres": "Zlín",
    "obec": "Veselá",
    "val": "76315 Vesela Vesela"
  },
  {
    "cast": "Veselá",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Veselá",
    "val": "33701 Vesela Vesela"
  },
  {
    "cast": "Veselá",
    "psc": "51252",
    "okres": "Semily",
    "obec": "Veselá",
    "val": "51252 Vesela Vesela"
  },
  {
    "cast": "Veselá",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Sedletín",
    "val": "58301 Sedletin Vesela"
  },
  {
    "cast": "Veselá",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Veselá",
    "val": "39470 Vesela Vesela"
  },
  {
    "cast": "Veselá",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mnichovo Hradiště",
    "val": "29501 Mnichovo Hradiste Vesela"
  },
  {
    "cast": "Veselé",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Veselé",
    "val": "40502 Vesele Vesele"
  },
  {
    "cast": "Veselí",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74235 Odry Veseli"
  },
  {
    "cast": "Veselí",
    "psc": "41108",
    "okres": "Litoměřice",
    "obec": "Štětí",
    "val": "41108 Steti Veseli"
  },
  {
    "cast": "Veselí",
    "psc": "53501",
    "okres": "Pardubice",
    "obec": "Veselí",
    "val": "53501 Veseli Veseli"
  },
  {
    "cast": "Veselí",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Pavlov",
    "val": "78985 Pavlov Veseli"
  },
  {
    "cast": "Veselí",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Zákupy",
    "val": "47002 Zakupy Veseli"
  },
  {
    "cast": "Veselí",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Dalečín",
    "val": "59265 Dalecin Veseli"
  },
  {
    "cast": "Veselí",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Lomnice",
    "val": "67923 Lomnice Veseli"
  },
  {
    "cast": "Veselí",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Veseli"
  },
  {
    "cast": "Veselí",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Janovice nad Úhlavou",
    "val": "34021 Janovice nad Uhlavou Veseli"
  },
  {
    "cast": "Veselí nad Lužnicí I",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Veselí nad Lužnicí",
    "val": "39181 Veseli nad Luznici Veseli nad Luznici I"
  },
  {
    "cast": "Veselí nad Lužnicí II",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Veselí nad Lužnicí",
    "val": "39181 Veseli nad Luznici Veseli nad Luznici II"
  },
  {
    "cast": "Veselí nad Moravou",
    "psc": "69801",
    "okres": "Hodonín",
    "obec": "Veselí nad Moravou",
    "val": "69801 Veseli nad Moravou Veseli nad Moravou"
  },
  {
    "cast": "Veselice",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Velká Jesenice",
    "val": "55101 Velka Jesenice Veselice"
  },
  {
    "cast": "Veselice",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Veselice",
    "val": "29404 Veselice Veselice"
  },
  {
    "cast": "Veselice",
    "psc": "67913",
    "okres": "Blansko",
    "obec": "Vavřinec",
    "val": "67913 Vavrinec Veselice"
  },
  {
    "cast": "Veselice",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Veselice"
  },
  {
    "cast": "Veselíčko",
    "psc": "78324",
    "okres": "Olomouc",
    "obec": "Luká",
    "val": "78324 Luka Veselicko"
  },
  {
    "cast": "Veselíčko",
    "psc": "75125",
    "okres": "Přerov",
    "obec": "Veselíčko",
    "val": "75125 Veselicko Veselicko"
  },
  {
    "cast": "Veselíčko",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Veselicko"
  },
  {
    "cast": "Veselíčko 1.díl",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Veselé",
    "val": "40502 Vesele Veselicko 1.dil"
  },
  {
    "cast": "Veselíčko (část)",
    "psc": "39842",
    "okres": "Písek",
    "obec": "Veselíčko",
    "val": "39842 Veselicko Veselicko (cast)"
  },
  {
    "cast": "Veselíčko (část)",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Veselíčko",
    "val": "39843 Veselicko Veselicko (cast)"
  },
  {
    "cast": "Veselka",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25901 Olbramovice Veselka"
  },
  {
    "cast": "Veselka",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Veselka"
  },
  {
    "cast": "Veselka",
    "psc": "67974",
    "okres": "Blansko",
    "obec": "Kněževes",
    "val": "67974 Knezeves Veselka"
  },
  {
    "cast": "Veselka",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Trhové Sviny",
    "val": "37401 Trhove Sviny Veselka"
  },
  {
    "cast": "Veselov",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36452 Zlutice Veselov"
  },
  {
    "cast": "Veselská Lhota",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Vysoké Veselí",
    "val": "50703 Vysoke Veseli Veselska Lhota"
  },
  {
    "cast": "Veselý Kopec",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Vesely Kopec"
  },
  {
    "cast": "Veselý Žďár",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Veselý Žďár",
    "val": "58001 Vesely Zdar Vesely Zdar"
  },
  {
    "cast": "Veská",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Sezemice",
    "val": "53304 Sezemice Veska"
  },
  {
    "cast": "Véska",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Heřmanice u Oder",
    "val": "74235 Hermanice u Oder Veska"
  },
  {
    "cast": "Véska",
    "psc": "78316",
    "okres": "Olomouc",
    "obec": "Dolany",
    "val": "78316 Dolany Veska"
  },
  {
    "cast": "Vésky",
    "psc": "68601",
    "okres": "Uherské Hradiště",
    "obec": "Uherské Hradiště",
    "val": "68601 Uherske Hradiste Vesky"
  },
  {
    "cast": "Vesnička",
    "psc": "47115",
    "okres": "Česká Lípa",
    "obec": "Prysk",
    "val": "47115 Prysk Vesnicka"
  },
  {
    "cast": "Vestec",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Mezno",
    "val": "25786 Mezno Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "28933",
    "okres": "Nymburk",
    "obec": "Vestec",
    "val": "28933 Vestec Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Vestec",
    "val": "55205 Vestec Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Zaloňov",
    "val": "55101 Zalonov Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "25250",
    "okres": "Praha-západ",
    "obec": "Vestec",
    "val": "25250 Vestec Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Hřiměždice",
    "val": "26301 Hrimezdice Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53701 Chrudim Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Chocerady",
    "val": "25724 Chocerady Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Zbizuby",
    "val": "28504 Zbizuby Vestec"
  },
  {
    "cast": "Vestec",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Vestec"
  },
  {
    "cast": "Vestec (část)",
    "psc": "53845",
    "okres": "Chrudim",
    "obec": "Běstvina",
    "val": "53845 Bestvina Vestec (cast)"
  },
  {
    "cast": "Vestec (část)",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Běstvina",
    "val": "53843 Bestvina Vestec (cast)"
  },
  {
    "cast": "Vestecká Lhotka",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Jeřišno",
    "val": "58301 Jerisno Vestecka Lhotka"
  },
  {
    "cast": "Věstín",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Věstín",
    "val": "59265 Vestin Vestin"
  },
  {
    "cast": "Věstínek",
    "psc": "59265",
    "okres": "Žďár nad Sázavou",
    "obec": "Věstín",
    "val": "59265 Vestin Vestinek"
  },
  {
    "cast": "Věstoňovice",
    "psc": "67507",
    "okres": "Třebíč",
    "obec": "Benetice",
    "val": "67507 Benetice Vestonovice"
  },
  {
    "cast": "Věšín (část)",
    "psc": "26243",
    "okres": "Příbram",
    "obec": "Věšín",
    "val": "26243 Vesin Vesin (cast)"
  },
  {
    "cast": "Věšín (část)",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Věšín",
    "val": "26242 Vesin Vesin (cast)"
  },
  {
    "cast": "Věšťany",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Modlany",
    "val": "41501 Modlany Vestany"
  },
  {
    "cast": "Věštín",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Strašín",
    "val": "34201 Strasin Vestin"
  },
  {
    "cast": "Věteřov",
    "psc": "69701",
    "okres": "Hodonín",
    "obec": "Věteřov",
    "val": "69701 Veterov Veterov"
  },
  {
    "cast": "Vetlá",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Vrbice",
    "val": "41301 Vrbice Vetla"
  },
  {
    "cast": "Větrník",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Vestec",
    "val": "55205 Vestec Vetrnik"
  },
  {
    "cast": "Větrný Jeníkov",
    "psc": "58842",
    "okres": "Jihlava",
    "obec": "Větrný Jeníkov",
    "val": "58842 Vetrny Jenikov Vetrny Jenikov"
  },
  {
    "cast": "Větrov",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Vetrov"
  },
  {
    "cast": "Větrov",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Vetrov"
  },
  {
    "cast": "Větrov",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Vysoký Újezd",
    "val": "25744 Vysoky Ujezd Vetrov"
  },
  {
    "cast": "Větrov",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Solenice",
    "val": "26263 Solenice Vetrov"
  },
  {
    "cast": "Větrov",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Frýdlant",
    "val": "46401 Frydlant Vetrov"
  },
  {
    "cast": "Větrovy (část)",
    "psc": "39001",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39001 Tabor Vetrovy (cast)"
  },
  {
    "cast": "Větrovy (část)",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39002 Tabor Vetrovy (cast)"
  },
  {
    "cast": "Větrušice",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Kly",
    "val": "27741 Kly Vetrusice"
  },
  {
    "cast": "Větrušice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Čeradice",
    "val": "43801 Ceradice Vetrusice"
  },
  {
    "cast": "Větrušice",
    "psc": "25067",
    "okres": "Praha-východ",
    "obec": "Větrušice",
    "val": "25067 Vetrusice Vetrusice"
  },
  {
    "cast": "Větřkovice",
    "psc": "74743",
    "okres": "Opava",
    "obec": "Větřkovice",
    "val": "74743 Vetrkovice Vetrkovice"
  },
  {
    "cast": "Větřní",
    "psc": "38211",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38211 Vetrni Vetrni"
  },
  {
    "cast": "Vevčice (část)",
    "psc": "67153",
    "okres": "Znojmo",
    "obec": "Vevčice",
    "val": "67153 Vevcice Vevcice (cast)"
  },
  {
    "cast": "Vevčice (část)",
    "psc": "67132",
    "okres": "Znojmo",
    "obec": "Vevčice",
    "val": "67132 Vevcice Vevcice (cast)"
  },
  {
    "cast": "Veverská Bítýška",
    "psc": "66471",
    "okres": "Brno-venkov",
    "obec": "Veverská Bítýška",
    "val": "66471 Veverska Bityska Veverska Bityska"
  },
  {
    "cast": "Veverské Knínice",
    "psc": "66481",
    "okres": "Brno-venkov",
    "obec": "Veverské Knínice",
    "val": "66481 Veverske Kninice Veverske Kninice"
  },
  {
    "cast": "Veveří",
    "psc": "79351",
    "okres": "Olomouc",
    "obec": "Huzová",
    "val": "79351 Huzova Veveri"
  },
  {
    "cast": "Veveří",
    "psc": "37333",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37333 Nove Hrady Veveri"
  },
  {
    "cast": "Veveří (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Veveri (cast)"
  },
  {
    "cast": "Veveří (část)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Veveri (cast)"
  },
  {
    "cast": "Věvrov",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Horšovský Týn",
    "val": "34601 Horsovsky Tyn Vevrov"
  },
  {
    "cast": "Věž",
    "psc": "58256",
    "okres": "Havlíčkův Brod",
    "obec": "Věž",
    "val": "58256 Vez Vez"
  },
  {
    "cast": "Věžky",
    "psc": "75119",
    "okres": "Přerov",
    "obec": "Věžky",
    "val": "75119 Vezky Vezky"
  },
  {
    "cast": "Věžky",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Věžky",
    "val": "76833 Vezky Vezky"
  },
  {
    "cast": "Věžná",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Věžná",
    "val": "39501 Vezna Vezna"
  },
  {
    "cast": "Věžná (část)",
    "psc": "59262",
    "okres": "Žďár nad Sázavou",
    "obec": "Věžná",
    "val": "59262 Vezna Vezna (cast)"
  },
  {
    "cast": "Věžná (část)",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Věžná",
    "val": "59301 Vezna Vezna (cast)"
  },
  {
    "cast": "Věžnice",
    "psc": "58827",
    "okres": "Jihlava",
    "obec": "Věžnice",
    "val": "58827 Veznice Veznice"
  },
  {
    "cast": "Věžnice (část)",
    "psc": "58251",
    "okres": "Havlíčkův Brod",
    "obec": "Věžnice",
    "val": "58251 Veznice Veznice (cast)"
  },
  {
    "cast": "Věžnice (část)",
    "psc": "58252",
    "okres": "Havlíčkův Brod",
    "obec": "Věžnice",
    "val": "58252 Veznice Veznice (cast)"
  },
  {
    "cast": "Věžnička",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Věžnička",
    "val": "58813 Veznicka Veznicka"
  },
  {
    "cast": "Věžníčky",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Popovice",
    "val": "25701 Popovice Veznicky"
  },
  {
    "cast": "Věžníkov",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Slavošov",
    "val": "28522 Slavosov Veznikov"
  },
  {
    "cast": "Věžovatá Pláně",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Věžovatá Pláně",
    "val": "38232 Vezovata Plane Vezovata Plane"
  },
  {
    "cast": "Vchynice",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Vchynice",
    "val": "41002 Vchynice Vchynice"
  },
  {
    "cast": "Vchynice-Tetov I",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Srní",
    "val": "34192 Srni Vchynice-Tetov I"
  },
  {
    "cast": "Víceměřice",
    "psc": "79826",
    "okres": "Prostějov",
    "obec": "Víceměřice",
    "val": "79826 Vicemerice Vicemerice"
  },
  {
    "cast": "Vícemil",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Vícemil",
    "val": "37821 Vicemil Vicemil"
  },
  {
    "cast": "Vícemilice",
    "psc": "68501",
    "okres": "Vyškov",
    "obec": "Bučovice",
    "val": "68501 Bucovice Vicemilice"
  },
  {
    "cast": "Vícemily",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Svatá Maří",
    "val": "38301 Svata Mari Vicemily"
  },
  {
    "cast": "Vícenice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Vicenice"
  },
  {
    "cast": "Vícenice",
    "psc": "67602",
    "okres": "Třebíč",
    "obec": "Vícenice",
    "val": "67602 Vicenice Vicenice"
  },
  {
    "cast": "Vícenice u Náměště nad Oslavou",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Vícenice u Náměště nad Oslavou",
    "val": "67571 Vicenice u Nameste nad Oslavou Vicenice u Nameste nad Oslavou"
  },
  {
    "cast": "Víckov",
    "psc": "59451",
    "okres": "Brno-venkov",
    "obec": "Žďárec",
    "val": "59451 Zdarec Vickov"
  },
  {
    "cast": "Víckovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Třebětín",
    "val": "28601 Trebetin Vickovice"
  },
  {
    "cast": "Vicmanov",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Mukařov",
    "val": "29501 Mukarov Vicmanov"
  },
  {
    "cast": "Vícov",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Vícov",
    "val": "79803 Vicov Vicov"
  },
  {
    "cast": "Vičice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Březno",
    "val": "43801 Brezno Vicice"
  },
  {
    "cast": "Vidče",
    "psc": "75653",
    "okres": "Vsetín",
    "obec": "Vidče",
    "val": "75653 Vidce Vidce"
  },
  {
    "cast": "Vídeň",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Vídeň",
    "val": "59401 Viden Viden"
  },
  {
    "cast": "Vidhostice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Vroutek",
    "val": "44101 Vroutek Vidhostice"
  },
  {
    "cast": "Vidice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Vidice",
    "val": "28401 Vidice Vidice"
  },
  {
    "cast": "Vidice",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Vidice",
    "val": "34601 Vidice Vidice"
  },
  {
    "cast": "Vidim",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Vidim",
    "val": "27721 Vidim Vidim"
  },
  {
    "cast": "Vidlákova Lhota",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Benešov",
    "val": "25601 Benesov Vidlakova Lhota"
  },
  {
    "cast": "Vidlatá Seč",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Vidlatá Seč",
    "val": "57001 Vidlata Sec Vidlata Sec"
  },
  {
    "cast": "Vidly",
    "psc": "79326",
    "okres": "Bruntál",
    "obec": "Vrbno pod Pradědem",
    "val": "79326 Vrbno pod Pradedem Vidly"
  },
  {
    "cast": "Vidnava",
    "psc": "79055",
    "okres": "Jeseník",
    "obec": "Vidnava",
    "val": "79055 Vidnava Vidnava"
  },
  {
    "cast": "Vidochov",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Vidochov",
    "val": "50901 Vidochov Vidochov"
  },
  {
    "cast": "Vidolice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Pětipsy",
    "val": "43801 Petipsy Vidolice"
  },
  {
    "cast": "Vidoň",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Tetín",
    "val": "50771 Tetin Vidon"
  },
  {
    "cast": "Vidonice",
    "psc": "50782",
    "okres": "Jičín",
    "obec": "Pecka",
    "val": "50782 Pecka Vidonice"
  },
  {
    "cast": "Vidonín",
    "psc": "59457",
    "okres": "Žďár nad Sázavou",
    "obec": "Vidonín",
    "val": "59457 Vidonin Vidonin"
  },
  {
    "cast": "Vidov",
    "psc": "37007",
    "okres": "České Budějovice",
    "obec": "Vidov",
    "val": "37007 Vidov Vidov"
  },
  {
    "cast": "Vidovice",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Kunice",
    "val": "25163 Kunice Vidovice"
  },
  {
    "cast": "Vidovle",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Bitozeves",
    "val": "44001 Bitozeves Vidovle"
  },
  {
    "cast": "Vidžín",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Úterý",
    "val": "33041 Utery Vidzin"
  },
  {
    "cast": "Vigantice",
    "psc": "75661",
    "okres": "Vsetín",
    "obec": "Vigantice",
    "val": "75661 Vigantice Vigantice"
  },
  {
    "cast": "Víchov",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34901 Cernosin Vichov"
  },
  {
    "cast": "Víchová nad Jizerou",
    "psc": "51241",
    "okres": "Semily",
    "obec": "Víchová nad Jizerou",
    "val": "51241 Vichova nad Jizerou Vichova nad Jizerou"
  },
  {
    "cast": "Víchovská Lhota",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Víchová nad Jizerou",
    "val": "51401 Vichova nad Jizerou Vichovska Lhota"
  },
  {
    "cast": "Vikantice",
    "psc": "78825",
    "okres": "Šumperk",
    "obec": "Vikantice",
    "val": "78825 Vikantice Vikantice"
  },
  {
    "cast": "Vikletice",
    "psc": "43801",
    "okres": "Chomutov",
    "obec": "Chbany",
    "val": "43801 Chbany Vikletice"
  },
  {
    "cast": "Vikýřovice",
    "psc": "78813",
    "okres": "Šumperk",
    "obec": "Vikýřovice",
    "val": "78813 Vikyrovice Vikyrovice"
  },
  {
    "cast": "Vílanec",
    "psc": "58835",
    "okres": "Jihlava",
    "obec": "Vílanec",
    "val": "58835 Vilanec Vilanec"
  },
  {
    "cast": "Vilantice",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vilantice",
    "val": "54401 Vilantice Vilantice"
  },
  {
    "cast": "Vilasova Lhota",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Vilasova Lhota"
  },
  {
    "cast": "Vilémov",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Vilemov"
  },
  {
    "cast": "Vilémov",
    "psc": "78322",
    "okres": "Olomouc",
    "obec": "Vilémov",
    "val": "78322 Vilemov Vilemov"
  },
  {
    "cast": "Vilémov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Humpolec",
    "val": "39601 Humpolec Vilemov"
  },
  {
    "cast": "Vilémov",
    "psc": "40780",
    "okres": "Děčín",
    "obec": "Vilémov",
    "val": "40780 Vilemov Vilemov"
  },
  {
    "cast": "Vilémov",
    "psc": "43154",
    "okres": "Chomutov",
    "obec": "Vilémov",
    "val": "43154 Vilemov Vilemov"
  },
  {
    "cast": "Vilémov (část)",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Vilemov (cast)"
  },
  {
    "cast": "Vilémov (část)",
    "psc": "58283",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58283 Vilemov Vilemov (cast)"
  },
  {
    "cast": "Vilémovec",
    "psc": "58232",
    "okres": "Havlíčkův Brod",
    "obec": "Lipnice nad Sázavou",
    "val": "58232 Lipnice nad Sazavou Vilemovec"
  },
  {
    "cast": "Vilémovice",
    "psc": "67906",
    "okres": "Blansko",
    "obec": "Vilémovice",
    "val": "67906 Vilemovice Vilemovice"
  },
  {
    "cast": "Vilémovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Červené Janovice",
    "val": "28601 Cervene Janovice Vilemovice"
  },
  {
    "cast": "Vilémovice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémovice",
    "val": "58401 Vilemovice Vilemovice"
  },
  {
    "cast": "Vilice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Vilice",
    "val": "39143 Vilice Vilice"
  },
  {
    "cast": "Vilín",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Vilin"
  },
  {
    "cast": "Vílov",
    "psc": "34506",
    "okres": "Klatovy",
    "obec": "Černíkov",
    "val": "34506 Cernikov Vilov"
  },
  {
    "cast": "Vilsnice-Děčín XII x)",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Děčín",
    "val": "40502 Decin Vilsnice-Decin XII x)"
  },
  {
    "cast": "Vimperk I",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Vimperk I"
  },
  {
    "cast": "Vimperk II",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Vimperk II"
  },
  {
    "cast": "Vimperk III",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Vimperk III"
  },
  {
    "cast": "Vinary",
    "psc": "50353",
    "okres": "Hradec Králové",
    "obec": "Vinary",
    "val": "50353 Vinary Vinary"
  },
  {
    "cast": "Vinary",
    "psc": "53863",
    "okres": "Ústí nad Orlicí",
    "obec": "Vinary",
    "val": "53863 Vinary Vinary"
  },
  {
    "cast": "Vinary-Přerov XI x)",
    "psc": "75124",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75124 Prerov Vinary-Prerov XI x)"
  },
  {
    "cast": "Vinaře",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vinaře",
    "val": "28601 Vinare Vinare"
  },
  {
    "cast": "Vinaře",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Vilémov",
    "val": "43201 Vilemov Vinare"
  },
  {
    "cast": "Vinařice",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Jirkov",
    "val": "43111 Jirkov Vinarice"
  },
  {
    "cast": "Vinařice",
    "psc": "43915",
    "okres": "Louny",
    "obec": "Vinařice",
    "val": "43915 Vinarice Vinarice"
  },
  {
    "cast": "Vinařice",
    "psc": "27307",
    "okres": "Kladno",
    "obec": "Vinařice",
    "val": "27307 Vinarice Vinarice"
  },
  {
    "cast": "Vinařice",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Vinařice",
    "val": "29441 Vinarice Vinarice"
  },
  {
    "cast": "Vinařice",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Vinařice",
    "val": "26701 Vinarice Vinarice"
  },
  {
    "cast": "Vinařice",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Týnec nad Labem",
    "val": "28126 Tynec nad Labem Vinarice"
  },
  {
    "cast": "Vincencov",
    "psc": "79804",
    "okres": "Prostějov",
    "obec": "Vincencov",
    "val": "79804 Vincencov Vincencov"
  },
  {
    "cast": "Vinec",
    "psc": "29301",
    "okres": "Mladá Boleslav",
    "obec": "Vinec",
    "val": "29301 Vinec Vinec"
  },
  {
    "cast": "Vinice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vinaře",
    "val": "28601 Vinare Vinice"
  },
  {
    "cast": "Vinice",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Městec Králové",
    "val": "28903 Mestec Kralove Vinice"
  },
  {
    "cast": "Vinice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Třebnouševes",
    "val": "50801 Trebnouseves Vinice"
  },
  {
    "cast": "Viničná Lhota",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Rožďalovice",
    "val": "28934 Rozdalovice Vinicna Lhota"
  },
  {
    "cast": "Viničné Šumice",
    "psc": "66406",
    "okres": "Brno-venkov",
    "obec": "Viničné Šumice",
    "val": "66406 Vinicne Sumice Vinicne Sumice"
  },
  {
    "cast": "Vinná",
    "psc": "38203",
    "okres": "Český Krumlov",
    "obec": "Křemže",
    "val": "38203 Kremze Vinna"
  },
  {
    "cast": "Vinné",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Ploskovice",
    "val": "41201 Ploskovice Vinne"
  },
  {
    "cast": "Víno",
    "psc": "79397",
    "okres": "Bruntál",
    "obec": "Slezské Rudoltice",
    "val": "79397 Slezske Rudoltice Vino"
  },
  {
    "cast": "Vinohrady (část)",
    "psc": "11000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "11000 Praha Vinohrady (cast)"
  },
  {
    "cast": "Vinohrady (část)",
    "psc": "12000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "12000 Praha Vinohrady (cast)"
  },
  {
    "cast": "Vinohrady (část)",
    "psc": "13000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "13000 Praha Vinohrady (cast)"
  },
  {
    "cast": "Vinohrady (část)",
    "psc": "14000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14000 Praha Vinohrady (cast)"
  },
  {
    "cast": "Vinohrady (část)",
    "psc": "10000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10000 Praha Vinohrady (cast)"
  },
  {
    "cast": "Vinohrady (část)",
    "psc": "10100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10100 Praha Vinohrady (cast)"
  },
  {
    "cast": "Vinoř",
    "psc": "19017",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19017 Praha Vinor"
  },
  {
    "cast": "Vintířov",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Obrataň",
    "val": "39501 Obratan Vintirov"
  },
  {
    "cast": "Vintířov",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43201 Radonice Vintirov"
  },
  {
    "cast": "Vintířov",
    "psc": "35735",
    "okres": "Sokolov",
    "obec": "Vintířov",
    "val": "35735 Vintirov Vintirov"
  },
  {
    "cast": "Vír",
    "psc": "59266",
    "okres": "Žďár nad Sázavou",
    "obec": "Vír",
    "val": "59266 Vir Vir"
  },
  {
    "cast": "Virt",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Strakonice",
    "val": "38601 Strakonice Virt"
  },
  {
    "cast": "Víska",
    "psc": "78321",
    "okres": "Olomouc",
    "obec": "Litovel",
    "val": "78321 Litovel Viska"
  },
  {
    "cast": "Víska",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Čmelíny",
    "val": "33501 Cmeliny Viska"
  },
  {
    "cast": "Víska",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Nová Ves",
    "val": "38719 Nova Ves Viska"
  },
  {
    "cast": "Víska",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Chrastava",
    "val": "46331 Chrastava Viska"
  },
  {
    "cast": "Víska",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Víska",
    "val": "58301 Viska Viska"
  },
  {
    "cast": "Víska",
    "psc": "29425",
    "okres": "Mladá Boleslav",
    "obec": "Březovice",
    "val": "29425 Brezovice Viska"
  },
  {
    "cast": "Víska",
    "psc": "67529",
    "okres": "Jihlava",
    "obec": "Kněžice",
    "val": "67529 Knezice Viska"
  },
  {
    "cast": "Víska",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46401 Visnova Viska"
  },
  {
    "cast": "Víska",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Viska"
  },
  {
    "cast": "Víska",
    "psc": "26252",
    "okres": "Příbram",
    "obec": "Vysoký Chlumec",
    "val": "26252 Vysoky Chlumec Viska"
  },
  {
    "cast": "Víska pod Lesy",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Česká Kamenice",
    "val": "40502 Ceska Kamenice Viska pod Lesy"
  },
  {
    "cast": "Víska u Jevíčka",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Víska u Jevíčka",
    "val": "56943 Viska u Jevicka Viska u Jevicka"
  },
  {
    "cast": "Víska (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47002 Kravare Viska (cast)"
  },
  {
    "cast": "Víska (část)",
    "psc": "47103",
    "okres": "Česká Lípa",
    "obec": "Kravaře",
    "val": "47103 Kravare Viska (cast)"
  },
  {
    "cast": "Vísky",
    "psc": "33843",
    "okres": "Rokycany",
    "obec": "Vísky",
    "val": "33843 Visky Visky"
  },
  {
    "cast": "Vísky",
    "psc": "67933",
    "okres": "Blansko",
    "obec": "Vísky",
    "val": "67933 Visky Visky"
  },
  {
    "cast": "Višňáry",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Morašice",
    "val": "57001 Morasice Visnary"
  },
  {
    "cast": "Višňová",
    "psc": "46401",
    "okres": "Liberec",
    "obec": "Višňová",
    "val": "46401 Visnova Visnova"
  },
  {
    "cast": "Višňová",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Višňová",
    "val": "37821 Visnova Visnova"
  },
  {
    "cast": "Višňová (část)",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Višňová",
    "val": "26101 Visnova Visnova (cast)"
  },
  {
    "cast": "Višňová (část)",
    "psc": "26261",
    "okres": "Příbram",
    "obec": "Višňová",
    "val": "26261 Visnova Visnova (cast)"
  },
  {
    "cast": "Višňové",
    "psc": "67138",
    "okres": "Znojmo",
    "obec": "Višňové",
    "val": "67138 Visnove Visnove"
  },
  {
    "cast": "Vítaná",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Bezděkov",
    "val": "33901 Bezdekov Vitana"
  },
  {
    "cast": "Vítání",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Srby",
    "val": "34601 Srby Vitani"
  },
  {
    "cast": "Vítanov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vítanov",
    "val": "53901 Vitanov Vitanov"
  },
  {
    "cast": "Vitanovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Slapsko",
    "val": "39143 Slapsko Vitanovice"
  },
  {
    "cast": "Vitanovice",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Pěnčín",
    "val": "46345 Pencin Vitanovice"
  },
  {
    "cast": "Vitčice",
    "psc": "44101",
    "okres": "Chomutov",
    "obec": "Veliká Ves",
    "val": "44101 Velika Ves Vitcice"
  },
  {
    "cast": "Vitčice",
    "psc": "79827",
    "okres": "Prostějov",
    "obec": "Vitčice",
    "val": "79827 Vitcice Vitcice"
  },
  {
    "cast": "Vítějeves",
    "psc": "56906",
    "okres": "Svitavy",
    "obec": "Vítějeves",
    "val": "56906 Vitejeves Vitejeves"
  },
  {
    "cast": "Vitějovice (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Vitějovice",
    "val": "38301 Vitejovice Vitejovice (cast)"
  },
  {
    "cast": "Vitějovice (část)",
    "psc": "38427",
    "okres": "Prachatice",
    "obec": "Vitějovice",
    "val": "38427 Vitejovice Vitejovice (cast)"
  },
  {
    "cast": "Viteň",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Viten"
  },
  {
    "cast": "Vítězná-Bukovina x)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Vitezna-Bukovina x)"
  },
  {
    "cast": "Vítězná-Hájemství x)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Vitezna-Hajemstvi x)"
  },
  {
    "cast": "Vítězná-Huntířov x)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Vitezna-Huntirov x)"
  },
  {
    "cast": "Vítězná-Kocléřov x)",
    "psc": "54462",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54462 Vitezna Vitezna-Koclerov x)"
  },
  {
    "cast": "Vítězná-Komárov x)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Vitezna-Komarov x)"
  },
  {
    "cast": "Vítězná-Nové Záboří x)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Vitezna-Nove Zabori x)"
  },
  {
    "cast": "Vítězná-Záboří x)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Vitezna-Zabori x)"
  },
  {
    "cast": "Vítězov",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Velim",
    "val": "28002 Velim Vitezov"
  },
  {
    "cast": "Vítěž",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Vitez"
  },
  {
    "cast": "Vitice",
    "psc": "28106",
    "okres": "Kolín",
    "obec": "Vitice",
    "val": "28106 Vitice Vitice"
  },
  {
    "cast": "Vitice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Želiv",
    "val": "39601 Zeliv Vitice"
  },
  {
    "cast": "Vitice",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Krašlovice",
    "val": "38901 Kraslovice Vitice"
  },
  {
    "cast": "Vitín",
    "psc": "37363",
    "okres": "České Budějovice",
    "obec": "Vitín",
    "val": "37363 Vitin Vitin"
  },
  {
    "cast": "Vitín",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Počepice",
    "val": "26255 Pocepice Vitin"
  },
  {
    "cast": "Vitiněves",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Vitiněves",
    "val": "50601 Vitineves Vitineves"
  },
  {
    "cast": "Vitíněves",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Město pod Landštejnem",
    "val": "37881 Stare Mesto pod Landstejnem Vitineves"
  },
  {
    "cast": "Vitinka",
    "psc": "33701",
    "okres": "Rokycany",
    "obec": "Osek",
    "val": "33701 Osek Vitinka"
  },
  {
    "cast": "Vítkov",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74901 Vitkov Vitkov"
  },
  {
    "cast": "Vítkov",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Tachov",
    "val": "34701 Tachov Vitkov"
  },
  {
    "cast": "Vítkov",
    "psc": "35601",
    "okres": "Sokolov",
    "obec": "Sokolov",
    "val": "35601 Sokolov Vitkov"
  },
  {
    "cast": "Vítkov",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Štěkeň",
    "val": "38601 Steken Vitkov"
  },
  {
    "cast": "Vítkov",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Vitkov"
  },
  {
    "cast": "Vítkovice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Lubenec",
    "val": "44101 Lubenec Vitkovice"
  },
  {
    "cast": "Vítkovice",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Klatovy",
    "val": "33901 Klatovy Vitkovice"
  },
  {
    "cast": "Vítkovice",
    "psc": "70300",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70300 Ostrava Vitkovice"
  },
  {
    "cast": "Vítkovice (část)",
    "psc": "51237",
    "okres": "Semily",
    "obec": "Vítkovice",
    "val": "51237 Vitkovice Vitkovice (cast)"
  },
  {
    "cast": "Vítkovice (část)",
    "psc": "51238",
    "okres": "Semily",
    "obec": "Vítkovice",
    "val": "51238 Vitkovice Vitkovice (cast)"
  },
  {
    "cast": "Vítochov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Bystřice nad Pernštejnem",
    "val": "59301 Bystrice nad Pernstejnem Vitochov"
  },
  {
    "cast": "Vítonice",
    "psc": "67161",
    "okres": "Znojmo",
    "obec": "Vítonice",
    "val": "67161 Vitonice Vitonice"
  },
  {
    "cast": "Vítonice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Blažejovice",
    "val": "25768 Blazejovice Vitonice"
  },
  {
    "cast": "Vítonice",
    "psc": "76861",
    "okres": "Kroměříž",
    "obec": "Vítonice",
    "val": "76861 Vitonice Vitonice"
  },
  {
    "cast": "Vítonín",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58291 Krasna Hora Vitonin"
  },
  {
    "cast": "Vítov",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Žižice",
    "val": "27401 Zizice Vitov"
  },
  {
    "cast": "Vítová",
    "psc": "76316",
    "okres": "Zlín",
    "obec": "Fryšták",
    "val": "76316 Frystak Vitova"
  },
  {
    "cast": "Vítovice",
    "psc": "39421",
    "okres": "Pelhřimov",
    "obec": "Hořepník",
    "val": "39421 Horepnik Vitovice"
  },
  {
    "cast": "Vítovice",
    "psc": "68301",
    "okres": "Vyškov",
    "obec": "Rousínov",
    "val": "68301 Rousinov Vitovice"
  },
  {
    "cast": "Vítovka",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Odry",
    "val": "74235 Odry Vitovka"
  },
  {
    "cast": "Vizovice",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Vizovice",
    "val": "76312 Vizovice Vizovice"
  },
  {
    "cast": "Vižina",
    "psc": "26724",
    "okres": "Beroun",
    "obec": "Vižina",
    "val": "26724 Vizina Vizina"
  },
  {
    "cast": "Vížka",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Vizka"
  },
  {
    "cast": "Vížky",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Lukavice",
    "val": "53821 Lukavice Vizky"
  },
  {
    "cast": "Vižňov",
    "psc": "54983",
    "okres": "Náchod",
    "obec": "Meziměstí",
    "val": "54983 Mezimesti Viznov"
  },
  {
    "cast": "Vlačice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vlačice",
    "val": "28601 Vlacice Vlacice"
  },
  {
    "cast": "Vladislav",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Vladislav",
    "val": "67501 Vladislav Vladislav"
  },
  {
    "cast": "Vladměřice",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Vladmerice"
  },
  {
    "cast": "Vladořice",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36452 Zlutice Vladorice"
  },
  {
    "cast": "Vladyčín",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Vladycin"
  },
  {
    "cast": "Vlachnovice",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Jílovice",
    "val": "37312 Jilovice Vlachnovice"
  },
  {
    "cast": "Vlachov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Lukavice",
    "val": "78901 Lukavice Vlachov"
  },
  {
    "cast": "Vlachova Lhota",
    "psc": "76601",
    "okres": "Zlín",
    "obec": "Vlachova Lhota",
    "val": "76601 Vlachova Lhota Vlachova Lhota"
  },
  {
    "cast": "Vlachové",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Osečná",
    "val": "46352 Osecna Vlachove"
  },
  {
    "cast": "Vlachovice",
    "psc": "76324",
    "okres": "Zlín",
    "obec": "Vlachovice",
    "val": "76324 Vlachovice Vlachovice"
  },
  {
    "cast": "Vlachovice",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Vlachovice",
    "val": "59231 Vlachovice Vlachovice"
  },
  {
    "cast": "Vlachovo Březí",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Vlachovo Březí",
    "val": "38422 Vlachovo Brezi Vlachovo Brezi"
  },
  {
    "cast": "Vlasatice",
    "psc": "69130",
    "okres": "Brno-venkov",
    "obec": "Vlasatice",
    "val": "69130 Vlasatice Vlasatice"
  },
  {
    "cast": "Vlasenice",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Lhota-Vlasenice",
    "val": "39470 Lhota-Vlasenice Vlasenice"
  },
  {
    "cast": "Vlásenice",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39131 Jistebnice Vlasenice"
  },
  {
    "cast": "Vlásenice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Vlasenice"
  },
  {
    "cast": "Vlásenice-Drbohlavy",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Pelhřimov",
    "val": "39301 Pelhrimov Vlasenice-Drbohlavy"
  },
  {
    "cast": "Vlásenka",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Česká Metuje",
    "val": "54931 Ceska Metuje Vlasenka"
  },
  {
    "cast": "Vlaské",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Vlaske"
  },
  {
    "cast": "Vlastec",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Vlastec",
    "val": "39701 Vlastec Vlastec"
  },
  {
    "cast": "Vlastějov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Vlastejov"
  },
  {
    "cast": "Vlastějovice",
    "psc": "28523",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "28523 Vlastejovice Vlastejovice"
  },
  {
    "cast": "Vlastiboř",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Vlastiboř",
    "val": "39201 Vlastibor Vlastibor"
  },
  {
    "cast": "Vlastiboř",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Vlastiboř",
    "val": "46822 Vlastibor Vlastibor"
  },
  {
    "cast": "Vlastibořice",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Vlastibořice",
    "val": "46344 Vlastiborice Vlastiborice"
  },
  {
    "cast": "Vlastislav",
    "psc": "41114",
    "okres": "Litoměřice",
    "obec": "Vlastislav",
    "val": "41114 Vlastislav Vlastislav"
  },
  {
    "cast": "Vlastišov",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Vlastisov"
  },
  {
    "cast": "Vlastkovec",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Slavonice",
    "val": "37881 Slavonice Vlastkovec"
  },
  {
    "cast": "Vlašim",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vlašim",
    "val": "25801 Vlasim Vlasim"
  },
  {
    "cast": "Vlaštovičky",
    "psc": "74601",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74601 Opava Vlastovicky"
  },
  {
    "cast": "Vlčatín",
    "psc": "67505",
    "okres": "Třebíč",
    "obec": "Vlčatín",
    "val": "67505 Vlcatin Vlcatin"
  },
  {
    "cast": "Vlčetín",
    "psc": "46343",
    "okres": "Liberec",
    "obec": "Bílá",
    "val": "46343 Bila Vlcetin"
  },
  {
    "cast": "Vlčetín",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Žirovnice",
    "val": "39468 Zirovnice Vlcetin"
  },
  {
    "cast": "Vlčetínec",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Vlčetínec",
    "val": "37842 Vlcetinec Vlcetinec"
  },
  {
    "cast": "Vlčeves (část)",
    "psc": "39501",
    "okres": "Tábor",
    "obec": "Vlčeves",
    "val": "39501 Vlceves Vlceves (cast)"
  },
  {
    "cast": "Vlčeves (část)",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Vlčeves",
    "val": "39201 Vlceves Vlceves (cast)"
  },
  {
    "cast": "Vlčí",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Vlčí",
    "val": "33401 Vlci Vlci"
  },
  {
    "cast": "Vlčí",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Chlumčany",
    "val": "44001 Chlumcany Vlci"
  },
  {
    "cast": "Vlčí Doly",
    "psc": "76833",
    "okres": "Kroměříž",
    "obec": "Věžky",
    "val": "76833 Vezky Vlci Doly"
  },
  {
    "cast": "Vlčí Důl",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Vlci Dul"
  },
  {
    "cast": "Vlčí Habřina",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Vlčí Habřina",
    "val": "53341 Vlci Habrina Vlci Habrina"
  },
  {
    "cast": "Vlčí Hora",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40747 Krasna Lipa Vlci Hora"
  },
  {
    "cast": "Vlčí Hory",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Staré Bříště",
    "val": "39601 Stare Briste Vlci Hory"
  },
  {
    "cast": "Vlčí Jámy",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Lenora",
    "val": "38451 Lenora Vlci Jamy"
  },
  {
    "cast": "Vlčí Pole",
    "psc": "29404",
    "okres": "Mladá Boleslav",
    "obec": "Dolní Bousov",
    "val": "29404 Dolni Bousov Vlci Pole"
  },
  {
    "cast": "Vlčice",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Vlčice",
    "val": "79065 Vlcice Vlcice"
  },
  {
    "cast": "Vlčice",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Vlčice",
    "val": "54101 Vlcice Vlcice"
  },
  {
    "cast": "Vlčice",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Blovice",
    "val": "33601 Blovice Vlcice"
  },
  {
    "cast": "Vlčice",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Střížovice",
    "val": "37853 Strizovice Vlcice"
  },
  {
    "cast": "Vlčkov",
    "psc": "56002",
    "okres": "Svitavy",
    "obec": "Vlčkov",
    "val": "56002 Vlckov Vlckov"
  },
  {
    "cast": "Vlčková",
    "psc": "76319",
    "okres": "Zlín",
    "obec": "Vlčková",
    "val": "76319 Vlckova Vlckova"
  },
  {
    "cast": "Vlčkovice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Kolinec",
    "val": "34142 Kolinec Vlckovice"
  },
  {
    "cast": "Vlčkovice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25703 Neustupov Vlckovice"
  },
  {
    "cast": "Vlčkovice",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Praskačka",
    "val": "50327 Praskacka Vlckovice"
  },
  {
    "cast": "Vlčkovice",
    "psc": "56164",
    "okres": "Ústí nad Orlicí",
    "obec": "Mladkov",
    "val": "56164 Mladkov Vlckovice"
  },
  {
    "cast": "Vlčnov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Zavlekov",
    "val": "34142 Zavlekov Vlcnov"
  },
  {
    "cast": "Vlčnov",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Chrudim",
    "val": "53701 Chrudim Vlcnov"
  },
  {
    "cast": "Vlčnov",
    "psc": "68761",
    "okres": "Uherské Hradiště",
    "obec": "Vlčnov",
    "val": "68761 Vlcnov Vlcnov"
  },
  {
    "cast": "Vlčnov",
    "psc": "74231",
    "okres": "Nový Jičín",
    "obec": "Starý Jičín",
    "val": "74231 Stary Jicin Vlcnov"
  },
  {
    "cast": "Vlčovice",
    "psc": "74221",
    "okres": "Nový Jičín",
    "obec": "Kopřivnice",
    "val": "74221 Koprivnice Vlcovice"
  },
  {
    "cast": "Vlčtejn",
    "psc": "33204",
    "okres": "Plzeň-jih",
    "obec": "Vlčtejn",
    "val": "33204 Vlctejn Vlctejn"
  },
  {
    "cast": "Vletice",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Vletice"
  },
  {
    "cast": "Vlhlavy",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Sedlec",
    "val": "37341 Sedlec Vlhlavy"
  },
  {
    "cast": "Vlhošť",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Žeretice",
    "val": "50703 Zeretice Vlhost"
  },
  {
    "cast": "Vliněves (část)",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Dolní Beřkovice",
    "val": "27601 Dolni Berkovice Vlineves (cast)"
  },
  {
    "cast": "Vliněves (část)",
    "psc": "27701",
    "okres": "Mělník",
    "obec": "Dolní Beřkovice",
    "val": "27701 Dolni Berkovice Vlineves (cast)"
  },
  {
    "cast": "Vlkaň",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43201 Radonice Vlkan"
  },
  {
    "cast": "Vlkančice",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Vlkančice",
    "val": "28163 Vlkancice Vlkancice"
  },
  {
    "cast": "Vlkaneč",
    "psc": "28564",
    "okres": "Kutná Hora",
    "obec": "Vlkaneč",
    "val": "28564 Vlkanec Vlkanec"
  },
  {
    "cast": "Vlkanov",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Vlkanov",
    "val": "34522 Vlkanov Vlkanov"
  },
  {
    "cast": "Vlkanov",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Vlkanov",
    "val": "58291 Vlkanov Vlkanov"
  },
  {
    "cast": "Vlkava",
    "psc": "29443",
    "okres": "Mladá Boleslav",
    "obec": "Vlkava",
    "val": "29443 Vlkava Vlkava"
  },
  {
    "cast": "Vlkonice",
    "psc": "38486",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38486 Vacov Vlkonice"
  },
  {
    "cast": "Vlkonice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Vlkonice"
  },
  {
    "cast": "Vlkonice",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Budětice",
    "val": "34101 Budetice Vlkonice"
  },
  {
    "cast": "Vlkosovice",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Černovice",
    "val": "39470 Cernovice Vlkosovice"
  },
  {
    "cast": "Vlkoš",
    "psc": "69641",
    "okres": "Hodonín",
    "obec": "Vlkoš",
    "val": "69641 Vlkos Vlkos"
  },
  {
    "cast": "Vlkoš",
    "psc": "75119",
    "okres": "Přerov",
    "obec": "Vlkoš",
    "val": "75119 Vlkos Vlkos"
  },
  {
    "cast": "Vlkošov",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Vlkosov"
  },
  {
    "cast": "Vlkov",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Dobřeň",
    "val": "27721 Dobren Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Vlkov",
    "val": "55101 Vlkov Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Děkov",
    "val": "27004 Dekov Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Stvolová",
    "val": "67961 Stvolova Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Čakov",
    "val": "25601 Cakov Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Vlkov",
    "val": "39181 Vlkov Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Vlkov",
    "val": "59453 Vlkov Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Vlkov"
  },
  {
    "cast": "Vlkov",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Vlkov",
    "val": "37341 Vlkov Vlkov"
  },
  {
    "cast": "Vlkov nad Lesy",
    "psc": "50351",
    "okres": "Nymburk",
    "obec": "Běrunice",
    "val": "50351 Berunice Vlkov nad Lesy"
  },
  {
    "cast": "Vlkov pod Oškobrhem",
    "psc": "28904",
    "okres": "Nymburk",
    "obec": "Vlkov pod Oškobrhem",
    "val": "28904 Vlkov pod Oskobrhem Vlkov pod Oskobrhem"
  },
  {
    "cast": "Vlková",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Zbizuby",
    "val": "28504 Zbizuby Vlkova"
  },
  {
    "cast": "Vlkovec",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Chocerady",
    "val": "25724 Chocerady Vlkovec"
  },
  {
    "cast": "Vlkovice",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Fulnek",
    "val": "74245 Fulnek Vlkovice"
  },
  {
    "cast": "Vlkovice",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Vlkovice",
    "val": "35301 Vlkovice Vlkovice"
  },
  {
    "cast": "Vlkovice",
    "psc": "37373",
    "okres": "České Budějovice",
    "obec": "Lišov",
    "val": "37373 Lisov Vlkovice"
  },
  {
    "cast": "Vlksice",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Vlksice",
    "val": "39901 Vlksice Vlksice"
  },
  {
    "cast": "Vlkýš",
    "psc": "33024",
    "okres": "Plzeň-sever",
    "obec": "Heřmanova Huť",
    "val": "33024 Hermanova Hut Vlkys"
  },
  {
    "cast": "Vnarovy",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Vnarovy"
  },
  {
    "cast": "Vnitřní Město",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Písek",
    "val": "39701 Pisek Vnitrni Mesto"
  },
  {
    "cast": "Vnitřní Město",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Vnitrni Mesto"
  },
  {
    "cast": "Vnitřní Město",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Vnitrni Mesto"
  },
  {
    "cast": "Vnitřní Město",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Vnitrni Mesto"
  },
  {
    "cast": "Vnitřní Město",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Vnitrni Mesto"
  },
  {
    "cast": "Vnorovice",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Staré Hobzí",
    "val": "38001 Stare Hobzi Vnorovice"
  },
  {
    "cast": "Vnorovy",
    "psc": "69661",
    "okres": "Hodonín",
    "obec": "Vnorovy",
    "val": "69661 Vnorovy Vnorovy"
  },
  {
    "cast": "Voděrádky",
    "psc": "25101",
    "okres": "Praha-východ",
    "obec": "Říčany",
    "val": "25101 Ricany Voderadky"
  },
  {
    "cast": "Voděrady",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Voderady"
  },
  {
    "cast": "Voděrady",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Bílence",
    "val": "43001 Bilence Voderady"
  },
  {
    "cast": "Voděrady",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Luštěnice",
    "val": "29442 Lustenice Voderady"
  },
  {
    "cast": "Voděrady",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Voděrady",
    "val": "56601 Voderady Voderady"
  },
  {
    "cast": "Voděrady",
    "psc": "67901",
    "okres": "Blansko",
    "obec": "Voděrady",
    "val": "67901 Voderady Voderady"
  },
  {
    "cast": "Voděrady",
    "psc": "46342",
    "okres": "Jablonec nad Nisou",
    "obec": "Frýdštejn",
    "val": "46342 Frydstejn Voderady"
  },
  {
    "cast": "Voděrady",
    "psc": "51734",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Voděrady",
    "val": "51734 Voderady Voderady"
  },
  {
    "cast": "Vodice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Lhenice",
    "val": "38411 Lhenice Vodice"
  },
  {
    "cast": "Vodice (část)",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Vodice",
    "val": "39155 Vodice Vodice (cast)"
  },
  {
    "cast": "Vodice (část)",
    "psc": "39153",
    "okres": "Tábor",
    "obec": "Vodice",
    "val": "39153 Vodice Vodice (cast)"
  },
  {
    "cast": "Vodná",
    "psc": "36464",
    "okres": "Karlovy Vary",
    "obec": "Bečov nad Teplou",
    "val": "36464 Becov nad Teplou Vodna"
  },
  {
    "cast": "Vodná",
    "psc": "39470",
    "okres": "Pelhřimov",
    "obec": "Kamenice nad Lipou",
    "val": "39470 Kamenice nad Lipou Vodna"
  },
  {
    "cast": "Vodňanské Svobodné Hory",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Vodnanske Svobodne Hory"
  },
  {
    "cast": "Vodňany I",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Vodnany I"
  },
  {
    "cast": "Vodňany II",
    "psc": "38901",
    "okres": "Strakonice",
    "obec": "Vodňany",
    "val": "38901 Vodnany Vodnany II"
  },
  {
    "cast": "Vodní Ples-Dolní Ples x)",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Rasošky",
    "val": "55101 Rasosky Vodni Ples-Dolni Ples x)"
  },
  {
    "cast": "Vodní Újezd",
    "psc": "33441",
    "okres": "Plzeň-jih",
    "obec": "Dobřany",
    "val": "33441 Dobrany Vodni Ujezd"
  },
  {
    "cast": "Vodochody",
    "psc": "25069",
    "okres": "Praha-východ",
    "obec": "Vodochody",
    "val": "25069 Vodochody Vodochody"
  },
  {
    "cast": "Vodochody",
    "psc": "41184",
    "okres": "Litoměřice",
    "obec": "Straškov-Vodochody",
    "val": "41184 Straskov-Vodochody Vodochody"
  },
  {
    "cast": "Vodokrty",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Řenče",
    "val": "33401 Rence Vodokrty"
  },
  {
    "cast": "Vodranty",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vodranty",
    "val": "28601 Vodranty Vodranty"
  },
  {
    "cast": "Vodslivy",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Vodslivy",
    "val": "25724 Vodslivy Vodslivy"
  },
  {
    "cast": "Vohančice",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Vohančice",
    "val": "66601 Vohancice Vohancice"
  },
  {
    "cast": "Vochov",
    "psc": "33023",
    "okres": "Plzeň-sever",
    "obec": "Vochov",
    "val": "33023 Vochov Vochov"
  },
  {
    "cast": "Vojenice",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Kladruby",
    "val": "33808 Kladruby Vojenice"
  },
  {
    "cast": "Vojenice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Voděrady",
    "val": "51721 Voderady Vojenice"
  },
  {
    "cast": "Vojetice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Vojetice"
  },
  {
    "cast": "Vojetín",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Doksy",
    "val": "47201 Doksy Vojetin"
  },
  {
    "cast": "Vojetín (část)",
    "psc": "59257",
    "okres": "Žďár nad Sázavou",
    "obec": "Rozsochy",
    "val": "59257 Rozsochy Vojetin (cast)"
  },
  {
    "cast": "Vojetín (část)",
    "psc": "59251",
    "okres": "Žďár nad Sázavou",
    "obec": "Rozsochy",
    "val": "59251 Rozsochy Vojetin (cast)"
  },
  {
    "cast": "Vojice",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Podhorní Újezd a Vojice",
    "val": "50801 Podhorni Ujezd a Vojice Vojice"
  },
  {
    "cast": "Vojkov",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25753 Vojkov Vojkov"
  },
  {
    "cast": "Vojkovice",
    "psc": "73951",
    "okres": "Frýdek-Místek",
    "obec": "Vojkovice",
    "val": "73951 Vojkovice Vojkovice"
  },
  {
    "cast": "Vojkovice",
    "psc": "66701",
    "okres": "Brno-venkov",
    "obec": "Vojkovice",
    "val": "66701 Vojkovice Vojkovice"
  },
  {
    "cast": "Vojkovice",
    "psc": "36273",
    "okres": "Karlovy Vary",
    "obec": "Vojkovice",
    "val": "36273 Vojkovice Vojkovice"
  },
  {
    "cast": "Vojkovice",
    "psc": "27744",
    "okres": "Mělník",
    "obec": "Vojkovice",
    "val": "27744 Vojkovice Vojkovice"
  },
  {
    "cast": "Vojnice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Koštice",
    "val": "44001 Kostice Vojnice"
  },
  {
    "cast": "Vojnice",
    "psc": "78346",
    "okres": "Olomouc",
    "obec": "Těšetice",
    "val": "78346 Tesetice Vojnice"
  },
  {
    "cast": "Vojnice",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Volenice",
    "val": "38716 Volenice Vojnice"
  },
  {
    "cast": "Vojničky",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Koštice",
    "val": "44001 Kostice Vojnicky"
  },
  {
    "cast": "Vojníkov",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Vojníkov",
    "val": "39701 Vojnikov Vojnikov"
  },
  {
    "cast": "Vojnín",
    "psc": "43155",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43155 Radonice Vojnin"
  },
  {
    "cast": "Vojnův Městec",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Vojnův Městec",
    "val": "59101 Vojnuv Mestec Vojnuv Mestec"
  },
  {
    "cast": "Vojovice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Neurazy",
    "val": "33501 Neurazy Vojovice"
  },
  {
    "cast": "Vojslavice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25703 Bystrice Vojslavice"
  },
  {
    "cast": "Vojslavice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Vojslavice",
    "val": "39601 Vojslavice Vojslavice"
  },
  {
    "cast": "Vojslavice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Šumavské Hoštice",
    "val": "38301 Sumavske Hostice Vojslavice"
  },
  {
    "cast": "Vojtanov",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Vojtanov",
    "val": "35134 Vojtanov Vojtanov"
  },
  {
    "cast": "Vojtěchov",
    "psc": "27735",
    "okres": "Mělník",
    "obec": "Mšeno",
    "val": "27735 Mseno Vojtechov"
  },
  {
    "cast": "Vojtěchov",
    "psc": "79855",
    "okres": "Prostějov",
    "obec": "Hvozd",
    "val": "79855 Hvozd Vojtechov"
  },
  {
    "cast": "Vojtěchov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vojtěchov",
    "val": "53901 Vojtechov Vojtechov"
  },
  {
    "cast": "Vojtěchov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Lísek",
    "val": "59301 Lisek Vojtechov"
  },
  {
    "cast": "Vojtěšice",
    "psc": "51243",
    "okres": "Semily",
    "obec": "Jablonec nad Jizerou",
    "val": "51243 Jablonec nad Jizerou Vojtesice"
  },
  {
    "cast": "Vojtěšín",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Úněšov",
    "val": "33038 Unesov Vojtesin"
  },
  {
    "cast": "Vojtíškov",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Vojtiskov"
  },
  {
    "cast": "Vojtovice",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Vlčice",
    "val": "79065 Vlcice Vojtovice"
  },
  {
    "cast": "Vokov",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Třebeň",
    "val": "35134 Treben Vokov"
  },
  {
    "cast": "Vokov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Vokov",
    "val": "39301 Vokov Vokov"
  },
  {
    "cast": "Vokovice (část)",
    "psc": "16000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16000 Praha Vokovice (cast)"
  },
  {
    "cast": "Vokovice (část)",
    "psc": "16400",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "16400 Praha Vokovice (cast)"
  },
  {
    "cast": "Vokšice",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Podhradí",
    "val": "50601 Podhradi Voksice"
  },
  {
    "cast": "Volanice",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Volanice",
    "val": "50703 Volanice Volanice"
  },
  {
    "cast": "Volanov",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Volanov"
  },
  {
    "cast": "Volárna",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Volárna",
    "val": "28002 Volarna Volarna"
  },
  {
    "cast": "Volárna",
    "psc": "79201",
    "okres": "Bruntál",
    "obec": "Roudno",
    "val": "79201 Roudno Volarna"
  },
  {
    "cast": "Volary (část)",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Volary",
    "val": "38451 Volary Volary (cast)"
  },
  {
    "cast": "Volary (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Volary",
    "val": "38301 Volary Volary (cast)"
  },
  {
    "cast": "Volavá Lhota",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Vlastějovice",
    "val": "28522 Vlastejovice Volava Lhota"
  },
  {
    "cast": "Volavec (část)",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Radostná pod Kozákovem",
    "val": "51101 Radostna pod Kozakovem Volavec (cast)"
  },
  {
    "cast": "Volavec (část)",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Radostná pod Kozákovem",
    "val": "51263 Radostna pod Kozakovem Volavec (cast)"
  },
  {
    "cast": "Volavka",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Pravonín",
    "val": "25708 Pravonin Volavka"
  },
  {
    "cast": "Volduchy",
    "psc": "33822",
    "okres": "Rokycany",
    "obec": "Volduchy",
    "val": "33822 Volduchy Volduchy"
  },
  {
    "cast": "Voleč",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Voleč",
    "val": "53341 Volec Volec"
  },
  {
    "cast": "Volenice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Počedělice",
    "val": "44001 Pocedelice Volenice"
  },
  {
    "cast": "Volenice",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Volenice",
    "val": "26272 Volenice Volenice"
  },
  {
    "cast": "Volenice",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Volenice",
    "val": "38716 Volenice Volenice"
  },
  {
    "cast": "Voletice",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Voletice"
  },
  {
    "cast": "Voletiny",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Trutnov",
    "val": "54101 Trutnov Voletiny"
  },
  {
    "cast": "Volevčice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Volevčice",
    "val": "43401 Volevcice Volevcice"
  },
  {
    "cast": "Volevčice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Volevčice",
    "val": "58856 Volevcice Volevcice"
  },
  {
    "cast": "Volfartice",
    "psc": "47112",
    "okres": "Česká Lípa",
    "obec": "Volfartice",
    "val": "47112 Volfartice Volfartice"
  },
  {
    "cast": "Volfířov",
    "psc": "38001",
    "okres": "Jindřichův Hradec",
    "obec": "Volfířov",
    "val": "38001 Volfirov Volfirov"
  },
  {
    "cast": "Volichov",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Krásná Hora",
    "val": "58291 Krasna Hora Volichov"
  },
  {
    "cast": "Volovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Prachatice",
    "val": "38301 Prachatice Volovice"
  },
  {
    "cast": "Volovka",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Velká Jesenice",
    "val": "55101 Velka Jesenice Volovka"
  },
  {
    "cast": "Volšovy",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Volsovy"
  },
  {
    "cast": "Voltuš",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Voltus"
  },
  {
    "cast": "Voltýřov",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Klučenice",
    "val": "26256 Klucenice Voltyrov"
  },
  {
    "cast": "Volyně",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Volyně",
    "val": "38701 Volyne Volyne"
  },
  {
    "cast": "Volyně",
    "psc": "43183",
    "okres": "Chomutov",
    "obec": "Výsluní",
    "val": "43183 Vysluni Volyne"
  },
  {
    "cast": "Vonoklasy",
    "psc": "25228",
    "okres": "Praha-západ",
    "obec": "Vonoklasy",
    "val": "25228 Vonoklasy Vonoklasy"
  },
  {
    "cast": "Vonšov",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Skalná",
    "val": "35134 Skalna Vonsov"
  },
  {
    "cast": "Voračice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25753 Vojkov Voracice"
  },
  {
    "cast": "Vorklebice",
    "psc": "46345",
    "okres": "Liberec",
    "obec": "Kobyly",
    "val": "46345 Kobyly Vorklebice"
  },
  {
    "cast": "Vortová (část)",
    "psc": "53961",
    "okres": "Chrudim",
    "obec": "Vortová",
    "val": "53961 Vortova Vortova (cast)"
  },
  {
    "cast": "Vortová (část)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vortová",
    "val": "53901 Vortova Vortova (cast)"
  },
  {
    "cast": "Vosí",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Švihov",
    "val": "34012 Svihov Vosi"
  },
  {
    "cast": "Vosná",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Vosna"
  },
  {
    "cast": "Votice",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Votice"
  },
  {
    "cast": "Votuz",
    "psc": "50801",
    "okres": "Jičín",
    "obec": "Boháňka",
    "val": "50801 Bohanka Votuz"
  },
  {
    "cast": "Vozerovice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Vozerovice"
  },
  {
    "cast": "Voznice",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Voznice",
    "val": "26301 Voznice Voznice"
  },
  {
    "cast": "Vrabcov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Vrabcov"
  },
  {
    "cast": "Vrábče",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Vrábče",
    "val": "37001 Vrabce Vrabce"
  },
  {
    "cast": "Vrábsko",
    "psc": "39804",
    "okres": "Písek",
    "obec": "Smetanova Lhota",
    "val": "39804 Smetanova Lhota Vrabsko"
  },
  {
    "cast": "Vráce",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Vrace"
  },
  {
    "cast": "Vraclav",
    "psc": "56542",
    "okres": "Ústí nad Orlicí",
    "obec": "Vraclav",
    "val": "56542 Vraclav Vraclav"
  },
  {
    "cast": "Vraclávek",
    "psc": "79401",
    "okres": "Bruntál",
    "obec": "Hošťálkovy",
    "val": "79401 Hostalkovy Vraclavek"
  },
  {
    "cast": "Vracov",
    "psc": "69642",
    "okres": "Hodonín",
    "obec": "Vracov",
    "val": "69642 Vracov Vracov"
  },
  {
    "cast": "Vracov",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34034 Planice Vracov"
  },
  {
    "cast": "Vracovice",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Vracovice",
    "val": "67102 Vracovice Vracovice"
  },
  {
    "cast": "Vracovice (část)",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vracovice",
    "val": "25801 Vracovice Vracovice (cast)"
  },
  {
    "cast": "Vracovice (část)",
    "psc": "25709",
    "okres": "Benešov",
    "obec": "Vracovice",
    "val": "25709 Vracovice Vracovice (cast)"
  },
  {
    "cast": "Vračkovice",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Vrackovice"
  },
  {
    "cast": "Vračovice",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vračovice-Orlov",
    "val": "56601 Vracovice-Orlov Vracovice"
  },
  {
    "cast": "Vrahovice",
    "psc": "79811",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79811 Prostejov Vrahovice"
  },
  {
    "cast": "Vrahožily",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Rtyně nad Bílinou",
    "val": "41501 Rtyne nad Bilinou Vrahozily"
  },
  {
    "cast": "Vraňany",
    "psc": "27707",
    "okres": "Mělník",
    "obec": "Vraňany",
    "val": "27707 Vranany Vranany"
  },
  {
    "cast": "Vrančice",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Vrančice",
    "val": "26231 Vrancice Vrancice"
  },
  {
    "cast": "Vrané nad Vltavou (část)",
    "psc": "25245",
    "okres": "Praha-západ",
    "obec": "Vrané nad Vltavou",
    "val": "25245 Vrane nad Vltavou Vrane nad Vltavou (cast)"
  },
  {
    "cast": "Vrané nad Vltavou (část)",
    "psc": "25246",
    "okres": "Praha-západ",
    "obec": "Vrané nad Vltavou",
    "val": "25246 Vrane nad Vltavou Vrane nad Vltavou (cast)"
  },
  {
    "cast": "Vranice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Píšť",
    "val": "39601 Pist Vranice"
  },
  {
    "cast": "Vranice",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Zbizuby",
    "val": "28504 Zbizuby Vranice"
  },
  {
    "cast": "Vraník",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Ledečko",
    "val": "28506 Ledecko Vranik"
  },
  {
    "cast": "Vranín",
    "psc": "67544",
    "okres": "Třebíč",
    "obec": "Moravské Budějovice",
    "val": "67544 Moravske Budejovice Vranin"
  },
  {
    "cast": "Vranov",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Vranov"
  },
  {
    "cast": "Vranov",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Vranov",
    "val": "34901 Vranov Vranov"
  },
  {
    "cast": "Vranov",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25722 Vranov Vranov"
  },
  {
    "cast": "Vranov",
    "psc": "47124",
    "okres": "Česká Lípa",
    "obec": "Mimoň",
    "val": "47124 Mimon Vranov"
  },
  {
    "cast": "Vranov",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Ctětín",
    "val": "53825 Ctetin Vranov"
  },
  {
    "cast": "Vranov",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Mnichov",
    "val": "34522 Mnichov Vranov"
  },
  {
    "cast": "Vranov",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Dražíč",
    "val": "37501 Drazic Vranov"
  },
  {
    "cast": "Vránov",
    "psc": "34561",
    "okres": "Domažlice",
    "obec": "Staňkov",
    "val": "34561 Stankov Vranov"
  },
  {
    "cast": "Vranov nad Dyjí",
    "psc": "67103",
    "okres": "Znojmo",
    "obec": "Vranov nad Dyjí",
    "val": "67103 Vranov nad Dyji Vranov nad Dyji"
  },
  {
    "cast": "Vranov (část)",
    "psc": "66434",
    "okres": "Brno-venkov",
    "obec": "Vranov",
    "val": "66434 Vranov Vranov (cast)"
  },
  {
    "cast": "Vranov (část)",
    "psc": "66432",
    "okres": "Brno-venkov",
    "obec": "Vranov",
    "val": "66432 Vranov Vranov (cast)"
  },
  {
    "cast": "Vranová Lhota",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Vranová Lhota",
    "val": "57101 Vranova Lhota Vranova Lhota"
  },
  {
    "cast": "Vranová (část)",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Vranová",
    "val": "67962 Vranova Vranova (cast)"
  },
  {
    "cast": "Vranová (část)",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Vranová",
    "val": "67961 Vranova Vranova (cast)"
  },
  {
    "cast": "Vranové 1.díl",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Vranove 1.dil"
  },
  {
    "cast": "Vranové 2.díl",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Vranove 2.dil"
  },
  {
    "cast": "Vranovice",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Břasy",
    "val": "33824 Brasy Vranovice"
  },
  {
    "cast": "Vranovice",
    "psc": "69125",
    "okres": "Brno-venkov",
    "obec": "Vranovice",
    "val": "69125 Vranovice Vranovice"
  },
  {
    "cast": "Vranovice",
    "psc": "79808",
    "okres": "Prostějov",
    "obec": "Vranovice-Kelčice",
    "val": "79808 Vranovice-Kelcice Vranovice"
  },
  {
    "cast": "Vranovice",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Vranovice",
    "val": "26242 Vranovice Vranovice"
  },
  {
    "cast": "Vranovská Lhota",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Vranov",
    "val": "25722 Vranov Vranovska Lhota"
  },
  {
    "cast": "Vranovská Ves",
    "psc": "67151",
    "okres": "Znojmo",
    "obec": "Vranovská Ves",
    "val": "67151 Vranovska Ves Vranovska Ves"
  },
  {
    "cast": "Vranovsko",
    "psc": "51252",
    "okres": "Semily",
    "obec": "Veselá",
    "val": "51252 Vesela Vranovsko"
  },
  {
    "cast": "Vraný",
    "psc": "27373",
    "okres": "Kladno",
    "obec": "Vraný",
    "val": "27373 Vrany Vrany"
  },
  {
    "cast": "Vrapice (část)",
    "psc": "27203",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27203 Kladno Vrapice (cast)"
  },
  {
    "cast": "Vrapice (část)",
    "psc": "27341",
    "okres": "Kladno",
    "obec": "Kladno",
    "val": "27341 Kladno Vrapice (cast)"
  },
  {
    "cast": "Vrát",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Koberovy",
    "val": "46822 Koberovy Vrat"
  },
  {
    "cast": "Vratěnín",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Vratěnín",
    "val": "67107 Vratenin Vratenin"
  },
  {
    "cast": "Vratíkov",
    "psc": "68001",
    "okres": "Blansko",
    "obec": "Boskovice",
    "val": "68001 Boskovice Vratikov"
  },
  {
    "cast": "Vratimov",
    "psc": "73932",
    "okres": "Ostrava-město",
    "obec": "Vratimov",
    "val": "73932 Vratimov Vratimov"
  },
  {
    "cast": "Vratislávka",
    "psc": "59451",
    "okres": "Brno-venkov",
    "obec": "Vratislávka",
    "val": "59451 Vratislavka Vratislavka"
  },
  {
    "cast": "Vratišov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Mezná",
    "val": "39301 Mezna Vratisov"
  },
  {
    "cast": "Vratišov",
    "psc": "39901",
    "okres": "Tábor",
    "obec": "Nadějkov",
    "val": "39901 Nadejkov Vratisov"
  },
  {
    "cast": "Vratkov",
    "psc": "58301",
    "okres": "Havlíčkův Brod",
    "obec": "Rušinov",
    "val": "58301 Rusinov Vratkov"
  },
  {
    "cast": "Vratkov",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Nechvalice",
    "val": "25791 Nechvalice Vratkov"
  },
  {
    "cast": "Vrátkov",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Vrátkov",
    "val": "28201 Vratkov Vratkov"
  },
  {
    "cast": "Vrátno",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Vrátno",
    "val": "29426 Vratno Vratno"
  },
  {
    "cast": "Vráto (část)",
    "psc": "37371",
    "okres": "České Budějovice",
    "obec": "Vráto",
    "val": "37371 Vrato Vrato (cast)"
  },
  {
    "cast": "Vráto (část)",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Vráto",
    "val": "37001 Vrato Vrato (cast)"
  },
  {
    "cast": "Vráž",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dlažov",
    "val": "33901 Dlazov Vraz"
  },
  {
    "cast": "Vráž",
    "psc": "25724",
    "okres": "Benešov",
    "obec": "Ostředek",
    "val": "25724 Ostredek Vraz"
  },
  {
    "cast": "Vráž",
    "psc": "26711",
    "okres": "Beroun",
    "obec": "Vráž",
    "val": "26711 Vraz Vraz"
  },
  {
    "cast": "Vraždovy Lhotice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Dolní Kralovice",
    "val": "25768 Dolni Kralovice Vrazdovy Lhotice"
  },
  {
    "cast": "Vražkov",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Vražkov",
    "val": "41301 Vrazkov Vrazkov"
  },
  {
    "cast": "Vrážná",
    "psc": "39137",
    "okres": "Tábor",
    "obec": "Chotoviny",
    "val": "39137 Chotoviny Vrazna"
  },
  {
    "cast": "Vražné",
    "psc": "74235",
    "okres": "Nový Jičín",
    "obec": "Vražné",
    "val": "74235 Vrazne Vrazne"
  },
  {
    "cast": "Vrážné",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Vrážné",
    "val": "56943 Vrazne Vrazne"
  },
  {
    "cast": "Vrážné",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Pláně",
    "val": "33101 Plane Vrazne"
  },
  {
    "cast": "Vrbátky",
    "psc": "79813",
    "okres": "Prostějov",
    "obec": "Vrbátky",
    "val": "79813 Vrbatky Vrbatky"
  },
  {
    "cast": "Vrbatův Kostelec",
    "psc": "53956",
    "okres": "Chrudim",
    "obec": "Vrbatův Kostelec",
    "val": "53956 Vrbatuv Kostelec Vrbatuv Kostelec"
  },
  {
    "cast": "Vrbčany",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Vrbčany",
    "val": "28002 Vrbcany Vrbcany"
  },
  {
    "cast": "Vrbětice",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Tisovec",
    "val": "53973 Tisovec Vrbetice"
  },
  {
    "cast": "Vrbětice",
    "psc": "76324",
    "okres": "Zlín",
    "obec": "Vlachovice",
    "val": "76324 Vlachovice Vrbetice"
  },
  {
    "cast": "Vrbětín",
    "psc": "25701",
    "okres": "Benešov",
    "obec": "Postupice",
    "val": "25701 Postupice Vrbetin"
  },
  {
    "cast": "Vrbice",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vrbice",
    "val": "38473 Vrbice Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Vrbice",
    "val": "36453 Vrbice Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "73551",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73551 Bohumin Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Vrbice",
    "val": "50703 Vrbice Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Hořovičky",
    "val": "27004 Horovicky Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "69109",
    "okres": "Břeclav",
    "obec": "Vrbice",
    "val": "69109 Vrbice Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Hracholusky",
    "val": "38301 Hracholusky Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "41119",
    "okres": "Litoměřice",
    "obec": "Mšené-lázně",
    "val": "41119 Msene-lazne Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "41164",
    "okres": "Litoměřice",
    "obec": "Vrbice",
    "val": "41164 Vrbice Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "51741",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Vrbice",
    "val": "51741 Vrbice Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Leština u Světlé",
    "val": "58401 Lestina u Svetle Vrbice"
  },
  {
    "cast": "Vrbice",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Vrbice"
  },
  {
    "cast": "Vrbice u Bezdružic",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Lestkov",
    "val": "34953 Lestkov Vrbice u Bezdruzic"
  },
  {
    "cast": "Vrbice u Stříbra",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Kladruby",
    "val": "34901 Kladruby Vrbice u Stribra"
  },
  {
    "cast": "Vrbice (část)",
    "psc": "28904",
    "okres": "Nymburk",
    "obec": "Vrbice",
    "val": "28904 Vrbice Vrbice (cast)"
  },
  {
    "cast": "Vrbice (část)",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Vrbice",
    "val": "28903 Vrbice Vrbice (cast)"
  },
  {
    "cast": "Vrbičany",
    "psc": "41121",
    "okres": "Litoměřice",
    "obec": "Vrbičany",
    "val": "41121 Vrbicany Vrbicany"
  },
  {
    "cast": "Vrbičany",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Vrbičany",
    "val": "27374 Vrbicany Vrbicany"
  },
  {
    "cast": "Vrbička",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Vroutek",
    "val": "44101 Vroutek Vrbicka"
  },
  {
    "cast": "Vrbka",
    "psc": "76821",
    "okres": "Kroměříž",
    "obec": "Vrbka",
    "val": "76821 Vrbka Vrbka"
  },
  {
    "cast": "Vrbka",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Postoloprty",
    "val": "44001 Postoloprty Vrbka"
  },
  {
    "cast": "Vrbka",
    "psc": "74728",
    "okres": "Opava",
    "obec": "Služovice",
    "val": "74728 Sluzovice Vrbka"
  },
  {
    "cast": "Vrbka",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Kozlov",
    "val": "58401 Kozlov Vrbka"
  },
  {
    "cast": "Vrbka",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Budyně nad Ohří",
    "val": "41301 Budyne nad Ohri Vrbka"
  },
  {
    "cast": "Vrbno",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Hořín",
    "val": "27601 Horin Vrbno"
  },
  {
    "cast": "Vrbno",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Kadov",
    "val": "38801 Kadov Vrbno"
  },
  {
    "cast": "Vrbno nad Lesy",
    "psc": "43906",
    "okres": "Louny",
    "obec": "Vrbno nad Lesy",
    "val": "43906 Vrbno nad Lesy Vrbno nad Lesy"
  },
  {
    "cast": "Vrbno pod Pradědem",
    "psc": "79326",
    "okres": "Bruntál",
    "obec": "Vrbno pod Pradědem",
    "val": "79326 Vrbno pod Pradedem Vrbno pod Pradedem"
  },
  {
    "cast": "Vrbová Lhota",
    "psc": "28911",
    "okres": "Nymburk",
    "obec": "Vrbová Lhota",
    "val": "28911 Vrbova Lhota Vrbova Lhota"
  },
  {
    "cast": "Vrbovec",
    "psc": "67124",
    "okres": "Znojmo",
    "obec": "Vrbovec",
    "val": "67124 Vrbovec Vrbovec"
  },
  {
    "cast": "Vrcov",
    "psc": "37312",
    "okres": "České Budějovice",
    "obec": "Borovany",
    "val": "37312 Borovany Vrcov"
  },
  {
    "cast": "Vrcovice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Vrcovice",
    "val": "39701 Vrcovice Vrcovice"
  },
  {
    "cast": "Vrčeň",
    "psc": "33541",
    "okres": "Plzeň-jih",
    "obec": "Vrčeň",
    "val": "33541 Vrcen Vrcen"
  },
  {
    "cast": "Vrdy (část)",
    "psc": "28571",
    "okres": "Kutná Hora",
    "obec": "Vrdy",
    "val": "28571 Vrdy Vrdy (cast)"
  },
  {
    "cast": "Vrdy (část)",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vrdy",
    "val": "28601 Vrdy Vrdy (cast)"
  },
  {
    "cast": "Vrhaveč",
    "psc": "33023",
    "okres": "Tachov",
    "obec": "Kostelec",
    "val": "33023 Kostelec Vrhavec"
  },
  {
    "cast": "Vrhaveč",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Vrhaveč",
    "val": "33901 Vrhavec Vrhavec"
  },
  {
    "cast": "Vrcha",
    "psc": "53701",
    "okres": "Chrudim",
    "obec": "Sobětuchy",
    "val": "53701 Sobetuchy Vrcha"
  },
  {
    "cast": "Vrchbělá",
    "psc": "29421",
    "okres": "Mladá Boleslav",
    "obec": "Bělá pod Bezdězem",
    "val": "29421 Bela pod Bezdezem Vrchbela"
  },
  {
    "cast": "Vrchlabí (část)",
    "psc": "54301",
    "okres": "Trutnov",
    "obec": "Vrchlabí",
    "val": "54301 Vrchlabi Vrchlabi (cast)"
  },
  {
    "cast": "Vrchlabí (část)",
    "psc": "54302",
    "okres": "Trutnov",
    "obec": "Vrchlabí",
    "val": "54302 Vrchlabi Vrchlabi (cast)"
  },
  {
    "cast": "Vrchlabí (část)",
    "psc": "54303",
    "okres": "Trutnov",
    "obec": "Vrchlabí",
    "val": "54303 Vrchlabi Vrchlabi (cast)"
  },
  {
    "cast": "Vrchlice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Vrchlice"
  },
  {
    "cast": "Vrcholtovice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Vrcholtovice"
  },
  {
    "cast": "Vrchoslav (část)",
    "psc": "41741",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41741 Krupka Vrchoslav (cast)"
  },
  {
    "cast": "Vrchoslav (část)",
    "psc": "41742",
    "okres": "Teplice",
    "obec": "Krupka",
    "val": "41742 Krupka Vrchoslav (cast)"
  },
  {
    "cast": "Vrchoslavice",
    "psc": "79827",
    "okres": "Prostějov",
    "obec": "Vrchoslavice",
    "val": "79827 Vrchoslavice Vrchoslavice"
  },
  {
    "cast": "Vrchotice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Vrchotice"
  },
  {
    "cast": "Vrchotovy Janovice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Vrchotovy Janovice",
    "val": "25753 Vrchotovy Janovice Vrchotovy Janovice"
  },
  {
    "cast": "Vrchovany",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Vrchovany",
    "val": "47201 Vrchovany Vrchovany"
  },
  {
    "cast": "Vrchovina",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Sychrov",
    "val": "46344 Sychrov Vrchovina"
  },
  {
    "cast": "Vrchovina",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Vrchovina"
  },
  {
    "cast": "Vrchoviny",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Nové Město nad Metují",
    "val": "54901 Nove Mesto nad Metuji Vrchoviny"
  },
  {
    "cast": "Vrchovnice",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Vrchovnice",
    "val": "50303 Vrchovnice Vrchovnice"
  },
  {
    "cast": "Vrchy",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Vrchy"
  },
  {
    "cast": "Vrchy",
    "psc": "74245",
    "okres": "Nový Jičín",
    "obec": "Vrchy",
    "val": "74245 Vrchy Vrchy"
  },
  {
    "cast": "Vrkoslavice",
    "psc": "46606",
    "okres": "Jablonec nad Nisou",
    "obec": "Jablonec nad Nisou",
    "val": "46606 Jablonec nad Nisou Vrkoslavice"
  },
  {
    "cast": "Vroutek",
    "psc": "43982",
    "okres": "Louny",
    "obec": "Vroutek",
    "val": "43982 Vroutek Vroutek"
  },
  {
    "cast": "Vrskmaň (část)",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Vrskmaň",
    "val": "43111 Vrskman Vrskman (cast)"
  },
  {
    "cast": "Vrskmaň (část)",
    "psc": "43115",
    "okres": "Chomutov",
    "obec": "Vrskmaň",
    "val": "43115 Vrskman Vrskman (cast)"
  },
  {
    "cast": "Vršce",
    "psc": "50733",
    "okres": "Jičín",
    "obec": "Vršce",
    "val": "50733 Vrsce Vrsce"
  },
  {
    "cast": "Vršek",
    "psc": "36251",
    "okres": "Karlovy Vary",
    "obec": "Jáchymov",
    "val": "36251 Jachymov Vrsek"
  },
  {
    "cast": "Vršice",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Zásmuky",
    "val": "28144 Zasmuky Vrsice"
  },
  {
    "cast": "Vršov",
    "psc": "53825",
    "okres": "Chrudim",
    "obec": "Horní Bradlo",
    "val": "53825 Horni Bradlo Vrsov"
  },
  {
    "cast": "Vršovice",
    "psc": "74761",
    "okres": "Opava",
    "obec": "Vršovice",
    "val": "74761 Vrsovice Vrsovice"
  },
  {
    "cast": "Vršovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Vršovice",
    "val": "44001 Vrsovice Vrsovice"
  },
  {
    "cast": "Vršovice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Jesenice",
    "val": "26401 Jesenice Vrsovice"
  },
  {
    "cast": "Vršovice (část)",
    "psc": "14000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14000 Praha Vrsovice (cast)"
  },
  {
    "cast": "Vršovice (část)",
    "psc": "10000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10000 Praha Vrsovice (cast)"
  },
  {
    "cast": "Vršovice (část)",
    "psc": "10100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10100 Praha Vrsovice (cast)"
  },
  {
    "cast": "Vršovka",
    "psc": "54901",
    "okres": "Náchod",
    "obec": "Vršovka",
    "val": "54901 Vrsovka Vrsovka"
  },
  {
    "cast": "Vrtěšice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Golčův Jeníkov",
    "val": "58282 Golcuv Jenikov Vrtesice"
  },
  {
    "cast": "Vrtěžíř",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Štěpánov nad Svratkou",
    "val": "59301 Stepanov nad Svratkou Vrtezir"
  },
  {
    "cast": "Vrtky",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Vrtky"
  },
  {
    "cast": "Vrutice",
    "psc": "41147",
    "okres": "Litoměřice",
    "obec": "Vrutice",
    "val": "41147 Vrutice Vrutice"
  },
  {
    "cast": "Vržanov",
    "psc": "58822",
    "okres": "Jihlava",
    "obec": "Kamenice",
    "val": "58822 Kamenice Vrzanov"
  },
  {
    "cast": "Vřesce",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Ratibořské Hory",
    "val": "39143 Ratiborske Hory Vresce"
  },
  {
    "cast": "Vřesice (část)",
    "psc": "67962",
    "okres": "Blansko",
    "obec": "Sulíkov",
    "val": "67962 Sulikov Vresice (cast)"
  },
  {
    "cast": "Vřesice (část)",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Sulíkov",
    "val": "67961 Sulikov Vresice (cast)"
  },
  {
    "cast": "Vřesina",
    "psc": "74720",
    "okres": "Opava",
    "obec": "Vřesina",
    "val": "74720 Vresina Vresina"
  },
  {
    "cast": "Vřesina",
    "psc": "74285",
    "okres": "Ostrava-město",
    "obec": "Vřesina",
    "val": "74285 Vresina Vresina"
  },
  {
    "cast": "Vřeskovice",
    "psc": "33401",
    "okres": "Klatovy",
    "obec": "Vřeskovice",
    "val": "33401 Vreskovice Vreskovice"
  },
  {
    "cast": "Vřesník",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Vřesník",
    "val": "50771 Vresnik Vresnik"
  },
  {
    "cast": "Vřesník",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Želiv",
    "val": "39601 Zeliv Vresnik"
  },
  {
    "cast": "Vřesová",
    "psc": "35735",
    "okres": "Sokolov",
    "obec": "Vřesová",
    "val": "35735 Vresova Vresova"
  },
  {
    "cast": "Vřesovice",
    "psc": "69648",
    "okres": "Hodonín",
    "obec": "Vřesovice",
    "val": "69648 Vresovice Vresovice"
  },
  {
    "cast": "Vřesovice",
    "psc": "79809",
    "okres": "Prostějov",
    "obec": "Vřesovice",
    "val": "79809 Vresovice Vresovice"
  },
  {
    "cast": "Vříšť",
    "psc": "59203",
    "okres": "Žďár nad Sázavou",
    "obec": "Sněžné",
    "val": "59203 Snezne Vrist"
  },
  {
    "cast": "Vsetín",
    "psc": "75501",
    "okres": "Vsetín",
    "obec": "Vsetín",
    "val": "75501 Vsetin Vsetin"
  },
  {
    "cast": "Vsisko",
    "psc": "78372",
    "okres": "Olomouc",
    "obec": "Velký Týnec",
    "val": "78372 Velky Tynec Vsisko"
  },
  {
    "cast": "Vstiš",
    "psc": "33441",
    "okres": "Plzeň-jih",
    "obec": "Vstiš",
    "val": "33441 Vstis Vstis"
  },
  {
    "cast": "Všeborovice",
    "psc": "36263",
    "okres": "Karlovy Vary",
    "obec": "Dalovice",
    "val": "36263 Dalovice Vseborovice"
  },
  {
    "cast": "Všebořice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Loket",
    "val": "25768 Loket Vseborice"
  },
  {
    "cast": "Všebořice (část)",
    "psc": "40001",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40001 Usti nad Labem Vseborice (cast)"
  },
  {
    "cast": "Všebořice (část)",
    "psc": "40010",
    "okres": "Ústí nad Labem",
    "obec": "Ústí nad Labem",
    "val": "40010 Usti nad Labem Vseborice (cast)"
  },
  {
    "cast": "Všedobrovice",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Kamenice",
    "val": "25168 Kamenice Vsedobrovice"
  },
  {
    "cast": "Všehrdy",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Všehrdy",
    "val": "43001 Vsehrdy Vsehrdy"
  },
  {
    "cast": "Všehrdy",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Všehrdy",
    "val": "33141 Vsehrdy Vsehrdy"
  },
  {
    "cast": "Všechlapy",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Malšice",
    "val": "39175 Malsice Vsechlapy"
  },
  {
    "cast": "Všechlapy",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Vsechlapy"
  },
  {
    "cast": "Všechlapy",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Všechlapy",
    "val": "25726 Vsechlapy Vsechlapy"
  },
  {
    "cast": "Všechlapy",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Všechlapy",
    "val": "28802 Vsechlapy Vsechlapy"
  },
  {
    "cast": "Všechlapy",
    "psc": "41771",
    "okres": "Teplice",
    "obec": "Zabrušany",
    "val": "41771 Zabrusany Vsechlapy"
  },
  {
    "cast": "Všechlapy",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Předslavice",
    "val": "38701 Predslavice Vsechlapy"
  },
  {
    "cast": "Všechov",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39131 Tabor Vsechov"
  },
  {
    "cast": "Všechovice",
    "psc": "75353",
    "okres": "Přerov",
    "obec": "Všechovice",
    "val": "75353 Vsechovice Vsechovice"
  },
  {
    "cast": "Všechovice (část)",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Všechovice",
    "val": "66601 Vsechovice Vsechovice (cast)"
  },
  {
    "cast": "Všechovice (část)",
    "psc": "66603",
    "okres": "Brno-venkov",
    "obec": "Všechovice",
    "val": "66603 Vsechovice Vsechovice (cast)"
  },
  {
    "cast": "Všechromy",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Strančice",
    "val": "25163 Strancice Vsechromy"
  },
  {
    "cast": "Všejany",
    "psc": "29443",
    "okres": "Mladá Boleslav",
    "obec": "Všejany",
    "val": "29443 Vsejany Vsejany"
  },
  {
    "cast": "Všekary",
    "psc": "34562",
    "okres": "Domažlice",
    "obec": "Všekary",
    "val": "34562 Vsekary Vsekary"
  },
  {
    "cast": "Všelibice",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Všelibice",
    "val": "46348 Vselibice Vselibice"
  },
  {
    "cast": "Všeliby",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Samšina",
    "val": "50601 Samsina Vseliby"
  },
  {
    "cast": "Všeliby",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Studnice",
    "val": "54701 Studnice Vseliby"
  },
  {
    "cast": "Všeměry",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přídolí",
    "val": "38101 Pridoli Vsemery"
  },
  {
    "cast": "Všeměřice",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Dolní Dvořiště",
    "val": "38241 Dolni Dvoriste Vsemerice"
  },
  {
    "cast": "Všemily",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Jetřichovice",
    "val": "40502 Jetrichovice Vsemily"
  },
  {
    "cast": "Všemina",
    "psc": "76315",
    "okres": "Zlín",
    "obec": "Všemina",
    "val": "76315 Vsemina Vsemina"
  },
  {
    "cast": "Všemyslice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Všemyslice",
    "val": "37501 Vsemyslice Vsemyslice"
  },
  {
    "cast": "Všeň (část)",
    "psc": "51265",
    "okres": "Semily",
    "obec": "Všeň",
    "val": "51265 Vsen Vsen (cast)"
  },
  {
    "cast": "Všeň (část)",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Všeň",
    "val": "51101 Vsen Vsen (cast)"
  },
  {
    "cast": "Všenice",
    "psc": "33824",
    "okres": "Rokycany",
    "obec": "Všenice",
    "val": "33824 Vsenice Vsenice"
  },
  {
    "cast": "Všenory",
    "psc": "25231",
    "okres": "Praha-západ",
    "obec": "Všenory",
    "val": "25231 Vsenory Vsenory"
  },
  {
    "cast": "Všepadly",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Všepadly",
    "val": "34543 Vsepadly Vsepadly"
  },
  {
    "cast": "Všeradice",
    "psc": "26726",
    "okres": "Beroun",
    "obec": "Všeradice",
    "val": "26726 Vseradice Vseradice"
  },
  {
    "cast": "Všeradov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Všeradov",
    "val": "53901 Vseradov Vseradov"
  },
  {
    "cast": "Všeruby",
    "psc": "34507",
    "okres": "Domažlice",
    "obec": "Všeruby",
    "val": "34507 Vseruby Vseruby"
  },
  {
    "cast": "Všeruby",
    "psc": "33016",
    "okres": "Plzeň-sever",
    "obec": "Všeruby",
    "val": "33016 Vseruby Vseruby"
  },
  {
    "cast": "Všesoky",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28401 Chlistovice Vsesoky"
  },
  {
    "cast": "Všestary",
    "psc": "50312",
    "okres": "Hradec Králové",
    "obec": "Všestary",
    "val": "50312 Vsestary Vsestary"
  },
  {
    "cast": "Všestary (část)",
    "psc": "25163",
    "okres": "Praha-východ",
    "obec": "Všestary",
    "val": "25163 Vsestary Vsestary (cast)"
  },
  {
    "cast": "Všestary (část)",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Všestary",
    "val": "25164 Vsestary Vsestary (cast)"
  },
  {
    "cast": "Všestudy",
    "psc": "27746",
    "okres": "Mělník",
    "obec": "Všestudy",
    "val": "27746 Vsestudy Vsestudy"
  },
  {
    "cast": "Všestudy",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Všestudy",
    "val": "43111 Vsestudy Vsestudy"
  },
  {
    "cast": "Všesulov",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Všesulov",
    "val": "27034 Vsesulov Vsesulov"
  },
  {
    "cast": "Všešímy",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Kunice",
    "val": "25164 Kunice Vsesimy"
  },
  {
    "cast": "Všetaty",
    "psc": "27716",
    "okres": "Mělník",
    "obec": "Všetaty",
    "val": "27716 Vsetaty Vsetaty"
  },
  {
    "cast": "Všetaty",
    "psc": "27021",
    "okres": "Rakovník",
    "obec": "Všetaty",
    "val": "27021 Vsetaty Vsetaty"
  },
  {
    "cast": "Všeteč",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Všemyslice",
    "val": "37501 Vsemyslice Vsetec"
  },
  {
    "cast": "Všetice",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Netvořice",
    "val": "25744 Netvorice Vsetice"
  },
  {
    "cast": "Všetuly",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Holešov",
    "val": "76901 Holesov Vsetuly"
  },
  {
    "cast": "Vševily",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Vševily",
    "val": "26272 Vsevily Vsevily"
  },
  {
    "cast": "Vtelno",
    "psc": "43401",
    "okres": "Most",
    "obec": "Most",
    "val": "43401 Most Vtelno"
  },
  {
    "cast": "Vůsí",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Květov",
    "val": "39901 Kvetov Vusi"
  },
  {
    "cast": "Výčapy",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Výčapy",
    "val": "67401 Vycapy Vycapy"
  },
  {
    "cast": "Výčapy",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vlačice",
    "val": "28601 Vlacice Vycapy"
  },
  {
    "cast": "Vydří",
    "psc": "37802",
    "okres": "Jindřichův Hradec",
    "obec": "Vydří",
    "val": "37802 Vydri Vydri"
  },
  {
    "cast": "Vydří Most",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Kvilda",
    "val": "38501 Kvilda Vydri Most"
  },
  {
    "cast": "Výheň",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Netřebice",
    "val": "38232 Netrebice Vyhen"
  },
  {
    "cast": "Výhled",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Chvalkovice",
    "val": "55204 Chvalkovice Vyhled"
  },
  {
    "cast": "Výhledy",
    "psc": "35201",
    "okres": "Cheb",
    "obec": "Hazlov",
    "val": "35201 Hazlov Vyhledy"
  },
  {
    "cast": "Vyhlídky",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Horní Stropnice",
    "val": "37401 Horni Stropnice Vyhlidky"
  },
  {
    "cast": "Vyhnanice",
    "psc": "39175",
    "okres": "Tábor",
    "obec": "Hlavatce",
    "val": "39175 Hlavatce Vyhnanice"
  },
  {
    "cast": "Vyhnanice",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Voděrady",
    "val": "51721 Voderady Vyhnanice"
  },
  {
    "cast": "Vyhnánov",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Včelákov",
    "val": "53901 Vcelakov Vyhnanov"
  },
  {
    "cast": "Vyhnánov",
    "psc": "51742",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Doudleby nad Orlicí",
    "val": "51742 Doudleby nad Orlici Vyhnanov"
  },
  {
    "cast": "Východní Předměstí (část)",
    "psc": "30100",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "30100 Plzen Vychodni Predmesti (cast)"
  },
  {
    "cast": "Východní Předměstí (část)",
    "psc": "32600",
    "okres": "Plzeň-město",
    "obec": "Plzeň",
    "val": "32600 Plzen Vychodni Predmesti (cast)"
  },
  {
    "cast": "Vykáň",
    "psc": "28915",
    "okres": "Nymburk",
    "obec": "Vykáň",
    "val": "28915 Vykan Vykan"
  },
  {
    "cast": "Výkleky",
    "psc": "75125",
    "okres": "Přerov",
    "obec": "Výkleky",
    "val": "75125 Vykleky Vykleky"
  },
  {
    "cast": "Vykmanov",
    "psc": "36301",
    "okres": "Karlovy Vary",
    "obec": "Ostrov",
    "val": "36301 Ostrov Vykmanov"
  },
  {
    "cast": "Vykmanov",
    "psc": "43151",
    "okres": "Chomutov",
    "obec": "Perštejn",
    "val": "43151 Perstejn Vykmanov"
  },
  {
    "cast": "Výnězda",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Omlenice",
    "val": "38241 Omlenice Vynezda"
  },
  {
    "cast": "Výprachtice (část)",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Výprachtice",
    "val": "56301 Vyprachtice Vyprachtice (cast)"
  },
  {
    "cast": "Výprachtice (část)",
    "psc": "56134",
    "okres": "Ústí nad Orlicí",
    "obec": "Výprachtice",
    "val": "56134 Vyprachtice Vyprachtice (cast)"
  },
  {
    "cast": "Výrava",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Výrava",
    "val": "50303 Vyrava Vyrava"
  },
  {
    "cast": "Výrov",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Dolany",
    "val": "33901 Dolany Vyrov"
  },
  {
    "cast": "Výrov",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Výrov",
    "val": "33141 Vyrov Vyrov"
  },
  {
    "cast": "Výrov",
    "psc": "34601",
    "okres": "Domažlice",
    "obec": "Blížejov",
    "val": "34601 Blizejov Vyrov"
  },
  {
    "cast": "Výrov (část)",
    "psc": "38421",
    "okres": "Prachatice",
    "obec": "Husinec",
    "val": "38421 Husinec Vyrov (cast)"
  },
  {
    "cast": "Výrov (část)",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Husinec",
    "val": "38301 Husinec Vyrov (cast)"
  },
  {
    "cast": "Výrovice",
    "psc": "67134",
    "okres": "Znojmo",
    "obec": "Výrovice",
    "val": "67134 Vyrovice Vyrovice"
  },
  {
    "cast": "Výsada",
    "psc": "43191",
    "okres": "Chomutov",
    "obec": "Vejprty",
    "val": "43191 Vejprty Vysada"
  },
  {
    "cast": "Vyskeř (část)",
    "psc": "51264",
    "okres": "Semily",
    "obec": "Vyskeř",
    "val": "51264 Vysker Vysker (cast)"
  },
  {
    "cast": "Vyskeř (část)",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Vyskeř",
    "val": "51101 Vysker Vysker (cast)"
  },
  {
    "cast": "Vyskytná nad Jihlavou",
    "psc": "58841",
    "okres": "Jihlava",
    "obec": "Vyskytná nad Jihlavou",
    "val": "58841 Vyskytna nad Jihlavou Vyskytna nad Jihlavou"
  },
  {
    "cast": "Vyskytná (část)",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Vyskytná",
    "val": "39301 Vyskytna Vyskytna (cast)"
  },
  {
    "cast": "Vyskytná (část)",
    "psc": "39405",
    "okres": "Pelhřimov",
    "obec": "Vyskytná",
    "val": "39405 Vyskytna Vyskytna (cast)"
  },
  {
    "cast": "Výsluní",
    "psc": "43183",
    "okres": "Chomutov",
    "obec": "Výsluní",
    "val": "43183 Vysluni Vysluni"
  },
  {
    "cast": "Vysočany",
    "psc": "34802",
    "okres": "Tachov",
    "obec": "Bor",
    "val": "34802 Bor Vysocany"
  },
  {
    "cast": "Vysočany",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Vysocany"
  },
  {
    "cast": "Vysočany",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Vysočany",
    "val": "67107 Vysocany Vysocany"
  },
  {
    "cast": "Vysočany",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Nový Bydžov",
    "val": "50401 Novy Bydzov Vysocany"
  },
  {
    "cast": "Vysočany",
    "psc": "43143",
    "okres": "Chomutov",
    "obec": "Hrušovany",
    "val": "43143 Hrusovany Vysocany"
  },
  {
    "cast": "Vysočany (část)",
    "psc": "13000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "13000 Praha Vysocany (cast)"
  },
  {
    "cast": "Vysočany (část)",
    "psc": "19000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19000 Praha Vysocany (cast)"
  },
  {
    "cast": "Vysočany (část)",
    "psc": "19800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "19800 Praha Vysocany (cast)"
  },
  {
    "cast": "Vysočina-Dřevíkov x)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Vysocina-Drevikov x)"
  },
  {
    "cast": "Vysočina-Možděnice x)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Vysocina-Mozdenice x)"
  },
  {
    "cast": "Vysočina-Petrkov x)",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Bojanov",
    "val": "53807 Bojanov Vysocina-Petrkov x)"
  },
  {
    "cast": "Vysočina-Rváčov x)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Vysocina-Rvacov x)"
  },
  {
    "cast": "Vysočina-Svatý Mikuláš x)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Vysocina-Svaty Mikulas x)"
  },
  {
    "cast": "Vysočina-Svobodné Hamry x)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Vysocina-Svobodne Hamry x)"
  },
  {
    "cast": "Vysočina-Veselý Kopec x)",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Vysočina",
    "val": "53901 Vysocina Vysocina-Vesely Kopec x)"
  },
  {
    "cast": "Vysoká",
    "psc": "75641",
    "okres": "Vsetín",
    "obec": "Lešná",
    "val": "75641 Lesna Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Stará Voda",
    "val": "35002 Stara Voda Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "43102",
    "okres": "Chomutov",
    "obec": "Málkov",
    "val": "43102 Malkov Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Vysoká",
    "val": "56943 Vysoka Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "79399",
    "okres": "Bruntál",
    "obec": "Vysoká",
    "val": "79399 Vysoka Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "46331",
    "okres": "Liberec",
    "obec": "Chrastava",
    "val": "46331 Chrastava Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Kosova Hora",
    "val": "26401 Kosova Hora Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "36263",
    "okres": "Karlovy Vary",
    "obec": "Dalovice",
    "val": "36263 Dalovice Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Suchdol",
    "val": "28401 Suchdol Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Javorník",
    "val": "56601 Javornik Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Vysoká",
    "val": "58001 Vysoka Vysoka"
  },
  {
    "cast": "Vysoká",
    "psc": "75366",
    "okres": "Přerov",
    "obec": "Hustopeče nad Bečvou",
    "val": "75366 Hustopece nad Becvou Vysoka"
  },
  {
    "cast": "Vysoká Jedle",
    "psc": "43158",
    "okres": "Chomutov",
    "obec": "Místo",
    "val": "43158 Misto Vysoka Jedle"
  },
  {
    "cast": "Vysoká Lhota",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Čerčany",
    "val": "25722 Cercany Vysoka Lhota"
  },
  {
    "cast": "Vysoká Lhota",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Vysoká Lhota",
    "val": "39501 Vysoka Lhota Vysoka Lhota"
  },
  {
    "cast": "Vysoká Libeň",
    "psc": "27738",
    "okres": "Mělník",
    "obec": "Mělnické Vtelno",
    "val": "27738 Melnicke Vtelno Vysoka Liben"
  },
  {
    "cast": "Vysoká Libyně",
    "psc": "33141",
    "okres": "Plzeň-sever",
    "obec": "Vysoká Libyně",
    "val": "33141 Vysoka Libyne Vysoka Libyne"
  },
  {
    "cast": "Vysoká Lípa",
    "psc": "40502",
    "okres": "Děčín",
    "obec": "Jetřichovice",
    "val": "40502 Jetrichovice Vysoka Lipa"
  },
  {
    "cast": "Vysoká nad Labem",
    "psc": "50331",
    "okres": "Hradec Králové",
    "obec": "Vysoká nad Labem",
    "val": "50331 Vysoka nad Labem Vysoka nad Labem"
  },
  {
    "cast": "Vysoká Pec",
    "psc": "26241",
    "okres": "Příbram",
    "obec": "Bohutín",
    "val": "26241 Bohutin Vysoka Pec"
  },
  {
    "cast": "Vysoká Pec",
    "psc": "43159",
    "okres": "Chomutov",
    "obec": "Vysoká Pec",
    "val": "43159 Vysoka Pec Vysoka Pec"
  },
  {
    "cast": "Vysoká Pec",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Vysoká Pec",
    "val": "36221 Vysoka Pec Vysoka Pec"
  },
  {
    "cast": "Vysoká Srbská (část)",
    "psc": "54937",
    "okres": "Náchod",
    "obec": "Vysoká Srbská",
    "val": "54937 Vysoka Srbska Vysoka Srbska (cast)"
  },
  {
    "cast": "Vysoká Srbská (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Vysoká Srbská",
    "val": "54931 Vysoka Srbska Vysoka Srbska (cast)"
  },
  {
    "cast": "Vysoká Štola",
    "psc": "36221",
    "okres": "Karlovy Vary",
    "obec": "Nejdek",
    "val": "36221 Nejdek Vysoka Stola"
  },
  {
    "cast": "Vysoká u Holic",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Ostřetín",
    "val": "53401 Ostretin Vysoka u Holic"
  },
  {
    "cast": "Vysoká u Příbramě",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Vysoká u Příbramě",
    "val": "26242 Vysoka u Pribrame Vysoka u Pribrame"
  },
  {
    "cast": "Vysoká (část)",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Vysoká",
    "val": "27721 Vysoka Vysoka (cast)"
  },
  {
    "cast": "Vysoká (část)",
    "psc": "27724",
    "okres": "Mělník",
    "obec": "Vysoká",
    "val": "27724 Vysoka Vysoka (cast)"
  },
  {
    "cast": "Vysoké",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Vysoké",
    "val": "59101 Vysoke Vysoke"
  },
  {
    "cast": "Vysoké Březno",
    "psc": "43401",
    "okres": "Most",
    "obec": "Malé Březno",
    "val": "43401 Male Brezno Vysoke Brezno"
  },
  {
    "cast": "Vysoké Chvojno",
    "psc": "53321",
    "okres": "Pardubice",
    "obec": "Vysoké Chvojno",
    "val": "53321 Vysoke Chvojno Vysoke Chvojno"
  },
  {
    "cast": "Vysoké Jamné",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Lestkov",
    "val": "34953 Lestkov Vysoke Jamne"
  },
  {
    "cast": "Vysoké Mýto-Město",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Vysoké Mýto",
    "val": "56601 Vysoke Myto Vysoke Myto-Mesto"
  },
  {
    "cast": "Vysoké nad Jizerou",
    "psc": "51211",
    "okres": "Semily",
    "obec": "Vysoké nad Jizerou",
    "val": "51211 Vysoke nad Jizerou Vysoke nad Jizerou"
  },
  {
    "cast": "Vysoké Pole",
    "psc": "76325",
    "okres": "Zlín",
    "obec": "Vysoké Pole",
    "val": "76325 Vysoke Pole Vysoke Pole"
  },
  {
    "cast": "Vysoké Popovice",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Vysoké Popovice",
    "val": "66484 Vysoke Popovice Vysoke Popovice"
  },
  {
    "cast": "Vysoké Sedliště",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Vysoke Sedliste"
  },
  {
    "cast": "Vysoké Studnice",
    "psc": "58821",
    "okres": "Jihlava",
    "obec": "Vysoké Studnice",
    "val": "58821 Vysoke Studnice Vysoke Studnice"
  },
  {
    "cast": "Vysoké Třebušice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Krásný Dvůr",
    "val": "44101 Krasny Dvur Vysoke Trebusice"
  },
  {
    "cast": "Vysoké Veselí",
    "psc": "50703",
    "okres": "Jičín",
    "obec": "Vysoké Veselí",
    "val": "50703 Vysoke Veseli Vysoke Veseli"
  },
  {
    "cast": "Vysoké Žibřidovice",
    "psc": "78832",
    "okres": "Šumperk",
    "obec": "Hanušovice",
    "val": "78832 Hanusovice Vysoke Zibridovice"
  },
  {
    "cast": "Vysokov (část)",
    "psc": "54701",
    "okres": "Náchod",
    "obec": "Vysokov",
    "val": "54701 Vysokov Vysokov (cast)"
  },
  {
    "cast": "Vysokov (část)",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Vysokov",
    "val": "55203 Vysokov Vysokov (cast)"
  },
  {
    "cast": "Vysokov (část)",
    "psc": "54912",
    "okres": "Náchod",
    "obec": "Vysokov",
    "val": "54912 Vysokov Vysokov (cast)"
  },
  {
    "cast": "Vysoký Chlumec",
    "psc": "26252",
    "okres": "Příbram",
    "obec": "Vysoký Chlumec",
    "val": "26252 Vysoky Chlumec Vysoky Chlumec"
  },
  {
    "cast": "Vysoký Les",
    "psc": "57201",
    "okres": "Svitavy",
    "obec": "Sebranice",
    "val": "57201 Sebranice Vysoky Les"
  },
  {
    "cast": "Vysoký Potok",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Vysoky Potok"
  },
  {
    "cast": "Vysoký Újezd",
    "psc": "25744",
    "okres": "Benešov",
    "obec": "Vysoký Újezd",
    "val": "25744 Vysoky Ujezd Vysoky Ujezd"
  },
  {
    "cast": "Vysoký Újezd",
    "psc": "26716",
    "okres": "Beroun",
    "obec": "Vysoký Újezd",
    "val": "26716 Vysoky Ujezd Vysoky Ujezd"
  },
  {
    "cast": "Vysoký Újezd",
    "psc": "51771",
    "okres": "Hradec Králové",
    "obec": "Vysoký Újezd",
    "val": "51771 Vysoky Ujezd Vysoky Ujezd"
  },
  {
    "cast": "Výsonín",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Lukavice",
    "val": "53821 Lukavice Vysonin"
  },
  {
    "cast": "Vystrčenovice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Vystrčenovice",
    "val": "58856 Vystrcenovice Vystrcenovice"
  },
  {
    "cast": "Vystrkov",
    "psc": "46348",
    "okres": "Liberec",
    "obec": "Cetenov",
    "val": "46348 Cetenov Vystrkov"
  },
  {
    "cast": "Vystrkov",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Kozárovice",
    "val": "26272 Kozarovice Vystrkov"
  },
  {
    "cast": "Vystrkov",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Vystrkov",
    "val": "39601 Vystrkov Vystrkov"
  },
  {
    "cast": "Vyšehněvice",
    "psc": "53341",
    "okres": "Pardubice",
    "obec": "Vyšehněvice",
    "val": "53341 Vysehnevice Vysehnevice"
  },
  {
    "cast": "Vyšehorky",
    "psc": "78985",
    "okres": "Šumperk",
    "obec": "Líšnice",
    "val": "78985 Lisnice Vysehorky"
  },
  {
    "cast": "Vyšehoří",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Vyšehoří",
    "val": "78901 Vysehori Vysehori"
  },
  {
    "cast": "Vyšehořovice",
    "psc": "25087",
    "okres": "Praha-východ",
    "obec": "Vyšehořovice",
    "val": "25087 Vysehorovice Vysehorovice"
  },
  {
    "cast": "Vyšehrad (část)",
    "psc": "12000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "12000 Praha Vysehrad (cast)"
  },
  {
    "cast": "Vyšehrad (část)",
    "psc": "12800",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "12800 Praha Vysehrad (cast)"
  },
  {
    "cast": "Vyšetice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Vysetice"
  },
  {
    "cast": "Výšice",
    "psc": "38801",
    "okres": "Strakonice",
    "obec": "Myštice",
    "val": "38801 Mystice Vysice"
  },
  {
    "cast": "Vyšínek",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Zlonice",
    "val": "27371 Zlonice Vysinek"
  },
  {
    "cast": "Výšinka",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Hajnice",
    "val": "54401 Hajnice Vysinka"
  },
  {
    "cast": "Výškov",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Výškov",
    "val": "44001 Vyskov Vyskov"
  },
  {
    "cast": "Výškov",
    "psc": "34813",
    "okres": "Tachov",
    "obec": "Chodová Planá",
    "val": "34813 Chodova Plana Vyskov"
  },
  {
    "cast": "Vyškovec",
    "psc": "68774",
    "okres": "Uherské Hradiště",
    "obec": "Vyškovec",
    "val": "68774 Vyskovec Vyskovec"
  },
  {
    "cast": "Výškovice",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Vimperk",
    "val": "38501 Vimperk Vyskovice"
  },
  {
    "cast": "Výškovice",
    "psc": "74301",
    "okres": "Nový Jičín",
    "obec": "Bílovec",
    "val": "74301 Bilovec Vyskovice"
  },
  {
    "cast": "Výškovice",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Vyskovice"
  },
  {
    "cast": "Vyškov-Město",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Vyskov-Mesto"
  },
  {
    "cast": "Vyškov-Předměstí",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Vyskov-Predmesti"
  },
  {
    "cast": "Vyšné",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Nové Hrady",
    "val": "37401 Nove Hrady Vysne"
  },
  {
    "cast": "Vyšní Lhoty",
    "psc": "73951",
    "okres": "Frýdek-Místek",
    "obec": "Vyšní Lhoty",
    "val": "73951 Vysni Lhoty Vysni Lhoty"
  },
  {
    "cast": "Vyšný",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Český Krumlov",
    "val": "38101 Cesky Krumlov Vysny"
  },
  {
    "cast": "Vyšovatka",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Buk",
    "val": "38301 Buk Vysovatka"
  },
  {
    "cast": "Výšovice",
    "psc": "79809",
    "okres": "Prostějov",
    "obec": "Výšovice",
    "val": "79809 Vysovice Vysovice"
  },
  {
    "cast": "Vyšší Brod",
    "psc": "38273",
    "okres": "Český Krumlov",
    "obec": "Vyšší Brod",
    "val": "38273 Vyssi Brod Vyssi Brod"
  },
  {
    "cast": "Výžerky",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Výžerky",
    "val": "28163 Vyzerky Vyzerky"
  },
  {
    "cast": "Vyžice",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Vyžice",
    "val": "53803 Vyzice Vyzice"
  },
  {
    "cast": "Vyžlovka",
    "psc": "28163",
    "okres": "Praha-východ",
    "obec": "Vyžlovka",
    "val": "28163 Vyzlovka Vyzlovka"
  },
  {
    "cast": "Xaverov",
    "psc": "28506",
    "okres": "Benešov",
    "obec": "Xaverov",
    "val": "28506 Xaverov Xaverov"
  },
  {
    "cast": "Za nemocnicí",
    "psc": "41201",
    "okres": "Litoměřice",
    "obec": "Litoměřice",
    "val": "41201 Litomerice Za nemocnici"
  },
  {
    "cast": "Zábědov",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Nový Bydžov",
    "val": "50401 Novy Bydzov Zabedov"
  },
  {
    "cast": "Záběhlice",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Řečice",
    "val": "39601 Recice Zabehlice"
  },
  {
    "cast": "Záběhlice",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Zabehlice"
  },
  {
    "cast": "Záběhlice (část)",
    "psc": "14100",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "14100 Praha Zabehlice (cast)"
  },
  {
    "cast": "Záběhlice (část)",
    "psc": "10200",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10200 Praha Zabehlice (cast)"
  },
  {
    "cast": "Záběhlice (část)",
    "psc": "10600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10600 Praha Zabehlice (cast)"
  },
  {
    "cast": "Zábeštní Lhota",
    "psc": "75127",
    "okres": "Přerov",
    "obec": "Zábeštní Lhota",
    "val": "75127 Zabestni Lhota Zabestni Lhota"
  },
  {
    "cast": "Záblatí",
    "psc": "73552",
    "okres": "Karviná",
    "obec": "Bohumín",
    "val": "73552 Bohumin Zablati"
  },
  {
    "cast": "Záblatí",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37348 Driten Zablati"
  },
  {
    "cast": "Záblatí",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Záblatí",
    "val": "37901 Zablati Zablati"
  },
  {
    "cast": "Záblatí",
    "psc": "38433",
    "okres": "Prachatice",
    "obec": "Záblatí",
    "val": "38433 Zablati Zablati"
  },
  {
    "cast": "Záblatí",
    "psc": "59453",
    "okres": "Žďár nad Sázavou",
    "obec": "Záblatí",
    "val": "59453 Zablati Zablati"
  },
  {
    "cast": "Záblatíčko",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dříteň",
    "val": "37348 Driten Zablaticko"
  },
  {
    "cast": "Zábludov",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Zabludov"
  },
  {
    "cast": "Záborčí",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Zaborci"
  },
  {
    "cast": "Záborná",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Záborná",
    "val": "58813 Zaborna Zaborna"
  },
  {
    "cast": "Záborná Lhota",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Zaborna Lhota"
  },
  {
    "cast": "Záborov",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Lanžov",
    "val": "54401 Lanzov Zaborov"
  },
  {
    "cast": "Záboří",
    "psc": "27741",
    "okres": "Mělník",
    "obec": "Kly",
    "val": "27741 Kly Zabori"
  },
  {
    "cast": "Záboří",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Protivín",
    "val": "39811 Protivin Zabori"
  },
  {
    "cast": "Záboří",
    "psc": "37384",
    "okres": "České Budějovice",
    "obec": "Záboří",
    "val": "37384 Zabori Zabori"
  },
  {
    "cast": "Záboří",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Proseč",
    "val": "53944 Prosec Zabori"
  },
  {
    "cast": "Záboří",
    "psc": "38734",
    "okres": "Strakonice",
    "obec": "Záboří",
    "val": "38734 Zabori Zabori"
  },
  {
    "cast": "Záboří",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Vítězná",
    "val": "54401 Vitezna Zabori"
  },
  {
    "cast": "Záboří nad Labem",
    "psc": "28574",
    "okres": "Kutná Hora",
    "obec": "Záboří nad Labem",
    "val": "28574 Zabori nad Labem Zabori nad Labem"
  },
  {
    "cast": "Zábrdí",
    "psc": "46352",
    "okres": "Liberec",
    "obec": "Osečná",
    "val": "46352 Osecna Zabrdi"
  },
  {
    "cast": "Zábrdí",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Zábrdí",
    "val": "38301 Zabrdi Zabrdi"
  },
  {
    "cast": "Zábrdovice",
    "psc": "28933",
    "okres": "Nymburk",
    "obec": "Křinec",
    "val": "28933 Krinec Zabrdovice"
  },
  {
    "cast": "Zábrdovice (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Zabrdovice (cast)"
  },
  {
    "cast": "Zábrdovice (část)",
    "psc": "61300",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61300 Brno Zabrdovice (cast)"
  },
  {
    "cast": "Zábrdovice (část)",
    "psc": "61400",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61400 Brno Zabrdovice (cast)"
  },
  {
    "cast": "Zábrdovice (část)",
    "psc": "61500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61500 Brno Zabrdovice (cast)"
  },
  {
    "cast": "Zábrodí",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Zábrodí",
    "val": "54941 Zabrodi Zabrodi"
  },
  {
    "cast": "Zabrušany",
    "psc": "41771",
    "okres": "Teplice",
    "obec": "Zabrušany",
    "val": "41771 Zabrusany Zabrusany"
  },
  {
    "cast": "Zábřeh",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Zábřeh",
    "val": "78901 Zabreh Zabreh"
  },
  {
    "cast": "Zábřeh",
    "psc": "74722",
    "okres": "Opava",
    "obec": "Dolní Benešov",
    "val": "74722 Dolni Benesov Zabreh"
  },
  {
    "cast": "Zábřeh (část)",
    "psc": "70900",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70900 Ostrava Zabreh (cast)"
  },
  {
    "cast": "Zábřeh (část)",
    "psc": "70030",
    "okres": "Ostrava-město",
    "obec": "Ostrava",
    "val": "70030 Ostrava Zabreh (cast)"
  },
  {
    "cast": "Zábřezí",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Zábřezí-Řečice",
    "val": "54401 Zabrezi-Recice Zabrezi"
  },
  {
    "cast": "Zadky",
    "psc": "74774",
    "okres": "Opava",
    "obec": "Neplachovice",
    "val": "74774 Neplachovice Zadky"
  },
  {
    "cast": "Zadní",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Červené Janovice",
    "val": "28601 Cervene Janovice Zadni"
  },
  {
    "cast": "Zadní Arnoštov",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Jevíčko",
    "val": "56943 Jevicko Zadni Arnostov"
  },
  {
    "cast": "Zadní Chlum (část)",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Klučenice",
    "val": "26263 Klucenice Zadni Chlum (cast)"
  },
  {
    "cast": "Zadní Chlum (část)",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Klučenice",
    "val": "26256 Klucenice Zadni Chlum (cast)"
  },
  {
    "cast": "Zadní Chodov",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Zadní Chodov",
    "val": "34815 Zadni Chodov Zadni Chodov"
  },
  {
    "cast": "Zadní Kopanina",
    "psc": "15500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15500 Praha Zadni Kopanina"
  },
  {
    "cast": "Zadní Lomná",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Pojbuky",
    "val": "39143 Pojbuky Zadni Lomna"
  },
  {
    "cast": "Zadní Milíře",
    "psc": "34701",
    "okres": "Tachov",
    "obec": "Milíře",
    "val": "34701 Milire Zadni Milire"
  },
  {
    "cast": "Zadní Mostek",
    "psc": "54475",
    "okres": "Trutnov",
    "obec": "Mostek",
    "val": "54475 Mostek Zadni Mostek"
  },
  {
    "cast": "Zadní Poříčí",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Březnice",
    "val": "26272 Breznice Zadni Porici"
  },
  {
    "cast": "Zadní Ptákovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Nebřehovice",
    "val": "38601 Nebrehovice Zadni Ptakovice"
  },
  {
    "cast": "Zadní Střítež",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Zadní Střítež",
    "val": "39143 Zadni Stritez Zadni Stritez"
  },
  {
    "cast": "Zadní Třebaň",
    "psc": "26729",
    "okres": "Beroun",
    "obec": "Zadní Třebaň",
    "val": "26729 Zadni Treban Zadni Treban"
  },
  {
    "cast": "Zadní Újezd",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Medlov",
    "val": "78391 Medlov Zadni Ujezd"
  },
  {
    "cast": "Zadní Ves",
    "psc": "79326",
    "okres": "Bruntál",
    "obec": "Karlovice",
    "val": "79326 Karlovice Zadni Ves"
  },
  {
    "cast": "Zadní Vydří",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Zadní Vydří",
    "val": "58856 Zadni Vydri Zadni Vydri"
  },
  {
    "cast": "Zadní Zborovice",
    "psc": "38601",
    "okres": "Strakonice",
    "obec": "Třebohostice",
    "val": "38601 Trebohostice Zadni Zborovice"
  },
  {
    "cast": "Zadní Zhořec",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Zadní Zhořec",
    "val": "59444 Zadni Zhorec Zadni Zhorec"
  },
  {
    "cast": "Zádolí",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Zadoli"
  },
  {
    "cast": "Zádolí",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Trnov",
    "val": "51801 Trnov Zadoli"
  },
  {
    "cast": "Zádolí",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Zádolí",
    "val": "56601 Zadoli Zadoli"
  },
  {
    "cast": "Zadražany",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Nepolisy",
    "val": "50351 Nepolisy Zadrazany"
  },
  {
    "cast": "Zádub",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Olbramov",
    "val": "34901 Olbramov Zadub"
  },
  {
    "cast": "Zádub",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Zádub-Závišín",
    "val": "35301 Zadub-Zavisin Zadub"
  },
  {
    "cast": "Zádveřice",
    "psc": "76312",
    "okres": "Zlín",
    "obec": "Zádveřice-Raková",
    "val": "76312 Zadverice-Rakova Zadverice"
  },
  {
    "cast": "Zaháj",
    "psc": "56601",
    "okres": "Ústí nad Orlicí",
    "obec": "Tisová",
    "val": "56601 Tisova Zahaj"
  },
  {
    "cast": "Zahájí",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Zahaji"
  },
  {
    "cast": "Zahájí",
    "psc": "27737",
    "okres": "Mělník",
    "obec": "Chorušice",
    "val": "27737 Chorusice Zahaji"
  },
  {
    "cast": "Zahájí",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Zahájí",
    "val": "37348 Zahaji Zahaji"
  },
  {
    "cast": "Zahájí",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Hněvkovice",
    "val": "58401 Hnevkovice Zahaji"
  },
  {
    "cast": "Záhlinice",
    "psc": "76824",
    "okres": "Kroměříž",
    "obec": "Hulín",
    "val": "76824 Hulin Zahlinice"
  },
  {
    "cast": "Zahnašovice",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Zahnašovice",
    "val": "76901 Zahnasovice Zahnasovice"
  },
  {
    "cast": "Zahorčice",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Lnáře",
    "val": "38742 Lnare Zahorcice"
  },
  {
    "cast": "Zahorčice",
    "psc": "38719",
    "okres": "Strakonice",
    "obec": "Zahorčice",
    "val": "38719 Zahorcice Zahorcice"
  },
  {
    "cast": "Zahorčice",
    "psc": "34021",
    "okres": "Klatovy",
    "obec": "Strážov",
    "val": "34021 Strazov Zahorcice"
  },
  {
    "cast": "Zahorčice",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Boršov nad Vltavou",
    "val": "37001 Borsov nad Vltavou Zahorcice"
  },
  {
    "cast": "Zahorčičky",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Hradiště",
    "val": "33544 Hradiste Zahorcicky"
  },
  {
    "cast": "Záhorkovice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mojné",
    "val": "38232 Mojne Zahorkovice"
  },
  {
    "cast": "Záhornice",
    "psc": "28903",
    "okres": "Nymburk",
    "obec": "Záhornice",
    "val": "28903 Zahornice Zahornice"
  },
  {
    "cast": "Záhornice",
    "psc": "51732",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Trnov",
    "val": "51732 Trnov Zahornice"
  },
  {
    "cast": "Záhorovice",
    "psc": "68771",
    "okres": "Uherské Hradiště",
    "obec": "Záhorovice",
    "val": "68771 Zahorovice Zahorovice"
  },
  {
    "cast": "Záhory",
    "psc": "51761",
    "okres": "Ústí nad Orlicí",
    "obec": "Kunvald",
    "val": "51761 Kunvald Zahory"
  },
  {
    "cast": "Zahořánky",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přídolí",
    "val": "38101 Pridoli Zahoranky"
  },
  {
    "cast": "Zahořany",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Zahorany"
  },
  {
    "cast": "Zahořany",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Vilémov",
    "val": "43201 Vilemov Zahorany"
  },
  {
    "cast": "Zahořany",
    "psc": "41148",
    "okres": "Litoměřice",
    "obec": "Křešice",
    "val": "41148 Kresice Zahorany"
  },
  {
    "cast": "Zahořany",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Zahořany",
    "val": "34401 Zahorany Zahorany"
  },
  {
    "cast": "Zahořany",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Okrouhlo",
    "val": "25401 Okrouhlo Zahorany"
  },
  {
    "cast": "Zahořany",
    "psc": "25210",
    "okres": "Praha-západ",
    "obec": "Zahořany",
    "val": "25210 Zahorany Zahorany"
  },
  {
    "cast": "Zahořany",
    "psc": "25751",
    "okres": "Benešov",
    "obec": "Bystřice",
    "val": "25751 Bystrice Zahorany"
  },
  {
    "cast": "Zahořany",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Králův Dvůr",
    "val": "26701 Kraluv Dvur Zahorany"
  },
  {
    "cast": "Záhoří",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žatec",
    "val": "43801 Zatec Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "39165",
    "okres": "Tábor",
    "obec": "Záhoří",
    "val": "39165 Zahori Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "51301",
    "okres": "Semily",
    "obec": "Záhoří",
    "val": "51301 Zahori Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Žim",
    "val": "41501 Zim Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Černošín",
    "val": "34901 Cernosin Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Bošice",
    "val": "38481 Bosice Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mileč",
    "val": "33501 Milec Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Verušičky",
    "val": "36452 Verusicky Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Chroboly",
    "val": "38301 Chroboly Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "39601",
    "okres": "Pelhřimov",
    "obec": "Mladé Bříště",
    "val": "39601 Mlade Briste Zahori"
  },
  {
    "cast": "Záhoří",
    "psc": "37821",
    "okres": "Jindřichův Hradec",
    "obec": "Záhoří",
    "val": "37821 Zahori Zahori"
  },
  {
    "cast": "Záhoří a Kozinec",
    "psc": "25791",
    "okres": "Příbram",
    "obec": "Sedlec-Prčice",
    "val": "25791 Sedlec-Prcice Zahori a Kozinec"
  },
  {
    "cast": "Záhoří u Miličína",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Zahori u Milicina"
  },
  {
    "cast": "Záhořice",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36452 Zlutice Zahorice"
  },
  {
    "cast": "Záhoříčko",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Čkyně",
    "val": "38481 Ckyne Zahoricko"
  },
  {
    "cast": "Záhoříčko",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Zahoricko"
  },
  {
    "cast": "Záhoříčko",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Nemyšl",
    "val": "39143 Nemysl Zahoricko"
  },
  {
    "cast": "Záhořín",
    "psc": "47301",
    "okres": "Česká Lípa",
    "obec": "Cvikov",
    "val": "47301 Cvikov Zahorin"
  },
  {
    "cast": "Záhostice",
    "psc": "39155",
    "okres": "Tábor",
    "obec": "Chýnov",
    "val": "39155 Chynov Zahostice"
  },
  {
    "cast": "Záhrabská",
    "psc": "26711",
    "okres": "Beroun",
    "obec": "Svatý Jan pod Skalou",
    "val": "26711 Svaty Jan pod Skalou Zahrabska"
  },
  {
    "cast": "Zahrada",
    "psc": "59455",
    "okres": "Brno-venkov",
    "obec": "Kaly",
    "val": "59455 Kaly Zahrada"
  },
  {
    "cast": "Zahrádčice",
    "psc": "25768",
    "okres": "Benešov",
    "obec": "Dolní Kralovice",
    "val": "25768 Dolni Kralovice Zahradcice"
  },
  {
    "cast": "Záhradí",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Litomyšl",
    "val": "57001 Litomysl Zahradi"
  },
  {
    "cast": "Zahradiště",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Radostín nad Oslavou",
    "val": "59444 Radostin nad Oslavou Zahradiste"
  },
  {
    "cast": "Zahrádka",
    "psc": "39131",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39131 Tabor Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Vojkov",
    "val": "25901 Vojkov Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pošná",
    "val": "39501 Posna Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Čachrov",
    "val": "34142 Cachrov Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "36461",
    "okres": "Cheb",
    "obec": "Teplá",
    "val": "36461 Tepla Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Slapsko",
    "val": "39143 Slapsko Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "33035",
    "okres": "Plzeň-sever",
    "obec": "Zahrádka",
    "val": "33035 Zahradka Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Čížkov",
    "val": "33563 Cizkov Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mirkovice",
    "val": "38232 Mirkovice Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Zahrádka",
    "val": "67571 Zahradka Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kostelec nad Vltavou",
    "val": "39901 Kostelec nad Vltavou Zahradka"
  },
  {
    "cast": "Zahrádka",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Rožmitál na Šumavě",
    "val": "38241 Rozmital na Sumave Zahradka"
  },
  {
    "cast": "Zahrádky",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Borová Lada",
    "val": "38501 Borova Lada Zahradky"
  },
  {
    "cast": "Zahrádky",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Zahrádky",
    "val": "37853 Zahradky Zahradky"
  },
  {
    "cast": "Zahrádky",
    "psc": "47101",
    "okres": "Česká Lípa",
    "obec": "Zahrádky",
    "val": "47101 Zahradky Zahradky"
  },
  {
    "cast": "Zahradnice",
    "psc": "25753",
    "okres": "Benešov",
    "obec": "Olbramovice",
    "val": "25753 Olbramovice Zahradnice"
  },
  {
    "cast": "Zahrady",
    "psc": "40747",
    "okres": "Děčín",
    "obec": "Krásná Lípa",
    "val": "40747 Krasna Lipa Zahrady"
  },
  {
    "cast": "Záhrobí",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Bělčice",
    "val": "38742 Belcice Zahrobi"
  },
  {
    "cast": "Záhuby",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Zelenecká Lhota",
    "val": "50723 Zelenecka Lhota Zahuby"
  },
  {
    "cast": "Záhvozdí",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Želnava",
    "val": "38451 Zelnava Zahvozdi"
  },
  {
    "cast": "Záchlumí",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Záchlumí",
    "val": "34901 Zachlumi Zachlumi"
  },
  {
    "cast": "Záchlumí",
    "psc": "56186",
    "okres": "Ústí nad Orlicí",
    "obec": "Záchlumí",
    "val": "56186 Zachlumi Zachlumi"
  },
  {
    "cast": "Zachotín",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Zachotín",
    "val": "39301 Zachotin Zachotin"
  },
  {
    "cast": "Zachrašťany",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Zachrašťany",
    "val": "50401 Zachrastany Zachrastany"
  },
  {
    "cast": "Zajakury",
    "psc": "50743",
    "okres": "Jičín",
    "obec": "Sobotka",
    "val": "50743 Sobotka Zajakury"
  },
  {
    "cast": "Zaječí",
    "psc": "69105",
    "okres": "Břeclav",
    "obec": "Zaječí",
    "val": "69105 Zajeci Zajeci"
  },
  {
    "cast": "Zaječí",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Zajeci"
  },
  {
    "cast": "Zaječice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Bečov",
    "val": "43401 Becov Zajecice"
  },
  {
    "cast": "Zaječice",
    "psc": "25167",
    "okres": "Benešov",
    "obec": "Pyšely",
    "val": "25167 Pysely Zajecice"
  },
  {
    "cast": "Zaječice",
    "psc": "43111",
    "okres": "Chomutov",
    "obec": "Vrskmaň",
    "val": "43111 Vrskman Zajecice"
  },
  {
    "cast": "Zaječice (část)",
    "psc": "53835",
    "okres": "Chrudim",
    "obec": "Zaječice",
    "val": "53835 Zajecice Zajecice (cast)"
  },
  {
    "cast": "Zaječice (část)",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Zaječice",
    "val": "53851 Zajecice Zajecice (cast)"
  },
  {
    "cast": "Zaječiny",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Kunvald",
    "val": "56401 Kunvald Zajeciny"
  },
  {
    "cast": "Zaječov (část)",
    "psc": "26763",
    "okres": "Beroun",
    "obec": "Zaječov",
    "val": "26763 Zajecov Zajecov (cast)"
  },
  {
    "cast": "Zaječov (část)",
    "psc": "26762",
    "okres": "Beroun",
    "obec": "Zaječov",
    "val": "26762 Zajecov Zajecov (cast)"
  },
  {
    "cast": "Zájezd",
    "psc": "27343",
    "okres": "Kladno",
    "obec": "Zájezd",
    "val": "27343 Zajezd Zajezd"
  },
  {
    "cast": "Zájezd",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Česká Skalice",
    "val": "55203 Ceska Skalice Zajezd"
  },
  {
    "cast": "Zájezdec",
    "psc": "53851",
    "okres": "Chrudim",
    "obec": "Zájezdec",
    "val": "53851 Zajezdec Zajezdec"
  },
  {
    "cast": "Zájezdy",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Zajezdy"
  },
  {
    "cast": "Zajíčkov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Zajíčkov",
    "val": "39301 Zajickov Zajickov"
  },
  {
    "cast": "Zákolany",
    "psc": "27328",
    "okres": "Kladno",
    "obec": "Zákolany",
    "val": "27328 Zakolany Zakolany"
  },
  {
    "cast": "Zakopaná",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Branžež",
    "val": "29402 Branzez Zakopana"
  },
  {
    "cast": "Zákoutí",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Benecko",
    "val": "51401 Benecko Zakouti"
  },
  {
    "cast": "Zákoutí",
    "psc": "43001",
    "okres": "Chomutov",
    "obec": "Blatno",
    "val": "43001 Blatno Zakouti"
  },
  {
    "cast": "Zákraví",
    "psc": "51801",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Ohnišov",
    "val": "51801 Ohnisov Zakravi"
  },
  {
    "cast": "Zakřany",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Zakřany",
    "val": "66484 Zakrany Zakrany"
  },
  {
    "cast": "Zákřov",
    "psc": "78357",
    "okres": "Olomouc",
    "obec": "Tršice",
    "val": "78357 Trsice Zakrov"
  },
  {
    "cast": "Zakšín",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Zaksin"
  },
  {
    "cast": "Zákupy",
    "psc": "47123",
    "okres": "Česká Lípa",
    "obec": "Zákupy",
    "val": "47123 Zakupy Zakupy"
  },
  {
    "cast": "Zalány",
    "psc": "26242",
    "okres": "Příbram",
    "obec": "Rožmitál pod Třemšínem",
    "val": "26242 Rozmital pod Tremsinem Zalany"
  },
  {
    "cast": "Zalažany",
    "psc": "53863",
    "okres": "Chrudim",
    "obec": "Jenišovice",
    "val": "53863 Jenisovice Zalazany"
  },
  {
    "cast": "Zálepy (část)",
    "psc": "25241",
    "okres": "Praha-západ",
    "obec": "Dolní Břežany",
    "val": "25241 Dolni Brezany Zalepy (cast)"
  },
  {
    "cast": "Zálepy (část)",
    "psc": "25245",
    "okres": "Praha-západ",
    "obec": "Dolní Břežany",
    "val": "25245 Dolni Brezany Zalepy (cast)"
  },
  {
    "cast": "Zálesí",
    "psc": "67102",
    "okres": "Znojmo",
    "obec": "Zálesí",
    "val": "67102 Zalesi Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "38473",
    "okres": "Strakonice",
    "obec": "Drážov",
    "val": "38473 Drazov Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25786 Neustupov Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "56943",
    "okres": "Svitavy",
    "obec": "Biskupice",
    "val": "56943 Biskupice Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Příchovice",
    "val": "33401 Prichovice Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "58265",
    "okres": "Havlíčkův Brod",
    "obec": "Slavíkov",
    "val": "58265 Slavikov Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Teplýšovice",
    "val": "25601 Teplysovice Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "79070",
    "okres": "Jeseník",
    "obec": "Javorník",
    "val": "79070 Javornik Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Doubravice",
    "val": "54401 Doubravice Zalesi"
  },
  {
    "cast": "Zálesí",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Horní Krupá",
    "val": "58001 Horni Krupa Zalesi"
  },
  {
    "cast": "Zálesí 1.díl",
    "psc": "25755",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25755 Marsovice Zalesi 1.dil"
  },
  {
    "cast": "Zálesí 2.díl",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Zalesi 2.dil"
  },
  {
    "cast": "Zálesná Zhoř",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Zálesná Zhoř",
    "val": "66484 Zalesna Zhor Zalesna Zhor"
  },
  {
    "cast": "Zálesní Lhota",
    "psc": "51401",
    "okres": "Semily",
    "obec": "Studenec",
    "val": "51401 Studenec Zalesni Lhota"
  },
  {
    "cast": "Zalešany",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Zalešany",
    "val": "28002 Zalesany Zalesany"
  },
  {
    "cast": "Zálezlice",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Zálezlice",
    "val": "27745 Zalezlice Zalezlice"
  },
  {
    "cast": "Zálezly",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Skapce",
    "val": "34901 Skapce Zalezly"
  },
  {
    "cast": "Zálezly",
    "psc": "38481",
    "okres": "Prachatice",
    "obec": "Zálezly",
    "val": "38481 Zalezly Zalezly"
  },
  {
    "cast": "Zálezly",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Velemyšleves",
    "val": "43801 Velemysleves Zalezly"
  },
  {
    "cast": "Zalíbená",
    "psc": "28506",
    "okres": "Kutná Hora",
    "obec": "Podveky",
    "val": "28506 Podveky Zalibena"
  },
  {
    "cast": "Zalíbené",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Studnice",
    "val": "53901 Studnice Zalibene"
  },
  {
    "cast": "Zaliny",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Ledenice",
    "val": "37006 Ledenice Zaliny"
  },
  {
    "cast": "Zaloňov",
    "psc": "55101",
    "okres": "Náchod",
    "obec": "Zaloňov",
    "val": "55101 Zalonov Zalonov"
  },
  {
    "cast": "Zálší",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Sepekov",
    "val": "39901 Sepekov Zalsi"
  },
  {
    "cast": "Zálší",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Zálší",
    "val": "56501 Zalsi Zalsi"
  },
  {
    "cast": "Zálší",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Zálší",
    "val": "39181 Zalsi Zalsi"
  },
  {
    "cast": "Zalužany (část)",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Zalužany",
    "val": "26272 Zaluzany Zaluzany (cast)"
  },
  {
    "cast": "Zalužany (část)",
    "psc": "26284",
    "okres": "Příbram",
    "obec": "Zalužany",
    "val": "26284 Zaluzany Zaluzany (cast)"
  },
  {
    "cast": "Záluží",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39002 Tabor Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "26761",
    "okres": "Beroun",
    "obec": "Záluží",
    "val": "26761 Zaluzi Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "33301",
    "okres": "Plzeň-jih",
    "obec": "Kotovice",
    "val": "33301 Kotovice Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Sušice",
    "val": "34201 Susice Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Chyšky",
    "val": "39901 Chysky Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Vlastiboř",
    "val": "39201 Vlastibor Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "43601",
    "okres": "Most",
    "obec": "Litvínov",
    "val": "43601 Litvinov Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "38773",
    "okres": "Strakonice",
    "obec": "Bílsko",
    "val": "38773 Bilsko Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Třemošná",
    "val": "33011 Tremosna Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "25088",
    "okres": "Praha-východ",
    "obec": "Čelákovice",
    "val": "25088 Celakovice Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Slavče",
    "val": "37401 Slavce Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Dolní Třebonín",
    "val": "38232 Dolni Trebonin Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "41301",
    "okres": "Litoměřice",
    "obec": "Záluží",
    "val": "41301 Zaluzi Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Přídolí",
    "val": "38101 Pridoli Zaluzi"
  },
  {
    "cast": "Záluží",
    "psc": "33561",
    "okres": "Plzeň-jih",
    "obec": "Spálené Poříčí",
    "val": "33561 Spalene Porici Zaluzi"
  },
  {
    "cast": "Záluží u Budislavě",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Budislav",
    "val": "39201 Budislav Zaluzi u Budislave"
  },
  {
    "cast": "Zálužice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Zálužice",
    "val": "43801 Zaluzice Zaluzice"
  },
  {
    "cast": "Zálužice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hartmanice",
    "val": "34201 Hartmanice Zaluzice"
  },
  {
    "cast": "Zálužice",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Pištín",
    "val": "37341 Pistin Zaluzice"
  },
  {
    "cast": "Zálužné (část)",
    "psc": "74784",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74784 Vitkov Zaluzne (cast)"
  },
  {
    "cast": "Zálužné (část)",
    "psc": "74901",
    "okres": "Opava",
    "obec": "Vítkov",
    "val": "74901 Vitkov Zaluzne (cast)"
  },
  {
    "cast": "Zamachy",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Velké Všelisy",
    "val": "29426 Velke Vselisy Zamachy"
  },
  {
    "cast": "Zámecká",
    "psc": "47125",
    "okres": "Liberec",
    "obec": "Jablonné v Podještědí",
    "val": "47125 Jablonne v Podjestedi Zamecka"
  },
  {
    "cast": "Zámek",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Zamek"
  },
  {
    "cast": "Záměl",
    "psc": "51743",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Záměl",
    "val": "51743 Zamel Zamel"
  },
  {
    "cast": "Zámělíč",
    "psc": "34522",
    "okres": "Domažlice",
    "obec": "Poběžovice",
    "val": "34522 Pobezovice Zamelic"
  },
  {
    "cast": "Zámezí",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Železnice",
    "val": "50713 Zeleznice Zamezi"
  },
  {
    "cast": "Zámlyní",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Předmíř",
    "val": "38742 Predmir Zamlyni"
  },
  {
    "cast": "Zámostí",
    "psc": "67401",
    "okres": "Třebíč",
    "obec": "Třebíč",
    "val": "67401 Trebic Zamosti"
  },
  {
    "cast": "Zámostí",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Zámostí-Blata",
    "val": "50601 Zamosti-Blata Zamosti"
  },
  {
    "cast": "Zámostí",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Rožďalovice",
    "val": "28934 Rozdalovice Zamosti"
  },
  {
    "cast": "Zámostí",
    "psc": "29431",
    "okres": "Mladá Boleslav",
    "obec": "Písková Lhota",
    "val": "29431 Piskova Lhota Zamosti"
  },
  {
    "cast": "Zámrsk",
    "psc": "56543",
    "okres": "Ústí nad Orlicí",
    "obec": "Zámrsk",
    "val": "56543 Zamrsk Zamrsk"
  },
  {
    "cast": "Zámrsky",
    "psc": "75301",
    "okres": "Přerov",
    "obec": "Zámrsky",
    "val": "75301 Zamrsky Zamrsky"
  },
  {
    "cast": "Zámyšl",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Zamysl"
  },
  {
    "cast": "Zápudov",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Boseň",
    "val": "29501 Bosen Zapudov"
  },
  {
    "cast": "Zápy",
    "psc": "25001",
    "okres": "Praha-východ",
    "obec": "Zápy",
    "val": "25001 Zapy Zapy"
  },
  {
    "cast": "Zarazice",
    "psc": "69801",
    "okres": "Hodonín",
    "obec": "Veselí nad Moravou",
    "val": "69801 Veseli nad Moravou Zarazice"
  },
  {
    "cast": "Zárubice (část)",
    "psc": "67501",
    "okres": "Třebíč",
    "obec": "Zárubice",
    "val": "67501 Zarubice Zarubice (cast)"
  },
  {
    "cast": "Zárubice (část)",
    "psc": "67552",
    "okres": "Třebíč",
    "obec": "Zárubice",
    "val": "67552 Zarubice Zarubice (cast)"
  },
  {
    "cast": "Zárybnice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Neveklov",
    "val": "25756 Neveklov Zarybnice"
  },
  {
    "cast": "Zárybničná Lhota",
    "psc": "39156",
    "okres": "Tábor",
    "obec": "Tábor",
    "val": "39156 Tabor Zarybnicna Lhota"
  },
  {
    "cast": "Záryby",
    "psc": "27713",
    "okres": "Praha-východ",
    "obec": "Záryby",
    "val": "27713 Zaryby Zaryby"
  },
  {
    "cast": "Zářecká Lhota",
    "psc": "56501",
    "okres": "Ústí nad Orlicí",
    "obec": "Zářecká Lhota",
    "val": "56501 Zarecka Lhota Zarecka Lhota"
  },
  {
    "cast": "Zaříčany",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Bílé Podolí",
    "val": "28601 Bile Podoli Zaricany"
  },
  {
    "cast": "Záříčí",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Dírná",
    "val": "39201 Dirna Zarici"
  },
  {
    "cast": "Záříčí",
    "psc": "76811",
    "okres": "Kroměříž",
    "obec": "Záříčí",
    "val": "76811 Zarici Zarici"
  },
  {
    "cast": "Záříčí u Mladé Vožice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Šebířov",
    "val": "39143 Sebirov Zarici u Mlade Vozice"
  },
  {
    "cast": "Zásada",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Pěnčín",
    "val": "46344 Pencin Zasada"
  },
  {
    "cast": "Zásada",
    "psc": "46825",
    "okres": "Jablonec nad Nisou",
    "obec": "Zásada",
    "val": "46825 Zasada Zasada"
  },
  {
    "cast": "Zásada u Kadaně",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Kadaň",
    "val": "43201 Kadan Zasada u Kadane"
  },
  {
    "cast": "Zásadka",
    "psc": "29501",
    "okres": "Mladá Boleslav",
    "obec": "Boseň",
    "val": "29501 Bosen Zasadka"
  },
  {
    "cast": "Záseka",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Netín",
    "val": "59444 Netin Zaseka"
  },
  {
    "cast": "Záskalí",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Hodkovice nad Mohelkou",
    "val": "46342 Hodkovice nad Mohelkou Zaskali"
  },
  {
    "cast": "Zásmuky",
    "psc": "28144",
    "okres": "Kolín",
    "obec": "Zásmuky",
    "val": "28144 Zasmuky Zasmuky"
  },
  {
    "cast": "Zástava",
    "psc": "53304",
    "okres": "Pardubice",
    "obec": "Újezd u Sezemic",
    "val": "53304 Ujezd u Sezemic Zastava"
  },
  {
    "cast": "Zastávka",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Přeštice",
    "val": "33401 Prestice Zastavka"
  },
  {
    "cast": "Zastávka",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Zastávka",
    "val": "66484 Zastavka Zastavka"
  },
  {
    "cast": "Zástřizly",
    "psc": "76805",
    "okres": "Kroměříž",
    "obec": "Zástřizly",
    "val": "76805 Zastrizly Zastrizly"
  },
  {
    "cast": "Zašová (část)",
    "psc": "75654",
    "okres": "Vsetín",
    "obec": "Zašová",
    "val": "75654 Zasova Zasova (cast)"
  },
  {
    "cast": "Zašová (část)",
    "psc": "75651",
    "okres": "Vsetín",
    "obec": "Zašová",
    "val": "75651 Zasova Zasova (cast)"
  },
  {
    "cast": "Zašovice",
    "psc": "67521",
    "okres": "Třebíč",
    "obec": "Zašovice",
    "val": "67521 Zasovice Zasovice"
  },
  {
    "cast": "Zátaví",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Kestřany",
    "val": "39701 Kestrany Zatavi"
  },
  {
    "cast": "Zátoň",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Lenora",
    "val": "38451 Lenora Zaton"
  },
  {
    "cast": "Zátoň",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38101 Vetrni Zaton"
  },
  {
    "cast": "Zátoňské Dvory",
    "psc": "38101",
    "okres": "Český Krumlov",
    "obec": "Větřní",
    "val": "38101 Vetrni Zatonske Dvory"
  },
  {
    "cast": "Zátor",
    "psc": "79316",
    "okres": "Bruntál",
    "obec": "Zátor",
    "val": "79316 Zator Zator"
  },
  {
    "cast": "Zátvor",
    "psc": "27745",
    "okres": "Mělník",
    "obec": "Zálezlice",
    "val": "27745 Zalezlice Zatvor"
  },
  {
    "cast": "Zátyní",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Dubá",
    "val": "47201 Duba Zatyni"
  },
  {
    "cast": "Závada",
    "psc": "74719",
    "okres": "Opava",
    "obec": "Závada",
    "val": "74719 Zavada Zavada"
  },
  {
    "cast": "Závada",
    "psc": "73572",
    "okres": "Karviná",
    "obec": "Petrovice u Karviné",
    "val": "73572 Petrovice u Karvine Zavada"
  },
  {
    "cast": "Zavadilka",
    "psc": "28802",
    "okres": "Nymburk",
    "obec": "Jizbice",
    "val": "28802 Jizbice Zavadilka"
  },
  {
    "cast": "Zavadilka",
    "psc": "79852",
    "okres": "Prostějov",
    "obec": "Budětsko",
    "val": "79852 Budetsko Zavadilka"
  },
  {
    "cast": "Zavadilka-Beroun x)",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Zavadilka-Beroun x)"
  },
  {
    "cast": "Závidkovice",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Zavidkovice"
  },
  {
    "cast": "Zavidov",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Zavidov",
    "val": "27035 Zavidov Zavidov"
  },
  {
    "cast": "Závist",
    "psc": "67922",
    "okres": "Blansko",
    "obec": "Závist",
    "val": "67922 Zavist Zavist"
  },
  {
    "cast": "Závist",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Předklášteří",
    "val": "66601 Predklasteri Zavist"
  },
  {
    "cast": "Závist",
    "psc": "59401",
    "okres": "Žďár nad Sázavou",
    "obec": "Lavičky",
    "val": "59401 Lavicky Zavist"
  },
  {
    "cast": "Závist",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Rybník",
    "val": "34525 Rybnik Zavist"
  },
  {
    "cast": "Závišice",
    "psc": "74221",
    "okres": "Nový Jičín",
    "obec": "Závišice",
    "val": "74221 Zavisice Zavisice"
  },
  {
    "cast": "Závišín",
    "psc": "38742",
    "okres": "Strakonice",
    "obec": "Bělčice",
    "val": "38742 Belcice Zavisin"
  },
  {
    "cast": "Závišín",
    "psc": "35301",
    "okres": "Cheb",
    "obec": "Zádub-Závišín",
    "val": "35301 Zadub-Zavisin Zavisin"
  },
  {
    "cast": "Zavlekov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Zavlekov",
    "val": "34142 Zavlekov Zavlekov"
  },
  {
    "cast": "Závodí-Beroun x)",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Zavodi-Beroun x)"
  },
  {
    "cast": "Závratec",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Třemošnice",
    "val": "53843 Tremosnice Zavratec"
  },
  {
    "cast": "Závraty",
    "psc": "37001",
    "okres": "České Budějovice",
    "obec": "Závraty",
    "val": "37001 Zavraty Zavraty"
  },
  {
    "cast": "Závrchy",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Vysoká Srbská",
    "val": "54931 Vysoka Srbska Zavrchy"
  },
  {
    "cast": "Zavržice",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Zavrzice"
  },
  {
    "cast": "Závsí",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Dírná",
    "val": "39201 Dirna Zavsi"
  },
  {
    "cast": "Zbečník (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54931 Hronov Zbecnik (cast)"
  },
  {
    "cast": "Zbečník (část)",
    "psc": "54941",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54941 Hronov Zbecnik (cast)"
  },
  {
    "cast": "Zbečno",
    "psc": "27024",
    "okres": "Rakovník",
    "obec": "Zbečno",
    "val": "27024 Zbecno Zbecno"
  },
  {
    "cast": "Zbelítov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Zbelítov",
    "val": "39901 Zbelitov Zbelitov"
  },
  {
    "cast": "Zbelítov",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Zbelitov"
  },
  {
    "cast": "Zbenice (část)",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Zbenice",
    "val": "26231 Zbenice Zbenice (cast)"
  },
  {
    "cast": "Zbenice (část)",
    "psc": "26272",
    "okres": "Příbram",
    "obec": "Zbenice",
    "val": "26272 Zbenice Zbenice (cast)"
  },
  {
    "cast": "Zberaz",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Sedlčany",
    "val": "26401 Sedlcany Zberaz"
  },
  {
    "cast": "Zběšice",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Bernartice",
    "val": "39843 Bernartice Zbesice"
  },
  {
    "cast": "Zběšičky",
    "psc": "39843",
    "okres": "Písek",
    "obec": "Zběšičky",
    "val": "39843 Zbesicky Zbesicky"
  },
  {
    "cast": "Zbilidy",
    "psc": "58805",
    "okres": "Jihlava",
    "obec": "Zbilidy",
    "val": "58805 Zbilidy Zbilidy"
  },
  {
    "cast": "Zbinohy",
    "psc": "58842",
    "okres": "Jihlava",
    "obec": "Zbinohy",
    "val": "58842 Zbinohy Zbinohy"
  },
  {
    "cast": "Zbiroh",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Zbiroh",
    "val": "33808 Zbiroh Zbiroh"
  },
  {
    "cast": "Zbirohy",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Koberovy",
    "val": "46822 Koberovy Zbirohy"
  },
  {
    "cast": "Zbislav",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Zhoř",
    "val": "39901 Zhor Zbislav"
  },
  {
    "cast": "Zbizuby",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Zbizuby",
    "val": "28504 Zbizuby Zbizuby"
  },
  {
    "cast": "Zblov",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Studnice",
    "val": "55203 Studnice Zblov"
  },
  {
    "cast": "Zblovice",
    "psc": "67107",
    "okres": "Znojmo",
    "obec": "Zblovice",
    "val": "67107 Zblovice Zblovice"
  },
  {
    "cast": "Zboněk",
    "psc": "67961",
    "okres": "Blansko",
    "obec": "Letovice",
    "val": "67961 Letovice Zbonek"
  },
  {
    "cast": "Zbonín",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Varvažov",
    "val": "39701 Varvazov Zbonin"
  },
  {
    "cast": "Zborná",
    "psc": "58601",
    "okres": "Jihlava",
    "obec": "Jihlava",
    "val": "58601 Jihlava Zborna"
  },
  {
    "cast": "Zborov",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Zborov",
    "val": "78901 Zborov Zborov"
  },
  {
    "cast": "Zborov",
    "psc": "37006",
    "okres": "České Budějovice",
    "obec": "Ledenice",
    "val": "37006 Ledenice Zborov"
  },
  {
    "cast": "Zborovice",
    "psc": "76832",
    "okres": "Kroměříž",
    "obec": "Zborovice",
    "val": "76832 Zborovice Zborovice"
  },
  {
    "cast": "Zborovy",
    "psc": "34034",
    "okres": "Klatovy",
    "obec": "Zborovy",
    "val": "34034 Zborovy Zborovy"
  },
  {
    "cast": "Zbořený Kostelec",
    "psc": "25741",
    "okres": "Benešov",
    "obec": "Týnec nad Sázavou",
    "val": "25741 Tynec nad Sazavou Zboreny Kostelec"
  },
  {
    "cast": "Zboží",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Úbislavice",
    "val": "50901 Ubislavice Zbozi"
  },
  {
    "cast": "Zboží",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Habry",
    "val": "58291 Habry Zbozi"
  },
  {
    "cast": "Zboží",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Dvůr Králové nad Labem",
    "val": "54401 Dvur Kralove nad Labem Zbozi"
  },
  {
    "cast": "Zbožice",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkův Brod",
    "val": "58001 Havlickuv Brod Zbozice"
  },
  {
    "cast": "Zbožíčko",
    "psc": "28925",
    "okres": "Nymburk",
    "obec": "Zbožíčko",
    "val": "28925 Zbozicko Zbozicko"
  },
  {
    "cast": "Zbožnice",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Václavice",
    "val": "25601 Vaclavice Zboznice"
  },
  {
    "cast": "Zbožnov",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Zboznov"
  },
  {
    "cast": "Zbraň",
    "psc": "28126",
    "okres": "Kolín",
    "obec": "Žiželice",
    "val": "28126 Zizelice Zbran"
  },
  {
    "cast": "Zbraněves",
    "psc": "53311",
    "okres": "Pardubice",
    "obec": "Zdechovice",
    "val": "53311 Zdechovice Zbraneves"
  },
  {
    "cast": "Zbraslav",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Štědrá",
    "val": "36452 Stedra Zbraslav"
  },
  {
    "cast": "Zbraslav",
    "psc": "15600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15600 Praha Zbraslav"
  },
  {
    "cast": "Zbraslav (část)",
    "psc": "66484",
    "okres": "Brno-venkov",
    "obec": "Zbraslav",
    "val": "66484 Zbraslav Zbraslav (cast)"
  },
  {
    "cast": "Zbraslav (část)",
    "psc": "66488",
    "okres": "Brno-venkov",
    "obec": "Zbraslav",
    "val": "66488 Zbraslav Zbraslav (cast)"
  },
  {
    "cast": "Zbraslavec",
    "psc": "67972",
    "okres": "Blansko",
    "obec": "Zbraslavec",
    "val": "67972 Zbraslavec Zbraslavec"
  },
  {
    "cast": "Zbraslavice (část)",
    "psc": "28521",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28521 Zbraslavice Zbraslavice (cast)"
  },
  {
    "cast": "Zbraslavice (část)",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zbraslavice",
    "val": "28522 Zbraslavice Zbraslavice (cast)"
  },
  {
    "cast": "Zbrašín",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Zbrašín",
    "val": "44001 Zbrasin Zbrasin"
  },
  {
    "cast": "Zbudov",
    "psc": "37348",
    "okres": "České Budějovice",
    "obec": "Dívčice",
    "val": "37348 Divcice Zbudov"
  },
  {
    "cast": "Zbudov",
    "psc": "56182",
    "okres": "Ústí nad Orlicí",
    "obec": "Klášterec nad Orlicí",
    "val": "56182 Klasterec nad Orlici Zbudov"
  },
  {
    "cast": "Zbudovice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Zbýšov",
    "val": "28601 Zbysov Zbudovice"
  },
  {
    "cast": "Zbůch",
    "psc": "33022",
    "okres": "Plzeň-sever",
    "obec": "Zbůch",
    "val": "33022 Zbuch Zbuch"
  },
  {
    "cast": "Zbuzany",
    "psc": "25225",
    "okres": "Praha-západ",
    "obec": "Zbuzany",
    "val": "25225 Zbuzany Zbuzany"
  },
  {
    "cast": "Zbyhněvice (část)",
    "psc": "53821",
    "okres": "Chrudim",
    "obec": "Morašice",
    "val": "53821 Morasice Zbyhnevice (cast)"
  },
  {
    "cast": "Zbyhněvice (část)",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Morašice",
    "val": "53803 Morasice Zbyhnevice (cast)"
  },
  {
    "cast": "Zbynice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Hrádek",
    "val": "34201 Hradek Zbynice"
  },
  {
    "cast": "Zbyny",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Doksy",
    "val": "47201 Doksy Zbyny"
  },
  {
    "cast": "Zbyslav",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Vrdy",
    "val": "28601 Vrdy Zbyslav"
  },
  {
    "cast": "Zbyslav",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "33901 Planice Zbyslav"
  },
  {
    "cast": "Zbyslavec",
    "psc": "53803",
    "okres": "Chrudim",
    "obec": "Míčov-Sušice",
    "val": "53803 Micov-Susice Zbyslavec"
  },
  {
    "cast": "Zbyslavice",
    "psc": "74283",
    "okres": "Ostrava-město",
    "obec": "Zbyslavice",
    "val": "74283 Zbyslavice Zbyslavice"
  },
  {
    "cast": "Zbýšov",
    "psc": "66411",
    "okres": "Brno-venkov",
    "obec": "Zbýšov",
    "val": "66411 Zbysov Zbysov"
  },
  {
    "cast": "Zbýšov",
    "psc": "28565",
    "okres": "Kutná Hora",
    "obec": "Zbýšov",
    "val": "28565 Zbysov Zbysov"
  },
  {
    "cast": "Zbýšov",
    "psc": "68352",
    "okres": "Vyškov",
    "obec": "Zbýšov",
    "val": "68352 Zbysov Zbysov"
  },
  {
    "cast": "Zbytiny",
    "psc": "38441",
    "okres": "Prachatice",
    "obec": "Zbytiny",
    "val": "38441 Zbytiny Zbytiny"
  },
  {
    "cast": "Zdaboř-Příbram V x)",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Zdabor-Pribram V x)"
  },
  {
    "cast": "Zdeboř",
    "psc": "25901",
    "okres": "Benešov",
    "obec": "Votice",
    "val": "25901 Votice Zdebor"
  },
  {
    "cast": "Zdebořice",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Plánice",
    "val": "34142 Planice Zdeborice"
  },
  {
    "cast": "Zdebuzeves",
    "psc": "25726",
    "okres": "Benešov",
    "obec": "Divišov",
    "val": "25726 Divisov Zdebuzeves"
  },
  {
    "cast": "Zděchov",
    "psc": "75607",
    "okres": "Vsetín",
    "obec": "Zděchov",
    "val": "75607 Zdechov Zdechov"
  },
  {
    "cast": "Zdechovice",
    "psc": "50401",
    "okres": "Hradec Králové",
    "obec": "Zdechovice",
    "val": "50401 Zdechovice Zdechovice"
  },
  {
    "cast": "Zdechovice (část)",
    "psc": "53311",
    "okres": "Pardubice",
    "obec": "Zdechovice",
    "val": "53311 Zdechovice Zdechovice (cast)"
  },
  {
    "cast": "Zdechovice (část)",
    "psc": "53313",
    "okres": "Pardubice",
    "obec": "Zdechovice",
    "val": "53313 Zdechovice Zdechovice (cast)"
  },
  {
    "cast": "Zdejcina-Beroun x)",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Beroun",
    "val": "26601 Beroun Zdejcina-Beroun x)"
  },
  {
    "cast": "Zdelov",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Zdelov",
    "val": "51721 Zdelov Zdelov"
  },
  {
    "cast": "Zdemyslice",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Zdemyslice",
    "val": "33601 Zdemyslice Zdemyslice"
  },
  {
    "cast": "Zdenice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Nebahovy",
    "val": "38301 Nebahovy Zdenice"
  },
  {
    "cast": "Zdeňkov",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Zdeňkov",
    "val": "58856 Zdenkov Zdenkov"
  },
  {
    "cast": "Zderadice",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Maršovice",
    "val": "25756 Marsovice Zderadice"
  },
  {
    "cast": "Zderadinky",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Kácov",
    "val": "28522 Kacov Zderadinky"
  },
  {
    "cast": "Zderadiny",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Kácov",
    "val": "28522 Kacov Zderadiny"
  },
  {
    "cast": "Zderaz",
    "psc": "34012",
    "okres": "Klatovy",
    "obec": "Biřkov",
    "val": "34012 Birkov Zderaz"
  },
  {
    "cast": "Zderaz",
    "psc": "27004",
    "okres": "Rakovník",
    "obec": "Kolešovice",
    "val": "27004 Kolesovice Zderaz"
  },
  {
    "cast": "Zderaz",
    "psc": "53944",
    "okres": "Chrudim",
    "obec": "Zderaz",
    "val": "53944 Zderaz Zderaz"
  },
  {
    "cast": "Zdeslav",
    "psc": "33901",
    "okres": "Klatovy",
    "obec": "Poleň",
    "val": "33901 Polen Zdeslav"
  },
  {
    "cast": "Zdeslav",
    "psc": "27034",
    "okres": "Rakovník",
    "obec": "Čistá",
    "val": "27034 Cista Zdeslav"
  },
  {
    "cast": "Zdeslavice",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Černíny",
    "val": "28601 Cerniny Zdeslavice"
  },
  {
    "cast": "Zdeslavice",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28401 Chlistovice Zdeslavice"
  },
  {
    "cast": "Zdeslavice",
    "psc": "58401",
    "okres": "Havlíčkův Brod",
    "obec": "Číhošť",
    "val": "58401 Cihost Zdeslavice"
  },
  {
    "cast": "Zdešov",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Jarošov nad Nežárkou",
    "val": "37842 Jarosov nad Nezarkou Zdesov"
  },
  {
    "cast": "Zdětín",
    "psc": "79843",
    "okres": "Prostějov",
    "obec": "Zdětín",
    "val": "79843 Zdetin Zdetin"
  },
  {
    "cast": "Zdětín",
    "psc": "29471",
    "okres": "Mladá Boleslav",
    "obec": "Zdětín",
    "val": "29471 Zdetin Zdetin"
  },
  {
    "cast": "Zdibsko",
    "psc": "25067",
    "okres": "Praha-východ",
    "obec": "Klecany",
    "val": "25067 Klecany Zdibsko"
  },
  {
    "cast": "Zdiby",
    "psc": "25066",
    "okres": "Praha-východ",
    "obec": "Zdiby",
    "val": "25066 Zdiby Zdiby"
  },
  {
    "cast": "Zdice",
    "psc": "26751",
    "okres": "Beroun",
    "obec": "Zdice",
    "val": "26751 Zdice Zdice"
  },
  {
    "cast": "Zdíkov (část)",
    "psc": "38472",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38472 Zdikov Zdikov (cast)"
  },
  {
    "cast": "Zdíkov (část)",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Zdikov (cast)"
  },
  {
    "cast": "Zdíkovec",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Zdikovec"
  },
  {
    "cast": "Zdíky",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Bujanov",
    "val": "38241 Bujanov Zdiky"
  },
  {
    "cast": "Zdiměřice",
    "psc": "25708",
    "okres": "Benešov",
    "obec": "Načeradec",
    "val": "25708 Naceradec Zdimerice"
  },
  {
    "cast": "Zdiměřice (část)",
    "psc": "14900",
    "okres": "Praha-západ",
    "obec": "Jesenice",
    "val": "14900 Jesenice Zdimerice (cast)"
  },
  {
    "cast": "Zdiměřice (část)",
    "psc": "25242",
    "okres": "Praha-západ",
    "obec": "Jesenice",
    "val": "25242 Jesenice Zdimerice (cast)"
  },
  {
    "cast": "Zdislav",
    "psc": "53854",
    "okres": "Chrudim",
    "obec": "Luže",
    "val": "53854 Luze Zdislav"
  },
  {
    "cast": "Zdislava",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Zdislava",
    "val": "46353 Zdislava Zdislava"
  },
  {
    "cast": "Zdislavice",
    "psc": "25764",
    "okres": "Benešov",
    "obec": "Zdislavice",
    "val": "25764 Zdislavice Zdislavice"
  },
  {
    "cast": "Zdislavice",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Troubky-Zdislavice",
    "val": "76802 Troubky-Zdislavice Zdislavice"
  },
  {
    "cast": "Zdislavice (část)",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Herálec",
    "val": "58001 Heralec Zdislavice (cast)"
  },
  {
    "cast": "Zdislavice (část)",
    "psc": "58255",
    "okres": "Havlíčkův Brod",
    "obec": "Herálec",
    "val": "58255 Heralec Zdislavice (cast)"
  },
  {
    "cast": "Zdobín",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Zdobín",
    "val": "54401 Zdobin Zdobin"
  },
  {
    "cast": "Zdobnice",
    "psc": "51601",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Zdobnice",
    "val": "51601 Zdobnice Zdobnice"
  },
  {
    "cast": "Zdoňov",
    "psc": "54957",
    "okres": "Náchod",
    "obec": "Teplice nad Metují",
    "val": "54957 Teplice nad Metuji Zdonov"
  },
  {
    "cast": "Zdounky",
    "psc": "76802",
    "okres": "Kroměříž",
    "obec": "Zdounky",
    "val": "76802 Zdounky Zdounky"
  },
  {
    "cast": "Zdravá Voda",
    "psc": "69634",
    "okres": "Hodonín",
    "obec": "Žarošice",
    "val": "69634 Zarosice Zdrava Voda"
  },
  {
    "cast": "Zduchovice",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Zduchovice",
    "val": "26263 Zduchovice Zduchovice"
  },
  {
    "cast": "Zehuby",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Žleby",
    "val": "28601 Zleby Zehuby"
  },
  {
    "cast": "Zechov",
    "psc": "25789",
    "okres": "Benešov",
    "obec": "Smilkov",
    "val": "25789 Smilkov Zechov"
  },
  {
    "cast": "Zechovice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Volyně",
    "val": "38701 Volyne Zechovice"
  },
  {
    "cast": "Zelčín",
    "psc": "27601",
    "okres": "Mělník",
    "obec": "Hořín",
    "val": "27601 Horin Zelcin"
  },
  {
    "cast": "Zelená",
    "psc": "35134",
    "okres": "Cheb",
    "obec": "Skalná",
    "val": "35134 Skalna Zelena"
  },
  {
    "cast": "Zelená",
    "psc": "43102",
    "okres": "Chomutov",
    "obec": "Málkov",
    "val": "43102 Malkov Zelena"
  },
  {
    "cast": "Zelená",
    "psc": "29442",
    "okres": "Mladá Boleslav",
    "obec": "Luštěnice",
    "val": "29442 Lustenice Zelena"
  },
  {
    "cast": "Zelená Hora",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Lužany",
    "val": "33401 Luzany Zelena Hora"
  },
  {
    "cast": "Zelená Hora",
    "psc": "35801",
    "okres": "Sokolov",
    "obec": "Kraslice",
    "val": "35801 Kraslice Zelena Hora"
  },
  {
    "cast": "Zelená Hora",
    "psc": "68321",
    "okres": "Vyškov",
    "obec": "Zelená Hora",
    "val": "68321 Zelena Hora Zelena Hora"
  },
  {
    "cast": "Zelená Lhota",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Nýrsko",
    "val": "34022 Nyrsko Zelena Lhota"
  },
  {
    "cast": "Zelená Ves",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Mezilesí",
    "val": "39501 Mezilesi Zelena Ves"
  },
  {
    "cast": "Zelené",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Lužany",
    "val": "33401 Luzany Zelene"
  },
  {
    "cast": "Zelené Předměstí",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Zelene Predmesti"
  },
  {
    "cast": "Zelenecká Lhota",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Zelenecká Lhota",
    "val": "50723 Zelenecka Lhota Zelenecka Lhota"
  },
  {
    "cast": "Zeleneč",
    "psc": "25091",
    "okres": "Praha-východ",
    "obec": "Zeleneč",
    "val": "25091 Zelenec Zelenec"
  },
  {
    "cast": "Zelený",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Úštěk",
    "val": "41145 Ustek Zeleny"
  },
  {
    "cast": "Zelený Háj",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Vojtanov",
    "val": "35002 Vojtanov Zeleny Haj"
  },
  {
    "cast": "Zelinkovice",
    "psc": "73942",
    "okres": "Frýdek-Místek",
    "obec": "Frýdek-Místek",
    "val": "73942 Frydek-Mistek Zelinkovice"
  },
  {
    "cast": "Zeměchy",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Jimlín",
    "val": "44001 Jimlin Zemechy"
  },
  {
    "cast": "Zeměchy",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Kralupy nad Vltavou",
    "val": "27801 Kralupy nad Vltavou Zemechy"
  },
  {
    "cast": "Zemětice",
    "psc": "33452",
    "okres": "Plzeň-jih",
    "obec": "Zemětice",
    "val": "33452 Zemetice Zemetice"
  },
  {
    "cast": "Zhorný",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Zhorny"
  },
  {
    "cast": "Zhoř",
    "psc": "34901",
    "okres": "Tachov",
    "obec": "Zhoř",
    "val": "34901 Zhor Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Pacov",
    "val": "39501 Pacov Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Zhoř",
    "val": "39901 Zhor Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "25765",
    "okres": "Benešov",
    "obec": "Čechtice",
    "val": "25765 Cechtice Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "58826",
    "okres": "Jihlava",
    "obec": "Zhoř",
    "val": "58826 Zhor Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "56002",
    "okres": "Svitavy",
    "obec": "Němčice",
    "val": "56002 Nemcice Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Červené Janovice",
    "val": "28601 Cervene Janovice Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Zhoř",
    "val": "67923 Zhor Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Krakovec",
    "val": "27035 Krakovec Zhor"
  },
  {
    "cast": "Zhoř",
    "psc": "26256",
    "okres": "Příbram",
    "obec": "Krásná Hora nad Vltavou",
    "val": "26256 Krasna Hora nad Vltavou Zhor"
  },
  {
    "cast": "Zhoř u Mladé Vožice",
    "psc": "39143",
    "okres": "Tábor",
    "obec": "Zhoř u Mladé Vožice",
    "val": "39143 Zhor u Mlade Vozice Zhor u Mlade Vozice"
  },
  {
    "cast": "Zhoř u Tábora",
    "psc": "39002",
    "okres": "Tábor",
    "obec": "Zhoř u Tábora",
    "val": "39002 Zhor u Tabora Zhor u Tabora"
  },
  {
    "cast": "Zhořec",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Zhořec",
    "val": "39501 Zhorec Zhorec"
  },
  {
    "cast": "Zhořec",
    "psc": "33162",
    "okres": "Plzeň-sever",
    "obec": "Manětín",
    "val": "33162 Manetin Zhorec"
  },
  {
    "cast": "Zhořec",
    "psc": "34953",
    "okres": "Tachov",
    "obec": "Bezdružice",
    "val": "34953 Bezdruzice Zhorec"
  },
  {
    "cast": "Zhůř",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Chocenice",
    "val": "33501 Chocenice Zhur"
  },
  {
    "cast": "Zhůří",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Rejštejn",
    "val": "34192 Rejstejn Zhuri"
  },
  {
    "cast": "Zibohlavy",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Kolín",
    "val": "28002 Kolin Zibohlavy"
  },
  {
    "cast": "Zichov",
    "psc": "34543",
    "okres": "Domažlice",
    "obec": "Koloveč",
    "val": "34543 Kolovec Zichov"
  },
  {
    "cast": "Zichovec",
    "psc": "27374",
    "okres": "Kladno",
    "obec": "Zichovec",
    "val": "27374 Zichovec Zichovec"
  },
  {
    "cast": "Zimoř",
    "psc": "41145",
    "okres": "Litoměřice",
    "obec": "Liběšice",
    "val": "41145 Libesice Zimor"
  },
  {
    "cast": "Zlámanec",
    "psc": "68712",
    "okres": "Uherské Hradiště",
    "obec": "Zlámanec",
    "val": "68712 Zlamanec Zlamanec"
  },
  {
    "cast": "Zlámaniny",
    "psc": "50901",
    "okres": "Jičín",
    "obec": "Nová Paka",
    "val": "50901 Nova Paka Zlamaniny"
  },
  {
    "cast": "Zlámanka",
    "psc": "76701",
    "okres": "Kroměříž",
    "obec": "Kroměříž",
    "val": "76701 Kromeriz Zlamanka"
  },
  {
    "cast": "Zlatá",
    "psc": "25083",
    "okres": "Praha-východ",
    "obec": "Zlatá",
    "val": "25083 Zlata Zlata"
  },
  {
    "cast": "Zlatá",
    "psc": "35751",
    "okres": "Sokolov",
    "obec": "Kynšperk nad Ohří",
    "val": "35751 Kynsperk nad Ohri Zlata"
  },
  {
    "cast": "Zlatá Koruna",
    "psc": "38202",
    "okres": "Český Krumlov",
    "obec": "Zlatá Koruna",
    "val": "38202 Zlata Koruna Zlata Koruna"
  },
  {
    "cast": "Zlatá Olešnice",
    "psc": "54101",
    "okres": "Trutnov",
    "obec": "Zlatá Olešnice",
    "val": "54101 Zlata Olesnice Zlata Olesnice"
  },
  {
    "cast": "Zlatá Olešnice",
    "psc": "46847",
    "okres": "Jablonec nad Nisou",
    "obec": "Zlatá Olešnice",
    "val": "46847 Zlata Olesnice Zlata Olesnice"
  },
  {
    "cast": "Zlaté Hory",
    "psc": "79376",
    "okres": "Jeseník",
    "obec": "Zlaté Hory",
    "val": "79376 Zlate Hory Zlate Hory"
  },
  {
    "cast": "Zlátenka (část)",
    "psc": "39501",
    "okres": "Pelhřimov",
    "obec": "Zlátenka",
    "val": "39501 Zlatenka Zlatenka (cast)"
  },
  {
    "cast": "Zlátenka (část)",
    "psc": "39413",
    "okres": "Pelhřimov",
    "obec": "Zlátenka",
    "val": "39413 Zlatenka Zlatenka (cast)"
  },
  {
    "cast": "Zlatkov",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Rožná",
    "val": "59301 Rozna Zlatkov"
  },
  {
    "cast": "Zlatníky",
    "psc": "74601",
    "okres": "Opava",
    "obec": "Opava",
    "val": "74601 Opava Zlatniky"
  },
  {
    "cast": "Zlatníky",
    "psc": "25241",
    "okres": "Praha-západ",
    "obec": "Zlatníky-Hodkovice",
    "val": "25241 Zlatniky-Hodkovice Zlatniky"
  },
  {
    "cast": "Zlatý Kopec",
    "psc": "36262",
    "okres": "Karlovy Vary",
    "obec": "Boží Dar",
    "val": "36262 Bozi Dar Zlaty Kopec"
  },
  {
    "cast": "Zlatý Potok",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Malá Morava",
    "val": "78833 Mala Morava Zlaty Potok"
  },
  {
    "cast": "Zlechov",
    "psc": "68710",
    "okres": "Uherské Hradiště",
    "obec": "Zlechov",
    "val": "68710 Zlechov Zlechov"
  },
  {
    "cast": "Zlenice",
    "psc": "25722",
    "okres": "Benešov",
    "obec": "Lštění",
    "val": "25722 Lsteni Zlenice"
  },
  {
    "cast": "Zlešice",
    "psc": "38701",
    "okres": "Strakonice",
    "obec": "Malenice",
    "val": "38701 Malenice Zlesice"
  },
  {
    "cast": "Zlíč",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Česká Skalice",
    "val": "55203 Ceska Skalice Zlic"
  },
  {
    "cast": "Zličín (část)",
    "psc": "15500",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15500 Praha Zlicin (cast)"
  },
  {
    "cast": "Zličín (část)",
    "psc": "15521",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "15521 Praha Zlicin (cast)"
  },
  {
    "cast": "Zlíčko",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Vysoká Srbská",
    "val": "54931 Vysoka Srbska Zlicko"
  },
  {
    "cast": "Zlín (část)",
    "psc": "76001",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76001 Zlin Zlin (cast)"
  },
  {
    "cast": "Zlín (část)",
    "psc": "76005",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76005 Zlin Zlin (cast)"
  },
  {
    "cast": "Zlín (část)",
    "psc": "76302",
    "okres": "Zlín",
    "obec": "Zlín",
    "val": "76302 Zlin Zlin (cast)"
  },
  {
    "cast": "Zliv",
    "psc": "50723",
    "okres": "Jičín",
    "obec": "Libáň",
    "val": "50723 Liban Zliv"
  },
  {
    "cast": "Zliv",
    "psc": "37344",
    "okres": "České Budějovice",
    "obec": "Zliv",
    "val": "37344 Zliv Zliv"
  },
  {
    "cast": "Zliv",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Kácov",
    "val": "28522 Kacov Zliv"
  },
  {
    "cast": "Zliv",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Planá",
    "val": "34815 Plana Zliv"
  },
  {
    "cast": "Zlivice",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Čížová",
    "val": "39701 Cizova Zlivice"
  },
  {
    "cast": "Zlobice",
    "psc": "76831",
    "okres": "Kroměříž",
    "obec": "Zlobice",
    "val": "76831 Zlobice Zlobice"
  },
  {
    "cast": "Zlončice",
    "psc": "27801",
    "okres": "Mělník",
    "obec": "Zlončice",
    "val": "27801 Zloncice Zloncice"
  },
  {
    "cast": "Zlonice",
    "psc": "27371",
    "okres": "Kladno",
    "obec": "Zlonice",
    "val": "27371 Zlonice Zlonice"
  },
  {
    "cast": "Zlonín",
    "psc": "25064",
    "okres": "Praha-východ",
    "obec": "Zlonín",
    "val": "25064 Zlonin Zlonin"
  },
  {
    "cast": "Zlosyň",
    "psc": "27744",
    "okres": "Mělník",
    "obec": "Zlosyň",
    "val": "27744 Zlosyn Zlosyn"
  },
  {
    "cast": "Zlovědice",
    "psc": "44101",
    "okres": "Louny",
    "obec": "Krásný Dvůr",
    "val": "44101 Krasny Dvur Zlovedice"
  },
  {
    "cast": "Zlukov",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Zlukov",
    "val": "39181 Zlukov Zlukov"
  },
  {
    "cast": "Zminný",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Dašice",
    "val": "53002 Dasice Zminny"
  },
  {
    "cast": "Zmišovice",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Červená Řečice",
    "val": "39301 Cervena Recice Zmisovice"
  },
  {
    "cast": "Zňátky",
    "psc": "67571",
    "okres": "Třebíč",
    "obec": "Náměšť nad Oslavou",
    "val": "67571 Namest nad Oslavou Znatky"
  },
  {
    "cast": "Znětínek",
    "psc": "59444",
    "okres": "Žďár nad Sázavou",
    "obec": "Znětínek",
    "val": "59444 Znetinek Znetinek"
  },
  {
    "cast": "Znojmo (část)",
    "psc": "67182",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "67182 Znojmo Znojmo (cast)"
  },
  {
    "cast": "Znojmo (část)",
    "psc": "66902",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "66902 Znojmo Znojmo (cast)"
  },
  {
    "cast": "Znojmo (část)",
    "psc": "67181",
    "okres": "Znojmo",
    "obec": "Znojmo",
    "val": "67181 Znojmo Znojmo (cast)"
  },
  {
    "cast": "Znosim",
    "psc": "25801",
    "okres": "Benešov",
    "obec": "Vlašim",
    "val": "25801 Vlasim Znosim"
  },
  {
    "cast": "Zouvalka",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Vyškov",
    "val": "68201 Vyskov Zouvalka"
  },
  {
    "cast": "Zrnětín",
    "psc": "57001",
    "okres": "Svitavy",
    "obec": "Poříčí u Litomyšle",
    "val": "57001 Porici u Litomysle Zrnetin"
  },
  {
    "cast": "Zruč",
    "psc": "33008",
    "okres": "Plzeň-sever",
    "obec": "Zruč-Senec",
    "val": "33008 Zruc-Senec Zruc"
  },
  {
    "cast": "Zruč nad Sázavou",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zruč nad Sázavou",
    "val": "28522 Zruc nad Sazavou Zruc nad Sazavou"
  },
  {
    "cast": "Zubčice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Zubčice",
    "val": "38232 Zubcice Zubcice"
  },
  {
    "cast": "Zubčická Lhotka",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Zubčice",
    "val": "38232 Zubcice Zubcicka Lhotka"
  },
  {
    "cast": "Zubrnice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Zubrnice",
    "val": "40002 Zubrnice Zubrnice"
  },
  {
    "cast": "Zubří",
    "psc": "75654",
    "okres": "Vsetín",
    "obec": "Zubří",
    "val": "75654 Zubri Zubri"
  },
  {
    "cast": "Zubří",
    "psc": "53901",
    "okres": "Chrudim",
    "obec": "Trhová Kamenice",
    "val": "53901 Trhova Kamenice Zubri"
  },
  {
    "cast": "Zubří",
    "psc": "59231",
    "okres": "Žďár nad Sázavou",
    "obec": "Zubří",
    "val": "59231 Zubri Zubri"
  },
  {
    "cast": "Zuklín",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Strašín",
    "val": "34201 Strasin Zuklin"
  },
  {
    "cast": "Zvánovice (část)",
    "psc": "25165",
    "okres": "Praha-východ",
    "obec": "Zvánovice",
    "val": "25165 Zvanovice Zvanovice (cast)"
  },
  {
    "cast": "Zvánovice (část)",
    "psc": "25164",
    "okres": "Praha-východ",
    "obec": "Zvánovice",
    "val": "25164 Zvanovice Zvanovice (cast)"
  },
  {
    "cast": "Zvěrkovice",
    "psc": "67602",
    "okres": "Třebíč",
    "obec": "Zvěrkovice",
    "val": "67602 Zverkovice Zverkovice"
  },
  {
    "cast": "Zvěrkovice",
    "psc": "37501",
    "okres": "České Budějovice",
    "obec": "Temelín",
    "val": "37501 Temelin Zverkovice"
  },
  {
    "cast": "Zvěrotice",
    "psc": "39201",
    "okres": "Tábor",
    "obec": "Zvěrotice",
    "val": "39201 Zverotice Zverotice"
  },
  {
    "cast": "Zvěřenice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Záblatí",
    "val": "38301 Zablati Zverenice"
  },
  {
    "cast": "Zvěřetice",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Babice",
    "val": "38411 Babice Zveretice"
  },
  {
    "cast": "Zvěřínek",
    "psc": "28913",
    "okres": "Nymburk",
    "obec": "Zvěřínek",
    "val": "28913 Zverinek Zverinek"
  },
  {
    "cast": "Zvěstonín",
    "psc": "39133",
    "okres": "Tábor",
    "obec": "Jistebnice",
    "val": "39133 Jistebnice Zvestonin"
  },
  {
    "cast": "Zvěstov (část)",
    "psc": "25705",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25705 Zvestov Zvestov (cast)"
  },
  {
    "cast": "Zvěstov (část)",
    "psc": "25706",
    "okres": "Benešov",
    "obec": "Zvěstov",
    "val": "25706 Zvestov Zvestov (cast)"
  },
  {
    "cast": "Zvěstovice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Zvěstovice",
    "val": "58282 Zvestovice Zvestovice"
  },
  {
    "cast": "Zvíkov",
    "psc": "34142",
    "okres": "Klatovy",
    "obec": "Hlavňovice",
    "val": "34142 Hlavnovice Zvikov"
  },
  {
    "cast": "Zvíkov",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Zvíkov",
    "val": "38232 Zvikov Zvikov"
  },
  {
    "cast": "Zvíkov",
    "psc": "50315",
    "okres": "Hradec Králové",
    "obec": "Boharyně",
    "val": "50315 Boharyne Zvikov"
  },
  {
    "cast": "Zvíkov",
    "psc": "37372",
    "okres": "České Budějovice",
    "obec": "Zvíkov",
    "val": "37372 Zvikov Zvikov"
  },
  {
    "cast": "Zvíkovec",
    "psc": "33808",
    "okres": "Rokycany",
    "obec": "Zvíkovec",
    "val": "33808 Zvikovec Zvikovec"
  },
  {
    "cast": "Zvíkovské Podhradí",
    "psc": "39701",
    "okres": "Písek",
    "obec": "Zvíkovské Podhradí",
    "val": "39701 Zvikovske Podhradi Zvikovske Podhradi"
  },
  {
    "cast": "Zvírotice",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Dublovice",
    "val": "26401 Dublovice Zvirotice"
  },
  {
    "cast": "Zvířetice",
    "psc": "29401",
    "okres": "Mladá Boleslav",
    "obec": "Bakov nad Jizerou",
    "val": "29401 Bakov nad Jizerou Zviretice"
  },
  {
    "cast": "Zvole",
    "psc": "78901",
    "okres": "Šumperk",
    "obec": "Zvole",
    "val": "78901 Zvole Zvole"
  },
  {
    "cast": "Zvole",
    "psc": "55225",
    "okres": "Náchod",
    "obec": "Rychnovek",
    "val": "55225 Rychnovek Zvole"
  },
  {
    "cast": "Zvole",
    "psc": "59256",
    "okres": "Žďár nad Sázavou",
    "obec": "Zvole",
    "val": "59256 Zvole Zvole"
  },
  {
    "cast": "Zvole (část)",
    "psc": "25245",
    "okres": "Praha-západ",
    "obec": "Zvole",
    "val": "25245 Zvole Zvole (cast)"
  },
  {
    "cast": "Zvole (část)",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Zvole",
    "val": "25401 Zvole Zvole (cast)"
  },
  {
    "cast": "Zvoleněves",
    "psc": "27325",
    "okres": "Kladno",
    "obec": "Zvoleněves",
    "val": "27325 Zvoleneves Zvoleneves"
  },
  {
    "cast": "Zvolenovice",
    "psc": "58856",
    "okres": "Jihlava",
    "obec": "Zvolenovice",
    "val": "58856 Zvolenovice Zvolenovice"
  },
  {
    "cast": "Zvonovice",
    "psc": "68201",
    "okres": "Vyškov",
    "obec": "Rostěnice-Zvonovice",
    "val": "68201 Rostenice-Zvonovice Zvonovice"
  },
  {
    "cast": "Zvotoky",
    "psc": "38716",
    "okres": "Strakonice",
    "obec": "Zvotoky",
    "val": "38716 Zvotoky Zvotoky"
  },
  {
    "cast": "Zvůle",
    "psc": "37853",
    "okres": "Jindřichův Hradec",
    "obec": "Kunžak",
    "val": "37853 Kunzak Zvule"
  },
  {
    "cast": "Žabčice",
    "psc": "66463",
    "okres": "Brno-venkov",
    "obec": "Žabčice",
    "val": "66463 Zabcice Zabcice"
  },
  {
    "cast": "Žabeň",
    "psc": "73925",
    "okres": "Frýdek-Místek",
    "obec": "Žabeň",
    "val": "73925 Zaben Zaben"
  },
  {
    "cast": "Žabokliky",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Nové Sedlo",
    "val": "43801 Nove Sedlo Zabokliky"
  },
  {
    "cast": "Žabokrky (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54931 Hronov Zabokrky (cast)"
  },
  {
    "cast": "Žabokrky (část)",
    "psc": "54934",
    "okres": "Náchod",
    "obec": "Hronov",
    "val": "54934 Hronov Zabokrky (cast)"
  },
  {
    "cast": "Žabonosy",
    "psc": "28002",
    "okres": "Kolín",
    "obec": "Žabonosy",
    "val": "28002 Zabonosy Zabonosy"
  },
  {
    "cast": "Žabovřesky",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Chlístov",
    "val": "25601 Chlistov Zabovresky"
  },
  {
    "cast": "Žabovřesky",
    "psc": "37341",
    "okres": "České Budějovice",
    "obec": "Žabovřesky",
    "val": "37341 Zabovresky Zabovresky"
  },
  {
    "cast": "Žabovřesky nad Ohří",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Žabovřesky nad Ohří",
    "val": "41002 Zabovresky nad Ohri Zabovresky nad Ohri"
  },
  {
    "cast": "Žabovřesky (část)",
    "psc": "60200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "60200 Brno Zabovresky (cast)"
  },
  {
    "cast": "Žabovřesky (část)",
    "psc": "61200",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61200 Brno Zabovresky (cast)"
  },
  {
    "cast": "Žabovřesky (část)",
    "psc": "61600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61600 Brno Zabovresky (cast)"
  },
  {
    "cast": "Žabovřesky (část)",
    "psc": "63700",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63700 Brno Zabovresky (cast)"
  },
  {
    "cast": "Žacléř (část)",
    "psc": "54201",
    "okres": "Trutnov",
    "obec": "Žacléř",
    "val": "54201 Zacler Zacler (cast)"
  },
  {
    "cast": "Žacléř (část)",
    "psc": "54226",
    "okres": "Trutnov",
    "obec": "Žacléř",
    "val": "54226 Zacler Zacler (cast)"
  },
  {
    "cast": "Žádlovice",
    "psc": "78983",
    "okres": "Šumperk",
    "obec": "Loštice",
    "val": "78983 Lostice Zadlovice"
  },
  {
    "cast": "Žádovice",
    "psc": "69649",
    "okres": "Hodonín",
    "obec": "Žádovice",
    "val": "69649 Zadovice Zadovice"
  },
  {
    "cast": "Žákava (část)",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Žákava",
    "val": "33601 Zakava Zakava (cast)"
  },
  {
    "cast": "Žákava (část)",
    "psc": "33204",
    "okres": "Plzeň-jih",
    "obec": "Žákava",
    "val": "33204 Zakava Zakava (cast)"
  },
  {
    "cast": "Žákovice",
    "psc": "75354",
    "okres": "Přerov",
    "obec": "Žákovice",
    "val": "75354 Zakovice Zakovice"
  },
  {
    "cast": "Žáky",
    "psc": "28601",
    "okres": "Kutná Hora",
    "obec": "Žáky",
    "val": "28601 Zaky Zaky"
  },
  {
    "cast": "Žalany",
    "psc": "41763",
    "okres": "Teplice",
    "obec": "Žalany",
    "val": "41763 Zalany Zalany"
  },
  {
    "cast": "Žalhostice",
    "psc": "41101",
    "okres": "Litoměřice",
    "obec": "Žalhostice",
    "val": "41101 Zalhostice Zalhostice"
  },
  {
    "cast": "Žalkovice",
    "psc": "76823",
    "okres": "Kroměříž",
    "obec": "Žalkovice",
    "val": "76823 Zalkovice Zalkovice"
  },
  {
    "cast": "Žalmanov",
    "psc": "36471",
    "okres": "Karlovy Vary",
    "obec": "Stružná",
    "val": "36471 Struzna Zalmanov"
  },
  {
    "cast": "Žaltice",
    "psc": "38232",
    "okres": "Český Krumlov",
    "obec": "Mirkovice",
    "val": "38232 Mirkovice Zaltice"
  },
  {
    "cast": "Žalý",
    "psc": "51237",
    "okres": "Semily",
    "obec": "Benecko",
    "val": "51237 Benecko Zaly"
  },
  {
    "cast": "Žamberk (část)",
    "psc": "56184",
    "okres": "Ústí nad Orlicí",
    "obec": "Žamberk",
    "val": "56184 Zamberk Zamberk (cast)"
  },
  {
    "cast": "Žamberk (část)",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Žamberk",
    "val": "56401 Zamberk Zamberk (cast)"
  },
  {
    "cast": "Žampach",
    "psc": "25282",
    "okres": "Praha-západ",
    "obec": "Kamenný Přívoz",
    "val": "25282 Kamenny Privoz Zampach"
  },
  {
    "cast": "Žampach",
    "psc": "25401",
    "okres": "Praha-západ",
    "obec": "Jílové u Prahy",
    "val": "25401 Jilove u Prahy Zampach"
  },
  {
    "cast": "Žampach (část)",
    "psc": "56401",
    "okres": "Ústí nad Orlicí",
    "obec": "Žampach",
    "val": "56401 Zampach Zampach (cast)"
  },
  {
    "cast": "Žampach (část)",
    "psc": "56101",
    "okres": "Ústí nad Orlicí",
    "obec": "Žampach",
    "val": "56101 Zampach Zampach (cast)"
  },
  {
    "cast": "Žandov",
    "psc": "47107",
    "okres": "Česká Lípa",
    "obec": "Žandov",
    "val": "47107 Zandov Zandov"
  },
  {
    "cast": "Žandov",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Chlístovice",
    "val": "28504 Chlistovice Zandov"
  },
  {
    "cast": "Žandov",
    "psc": "40339",
    "okres": "Ústí nad Labem",
    "obec": "Chlumec",
    "val": "40339 Chlumec Zandov"
  },
  {
    "cast": "Žantov",
    "psc": "29402",
    "okres": "Mladá Boleslav",
    "obec": "Kněžmost",
    "val": "29402 Knezmost Zantov"
  },
  {
    "cast": "Žantov",
    "psc": "50351",
    "okres": "Hradec Králové",
    "obec": "Nový Bydžov",
    "val": "50351 Novy Bydzov Zantov"
  },
  {
    "cast": "Žár",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Vacov",
    "val": "38473 Vacov Zar"
  },
  {
    "cast": "Žár",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Žár",
    "val": "37401 Zar Zar"
  },
  {
    "cast": "Žáravice",
    "psc": "53316",
    "okres": "Pardubice",
    "obec": "Žáravice",
    "val": "53316 Zaravice Zaravice"
  },
  {
    "cast": "Žarošice",
    "psc": "69634",
    "okres": "Hodonín",
    "obec": "Žarošice",
    "val": "69634 Zarosice Zarosice"
  },
  {
    "cast": "Žárová",
    "psc": "78815",
    "okres": "Šumperk",
    "obec": "Velké Losiny",
    "val": "78815 Velke Losiny Zarova"
  },
  {
    "cast": "Žárovice",
    "psc": "79803",
    "okres": "Prostějov",
    "obec": "Plumlov",
    "val": "79803 Plumlov Zarovice"
  },
  {
    "cast": "Žárovná",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Žárovná",
    "val": "38301 Zarovna Zarovna"
  },
  {
    "cast": "Žáry",
    "psc": "79395",
    "okres": "Bruntál",
    "obec": "Město Albrechtice",
    "val": "79395 Mesto Albrechtice Zary"
  },
  {
    "cast": "Žatčany",
    "psc": "66453",
    "okres": "Brno-venkov",
    "obec": "Žatčany",
    "val": "66453 Zatcany Zatcany"
  },
  {
    "cast": "Žatec",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žatec",
    "val": "43801 Zatec Zatec"
  },
  {
    "cast": "Žatec",
    "psc": "58862",
    "okres": "Jihlava",
    "obec": "Žatec",
    "val": "58862 Zatec Zatec"
  },
  {
    "cast": "Ždánice",
    "psc": "58282",
    "okres": "Havlíčkův Brod",
    "obec": "Vilémov",
    "val": "58282 Vilemov Zdanice"
  },
  {
    "cast": "Ždánice",
    "psc": "28163",
    "okres": "Kolín",
    "obec": "Ždánice",
    "val": "28163 Zdanice Zdanice"
  },
  {
    "cast": "Ždánice",
    "psc": "59301",
    "okres": "Žďár nad Sázavou",
    "obec": "Ždánice",
    "val": "59301 Zdanice Zdanice"
  },
  {
    "cast": "Ždánice (část)",
    "psc": "69632",
    "okres": "Hodonín",
    "obec": "Ždánice",
    "val": "69632 Zdanice Zdanice (cast)"
  },
  {
    "cast": "Ždánice (část)",
    "psc": "68501",
    "okres": "Hodonín",
    "obec": "Ždánice",
    "val": "68501 Zdanice Zdanice (cast)"
  },
  {
    "cast": "Ždánov",
    "psc": "34401",
    "okres": "Domažlice",
    "obec": "Ždánov",
    "val": "34401 Zdanov Zdanov"
  },
  {
    "cast": "Ždánov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Nezdice na Šumavě",
    "val": "34201 Nezdice na Sumave Zdanov"
  },
  {
    "cast": "Žďár",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Žďár",
    "val": "39811 Zdar Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "26401",
    "okres": "Příbram",
    "obec": "Radíč",
    "val": "26401 Radic Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Doksy",
    "val": "47201 Doksy Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Ždírec",
    "val": "33601 Zdirec Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "67902",
    "okres": "Blansko",
    "obec": "Žďár",
    "val": "67902 Zdar Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "38241",
    "okres": "Český Krumlov",
    "obec": "Kaplice",
    "val": "38241 Kaplice Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "27033",
    "okres": "Rakovník",
    "obec": "Žďár",
    "val": "27033 Zdar Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "34101",
    "okres": "Klatovy",
    "obec": "Nalžovské Hory",
    "val": "34101 Nalzovske Hory Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "46841",
    "okres": "Jablonec nad Nisou",
    "obec": "Tanvald",
    "val": "46841 Tanvald Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "50791",
    "okres": "Semily",
    "obec": "Levínská Olešnice",
    "val": "50791 Levinska Olesnice Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Veselá",
    "val": "51263 Vesela Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "37842",
    "okres": "Jindřichův Hradec",
    "obec": "Žďár",
    "val": "37842 Zdar Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "29412",
    "okres": "Mladá Boleslav",
    "obec": "Žďár",
    "val": "29412 Zdar Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Velké Chvojno",
    "val": "40002 Velke Chvojno Zdar"
  },
  {
    "cast": "Žďár",
    "psc": "34815",
    "okres": "Tachov",
    "obec": "Chodský Újezd",
    "val": "34815 Chodsky Ujezd Zdar"
  },
  {
    "cast": "Žďár nad Metují (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Žďár nad Metují",
    "val": "54931 Zdar nad Metuji Zdar nad Metuji (cast)"
  },
  {
    "cast": "Žďár nad Metují (část)",
    "psc": "54955",
    "okres": "Náchod",
    "obec": "Žďár nad Metují",
    "val": "54955 Zdar nad Metuji Zdar nad Metuji (cast)"
  },
  {
    "cast": "Žďár nad Metují (část)",
    "psc": "54954",
    "okres": "Náchod",
    "obec": "Žďár nad Metují",
    "val": "54954 Zdar nad Metuji Zdar nad Metuji (cast)"
  },
  {
    "cast": "Žďár nad Orlicí (část)",
    "psc": "51723",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Žďár nad Orlicí",
    "val": "51723 Zdar nad Orlici Zdar nad Orlici (cast)"
  },
  {
    "cast": "Žďár nad Orlicí (část)",
    "psc": "51721",
    "okres": "Rychnov nad Kněžnou",
    "obec": "Žďár nad Orlicí",
    "val": "51721 Zdar nad Orlici Zdar nad Orlici (cast)"
  },
  {
    "cast": "Žďár nad Sázavou 1",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Zdar nad Sazavou 1"
  },
  {
    "cast": "Žďár nad Sázavou 2 (část)",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Zdar nad Sazavou 2 (cast)"
  },
  {
    "cast": "Žďár nad Sázavou 2 (část)",
    "psc": "59102",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59102 Zdar nad Sazavou Zdar nad Sazavou 2 (cast)"
  },
  {
    "cast": "Žďár nad Sázavou 3",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Zdar nad Sazavou 3"
  },
  {
    "cast": "Žďár nad Sázavou 4",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Zdar nad Sazavou 4"
  },
  {
    "cast": "Žďár nad Sázavou 5",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Zdar nad Sazavou 5"
  },
  {
    "cast": "Žďár nad Sázavou 6",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Zdar nad Sazavou 6"
  },
  {
    "cast": "Žďár nad Sázavou 7",
    "psc": "59101",
    "okres": "Žďár nad Sázavou",
    "obec": "Žďár nad Sázavou",
    "val": "59101 Zdar nad Sazavou Zdar nad Sazavou 7"
  },
  {
    "cast": "Žďár u Kumburku",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Syřenov",
    "val": "51251 Syrenov Zdar u Kumburku"
  },
  {
    "cast": "Žďár (část)",
    "psc": "55205",
    "okres": "Náchod",
    "obec": "Brzice",
    "val": "55205 Brzice Zdar (cast)"
  },
  {
    "cast": "Žďár (část)",
    "psc": "55204",
    "okres": "Náchod",
    "obec": "Brzice",
    "val": "55204 Brzice Zdar (cast)"
  },
  {
    "cast": "Žďárec",
    "psc": "59456",
    "okres": "Brno-venkov",
    "obec": "Žďárec",
    "val": "59456 Zdarec Zdarec"
  },
  {
    "cast": "Žďárec u Seče",
    "psc": "53807",
    "okres": "Chrudim",
    "obec": "Seč",
    "val": "53807 Sec Zdarec u Sece"
  },
  {
    "cast": "Žďárec u Skutče",
    "psc": "53973",
    "okres": "Chrudim",
    "obec": "Skuteč",
    "val": "53973 Skutec Zdarec u Skutce"
  },
  {
    "cast": "Žďárek",
    "psc": "46344",
    "okres": "Liberec",
    "obec": "Žďárek",
    "val": "46344 Zdarek Zdarek"
  },
  {
    "cast": "Žďárek",
    "psc": "36453",
    "okres": "Karlovy Vary",
    "obec": "Chyše",
    "val": "36453 Chyse Zdarek"
  },
  {
    "cast": "Žďárek",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Libouchec",
    "val": "40002 Libouchec Zdarek"
  },
  {
    "cast": "Žďárek",
    "psc": "46342",
    "okres": "Liberec",
    "obec": "Hodkovice nad Mohelkou",
    "val": "46342 Hodkovice nad Mohelkou Zdarek"
  },
  {
    "cast": "Žďárky (část)",
    "psc": "54937",
    "okres": "Náchod",
    "obec": "Žďárky",
    "val": "54937 Zdarky Zdarky (cast)"
  },
  {
    "cast": "Žďárky (část)",
    "psc": "54931",
    "okres": "Náchod",
    "obec": "Žďárky",
    "val": "54931 Zdarky Zdarky (cast)"
  },
  {
    "cast": "Žďárná",
    "psc": "67952",
    "okres": "Blansko",
    "obec": "Žďárná",
    "val": "67952 Zdarna Zdarna"
  },
  {
    "cast": "Žďárské Chalupy",
    "psc": "39811",
    "okres": "Písek",
    "obec": "Žďár",
    "val": "39811 Zdar Zdarske Chalupy"
  },
  {
    "cast": "Žďárský Potok",
    "psc": "79501",
    "okres": "Bruntál",
    "obec": "Stará Ves",
    "val": "79501 Stara Ves Zdarsky Potok"
  },
  {
    "cast": "Žďáry",
    "psc": "27035",
    "okres": "Rakovník",
    "obec": "Hvozd",
    "val": "27035 Hvozd Zdary"
  },
  {
    "cast": "Ždírec",
    "psc": "58813",
    "okres": "Jihlava",
    "obec": "Ždírec",
    "val": "58813 Zdirec Zdirec"
  },
  {
    "cast": "Ždírec",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Ždírec",
    "val": "47201 Zdirec Zdirec"
  },
  {
    "cast": "Ždírec",
    "psc": "33601",
    "okres": "Plzeň-jih",
    "obec": "Ždírec",
    "val": "33601 Zdirec Zdirec"
  },
  {
    "cast": "Ždírec",
    "psc": "58001",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec",
    "val": "58001 Zdirec Zdirec"
  },
  {
    "cast": "Ždírec nad Doubravou",
    "psc": "58263",
    "okres": "Havlíčkův Brod",
    "obec": "Ždírec nad Doubravou",
    "val": "58263 Zdirec nad Doubravou Zdirec nad Doubravou"
  },
  {
    "cast": "Ždírecký Důl",
    "psc": "47201",
    "okres": "Česká Lípa",
    "obec": "Ždírec",
    "val": "47201 Zdirec Zdirecky Dul"
  },
  {
    "cast": "Ždírnice",
    "psc": "54371",
    "okres": "Trutnov",
    "obec": "Horní Olešnice",
    "val": "54371 Horni Olesnice Zdirnice"
  },
  {
    "cast": "Ždov",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Radonice",
    "val": "43201 Radonice Zdov"
  },
  {
    "cast": "Žebětín",
    "psc": "64100",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "64100 Brno Zebetin"
  },
  {
    "cast": "Žebice",
    "psc": "29426",
    "okres": "Mladá Boleslav",
    "obec": "Boreč",
    "val": "29426 Borec Zebice"
  },
  {
    "cast": "Žebnice",
    "psc": "33101",
    "okres": "Plzeň-sever",
    "obec": "Plasy",
    "val": "33101 Plasy Zebnice"
  },
  {
    "cast": "Žebrák",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Nečín",
    "val": "26301 Necin Zebrak"
  },
  {
    "cast": "Žebrák",
    "psc": "26753",
    "okres": "Beroun",
    "obec": "Žebrák",
    "val": "26753 Zebrak Zebrak"
  },
  {
    "cast": "Žebrákov",
    "psc": "39901",
    "okres": "Písek",
    "obec": "Kovářov",
    "val": "39901 Kovarov Zebrakov"
  },
  {
    "cast": "Žebrákov",
    "psc": "26263",
    "okres": "Příbram",
    "obec": "Zduchovice",
    "val": "26263 Zduchovice Zebrakov"
  },
  {
    "cast": "Žebrákov",
    "psc": "58291",
    "okres": "Havlíčkův Brod",
    "obec": "Světlá nad Sázavou",
    "val": "58291 Svetla nad Sazavou Zebrakov"
  },
  {
    "cast": "Žebráky",
    "psc": "34806",
    "okres": "Tachov",
    "obec": "Hošťka",
    "val": "34806 Hostka Zebraky"
  },
  {
    "cast": "Žehrov",
    "psc": "29412",
    "okres": "Mladá Boleslav",
    "obec": "Žďár",
    "val": "29412 Zdar Zehrov"
  },
  {
    "cast": "Žehuň",
    "psc": "28905",
    "okres": "Kolín",
    "obec": "Žehuň",
    "val": "28905 Zehun Zehun"
  },
  {
    "cast": "Žehušice",
    "psc": "28575",
    "okres": "Kutná Hora",
    "obec": "Žehušice",
    "val": "28575 Zehusice Zehusice"
  },
  {
    "cast": "Želatovice",
    "psc": "75116",
    "okres": "Přerov",
    "obec": "Želatovice",
    "val": "75116 Zelatovice Zelatovice"
  },
  {
    "cast": "Želčany",
    "psc": "33204",
    "okres": "Plzeň-město",
    "obec": "Chválenice",
    "val": "33204 Chvalenice Zelcany"
  },
  {
    "cast": "Želeč",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Měcholupy",
    "val": "43801 Mecholupy Zelec"
  },
  {
    "cast": "Želeč",
    "psc": "39174",
    "okres": "Tábor",
    "obec": "Želeč",
    "val": "39174 Zelec Zelec"
  },
  {
    "cast": "Želeč",
    "psc": "79807",
    "okres": "Prostějov",
    "obec": "Želeč",
    "val": "79807 Zelec Zelec"
  },
  {
    "cast": "Želeč",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Malá Skála",
    "val": "46822 Mala Skala Zelec"
  },
  {
    "cast": "Želechovice",
    "psc": "78391",
    "okres": "Olomouc",
    "obec": "Želechovice",
    "val": "78391 Zelechovice Zelechovice"
  },
  {
    "cast": "Želechovice",
    "psc": "41002",
    "okres": "Litoměřice",
    "obec": "Čížkovice",
    "val": "41002 Cizkovice Zelechovice"
  },
  {
    "cast": "Želechovice nad Dřevnicí",
    "psc": "76311",
    "okres": "Zlín",
    "obec": "Želechovice nad Dřevnicí",
    "val": "76311 Zelechovice nad Drevnici Zelechovice nad Drevnici"
  },
  {
    "cast": "Želechy",
    "psc": "51251",
    "okres": "Semily",
    "obec": "Lomnice nad Popelkou",
    "val": "51251 Lomnice nad Popelkou Zelechy"
  },
  {
    "cast": "Želejov",
    "psc": "50771",
    "okres": "Jičín",
    "obec": "Borek",
    "val": "50771 Borek Zelejov"
  },
  {
    "cast": "Želejov",
    "psc": "51101",
    "okres": "Semily",
    "obec": "Hrubá Skála",
    "val": "51101 Hruba Skala Zelejov"
  },
  {
    "cast": "Želenice",
    "psc": "43401",
    "okres": "Most",
    "obec": "Želenice",
    "val": "43401 Zelenice Zelenice"
  },
  {
    "cast": "Želenice",
    "psc": "27341",
    "okres": "Kladno",
    "obec": "Želenice",
    "val": "27341 Zelenice Zelenice"
  },
  {
    "cast": "Želénky",
    "psc": "41771",
    "okres": "Teplice",
    "obec": "Zabrušany",
    "val": "41771 Zabrusany Zelenky"
  },
  {
    "cast": "Želešice",
    "psc": "66443",
    "okres": "Brno-venkov",
    "obec": "Želešice",
    "val": "66443 Zelesice Zelesice"
  },
  {
    "cast": "Želetava",
    "psc": "67526",
    "okres": "Třebíč",
    "obec": "Želetava",
    "val": "67526 Zeletava Zeletava"
  },
  {
    "cast": "Želetice",
    "psc": "67134",
    "okres": "Znojmo",
    "obec": "Želetice",
    "val": "67134 Zeletice Zeletice"
  },
  {
    "cast": "Želetice",
    "psc": "69637",
    "okres": "Hodonín",
    "obec": "Želetice",
    "val": "69637 Zeletice Zeletice"
  },
  {
    "cast": "Želevčice",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Slaný",
    "val": "27401 Slany Zelevcice"
  },
  {
    "cast": "Želevice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Koštice",
    "val": "44001 Kostice Zelevice"
  },
  {
    "cast": "Železná",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Libořice",
    "val": "43801 Liborice Zelezna"
  },
  {
    "cast": "Železná",
    "psc": "26601",
    "okres": "Beroun",
    "obec": "Železná",
    "val": "26601 Zelezna Zelezna"
  },
  {
    "cast": "Železná",
    "psc": "79326",
    "okres": "Bruntál",
    "obec": "Vrbno pod Pradědem",
    "val": "79326 Vrbno pod Pradedem Zelezna"
  },
  {
    "cast": "Železná",
    "psc": "34525",
    "okres": "Domažlice",
    "obec": "Bělá nad Radbuzou",
    "val": "34525 Bela nad Radbuzou Zelezna"
  },
  {
    "cast": "Železná Ruda",
    "psc": "34004",
    "okres": "Klatovy",
    "obec": "Železná Ruda",
    "val": "34004 Zelezna Ruda Zelezna Ruda"
  },
  {
    "cast": "Železné",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Železné",
    "val": "66601 Zelezne Zelezne"
  },
  {
    "cast": "Železné Horky",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Havlíčkova Borová",
    "val": "58222 Havlickova Borova Zelezne Horky"
  },
  {
    "cast": "Železnice",
    "psc": "50713",
    "okres": "Jičín",
    "obec": "Železnice",
    "val": "50713 Zeleznice Zeleznice"
  },
  {
    "cast": "Železný Brod",
    "psc": "46822",
    "okres": "Jablonec nad Nisou",
    "obec": "Železný Brod",
    "val": "46822 Zelezny Brod Zelezny Brod"
  },
  {
    "cast": "Železný Újezd",
    "psc": "33563",
    "okres": "Plzeň-jih",
    "obec": "Čížkov",
    "val": "33563 Cizkov Zelezny Ujezd"
  },
  {
    "cast": "Želí",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Libčany",
    "val": "50327 Libcany Zeli"
  },
  {
    "cast": "Želibořice",
    "psc": "38422",
    "okres": "Prachatice",
    "obec": "Bušanovice",
    "val": "38422 Busanovice Zeliborice"
  },
  {
    "cast": "Želina",
    "psc": "43201",
    "okres": "Chomutov",
    "obec": "Rokle",
    "val": "43201 Rokle Zelina"
  },
  {
    "cast": "Želiv",
    "psc": "39444",
    "okres": "Pelhřimov",
    "obec": "Želiv",
    "val": "39444 Zeliv Zeliv"
  },
  {
    "cast": "Želivec",
    "psc": "25168",
    "okres": "Praha-východ",
    "obec": "Sulice",
    "val": "25168 Sulice Zelivec"
  },
  {
    "cast": "Želivec",
    "psc": "28522",
    "okres": "Kutná Hora",
    "obec": "Zruč nad Sázavou",
    "val": "28522 Zruc nad Sazavou Zelivec"
  },
  {
    "cast": "Želivsko",
    "psc": "56904",
    "okres": "Svitavy",
    "obec": "Želivsko",
    "val": "56904 Zelivsko Zelivsko"
  },
  {
    "cast": "Želízy",
    "psc": "27721",
    "okres": "Mělník",
    "obec": "Želízy",
    "val": "27721 Zelizy Zelizy"
  },
  {
    "cast": "Želkovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Želkovice",
    "val": "44001 Zelkovice Zelkovice"
  },
  {
    "cast": "Želkovice",
    "psc": "26701",
    "okres": "Beroun",
    "obec": "Libomyšl",
    "val": "26701 Libomysl Zelkovice"
  },
  {
    "cast": "Želkovice (část)",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Hořiněves",
    "val": "50303 Horineves Zelkovice (cast)"
  },
  {
    "cast": "Želkovice (část)",
    "psc": "50801",
    "okres": "Hradec Králové",
    "obec": "Hořiněves",
    "val": "50801 Horineves Zelkovice (cast)"
  },
  {
    "cast": "Želnava",
    "psc": "38451",
    "okres": "Prachatice",
    "obec": "Želnava",
    "val": "38451 Zelnava Zelnava"
  },
  {
    "cast": "Želvice",
    "psc": "33501",
    "okres": "Plzeň-jih",
    "obec": "Mileč",
    "val": "33501 Milec Zelvice"
  },
  {
    "cast": "Žemličkova Lhota",
    "psc": "26255",
    "okres": "Příbram",
    "obec": "Petrovice",
    "val": "26255 Petrovice Zemlickova Lhota"
  },
  {
    "cast": "Ženklava",
    "psc": "74267",
    "okres": "Nový Jičín",
    "obec": "Ženklava",
    "val": "74267 Zenklava Zenklava"
  },
  {
    "cast": "Žeranovice",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Žeranovice",
    "val": "76901 Zeranovice Zeranovice"
  },
  {
    "cast": "Žeravice",
    "psc": "69647",
    "okres": "Hodonín",
    "obec": "Žeravice",
    "val": "69647 Zeravice Zeravice"
  },
  {
    "cast": "Žeravice-Přerov XII x)",
    "psc": "75002",
    "okres": "Přerov",
    "obec": "Přerov",
    "val": "75002 Prerov Zeravice-Prerov XII x)"
  },
  {
    "cast": "Žeraviny",
    "psc": "69663",
    "okres": "Hodonín",
    "obec": "Žeraviny",
    "val": "69663 Zeraviny Zeraviny"
  },
  {
    "cast": "Žerčice (část)",
    "psc": "29446",
    "okres": "Mladá Boleslav",
    "obec": "Žerčice",
    "val": "29446 Zercice Zercice (cast)"
  },
  {
    "cast": "Žerčice (část)",
    "psc": "29441",
    "okres": "Mladá Boleslav",
    "obec": "Žerčice",
    "val": "29441 Zercice Zercice (cast)"
  },
  {
    "cast": "Žeretice",
    "psc": "50702",
    "okres": "Jičín",
    "obec": "Žeretice",
    "val": "50702 Zeretice Zeretice"
  },
  {
    "cast": "Žermanice",
    "psc": "73937",
    "okres": "Frýdek-Místek",
    "obec": "Žermanice",
    "val": "73937 Zermanice Zermanice"
  },
  {
    "cast": "Žernov",
    "psc": "55203",
    "okres": "Náchod",
    "obec": "Žernov",
    "val": "55203 Zernov Zernov"
  },
  {
    "cast": "Žernov",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Žernov",
    "val": "51263 Zernov Zernov"
  },
  {
    "cast": "Žernovice",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Žernovice",
    "val": "38301 Zernovice Zernovice"
  },
  {
    "cast": "Žernovka",
    "psc": "25162",
    "okres": "Praha-východ",
    "obec": "Mukařov",
    "val": "25162 Mukarov Zernovka"
  },
  {
    "cast": "Žernovník",
    "psc": "67921",
    "okres": "Blansko",
    "obec": "Žernovník",
    "val": "67921 Zernovnik Zernovnik"
  },
  {
    "cast": "Žernovník (část)",
    "psc": "33038",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33038 Bezverov Zernovnik (cast)"
  },
  {
    "cast": "Žernovník (část)",
    "psc": "33041",
    "okres": "Plzeň-sever",
    "obec": "Bezvěrov",
    "val": "33041 Bezverov Zernovnik (cast)"
  },
  {
    "cast": "Žernůvka",
    "psc": "66601",
    "okres": "Brno-venkov",
    "obec": "Nelepeč-Žernůvka",
    "val": "66601 Nelepec-Zernuvka Zernuvka"
  },
  {
    "cast": "Žerotice",
    "psc": "67134",
    "okres": "Znojmo",
    "obec": "Žerotice",
    "val": "67134 Zerotice Zerotice"
  },
  {
    "cast": "Žerotín",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Žerotín",
    "val": "44001 Zerotin Zerotin"
  },
  {
    "cast": "Žerotín",
    "psc": "78401",
    "okres": "Olomouc",
    "obec": "Žerotín",
    "val": "78401 Zerotin Zerotin"
  },
  {
    "cast": "Žerovice",
    "psc": "33401",
    "okres": "Plzeň-jih",
    "obec": "Přeštice",
    "val": "33401 Prestice Zerovice"
  },
  {
    "cast": "Žerůtky",
    "psc": "67151",
    "okres": "Znojmo",
    "obec": "Žerůtky",
    "val": "67151 Zerutky Zerutky"
  },
  {
    "cast": "Žerůtky",
    "psc": "67971",
    "okres": "Blansko",
    "obec": "Žerůtky",
    "val": "67971 Zerutky Zerutky"
  },
  {
    "cast": "Žerůvky",
    "psc": "77900",
    "okres": "Olomouc",
    "obec": "Bystročice",
    "val": "77900 Bystrocice Zeruvky"
  },
  {
    "cast": "Žešov",
    "psc": "79601",
    "okres": "Prostějov",
    "obec": "Prostějov",
    "val": "79601 Prostejov Zesov"
  },
  {
    "cast": "Žežice",
    "psc": "26101",
    "okres": "Příbram",
    "obec": "Příbram",
    "val": "26101 Pribram Zezice"
  },
  {
    "cast": "Žežice",
    "psc": "40002",
    "okres": "Ústí nad Labem",
    "obec": "Chuderov",
    "val": "40002 Chuderov Zezice"
  },
  {
    "cast": "Žhery",
    "psc": "28201",
    "okres": "Kolín",
    "obec": "Klučov",
    "val": "28201 Klucov Zhery"
  },
  {
    "cast": "Žibkov",
    "psc": "25786",
    "okres": "Benešov",
    "obec": "Miličín",
    "val": "25786 Milicin Zibkov"
  },
  {
    "cast": "Žibřidice",
    "psc": "46353",
    "okres": "Liberec",
    "obec": "Křižany",
    "val": "46353 Krizany Zibridice"
  },
  {
    "cast": "Židenice (část)",
    "psc": "61500",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61500 Brno Zidenice (cast)"
  },
  {
    "cast": "Židenice (část)",
    "psc": "61800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "61800 Brno Zidenice (cast)"
  },
  {
    "cast": "Židenice (část)",
    "psc": "62800",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "62800 Brno Zidenice (cast)"
  },
  {
    "cast": "Židenice (část)",
    "psc": "63600",
    "okres": "Brno-město",
    "obec": "Brno",
    "val": "63600 Brno Zidenice (cast)"
  },
  {
    "cast": "Židlochovice",
    "psc": "66701",
    "okres": "Brno-venkov",
    "obec": "Židlochovice",
    "val": "66701 Zidlochovice Zidlochovice"
  },
  {
    "cast": "Židněves",
    "psc": "29406",
    "okres": "Mladá Boleslav",
    "obec": "Židněves",
    "val": "29406 Zidneves Zidneves"
  },
  {
    "cast": "Židovice",
    "psc": "44001",
    "okres": "Louny",
    "obec": "Libčeves",
    "val": "44001 Libceves Zidovice"
  },
  {
    "cast": "Židovice",
    "psc": "50732",
    "okres": "Jičín",
    "obec": "Židovice",
    "val": "50732 Zidovice Zidovice"
  },
  {
    "cast": "Židovice",
    "psc": "41183",
    "okres": "Litoměřice",
    "obec": "Židovice",
    "val": "41183 Zidovice Zidovice"
  },
  {
    "cast": "Žihle",
    "psc": "33165",
    "okres": "Plzeň-sever",
    "obec": "Žihle",
    "val": "33165 Zihle Zihle"
  },
  {
    "cast": "Žihobce",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Žihobce",
    "val": "34201 Zihobce Zihobce"
  },
  {
    "cast": "Žichlice",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Hromnice",
    "val": "33011 Hromnice Zichlice"
  },
  {
    "cast": "Žichlínek",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Žichlínek",
    "val": "56301 Zichlinek Zichlinek"
  },
  {
    "cast": "Žichlínské Předměstí",
    "psc": "56301",
    "okres": "Ústí nad Orlicí",
    "obec": "Lanškroun",
    "val": "56301 Lanskroun Zichlinske Predmesti"
  },
  {
    "cast": "Žichov",
    "psc": "41804",
    "okres": "Teplice",
    "obec": "Měrunice",
    "val": "41804 Merunice Zichov"
  },
  {
    "cast": "Žíchovec",
    "psc": "38301",
    "okres": "Prachatice",
    "obec": "Strunkovice nad Blanicí",
    "val": "38301 Strunkovice nad Blanici Zichovec"
  },
  {
    "cast": "Žichovice",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Žichovice",
    "val": "34201 Zichovice Zichovice"
  },
  {
    "cast": "Žíka",
    "psc": "53401",
    "okres": "Pardubice",
    "obec": "Trusnov",
    "val": "53401 Trusnov Zika"
  },
  {
    "cast": "Žikov",
    "psc": "34201",
    "okres": "Klatovy",
    "obec": "Petrovice u Sušice",
    "val": "34201 Petrovice u Susice Zikov"
  },
  {
    "cast": "Žilina",
    "psc": "27301",
    "okres": "Kladno",
    "obec": "Žilina",
    "val": "27301 Zilina Zilina"
  },
  {
    "cast": "Žilina",
    "psc": "74101",
    "okres": "Nový Jičín",
    "obec": "Nový Jičín",
    "val": "74101 Novy Jicin Zilina"
  },
  {
    "cast": "Žilov",
    "psc": "33011",
    "okres": "Plzeň-sever",
    "obec": "Žilov",
    "val": "33011 Zilov Zilov"
  },
  {
    "cast": "Žim",
    "psc": "41501",
    "okres": "Teplice",
    "obec": "Žim",
    "val": "41501 Zim Zim"
  },
  {
    "cast": "Žimrovice",
    "psc": "74741",
    "okres": "Opava",
    "obec": "Hradec nad Moravicí",
    "val": "74741 Hradec nad Moravici Zimrovice"
  },
  {
    "cast": "Žimutice",
    "psc": "37366",
    "okres": "České Budějovice",
    "obec": "Žimutice",
    "val": "37366 Zimutice Zimutice"
  },
  {
    "cast": "Žíňánky",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Soběhrdy",
    "val": "25601 Sobehrdy Zinanky"
  },
  {
    "cast": "Žíňany",
    "psc": "25601",
    "okres": "Benešov",
    "obec": "Soběhrdy",
    "val": "25601 Sobehrdy Zinany"
  },
  {
    "cast": "Žinice",
    "psc": "25703",
    "okres": "Benešov",
    "obec": "Neustupov",
    "val": "25703 Neustupov Zinice"
  },
  {
    "cast": "Žinkovy",
    "psc": "33554",
    "okres": "Plzeň-jih",
    "obec": "Žinkovy",
    "val": "33554 Zinkovy Zinkovy"
  },
  {
    "cast": "Žipotín",
    "psc": "57101",
    "okres": "Svitavy",
    "obec": "Gruna",
    "val": "57101 Gruna Zipotin"
  },
  {
    "cast": "Žírec",
    "psc": "38473",
    "okres": "Prachatice",
    "obec": "Zdíkov",
    "val": "38473 Zdikov Zirec"
  },
  {
    "cast": "Žirecká Podstráň (část)",
    "psc": "54404",
    "okres": "Trutnov",
    "obec": "Dvůr Králové nad Labem",
    "val": "54404 Dvur Kralove nad Labem Zirecka Podstran (cast)"
  },
  {
    "cast": "Žirecká Podstráň (část)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Dvůr Králové nad Labem",
    "val": "54401 Dvur Kralove nad Labem Zirecka Podstran (cast)"
  },
  {
    "cast": "Žireč (část)",
    "psc": "54404",
    "okres": "Trutnov",
    "obec": "Dvůr Králové nad Labem",
    "val": "54404 Dvur Kralove nad Labem Zirec (cast)"
  },
  {
    "cast": "Žireč (část)",
    "psc": "54401",
    "okres": "Trutnov",
    "obec": "Dvůr Králové nad Labem",
    "val": "54401 Dvur Kralove nad Labem Zirec (cast)"
  },
  {
    "cast": "Žirov",
    "psc": "39301",
    "okres": "Pelhřimov",
    "obec": "Žirov",
    "val": "39301 Zirov Zirov"
  },
  {
    "cast": "Žírovice",
    "psc": "35002",
    "okres": "Cheb",
    "obec": "Františkovy Lázně",
    "val": "35002 Frantiskovy Lazne Zirovice"
  },
  {
    "cast": "Žirovnice",
    "psc": "39468",
    "okres": "Pelhřimov",
    "obec": "Žirovnice",
    "val": "39468 Zirovnice Zirovnice"
  },
  {
    "cast": "Žíšov",
    "psc": "39181",
    "okres": "Tábor",
    "obec": "Žíšov",
    "val": "39181 Zisov Zisov"
  },
  {
    "cast": "Žíšov",
    "psc": "28504",
    "okres": "Kutná Hora",
    "obec": "Vavřinec",
    "val": "28504 Vavrinec Zisov"
  },
  {
    "cast": "Žíteč (část)",
    "psc": "37901",
    "okres": "Jindřichův Hradec",
    "obec": "Chlum u Třeboně",
    "val": "37901 Chlum u Trebone Zitec (cast)"
  },
  {
    "cast": "Žíteč (část)",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Chlum u Třeboně",
    "val": "37806 Chlum u Trebone Zitec (cast)"
  },
  {
    "cast": "Žitenice",
    "psc": "41141",
    "okres": "Litoměřice",
    "obec": "Žitenice",
    "val": "41141 Zitenice Zitenice"
  },
  {
    "cast": "Žitětín",
    "psc": "50601",
    "okres": "Jičín",
    "obec": "Jičíněves",
    "val": "50601 Jicineves Zitetin"
  },
  {
    "cast": "Žítková",
    "psc": "68774",
    "okres": "Uherské Hradiště",
    "obec": "Žítková",
    "val": "68774 Zitkova Zitkova"
  },
  {
    "cast": "Žitná",
    "psc": "38411",
    "okres": "Prachatice",
    "obec": "Hracholusky",
    "val": "38411 Hracholusky Zitna"
  },
  {
    "cast": "Žitovlice",
    "psc": "28934",
    "okres": "Nymburk",
    "obec": "Žitovlice",
    "val": "28934 Zitovlice Zitovlice"
  },
  {
    "cast": "Živanice",
    "psc": "53342",
    "okres": "Pardubice",
    "obec": "Živanice",
    "val": "53342 Zivanice Zivanice"
  },
  {
    "cast": "Živohošť",
    "psc": "25756",
    "okres": "Benešov",
    "obec": "Křečovice",
    "val": "25756 Krecovice Zivohost"
  },
  {
    "cast": "Živohošť",
    "psc": "26203",
    "okres": "Příbram",
    "obec": "Chotilsko",
    "val": "26203 Chotilsko Zivohost"
  },
  {
    "cast": "Živonín",
    "psc": "27733",
    "okres": "Mělník",
    "obec": "Řepín",
    "val": "27733 Repin Zivonin"
  },
  {
    "cast": "Životice",
    "psc": "26231",
    "okres": "Příbram",
    "obec": "Vrančice",
    "val": "26231 Vrancice Zivotice"
  },
  {
    "cast": "Životice",
    "psc": "73601",
    "okres": "Karviná",
    "obec": "Havířov",
    "val": "73601 Havirov Zivotice"
  },
  {
    "cast": "Životice",
    "psc": "33544",
    "okres": "Plzeň-jih",
    "obec": "Životice",
    "val": "33544 Zivotice Zivotice"
  },
  {
    "cast": "Životice u Nového Jičína",
    "psc": "74272",
    "okres": "Nový Jičín",
    "obec": "Životice u Nového Jičína",
    "val": "74272 Zivotice u Noveho Jicina Zivotice u Noveho Jicina"
  },
  {
    "cast": "Žiznětice",
    "psc": "34022",
    "okres": "Klatovy",
    "obec": "Dešenice",
    "val": "34022 Desenice Ziznetice"
  },
  {
    "cast": "Žizníkov (část)",
    "psc": "47001",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47001 Ceska Lipa Ziznikov (cast)"
  },
  {
    "cast": "Žizníkov (část)",
    "psc": "47002",
    "okres": "Česká Lípa",
    "obec": "Česká Lípa",
    "val": "47002 Ceska Lipa Ziznikov (cast)"
  },
  {
    "cast": "Žíželeves",
    "psc": "50303",
    "okres": "Hradec Králové",
    "obec": "Hořiněves",
    "val": "50303 Horineves Zizeleves"
  },
  {
    "cast": "Žiželice",
    "psc": "43801",
    "okres": "Louny",
    "obec": "Žiželice",
    "val": "43801 Zizelice Zizelice"
  },
  {
    "cast": "Žiželice",
    "psc": "28129",
    "okres": "Kolín",
    "obec": "Žiželice",
    "val": "28129 Zizelice Zizelice"
  },
  {
    "cast": "Žižice",
    "psc": "27401",
    "okres": "Kladno",
    "obec": "Žižice",
    "val": "27401 Zizice Zizice"
  },
  {
    "cast": "Žižín",
    "psc": "53002",
    "okres": "Pardubice",
    "obec": "Pardubice",
    "val": "53002 Pardubice Zizin"
  },
  {
    "cast": "Žižkov",
    "psc": "28401",
    "okres": "Kutná Hora",
    "obec": "Kutná Hora",
    "val": "28401 Kutna Hora Zizkov"
  },
  {
    "cast": "Žižkov (část)",
    "psc": "13000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "13000 Praha Zizkov (cast)"
  },
  {
    "cast": "Žižkov (část)",
    "psc": "10000",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "10000 Praha Zizkov (cast)"
  },
  {
    "cast": "Žižkov (část)",
    "psc": "18600",
    "okres": "Hlavní město Praha",
    "obec": "Praha",
    "val": "18600 Praha Zizkov (cast)"
  },
  {
    "cast": "Žižkovec",
    "psc": "50327",
    "okres": "Hradec Králové",
    "obec": "Praskačka",
    "val": "50327 Praskacka Zizkovec"
  },
  {
    "cast": "Žižkovo Pole",
    "psc": "58222",
    "okres": "Havlíčkův Brod",
    "obec": "Žižkovo Pole",
    "val": "58222 Zizkovo Pole Zizkovo Pole"
  },
  {
    "cast": "Žižlavice",
    "psc": "67801",
    "okres": "Blansko",
    "obec": "Blansko",
    "val": "67801 Blansko Zizlavice"
  },
  {
    "cast": "Žlábek",
    "psc": "38226",
    "okres": "Český Krumlov",
    "obec": "Horní Planá",
    "val": "38226 Horni Plana Zlabek"
  },
  {
    "cast": "Žlábek",
    "psc": "51263",
    "okres": "Semily",
    "obec": "Tatobity",
    "val": "51263 Tatobity Zlabek"
  },
  {
    "cast": "Žleb",
    "psc": "78833",
    "okres": "Šumperk",
    "obec": "Hanušovice",
    "val": "78833 Hanusovice Zleb"
  },
  {
    "cast": "Žlebská Lhotka",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Žlebské Chvalovice",
    "val": "53843 Zlebske Chvalovice Zlebska Lhotka"
  },
  {
    "cast": "Žlebské Chvalovice",
    "psc": "53843",
    "okres": "Chrudim",
    "obec": "Žlebské Chvalovice",
    "val": "53843 Zlebske Chvalovice Zlebske Chvalovice"
  },
  {
    "cast": "Žleby",
    "psc": "28561",
    "okres": "Kutná Hora",
    "obec": "Žleby",
    "val": "28561 Zleby Zleby"
  },
  {
    "cast": "Žleby",
    "psc": "67923",
    "okres": "Brno-venkov",
    "obec": "Strhaře",
    "val": "67923 Strhare Zleby"
  },
  {
    "cast": "Žlíbek",
    "psc": "34192",
    "okres": "Klatovy",
    "obec": "Kašperské Hory",
    "val": "34192 Kasperske Hory Zlibek"
  },
  {
    "cast": "Žlíbky",
    "psc": "38501",
    "okres": "Prachatice",
    "obec": "Horní Vltavice",
    "val": "38501 Horni Vltavice Zlibky"
  },
  {
    "cast": "Žloukovice",
    "psc": "26705",
    "okres": "Beroun",
    "obec": "Nižbor",
    "val": "26705 Nizbor Zloukovice"
  },
  {
    "cast": "Žlunice",
    "psc": "50734",
    "okres": "Jičín",
    "obec": "Žlunice",
    "val": "50734 Zlunice Zlunice"
  },
  {
    "cast": "Žlutava",
    "psc": "76361",
    "okres": "Zlín",
    "obec": "Žlutava",
    "val": "76361 Zlutava Zlutava"
  },
  {
    "cast": "Žlutice",
    "psc": "36452",
    "okres": "Karlovy Vary",
    "obec": "Žlutice",
    "val": "36452 Zlutice Zlutice"
  },
  {
    "cast": "Žofín",
    "psc": "40757",
    "okres": "Děčín",
    "obec": "Horní Podluží",
    "val": "40757 Horni Podluzi Zofin"
  },
  {
    "cast": "Žofina Huť",
    "psc": "37806",
    "okres": "Jindřichův Hradec",
    "obec": "Nová Ves nad Lužnicí",
    "val": "37806 Nova Ves nad Luznici Zofina Hut"
  },
  {
    "cast": "Žopy",
    "psc": "76901",
    "okres": "Kroměříž",
    "obec": "Holešov",
    "val": "76901 Holesov Zopy"
  },
  {
    "cast": "Žulová",
    "psc": "79065",
    "okres": "Jeseník",
    "obec": "Žulová",
    "val": "79065 Zulova Zulova"
  },
  {
    "cast": "Žumberk",
    "psc": "53836",
    "okres": "Chrudim",
    "obec": "Žumberk",
    "val": "53836 Zumberk Zumberk"
  },
  {
    "cast": "Žumberk",
    "psc": "37401",
    "okres": "České Budějovice",
    "obec": "Žár",
    "val": "37401 Zar Zumberk"
  },
  {
    "cast": "Županovice",
    "psc": "26301",
    "okres": "Příbram",
    "obec": "Županovice",
    "val": "26301 Zupanovice Zupanovice"
  },
  {
    "cast": "Županovice",
    "psc": "37881",
    "okres": "Jindřichův Hradec",
    "obec": "Županovice",
    "val": "37881 Zupanovice Zupanovice"
  }
]



// WEBPACK FOOTER //
// build/services/pscDimensions/pscData.js